Array.prototype.find || Object.defineProperty(Array.prototype, "find", {
  value: function(b) {
    if (this == null)
      throw new TypeError("Array.prototype.find called on null or undefined");
    if (typeof b != "function")
      throw new TypeError("predicate must be a function");
    for (var e = Object(this), t = e.length >>> 0, n = arguments[1], s = 0; s !== t; s++)
      if (b.call(n, this[s], s, e))
        return this[s];
  }
});
Array.prototype.includes || (Array.prototype.includes = function(b) {
  if (this == null)
    throw new TypeError("Array.prototype.includes called on null or undefined");
  var e = Object(this), t = parseInt(e.length, 10) || 0;
  if (t === 0)
    return !1;
  var n = parseInt(arguments[1], 10) || 0, s;
  n >= 0 ? s = n : (s = t + n, s < 0 && (s = 0));
  for (var o; s < t; ) {
    if (o = e[s], b === o || b !== b && o !== o)
      return !0;
    s++;
  }
  return !1;
});
Array.prototype.map || (Array.prototype.map = function(b) {
  var e, t, n;
  if (this == null)
    throw new TypeError("this is null or not defined");
  var s = Object(this), o = s.length >>> 0;
  if (typeof b != "function")
    throw new TypeError(b + " is not a function");
  for (arguments.length > 1 && (e = arguments[1]), t = new Array(o), n = 0; n < o; ) {
    var h, c;
    n in s && (h = s[n], c = b.call(e, h, n, s), t[n] = c), n++;
  }
  return t;
});
String.prototype.startsWith || Object.defineProperty(String.prototype, "startsWith", {
  value: function(b, e) {
    var t = e > 0 ? e | 0 : 0;
    return this.substring(t, t + b.length) === b;
  }
});
String.prototype.endsWith || (String.prototype.endsWith = function(b, e) {
  return (e === void 0 || e > this.length) && (e = this.length), this.substring(e - b.length, e) === b;
});
var Er = /* @__PURE__ */ ((b) => (b[b.Editor = 1] = "Editor", b[b.Viewer = 2] = "Viewer", b))(Er || {}), $a = /* @__PURE__ */ ((b) => (b.None = "None", b.Translate = "Translate", b.Rotate = "Rotate", b.Scaling = "Scaling", b))($a || {}), Ay = /* @__PURE__ */ ((b) => (b[b.Customizer = 1] = "Customizer", b[b.Composer = 2] = "Composer", b[b.Viewer = 3] = "Viewer", b))(Ay || {}), zh = typeof Float32Array < "u" ? Float32Array : Array;
function Ty() {
  var b = new zh(3);
  return zh != Float32Array && (b[0] = 0, b[1] = 0, b[2] = 0), b;
}
function Lh(b) {
  var e = b[0], t = b[1], n = b[2];
  return Math.sqrt(e * e + t * t + n * n);
}
(function() {
  var b = Ty();
  return function(e, t, n, s, o, h) {
    var c, _;
    for (t || (t = 3), n || (n = 0), s ? _ = Math.min(s * t + n, e.length) : _ = e.length, c = n; c < _; c += t)
      b[0] = e[c], b[1] = e[c + 1], b[2] = e[c + 2], o(b, b, h), e[c] = b[0], e[c + 1] = b[1], e[c + 2] = b[2];
    return e;
  };
})();
function Ly(b) {
  var e = b[0], t = b[1], n = b[2], s = b[3], o = b[4], h = b[5], c = b[6], _ = b[7], x = b[8], B = b[9], P = b[10], U = b[11], M = b[12], Z = b[13], F = b[14], Q = b[15], D = e * h - t * o, te = e * c - n * o, ee = t * c - n * h, le = x * Z - B * M, fe = x * F - P * M, X = B * F - P * Z, W = e * X - t * fe + n * le, je = o * X - h * fe + c * le, ke = x * ee - B * te + P * D, Ye = M * ee - Z * te + F * D;
  return _ * W - s * je + Q * ke - U * Ye;
}
function By(b, e, t) {
  var n = e[0], s = e[1], o = e[2], h = e[3], c = e[4], _ = e[5], x = e[6], B = e[7], P = e[8], U = e[9], M = e[10], Z = e[11], F = e[12], Q = e[13], D = e[14], te = e[15], ee = t[0], le = t[1], fe = t[2], X = t[3];
  return b[0] = ee * n + le * c + fe * P + X * F, b[1] = ee * s + le * _ + fe * U + X * Q, b[2] = ee * o + le * x + fe * M + X * D, b[3] = ee * h + le * B + fe * Z + X * te, ee = t[4], le = t[5], fe = t[6], X = t[7], b[4] = ee * n + le * c + fe * P + X * F, b[5] = ee * s + le * _ + fe * U + X * Q, b[6] = ee * o + le * x + fe * M + X * D, b[7] = ee * h + le * B + fe * Z + X * te, ee = t[8], le = t[9], fe = t[10], X = t[11], b[8] = ee * n + le * c + fe * P + X * F, b[9] = ee * s + le * _ + fe * U + X * Q, b[10] = ee * o + le * x + fe * M + X * D, b[11] = ee * h + le * B + fe * Z + X * te, ee = t[12], le = t[13], fe = t[14], X = t[15], b[12] = ee * n + le * c + fe * P + X * F, b[13] = ee * s + le * _ + fe * U + X * Q, b[14] = ee * o + le * x + fe * M + X * D, b[15] = ee * h + le * B + fe * Z + X * te, b;
}
function ky(b, e) {
  var t = e[0], n = e[1], s = e[2], o = e[4], h = e[5], c = e[6], _ = e[8], x = e[9], B = e[10];
  return b[0] = Math.sqrt(t * t + n * n + s * s), b[1] = Math.sqrt(o * o + h * h + c * c), b[2] = Math.sqrt(_ * _ + x * x + B * B), b;
}
function Ey(b, e) {
  var t = new zh(3);
  ky(t, e);
  var n = 1 / t[0], s = 1 / t[1], o = 1 / t[2], h = e[0] * n, c = e[1] * s, _ = e[2] * o, x = e[4] * n, B = e[5] * s, P = e[6] * o, U = e[8] * n, M = e[9] * s, Z = e[10] * o, F = h + B + Z, Q = 0;
  return F > 0 ? (Q = Math.sqrt(F + 1) * 2, b[3] = 0.25 * Q, b[0] = (P - M) / Q, b[1] = (U - _) / Q, b[2] = (c - x) / Q) : h > B && h > Z ? (Q = Math.sqrt(1 + h - B - Z) * 2, b[3] = (P - M) / Q, b[0] = 0.25 * Q, b[1] = (c + x) / Q, b[2] = (U + _) / Q) : B > Z ? (Q = Math.sqrt(1 + B - h - Z) * 2, b[3] = (U - _) / Q, b[0] = (c + x) / Q, b[1] = 0.25 * Q, b[2] = (P + M) / Q) : (Q = Math.sqrt(1 + Z - h - B) * 2, b[3] = (c - x) / Q, b[0] = (U + _) / Q, b[1] = (P + M) / Q, b[2] = 0.25 * Q), b;
}
var en, dl, Fh, la;
function Ii(b, e, t, n) {
  var s, o = arguments.length, h = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    h = Reflect.decorate(b, e, t, n);
  else
    for (var c = b.length - 1; c >= 0; c--)
      (s = b[c]) && (h = (o < 3 ? s(h) : o > 3 ? s(e, t, h) : s(e, t)) || h);
  return o > 3 && h && Object.defineProperty(e, t, h), h;
}
(function(b) {
  b.ACCESSOR = "Accessor", b.ANIMATION = "Animation", b.ANIMATION_CHANNEL = "AnimationChannel", b.ANIMATION_SAMPLER = "AnimationSampler", b.BUFFER = "Buffer", b.CAMERA = "Camera", b.MATERIAL = "Material", b.MESH = "Mesh", b.PRIMITIVE = "Primitive", b.PRIMITIVE_TARGET = "PrimitiveTarget", b.NODE = "Node", b.ROOT = "Root", b.SCENE = "Scene", b.SKIN = "Skin", b.TEXTURE = "Texture", b.TEXTURE_INFO = "TextureInfo";
})(en || (en = {})), function(b) {
  b.INTERLEAVED = "interleaved", b.SEPARATE = "separate";
}(dl || (dl = {})), function(b) {
  b[b.R = 4096] = "R", b[b.G = 256] = "G", b[b.B = 16] = "B", b[b.A = 1] = "A";
}(Fh || (Fh = {})), function(b) {
  b.GLTF = "GLTF", b.GLB = "GLB";
}(la || (la = {}));
class Ml {
  constructor(e, t, n) {
    if (this.t = void 0, this.i = void 0, this.h = void 0, this.o = !1, this.u = [], this.t = e, this.i = t, this.h = n, !t.canLink(n))
      throw new Error("Cannot link disconnected graphs/documents.");
  }
  getName() {
    return this.t;
  }
  getParent() {
    return this.i;
  }
  getChild() {
    return this.h;
  }
  setChild(e) {
    return this.h = e, this;
  }
  dispose() {
    this.o || (this.o = !0, this.u.forEach((e) => e()), this.u.length = 0);
  }
  onDispose(e) {
    return this.u.push(e), this;
  }
  isDisposed() {
    return this.o;
  }
}
class Iy {
  constructor() {
    this.l = /* @__PURE__ */ new Set(), this.p = /* @__PURE__ */ new Set(), this.g = /* @__PURE__ */ new Map(), this.v = /* @__PURE__ */ new Map(), this.u = {};
  }
  on(e, t) {
    return this.u[e] = this.u[e] || [], this.u[e].push(t), this;
  }
  emit(e, t) {
    for (const n of this.u[e] || [])
      n(t);
    return this;
  }
  getLinks() {
    return Array.from(this.p);
  }
  listParentLinks(e) {
    return Array.from(this.v.get(e) || this.l);
  }
  listParents(e) {
    return this.listParentLinks(e).map((t) => t.getParent());
  }
  listChildLinks(e) {
    return Array.from(this.g.get(e) || this.l);
  }
  listChildren(e) {
    return this.listChildLinks(e).map((t) => t.getChild());
  }
  disconnectChildren(e) {
    return (this.g.get(e) || this.l).forEach((t) => t.dispose()), this;
  }
  disconnectParents(e, t) {
    let n = Array.from(this.v.get(e) || this.l);
    return t && (n = n.filter((s) => t(s.getParent()))), n.forEach((s) => s.dispose()), this;
  }
  swapChild(e, t, n) {
    const s = this.g.get(e) || this.l;
    return Array.from(s).filter((o) => o.getChild() === t).forEach((o) => {
      this.v.get(t).delete(o), o.setChild(n), this.v.has(n) || this.v.set(n, /* @__PURE__ */ new Set()), this.v.get(n).add(o);
    }), this;
  }
  link(e, t, n) {
    if (!n)
      return null;
    const s = new Ml(e, t, n);
    return this.registerLink(s), s;
  }
  registerLink(e) {
    this.p.add(e);
    const t = e.getParent();
    this.g.has(t) || this.g.set(t, /* @__PURE__ */ new Set()), this.g.get(t).add(e);
    const n = e.getChild();
    return this.v.has(n) || this.v.set(n, /* @__PURE__ */ new Set()), this.v.get(n).add(e), e.onDispose(() => this.unlink(e)), e;
  }
  unlink(e) {
    return this.p.delete(e), this.g.get(e.getParent()).delete(e), this.v.get(e.getChild()).delete(e), this;
  }
}
function En(b, e) {
  Object.defineProperty(b, e, { get: function() {
    return this["__" + e];
  }, set: function(t) {
    const n = this["__" + e];
    n && !Array.isArray(n) && n.dispose(), t && !Array.isArray(t) && t.onDispose(() => {
      this["__" + e] = null;
    }), this["__" + e] = t;
  }, enumerable: !0 });
}
function Wn(b, e) {
}
class br {
  static createBufferFromDataURI(e) {
    if (typeof Buffer > "u") {
      const t = atob(e.split(",")[1]), n = new Uint8Array(t.length);
      for (let s = 0; s < t.length; s++)
        n[s] = t.charCodeAt(s);
      return n.buffer;
    }
    {
      const t = e.split(",")[1], n = e.indexOf("base64") >= 0;
      return this.trim(Buffer.from(t, n ? "base64" : "utf8"));
    }
  }
  static encodeText(e) {
    return typeof TextEncoder < "u" ? new TextEncoder().encode(e).buffer : this.trim(Buffer.from(e));
  }
  static decodeText(e) {
    return typeof TextDecoder < "u" ? new TextDecoder().decode(e) : Buffer.from(e).toString("utf8");
  }
  static trim(e) {
    const { byteOffset: t, byteLength: n } = e;
    return e.buffer.slice(t, t + n);
  }
  static concat(e) {
    let t = 0;
    for (const o of e)
      t += o.byteLength;
    const n = new Uint8Array(t);
    let s = 0;
    for (const o of e)
      n.set(new Uint8Array(o), s), s += o.byteLength;
    return n.buffer;
  }
  static pad(e, t = 0) {
    const n = this.padNumber(e.byteLength);
    if (n !== e.byteLength) {
      const s = new Uint8Array(n);
      if (s.set(new Uint8Array(e)), t !== 0)
        for (let o = e.byteLength; o < n; o++)
          s[o] = t;
      return s.buffer;
    }
    return e;
  }
  static padNumber(e) {
    return 4 * Math.ceil(e / 4);
  }
  static equals(e, t) {
    if (e === t)
      return !0;
    if (e.byteLength !== t.byteLength)
      return !1;
    const n = new DataView(e), s = new DataView(t);
    let o = e.byteLength;
    for (; o--; )
      if (n.getUint8(o) !== s.getUint8(o))
        return !1;
    return !0;
  }
}
class qo {
  static hexToFactor(e, t) {
    e = Math.floor(e);
    const n = t;
    return n[0] = (e >> 16 & 255) / 255, n[1] = (e >> 8 & 255) / 255, n[2] = (255 & e) / 255, this.convertSRGBToLinear(t, t);
  }
  static factorToHex(e) {
    const t = [...e], [n, s, o] = this.convertLinearToSRGB(e, t);
    return 255 * n << 16 ^ 255 * s << 8 ^ 255 * o << 0;
  }
  static convertSRGBToLinear(e, t) {
    const n = e, s = t;
    for (let o = 0; o < 3; o++)
      s[o] = n[o] < 0.04045 ? 0.0773993808 * n[o] : Math.pow(0.9478672986 * n[o] + 0.0521327014, 2.4);
    return t;
  }
  static convertLinearToSRGB(e, t) {
    const n = e, s = t;
    for (let o = 0; o < 3; o++)
      s[o] = n[o] < 31308e-7 ? 12.92 * n[o] : 1.055 * Math.pow(n[o], 0.41666) - 0.055;
    return t;
  }
}
class gl {
  static basename(e) {
    const t = e.split(/[\\/]/).pop();
    return t.substr(0, t.lastIndexOf("."));
  }
  static extension(e) {
    return e.indexOf("data:") !== 0 ? e.split(/[\\/]/).pop().split(/[.]/).pop() : e.indexOf("data:image/png") === 0 ? "png" : e.indexOf("data:image/jpeg") === 0 ? "jpeg" : "bin";
  }
}
class Cl {
  match(e) {
    const t = new Uint8Array(e);
    return t.length >= 8 && t[0] === 137 && t[1] === 80 && t[2] === 78 && t[3] === 71 && t[4] === 13 && t[5] === 10 && t[6] === 26 && t[7] === 10;
  }
  getSize(e) {
    const t = new DataView(e);
    return br.decodeText(e.slice(12, 16)) === Cl.PNG_FRIED_CHUNK_NAME ? [t.getUint32(32, !1), t.getUint32(36, !1)] : [t.getUint32(16, !1), t.getUint32(20, !1)];
  }
  getChannels(e) {
    return 4;
  }
}
Cl.PNG_FRIED_CHUNK_NAME = "CgBI";
class La {
  static registerFormat(e, t) {
    this.impls[e] = t;
  }
  static getMimeType(e) {
    for (const t in this.impls)
      if (this.impls[t].match(e))
        return t;
    return null;
  }
  static getSize(e, t) {
    return this.impls[t] ? this.impls[t].getSize(e) : null;
  }
  static getChannels(e, t) {
    return this.impls[t] ? this.impls[t].getChannels(e) : null;
  }
  static getMemSize(e, t) {
    if (!this.impls[t])
      return null;
    if (this.impls[t].getGPUByteLength)
      return this.impls[t].getGPUByteLength(e);
    let n = 0;
    const s = this.getSize(e, t);
    if (!s)
      return null;
    for (; s[0] > 1 || s[1] > 1; )
      n += s[0] * s[1] * 4, s[0] = Math.max(Math.floor(s[0] / 2), 1), s[1] = Math.max(Math.floor(s[1] / 2), 1);
    return n += 4, n;
  }
  static mimeTypeToExtension(e) {
    return e === "image/jpeg" ? "jpg" : e.split("/").pop();
  }
  static extensionToMimeType(e) {
    return e === "jpg" ? "image/jpeg" : `image/${e}`;
  }
}
function Py(b, e) {
  if (e > b.byteLength)
    throw new TypeError("Corrupt JPG, exceeded buffer limits");
  if (b.getUint8(e) !== 255)
    throw new TypeError("Invalid JPG, marker table corrupted");
  return b;
}
La.impls = { "image/jpeg": new class {
  match(b) {
    const e = new Uint8Array(b);
    return e.length >= 3 && e[0] === 255 && e[1] === 216 && e[2] === 255;
  }
  getSize(b) {
    let e, t, n = new DataView(b, 4);
    for (; n.byteLength; ) {
      if (e = n.getUint16(0, !1), Py(n, e), t = n.getUint8(e + 1), t === 192 || t === 193 || t === 194)
        return [n.getUint16(e + 7, !1), n.getUint16(e + 5, !1)];
      n = new DataView(b, n.byteOffset + e + 2);
    }
    throw new TypeError("Invalid JPG, no size found");
  }
  getChannels(b) {
    return 3;
  }
}(), "image/png": new Cl() };
class Kn {
  static identity(e) {
    return e;
  }
  static eq(e, t) {
    if (e.length !== t.length)
      return !1;
    for (let n = 0; n < e.length; n++)
      if (Math.abs(e[n] - t[n]) > 1e-5)
        return !1;
    return !0;
  }
  static denormalize(e, t) {
    switch (t) {
      case 5126:
        return e;
      case 5123:
        return e / 65535;
      case 5121:
        return e / 255;
      case 5122:
        return Math.max(e / 32767, -1);
      case 5120:
        return Math.max(e / 127, -1);
      default:
        throw new Error("Invalid component type.");
    }
  }
  static normalize(e, t) {
    switch (t) {
      case 5126:
        return e;
      case 5123:
        return Math.round(65535 * e);
      case 5121:
        return Math.round(255 * e);
      case 5122:
        return Math.round(32767 * e);
      case 5120:
        return Math.round(127 * e);
      default:
        throw new Error("Invalid component type.");
    }
  }
  static decompose(e, t, n, s) {
    let o = Lh([e[0], e[1], e[2]]);
    const h = Lh([e[4], e[5], e[6]]), c = Lh([e[8], e[9], e[10]]);
    Ly(e) < 0 && (o = -o), t[0] = e[12], t[1] = e[13], t[2] = e[14];
    const _ = e.slice(), x = 1 / o, B = 1 / h, P = 1 / c;
    _[0] *= x, _[1] *= x, _[2] *= x, _[4] *= B, _[5] *= B, _[6] *= B, _[8] *= P, _[9] *= P, _[10] *= P, Ey(n, _), s[0] = o, s[1] = h, s[2] = c;
  }
  static compose(e, t, n, s) {
    const o = s, h = t[0], c = t[1], _ = t[2], x = t[3], B = h + h, P = c + c, U = _ + _, M = h * B, Z = h * P, F = h * U, Q = c * P, D = c * U, te = _ * U, ee = x * B, le = x * P, fe = x * U, X = n[0], W = n[1], je = n[2];
    return o[0] = (1 - (Q + te)) * X, o[1] = (Z + fe) * X, o[2] = (F - le) * X, o[3] = 0, o[4] = (Z - fe) * W, o[5] = (1 - (M + te)) * W, o[6] = (D + ee) * W, o[7] = 0, o[8] = (F + le) * je, o[9] = (D - ee) * je, o[10] = (1 - (M + Q)) * je, o[11] = 0, o[12] = e[0], o[13] = e[1], o[14] = e[2], o[15] = 1, o;
  }
}
class jr {
  constructor(e) {
    this.verbosity = void 0, this.verbosity = e;
  }
  debug(e) {
    this.verbosity <= jr.Verbosity.DEBUG && console.debug(e);
  }
  info(e) {
    this.verbosity <= jr.Verbosity.INFO && console.info(e);
  }
  warn(e) {
    this.verbosity <= jr.Verbosity.WARN && console.warn(e);
  }
  error(e) {
    this.verbosity <= jr.Verbosity.ERROR && console.error(e);
  }
}
jr.Verbosity = { SILENT: 4, ERROR: 3, WARN: 2, INFO: 1, DEBUG: 0 }, jr.DEFAULT_INSTANCE = new jr(jr.Verbosity.INFO);
const _f = "23456789abdegjkmnpqrvwxyzABDEGJKMNPQRVWXYZ", vf = /* @__PURE__ */ new Set(), Oy = function() {
  let b = "";
  for (let e = 0; e < 6; e++)
    b += _f.charAt(Math.floor(Math.random() * _f.length));
  return b;
}, Ny = function() {
  for (let b = 0; b < 999; b++) {
    const e = Oy();
    if (!vf.has(e))
      return vf.add(e), e;
  }
  return "";
}, In = (b) => b;
class ka extends class {
  constructor(e) {
    this.graph = void 0, this.o = !1, this.graph = e, this.graph = e;
  }
  canLink(e) {
    return this.graph === e.graph;
  }
  isDisposed() {
    return this.o;
  }
  dispose() {
    this.graph.disconnectChildren(this), this.graph.disconnectParents(this), this.o = !0, this.graph.emit("dispose", this);
  }
  detach() {
    return this.graph.disconnectParents(this), this;
  }
  swap(e, t) {
    return this.graph.swapChild(this, e, t), this;
  }
  addGraphChild(e, t) {
    return e.push(t), t.onDispose(() => {
      const n = e.filter((s) => s !== t);
      e.length = 0;
      for (const s of n)
        e.push(s);
    }), this;
  }
  removeGraphChild(e, t) {
    return e.filter((n) => n.getChild() === t).forEach((n) => n.dispose()), this;
  }
  clearGraphChildList(e) {
    for (; e.length > 0; )
      e[0].dispose();
    return this;
  }
  listGraphParents() {
    return this.graph.listParents(this);
  }
} {
  constructor(e, t = "") {
    super(e), this.graph = void 0, this.m = {}, this.t = "", this.graph = e, this.t = t;
  }
  getName() {
    return this.t;
  }
  setName(e) {
    return this.t = e, this;
  }
  getExtras() {
    return this.m;
  }
  setExtras(e) {
    return this.m = e, this;
  }
  clone() {
    const e = new this.constructor(this.graph).copy(this, In);
    return this.graph.emit("clone", e), e;
  }
  copy(e, t = In) {
    return this.t = e.t, this.m = JSON.parse(JSON.stringify(e.m)), this;
  }
  detach() {
    return this.graph.disconnectParents(this, (e) => e.propertyType !== "Root"), this;
  }
  listParents() {
    return this.listGraphParents();
  }
}
const yf = "Pass extension name (string) as lookup token, not a constructor.";
class Wr extends ka {
  constructor(...e) {
    super(...e), this.extensions = [];
  }
  copy(e, t = In) {
    return super.copy(e, t), this.clearGraphChildList(this.extensions), e.extensions.forEach((n) => {
      const s = n.getChild();
      this.setExtension(s.extensionName, t(s));
    }), this;
  }
  getExtension(e) {
    if (typeof e != "string")
      throw new Error(yf);
    const t = this.extensions.find((n) => n.getChild().extensionName === e);
    return t ? t.getChild() : null;
  }
  setExtension(e, t) {
    if (typeof e != "string")
      throw new Error(yf);
    const n = this.getExtension(e);
    return n && this.removeGraphChild(this.extensions, n), t ? (t.T(this), this.addGraphChild(this.extensions, this.graph.link(e, this, t))) : this;
  }
  listExtensions() {
    return this.extensions.map((e) => e.getChild());
  }
}
Ii([Wn], Wr.prototype, "extensions", void 0);
class Ti extends Wr {
  constructor(...e) {
    super(...e), this.propertyType = en.ACCESSOR, this.S = null, this.M = Ti.Type.SCALAR, this.I = Ti.ComponentType.FLOAT, this.N = !1, this.C = Kn.identity, this.O = Kn.identity, this.buffer = null;
  }
  copy(e, t = In) {
    return super.copy(e, t), this.M = e.M, this.I = e.I, this.N = e.N, this.C = e.C, this.O = e.O, e.S && (this.S = e.S.slice()), this.setBuffer(e.buffer ? t(e.buffer.getChild()) : null), this;
  }
  static getElementSize(e) {
    switch (e) {
      case Ti.Type.SCALAR:
        return 1;
      case Ti.Type.VEC2:
        return 2;
      case Ti.Type.VEC3:
        return 3;
      case Ti.Type.VEC4:
      case Ti.Type.MAT2:
        return 4;
      case Ti.Type.MAT3:
        return 9;
      case Ti.Type.MAT4:
        return 16;
      default:
        throw new Error("Unexpected type: " + e);
    }
  }
  static getComponentSize(e) {
    switch (e) {
      case Ti.ComponentType.BYTE:
      case Ti.ComponentType.UNSIGNED_BYTE:
        return 1;
      case Ti.ComponentType.SHORT:
      case Ti.ComponentType.UNSIGNED_SHORT:
        return 2;
      case Ti.ComponentType.UNSIGNED_INT:
      case Ti.ComponentType.FLOAT:
        return 4;
      default:
        throw new Error("Unexpected component type: " + e);
    }
  }
  getMinNormalized(e) {
    const t = this.getElementSize();
    this.getMin(e);
    for (let n = 0; n < t; n++)
      e[n] = this.O(e[n]);
    return e;
  }
  getMin(e) {
    const t = this.getCount(), n = this.getElementSize();
    for (let s = 0; s < n; s++)
      e[s] = 1 / 0;
    for (let s = 0; s < t * n; s += n)
      for (let o = 0; o < n; o++) {
        const h = this.S[s + o];
        Number.isFinite(h) && (e[o] = Math.min(e[o], h));
      }
    return e;
  }
  getMaxNormalized(e) {
    const t = this.getElementSize();
    this.getMax(e);
    for (let n = 0; n < t; n++)
      e[n] = this.O(e[n]);
    return e;
  }
  getMax(e) {
    const t = this.getCount(), n = this.getElementSize();
    for (let s = 0; s < n; s++)
      e[s] = -1 / 0;
    for (let s = 0; s < t * n; s += n)
      for (let o = 0; o < n; o++) {
        const h = this.S[s + o];
        Number.isFinite(h) && (e[o] = Math.max(e[o], h));
      }
    return e;
  }
  getCount() {
    return this.S ? this.S.length / this.getElementSize() : 0;
  }
  getType() {
    return this.M;
  }
  setType(e) {
    return this.M = e, this;
  }
  getElementSize() {
    return Ti.getElementSize(this.M);
  }
  getComponentSize() {
    return this.S.BYTES_PER_ELEMENT;
  }
  getComponentType() {
    return this.I;
  }
  getNormalized() {
    return this.N;
  }
  setNormalized(e) {
    return this.N = e, e ? (this.O = (t) => Kn.denormalize(t, this.I), this.C = (t) => Kn.normalize(t, this.I)) : (this.O = Kn.identity, this.C = Kn.identity), this;
  }
  getScalar(e) {
    const t = this.getElementSize();
    return this.O(this.S[e * t]);
  }
  setScalar(e, t) {
    return this.S[e * this.getElementSize()] = this.C(t), this;
  }
  getElement(e, t) {
    const n = this.getElementSize();
    for (let s = 0; s < n; s++)
      t[s] = this.O(this.S[e * n + s]);
    return t;
  }
  setElement(e, t) {
    const n = this.getElementSize();
    for (let s = 0; s < n; s++)
      this.S[e * n + s] = this.C(t[s]);
    return this;
  }
  getBuffer() {
    return this.buffer ? this.buffer.getChild() : null;
  }
  setBuffer(e) {
    return this.buffer = this.graph.link("buffer", this, e), this;
  }
  getArray() {
    return this.S;
  }
  setArray(e) {
    return this.I = e ? function(t) {
      switch (t.constructor) {
        case Float32Array:
          return Ti.ComponentType.FLOAT;
        case Uint32Array:
          return Ti.ComponentType.UNSIGNED_INT;
        case Uint16Array:
          return Ti.ComponentType.UNSIGNED_SHORT;
        case Uint8Array:
          return Ti.ComponentType.UNSIGNED_BYTE;
        case Int16Array:
          return Ti.ComponentType.SHORT;
        case Int8Array:
          return Ti.ComponentType.BYTE;
        default:
          throw new Error("Unknown accessor componentType.");
      }
    }(e) : Ti.ComponentType.FLOAT, this.S = e, this;
  }
  getByteLength() {
    return this.S ? this.S.byteLength : 0;
  }
}
Ti.Type = { SCALAR: "SCALAR", VEC2: "VEC2", VEC3: "VEC3", VEC4: "VEC4", MAT2: "MAT2", MAT3: "MAT3", MAT4: "MAT4" }, Ti.ComponentType = { BYTE: 5120, UNSIGNED_BYTE: 5121, SHORT: 5122, UNSIGNED_SHORT: 5123, UNSIGNED_INT: 5125, FLOAT: 5126 }, Ii([En], Ti.prototype, "buffer", void 0);
class pl extends Wr {
  constructor(...e) {
    super(...e), this.propertyType = en.ANIMATION, this.channels = [], this.samplers = [];
  }
  copy(e, t = In) {
    return super.copy(e, t), this.clearGraphChildList(this.channels), this.clearGraphChildList(this.samplers), e.channels.forEach((n) => this.addChannel(t(n.getChild()))), e.samplers.forEach((n) => this.addSampler(t(n.getChild()))), this;
  }
  addChannel(e) {
    const t = this.graph.link("channel", this, e);
    return this.addGraphChild(this.channels, t);
  }
  removeChannel(e) {
    return this.removeGraphChild(this.channels, e);
  }
  listChannels() {
    return this.channels.map((e) => e.getChild());
  }
  addSampler(e) {
    const t = this.graph.link("sampler", this, e);
    return this.addGraphChild(this.samplers, t);
  }
  removeSampler(e) {
    return this.removeGraphChild(this.samplers, e);
  }
  listSamplers() {
    return this.samplers.map((e) => e.getChild());
  }
}
Ii([Wn], pl.prototype, "channels", void 0), Ii([Wn], pl.prototype, "samplers", void 0);
class sl extends ka {
  constructor(...e) {
    super(...e), this.propertyType = en.ANIMATION_CHANNEL, this._ = null, this.targetNode = null, this.sampler = null;
  }
  copy(e, t = In) {
    return super.copy(e, t), this._ = e._, this.setTargetNode(e.targetNode ? t(e.targetNode.getChild()) : null), this.setSampler(e.sampler ? t(e.sampler.getChild()) : null), this;
  }
  getTargetPath() {
    return this._;
  }
  setTargetPath(e) {
    return this._ = e, this;
  }
  getTargetNode() {
    return this.targetNode ? this.targetNode.getChild() : null;
  }
  setTargetNode(e) {
    return this.targetNode = this.graph.link("target.node", this, e), this;
  }
  getSampler() {
    return this.sampler ? this.sampler.getChild() : null;
  }
  setSampler(e) {
    return this.sampler = this.graph.link("sampler", this, e), this;
  }
}
sl.TargetPath = { TRANSLATION: "translation", ROTATION: "rotation", SCALE: "scale", WEIGHTS: "weights" }, Ii([En], sl.prototype, "targetNode", void 0), Ii([En], sl.prototype, "sampler", void 0);
class ua extends ka {
  constructor(...e) {
    super(...e), this.propertyType = en.ANIMATION_SAMPLER, this.L = ua.Interpolation.LINEAR, this.input = null, this.output = null;
  }
  copy(e, t = In) {
    return super.copy(e, t), this.L = e.L, this.setInput(e.input ? t(e.input.getChild()) : null), this.setOutput(e.output ? t(e.output.getChild()) : null), this;
  }
  getInterpolation() {
    return this.L;
  }
  setInterpolation(e) {
    return this.L = e, this;
  }
  getInput() {
    return this.input ? this.input.getChild() : null;
  }
  setInput(e) {
    return this.input = this.graph.link("input", this, e), this;
  }
  getOutput() {
    return this.output ? this.output.getChild() : null;
  }
  setOutput(e) {
    return this.output = this.graph.link("output", this, e), this;
  }
}
ua.Interpolation = { LINEAR: "LINEAR", STEP: "STEP", CUBICSPLINE: "CUBICSPLINE" }, Ii([En], ua.prototype, "input", void 0), Ii([En], ua.prototype, "output", void 0);
let hd = class extends Wr {
  constructor(...e) {
    super(...e), this.propertyType = en.BUFFER, this.P = "";
  }
  copy(e, t = In) {
    return super.copy(e, t), this.P = e.P, this;
  }
  getURI() {
    return this.P;
  }
  setURI(e) {
    return this.P = e, this;
  }
};
class ca extends Wr {
  constructor(...e) {
    super(...e), this.propertyType = en.CAMERA, this.M = ca.Type.PERSPECTIVE, this.U = 0.1, this.k = 100, this.F = null, this.j = 2 * Math.PI * 50 / 360, this.D = 1, this.J = 1;
  }
  copy(e, t = In) {
    return super.copy(e, t), this.M = e.M, this.U = e.U, this.k = e.k, this.F = e.F, this.j = e.j, this.D = e.D, this.J = e.J, this;
  }
  getType() {
    return this.M;
  }
  setType(e) {
    return this.M = e, this;
  }
  getZNear() {
    return this.U;
  }
  setZNear(e) {
    return this.U = e, this;
  }
  getZFar() {
    return this.k;
  }
  setZFar(e) {
    return this.k = e, this;
  }
  getAspectRatio() {
    return this.F;
  }
  setAspectRatio(e) {
    return this.F = e, this;
  }
  getYFov() {
    return this.j;
  }
  setYFov(e) {
    return this.j = e, this;
  }
  getXMag() {
    return this.D;
  }
  setXMag(e) {
    return this.D = e, this;
  }
  getYMag() {
    return this.J;
  }
  setYMag(e) {
    return this.J = e, this;
  }
}
ca.Type = { PERSPECTIVE: "perspective", ORTHOGRAPHIC: "orthographic" };
class ud extends ka {
  constructor(e, t) {
    super(e), this.$ = void 0, this.$ = t, this.$.addExtensionProperty(this);
  }
  clone() {
    const e = new this.constructor(this.graph, this.$).copy(this, In);
    return this.graph.emit("clone", e), e;
  }
  dispose() {
    this.$.removeExtensionProperty(this), super.dispose();
  }
  T(e) {
    if (!this.parentTypes.includes(e.propertyType))
      throw new Error(`Parent "${e.propertyType}" invalid for child "${this.propertyType}".`);
  }
}
ud.EXTENSION_NAME = void 0;
class cd extends Ml {
  constructor(...e) {
    super(...e), this.semantic = "";
  }
  copy(e) {
    return this.semantic = e.semantic, this;
  }
}
class fd extends Ml {
  copy(e) {
    return this;
  }
}
let Ry = class extends Ml {
  constructor(...e) {
    super(...e), this.channels = 0;
  }
  copy(e) {
    return this.channels = e.channels, this;
  }
};
class Dy extends Iy {
  linkAttribute(e, t, n) {
    if (!n)
      return null;
    const s = new cd(e, t, n);
    return s.semantic = e, this.registerLink(s), s;
  }
  linkIndex(e, t, n) {
    if (!n)
      return null;
    const s = new fd(e, t, n);
    return this.registerLink(s), s;
  }
  linkTexture(e, t, n, s) {
    if (!s)
      return null;
    const o = new Ry(e, n, s);
    return o.channels = t, this.registerLink(o), o;
  }
}
class ds extends Wr {
  constructor(...e) {
    super(...e), this.propertyType = en.TEXTURE_INFO, this.V = 0, this.W = null, this.q = null, this.Y = ds.WrapMode.REPEAT, this.H = ds.WrapMode.REPEAT;
  }
  copy(e, t = In) {
    return super.copy(e, t), this.V = e.V, this.W = e.W, this.q = e.q, this.Y = e.Y, this.H = e.H, this;
  }
  equals(e) {
    return this.getTexCoord() === e.getTexCoord() && this.getMagFilter() === e.getMagFilter() && this.getMinFilter() === e.getMinFilter() && this.getWrapS() === e.getWrapS() && this.getWrapT() === e.getWrapT();
  }
  getTexCoord() {
    return this.V;
  }
  setTexCoord(e) {
    return this.V = e, this;
  }
  getMagFilter() {
    return this.W;
  }
  setMagFilter(e) {
    return this.W = e, this;
  }
  getMinFilter() {
    return this.q;
  }
  setMinFilter(e) {
    return this.q = e, this;
  }
  getWrapS() {
    return this.Y;
  }
  setWrapS(e) {
    return this.Y = e, this;
  }
  getWrapT() {
    return this.H;
  }
  setWrapT(e) {
    return this.H = e, this;
  }
}
ds.WrapMode = { CLAMP_TO_EDGE: 33071, MIRRORED_REPEAT: 33648, REPEAT: 10497 }, ds.MagFilter = { NEAREST: 9728, LINEAR: 9729 }, ds.MinFilter = { NEAREST: 9728, LINEAR: 9729, NEAREST_MIPMAP_NEAREST: 9984, LINEAR_MIPMAP_NEAREST: 9985, NEAREST_MIPMAP_LINEAR: 9986, LINEAR_MIPMAP_LINEAR: 9987 };
const { R: $o, G: Xo, B: Ko, A: zy } = Fh;
class nr extends Wr {
  constructor(...e) {
    super(...e), this.propertyType = en.MATERIAL, this.Z = nr.AlphaMode.OPAQUE, this.K = 0.5, this.X = !1, this.tt = [1, 1, 1, 1], this.st = [0, 0, 0], this.et = 1, this.it = 1, this.rt = 1, this.nt = 1, this.baseColorTexture = null, this.baseColorTextureInfo = this.graph.link("baseColorTextureInfo", this, new ds(this.graph)), this.emissiveTexture = null, this.emissiveTextureInfo = this.graph.link("emissiveTextureInfo", this, new ds(this.graph)), this.normalTexture = null, this.normalTextureInfo = this.graph.link("normalTextureInfo", this, new ds(this.graph)), this.occlusionTexture = null, this.occlusionTextureInfo = this.graph.link("occlusionTextureInfo", this, new ds(this.graph)), this.metallicRoughnessTexture = null, this.metallicRoughnessTextureInfo = this.graph.link("metallicRoughnessTextureInfo", this, new ds(this.graph));
  }
  copy(e, t = In) {
    return super.copy(e, t), this.Z = e.Z, this.K = e.K, this.X = e.X, this.tt = [...e.tt], this.st = [...e.st], this.et = e.et, this.it = e.it, this.rt = e.rt, this.nt = e.nt, this.setBaseColorTexture(e.baseColorTexture ? t(e.baseColorTexture.getChild()) : null), this.baseColorTextureInfo.getChild().copy(t(e.baseColorTextureInfo.getChild()), t), this.setEmissiveTexture(e.emissiveTexture ? t(e.emissiveTexture.getChild()) : null), this.emissiveTextureInfo.getChild().copy(t(e.emissiveTextureInfo.getChild()), t), this.setNormalTexture(e.normalTexture ? t(e.normalTexture.getChild()) : null), this.normalTextureInfo.getChild().copy(t(e.normalTextureInfo.getChild()), t), this.setOcclusionTexture(e.occlusionTexture ? t(e.occlusionTexture.getChild()) : null), this.occlusionTextureInfo.getChild().copy(t(e.occlusionTextureInfo.getChild()), t), this.setMetallicRoughnessTexture(e.metallicRoughnessTexture ? t(e.metallicRoughnessTexture.getChild()) : null), this.metallicRoughnessTextureInfo.getChild().copy(t(e.metallicRoughnessTextureInfo.getChild()), t), this;
  }
  equals(e) {
    if (this.getAlphaMode() !== e.getAlphaMode() || this.getAlphaCutoff() !== e.getAlphaCutoff() || this.getDoubleSided() !== e.getDoubleSided() || !Kn.eq(this.getBaseColorFactor(), e.getBaseColorFactor()) || !Kn.eq(this.getEmissiveFactor(), e.getEmissiveFactor()) || this.getNormalScale() !== e.getNormalScale() || this.getOcclusionStrength() !== e.getOcclusionStrength() || this.getRoughnessFactor() !== e.getRoughnessFactor() || this.getMetallicFactor() !== e.getMetallicFactor() || (this.getBaseColorTexture() || e.getBaseColorTexture()) && (this.getBaseColorTexture() !== e.getBaseColorTexture() || this.getBaseColorTexture() && !this.getBaseColorTextureInfo().equals(e.getBaseColorTextureInfo())) || (this.getEmissiveTexture() || e.getEmissiveTexture()) && (this.getEmissiveTexture() !== e.getEmissiveTexture() || this.getEmissiveTexture() && !this.getEmissiveTextureInfo().equals(e.getEmissiveTextureInfo())) || (this.getNormalTexture() || e.getNormalTexture()) && (this.getNormalTexture() !== e.getNormalTexture() || this.getNormalTexture() && !this.getNormalTextureInfo().equals(e.getNormalTextureInfo())) || (this.getOcclusionTexture() || e.getOcclusionTexture()) && (this.getOcclusionTexture() !== e.getOcclusionTexture() || this.getOcclusionTexture() && !this.getOcclusionTextureInfo().equals(e.getOcclusionTextureInfo())) || (this.getMetallicRoughnessTexture() || e.getMetallicRoughnessTexture()) && (this.getMetallicRoughnessTexture() !== e.getMetallicRoughnessTexture() || this.getMetallicRoughnessTexture() && !this.getMetallicRoughnessTextureInfo().equals(e.getMetallicRoughnessTextureInfo())))
      return !1;
    const t = this.listExtensions(), n = e.listExtensions();
    if (t.length !== n.length)
      return !1;
    for (let s = 0; s < t.length; s++)
      if (t[s] !== n[s])
        return !1;
    return !0;
  }
  dispose() {
    this.baseColorTextureInfo.getChild().dispose(), this.emissiveTextureInfo.getChild().dispose(), this.normalTextureInfo.getChild().dispose(), this.occlusionTextureInfo.getChild().dispose(), this.metallicRoughnessTextureInfo.getChild().dispose(), super.dispose();
  }
  getDoubleSided() {
    return this.X;
  }
  setDoubleSided(e) {
    return this.X = e, this;
  }
  getAlpha() {
    return this.tt[3];
  }
  setAlpha(e) {
    return this.tt[3] = e, this;
  }
  getAlphaMode() {
    return this.Z;
  }
  setAlphaMode(e) {
    return this.Z = e, this;
  }
  getAlphaCutoff() {
    return this.K;
  }
  setAlphaCutoff(e) {
    return this.K = e, this;
  }
  getBaseColorFactor() {
    return this.tt;
  }
  setBaseColorFactor(e) {
    return this.tt = e, this;
  }
  getBaseColorHex() {
    return qo.factorToHex(this.tt);
  }
  setBaseColorHex(e) {
    return qo.hexToFactor(e, this.tt), this;
  }
  getBaseColorTexture() {
    return this.baseColorTexture ? this.baseColorTexture.getChild() : null;
  }
  getBaseColorTextureInfo() {
    return this.baseColorTexture ? this.baseColorTextureInfo.getChild() : null;
  }
  setBaseColorTexture(e) {
    return this.baseColorTexture = this.graph.linkTexture("baseColorTexture", $o | Xo | Ko | zy, this, e), this;
  }
  getEmissiveFactor() {
    return this.st;
  }
  setEmissiveFactor(e) {
    return this.st = e, this;
  }
  getEmissiveHex() {
    return qo.factorToHex(this.st);
  }
  setEmissiveHex(e) {
    return qo.hexToFactor(e, this.st), this;
  }
  getEmissiveTexture() {
    return this.emissiveTexture ? this.emissiveTexture.getChild() : null;
  }
  getEmissiveTextureInfo() {
    return this.emissiveTexture ? this.emissiveTextureInfo.getChild() : null;
  }
  setEmissiveTexture(e) {
    return this.emissiveTexture = this.graph.linkTexture("emissiveTexture", $o | Xo | Ko, this, e), this;
  }
  getNormalScale() {
    return this.et;
  }
  setNormalScale(e) {
    return this.et = e, this;
  }
  getNormalTexture() {
    return this.normalTexture ? this.normalTexture.getChild() : null;
  }
  getNormalTextureInfo() {
    return this.normalTexture ? this.normalTextureInfo.getChild() : null;
  }
  setNormalTexture(e) {
    return this.normalTexture = this.graph.linkTexture("normalTexture", $o | Xo | Ko, this, e), this;
  }
  getOcclusionStrength() {
    return this.it;
  }
  setOcclusionStrength(e) {
    return this.it = e, this;
  }
  getOcclusionTexture() {
    return this.occlusionTexture ? this.occlusionTexture.getChild() : null;
  }
  getOcclusionTextureInfo() {
    return this.occlusionTexture ? this.occlusionTextureInfo.getChild() : null;
  }
  setOcclusionTexture(e) {
    return this.occlusionTexture = this.graph.linkTexture("occlusionTexture", $o, this, e), this;
  }
  getRoughnessFactor() {
    return this.rt;
  }
  setRoughnessFactor(e) {
    return this.rt = e, this;
  }
  getMetallicFactor() {
    return this.nt;
  }
  setMetallicFactor(e) {
    return this.nt = e, this;
  }
  getMetallicRoughnessTexture() {
    return this.metallicRoughnessTexture ? this.metallicRoughnessTexture.getChild() : null;
  }
  getMetallicRoughnessTextureInfo() {
    return this.metallicRoughnessTexture ? this.metallicRoughnessTextureInfo.getChild() : null;
  }
  setMetallicRoughnessTexture(e) {
    return this.metallicRoughnessTexture = this.graph.linkTexture("metallicRoughnessTexture", Xo | Ko, this, e), this;
  }
}
nr.AlphaMode = { OPAQUE: "OPAQUE", MASK: "MASK", BLEND: "BLEND" }, Ii([En], nr.prototype, "baseColorTexture", void 0), Ii([En], nr.prototype, "baseColorTextureInfo", void 0), Ii([En], nr.prototype, "emissiveTexture", void 0), Ii([En], nr.prototype, "emissiveTextureInfo", void 0), Ii([En], nr.prototype, "normalTexture", void 0), Ii([En], nr.prototype, "normalTextureInfo", void 0), Ii([En], nr.prototype, "occlusionTexture", void 0), Ii([En], nr.prototype, "occlusionTextureInfo", void 0), Ii([En], nr.prototype, "metallicRoughnessTexture", void 0), Ii([En], nr.prototype, "metallicRoughnessTextureInfo", void 0);
class tu extends Wr {
  constructor(...e) {
    super(...e), this.propertyType = en.MESH, this.ht = [], this.primitives = [];
  }
  copy(e, t = In) {
    return super.copy(e, t), this.ht = [...e.ht], this.clearGraphChildList(this.primitives), e.primitives.forEach((n) => this.addPrimitive(t(n.getChild()))), this;
  }
  addPrimitive(e) {
    return this.addGraphChild(this.primitives, this.graph.link("primitive", this, e));
  }
  removePrimitive(e) {
    return this.removeGraphChild(this.primitives, e);
  }
  listPrimitives() {
    return this.primitives.map((e) => e.getChild());
  }
  getWeights() {
    return this.ht;
  }
  setWeights(e) {
    return this.ht = e, this;
  }
}
Ii([Wn], tu.prototype, "primitives", void 0);
class Zs extends Wr {
  constructor(...e) {
    super(...e), this.propertyType = en.NODE, this.ot = [0, 0, 0], this.ut = [0, 0, 0, 1], this.ct = [1, 1, 1], this.ht = [], this.i = null, this.camera = null, this.mesh = null, this.skin = null, this.children = [];
  }
  copy(e, t = In) {
    return super.copy(e, t), this.ot = [...e.ot], this.ut = [...e.ut], this.ct = [...e.ct], this.ht = [...e.ht], this.setCamera(e.camera ? t(e.camera.getChild()) : null), this.setMesh(e.mesh ? t(e.mesh.getChild()) : null), this.setSkin(e.skin ? t(e.skin.getChild()) : null), t !== In && (this.clearGraphChildList(this.children), e.children.forEach((n) => this.addChild(t(n.getChild())))), this;
  }
  getTranslation() {
    return this.ot;
  }
  getRotation() {
    return this.ut;
  }
  getScale() {
    return this.ct;
  }
  setTranslation(e) {
    return this.ot = e, this;
  }
  setRotation(e) {
    return this.ut = e, this;
  }
  setScale(e) {
    return this.ct = e, this;
  }
  getMatrix() {
    return Kn.compose(this.ot, this.ut, this.ct, []);
  }
  setMatrix(e) {
    return Kn.decompose(e, this.ot, this.ut, this.ct), this;
  }
  getWorldTranslation() {
    const e = [0, 0, 0];
    return Kn.decompose(this.getWorldMatrix(), e, [0, 0, 0, 1], [1, 1, 1]), e;
  }
  getWorldRotation() {
    const e = [0, 0, 0, 1];
    return Kn.decompose(this.getWorldMatrix(), [0, 0, 0], e, [1, 1, 1]), e;
  }
  getWorldScale() {
    const e = [1, 1, 1];
    return Kn.decompose(this.getWorldMatrix(), [0, 0, 0], [0, 0, 0, 1], e), e;
  }
  getWorldMatrix() {
    const e = [];
    for (let s = this; s instanceof Zs; s = s.i)
      e.push(s);
    let t;
    const n = e.pop().getMatrix();
    for (; t = e.pop(); )
      By(n, n, t.getMatrix());
    return n;
  }
  addChild(e) {
    e.i && e.i.removeChild(e);
    const t = this.graph.link("child", this, e);
    return this.addGraphChild(this.children, t), e.i = this, t.onDispose(() => e.i = null), this;
  }
  removeChild(e) {
    return this.removeGraphChild(this.children, e);
  }
  listChildren() {
    return this.children.map((e) => e.getChild());
  }
  getParent() {
    return this.i;
  }
  getMesh() {
    return this.mesh ? this.mesh.getChild() : null;
  }
  setMesh(e) {
    return this.mesh = this.graph.link("mesh", this, e), this;
  }
  getCamera() {
    return this.camera ? this.camera.getChild() : null;
  }
  setCamera(e) {
    return this.camera = this.graph.link("camera", this, e), this;
  }
  getSkin() {
    return this.skin ? this.skin.getChild() : null;
  }
  setSkin(e) {
    return this.skin = this.graph.link("skin", this, e), this;
  }
  getWeights() {
    return this.ht;
  }
  setWeights(e) {
    return this.ht = e, this;
  }
  traverse(e) {
    e(this);
    for (const t of this.listChildren())
      t.traverse(e);
    return this;
  }
}
Ii([En], Zs.prototype, "camera", void 0), Ii([En], Zs.prototype, "mesh", void 0), Ii([En], Zs.prototype, "skin", void 0), Ii([Wn], Zs.prototype, "children", void 0);
class Ws extends Wr {
  constructor(...e) {
    super(...e), this.propertyType = en.PRIMITIVE, this.at = Ws.Mode.TRIANGLES, this.material = null, this.indices = null, this.attributes = [], this.targets = [];
  }
  copy(e, t = In) {
    return super.copy(e, t), this.at = e.at, this.setIndices(e.indices ? t(e.indices.getChild()) : null), this.setMaterial(e.material ? t(e.material.getChild()) : null), this.clearGraphChildList(this.attributes), e.listSemantics().forEach((n) => {
      this.setAttribute(n, t(e.getAttribute(n)));
    }), this.clearGraphChildList(this.targets), e.targets.forEach((n) => this.addTarget(t(n.getChild()))), this;
  }
  getIndices() {
    return this.indices ? this.indices.getChild() : null;
  }
  setIndices(e) {
    return this.indices = this.graph.linkIndex("indices", this, e), this;
  }
  getAttribute(e) {
    const t = this.attributes.find((n) => n.semantic === e);
    return t ? t.getChild() : null;
  }
  setAttribute(e, t) {
    const n = this.getAttribute(e);
    if (n && this.removeGraphChild(this.attributes, n), !t)
      return this;
    const s = this.graph.linkAttribute(e, this, t);
    return this.addGraphChild(this.attributes, s);
  }
  listAttributes() {
    return this.attributes.map((e) => e.getChild());
  }
  listSemantics() {
    return this.attributes.map((e) => e.semantic);
  }
  getMaterial() {
    return this.material ? this.material.getChild() : null;
  }
  setMaterial(e) {
    return this.material = this.graph.link("material", this, e), this;
  }
  getMode() {
    return this.at;
  }
  setMode(e) {
    return this.at = e, this;
  }
  listTargets() {
    return this.targets.map((e) => e.getChild());
  }
  addTarget(e) {
    return this.addGraphChild(this.targets, this.graph.link("target", this, e)), this;
  }
  removeTarget(e) {
    return this.removeGraphChild(this.targets, e);
  }
}
Ws.Mode = { POINTS: 0, LINES: 1, LINE_LOOP: 2, LINE_STRIP: 3, TRIANGLES: 4, TRIANGLE_STRIP: 5, TRIANGLE_FAN: 6 }, Ii([En], Ws.prototype, "material", void 0), Ii([En], Ws.prototype, "indices", void 0), Ii([Wn], Ws.prototype, "attributes", void 0), Ii([Wn], Ws.prototype, "targets", void 0);
class dd extends ka {
  constructor(...e) {
    super(...e), this.propertyType = en.PRIMITIVE_TARGET, this.attributes = [];
  }
  copy(e, t = In) {
    return super.copy(e, t), this.clearGraphChildList(this.attributes), e.listSemantics().forEach((n) => {
      this.setAttribute(n, t(e.getAttribute(n)));
    }), this;
  }
  getAttribute(e) {
    const t = this.attributes.find((n) => n.semantic === e);
    return t ? t.getChild() : null;
  }
  setAttribute(e, t) {
    const n = this.getAttribute(e);
    if (n && this.removeGraphChild(this.attributes, n), !t)
      return this;
    const s = this.graph.linkAttribute(e, this, t);
    return s.semantic = e, this.addGraphChild(this.attributes, s);
  }
  listAttributes() {
    return this.attributes.map((e) => e.getChild());
  }
  listSemantics() {
    return this.attributes.map((e) => e.semantic);
  }
}
Ii([Wn], dd.prototype, "attributes", void 0);
class ro extends Wr {
  constructor(...e) {
    super(...e), this.propertyType = en.SCENE, this.children = [];
  }
  copy(e, t = In) {
    return super.copy(e, t), t !== In && (this.clearGraphChildList(this.children), e.children.forEach((n) => this.addChild(t(n.getChild())))), this;
  }
  addChild(e) {
    e.i && e.i.removeChild(e);
    const t = this.graph.link("child", this, e);
    return this.addGraphChild(this.children, t), e.i = this, t.onDispose(() => e.i = null), this;
  }
  removeChild(e) {
    return this.removeGraphChild(this.children, e);
  }
  listChildren() {
    return this.children.map((e) => e.getChild());
  }
  traverse(e) {
    for (const t of this.listChildren())
      t.traverse(e);
    return this;
  }
}
Ii([Wn], ro.prototype, "children", void 0);
class Ja extends Wr {
  constructor(...e) {
    super(...e), this.propertyType = en.SKIN, this.skeleton = null, this.inverseBindMatrices = null, this.joints = [];
  }
  copy(e, t = In) {
    return super.copy(e, t), this.setSkeleton(e.skeleton ? t(e.skeleton.getChild()) : null), this.setInverseBindMatrices(e.inverseBindMatrices ? t(e.inverseBindMatrices.getChild()) : null), this.clearGraphChildList(this.joints), e.joints.forEach((n) => this.addJoint(t(n.getChild()))), this;
  }
  getSkeleton() {
    return this.skeleton ? this.skeleton.getChild() : null;
  }
  setSkeleton(e) {
    return this.skeleton = this.graph.link("skeleton", this, e), this;
  }
  getInverseBindMatrices() {
    return this.inverseBindMatrices ? this.inverseBindMatrices.getChild() : null;
  }
  setInverseBindMatrices(e) {
    return this.inverseBindMatrices = this.graph.link("inverseBindMatrices", this, e), this;
  }
  addJoint(e) {
    const t = this.graph.link("joint", this, e);
    return this.addGraphChild(this.joints, t);
  }
  removeJoint(e) {
    return this.removeGraphChild(this.joints, e);
  }
  listJoints() {
    return this.joints.map((e) => e.getChild());
  }
}
Ii([En], Ja.prototype, "skeleton", void 0), Ii([En], Ja.prototype, "inverseBindMatrices", void 0), Ii([Wn], Ja.prototype, "joints", void 0);
class gd extends Wr {
  constructor(...e) {
    super(...e), this.propertyType = en.TEXTURE, this.lt = null, this.ft = "", this.P = "";
  }
  copy(e, t = In) {
    return super.copy(e, t), this.ft = e.ft, this.P = e.P, e.lt && (this.lt = e.lt.slice(0)), this;
  }
  getMimeType() {
    return this.ft || La.extensionToMimeType(gl.extension(this.P));
  }
  setMimeType(e) {
    return this.ft = e, this;
  }
  getURI() {
    return this.P;
  }
  setURI(e) {
    return this.P = e, this.ft = La.extensionToMimeType(gl.extension(e)), this;
  }
  getImage() {
    return this.lt;
  }
  setImage(e) {
    return this.lt = e, this;
  }
  getSize() {
    return this.lt ? La.getSize(this.lt, this.getMimeType()) : null;
  }
}
class ns extends ka {
  constructor(e) {
    super(e), this.propertyType = en.ROOT, this.dt = { generator: "glTF-Transform v1.2.4", version: "2.0" }, this.gt = /* @__PURE__ */ new Set(), this.defaultScene = null, this.accessors = [], this.animations = [], this.buffers = [], this.cameras = [], this.materials = [], this.meshes = [], this.nodes = [], this.scenes = [], this.skins = [], this.textures = [], e.on("clone", (t) => this.wt(t));
  }
  clone() {
    throw new Error("Root cannot be cloned.");
  }
  copy(e, t = In) {
    if (super.copy(e, t), t === In)
      throw new Error("Root cannot be copied.");
    return Object.assign(this.dt, e.dt), e.accessors.forEach((n) => this.vt(t(n.getChild()))), e.animations.forEach((n) => this.Tt(t(n.getChild()))), e.buffers.forEach((n) => this.yt(t(n.getChild()))), e.cameras.forEach((n) => this.At(t(n.getChild()))), e.materials.forEach((n) => this.Et(t(n.getChild()))), e.meshes.forEach((n) => this.xt(t(n.getChild()))), e.nodes.forEach((n) => this.St(t(n.getChild()))), e.scenes.forEach((n) => this.Mt(t(n.getChild()))), e.skins.forEach((n) => this.It(t(n.getChild()))), e.textures.forEach((n) => this.bt(t(n.getChild()))), this.setDefaultScene(e.defaultScene ? t(e.defaultScene.getChild()) : null), this;
  }
  wt(e) {
    return e instanceof ro ? this.Mt(e) : e instanceof Zs ? this.St(e) : e instanceof ca ? this.At(e) : e instanceof Ja ? this.It(e) : e instanceof tu ? this.xt(e) : e instanceof nr ? this.Et(e) : e instanceof gd ? this.bt(e) : e instanceof pl ? this.Tt(e) : e instanceof Ti ? this.vt(e) : e instanceof hd && this.yt(e), this;
  }
  getAsset() {
    return this.dt;
  }
  listExtensionsUsed() {
    return Array.from(this.gt);
  }
  listExtensionsRequired() {
    return this.listExtensionsUsed().filter((e) => e.isRequired());
  }
  Rt(e) {
    return this.gt.add(e), this;
  }
  Nt(e) {
    return this.gt.delete(e), this;
  }
  Mt(e) {
    return this.addGraphChild(this.scenes, this.graph.link("scene", this, e));
  }
  listScenes() {
    return this.scenes.map((e) => e.getChild());
  }
  setDefaultScene(e) {
    return this.defaultScene = this.graph.link("scene", this, e), this;
  }
  getDefaultScene() {
    return this.defaultScene ? this.defaultScene.getChild() : null;
  }
  St(e) {
    return this.addGraphChild(this.nodes, this.graph.link("node", this, e));
  }
  listNodes() {
    return this.nodes.map((e) => e.getChild());
  }
  At(e) {
    return this.addGraphChild(this.cameras, this.graph.link("camera", this, e));
  }
  listCameras() {
    return this.cameras.map((e) => e.getChild());
  }
  It(e) {
    return this.addGraphChild(this.skins, this.graph.link("skin", this, e));
  }
  listSkins() {
    return this.skins.map((e) => e.getChild());
  }
  xt(e) {
    return this.addGraphChild(this.meshes, this.graph.link("mesh", this, e));
  }
  listMeshes() {
    return this.meshes.map((e) => e.getChild());
  }
  Et(e) {
    return this.addGraphChild(this.materials, this.graph.link("material", this, e));
  }
  listMaterials() {
    return this.materials.map((e) => e.getChild());
  }
  bt(e) {
    return this.addGraphChild(this.textures, this.graph.link("texture", this, e));
  }
  listTextures() {
    return this.textures.map((e) => e.getChild());
  }
  Tt(e) {
    return this.addGraphChild(this.animations, this.graph.link("animation", this, e));
  }
  listAnimations() {
    return this.animations.map((e) => e.getChild());
  }
  vt(e) {
    return this.addGraphChild(this.accessors, this.graph.link("accessor", this, e));
  }
  listAccessors() {
    return this.accessors.map((e) => e.getChild());
  }
  yt(e) {
    return this.addGraphChild(this.buffers, this.graph.link("buffer", this, e));
  }
  listBuffers() {
    return this.buffers.map((e) => e.getChild());
  }
}
Ii([En], ns.prototype, "defaultScene", void 0), Ii([Wn], ns.prototype, "accessors", void 0), Ii([Wn], ns.prototype, "animations", void 0), Ii([Wn], ns.prototype, "buffers", void 0), Ii([Wn], ns.prototype, "cameras", void 0), Ii([Wn], ns.prototype, "materials", void 0), Ii([Wn], ns.prototype, "meshes", void 0), Ii([Wn], ns.prototype, "nodes", void 0), Ii([Wn], ns.prototype, "scenes", void 0), Ii([Wn], ns.prototype, "skins", void 0), Ii([Wn], ns.prototype, "textures", void 0);
class iu {
  constructor() {
    this.Ct = new Dy(), this.Ot = new ns(this.Ct), this._t = jr.DEFAULT_INSTANCE;
  }
  getRoot() {
    return this.Ot;
  }
  getGraph() {
    return this.Ct;
  }
  getLogger() {
    return this._t;
  }
  setLogger(e) {
    return this._t = e, this;
  }
  clone() {
    return new iu().merge(this).setLogger(this._t);
  }
  merge(e) {
    const t = {};
    for (const h of e.getRoot().listExtensionsUsed()) {
      const c = this.createExtension(h.constructor);
      h.isRequired() && c.setRequired(!0), t[c.extensionName] = c;
    }
    const n = /* @__PURE__ */ new Set(), s = /* @__PURE__ */ new Map();
    n.add(e.Ot), s.set(e.Ot, this.Ot);
    for (const h of e.Ct.getLinks())
      for (const c of [h.getParent(), h.getChild()]) {
        if (n.has(c))
          continue;
        let _;
        if (c.propertyType === en.TEXTURE_INFO)
          _ = c;
        else {
          const x = c.constructor;
          _ = c instanceof ud ? new x(this.Ct, t[c.extensionName]) : new x(this.Ct);
        }
        s.set(c, _), n.add(c);
      }
    const o = (h) => {
      const c = s.get(h);
      if (!c)
        throw new Error("Could resolve property.");
      return c;
    };
    for (const h of n) {
      const c = s.get(h);
      if (!c)
        throw new Error("Could resolve property.");
      c.copy(h, o);
    }
    return this;
  }
  async transform(...e) {
    const t = e.map((n) => n.name);
    for (const n of e)
      await n(this, { stack: t });
    return this;
  }
  createExtension(e) {
    const t = e.EXTENSION_NAME;
    return this.getRoot().listExtensionsUsed().find((n) => n.extensionName === t) || new e(this);
  }
  createScene(e = "") {
    const t = new ro(this.Ct, e);
    return this.Ot.Mt(t), t;
  }
  createNode(e = "") {
    const t = new Zs(this.Ct, e);
    return this.Ot.St(t), t;
  }
  createCamera(e = "") {
    const t = new ca(this.Ct, e);
    return this.Ot.At(t), t;
  }
  createSkin(e = "") {
    const t = new Ja(this.Ct, e);
    return this.Ot.It(t), t;
  }
  createMesh(e = "") {
    const t = new tu(this.Ct, e);
    return this.Ot.xt(t), t;
  }
  createPrimitive() {
    return new Ws(this.Ct);
  }
  createPrimitiveTarget(e = "") {
    return new dd(this.Ct, e);
  }
  createMaterial(e = "") {
    const t = new nr(this.Ct, e);
    return this.Ot.Et(t), t;
  }
  createTexture(e = "") {
    const t = new gd(this.Ct, e);
    return this.Ot.bt(t), t;
  }
  createAnimation(e = "") {
    const t = new pl(this.Ct, e);
    return this.Ot.Tt(t), t;
  }
  createAnimationChannel(e = "") {
    return new sl(this.Ct, e);
  }
  createAnimationSampler(e = "") {
    return new ua(this.Ct, e);
  }
  createAccessor(e = "", t = null) {
    t || (t = this.getRoot().listBuffers()[0]);
    const n = new Ti(this.Ct, e).setBuffer(t);
    return this.Ot.vt(n), n;
  }
  createBuffer(e = "") {
    const t = new hd(this.Ct, e);
    return this.Ot.yt(t), t;
  }
}
function rs() {
  return (rs = Object.assign || function(b) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (b[n] = t[n]);
    }
    return b;
  }).apply(this, arguments);
}
class Fy {
  constructor(e) {
    this.jsonDoc = void 0, this.buffers = [], this.bufferViews = [], this.bufferViewBuffers = [], this.accessors = [], this.textures = [], this.textureInfos = /* @__PURE__ */ new Map(), this.materials = [], this.meshes = [], this.cameras = [], this.nodes = [], this.skins = [], this.animations = [], this.scenes = [], this.jsonDoc = e;
  }
  setTextureInfo(e, t) {
    this.textureInfos.set(e, t), t.texCoord !== void 0 && e.setTexCoord(t.texCoord);
    const n = this.jsonDoc.json.textures[t.index];
    if (n.sampler === void 0)
      return;
    const s = this.jsonDoc.json.samplers[n.sampler];
    s.magFilter !== void 0 && e.setMagFilter(s.magFilter), s.minFilter !== void 0 && e.setMinFilter(s.minFilter), s.wrapS !== void 0 && e.setWrapS(s.wrapS), s.wrapT !== void 0 && e.setWrapT(s.wrapT);
  }
}
const Uh = { 5120: Int8Array, 5121: Uint8Array, 5122: Int16Array, 5123: Uint16Array, 5125: Uint32Array, 5126: Float32Array }, bf = { logger: jr.DEFAULT_INSTANCE, extensions: [], dependencies: {} };
function Jo(b, e) {
  const t = e.bufferViews[b.bufferView], n = e.jsonDoc.json.bufferViews[b.bufferView], s = Uh[b.componentType], o = Ti.getElementSize(b.type), h = s.BYTES_PER_ELEMENT;
  if (n.byteStride !== void 0 && n.byteStride !== o * h)
    return function(_, x) {
      const B = x.bufferViews[_.bufferView], P = x.jsonDoc.json.bufferViews[_.bufferView], U = Uh[_.componentType], M = Ti.getElementSize(_.type), Z = U.BYTES_PER_ELEMENT, F = _.byteOffset || 0, Q = new U(_.count * M), D = new DataView(B.buffer, B.byteOffset, B.byteLength), te = P.byteStride;
      for (let ee = 0; ee < _.count; ee++)
        for (let le = 0; le < M; le++) {
          const fe = F + ee * te + le * Z;
          let X;
          switch (_.componentType) {
            case Ti.ComponentType.FLOAT:
              X = D.getFloat32(fe, !0);
              break;
            case Ti.ComponentType.UNSIGNED_INT:
              X = D.getUint32(fe, !0);
              break;
            case Ti.ComponentType.UNSIGNED_SHORT:
              X = D.getUint16(fe, !0);
              break;
            case Ti.ComponentType.UNSIGNED_BYTE:
              X = D.getUint8(fe);
              break;
            case Ti.ComponentType.SHORT:
              X = D.getInt16(fe, !0);
              break;
            case Ti.ComponentType.BYTE:
              X = D.getInt8(fe);
              break;
            default:
              throw new Error(`Unexpected componentType "${_.componentType}".`);
          }
          Q[ee * M + le] = X;
        }
      return Q;
    }(b, e);
  const c = t.byteOffset + (b.byteOffset || 0);
  return new s(t.buffer.slice(c, c + b.count * o * h));
}
var Qa, eo;
(function(b) {
  b[b.ARRAY_BUFFER = 34962] = "ARRAY_BUFFER", b[b.ELEMENT_ARRAY_BUFFER = 34963] = "ELEMENT_ARRAY_BUFFER";
})(Qa || (Qa = {})), function(b) {
  b.ARRAY_BUFFER = "ARRAY_BUFFER", b.ELEMENT_ARRAY_BUFFER = "ELEMENT_ARRAY_BUFFER", b.INVERSE_BIND_MATRICES = "INVERSE_BIND_MATRICES", b.OTHER = "OTHER";
}(eo || (eo = {}));
class as {
  constructor(e, t, n) {
    this.Bt = void 0, this.jsonDoc = void 0, this.options = void 0, this.accessorIndexMap = /* @__PURE__ */ new Map(), this.bufferIndexMap = /* @__PURE__ */ new Map(), this.cameraIndexMap = /* @__PURE__ */ new Map(), this.skinIndexMap = /* @__PURE__ */ new Map(), this.materialIndexMap = /* @__PURE__ */ new Map(), this.meshIndexMap = /* @__PURE__ */ new Map(), this.nodeIndexMap = /* @__PURE__ */ new Map(), this.imageIndexMap = /* @__PURE__ */ new Map(), this.textureDefIndexMap = /* @__PURE__ */ new Map(), this.textureInfoDefMap = /* @__PURE__ */ new Map(), this.samplerDefIndexMap = /* @__PURE__ */ new Map(), this.imageBufferViews = [], this.otherBufferViews = /* @__PURE__ */ new Map(), this.otherBufferViewsIndexMap = /* @__PURE__ */ new Map(), this.extensionData = {}, this.bufferURIGenerator = void 0, this.imageURIGenerator = void 0, this.logger = void 0, this.Lt = /* @__PURE__ */ new Map(), this.accessorUsageGroupedByParent = /* @__PURE__ */ new Set(["ARRAY_BUFFER"]), this.accessorParents = /* @__PURE__ */ new Map(), this.Bt = e, this.jsonDoc = t, this.options = n;
    const s = e.getRoot(), o = s.listBuffers().length, h = s.listTextures().length;
    this.bufferURIGenerator = new xf(o > 1, n.basename), this.imageURIGenerator = new xf(h > 1, n.basename), this.logger = e.getLogger();
  }
  createTextureInfoDef(e, t) {
    const n = { magFilter: t.getMagFilter() || void 0, minFilter: t.getMinFilter() || void 0, wrapS: t.getWrapS(), wrapT: t.getWrapT() }, s = JSON.stringify(n);
    this.samplerDefIndexMap.has(s) || (this.samplerDefIndexMap.set(s, this.jsonDoc.json.samplers.length), this.jsonDoc.json.samplers.push(n));
    const o = { source: this.imageIndexMap.get(e), sampler: this.samplerDefIndexMap.get(s) }, h = JSON.stringify(o);
    this.textureDefIndexMap.has(h) || (this.textureDefIndexMap.set(h, this.jsonDoc.json.textures.length), this.jsonDoc.json.textures.push(o));
    const c = { index: this.textureDefIndexMap.get(h) };
    return t.getTexCoord() !== 0 && (c.texCoord = t.getTexCoord()), this.textureInfoDefMap.set(t, c), c;
  }
  createPropertyDef(e) {
    const t = {};
    return e.getName() && (t.name = e.getName()), Object.keys(e.getExtras()).length > 0 && (t.extras = e.getExtras()), t;
  }
  createAccessorDef(e) {
    const t = this.createPropertyDef(e);
    return t.type = e.getType(), t.componentType = e.getComponentType(), t.count = e.getCount(), this.Bt.getGraph().listParentLinks(e).some((n) => n.getName() === "POSITION" || n.getName() === "input") && (t.max = e.getMax([]).map(Math.fround), t.min = e.getMin([]).map(Math.fround)), e.getNormalized() && (t.normalized = e.getNormalized()), t;
  }
  createImageData(e, t, n) {
    if (this.options.format === la.GLB)
      this.imageBufferViews.push(t), e.bufferView = this.jsonDoc.json.bufferViews.length, this.jsonDoc.json.bufferViews.push({ buffer: 0, byteOffset: -1, byteLength: t.byteLength });
    else {
      const s = La.mimeTypeToExtension(n.getMimeType());
      e.uri = this.imageURIGenerator.createURI(n, s), this.jsonDoc.resources[e.uri] = t;
    }
  }
  getAccessorUsage(e) {
    const t = this.Lt.get(e);
    if (t)
      return t;
    for (const n of this.Bt.getGraph().listParentLinks(e)) {
      if (n.getName() === "inverseBindMatrices")
        return as.BufferViewUsage.INVERSE_BIND_MATRICES;
      if (n instanceof cd)
        return as.BufferViewUsage.ARRAY_BUFFER;
      if (n instanceof fd)
        return as.BufferViewUsage.ELEMENT_ARRAY_BUFFER;
    }
    return as.BufferViewUsage.OTHER;
  }
  addAccessorToUsageGroup(e, t) {
    const n = this.Lt.get(e);
    if (n && n !== t)
      throw new Error(`Accessor with usage "${n}" cannot be reused as "${t}".`);
    return this.Lt.set(e, t), this;
  }
  listAccessorUsageGroups() {
    const e = {};
    for (const [t, n] of Array.from(this.Lt.entries()))
      e[n] = e[n] || [], e[n].push(t);
    return e;
  }
}
as.BufferViewTarget = Qa, as.BufferViewUsage = eo, as.USAGE_TO_TARGET = { [eo.ARRAY_BUFFER]: Qa.ARRAY_BUFFER, [eo.ELEMENT_ARRAY_BUFFER]: Qa.ELEMENT_ARRAY_BUFFER };
class xf {
  constructor(e, t) {
    this.multiple = void 0, this.basename = void 0, this.counter = 1, this.multiple = e, this.basename = t;
  }
  createURI(e, t) {
    return e.getURI() ? e.getURI() : this.multiple ? `${this.basename}_${this.counter++}.${t}` : `${this.basename}.${t}`;
  }
}
const { BufferViewUsage: Bh } = as;
var ml;
(function(b) {
  b[b.JSON = 1313821514] = "JSON", b[b.BIN = 5130562] = "BIN";
})(ml || (ml = {}));
class Uy {
  constructor() {
    this._t = jr.DEFAULT_INSTANCE, this.gt = /* @__PURE__ */ new Set(), this.Pt = {}, this.Ut = dl.INTERLEAVED;
  }
  setLogger(e) {
    return this._t = e, this;
  }
  registerExtensions(e) {
    for (const t of e)
      this.gt.add(t), t.register();
    return this;
  }
  registerDependencies(e) {
    return Object.assign(this.Pt, e), this;
  }
  setVertexLayout(e) {
    return this.Ut = e, this;
  }
  kt(e) {
    function t(n) {
      if (n.uri && !(n.uri in e.resources) && n.uri.match(/data:/)) {
        const s = `__${Ny()}.${gl.extension(n.uri)}`;
        e.resources[s] = br.createBufferFromDataURI(n.uri), n.uri = s;
      }
    }
    (e.json.images || []).forEach((n) => {
      if (n.bufferView === void 0 && n.uri === void 0)
        throw new Error("Missing resource URI or buffer view.");
      t(n);
    }), (e.json.buffers || []).forEach(t);
  }
  readJSON(e) {
    return e = this.Ft(e), this.kt(e), (class {
      static read(t, n = bf) {
        const s = rs({}, bf, n), { json: o } = t, h = new iu();
        this.validate(t, s);
        const c = new Fy(t), _ = o.asset, x = h.getRoot().getAsset();
        _.copyright && (x.copyright = _.copyright), _.extras && (x.extras = _.extras), o.extras !== void 0 && h.getRoot().setExtras(rs({}, o.extras));
        const B = o.extensionsUsed || [], P = o.extensionsRequired || [];
        for (const te of s.extensions)
          if (B.includes(te.EXTENSION_NAME)) {
            const ee = h.createExtension(te).setRequired(P.includes(te.EXTENSION_NAME));
            for (const le of ee.readDependencies)
              ee.install(le, s.dependencies[le]);
          }
        const U = o.buffers || [];
        h.getRoot().listExtensionsUsed().filter((te) => te.prereadTypes.includes(en.BUFFER)).forEach((te) => te.preread(c, en.BUFFER)), c.buffers = U.map((te) => {
          const ee = h.createBuffer(te.name);
          return te.extras && ee.setExtras(te.extras), te.uri && te.uri.indexOf("__") !== 0 && ee.setURI(te.uri), ee;
        }), c.bufferViewBuffers = (o.bufferViews || []).map((te, ee) => {
          if (!c.bufferViews[ee]) {
            const le = t.json.buffers[te.buffer], fe = new Uint8Array(le.uri ? t.resources[le.uri] : t.resources["@glb.bin"], te.byteOffset || 0, te.byteLength);
            c.bufferViews[ee] = fe;
          }
          return c.buffers[te.buffer];
        }), c.accessors = (o.accessors || []).map((te) => {
          const ee = h.createAccessor(te.name, c.bufferViewBuffers[te.bufferView]).setType(te.type);
          if (te.extras && ee.setExtras(te.extras), te.normalized !== void 0 && ee.setNormalized(te.normalized), te.bufferView === void 0 && !te.sparse)
            return ee;
          let le;
          return le = te.sparse !== void 0 ? function(fe, X) {
            const W = Uh[fe.componentType], je = Ti.getElementSize(fe.type);
            let ke;
            ke = fe.bufferView !== void 0 ? Jo(fe, X) : new W(fe.count * je);
            const Ye = fe.sparse, pt = Ye.count, Le = rs({}, fe, Ye.indices, { count: pt, type: "SCALAR" }), $e = rs({}, fe, Ye.values, { count: pt }), ce = Jo(Le, X), ht = Jo($e, X);
            for (let De = 0; De < Le.count; De++)
              for (let ft = 0; ft < je; ft++)
                ke[ce[De] * je + ft] = ht[De * je + ft];
            return ke;
          }(te, c) : Jo(te, c), ee.setArray(le), ee;
        });
        const M = o.images || [], Z = o.textures || [];
        h.getRoot().listExtensionsUsed().filter((te) => te.prereadTypes.includes(en.TEXTURE)).forEach((te) => te.preread(c, en.TEXTURE)), c.textures = M.map((te) => {
          const ee = h.createTexture(te.name);
          if (te.extras && ee.setExtras(te.extras), te.bufferView !== void 0) {
            const le = o.bufferViews[te.bufferView], fe = t.json.buffers[le.buffer], X = le.byteOffset || 0, W = (fe.uri ? t.resources[fe.uri] : t.resources["@glb.bin"]).slice(X, X + le.byteLength);
            ee.setImage(W);
          } else
            te.uri !== void 0 && (ee.setImage(t.resources[te.uri]), te.uri.indexOf("__") !== 0 && ee.setURI(te.uri));
          if (te.mimeType !== void 0)
            ee.setMimeType(te.mimeType);
          else if (te.uri) {
            const le = gl.extension(te.uri);
            ee.setMimeType(La.extensionToMimeType(le));
          }
          return ee;
        }), c.materials = (o.materials || []).map((te) => {
          const ee = h.createMaterial(te.name);
          te.extras && ee.setExtras(te.extras), te.alphaMode !== void 0 && ee.setAlphaMode(te.alphaMode), te.alphaCutoff !== void 0 && ee.setAlphaCutoff(te.alphaCutoff), te.doubleSided !== void 0 && ee.setDoubleSided(te.doubleSided);
          const le = te.pbrMetallicRoughness || {};
          if (le.baseColorFactor !== void 0 && ee.setBaseColorFactor(le.baseColorFactor), te.emissiveFactor !== void 0 && ee.setEmissiveFactor(te.emissiveFactor), le.metallicFactor !== void 0 && ee.setMetallicFactor(le.metallicFactor), le.roughnessFactor !== void 0 && ee.setRoughnessFactor(le.roughnessFactor), le.baseColorTexture !== void 0) {
            const fe = le.baseColorTexture;
            ee.setBaseColorTexture(c.textures[Z[fe.index].source]), c.setTextureInfo(ee.getBaseColorTextureInfo(), fe);
          }
          if (te.emissiveTexture !== void 0) {
            const fe = te.emissiveTexture;
            ee.setEmissiveTexture(c.textures[Z[fe.index].source]), c.setTextureInfo(ee.getEmissiveTextureInfo(), fe);
          }
          if (te.normalTexture !== void 0) {
            const fe = te.normalTexture;
            ee.setNormalTexture(c.textures[Z[fe.index].source]), c.setTextureInfo(ee.getNormalTextureInfo(), fe), te.normalTexture.scale !== void 0 && ee.setNormalScale(te.normalTexture.scale);
          }
          if (te.occlusionTexture !== void 0) {
            const fe = te.occlusionTexture;
            ee.setOcclusionTexture(c.textures[Z[fe.index].source]), c.setTextureInfo(ee.getOcclusionTextureInfo(), fe), te.occlusionTexture.strength !== void 0 && ee.setOcclusionStrength(te.occlusionTexture.strength);
          }
          if (le.metallicRoughnessTexture !== void 0) {
            const fe = le.metallicRoughnessTexture;
            ee.setMetallicRoughnessTexture(c.textures[Z[fe.index].source]), c.setTextureInfo(ee.getMetallicRoughnessTextureInfo(), fe);
          }
          return ee;
        });
        const F = o.meshes || [];
        h.getRoot().listExtensionsUsed().filter((te) => te.prereadTypes.includes(en.PRIMITIVE)).forEach((te) => te.preread(c, en.PRIMITIVE)), c.meshes = F.map((te) => {
          const ee = h.createMesh(te.name);
          return te.extras && ee.setExtras(te.extras), te.weights !== void 0 && ee.setWeights(te.weights), (te.primitives || []).forEach((le) => {
            const fe = h.createPrimitive();
            le.extras && fe.setExtras(le.extras), le.material !== void 0 && fe.setMaterial(c.materials[le.material]), le.mode !== void 0 && fe.setMode(le.mode);
            for (const [W, je] of Object.entries(le.attributes || {}))
              fe.setAttribute(W, c.accessors[je]);
            le.indices !== void 0 && fe.setIndices(c.accessors[le.indices]);
            const X = te.extras && te.extras.targetNames || [];
            (le.targets || []).forEach((W, je) => {
              const ke = X[je] || je.toString(), Ye = h.createPrimitiveTarget(ke);
              for (const [pt, Le] of Object.entries(W))
                Ye.setAttribute(pt, c.accessors[Le]);
              fe.addTarget(Ye);
            }), ee.addPrimitive(fe);
          }), ee;
        }), c.cameras = (o.cameras || []).map((te) => {
          const ee = h.createCamera(te.name).setType(te.type);
          if (te.extras && ee.setExtras(te.extras), te.type === ca.Type.PERSPECTIVE) {
            const le = te.perspective;
            ee.setYFov(le.yfov), ee.setZNear(le.znear), le.zfar !== void 0 && ee.setZFar(le.zfar), le.aspectRatio !== void 0 && ee.setAspectRatio(le.aspectRatio);
          } else {
            const le = te.orthographic;
            ee.setZNear(le.znear).setZFar(le.zfar).setXMag(le.xmag).setYMag(le.ymag);
          }
          return ee;
        });
        const Q = o.nodes || [];
        h.getRoot().listExtensionsUsed().filter((te) => te.prereadTypes.includes(en.NODE)).forEach((te) => te.preread(c, en.NODE)), c.nodes = Q.map((te) => {
          const ee = h.createNode(te.name);
          if (te.extras && ee.setExtras(te.extras), te.translation !== void 0 && ee.setTranslation(te.translation), te.rotation !== void 0 && ee.setRotation(te.rotation), te.scale !== void 0 && ee.setScale(te.scale), te.matrix !== void 0) {
            const le = [0, 0, 0], fe = [0, 0, 0, 1], X = [1, 1, 1];
            Kn.decompose(te.matrix, le, fe, X), ee.setTranslation(le), ee.setRotation(fe), ee.setScale(X);
          }
          return te.weights !== void 0 && ee.setWeights(te.weights), ee;
        }), c.skins = (o.skins || []).map((te) => {
          const ee = h.createSkin(te.name);
          te.extras && ee.setExtras(te.extras), te.inverseBindMatrices !== void 0 && ee.setInverseBindMatrices(c.accessors[te.inverseBindMatrices]), te.skeleton !== void 0 && ee.setSkeleton(c.nodes[te.skeleton]);
          for (const le of te.joints)
            ee.addJoint(c.nodes[le]);
          return ee;
        }), Q.map((te, ee) => {
          const le = c.nodes[ee];
          (te.children || []).forEach((fe) => le.addChild(c.nodes[fe])), te.mesh !== void 0 && le.setMesh(c.meshes[te.mesh]), te.camera !== void 0 && le.setCamera(c.cameras[te.camera]), te.skin !== void 0 && le.setSkin(c.skins[te.skin]);
        }), c.animations = (o.animations || []).map((te) => {
          const ee = h.createAnimation(te.name);
          te.extras && ee.setExtras(te.extras);
          const le = (te.samplers || []).map((fe) => {
            const X = h.createAnimationSampler().setInput(c.accessors[fe.input]).setOutput(c.accessors[fe.output]).setInterpolation(fe.interpolation || ua.Interpolation.LINEAR);
            return fe.extras && X.setExtras(fe.extras), ee.addSampler(X), X;
          });
          return (te.channels || []).forEach((fe) => {
            const X = h.createAnimationChannel().setSampler(le[fe.sampler]).setTargetNode(c.nodes[fe.target.node]).setTargetPath(fe.target.path);
            fe.extras && X.setExtras(fe.extras), ee.addChannel(X);
          }), ee;
        });
        const D = o.scenes || [];
        return h.getRoot().listExtensionsUsed().filter((te) => te.prereadTypes.includes(en.SCENE)).forEach((te) => te.preread(c, en.SCENE)), c.scenes = D.map((te) => {
          const ee = h.createScene(te.name);
          return te.extras && ee.setExtras(te.extras), (te.nodes || []).map((le) => c.nodes[le]).forEach((le) => ee.addChild(le)), ee;
        }), o.scene !== void 0 && h.getRoot().setDefaultScene(c.scenes[o.scene]), h.getRoot().listExtensionsUsed().forEach((te) => te.read(c)), h;
      }
      static validate(t, n) {
        const s = t.json;
        if (s.asset.version !== "2.0")
          throw new Error(`Unsupported glTF version, "${s.asset.version}".`);
        if (s.extensionsRequired) {
          for (const o of s.extensionsRequired)
            if (!n.extensions.find((h) => h.EXTENSION_NAME === o))
              throw new Error(`Missing required extension, "${o}".`);
        }
        if (s.extensionsUsed)
          for (const o of s.extensionsUsed)
            n.extensions.find((h) => h.EXTENSION_NAME === o) || n.logger.warn(`Missing optional extension, "${o}".`);
      }
    }).read(e, { extensions: Array.from(this.gt), dependencies: this.Pt, logger: this._t });
  }
  writeJSON(e, t = {}) {
    if (t.format === la.GLB && e.getRoot().listBuffers().length > 1)
      throw new Error("GLB must have 0–1 buffers.");
    return (class {
      static write(n, s) {
        const o = n.getRoot(), h = { asset: rs({ generator: "glTF-Transform v1.2.4" }, o.getAsset()), extras: rs({}, o.getExtras()) }, c = { json: h, resources: {} }, _ = new as(n, c, s), x = s.logger || jr.DEFAULT_INSTANCE, B = new Set(s.extensions.map((D) => D.EXTENSION_NAME)), P = n.getRoot().listExtensionsUsed().filter((D) => B.has(D.extensionName)), U = n.getRoot().listExtensionsRequired().filter((D) => B.has(D.extensionName));
        P.length < n.getRoot().listExtensionsUsed().length && x.debug("Some extensions were not registered for I/O, and will not be written.");
        for (const D of P)
          for (const te of D.writeDependencies)
            D.install(te, s.dependencies[te]);
        function M(D, te, ee, le) {
          const fe = [];
          let X = 0;
          for (const je of D) {
            const ke = _.createAccessorDef(je);
            ke.bufferView = h.bufferViews.length;
            const Ye = br.pad(je.getArray().buffer);
            ke.byteOffset = X, X += Ye.byteLength, fe.push(Ye), _.accessorIndexMap.set(je, h.accessors.length), h.accessors.push(ke);
          }
          const W = { buffer: te, byteOffset: ee, byteLength: br.concat(fe).byteLength };
          return le && (W.target = le), h.bufferViews.push(W), { buffers: fe, byteLength: X };
        }
        function Z(D, te, ee) {
          const le = D[0].getCount();
          let fe = 0;
          for (const ke of D) {
            const Ye = _.createAccessorDef(ke);
            Ye.bufferView = h.bufferViews.length, Ye.byteOffset = fe;
            const pt = ke.getElementSize(), Le = ke.getComponentSize();
            fe += br.padNumber(pt * Le), _.accessorIndexMap.set(ke, h.accessors.length), h.accessors.push(Ye);
          }
          const X = le * fe, W = new ArrayBuffer(X), je = new DataView(W);
          for (let ke = 0; ke < le; ke++) {
            let Ye = 0;
            for (const pt of D) {
              const Le = pt.getElementSize(), $e = pt.getComponentSize(), ce = pt.getComponentType(), ht = pt.getArray();
              for (let De = 0; De < Le; De++) {
                const ft = ke * fe + Ye + De * $e, Yt = ht[ke * Le + De];
                switch (ce) {
                  case Ti.ComponentType.FLOAT:
                    je.setFloat32(ft, Yt, !0);
                    break;
                  case Ti.ComponentType.BYTE:
                    je.setInt8(ft, Yt);
                    break;
                  case Ti.ComponentType.SHORT:
                    je.setInt16(ft, Yt, !0);
                    break;
                  case Ti.ComponentType.UNSIGNED_BYTE:
                    je.setUint8(ft, Yt);
                    break;
                  case Ti.ComponentType.UNSIGNED_SHORT:
                    je.setUint16(ft, Yt, !0);
                    break;
                  case Ti.ComponentType.UNSIGNED_INT:
                    je.setUint32(ft, Yt, !0);
                    break;
                  default:
                    throw new Error("Unexpected component type: " + ce);
                }
              }
              Ye += br.padNumber(Le * $e);
            }
          }
          return h.bufferViews.push({ buffer: te, byteOffset: ee, byteLength: X, byteStride: fe, target: as.BufferViewTarget.ARRAY_BUFFER }), { byteLength: X, buffers: [W] };
        }
        const F = /* @__PURE__ */ new Map();
        for (const D of n.getGraph().getLinks()) {
          if (D.getParent() === o)
            continue;
          const te = D.getChild();
          if (te instanceof Ti) {
            const ee = F.get(te) || [];
            ee.push(D), F.set(te, ee);
          }
        }
        if (h.accessors = [], h.bufferViews = [], h.samplers = [], h.textures = [], h.images = o.listTextures().map((D, te) => {
          const ee = _.createPropertyDef(D);
          D.getMimeType() && (ee.mimeType = D.getMimeType());
          const le = D.getImage();
          return le && _.createImageData(ee, le, D), _.imageIndexMap.set(D, te), ee;
        }), P.filter((D) => D.prewriteTypes.includes(en.ACCESSOR)).forEach((D) => D.prewrite(_, en.ACCESSOR)), o.listAccessors().forEach((D) => {
          const te = _.accessorUsageGroupedByParent, ee = _.accessorParents;
          if (_.accessorIndexMap.has(D))
            return;
          const le = F.get(D) || [], fe = _.getAccessorUsage(D);
          if (_.addAccessorToUsageGroup(D, fe), te.has(fe)) {
            const X = le[0].getParent(), W = ee.get(X) || /* @__PURE__ */ new Set();
            W.add(D), ee.set(X, W);
          }
        }), P.filter((D) => D.prewriteTypes.includes(en.BUFFER)).forEach((D) => D.prewrite(_, en.BUFFER)), (o.listAccessors().length > 0 || o.listTextures().length > 0 || _.otherBufferViews.size > 0) && o.listBuffers().length === 0)
          throw new Error("Buffer required for Document resources, but none was found.");
        h.buffers = [], o.listBuffers().forEach((D, te) => {
          const ee = _.createPropertyDef(D), le = _.accessorUsageGroupedByParent, fe = _.accessorParents, X = D.listParents().filter((Le) => Le instanceof Ti), W = new Set(X), je = [], ke = h.buffers.length;
          let Ye = 0;
          const pt = _.listAccessorUsageGroups();
          for (const Le in pt)
            if (le.has(Le))
              for (const $e of Array.from(fe.values())) {
                const ce = Array.from($e).filter((ht) => W.has(ht)).filter((ht) => _.getAccessorUsage(ht) === Le);
                if (ce.length)
                  if (Le !== Bh.ARRAY_BUFFER || s.vertexLayout === dl.INTERLEAVED) {
                    const ht = Le === Bh.ARRAY_BUFFER ? Z(ce, ke, Ye) : M(ce, ke, Ye);
                    Ye += ht.byteLength, je.push(...ht.buffers);
                  } else
                    for (const ht of ce) {
                      const De = Z([ht], ke, Ye);
                      Ye += De.byteLength, je.push(...De.buffers);
                    }
              }
            else {
              const $e = pt[Le].filter((ht) => W.has(ht));
              if (!$e.length)
                continue;
              const ce = M($e, ke, Ye, Le === Bh.ELEMENT_ARRAY_BUFFER ? as.BufferViewTarget.ELEMENT_ARRAY_BUFFER : void 0);
              Ye += ce.byteLength, je.push(...ce.buffers);
            }
          if (_.imageBufferViews.length && te === 0) {
            for (let Le = 0; Le < _.imageBufferViews.length; Le++)
              if (h.bufferViews[h.images[Le].bufferView].byteOffset = Ye, Ye += _.imageBufferViews[Le].byteLength, je.push(_.imageBufferViews[Le]), Ye % 8) {
                const $e = 8 - Ye % 8;
                Ye += $e, je.push(new ArrayBuffer($e));
              }
          }
          if (_.otherBufferViews.has(D))
            for (const Le of _.otherBufferViews.get(D))
              h.bufferViews.push({ buffer: ke, byteOffset: Ye, byteLength: Le.byteLength }), _.otherBufferViewsIndexMap.set(Le, h.bufferViews.length - 1), Ye += Le.byteLength, je.push(Le);
          if (Ye) {
            let Le;
            s.format === la.GLB ? Le = "@glb.bin" : (Le = _.bufferURIGenerator.createURI(D, "bin"), ee.uri = Le), ee.byteLength = Ye, c.resources[Le] = br.concat(je);
          }
          h.buffers.push(ee), _.bufferIndexMap.set(D, te);
        }), o.listAccessors().find((D) => !D.getBuffer()) && x.warn("Skipped writing one or more Accessors: no Buffer assigned."), h.materials = o.listMaterials().map((D, te) => {
          const ee = _.createPropertyDef(D);
          if (D.getAlphaMode() !== nr.AlphaMode.OPAQUE && (ee.alphaMode = D.getAlphaMode()), D.getAlphaMode() === nr.AlphaMode.MASK && (ee.alphaCutoff = D.getAlphaCutoff()), D.getDoubleSided() && (ee.doubleSided = !0), ee.pbrMetallicRoughness = {}, Kn.eq(D.getBaseColorFactor(), [1, 1, 1, 1]) || (ee.pbrMetallicRoughness.baseColorFactor = D.getBaseColorFactor()), Kn.eq(D.getEmissiveFactor(), [0, 0, 0]) || (ee.emissiveFactor = D.getEmissiveFactor()), D.getRoughnessFactor() !== 1 && (ee.pbrMetallicRoughness.roughnessFactor = D.getRoughnessFactor()), D.getMetallicFactor() !== 1 && (ee.pbrMetallicRoughness.metallicFactor = D.getMetallicFactor()), D.getBaseColorTexture()) {
            const le = D.getBaseColorTexture(), fe = D.getBaseColorTextureInfo();
            ee.pbrMetallicRoughness.baseColorTexture = _.createTextureInfoDef(le, fe);
          }
          if (D.getEmissiveTexture()) {
            const le = D.getEmissiveTexture(), fe = D.getEmissiveTextureInfo();
            ee.emissiveTexture = _.createTextureInfoDef(le, fe);
          }
          if (D.getNormalTexture()) {
            const le = D.getNormalTexture(), fe = D.getNormalTextureInfo(), X = _.createTextureInfoDef(le, fe);
            D.getNormalScale() !== 1 && (X.scale = D.getNormalScale()), ee.normalTexture = X;
          }
          if (D.getOcclusionTexture()) {
            const le = D.getOcclusionTexture(), fe = D.getOcclusionTextureInfo(), X = _.createTextureInfoDef(le, fe);
            D.getOcclusionStrength() !== 1 && (X.strength = D.getOcclusionStrength()), ee.occlusionTexture = X;
          }
          if (D.getMetallicRoughnessTexture()) {
            const le = D.getMetallicRoughnessTexture(), fe = D.getMetallicRoughnessTextureInfo();
            ee.pbrMetallicRoughness.metallicRoughnessTexture = _.createTextureInfoDef(le, fe);
          }
          return _.materialIndexMap.set(D, te), ee;
        }), h.meshes = o.listMeshes().map((D, te) => {
          const ee = _.createPropertyDef(D);
          let le = null;
          return ee.primitives = D.listPrimitives().map((fe) => {
            const X = { attributes: {} };
            X.mode = fe.getMode();
            const W = fe.getMaterial();
            W && (X.material = _.materialIndexMap.get(W)), Object.keys(fe.getExtras()).length && (X.extras = fe.getExtras());
            const je = fe.getIndices();
            je && (X.indices = _.accessorIndexMap.get(je));
            for (const ke of fe.listSemantics())
              X.attributes[ke] = _.accessorIndexMap.get(fe.getAttribute(ke));
            for (const ke of fe.listTargets()) {
              const Ye = {};
              for (const pt of ke.listSemantics())
                Ye[pt] = _.accessorIndexMap.get(ke.getAttribute(pt));
              X.targets = X.targets || [], X.targets.push(Ye);
            }
            return fe.listTargets().length && !le && (le = fe.listTargets().map((ke) => ke.getName())), X;
          }), D.getWeights().length && (ee.weights = D.getWeights()), le && (ee.extras = ee.extras || {}, ee.extras.targetNames = le), _.meshIndexMap.set(D, te), ee;
        }), h.cameras = o.listCameras().map((D, te) => {
          const ee = _.createPropertyDef(D);
          if (ee.type = D.getType(), ee.type === ca.Type.PERSPECTIVE) {
            ee.perspective = { znear: D.getZNear(), zfar: D.getZFar(), yfov: D.getYFov() };
            const le = D.getAspectRatio();
            le !== null && (ee.perspective.aspectRatio = le);
          } else
            ee.orthographic = { znear: D.getZNear(), zfar: D.getZFar(), xmag: D.getXMag(), ymag: D.getYMag() };
          return _.cameraIndexMap.set(D, te), ee;
        }), h.nodes = o.listNodes().map((D, te) => {
          const ee = _.createPropertyDef(D);
          return Kn.eq(D.getTranslation(), [0, 0, 0]) || (ee.translation = D.getTranslation()), Kn.eq(D.getRotation(), [0, 0, 0, 1]) || (ee.rotation = D.getRotation()), Kn.eq(D.getScale(), [1, 1, 1]) || (ee.scale = D.getScale()), D.getWeights().length && (ee.weights = D.getWeights()), _.nodeIndexMap.set(D, te), ee;
        }), h.skins = o.listSkins().map((D, te) => {
          const ee = _.createPropertyDef(D), le = D.getInverseBindMatrices();
          le && (ee.inverseBindMatrices = _.accessorIndexMap.get(le));
          const fe = D.getSkeleton();
          return fe && (ee.skeleton = _.nodeIndexMap.get(fe)), ee.joints = D.listJoints().map((X) => _.nodeIndexMap.get(X)), _.skinIndexMap.set(D, te), ee;
        }), o.listNodes().forEach((D, te) => {
          const ee = h.nodes[te], le = D.getMesh();
          le && (ee.mesh = _.meshIndexMap.get(le));
          const fe = D.getCamera();
          fe && (ee.camera = _.cameraIndexMap.get(fe));
          const X = D.getSkin();
          X && (ee.skin = _.skinIndexMap.get(X)), D.listChildren().length > 0 && (ee.children = D.listChildren().map((W) => _.nodeIndexMap.get(W)));
        }), h.animations = o.listAnimations().map((D) => {
          const te = _.createPropertyDef(D), ee = /* @__PURE__ */ new Map();
          return te.samplers = D.listSamplers().map((le, fe) => {
            const X = _.createPropertyDef(le);
            return X.input = _.accessorIndexMap.get(le.getInput()), X.output = _.accessorIndexMap.get(le.getOutput()), X.interpolation = le.getInterpolation(), ee.set(le, fe), X;
          }), te.channels = D.listChannels().map((le) => {
            const fe = _.createPropertyDef(le);
            return fe.sampler = ee.get(le.getSampler()), fe.target = { node: _.nodeIndexMap.get(le.getTargetNode()), path: le.getTargetPath() }, fe;
          }), te;
        }), h.scenes = o.listScenes().map((D) => {
          const te = _.createPropertyDef(D);
          return te.nodes = D.listChildren().map((ee) => _.nodeIndexMap.get(ee)), te;
        });
        const Q = o.getDefaultScene();
        return Q && (h.scene = o.listScenes().indexOf(Q)), h.extensionsUsed = P.map((D) => D.extensionName), h.extensionsRequired = U.map((D) => D.extensionName), P.forEach((D) => D.write(_)), function(D) {
          const te = [];
          for (const ee in D) {
            const le = D[ee];
            (Array.isArray(le) && le.length === 0 || le === null || le === "" || le && typeof le == "object" && Object.keys(le).length === 0) && te.push(ee);
          }
          for (const ee of te)
            delete D[ee];
        }(h), c;
      }
    }).write(e, { format: t.format || la.GLTF, basename: t.basename || "", logger: this._t, vertexLayout: this.Ut, dependencies: rs({}, this.Pt), extensions: Array.from(this.gt) });
  }
  Ft(e) {
    const { images: t, buffers: n } = e.json;
    return e = { json: rs({}, e.json), resources: rs({}, e.resources) }, t && (e.json.images = t.map((s) => rs({}, s))), n && (e.json.buffers = n.map((s) => rs({}, s))), e;
  }
  binaryToJSON(e) {
    const t = this.Gt(e);
    this.kt(t);
    const n = t.json;
    if (n.buffers && n.buffers.some((s) => function(o, h) {
      return h.uri !== void 0 && !(h.uri in o.resources);
    }(t, s)))
      throw new Error("Cannot resolve external buffers with binaryToJSON().");
    if (n.images && n.images.some((s) => function(o, h) {
      return h.uri !== void 0 && !(h.uri in o.resources) && h.bufferView === void 0;
    }(t, s)))
      throw new Error("Cannot resolve external images with binaryToJSON().");
    return t;
  }
  Gt(e) {
    const t = new Uint32Array(e, 0, 3);
    if (t[0] !== 1179937895)
      throw new Error("Invalid glTF asset.");
    if (t[1] !== 2)
      throw new Error(`Unsupported glTF binary version, "${t[1]}".`);
    const n = new Uint32Array(e, 12, 2);
    if (n[1] !== ml.JSON)
      throw new Error("Missing required GLB JSON chunk.");
    const s = n[0], o = br.decodeText(e.slice(20, 20 + s)), h = JSON.parse(o), c = 20 + s;
    if (e.byteLength <= c)
      return { json: h, resources: {} };
    const _ = new Uint32Array(e, c, 2);
    if (_[1] !== ml.BIN)
      throw new Error("Expected GLB BIN in second chunk.");
    return { json: h, resources: { "@glb.bin": e.slice(c + 8, c + 8 + _[0]) } };
  }
  readBinary(e) {
    return this.readJSON(this.binaryToJSON(e));
  }
  writeBinary(e) {
    const { json: t, resources: n } = this.writeJSON(e, { format: la.GLB }), s = new Uint32Array([1179937895, 2, 12]), o = JSON.stringify(t), h = br.pad(br.encodeText(o), 32), c = new Uint32Array([h.byteLength, 1313821514]).buffer, _ = br.concat([c, h]);
    s[s.length - 1] += _.byteLength;
    const x = Object.values(n)[0];
    if (!x || !x.byteLength)
      return br.concat([s.buffer, _]);
    const B = br.pad(x, 0), P = new Uint32Array([B.byteLength, 5130562]).buffer, U = br.concat([P, B]);
    return s[s.length - 1] += U.byteLength, br.concat([s.buffer, _, U]);
  }
}
const Vy = {};
class wf extends Uy {
  constructor(e = Vy) {
    super(), this.qt = void 0, this.qt = e;
  }
  read(e) {
    return this.readAsJSON(e).then((t) => this.readJSON(t));
  }
  readAsJSON(e) {
    return e.match(/^data:application\/octet-stream;/) || new URL(e, window.location.href).pathname.match(/\.glb$/) ? this.Jt(e) : this.zt(e);
  }
  Wt(e, t) {
    const n = [...e.json.images || [], ...e.json.buffers || []].map((s) => {
      const o = s.uri;
      return !o || o.match(/data:/) ? Promise.resolve() : fetch(function(h, c) {
        if (!function(B) {
          return !/^(?:[a-zA-Z]+:)?\//.test(B);
        }(c))
          return c;
        const _ = h.split("/"), x = c.split("/");
        _.pop();
        for (let B = 0; B < x.length; B++)
          x[B] !== "." && (x[B] === ".." ? _.pop() : _.push(x[B]));
        return _.join("/");
      }(t, o), this.qt).then((h) => h.arrayBuffer()).then((h) => {
        e.resources[o] = h;
      });
    });
    return Promise.all(n).then(() => {
    });
  }
  zt(e) {
    var t = this;
    const n = { json: {}, resources: {} };
    return fetch(e, this.qt).then((s) => s.json()).then(async function(s) {
      return n.json = s, await t.Wt(n, Sf(e)), t.kt(n), n;
    });
  }
  Jt(e) {
    var t = this;
    return fetch(e, this.qt).then((n) => n.arrayBuffer()).then(async function(n) {
      const s = t.Gt(n);
      return await t.Wt(s, Sf(e)), t.kt(s), s;
    });
  }
}
function Sf(b) {
  const e = b.lastIndexOf("/");
  return e === -1 ? "./" : b.substr(0, e + 1);
}
var Hy = Object.defineProperty, Yy = (b, e, t) => e in b ? Hy(b, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : b[e] = t, Qo = (b, e, t) => Yy(b, typeof e != "symbol" ? e + "" : e, t);
function Gy(b) {
  return b && b.__esModule && Object.prototype.hasOwnProperty.call(b, "default") ? b.default : b;
}
function jy(b) {
  if (Object.prototype.hasOwnProperty.call(b, "__esModule"))
    return b;
  var e = b.default;
  if (typeof e == "function") {
    var t = function n() {
      return this instanceof n ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    t.prototype = e.prototype;
  } else
    t = {};
  return Object.defineProperty(t, "__esModule", { value: !0 }), Object.keys(b).forEach(function(n) {
    var s = Object.getOwnPropertyDescriptor(b, n);
    Object.defineProperty(t, n, s.get ? s : {
      enumerable: !0,
      get: function() {
        return b[n];
      }
    });
  }), t;
}
function Wy(b) {
  throw new Error('Could not dynamically require "' + b + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var Vh = { exports: {} };
const Zy = {}, qy = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Zy
}, Symbol.toStringTag, { value: "Module" })), Mf = /* @__PURE__ */ jy(qy);
/*!
 * Paper.js v0.12.18 - The Swiss Army Knife of Vector Graphics Scripting.
 * http://paperjs.org/
 *
 * Copyright (c) 2011 - 2020, Jürg Lehni & Jonathan Puckey
 * http://juerglehni.com/ & https://puckey.studio/
 *
 * Distributed under the MIT license. See LICENSE file for details.
 *
 * All rights reserved.
 *
 * Date: Wed Jul 17 14:57:24 2024 +0200
 *
 ***
 *
 * Straps.js - Class inheritance library with support for bean-style accessors
 *
 * Copyright (c) 2006 - 2020 Jürg Lehni
 * http://juerglehni.com/
 *
 * Distributed under the MIT license.
 *
 ***
 *
 * Acorn.js
 * https://marijnhaverbeke.nl/acorn/
 *
 * Acorn is a tiny, fast JavaScript parser written in JavaScript,
 * created by Marijn Haverbeke and released under an MIT license.
 *
 */
var $y = Vh.exports, Cf;
function Xy() {
  return Cf || (Cf = 1, function(b) {
    (function(e, t) {
      e = e || Mf;
      var n = e.window, s = e.document, o = new function() {
        var i = /^(statics|enumerable|beans|preserve)$/, r = [], a = r.slice, l = Object.create, u = Object.getOwnPropertyDescriptor, d = Object.defineProperty, v = r.forEach || function(A, T) {
          for (var G = 0, R = this.length; G < R; G++)
            A.call(T, this[G], G, this);
        }, p = function(A, T) {
          for (var G in this)
            this.hasOwnProperty(G) && A.call(T, this[G], G, this);
        }, y = Object.assign || function(A) {
          for (var T = 1, G = arguments.length; T < G; T++) {
            var R = arguments[T];
            for (var Y in R)
              R.hasOwnProperty(Y) && (A[Y] = R[Y]);
          }
          return A;
        }, S = function(A, T, G) {
          if (A) {
            var R = u(A, "length");
            (R && typeof R.value == "number" ? v : p).call(A, T, G = G || A);
          }
          return G;
        };
        function L(A, T, G, R, Y) {
          var k = {};
          function z(H, ie) {
            ie = ie || (ie = u(T, H)) && (ie.get ? ie : ie.value), typeof ie == "string" && ie[0] === "#" && (ie = A[ie.substring(1)] || ie);
            var ae = typeof ie == "function", he = ie, pe = Y || ae && !ie.base ? ie && ie.get ? H in A : A[H] : null, se;
            (!Y || !pe) && (ae && pe && (ie.base = pe), ae && R !== !1 && (se = H.match(/^([gs]et|is)(([A-Z])(.*))$/)) && (k[se[3].toLowerCase() + se[4]] = se[2]), (!he || ae || !he.get || typeof he.get != "function" || !E.isPlainObject(he)) && (he = { value: he, writable: !0 }), (u(A, H) || { configurable: !0 }).configurable && (he.configurable = !0, he.enumerable = G ?? !se), d(A, H, he));
          }
          if (T) {
            for (var C in T)
              T.hasOwnProperty(C) && !i.test(C) && z(C);
            for (var C in k) {
              var I = k[C], j = A["set" + I], q = A["get" + I] || j && A["is" + I];
              q && (R === !0 || q.length === 0) && z(C, { get: q, set: j });
            }
          }
          return A;
        }
        function E() {
          for (var A = 0, T = arguments.length; A < T; A++) {
            var G = arguments[A];
            G && y(this, G);
          }
          return this;
        }
        return L(E, {
          inject: function(A) {
            if (A) {
              var T = A.statics === !0 ? A : A.statics, G = A.beans, R = A.preserve;
              T !== A && L(this.prototype, A, A.enumerable, G, R), L(this, T, null, G, R);
            }
            for (var Y = 1, k = arguments.length; Y < k; Y++)
              this.inject(arguments[Y]);
            return this;
          },
          extend: function() {
            for (var A = this, T, G, R = 0, Y, k = arguments.length; R < k && !(T && G); R++)
              Y = arguments[R], T = T || Y.initialize, G = G || Y.prototype;
            return T = T || function() {
              A.apply(this, arguments);
            }, G = T.prototype = G || l(this.prototype), d(
              G,
              "constructor",
              { value: T, writable: !0, configurable: !0 }
            ), L(T, this), arguments.length && this.inject.apply(T, arguments), T.base = A, T;
          }
        }).inject({
          enumerable: !1,
          initialize: E,
          set: E,
          inject: function() {
            for (var A = 0, T = arguments.length; A < T; A++) {
              var G = arguments[A];
              G && L(this, G, G.enumerable, G.beans, G.preserve);
            }
            return this;
          },
          extend: function() {
            var A = l(this);
            return A.inject.apply(A, arguments);
          },
          each: function(A, T) {
            return S(this, A, T);
          },
          clone: function() {
            return new this.constructor(this);
          },
          statics: {
            set: y,
            each: S,
            create: l,
            define: d,
            describe: u,
            clone: function(A) {
              return y(new A.constructor(), A);
            },
            isPlainObject: function(A) {
              var T = A != null && A.constructor;
              return T && (T === Object || T === E || T.name === "Object");
            },
            pick: function(A, T) {
              return A !== t ? A : T;
            },
            slice: function(A, T, G) {
              return a.call(A, T, G);
            }
          }
        });
      }();
      b.exports = o, o.inject({
        enumerable: !1,
        toString: function() {
          return this._id != null ? (this._class || "Object") + (this._name ? " '" + this._name + "'" : " @" + this._id) : "{ " + o.each(this, function(i, r) {
            if (!/^_/.test(r)) {
              var a = typeof i;
              this.push(r + ": " + (a === "number" ? B.instance.number(i) : a === "string" ? "'" + i + "'" : i));
            }
          }, []).join(", ") + " }";
        },
        getClassName: function() {
          return this._class || "";
        },
        importJSON: function(i) {
          return o.importJSON(i, this);
        },
        exportJSON: function(i) {
          return o.exportJSON(this, i);
        },
        toJSON: function() {
          return o.serialize(this);
        },
        set: function(i, r) {
          return i && o.filter(this, i, r, this._prioritize), this;
        }
      }, {
        beans: !1,
        statics: {
          exports: {},
          extend: function i() {
            var r = i.base.apply(this, arguments), a = r.prototype._class;
            return a && !o.exports[a] && (o.exports[a] = r), r;
          },
          equals: function(i, r) {
            if (i === r)
              return !0;
            if (i && i.equals)
              return i.equals(r);
            if (r && r.equals)
              return r.equals(i);
            if (i && r && typeof i == "object" && typeof r == "object") {
              if (Array.isArray(i) && Array.isArray(r)) {
                var a = i.length;
                if (a !== r.length)
                  return !1;
                for (; a--; )
                  if (!o.equals(i[a], r[a]))
                    return !1;
              } else {
                var l = Object.keys(i), a = l.length;
                if (a !== Object.keys(r).length)
                  return !1;
                for (; a--; ) {
                  var u = l[a];
                  if (!(r.hasOwnProperty(u) && o.equals(i[u], r[u])))
                    return !1;
                }
              }
              return !0;
            }
            return !1;
          },
          read: function(i, r, a, l) {
            if (this === o) {
              var u = this.peek(i, r);
              return i.__index++, u;
            }
            var d = this.prototype, v = d._readIndex, p = r || v && i.__index || 0, y = i.length, S = i[p];
            if (l = l || y - p, S instanceof this || a && a.readNull && S == null && l <= 1)
              return v && (i.__index = p + 1), S && a && a.clone ? S.clone() : S;
            if (S = o.create(d), v && (S.__read = !0), S = S.initialize.apply(S, p > 0 || p + l < y ? o.slice(i, p, p + l) : i) || S, v) {
              i.__index = p + S.__read;
              var L = S.__filtered;
              L && (i.__filtered = L, S.__filtered = t), S.__read = t;
            }
            return S;
          },
          peek: function(i, r) {
            return i[i.__index = r || i.__index || 0];
          },
          remain: function(i) {
            return i.length - (i.__index || 0);
          },
          readList: function(i, r, a, l) {
            for (var u = [], d, v = r || 0, p = l ? v + l : i.length, y = v; y < p; y++)
              u.push(Array.isArray(d = i[y]) ? this.read(d, 0, a) : this.read(i, y, a, 1));
            return u;
          },
          readNamed: function(i, r, a, l, u) {
            var d = this.getNamed(i, r), v = d !== t;
            if (v) {
              var p = i.__filtered;
              if (!p) {
                var y = this.getSource(i);
                p = i.__filtered = o.create(y), p.__unfiltered = y;
              }
              p[r] = t;
            }
            return this.read(v ? [d] : i, a, l, u);
          },
          readSupported: function(i, r) {
            var a = this.getSource(i), l = this, u = !1;
            return a && Object.keys(a).forEach(function(d) {
              if (d in r) {
                var v = l.readNamed(i, d);
                v !== t && (r[d] = v), u = !0;
              }
            }), u;
          },
          getSource: function(i) {
            var r = i.__source;
            if (r === t) {
              var a = i.length === 1 && i[0];
              r = i.__source = a && o.isPlainObject(a) ? a : null;
            }
            return r;
          },
          getNamed: function(i, r) {
            var a = this.getSource(i);
            if (a)
              return r ? a[r] : i.__filtered || a;
          },
          hasNamed: function(i, r) {
            return !!this.getNamed(i, r);
          },
          filter: function(i, r, a, l) {
            var u;
            function d(L) {
              if (!(a && L in a) && !(u && L in u)) {
                var E = r[L];
                E !== t && (i[L] = E);
              }
            }
            if (l) {
              for (var v = {}, p = 0, y, S = l.length; p < S; p++)
                (y = l[p]) in r && (d(y), v[y] = !0);
              u = v;
            }
            return Object.keys(r.__unfiltered || r).forEach(d), i;
          },
          isPlainValue: function(i, r) {
            return o.isPlainObject(i) || Array.isArray(i) || r && typeof i == "string";
          },
          serialize: function(i, r, a, l) {
            r = r || {};
            var u = !l, d;
            if (u && (r.formatter = new B(r.precision), l = {
              length: 0,
              definitions: {},
              references: {},
              add: function(E, A) {
                var T = "#" + E._id, G = this.references[T];
                if (!G) {
                  this.length++;
                  var R = A.call(E), Y = E._class;
                  Y && R[0] !== Y && R.unshift(Y), this.definitions[T] = R, G = this.references[T] = [T];
                }
                return G;
              }
            }), i && i._serialize) {
              d = i._serialize(r, l);
              var v = i._class;
              v && !i._compactSerialize && (u || !a) && d[0] !== v && d.unshift(v);
            } else if (Array.isArray(i)) {
              d = [];
              for (var p = 0, y = i.length; p < y; p++)
                d[p] = o.serialize(i[p], r, a, l);
            } else if (o.isPlainObject(i)) {
              d = {};
              for (var S = Object.keys(i), p = 0, y = S.length; p < y; p++) {
                var L = S[p];
                d[L] = o.serialize(
                  i[L],
                  r,
                  a,
                  l
                );
              }
            } else
              typeof i == "number" ? d = r.formatter.number(i, r.precision) : d = i;
            return u && l.length > 0 ? [["dictionary", l.definitions], d] : d;
          },
          deserialize: function(i, r, a, l, u) {
            var d = i, v = !a, p = v && i && i.length && i[0][0] === "dictionary";
            if (a = a || {}, Array.isArray(i)) {
              var y = i[0], S = y === "dictionary";
              if (i.length == 1 && /^#/.test(y))
                return a.dictionary[y];
              y = o.exports[y], d = [];
              for (var L = y ? 1 : 0, E = i.length; L < E; L++)
                d.push(o.deserialize(
                  i[L],
                  r,
                  a,
                  S,
                  p
                ));
              if (y) {
                var A = d;
                r ? d = r(y, A, v || u) : d = new y(A);
              }
            } else if (o.isPlainObject(i)) {
              d = {}, l && (a.dictionary = d);
              for (var T in i)
                d[T] = o.deserialize(i[T], r, a);
            }
            return p ? d[1] : d;
          },
          exportJSON: function(i, r) {
            var a = o.serialize(i, r);
            return r && r.asString == !1 ? a : JSON.stringify(a);
          },
          importJSON: function(i, r) {
            return o.deserialize(
              typeof i == "string" ? JSON.parse(i) : i,
              function(a, l, u) {
                var d = u && r && r.constructor === a, v = d ? r : o.create(a.prototype);
                if (l.length === 1 && v instanceof X && (d || !(v instanceof je))) {
                  var p = l[0];
                  o.isPlainObject(p) && (p.insert = !1, d && (l = l.concat([X.INSERT])));
                }
                return (d ? v.set : a).apply(v, l), d && (r = null), v;
              }
            );
          },
          push: function(i, r) {
            var a = r.length;
            if (a < 4096)
              i.push.apply(i, r);
            else {
              var l = i.length;
              i.length += a;
              for (var u = 0; u < a; u++)
                i[l + u] = r[u];
            }
            return i;
          },
          splice: function(i, r, a, l) {
            var u = r && r.length, d = a === t;
            a = d ? i.length : a, a > i.length && (a = i.length);
            for (var v = 0; v < u; v++)
              r[v]._index = a + v;
            if (d)
              return o.push(i, r), [];
            var p = [a, l];
            r && o.push(p, r);
            for (var y = i.splice.apply(i, p), v = 0, S = y.length; v < S; v++)
              y[v]._index = t;
            for (var v = a + u, S = i.length; v < S; v++)
              i[v]._index = v;
            return y;
          },
          capitalize: function(i) {
            return i.replace(/\b[a-z]/g, function(r) {
              return r.toUpperCase();
            });
          },
          camelize: function(i) {
            return i.replace(/-(.)/g, function(r, a) {
              return a.toUpperCase();
            });
          },
          hyphenate: function(i) {
            return i.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
          }
        }
      });
      var h = {
        on: function(i, r) {
          if (typeof i != "string")
            o.each(i, function(d, v) {
              this.on(v, d);
            }, this);
          else {
            var a = this._eventTypes, l = a && a[i], u = this._callbacks = this._callbacks || {};
            u = u[i] = u[i] || [], u.indexOf(r) === -1 && (u.push(r), l && l.install && u.length === 1 && l.install.call(this, i));
          }
          return this;
        },
        off: function(i, r) {
          if (typeof i != "string") {
            o.each(i, function(v, p) {
              this.off(p, v);
            }, this);
            return;
          }
          var a = this._eventTypes, l = a && a[i], u = this._callbacks && this._callbacks[i], d;
          return u && (!r || (d = u.indexOf(r)) !== -1 && u.length === 1 ? (l && l.uninstall && l.uninstall.call(this, i), delete this._callbacks[i]) : d !== -1 && u.splice(d, 1)), this;
        },
        once: function(i, r) {
          return this.on(i, function a() {
            r.apply(this, arguments), this.off(i, a);
          });
        },
        emit: function(i, r) {
          var a = this._callbacks && this._callbacks[i];
          if (!a)
            return !1;
          var l = o.slice(arguments, 1), u = r && r.target && !r.currentTarget;
          a = a.slice(), u && (r.currentTarget = this);
          for (var d = 0, v = a.length; d < v; d++)
            if (a[d].apply(this, l) == !1) {
              r && r.stop && r.stop();
              break;
            }
          return u && delete r.currentTarget, !0;
        },
        responds: function(i) {
          return !!(this._callbacks && this._callbacks[i]);
        },
        attach: "#on",
        detach: "#off",
        fire: "#emit",
        _installEvents: function(i) {
          var r = this._eventTypes, a = this._callbacks, l = i ? "install" : "uninstall";
          if (r) {
            for (var u in a)
              if (a[u].length > 0) {
                var d = r[u], v = d && d[l];
                v && v.call(this, u);
              }
          }
        },
        statics: {
          inject: function i(r) {
            var a = r._events;
            if (a) {
              var l = {};
              o.each(a, function(u, d) {
                var v = typeof u == "string", p = v ? u : d, y = o.capitalize(p), S = p.substring(2).toLowerCase();
                l[S] = v ? {} : u, p = "_" + p, r["get" + y] = function() {
                  return this[p];
                }, r["set" + y] = function(L) {
                  var E = this[p];
                  E && this.off(S, E), L && this.on(S, L), this[p] = L;
                };
              }), r._eventTypes = l;
            }
            return i.base.apply(this, arguments);
          }
        }
      }, c = o.extend({
        _class: "PaperScope",
        initialize: function i() {
          He = this, this.settings = new o({
            applyMatrix: !0,
            insertItems: !0,
            handleSize: 4,
            hitTolerance: 0
          }), this.project = null, this.projects = [], this.tools = [], this._id = i._id++, i._scopes[this._id] = this;
          var r = i.prototype;
          if (!this.support) {
            var a = mt.getContext(1, 1) || {};
            r.support = {
              nativeDash: "setLineDash" in a || "mozDash" in a,
              nativeBlendModes: Qe.nativeModes
            }, mt.release(a);
          }
          if (!this.agent) {
            var l = e.navigator.userAgent.toLowerCase(), u = (/(darwin|win|mac|linux|freebsd|sunos)/.exec(l) || [])[0], d = u === "darwin" ? "mac" : u, v = r.agent = r.browser = { platform: d };
            d && (v[d] = !0), l.replace(
              /(opera|chrome|safari|webkit|firefox|msie|trident|atom|node|jsdom)\/?\s*([.\d]+)(?:.*version\/([.\d]+))?(?:.*rv\:v?([.\d]+))?/g,
              function(p, y, S, L, E) {
                if (!v.chrome) {
                  var A = y === "opera" ? L : /^(node|trident)$/.test(y) ? E : S;
                  v.version = A, v.versionNumber = parseFloat(A), y = { trident: "msie", jsdom: "node" }[y] || y, v.name = y, v[y] = !0;
                }
              }
            ), v.chrome && delete v.webkit, v.atom && delete v.chrome;
          }
        },
        version: "0.12.18",
        getView: function() {
          var i = this.project;
          return i && i._view;
        },
        getPaper: function() {
          return this;
        },
        execute: function(i, r) {
          var a = He.PaperScript.execute(i, this, r);
          return ei.updateFocus(), a;
        },
        install: function(i) {
          var r = this;
          o.each(["project", "view", "tool"], function(l) {
            o.define(i, l, {
              configurable: !0,
              get: function() {
                return r[l];
              }
            });
          });
          for (var a in this)
            !/^_/.test(a) && this[a] && (i[a] = this[a]);
        },
        setup: function(i) {
          return He = this, this.project = new fe(i), this;
        },
        createCanvas: function(i, r) {
          return mt.getCanvas(i, r);
        },
        activate: function() {
          He = this;
        },
        clear: function() {
          for (var i = this.projects, r = this.tools, a = i.length - 1; a >= 0; a--)
            i[a].remove();
          for (var a = r.length - 1; a >= 0; a--)
            r[a].remove();
        },
        remove: function() {
          this.clear(), delete c._scopes[this._id];
        },
        statics: new function() {
          function i(r) {
            return r += "Attribute", function(a, l) {
              return a[r](l) || a[r]("data-paper-" + l);
            };
          }
          return {
            _scopes: {},
            _id: 0,
            get: function(r) {
              return this._scopes[r] || null;
            },
            getAttribute: i("get"),
            hasAttribute: i("has")
          };
        }()
      }), _ = o.extend(h, {
        initialize: function(i) {
          this._scope = He, this._index = this._scope[this._list].push(this) - 1, (i || !this._scope[this._reference]) && this.activate();
        },
        activate: function() {
          if (!this._scope)
            return !1;
          var i = this._scope[this._reference];
          return i && i !== this && i.emit("deactivate"), this._scope[this._reference] = this, this.emit("activate", i), !0;
        },
        isActive: function() {
          return this._scope[this._reference] === this;
        },
        remove: function() {
          return this._index == null ? !1 : (o.splice(this._scope[this._list], null, this._index, 1), this._scope[this._reference] == this && (this._scope[this._reference] = null), this._scope = null, !0);
        },
        getView: function() {
          return this._scope.getView();
        }
      }), x = {
        findItemBoundsCollisions: function(i, r, a) {
          function l(v) {
            for (var p = new Array(v.length), y = 0; y < v.length; y++) {
              var S = v[y].getBounds();
              p[y] = [S.left, S.top, S.right, S.bottom];
            }
            return p;
          }
          var u = l(i), d = !r || r === i ? u : l(r);
          return this.findBoundsCollisions(u, d, a || 0);
        },
        findCurveBoundsCollisions: function(i, r, a, l) {
          function u(A) {
            for (var T = Math.min, G = Math.max, R = new Array(A.length), Y = 0; Y < A.length; Y++) {
              var k = A[Y];
              R[Y] = [
                T(k[0], k[2], k[4], k[6]),
                T(k[1], k[3], k[5], k[7]),
                G(k[0], k[2], k[4], k[6]),
                G(k[1], k[3], k[5], k[7])
              ];
            }
            return R;
          }
          var d = u(i), v = !r || r === i ? d : u(r);
          if (l) {
            for (var p = this.findBoundsCollisions(
              d,
              v,
              a || 0,
              !1,
              !0
            ), y = this.findBoundsCollisions(
              d,
              v,
              a || 0,
              !0,
              !0
            ), S = [], L = 0, E = p.length; L < E; L++)
              S[L] = { hor: p[L], ver: y[L] };
            return S;
          }
          return this.findBoundsCollisions(d, v, a || 0);
        },
        findBoundsCollisions: function(i, r, a, l, u) {
          var d = !r || i === r, v = d ? i : i.concat(r), p = i.length, y = v.length;
          function S(Je, it, gt) {
            for (var Ne = 0, Fe = Je.length; Ne < Fe; ) {
              var st = Fe + Ne >>> 1;
              v[Je[st]][it] < gt ? Ne = st + 1 : Fe = st;
            }
            return Ne - 1;
          }
          for (var L = l ? 1 : 0, E = L + 2, A = l ? 0 : 1, T = A + 2, G = new Array(y), R = 0; R < y; R++)
            G[R] = R;
          G.sort(function(Je, it) {
            return v[Je][L] - v[it][L];
          });
          for (var Y = [], k = new Array(p), R = 0; R < y; R++) {
            var z = G[R], C = v[z], I = d ? z : z - p, j = z < p, q = d || !j, H = j ? [] : null;
            if (Y.length) {
              var ie = S(
                Y,
                E,
                C[L] - a
              ) + 1;
              if (Y.splice(0, ie), d && u) {
                H = H.concat(Y);
                for (var ae = 0; ae < Y.length; ae++) {
                  var he = Y[ae];
                  k[he].push(I);
                }
              } else
                for (var pe = C[T], se = C[A], ae = 0; ae < Y.length; ae++) {
                  var he = Y[ae], de = v[he], ve = he < p, we = d || he >= p;
                  (u || (j && we || q && ve) && pe >= de[A] - a && se <= de[T] + a) && (j && we && H.push(
                    d ? he : he - p
                  ), q && ve && k[he].push(I));
                }
            }
            if (j && (i === r && H.push(z), k[z] = H), Y.length) {
              var Se = C[E], Ae = S(Y, E, Se);
              Y.splice(Ae + 1, 0, z);
            } else
              Y.push(z);
          }
          for (var R = 0; R < k.length; R++) {
            var Ge = k[R];
            Ge && Ge.sort(function(it, gt) {
              return it - gt;
            });
          }
          return k;
        }
      }, B = o.extend({
        initialize: function(i) {
          this.precision = o.pick(i, 5), this.multiplier = Math.pow(10, this.precision);
        },
        number: function(i) {
          return this.precision < 16 ? Math.round(i * this.multiplier) / this.multiplier : i;
        },
        pair: function(i, r, a) {
          return this.number(i) + (a || ",") + this.number(r);
        },
        point: function(i, r) {
          return this.number(i.x) + (r || ",") + this.number(i.y);
        },
        size: function(i, r) {
          return this.number(i.width) + (r || ",") + this.number(i.height);
        },
        rectangle: function(i, r) {
          return this.point(i, r) + (r || ",") + this.size(i, r);
        }
      });
      B.instance = new B();
      var P = new function() {
        var i = [
          [0.5773502691896257],
          [0, 0.7745966692414834],
          [0.33998104358485626, 0.8611363115940526],
          [0, 0.5384693101056831, 0.906179845938664],
          [0.2386191860831969, 0.6612093864662645, 0.932469514203152],
          [0, 0.4058451513773972, 0.7415311855993945, 0.9491079123427585],
          [0.1834346424956498, 0.525532409916329, 0.7966664774136267, 0.9602898564975363],
          [0, 0.3242534234038089, 0.6133714327005904, 0.8360311073266358, 0.9681602395076261],
          [0.14887433898163122, 0.4333953941292472, 0.6794095682990244, 0.8650633666889845, 0.9739065285171717],
          [0, 0.26954315595234496, 0.5190961292068118, 0.7301520055740494, 0.8870625997680953, 0.978228658146057],
          [0.1252334085114689, 0.3678314989981802, 0.5873179542866175, 0.7699026741943047, 0.9041172563704749, 0.9815606342467192],
          [0, 0.2304583159551348, 0.44849275103644687, 0.6423493394403402, 0.8015780907333099, 0.9175983992229779, 0.9841830547185881],
          [0.10805494870734367, 0.31911236892788974, 0.5152486363581541, 0.6872929048116855, 0.827201315069765, 0.9284348836635735, 0.9862838086968123],
          [0, 0.20119409399743451, 0.3941513470775634, 0.5709721726085388, 0.7244177313601701, 0.8482065834104272, 0.937273392400706, 0.9879925180204854],
          [0.09501250983763744, 0.2816035507792589, 0.45801677765722737, 0.6178762444026438, 0.755404408355003, 0.8656312023878318, 0.9445750230732326, 0.9894009349916499]
        ], r = [
          [1],
          [0.8888888888888888, 0.5555555555555556],
          [0.6521451548625461, 0.34785484513745385],
          [0.5688888888888889, 0.47862867049936647, 0.23692688505618908],
          [0.46791393457269104, 0.3607615730481386, 0.17132449237917036],
          [0.4179591836734694, 0.3818300505051189, 0.27970539148927664, 0.1294849661688697],
          [0.362683783378362, 0.31370664587788727, 0.22238103445337448, 0.10122853629037626],
          [0.3302393550012598, 0.31234707704000286, 0.26061069640293544, 0.1806481606948574, 0.08127438836157441],
          [0.29552422471475287, 0.26926671930999635, 0.21908636251598204, 0.1494513491505806, 0.06667134430868814],
          [0.2729250867779006, 0.26280454451024665, 0.23319376459199048, 0.18629021092773426, 0.1255803694649046, 0.05566856711617366],
          [0.24914704581340277, 0.2334925365383548, 0.20316742672306592, 0.16007832854334622, 0.10693932599531843, 0.04717533638651183],
          [0.2325515532308739, 0.22628318026289723, 0.2078160475368885, 0.17814598076194574, 0.13887351021978725, 0.09212149983772845, 0.04048400476531588],
          [0.2152638534631578, 0.2051984637212956, 0.18553839747793782, 0.15720316715819355, 0.12151857068790319, 0.08015808715976021, 0.03511946033175186],
          [0.2025782419255613, 0.19843148532711158, 0.1861610000155622, 0.16626920581699392, 0.13957067792615432, 0.10715922046717194, 0.07036604748810812, 0.03075324199611727],
          [0.1894506104550685, 0.18260341504492358, 0.16915651939500254, 0.14959598881657674, 0.12462897125553388, 0.09515851168249279, 0.062253523938647894, 0.027152459411754096]
        ], a = Math.abs, l = Math.sqrt, u = Math.pow, d = Math.log2 || function(E) {
          return Math.log(E) * Math.LOG2E;
        }, v = 1e-12, p = 112e-18;
        function y(E, A, T) {
          return E < A ? A : E > T ? T : E;
        }
        function S(E, A, T) {
          function G(ie) {
            var ae = ie * 134217729, he = ie - ae, pe = he + ae, se = ie - pe;
            return [pe, se];
          }
          var R = A * A - E * T, Y = A * A + E * T;
          if (a(R) * 3 < Y) {
            var k = G(E), z = G(A), C = G(T), I = A * A, j = z[0] * z[0] - I + 2 * z[0] * z[1] + z[1] * z[1], q = E * T, H = k[0] * C[0] - q + k[0] * C[1] + k[1] * C[0] + k[1] * C[1];
            R = I - q + (j - H);
          }
          return R;
        }
        function L() {
          var E = Math.max.apply(Math, arguments);
          return E && (E < 1e-8 || E > 1e8) ? u(2, -Math.round(d(E))) : 0;
        }
        return {
          EPSILON: v,
          MACHINE_EPSILON: p,
          CURVETIME_EPSILON: 1e-8,
          GEOMETRIC_EPSILON: 1e-7,
          TRIGONOMETRIC_EPSILON: 1e-8,
          ANGULAR_EPSILON: 1e-5,
          KAPPA: 4 * (l(2) - 1) / 3,
          isZero: function(E) {
            return E >= -v && E <= v;
          },
          isMachineZero: function(E) {
            return E >= -p && E <= p;
          },
          clamp: y,
          integrate: function(E, A, T, G) {
            for (var R = i[G - 2], Y = r[G - 2], k = (T - A) * 0.5, z = k + A, C = 0, I = G + 1 >> 1, j = G & 1 ? Y[C++] * E(z) : 0; C < I; ) {
              var q = k * R[C];
              j += Y[C++] * (E(z + q) + E(z - q));
            }
            return k * j;
          },
          findRoot: function(E, A, T, G, R, Y, k) {
            for (var z = 0; z < Y; z++) {
              var C = E(T), I = C / A(T), j = T - I;
              if (a(I) < k) {
                T = j;
                break;
              }
              C > 0 ? (R = T, T = j <= G ? (G + R) * 0.5 : j) : (G = T, T = j >= R ? (G + R) * 0.5 : j);
            }
            return y(T, G, R);
          },
          solveQuadratic: function(E, A, T, G, R, Y) {
            var k, z = 1 / 0;
            if (a(E) < v) {
              if (a(A) < v)
                return a(T) < v ? -1 : 0;
              k = -T / A;
            } else {
              A *= -0.5;
              var C = S(E, A, T);
              if (C && a(C) < p) {
                var I = L(a(E), a(A), a(T));
                I && (E *= I, A *= I, T *= I, C = S(E, A, T));
              }
              if (C >= -p) {
                var j = C < 0 ? 0 : l(C), q = A + (A < 0 ? -j : j);
                q === 0 ? (k = T / E, z = -k) : (k = q / E, z = T / q);
              }
            }
            var H = 0, ie = R == null, ae = R - v, he = Y + v;
            return isFinite(k) && (ie || k > ae && k < he) && (G[H++] = ie ? k : y(k, R, Y)), z !== k && isFinite(z) && (ie || z > ae && z < he) && (G[H++] = ie ? z : y(z, R, Y)), H;
          },
          solveCubic: function(E, A, T, G, R, Y, k) {
            var z = L(a(E), a(A), a(T), a(G)), C, I, j, q, H;
            z && (E *= z, A *= z, T *= z, G *= z);
            function ie(Ae) {
              C = Ae;
              var Ge = E * C;
              I = Ge + A, j = I * C + T, q = (Ge + I) * C + j, H = j * C + G;
            }
            if (a(E) < v)
              E = A, I = T, j = G, C = 1 / 0;
            else if (a(G) < v)
              I = A, j = T, C = 0;
            else {
              ie(-(A / E) / 3);
              var ae = H / E, he = u(a(ae), 1 / 3), pe = ae < 0 ? -1 : 1, se = -q / E, de = se > 0 ? 1.324717957244746 * Math.max(he, l(se)) : he, ve = C - pe * de;
              if (ve !== C) {
                do
                  ie(ve), ve = q === 0 ? C : C - H / q / (1 + p);
                while (pe * ve > pe * C);
                a(E) * C * C > a(G / C) && (j = -G / C, I = (j - T) / C);
              }
            }
            var we = P.solveQuadratic(E, I, j, R, Y, k), Se = Y == null;
            return isFinite(C) && (we === 0 || we > 0 && C !== R[0] && C !== R[1]) && (Se || C > Y - v && C < k + v) && (R[we++] = Se ? C : y(C, Y, k)), we;
          }
        };
      }(), U = {
        _id: 1,
        _pools: {},
        get: function(i) {
          if (i) {
            var r = this._pools[i];
            return r || (r = this._pools[i] = { _id: 1 }), r._id++;
          } else
            return this._id++;
        }
      }, M = o.extend({
        _class: "Point",
        _readIndex: !0,
        initialize: function(i, r) {
          var a = typeof i, l = this.__read, u = 0;
          if (a === "number") {
            var d = typeof r == "number";
            this._set(i, d ? r : i), l && (u = d ? 2 : 1);
          } else if (a === "undefined" || i === null)
            this._set(0, 0), l && (u = i === null ? 1 : 0);
          else {
            var v = a === "string" ? i.split(/[\s,]+/) || [] : i;
            u = 1, Array.isArray(v) ? this._set(+v[0], +(v.length > 1 ? v[1] : v[0])) : "x" in v ? this._set(v.x || 0, v.y || 0) : "width" in v ? this._set(v.width || 0, v.height || 0) : "angle" in v ? (this._set(v.length || 0, 0), this.setAngle(v.angle || 0)) : (this._set(0, 0), u = 0);
          }
          return l && (this.__read = u), this;
        },
        set: "#initialize",
        _set: function(i, r) {
          return this.x = i, this.y = r, this;
        },
        equals: function(i) {
          return this === i || i && (this.x === i.x && this.y === i.y || Array.isArray(i) && this.x === i[0] && this.y === i[1]) || !1;
        },
        clone: function() {
          return new M(this.x, this.y);
        },
        toString: function() {
          var i = B.instance;
          return "{ x: " + i.number(this.x) + ", y: " + i.number(this.y) + " }";
        },
        _serialize: function(i) {
          var r = i.formatter;
          return [r.number(this.x), r.number(this.y)];
        },
        getLength: function() {
          return Math.sqrt(this.x * this.x + this.y * this.y);
        },
        setLength: function(i) {
          if (this.isZero()) {
            var r = this._angle || 0;
            this._set(
              Math.cos(r) * i,
              Math.sin(r) * i
            );
          } else {
            var a = i / this.getLength();
            P.isZero(a) && this.getAngle(), this._set(
              this.x * a,
              this.y * a
            );
          }
        },
        getAngle: function() {
          return this.getAngleInRadians.apply(this, arguments) * 180 / Math.PI;
        },
        setAngle: function(i) {
          this.setAngleInRadians.call(this, i * Math.PI / 180);
        },
        getAngleInDegrees: "#getAngle",
        setAngleInDegrees: "#setAngle",
        getAngleInRadians: function() {
          if (arguments.length) {
            var i = M.read(arguments), r = this.getLength() * i.getLength();
            if (P.isZero(r))
              return NaN;
            var a = this.dot(i) / r;
            return Math.acos(a < -1 ? -1 : a > 1 ? 1 : a);
          } else
            return this.isZero() ? this._angle || 0 : this._angle = Math.atan2(this.y, this.x);
        },
        setAngleInRadians: function(i) {
          if (this._angle = i, !this.isZero()) {
            var r = this.getLength();
            this._set(
              Math.cos(i) * r,
              Math.sin(i) * r
            );
          }
        },
        getQuadrant: function() {
          return this.x >= 0 ? this.y >= 0 ? 1 : 4 : this.y >= 0 ? 2 : 3;
        }
      }, {
        beans: !1,
        getDirectedAngle: function() {
          var i = M.read(arguments);
          return Math.atan2(this.cross(i), this.dot(i)) * 180 / Math.PI;
        },
        getDistance: function() {
          var i = arguments, r = M.read(i), a = r.x - this.x, l = r.y - this.y, u = a * a + l * l, d = o.read(i);
          return d ? u : Math.sqrt(u);
        },
        normalize: function(i) {
          i === t && (i = 1);
          var r = this.getLength(), a = r !== 0 ? i / r : 0, l = new M(this.x * a, this.y * a);
          return a >= 0 && (l._angle = this._angle), l;
        },
        rotate: function(i, r) {
          if (i === 0)
            return this.clone();
          i = i * Math.PI / 180;
          var a = r ? this.subtract(r) : this, l = Math.sin(i), u = Math.cos(i);
          return a = new M(
            a.x * u - a.y * l,
            a.x * l + a.y * u
          ), r ? a.add(r) : a;
        },
        transform: function(i) {
          return i ? i._transformPoint(this) : this;
        },
        add: function() {
          var i = M.read(arguments);
          return new M(this.x + i.x, this.y + i.y);
        },
        subtract: function() {
          var i = M.read(arguments);
          return new M(this.x - i.x, this.y - i.y);
        },
        multiply: function() {
          var i = M.read(arguments);
          return new M(this.x * i.x, this.y * i.y);
        },
        divide: function() {
          var i = M.read(arguments);
          return new M(this.x / i.x, this.y / i.y);
        },
        modulo: function() {
          var i = M.read(arguments);
          return new M(this.x % i.x, this.y % i.y);
        },
        negate: function() {
          return new M(-this.x, -this.y);
        },
        isInside: function() {
          return D.read(arguments).contains(this);
        },
        isClose: function() {
          var i = arguments, r = M.read(i), a = o.read(i);
          return this.getDistance(r) <= a;
        },
        isCollinear: function() {
          var i = M.read(arguments);
          return M.isCollinear(this.x, this.y, i.x, i.y);
        },
        isColinear: "#isCollinear",
        isOrthogonal: function() {
          var i = M.read(arguments);
          return M.isOrthogonal(this.x, this.y, i.x, i.y);
        },
        isZero: function() {
          var i = P.isZero;
          return i(this.x) && i(this.y);
        },
        isNaN: function() {
          return isNaN(this.x) || isNaN(this.y);
        },
        isInQuadrant: function(i) {
          return this.x * (i > 1 && i < 4 ? -1 : 1) >= 0 && this.y * (i > 2 ? -1 : 1) >= 0;
        },
        dot: function() {
          var i = M.read(arguments);
          return this.x * i.x + this.y * i.y;
        },
        cross: function() {
          var i = M.read(arguments);
          return this.x * i.y - this.y * i.x;
        },
        project: function() {
          var i = M.read(arguments), r = i.isZero() ? 0 : this.dot(i) / i.dot(i);
          return new M(
            i.x * r,
            i.y * r
          );
        },
        statics: {
          min: function() {
            var i = arguments, r = M.read(i), a = M.read(i);
            return new M(
              Math.min(r.x, a.x),
              Math.min(r.y, a.y)
            );
          },
          max: function() {
            var i = arguments, r = M.read(i), a = M.read(i);
            return new M(
              Math.max(r.x, a.x),
              Math.max(r.y, a.y)
            );
          },
          random: function() {
            return new M(Math.random(), Math.random());
          },
          isCollinear: function(i, r, a, l) {
            return Math.abs(i * l - r * a) <= Math.sqrt((i * i + r * r) * (a * a + l * l)) * 1e-8;
          },
          isOrthogonal: function(i, r, a, l) {
            return Math.abs(i * a + r * l) <= Math.sqrt((i * i + r * r) * (a * a + l * l)) * 1e-8;
          }
        }
      }, o.each(["round", "ceil", "floor", "abs"], function(i) {
        var r = Math[i];
        this[i] = function() {
          return new M(r(this.x), r(this.y));
        };
      }, {})), Z = M.extend({
        initialize: function(i, r, a, l) {
          this._x = i, this._y = r, this._owner = a, this._setter = l;
        },
        _set: function(i, r, a) {
          return this._x = i, this._y = r, a || this._owner[this._setter](this), this;
        },
        getX: function() {
          return this._x;
        },
        setX: function(i) {
          this._x = i, this._owner[this._setter](this);
        },
        getY: function() {
          return this._y;
        },
        setY: function(i) {
          this._y = i, this._owner[this._setter](this);
        },
        isSelected: function() {
          return !!(this._owner._selection & this._getSelection());
        },
        setSelected: function(i) {
          this._owner._changeSelection(this._getSelection(), i);
        },
        _getSelection: function() {
          return this._setter === "setPosition" ? 4 : 0;
        }
      }), F = o.extend({
        _class: "Size",
        _readIndex: !0,
        initialize: function(i, r) {
          var a = typeof i, l = this.__read, u = 0;
          if (a === "number") {
            var d = typeof r == "number";
            this._set(i, d ? r : i), l && (u = d ? 2 : 1);
          } else if (a === "undefined" || i === null)
            this._set(0, 0), l && (u = i === null ? 1 : 0);
          else {
            var v = a === "string" ? i.split(/[\s,]+/) || [] : i;
            u = 1, Array.isArray(v) ? this._set(+v[0], +(v.length > 1 ? v[1] : v[0])) : "width" in v ? this._set(v.width || 0, v.height || 0) : "x" in v ? this._set(v.x || 0, v.y || 0) : (this._set(0, 0), u = 0);
          }
          return l && (this.__read = u), this;
        },
        set: "#initialize",
        _set: function(i, r) {
          return this.width = i, this.height = r, this;
        },
        equals: function(i) {
          return i === this || i && (this.width === i.width && this.height === i.height || Array.isArray(i) && this.width === i[0] && this.height === i[1]) || !1;
        },
        clone: function() {
          return new F(this.width, this.height);
        },
        toString: function() {
          var i = B.instance;
          return "{ width: " + i.number(this.width) + ", height: " + i.number(this.height) + " }";
        },
        _serialize: function(i) {
          var r = i.formatter;
          return [
            r.number(this.width),
            r.number(this.height)
          ];
        },
        add: function() {
          var i = F.read(arguments);
          return new F(this.width + i.width, this.height + i.height);
        },
        subtract: function() {
          var i = F.read(arguments);
          return new F(this.width - i.width, this.height - i.height);
        },
        multiply: function() {
          var i = F.read(arguments);
          return new F(this.width * i.width, this.height * i.height);
        },
        divide: function() {
          var i = F.read(arguments);
          return new F(this.width / i.width, this.height / i.height);
        },
        modulo: function() {
          var i = F.read(arguments);
          return new F(this.width % i.width, this.height % i.height);
        },
        negate: function() {
          return new F(-this.width, -this.height);
        },
        isZero: function() {
          var i = P.isZero;
          return i(this.width) && i(this.height);
        },
        isNaN: function() {
          return isNaN(this.width) || isNaN(this.height);
        },
        statics: {
          min: function(i, r) {
            return new F(
              Math.min(i.width, r.width),
              Math.min(i.height, r.height)
            );
          },
          max: function(i, r) {
            return new F(
              Math.max(i.width, r.width),
              Math.max(i.height, r.height)
            );
          },
          random: function() {
            return new F(Math.random(), Math.random());
          }
        }
      }, o.each(["round", "ceil", "floor", "abs"], function(i) {
        var r = Math[i];
        this[i] = function() {
          return new F(r(this.width), r(this.height));
        };
      }, {})), Q = F.extend({
        initialize: function(i, r, a, l) {
          this._width = i, this._height = r, this._owner = a, this._setter = l;
        },
        _set: function(i, r, a) {
          return this._width = i, this._height = r, a || this._owner[this._setter](this), this;
        },
        getWidth: function() {
          return this._width;
        },
        setWidth: function(i) {
          this._width = i, this._owner[this._setter](this);
        },
        getHeight: function() {
          return this._height;
        },
        setHeight: function(i) {
          this._height = i, this._owner[this._setter](this);
        }
      }), D = o.extend({
        _class: "Rectangle",
        _readIndex: !0,
        beans: !0,
        initialize: function(i, r, a, l) {
          var u = arguments, d = typeof i, v;
          if (d === "number" ? (this._set(i, r, a, l), v = 4) : d === "undefined" || i === null ? (this._set(0, 0, 0, 0), v = i === null ? 1 : 0) : u.length === 1 && (Array.isArray(i) ? (this._set.apply(this, i), v = 1) : i.x !== t || i.width !== t ? (this._set(
            i.x || 0,
            i.y || 0,
            i.width || 0,
            i.height || 0
          ), v = 1) : i.from === t && i.to === t && (this._set(0, 0, 0, 0), o.readSupported(u, this) && (v = 1))), v === t) {
            var p = M.readNamed(u, "from"), y = o.peek(u), S = p.x, L = p.y, E, A;
            if (y && y.x !== t || o.hasNamed(u, "to")) {
              var T = M.readNamed(u, "to");
              E = T.x - S, A = T.y - L, E < 0 && (S = T.x, E = -E), A < 0 && (L = T.y, A = -A);
            } else {
              var G = F.read(u);
              E = G.width, A = G.height;
            }
            this._set(S, L, E, A), v = u.__index;
          }
          var R = u.__filtered;
          return R && (this.__filtered = R), this.__read && (this.__read = v), this;
        },
        set: "#initialize",
        _set: function(i, r, a, l) {
          return this.x = i, this.y = r, this.width = a, this.height = l, this;
        },
        clone: function() {
          return new D(this.x, this.y, this.width, this.height);
        },
        equals: function(i) {
          var r = o.isPlainValue(i) ? D.read(arguments) : i;
          return r === this || r && this.x === r.x && this.y === r.y && this.width === r.width && this.height === r.height || !1;
        },
        toString: function() {
          var i = B.instance;
          return "{ x: " + i.number(this.x) + ", y: " + i.number(this.y) + ", width: " + i.number(this.width) + ", height: " + i.number(this.height) + " }";
        },
        _serialize: function(i) {
          var r = i.formatter;
          return [
            r.number(this.x),
            r.number(this.y),
            r.number(this.width),
            r.number(this.height)
          ];
        },
        getPoint: function(i) {
          var r = i ? M : Z;
          return new r(this.x, this.y, this, "setPoint");
        },
        setPoint: function() {
          var i = M.read(arguments);
          this.x = i.x, this.y = i.y;
        },
        getSize: function(i) {
          var r = i ? F : Q;
          return new r(this.width, this.height, this, "setSize");
        },
        _fw: 1,
        _fh: 1,
        setSize: function() {
          var i = F.read(arguments), r = this._sx, a = this._sy, l = i.width, u = i.height;
          r && (this.x += (this.width - l) * r), a && (this.y += (this.height - u) * a), this.width = l, this.height = u, this._fw = this._fh = 1;
        },
        getLeft: function() {
          return this.x;
        },
        setLeft: function(i) {
          if (!this._fw) {
            var r = i - this.x;
            this.width -= this._sx === 0.5 ? r * 2 : r;
          }
          this.x = i, this._sx = this._fw = 0;
        },
        getTop: function() {
          return this.y;
        },
        setTop: function(i) {
          if (!this._fh) {
            var r = i - this.y;
            this.height -= this._sy === 0.5 ? r * 2 : r;
          }
          this.y = i, this._sy = this._fh = 0;
        },
        getRight: function() {
          return this.x + this.width;
        },
        setRight: function(i) {
          if (!this._fw) {
            var r = i - this.x;
            this.width = this._sx === 0.5 ? r * 2 : r;
          }
          this.x = i - this.width, this._sx = 1, this._fw = 0;
        },
        getBottom: function() {
          return this.y + this.height;
        },
        setBottom: function(i) {
          if (!this._fh) {
            var r = i - this.y;
            this.height = this._sy === 0.5 ? r * 2 : r;
          }
          this.y = i - this.height, this._sy = 1, this._fh = 0;
        },
        getCenterX: function() {
          return this.x + this.width / 2;
        },
        setCenterX: function(i) {
          this._fw || this._sx === 0.5 ? this.x = i - this.width / 2 : (this._sx && (this.x += (i - this.x) * 2 * this._sx), this.width = (i - this.x) * 2), this._sx = 0.5, this._fw = 0;
        },
        getCenterY: function() {
          return this.y + this.height / 2;
        },
        setCenterY: function(i) {
          this._fh || this._sy === 0.5 ? this.y = i - this.height / 2 : (this._sy && (this.y += (i - this.y) * 2 * this._sy), this.height = (i - this.y) * 2), this._sy = 0.5, this._fh = 0;
        },
        getCenter: function(i) {
          var r = i ? M : Z;
          return new r(this.getCenterX(), this.getCenterY(), this, "setCenter");
        },
        setCenter: function() {
          var i = M.read(arguments);
          return this.setCenterX(i.x), this.setCenterY(i.y), this;
        },
        getArea: function() {
          return this.width * this.height;
        },
        isEmpty: function() {
          return this.width === 0 || this.height === 0;
        },
        contains: function(i) {
          return i && i.width !== t || (Array.isArray(i) ? i : arguments).length === 4 ? this._containsRectangle(D.read(arguments)) : this._containsPoint(M.read(arguments));
        },
        _containsPoint: function(i) {
          var r = i.x, a = i.y;
          return r >= this.x && a >= this.y && r <= this.x + this.width && a <= this.y + this.height;
        },
        _containsRectangle: function(i) {
          var r = i.x, a = i.y;
          return r >= this.x && a >= this.y && r + i.width <= this.x + this.width && a + i.height <= this.y + this.height;
        },
        intersects: function() {
          var i = D.read(arguments), r = o.read(arguments) || 0;
          return i.x + i.width > this.x - r && i.y + i.height > this.y - r && i.x < this.x + this.width + r && i.y < this.y + this.height + r;
        },
        intersect: function() {
          var i = D.read(arguments), r = Math.max(this.x, i.x), a = Math.max(this.y, i.y), l = Math.min(this.x + this.width, i.x + i.width), u = Math.min(this.y + this.height, i.y + i.height);
          return new D(r, a, l - r, u - a);
        },
        unite: function() {
          var i = D.read(arguments), r = Math.min(this.x, i.x), a = Math.min(this.y, i.y), l = Math.max(this.x + this.width, i.x + i.width), u = Math.max(this.y + this.height, i.y + i.height);
          return new D(r, a, l - r, u - a);
        },
        include: function() {
          var i = M.read(arguments), r = Math.min(this.x, i.x), a = Math.min(this.y, i.y), l = Math.max(this.x + this.width, i.x), u = Math.max(this.y + this.height, i.y);
          return new D(r, a, l - r, u - a);
        },
        expand: function() {
          var i = F.read(arguments), r = i.width, a = i.height;
          return new D(
            this.x - r / 2,
            this.y - a / 2,
            this.width + r,
            this.height + a
          );
        },
        scale: function(i, r) {
          return this.expand(
            this.width * i - this.width,
            this.height * (r === t ? i : r) - this.height
          );
        }
      }, o.each(
        [
          ["Top", "Left"],
          ["Top", "Right"],
          ["Bottom", "Left"],
          ["Bottom", "Right"],
          ["Left", "Center"],
          ["Top", "Center"],
          ["Right", "Center"],
          ["Bottom", "Center"]
        ],
        function(i, r) {
          var a = i.join(""), l = /^[RL]/.test(a);
          r >= 4 && (i[1] += l ? "Y" : "X");
          var u = i[l ? 0 : 1], d = i[l ? 1 : 0], v = "get" + u, p = "get" + d, y = "set" + u, S = "set" + d, L = "get" + a, E = "set" + a;
          this[L] = function(A) {
            var T = A ? M : Z;
            return new T(this[v](), this[p](), this, E);
          }, this[E] = function() {
            var A = M.read(arguments);
            this[y](A.x), this[S](A.y);
          };
        },
        {
          beans: !0
        }
      )), te = D.extend(
        {
          initialize: function(i, r, a, l, u, d) {
            this._set(i, r, a, l, !0), this._owner = u, this._setter = d;
          },
          _set: function(i, r, a, l, u) {
            return this._x = i, this._y = r, this._width = a, this._height = l, u || this._owner[this._setter](this), this;
          }
        },
        new function() {
          var i = D.prototype;
          return o.each(
            ["x", "y", "width", "height"],
            function(r) {
              var a = o.capitalize(r), l = "_" + r;
              this["get" + a] = function() {
                return this[l];
              }, this["set" + a] = function(u) {
                this[l] = u, this._dontNotify || this._owner[this._setter](this);
              };
            },
            o.each(
              [
                "Point",
                "Size",
                "Center",
                "Left",
                "Top",
                "Right",
                "Bottom",
                "CenterX",
                "CenterY",
                "TopLeft",
                "TopRight",
                "BottomLeft",
                "BottomRight",
                "LeftCenter",
                "TopCenter",
                "RightCenter",
                "BottomCenter"
              ],
              function(r) {
                var a = "set" + r;
                this[a] = function() {
                  this._dontNotify = !0, i[a].apply(this, arguments), this._dontNotify = !1, this._owner[this._setter](this);
                };
              },
              {
                isSelected: function() {
                  return !!(this._owner._selection & 2);
                },
                setSelected: function(r) {
                  var a = this._owner;
                  a._changeSelection && a._changeSelection(2, r);
                }
              }
            )
          );
        }()
      ), ee = o.extend({
        _class: "Matrix",
        initialize: function i(r, a) {
          var l = arguments, u = l.length, d = !0;
          if (u >= 6 ? this._set.apply(this, l) : u === 1 || u === 2 ? r instanceof i ? this._set(
            r._a,
            r._b,
            r._c,
            r._d,
            r._tx,
            r._ty,
            a
          ) : Array.isArray(r) ? this._set.apply(
            this,
            a ? r.concat([a]) : r
          ) : d = !1 : u ? d = !1 : this.reset(), !d)
            throw new Error("Unsupported matrix parameters");
          return this;
        },
        set: "#initialize",
        _set: function(i, r, a, l, u, d, v) {
          return this._a = i, this._b = r, this._c = a, this._d = l, this._tx = u, this._ty = d, v || this._changed(), this;
        },
        _serialize: function(i, r) {
          return o.serialize(this.getValues(), i, !0, r);
        },
        _changed: function() {
          var i = this._owner;
          i && (i._applyMatrix ? i.transform(null, !0) : i._changed(25));
        },
        clone: function() {
          return new ee(
            this._a,
            this._b,
            this._c,
            this._d,
            this._tx,
            this._ty
          );
        },
        equals: function(i) {
          return i === this || i && this._a === i._a && this._b === i._b && this._c === i._c && this._d === i._d && this._tx === i._tx && this._ty === i._ty;
        },
        toString: function() {
          var i = B.instance;
          return "[[" + [
            i.number(this._a),
            i.number(this._c),
            i.number(this._tx)
          ].join(", ") + "], [" + [
            i.number(this._b),
            i.number(this._d),
            i.number(this._ty)
          ].join(", ") + "]]";
        },
        reset: function(i) {
          return this._a = this._d = 1, this._b = this._c = this._tx = this._ty = 0, i || this._changed(), this;
        },
        apply: function(i, r) {
          var a = this._owner;
          return a ? (a.transform(null, o.pick(i, !0), r), this.isIdentity()) : !1;
        },
        translate: function() {
          var i = M.read(arguments), r = i.x, a = i.y;
          return this._tx += r * this._a + a * this._c, this._ty += r * this._b + a * this._d, this._changed(), this;
        },
        scale: function() {
          var i = arguments, r = M.read(i), a = M.read(i, 0, { readNull: !0 });
          return a && this.translate(a), this._a *= r.x, this._b *= r.x, this._c *= r.y, this._d *= r.y, a && this.translate(a.negate()), this._changed(), this;
        },
        rotate: function(i) {
          i *= Math.PI / 180;
          var r = M.read(arguments, 1), a = r.x, l = r.y, u = Math.cos(i), d = Math.sin(i), v = a - a * u + l * d, p = l - a * d - l * u, y = this._a, S = this._b, L = this._c, E = this._d;
          return this._a = u * y + d * L, this._b = u * S + d * E, this._c = -d * y + u * L, this._d = -d * S + u * E, this._tx += v * y + p * L, this._ty += v * S + p * E, this._changed(), this;
        },
        shear: function() {
          var i = arguments, r = M.read(i), a = M.read(i, 0, { readNull: !0 });
          a && this.translate(a);
          var l = this._a, u = this._b;
          return this._a += r.y * this._c, this._b += r.y * this._d, this._c += r.x * l, this._d += r.x * u, a && this.translate(a.negate()), this._changed(), this;
        },
        skew: function() {
          var i = arguments, r = M.read(i), a = M.read(i, 0, { readNull: !0 }), l = Math.PI / 180, u = new M(
            Math.tan(r.x * l),
            Math.tan(r.y * l)
          );
          return this.shear(u, a);
        },
        append: function(i, r) {
          if (i) {
            var a = this._a, l = this._b, u = this._c, d = this._d, v = i._a, p = i._c, y = i._b, S = i._d, L = i._tx, E = i._ty;
            this._a = v * a + y * u, this._c = p * a + S * u, this._b = v * l + y * d, this._d = p * l + S * d, this._tx += L * a + E * u, this._ty += L * l + E * d, r || this._changed();
          }
          return this;
        },
        prepend: function(i, r) {
          if (i) {
            var a = this._a, l = this._b, u = this._c, d = this._d, v = this._tx, p = this._ty, y = i._a, S = i._c, L = i._b, E = i._d, A = i._tx, T = i._ty;
            this._a = y * a + S * l, this._c = y * u + S * d, this._b = L * a + E * l, this._d = L * u + E * d, this._tx = y * v + S * p + A, this._ty = L * v + E * p + T, r || this._changed();
          }
          return this;
        },
        appended: function(i) {
          return this.clone().append(i);
        },
        prepended: function(i) {
          return this.clone().prepend(i);
        },
        invert: function() {
          var i = this._a, r = this._b, a = this._c, l = this._d, u = this._tx, d = this._ty, v = i * l - r * a, p = null;
          return v && !isNaN(v) && isFinite(u) && isFinite(d) && (this._a = l / v, this._b = -r / v, this._c = -a / v, this._d = i / v, this._tx = (a * d - l * u) / v, this._ty = (r * u - i * d) / v, p = this), p;
        },
        inverted: function() {
          return this.clone().invert();
        },
        concatenate: "#append",
        preConcatenate: "#prepend",
        chain: "#appended",
        _shiftless: function() {
          return new ee(this._a, this._b, this._c, this._d, 0, 0);
        },
        _orNullIfIdentity: function() {
          return this.isIdentity() ? null : this;
        },
        isIdentity: function() {
          return this._a === 1 && this._b === 0 && this._c === 0 && this._d === 1 && this._tx === 0 && this._ty === 0;
        },
        isInvertible: function() {
          var i = this._a * this._d - this._c * this._b;
          return i && !isNaN(i) && isFinite(this._tx) && isFinite(this._ty);
        },
        isSingular: function() {
          return !this.isInvertible();
        },
        transform: function(i, r, a) {
          return arguments.length < 3 ? this._transformPoint(M.read(arguments)) : this._transformCoordinates(i, r, a);
        },
        _transformPoint: function(i, r, a) {
          var l = i.x, u = i.y;
          return r || (r = new M()), r._set(
            l * this._a + u * this._c + this._tx,
            l * this._b + u * this._d + this._ty,
            a
          );
        },
        _transformCoordinates: function(i, r, a) {
          for (var l = 0, u = 2 * a; l < u; l += 2) {
            var d = i[l], v = i[l + 1];
            r[l] = d * this._a + v * this._c + this._tx, r[l + 1] = d * this._b + v * this._d + this._ty;
          }
          return r;
        },
        _transformCorners: function(i) {
          var r = i.x, a = i.y, l = r + i.width, u = a + i.height, d = [r, a, l, a, l, u, r, u];
          return this._transformCoordinates(d, d, 4);
        },
        _transformBounds: function(i, r, a) {
          for (var l = this._transformCorners(i), u = l.slice(0, 2), d = u.slice(), v = 2; v < 8; v++) {
            var p = l[v], y = v & 1;
            p < u[y] ? u[y] = p : p > d[y] && (d[y] = p);
          }
          return r || (r = new D()), r._set(
            u[0],
            u[1],
            d[0] - u[0],
            d[1] - u[1],
            a
          );
        },
        inverseTransform: function() {
          return this._inverseTransform(M.read(arguments));
        },
        _inverseTransform: function(i, r, a) {
          var l = this._a, u = this._b, d = this._c, v = this._d, p = this._tx, y = this._ty, S = l * v - u * d, L = null;
          if (S && !isNaN(S) && isFinite(p) && isFinite(y)) {
            var E = i.x - this._tx, A = i.y - this._ty;
            r || (r = new M()), L = r._set(
              (E * v - A * d) / S,
              (A * l - E * u) / S,
              a
            );
          }
          return L;
        },
        decompose: function() {
          var i = this._a, r = this._b, a = this._c, l = this._d, u = i * l - r * a, d = Math.sqrt, v = Math.atan2, p = 180 / Math.PI, y, S, L;
          if (i !== 0 || r !== 0) {
            var E = d(i * i + r * r);
            y = Math.acos(i / E) * (r > 0 ? 1 : -1), S = [E, u / E], L = [v(i * a + r * l, E * E), 0];
          } else if (a !== 0 || l !== 0) {
            var A = d(a * a + l * l);
            y = Math.asin(a / A) * (l > 0 ? 1 : -1), S = [u / A, A], L = [0, v(i * a + r * l, A * A)];
          } else
            y = 0, L = S = [0, 0];
          return {
            translation: this.getTranslation(),
            rotation: y * p,
            scaling: new M(S),
            skewing: new M(L[0] * p, L[1] * p)
          };
        },
        getValues: function() {
          return [this._a, this._b, this._c, this._d, this._tx, this._ty];
        },
        getTranslation: function() {
          return new M(this._tx, this._ty);
        },
        getScaling: function() {
          return this.decompose().scaling;
        },
        getRotation: function() {
          return this.decompose().rotation;
        },
        applyToContext: function(i) {
          this.isIdentity() || i.transform(
            this._a,
            this._b,
            this._c,
            this._d,
            this._tx,
            this._ty
          );
        }
      }, o.each(["a", "b", "c", "d", "tx", "ty"], function(i) {
        var r = o.capitalize(i), a = "_" + i;
        this["get" + r] = function() {
          return this[a];
        }, this["set" + r] = function(l) {
          this[a] = l, this._changed();
        };
      }, {})), le = o.extend({
        _class: "Line",
        initialize: function(i, r, a, l, u) {
          var d = !1;
          arguments.length >= 4 ? (this._px = i, this._py = r, this._vx = a, this._vy = l, d = u) : (this._px = i.x, this._py = i.y, this._vx = r.x, this._vy = r.y, d = a), d || (this._vx -= this._px, this._vy -= this._py);
        },
        getPoint: function() {
          return new M(this._px, this._py);
        },
        getVector: function() {
          return new M(this._vx, this._vy);
        },
        getLength: function() {
          return this.getVector().getLength();
        },
        intersect: function(i, r) {
          return le.intersect(
            this._px,
            this._py,
            this._vx,
            this._vy,
            i._px,
            i._py,
            i._vx,
            i._vy,
            !0,
            r
          );
        },
        getSide: function(i, r) {
          return le.getSide(
            this._px,
            this._py,
            this._vx,
            this._vy,
            i.x,
            i.y,
            !0,
            r
          );
        },
        getDistance: function(i) {
          return Math.abs(this.getSignedDistance(i));
        },
        getSignedDistance: function(i) {
          return le.getSignedDistance(
            this._px,
            this._py,
            this._vx,
            this._vy,
            i.x,
            i.y,
            !0
          );
        },
        isCollinear: function(i) {
          return M.isCollinear(this._vx, this._vy, i._vx, i._vy);
        },
        isOrthogonal: function(i) {
          return M.isOrthogonal(this._vx, this._vy, i._vx, i._vy);
        },
        statics: {
          intersect: function(i, r, a, l, u, d, v, p, y, S) {
            y || (a -= i, l -= r, v -= u, p -= d);
            var L = a * p - l * v;
            if (!P.isMachineZero(L)) {
              var E = i - u, A = r - d, T = (v * A - p * E) / L, G = (a * A - l * E) / L, R = 1e-12, Y = -R, k = 1 + R;
              if (S || Y < T && T < k && Y < G && G < k)
                return S || (T = T <= 0 ? 0 : T >= 1 ? 1 : T), new M(
                  i + T * a,
                  r + T * l
                );
            }
          },
          getSide: function(i, r, a, l, u, d, v, p) {
            v || (a -= i, l -= r);
            var y = u - i, S = d - r, L = y * l - S * a;
            return !p && P.isMachineZero(L) && (L = (y * a + y * a) / (a * a + l * l), L >= 0 && L <= 1 && (L = 0)), L < 0 ? -1 : L > 0 ? 1 : 0;
          },
          getSignedDistance: function(i, r, a, l, u, d, v) {
            return v || (a -= i, l -= r), a === 0 ? l > 0 ? u - i : i - u : l === 0 ? a < 0 ? d - r : r - d : ((u - i) * l - (d - r) * a) / (l > a ? l * Math.sqrt(1 + a * a / (l * l)) : a * Math.sqrt(1 + l * l / (a * a)));
          },
          getDistance: function(i, r, a, l, u, d, v) {
            return Math.abs(
              le.getSignedDistance(i, r, a, l, u, d, v)
            );
          }
        }
      }), fe = _.extend({
        _class: "Project",
        _list: "projects",
        _reference: "project",
        _compactSerialize: !0,
        initialize: function(i) {
          _.call(this, !0), this._children = [], this._namedChildren = {}, this._activeLayer = null, this._currentStyle = new _i(null, null, this), this._view = ei.create(
            this,
            i || mt.getCanvas(1, 1)
          ), this._selectionItems = {}, this._selectionCount = 0, this._updateVersion = 0;
        },
        _serialize: function(i, r) {
          return o.serialize(this._children, i, !0, r);
        },
        _changed: function(i, r) {
          if (i & 1) {
            var a = this._view;
            a && (a._needsUpdate = !0, !a._requested && a._autoUpdate && a.requestUpdate());
          }
          var l = this._changes;
          if (l && r) {
            var u = this._changesById, d = r._id, v = u[d];
            v ? v.flags |= i : l.push(u[d] = { item: r, flags: i });
          }
        },
        clear: function() {
          for (var i = this._children, r = i.length - 1; r >= 0; r--)
            i[r].remove();
        },
        isEmpty: function() {
          return !this._children.length;
        },
        remove: function i() {
          return i.base.call(this) ? (this._view && this._view.remove(), !0) : !1;
        },
        getView: function() {
          return this._view;
        },
        getCurrentStyle: function() {
          return this._currentStyle;
        },
        setCurrentStyle: function(i) {
          this._currentStyle.set(i);
        },
        getIndex: function() {
          return this._index;
        },
        getOptions: function() {
          return this._scope.settings;
        },
        getLayers: function() {
          return this._children;
        },
        getActiveLayer: function() {
          return this._activeLayer || new je({ project: this, insert: !0 });
        },
        getSymbolDefinitions: function() {
          var i = [], r = {};
          return this.getItems({
            class: pt,
            match: function(a) {
              var l = a._definition, u = l._id;
              return r[u] || (r[u] = !0, i.push(l)), !1;
            }
          }), i;
        },
        getSymbols: "getSymbolDefinitions",
        getSelectedItems: function() {
          var i = this._selectionItems, r = [];
          for (var a in i) {
            var l = i[a], u = l._selection;
            u & 1 && l.isInserted() ? r.push(l) : u || this._updateSelection(l);
          }
          return r;
        },
        _updateSelection: function(i) {
          var r = i._id, a = this._selectionItems;
          i._selection ? a[r] !== i && (this._selectionCount++, a[r] = i) : a[r] === i && (this._selectionCount--, delete a[r]);
        },
        selectAll: function() {
          for (var i = this._children, r = 0, a = i.length; r < a; r++)
            i[r].setFullySelected(!0);
        },
        deselectAll: function() {
          var i = this._selectionItems;
          for (var r in i)
            i[r].setFullySelected(!1);
        },
        addLayer: function(i) {
          return this.insertLayer(t, i);
        },
        insertLayer: function(i, r) {
          if (r instanceof je) {
            r._remove(!1, !0), o.splice(this._children, [r], i, 0), r._setProject(this, !0);
            var a = r._name;
            a && r.setName(a), this._changes && r._changed(5), this._activeLayer || (this._activeLayer = r);
          } else
            r = null;
          return r;
        },
        _insertItem: function(i, r, a) {
          return r = this.insertLayer(i, r) || (this._activeLayer || this._insertItem(
            t,
            new je(X.NO_INSERT),
            !0
          )).insertChild(i, r), a && r.activate && r.activate(), r;
        },
        getItems: function(i) {
          return X._getItems(this, i);
        },
        getItem: function(i) {
          return X._getItems(this, i, null, null, !0)[0] || null;
        },
        importJSON: function(i) {
          this.activate();
          var r = this._activeLayer;
          return o.importJSON(i, r && r.isEmpty() && r);
        },
        removeOn: function(i) {
          var r = this._removeSets;
          if (r) {
            i === "mouseup" && (r.mousedrag = null);
            var a = r[i];
            if (a) {
              for (var l in a) {
                var u = a[l];
                for (var d in r) {
                  var v = r[d];
                  v && v != a && delete v[u._id];
                }
                u.remove();
              }
              r[i] = null;
            }
          }
        },
        draw: function(i, r, a) {
          this._updateVersion++, i.save(), r.applyToContext(i);
          for (var l = this._children, u = new o({
            offset: new M(0, 0),
            pixelRatio: a,
            viewMatrix: r.isIdentity() ? null : r,
            matrices: [new ee()],
            updateMatrix: !0
          }), d = 0, v = l.length; d < v; d++)
            l[d].draw(i, u);
          if (i.restore(), this._selectionCount > 0) {
            i.save(), i.strokeWidth = 1;
            var p = this._selectionItems, y = this._scope.settings.handleSize, S = this._updateVersion;
            for (var L in p)
              p[L]._drawSelection(i, r, y, p, S);
            i.restore();
          }
        }
      }), X = o.extend(
        h,
        {
          statics: {
            extend: function i(r) {
              return r._serializeFields && (r._serializeFields = o.set(
                {},
                this.prototype._serializeFields,
                r._serializeFields
              )), i.base.apply(this, arguments);
            },
            INSERT: { insert: !0 },
            NO_INSERT: { insert: !1 }
          },
          _class: "Item",
          _name: null,
          _applyMatrix: !0,
          _canApplyMatrix: !0,
          _canScaleStroke: !1,
          _pivot: null,
          _visible: !0,
          _blendMode: "normal",
          _opacity: 1,
          _locked: !1,
          _guide: !1,
          _clipMask: !1,
          _selection: 0,
          _selectBounds: !0,
          _selectChildren: !1,
          _serializeFields: {
            name: null,
            applyMatrix: null,
            matrix: new ee(),
            pivot: null,
            visible: !0,
            blendMode: "normal",
            opacity: 1,
            locked: !1,
            guide: !1,
            clipMask: !1,
            selected: !1,
            data: {}
          },
          _prioritize: ["applyMatrix"]
        },
        new function() {
          var i = [
            "onMouseDown",
            "onMouseUp",
            "onMouseDrag",
            "onClick",
            "onDoubleClick",
            "onMouseMove",
            "onMouseEnter",
            "onMouseLeave"
          ];
          return o.each(
            i,
            function(r) {
              this._events[r] = {
                install: function(a) {
                  this.getView()._countItemEvent(a, 1);
                },
                uninstall: function(a) {
                  this.getView()._countItemEvent(a, -1);
                }
              };
            },
            {
              _events: {
                onFrame: {
                  install: function() {
                    this.getView()._animateItem(this, !0);
                  },
                  uninstall: function() {
                    this.getView()._animateItem(this, !1);
                  }
                },
                onLoad: {},
                onError: {}
              },
              statics: {
                _itemHandlers: i
              }
            }
          );
        }(),
        {
          initialize: function() {
          },
          _initialize: function(i, r) {
            var a = i && o.isPlainObject(i), l = a && i.internal === !0, u = this._matrix = new ee(), d = a && i.project || He.project, v = He.settings;
            return this._id = l ? null : U.get(), this._parent = this._index = null, this._applyMatrix = this._canApplyMatrix && v.applyMatrix, r && u.translate(r), u._owner = this, this._style = new _i(d._currentStyle, this, d), l || a && i.insert == !1 || !v.insertItems && !(a && i.insert == !0) ? this._setProject(d) : (a && i.parent || d)._insertItem(t, this, !0), a && i !== X.NO_INSERT && i !== X.INSERT && this.set(i, {
              internal: !0,
              insert: !0,
              project: !0,
              parent: !0
            }), a;
          },
          _serialize: function(i, r) {
            var a = {}, l = this;
            function u(d) {
              for (var v in d) {
                var p = l[v];
                o.equals(p, v === "leading" ? d.fontSize * 1.2 : d[v]) || (a[v] = o.serialize(
                  p,
                  i,
                  v !== "data",
                  r
                ));
              }
            }
            return u(this._serializeFields), this instanceof W || u(this._style._defaults), [this._class, a];
          },
          _changed: function(i) {
            var r = this._symbol, a = this._parent || r, l = this._project;
            i & 8 && (this._bounds = this._position = this._decomposed = t), i & 16 && (this._globalMatrix = t), a && i & 72 && X._clearBoundsCache(a), i & 2 && X._clearBoundsCache(this), l && l._changed(i, this), r && r._changed(i);
          },
          getId: function() {
            return this._id;
          },
          getName: function() {
            return this._name;
          },
          setName: function(i) {
            if (this._name && this._removeNamed(), i === +i + "")
              throw new Error(
                "Names consisting only of numbers are not supported."
              );
            var r = this._getOwner();
            if (i && r) {
              var a = r._children, l = r._namedChildren;
              (l[i] = l[i] || []).push(this), i in a || (a[i] = this);
            }
            this._name = i || t, this._changed(256);
          },
          getStyle: function() {
            return this._style;
          },
          setStyle: function(i) {
            this.getStyle().set(i);
          }
        },
        o.each(
          ["locked", "visible", "blendMode", "opacity", "guide"],
          function(i) {
            var r = o.capitalize(i), a = "_" + i, l = {
              locked: 256,
              visible: 265
            };
            this["get" + r] = function() {
              return this[a];
            }, this["set" + r] = function(u) {
              u != this[a] && (this[a] = u, this._changed(l[i] || 257));
            };
          },
          {}
        ),
        {
          beans: !0,
          getSelection: function() {
            return this._selection;
          },
          setSelection: function(i) {
            if (i !== this._selection) {
              this._selection = i;
              var r = this._project;
              r && (r._updateSelection(this), this._changed(257));
            }
          },
          _changeSelection: function(i, r) {
            var a = this._selection;
            this.setSelection(r ? a | i : a & ~i);
          },
          isSelected: function() {
            if (this._selectChildren) {
              for (var i = this._children, r = 0, a = i.length; r < a; r++)
                if (i[r].isSelected())
                  return !0;
            }
            return !!(this._selection & 1);
          },
          setSelected: function(i) {
            if (this._selectChildren)
              for (var r = this._children, a = 0, l = r.length; a < l; a++)
                r[a].setSelected(i);
            this._changeSelection(1, i);
          },
          isFullySelected: function() {
            var i = this._children, r = !!(this._selection & 1);
            if (i && r) {
              for (var a = 0, l = i.length; a < l; a++)
                if (!i[a].isFullySelected())
                  return !1;
              return !0;
            }
            return r;
          },
          setFullySelected: function(i) {
            var r = this._children;
            if (r)
              for (var a = 0, l = r.length; a < l; a++)
                r[a].setFullySelected(i);
            this._changeSelection(1, i);
          },
          isClipMask: function() {
            return this._clipMask;
          },
          setClipMask: function(i) {
            this._clipMask != (i = !!i) && (this._clipMask = i, i && (this.setFillColor(null), this.setStrokeColor(null)), this._changed(257), this._parent && this._parent._changed(2048));
          },
          getData: function() {
            return this._data || (this._data = {}), this._data;
          },
          setData: function(i) {
            this._data = i;
          },
          getPosition: function(i) {
            var r = i ? M : Z, a = this._position || (this._position = this._getPositionFromBounds());
            return new r(a.x, a.y, this, "setPosition");
          },
          setPosition: function() {
            this.translate(M.read(arguments).subtract(this.getPosition(!0)));
          },
          _getPositionFromBounds: function(i) {
            return this._pivot ? this._matrix._transformPoint(this._pivot) : (i || this.getBounds()).getCenter(!0);
          },
          getPivot: function() {
            var i = this._pivot;
            return i ? new Z(i.x, i.y, this, "setPivot") : null;
          },
          setPivot: function() {
            this._pivot = M.read(arguments, 0, { clone: !0, readNull: !0 }), this._position = t;
          }
        },
        o.each(
          {
            getStrokeBounds: { stroke: !0 },
            getHandleBounds: { handle: !0 },
            getInternalBounds: { internal: !0 }
          },
          function(i, r) {
            this[r] = function(a) {
              return this.getBounds(a, i);
            };
          },
          {
            beans: !0,
            getBounds: function(i, r) {
              var a = r || i instanceof ee, l = o.set(
                {},
                a ? r : i,
                this._boundsOptions
              );
              (!l.stroke || this.getStrokeScaling()) && (l.cacheItem = this);
              var u = this._getCachedBounds(a && i, l).rect;
              return arguments.length ? u : new te(
                u.x,
                u.y,
                u.width,
                u.height,
                this,
                "setBounds"
              );
            },
            setBounds: function() {
              var i = D.read(arguments), r = this.getBounds(), a = this._matrix, l = new ee(), u = i.getCenter();
              l.translate(u), (i.width != r.width || i.height != r.height) && (a.isInvertible() || (a.set(a._backup || new ee().translate(a.getTranslation())), r = this.getBounds()), l.scale(
                r.width !== 0 ? i.width / r.width : 0,
                r.height !== 0 ? i.height / r.height : 0
              )), u = r.getCenter(), l.translate(-u.x, -u.y), this.transform(l);
            },
            _getBounds: function(i, r) {
              var a = this._children;
              return !a || !a.length ? new D() : (X._updateBoundsCache(this, r.cacheItem), X._getBounds(a, i, r));
            },
            _getBoundsCacheKey: function(i, r) {
              return [
                i.stroke ? 1 : 0,
                i.handle ? 1 : 0,
                r ? 1 : 0
              ].join("");
            },
            _getCachedBounds: function(i, r, a) {
              i = i && i._orNullIfIdentity();
              var l = r.internal && !a, u = r.cacheItem, d = l ? null : this._matrix._orNullIfIdentity(), v = u && (!i || i.equals(d)) && this._getBoundsCacheKey(r, l), p = this._bounds;
              if (X._updateBoundsCache(this._parent || this._symbol, u), v && p && v in p) {
                var y = p[v];
                return {
                  rect: y.rect.clone(),
                  nonscaling: y.nonscaling
                };
              }
              var S = this._getBounds(i || d, r), L = S.rect || S, E = this._style, A = S.nonscaling || E.hasStroke() && !E.getStrokeScaling();
              if (v) {
                p || (this._bounds = p = {});
                var y = p[v] = {
                  rect: L.clone(),
                  nonscaling: A,
                  internal: l
                };
              }
              return {
                rect: L,
                nonscaling: A
              };
            },
            _getStrokeMatrix: function(i, r) {
              var a = this.getStrokeScaling() ? null : r && r.internal ? this : this._parent || this._symbol && this._symbol._item, l = a ? a.getViewMatrix().invert() : i;
              return l && l._shiftless();
            },
            statics: {
              _updateBoundsCache: function(i, r) {
                if (i && r) {
                  var a = r._id, l = i._boundsCache = i._boundsCache || {
                    ids: {},
                    list: []
                  };
                  l.ids[a] || (l.list.push(r), l.ids[a] = r);
                }
              },
              _clearBoundsCache: function(i) {
                var r = i._boundsCache;
                if (r) {
                  i._bounds = i._position = i._boundsCache = t;
                  for (var a = 0, l = r.list, u = l.length; a < u; a++) {
                    var d = l[a];
                    d !== i && (d._bounds = d._position = t, d._boundsCache && X._clearBoundsCache(d));
                  }
                }
              },
              _getBounds: function(i, r, a) {
                var l = 1 / 0, u = -l, d = l, v = u, p = !1;
                a = a || {};
                for (var y = 0, S = i.length; y < S; y++) {
                  var L = i[y];
                  if (L._visible && !L.isEmpty(!0)) {
                    var E = L._getCachedBounds(
                      r && r.appended(L._matrix),
                      a,
                      !0
                    ), A = E.rect;
                    l = Math.min(A.x, l), d = Math.min(A.y, d), u = Math.max(A.x + A.width, u), v = Math.max(A.y + A.height, v), E.nonscaling && (p = !0);
                  }
                }
                return {
                  rect: isFinite(l) ? new D(l, d, u - l, v - d) : new D(),
                  nonscaling: p
                };
              }
            }
          }
        ),
        {
          beans: !0,
          _decompose: function() {
            return this._applyMatrix ? null : this._decomposed || (this._decomposed = this._matrix.decompose());
          },
          getRotation: function() {
            var i = this._decompose();
            return i ? i.rotation : 0;
          },
          setRotation: function(i) {
            var r = this.getRotation();
            if (r != null && i != null) {
              var a = this._decomposed;
              this.rotate(i - r), a && (a.rotation = i, this._decomposed = a);
            }
          },
          getScaling: function() {
            var i = this._decompose(), r = i && i.scaling;
            return new Z(r ? r.x : 1, r ? r.y : 1, this, "setScaling");
          },
          setScaling: function() {
            var i = this.getScaling(), r = M.read(arguments, 0, { clone: !0, readNull: !0 });
            if (i && r && !i.equals(r)) {
              var a = this.getRotation(), l = this._decomposed, u = new ee(), d = P.isZero;
              if (d(i.x) || d(i.y))
                u.translate(l.translation), a && u.rotate(a), u.scale(r.x, r.y), this._matrix.set(u);
              else {
                var v = this.getPosition(!0);
                u.translate(v), a && u.rotate(a), u.scale(r.x / i.x, r.y / i.y), a && u.rotate(-a), u.translate(v.negate()), this.transform(u);
              }
              l && (l.scaling = r, this._decomposed = l);
            }
          },
          getMatrix: function() {
            return this._matrix;
          },
          setMatrix: function() {
            var i = this._matrix;
            i.set.apply(i, arguments);
          },
          getGlobalMatrix: function(i) {
            var r = this._globalMatrix;
            if (r)
              for (var a = this._parent, l = []; a; ) {
                if (!a._globalMatrix) {
                  r = null;
                  for (var u = 0, d = l.length; u < d; u++)
                    l[u]._globalMatrix = null;
                  break;
                }
                l.push(a), a = a._parent;
              }
            if (!r) {
              r = this._globalMatrix = this._matrix.clone();
              var a = this._parent;
              a && r.prepend(a.getGlobalMatrix(!0));
            }
            return i ? r : r.clone();
          },
          getViewMatrix: function() {
            return this.getGlobalMatrix().prepend(this.getView()._matrix);
          },
          getApplyMatrix: function() {
            return this._applyMatrix;
          },
          setApplyMatrix: function(i) {
            (this._applyMatrix = this._canApplyMatrix && !!i) && this.transform(null, !0);
          },
          getTransformContent: "#getApplyMatrix",
          setTransformContent: "#setApplyMatrix"
        },
        {
          getProject: function() {
            return this._project;
          },
          _setProject: function(i, r) {
            if (this._project !== i) {
              this._project && this._installEvents(!1), this._project = i;
              for (var a = this._children, l = 0, u = a && a.length; l < u; l++)
                a[l]._setProject(i);
              r = !0;
            }
            r && this._installEvents(!0);
          },
          getView: function() {
            return this._project._view;
          },
          _installEvents: function i(r) {
            i.base.call(this, r);
            for (var a = this._children, l = 0, u = a && a.length; l < u; l++)
              a[l]._installEvents(r);
          },
          getLayer: function() {
            for (var i = this; i = i._parent; )
              if (i instanceof je)
                return i;
            return null;
          },
          getParent: function() {
            return this._parent;
          },
          setParent: function(i) {
            return i.addChild(this);
          },
          _getOwner: "#getParent",
          getChildren: function() {
            return this._children;
          },
          setChildren: function(i) {
            this.removeChildren(), this.addChildren(i);
          },
          getFirstChild: function() {
            return this._children && this._children[0] || null;
          },
          getLastChild: function() {
            return this._children && this._children[this._children.length - 1] || null;
          },
          getNextSibling: function() {
            var i = this._getOwner();
            return i && i._children[this._index + 1] || null;
          },
          getPreviousSibling: function() {
            var i = this._getOwner();
            return i && i._children[this._index - 1] || null;
          },
          getIndex: function() {
            return this._index;
          },
          setIndex: function(i) {
            var r = this._parent, a = r && r._children;
            a && r.insertChildren(
              i in a ? i : t,
              [this]
            );
          },
          equals: function(i) {
            return i === this || i && this._class === i._class && this._style.equals(i._style) && this._matrix.equals(i._matrix) && this._locked === i._locked && this._visible === i._visible && this._blendMode === i._blendMode && this._opacity === i._opacity && this._clipMask === i._clipMask && this._guide === i._guide && this._equals(i) || !1;
          },
          _equals: function(i) {
            return o.equals(this._children, i._children);
          },
          clone: function(i) {
            var r = new this.constructor(X.NO_INSERT), a = this._children, l = o.pick(
              i ? i.insert : t,
              i === t || i === !0
            ), u = o.pick(i ? i.deep : t, !0);
            a && r.copyAttributes(this), (!a || u) && r.copyContent(this), a || r.copyAttributes(this), l && r.insertAbove(this);
            var d = this._name, v = this._parent;
            if (d && v) {
              for (var a = v._children, p = d, y = 1; a[d]; )
                d = p + " " + y++;
              d !== p && r.setName(d);
            }
            return r;
          },
          copyContent: function(i) {
            for (var r = i._children, a = 0, l = r && r.length; a < l; a++)
              this.addChild(r[a].clone(!1), !0);
          },
          copyAttributes: function(i, r) {
            this.setStyle(i._style);
            for (var a = [
              "_locked",
              "_visible",
              "_blendMode",
              "_opacity",
              "_clipMask",
              "_guide"
            ], l = 0, u = a.length; l < u; l++) {
              var d = a[l];
              i.hasOwnProperty(d) && (this[d] = i[d]);
            }
            r || this._matrix.set(i._matrix, !0), this.setApplyMatrix(i._applyMatrix), this.setPivot(i._pivot), this.setSelection(i._selection);
            var v = i._data, p = i._name;
            this._data = v ? o.clone(v) : null, p && this.setName(p);
          },
          rasterize: function(i, r) {
            var a, l, u;
            o.isPlainObject(i) ? (a = i.resolution, l = i.insert, u = i.raster) : (a = i, l = r), u || (u = new Ye(X.NO_INSERT));
            var d = this.getStrokeBounds(), v = (a || this.getView().getResolution()) / 72, p = d.getTopLeft().floor(), y = d.getBottomRight().ceil(), S = new F(y.subtract(p)), L = S.multiply(v);
            if (u.setSize(L, !0), !L.isZero()) {
              var E = u.getContext(!0), A = new ee().scale(v).translate(p.negate());
              E.save(), A.applyToContext(E), this.draw(E, new o({ matrices: [A] })), E.restore();
            }
            return u._matrix.set(
              new ee().translate(p.add(S.divide(2))).scale(1 / v)
            ), (l === t || l) && u.insertAbove(this), u;
          },
          contains: function() {
            var i = this._matrix;
            return i.isInvertible() && !!this._contains(i._inverseTransform(M.read(arguments)));
          },
          _contains: function(i) {
            var r = this._children;
            if (r) {
              for (var a = r.length - 1; a >= 0; a--)
                if (r[a].contains(i))
                  return !0;
              return !1;
            }
            return i.isInside(this.getInternalBounds());
          },
          isInside: function() {
            return D.read(arguments).contains(this.getBounds());
          },
          _asPathItem: function() {
            return new We.Rectangle({
              rectangle: this.getInternalBounds(),
              matrix: this._matrix,
              insert: !1
            });
          },
          intersects: function(i, r) {
            return i instanceof X ? this._asPathItem().getIntersections(
              i._asPathItem(),
              null,
              r,
              !0
            ).length > 0 : !1;
          }
        },
        new function() {
          function i() {
            var l = arguments;
            return this._hitTest(
              M.read(l),
              $e.getOptions(l)
            );
          }
          function r() {
            var l = arguments, u = M.read(l), d = $e.getOptions(l), v = [];
            return this._hitTest(u, new o({ all: v }, d)), v;
          }
          function a(l, u, d, v) {
            var p = this._children;
            if (p)
              for (var y = p.length - 1; y >= 0; y--) {
                var S = p[y], L = S !== v && S._hitTest(
                  l,
                  u,
                  d
                );
                if (L && !u.all)
                  return L;
              }
            return null;
          }
          return fe.inject({
            hitTest: i,
            hitTestAll: r,
            _hitTest: a
          }), {
            hitTest: i,
            hitTestAll: r,
            _hitTestChildren: a
          };
        }(),
        {
          _hitTest: function(i, r, a) {
            if (this._locked || !this._visible || this._guide && !r.guides || this.isEmpty())
              return null;
            var l = this._matrix, u = a ? a.appended(l) : this.getGlobalMatrix().prepend(this.getView()._matrix), d = Math.max(r.tolerance, 1e-12), v = r._tolerancePadding = new F(
              We._getStrokePadding(
                d,
                l._shiftless().invert()
              )
            );
            if (i = l._inverseTransform(i), !i || !this._children && !this.getBounds({ internal: !0, stroke: !0, handle: !0 }).expand(v.multiply(2))._containsPoint(i))
              return null;
            var p = !(r.guides && !this._guide || r.selected && !this.isSelected() || r.type && r.type !== o.hyphenate(this._class) || r.class && !(this instanceof r.class)), y = r.match, S = this, L, E;
            function A(C) {
              return C && y && !y(C) && (C = null), C && r.all && r.all.push(C), C;
            }
            function T(C, I) {
              var j = I ? L["get" + I]() : S.getPosition();
              if (i.subtract(j).divide(v).length <= 1)
                return new $e(C, S, {
                  name: I ? o.hyphenate(I) : C,
                  point: j
                });
            }
            var G = r.position, R = r.center, Y = r.bounds;
            if (p && this._parent && (G || R || Y)) {
              if ((R || Y) && (L = this.getInternalBounds()), E = G && T("position") || R && T("center", "Center"), !E && Y)
                for (var k = [
                  "TopLeft",
                  "TopRight",
                  "BottomLeft",
                  "BottomRight",
                  "LeftCenter",
                  "TopCenter",
                  "RightCenter",
                  "BottomCenter"
                ], z = 0; z < 8 && !E; z++)
                  E = T("bounds", k[z]);
              E = A(E);
            }
            return E || (E = this._hitTestChildren(i, r, u) || p && A(this._hitTestSelf(
              i,
              r,
              u,
              this.getStrokeScaling() ? null : u._shiftless().invert()
            )) || null), E && E.point && (E.point = l.transform(E.point)), E;
          },
          _hitTestSelf: function(i, r) {
            if (r.fill && this.hasFill() && this._contains(i))
              return new $e("fill", this);
          },
          matches: function(i, r) {
            function a(v, p) {
              for (var y in v)
                if (v.hasOwnProperty(y)) {
                  var S = v[y], L = p[y];
                  if (o.isPlainObject(S) && o.isPlainObject(L)) {
                    if (!a(S, L))
                      return !1;
                  } else if (!o.equals(S, L))
                    return !1;
                }
              return !0;
            }
            var l = typeof i;
            if (l === "object") {
              for (var u in i)
                if (i.hasOwnProperty(u) && !this.matches(u, i[u]))
                  return !1;
              return !0;
            } else {
              if (l === "function")
                return i(this);
              if (i === "match")
                return r(this);
              var d = /^(empty|editable)$/.test(i) ? this["is" + o.capitalize(i)]() : i === "type" ? o.hyphenate(this._class) : this[i];
              if (i === "class") {
                if (typeof r == "function")
                  return this instanceof r;
                d = this._class;
              }
              if (typeof r == "function")
                return !!r(d);
              if (r) {
                if (r.test)
                  return r.test(d);
                if (o.isPlainObject(r))
                  return a(r, d);
              }
              return o.equals(d, r);
            }
          },
          getItems: function(i) {
            return X._getItems(this, i, this._matrix);
          },
          getItem: function(i) {
            return X._getItems(this, i, this._matrix, null, !0)[0] || null;
          },
          statics: {
            _getItems: function i(r, a, l, u, d) {
              if (!u) {
                var v = typeof a == "object" && a, p = v && v.overlapping, y = v && v.inside, S = p || y, A = S && D.read([S]);
                u = {
                  items: [],
                  recursive: v && v.recursive !== !1,
                  inside: !!y,
                  overlapping: !!p,
                  rect: A,
                  path: p && new We.Rectangle({
                    rectangle: A,
                    insert: !1
                  })
                }, v && (a = o.filter({}, a, {
                  recursive: !0,
                  inside: !0,
                  overlapping: !0
                }));
              }
              var L = r._children, E = u.items, A = u.rect;
              l = A && (l || new ee());
              for (var T = 0, G = L && L.length; T < G; T++) {
                var R = L[T], Y = l && l.appended(R._matrix), k = !0;
                if (A) {
                  var S = R.getBounds(Y);
                  if (!A.intersects(S))
                    continue;
                  A.contains(S) || u.overlapping && (S.contains(A) || u.path.intersects(R, Y)) || (k = !1);
                }
                if (k && R.matches(a) && (E.push(R), d) || (u.recursive !== !1 && i(R, a, Y, u, d), d && E.length > 0))
                  break;
              }
              return E;
            }
          }
        },
        {
          importJSON: function(i) {
            var r = o.importJSON(i, this);
            return r !== this ? this.addChild(r) : r;
          },
          addChild: function(i) {
            return this.insertChild(t, i);
          },
          insertChild: function(i, r) {
            var a = r ? this.insertChildren(i, [r]) : null;
            return a && a[0];
          },
          addChildren: function(i) {
            return this.insertChildren(this._children.length, i);
          },
          insertChildren: function(i, r) {
            var a = this._children;
            if (a && r && r.length > 0) {
              r = o.slice(r);
              for (var l = {}, u = r.length - 1; u >= 0; u--) {
                var d = r[u], v = d && d._id;
                !d || l[v] ? r.splice(u, 1) : (d._remove(!1, !0), l[v] = !0);
              }
              o.splice(a, r, i, 0);
              for (var p = this._project, y = p._changes, u = 0, S = r.length; u < S; u++) {
                var d = r[u], L = d._name;
                d._parent = this, d._setProject(p, !0), L && d.setName(L), y && d._changed(5);
              }
              this._changed(11);
            } else
              r = null;
            return r;
          },
          _insertItem: "#insertChild",
          _insertAt: function(i, r) {
            var a = i && i._getOwner(), l = i !== this && a ? this : null;
            return l && (l._remove(!1, !0), a._insertItem(i._index + r, l)), l;
          },
          insertAbove: function(i) {
            return this._insertAt(i, 1);
          },
          insertBelow: function(i) {
            return this._insertAt(i, 0);
          },
          sendToBack: function() {
            var i = this._getOwner();
            return i ? i._insertItem(0, this) : null;
          },
          bringToFront: function() {
            var i = this._getOwner();
            return i ? i._insertItem(t, this) : null;
          },
          appendTop: "#addChild",
          appendBottom: function(i) {
            return this.insertChild(0, i);
          },
          moveAbove: "#insertAbove",
          moveBelow: "#insertBelow",
          addTo: function(i) {
            return i._insertItem(t, this);
          },
          copyTo: function(i) {
            return this.clone(!1).addTo(i);
          },
          reduce: function(i) {
            var r = this._children;
            if (r && r.length === 1) {
              var a = r[0].reduce(i);
              return this._parent ? (a.insertAbove(this), this.remove()) : a.remove(), a;
            }
            return this;
          },
          _removeNamed: function() {
            var i = this._getOwner();
            if (i) {
              var r = i._children, a = i._namedChildren, l = this._name, u = a[l], d = u ? u.indexOf(this) : -1;
              d !== -1 && (r[l] == this && delete r[l], u.splice(d, 1), u.length ? r[l] = u[0] : delete a[l]);
            }
          },
          _remove: function(i, r) {
            var a = this._getOwner(), l = this._project, u = this._index;
            return this._style && this._style._dispose(), a ? (this._name && this._removeNamed(), u != null && (l._activeLayer === this && (l._activeLayer = this.getNextSibling() || this.getPreviousSibling()), o.splice(a._children, null, u, 1)), this._installEvents(!1), i && l._changes && this._changed(5), r && a._changed(11, this), this._parent = null, !0) : !1;
          },
          remove: function() {
            return this._remove(!0, !0);
          },
          replaceWith: function(i) {
            var r = i && i.insertBelow(this);
            return r && this.remove(), r;
          },
          removeChildren: function(i, r) {
            if (!this._children)
              return null;
            i = i || 0, r = o.pick(r, this._children.length);
            for (var a = o.splice(this._children, null, i, r - i), l = a.length - 1; l >= 0; l--)
              a[l]._remove(!0, !1);
            return a.length > 0 && this._changed(11), a;
          },
          clear: "#removeChildren",
          reverseChildren: function() {
            if (this._children) {
              this._children.reverse();
              for (var i = 0, r = this._children.length; i < r; i++)
                this._children[i]._index = i;
              this._changed(11);
            }
          },
          isEmpty: function(i) {
            var r = this._children, a = r ? r.length : 0;
            if (i) {
              for (var l = 0; l < a; l++)
                if (!r[l].isEmpty(i))
                  return !1;
              return !0;
            }
            return !a;
          },
          isEditable: function() {
            for (var i = this; i; ) {
              if (!i._visible || i._locked)
                return !1;
              i = i._parent;
            }
            return !0;
          },
          hasFill: function() {
            return this.getStyle().hasFill();
          },
          hasStroke: function() {
            return this.getStyle().hasStroke();
          },
          hasShadow: function() {
            return this.getStyle().hasShadow();
          },
          _getOrder: function(i) {
            function r(v) {
              var p = [];
              do
                p.unshift(v);
              while (v = v._parent);
              return p;
            }
            for (var a = r(this), l = r(i), u = 0, d = Math.min(a.length, l.length); u < d; u++)
              if (a[u] != l[u])
                return a[u]._index < l[u]._index ? 1 : -1;
            return 0;
          },
          hasChildren: function() {
            return this._children && this._children.length > 0;
          },
          isInserted: function() {
            return this._parent ? this._parent.isInserted() : !1;
          },
          isAbove: function(i) {
            return this._getOrder(i) === -1;
          },
          isBelow: function(i) {
            return this._getOrder(i) === 1;
          },
          isParent: function(i) {
            return this._parent === i;
          },
          isChild: function(i) {
            return i && i._parent === this;
          },
          isDescendant: function(i) {
            for (var r = this; r = r._parent; )
              if (r === i)
                return !0;
            return !1;
          },
          isAncestor: function(i) {
            return i ? i.isDescendant(this) : !1;
          },
          isSibling: function(i) {
            return this._parent === i._parent;
          },
          isGroupedWith: function(i) {
            for (var r = this._parent; r; ) {
              if (r._parent && /^(Group|Layer|CompoundPath)$/.test(r._class) && i.isDescendant(r))
                return !0;
              r = r._parent;
            }
            return !1;
          }
        },
        o.each(["rotate", "scale", "shear", "skew"], function(i) {
          var r = i === "rotate";
          this[i] = function() {
            var a = arguments, l = (r ? o : M).read(a), u = M.read(a, 0, { readNull: !0 });
            return this.transform(new ee()[i](
              l,
              u || this.getPosition(!0)
            ));
          };
        }, {
          translate: function() {
            var i = new ee();
            return this.transform(i.translate.apply(i, arguments));
          },
          transform: function(i, r, a) {
            var l = this._matrix, u = i && !i.isIdentity(), d = a && this._canApplyMatrix || this._applyMatrix && (u || !l.isIdentity() || r && this._children);
            if (!u && !d)
              return this;
            if (u) {
              !i.isInvertible() && l.isInvertible() && (l._backup = l.getValues()), l.prepend(i, !0);
              var v = this._style, p = v.getFillColor(!0), y = v.getStrokeColor(!0);
              p && p.transform(i), y && y.transform(i);
            }
            if (d && (d = this._transformContent(
              l,
              r,
              a
            ))) {
              var S = this._pivot;
              S && l._transformPoint(S, S, !0), l.reset(!0), a && this._canApplyMatrix && (this._applyMatrix = !0);
            }
            var L = this._bounds, E = this._position;
            (u || d) && this._changed(25);
            var A = u && L && i.decompose();
            if (A && A.skewing.isZero() && A.rotation % 90 === 0) {
              for (var T in L) {
                var G = L[T];
                if (G.nonscaling)
                  delete L[T];
                else if (d || !G.internal) {
                  var R = G.rect;
                  i._transformBounds(R, R);
                }
              }
              this._bounds = L;
              var Y = L[this._getBoundsCacheKey(
                this._boundsOptions || {}
              )];
              Y && (this._position = this._getPositionFromBounds(Y.rect));
            } else
              u && E && this._pivot && (this._position = i._transformPoint(E, E));
            return this;
          },
          _transformContent: function(i, r, a) {
            var l = this._children;
            if (l) {
              for (var u = 0, d = l.length; u < d; u++)
                l[u].transform(i, r, a);
              return !0;
            }
          },
          globalToLocal: function() {
            return this.getGlobalMatrix(!0)._inverseTransform(
              M.read(arguments)
            );
          },
          localToGlobal: function() {
            return this.getGlobalMatrix(!0)._transformPoint(
              M.read(arguments)
            );
          },
          parentToLocal: function() {
            return this._matrix._inverseTransform(M.read(arguments));
          },
          localToParent: function() {
            return this._matrix._transformPoint(M.read(arguments));
          },
          fitBounds: function(i, r) {
            i = D.read(arguments);
            var a = this.getBounds(), l = a.height / a.width, u = i.height / i.width, d = (r ? l > u : l < u) ? i.width / a.width : i.height / a.height, v = new D(
              new M(),
              new F(a.width * d, a.height * d)
            );
            v.setCenter(i.getCenter()), this.setBounds(v);
          }
        }),
        {
          _setStyles: function(i, r, a) {
            var l = this._style, u = this._matrix;
            if (l.hasFill() && (i.fillStyle = l.getFillColor().toCanvasStyle(i, u)), l.hasStroke()) {
              i.strokeStyle = l.getStrokeColor().toCanvasStyle(i, u), i.lineWidth = l.getStrokeWidth();
              var d = l.getStrokeJoin(), v = l.getStrokeCap(), p = l.getMiterLimit();
              if (d && (i.lineJoin = d), v && (i.lineCap = v), p && (i.miterLimit = p), He.support.nativeDash) {
                var y = l.getDashArray(), S = l.getDashOffset();
                y && y.length && ("setLineDash" in i ? (i.setLineDash(y), i.lineDashOffset = S) : (i.mozDash = y, i.mozDashOffset = S));
              }
            }
            if (l.hasShadow()) {
              var L = r.pixelRatio || 1, E = a._shiftless().prepend(
                new ee().scale(L, L)
              ), A = E.transform(new M(l.getShadowBlur(), 0)), T = E.transform(this.getShadowOffset());
              i.shadowColor = l.getShadowColor().toCanvasStyle(i), i.shadowBlur = A.getLength(), i.shadowOffsetX = T.x, i.shadowOffsetY = T.y;
            }
          },
          draw: function(i, r, a) {
            if (this._updateVersion = this._project._updateVersion, !(!this._visible || this._opacity === 0)) {
              var l = r.matrices, u = r.viewMatrix, d = this._matrix, v = l[l.length - 1].appended(d);
              if (v.isInvertible()) {
                u = u ? u.appended(v) : v, l.push(v), r.updateMatrix && (this._globalMatrix = v);
                var p = this._blendMode, y = P.clamp(this._opacity, 0, 1), S = p === "normal", L = Qe.nativeModes[p], E = S && y === 1 || r.dontStart || r.clip || (L || S && y < 1) && this._canComposite(), A = r.pixelRatio || 1, T, G, R;
                if (!E) {
                  var Y = this.getStrokeBounds(u);
                  if (!Y.width || !Y.height) {
                    l.pop();
                    return;
                  }
                  R = r.offset, G = r.offset = Y.getTopLeft().floor(), T = i, i = mt.getContext(Y.getSize().ceil().add(1).multiply(A)), A !== 1 && i.scale(A, A);
                }
                i.save();
                var k = a ? a.appended(d) : this._canScaleStroke && !this.getStrokeScaling(!0) && u, z = !E && r.clipItem, C = !k || z;
                if (E ? (i.globalAlpha = y, L && (i.globalCompositeOperation = p)) : C && i.translate(-G.x, -G.y), C && (E ? d : u).applyToContext(i), z && r.clipItem.draw(i, r.extend({ clip: !0 })), k) {
                  i.setTransform(A, 0, 0, A, 0, 0);
                  var I = r.offset;
                  I && i.translate(-I.x, -I.y);
                }
                this._draw(i, r, u, k), i.restore(), l.pop(), r.clip && !r.dontFinish && i.clip(this.getFillRule()), E || (Qe.process(
                  p,
                  i,
                  T,
                  y,
                  G.subtract(R).multiply(A)
                ), mt.release(i), r.offset = R);
              }
            }
          },
          _isUpdated: function(i) {
            var r = this._parent;
            if (r instanceof It)
              return r._isUpdated(i);
            var a = this._updateVersion === i;
            return !a && r && r._visible && r._isUpdated(i) && (this._updateVersion = i, a = !0), a;
          },
          _drawSelection: function(i, r, a, l, u) {
            var d = this._selection, v = d & 1, p = d & 2 || v && this._selectBounds, y = d & 4;
            if (this._drawSelected || (v = !1), (v || p || y) && this._isUpdated(u)) {
              var S, L = this.getSelectedColor(!0) || (S = this.getLayer()) && S.getSelectedColor(!0), E = r.appended(this.getGlobalMatrix(!0)), A = a / 2;
              if (i.strokeStyle = i.fillStyle = L ? L.toCanvasStyle(i) : "#009dec", v && this._drawSelected(i, E, l), y) {
                var T = this.getPosition(!0), G = this._parent, R = G ? G.localToGlobal(T) : T, Y = R.x, k = R.y;
                i.beginPath(), i.arc(Y, k, A, 0, Math.PI * 2, !0), i.stroke();
                for (var z = [[0, -1], [1, 0], [0, 1], [-1, 0]], C = A, I = a + 1, j = 0; j < 4; j++) {
                  var q = z[j], H = q[0], ie = q[1];
                  i.moveTo(Y + H * C, k + ie * C), i.lineTo(Y + H * I, k + ie * I), i.stroke();
                }
              }
              if (p) {
                var ae = E._transformCorners(this.getInternalBounds());
                i.beginPath();
                for (var j = 0; j < 8; j++)
                  i[j ? "lineTo" : "moveTo"](ae[j], ae[++j]);
                i.closePath(), i.stroke();
                for (var j = 0; j < 8; j++)
                  i.fillRect(
                    ae[j] - A,
                    ae[++j] - A,
                    a,
                    a
                  );
              }
            }
          },
          _canComposite: function() {
            return !1;
          }
        },
        o.each(["down", "drag", "up", "move"], function(i) {
          this["removeOn" + o.capitalize(i)] = function() {
            var r = {};
            return r[i] = !0, this.removeOn(r);
          };
        }, {
          removeOn: function(i) {
            for (var r in i)
              if (i[r]) {
                var a = "mouse" + r, l = this._project, u = l._removeSets = l._removeSets || {};
                u[a] = u[a] || {}, u[a][this._id] = this;
              }
            return this;
          }
        }),
        {
          tween: function(i, r, a) {
            a || (a = r, r = i, i = null, a || (a = r, r = null));
            var l = a && a.easing, u = a && a.start, d = a != null && (typeof a == "number" ? a : a.duration), v = new et(this, i, r, d, l, u);
            function p(y) {
              v._handleFrame(y.time * 1e3), v.running || this.off("frame", p);
            }
            return d && this.on("frame", p), v;
          },
          tweenTo: function(i, r) {
            return this.tween(null, i, r);
          },
          tweenFrom: function(i, r) {
            return this.tween(i, null, r);
          }
        }
      ), W = X.extend({
        _class: "Group",
        _selectBounds: !1,
        _selectChildren: !0,
        _serializeFields: {
          children: []
        },
        initialize: function(i) {
          this._children = [], this._namedChildren = {}, this._initialize(i) || this.addChildren(Array.isArray(i) ? i : arguments);
        },
        _changed: function i(r) {
          i.base.call(this, r), r & 2050 && (this._clipItem = t);
        },
        _getClipItem: function() {
          var i = this._clipItem;
          if (i === t) {
            i = null;
            for (var r = this._children, a = 0, l = r.length; a < l; a++)
              if (r[a]._clipMask) {
                i = r[a];
                break;
              }
            this._clipItem = i;
          }
          return i;
        },
        isClipped: function() {
          return !!this._getClipItem();
        },
        setClipped: function(i) {
          var r = this.getFirstChild();
          r && r.setClipMask(i);
        },
        _getBounds: function i(r, a) {
          var l = this._getClipItem();
          return l ? l._getCachedBounds(
            l._matrix.prepended(r),
            o.set({}, a, { stroke: !1 })
          ) : i.base.call(this, r, a);
        },
        _hitTestChildren: function i(r, a, l) {
          var u = this._getClipItem();
          return (!u || u.contains(r)) && i.base.call(
            this,
            r,
            a,
            l,
            u
          );
        },
        _draw: function(i, r) {
          var a = r.clip, l = !a && this._getClipItem();
          r = r.extend({ clipItem: l, clip: !1 }), a ? (i.beginPath(), r.dontStart = r.dontFinish = !0) : l && l.draw(i, r.extend({ clip: !0 }));
          for (var u = this._children, d = 0, v = u.length; d < v; d++) {
            var p = u[d];
            p !== l && p.draw(i, r);
          }
        }
      }), je = W.extend({
        _class: "Layer",
        initialize: function() {
          W.apply(this, arguments);
        },
        _getOwner: function() {
          return this._parent || this._index != null && this._project;
        },
        isInserted: function i() {
          return this._parent ? i.base.call(this) : this._index != null;
        },
        activate: function() {
          this._project._activeLayer = this;
        },
        _hitTestSelf: function() {
        }
      }), ke = X.extend(
        {
          _class: "Shape",
          _applyMatrix: !1,
          _canApplyMatrix: !1,
          _canScaleStroke: !0,
          _serializeFields: {
            type: null,
            size: null,
            radius: null
          },
          initialize: function(i, r) {
            this._initialize(i, r);
          },
          _equals: function(i) {
            return this._type === i._type && this._size.equals(i._size) && o.equals(this._radius, i._radius);
          },
          copyContent: function(i) {
            this.setType(i._type), this.setSize(i._size), this.setRadius(i._radius);
          },
          getType: function() {
            return this._type;
          },
          setType: function(i) {
            this._type = i;
          },
          getShape: "#getType",
          setShape: "#setType",
          getSize: function() {
            var i = this._size;
            return new Q(i.width, i.height, this, "setSize");
          },
          setSize: function() {
            var i = F.read(arguments);
            if (!this._size)
              this._size = i.clone();
            else if (!this._size.equals(i)) {
              var r = this._type, a = i.width, l = i.height;
              r === "rectangle" ? this._radius.set(F.min(this._radius, i.divide(2).abs())) : r === "circle" ? (a = l = (a + l) / 2, this._radius = a / 2) : r === "ellipse" && this._radius._set(a / 2, l / 2), this._size._set(a, l), this._changed(9);
            }
          },
          getRadius: function() {
            var i = this._radius;
            return this._type === "circle" ? i : new Q(i.width, i.height, this, "setRadius");
          },
          setRadius: function(i) {
            var r = this._type;
            if (r === "circle") {
              if (i === this._radius)
                return;
              var a = i * 2;
              this._radius = i, this._size._set(a, a);
            } else if (i = F.read(arguments), !this._radius)
              this._radius = i.clone();
            else {
              if (this._radius.equals(i))
                return;
              if (this._radius.set(i), r === "rectangle") {
                var a = F.max(this._size, i.multiply(2));
                this._size.set(a);
              } else
                r === "ellipse" && this._size._set(i.width * 2, i.height * 2);
            }
            this._changed(9);
          },
          isEmpty: function() {
            return !1;
          },
          toPath: function(i) {
            var r = new We[o.capitalize(this._type)]({
              center: new M(),
              size: this._size,
              radius: this._radius,
              insert: !1
            });
            return r.copyAttributes(this), He.settings.applyMatrix && r.setApplyMatrix(!0), (i === t || i) && r.insertAbove(this), r;
          },
          toShape: "#clone",
          _asPathItem: function() {
            return this.toPath(!1);
          },
          _draw: function(i, r, a, l) {
            var u = this._style, d = u.hasFill(), v = u.hasStroke(), p = r.dontFinish || r.clip, y = !l;
            if (d || v || p) {
              var S = this._type, L = this._radius, E = S === "circle";
              if (r.dontStart || i.beginPath(), y && E)
                i.arc(0, 0, L, 0, Math.PI * 2, !0);
              else {
                var A = E ? L : L.width, T = E ? L : L.height, G = this._size, R = G.width, Y = G.height;
                if (y && S === "rectangle" && A === 0 && T === 0)
                  i.rect(-R / 2, -Y / 2, R, Y);
                else {
                  var k = R / 2, z = Y / 2, C = 1 - 0.5522847498307936, I = A * C, j = T * C, q = [
                    -k,
                    -z + T,
                    -k,
                    -z + j,
                    -k + I,
                    -z,
                    -k + A,
                    -z,
                    k - A,
                    -z,
                    k - I,
                    -z,
                    k,
                    -z + j,
                    k,
                    -z + T,
                    k,
                    z - T,
                    k,
                    z - j,
                    k - I,
                    z,
                    k - A,
                    z,
                    -k + A,
                    z,
                    -k + I,
                    z,
                    -k,
                    z - j,
                    -k,
                    z - T
                  ];
                  l && l.transform(q, q, 32), i.moveTo(q[0], q[1]), i.bezierCurveTo(q[2], q[3], q[4], q[5], q[6], q[7]), k !== A && i.lineTo(q[8], q[9]), i.bezierCurveTo(q[10], q[11], q[12], q[13], q[14], q[15]), z !== T && i.lineTo(q[16], q[17]), i.bezierCurveTo(q[18], q[19], q[20], q[21], q[22], q[23]), k !== A && i.lineTo(q[24], q[25]), i.bezierCurveTo(q[26], q[27], q[28], q[29], q[30], q[31]);
                }
              }
              i.closePath();
            }
            !p && (d || v) && (this._setStyles(i, r, a), d && (i.fill(u.getFillRule()), i.shadowColor = "rgba(0,0,0,0)"), v && i.stroke());
          },
          _canComposite: function() {
            return !(this.hasFill() && this.hasStroke());
          },
          _getBounds: function(i, r) {
            var a = new D(this._size).setCenter(0, 0), l = this._style, u = r.stroke && l.hasStroke() && l.getStrokeWidth();
            return i && (a = i._transformBounds(a)), u ? a.expand(We._getStrokePadding(
              u,
              this._getStrokeMatrix(i, r)
            )) : a;
          }
        },
        new function() {
          function i(a, l, u) {
            var d = a._radius;
            if (!d.isZero())
              for (var v = a._size.divide(2), p = 1; p <= 4; p++) {
                var y = new M(p > 1 && p < 4 ? -1 : 1, p > 2 ? -1 : 1), S = y.multiply(v), L = S.subtract(y.multiply(d)), E = new D(
                  u ? S.add(y.multiply(u)) : S,
                  L
                );
                if (E.contains(l))
                  return { point: L, quadrant: p };
              }
          }
          function r(a, l, u, d) {
            var v = a.divide(l);
            return (!d || v.isInQuadrant(d)) && v.subtract(v.normalize()).multiply(l).divide(u).length <= 1;
          }
          return {
            _contains: function a(l) {
              if (this._type === "rectangle") {
                var u = i(this, l);
                return u ? l.subtract(u.point).divide(this._radius).getLength() <= 1 : a.base.call(this, l);
              } else
                return l.divide(this.size).getLength() <= 0.5;
            },
            _hitTestSelf: function a(l, u, d, v) {
              var p = !1, y = this._style, S = u.stroke && y.hasStroke(), L = u.fill && y.hasFill();
              if (S || L) {
                var E = this._type, A = this._radius, T = S ? y.getStrokeWidth() / 2 : 0, G = u._tolerancePadding.add(
                  We._getStrokePadding(
                    T,
                    !y.getStrokeScaling() && v
                  )
                );
                if (E === "rectangle") {
                  var R = G.multiply(2), Y = i(this, l, R);
                  if (Y)
                    p = r(
                      l.subtract(Y.point),
                      A,
                      G,
                      Y.quadrant
                    );
                  else {
                    var k = new D(this._size).setCenter(0, 0), z = k.expand(R), C = k.expand(R.negate());
                    p = z._containsPoint(l) && !C._containsPoint(l);
                  }
                } else
                  p = r(l, A, G);
              }
              return p ? new $e(S ? "stroke" : "fill", this) : a.base.apply(this, arguments);
            }
          };
        }(),
        {
          statics: new function() {
            function i(r, a, l, u, d) {
              var v = o.create(ke.prototype);
              return v._type = r, v._size = l, v._radius = u, v._initialize(o.getNamed(d), a), v;
            }
            return {
              Circle: function() {
                var r = arguments, a = M.readNamed(r, "center"), l = o.readNamed(r, "radius");
                return i(
                  "circle",
                  a,
                  new F(l * 2),
                  l,
                  r
                );
              },
              Rectangle: function() {
                var r = arguments, a = D.readNamed(r, "rectangle"), l = F.min(
                  F.readNamed(r, "radius"),
                  a.getSize(!0).divide(2)
                );
                return i(
                  "rectangle",
                  a.getCenter(!0),
                  a.getSize(!0),
                  l,
                  r
                );
              },
              Ellipse: function() {
                var r = arguments, a = ke._readEllipse(r), l = a.radius;
                return i(
                  "ellipse",
                  a.center,
                  l.multiply(2),
                  l,
                  r
                );
              },
              _readEllipse: function(r) {
                var a, l;
                if (o.hasNamed(r, "radius"))
                  a = M.readNamed(r, "center"), l = F.readNamed(r, "radius");
                else {
                  var u = D.readNamed(r, "rectangle");
                  a = u.getCenter(!0), l = u.getSize(!0).divide(2);
                }
                return { center: a, radius: l };
              }
            };
          }()
        }
      ), Ye = X.extend({
        _class: "Raster",
        _applyMatrix: !1,
        _canApplyMatrix: !1,
        _boundsOptions: { stroke: !1, handle: !1 },
        _serializeFields: {
          crossOrigin: null,
          source: null
        },
        _prioritize: ["crossOrigin"],
        _smoothing: "low",
        beans: !0,
        initialize: function(i, r) {
          if (!this._initialize(
            i,
            r !== t && M.read(arguments)
          )) {
            var a, l = typeof i, u = l === "string" ? s.getElementById(i) : l === "object" ? i : null;
            if (u && u !== X.NO_INSERT) {
              if (u.getContext || u.naturalHeight != null)
                a = u;
              else if (u) {
                var d = F.read(arguments);
                d.isZero() || (a = mt.getCanvas(d));
              }
            }
            a ? this.setImage(a) : this.setSource(i);
          }
          this._size || (this._size = new F(), this._loaded = !1);
        },
        _equals: function(i) {
          return this.getSource() === i.getSource();
        },
        copyContent: function(i) {
          var r = i._image, a = i._canvas;
          if (r)
            this._setImage(r);
          else if (a) {
            var l = mt.getCanvas(i._size);
            l.getContext("2d").drawImage(a, 0, 0), this._setImage(l);
          }
          this._crossOrigin = i._crossOrigin;
        },
        getSize: function() {
          var i = this._size;
          return new Q(
            i ? i.width : 0,
            i ? i.height : 0,
            this,
            "setSize"
          );
        },
        setSize: function(i, r) {
          var a = F.read(arguments);
          if (a.equals(this._size))
            r && this.clear();
          else if (a.width > 0 && a.height > 0) {
            var l = !r && this.getElement();
            this._setImage(mt.getCanvas(a)), l && this.getContext(!0).drawImage(
              l,
              0,
              0,
              a.width,
              a.height
            );
          } else
            this._canvas && mt.release(this._canvas), this._size = a.clone();
        },
        getWidth: function() {
          return this._size ? this._size.width : 0;
        },
        setWidth: function(i) {
          this.setSize(i, this.getHeight());
        },
        getHeight: function() {
          return this._size ? this._size.height : 0;
        },
        setHeight: function(i) {
          this.setSize(this.getWidth(), i);
        },
        getLoaded: function() {
          return this._loaded;
        },
        isEmpty: function() {
          var i = this._size;
          return !i || i.width === 0 && i.height === 0;
        },
        getResolution: function() {
          var i = this._matrix, r = new M(0, 0).transform(i), a = new M(1, 0).transform(i).subtract(r), l = new M(0, 1).transform(i).subtract(r);
          return new F(
            72 / a.getLength(),
            72 / l.getLength()
          );
        },
        getPpi: "#getResolution",
        getImage: function() {
          return this._image;
        },
        setImage: function(i) {
          var r = this;
          function a(l) {
            var u = r.getView(), d = l && l.type || "load";
            u && r.responds(d) && (He = u._scope, r.emit(d, new Fi(l)));
          }
          this._setImage(i), this._loaded ? setTimeout(a, 0) : i && $t.add(i, {
            load: function(l) {
              r._setImage(i), a(l);
            },
            error: a
          });
        },
        _setImage: function(i) {
          this._canvas && mt.release(this._canvas), i && i.getContext ? (this._image = null, this._canvas = i, this._loaded = !0) : (this._image = i, this._canvas = null, this._loaded = !!(i && i.src && i.complete)), this._size = new F(
            i ? i.naturalWidth || i.width : 0,
            i ? i.naturalHeight || i.height : 0
          ), this._context = null, this._changed(1033);
        },
        getCanvas: function() {
          if (!this._canvas) {
            var i = mt.getContext(this._size);
            try {
              this._image && i.drawImage(this._image, 0, 0), this._canvas = i.canvas;
            } catch {
              mt.release(i);
            }
          }
          return this._canvas;
        },
        setCanvas: "#setImage",
        getContext: function(i) {
          return this._context || (this._context = this.getCanvas().getContext("2d")), i && (this._image = null, this._changed(1025)), this._context;
        },
        setContext: function(i) {
          this._context = i;
        },
        getSource: function() {
          var i = this._image;
          return i && i.src || this.toDataURL();
        },
        setSource: function(i) {
          var r = new e.Image(), a = this._crossOrigin;
          a && (r.crossOrigin = a), i && (r.src = i), this.setImage(r);
        },
        getCrossOrigin: function() {
          var i = this._image;
          return i && i.crossOrigin || this._crossOrigin || "";
        },
        setCrossOrigin: function(i) {
          this._crossOrigin = i;
          var r = this._image;
          r && (r.crossOrigin = i);
        },
        getSmoothing: function() {
          return this._smoothing;
        },
        setSmoothing: function(i) {
          this._smoothing = typeof i == "string" ? i : i ? "low" : "off", this._changed(257);
        },
        getElement: function() {
          return this._canvas || this._loaded && this._image;
        }
      }, {
        beans: !1,
        getSubCanvas: function() {
          var i = D.read(arguments), r = mt.getContext(i.getSize());
          return r.drawImage(
            this.getCanvas(),
            i.x,
            i.y,
            i.width,
            i.height,
            0,
            0,
            i.width,
            i.height
          ), r.canvas;
        },
        getSubRaster: function() {
          var i = D.read(arguments), r = new Ye(X.NO_INSERT);
          return r._setImage(this.getSubCanvas(i)), r.translate(i.getCenter().subtract(this.getSize().divide(2))), r._matrix.prepend(this._matrix), r.insertAbove(this), r;
        },
        toDataURL: function() {
          var i = this._image, r = i && i.src;
          if (/^data:/.test(r))
            return r;
          var a = this.getCanvas();
          return a ? a.toDataURL.apply(a, arguments) : null;
        },
        drawImage: function(i) {
          var r = M.read(arguments, 1);
          this.getContext(!0).drawImage(i, r.x, r.y);
        },
        getAverageColor: function(i) {
          var r, a;
          if (i ? i instanceof Yt ? (a = i, r = i.getBounds()) : typeof i == "object" && ("width" in i ? r = new D(i) : "x" in i && (r = new D(i.x - 0.5, i.y - 0.5, 1, 1))) : r = this.getBounds(), !r)
            return null;
          var l = 32, u = Math.min(r.width, l), d = Math.min(r.height, l), v = Ye._sampleContext;
          v ? v.clearRect(0, 0, l + 1, l + 1) : v = Ye._sampleContext = mt.getContext(
            new F(l)
          ), v.save();
          var p = new ee().scale(u / r.width, d / r.height).translate(-r.x, -r.y);
          p.applyToContext(v), a && a.draw(v, new o({ clip: !0, matrices: [p] })), this._matrix.applyToContext(v);
          var y = this.getElement(), S = this._size;
          y && v.drawImage(y, -S.width / 2, -S.height / 2), v.restore();
          for (var L = v.getImageData(
            0.5,
            0.5,
            Math.ceil(u),
            Math.ceil(d)
          ).data, E = [0, 0, 0], A = 0, T = 0, G = L.length; T < G; T += 4) {
            var R = L[T + 3];
            A += R, R /= 255, E[0] += L[T] * R, E[1] += L[T + 1] * R, E[2] += L[T + 2] * R;
          }
          for (var T = 0; T < 3; T++)
            E[T] /= A;
          return A ? Lt.read(E) : null;
        },
        getPixel: function() {
          var i = M.read(arguments), r = this.getContext().getImageData(i.x, i.y, 1, 1).data;
          return new Lt(
            "rgb",
            [r[0] / 255, r[1] / 255, r[2] / 255],
            r[3] / 255
          );
        },
        setPixel: function() {
          var i = arguments, r = M.read(i), a = Lt.read(i), l = a._convert("rgb"), u = a._alpha, d = this.getContext(!0), v = d.createImageData(1, 1), p = v.data;
          p[0] = l[0] * 255, p[1] = l[1] * 255, p[2] = l[2] * 255, p[3] = u != null ? u * 255 : 255, d.putImageData(v, r.x, r.y);
        },
        clear: function() {
          var i = this._size;
          this.getContext(!0).clearRect(0, 0, i.width + 1, i.height + 1);
        },
        createImageData: function() {
          var i = F.read(arguments);
          return this.getContext().createImageData(i.width, i.height);
        },
        getImageData: function() {
          var i = D.read(arguments);
          return i.isEmpty() && (i = new D(this._size)), this.getContext().getImageData(
            i.x,
            i.y,
            i.width,
            i.height
          );
        },
        putImageData: function(i) {
          var r = M.read(arguments, 1);
          this.getContext(!0).putImageData(i, r.x, r.y);
        },
        setImageData: function(i) {
          this.setSize(i), this.getContext(!0).putImageData(i, 0, 0);
        },
        _getBounds: function(i, r) {
          var a = new D(this._size).setCenter(0, 0);
          return i ? i._transformBounds(a) : a;
        },
        _hitTestSelf: function(i) {
          if (this._contains(i)) {
            var r = this;
            return new $e("pixel", r, {
              offset: i.add(r._size.divide(2)).round(),
              color: {
                get: function() {
                  return r.getPixel(this.offset);
                }
              }
            });
          }
        },
        _draw: function(i, r, a) {
          var l = this.getElement();
          if (l && l.width > 0 && l.height > 0) {
            i.globalAlpha = P.clamp(this._opacity, 0, 1), this._setStyles(i, r, a);
            var u = this._smoothing, d = u === "off";
            Wt.setPrefixed(
              i,
              d ? "imageSmoothingEnabled" : "imageSmoothingQuality",
              d ? !1 : u
            ), i.drawImage(
              l,
              -this._size.width / 2,
              -this._size.height / 2
            );
          }
        },
        _canComposite: function() {
          return !0;
        }
      }), pt = X.extend({
        _class: "SymbolItem",
        _applyMatrix: !1,
        _canApplyMatrix: !1,
        _boundsOptions: { stroke: !0 },
        _serializeFields: {
          symbol: null
        },
        initialize: function(i, r) {
          this._initialize(
            i,
            r !== t && M.read(arguments, 1)
          ) || this.setDefinition(i instanceof Le ? i : new Le(i));
        },
        _equals: function(i) {
          return this._definition === i._definition;
        },
        copyContent: function(i) {
          this.setDefinition(i._definition);
        },
        getDefinition: function() {
          return this._definition;
        },
        setDefinition: function(i) {
          this._definition = i, this._changed(9);
        },
        getSymbol: "#getDefinition",
        setSymbol: "#setDefinition",
        isEmpty: function() {
          return this._definition._item.isEmpty();
        },
        _getBounds: function(i, r) {
          var a = this._definition._item;
          return a._getCachedBounds(a._matrix.prepended(i), r);
        },
        _hitTestSelf: function(i, r, a) {
          var l = r.extend({ all: !1 }), u = this._definition._item._hitTest(i, l, a);
          return u && (u.item = this), u;
        },
        _draw: function(i, r) {
          this._definition._item.draw(i, r);
        }
      }), Le = o.extend({
        _class: "SymbolDefinition",
        initialize: function(i, r) {
          this._id = U.get(), this.project = He.project, i && this.setItem(i, r);
        },
        _serialize: function(i, r) {
          return r.add(this, function() {
            return o.serialize(
              [this._class, this._item],
              i,
              !1,
              r
            );
          });
        },
        _changed: function(i) {
          i & 8 && X._clearBoundsCache(this), i & 1 && this.project._changed(i);
        },
        getItem: function() {
          return this._item;
        },
        setItem: function(i, r) {
          i._symbol && (i = i.clone()), this._item && (this._item._symbol = null), this._item = i, i.remove(), i.setSelected(!1), r || i.setPosition(new M()), i._symbol = this, this._changed(9);
        },
        getDefinition: "#getItem",
        setDefinition: "#setItem",
        place: function(i) {
          return new pt(this, i);
        },
        clone: function() {
          return new Le(this._item.clone(!1));
        },
        equals: function(i) {
          return i === this || i && this._item.equals(i._item) || !1;
        }
      }), $e = o.extend({
        _class: "HitResult",
        initialize: function(i, r, a) {
          this.type = i, this.item = r, a && this.inject(a);
        },
        statics: {
          getOptions: function(i) {
            var r = i && o.read(i);
            return new o({
              type: null,
              tolerance: He.settings.hitTolerance,
              fill: !r,
              stroke: !r,
              segments: !r,
              handles: !1,
              ends: !1,
              position: !1,
              center: !1,
              bounds: !1,
              guides: !1,
              selected: !1
            }, r);
          }
        }
      }), ce = o.extend({
        _class: "Segment",
        beans: !0,
        _selection: 0,
        initialize: function(i, r, a, l, u, d) {
          var v = arguments.length, p, y, S, L;
          v > 0 && (i == null || typeof i == "object" ? v === 1 && i && "point" in i ? (p = i.point, y = i.handleIn, S = i.handleOut, L = i.selection) : (p = i, y = r, S = a, L = l) : (p = [i, r], y = a !== t ? [a, l] : null, S = u !== t ? [u, d] : null)), new ht(p, this, "_point"), new ht(y, this, "_handleIn"), new ht(S, this, "_handleOut"), L && this.setSelection(L);
        },
        _serialize: function(i, r) {
          var a = this._point, l = this._selection, u = l || this.hasHandles() ? [a, this._handleIn, this._handleOut] : a;
          return l && u.push(l), o.serialize(u, i, !0, r);
        },
        _changed: function(i) {
          var r = this._path;
          if (r) {
            var a = r._curves, l = this._index, u;
            a && ((!i || i === this._point || i === this._handleIn) && (u = l > 0 ? a[l - 1] : r._closed ? a[a.length - 1] : null) && u._changed(), (!i || i === this._point || i === this._handleOut) && (u = a[l]) && u._changed()), r._changed(41);
          }
        },
        getPoint: function() {
          return this._point;
        },
        setPoint: function() {
          this._point.set(M.read(arguments));
        },
        getHandleIn: function() {
          return this._handleIn;
        },
        setHandleIn: function() {
          this._handleIn.set(M.read(arguments));
        },
        getHandleOut: function() {
          return this._handleOut;
        },
        setHandleOut: function() {
          this._handleOut.set(M.read(arguments));
        },
        hasHandles: function() {
          return !this._handleIn.isZero() || !this._handleOut.isZero();
        },
        isSmooth: function() {
          var i = this._handleIn, r = this._handleOut;
          return !i.isZero() && !r.isZero() && i.isCollinear(r);
        },
        clearHandles: function() {
          this._handleIn._set(0, 0), this._handleOut._set(0, 0);
        },
        getSelection: function() {
          return this._selection;
        },
        setSelection: function(i) {
          var r = this._selection, a = this._path;
          this._selection = i = i || 0, a && i !== r && (a._updateSelection(this, r, i), a._changed(257));
        },
        _changeSelection: function(i, r) {
          var a = this._selection;
          this.setSelection(r ? a | i : a & ~i);
        },
        isSelected: function() {
          return !!(this._selection & 7);
        },
        setSelected: function(i) {
          this._changeSelection(7, i);
        },
        getIndex: function() {
          return this._index !== t ? this._index : null;
        },
        getPath: function() {
          return this._path || null;
        },
        getCurve: function() {
          var i = this._path, r = this._index;
          return i ? (r > 0 && !i._closed && r === i._segments.length - 1 && r--, i.getCurves()[r] || null) : null;
        },
        getLocation: function() {
          var i = this.getCurve();
          return i ? new ft(i, this === i._segment1 ? 0 : 1) : null;
        },
        getNext: function() {
          var i = this._path && this._path._segments;
          return i && (i[this._index + 1] || this._path._closed && i[0]) || null;
        },
        smooth: function(i, r, a) {
          var l = i || {}, u = l.type, d = l.factor, v = this.getPrevious(), p = this.getNext(), y = (v || this)._point, S = this._point, L = (p || this)._point, E = y.getDistance(S), A = S.getDistance(L);
          if (!u || u === "catmull-rom") {
            var T = d === t ? 0.5 : d, G = Math.pow(E, T), R = G * G, Y = Math.pow(A, T), k = Y * Y;
            if (!r && v) {
              var z = 2 * k + 3 * Y * G + R, C = 3 * Y * (Y + G);
              this.setHandleIn(C !== 0 ? new M(
                (k * y._x + z * S._x - R * L._x) / C - S._x,
                (k * y._y + z * S._y - R * L._y) / C - S._y
              ) : new M());
            }
            if (!a && p) {
              var z = 2 * R + 3 * G * Y + k, C = 3 * G * (G + Y);
              this.setHandleOut(C !== 0 ? new M(
                (R * L._x + z * S._x - k * y._x) / C - S._x,
                (R * L._y + z * S._y - k * y._y) / C - S._y
              ) : new M());
            }
          } else if (u === "geometric") {
            if (v && p) {
              var I = y.subtract(L), j = d === t ? 0.4 : d, q = j * E / (E + A);
              r || this.setHandleIn(I.multiply(q)), a || this.setHandleOut(I.multiply(q - j));
            }
          } else
            throw new Error("Smoothing method '" + u + "' not supported.");
        },
        getPrevious: function() {
          var i = this._path && this._path._segments;
          return i && (i[this._index - 1] || this._path._closed && i[i.length - 1]) || null;
        },
        isFirst: function() {
          return !this._index;
        },
        isLast: function() {
          var i = this._path;
          return i && this._index === i._segments.length - 1 || !1;
        },
        reverse: function() {
          var i = this._handleIn, r = this._handleOut, a = i.clone();
          i.set(r), r.set(a);
        },
        reversed: function() {
          return new ce(this._point, this._handleOut, this._handleIn);
        },
        remove: function() {
          return this._path ? !!this._path.removeSegment(this._index) : !1;
        },
        clone: function() {
          return new ce(this._point, this._handleIn, this._handleOut);
        },
        equals: function(i) {
          return i === this || i && this._class === i._class && this._point.equals(i._point) && this._handleIn.equals(i._handleIn) && this._handleOut.equals(i._handleOut) || !1;
        },
        toString: function() {
          var i = ["point: " + this._point];
          return this._handleIn.isZero() || i.push("handleIn: " + this._handleIn), this._handleOut.isZero() || i.push("handleOut: " + this._handleOut), "{ " + i.join(", ") + " }";
        },
        transform: function(i) {
          this._transformCoordinates(i, new Array(6), !0), this._changed();
        },
        interpolate: function(i, r, a) {
          var l = 1 - a, u = a, d = i._point, v = r._point, p = i._handleIn, y = r._handleIn, S = r._handleOut, L = i._handleOut;
          this._point._set(
            l * d._x + u * v._x,
            l * d._y + u * v._y,
            !0
          ), this._handleIn._set(
            l * p._x + u * y._x,
            l * p._y + u * y._y,
            !0
          ), this._handleOut._set(
            l * L._x + u * S._x,
            l * L._y + u * S._y,
            !0
          ), this._changed();
        },
        _transformCoordinates: function(i, r, a) {
          var l = this._point, u = !a || !this._handleIn.isZero() ? this._handleIn : null, d = !a || !this._handleOut.isZero() ? this._handleOut : null, v = l._x, p = l._y, y = 2;
          return r[0] = v, r[1] = p, u && (r[y++] = u._x + v, r[y++] = u._y + p), d && (r[y++] = d._x + v, r[y++] = d._y + p), i && (i._transformCoordinates(r, r, y / 2), v = r[0], p = r[1], a ? (l._x = v, l._y = p, y = 2, u && (u._x = r[y++] - v, u._y = r[y++] - p), d && (d._x = r[y++] - v, d._y = r[y++] - p)) : (u || (r[y++] = v, r[y++] = p), d || (r[y++] = v, r[y++] = p))), r;
        }
      }), ht = M.extend({
        initialize: function(i, r, a) {
          var l, u, d;
          if (!i)
            l = u = 0;
          else if ((l = i[0]) !== t)
            u = i[1];
          else {
            var v = i;
            (l = v.x) === t && (v = M.read(arguments), l = v.x), u = v.y, d = v.selected;
          }
          this._x = l, this._y = u, this._owner = r, r[a] = this, d && this.setSelected(!0);
        },
        _set: function(i, r) {
          return this._x = i, this._y = r, this._owner._changed(this), this;
        },
        getX: function() {
          return this._x;
        },
        setX: function(i) {
          this._x = i, this._owner._changed(this);
        },
        getY: function() {
          return this._y;
        },
        setY: function(i) {
          this._y = i, this._owner._changed(this);
        },
        isZero: function() {
          var i = P.isZero;
          return i(this._x) && i(this._y);
        },
        isSelected: function() {
          return !!(this._owner._selection & this._getSelection());
        },
        setSelected: function(i) {
          this._owner._changeSelection(this._getSelection(), i);
        },
        _getSelection: function() {
          var i = this._owner;
          return this === i._point ? 1 : this === i._handleIn ? 2 : this === i._handleOut ? 4 : 0;
        }
      }), De = o.extend(
        {
          _class: "Curve",
          beans: !0,
          initialize: function(i, r, a, l, u, d, v, p) {
            var y = arguments.length, S, L, E, A, T, G;
            y === 3 ? (this._path = i, S = r, L = a) : y ? y === 1 ? "segment1" in i ? (S = new ce(i.segment1), L = new ce(i.segment2)) : "point1" in i ? (E = i.point1, T = i.handle1, G = i.handle2, A = i.point2) : Array.isArray(i) && (E = [i[0], i[1]], A = [i[6], i[7]], T = [i[2] - i[0], i[3] - i[1]], G = [i[4] - i[6], i[5] - i[7]]) : y === 2 ? (S = new ce(i), L = new ce(r)) : y === 4 ? (E = i, T = r, G = a, A = l) : y === 8 && (E = [i, r], A = [v, p], T = [a - i, l - r], G = [u - v, d - p]) : (S = new ce(), L = new ce()), this._segment1 = S || new ce(E, null, T), this._segment2 = L || new ce(A, G, null);
          },
          _serialize: function(i, r) {
            return o.serialize(
              this.hasHandles() ? [
                this.getPoint1(),
                this.getHandle1(),
                this.getHandle2(),
                this.getPoint2()
              ] : [this.getPoint1(), this.getPoint2()],
              i,
              !0,
              r
            );
          },
          _changed: function() {
            this._length = this._bounds = t;
          },
          clone: function() {
            return new De(this._segment1, this._segment2);
          },
          toString: function() {
            var i = ["point1: " + this._segment1._point];
            return this._segment1._handleOut.isZero() || i.push("handle1: " + this._segment1._handleOut), this._segment2._handleIn.isZero() || i.push("handle2: " + this._segment2._handleIn), i.push("point2: " + this._segment2._point), "{ " + i.join(", ") + " }";
          },
          classify: function() {
            return De.classify(this.getValues());
          },
          remove: function() {
            var i = !1;
            if (this._path) {
              var r = this._segment2, a = r._handleOut;
              i = r.remove(), i && this._segment1._handleOut.set(a);
            }
            return i;
          },
          getPoint1: function() {
            return this._segment1._point;
          },
          setPoint1: function() {
            this._segment1._point.set(M.read(arguments));
          },
          getPoint2: function() {
            return this._segment2._point;
          },
          setPoint2: function() {
            this._segment2._point.set(M.read(arguments));
          },
          getHandle1: function() {
            return this._segment1._handleOut;
          },
          setHandle1: function() {
            this._segment1._handleOut.set(M.read(arguments));
          },
          getHandle2: function() {
            return this._segment2._handleIn;
          },
          setHandle2: function() {
            this._segment2._handleIn.set(M.read(arguments));
          },
          getSegment1: function() {
            return this._segment1;
          },
          getSegment2: function() {
            return this._segment2;
          },
          getPath: function() {
            return this._path;
          },
          getIndex: function() {
            return this._segment1._index;
          },
          getNext: function() {
            var i = this._path && this._path._curves;
            return i && (i[this._segment1._index + 1] || this._path._closed && i[0]) || null;
          },
          getPrevious: function() {
            var i = this._path && this._path._curves;
            return i && (i[this._segment1._index - 1] || this._path._closed && i[i.length - 1]) || null;
          },
          isFirst: function() {
            return !this._segment1._index;
          },
          isLast: function() {
            var i = this._path;
            return i && this._segment1._index === i._curves.length - 1 || !1;
          },
          isSelected: function() {
            return this.getPoint1().isSelected() && this.getHandle1().isSelected() && this.getHandle2().isSelected() && this.getPoint2().isSelected();
          },
          setSelected: function(i) {
            this.getPoint1().setSelected(i), this.getHandle1().setSelected(i), this.getHandle2().setSelected(i), this.getPoint2().setSelected(i);
          },
          getValues: function(i) {
            return De.getValues(this._segment1, this._segment2, i);
          },
          getPoints: function() {
            for (var i = this.getValues(), r = [], a = 0; a < 8; a += 2)
              r.push(new M(i[a], i[a + 1]));
            return r;
          }
        },
        {
          getLength: function() {
            return this._length == null && (this._length = De.getLength(this.getValues(), 0, 1)), this._length;
          },
          getArea: function() {
            return De.getArea(this.getValues());
          },
          getLine: function() {
            return new le(this._segment1._point, this._segment2._point);
          },
          getPart: function(i, r) {
            return new De(De.getPart(this.getValues(), i, r));
          },
          getPartLength: function(i, r) {
            return De.getLength(this.getValues(), i, r);
          },
          divideAt: function(i) {
            return this.divideAtTime(i && i.curve === this ? i.time : this.getTimeAt(i));
          },
          divideAtTime: function(i, r) {
            var a = 1e-8, l = 1 - a, u = null;
            if (i >= a && i <= l) {
              var d = De.subdivide(this.getValues(), i), v = d[0], p = d[1], y = r || this.hasHandles(), S = this._segment1, L = this._segment2, E = this._path;
              y && (S._handleOut._set(v[2] - v[0], v[3] - v[1]), L._handleIn._set(p[4] - p[6], p[5] - p[7]));
              var A = v[6], T = v[7], G = new ce(
                new M(A, T),
                y && new M(v[4] - A, v[5] - T),
                y && new M(p[2] - A, p[3] - T)
              );
              E ? (E.insert(S._index + 1, G), u = this.getNext()) : (this._segment2 = G, this._changed(), u = new De(G, L));
            }
            return u;
          },
          splitAt: function(i) {
            var r = this._path;
            return r ? r.splitAt(i) : null;
          },
          splitAtTime: function(i) {
            return this.splitAt(this.getLocationAtTime(i));
          },
          divide: function(i, r) {
            return this.divideAtTime(i === t ? 0.5 : r ? i : this.getTimeAt(i));
          },
          split: function(i, r) {
            return this.splitAtTime(i === t ? 0.5 : r ? i : this.getTimeAt(i));
          },
          reversed: function() {
            return new De(this._segment2.reversed(), this._segment1.reversed());
          },
          clearHandles: function() {
            this._segment1._handleOut._set(0, 0), this._segment2._handleIn._set(0, 0);
          },
          statics: {
            getValues: function(i, r, a, l) {
              var u = i._point, d = i._handleOut, v = r._handleIn, p = r._point, y = u.x, S = u.y, L = p.x, E = p.y, A = l ? [y, S, y, S, L, E, L, E] : [
                y,
                S,
                y + d._x,
                S + d._y,
                L + v._x,
                E + v._y,
                L,
                E
              ];
              return a && a._transformCoordinates(A, A, 4), A;
            },
            subdivide: function(i, r) {
              var a = i[0], l = i[1], u = i[2], d = i[3], v = i[4], p = i[5], y = i[6], S = i[7];
              r === t && (r = 0.5);
              var L = 1 - r, E = L * a + r * u, A = L * l + r * d, T = L * u + r * v, G = L * d + r * p, R = L * v + r * y, Y = L * p + r * S, k = L * E + r * T, z = L * A + r * G, C = L * T + r * R, I = L * G + r * Y, j = L * k + r * C, q = L * z + r * I;
              return [
                [a, l, E, A, k, z, j, q],
                [j, q, C, I, R, Y, y, S]
              ];
            },
            getMonoCurves: function(i, r) {
              var a = [], l = r ? 0 : 1, u = i[l + 0], d = i[l + 2], v = i[l + 4], p = i[l + 6];
              if (u >= d == d >= v && d >= v == v >= p || De.isStraight(i))
                a.push(i);
              else {
                var y = 3 * (d - v) - u + p, S = 2 * (u + v) - 4 * d, L = d - u, E = 1e-8, A = 1 - E, T = [], G = P.solveQuadratic(y, S, L, T, E, A);
                if (!G)
                  a.push(i);
                else {
                  T.sort();
                  var R = T[0], Y = De.subdivide(i, R);
                  a.push(Y[0]), G > 1 && (R = (T[1] - R) / (1 - R), Y = De.subdivide(Y[1], R), a.push(Y[0])), a.push(Y[1]);
                }
              }
              return a;
            },
            solveCubic: function(i, r, a, l, u, d) {
              var v = i[r], p = i[r + 2], y = i[r + 4], S = i[r + 6], L = 0;
              if (!(v < a && S < a && p < a && y < a || v > a && S > a && p > a && y > a)) {
                var E = 3 * (p - v), A = 3 * (y - p) - E, T = S - v - E - A;
                L = P.solveCubic(T, A, E, v - a, l, u, d);
              }
              return L;
            },
            getTimeOf: function(i, r) {
              var a = new M(i[0], i[1]), l = new M(i[6], i[7]), u = 1e-12, d = 1e-7, v = r.isClose(a, u) ? 0 : r.isClose(l, u) ? 1 : null;
              if (v === null)
                for (var p = [r.x, r.y], y = [], S = 0; S < 2; S++)
                  for (var L = De.solveCubic(i, S, p[S], y, 0, 1), E = 0; E < L; E++) {
                    var A = y[E];
                    if (r.isClose(De.getPoint(i, A), d))
                      return A;
                  }
              return r.isClose(a, d) ? 0 : r.isClose(l, d) ? 1 : null;
            },
            getNearestTime: function(i, r) {
              if (De.isStraight(i)) {
                var a = i[0], l = i[1], u = i[6], d = i[7], v = u - a, p = d - l, y = v * v + p * p;
                if (y === 0)
                  return 0;
                var S = ((r.x - a) * v + (r.y - l) * p) / y;
                return S < 1e-12 ? 0 : S > 0.999999999999 ? 1 : De.getTimeOf(
                  i,
                  new M(a + S * v, l + S * p)
                );
              }
              var L = 100, E = 1 / 0, A = 0;
              function T(Y) {
                if (Y >= 0 && Y <= 1) {
                  var k = r.getDistance(De.getPoint(i, Y), !0);
                  if (k < E)
                    return E = k, A = Y, !0;
                }
              }
              for (var G = 0; G <= L; G++)
                T(G / L);
              for (var R = 1 / (L * 2); R > 1e-8; )
                !T(A - R) && !T(A + R) && (R /= 2);
              return A;
            },
            getPart: function(i, r, a) {
              var l = r > a;
              if (l) {
                var u = r;
                r = a, a = u;
              }
              return r > 0 && (i = De.subdivide(i, r)[1]), a < 1 && (i = De.subdivide(i, (a - r) / (1 - r))[0]), l ? [i[6], i[7], i[4], i[5], i[2], i[3], i[0], i[1]] : i;
            },
            isFlatEnough: function(i, r) {
              var a = i[0], l = i[1], u = i[2], d = i[3], v = i[4], p = i[5], y = i[6], S = i[7], L = 3 * u - 2 * a - y, E = 3 * d - 2 * l - S, A = 3 * v - 2 * y - a, T = 3 * p - 2 * S - l;
              return Math.max(L * L, A * A) + Math.max(E * E, T * T) <= 16 * r * r;
            },
            getArea: function(i) {
              var r = i[0], a = i[1], l = i[2], u = i[3], d = i[4], v = i[5], p = i[6], y = i[7];
              return 3 * ((y - a) * (l + d) - (p - r) * (u + v) + u * (r - d) - l * (a - v) + y * (d + r / 3) - p * (v + a / 3)) / 20;
            },
            getBounds: function(i) {
              for (var r = i.slice(0, 2), a = r.slice(), l = [0, 0], u = 0; u < 2; u++)
                De._addBounds(
                  i[u],
                  i[u + 2],
                  i[u + 4],
                  i[u + 6],
                  u,
                  0,
                  r,
                  a,
                  l
                );
              return new D(r[0], r[1], a[0] - r[0], a[1] - r[1]);
            },
            _addBounds: function(i, r, a, l, u, d, v, p, y) {
              function S(j, q) {
                var H = j - q, ie = j + q;
                H < v[u] && (v[u] = H), ie > p[u] && (p[u] = ie);
              }
              d /= 2;
              var L = v[u] + d, E = p[u] - d;
              if (i < L || r < L || a < L || l < L || i > E || r > E || a > E || l > E)
                if (r < i != r < l && a < i != a < l)
                  S(i, 0), S(l, 0);
                else {
                  var A = 3 * (r - a) - i + l, T = 2 * (i + a) - 4 * r, G = r - i, R = P.solveQuadratic(A, T, G, y), Y = 1e-8, k = 1 - Y;
                  S(l, 0);
                  for (var z = 0; z < R; z++) {
                    var C = y[z], I = 1 - C;
                    Y <= C && C <= k && S(
                      I * I * I * i + 3 * I * I * C * r + 3 * I * C * C * a + C * C * C * l,
                      d
                    );
                  }
                }
            }
          }
        },
        o.each(
          ["getBounds", "getStrokeBounds", "getHandleBounds"],
          function(i) {
            this[i] = function() {
              this._bounds || (this._bounds = {});
              var r = this._bounds[i];
              return r || (r = this._bounds[i] = We[i](
                [this._segment1, this._segment2],
                !1,
                this._path
              )), r.clone();
            };
          },
          {}
        ),
        o.each({
          isStraight: function(i, r, a, l) {
            if (r.isZero() && a.isZero())
              return !0;
            var u = l.subtract(i);
            if (u.isZero())
              return !1;
            if (u.isCollinear(r) && u.isCollinear(a)) {
              var d = new le(i, l), v = 1e-7;
              if (d.getDistance(i.add(r)) < v && d.getDistance(l.add(a)) < v) {
                var p = u.dot(u), y = u.dot(r) / p, S = u.dot(a) / p;
                return y >= 0 && y <= 1 && S <= 0 && S >= -1;
              }
            }
            return !1;
          },
          isLinear: function(i, r, a, l) {
            var u = l.subtract(i).divide(3);
            return r.equals(u) && a.negate().equals(u);
          }
        }, function(i, r) {
          this[r] = function(a) {
            var l = this._segment1, u = this._segment2;
            return i(
              l._point,
              l._handleOut,
              u._handleIn,
              u._point,
              a
            );
          }, this.statics[r] = function(a, l) {
            var u = a[0], d = a[1], v = a[6], p = a[7];
            return i(
              new M(u, d),
              new M(a[2] - u, a[3] - d),
              new M(a[4] - v, a[5] - p),
              new M(v, p),
              l
            );
          };
        }, {
          statics: {},
          hasHandles: function() {
            return !this._segment1._handleOut.isZero() || !this._segment2._handleIn.isZero();
          },
          hasLength: function(i) {
            return (!this.getPoint1().equals(this.getPoint2()) || this.hasHandles()) && this.getLength() > (i || 0);
          },
          isCollinear: function(i) {
            return i && this.isStraight() && i.isStraight() && this.getLine().isCollinear(i.getLine());
          },
          isHorizontal: function() {
            return this.isStraight() && Math.abs(this.getTangentAtTime(0.5).y) < 1e-8;
          },
          isVertical: function() {
            return this.isStraight() && Math.abs(this.getTangentAtTime(0.5).x) < 1e-8;
          }
        }),
        {
          beans: !1,
          getLocationAt: function(i, r) {
            return this.getLocationAtTime(
              r ? i : this.getTimeAt(i)
            );
          },
          getLocationAtTime: function(i) {
            return i != null && i >= 0 && i <= 1 ? new ft(this, i) : null;
          },
          getTimeAt: function(i, r) {
            return De.getTimeAt(this.getValues(), i, r);
          },
          getParameterAt: "#getTimeAt",
          getTimesWithTangent: function() {
            var i = M.read(arguments);
            return i.isZero() ? [] : De.getTimesWithTangent(this.getValues(), i);
          },
          getOffsetAtTime: function(i) {
            return this.getPartLength(0, i);
          },
          getLocationOf: function() {
            return this.getLocationAtTime(this.getTimeOf(M.read(arguments)));
          },
          getOffsetOf: function() {
            var i = this.getLocationOf.apply(this, arguments);
            return i ? i.getOffset() : null;
          },
          getTimeOf: function() {
            return De.getTimeOf(this.getValues(), M.read(arguments));
          },
          getParameterOf: "#getTimeOf",
          getNearestLocation: function() {
            var i = M.read(arguments), r = this.getValues(), a = De.getNearestTime(r, i), l = De.getPoint(r, a);
            return new ft(this, a, l, null, i.getDistance(l));
          },
          getNearestPoint: function() {
            var i = this.getNearestLocation.apply(this, arguments);
            return i && i.getPoint();
          }
        },
        new function() {
          var i = [
            "getPoint",
            "getTangent",
            "getNormal",
            "getWeightedTangent",
            "getWeightedNormal",
            "getCurvature"
          ];
          return o.each(
            i,
            function(r) {
              this[r + "At"] = function(a, l) {
                var u = this.getValues();
                return De[r](u, l ? a : De.getTimeAt(u, a));
              }, this[r + "AtTime"] = function(a) {
                return De[r](this.getValues(), a);
              };
            },
            {
              statics: {
                _evaluateMethods: i
              }
            }
          );
        }(),
        new function() {
          function i(l) {
            var u = l[0], d = l[1], v = l[2], p = l[3], y = l[4], S = l[5], L = l[6], E = l[7], A = 9 * (v - y) + 3 * (L - u), T = 6 * (u + y) - 12 * v, G = 3 * (v - u), R = 9 * (p - S) + 3 * (E - d), Y = 6 * (d + S) - 12 * p, k = 3 * (p - d);
            return function(z) {
              var C = (A * z + T) * z + G, I = (R * z + Y) * z + k;
              return Math.sqrt(C * C + I * I);
            };
          }
          function r(l, u) {
            return Math.max(2, Math.min(16, Math.ceil(Math.abs(u - l) * 32)));
          }
          function a(l, u, d, v) {
            if (u == null || u < 0 || u > 1)
              return null;
            var p = l[0], y = l[1], S = l[2], L = l[3], E = l[4], A = l[5], T = l[6], G = l[7], R = P.isZero;
            R(S - p) && R(L - y) && (S = p, L = y), R(E - T) && R(A - G) && (E = T, A = G);
            var Y = 3 * (S - p), k = 3 * (E - S) - Y, z = T - p - Y - k, C = 3 * (L - y), I = 3 * (A - L) - C, j = G - y - C - I, q, H;
            if (d === 0)
              q = u === 0 ? p : u === 1 ? T : ((z * u + k) * u + Y) * u + p, H = u === 0 ? y : u === 1 ? G : ((j * u + I) * u + C) * u + y;
            else {
              var ie = 1e-8, ae = 1 - ie;
              if (u < ie ? (q = Y, H = C) : u > ae ? (q = 3 * (T - E), H = 3 * (G - A)) : (q = (3 * z * u + 2 * k) * u + Y, H = (3 * j * u + 2 * I) * u + C), v) {
                q === 0 && H === 0 && (u < ie || u > ae) && (q = E - S, H = A - L);
                var he = Math.sqrt(q * q + H * H);
                he && (q /= he, H /= he);
              }
              if (d === 3) {
                var E = 6 * z * u + 2 * k, A = 6 * j * u + 2 * I, pe = Math.pow(q * q + H * H, 3 / 2);
                q = pe !== 0 ? (q * A - H * E) / pe : 0, H = 0;
              }
            }
            return d === 2 ? new M(H, -q) : new M(q, H);
          }
          return { statics: {
            classify: function(l) {
              var u = l[0], d = l[1], v = l[2], p = l[3], y = l[4], S = l[5], L = l[6], E = l[7], A = u * (E - S) + d * (y - L) + L * S - E * y, T = v * (d - E) + p * (L - u) + u * E - d * L, G = y * (p - d) + S * (u - v) + v * d - p * u, R = 3 * G, Y = R - T, k = Y - T + A, z = Math.sqrt(k * k + Y * Y + R * R), C = z !== 0 ? 1 / z : 0, I = P.isZero, j = "serpentine";
              k *= C, Y *= C, R *= C;
              function q(he, pe, se) {
                var de = pe !== t, ve = de && pe > 0 && pe < 1, we = de && se > 0 && se < 1;
                return de && (!(ve || we) || he === "loop" && !(ve && we)) && (he = "arch", ve = we = !1), {
                  type: he,
                  roots: ve || we ? ve && we ? pe < se ? [pe, se] : [se, pe] : [ve ? pe : se] : null
                };
              }
              if (I(k))
                return I(Y) ? q(I(R) ? "line" : "quadratic") : q(j, R / (3 * Y));
              var H = 3 * Y * Y - 4 * k * R;
              if (I(H))
                return q("cusp", Y / (2 * k));
              var ie = H > 0 ? Math.sqrt(H / 3) : Math.sqrt(-H), ae = 2 * k;
              return q(
                H > 0 ? j : "loop",
                (Y + ie) / ae,
                (Y - ie) / ae
              );
            },
            getLength: function(l, u, d, v) {
              if (u === t && (u = 0), d === t && (d = 1), De.isStraight(l)) {
                var p = l;
                d < 1 && (p = De.subdivide(p, d)[0], u /= d), u > 0 && (p = De.subdivide(p, u)[1]);
                var y = p[6] - p[0], S = p[7] - p[1];
                return Math.sqrt(y * y + S * S);
              }
              return P.integrate(
                v || i(l),
                u,
                d,
                r(u, d)
              );
            },
            getTimeAt: function(l, u, d) {
              if (d === t && (d = u < 0 ? 1 : 0), u === 0)
                return d;
              var v = Math.abs, p = 1e-12, y = u > 0, S = y ? d : 0, L = y ? 1 : d, E = i(l), A = De.getLength(l, S, L, E), T = v(u) - A;
              if (v(T) < p)
                return y ? L : S;
              if (T > p)
                return null;
              var G = u / A, R = 0;
              function Y(k) {
                return R += P.integrate(
                  E,
                  d,
                  k,
                  r(d, k)
                ), d = k, R - u;
              }
              return P.findRoot(
                Y,
                E,
                d + G,
                S,
                L,
                32,
                1e-12
              );
            },
            getPoint: function(l, u) {
              return a(l, u, 0, !1);
            },
            getTangent: function(l, u) {
              return a(l, u, 1, !0);
            },
            getWeightedTangent: function(l, u) {
              return a(l, u, 1, !1);
            },
            getNormal: function(l, u) {
              return a(l, u, 2, !0);
            },
            getWeightedNormal: function(l, u) {
              return a(l, u, 2, !1);
            },
            getCurvature: function(l, u) {
              return a(l, u, 3, !1).x;
            },
            getPeaks: function(l) {
              var u = l[0], d = l[1], v = l[2], p = l[3], y = l[4], S = l[5], L = l[6], E = l[7], A = -u + 3 * v - 3 * y + L, T = 3 * u - 6 * v + 3 * y, G = -3 * u + 3 * v, R = -d + 3 * p - 3 * S + E, Y = 3 * d - 6 * p + 3 * S, k = -3 * d + 3 * p, z = 1e-8, C = 1 - z, I = [];
              return P.solveCubic(
                9 * (A * A + R * R),
                9 * (A * T + Y * R),
                2 * (T * T + Y * Y) + 3 * (G * A + k * R),
                G * T + Y * k,
                I,
                z,
                C
              ), I.sort();
            }
          } };
        }(),
        new function() {
          function i(T, G, R, Y, k, z, C) {
            var I = !C && R.getPrevious() === k, j = !C && R !== k && R.getNext() === k, q = 1e-8, H = 1 - q;
            if (Y !== null && Y >= (I ? q : 0) && Y <= (j ? H : 1) && z !== null && z >= (j ? q : 0) && z <= (I ? H : 1)) {
              var ie = new ft(R, Y, null, C), ae = new ft(k, z, null, C);
              ie._intersection = ae, ae._intersection = ie, (!G || G(ie)) && ft.insert(T, ie, !0);
            }
          }
          function r(T, G, R, Y, k, z, C, I, j, q, H, ie, ae) {
            if (++j >= 4096 || ++I >= 40)
              return j;
            var he = 1e-9, pe = G[0], se = G[1], de = G[6], ve = G[7], we = le.getSignedDistance, Se = we(pe, se, de, ve, G[2], G[3]), Ae = we(pe, se, de, ve, G[4], G[5]), Ge = Se * Ae > 0 ? 3 / 4 : 4 / 9, Je = Ge * Math.min(0, Se, Ae), it = Ge * Math.max(0, Se, Ae), gt = we(pe, se, de, ve, T[0], T[1]), Ne = we(pe, se, de, ve, T[2], T[3]), Fe = we(pe, se, de, ve, T[4], T[5]), st = we(pe, se, de, ve, T[6], T[7]), _t = a(gt, Ne, Fe, st), vt = _t[0], Rt = _t[1], Et, Ht;
            if (Se === 0 && Ae === 0 && gt === 0 && Ne === 0 && Fe === 0 && st === 0 || (Et = l(vt, Rt, Je, it)) == null || (Ht = l(
              vt.reverse(),
              Rt.reverse(),
              Je,
              it
            )) == null)
              return j;
            var jt = q + (H - q) * Et, Vt = q + (H - q) * Ht;
            if (Math.max(ae - ie, Vt - jt) < he) {
              var Mi = (jt + Vt) / 2, Li = (ie + ae) / 2;
              i(
                k,
                z,
                C ? Y : R,
                C ? Li : Mi,
                C ? R : Y,
                C ? Mi : Li
              );
            } else {
              T = De.getPart(T, Et, Ht);
              var Ai = ae - ie;
              if (Ht - Et > 0.8)
                if (Vt - jt > Ai) {
                  var vi = De.subdivide(T, 0.5), Mi = (jt + Vt) / 2;
                  j = r(
                    G,
                    vi[0],
                    Y,
                    R,
                    k,
                    z,
                    !C,
                    I,
                    j,
                    ie,
                    ae,
                    jt,
                    Mi
                  ), j = r(
                    G,
                    vi[1],
                    Y,
                    R,
                    k,
                    z,
                    !C,
                    I,
                    j,
                    ie,
                    ae,
                    Mi,
                    Vt
                  );
                } else {
                  var vi = De.subdivide(G, 0.5), Li = (ie + ae) / 2;
                  j = r(
                    vi[0],
                    T,
                    Y,
                    R,
                    k,
                    z,
                    !C,
                    I,
                    j,
                    ie,
                    Li,
                    jt,
                    Vt
                  ), j = r(
                    vi[1],
                    T,
                    Y,
                    R,
                    k,
                    z,
                    !C,
                    I,
                    j,
                    Li,
                    ae,
                    jt,
                    Vt
                  );
                }
              else
                Ai === 0 || Ai >= he ? j = r(
                  G,
                  T,
                  Y,
                  R,
                  k,
                  z,
                  !C,
                  I,
                  j,
                  ie,
                  ae,
                  jt,
                  Vt
                ) : j = r(
                  T,
                  G,
                  R,
                  Y,
                  k,
                  z,
                  C,
                  I,
                  j,
                  jt,
                  Vt,
                  ie,
                  ae
                );
            }
            return j;
          }
          function a(T, G, R, Y) {
            var k = [0, T], z = [1 / 3, G], C = [2 / 3, R], I = [1, Y], j = G - (2 * T + Y) / 3, q = R - (T + 2 * Y) / 3, H;
            if (j * q < 0)
              H = [[k, z, I], [k, C, I]];
            else {
              var ie = j / q;
              H = [
                ie >= 2 ? [k, z, I] : ie <= 0.5 ? [k, C, I] : [k, z, C, I],
                [k, I]
              ];
            }
            return (j || q) < 0 ? H.reverse() : H;
          }
          function l(T, G, R, Y) {
            return T[0][1] < R ? u(T, !0, R) : G[0][1] > Y ? u(G, !1, Y) : T[0][0];
          }
          function u(T, G, R) {
            for (var Y = T[0][0], k = T[0][1], z = 1, C = T.length; z < C; z++) {
              var I = T[z][0], j = T[z][1];
              if (G ? j >= R : j <= R)
                return j === R ? I : Y + (R - k) * (I - Y) / (j - k);
              Y = I, k = j;
            }
            return null;
          }
          function d(T, G, R, Y, k) {
            var z = P.isZero;
            if (z(Y) && z(k)) {
              var C = De.getTimeOf(T, new M(G, R));
              return C === null ? [] : [C];
            }
            for (var I = Math.atan2(-k, Y), j = Math.sin(I), q = Math.cos(I), H = [], ie = [], ae = 0; ae < 8; ae += 2) {
              var he = T[ae] - G, pe = T[ae + 1] - R;
              H.push(
                he * q - pe * j,
                he * j + pe * q
              );
            }
            return De.solveCubic(H, 1, 0, ie, 0, 1), ie;
          }
          function v(T, G, R, Y, k, z, C) {
            for (var I = G[0], j = G[1], q = G[6], H = G[7], ie = d(T, I, j, q - I, H - j), ae = 0, he = ie.length; ae < he; ae++) {
              var pe = ie[ae], se = De.getPoint(T, pe), de = De.getTimeOf(G, se);
              de !== null && i(
                k,
                z,
                C ? Y : R,
                C ? de : pe,
                C ? R : Y,
                C ? pe : de
              );
            }
          }
          function p(T, G, R, Y, k, z) {
            var C = le.intersect(
              T[0],
              T[1],
              T[6],
              T[7],
              G[0],
              G[1],
              G[6],
              G[7]
            );
            C && i(
              k,
              z,
              R,
              De.getTimeOf(T, C),
              Y,
              De.getTimeOf(G, C)
            );
          }
          function y(T, G, R, Y, k, z) {
            var C = 1e-12, I = Math.min, j = Math.max;
            if (j(T[0], T[2], T[4], T[6]) + C > I(G[0], G[2], G[4], G[6]) && I(T[0], T[2], T[4], T[6]) - C < j(G[0], G[2], G[4], G[6]) && j(T[1], T[3], T[5], T[7]) + C > I(G[1], G[3], G[5], G[7]) && I(T[1], T[3], T[5], T[7]) - C < j(G[1], G[3], G[5], G[7])) {
              var q = E(T, G);
              if (q)
                for (var H = 0; H < 2; H++) {
                  var ie = q[H];
                  i(
                    k,
                    z,
                    R,
                    ie[0],
                    Y,
                    ie[1],
                    !0
                  );
                }
              else {
                var ae = De.isStraight(T), he = De.isStraight(G), pe = ae && he, se = ae && !he, de = k.length;
                if ((pe ? p : ae || he ? v : r)(
                  se ? G : T,
                  se ? T : G,
                  se ? Y : R,
                  se ? R : Y,
                  k,
                  z,
                  se,
                  0,
                  0,
                  0,
                  1,
                  0,
                  1
                ), !pe || k.length === de)
                  for (var H = 0; H < 4; H++) {
                    var ve = H >> 1, we = H & 1, Se = ve * 6, Ae = we * 6, Ge = new M(T[Se], T[Se + 1]), Je = new M(G[Ae], G[Ae + 1]);
                    Ge.isClose(Je, C) && i(
                      k,
                      z,
                      R,
                      ve,
                      Y,
                      we
                    );
                  }
              }
            }
            return k;
          }
          function S(T, G, R, Y) {
            var k = De.classify(T);
            if (k.type === "loop") {
              var z = k.roots;
              i(
                R,
                Y,
                G,
                z[0],
                G,
                z[1]
              );
            }
            return R;
          }
          function L(T, G, R, Y, k, z) {
            var C = 1e-7, I = !G;
            I && (G = T);
            for (var j = T.length, q = G.length, H = new Array(j), ie = I ? H : new Array(q), ae = [], he = 0; he < j; he++)
              H[he] = T[he].getValues(Y);
            if (!I)
              for (var he = 0; he < q; he++)
                ie[he] = G[he].getValues(k);
            for (var pe = x.findCurveBoundsCollisions(
              H,
              ie,
              C
            ), se = 0; se < j; se++) {
              var de = T[se], ve = H[se];
              I && S(ve, de, ae, R);
              var we = pe[se];
              if (we)
                for (var Se = 0; Se < we.length; Se++) {
                  if (z && ae.length)
                    return ae;
                  var Ae = we[Se];
                  if (!I || Ae > se) {
                    var Ge = G[Ae], Je = ie[Ae];
                    y(
                      ve,
                      Je,
                      de,
                      Ge,
                      ae,
                      R
                    );
                  }
                }
            }
            return ae;
          }
          function E(T, G) {
            function R(st) {
              var _t = st[6] - st[0], vt = st[7] - st[1];
              return _t * _t + vt * vt;
            }
            var Y = Math.abs, k = le.getDistance, z = 1e-8, C = 1e-7, I = De.isStraight(T), j = De.isStraight(G), q = I && j, H = R(T) < R(G), ie = H ? G : T, ae = H ? T : G, he = ie[0], pe = ie[1], se = ie[6] - he, de = ie[7] - pe;
            if (k(he, pe, se, de, ae[0], ae[1], !0) < C && k(he, pe, se, de, ae[6], ae[7], !0) < C)
              !q && k(he, pe, se, de, ie[2], ie[3], !0) < C && k(he, pe, se, de, ie[4], ie[5], !0) < C && k(he, pe, se, de, ae[2], ae[3], !0) < C && k(he, pe, se, de, ae[4], ae[5], !0) < C && (I = j = q = !0);
            else if (q)
              return null;
            if (I ^ j)
              return null;
            for (var ve = [T, G], we = [], Se = 0; Se < 4 && we.length < 2; Se++) {
              var Ae = Se & 1, Ge = Ae ^ 1, Je = Se >> 1, it = De.getTimeOf(ve[Ae], new M(
                ve[Ge][Je ? 6 : 0],
                ve[Ge][Je ? 7 : 1]
              ));
              if (it != null) {
                var gt = Ae ? [Je, it] : [it, Je];
                (!we.length || Y(gt[0] - we[0][0]) > z && Y(gt[1] - we[0][1]) > z) && we.push(gt);
              }
              if (Se > 2 && !we.length)
                break;
            }
            if (we.length !== 2)
              we = null;
            else if (!q) {
              var Ne = De.getPart(T, we[0][0], we[1][0]), Fe = De.getPart(G, we[0][1], we[1][1]);
              (Y(Fe[2] - Ne[2]) > C || Y(Fe[3] - Ne[3]) > C || Y(Fe[4] - Ne[4]) > C || Y(Fe[5] - Ne[5]) > C) && (we = null);
            }
            return we;
          }
          function A(T, G) {
            var R = T[0], Y = T[1], k = T[2], z = T[3], C = T[4], I = T[5], j = T[6], q = T[7], H = G.normalize(), ie = H.x, ae = H.y, he = 3 * j - 9 * C + 9 * k - 3 * R, pe = 3 * q - 9 * I + 9 * z - 3 * Y, se = 6 * C - 12 * k + 6 * R, de = 6 * I - 12 * z + 6 * Y, ve = 3 * k - 3 * R, we = 3 * z - 3 * Y, Se = 2 * he * ae - 2 * pe * ie, Ae = [];
            if (Math.abs(Se) < P.CURVETIME_EPSILON) {
              var Ge = he * we - pe * ve, Se = he * de - pe * se;
              if (Se != 0) {
                var Je = -Ge / Se;
                Je >= 0 && Je <= 1 && Ae.push(Je);
              }
            } else {
              var it = (se * se - 4 * he * ve) * ae * ae + (-2 * se * de + 4 * pe * ve + 4 * he * we) * ie * ae + (de * de - 4 * pe * we) * ie * ie, gt = se * ae - de * ie;
              if (it >= 0 && Se != 0) {
                var Ne = Math.sqrt(it), Fe = -(gt + Ne) / Se, st = (-gt + Ne) / Se;
                Fe >= 0 && Fe <= 1 && Ae.push(Fe), st >= 0 && st <= 1 && Ae.push(st);
              }
            }
            return Ae;
          }
          return {
            getIntersections: function(T) {
              var G = this.getValues(), R = T && T !== this && T.getValues();
              return R ? y(G, R, this, T, []) : S(G, this, []);
            },
            statics: {
              getOverlaps: E,
              getIntersections: L,
              getCurveLineIntersections: d,
              getTimesWithTangent: A
            }
          };
        }()
      ), ft = o.extend(
        {
          _class: "CurveLocation",
          initialize: function(i, r, a, l, u) {
            if (r >= 0.99999999) {
              var d = i.getNext();
              d && (r = 0, i = d);
            }
            this._setCurve(i), this._time = r, this._point = a || i.getPointAtTime(r), this._overlap = l, this._distance = u, this._intersection = this._next = this._previous = null;
          },
          _setPath: function(i) {
            this._path = i, this._version = i ? i._version : 0;
          },
          _setCurve: function(i) {
            this._setPath(i._path), this._curve = i, this._segment = null, this._segment1 = i._segment1, this._segment2 = i._segment2;
          },
          _setSegment: function(i) {
            var r = i.getCurve();
            r ? this._setCurve(r) : (this._setPath(i._path), this._segment1 = i, this._segment2 = null), this._segment = i, this._time = i === this._segment1 ? 0 : 1, this._point = i._point.clone();
          },
          getSegment: function() {
            var i = this._segment;
            if (!i) {
              var r = this.getCurve(), a = this.getTime();
              a === 0 ? i = r._segment1 : a === 1 ? i = r._segment2 : a != null && (i = r.getPartLength(0, a) < r.getPartLength(a, 1) ? r._segment1 : r._segment2), this._segment = i;
            }
            return i;
          },
          getCurve: function() {
            var i = this._path, r = this;
            i && i._version !== this._version && (this._time = this._offset = this._curveOffset = this._curve = null);
            function a(l) {
              var u = l && l.getCurve();
              if (u && (r._time = u.getTimeOf(r._point)) != null)
                return r._setCurve(u), u;
            }
            return this._curve || a(this._segment) || a(this._segment1) || a(this._segment2.getPrevious());
          },
          getPath: function() {
            var i = this.getCurve();
            return i && i._path;
          },
          getIndex: function() {
            var i = this.getCurve();
            return i && i.getIndex();
          },
          getTime: function() {
            var i = this.getCurve(), r = this._time;
            return i && r == null ? this._time = i.getTimeOf(this._point) : r;
          },
          getParameter: "#getTime",
          getPoint: function() {
            return this._point;
          },
          getOffset: function() {
            var i = this._offset;
            if (i == null) {
              i = 0;
              var r = this.getPath(), a = this.getIndex();
              if (r && a != null)
                for (var l = r.getCurves(), u = 0; u < a; u++)
                  i += l[u].getLength();
              this._offset = i += this.getCurveOffset();
            }
            return i;
          },
          getCurveOffset: function() {
            var i = this._curveOffset;
            if (i == null) {
              var r = this.getCurve(), a = this.getTime();
              this._curveOffset = i = a != null && r && r.getPartLength(0, a);
            }
            return i;
          },
          getIntersection: function() {
            return this._intersection;
          },
          getDistance: function() {
            return this._distance;
          },
          divide: function() {
            var i = this.getCurve(), r = i && i.divideAtTime(this.getTime());
            return r && this._setSegment(r._segment1), r;
          },
          split: function() {
            var i = this.getCurve(), r = i._path, a = i && i.splitAtTime(this.getTime());
            return a && this._setSegment(r.getLastSegment()), a;
          },
          equals: function(i, r) {
            var a = this === i;
            if (!a && i instanceof ft) {
              var l = this.getCurve(), u = i.getCurve(), d = l._path, v = u._path;
              if (d === v) {
                var p = Math.abs, y = 1e-7, S = p(this.getOffset() - i.getOffset()), L = !r && this._intersection, E = !r && i._intersection;
                a = (S < y || d && p(d.getLength() - S) < y) && (!L && !E || L && E && L.equals(E, !0));
              }
            }
            return a;
          },
          toString: function() {
            var i = [], r = this.getPoint(), a = B.instance;
            r && i.push("point: " + r);
            var l = this.getIndex();
            l != null && i.push("index: " + l);
            var u = this.getTime();
            return u != null && i.push("time: " + a.number(u)), this._distance != null && i.push("distance: " + a.number(this._distance)), "{ " + i.join(", ") + " }";
          },
          isTouching: function() {
            var i = this._intersection;
            if (i && this.getTangent().isCollinear(i.getTangent())) {
              var r = this.getCurve(), a = i.getCurve();
              return !(r.isStraight() && a.isStraight() && r.getLine().intersect(a.getLine()));
            }
            return !1;
          },
          isCrossing: function() {
            var i = this._intersection;
            if (!i)
              return !1;
            var r = this.getTime(), a = i.getTime(), l = 1e-8, u = 1 - l, d = r >= l && r <= u, v = a >= l && a <= u;
            if (d && v)
              return !this.isTouching();
            var p = this.getCurve(), y = p && r < l ? p.getPrevious() : p, S = i.getCurve(), L = S && a < l ? S.getPrevious() : S;
            if (r > u && (p = p.getNext()), a > u && (S = S.getNext()), !y || !p || !L || !S)
              return !1;
            var E = [];
            function A(ie, ae) {
              var he = ie.getValues(), pe = De.classify(he).roots || De.getPeaks(he), se = pe.length, de = De.getLength(
                he,
                ae && se ? pe[se - 1] : 0,
                !ae && se ? pe[0] : 1
              );
              E.push(se ? de : de / 32);
            }
            function T(ie, ae, he) {
              return ae < he ? ie > ae && ie < he : ie > ae || ie < he;
            }
            d || (A(y, !0), A(p, !1)), v || (A(L, !0), A(S, !1));
            var G = this.getPoint(), R = Math.min.apply(Math, E), Y = d ? p.getTangentAtTime(r) : p.getPointAt(R).subtract(G), k = d ? Y.negate() : y.getPointAt(-R).subtract(G), z = v ? S.getTangentAtTime(a) : S.getPointAt(R).subtract(G), C = v ? z.negate() : L.getPointAt(-R).subtract(G), I = k.getAngle(), j = Y.getAngle(), q = C.getAngle(), H = z.getAngle();
            return !!(d ? T(I, q, H) ^ T(j, q, H) && T(I, H, q) ^ T(j, H, q) : T(q, I, j) ^ T(H, I, j) && T(q, j, I) ^ T(H, j, I));
          },
          hasOverlap: function() {
            return !!this._overlap;
          }
        },
        o.each(De._evaluateMethods, function(i) {
          var r = i + "At";
          this[i] = function() {
            var a = this.getCurve(), l = this.getTime();
            return l != null && a && a[r](l, !0);
          };
        }, {
          preserve: !0
        }),
        new function() {
          function i(r, a, l) {
            var u = r.length, d = 0, v = u - 1;
            function p(G, R) {
              for (var Y = G + R; Y >= -1 && Y <= u; Y += R) {
                var k = r[(Y % u + u) % u];
                if (!a.getPoint().isClose(
                  k.getPoint(),
                  1e-7
                ))
                  break;
                if (a.equals(k))
                  return k;
              }
              return null;
            }
            for (; d <= v; ) {
              var y = d + v >>> 1, S = r[y], L;
              if (l && (L = a.equals(S) ? S : p(y, -1) || p(y, 1)))
                return a._overlap && (L._overlap = L._intersection._overlap = !0), L;
              var E = a.getPath(), A = S.getPath(), T = E !== A ? E._id - A._id : a.getIndex() + a.getTime() - (S.getIndex() + S.getTime());
              T < 0 ? v = y - 1 : d = y + 1;
            }
            return r.splice(d, 0, a), a;
          }
          return { statics: {
            insert: i,
            expand: function(r) {
              for (var a = r.slice(), l = r.length - 1; l >= 0; l--)
                i(a, r[l]._intersection, !1);
              return a;
            }
          } };
        }()
      ), Yt = X.extend({
        _class: "PathItem",
        _selectBounds: !1,
        _canScaleStroke: !0,
        beans: !0,
        initialize: function() {
        },
        statics: {
          create: function(i) {
            var r, a, l;
            if (o.isPlainObject(i) ? (a = i.segments, r = i.pathData) : Array.isArray(i) ? a = i : typeof i == "string" && (r = i), a) {
              var u = a[0];
              l = u && Array.isArray(u[0]);
            } else
              r && (l = (r.match(/m/gi) || []).length > 1 || /z\s*\S+/i.test(r));
            var d = l ? It : We;
            return new d(i);
          }
        },
        _asPathItem: function() {
          return this;
        },
        isClockwise: function() {
          return this.getArea() >= 0;
        },
        setClockwise: function(i) {
          this.isClockwise() != (i = !!i) && this.reverse();
        },
        setPathData: function(i) {
          var r = i && i.match(/[mlhvcsqtaz][^mlhvcsqtaz]*/ig), a, l = !1, u, d, v = new M(), p = new M();
          function y(C, I) {
            var j = +a[C];
            return l && (j += v[I]), j;
          }
          function S(C) {
            return new M(
              y(C, "x"),
              y(C + 1, "y")
            );
          }
          this.clear();
          for (var L = 0, E = r && r.length; L < E; L++) {
            var A = r[L], T = A[0], G = T.toLowerCase();
            a = A.match(/[+-]?(?:\d*\.\d+|\d+\.?)(?:[eE][+-]?\d+)?/g);
            var R = a && a.length;
            switch (l = T === G, u === "z" && !/[mz]/.test(G) && this.moveTo(v), G) {
              case "m":
              case "l":
                for (var Y = G === "m", k = 0; k < R; k += 2)
                  this[Y ? "moveTo" : "lineTo"](v = S(k)), Y && (p = v, Y = !1);
                d = v;
                break;
              case "h":
              case "v":
                var z = G === "h" ? "x" : "y";
                v = v.clone();
                for (var k = 0; k < R; k++)
                  v[z] = y(k, z), this.lineTo(v);
                d = v;
                break;
              case "c":
                for (var k = 0; k < R; k += 6)
                  this.cubicCurveTo(
                    S(k),
                    d = S(k + 2),
                    v = S(k + 4)
                  );
                break;
              case "s":
                for (var k = 0; k < R; k += 4)
                  this.cubicCurveTo(
                    /[cs]/.test(u) ? v.multiply(2).subtract(d) : v,
                    d = S(k),
                    v = S(k + 2)
                  ), u = G;
                break;
              case "q":
                for (var k = 0; k < R; k += 4)
                  this.quadraticCurveTo(
                    d = S(k),
                    v = S(k + 2)
                  );
                break;
              case "t":
                for (var k = 0; k < R; k += 2)
                  this.quadraticCurveTo(
                    d = /[qt]/.test(u) ? v.multiply(2).subtract(d) : v,
                    v = S(k)
                  ), u = G;
                break;
              case "a":
                for (var k = 0; k < R; k += 7)
                  this.arcTo(
                    v = S(k + 5),
                    new F(+a[k], +a[k + 1]),
                    +a[k + 2],
                    +a[k + 4],
                    +a[k + 3]
                  );
                break;
              case "z":
                this.closePath(1e-12), v = p;
                break;
            }
            u = G;
          }
        },
        _canComposite: function() {
          return !(this.hasFill() && this.hasStroke());
        },
        _contains: function(i) {
          var r = i.isInside(
            this.getBounds({ internal: !0, handle: !0 })
          ) ? this._getWinding(i) : {};
          return r.onPath || !!(this.getFillRule() === "evenodd" ? r.windingL & 1 || r.windingR & 1 : r.winding);
        },
        getIntersections: function(i, r, a, l) {
          var u = this === i || !i, d = this._matrix._orNullIfIdentity(), v = u ? d : (a || i._matrix)._orNullIfIdentity();
          return u || this.getBounds(d).intersects(
            i.getBounds(v),
            1e-12
          ) ? De.getIntersections(
            this.getCurves(),
            !u && i.getCurves(),
            r,
            d,
            v,
            l
          ) : [];
        },
        getCrossings: function(i) {
          return this.getIntersections(i, function(r) {
            return r.isCrossing();
          });
        },
        getNearestLocation: function() {
          for (var i = M.read(arguments), r = this.getCurves(), a = 1 / 0, l = null, u = 0, d = r.length; u < d; u++) {
            var v = r[u].getNearestLocation(i);
            v._distance < a && (a = v._distance, l = v);
          }
          return l;
        },
        getNearestPoint: function() {
          var i = this.getNearestLocation.apply(this, arguments);
          return i && i.getPoint();
        },
        interpolate: function(i, r, a) {
          var l = !this._children, u = l ? "_segments" : "_children", d = i[u], v = r[u], p = this[u];
          if (!d || !v || d.length !== v.length)
            throw new Error("Invalid operands in interpolate() call: " + i + ", " + r);
          var y = p.length, S = v.length;
          if (y < S)
            for (var L = l ? ce : We, E = y; E < S; E++)
              this.add(new L());
          else
            y > S && this[l ? "removeSegments" : "removeChildren"](S, y);
          for (var E = 0; E < S; E++)
            p[E].interpolate(d[E], v[E], a);
          l && (this.setClosed(i._closed), this._changed(9));
        },
        compare: function(i) {
          var r = !1;
          if (i) {
            var a = this._children || [this], l = i._children ? i._children.slice() : [i], u = a.length, d = l.length, v = [], p = 0;
            r = !0;
            for (var y = x.findItemBoundsCollisions(a, l, P.GEOMETRIC_EPSILON), S = u - 1; S >= 0 && r; S--) {
              var L = a[S];
              r = !1;
              var E = y[S];
              if (E)
                for (var A = E.length - 1; A >= 0 && !r; A--)
                  L.compare(l[E[A]]) && (v[E[A]] || (v[E[A]] = !0, p++), r = !0);
            }
            r = r && p === d;
          }
          return r;
        }
      }), We = Yt.extend(
        {
          _class: "Path",
          _serializeFields: {
            segments: [],
            closed: !1
          },
          initialize: function(i) {
            this._closed = !1, this._segments = [], this._version = 0;
            var r = arguments, a = Array.isArray(i) ? typeof i[0] == "object" ? i : r : i && i.size === t && (i.x !== t || i.point !== t) ? r : null;
            a && a.length > 0 ? this.setSegments(a) : (this._curves = t, this._segmentSelection = 0, !a && typeof i == "string" && (this.setPathData(i), i = null)), this._initialize(!a && i);
          },
          _equals: function(i) {
            return this._closed === i._closed && o.equals(this._segments, i._segments);
          },
          copyContent: function(i) {
            this.setSegments(i._segments), this._closed = i._closed;
          },
          _changed: function i(r) {
            if (i.base.call(this, r), r & 8) {
              if (this._length = this._area = t, r & 32)
                this._version++;
              else if (this._curves)
                for (var a = 0, l = this._curves.length; a < l; a++)
                  this._curves[a]._changed();
            } else
              r & 64 && (this._bounds = t);
          },
          getStyle: function() {
            var i = this._parent;
            return (i instanceof It ? i : this)._style;
          },
          getSegments: function() {
            return this._segments;
          },
          setSegments: function(i) {
            var r = this.isFullySelected(), a = i && i.length;
            if (this._segments.length = 0, this._segmentSelection = 0, this._curves = t, a) {
              var l = i[a - 1];
              typeof l == "boolean" && (this.setClosed(l), a--), this._add(ce.readList(i, 0, {}, a));
            }
            r && this.setFullySelected(!0);
          },
          getFirstSegment: function() {
            return this._segments[0];
          },
          getLastSegment: function() {
            return this._segments[this._segments.length - 1];
          },
          getCurves: function() {
            var i = this._curves, r = this._segments;
            if (!i) {
              var a = this._countCurves();
              i = this._curves = new Array(a);
              for (var l = 0; l < a; l++)
                i[l] = new De(
                  this,
                  r[l],
                  r[l + 1] || r[0]
                );
            }
            return i;
          },
          getFirstCurve: function() {
            return this.getCurves()[0];
          },
          getLastCurve: function() {
            var i = this.getCurves();
            return i[i.length - 1];
          },
          isClosed: function() {
            return this._closed;
          },
          setClosed: function(i) {
            if (this._closed != (i = !!i)) {
              if (this._closed = i, this._curves) {
                var r = this._curves.length = this._countCurves();
                i && (this._curves[r - 1] = new De(
                  this,
                  this._segments[r - 1],
                  this._segments[0]
                ));
              }
              this._changed(41);
            }
          }
        },
        {
          beans: !0,
          getPathData: function(i, r) {
            var a = this._segments, l = a.length, u = new B(r), d = new Array(6), v = !0, p, y, S, L, E, A, T, G, R = [];
            function Y(z, C) {
              if (z._transformCoordinates(i, d), p = d[0], y = d[1], v)
                R.push("M" + u.pair(p, y)), v = !1;
              else if (E = d[2], A = d[3], E === p && A === y && T === S && G === L) {
                if (!C) {
                  var I = p - S, j = y - L;
                  R.push(
                    I === 0 ? "v" + u.number(j) : j === 0 ? "h" + u.number(I) : "l" + u.pair(I, j)
                  );
                }
              } else
                R.push("c" + u.pair(T - S, G - L) + " " + u.pair(E - S, A - L) + " " + u.pair(p - S, y - L));
              S = p, L = y, T = d[4], G = d[5];
            }
            if (!l)
              return "";
            for (var k = 0; k < l; k++)
              Y(a[k]);
            return this._closed && l > 0 && (Y(a[0], !0), R.push("z")), R.join("");
          },
          isEmpty: function() {
            return !this._segments.length;
          },
          _transformContent: function(i) {
            for (var r = this._segments, a = new Array(6), l = 0, u = r.length; l < u; l++)
              r[l]._transformCoordinates(i, a, !0);
            return !0;
          },
          _add: function(i, r) {
            for (var a = this._segments, l = this._curves, u = i.length, d = r == null, r = d ? a.length : r, v = 0; v < u; v++) {
              var p = i[v];
              p._path && (p = i[v] = p.clone()), p._path = this, p._index = r + v, p._selection && this._updateSelection(p, 0, p._selection);
            }
            if (d)
              o.push(a, i);
            else {
              a.splice.apply(a, [r, 0].concat(i));
              for (var v = r + u, y = a.length; v < y; v++)
                a[v]._index = v;
            }
            if (l) {
              var S = this._countCurves(), L = r > 0 && r + u - 1 === S ? r - 1 : r, E = L, A = Math.min(L + u, S);
              i._curves && (l.splice.apply(l, [L, 0].concat(i._curves)), E += i._curves.length);
              for (var v = E; v < A; v++)
                l.splice(v, 0, new De(this, null, null));
              this._adjustCurves(L, A);
            }
            return this._changed(41), i;
          },
          _adjustCurves: function(i, r) {
            for (var a = this._segments, l = this._curves, u, d = i; d < r; d++)
              u = l[d], u._path = this, u._segment1 = a[d], u._segment2 = a[d + 1] || a[0], u._changed();
            (u = l[this._closed && !i ? a.length - 1 : i - 1]) && (u._segment2 = a[i] || a[0], u._changed()), (u = l[r]) && (u._segment1 = a[r], u._changed());
          },
          _countCurves: function() {
            var i = this._segments.length;
            return !this._closed && i > 0 ? i - 1 : i;
          },
          add: function(i) {
            var r = arguments;
            return r.length > 1 && typeof i != "number" ? this._add(ce.readList(r)) : this._add([ce.read(r)])[0];
          },
          insert: function(i, r) {
            var a = arguments;
            return a.length > 2 && typeof r != "number" ? this._add(ce.readList(a, 1), i) : this._add([ce.read(a, 1)], i)[0];
          },
          addSegment: function() {
            return this._add([ce.read(arguments)])[0];
          },
          insertSegment: function(i) {
            return this._add([ce.read(arguments, 1)], i)[0];
          },
          addSegments: function(i) {
            return this._add(ce.readList(i));
          },
          insertSegments: function(i, r) {
            return this._add(ce.readList(r), i);
          },
          removeSegment: function(i) {
            return this.removeSegments(i, i + 1)[0] || null;
          },
          removeSegments: function(i, r, a) {
            i = i || 0, r = o.pick(r, this._segments.length);
            var l = this._segments, u = this._curves, d = l.length, v = l.splice(i, r - i), p = v.length;
            if (!p)
              return v;
            for (var y = 0; y < p; y++) {
              var S = v[y];
              S._selection && this._updateSelection(S, S._selection, 0), S._index = S._path = null;
            }
            for (var y = i, L = l.length; y < L; y++)
              l[y]._index = y;
            if (u) {
              for (var E = i > 0 && r === d + (this._closed ? 1 : 0) ? i - 1 : i, u = u.splice(E, p), y = u.length - 1; y >= 0; y--)
                u[y]._path = null;
              a && (v._curves = u.slice(1)), this._adjustCurves(E, E);
            }
            return this._changed(41), v;
          },
          clear: "#removeSegments",
          hasHandles: function() {
            for (var i = this._segments, r = 0, a = i.length; r < a; r++)
              if (i[r].hasHandles())
                return !0;
            return !1;
          },
          clearHandles: function() {
            for (var i = this._segments, r = 0, a = i.length; r < a; r++)
              i[r].clearHandles();
          },
          getLength: function() {
            if (this._length == null) {
              for (var i = this.getCurves(), r = 0, a = 0, l = i.length; a < l; a++)
                r += i[a].getLength();
              this._length = r;
            }
            return this._length;
          },
          getArea: function() {
            var i = this._area;
            if (i == null) {
              var r = this._segments, a = this._closed;
              i = 0;
              for (var l = 0, u = r.length; l < u; l++) {
                var d = l + 1 === u;
                i += De.getArea(De.getValues(
                  r[l],
                  r[d ? 0 : l + 1],
                  null,
                  d && !a
                ));
              }
              this._area = i;
            }
            return i;
          },
          isFullySelected: function() {
            var i = this._segments.length;
            return this.isSelected() && i > 0 && this._segmentSelection === i * 7;
          },
          setFullySelected: function(i) {
            i && this._selectSegments(!0), this.setSelected(i);
          },
          setSelection: function i(r) {
            r & 1 || this._selectSegments(!1), i.base.call(this, r);
          },
          _selectSegments: function(i) {
            var r = this._segments, a = r.length, l = i ? 7 : 0;
            this._segmentSelection = l * a;
            for (var u = 0; u < a; u++)
              r[u]._selection = l;
          },
          _updateSelection: function(i, r, a) {
            i._selection = a;
            var l = this._segmentSelection += a - r;
            l > 0 && this.setSelected(!0);
          },
          divideAt: function(i) {
            var r = this.getLocationAt(i), a;
            return r && (a = r.getCurve().divideAt(r.getCurveOffset())) ? a._segment1 : null;
          },
          splitAt: function(i) {
            var r = this.getLocationAt(i), a = r && r.index, l = r && r.time, u = 1e-8, d = 1 - u;
            l > d && (a++, l = 0);
            var v = this.getCurves();
            if (a >= 0 && a < v.length) {
              l >= u && v[a++].divideAtTime(l);
              var p = this.removeSegments(a, this._segments.length, !0), y;
              return this._closed ? (this.setClosed(!1), y = this) : (y = new We(X.NO_INSERT), y.insertAbove(this), y.copyAttributes(this)), y._add(p, 0), this.addSegment(p[0]), y;
            }
            return null;
          },
          split: function(i, r) {
            var a, l = r === t ? i : (a = this.getCurves()[i]) && a.getLocationAtTime(r);
            return l != null ? this.splitAt(l) : null;
          },
          join: function(i, r) {
            var a = r || 0;
            if (i && i !== this) {
              var l = i._segments, u = this.getLastSegment(), d = i.getLastSegment();
              if (!d)
                return this;
              u && u._point.isClose(d._point, a) && i.reverse();
              var v = i.getFirstSegment();
              if (u && u._point.isClose(v._point, a))
                u.setHandleOut(v._handleOut), this._add(l.slice(1));
              else {
                var p = this.getFirstSegment();
                p && p._point.isClose(v._point, a) && i.reverse(), d = i.getLastSegment(), p && p._point.isClose(d._point, a) ? (p.setHandleIn(d._handleIn), this._add(l.slice(0, l.length - 1), 0)) : this._add(l.slice());
              }
              i._closed && this._add([l[0]]), i.remove();
            }
            var y = this.getFirstSegment(), S = this.getLastSegment();
            return y !== S && y._point.isClose(S._point, a) && (y.setHandleIn(S._handleIn), S.remove(), this.setClosed(!0)), this;
          },
          reduce: function(i) {
            for (var r = this.getCurves(), a = i && i.simplify, l = a ? 1e-7 : 0, u = r.length - 1; u >= 0; u--) {
              var d = r[u];
              !d.hasHandles() && (!d.hasLength(l) || a && d.isCollinear(d.getNext())) && d.remove();
            }
            return this;
          },
          reverse: function() {
            this._segments.reverse();
            for (var i = 0, r = this._segments.length; i < r; i++) {
              var a = this._segments[i], l = a._handleIn;
              a._handleIn = a._handleOut, a._handleOut = l, a._index = i;
            }
            this._curves = null, this._changed(9);
          },
          flatten: function(i) {
            for (var r = new rt(this, i || 0.25, 256, !0), a = r.parts, l = a.length, u = [], d = 0; d < l; d++)
              u.push(new ce(a[d].curve.slice(0, 2)));
            !this._closed && l > 0 && u.push(new ce(a[l - 1].curve.slice(6))), this.setSegments(u);
          },
          simplify: function(i) {
            var r = new tt(this).fit(i || 2.5);
            return r && this.setSegments(r), !!r;
          },
          smooth: function(i) {
            var r = this, a = i || {}, l = a.type || "asymmetric", u = this._segments, d = u.length, v = this._closed;
            function p(vt, Rt) {
              var Et = vt && vt.index;
              if (Et != null) {
                var Ht = vt.path;
                if (Ht && Ht !== r)
                  throw new Error(vt._class + " " + Et + " of " + Ht + " is not part of " + r);
                Rt && vt instanceof De && Et++;
              } else
                Et = typeof vt == "number" ? vt : Rt;
              return Math.min(Et < 0 && v ? Et % d : Et < 0 ? Et + d : Et, d - 1);
            }
            var y = v && a.from === t && a.to === t, S = p(a.from, 0), L = p(a.to, d - 1);
            if (S > L)
              if (v)
                S -= d;
              else {
                var E = S;
                S = L, L = E;
              }
            if (/^(?:asymmetric|continuous)$/.test(l)) {
              var A = l === "asymmetric", T = Math.min, G = L - S + 1, R = G - 1, Y = y ? T(G, 4) : 1, k = Y, z = Y, C = [];
              if (v || (k = T(1, S), z = T(1, d - L - 1)), R += k + z, R <= 1)
                return;
              for (var I = 0, j = S - k; I <= R; I++, j++)
                C[I] = u[(j < 0 ? j + d : j) % d]._point;
              for (var q = C[0]._x + 2 * C[1]._x, H = C[0]._y + 2 * C[1]._y, ie = 2, ae = R - 1, he = [q], pe = [H], se = [ie], de = [], ve = [], I = 1; I < R; I++) {
                var we = I < ae, Se = we || A ? 1 : 2, Ae = we ? 4 : A ? 2 : 7, Ge = we ? 4 : A ? 3 : 8, Je = we ? 2 : A ? 0 : 1, it = Se / ie;
                ie = se[I] = Ae - it, q = he[I] = Ge * C[I]._x + Je * C[I + 1]._x - it * q, H = pe[I] = Ge * C[I]._y + Je * C[I + 1]._y - it * H;
              }
              de[ae] = he[ae] / se[ae], ve[ae] = pe[ae] / se[ae];
              for (var I = R - 2; I >= 0; I--)
                de[I] = (he[I] - de[I + 1]) / se[I], ve[I] = (pe[I] - ve[I + 1]) / se[I];
              de[R] = (3 * C[R]._x - de[ae]) / 2, ve[R] = (3 * C[R]._y - ve[ae]) / 2;
              for (var I = k, gt = R - z, j = S; I <= gt; I++, j++) {
                var Ne = u[j < 0 ? j + d : j], Fe = Ne._point, st = de[I] - Fe._x, _t = ve[I] - Fe._y;
                (y || I < gt) && Ne.setHandleOut(st, _t), (y || I > k) && Ne.setHandleIn(-st, -_t);
              }
            } else
              for (var I = S; I <= L; I++)
                u[I < 0 ? I + d : I].smooth(
                  a,
                  !y && I === S,
                  !y && I === L
                );
          },
          toShape: function(i) {
            if (!this._closed)
              return null;
            var r = this._segments, a, l, u, d;
            function v(A, T) {
              var G = r[A], R = G.getNext(), Y = r[T], k = Y.getNext();
              return G._handleOut.isZero() && R._handleIn.isZero() && Y._handleOut.isZero() && k._handleIn.isZero() && R._point.subtract(G._point).isCollinear(
                k._point.subtract(Y._point)
              );
            }
            function p(A) {
              var T = r[A], G = T.getPrevious(), R = T.getNext();
              return G._handleOut.isZero() && T._handleIn.isZero() && T._handleOut.isZero() && R._handleIn.isZero() && T._point.subtract(G._point).isOrthogonal(
                R._point.subtract(T._point)
              );
            }
            function y(A) {
              var T = r[A], G = T.getNext(), R = T._handleOut, Y = G._handleIn, k = 0.5522847498307936;
              if (R.isOrthogonal(Y)) {
                var z = T._point, C = G._point, I = new le(z, R, !0).intersect(
                  new le(C, Y, !0),
                  !0
                );
                return I && P.isZero(R.getLength() / I.subtract(z).getLength() - k) && P.isZero(Y.getLength() / I.subtract(C).getLength() - k);
              }
              return !1;
            }
            function S(A, T) {
              return r[A]._point.getDistance(r[T]._point);
            }
            if (!this.hasHandles() && r.length === 4 && v(0, 2) && v(1, 3) && p(1) ? (a = ke.Rectangle, l = new F(S(0, 3), S(0, 1)), d = r[1]._point.add(r[2]._point).divide(2)) : r.length === 8 && y(0) && y(2) && y(4) && y(6) && v(1, 5) && v(3, 7) ? (a = ke.Rectangle, l = new F(S(1, 6), S(0, 3)), u = l.subtract(new F(
              S(0, 7),
              S(1, 2)
            )).divide(2), d = r[3]._point.add(r[4]._point).divide(2)) : r.length === 4 && y(0) && y(1) && y(2) && y(3) && (P.isZero(S(0, 2) - S(1, 3)) ? (a = ke.Circle, u = S(0, 2) / 2) : (a = ke.Ellipse, u = new F(S(2, 0) / 2, S(3, 1) / 2)), d = r[1]._point), a) {
              var L = this.getPosition(!0), E = new a({
                center: L,
                size: l,
                radius: u,
                insert: !1
              });
              return E.copyAttributes(this, !0), E._matrix.prepend(this._matrix), E.rotate(d.subtract(L).getAngle() + 90), (i === t || i) && E.insertAbove(this), E;
            }
            return null;
          },
          toPath: "#clone",
          compare: function i(r) {
            if (!r || r instanceof It)
              return i.base.call(this, r);
            var a = this.getCurves(), l = r.getCurves(), u = a.length, d = l.length;
            if (!u || !d)
              return u == d;
            for (var v = a[0].getValues(), p = [], y = 0, S, L = 0, E, A = 0; A < d; A++) {
              var T = l[A].getValues();
              p.push(T);
              var G = De.getOverlaps(v, T);
              if (G) {
                S = !A && G[0][0] > 0 ? d - 1 : A, E = G[0][1];
                break;
              }
            }
            for (var R = Math.abs, Y = 1e-8, T = p[S], k; v && T; ) {
              var G = De.getOverlaps(v, T);
              if (G) {
                var z = G[0][0];
                if (R(z - L) < Y) {
                  L = G[1][0], L === 1 && (v = ++y < u ? a[y].getValues() : null, L = 0);
                  var C = G[0][1];
                  if (R(C - E) < Y) {
                    if (k || (k = [S, C]), E = G[1][1], E === 1 && (++S >= d && (S = 0), T = p[S] || l[S].getValues(), E = 0), !v)
                      return k[0] === S && k[1] === E;
                    continue;
                  }
                }
              }
              break;
            }
            return !1;
          },
          _hitTestSelf: function(i, r, a, l) {
            var u = this, d = this.getStyle(), v = this._segments, p = v.length, y = this._closed, S = r._tolerancePadding, L = S, E, A, T, G, R, Y, k = r.stroke && d.hasStroke(), z = r.fill && d.hasFill(), C = r.curves, I = k ? d.getStrokeWidth() / 2 : z && r.tolerance > 0 || C ? 0 : null;
            I !== null && (I > 0 ? (E = d.getStrokeJoin(), A = d.getStrokeCap(), T = d.getMiterLimit(), L = L.add(
              We._getStrokePadding(I, l)
            )) : E = A = "round");
            function j(de, ve) {
              return i.subtract(de).divide(ve).length <= 1;
            }
            function q(de, ve, we) {
              if (!r.selected || ve.isSelected()) {
                var Se = de._point;
                if (ve !== Se && (ve = ve.add(Se)), j(ve, L))
                  return new $e(we, u, {
                    segment: de,
                    point: ve
                  });
              }
            }
            function H(de, ve) {
              return (ve || r.segments) && q(de, de._point, "segment") || !ve && r.handles && (q(de, de._handleIn, "handle-in") || q(de, de._handleOut, "handle-out"));
            }
            function ie(de) {
              G.add(de);
            }
            function ae(de) {
              var ve = y || de._index > 0 && de._index < p - 1;
              if ((ve ? E : A) === "round")
                return j(de._point, L);
              if (G = new We({ internal: !0, closed: !0 }), ve ? de.isSmooth() || We._addBevelJoin(
                de,
                E,
                I,
                T,
                null,
                l,
                ie,
                !0
              ) : A === "square" && We._addSquareCap(
                de,
                A,
                I,
                null,
                l,
                ie,
                !0
              ), !G.isEmpty()) {
                var we;
                return G.contains(i) || (we = G.getNearestLocation(i)) && j(we.getPoint(), S);
              }
            }
            if (r.ends && !r.segments && !y) {
              if (Y = H(v[0], !0) || H(v[p - 1], !0))
                return Y;
            } else if (r.segments || r.handles) {
              for (var he = 0; he < p; he++)
                if (Y = H(v[he]))
                  return Y;
            }
            if (I !== null) {
              if (R = this.getNearestLocation(i), R) {
                var pe = R.getTime();
                pe === 0 || pe === 1 && p > 1 ? ae(R.getSegment()) || (R = null) : j(R.getPoint(), L) || (R = null);
              }
              if (!R && E === "miter" && p > 1)
                for (var he = 0; he < p; he++) {
                  var se = v[he];
                  if (i.getDistance(se._point) <= T * I && ae(se)) {
                    R = se.getLocation();
                    break;
                  }
                }
            }
            return !R && z && this._contains(i) || R && !k && !C ? new $e("fill", this) : R ? new $e(k ? "stroke" : "curve", this, {
              location: R,
              point: R.getPoint()
            }) : null;
          }
        },
        o.each(
          De._evaluateMethods,
          function(i) {
            this[i + "At"] = function(r) {
              var a = this.getLocationAt(r);
              return a && a[i]();
            };
          },
          {
            beans: !1,
            getLocationOf: function() {
              for (var i = M.read(arguments), r = this.getCurves(), a = 0, l = r.length; a < l; a++) {
                var u = r[a].getLocationOf(i);
                if (u)
                  return u;
              }
              return null;
            },
            getOffsetOf: function() {
              var i = this.getLocationOf.apply(this, arguments);
              return i ? i.getOffset() : null;
            },
            getLocationAt: function(i) {
              if (typeof i == "number") {
                for (var r = this.getCurves(), a = 0, l = 0, u = r.length; l < u; l++) {
                  var d = a, v = r[l];
                  if (a += v.getLength(), a > i)
                    return v.getLocationAt(i - d);
                }
                if (r.length > 0 && i <= this.getLength())
                  return new ft(r[r.length - 1], 1);
              } else if (i && i.getPath && i.getPath() === this)
                return i;
              return null;
            },
            getOffsetsWithTangent: function() {
              var i = M.read(arguments);
              if (i.isZero())
                return [];
              for (var r = [], a = 0, l = this.getCurves(), u = 0, d = l.length; u < d; u++) {
                for (var v = l[u], p = v.getTimesWithTangent(i), y = 0, S = p.length; y < S; y++) {
                  var L = a + v.getOffsetAtTime(p[y]);
                  r.indexOf(L) < 0 && r.push(L);
                }
                a += v.length;
              }
              return r;
            }
          }
        ),
        new function() {
          function i(a, l, u, d) {
            if (d <= 0)
              return;
            var v = d / 2, p = d - 2, y = v - 1, S = new Array(6), L, E;
            function A(z) {
              var C = S[z], I = S[z + 1];
              (L != C || E != I) && (a.beginPath(), a.moveTo(L, E), a.lineTo(C, I), a.stroke(), a.beginPath(), a.arc(C, I, v, 0, Math.PI * 2, !0), a.fill());
            }
            for (var T = 0, G = l.length; T < G; T++) {
              var R = l[T], Y = R._selection;
              if (R._transformCoordinates(u, S), L = S[0], E = S[1], Y & 2 && A(2), Y & 4 && A(4), a.fillRect(L - v, E - v, d, d), p > 0 && !(Y & 1)) {
                var k = a.fillStyle;
                a.fillStyle = "#ffffff", a.fillRect(L - y, E - y, p, p), a.fillStyle = k;
              }
            }
          }
          function r(a, l, u) {
            var d = l._segments, v = d.length, p = new Array(6), y = !0, S, L, E, A, T, G, R, Y;
            function k(C) {
              if (u)
                C._transformCoordinates(u, p), S = p[0], L = p[1];
              else {
                var I = C._point;
                S = I._x, L = I._y;
              }
              if (y)
                a.moveTo(S, L), y = !1;
              else {
                if (u)
                  T = p[2], G = p[3];
                else {
                  var j = C._handleIn;
                  T = S + j._x, G = L + j._y;
                }
                T === S && G === L && R === E && Y === A ? a.lineTo(S, L) : a.bezierCurveTo(R, Y, T, G, S, L);
              }
              if (E = S, A = L, u)
                R = p[4], Y = p[5];
              else {
                var j = C._handleOut;
                R = E + j._x, Y = A + j._y;
              }
            }
            for (var z = 0; z < v; z++)
              k(d[z]);
            l._closed && v > 0 && k(d[0]);
          }
          return {
            _draw: function(a, l, u, d) {
              var v = l.dontStart, p = l.dontFinish || l.clip, y = this.getStyle(), S = y.hasFill(), L = y.hasStroke(), E = y.getDashArray(), A = !He.support.nativeDash && L && E && E.length;
              v || a.beginPath(), (S || L && !A || p) && (r(a, this, d), this._closed && a.closePath());
              function T(C) {
                return E[(C % A + A) % A];
              }
              if (!p && (S || L) && (this._setStyles(a, l, u), S && (a.fill(y.getFillRule()), a.shadowColor = "rgba(0,0,0,0)"), L)) {
                if (A) {
                  v || a.beginPath();
                  for (var G = new rt(
                    this,
                    0.25,
                    32,
                    !1,
                    d
                  ), R = G.length, Y = -y.getDashOffset(), k, z = 0; Y > 0; )
                    Y -= T(z--) + T(z--);
                  for (; Y < R; )
                    k = Y + T(z++), (Y > 0 || k > 0) && G.drawPart(
                      a,
                      Math.max(Y, 0),
                      Math.max(k, 0)
                    ), Y = k + T(z++);
                }
                a.stroke();
              }
            },
            _drawSelected: function(a, l) {
              a.beginPath(), r(a, this, l), a.stroke(), i(a, this._segments, l, He.settings.handleSize);
            }
          };
        }(),
        new function() {
          function i(r) {
            var a = r._segments;
            if (!a.length)
              throw new Error("Use a moveTo() command first");
            return a[a.length - 1];
          }
          return {
            moveTo: function() {
              var r = this._segments;
              r.length === 1 && this.removeSegment(0), r.length || this._add([new ce(M.read(arguments))]);
            },
            moveBy: function() {
              throw new Error("moveBy() is unsupported on Path items.");
            },
            lineTo: function() {
              this._add([new ce(M.read(arguments))]);
            },
            cubicCurveTo: function() {
              var r = arguments, a = M.read(r), l = M.read(r), u = M.read(r), d = i(this);
              d.setHandleOut(a.subtract(d._point)), this._add([new ce(u, l.subtract(u))]);
            },
            quadraticCurveTo: function() {
              var r = arguments, a = M.read(r), l = M.read(r), u = i(this)._point;
              this.cubicCurveTo(
                a.add(u.subtract(a).multiply(1 / 3)),
                a.add(l.subtract(a).multiply(1 / 3)),
                l
              );
            },
            curveTo: function() {
              var r = arguments, a = M.read(r), l = M.read(r), u = o.pick(o.read(r), 0.5), d = 1 - u, v = i(this)._point, p = a.subtract(v.multiply(d * d)).subtract(l.multiply(u * u)).divide(2 * u * d);
              if (p.isNaN())
                throw new Error(
                  "Cannot put a curve through points with parameter = " + u
                );
              this.quadraticCurveTo(p, l);
            },
            arcTo: function() {
              var r = arguments, a = Math.abs, l = Math.sqrt, u = i(this), d = u._point, v = M.read(r), G, p = o.peek(r), y = o.pick(p, !0), S, L, E, A;
              if (typeof y == "boolean")
                var T = d.add(v).divide(2), G = T.add(T.subtract(d).rotate(
                  y ? -90 : 90
                ));
              else if (o.remain(r) <= 2)
                G = v, v = M.read(r);
              else if (!d.equals(v)) {
                var R = F.read(r), Y = P.isZero;
                if (Y(R.width) || Y(R.height))
                  return this.lineTo(v);
                var k = o.read(r), y = !!o.read(r), z = !!o.read(r), T = d.add(v).divide(2), C = d.subtract(T).rotate(-k), I = C.x, j = C.y, q = a(R.width), H = a(R.height), ie = q * q, ae = H * H, he = I * I, pe = j * j, se = l(he / ie + pe / ae);
                if (se > 1 && (q *= se, H *= se, ie = q * q, ae = H * H), se = (ie * ae - ie * pe - ae * he) / (ie * pe + ae * he), a(se) < 1e-12 && (se = 0), se < 0)
                  throw new Error(
                    "Cannot create an arc with the given arguments"
                  );
                S = new M(q * j / H, -H * I / q).multiply((z === y ? -1 : 1) * l(se)).rotate(k).add(T), A = new ee().translate(S).rotate(k).scale(q, H), E = A._inverseTransform(d), L = E.getDirectedAngle(A._inverseTransform(v)), !y && L > 0 ? L -= 360 : y && L < 0 && (L += 360);
              }
              if (G) {
                var de = new le(
                  d.add(G).divide(2),
                  G.subtract(d).rotate(90),
                  !0
                ), ve = new le(
                  G.add(v).divide(2),
                  v.subtract(G).rotate(90),
                  !0
                ), we = new le(d, v), Se = we.getSide(G);
                if (S = de.intersect(ve, !0), !S) {
                  if (!Se)
                    return this.lineTo(v);
                  throw new Error(
                    "Cannot create an arc with the given arguments"
                  );
                }
                E = d.subtract(S), L = E.getDirectedAngle(v.subtract(S));
                var Ae = we.getSide(S, !0);
                Ae === 0 ? L = Se * a(L) : Se === Ae && (L += L < 0 ? 360 : -360);
              }
              if (L) {
                for (var Ge = 1e-5, Je = a(L), it = Je >= 360 ? 4 : Math.ceil((Je - Ge) / 90), gt = L / it, Ne = gt * Math.PI / 360, Fe = 4 / 3 * Math.sin(Ne) / (1 + Math.cos(Ne)), st = [], _t = 0; _t <= it; _t++) {
                  var C = v, vt = null;
                  if (_t < it && (vt = E.rotate(90).multiply(Fe), A ? (C = A._transformPoint(E), vt = A._transformPoint(E.add(vt)).subtract(C)) : C = S.add(E)), !_t)
                    u.setHandleOut(vt);
                  else {
                    var Rt = E.rotate(-90).multiply(Fe);
                    A && (Rt = A._transformPoint(E.add(Rt)).subtract(C)), st.push(new ce(C, Rt, vt));
                  }
                  E = E.rotate(gt);
                }
                this._add(st);
              }
            },
            lineBy: function() {
              var r = M.read(arguments), a = i(this)._point;
              this.lineTo(a.add(r));
            },
            curveBy: function() {
              var r = arguments, a = M.read(r), l = M.read(r), u = o.read(r), d = i(this)._point;
              this.curveTo(d.add(a), d.add(l), u);
            },
            cubicCurveBy: function() {
              var r = arguments, a = M.read(r), l = M.read(r), u = M.read(r), d = i(this)._point;
              this.cubicCurveTo(
                d.add(a),
                d.add(l),
                d.add(u)
              );
            },
            quadraticCurveBy: function() {
              var r = arguments, a = M.read(r), l = M.read(r), u = i(this)._point;
              this.quadraticCurveTo(u.add(a), u.add(l));
            },
            arcBy: function() {
              var r = arguments, a = i(this)._point, l = a.add(M.read(r)), u = o.pick(o.peek(r), !0);
              typeof u == "boolean" ? this.arcTo(l, u) : this.arcTo(l, a.add(M.read(r)));
            },
            closePath: function(r) {
              this.setClosed(!0), this.join(this, r);
            }
          };
        }(),
        {
          _getBounds: function(i, r) {
            var a = r.handle ? "getHandleBounds" : r.stroke ? "getStrokeBounds" : "getBounds";
            return We[a](this._segments, this._closed, this, i, r);
          },
          statics: {
            getBounds: function(i, r, a, l, u, d) {
              var v = i[0];
              if (!v)
                return new D();
              var p = new Array(6), y = v._transformCoordinates(l, new Array(6)), S = y.slice(0, 2), L = S.slice(), E = new Array(2);
              function A(R) {
                R._transformCoordinates(l, p);
                for (var Y = 0; Y < 2; Y++)
                  De._addBounds(
                    y[Y],
                    y[Y + 4],
                    p[Y + 2],
                    p[Y],
                    Y,
                    d ? d[Y] : 0,
                    S,
                    L,
                    E
                  );
                var k = y;
                y = p, p = k;
              }
              for (var T = 1, G = i.length; T < G; T++)
                A(i[T]);
              return r && A(v), new D(S[0], S[1], L[0] - S[0], L[1] - S[1]);
            },
            getStrokeBounds: function(i, r, a, l, u) {
              var d = a.getStyle(), v = d.hasStroke(), p = d.getStrokeWidth(), y = v && a._getStrokeMatrix(l, u), S = v && We._getStrokePadding(
                p,
                y
              ), L = We.getBounds(
                i,
                r,
                a,
                l,
                u,
                S
              );
              if (!v)
                return L;
              var E = p / 2, A = d.getStrokeJoin(), T = d.getStrokeCap(), G = d.getMiterLimit(), R = new D(new F(S));
              function Y(q) {
                L = L.include(q);
              }
              function k(q) {
                L = L.unite(
                  R.setCenter(q._point.transform(l))
                );
              }
              function z(q, H) {
                H === "round" || q.isSmooth() ? k(q) : We._addBevelJoin(
                  q,
                  H,
                  E,
                  G,
                  l,
                  y,
                  Y
                );
              }
              function C(q, H) {
                H === "round" ? k(q) : We._addSquareCap(
                  q,
                  H,
                  E,
                  l,
                  y,
                  Y
                );
              }
              var I = i.length - (r ? 0 : 1);
              if (I > 0) {
                for (var j = 1; j < I; j++)
                  z(i[j], A);
                r ? z(i[0], A) : (C(i[0], T), C(i[i.length - 1], T));
              }
              return L;
            },
            _getStrokePadding: function(i, r) {
              if (!r)
                return [i, i];
              var a = new M(i, 0).transform(r), l = new M(0, i).transform(r), u = a.getAngleInRadians(), d = a.getLength(), v = l.getLength(), p = Math.sin(u), y = Math.cos(u), S = Math.tan(u), L = Math.atan2(v * S, d), E = Math.atan2(v, S * d);
              return [
                Math.abs(d * Math.cos(L) * y + v * Math.sin(L) * p),
                Math.abs(v * Math.sin(E) * y + d * Math.cos(E) * p)
              ];
            },
            _addBevelJoin: function(i, r, a, l, u, d, v, p) {
              var y = i.getCurve(), S = y.getPrevious(), L = y.getPoint1().transform(u), E = S.getNormalAtTime(1).multiply(a).transform(d), A = y.getNormalAtTime(0).multiply(a).transform(d), T = E.getDirectedAngle(A);
              if ((T < 0 || T >= 180) && (E = E.negate(), A = A.negate()), p && v(L), v(L.add(E)), r === "miter") {
                var G = new le(
                  L.add(E),
                  new M(-E.y, E.x),
                  !0
                ).intersect(new le(
                  L.add(A),
                  new M(-A.y, A.x),
                  !0
                ), !0);
                G && L.getDistance(G) <= l * a && v(G);
              }
              v(L.add(A));
            },
            _addSquareCap: function(i, r, a, l, u, d, v) {
              var p = i._point.transform(l), y = i.getLocation(), S = y.getNormal().multiply(y.getTime() === 0 ? a : -a).transform(u);
              r === "square" && (v && (d(p.subtract(S)), d(p.add(S))), p = p.add(S.rotate(-90))), d(p.add(S)), d(p.subtract(S));
            },
            getHandleBounds: function(i, r, a, l, u) {
              var d = a.getStyle(), v = u.stroke && d.hasStroke(), p, y;
              if (v) {
                var S = a._getStrokeMatrix(l, u), L = d.getStrokeWidth() / 2, E = L;
                d.getStrokeJoin() === "miter" && (E = L * d.getMiterLimit()), d.getStrokeCap() === "square" && (E = Math.max(E, L * Math.SQRT2)), p = We._getStrokePadding(L, S), y = We._getStrokePadding(E, S);
              }
              for (var A = new Array(6), T = 1 / 0, G = -T, R = T, Y = G, k = 0, z = i.length; k < z; k++) {
                var C = i[k];
                C._transformCoordinates(l, A);
                for (var I = 0; I < 6; I += 2) {
                  var j = I ? p : y, q = j ? j[0] : 0, H = j ? j[1] : 0, ie = A[I], ae = A[I + 1], he = ie - q, pe = ie + q, se = ae - H, de = ae + H;
                  he < T && (T = he), pe > G && (G = pe), se < R && (R = se), de > Y && (Y = de);
                }
              }
              return new D(T, R, G - T, Y - R);
            }
          }
        }
      );
      We.inject({ statics: new function() {
        var i = 0.5522847498307936, r = [
          new ce([-1, 0], [0, i], [0, -i]),
          new ce([0, -1], [-i, 0], [i, 0]),
          new ce([1, 0], [0, -i], [0, i]),
          new ce([0, 1], [i, 0], [-i, 0])
        ];
        function a(u, d, v) {
          var p = o.getNamed(v), y = new We(p && (p.insert == !0 ? X.INSERT : p.insert == !1 ? X.NO_INSERT : null));
          return y._add(u), y._closed = d, y.set(p, X.INSERT);
        }
        function l(u, d, v) {
          for (var p = new Array(4), y = 0; y < 4; y++) {
            var S = r[y];
            p[y] = new ce(
              S._point.multiply(d).add(u),
              S._handleIn.multiply(d),
              S._handleOut.multiply(d)
            );
          }
          return a(p, !0, v);
        }
        return {
          Line: function() {
            var u = arguments;
            return a([
              new ce(M.readNamed(u, "from")),
              new ce(M.readNamed(u, "to"))
            ], !1, u);
          },
          Circle: function() {
            var u = arguments, d = M.readNamed(u, "center"), v = o.readNamed(u, "radius");
            return l(d, new F(v), u);
          },
          Rectangle: function() {
            var u = arguments, d = D.readNamed(u, "rectangle"), v = F.readNamed(
              u,
              "radius",
              0,
              { readNull: !0 }
            ), p = d.getBottomLeft(!0), y = d.getTopLeft(!0), S = d.getTopRight(!0), L = d.getBottomRight(!0), E;
            if (!v || v.isZero())
              E = [
                new ce(p),
                new ce(y),
                new ce(S),
                new ce(L)
              ];
            else {
              v = F.min(v, d.getSize(!0).divide(2));
              var A = v.width, T = v.height, G = A * i, R = T * i;
              E = [
                new ce(p.add(A, 0), null, [-G, 0]),
                new ce(p.subtract(0, T), [0, R]),
                new ce(y.add(0, T), null, [0, -R]),
                new ce(y.add(A, 0), [-G, 0], null),
                new ce(S.subtract(A, 0), null, [G, 0]),
                new ce(S.add(0, T), [0, -R], null),
                new ce(L.subtract(0, T), null, [0, R]),
                new ce(L.subtract(A, 0), [G, 0])
              ];
            }
            return a(E, !0, u);
          },
          RoundRectangle: "#Rectangle",
          Ellipse: function() {
            var u = arguments, d = ke._readEllipse(u);
            return l(d.center, d.radius, u);
          },
          Oval: "#Ellipse",
          Arc: function() {
            var u = arguments, d = M.readNamed(u, "from"), v = M.readNamed(u, "through"), p = M.readNamed(u, "to"), y = o.getNamed(u), S = new We(y && y.insert == !1 && X.NO_INSERT);
            return S.moveTo(d), S.arcTo(v, p), S.set(y);
          },
          RegularPolygon: function() {
            for (var u = arguments, d = M.readNamed(u, "center"), v = o.readNamed(u, "sides"), p = o.readNamed(u, "radius"), y = 360 / v, S = v % 3 === 0, L = new M(0, S ? -p : p), E = S ? -1 : 0.5, A = new Array(v), T = 0; T < v; T++)
              A[T] = new ce(d.add(
                L.rotate((T + E) * y)
              ));
            return a(A, !0, u);
          },
          Star: function() {
            for (var u = arguments, d = M.readNamed(u, "center"), v = o.readNamed(u, "points") * 2, p = o.readNamed(u, "radius1"), y = o.readNamed(u, "radius2"), S = 360 / v, L = new M(0, -1), E = new Array(v), A = 0; A < v; A++)
              E[A] = new ce(d.add(L.rotate(S * A).multiply(A % 2 ? y : p)));
            return a(E, !0, u);
          }
        };
      }() });
      var It = Yt.extend(
        {
          _class: "CompoundPath",
          _serializeFields: {
            children: []
          },
          beans: !0,
          initialize: function(i) {
            this._children = [], this._namedChildren = {}, this._initialize(i) || (typeof i == "string" ? this.setPathData(i) : this.addChildren(Array.isArray(i) ? i : arguments));
          },
          insertChildren: function i(r, a) {
            var l = a, u = l[0];
            u && typeof u[0] == "number" && (l = [l]);
            for (var d = a.length - 1; d >= 0; d--) {
              var v = l[d];
              l === a && !(v instanceof We) && (l = o.slice(l)), Array.isArray(v) ? l[d] = new We({ segments: v, insert: !1 }) : v instanceof It && (l.splice.apply(l, [d, 1].concat(v.removeChildren())), v.remove());
            }
            return i.base.call(this, r, l);
          },
          reduce: function i(r) {
            for (var a = this._children, l = a.length - 1; l >= 0; l--) {
              var u = a[l].reduce(r);
              u.isEmpty() && u.remove();
            }
            if (!a.length) {
              var u = new We(X.NO_INSERT);
              return u.copyAttributes(this), u.insertAbove(this), this.remove(), u;
            }
            return i.base.call(this);
          },
          isClosed: function() {
            for (var i = this._children, r = 0, a = i.length; r < a; r++)
              if (!i[r]._closed)
                return !1;
            return !0;
          },
          setClosed: function(i) {
            for (var r = this._children, a = 0, l = r.length; a < l; a++)
              r[a].setClosed(i);
          },
          getFirstSegment: function() {
            var i = this.getFirstChild();
            return i && i.getFirstSegment();
          },
          getLastSegment: function() {
            var i = this.getLastChild();
            return i && i.getLastSegment();
          },
          getCurves: function() {
            for (var i = this._children, r = [], a = 0, l = i.length; a < l; a++)
              o.push(r, i[a].getCurves());
            return r;
          },
          getFirstCurve: function() {
            var i = this.getFirstChild();
            return i && i.getFirstCurve();
          },
          getLastCurve: function() {
            var i = this.getLastChild();
            return i && i.getLastCurve();
          },
          getArea: function() {
            for (var i = this._children, r = 0, a = 0, l = i.length; a < l; a++)
              r += i[a].getArea();
            return r;
          },
          getLength: function() {
            for (var i = this._children, r = 0, a = 0, l = i.length; a < l; a++)
              r += i[a].getLength();
            return r;
          },
          getPathData: function(i, r) {
            for (var a = this._children, l = [], u = 0, d = a.length; u < d; u++) {
              var v = a[u], p = v._matrix;
              l.push(v.getPathData(i && !p.isIdentity() ? i.appended(p) : i, r));
            }
            return l.join("");
          },
          _hitTestChildren: function i(r, a, l) {
            return i.base.call(
              this,
              r,
              a.class === We || a.type === "path" ? a : o.set({}, a, { fill: !1 }),
              l
            );
          },
          _draw: function(i, r, a, l) {
            var u = this._children;
            if (u.length) {
              r = r.extend({ dontStart: !0, dontFinish: !0 }), i.beginPath();
              for (var d = 0, v = u.length; d < v; d++)
                u[d].draw(i, r, l);
              if (!r.clip) {
                this._setStyles(i, r, a);
                var p = this._style;
                p.hasFill() && (i.fill(p.getFillRule()), i.shadowColor = "rgba(0,0,0,0)"), p.hasStroke() && i.stroke();
              }
            }
          },
          _drawSelected: function(i, r, a) {
            for (var l = this._children, u = 0, d = l.length; u < d; u++) {
              var v = l[u], p = v._matrix;
              a[v._id] || v._drawSelected(i, p.isIdentity() ? r : r.appended(p));
            }
          }
        },
        new function() {
          function i(r, a) {
            var l = r._children;
            if (a && !l.length)
              throw new Error("Use a moveTo() command first");
            return l[l.length - 1];
          }
          return o.each(
            [
              "lineTo",
              "cubicCurveTo",
              "quadraticCurveTo",
              "curveTo",
              "arcTo",
              "lineBy",
              "cubicCurveBy",
              "quadraticCurveBy",
              "curveBy",
              "arcBy"
            ],
            function(r) {
              this[r] = function() {
                var a = i(this, !0);
                a[r].apply(a, arguments);
              };
            },
            {
              moveTo: function() {
                var r = i(this), a = r && r.isEmpty() ? r : new We(X.NO_INSERT);
                a !== r && this.addChild(a), a.moveTo.apply(a, arguments);
              },
              moveBy: function() {
                var r = i(this, !0), a = r && r.getLastSegment(), l = M.read(arguments);
                this.moveTo(a ? l.add(a._point) : l);
              },
              closePath: function(r) {
                i(this, !0).closePath(r);
              }
            }
          );
        }(),
        o.each(["reverse", "flatten", "simplify", "smooth"], function(i) {
          this[i] = function(r) {
            for (var a = this._children, l, u = 0, d = a.length; u < d; u++)
              l = a[u][i](r) || l;
            return l;
          };
        }, {})
      );
      Yt.inject(new function() {
        var i = Math.min, r = Math.max, a = Math.abs, l = {
          unite: { 1: !0, 2: !0 },
          intersect: { 2: !0 },
          subtract: { 1: !0 },
          exclude: { 1: !0, "-1": !0 }
        };
        function u(k) {
          return k._children || [k];
        }
        function d(k, z) {
          var C = k.clone(!1).reduce({ simplify: !0 }).transform(null, !0, !0);
          if (z) {
            for (var I = u(C), j = 0, q = I.length; j < q; j++) {
              var k = I[j];
              !k._closed && !k.isEmpty() && (k.closePath(1e-12), k.getFirstSegment().setHandleIn(0, 0), k.getLastSegment().setHandleOut(0, 0));
            }
            C = C.resolveCrossings().reorient(C.getFillRule() === "nonzero", !0);
          }
          return C;
        }
        function v(k, z, C, I, j) {
          var q = new It(X.NO_INSERT);
          return q.addChildren(k, !0), q = q.reduce({ simplify: z }), j && j.insert == !1 || q.insertAbove(I && C.isSibling(I) && C.getIndex() < I.getIndex() ? I : C), q.copyAttributes(C, !0), q;
        }
        function p(k) {
          return k.hasOverlap() || k.isCrossing();
        }
        function y(k, z, C, I) {
          if (I && (I.trace == !1 || I.stroke) && /^(subtract|intersect)$/.test(C))
            return S(k, z, C);
          var j = d(k, !0), q = z && k !== z && d(z, !0), H = l[C];
          H[C] = !0, q && (H.subtract || H.exclude) ^ (q.isClockwise() ^ j.isClockwise()) && q.reverse();
          var ie = T(ft.expand(
            j.getIntersections(q, p)
          )), ae = u(j), he = q && u(q), pe = [], se = [], de;
          function ve(vt) {
            for (var Rt = 0, Et = vt.length; Rt < Et; Rt++) {
              var Ht = vt[Rt];
              o.push(pe, Ht._segments), o.push(se, Ht.getCurves()), Ht._overlapsOnly = !0;
            }
          }
          function we(vt) {
            for (var Rt = [], Et = 0, Ht = vt && vt.length; Et < Ht; Et++)
              Rt.push(se[vt[Et]]);
            return Rt;
          }
          if (ie.length) {
            ve(ae), he && ve(he);
            for (var Se = new Array(se.length), Ae = 0, Ge = se.length; Ae < Ge; Ae++)
              Se[Ae] = se[Ae].getValues();
            for (var Je = x.findCurveBoundsCollisions(
              Se,
              Se,
              0,
              !0
            ), it = {}, Ae = 0; Ae < se.length; Ae++) {
              var gt = se[Ae], Ne = gt._path._id, Fe = it[Ne] = it[Ne] || {};
              Fe[gt.getIndex()] = {
                hor: we(Je[Ae].hor),
                ver: we(Je[Ae].ver)
              };
            }
            for (var Ae = 0, Ge = ie.length; Ae < Ge; Ae++)
              R(
                ie[Ae]._segment,
                j,
                q,
                it,
                H
              );
            for (var Ae = 0, Ge = pe.length; Ae < Ge; Ae++) {
              var st = pe[Ae], _t = st._intersection;
              st._winding || R(
                st,
                j,
                q,
                it,
                H
              ), _t && _t._overlap || (st._path._overlapsOnly = !1);
            }
            de = Y(pe, H);
          } else
            de = A(
              he ? ae.concat(he) : ae.slice(),
              function(vt) {
                return !!H[vt];
              }
            );
          return v(de, !0, k, z, I);
        }
        function S(k, z, C) {
          var I = d(k), j = d(z), q = I.getIntersections(j, p), H = C === "subtract", ie = C === "divide", ae = {}, he = [];
          function pe(ve) {
            if (!ae[ve._id] && (ie || j.contains(ve.getPointAt(ve.getLength() / 2)) ^ H))
              return he.unshift(ve), ae[ve._id] = !0;
          }
          for (var se = q.length - 1; se >= 0; se--) {
            var de = q[se].split();
            de && (pe(de) && de.getFirstSegment().setHandleIn(0, 0), I.getLastSegment().setHandleOut(0, 0));
          }
          return pe(I), v(he, !1, k, z);
        }
        function L(k, z) {
          for (var C = k; C; ) {
            if (C === z)
              return;
            C = C._previous;
          }
          for (; k._next && k._next !== z; )
            k = k._next;
          if (!k._next) {
            for (; z._previous; )
              z = z._previous;
            k._next = z, z._previous = k;
          }
        }
        function E(k) {
          for (var z = k.length - 1; z >= 0; z--)
            k[z].clearHandles();
        }
        function A(k, z, C) {
          var I = k && k.length;
          if (I) {
            var j = o.each(k, function(Je, it) {
              this[Je._id] = {
                container: null,
                winding: Je.isClockwise() ? 1 : -1,
                index: it
              };
            }, {}), q = k.slice().sort(function(Je, it) {
              return a(it.getArea()) - a(Je.getArea());
            }), H = q[0], ie = x.findItemBoundsCollisions(
              q,
              null,
              P.GEOMETRIC_EPSILON
            );
            C == null && (C = H.isClockwise());
            for (var ae = 0; ae < I; ae++) {
              var he = q[ae], pe = j[he._id], se = 0, de = ie[ae];
              if (de) {
                for (var ve = null, we = de.length - 1; we >= 0; we--)
                  if (de[we] < ae) {
                    ve = ve || he.getInteriorPoint();
                    var Se = q[de[we]];
                    if (Se.contains(ve)) {
                      var Ae = j[Se._id];
                      se = Ae.winding, pe.winding += se, pe.container = Ae.exclude ? Ae.container : Se;
                      break;
                    }
                  }
              }
              if (z(pe.winding) === z(se))
                pe.exclude = !0, k[pe.index] = null;
              else {
                var Ge = pe.container;
                he.setClockwise(
                  Ge ? !Ge.isClockwise() : C
                );
              }
            }
          }
          return k;
        }
        function T(k, z, C) {
          var I = z && [], j = 1e-8, q = 1 - j, H = !1, ie = C || [], ae = C && {}, he, pe, se;
          function de(Rt) {
            return Rt._path._id + "." + Rt._segment1._index;
          }
          for (var ve = (C && C.length) - 1; ve >= 0; ve--) {
            var we = C[ve];
            we._path && (ae[de(we)] = !0);
          }
          for (var ve = k.length - 1; ve >= 0; ve--) {
            var Se = k[ve], Ae = Se._time, Ge = Ae, Je = z && !z(Se), we = Se._curve, it;
            if (we && (we !== pe ? (H = !we.hasHandles() || ae && ae[de(we)], he = [], se = null, pe = we) : se >= j && (Ae /= se)), Je) {
              he && he.push(Se);
              continue;
            } else
              z && I.unshift(Se);
            if (se = Ge, Ae < j)
              it = we._segment1;
            else if (Ae > q)
              it = we._segment2;
            else {
              var gt = we.divideAtTime(Ae, !0);
              H && ie.push(we, gt), it = gt._segment1;
              for (var Ne = he.length - 1; Ne >= 0; Ne--) {
                var Fe = he[Ne];
                Fe._time = (Fe._time - Ae) / (1 - Ae);
              }
            }
            Se._setSegment(it);
            var st = it._intersection, _t = Se._intersection;
            if (st) {
              L(st, _t);
              for (var vt = st; vt; )
                L(vt._intersection, st), vt = vt._next;
            } else
              it._intersection = _t;
          }
          return C || E(ie), I || k;
        }
        function G(k, z, C, I, j) {
          var q = Array.isArray(z) ? z : z[C ? "hor" : "ver"], H = C ? 1 : 0, ie = H ^ 1, ae = [k.x, k.y], he = ae[H], pe = ae[ie], se = 1e-9, de = 1e-6, ve = he - se, we = he + se, Se = 0, Ae = 0, Ge = 0, Je = 0, it = !1, gt = !1, Ne = 1, Fe = [], st, _t;
          function vt(ri) {
            var Nt = ri[ie + 0], Di = ri[ie + 6];
            if (!(pe < i(Nt, Di) || pe > r(Nt, Di))) {
              var li = ri[H + 0], nn = ri[H + 2], Vi = ri[H + 4], Wi = ri[H + 6];
              if (Nt === Di) {
                (li < we && Wi > ve || Wi < we && li > ve) && (it = !0);
                return;
              }
              var Ji = pe === Nt ? 0 : pe === Di || ve > r(li, nn, Vi, Wi) || we < i(li, nn, Vi, Wi) ? 1 : De.solveCubic(ri, ie, pe, Fe, 0, 1) > 0 ? Fe[0] : 1, Hi = Ji === 0 ? li : Ji === 1 ? Wi : De.getPoint(ri, Ji)[C ? "y" : "x"], $i = Nt > Di ? 1 : -1, _n = st[ie] > st[ie + 6] ? 1 : -1, Xi = st[H + 6];
              return pe !== Nt ? (Hi < ve ? Ge += $i : Hi > we ? Je += $i : it = !0, Hi > he - de && Hi < he + de && (Ne /= 2)) : ($i !== _n ? li < ve ? Ge += $i : li > we && (Je += $i) : li != Xi && (Xi < we && Hi > we ? (Je += $i, it = !0) : Xi > ve && Hi < ve && (Ge += $i, it = !0)), Ne /= 4), st = ri, !j && Hi > ve && Hi < we && De.getTangent(ri, Ji)[C ? "x" : "y"] === 0 && G(k, z, !C, I, !0);
            }
          }
          function Rt(ri) {
            var Nt = ri[ie + 0], Di = ri[ie + 2], li = ri[ie + 4], nn = ri[ie + 6];
            if (pe <= r(Nt, Di, li, nn) && pe >= i(Nt, Di, li, nn)) {
              for (var Vi = ri[H + 0], Wi = ri[H + 2], Ji = ri[H + 4], Hi = ri[H + 6], $i = ve > r(Vi, Wi, Ji, Hi) || we < i(Vi, Wi, Ji, Hi) ? [ri] : De.getMonoCurves(ri, C), _n, Xi = 0, cn = $i.length; Xi < cn; Xi++)
                if (_n = vt($i[Xi]))
                  return _n;
            }
          }
          for (var Et = 0, Ht = q.length; Et < Ht; Et++) {
            var jt = q[Et], Vt = jt._path, Mi = jt.getValues(), Li;
            if ((!Et || q[Et - 1]._path !== Vt) && (st = null, Vt._closed || (_t = De.getValues(
              Vt.getLastCurve().getSegment2(),
              jt.getSegment1(),
              null,
              !I
            ), _t[ie] !== _t[ie + 6] && (st = _t)), !st)) {
              st = Mi;
              for (var Ai = Vt.getLastCurve(); Ai && Ai !== jt; ) {
                var vi = Ai.getValues();
                if (vi[ie] !== vi[ie + 6]) {
                  st = vi;
                  break;
                }
                Ai = Ai.getPrevious();
              }
            }
            if (Li = Rt(Mi))
              return Li;
            if (Et + 1 === Ht || q[Et + 1]._path !== Vt) {
              if (_t && (Li = Rt(_t)))
                return Li;
              it && !Ge && !Je && (Ge = Je = Vt.isClockwise(I) ^ C ? 1 : -1), Se += Ge, Ae += Je, Ge = Je = 0, it && (gt = !0, it = !1), _t = null;
            }
          }
          return Se = a(Se), Ae = a(Ae), {
            winding: r(Se, Ae),
            windingL: Se,
            windingR: Ae,
            quality: Ne,
            onPath: gt
          };
        }
        function R(k, z, C, I, j) {
          var q = [], H = k, ie = 0, ae;
          do {
            var he = k.getCurve();
            if (he) {
              var pe = he.getLength();
              q.push({ segment: k, curve: he, length: pe }), ie += pe;
            }
            k = k.getNext();
          } while (k && !k._intersection && k !== H);
          for (var se = [0.5, 0.25, 0.75], ae = { winding: 0, quality: -1 }, de = 1e-3, ve = 1 - de, we = 0; we < se.length && ae.quality < 0.5; we++)
            for (var pe = ie * se[we], Se = 0, Ae = q.length; Se < Ae; Se++) {
              var Ge = q[Se], Je = Ge.length;
              if (pe <= Je) {
                var he = Ge.curve, it = he._path, gt = it._parent, Ne = gt instanceof It ? gt : it, Fe = P.clamp(he.getTimeAt(pe), de, ve), st = he.getPointAtTime(Fe), _t = a(he.getTangentAtTime(Fe).y) < Math.SQRT1_2, vt = null;
                if (j.subtract && C) {
                  var Rt = Ne === z ? C : z, Et = Rt._getWinding(st, _t, !0);
                  if (Ne === z && Et.winding || Ne === C && !Et.winding) {
                    if (Et.quality < 1)
                      continue;
                    vt = { winding: 0, quality: 1 };
                  }
                }
                vt = vt || G(
                  st,
                  I[it._id][he.getIndex()],
                  _t,
                  !0
                ), vt.quality > ae.quality && (ae = vt);
                break;
              }
              pe -= Je;
            }
          for (var Se = q.length - 1; Se >= 0; Se--)
            q[Se].segment._winding = ae;
        }
        function Y(k, z) {
          var C = [], I;
          function j(Ht) {
            var jt;
            return !!(Ht && !Ht._visited && (!z || z[(jt = Ht._winding || {}).winding] && !(z.unite && jt.winding === 2 && jt.windingL && jt.windingR)));
          }
          function q(Ht) {
            if (Ht) {
              for (var jt = 0, Vt = I.length; jt < Vt; jt++)
                if (Ht === I[jt])
                  return !0;
            }
            return !1;
          }
          function H(Ht) {
            for (var jt = Ht._segments, Vt = 0, Mi = jt.length; Vt < Mi; Vt++)
              jt[Vt]._visited = !0;
          }
          function ie(Ht, jt) {
            var Vt = Ht._intersection, Mi = Vt, Li = [];
            jt && (I = [Ht]);
            function Ai(vi, ri) {
              for (; vi && vi !== ri; ) {
                var Nt = vi._segment, Di = Nt && Nt._path;
                if (Di) {
                  var li = Nt.getNext() || Di.getFirstSegment(), nn = li._intersection;
                  Nt !== Ht && (q(Nt) || q(li) || li && j(Nt) && (j(li) || nn && j(nn._segment))) && Li.push(Nt), jt && I.push(Nt);
                }
                vi = vi._next;
              }
            }
            if (Vt) {
              for (Ai(Vt); Vt && Vt._previous; )
                Vt = Vt._previous;
              Ai(Vt, Mi);
            }
            return Li;
          }
          k.sort(function(Ht, jt) {
            var Vt = Ht._intersection, Mi = jt._intersection, Li = !!(Vt && Vt._overlap), Ai = !!(Mi && Mi._overlap), vi = Ht._path, ri = jt._path;
            return Li ^ Ai ? Li ? 1 : -1 : !Vt ^ !Mi ? Vt ? 1 : -1 : vi !== ri ? vi._id - ri._id : Ht._index - jt._index;
          });
          for (var ae = 0, he = k.length; ae < he; ae++) {
            var pe = k[ae], se = j(pe), de = null, ve = !1, we = !0, Se = [], Ae, Ge, Je;
            if (se && pe._path._overlapsOnly) {
              var it = pe._path, gt = pe._intersection._segment._path;
              it.compare(gt) && (it.getArea() && C.push(it.clone(!1)), H(it), H(gt), se = !1);
            }
            for (; se; ) {
              var Ne = !de, Fe = ie(pe, Ne), st = Fe.shift(), ve = !Ne && (q(pe) || q(st)), _t = !ve && st;
              if (Ne && (de = new We(X.NO_INSERT), Ae = null), ve) {
                (pe.isFirst() || pe.isLast()) && (we = pe._path._closed), pe._visited = !0;
                break;
              }
              if (_t && Ae && (Se.push(Ae), Ae = null), Ae || (_t && Fe.push(pe), Ae = {
                start: de._segments.length,
                crossings: Fe,
                visited: Ge = [],
                handleIn: Je
              }), _t && (pe = st), !j(pe)) {
                de.removeSegments(Ae.start);
                for (var vt = 0, Rt = Ge.length; vt < Rt; vt++)
                  Ge[vt]._visited = !1;
                Ge.length = 0;
                do
                  pe = Ae && Ae.crossings.shift(), (!pe || !pe._path) && (pe = null, Ae = Se.pop(), Ae && (Ge = Ae.visited, Je = Ae.handleIn));
                while (Ae && !j(pe));
                if (!pe)
                  break;
              }
              var Et = pe.getNext();
              de.add(new ce(
                pe._point,
                Je,
                Et && pe._handleOut
              )), pe._visited = !0, Ge.push(pe), pe = Et || pe._path.getFirstSegment(), Je = Et && Et._handleIn;
            }
            ve && (we && (de.getFirstSegment().setHandleIn(Je), de.setClosed(we)), de.getArea() !== 0 && C.push(de));
          }
          return C;
        }
        return {
          _getWinding: function(k, z, C) {
            return G(k, this.getCurves(), z, C);
          },
          unite: function(k, z) {
            return y(this, k, "unite", z);
          },
          intersect: function(k, z) {
            return y(this, k, "intersect", z);
          },
          subtract: function(k, z) {
            return y(this, k, "subtract", z);
          },
          exclude: function(k, z) {
            return y(this, k, "exclude", z);
          },
          divide: function(k, z) {
            return z && (z.trace == !1 || z.stroke) ? S(this, k, "divide") : v([
              this.subtract(k, z),
              this.intersect(k, z)
            ], !0, this, k, z);
          },
          resolveCrossings: function() {
            var k = this._children, z = k || [this];
            function C(Ae, Ge) {
              var Je = Ae && Ae._intersection;
              return Je && Je._overlap && Je._path === Ge;
            }
            var I = !1, j = !1, q = this.getIntersections(null, function(Ae) {
              return Ae.hasOverlap() && (I = !0) || Ae.isCrossing() && (j = !0);
            }), H = I && j && [];
            if (q = ft.expand(q), I)
              for (var ie = T(q, function(Ae) {
                return Ae.hasOverlap();
              }, H), ae = ie.length - 1; ae >= 0; ae--) {
                var he = ie[ae], pe = he._path, se = he._segment, de = se.getPrevious(), ve = se.getNext();
                C(de, pe) && C(ve, pe) && (se.remove(), de._handleOut._set(0, 0), ve._handleIn._set(0, 0), de !== se && !de.getCurve().hasLength() && (ve._handleIn.set(de._handleIn), de.remove()));
              }
            j && (T(q, I && function(Ae) {
              var Ge = Ae.getCurve(), Je = Ae.getSegment(), it = Ae._intersection, gt = it._curve, Ne = it._segment;
              if (Ge && gt && Ge._path && gt._path)
                return !0;
              Je && (Je._intersection = null), Ne && (Ne._intersection = null);
            }, H), H && E(H), z = Y(o.each(z, function(Ae) {
              o.push(this, Ae._segments);
            }, [])));
            var we = z.length, Se;
            return we > 1 && k ? (z !== k && this.setChildren(z), Se = this) : we === 1 && !k && (z[0] !== this && this.setSegments(z[0].removeSegments()), Se = this), Se || (Se = new It(X.NO_INSERT), Se.addChildren(z), Se = Se.reduce(), Se.copyAttributes(this), this.replaceWith(Se)), Se;
          },
          reorient: function(k, z) {
            var C = this._children;
            return C && C.length ? this.setChildren(A(
              this.removeChildren(),
              function(I) {
                return !!(k ? I : I & 1);
              },
              z
            )) : z !== t && this.setClockwise(z), this;
          },
          getInteriorPoint: function() {
            var k = this.getBounds(), z = k.getCenter(!0);
            if (!this.contains(z)) {
              for (var C = this.getCurves(), I = z.y, j = [], q = [], H = 0, ie = C.length; H < ie; H++) {
                var ae = C[H].getValues(), he = ae[1], pe = ae[3], se = ae[5], de = ae[7];
                if (I >= i(he, pe, se, de) && I <= r(he, pe, se, de))
                  for (var ve = De.getMonoCurves(ae), we = 0, Se = ve.length; we < Se; we++) {
                    var Ae = ve[we], Ge = Ae[1], Je = Ae[7];
                    if (Ge !== Je && (I >= Ge && I <= Je || I >= Je && I <= Ge)) {
                      var it = I === Ge ? Ae[0] : I === Je ? Ae[6] : De.solveCubic(Ae, 1, I, q, 0, 1) === 1 ? De.getPoint(Ae, q[0]).x : (Ae[0] + Ae[6]) / 2;
                      j.push(it);
                    }
                  }
              }
              j.length > 1 && (j.sort(function(gt, Ne) {
                return gt - Ne;
              }), z.x = (j[0] + j[1]) / 2);
            }
            return z;
          }
        };
      }());
      var rt = o.extend(
        {
          _class: "PathFlattener",
          initialize: function(i, r, a, l, u) {
            var d = [], v = [], p = 0, y = 1 / (a || 32), S = i._segments, L = S[0], E;
            function A(Y, k) {
              var z = De.getValues(Y, k, u);
              d.push(z), T(z, Y._index, 0, 1);
            }
            function T(Y, k, z, C) {
              if (C - z > y && !(l && De.isStraight(Y)) && !De.isFlatEnough(Y, r || 0.25)) {
                var I = De.subdivide(Y, 0.5), j = (z + C) / 2;
                T(I[0], k, z, j), T(I[1], k, j, C);
              } else {
                var q = Y[6] - Y[0], H = Y[7] - Y[1], ie = Math.sqrt(q * q + H * H);
                ie > 0 && (p += ie, v.push({
                  offset: p,
                  curve: Y,
                  index: k,
                  time: C
                }));
              }
            }
            for (var G = 1, R = S.length; G < R; G++)
              E = S[G], A(L, E), L = E;
            i._closed && A(E || L, S[0]), this.curves = d, this.parts = v, this.length = p, this.index = 0;
          },
          _get: function(i) {
            for (var r = this.parts, a = r.length, l, u = this.index; l = u, !(!u || r[--u].offset < i); )
              ;
            for (; l < a; l++) {
              var d = r[l];
              if (d.offset >= i) {
                this.index = l;
                var v = r[l - 1], p = v && v.index === d.index ? v.time : 0, y = v ? v.offset : 0;
                return {
                  index: d.index,
                  time: p + (d.time - p) * (i - y) / (d.offset - y)
                };
              }
            }
            return {
              index: r[a - 1].index,
              time: 1
            };
          },
          drawPart: function(i, r, a) {
            for (var l = this._get(r), u = this._get(a), d = l.index, v = u.index; d <= v; d++) {
              var p = De.getPart(
                this.curves[d],
                d === l.index ? l.time : 0,
                d === u.index ? u.time : 1
              );
              d === l.index && i.moveTo(p[0], p[1]), i.bezierCurveTo.apply(i, p.slice(2));
            }
          }
        },
        o.each(
          De._evaluateMethods,
          function(i) {
            this[i + "At"] = function(r) {
              var a = this._get(r);
              return De[i](this.curves[a.index], a.time);
            };
          },
          {}
        )
      ), tt = o.extend({
        initialize: function(i) {
          for (var r = this.points = [], a = i._segments, l = i._closed, u = 0, d, v = a.length; u < v; u++) {
            var p = a[u].point;
            (!d || !d.equals(p)) && r.push(d = p.clone());
          }
          l && (r.unshift(r[r.length - 1]), r.push(r[1])), this.closed = l;
        },
        fit: function(i) {
          var r = this.points, a = r.length, l = null;
          return a > 0 && (l = [new ce(r[0])], a > 1 && (this.fitCubic(
            l,
            i,
            0,
            a - 1,
            r[1].subtract(r[0]),
            r[a - 2].subtract(r[a - 1])
          ), this.closed && (l.shift(), l.pop()))), l;
        },
        fitCubic: function(i, r, a, l, u, d) {
          var v = this.points;
          if (l - a === 1) {
            var p = v[a], y = v[l], S = p.getDistance(y) / 3;
            this.addCurve(i, [
              p,
              p.add(u.normalize(S)),
              y.add(d.normalize(S)),
              y
            ]);
            return;
          }
          for (var L = this.chordLengthParameterize(a, l), E = Math.max(r, r * r), A, T = !0, G = 0; G <= 4; G++) {
            var R = this.generateBezier(a, l, L, u, d), Y = this.findMaxError(a, l, R, L);
            if (Y.error < r && T) {
              this.addCurve(i, R);
              return;
            }
            if (A = Y.index, Y.error >= E)
              break;
            T = this.reparameterize(a, l, L, R), E = Y.error;
          }
          var k = v[A - 1].subtract(v[A + 1]);
          this.fitCubic(i, r, a, A, u, k), this.fitCubic(i, r, A, l, k.negate(), d);
        },
        addCurve: function(i, r) {
          var a = i[i.length - 1];
          a.setHandleOut(r[1].subtract(r[0])), i.push(new ce(r[3], r[2].subtract(r[3])));
        },
        generateBezier: function(i, r, a, l, u) {
          for (var d = 1e-12, v = Math.abs, p = this.points, y = p[i], S = p[r], L = [[0, 0], [0, 0]], E = [0, 0], A = 0, T = r - i + 1; A < T; A++) {
            var G = a[A], R = 1 - G, Y = 3 * G * R, k = R * R * R, z = Y * R, C = Y * G, I = G * G * G, j = l.normalize(z), q = u.normalize(C), H = p[i + A].subtract(y.multiply(k + z)).subtract(S.multiply(C + I));
            L[0][0] += j.dot(j), L[0][1] += j.dot(q), L[1][0] = L[0][1], L[1][1] += q.dot(q), E[0] += j.dot(H), E[1] += q.dot(H);
          }
          var ie = L[0][0] * L[1][1] - L[1][0] * L[0][1], ae, he;
          if (v(ie) > d) {
            var pe = L[0][0] * E[1] - L[1][0] * E[0], se = E[0] * L[1][1] - E[1] * L[0][1];
            ae = se / ie, he = pe / ie;
          } else {
            var de = L[0][0] + L[0][1], ve = L[1][0] + L[1][1];
            ae = he = v(de) > d ? E[0] / de : v(ve) > d ? E[1] / ve : 0;
          }
          var we = S.getDistance(y), Se = d * we, Ae, Ge;
          if (ae < Se || he < Se)
            ae = he = we / 3;
          else {
            var Je = S.subtract(y);
            Ae = l.normalize(ae), Ge = u.normalize(he), Ae.dot(Je) - Ge.dot(Je) > we * we && (ae = he = we / 3, Ae = Ge = null);
          }
          return [
            y,
            y.add(Ae || l.normalize(ae)),
            S.add(Ge || u.normalize(he)),
            S
          ];
        },
        reparameterize: function(i, r, a, l) {
          for (var u = i; u <= r; u++)
            a[u - i] = this.findRoot(l, this.points[u], a[u - i]);
          for (var u = 1, d = a.length; u < d; u++)
            if (a[u] <= a[u - 1])
              return !1;
          return !0;
        },
        findRoot: function(i, r, a) {
          for (var l = [], u = [], d = 0; d <= 2; d++)
            l[d] = i[d + 1].subtract(i[d]).multiply(3);
          for (var d = 0; d <= 1; d++)
            u[d] = l[d + 1].subtract(l[d]).multiply(2);
          var v = this.evaluate(3, i, a), p = this.evaluate(2, l, a), y = this.evaluate(1, u, a), S = v.subtract(r), L = p.dot(p) + S.dot(y);
          return P.isMachineZero(L) ? a : a - S.dot(p) / L;
        },
        evaluate: function(i, r, a) {
          for (var l = r.slice(), u = 1; u <= i; u++)
            for (var d = 0; d <= i - u; d++)
              l[d] = l[d].multiply(1 - a).add(l[d + 1].multiply(a));
          return l[0];
        },
        chordLengthParameterize: function(i, r) {
          for (var a = [0], l = i + 1; l <= r; l++)
            a[l - i] = a[l - i - 1] + this.points[l].getDistance(this.points[l - 1]);
          for (var l = 1, u = r - i; l <= u; l++)
            a[l] /= a[u];
          return a;
        },
        findMaxError: function(i, r, a, l) {
          for (var u = Math.floor((r - i + 1) / 2), d = 0, v = i + 1; v < r; v++) {
            var p = this.evaluate(3, a, l[v - i]), y = p.subtract(this.points[v]), S = y.x * y.x + y.y * y.y;
            S >= d && (d = S, u = v);
          }
          return {
            error: d,
            index: u
          };
        }
      }), Kt = X.extend({
        _class: "TextItem",
        _applyMatrix: !1,
        _canApplyMatrix: !1,
        _serializeFields: {
          content: null
        },
        _boundsOptions: { stroke: !1, handle: !1 },
        initialize: function(i) {
          this._content = "", this._lines = [];
          var r = i && o.isPlainObject(i) && i.x === t && i.y === t;
          this._initialize(r && i, !r && M.read(arguments));
        },
        _equals: function(i) {
          return this._content === i._content;
        },
        copyContent: function(i) {
          this.setContent(i._content);
        },
        getContent: function() {
          return this._content;
        },
        setContent: function(i) {
          this._content = "" + i, this._lines = this._content.split(/\r\n|\n|\r/mg), this._changed(521);
        },
        isEmpty: function() {
          return !this._content;
        },
        getCharacterStyle: "#getStyle",
        setCharacterStyle: "#setStyle",
        getParagraphStyle: "#getStyle",
        setParagraphStyle: "#setStyle"
      }), qt = Kt.extend({
        _class: "PointText",
        initialize: function() {
          Kt.apply(this, arguments);
        },
        getPoint: function() {
          var i = this._matrix.getTranslation();
          return new Z(i.x, i.y, this, "setPoint");
        },
        setPoint: function() {
          var i = M.read(arguments);
          this.translate(i.subtract(this._matrix.getTranslation()));
        },
        _draw: function(i, r, a) {
          if (this._content) {
            this._setStyles(i, r, a);
            var l = this._lines, u = this._style, d = u.hasFill(), v = u.hasStroke(), p = u.getLeading(), y = i.shadowColor;
            i.font = u.getFontStyle(), i.textAlign = u.getJustification();
            for (var S = 0, L = l.length; S < L; S++) {
              i.shadowColor = y;
              var E = l[S];
              d && (i.fillText(E, 0, 0), i.shadowColor = "rgba(0,0,0,0)"), v && i.strokeText(E, 0, 0), i.translate(0, p);
            }
          }
        },
        _getBounds: function(i, r) {
          var a = this._style, l = this._lines, u = l.length, d = a.getJustification(), v = a.getLeading(), p = this.getView().getTextWidth(a.getFontStyle(), l), y = 0;
          d !== "left" && (y -= p / (d === "center" ? 2 : 1));
          var S = new D(
            y,
            u ? -0.75 * v : 0,
            p,
            u * v
          );
          return i ? i._transformBounds(S, S) : S;
        }
      }), Lt = o.extend(
        new function() {
          var i = {
            gray: ["gray"],
            rgb: ["red", "green", "blue"],
            hsb: ["hue", "saturation", "brightness"],
            hsl: ["hue", "saturation", "lightness"],
            gradient: ["gradient", "origin", "destination", "highlight"]
          }, r = {}, a = {
            transparent: [0, 0, 0, 0]
          }, l;
          function u(p) {
            var y = p.match(
              /^#([\da-f]{2})([\da-f]{2})([\da-f]{2})([\da-f]{2})?$/i
            ) || p.match(
              /^#([\da-f])([\da-f])([\da-f])([\da-f])?$/i
            ), S = "rgb", L;
            if (y) {
              var E = y[4] ? 4 : 3;
              L = new Array(E);
              for (var A = 0; A < E; A++) {
                var T = y[A + 1];
                L[A] = parseInt(T.length == 1 ? T + T : T, 16) / 255;
              }
            } else if (y = p.match(/^(rgb|hsl)a?\((.*)\)$/)) {
              S = y[1], L = y[2].trim().split(/[,\s]+/g);
              for (var G = S === "hsl", A = 0, R = Math.min(L.length, 4); A < R; A++) {
                var Y = L[A], T = parseFloat(Y);
                if (G)
                  if (A === 0) {
                    var k = Y.match(/([a-z]*)$/)[1];
                    T *= {
                      turn: 360,
                      rad: 180 / Math.PI,
                      grad: 0.9
                    }[k] || 1;
                  } else
                    A < 3 && (T /= 100);
                else
                  A < 3 && (T /= /%$/.test(Y) ? 100 : 255);
                L[A] = T;
              }
            } else {
              var z = a[p];
              if (!z)
                if (n) {
                  l || (l = mt.getContext(1, 1, {
                    willReadFrequently: !0
                  }), l.globalCompositeOperation = "copy"), l.fillStyle = "rgba(0,0,0,0)", l.fillStyle = p, l.fillRect(0, 0, 1, 1);
                  var C = l.getImageData(0, 0, 1, 1).data;
                  z = a[p] = [
                    C[0] / 255,
                    C[1] / 255,
                    C[2] / 255
                  ];
                } else
                  z = [0, 0, 0];
              L = z.slice();
            }
            return [S, L];
          }
          var d = [
            [0, 3, 1],
            [2, 0, 1],
            [1, 0, 3],
            [1, 2, 0],
            [3, 1, 0],
            [0, 1, 2]
          ], v = {
            "rgb-hsb": function(p, y, S) {
              var L = Math.max(p, y, S), E = Math.min(p, y, S), A = L - E, T = A === 0 ? 0 : (L == p ? (y - S) / A + (y < S ? 6 : 0) : L == y ? (S - p) / A + 2 : (p - y) / A + 4) * 60;
              return [T, L === 0 ? 0 : A / L, L];
            },
            "hsb-rgb": function(p, y, S) {
              p = (p / 60 % 6 + 6) % 6;
              var E = Math.floor(p), L = p - E, E = d[E], A = [
                S,
                S * (1 - y),
                S * (1 - y * L),
                S * (1 - y * (1 - L))
              ];
              return [A[E[0]], A[E[1]], A[E[2]]];
            },
            "rgb-hsl": function(p, y, S) {
              var L = Math.max(p, y, S), E = Math.min(p, y, S), A = L - E, T = A === 0, G = T ? 0 : (L == p ? (y - S) / A + (y < S ? 6 : 0) : L == y ? (S - p) / A + 2 : (p - y) / A + 4) * 60, R = (L + E) / 2, Y = T ? 0 : R < 0.5 ? A / (L + E) : A / (2 - L - E);
              return [G, Y, R];
            },
            "hsl-rgb": function(p, y, S) {
              if (p = (p / 360 % 1 + 1) % 1, y === 0)
                return [S, S, S];
              for (var L = [p + 1 / 3, p, p - 1 / 3], E = S < 0.5 ? S * (1 + y) : S + y - S * y, A = 2 * S - E, T = [], G = 0; G < 3; G++) {
                var R = L[G];
                R < 0 && (R += 1), R > 1 && (R -= 1), T[G] = 6 * R < 1 ? A + (E - A) * 6 * R : 2 * R < 1 ? E : 3 * R < 2 ? A + (E - A) * (2 / 3 - R) * 6 : A;
              }
              return T;
            },
            "rgb-gray": function(p, y, S) {
              return [p * 0.2989 + y * 0.587 + S * 0.114];
            },
            "gray-rgb": function(p) {
              return [p, p, p];
            },
            "gray-hsb": function(p) {
              return [0, 0, p];
            },
            "gray-hsl": function(p) {
              return [0, 0, p];
            },
            "gradient-rgb": function() {
              return [];
            },
            "rgb-gradient": function() {
              return [];
            }
          };
          return o.each(i, function(p, y) {
            r[y] = [], o.each(p, function(S, L) {
              var E = o.capitalize(S), A = /^(hue|saturation)$/.test(S), T = r[y][L] = y === "gradient" ? S === "gradient" ? function(G) {
                var R = this._components[0];
                return G = Ci.read(
                  Array.isArray(G) ? G : arguments,
                  0,
                  { readNull: !0 }
                ), R !== G && (R && R._removeOwner(this), G && G._addOwner(this)), G;
              } : function() {
                return M.read(arguments, 0, {
                  readNull: S === "highlight",
                  clone: !0
                });
              } : function(G) {
                return G == null || isNaN(G) ? 0 : +G;
              };
              this["get" + E] = function() {
                return this._type === y || A && /^hs[bl]$/.test(this._type) ? this._components[L] : this._convert(y)[L];
              }, this["set" + E] = function(G) {
                this._type !== y && !(A && /^hs[bl]$/.test(this._type)) && (this._components = this._convert(y), this._properties = i[y], this._type = y), this._components[L] = T.call(this, G), this._changed();
              };
            }, this);
          }, {
            _class: "Color",
            _readIndex: !0,
            initialize: function p(y) {
              var S = arguments, L = this.__read, E = 0, A, T, G, R;
              Array.isArray(y) && (S = y, y = S[0]);
              var Y = y != null && typeof y;
              if (Y === "string" && y in i && (A = y, y = S[1], Array.isArray(y) ? (T = y, G = S[2]) : (L && (E = 1), S = o.slice(S, 1), Y = typeof y)), !T) {
                if (R = Y === "number" ? S : Y === "object" && y.length != null ? y : null, R) {
                  A || (A = R.length >= 3 ? "rgb" : "gray");
                  var k = i[A].length;
                  G = R[k], L && (E += R === arguments ? k + (G != null ? 1 : 0) : 1), R.length > k && (R = o.slice(R, 0, k));
                } else if (Y === "string") {
                  var z = u(y);
                  A = z[0], T = z[1], T.length === 4 && (G = T[3], T.length--);
                } else if (Y === "object")
                  if (y.constructor === p) {
                    if (A = y._type, T = y._components.slice(), G = y._alpha, A === "gradient")
                      for (var C = 1, I = T.length; C < I; C++) {
                        var j = T[C];
                        j && (T[C] = j.clone());
                      }
                  } else if (y.constructor === Ci)
                    A = "gradient", R = S;
                  else {
                    A = "hue" in y ? "lightness" in y ? "hsl" : "hsb" : "gradient" in y || "stops" in y || "radial" in y ? "gradient" : "gray" in y ? "gray" : "rgb";
                    var q = i[A], H = r[A];
                    this._components = T = [];
                    for (var C = 0, I = q.length; C < I; C++) {
                      var ie = y[q[C]];
                      ie == null && !C && A === "gradient" && "stops" in y && (ie = {
                        stops: y.stops,
                        radial: y.radial
                      }), ie = H[C].call(this, ie), ie != null && (T[C] = ie);
                    }
                    G = y.alpha;
                  }
                L && A && (E = 1);
              }
              if (this._type = A || "rgb", !T) {
                this._components = T = [];
                for (var H = r[this._type], C = 0, I = H.length; C < I; C++) {
                  var ie = H[C].call(this, R && R[C]);
                  ie != null && (T[C] = ie);
                }
              }
              return this._components = T, this._properties = i[this._type], this._alpha = G, L && (this.__read = E), this;
            },
            set: "#initialize",
            _serialize: function(p, y) {
              var S = this.getComponents();
              return o.serialize(
                /^(gray|rgb)$/.test(this._type) ? S : [this._type].concat(S),
                p,
                !0,
                y
              );
            },
            _changed: function() {
              this._canvasStyle = null, this._owner && (this._setter ? this._owner[this._setter](this) : this._owner._changed(129));
            },
            _convert: function(p) {
              var y;
              return this._type === p ? this._components.slice() : (y = v[this._type + "-" + p]) ? y.apply(this, this._components) : v["rgb-" + p].apply(
                this,
                v[this._type + "-rgb"].apply(
                  this,
                  this._components
                )
              );
            },
            convert: function(p) {
              return new Lt(p, this._convert(p), this._alpha);
            },
            getType: function() {
              return this._type;
            },
            setType: function(p) {
              this._components = this._convert(p), this._properties = i[p], this._type = p;
            },
            getComponents: function() {
              var p = this._components.slice();
              return this._alpha != null && p.push(this._alpha), p;
            },
            getAlpha: function() {
              return this._alpha != null ? this._alpha : 1;
            },
            setAlpha: function(p) {
              this._alpha = p == null ? null : Math.min(Math.max(p, 0), 1), this._changed();
            },
            hasAlpha: function() {
              return this._alpha != null;
            },
            equals: function(p) {
              var y = o.isPlainValue(p, !0) ? Lt.read(arguments) : p;
              return y === this || y && this._class === y._class && this._type === y._type && this.getAlpha() === y.getAlpha() && o.equals(this._components, y._components) || !1;
            },
            toString: function() {
              for (var p = this._properties, y = [], S = this._type === "gradient", L = B.instance, E = 0, A = p.length; E < A; E++) {
                var T = this._components[E];
                T != null && y.push(p[E] + ": " + (S ? T : L.number(T)));
              }
              return this._alpha != null && y.push("alpha: " + L.number(this._alpha)), "{ " + y.join(", ") + " }";
            },
            toCSS: function(p) {
              var y = this._convert("rgb"), S = p || this._alpha == null ? 1 : this._alpha;
              function L(E) {
                return Math.round((E < 0 ? 0 : E > 1 ? 1 : E) * 255);
              }
              return y = [
                L(y[0]),
                L(y[1]),
                L(y[2])
              ], S < 1 && y.push(S < 0 ? 0 : S), p ? "#" + ((1 << 24) + (y[0] << 16) + (y[1] << 8) + y[2]).toString(16).slice(1) : (y.length == 4 ? "rgba(" : "rgb(") + y.join(",") + ")";
            },
            toCanvasStyle: function(p, y) {
              if (this._canvasStyle)
                return this._canvasStyle;
              if (this._type !== "gradient")
                return this._canvasStyle = this.toCSS();
              var S = this._components, L = S[0], E = L._stops, A = S[1], T = S[2], G = S[3], R = y && y.inverted(), Y;
              if (R && (A = R._transformPoint(A), T = R._transformPoint(T), G && (G = R._transformPoint(G))), L._radial) {
                var k = T.getDistance(A);
                if (G) {
                  var z = G.subtract(A);
                  z.getLength() > k && (G = A.add(z.normalize(k - 0.1)));
                }
                var C = G || A;
                Y = p.createRadialGradient(
                  C.x,
                  C.y,
                  0,
                  A.x,
                  A.y,
                  k
                );
              } else
                Y = p.createLinearGradient(
                  A.x,
                  A.y,
                  T.x,
                  T.y
                );
              for (var I = 0, j = E.length; I < j; I++) {
                var q = E[I], H = q._offset;
                Y.addColorStop(
                  H ?? I / (j - 1),
                  q._color.toCanvasStyle()
                );
              }
              return this._canvasStyle = Y;
            },
            transform: function(p) {
              if (this._type === "gradient") {
                for (var y = this._components, S = 1, L = y.length; S < L; S++) {
                  var E = y[S];
                  p._transformPoint(E, E, !0);
                }
                this._changed();
              }
            },
            statics: {
              _types: i,
              random: function() {
                var p = Math.random;
                return new Lt(p(), p(), p());
              },
              _setOwner: function(p, y, S) {
                return p && (p._owner && y && p._owner !== y && (p = p.clone()), !p._owner ^ !y && (p._owner = y || null, p._setter = S || null)), p;
              }
            }
          });
        }(),
        new function() {
          var i = {
            add: function(r, a) {
              return r + a;
            },
            subtract: function(r, a) {
              return r - a;
            },
            multiply: function(r, a) {
              return r * a;
            },
            divide: function(r, a) {
              return r / a;
            }
          };
          return o.each(i, function(r, a) {
            this[a] = function(l) {
              l = Lt.read(arguments);
              for (var u = this._type, d = this._components, v = l._convert(u), p = 0, y = d.length; p < y; p++)
                v[p] = r(d[p], v[p]);
              return new Lt(
                u,
                v,
                this._alpha != null ? r(this._alpha, l.getAlpha()) : null
              );
            };
          }, {});
        }()
      ), Ci = o.extend({
        _class: "Gradient",
        initialize: function(i, r) {
          this._id = U.get(), i && o.isPlainObject(i) && (this.set(i), i = r = null), this._stops == null && this.setStops(i || ["white", "black"]), this._radial == null && this.setRadial(typeof r == "string" && r === "radial" || r || !1);
        },
        _serialize: function(i, r) {
          return r.add(this, function() {
            return o.serialize(
              [this._stops, this._radial],
              i,
              !0,
              r
            );
          });
        },
        _changed: function() {
          for (var i = 0, r = this._owners && this._owners.length; i < r; i++)
            this._owners[i]._changed();
        },
        _addOwner: function(i) {
          this._owners || (this._owners = []), this._owners.push(i);
        },
        _removeOwner: function(i) {
          var r = this._owners ? this._owners.indexOf(i) : -1;
          r != -1 && (this._owners.splice(r, 1), this._owners.length || (this._owners = t));
        },
        clone: function() {
          for (var i = [], r = 0, a = this._stops.length; r < a; r++)
            i[r] = this._stops[r].clone();
          return new Ci(i, this._radial);
        },
        getStops: function() {
          return this._stops;
        },
        setStops: function(i) {
          if (i.length < 2)
            throw new Error(
              "Gradient stop list needs to contain at least two stops."
            );
          var r = this._stops;
          if (r)
            for (var a = 0, l = r.length; a < l; a++)
              r[a]._owner = t;
          r = this._stops = ji.readList(i, 0, { clone: !0 });
          for (var a = 0, l = r.length; a < l; a++)
            r[a]._owner = this;
          this._changed();
        },
        getRadial: function() {
          return this._radial;
        },
        setRadial: function(i) {
          this._radial = i, this._changed();
        },
        equals: function(i) {
          if (i === this)
            return !0;
          if (i && this._class === i._class) {
            var r = this._stops, a = i._stops, l = r.length;
            if (l === a.length) {
              for (var u = 0; u < l; u++)
                if (!r[u].equals(a[u]))
                  return !1;
              return !0;
            }
          }
          return !1;
        }
      }), ji = o.extend({
        _class: "GradientStop",
        initialize: function(i, r) {
          var a = i, l = r;
          typeof i == "object" && r === t && (Array.isArray(i) && typeof i[0] != "number" ? (a = i[0], l = i[1]) : ("color" in i || "offset" in i || "rampPoint" in i) && (a = i.color, l = i.offset || i.rampPoint || 0)), this.setColor(a), this.setOffset(l);
        },
        clone: function() {
          return new ji(this._color.clone(), this._offset);
        },
        _serialize: function(i, r) {
          var a = this._color, l = this._offset;
          return o.serialize(
            l == null ? [a] : [a, l],
            i,
            !0,
            r
          );
        },
        _changed: function() {
          this._owner && this._owner._changed(129);
        },
        getOffset: function() {
          return this._offset;
        },
        setOffset: function(i) {
          this._offset = i, this._changed();
        },
        getRampPoint: "#getOffset",
        setRampPoint: "#setOffset",
        getColor: function() {
          return this._color;
        },
        setColor: function() {
          Lt._setOwner(this._color, null), this._color = Lt._setOwner(
            Lt.read(arguments, 0),
            this,
            "setColor"
          ), this._changed();
        },
        equals: function(i) {
          return i === this || i && this._class === i._class && this._color.equals(i._color) && this._offset == i._offset || !1;
        }
      }), _i = o.extend(new function() {
        var i = {
          fillColor: null,
          fillRule: "nonzero",
          strokeColor: null,
          strokeWidth: 1,
          strokeCap: "butt",
          strokeJoin: "miter",
          strokeScaling: !0,
          miterLimit: 10,
          dashOffset: 0,
          dashArray: [],
          shadowColor: null,
          shadowBlur: 0,
          shadowOffset: new M(),
          selectedColor: null
        }, r = o.set({}, i, {
          fontFamily: "sans-serif",
          fontWeight: "normal",
          fontSize: 12,
          leading: null,
          justification: "left"
        }), a = o.set({}, r, {
          fillColor: new Lt()
        }), l = {
          strokeWidth: 193,
          strokeCap: 193,
          strokeJoin: 193,
          strokeScaling: 201,
          miterLimit: 193,
          fontFamily: 9,
          fontWeight: 9,
          fontSize: 9,
          font: 9,
          leading: 9,
          justification: 9
        }, u = {
          beans: !0
        }, d = {
          _class: "Style",
          beans: !0,
          initialize: function(v, p, y) {
            this._values = {}, this._owner = p, this._project = p && p._project || y || He.project, this._defaults = !p || p instanceof W ? r : p instanceof Kt ? a : i, v && this.set(v);
          }
        };
        return o.each(r, function(v, p) {
          var y = /Color$/.test(p), S = p === "shadowOffset", L = o.capitalize(p), E = l[p], A = "set" + L, T = "get" + L;
          d[A] = function(G) {
            var R = this._owner, Y = R && R._children, k = Y && Y.length > 0 && !(R instanceof It);
            if (k)
              for (var z = 0, C = Y.length; z < C; z++)
                Y[z]._style[A](G);
            if ((p === "selectedColor" || !k) && p in this._defaults) {
              var I = this._values[p];
              I !== G && (y && (I && (Lt._setOwner(I, null), I._canvasStyle = null), G && G.constructor === Lt && (G = Lt._setOwner(
                G,
                R,
                k && A
              ))), this._values[p] = G, R && R._changed(E || 129));
            }
          }, d[T] = function(G) {
            var R = this._owner, Y = R && R._children, k = Y && Y.length > 0 && !(R instanceof It), z;
            if (k && !G)
              for (var C = 0, I = Y.length; C < I; C++) {
                var j = Y[C]._style[T]();
                if (!C)
                  z = j;
                else if (!o.equals(z, j))
                  return t;
              }
            else if (p in this._defaults) {
              var z = this._values[p];
              if (z === t)
                z = this._defaults[p], z && z.clone && (z = z.clone());
              else {
                var q = y ? Lt : S ? M : null;
                q && !(z && z.constructor === q) && (this._values[p] = z = q.read(
                  [z],
                  0,
                  { readNull: !0, clone: !0 }
                ));
              }
            }
            return z && y && (z = Lt._setOwner(z, R, k && A)), z;
          }, u[T] = function(G) {
            return this._style[T](G);
          }, u[A] = function(G) {
            this._style[A](G);
          };
        }), o.each({
          Font: "FontFamily",
          WindingRule: "FillRule"
        }, function(v, p) {
          var y = "get" + p, S = "set" + p;
          d[y] = u[y] = "#get" + v, d[S] = u[S] = "#set" + v;
        }), X.inject(u), d;
      }(), {
        set: function(i) {
          var r = i instanceof _i, a = r ? i._values : i;
          if (a) {
            for (var l in a)
              if (l in this._defaults) {
                var u = a[l];
                this[l] = u && r && u.clone ? u.clone() : u;
              }
          }
        },
        equals: function(i) {
          function r(a, l, u) {
            var d = a._values, v = l._values, p = l._defaults;
            for (var y in d) {
              var S = d[y], L = v[y];
              if (!(u && y in v) && !o.equals(
                S,
                L === t ? p[y] : L
              ))
                return !1;
            }
            return !0;
          }
          return i === this || i && this._class === i._class && r(this, i) && r(i, this, !0) || !1;
        },
        _dispose: function() {
          var i;
          i = this.getFillColor(), i && (i._canvasStyle = null), i = this.getStrokeColor(), i && (i._canvasStyle = null), i = this.getShadowColor(), i && (i._canvasStyle = null);
        },
        hasFill: function() {
          var i = this.getFillColor();
          return !!i && i.alpha > 0;
        },
        hasStroke: function() {
          var i = this.getStrokeColor();
          return !!i && i.alpha > 0 && this.getStrokeWidth() > 0;
        },
        hasShadow: function() {
          var i = this.getShadowColor();
          return !!i && i.alpha > 0 && (this.getShadowBlur() > 0 || !this.getShadowOffset().isZero());
        },
        getView: function() {
          return this._project._view;
        },
        getFontStyle: function() {
          var i = this.getFontSize();
          return this.getFontWeight() + " " + i + (/[a-z]/i.test(i + "") ? " " : "px ") + this.getFontFamily();
        },
        getFont: "#getFontFamily",
        setFont: "#setFontFamily",
        getLeading: function i() {
          var r = i.base.call(this), a = this.getFontSize();
          return /pt|em|%|px/.test(a) && (a = this.getView().getPixelSize(a)), r ?? a * 1.2;
        }
      }), Wt = new function() {
        function i(r, a, l, u) {
          for (var d = ["", "webkit", "moz", "Moz", "ms", "o"], v = a[0].toUpperCase() + a.substring(1), p = 0; p < 6; p++) {
            var y = d[p], S = y ? y + v : a;
            if (S in r) {
              if (l)
                r[S] = u;
              else
                return r[S];
              break;
            }
          }
        }
        return {
          getStyles: function(r) {
            var a = r && r.nodeType !== 9 ? r.ownerDocument : r, l = a && a.defaultView;
            return l && l.getComputedStyle(r, "");
          },
          getBounds: function(r, a) {
            var l = r.ownerDocument, u = l.body, d = l.documentElement, v;
            try {
              v = r.getBoundingClientRect();
            } catch {
              v = { left: 0, top: 0, width: 0, height: 0 };
            }
            var p = v.left - (d.clientLeft || u.clientLeft || 0), y = v.top - (d.clientTop || u.clientTop || 0);
            if (!a) {
              var S = l.defaultView;
              p += S.pageXOffset || d.scrollLeft || u.scrollLeft, y += S.pageYOffset || d.scrollTop || u.scrollTop;
            }
            return new D(p, y, v.width, v.height);
          },
          getViewportBounds: function(r) {
            var a = r.ownerDocument, l = a.defaultView, u = a.documentElement;
            return new D(
              0,
              0,
              l.innerWidth || u.clientWidth,
              l.innerHeight || u.clientHeight
            );
          },
          getOffset: function(r, a) {
            return Wt.getBounds(r, a).getPoint();
          },
          getSize: function(r) {
            return Wt.getBounds(r, !0).getSize();
          },
          isInvisible: function(r) {
            return Wt.getSize(r).equals(new F(0, 0));
          },
          isInView: function(r) {
            return !Wt.isInvisible(r) && Wt.getViewportBounds(r).intersects(
              Wt.getBounds(r, !0)
            );
          },
          isInserted: function(r) {
            return s.body.contains(r);
          },
          getPrefixed: function(r, a) {
            return r && i(r, a);
          },
          setPrefixed: function(r, a, l) {
            if (typeof a == "object")
              for (var u in a)
                i(r, u, !0, a[u]);
            else
              i(r, a, !0, l);
          }
        };
      }(), $t = {
        add: function(i, r) {
          if (i)
            for (var a in r)
              for (var l = r[a], u = a.split(/[\s,]+/g), d = 0, v = u.length; d < v; d++) {
                var p = u[d], y = i === s && (p === "touchstart" || p === "touchmove") ? { passive: !1 } : !1;
                i.addEventListener(p, l, y);
              }
        },
        remove: function(i, r) {
          if (i)
            for (var a in r)
              for (var l = r[a], u = a.split(/[\s,]+/g), d = 0, v = u.length; d < v; d++)
                i.removeEventListener(u[d], l, !1);
        },
        getPoint: function(i) {
          var r = i.targetTouches ? i.targetTouches.length ? i.targetTouches[0] : i.changedTouches[0] : i;
          return new M(
            r.pageX || r.clientX + s.documentElement.scrollLeft,
            r.pageY || r.clientY + s.documentElement.scrollTop
          );
        },
        getTarget: function(i) {
          return i.target || i.srcElement;
        },
        getRelatedTarget: function(i) {
          return i.relatedTarget || i.toElement;
        },
        getOffset: function(i, r) {
          return $t.getPoint(i).subtract(Wt.getOffset(
            r || $t.getTarget(i)
          ));
        }
      };
      $t.requestAnimationFrame = new function() {
        var i = Wt.getPrefixed(n, "requestAnimationFrame"), r = !1, a = [], l;
        function u() {
          var d = a;
          a = [];
          for (var v = 0, p = d.length; v < p; v++)
            d[v]();
          r = i && a.length, r && i(u);
        }
        return function(d) {
          a.push(d), i ? r || (i(u), r = !0) : l || (l = setInterval(u, 1e3 / 60));
        };
      }();
      var ei = o.extend(
        h,
        {
          _class: "View",
          initialize: function i(r, a) {
            function l(E) {
              return a[E] || parseInt(a.getAttribute(E), 10);
            }
            function u() {
              var E = Wt.getSize(a);
              return E.isNaN() || E.isZero() ? new F(l("width"), l("height")) : E;
            }
            var d;
            if (n && a) {
              this._id = a.getAttribute("id"), this._id == null && a.setAttribute("id", this._id = "paper-view-" + i._id++), $t.add(a, this._viewEvents);
              var v = "none";
              if (Wt.setPrefixed(a.style, {
                userDrag: v,
                userSelect: v,
                touchCallout: v,
                contentZooming: v,
                tapHighlightColor: "rgba(0,0,0,0)"
              }), c.hasAttribute(a, "resize")) {
                var p = this;
                $t.add(n, this._windowEvents = {
                  resize: function() {
                    p.setViewSize(u());
                  }
                });
              }
              if (d = u(), c.hasAttribute(a, "stats") && typeof Stats < "u") {
                this._stats = new Stats();
                var y = this._stats.domElement, S = y.style, L = Wt.getOffset(a);
                S.position = "absolute", S.left = L.x + "px", S.top = L.y + "px", s.body.appendChild(y);
              }
            } else
              d = new F(a), a = null;
            this._project = r, this._scope = r._scope, this._element = a, this._pixelRatio || (this._pixelRatio = n && n.devicePixelRatio || 1), this._setElementSize(d.width, d.height), this._viewSize = d, i._views.push(this), i._viewsById[this._id] = this, (this._matrix = new ee())._owner = this, i._focused || (i._focused = this), this._frameItems = {}, this._frameItemCount = 0, this._itemEvents = { native: {}, virtual: {} }, this._autoUpdate = !He.agent.node, this._needsUpdate = !1;
          },
          remove: function() {
            if (!this._project)
              return !1;
            ei._focused === this && (ei._focused = null), ei._views.splice(ei._views.indexOf(this), 1), delete ei._viewsById[this._id];
            var i = this._project;
            return i._view === this && (i._view = null), $t.remove(this._element, this._viewEvents), $t.remove(n, this._windowEvents), this._element = this._project = null, this.off("frame"), this._animate = !1, this._frameItems = {}, !0;
          },
          _events: o.each(
            X._itemHandlers.concat(["onResize", "onKeyDown", "onKeyUp"]),
            function(i) {
              this[i] = {};
            },
            {
              onFrame: {
                install: function() {
                  this.play();
                },
                uninstall: function() {
                  this.pause();
                }
              }
            }
          ),
          _animate: !1,
          _time: 0,
          _count: 0,
          getAutoUpdate: function() {
            return this._autoUpdate;
          },
          setAutoUpdate: function(i) {
            this._autoUpdate = i, i && this.requestUpdate();
          },
          update: function() {
          },
          draw: function() {
            this.update();
          },
          requestUpdate: function() {
            if (!this._requested) {
              var i = this;
              $t.requestAnimationFrame(function() {
                if (i._requested = !1, i._animate) {
                  i.requestUpdate();
                  var r = i._element;
                  (!Wt.getPrefixed(s, "hidden") || c.getAttribute(r, "keepalive") === "true") && Wt.isInView(r) && i._handleFrame();
                }
                i._autoUpdate && i.update();
              }), this._requested = !0;
            }
          },
          play: function() {
            this._animate = !0, this.requestUpdate();
          },
          pause: function() {
            this._animate = !1;
          },
          _handleFrame: function() {
            He = this._scope;
            var i = Date.now() / 1e3, r = this._last ? i - this._last : 0;
            this._last = i, this.emit("frame", new o({
              delta: r,
              time: this._time += r,
              count: this._count++
            })), this._stats && this._stats.update();
          },
          _animateItem: function(i, r) {
            var a = this._frameItems;
            r ? (a[i._id] = {
              item: i,
              time: 0,
              count: 0
            }, ++this._frameItemCount === 1 && this.on("frame", this._handleFrameItems)) : (delete a[i._id], --this._frameItemCount === 0 && this.off("frame", this._handleFrameItems));
          },
          _handleFrameItems: function(i) {
            for (var r in this._frameItems) {
              var a = this._frameItems[r];
              a.item.emit("frame", new o(i, {
                time: a.time += i.delta,
                count: a.count++
              }));
            }
          },
          _changed: function() {
            this._project._changed(4097), this._bounds = this._decomposed = t;
          },
          getElement: function() {
            return this._element;
          },
          getPixelRatio: function() {
            return this._pixelRatio;
          },
          getResolution: function() {
            return this._pixelRatio * 72;
          },
          getViewSize: function() {
            var i = this._viewSize;
            return new Q(i.width, i.height, this, "setViewSize");
          },
          setViewSize: function() {
            var i = F.read(arguments), r = i.subtract(this._viewSize);
            r.isZero() || (this._setElementSize(i.width, i.height), this._viewSize.set(i), this._changed(), this.emit("resize", { size: i, delta: r }), this._autoUpdate && this.update());
          },
          _setElementSize: function(i, r) {
            var a = this._element;
            a && (a.width !== i && (a.width = i), a.height !== r && (a.height = r));
          },
          getBounds: function() {
            return this._bounds || (this._bounds = this._matrix.inverted()._transformBounds(
              new D(new M(), this._viewSize)
            )), this._bounds;
          },
          getSize: function() {
            return this.getBounds().getSize();
          },
          isVisible: function() {
            return Wt.isInView(this._element);
          },
          isInserted: function() {
            return Wt.isInserted(this._element);
          },
          getPixelSize: function(i) {
            var r = this._element, a;
            if (r) {
              var l = r.parentNode, u = s.createElement("div");
              u.style.fontSize = i, l.appendChild(u), a = parseFloat(Wt.getStyles(u).fontSize), l.removeChild(u);
            } else
              a = parseFloat(a);
            return a;
          },
          getTextWidth: function(i, r) {
            return 0;
          }
        },
        o.each(["rotate", "scale", "shear", "skew"], function(i) {
          var r = i === "rotate";
          this[i] = function() {
            var a = arguments, l = (r ? o : M).read(a), u = M.read(a, 0, { readNull: !0 });
            return this.transform(new ee()[i](
              l,
              u || this.getCenter(!0)
            ));
          };
        }, {
          _decompose: function() {
            return this._decomposed || (this._decomposed = this._matrix.decompose());
          },
          translate: function() {
            var i = new ee();
            return this.transform(i.translate.apply(i, arguments));
          },
          getCenter: function() {
            return this.getBounds().getCenter();
          },
          setCenter: function() {
            var i = M.read(arguments);
            this.translate(this.getCenter().subtract(i));
          },
          getZoom: function() {
            var i = this._decompose().scaling;
            return (i.x + i.y) / 2;
          },
          setZoom: function(i) {
            this.transform(new ee().scale(
              i / this.getZoom(),
              this.getCenter()
            ));
          },
          getRotation: function() {
            return this._decompose().rotation;
          },
          setRotation: function(i) {
            var r = this.getRotation();
            r != null && i != null && this.rotate(i - r);
          },
          getScaling: function() {
            var i = this._decompose().scaling;
            return new Z(i.x, i.y, this, "setScaling");
          },
          setScaling: function() {
            var i = this.getScaling(), r = M.read(arguments, 0, { clone: !0, readNull: !0 });
            i && r && this.scale(r.x / i.x, r.y / i.y);
          },
          getMatrix: function() {
            return this._matrix;
          },
          setMatrix: function() {
            var i = this._matrix;
            i.set.apply(i, arguments);
          },
          transform: function(i) {
            this._matrix.append(i);
          },
          scrollBy: function() {
            this.translate(M.read(arguments).negate());
          }
        }),
        {
          projectToView: function() {
            return this._matrix._transformPoint(M.read(arguments));
          },
          viewToProject: function() {
            return this._matrix._inverseTransform(M.read(arguments));
          },
          getEventPoint: function(i) {
            return this.viewToProject($t.getOffset(i, this._element));
          }
        },
        {
          statics: {
            _views: [],
            _viewsById: {},
            _id: 0,
            create: function(i, r) {
              s && typeof r == "string" && (r = s.getElementById(r));
              var a = n ? tn : ei;
              return new a(i, r);
            }
          }
        },
        new function() {
          if (!n)
            return;
          var i, r, a = !1, l = !1;
          function u(se) {
            var de = $t.getTarget(se);
            return de.getAttribute && ei._viewsById[de.getAttribute("id")];
          }
          function d() {
            var se = ei._focused;
            if (!se || !se.isVisible()) {
              for (var de = 0, ve = ei._views.length; de < ve; de++)
                if ((se = ei._views[de]).isVisible()) {
                  ei._focused = r = se;
                  break;
                }
            }
          }
          function v(se, de, ve) {
            se._handleMouseEvent("mousemove", de, ve);
          }
          var p = n.navigator, y, S, L;
          p.pointerEnabled || p.msPointerEnabled ? (y = "pointerdown MSPointerDown", S = "pointermove MSPointerMove", L = "pointerup pointercancel MSPointerUp MSPointerCancel") : (y = "touchstart", S = "touchmove", L = "touchend touchcancel", "ontouchstart" in n && p.userAgent.match(
            /mobile|tablet|ip(ad|hone|od)|android|silk/i
          ) || (y += " mousedown", S += " mousemove", L += " mouseup"));
          var E = {}, A = {
            mouseout: function(se) {
              var de = ei._focused, ve = $t.getRelatedTarget(se);
              if (de && (!ve || ve.nodeName === "HTML")) {
                var we = $t.getOffset(se, de._element), Se = we.x, Ae = Math.abs, Ge = Ae(Se), Je = 1 << 25, it = Ge - Je;
                we.x = Ae(it) < Ge ? it * (Se < 0 ? -1 : 1) : Se, v(de, se, de.viewToProject(we));
              }
            },
            scroll: d
          };
          E[y] = function(se) {
            var de = ei._focused = u(se);
            a || (a = !0, de._handleMouseEvent("mousedown", se));
          }, A[S] = function(se) {
            var de = ei._focused;
            if (!l) {
              var ve = u(se);
              ve ? de !== ve && (de && v(de, se), i || (i = de), de = ei._focused = r = ve) : r && r === de && (i && !i.isInserted() && (i = null), de = ei._focused = i, i = null, d());
            }
            de && v(de, se);
          }, A[y] = function() {
            l = !0;
          }, A[L] = function(se) {
            var de = ei._focused;
            de && a && de._handleMouseEvent("mouseup", se), l = a = !1;
          }, $t.add(s, A), $t.add(n, {
            load: d
          });
          var T = !1, G = !1, R = {
            doubleclick: "click",
            mousedrag: "mousemove"
          }, Y = !1, k, z, C, I, j, q, H, ie;
          function ae(se, de, ve, we, Se, Ae, Ge) {
            var Je = !1, it;
            function gt(Ne, Fe) {
              if (Ne.responds(Fe)) {
                if (it || (it = new yt(
                  Fe,
                  we,
                  Se,
                  de || Ne,
                  Ae ? Se.subtract(Ae) : null
                )), Ne.emit(Fe, it) && (T = !0, it.prevented && (G = !0), it.stopped))
                  return Je = !0;
              } else {
                var st = R[Fe];
                if (st)
                  return gt(Ne, st);
              }
            }
            for (; se && se !== Ge && !gt(se, ve); )
              se = se._parent;
            return Je;
          }
          function he(se, de, ve, we, Se, Ae) {
            return se._project.removeOn(ve), G = T = !1, j && ae(
              j,
              null,
              ve,
              we,
              Se,
              Ae
            ) || de && de !== j && !de.isDescendant(j) && ae(de, null, ve === "mousedrag" ? "mousemove" : ve, we, Se, Ae, j) || ae(
              se,
              j || de || se,
              ve,
              we,
              Se,
              Ae
            );
          }
          var pe = {
            mousedown: {
              mousedown: 1,
              mousedrag: 1,
              click: 1,
              doubleclick: 1
            },
            mouseup: {
              mouseup: 1,
              mousedrag: 1,
              click: 1,
              doubleclick: 1
            },
            mousemove: {
              mousedrag: 1,
              mousemove: 1,
              mouseenter: 1,
              mouseleave: 1
            }
          };
          return {
            _viewEvents: E,
            _handleMouseEvent: function(se, de, ve) {
              var we = this._itemEvents, Se = we.native[se], Ae = se === "mousemove", Ge = this._scope.tool, Je = this;
              function it(Rt) {
                return we.virtual[Rt] || Je.responds(Rt) || Ge && Ge.responds(Rt);
              }
              Ae && a && it("mousedrag") && (se = "mousedrag"), ve || (ve = this.getEventPoint(de));
              var gt = this.getBounds().contains(ve), Ne = Se && gt && Je._project.hitTest(ve, {
                tolerance: 0,
                fill: !0,
                stroke: !0
              }), Fe = Ne && Ne.item || null, st = !1, _t = {};
              if (_t[se.substr(5)] = !0, Se && Fe !== I && (I && ae(I, null, "mouseleave", de, ve), Fe && ae(Fe, null, "mouseenter", de, ve), I = Fe), Y ^ gt && (ae(
                this,
                null,
                gt ? "mouseenter" : "mouseleave",
                de,
                ve
              ), st = !0), (gt || _t.drag) && !ve.equals(z) && (he(
                this,
                Fe,
                Ae ? se : "mousemove",
                de,
                ve,
                z
              ), st = !0), Y = gt, _t.down && gt || _t.up && k) {
                if (he(this, Fe, se, de, ve, k), _t.down) {
                  if (ie = Fe === q && Date.now() - H < 300, C = q = Fe, !G && Fe) {
                    for (var vt = Fe; vt && !vt.responds("mousedrag"); )
                      vt = vt._parent;
                    vt && (j = Fe);
                  }
                  k = ve;
                } else
                  _t.up && (!G && Fe === C && (H = Date.now(), he(this, Fe, ie ? "doubleclick" : "click", de, ve, k), ie = !1), C = j = null);
                Y = !1, st = !0;
              }
              z = ve, st && Ge && (T = Ge._handleMouseEvent(se, de, ve, _t) || T), de.cancelable !== !1 && (T && !_t.move || _t.down && it("mouseup")) && de.preventDefault();
            },
            _handleKeyEvent: function(se, de, ve, we) {
              var Se = this._scope, Ae = Se.tool, Ge;
              function Je(it) {
                it.responds(se) && (He = Se, it.emit(se, Ge = Ge || new _e(se, de, ve, we)));
              }
              this.isVisible() && (Je(this), Ae && Ae.responds(se) && Je(Ae));
            },
            _countItemEvent: function(se, de) {
              var ve = this._itemEvents, we = ve.native, Se = ve.virtual;
              for (var Ae in pe)
                we[Ae] = (we[Ae] || 0) + (pe[Ae][se] || 0) * de;
              Se[se] = (Se[se] || 0) + de;
            },
            statics: {
              updateFocus: d,
              _resetState: function() {
                a = l = T = Y = !1, i = r = k = z = C = I = j = q = H = ie = null;
              }
            }
          };
        }()
      ), tn = ei.extend({
        _class: "CanvasView",
        initialize: function(i, r) {
          if (!(r instanceof n.HTMLCanvasElement)) {
            var a = F.read(arguments, 1);
            if (a.isZero())
              throw new Error(
                "Cannot create CanvasView with the provided argument: " + o.slice(arguments, 1)
              );
            r = mt.getCanvas(a);
          }
          var l = this._context = r.getContext("2d");
          if (l.save(), this._pixelRatio = 1, !/^off|false$/.test(c.getAttribute(r, "hidpi"))) {
            var u = n.devicePixelRatio || 1, d = Wt.getPrefixed(
              l,
              "backingStorePixelRatio"
            ) || 1;
            this._pixelRatio = u / d;
          }
          ei.call(this, i, r), this._needsUpdate = !0;
        },
        remove: function i() {
          return this._context.restore(), i.base.call(this);
        },
        _setElementSize: function i(r, a) {
          var l = this._pixelRatio;
          if (i.base.call(this, r * l, a * l), l !== 1) {
            var u = this._element, d = this._context;
            if (!c.hasAttribute(u, "resize")) {
              var v = u.style;
              v.width = r + "px", v.height = a + "px";
            }
            d.restore(), d.save(), d.scale(l, l);
          }
        },
        getContext: function() {
          return this._context;
        },
        getPixelSize: function i(r) {
          var a = He.agent, l;
          if (a && a.firefox)
            l = i.base.call(this, r);
          else {
            var u = this._context, d = u.font;
            u.font = r + " serif", l = parseFloat(u.font), u.font = d;
          }
          return l;
        },
        getTextWidth: function(i, r) {
          var a = this._context, l = a.font, u = 0;
          a.font = i;
          for (var d = 0, v = r.length; d < v; d++)
            u = Math.max(u, a.measureText(r[d]).width);
          return a.font = l, u;
        },
        update: function() {
          if (!this._needsUpdate)
            return !1;
          var i = this._project, r = this._context, a = this._viewSize;
          return r.clearRect(0, 0, a.width + 1, a.height + 1), i && i.draw(r, this._matrix, this._pixelRatio), this._needsUpdate = !1, !0;
        }
      }), Fi = o.extend({
        _class: "Event",
        initialize: function(i) {
          this.event = i, this.type = i && i.type;
        },
        prevented: !1,
        stopped: !1,
        preventDefault: function() {
          this.prevented = !0, this.event.preventDefault();
        },
        stopPropagation: function() {
          this.stopped = !0, this.event.stopPropagation();
        },
        stop: function() {
          this.stopPropagation(), this.preventDefault();
        },
        getTimeStamp: function() {
          return this.event.timeStamp;
        },
        getModifiers: function() {
          return Ct.modifiers;
        }
      }), _e = Fi.extend({
        _class: "KeyEvent",
        initialize: function(i, r, a, l) {
          this.type = i, this.event = r, this.key = a, this.character = l;
        },
        toString: function() {
          return "{ type: '" + this.type + "', key: '" + this.key + "', character: '" + this.character + "', modifiers: " + this.getModifiers() + " }";
        }
      }), Ct = new function() {
        var i = {
          "	": "tab",
          " ": "space",
          "\b": "backspace",
          "": "delete",
          Spacebar: "space",
          Del: "delete",
          Win: "meta",
          Esc: "escape"
        }, r = {
          tab: "	",
          space: " ",
          enter: "\r"
        }, a = {}, l = {}, u, d, v = new o({
          shift: !1,
          control: !1,
          alt: !1,
          meta: !1,
          capsLock: !1,
          space: !1
        }).inject({
          option: {
            get: function() {
              return this.alt;
            }
          },
          command: {
            get: function() {
              var S = He && He.agent;
              return S && S.mac ? this.meta : this.control;
            }
          }
        });
        function p(S) {
          var L = S.key || S.keyIdentifier;
          return L = /^U\+/.test(L) ? String.fromCharCode(parseInt(L.substr(2), 16)) : /^Arrow[A-Z]/.test(L) ? L.substr(5) : L === "Unidentified" || L === t ? String.fromCharCode(S.keyCode) : L, i[L] || (L.length > 1 ? o.hyphenate(L) : L.toLowerCase());
        }
        function y(S, L, E, A) {
          var T = ei._focused, G;
          if (a[L] = S, S ? l[L] = E : delete l[L], L.length > 1 && (G = o.camelize(L)) in v) {
            v[G] = S;
            var R = He && He.agent;
            if (G === "meta" && R && R.mac)
              if (S)
                u = {};
              else {
                for (var Y in u)
                  Y in l && y(!1, Y, u[Y], A);
                u = null;
              }
          } else
            S && u && (u[L] = E);
          T && T._handleKeyEvent(
            S ? "keydown" : "keyup",
            A,
            L,
            E
          );
        }
        return $t.add(s, {
          keydown: function(S) {
            var L = p(S), E = He && He.agent;
            L.length > 1 || E && E.chrome && (S.altKey || E.mac && S.metaKey || !E.mac && S.ctrlKey) ? y(
              !0,
              L,
              r[L] || (L.length > 1 ? "" : L),
              S
            ) : d = L;
          },
          keypress: function(S) {
            if (d) {
              var L = p(S), E = S.charCode, A = E >= 32 ? String.fromCharCode(E) : L.length > 1 ? "" : L;
              L !== d && (L = A.toLowerCase()), y(!0, L, A, S), d = null;
            }
          },
          keyup: function(S) {
            var L = p(S);
            L in l && y(!1, L, l[L], S);
          }
        }), $t.add(n, {
          blur: function(S) {
            for (var L in l)
              y(!1, L, l[L], S);
          }
        }), {
          modifiers: v,
          isDown: function(S) {
            return !!a[S];
          }
        };
      }(), yt = Fi.extend({
        _class: "MouseEvent",
        initialize: function(i, r, a, l, u) {
          this.type = i, this.event = r, this.point = a, this.target = l, this.delta = u;
        },
        toString: function() {
          return "{ type: '" + this.type + "', point: " + this.point + ", target: " + this.target + (this.delta ? ", delta: " + this.delta : "") + ", modifiers: " + this.getModifiers() + " }";
        }
      }), Re = Fi.extend({
        _class: "ToolEvent",
        _item: null,
        initialize: function(i, r, a) {
          this.tool = i, this.type = r, this.event = a;
        },
        _choosePoint: function(i, r) {
          return i || (r ? r.clone() : null);
        },
        getPoint: function() {
          return this._choosePoint(this._point, this.tool._point);
        },
        setPoint: function(i) {
          this._point = i;
        },
        getLastPoint: function() {
          return this._choosePoint(this._lastPoint, this.tool._lastPoint);
        },
        setLastPoint: function(i) {
          this._lastPoint = i;
        },
        getDownPoint: function() {
          return this._choosePoint(this._downPoint, this.tool._downPoint);
        },
        setDownPoint: function(i) {
          this._downPoint = i;
        },
        getMiddlePoint: function() {
          return !this._middlePoint && this.tool._lastPoint ? this.tool._point.add(this.tool._lastPoint).divide(2) : this._middlePoint;
        },
        setMiddlePoint: function(i) {
          this._middlePoint = i;
        },
        getDelta: function() {
          return !this._delta && this.tool._lastPoint ? this.tool._point.subtract(this.tool._lastPoint) : this._delta;
        },
        setDelta: function(i) {
          this._delta = i;
        },
        getCount: function() {
          return this.tool[/^mouse(down|up)$/.test(this.type) ? "_downCount" : "_moveCount"];
        },
        setCount: function(i) {
          this.tool[/^mouse(down|up)$/.test(this.type) ? "downCount" : "count"] = i;
        },
        getItem: function() {
          if (!this._item) {
            var i = this.tool._scope.project.hitTest(this.getPoint());
            if (i) {
              for (var r = i.item, a = r._parent; /^(Group|CompoundPath)$/.test(a._class); )
                r = a, a = a._parent;
              this._item = r;
            }
          }
          return this._item;
        },
        setItem: function(i) {
          this._item = i;
        },
        toString: function() {
          return "{ type: " + this.type + ", point: " + this.getPoint() + ", count: " + this.getCount() + ", modifiers: " + this.getModifiers() + " }";
        }
      }), Ee = _.extend({
        _class: "Tool",
        _list: "tools",
        _reference: "tool",
        _events: [
          "onMouseDown",
          "onMouseUp",
          "onMouseDrag",
          "onMouseMove",
          "onActivate",
          "onDeactivate",
          "onEditOptions",
          "onKeyDown",
          "onKeyUp"
        ],
        initialize: function(i) {
          _.call(this), this._moveCount = -1, this._downCount = -1, this.set(i);
        },
        getMinDistance: function() {
          return this._minDistance;
        },
        setMinDistance: function(i) {
          this._minDistance = i, i != null && this._maxDistance != null && i > this._maxDistance && (this._maxDistance = i);
        },
        getMaxDistance: function() {
          return this._maxDistance;
        },
        setMaxDistance: function(i) {
          this._maxDistance = i, this._minDistance != null && i != null && i < this._minDistance && (this._minDistance = i);
        },
        getFixedDistance: function() {
          return this._minDistance == this._maxDistance ? this._minDistance : null;
        },
        setFixedDistance: function(i) {
          this._minDistance = this._maxDistance = i;
        },
        _handleMouseEvent: function(i, r, a, l) {
          He = this._scope, l.drag && !this.responds(i) && (i = "mousemove");
          var u = l.move || l.drag, d = this.responds(i), v = !1, p = this;
          function y(L, E) {
            var A = a, T = u ? p._point : p._downPoint || A;
            if (u) {
              if (p._moveCount >= 0 && A.equals(T))
                return !1;
              if (T && (L != null || E != null)) {
                var G = A.subtract(T), R = G.getLength();
                if (R < (L || 0))
                  return !1;
                E && (A = T.add(G.normalize(
                  Math.min(R, E)
                )));
              }
              p._moveCount++;
            }
            return p._point = A, p._lastPoint = T || A, l.down && (p._moveCount = -1, p._downPoint = A, p._downCount++), !0;
          }
          function S() {
            d && (v = p.emit(i, new Re(p, i, r)) || v);
          }
          if (l.down)
            y(), S();
          else if (l.up)
            y(null, this._maxDistance), S();
          else if (d)
            for (; y(this._minDistance, this._maxDistance); )
              S();
          return v;
        }
      }), et = o.extend(h, {
        _class: "Tween",
        statics: {
          easings: new o({
            linear: function(i) {
              return i;
            },
            easeInQuad: function(i) {
              return i * i;
            },
            easeOutQuad: function(i) {
              return i * (2 - i);
            },
            easeInOutQuad: function(i) {
              return i < 0.5 ? 2 * i * i : -1 + 2 * (2 - i) * i;
            },
            easeInCubic: function(i) {
              return i * i * i;
            },
            easeOutCubic: function(i) {
              return --i * i * i + 1;
            },
            easeInOutCubic: function(i) {
              return i < 0.5 ? 4 * i * i * i : (i - 1) * (2 * i - 2) * (2 * i - 2) + 1;
            },
            easeInQuart: function(i) {
              return i * i * i * i;
            },
            easeOutQuart: function(i) {
              return 1 - --i * i * i * i;
            },
            easeInOutQuart: function(i) {
              return i < 0.5 ? 8 * i * i * i * i : 1 - 8 * --i * i * i * i;
            },
            easeInQuint: function(i) {
              return i * i * i * i * i;
            },
            easeOutQuint: function(i) {
              return 1 + --i * i * i * i * i;
            },
            easeInOutQuint: function(i) {
              return i < 0.5 ? 16 * i * i * i * i * i : 1 + 16 * --i * i * i * i * i;
            }
          })
        },
        initialize: function i(r, a, l, u, d, v) {
          this.object = r;
          var p = typeof d, y = p === "function";
          this.type = y ? p : p === "string" ? d : "linear", this.easing = y ? d : i.easings[this.type], this.duration = u, this.running = !1, this._then = null, this._startTime = null;
          var S = a || l;
          this._keys = S ? Object.keys(S) : [], this._parsedKeys = this._parseKeys(this._keys), this._from = S && this._getState(a), this._to = S && this._getState(l), v !== !1 && this.start();
        },
        then: function(i) {
          return this._then = i, this;
        },
        start: function() {
          return this._startTime = null, this.running = !0, this;
        },
        stop: function() {
          return this.running = !1, this;
        },
        update: function(i) {
          if (this.running) {
            i >= 1 && (i = 1, this.running = !1);
            for (var r = this.easing(i), a = this._keys, l = function(L) {
              return typeof L == "function" ? L(r, i) : L;
            }, u = 0, d = a && a.length; u < d; u++) {
              var v = a[u], p = l(this._from[v]), y = l(this._to[v]), S = p && y && p.__add && y.__add ? y.__subtract(p).__multiply(r).__add(p) : (y - p) * r + p;
              this._setProperty(this._parsedKeys[v], S);
            }
            this.responds("update") && this.emit("update", new o({
              progress: i,
              factor: r
            })), !this.running && this._then && this._then(this.object);
          }
          return this;
        },
        _events: {
          onUpdate: {}
        },
        _handleFrame: function(i) {
          var r = this._startTime, a = r ? (i - r) / this.duration : 0;
          r || (this._startTime = i), this.update(a);
        },
        _getState: function(i) {
          for (var r = this._keys, a = {}, l = 0, u = r.length; l < u; l++) {
            var d = r[l], v = this._parsedKeys[d], p = this._getProperty(v), y;
            if (i) {
              var S = this._resolveValue(p, i[d]);
              this._setProperty(v, S), y = this._getProperty(v), y = y && y.clone ? y.clone() : y, this._setProperty(v, p);
            } else
              y = p && p.clone ? p.clone() : p;
            a[d] = y;
          }
          return a;
        },
        _resolveValue: function(i, r) {
          if (r) {
            if (Array.isArray(r) && r.length === 2) {
              var a = r[0];
              return a && a.match && a.match(/^[+\-\*\/]=/) ? this._calculate(i, a[0], r[1]) : r;
            } else if (typeof r == "string") {
              var l = r.match(/^[+\-*/]=(.*)/);
              if (l) {
                var u = JSON.parse(l[1].replace(
                  /(['"])?([a-zA-Z0-9_]+)(['"])?:/g,
                  '"$2": '
                ));
                return this._calculate(i, r[0], u);
              }
            }
          }
          return r;
        },
        _calculate: function(i, r, a) {
          return He.PaperScript.calculateBinary(i, r, a);
        },
        _parseKeys: function(i) {
          for (var r = {}, a = 0, l = i.length; a < l; a++) {
            var u = i[a], d = u.replace(/\.([^.]*)/g, "/$1").replace(/\[['"]?([^'"\]]*)['"]?\]/g, "/$1");
            r[u] = d.split("/");
          }
          return r;
        },
        _getProperty: function(i, r) {
          for (var a = this.object, l = 0, u = i.length - (r || 0); l < u && a; l++)
            a = a[i[l]];
          return a;
        },
        _setProperty: function(i, r) {
          var a = this._getProperty(i, 1);
          a && (a[i[i.length - 1]] = r);
        }
      }), kt = {
        request: function(i) {
          var r = new e.XMLHttpRequest();
          return r.open(
            (i.method || "get").toUpperCase(),
            i.url,
            o.pick(i.async, !0)
          ), i.mimeType && r.overrideMimeType(i.mimeType), r.onload = function() {
            var a = r.status;
            a === 0 || a === 200 ? i.onLoad && i.onLoad.call(r, r.responseText) : r.onerror();
          }, r.onerror = function() {
            var a = r.status, l = 'Could not load "' + i.url + '" (Status: ' + a + ")";
            if (i.onError)
              i.onError(l, a);
            else
              throw new Error(l);
          }, r.send(null);
        }
      }, mt = o.exports.CanvasProvider = {
        canvases: [],
        getCanvas: function(i, r, a) {
          if (!n)
            return null;
          var l, u = !0;
          typeof i == "object" && (r = i.height, i = i.width), this.canvases.length ? l = this.canvases.pop() : (l = s.createElement("canvas"), u = !1);
          var d = l.getContext("2d", a || {});
          if (!d)
            throw new Error("Canvas " + l + " is unable to provide a 2D context.");
          return l.width === i && l.height === r ? u && d.clearRect(0, 0, i + 1, r + 1) : (l.width = i, l.height = r), d.save(), l;
        },
        getContext: function(i, r, a) {
          var l = this.getCanvas(i, r, a);
          return l ? l.getContext("2d", a || {}) : null;
        },
        release: function(i) {
          var r = i && i.canvas ? i.canvas : i;
          r && r.getContext && (r.getContext("2d").restore(), this.canvases.push(r));
        }
      }, Qe = new function() {
        var i = Math.min, r = Math.max, a = Math.abs, l, u, d, v, p, y, S, L, E, A, T;
        function G(j, q, H) {
          return 0.2989 * j + 0.587 * q + 0.114 * H;
        }
        function R(j, q, H, he) {
          var ae = he - G(j, q, H);
          E = j + ae, A = q + ae, T = H + ae;
          var he = G(E, A, T), pe = i(E, A, T), se = r(E, A, T);
          if (pe < 0) {
            var de = he - pe;
            E = he + (E - he) * he / de, A = he + (A - he) * he / de, T = he + (T - he) * he / de;
          }
          if (se > 255) {
            var ve = 255 - he, we = se - he;
            E = he + (E - he) * ve / we, A = he + (A - he) * ve / we, T = he + (T - he) * ve / we;
          }
        }
        function Y(j, q, H) {
          return r(j, q, H) - i(j, q, H);
        }
        function k(j, q, H, ie) {
          var ae = [j, q, H], he = r(j, q, H), pe = i(j, q, H), se;
          pe = pe === j ? 0 : pe === q ? 1 : 2, he = he === j ? 0 : he === q ? 1 : 2, se = i(pe, he) === 0 ? r(pe, he) === 1 ? 2 : 1 : 0, ae[he] > ae[pe] ? (ae[se] = (ae[se] - ae[pe]) * ie / (ae[he] - ae[pe]), ae[he] = ie) : ae[se] = ae[he] = 0, ae[pe] = 0, E = ae[0], A = ae[1], T = ae[2];
        }
        var z = {
          multiply: function() {
            E = p * l / 255, A = y * u / 255, T = S * d / 255;
          },
          screen: function() {
            E = p + l - p * l / 255, A = y + u - y * u / 255, T = S + d - S * d / 255;
          },
          overlay: function() {
            E = p < 128 ? 2 * p * l / 255 : 255 - 2 * (255 - p) * (255 - l) / 255, A = y < 128 ? 2 * y * u / 255 : 255 - 2 * (255 - y) * (255 - u) / 255, T = S < 128 ? 2 * S * d / 255 : 255 - 2 * (255 - S) * (255 - d) / 255;
          },
          "soft-light": function() {
            var j = l * p / 255;
            E = j + p * (255 - (255 - p) * (255 - l) / 255 - j) / 255, j = u * y / 255, A = j + y * (255 - (255 - y) * (255 - u) / 255 - j) / 255, j = d * S / 255, T = j + S * (255 - (255 - S) * (255 - d) / 255 - j) / 255;
          },
          "hard-light": function() {
            E = l < 128 ? 2 * l * p / 255 : 255 - 2 * (255 - l) * (255 - p) / 255, A = u < 128 ? 2 * u * y / 255 : 255 - 2 * (255 - u) * (255 - y) / 255, T = d < 128 ? 2 * d * S / 255 : 255 - 2 * (255 - d) * (255 - S) / 255;
          },
          "color-dodge": function() {
            E = p === 0 ? 0 : l === 255 ? 255 : i(255, 255 * p / (255 - l)), A = y === 0 ? 0 : u === 255 ? 255 : i(255, 255 * y / (255 - u)), T = S === 0 ? 0 : d === 255 ? 255 : i(255, 255 * S / (255 - d));
          },
          "color-burn": function() {
            E = p === 255 ? 255 : l === 0 ? 0 : r(0, 255 - (255 - p) * 255 / l), A = y === 255 ? 255 : u === 0 ? 0 : r(0, 255 - (255 - y) * 255 / u), T = S === 255 ? 255 : d === 0 ? 0 : r(0, 255 - (255 - S) * 255 / d);
          },
          darken: function() {
            E = p < l ? p : l, A = y < u ? y : u, T = S < d ? S : d;
          },
          lighten: function() {
            E = p > l ? p : l, A = y > u ? y : u, T = S > d ? S : d;
          },
          difference: function() {
            E = p - l, E < 0 && (E = -E), A = y - u, A < 0 && (A = -A), T = S - d, T < 0 && (T = -T);
          },
          exclusion: function() {
            E = p + l * (255 - p - p) / 255, A = y + u * (255 - y - y) / 255, T = S + d * (255 - S - S) / 255;
          },
          hue: function() {
            k(l, u, d, Y(p, y, S)), R(E, A, T, G(p, y, S));
          },
          saturation: function() {
            k(p, y, S, Y(l, u, d)), R(E, A, T, G(p, y, S));
          },
          luminosity: function() {
            R(p, y, S, G(l, u, d));
          },
          color: function() {
            R(l, u, d, G(p, y, S));
          },
          add: function() {
            E = i(p + l, 255), A = i(y + u, 255), T = i(S + d, 255);
          },
          subtract: function() {
            E = r(p - l, 0), A = r(y - u, 0), T = r(S - d, 0);
          },
          average: function() {
            E = (p + l) / 2, A = (y + u) / 2, T = (S + d) / 2;
          },
          negation: function() {
            E = 255 - a(255 - l - p), A = 255 - a(255 - u - y), T = 255 - a(255 - d - S);
          }
        }, C = this.nativeModes = o.each([
          "source-over",
          "source-in",
          "source-out",
          "source-atop",
          "destination-over",
          "destination-in",
          "destination-out",
          "destination-atop",
          "lighter",
          "darker",
          "copy",
          "xor"
        ], function(j) {
          this[j] = !0;
        }, {}), I = mt.getContext(1, 1, { willReadFrequently: !0 });
        I && (o.each(z, function(j, q) {
          var H = q === "darken", ie = !1;
          I.save();
          try {
            I.fillStyle = H ? "#300" : "#a00", I.fillRect(0, 0, 1, 1), I.globalCompositeOperation = q, I.globalCompositeOperation === q && (I.fillStyle = H ? "#a00" : "#300", I.fillRect(0, 0, 1, 1), ie = I.getImageData(0, 0, 1, 1).data[0] !== H ? 170 : 51);
          } catch {
          }
          I.restore(), C[q] = ie;
        }), mt.release(I)), this.process = function(j, q, H, ie, ae) {
          var he = q.canvas, pe = j === "normal";
          if (pe || C[j])
            H.save(), H.setTransform(1, 0, 0, 1, 0, 0), H.globalAlpha = ie, pe || (H.globalCompositeOperation = j), H.drawImage(he, ae.x, ae.y), H.restore();
          else {
            var se = z[j];
            if (!se)
              return;
            for (var de = H.getImageData(
              ae.x,
              ae.y,
              he.width,
              he.height
            ), ve = de.data, we = q.getImageData(
              0,
              0,
              he.width,
              he.height
            ).data, Se = 0, Ae = ve.length; Se < Ae; Se += 4) {
              l = we[Se], p = ve[Se], u = we[Se + 1], y = ve[Se + 1], d = we[Se + 2], S = ve[Se + 2], v = we[Se + 3], L = ve[Se + 3], se();
              var Ge = v * ie / 255, Je = 1 - Ge;
              ve[Se] = Ge * E + Je * p, ve[Se + 1] = Ge * A + Je * y, ve[Se + 2] = Ge * T + Je * S, ve[Se + 3] = v * ie + Je * L;
            }
            H.putImageData(de, ae.x, ae.y);
          }
        };
      }(), bt = new function() {
        var i = "http://www.w3.org/2000/svg", r = "http://www.w3.org/2000/xmlns", a = "http://www.w3.org/1999/xlink", l = {
          href: a,
          xlink: r,
          xmlns: r + "/",
          "xmlns:xlink": r + "/"
        };
        function u(p, y, S) {
          return v(s.createElementNS(i, p), y, S);
        }
        function d(p, y) {
          var S = l[y], L = S ? p.getAttributeNS(S, y) : p.getAttribute(y);
          return L === "null" ? null : L;
        }
        function v(p, y, S) {
          for (var L in y) {
            var E = y[L], A = l[L];
            typeof E == "number" && S && (E = S.number(E)), A ? p.setAttributeNS(A, L, E) : p.setAttribute(L, E);
          }
          return p;
        }
        return {
          svg: i,
          xmlns: r,
          xlink: a,
          create: u,
          get: d,
          set: v
        };
      }(), Gt = o.each({
        fillColor: ["fill", "color"],
        fillRule: ["fill-rule", "string"],
        strokeColor: ["stroke", "color"],
        strokeWidth: ["stroke-width", "number"],
        strokeCap: ["stroke-linecap", "string"],
        strokeJoin: ["stroke-linejoin", "string"],
        strokeScaling: ["vector-effect", "lookup", {
          true: "none",
          false: "non-scaling-stroke"
        }, function(i, r) {
          return !r && (i instanceof Yt || i instanceof ke || i instanceof Kt);
        }],
        miterLimit: ["stroke-miterlimit", "number"],
        dashArray: ["stroke-dasharray", "array"],
        dashOffset: ["stroke-dashoffset", "number"],
        fontFamily: ["font-family", "string"],
        fontWeight: ["font-weight", "string"],
        fontSize: ["font-size", "number"],
        justification: ["text-anchor", "lookup", {
          left: "start",
          center: "middle",
          right: "end"
        }],
        opacity: ["opacity", "number"],
        blendMode: ["mix-blend-mode", "style"]
      }, function(i, r) {
        var a = o.capitalize(r), l = i[2];
        this[r] = {
          type: i[1],
          property: r,
          attribute: i[0],
          toSVG: l,
          fromSVG: l && o.each(l, function(u, d) {
            this[u] = d;
          }, {}),
          exportFilter: i[3],
          get: "get" + a,
          set: "set" + a
        };
      }, {});
      new function() {
        var i;
        function r(z, C, I) {
          var j = new o(), q = z.getTranslation();
          if (C) {
            var H;
            z.isInvertible() ? (z = z._shiftless(), H = z._inverseTransform(q), q = null) : H = new M(), j[I ? "cx" : "x"] = H.x, j[I ? "cy" : "y"] = H.y;
          }
          if (!z.isIdentity()) {
            var ie = z.decompose();
            if (ie) {
              var ae = [], he = ie.rotation, pe = ie.scaling, se = ie.skewing;
              q && !q.isZero() && ae.push("translate(" + i.point(q) + ")"), he && ae.push("rotate(" + i.number(he) + ")"), (!P.isZero(pe.x - 1) || !P.isZero(pe.y - 1)) && ae.push("scale(" + i.point(pe) + ")"), se.x && ae.push("skewX(" + i.number(se.x) + ")"), se.y && ae.push("skewY(" + i.number(se.y) + ")"), j.transform = ae.join(" ");
            } else
              j.transform = "matrix(" + z.getValues().join(",") + ")";
          }
          return j;
        }
        function a(z, C) {
          for (var I = r(z._matrix), j = z._children, q = bt.create("g", I, i), H = 0, ie = j.length; H < ie; H++) {
            var ae = j[H], he = Y(ae, C);
            if (he)
              if (ae.isClipMask()) {
                var pe = bt.create("clipPath");
                pe.appendChild(he), G(ae, pe, "clip"), bt.set(q, {
                  "clip-path": "url(#" + pe.id + ")"
                });
              } else
                q.appendChild(he);
          }
          return q;
        }
        function l(z, C) {
          var I = r(z._matrix, !0), j = z.getSize(), q = z.getImage();
          return I.x -= j.width / 2, I.y -= j.height / 2, I.width = j.width, I.height = j.height, I.href = C.embedImages == !1 && q && q.src || z.toDataURL(), bt.create("image", I, i);
        }
        function u(z, C) {
          var I = C.matchShapes;
          if (I) {
            var j = z.toShape(!1);
            if (j)
              return d(j);
          }
          var q = z._segments, H = q.length, ie, ae = r(z._matrix);
          if (I && H >= 2 && !z.hasHandles())
            if (H > 2) {
              ie = z._closed ? "polygon" : "polyline";
              for (var he = [], pe = 0; pe < H; pe++)
                he.push(i.point(q[pe]._point));
              ae.points = he.join(" ");
            } else {
              ie = "line";
              var se = q[0]._point, de = q[1]._point;
              ae.set({
                x1: se.x,
                y1: se.y,
                x2: de.x,
                y2: de.y
              });
            }
          else
            ie = "path", ae.d = z.getPathData(null, C.precision);
          return bt.create(ie, ae, i);
        }
        function d(z) {
          var C = z._type, I = z._radius, j = r(z._matrix, !0, C !== "rectangle");
          if (C === "rectangle") {
            C = "rect";
            var q = z._size, H = q.width, ie = q.height;
            j.x -= H / 2, j.y -= ie / 2, j.width = H, j.height = ie, I.isZero() && (I = null);
          }
          return I && (C === "circle" ? j.r = I : (j.rx = I.width, j.ry = I.height)), bt.create(C, j, i);
        }
        function v(z, C) {
          var I = r(z._matrix), j = z.getPathData(null, C.precision);
          return j && (I.d = j), bt.create("path", I, i);
        }
        function p(z, C) {
          var I = r(z._matrix, !0), j = z._definition, q = T(j, "symbol"), H = j._item, ie = H.getStrokeBounds();
          return q || (q = bt.create("symbol", {
            viewBox: i.rectangle(ie)
          }), q.appendChild(Y(H, C)), G(j, q, "symbol")), I.href = "#" + q.id, I.x += ie.x, I.y += ie.y, I.width = ie.width, I.height = ie.height, I.overflow = "visible", bt.create("use", I, i);
        }
        function y(z) {
          var C = T(z, "color");
          if (!C) {
            var I = z.getGradient(), j = I._radial, q = z.getOrigin(), H = z.getDestination(), ie;
            if (j) {
              ie = {
                cx: q.x,
                cy: q.y,
                r: q.getDistance(H)
              };
              var ae = z.getHighlight();
              ae && (ie.fx = ae.x, ie.fy = ae.y);
            } else
              ie = {
                x1: q.x,
                y1: q.y,
                x2: H.x,
                y2: H.y
              };
            ie.gradientUnits = "userSpaceOnUse", C = bt.create((j ? "radial" : "linear") + "Gradient", ie, i);
            for (var he = I._stops, pe = 0, se = he.length; pe < se; pe++) {
              var de = he[pe], ve = de._color, we = ve.getAlpha(), Se = de._offset;
              ie = {
                offset: Se ?? pe / (se - 1)
              }, ve && (ie["stop-color"] = ve.toCSS(!0)), we < 1 && (ie["stop-opacity"] = we), C.appendChild(
                bt.create("stop", ie, i)
              );
            }
            G(z, C, "color");
          }
          return "url(#" + C.id + ")";
        }
        function S(z) {
          var C = bt.create(
            "text",
            r(z._matrix, !0),
            i
          );
          return C.textContent = z._content, C;
        }
        var L = {
          Group: a,
          Layer: a,
          Raster: l,
          Path: u,
          Shape: d,
          CompoundPath: v,
          SymbolItem: p,
          PointText: S
        };
        function E(z, C, I, j) {
          var q = {}, H = !j && z.getParent(), ie = [];
          return z._name != null && (q.id = z._name), o.each(Gt, function(ae) {
            var he = ae.get, pe = ae.type, se = z[he]();
            if (ae.exportFilter ? ae.exportFilter(z, se) : I.reduceAttributes == !1 || !H || !o.equals(H[he](), se)) {
              if (pe === "color" && se != null) {
                var de = se.getAlpha();
                de < 1 && (q[ae.attribute + "-opacity"] = de);
              }
              pe === "style" ? ie.push(ae.attribute + ": " + se) : q[ae.attribute] = se == null ? "none" : pe === "color" ? se.gradient ? y(se) : se.toCSS(!0) : pe === "array" ? se.join(",") : pe === "lookup" ? ae.toSVG[se] : se;
            }
          }), ie.length && (q.style = ie.join(";")), q.opacity === 1 && delete q.opacity, z._visible || (q.visibility = "hidden"), bt.set(C, q, i);
        }
        var A;
        function T(z, C) {
          return A || (A = { ids: {}, svgs: {} }), z && A.svgs[C + "-" + (z._id || z.__id || (z.__id = U.get("svg")))];
        }
        function G(z, C, I) {
          A || T();
          var j = A.ids[I] = (A.ids[I] || 0) + 1;
          C.id = I + "-" + j, A.svgs[I + "-" + (z._id || z.__id)] = C;
        }
        function R(z, C) {
          var I = z, j = null;
          if (A) {
            I = z.nodeName.toLowerCase() === "svg" && z;
            for (var q in A.svgs)
              j || (I || (I = bt.create("svg"), I.appendChild(z)), j = I.insertBefore(
                bt.create("defs"),
                I.firstChild
              )), j.appendChild(A.svgs[q]);
            A = null;
          }
          return C.asString ? new e.XMLSerializer().serializeToString(I) : I;
        }
        function Y(z, C, I) {
          var j = L[z._class], q = j && j(z, C);
          if (q) {
            var H = C.onExport;
            H && (q = H(z, q, C) || q);
            var ie = JSON.stringify(z._data);
            ie && ie !== "{}" && ie !== "null" && q.setAttribute("data-paper-data", ie);
          }
          return q && E(z, q, C, I);
        }
        function k(z) {
          return z || (z = {}), i = new B(z.precision), z;
        }
        X.inject({
          exportSVG: function(z) {
            return z = k(z), R(Y(this, z, !0), z);
          }
        }), fe.inject({
          exportSVG: function(z) {
            z = k(z);
            var C = this._children, I = this.getView(), j = o.pick(z.bounds, "view"), q = z.matrix || j === "view" && I._matrix, H = q && ee.read([q]), ie = j === "view" ? new D([0, 0], I.getViewSize()) : j === "content" ? X._getBounds(C, H, { stroke: !0 }).rect : D.read([j], 0, { readNull: !0 }), ae = {
              version: "1.1",
              xmlns: bt.svg,
              "xmlns:xlink": bt.xlink
            };
            ie && (ae.width = ie.width, ae.height = ie.height, (ie.x || ie.x === 0 || ie.y || ie.y === 0) && (ae.viewBox = i.rectangle(ie)));
            var he = bt.create("svg", ae, i), pe = he;
            H && !H.isIdentity() && (pe = he.appendChild(bt.create(
              "g",
              r(H),
              i
            )));
            for (var se = 0, de = C.length; se < de; se++)
              pe.appendChild(Y(C[se], z, !0));
            return R(he, z);
          }
        });
      }(), new function() {
        var i = {}, r;
        function a(C, I, j, q, H, ie) {
          var ae = bt.get(C, I) || ie, he = ae == null ? q ? null : j ? "" : 0 : j ? ae : parseFloat(ae);
          return /%\s*$/.test(ae) ? he / 100 * (H ? 1 : r[/x|^width/.test(I) ? "width" : "height"]) : he;
        }
        function l(C, I, j, q, H, ie, ae) {
          return I = a(C, I || "x", !1, q, H, ie), j = a(C, j || "y", !1, q, H, ae), q && (I == null || j == null) ? null : new M(I, j);
        }
        function u(C, I, j, q, H) {
          return I = a(C, I || "width", !1, q, H), j = a(C, j || "height", !1, q, H), q && (I == null || j == null) ? null : new F(I, j);
        }
        function d(C, I, j) {
          return C === "none" ? null : I === "number" ? parseFloat(C) : I === "array" ? C ? C.split(/[\s,]+/g).map(parseFloat) : [] : I === "color" ? Y(C) || C : I === "lookup" ? j[C] : C;
        }
        function v(C, I, j, q) {
          var H = C.childNodes, ie = I === "clippath", ae = I === "defs", he = new W(), pe = he._project, se = pe._currentStyle, de = [];
          if (!ie && !ae && (he = R(he, C, q), pe._currentStyle = he._style.clone()), q)
            for (var ve = C.querySelectorAll("defs"), we = 0, Se = ve.length; we < Se; we++)
              k(ve[we], j, !1);
          for (var we = 0, Se = H.length; we < Se; we++) {
            var Ae = H[we], Ge;
            Ae.nodeType === 1 && !/^defs$/i.test(Ae.nodeName) && (Ge = k(Ae, j, !1)) && !(Ge instanceof Le) && de.push(Ge);
          }
          return he.addChildren(de), ie && (he = R(he.reduce(), C, q)), pe._currentStyle = se, (ie || ae) && (he.remove(), he = null), he;
        }
        function p(C, I) {
          for (var j = C.getAttribute("points").match(
            /[+-]?(?:\d*\.\d+|\d+\.?)(?:[eE][+-]?\d+)?/g
          ), q = [], H = 0, ie = j.length; H < ie; H += 2)
            q.push(new M(
              parseFloat(j[H]),
              parseFloat(j[H + 1])
            ));
          var ae = new We(q);
          return I === "polygon" && ae.closePath(), ae;
        }
        function y(C) {
          return Yt.create(C.getAttribute("d"));
        }
        function S(C, I) {
          var j = (a(C, "href", !0) || "").substring(1), q = I === "radialgradient", H;
          if (j)
            H = i[j].getGradient(), H._radial ^ q && (H = H.clone(), H._radial = q);
          else {
            for (var ie = C.childNodes, ae = [], he = 0, pe = ie.length; he < pe; he++) {
              var se = ie[he];
              se.nodeType === 1 && ae.push(R(new ji(), se));
            }
            H = new Ci(ae, q);
          }
          var de, ve, we, Se = a(C, "gradientUnits", !0) !== "userSpaceOnUse";
          q ? (de = l(
            C,
            "cx",
            "cy",
            !1,
            Se,
            "50%",
            "50%"
          ), ve = de.add(
            a(C, "r", !1, !1, Se, "50%"),
            0
          ), we = l(C, "fx", "fy", !0, Se)) : (de = l(
            C,
            "x1",
            "y1",
            !1,
            Se,
            "0%",
            "0%"
          ), ve = l(
            C,
            "x2",
            "y2",
            !1,
            Se,
            "100%",
            "0%"
          ));
          var Ae = R(
            new Lt(H, de, ve, we),
            C
          );
          return Ae._scaleToBounds = Se, null;
        }
        var L = {
          "#document": function(C, I, j, q) {
            for (var H = C.childNodes, ie = 0, ae = H.length; ie < ae; ie++) {
              var he = H[ie];
              if (he.nodeType === 1)
                return k(he, j, q);
            }
          },
          g: v,
          svg: v,
          clippath: v,
          polygon: p,
          polyline: p,
          path: y,
          lineargradient: S,
          radialgradient: S,
          image: function(C) {
            var I = new Ye(a(C, "href", !0));
            return I.on("load", function() {
              var j = u(C);
              this.setSize(j);
              var q = l(C).add(j.divide(2));
              this._matrix.append(new ee().translate(q));
            }), I;
          },
          symbol: function(C, I, j, q) {
            return new Le(
              v(C, I, j, q),
              !0
            );
          },
          defs: v,
          use: function(C) {
            var I = (a(C, "href", !0) || "").substring(1), j = i[I], q = l(C);
            return j ? j instanceof Le ? j.place(q) : j.clone().translate(q) : null;
          },
          circle: function(C) {
            return new ke.Circle(
              l(C, "cx", "cy"),
              a(C, "r")
            );
          },
          ellipse: function(C) {
            return new ke.Ellipse({
              center: l(C, "cx", "cy"),
              radius: u(C, "rx", "ry")
            });
          },
          rect: function(C) {
            return new ke.Rectangle(new D(
              l(C),
              u(C)
            ), u(C, "rx", "ry"));
          },
          line: function(C) {
            return new We.Line(
              l(C, "x1", "y1"),
              l(C, "x2", "y2")
            );
          },
          text: function(C) {
            var I = new qt(l(C).add(
              l(C, "dx", "dy")
            ));
            return I.setContent(C.textContent.trim() || ""), I;
          },
          switch: v
        };
        function E(C, I, j, q) {
          if (C.transform) {
            for (var H = (q.getAttribute(j) || "").split(/\)\s*/g), ie = new ee(), ae = 0, he = H.length; ae < he; ae++) {
              var pe = H[ae];
              if (!pe)
                break;
              for (var se = pe.split(/\(\s*/), de = se[0].trim(), ve = se[1].split(/[\s,]+/g), we = 0, Se = ve.length; we < Se; we++)
                ve[we] = parseFloat(ve[we]);
              switch (de) {
                case "matrix":
                  ie.append(
                    new ee(ve[0], ve[1], ve[2], ve[3], ve[4], ve[5])
                  );
                  break;
                case "rotate":
                  ie.rotate(ve[0], ve[1] || 0, ve[2] || 0);
                  break;
                case "translate":
                  ie.translate(ve[0], ve[1] || 0);
                  break;
                case "scale":
                  ie.scale(ve);
                  break;
                case "skewX":
                  ie.skew(ve[0], 0);
                  break;
                case "skewY":
                  ie.skew(0, ve[0]);
                  break;
              }
            }
            C.transform(ie);
          }
        }
        function A(C, I, j) {
          var q = j === "fill-opacity" ? "getFillColor" : "getStrokeColor", H = C[q] && C[q]();
          H && H.setAlpha(parseFloat(I));
        }
        var T = o.set(o.each(Gt, function(C) {
          this[C.attribute] = function(I, j) {
            if (I[C.set] && (I[C.set](d(j, C.type, C.fromSVG)), C.type === "color")) {
              var q = I[C.get]();
              if (q && q._scaleToBounds) {
                var H = I.getBounds();
                q.transform(new ee().translate(H.getPoint()).scale(H.getSize()));
              }
            }
          };
        }, {}), {
          id: function(C, I) {
            i[I] = C, C.setName && C.setName(I);
          },
          "clip-path": function(C, I) {
            var j = Y(I);
            if (j)
              if (j = j.clone(), j.setClipMask(!0), C instanceof W)
                C.insertChild(0, j);
              else
                return new W(j, C);
          },
          gradientTransform: E,
          transform: E,
          "fill-opacity": A,
          "stroke-opacity": A,
          visibility: function(C, I) {
            C.setVisible && C.setVisible(I === "visible");
          },
          display: function(C, I) {
            C.setVisible && C.setVisible(I !== null);
          },
          "stop-color": function(C, I) {
            C.setColor && C.setColor(I);
          },
          "stop-opacity": function(C, I) {
            C._color && C._color.setAlpha(parseFloat(I));
          },
          offset: function(C, I) {
            if (C.setOffset) {
              var j = I.match(/(.*)%$/);
              C.setOffset(j ? j[1] / 100 : parseFloat(I));
            }
          },
          viewBox: function(C, I, j, q, H) {
            var ie = new D(d(I, "array")), ae = u(q, null, null, !0), he, pe;
            if (C instanceof W) {
              var se = ae ? ae.divide(ie.getSize()) : 1, pe = new ee().scale(se).translate(ie.getPoint().negate());
              he = C;
            } else
              C instanceof Le && (ae && ie.setSize(ae), he = C._item);
            if (he) {
              if (G(q, "overflow", H) !== "visible") {
                var de = new ke.Rectangle(ie);
                de.setClipMask(!0), he.addChild(de);
              }
              pe && he.transform(pe);
            }
          }
        });
        function G(C, I, j) {
          var q = C.attributes[I], H = q && q.value;
          if (!H && C.style) {
            var ie = o.camelize(I);
            H = C.style[ie], !H && j.node[ie] !== j.parent[ie] && (H = j.node[ie]);
          }
          return H ? H === "none" ? null : H : t;
        }
        function R(C, I, j) {
          var q = I.parentNode, H = {
            node: Wt.getStyles(I) || {},
            parent: !j && !/^defs$/i.test(q.tagName) && Wt.getStyles(q) || {}
          };
          return o.each(T, function(ie, ae) {
            var he = G(I, ae, H);
            C = he !== t && ie(C, he, ae, I, H) || C;
          }), C;
        }
        function Y(C) {
          var I = C && C.match(/\((?:["'#]*)([^"')]+)/), j = I && I[1], q = j && i[n ? j.replace(n.location.href.split("#")[0] + "#", "") : j];
          return q && q._scaleToBounds && (q = q.clone(), q._scaleToBounds = !0), q;
        }
        function k(C, I, j) {
          var q = C.nodeName.toLowerCase(), H = q !== "#document", ie = s.body, ae, he, pe;
          j && H && (r = He.getView().getSize(), r = u(C, null, null, !0) || r, ae = bt.create("svg", {
            style: "stroke-width: 1px; stroke-miterlimit: 10"
          }), he = C.parentNode, pe = C.nextSibling, ae.appendChild(C), ie.appendChild(ae));
          var se = He.settings, de = se.applyMatrix, ve = se.insertItems;
          se.applyMatrix = !1, se.insertItems = !1;
          var we = L[q], Se = we && we(C, q, I, j) || null;
          if (se.insertItems = ve, se.applyMatrix = de, Se) {
            H && !(Se instanceof W) && (Se = R(Se, C, j));
            var Ae = I.onImport, Ge = H && C.getAttribute("data-paper-data");
            Ae && (Se = Ae(C, Se, I) || Se), I.expandShapes && Se instanceof ke && (Se.remove(), Se = Se.toPath()), Ge && (Se._data = JSON.parse(Ge));
          }
          return ae && (ie.removeChild(ae), he && (pe ? he.insertBefore(C, pe) : he.appendChild(C))), j && (i = {}, Se && o.pick(I.applyMatrix, de) && Se.matrix.apply(!0, !0)), Se;
        }
        function z(C, I, j) {
          if (!C)
            return null;
          I = typeof I == "function" ? { onLoad: I } : I || {};
          var q = He, H = null;
          function ie(se) {
            try {
              var de = typeof se == "object" ? se : new e.DOMParser().parseFromString(
                se.trim(),
                "image/svg+xml"
              );
              if (!de.nodeName)
                throw de = null, new Error("Unsupported SVG source: " + C);
              He = q, H = k(de, I, !0), (!I || I.insert !== !1) && j._insertItem(t, H);
              var ve = I.onLoad;
              ve && ve(H, se);
            } catch (we) {
              ae(we);
            }
          }
          function ae(se, de) {
            var ve = I.onError;
            if (ve)
              ve(se, de);
            else
              throw new Error(se);
          }
          if (typeof C == "string" && !/^[\s\S]*</.test(C)) {
            var he = s.getElementById(C);
            he ? ie(he) : kt.request({
              url: C,
              async: !0,
              onLoad: ie,
              onError: ae
            });
          } else if (typeof File < "u" && C instanceof File) {
            var pe = new FileReader();
            return pe.onload = function() {
              ie(pe.result);
            }, pe.onerror = function() {
              ae(pe.error);
            }, pe.readAsText(C);
          } else
            ie(C);
          return H;
        }
        X.inject({
          importSVG: function(C, I) {
            return z(C, I, this);
          }
        }), fe.inject({
          importSVG: function(C, I) {
            return this.activate(), z(C, I, this);
          }
        });
      }(), o.exports.PaperScript = (function() {
        var i = this, r = i.acorn;
        if (!r && typeof Wy < "u")
          try {
            r = require("acorn");
          } catch {
          }
        if (!r) {
          var a, l;
          r = a = l = {}, function(R, Y) {
            if (typeof a == "object" && typeof l == "object")
              return Y(a);
            if (typeof t == "function" && t.amd)
              return t(["exports"], Y);
            Y(R.acorn || (R.acorn = {}));
          }(this, function(R) {
            R.version = "0.5.0";
            var Y, k, z, C;
            R.parse = function(K, oe) {
              return k = String(K), z = k.length, j(oe), me(), Js(Y.program);
            };
            var I = R.defaultOptions = {
              ecmaVersion: 5,
              strictSemicolons: !1,
              allowTrailingCommas: !0,
              forbidReserved: !1,
              allowReturnOutsideFunction: !1,
              locations: !1,
              onComment: null,
              ranges: !1,
              program: null,
              sourceFile: null,
              directSourceFile: null
            };
            function j(K) {
              Y = K || {};
              for (var oe in I)
                Object.prototype.hasOwnProperty.call(Y, oe) || (Y[oe] = I[oe]);
              C = Y.sourceFile || null;
            }
            var q = R.getLineInfo = function(K, oe) {
              for (var Me = 1, Be = 0; ; ) {
                O.lastIndex = Be;
                var ot = O.exec(K);
                if (ot && ot.index < oe)
                  ++Me, Be = ot.index + ot[0].length;
                else
                  break;
              }
              return { line: Me, column: oe - Be };
            };
            R.tokenize = function(K, oe) {
              k = String(K), z = k.length, j(oe), me();
              var Me = {};
              function Be(ot) {
                return Ge = ae, an(ot), Me.start = ie, Me.end = ae, Me.startLoc = he, Me.endLoc = pe, Me.type = se, Me.value = de, Me;
              }
              return Be.jumpTo = function(ot, ut) {
                if (H = ot, Y.locations) {
                  we = 1, Se = O.lastIndex = 0;
                  for (var St; (St = O.exec(k)) && St.index < ot; )
                    ++we, Se = St.index + St[0].length;
                }
                ve = ut, Ze();
              }, Be;
            };
            var H, ie, ae, he, pe, se, de, ve, we, Se, Ae, Ge, Je, it, gt, Ne;
            function Fe(K, oe) {
              var Me = q(k, K);
              oe += " (" + Me.line + ":" + Me.column + ")";
              var Be = new SyntaxError(oe);
              throw Be.pos = K, Be.loc = Me, Be.raisedAt = H, Be;
            }
            var st = [], _t = { type: "num" }, vt = { type: "regexp" }, Rt = { type: "string" }, Et = { type: "name" }, Ht = { type: "eof" }, jt = { keyword: "break" }, Vt = { keyword: "case", beforeExpr: !0 }, Mi = { keyword: "catch" }, Li = { keyword: "continue" }, Ai = { keyword: "debugger" }, vi = { keyword: "default" }, ri = { keyword: "do", isLoop: !0 }, Nt = { keyword: "else", beforeExpr: !0 }, Di = { keyword: "finally" }, li = { keyword: "for", isLoop: !0 }, nn = { keyword: "function" }, Vi = { keyword: "if" }, Wi = { keyword: "return", beforeExpr: !0 }, Ji = { keyword: "switch" }, Hi = { keyword: "throw", beforeExpr: !0 }, $i = { keyword: "try" }, _n = { keyword: "var" }, Xi = { keyword: "while", isLoop: !0 }, cn = { keyword: "with" }, Cn = { keyword: "new", beforeExpr: !0 }, Zr = { keyword: "this" }, Pr = { keyword: "null", atomValue: null }, An = { keyword: "true", atomValue: !0 }, qr = { keyword: "false", atomValue: !1 }, Vn = { keyword: "in", binop: 7, beforeExpr: !0 }, dr = {
              break: jt,
              case: Vt,
              catch: Mi,
              continue: Li,
              debugger: Ai,
              default: vi,
              do: ri,
              else: Nt,
              finally: Di,
              for: li,
              function: nn,
              if: Vi,
              return: Wi,
              switch: Ji,
              throw: Hi,
              try: $i,
              var: _n,
              while: Xi,
              with: cn,
              null: Pr,
              true: An,
              false: qr,
              new: Cn,
              in: Vn,
              instanceof: { keyword: "instanceof", binop: 7, beforeExpr: !0 },
              this: Zr,
              typeof: { keyword: "typeof", prefix: !0, beforeExpr: !0 },
              void: { keyword: "void", prefix: !0, beforeExpr: !0 },
              delete: { keyword: "delete", prefix: !0, beforeExpr: !0 }
            }, Hn = { type: "[", beforeExpr: !0 }, fn = { type: "]" }, dn = { type: "{", beforeExpr: !0 }, bn = { type: "}" }, sn = { type: "(", beforeExpr: !0 }, ni = { type: ")" }, gn = { type: ",", beforeExpr: !0 }, rn = { type: ";", beforeExpr: !0 }, Pn = { type: ":", beforeExpr: !0 }, gr = { type: "." }, Or = { type: "?", beforeExpr: !0 }, xr = { binop: 10, beforeExpr: !0 }, wr = { isAssign: !0, beforeExpr: !0 }, g = { isAssign: !0, beforeExpr: !0 }, V = { postfix: !0, prefix: !0, isUpdate: !0 }, ue = { prefix: !0, beforeExpr: !0 }, ye = { binop: 1, beforeExpr: !0 }, Ie = { binop: 2, beforeExpr: !0 }, nt = { binop: 3, beforeExpr: !0 }, dt = { binop: 4, beforeExpr: !0 }, zt = { binop: 5, beforeExpr: !0 }, Xt = { binop: 6, beforeExpr: !0 }, hi = { binop: 7, beforeExpr: !0 }, ii = { binop: 8, beforeExpr: !0 }, oi = { binop: 9, prefix: !0, beforeExpr: !0 }, vn = { binop: 10, beforeExpr: !0 };
            R.tokTypes = {
              bracketL: Hn,
              bracketR: fn,
              braceL: dn,
              braceR: bn,
              parenL: sn,
              parenR: ni,
              comma: gn,
              semi: rn,
              colon: Pn,
              dot: gr,
              question: Or,
              slash: xr,
              eq: wr,
              name: Et,
              eof: Ht,
              num: _t,
              regexp: vt,
              string: Rt
            };
            for (var rr in dr)
              R.tokTypes["_" + rr] = dr[rr];
            function Tn(K) {
              K = K.split(" ");
              var oe = "", Me = [];
              e:
                for (var Be = 0; Be < K.length; ++Be) {
                  for (var ot = 0; ot < Me.length; ++ot)
                    if (Me[ot][0].length == K[Be].length) {
                      Me[ot].push(K[Be]);
                      continue e;
                    }
                  Me.push([K[Be]]);
                }
              function ut(Zt) {
                if (Zt.length == 1)
                  return oe += "return str === " + JSON.stringify(Zt[0]) + ";";
                oe += "switch(str){";
                for (var yi = 0; yi < Zt.length; ++yi)
                  oe += "case " + JSON.stringify(Zt[yi]) + ":";
                oe += "return true}return false;";
              }
              if (Me.length > 3) {
                Me.sort(function(Zt, yi) {
                  return yi.length - Zt.length;
                }), oe += "switch(str.length){";
                for (var Be = 0; Be < Me.length; ++Be) {
                  var St = Me[Be];
                  oe += "case " + St[0].length + ":", ut(St);
                }
                oe += "}";
              } else
                ut(K);
              return new Function("str", oe);
            }
            var Sr = Tn("abstract boolean byte char class double enum export extends final float goto implements import int interface long native package private protected public short static super synchronized throws transient volatile"), Mr = Tn("class enum extends super const export import"), sr = Tn("implements interface let package private protected public static yield"), Cr = Tn("eval arguments"), os = Tn("break case catch continue debugger default do else finally for function if return switch throw try var while with null true false instanceof typeof void delete new in this"), Sn = /[\u1680\u180e\u2000-\u200a\u202f\u205f\u3000\ufeff]/, Nr = "ªµºÀ-ÖØ-öø-ˁˆ-ˑˠ-ˤˬˮͰ-ʹͶͷͺ-ͽΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԧԱ-Ֆՙա-ևא-תװ-ײؠ-يٮٯٱ-ۓەۥۦۮۯۺ-ۼۿܐܒ-ܯݍ-ޥޱߊ-ߪߴߵߺࠀ-ࠕࠚࠤࠨࡀ-ࡘࢠࢢ-ࢬऄ-हऽॐक़-ॡॱ-ॷॹ-ॿঅ-ঌএঐও-নপ-রলশ-হঽৎড়ঢ়য়-ৡৰৱਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਖ਼-ੜਫ਼ੲ-ੴઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽૐૠૡଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽଡ଼ଢ଼ୟ-ୡୱஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹௐఅ-ఌఎ-ఐఒ-నప-ళవ-హఽౘౙౠౡಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽೞೠೡೱೲഅ-ഌഎ-ഐഒ-ഺഽൎൠൡൺ-ൿඅ-ඖක-නඳ-රලව-ෆก-ะาำเ-ๆກຂຄງຈຊຍດ-ທນ-ຟມ-ຣລວສຫອ-ະາຳຽເ-ໄໆໜ-ໟༀཀ-ཇཉ-ཬྈ-ྌက-ဪဿၐ-ၕၚ-ၝၡၥၦၮ-ၰၵ-ႁႎႠ-ჅჇჍა-ჺჼ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᎠ-Ᏼᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛮ-ᛰᜀ-ᜌᜎ-ᜑᜠ-ᜱᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳៗៜᠠ-ᡷᢀ-ᢨᢪᢰ-ᣵᤀ-ᤜᥐ-ᥭᥰ-ᥴᦀ-ᦫᧁ-ᧇᨀ-ᨖᨠ-ᩔᪧᬅ-ᬳᭅ-ᭋᮃ-ᮠᮮᮯᮺ-ᯥᰀ-ᰣᱍ-ᱏᱚ-ᱽᳩ-ᳬᳮ-ᳱᳵᳶᴀ-ᶿḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼⁱⁿₐ-ₜℂℇℊ-ℓℕℙ-ℝℤΩℨK-ℭℯ-ℹℼ-ℿⅅ-ⅉⅎⅠ-ↈⰀ-Ⱞⰰ-ⱞⱠ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞⸯ々-〇〡-〩〱-〵〸-〼ぁ-ゖゝ-ゟァ-ヺー-ヿㄅ-ㄭㄱ-ㆎㆠ-ㆺㇰ-ㇿ㐀-䶵一-鿌ꀀ-ꒌꓐ-ꓽꔀ-ꘌꘐ-ꘟꘪꘫꙀ-ꙮꙿ-ꚗꚠ-ꛯꜗ-ꜟꜢ-ꞈꞋ-ꞎꞐ-ꞓꞠ-Ɦꟸ-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢꡀ-ꡳꢂ-ꢳꣲ-ꣷꣻꤊ-ꤥꤰ-ꥆꥠ-ꥼꦄ-ꦲꧏꨀ-ꨨꩀ-ꩂꩄ-ꩋꩠ-ꩶꩺꪀ-ꪯꪱꪵꪶꪹ-ꪽꫀꫂꫛ-ꫝꫠ-ꫪꫲ-ꫴꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꯀ-ꯢ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎ﬀ-ﬆﬓ-ﬗיִײַ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼＡ-Ｚａ-ｚｦ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ", Rr = "̀-ͯ҃-֑҇-ׇֽֿׁׂׅׄؐ-ؚؠ-ىٲ-ۓۧ-ۨۻ-ۼܰ-݊ࠀ-ࠔࠛ-ࠣࠥ-ࠧࠩ-࠭ࡀ-ࡗࣤ-ࣾऀ-ःऺ-़ा-ॏ॑-ॗॢ-ॣ०-९ঁ-ঃ়া-ৄেৈৗয়-ৠਁ-ਃ਼ਾ-ੂੇੈੋ-੍ੑ੦-ੱੵઁ-ઃ઼ા-ૅે-ૉો-્ૢ-ૣ૦-૯ଁ-ଃ଼ା-ୄେୈୋ-୍ୖୗୟ-ୠ୦-୯ஂா-ூெ-ைொ-்ௗ௦-௯ఁ-ఃె-ైొ-్ౕౖౢ-ౣ౦-౯ಂಃ಼ಾ-ೄೆ-ೈೊ-್ೕೖೢ-ೣ೦-೯ംഃെ-ൈൗൢ-ൣ൦-൯ංඃ්ා-ුූෘ-ෟෲෳิ-ฺเ-ๅ๐-๙ິ-ູ່-ໍ໐-໙༘༙༠-༩༹༵༷ཁ-ཇཱ-྄྆-྇ྍ-ྗྙ-ྼ࿆က-ဩ၀-၉ၧ-ၭၱ-ၴႂ-ႍႏ-ႝ፝-፟ᜎ-ᜐᜠ-ᜰᝀ-ᝐᝲᝳក-ឲ៝០-៩᠋-᠍᠐-᠙ᤠ-ᤫᤰ-᤻ᥑ-ᥭᦰ-ᧀᧈ-ᧉ᧐-᧙ᨀ-ᨕᨠ-ᩓ᩠-᩿᩼-᪉᪐-᪙ᭆ-ᭋ᭐-᭙᭫-᭳᮰-᮹᯦-᯳ᰀ-ᰢ᱀-᱉ᱛ-ᱽ᳐-᳒ᴀ-ᶾḁ-ἕ‌‍‿⁀⁔⃐-⃥⃜⃡-⃰ⶁ-ⶖⷠ-ⷿ〡-〨゙゚Ꙁ-ꙭꙴ-꙽ꚟ꛰-꛱ꟸ-ꠀ꠆ꠋꠣ-ꠧꢀ-ꢁꢴ-꣄꣐-꣙ꣳ-ꣷ꤀-꤉ꤦ-꤭ꤰ-ꥅꦀ-ꦃ꦳-꧀ꨀ-ꨧꩀ-ꩁꩌ-ꩍ꩐-꩙ꩻꫠ-ꫩꫲ-ꫳꯀ-ꯡ꯬꯭꯰-꯹ﬠ-ﬨ︀-️︠-︦︳︴﹍-﹏０-９＿", vs = new RegExp("[" + Nr + "]"), Ts = new RegExp("[" + Nr + Rr + "]"), w = /[\n\r\u2028\u2029]/, O = /\r\n|[\n\r\u2028\u2029]/g, J = R.isIdentifierStart = function(K) {
              return K < 65 ? K === 36 : K < 91 ? !0 : K < 97 ? K === 95 : K < 123 ? !0 : K >= 170 && vs.test(String.fromCharCode(K));
            }, re = R.isIdentifierChar = function(K) {
              return K < 48 ? K === 36 : K < 58 ? !0 : K < 65 ? !1 : K < 91 ? !0 : K < 97 ? K === 95 : K < 123 ? !0 : K >= 170 && Ts.test(String.fromCharCode(K));
            };
            function ge() {
              this.line = we, this.column = H - Se;
            }
            function me() {
              we = 1, H = Se = 0, ve = !0, Ze();
            }
            function xe(K, oe) {
              ae = H, Y.locations && (pe = new ge()), se = K, Ze(), de = oe, ve = K.beforeExpr;
            }
            function Ue() {
              var K = Y.onComment && Y.locations && new ge(), oe = H, Me = k.indexOf("*/", H += 2);
              if (Me === -1 && Fe(H - 2, "Unterminated comment"), H = Me + 2, Y.locations) {
                O.lastIndex = oe;
                for (var Be; (Be = O.exec(k)) && Be.index < H; )
                  ++we, Se = Be.index + Be[0].length;
              }
              Y.onComment && Y.onComment(
                !0,
                k.slice(oe + 2, Me),
                oe,
                H,
                K,
                Y.locations && new ge()
              );
            }
            function ze() {
              for (var K = H, oe = Y.onComment && Y.locations && new ge(), Me = k.charCodeAt(H += 2); H < z && Me !== 10 && Me !== 13 && Me !== 8232 && Me !== 8233; )
                ++H, Me = k.charCodeAt(H);
              Y.onComment && Y.onComment(
                !1,
                k.slice(K + 2, H),
                K,
                H,
                oe,
                Y.locations && new ge()
              );
            }
            function Ze() {
              for (; H < z; ) {
                var K = k.charCodeAt(H);
                if (K === 32)
                  ++H;
                else if (K === 13) {
                  ++H;
                  var oe = k.charCodeAt(H);
                  oe === 10 && ++H, Y.locations && (++we, Se = H);
                } else if (K === 10 || K === 8232 || K === 8233)
                  ++H, Y.locations && (++we, Se = H);
                else if (K > 8 && K < 14)
                  ++H;
                else if (K === 47) {
                  var oe = k.charCodeAt(H + 1);
                  if (oe === 42)
                    Ue();
                  else if (oe === 47)
                    ze();
                  else
                    break;
                } else if (K === 160)
                  ++H;
                else if (K >= 5760 && Sn.test(String.fromCharCode(K)))
                  ++H;
                else
                  break;
              }
            }
            function At() {
              var K = k.charCodeAt(H + 1);
              return K >= 48 && K <= 57 ? Qi(!0) : (++H, xe(gr));
            }
            function Bt() {
              var K = k.charCodeAt(H + 1);
              return ve ? (++H, ki()) : K === 61 ? xi(g, 2) : xi(xr, 1);
            }
            function lt() {
              var K = k.charCodeAt(H + 1);
              return K === 61 ? xi(g, 2) : xi(vn, 1);
            }
            function Ft(K) {
              var oe = k.charCodeAt(H + 1);
              return oe === K ? xi(K === 124 ? ye : Ie, 2) : oe === 61 ? xi(g, 2) : xi(K === 124 ? nt : zt, 1);
            }
            function fi() {
              var K = k.charCodeAt(H + 1);
              return K === 61 ? xi(g, 2) : xi(dt, 1);
            }
            function si(K) {
              var oe = k.charCodeAt(H + 1);
              return oe === K ? oe == 45 && k.charCodeAt(H + 2) == 62 && w.test(k.slice(Ge, H)) ? (H += 3, ze(), Ze(), an()) : xi(V, 2) : oe === 61 ? xi(g, 2) : xi(oi, 1);
            }
            function di(K) {
              var oe = k.charCodeAt(H + 1), Me = 1;
              return oe === K ? (Me = K === 62 && k.charCodeAt(H + 2) === 62 ? 3 : 2, k.charCodeAt(H + Me) === 61 ? xi(g, Me + 1) : xi(ii, Me)) : oe == 33 && K == 60 && k.charCodeAt(H + 2) == 45 && k.charCodeAt(H + 3) == 45 ? (H += 4, ze(), Ze(), an()) : (oe === 61 && (Me = k.charCodeAt(H + 2) === 61 ? 3 : 2), xi(hi, Me));
            }
            function xn(K) {
              var oe = k.charCodeAt(H + 1);
              return oe === 61 ? xi(Xt, k.charCodeAt(H + 2) === 61 ? 3 : 2) : xi(K === 61 ? wr : ue, 1);
            }
            function wn(K) {
              switch (K) {
                case 46:
                  return At();
                case 40:
                  return ++H, xe(sn);
                case 41:
                  return ++H, xe(ni);
                case 59:
                  return ++H, xe(rn);
                case 44:
                  return ++H, xe(gn);
                case 91:
                  return ++H, xe(Hn);
                case 93:
                  return ++H, xe(fn);
                case 123:
                  return ++H, xe(dn);
                case 125:
                  return ++H, xe(bn);
                case 58:
                  return ++H, xe(Pn);
                case 63:
                  return ++H, xe(Or);
                case 48:
                  var oe = k.charCodeAt(H + 1);
                  if (oe === 120 || oe === 88)
                    return Ni();
                case 49:
                case 50:
                case 51:
                case 52:
                case 53:
                case 54:
                case 55:
                case 56:
                case 57:
                  return Qi(!1);
                case 34:
                case 39:
                  return ar(K);
                case 47:
                  return Bt();
                case 37:
                case 42:
                  return lt();
                case 124:
                case 38:
                  return Ft(K);
                case 94:
                  return fi();
                case 43:
                case 45:
                  return si(K);
                case 60:
                case 62:
                  return di(K);
                case 61:
                case 33:
                  return xn(K);
                case 126:
                  return xi(ue, 1);
              }
              return !1;
            }
            function an(K) {
              if (K ? H = ie + 1 : ie = H, Y.locations && (he = new ge()), K)
                return ki();
              if (H >= z)
                return xe(Ht);
              var oe = k.charCodeAt(H);
              if (J(oe) || oe === 92)
                return Yn();
              var Me = wn(oe);
              if (Me === !1) {
                var Be = String.fromCharCode(oe);
                if (Be === "\\" || vs.test(Be))
                  return Yn();
                Fe(H, "Unexpected character '" + Be + "'");
              }
              return Me;
            }
            function xi(K, oe) {
              var Me = k.slice(H, H + oe);
              H += oe, xe(K, Me);
            }
            function ki() {
              for (var ot = "", K, oe, Me = H; ; ) {
                H >= z && Fe(Me, "Unterminated regular expression");
                var Be = k.charAt(H);
                if (w.test(Be) && Fe(Me, "Unterminated regular expression"), K)
                  K = !1;
                else {
                  if (Be === "[")
                    oe = !0;
                  else if (Be === "]" && oe)
                    oe = !1;
                  else if (Be === "/" && !oe)
                    break;
                  K = Be === "\\";
                }
                ++H;
              }
              var ot = k.slice(Me, H);
              ++H;
              var ut = Ar();
              ut && !/^[gmsiy]*$/.test(ut) && Fe(Me, "Invalid regexp flag");
              try {
                var St = new RegExp(ot, ut);
              } catch (Zt) {
                Zt instanceof SyntaxError && Fe(Me, Zt.message), Fe(Zt);
              }
              return xe(vt, St);
            }
            function Dn(K, oe) {
              for (var Me = H, Be = 0, ot = 0, ut = oe ?? 1 / 0; ot < ut; ++ot) {
                var St = k.charCodeAt(H), Zt;
                if (St >= 97 ? Zt = St - 97 + 10 : St >= 65 ? Zt = St - 65 + 10 : St >= 48 && St <= 57 ? Zt = St - 48 : Zt = 1 / 0, Zt >= K)
                  break;
                ++H, Be = Be * K + Zt;
              }
              return H === Me || oe != null && H - Me !== oe ? null : Be;
            }
            function Ni() {
              H += 2;
              var K = Dn(16);
              return K == null && Fe(ie + 2, "Expected hexadecimal number"), J(k.charCodeAt(H)) && Fe(H, "Identifier directly after number"), xe(_t, K);
            }
            function Qi(K) {
              var oe = H, Me = !1, Be = k.charCodeAt(H) === 48;
              !K && Dn(10) === null && Fe(oe, "Invalid number"), k.charCodeAt(H) === 46 && (++H, Dn(10), Me = !0);
              var ot = k.charCodeAt(H);
              (ot === 69 || ot === 101) && (ot = k.charCodeAt(++H), (ot === 43 || ot === 45) && ++H, Dn(10) === null && Fe(oe, "Invalid number"), Me = !0), J(k.charCodeAt(H)) && Fe(H, "Identifier directly after number");
              var ut = k.slice(oe, H), St;
              return Me ? St = parseFloat(ut) : !Be || ut.length === 1 ? St = parseInt(ut, 10) : /[89]/.test(ut) || Ne ? Fe(oe, "Invalid number") : St = parseInt(ut, 8), xe(_t, St);
            }
            function ar(K) {
              H++;
              for (var oe = ""; ; ) {
                H >= z && Fe(ie, "Unterminated string constant");
                var Me = k.charCodeAt(H);
                if (Me === K)
                  return ++H, xe(Rt, oe);
                if (Me === 92) {
                  Me = k.charCodeAt(++H);
                  var Be = /^[0-7]+/.exec(k.slice(H, H + 3));
                  for (Be && (Be = Be[0]); Be && parseInt(Be, 8) > 255; )
                    Be = Be.slice(0, -1);
                  if (Be === "0" && (Be = null), ++H, Be)
                    Ne && Fe(H - 2, "Octal literal in strict mode"), oe += String.fromCharCode(parseInt(Be, 8)), H += Be.length - 1;
                  else
                    switch (Me) {
                      case 110:
                        oe += `
`;
                        break;
                      case 114:
                        oe += "\r";
                        break;
                      case 120:
                        oe += String.fromCharCode(pr(2));
                        break;
                      case 117:
                        oe += String.fromCharCode(pr(4));
                        break;
                      case 85:
                        oe += String.fromCharCode(pr(8));
                        break;
                      case 116:
                        oe += "	";
                        break;
                      case 98:
                        oe += "\b";
                        break;
                      case 118:
                        oe += "\v";
                        break;
                      case 102:
                        oe += "\f";
                        break;
                      case 48:
                        oe += "\0";
                        break;
                      case 13:
                        k.charCodeAt(H) === 10 && ++H;
                      case 10:
                        Y.locations && (Se = H, ++we);
                        break;
                      default:
                        oe += String.fromCharCode(Me);
                        break;
                    }
                } else
                  (Me === 13 || Me === 10 || Me === 8232 || Me === 8233) && Fe(ie, "Unterminated string constant"), oe += String.fromCharCode(Me), ++H;
              }
            }
            function pr(K) {
              var oe = Dn(16, K);
              return oe === null && Fe(ie, "Bad character escape sequence"), oe;
            }
            var pn;
            function Ar() {
              pn = !1;
              for (var K, oe = !0, Me = H; ; ) {
                var Be = k.charCodeAt(H);
                if (re(Be))
                  pn && (K += k.charAt(H)), ++H;
                else if (Be === 92) {
                  pn || (K = k.slice(Me, H)), pn = !0, k.charCodeAt(++H) != 117 && Fe(H, "Expecting Unicode escape sequence \\uXXXX"), ++H;
                  var ot = pr(4), ut = String.fromCharCode(ot);
                  ut || Fe(H - 1, "Invalid Unicode escape"), (oe ? J(ot) : re(ot)) || Fe(H - 4, "Invalid Unicode escape"), K += ut;
                } else
                  break;
                oe = !1;
              }
              return pn ? K : k.slice(Me, H);
            }
            function Yn() {
              var K = Ar(), oe = Et;
              return !pn && os(K) && (oe = dr[K]), xe(oe, K);
            }
            function Qt() {
              Ae = ie, Ge = ae, Je = pe, an();
            }
            function qn(K) {
              if (Ne = K, H = ie, Y.locations)
                for (; H < Se; )
                  Se = k.lastIndexOf(`
`, Se - 2) + 1, --we;
              Ze(), an();
            }
            function Gn() {
              this.type = null, this.start = ie, this.end = null;
            }
            function Dr() {
              this.start = he, this.end = null, C !== null && (this.source = C);
            }
            function Si() {
              var K = new Gn();
              return Y.locations && (K.loc = new Dr()), Y.directSourceFile && (K.sourceFile = Y.directSourceFile), Y.ranges && (K.range = [ie, 0]), K;
            }
            function hn(K) {
              var oe = new Gn();
              return oe.start = K.start, Y.locations && (oe.loc = new Dr(), oe.loc.start = K.loc.start), Y.ranges && (oe.range = [K.range[0], 0]), oe;
            }
            function Jt(K, oe) {
              return K.type = oe, K.end = Ge, Y.locations && (K.loc.end = Je), Y.ranges && (K.range[1] = Ge), K;
            }
            function Ln(K) {
              return Y.ecmaVersion >= 5 && K.type === "ExpressionStatement" && K.expression.type === "Literal" && K.expression.value === "use strict";
            }
            function gi(K) {
              if (se === K)
                return Qt(), !0;
            }
            function Bi() {
              return !Y.strictSemicolons && (se === Ht || se === bn || w.test(k.slice(Ge, ie)));
            }
            function Bn() {
              !gi(rn) && !Bi() && un();
            }
            function ui(K) {
              se === K ? Qt() : un();
            }
            function un() {
              Fe(ie, "Unexpected token");
            }
            function zr(K) {
              K.type !== "Identifier" && K.type !== "MemberExpression" && Fe(K.start, "Assigning to rvalue"), Ne && K.type === "Identifier" && Cr(K.name) && Fe(K.start, "Assigning to " + K.name + " in strict mode");
            }
            function Js(K) {
              Ae = Ge = H, Y.locations && (Je = new ge()), it = Ne = null, gt = [], an();
              var oe = K || Si(), Me = !0;
              for (K || (oe.body = []); se !== Ht; ) {
                var Be = Ki();
                oe.body.push(Be), Me && Ln(Be) && qn(!0), Me = !1;
              }
              return Jt(oe, "Program");
            }
            var $r = { kind: "loop" }, Fr = { kind: "switch" };
            function Ki() {
              (se === xr || se === g && de == "/=") && an(!0);
              var K = se, oe = Si();
              switch (K) {
                case jt:
                case Li:
                  Qt();
                  var Me = K === jt;
                  gi(rn) || Bi() ? oe.label = null : se !== Et ? un() : (oe.label = qe(), Bn());
                  for (var Be = 0; Be < gt.length; ++Be) {
                    var ot = gt[Be];
                    if ((oe.label == null || ot.name === oe.label.name) && (ot.kind != null && (Me || ot.kind === "loop") || oe.label && Me))
                      break;
                  }
                  return Be === gt.length && Fe(oe.start, "Unsyntactic " + K.keyword), Jt(oe, Me ? "BreakStatement" : "ContinueStatement");
                case Ai:
                  return Qt(), Bn(), Jt(oe, "DebuggerStatement");
                case ri:
                  return Qt(), gt.push($r), oe.body = Ki(), gt.pop(), ui(Xi), oe.test = On(), Bn(), Jt(oe, "DoWhileStatement");
                case li:
                  if (Qt(), gt.push($r), ui(sn), se === rn)
                    return tr(oe, null);
                  if (se === _n) {
                    var ut = Si();
                    return Qt(), $n(ut, !0), Jt(ut, "VariableDeclaration"), ut.declarations.length === 1 && gi(Vn) ? Ur(oe, ut) : tr(oe, ut);
                  }
                  var ut = Pi(!1, !0);
                  return gi(Vn) ? (zr(ut), Ur(oe, ut)) : tr(oe, ut);
                case nn:
                  return Qt(), Tt(oe, !0);
                case Vi:
                  return Qt(), oe.test = On(), oe.consequent = Ki(), oe.alternate = gi(Nt) ? Ki() : null, Jt(oe, "IfStatement");
                case Wi:
                  return !it && !Y.allowReturnOutsideFunction && Fe(ie, "'return' outside of function"), Qt(), gi(rn) || Bi() ? oe.argument = null : (oe.argument = Pi(), Bn()), Jt(oe, "ReturnStatement");
                case Ji:
                  Qt(), oe.discriminant = On(), oe.cases = [], ui(dn), gt.push(Fr);
                  for (var St, Zt; se != bn; )
                    if (se === Vt || se === vi) {
                      var yi = se === Vt;
                      St && Jt(St, "SwitchCase"), oe.cases.push(St = Si()), St.consequent = [], Qt(), yi ? St.test = Pi() : (Zt && Fe(Ae, "Multiple default clauses"), Zt = !0, St.test = null), ui(Pn);
                    } else
                      St || un(), St.consequent.push(Ki());
                  return St && Jt(St, "SwitchCase"), Qt(), gt.pop(), Jt(oe, "SwitchStatement");
                case Hi:
                  return Qt(), w.test(k.slice(Ge, ie)) && Fe(Ge, "Illegal newline after throw"), oe.argument = Pi(), Bn(), Jt(oe, "ThrowStatement");
                case $i:
                  if (Qt(), oe.block = or(), oe.handler = null, se === Mi) {
                    var Yi = Si();
                    Qt(), ui(sn), Yi.param = qe(), Ne && Cr(Yi.param.name) && Fe(Yi.param.start, "Binding " + Yi.param.name + " in strict mode"), ui(ni), Yi.guard = null, Yi.body = or(), oe.handler = Jt(Yi, "CatchClause");
                  }
                  return oe.guardedHandlers = st, oe.finalizer = gi(Di) ? or() : null, !oe.handler && !oe.finalizer && Fe(oe.start, "Missing catch or finally clause"), Jt(oe, "TryStatement");
                case _n:
                  return Qt(), $n(oe), Bn(), Jt(oe, "VariableDeclaration");
                case Xi:
                  return Qt(), oe.test = On(), gt.push($r), oe.body = Ki(), gt.pop(), Jt(oe, "WhileStatement");
                case cn:
                  return Ne && Fe(ie, "'with' in strict mode"), Qt(), oe.object = On(), oe.body = Ki(), Jt(oe, "WithStatement");
                case dn:
                  return or();
                case rn:
                  return Qt(), Jt(oe, "EmptyStatement");
                default:
                  var Nn = de, mn = Pi();
                  if (K === Et && mn.type === "Identifier" && gi(Pn)) {
                    for (var Be = 0; Be < gt.length; ++Be)
                      gt[Be].name === Nn && Fe(mn.start, "Label '" + Nn + "' is already declared");
                    var mr = se.isLoop ? "loop" : se === Ji ? "switch" : null;
                    return gt.push({ name: Nn, kind: mr }), oe.body = Ki(), gt.pop(), oe.label = mn, Jt(oe, "LabeledStatement");
                  } else
                    return oe.expression = mn, Bn(), Jt(oe, "ExpressionStatement");
              }
            }
            function On() {
              ui(sn);
              var K = Pi();
              return ui(ni), K;
            }
            function or(K) {
              var oe = Si(), Me = !0, Be = !1, ot;
              for (oe.body = [], ui(dn); !gi(bn); ) {
                var ut = Ki();
                oe.body.push(ut), Me && K && Ln(ut) && (ot = Be, qn(Be = !0)), Me = !1;
              }
              return Be && !ot && qn(!1), Jt(oe, "BlockStatement");
            }
            function tr(K, oe) {
              return K.init = oe, ui(rn), K.test = se === rn ? null : Pi(), ui(rn), K.update = se === ni ? null : Pi(), ui(ni), K.body = Ki(), gt.pop(), Jt(K, "ForStatement");
            }
            function Ur(K, oe) {
              return K.left = oe, K.right = Pi(), ui(ni), K.body = Ki(), gt.pop(), Jt(K, "ForInStatement");
            }
            function $n(K, oe) {
              for (K.declarations = [], K.kind = "var"; ; ) {
                var Me = Si();
                if (Me.id = qe(), Ne && Cr(Me.id.name) && Fe(Me.id.start, "Binding " + Me.id.name + " in strict mode"), Me.init = gi(wr) ? Pi(!0, oe) : null, K.declarations.push(Jt(Me, "VariableDeclarator")), !gi(gn))
                  break;
              }
              return K;
            }
            function Pi(K, oe) {
              var Me = ls(oe);
              if (!K && se === gn) {
                var Be = hn(Me);
                for (Be.expressions = [Me]; gi(gn); )
                  Be.expressions.push(ls(oe));
                return Jt(Be, "SequenceExpression");
              }
              return Me;
            }
            function ls(K) {
              var oe = ys(K);
              if (se.isAssign) {
                var Me = hn(oe);
                return Me.operator = de, Me.left = oe, Qt(), Me.right = ls(K), zr(oe), Jt(Me, "AssignmentExpression");
              }
              return oe;
            }
            function ys(K) {
              var oe = Ls(K);
              if (gi(Or)) {
                var Me = hn(oe);
                return Me.test = oe, Me.consequent = Pi(!0), ui(Pn), Me.alternate = Pi(!0, K), Jt(Me, "ConditionalExpression");
              }
              return oe;
            }
            function Ls(K) {
              return Jn(zn(), -1, K);
            }
            function Jn(K, oe, Me) {
              var Be = se.binop;
              if (Be != null && (!Me || se !== Vn) && Be > oe) {
                var ot = hn(K);
                ot.left = K, ot.operator = de;
                var ut = se;
                Qt(), ot.right = Jn(zn(), Be, Me);
                var St = Jt(ot, ut === ye || ut === Ie ? "LogicalExpression" : "BinaryExpression");
                return Jn(St, oe, Me);
              }
              return K;
            }
            function zn() {
              if (se.prefix) {
                var K = Si(), oe = se.isUpdate;
                return K.operator = de, K.prefix = !0, ve = !0, Qt(), K.argument = zn(), oe ? zr(K.argument) : Ne && K.operator === "delete" && K.argument.type === "Identifier" && Fe(K.start, "Deleting local variable in strict mode"), Jt(K, oe ? "UpdateExpression" : "UnaryExpression");
              }
              for (var Me = bs(); se.postfix && !Bi(); ) {
                var K = hn(Me);
                K.operator = de, K.prefix = !1, K.argument = Me, zr(Me), Qt(), Me = Jt(K, "UpdateExpression");
              }
              return Me;
            }
            function bs() {
              return lr(Pe());
            }
            function lr(K, oe) {
              if (gi(gr)) {
                var Me = hn(K);
                return Me.object = K, Me.property = qe(!0), Me.computed = !1, lr(Jt(Me, "MemberExpression"), oe);
              } else if (gi(Hn)) {
                var Me = hn(K);
                return Me.object = K, Me.property = Pi(), Me.computed = !0, ui(fn), lr(Jt(Me, "MemberExpression"), oe);
              } else if (!oe && gi(sn)) {
                var Me = hn(K);
                return Me.callee = K, Me.arguments = Oe(ni, !1), lr(Jt(Me, "CallExpression"), oe);
              } else
                return K;
            }
            function Pe() {
              switch (se) {
                case Zr:
                  var Be = Si();
                  return Qt(), Jt(Be, "ThisExpression");
                case Et:
                  return qe();
                case _t:
                case Rt:
                case vt:
                  var Be = Si();
                  return Be.value = de, Be.raw = k.slice(ie, ae), Qt(), Jt(Be, "Literal");
                case Pr:
                case An:
                case qr:
                  var Be = Si();
                  return Be.value = se.atomValue, Be.raw = se.keyword, Qt(), Jt(Be, "Literal");
                case sn:
                  var K = he, oe = ie;
                  Qt();
                  var Me = Pi();
                  return Me.start = oe, Me.end = ae, Y.locations && (Me.loc.start = K, Me.loc.end = pe), Y.ranges && (Me.range = [oe, ae]), ui(ni), Me;
                case Hn:
                  var Be = Si();
                  return Qt(), Be.elements = Oe(fn, !0, !0), Jt(Be, "ArrayExpression");
                case dn:
                  return ct();
                case nn:
                  var Be = Si();
                  return Qt(), Tt(Be, !1);
                case Cn:
                  return Ke();
                default:
                  un();
              }
            }
            function Ke() {
              var K = Si();
              return Qt(), K.callee = lr(Pe(), !0), gi(sn) ? K.arguments = Oe(ni, !1) : K.arguments = st, Jt(K, "NewExpression");
            }
            function ct() {
              var K = Si(), oe = !0, Me = !1;
              for (K.properties = [], Qt(); !gi(bn); ) {
                if (oe)
                  oe = !1;
                else if (ui(gn), Y.allowTrailingCommas && gi(bn))
                  break;
                var Be = { key: xt() }, ot = !1, ut;
                if (gi(Pn) ? (Be.value = Pi(!0), ut = Be.kind = "init") : Y.ecmaVersion >= 5 && Be.key.type === "Identifier" && (Be.key.name === "get" || Be.key.name === "set") ? (ot = Me = !0, ut = Be.kind = Be.key.name, Be.key = xt(), se !== sn && un(), Be.value = Tt(Si(), !1)) : un(), Be.key.type === "Identifier" && (Ne || Me))
                  for (var St = 0; St < K.properties.length; ++St) {
                    var Zt = K.properties[St];
                    if (Zt.key.name === Be.key.name) {
                      var yi = ut == Zt.kind || ot && Zt.kind === "init" || ut === "init" && (Zt.kind === "get" || Zt.kind === "set");
                      yi && !Ne && ut === "init" && Zt.kind === "init" && (yi = !1), yi && Fe(Be.key.start, "Redefinition of property");
                    }
                  }
                K.properties.push(Be);
              }
              return Jt(K, "ObjectExpression");
            }
            function xt() {
              return se === _t || se === Rt ? Pe() : qe(!0);
            }
            function Tt(K, oe) {
              se === Et ? K.id = qe() : oe ? un() : K.id = null, K.params = [];
              var Me = !0;
              for (ui(sn); !gi(ni); )
                Me ? Me = !1 : ui(gn), K.params.push(qe());
              var Be = it, ot = gt;
              if (it = !0, gt = [], K.body = or(!0), it = Be, gt = ot, Ne || K.body.body.length && Ln(K.body.body[0]))
                for (var ut = K.id ? -1 : 0; ut < K.params.length; ++ut) {
                  var St = ut < 0 ? K.id : K.params[ut];
                  if ((sr(St.name) || Cr(St.name)) && Fe(St.start, "Defining '" + St.name + "' in strict mode"), ut >= 0)
                    for (var Zt = 0; Zt < ut; ++Zt)
                      St.name === K.params[Zt].name && Fe(St.start, "Argument name clash in strict mode");
                }
              return Jt(K, oe ? "FunctionDeclaration" : "FunctionExpression");
            }
            function Oe(K, oe, Me) {
              for (var Be = [], ot = !0; !gi(K); ) {
                if (ot)
                  ot = !1;
                else if (ui(gn), oe && Y.allowTrailingCommas && gi(K))
                  break;
                Me && se === gn ? Be.push(null) : Be.push(Pi(!0));
              }
              return Be;
            }
            function qe(K) {
              var oe = Si();
              return K && Y.forbidReserved == "everywhere" && (K = !1), se === Et ? (!K && (Y.forbidReserved && (Y.ecmaVersion === 3 ? Sr : Mr)(de) || Ne && sr(de)) && k.slice(ie, ae).indexOf("\\") == -1 && Fe(ie, "The keyword '" + de + "' is reserved"), oe.name = de) : K && se.keyword ? oe.name = se.keyword : un(), ve = !1, Qt(), Jt(oe, "Identifier");
            }
          }), r.version || (r = null);
        }
        function u(R, Y) {
          return (i.acorn || r).parse(R, Y);
        }
        var d = {
          "+": "__add",
          "-": "__subtract",
          "*": "__multiply",
          "/": "__divide",
          "%": "__modulo",
          "==": "__equals",
          "!=": "__equals"
        }, v = {
          "-": "__negate",
          "+": "__self"
        }, p = o.each(
          ["add", "subtract", "multiply", "divide", "modulo", "equals", "negate"],
          function(R) {
            this["__" + R] = "#" + R;
          },
          {
            __self: function() {
              return this;
            }
          }
        );
        M.inject(p), F.inject(p), Lt.inject(p);
        function y(R, Y, k) {
          var z = d[Y];
          if (R && R[z]) {
            var C = R[z](k);
            return Y === "!=" ? !C : C;
          }
          switch (Y) {
            case "+":
              return R + k;
            case "-":
              return R - k;
            case "*":
              return R * k;
            case "/":
              return R / k;
            case "%":
              return R % k;
            case "==":
              return R == k;
            case "!=":
              return R != k;
          }
        }
        function S(R, Y) {
          var k = v[R];
          if (Y && Y[k])
            return Y[k]();
          switch (R) {
            case "+":
              return +Y;
            case "-":
              return -Y;
          }
        }
        function L(R, Y) {
          if (!R)
            return "";
          Y = Y || {};
          var k = [];
          function z(Ne) {
            for (var Fe = 0, st = k.length; Fe < st; Fe++) {
              var _t = k[Fe];
              if (_t[0] >= Ne)
                break;
              Ne += _t[1];
            }
            return Ne;
          }
          function C(Ne) {
            return R.substring(
              z(Ne.range[0]),
              z(Ne.range[1])
            );
          }
          function I(Ne, Fe) {
            return R.substring(
              z(Ne.range[1]),
              z(Fe.range[0])
            );
          }
          function j(Ne, Fe) {
            for (var st = z(Ne.range[0]), _t = z(Ne.range[1]), vt = 0, Rt = k.length - 1; Rt >= 0; Rt--)
              if (st > k[Rt][0]) {
                vt = Rt + 1;
                break;
              }
            k.splice(vt, 0, [st, Fe.length - _t + st]), R = R.substring(0, st) + Fe + R.substring(_t);
          }
          function q(Ne, Fe) {
            switch (Ne.type) {
              case "UnaryExpression":
                if (Ne.operator in v && Ne.argument.type !== "Literal") {
                  var st = C(Ne.argument);
                  j(Ne, '$__("' + Ne.operator + '", ' + st + ")");
                }
                break;
              case "BinaryExpression":
                if (Ne.operator in d && Ne.left.type !== "Literal") {
                  var _t = C(Ne.left), vt = C(Ne.right), Rt = I(Ne.left, Ne.right), Et = Ne.operator;
                  j(Ne, "__$__(" + _t + "," + Rt.replace(
                    new RegExp("\\" + Et),
                    '"' + Et + '"'
                  ) + ", " + vt + ")");
                }
                break;
              case "UpdateExpression":
              case "AssignmentExpression":
                var Ht = Fe && Fe.type;
                if (!(Ht === "ForStatement" || Ht === "BinaryExpression" && /^[=!<>]/.test(Fe.operator) || Ht === "MemberExpression" && Fe.computed)) {
                  if (Ne.type === "UpdateExpression") {
                    var st = C(Ne.argument), jt = "__$__(" + st + ', "' + Ne.operator[0] + '", 1)', Vt = st + " = " + jt;
                    Ne.prefix ? Vt = "(" + Vt + ")" : (Ht === "AssignmentExpression" || Ht === "VariableDeclarator" || Ht === "BinaryExpression") && (C(Fe.left || Fe.id) === st && (Vt = jt), Vt = st + "; " + Vt), j(Ne, Vt);
                  } else if (/^.=$/.test(Ne.operator) && Ne.left.type !== "Literal") {
                    var _t = C(Ne.left), vt = C(Ne.right), jt = _t + " = __$__(" + _t + ', "' + Ne.operator[0] + '", ' + vt + ")";
                    j(Ne, /^\(.*\)$/.test(C(Ne)) ? "(" + jt + ")" : jt);
                  }
                }
                break;
            }
          }
          function H(Ne) {
            switch (Ne.type) {
              case "ExportDefaultDeclaration":
                j({
                  range: [Ne.start, Ne.declaration.start]
                }, "module.exports = ");
                break;
              case "ExportNamedDeclaration":
                var Fe = Ne.declaration, st = Ne.specifiers;
                if (Fe) {
                  var _t = Fe.declarations;
                  _t && (_t.forEach(function(Rt) {
                    j(Rt, "module.exports." + C(Rt));
                  }), j({
                    range: [
                      Ne.start,
                      Fe.start + Fe.kind.length
                    ]
                  }, ""));
                } else if (st) {
                  var vt = st.map(function(Rt) {
                    var Et = C(Rt);
                    return "module.exports." + Et + " = " + Et + "; ";
                  }).join("");
                  vt && j(Ne, vt);
                }
                break;
            }
          }
          function ie(Ne, Fe, st) {
            if (Ne) {
              for (var _t in Ne)
                if (_t !== "range" && _t !== "loc") {
                  var vt = Ne[_t];
                  if (Array.isArray(vt))
                    for (var Rt = 0, Et = vt.length; Rt < Et; Rt++)
                      ie(vt[Rt], Ne, st);
                  else
                    vt && typeof vt == "object" && ie(vt, Ne, st);
                }
              st.operatorOverloading !== !1 && q(Ne, Fe), st.moduleExports !== !1 && H(Ne);
            }
          }
          function ae(Ne) {
            var Fe = "", st = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
            for (Ne = (Math.abs(Ne) << 1) + (Ne < 0 ? 1 : 0); Ne || !Fe; ) {
              var _t = Ne & 31;
              Ne >>= 5, Ne && (_t |= 32), Fe += st[_t];
            }
            return Fe;
          }
          var he = Y.url || "", pe = Y.sourceMaps, se = Y.paperFeatures || {}, de = Y.source || R, ve = Y.offset || 0, we = He.agent, Se = we.versionNumber, Ae = !1, Ge = /\r\n|\n|\r/mg, Je;
          if (pe && (we.chrome && Se >= 30 || we.webkit && Se >= 537.76 || we.firefox && Se >= 23 || we.node)) {
            if (we.node)
              ve -= 2;
            else if (n && he && !n.location.href.indexOf(he)) {
              var it = s.getElementsByTagName("html")[0].innerHTML;
              ve = it.substr(0, it.indexOf(R) + 1).match(
                Ge
              ).length + 1;
            }
            Ae = ve > 0 && !(we.chrome && Se >= 36 || we.safari && Se >= 600 || we.firefox && Se >= 40 || we.node);
            var gt = ["AA" + ae(Ae ? 0 : ve) + "A"];
            gt.length = (R.match(Ge) || []).length + 1 + (Ae ? ve : 0), Je = {
              version: 3,
              file: he,
              names: [],
              mappings: gt.join(";AACA"),
              sourceRoot: "",
              sources: [he],
              sourcesContent: [de]
            };
          }
          return (se.operatorOverloading !== !1 || se.moduleExports !== !1) && ie(u(R, {
            ranges: !0,
            preserveParens: !0,
            sourceType: "module"
          }), null, se), Je && (Ae && (R = new Array(ve + 1).join(`
`) + R), /^(inline|both)$/.test(pe) && (R += `
//# sourceMappingURL=data:application/json;base64,` + e.btoa(unescape(encodeURIComponent(
            JSON.stringify(Je)
          )))), R += `
//# sourceURL=` + (he || "paperscript")), {
            url: he,
            source: de,
            code: R,
            map: Je
          };
        }
        function E(R, Y, k) {
          He = Y;
          var z = Y.getView(), C = /\btool\.\w+|\s+on(?:Key|Mouse)(?:Up|Down|Move|Drag)\b/.test(R) && !/\bnew\s+Tool\b/.test(R) ? new Ee() : null, I = C ? C._events : [], j = ["onFrame", "onResize"].concat(I), q = [], H = [], ie, ae = typeof R == "object" ? R : L(R, k);
          R = ae.code;
          function he(Se, Ae) {
            for (var Ge in Se)
              (Ae || !/^_/.test(Ge)) && new RegExp("([\\b\\s\\W]|^)" + Ge.replace(/\$/g, "\\$") + "\\b").test(R) && (q.push(Ge), H.push(Se[Ge]));
          }
          he(
            { __$__: y, $__: S, paper: Y, tool: C },
            !0
          ), he(Y), R = "var module = { exports: {} }; " + R;
          var ve = o.each(j, function(Se) {
            new RegExp("\\s+" + Se + "\\b").test(R) && (q.push(Se), this.push("module.exports." + Se + " = " + Se + ";"));
          }, []).join(`
`);
          ve && (R += `
` + ve), R += `
return module.exports;`;
          var pe = He.agent;
          if (s && (pe.chrome || pe.firefox && pe.versionNumber < 40)) {
            var se = s.createElement("script"), de = s.head || s.getElementsByTagName("head")[0];
            pe.firefox && (R = `
` + R), se.appendChild(s.createTextNode(
              "document.__paperscript__ = function(" + q + ") {" + R + `
}`
            )), de.appendChild(se), ie = s.__paperscript__, delete s.__paperscript__, de.removeChild(se);
          } else
            ie = Function(q, R);
          var ve = ie && ie.apply(Y, H), we = ve || {};
          return o.each(I, function(Se) {
            var Ae = we[Se];
            Ae && (C[Se] = Ae);
          }), z && (we.onResize && z.setOnResize(we.onResize), z.emit("resize", {
            size: z.size,
            delta: new M()
          }), we.onFrame && z.setOnFrame(we.onFrame), z.requestUpdate()), ve;
        }
        function A(R) {
          if (/^text\/(?:x-|)paperscript$/.test(R.type) && c.getAttribute(R, "ignore") !== "true") {
            var Y = c.getAttribute(R, "canvas"), k = s.getElementById(Y), z = R.src || R.getAttribute("data-src"), C = c.hasAttribute(R, "async"), I = "data-paper-scope";
            if (!k)
              throw new Error('Unable to find canvas with id "' + Y + '"');
            var j = c.get(k.getAttribute(I)) || new c().setup(k);
            return k.setAttribute(I, j._id), z ? kt.request({
              url: z,
              async: C,
              mimeType: "text/plain",
              onLoad: function(q) {
                E(q, j, z);
              }
            }) : E(R.innerHTML, j, R.baseURI), R.setAttribute("data-paper-ignore", "true"), j;
          }
        }
        function T() {
          o.each(
            s && s.getElementsByTagName("script"),
            A
          );
        }
        function G(R) {
          return R ? A(R) : T();
        }
        return n && (s.readyState === "complete" ? setTimeout(T) : $t.add(n, { load: T })), {
          compile: L,
          execute: E,
          load: G,
          parse: u,
          calculateBinary: y,
          calculateUnary: S
        };
      }).call(this);
      var He = new (c.inject(o.exports, {
        Base: o,
        Numerical: P,
        Key: Ct,
        DomEvent: $t,
        DomElement: Wt,
        document: s,
        window: n,
        Symbol: Le,
        PlacedSymbol: pt
      }))();
      return He.agent.node && Mf(He), typeof t == "function" && t.amd ? t("paper", He) : b && (b.exports = He), He;
    }).call($y, typeof self == "object" ? self : null);
  }(Vh)), Vh.exports;
}
var Ky = Xy();
const Af = /* @__PURE__ */ Gy(Ky);
class Jy {
  constructor() {
    Qo(this, "_paperScope", new Af.PaperScope()), Qo(this, "_baseMaterial", null), Qo(this, "_borderMaterial", null), Qo(this, "transparentMaterial", null);
    const e = document.createElement("canvas");
    e.width = 1, e.height = 1, this._paperScope.setup(new Af.Size(1, 1));
  }
  async generatePreview3D(e, t) {
    if (!e.columns || isNaN(e.columns) || e.columns < 1 || e.rows < 1 || !e.rows || isNaN(e.rows))
      throw new Error("Invalid columns or rows value. Columns and rows must be greater than 0 and must be a number.");
    console.log("Generating 3D preview for resizable canvas...", e);
    const { textureWidth: n, textureHeight: s } = await this.prepareMaterials(e, t), o = e.shape === "ellipse" ? await this.generateEllipseMesh(e, t, n, s) : this.buildRectangleMeshGroups(e, t, n, s);
    if (!o)
      return null;
    const {
      bordersList: h,
      backsList: c,
      frontsList: _,
      texturedBordersList: x,
      texturedBacksList: B,
      texturedFrontsList: P
    } = o, U = new BABYLON.Mesh("groupMesh", t), M = BABYLON.Mesh.MergeMeshes(h, !0, !0, void 0, !1, !1), Z = BABYLON.Mesh.MergeMeshes(c, !0, !0, void 0, !1, !1), F = BABYLON.Mesh.MergeMeshes(_, !0, !0, void 0, !1, !1), Q = BABYLON.Mesh.MergeMeshes(x, !0, !0, void 0, !1, !1), D = BABYLON.Mesh.MergeMeshes(B, !0, !0, void 0, !1, !1), te = BABYLON.Mesh.MergeMeshes(P, !0, !0, void 0, !1, !1);
    if (!M || !Z || !F || !Q || !D || !te)
      return null;
    M.material = this.transparentMaterial, Z.material = this.transparentMaterial, F.material = this.transparentMaterial, Q.material = this._borderMaterial, D.material = this._baseMaterial, te.material = this._baseMaterial, M.parent = U, Z.parent = U, F.parent = U, Q.parent = U, D.parent = U, te.parent = U, M.name = "borders", Z.name = "back", F.name = "front", Q.name = "texturedBorders", D.name = "texturedBack", te.name = "texturedFront";
    const ee = BABYLON.SceneSerializer.SerializeMesh(U, !1, !0);
    return U.dispose(), [...h, ...c, ..._, ...x, ...B, ...P].forEach(
      (le) => le && !le.isDisposed() && le.dispose()
    ), ee;
  }
  // Common material preparation
  async prepareMaterials(e, t) {
    this._baseMaterial || (this._baseMaterial = new BABYLON.PBRMaterial("baseMaterial", t)), this._borderMaterial || (this._borderMaterial = new BABYLON.PBRMaterial("borderMaterial", t)), this.transparentMaterial || (this.transparentMaterial = new BABYLON.StandardMaterial("transparentMaterial", t)), this._baseMaterial.albedoColor = BABYLON.Color3.FromHexString(e.backgroundColor ?? "#FFFFFF"), this._baseMaterial.metallic = 0, this._baseMaterial.roughness = 0.5, this._borderMaterial.albedoColor = BABYLON.Color3.FromHexString(e.borderColor ?? e.backgroundColor ?? "#000000"), this._borderMaterial.metallic = 0, this._borderMaterial.roughness = 0.5, this.transparentMaterial.alpha = 0, this.transparentMaterial.backFaceCulling = !0, this.transparentMaterial.diffuseColor = BABYLON.Color3.FromHexString("#FF0000");
    let n, s;
    const o = (h) => {
      h && (h.wrapU = BABYLON.Texture.CLAMP_ADDRESSMODE, h.wrapV = BABYLON.Texture.CLAMP_ADDRESSMODE);
    };
    if (e.useCheckerTexture) {
      const h = new Image();
      h.src = "https://zakekecdn.blob.core.windows.net/cdn/Test/checker_texture.png", await new Promise((c, _) => {
        h.onload = () => c(null), h.onerror = (x) => _(x);
      }), n = h.width, s = h.height, this._baseMaterial.albedoTexture = new BABYLON.Texture(
        "https://zakekecdn.blob.core.windows.net/cdn/Test/checker_texture.png",
        t
      ), o(this._baseMaterial.albedoTexture), this._borderMaterial.albedoTexture = new BABYLON.Texture(
        "https://zakekecdn.blob.core.windows.net/cdn/Test/checker_texture.png",
        t
      ), o(this._borderMaterial.albedoTexture);
    } else if (e.backgroundUrl) {
      const h = new Image();
      h.src = e.backgroundUrl, await new Promise((c, _) => {
        h.onload = () => c(null), h.onerror = (x) => _(x);
      }), n = h.width, s = h.height, this._baseMaterial.albedoTexture = new BABYLON.Texture(e.backgroundUrl, t), o(this._baseMaterial.albedoTexture), this._baseMaterial.albedoColor = new BABYLON.Color3(1, 1, 1), e.borderColor || (this._borderMaterial.albedoTexture = new BABYLON.Texture(e.backgroundUrl, t), o(this._borderMaterial.albedoTexture), this._borderMaterial.albedoColor = new BABYLON.Color3(1, 1, 1));
    }
    return { textureWidth: n, textureHeight: s };
  }
  // Rectangle mesh groups builder (non-ellipse)
  buildRectangleMeshGroups(e, t, n, s) {
    const o = [], h = [], c = [], _ = [], x = [], B = [];
    for (let P = 0; P < e.columns; P++)
      for (let U = 0; U < e.rows; U++) {
        const [M, Z, F] = this.generateCanvasMesh(e, t, P, U, !1), [Q, D, te] = this.generateCanvasMesh(e, t, P, U, !0, n, s);
        o.push(M), h.push(Z), c.push(F), _.push(Q), x.push(D), B.push(te);
      }
    return { bordersList: o, backsList: h, frontsList: c, texturedBordersList: _, texturedBacksList: x, texturedFrontsList: B };
  }
  // Procedural extruded ellipse (filled). Generates vertices, normals, uvs, indices manually.
  async generateEllipseMesh(e, t, n, s) {
    const o = e.width / 2, h = e.height / 2;
    let c;
    if (e.radiusResolution && e.radiusResolution > 1)
      c = Math.max(8, Math.round(e.radiusResolution));
    else {
      const a = e.radiusResolution && e.radiusResolution > 0 ? e.radiusResolution : 0.1;
      c = Math.max(32, Math.round(2 * Math.PI / a));
    }
    const _ = e.depth, x = _ / 2, B = -_ / 2;
    let P = 1, U = 1, M = 0, Z = 0;
    if (n && s) {
      const a = n / s, l = 2 * o / (2 * h);
      a > l ? (U = 1, P = l / a, M = (P - 1) / 2, Z = 0) : (P = 1, U = a / l, M = 0, Z = (U - 1) / 2);
    }
    const F = (a, l) => ({ u: a / (2 * o) + 0.5, v: l / (2 * h) + 0.5 }), Q = [], D = [], te = [], ee = [], le = (a, l, u, d, v) => {
      Q.push(a, l, u), D.push(0, 0, 1), te.push(d, v);
    };
    let fe = F(0, 0);
    le(0, 0, x, fe.u, fe.v);
    for (let a = 0; a < c; a++) {
      const l = a / c * Math.PI * 2, u = Math.cos(l) * o, d = Math.sin(l) * h, v = F(u, d);
      le(u, d, x, v.u, v.v);
    }
    for (let a = 0; a < c; a++) {
      const l = 1 + a, u = 1 + (a + 1) % c;
      ee.push(0, u, l);
    }
    const X = [], W = [], je = [], ke = [], Ye = (a, l, u, d, v) => {
      X.push(a, l, u), W.push(0, 0, -1), je.push(d, v);
    };
    fe = F(0, 0), Ye(0, 0, B, fe.u, fe.v);
    for (let a = 0; a < c; a++) {
      const l = a / c * Math.PI * 2, u = Math.cos(l) * o, d = Math.sin(l) * h, v = F(u, d);
      Ye(u, d, B, v.u, v.v);
    }
    for (let a = 0; a < c; a++) {
      const l = 1 + a, u = 1 + (a + 1) % c;
      ke.push(0, l, u);
    }
    const pt = [], Le = [], $e = [], ce = [], ht = (a, l, u, d, v, p, y, S) => {
      pt.push(a, l, u), Le.push(d, v, p), $e.push(y, S);
    };
    for (let a = 0; a < c; a++) {
      const l = a / c * Math.PI * 2, u = Math.cos(l) * o, d = Math.sin(l) * h;
      let v = u / o, p = d / h;
      const y = Math.hypot(v, p);
      y > 0 && (v /= y, p /= y);
      const S = a / c, L = S <= 0.5 ? S * 2 : (1 - S) * 2, E = 1, A = 1 - L;
      ht(u, d, B, v, p, 0, E, A);
    }
    for (let a = 0; a < c; a++) {
      const l = a / c * Math.PI * 2, u = Math.cos(l) * o, d = Math.sin(l) * h;
      let v = u / o, p = d / h;
      const y = Math.hypot(v, p);
      y > 0 && (v /= y, p /= y);
      const S = a / c, L = S <= 0.5 ? S * 2 : (1 - S) * 2, E = 0, A = 1 - L;
      ht(u, d, x, v, p, 0, E, A);
    }
    const De = c;
    for (let a = 0; a < c; a++) {
      const l = a, u = (a + 1) % c, d = De + a, v = De + (a + 1) % c;
      ce.push(l, d, v), ce.push(l, v, u);
    }
    const ft = new BABYLON.Mesh("groupMeshEllipse", t), Yt = new BABYLON.Mesh("back", t), We = new BABYLON.Mesh("front", t), It = new BABYLON.Mesh("borders", t), rt = new BABYLON.VertexData();
    rt.positions = Q, rt.normals = D, rt.uvs = te, rt.indices = ee, rt.applyToMesh(Yt);
    const tt = new BABYLON.VertexData();
    tt.positions = X, tt.normals = W, tt.uvs = je, tt.indices = ke, tt.applyToMesh(We);
    const Kt = new BABYLON.VertexData();
    Kt.positions = pt, Kt.normals = Le, Kt.uvs = $e, Kt.indices = ce, Kt.applyToMesh(It), this._baseMaterial || (this._baseMaterial = new BABYLON.PBRMaterial("ellipseBaseMat", t)), this._borderMaterial || (this._borderMaterial = new BABYLON.PBRMaterial("ellipseBorderMat", t)), Yt.material = this._baseMaterial, We.material = this._baseMaterial, It.material = this._borderMaterial, Yt.parent = ft, We.parent = ft, It.parent = ft;
    const qt = (a, l) => {
      let u = a / (2 * o) + 0.5, d = l / (2 * h) + 0.5;
      return u = u * P - M, d = d * U - Z, { u, v: d };
    }, Lt = [], Ci = [], ji = [], _i = [], Wt = (a, l, u, d, v) => {
      Lt.push(a, l, u), Ci.push(0, 0, -1), ji.push(d, v);
    };
    let $t = F(0, 0);
    Wt(0, 0, B, $t.u, $t.v);
    for (let a = 0; a < c; a++) {
      const l = a / c * Math.PI * 2, u = Math.cos(l) * o, d = Math.sin(l) * h, v = qt(u, d);
      Wt(u, d, B, v.u, v.v);
    }
    for (let a = 0; a < c; a++) {
      const l = 1 + a, u = 1 + (a + 1) % c;
      _i.push(0, l, u);
    }
    const ei = [], tn = [], Fi = [], _e = [], Ct = (a, l, u, d, v) => {
      ei.push(a, l, u), tn.push(0, 0, 1), Fi.push(d, v);
    };
    $t = F(0, 0), Ct(0, 0, x, $t.u, $t.v);
    for (let a = 0; a < c; a++) {
      const l = a / c * Math.PI * 2, u = Math.cos(l) * o, d = Math.sin(l) * h, v = qt(u, d);
      Ct(u, d, x, v.u, v.v);
    }
    for (let a = 0; a < c; a++) {
      const l = 1 + a, u = 1 + (a + 1) % c;
      _e.push(0, u, l);
    }
    const yt = [], Re = [], Ee = [], et = [], kt = (a, l, u, d, v, p, y, S) => {
      yt.push(a, l, u), Re.push(d, v, p), Ee.push(y, S);
    };
    for (let a = 0; a < c; a++) {
      const l = a / c * Math.PI * 2, u = Math.cos(l) * o, d = Math.sin(l) * h;
      let v = u / o, p = d / h;
      const y = Math.hypot(v, p);
      y > 0 && (v /= y, p /= y);
      const S = a / c;
      kt(u, d, B, v, p, 0, S, 0);
    }
    for (let a = 0; a < c; a++) {
      const l = a / c * Math.PI * 2, u = Math.cos(l) * o, d = Math.sin(l) * h;
      let v = u / o, p = d / h;
      const y = Math.hypot(v, p);
      y > 0 && (v /= y, p /= y);
      const S = a / c;
      kt(u, d, x, v, p, 0, S, 1);
    }
    const mt = c;
    for (let a = 0; a < c; a++) {
      const l = a, u = (a + 1) % c, d = mt + a, v = mt + (a + 1) % c;
      et.push(l, d, v), et.push(l, v, u);
    }
    const Qe = new BABYLON.Mesh("texturedBack", t), bt = new BABYLON.Mesh("texturedFront", t), Gt = new BABYLON.Mesh("texturedBorders", t), He = new BABYLON.VertexData();
    He.positions = ei, He.normals = tn, He.uvs = Fi, He.indices = _e, He.applyToMesh(Qe);
    const i = new BABYLON.VertexData();
    i.positions = Lt, i.normals = Ci, i.uvs = ji, i.indices = _i, i.applyToMesh(bt);
    const r = new BABYLON.VertexData();
    return r.positions = yt, r.normals = Re, r.uvs = Ee, r.indices = et, r.applyToMesh(Gt), Qe.material = this._baseMaterial, bt.material = this._baseMaterial, Gt.material = this._borderMaterial, Qe.parent = ft, bt.parent = ft, Gt.parent = ft, {
      bordersList: [It],
      backsList: [Yt],
      frontsList: [We],
      texturedBordersList: [Gt],
      texturedBacksList: [Qe],
      texturedFrontsList: [bt]
    };
  }
  generateCanvasMesh(e, t, n, s, o = !1, h, c) {
    const _ = e.width / e.columns, x = e.height / e.rows, B = _ * 0.1, P = BABYLON.MeshBuilder.CreateBox(
      "borders",
      {
        width: _,
        height: x,
        depth: e.depth
      },
      t
    ), U = BABYLON.MeshBuilder.CreatePlane(
      "front",
      {
        width: _,
        height: x
      },
      t
    ), M = BABYLON.MeshBuilder.CreatePlane(
      "back",
      {
        width: _,
        height: x
      },
      t
    );
    P.position = new BABYLON.Vector3(_ / 2 + n * (_ + B), x / 2 + s * (x + B)), U.position = new BABYLON.Vector3(_ / 2 + n * (_ + B), x / 2 + s * (x + B), -e.depth / 2), M.position = new BABYLON.Vector3(_ / 2 + n * (_ + B), x / 2 + s * (x + B), e.depth / 2), M.rotate(BABYLON.Axis.X, Math.PI, BABYLON.Space.WORLD), M.rotate(BABYLON.Axis.Z, Math.PI, BABYLON.Space.WORLD), P.material = this._borderMaterial, M.material = this._borderMaterial, U.material = this._baseMaterial;
    const Z = P.getVerticesData(BABYLON.VertexBuffer.NormalKind), F = P.getVerticesData(BABYLON.VertexBuffer.UVKind), Q = U.getVerticesData(BABYLON.VertexBuffer.UVKind), D = M.getVerticesData(BABYLON.VertexBuffer.UVKind);
    e.borderRadius > 0 && console.warn("Mirror canvas effect will not work for border radius > 0"), e.borderRadius === 0 && (o && h && c ? this.applyTexturedUVMapping(
      e,
      P,
      U,
      M,
      F,
      Q,
      D,
      Z,
      _,
      x,
      n,
      s,
      h,
      c
    ) : this.applyMirrorUVMapping(e, P, U, M, F, Q, D, Z, _, x, n, s)), U.isVisible = !1, M.isVisible = !1;
    const te = P.getVerticesData(BABYLON.VertexBuffer.PositionKind) ?? [], ee = P.getVerticesData(BABYLON.VertexBuffer.NormalKind) ?? [], le = P.getVerticesData(BABYLON.VertexBuffer.UVKind) ?? [], fe = P.getIndices() ?? [];
    return te.splice(0, 24), ee.splice(0, 24), le.splice(0, 16), fe.splice(fe.length - 12, 12), P.updateVerticesData(BABYLON.VertexBuffer.PositionKind, te), P.updateVerticesData(BABYLON.VertexBuffer.NormalKind, ee), P.updateVerticesData(BABYLON.VertexBuffer.UVKind, le), P.updateIndices(fe), [P, M, U];
  }
  // This method generate a UV map that stretches with the mesh, the aspect ratio
  // is compensated in the MeshSide canvas matrix.
  applyMirrorUVMapping(e, t, n, s, o, h, c, _, x, B, P, U) {
    const M = e.depth / e.width, Z = e.depth / e.height, F = Math.min(M, Z), Q = x / e.width, D = B / e.height;
    for (var te = 0; te < o.length; te += 2) {
      const fe = Math.round(_[te / 2 * 3]), X = Math.round(_[te / 2 * 3 + 1]), W = Math.round(_[te / 2 * 3 + 2]), je = fe == -1 && X == 0 && W == 0, ke = fe == 1 && X == 0 && W == 0, Ye = fe == 0 && X == 1 && W == 0, pt = fe == 0 && X == -1 && W == 0;
      if (je) {
        var ee = o[te], le = o[te + 1];
        o[te] = le * F + Q * P, o[te + 1] = ee * D + D * U;
      }
      if (ke) {
        var ee = o[te], le = o[te + 1];
        o[te] = le * F + (1 - F) - Q * (e.columns - 1 - P), o[te + 1] = ee * D + D * U;
      }
      if (pt) {
        var ee = o[te], le = o[te + 1];
        o[te] = le * Q + Q * P, o[te + 1] = ee * F + D * U;
      }
      if (Ye) {
        var ee = o[te], le = o[te + 1];
        o[te] = (-le + 1) * Q + Q * P, o[te + 1] = (-ee + 1) * F + (1 - F);
      }
    }
    t.setVerticesData(BABYLON.VertexBuffer.UVKind, o);
    for (var te = 0; te < h.length; te += 2) {
      var ee = h[te], le = h[te + 1];
      h[te] = ee * Q + Q * P, h[te + 1] = le * D + D * U;
    }
    n.setVerticesData(BABYLON.VertexBuffer.UVKind, h);
    for (var te = 0; te < c.length; te += 2) {
      var ee = c[te], le = c[te + 1];
      c[te] = ee * Q + Q * (e.columns - 1 - P), c[te + 1] = le * D + D * U;
    }
    s.setVerticesData(BABYLON.VertexBuffer.UVKind, c);
  }
  // This method generate a UV map that don't stretch with the mesh.
  applyTexturedUVMapping(e, t, n, s, o, h, c, _, x, B, P, U, M, Z) {
    const F = M / Z, Q = e.width / e.height;
    let D, te, ee, le;
    F > Q ? (te = 1, D = Q / F, ee = (D - 1) / 2, le = 0) : (D = 1, te = F / Q, ee = 0, le = (te - 1) / 2);
    const fe = x / e.width, X = B / e.height, W = e.depth / e.width * D, je = e.depth / e.height * te, ke = Math.min(W, je);
    for (var Ye = 0; Ye < o.length; Ye += 2) {
      const $e = Math.round(_[Ye / 2 * 3]), ce = Math.round(_[Ye / 2 * 3 + 1]), ht = Math.round(_[Ye / 2 * 3 + 2]), De = $e == -1 && ce == 0 && ht == 0, ft = $e == 1 && ce == 0 && ht == 0, Yt = $e == 0 && ce == 1 && ht == 0, We = $e == 0 && ce == -1 && ht == 0;
      if (De) {
        var pt = o[Ye], Le = o[Ye + 1];
        o[Ye] = (Le * ke + fe * P) * D - ee, o[Ye + 1] = (pt * X + X * U) * te - le;
      }
      if (ft) {
        var pt = o[Ye], Le = o[Ye + 1];
        o[Ye] = (Le * ke + (1 - ke) - fe * (e.columns - 1 - P)) * D - ee, o[Ye + 1] = (pt * X + X * U) * te - le;
      }
      if (We) {
        var pt = o[Ye], Le = o[Ye + 1];
        o[Ye] = (Le * fe + fe * P) * D - ee, o[Ye + 1] = (pt * ke + X * U) * te - le;
      }
      if (Yt) {
        var pt = o[Ye], Le = o[Ye + 1];
        o[Ye] = ((-Le + 1) * fe + fe * P) * D - ee, o[Ye + 1] = ((-pt + 1) * ke + (1 - ke)) * te - le;
      }
    }
    t.setVerticesData(BABYLON.VertexBuffer.UVKind, o);
    for (var Ye = 0; Ye < h.length; Ye += 2) {
      var pt = h[Ye], Le = h[Ye + 1];
      h[Ye] = (pt * fe + fe * P) * D - ee, h[Ye + 1] = (Le * X + X * U) * te - le;
    }
    n.setVerticesData(BABYLON.VertexBuffer.UVKind, h);
    for (var Ye = 0; Ye < c.length; Ye += 2) {
      var pt = c[Ye], Le = c[Ye + 1];
      c[Ye] = (pt * fe + fe * (e.columns - 1 - P)) * D - ee, c[Ye + 1] = (Le * X + X * U) * te - le;
    }
    s.setVerticesData(BABYLON.VertexBuffer.UVKind, c);
  }
}
function pd(b, e) {
  return function() {
    return b.apply(e, arguments);
  };
}
const { toString: Qy } = Object.prototype, { getPrototypeOf: Al } = Object, { iterator: Tl, toStringTag: md } = Symbol, Ll = ((b) => (e) => {
  const t = Qy.call(e);
  return b[t] || (b[t] = t.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), ps = (b) => (b = b.toLowerCase(), (e) => Ll(e) === b), Bl = (b) => (e) => typeof e === b, { isArray: Ea } = Array, Ba = Bl("undefined");
function co(b) {
  return b !== null && !Ba(b) && b.constructor !== null && !Ba(b.constructor) && Ir(b.constructor.isBuffer) && b.constructor.isBuffer(b);
}
const _d = ps("ArrayBuffer");
function eb(b) {
  let e;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? e = ArrayBuffer.isView(b) : e = b && b.buffer && _d(b.buffer), e;
}
const tb = Bl("string"), Ir = Bl("function"), vd = Bl("number"), fo = (b) => b !== null && typeof b == "object", ib = (b) => b === !0 || b === !1, al = (b) => {
  if (Ll(b) !== "object")
    return !1;
  const e = Al(b);
  return (e === null || e === Object.prototype || Object.getPrototypeOf(e) === null) && !(md in b) && !(Tl in b);
}, nb = (b) => {
  if (!fo(b) || co(b))
    return !1;
  try {
    return Object.keys(b).length === 0 && Object.getPrototypeOf(b) === Object.prototype;
  } catch {
    return !1;
  }
}, rb = ps("Date"), sb = ps("File"), ab = (b) => !!(b && typeof b.uri < "u"), ob = (b) => b && typeof b.getParts < "u", lb = ps("Blob"), hb = ps("FileList"), ub = (b) => fo(b) && Ir(b.pipe);
function cb() {
  return typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {};
}
const Tf = cb(), Lf = typeof Tf.FormData < "u" ? Tf.FormData : void 0, fb = (b) => {
  if (!b)
    return !1;
  if (Lf && b instanceof Lf)
    return !0;
  const e = Al(b);
  if (!e || e === Object.prototype || !Ir(b.append))
    return !1;
  const t = Ll(b);
  return t === "formdata" || // detect form-data instance
  t === "object" && Ir(b.toString) && b.toString() === "[object FormData]";
}, db = ps("URLSearchParams"), [gb, pb, mb, _b] = [
  "ReadableStream",
  "Request",
  "Response",
  "Headers"
].map(ps), vb = (b) => b.trim ? b.trim() : b.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function go(b, e, { allOwnKeys: t = !1 } = {}) {
  if (b === null || typeof b > "u")
    return;
  let n, s;
  if (typeof b != "object" && (b = [b]), Ea(b))
    for (n = 0, s = b.length; n < s; n++)
      e.call(null, b[n], n, b);
  else {
    if (co(b))
      return;
    const o = t ? Object.getOwnPropertyNames(b) : Object.keys(b), h = o.length;
    let c;
    for (n = 0; n < h; n++)
      c = o[n], e.call(null, b[c], c, b);
  }
}
function yd(b, e) {
  if (co(b))
    return null;
  e = e.toLowerCase();
  const t = Object.keys(b);
  let n = t.length, s;
  for (; n-- > 0; )
    if (s = t[n], e === s.toLowerCase())
      return s;
  return null;
}
const ha = (() => typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global)(), bd = (b) => !Ba(b) && b !== ha;
function Hh() {
  const { caseless: b, skipUndefined: e } = bd(this) && this || {}, t = {}, n = (s, o) => {
    if (o === "__proto__" || o === "constructor" || o === "prototype")
      return;
    const h = b && yd(t, o) || o;
    al(t[h]) && al(s) ? t[h] = Hh(t[h], s) : al(s) ? t[h] = Hh({}, s) : Ea(s) ? t[h] = s.slice() : (!e || !Ba(s)) && (t[h] = s);
  };
  for (let s = 0, o = arguments.length; s < o; s++)
    arguments[s] && go(arguments[s], n);
  return t;
}
const yb = (b, e, t, { allOwnKeys: n } = {}) => (go(
  e,
  (s, o) => {
    t && Ir(s) ? Object.defineProperty(b, o, {
      value: pd(s, t),
      writable: !0,
      enumerable: !0,
      configurable: !0
    }) : Object.defineProperty(b, o, {
      value: s,
      writable: !0,
      enumerable: !0,
      configurable: !0
    });
  },
  { allOwnKeys: n }
), b), bb = (b) => (b.charCodeAt(0) === 65279 && (b = b.slice(1)), b), xb = (b, e, t, n) => {
  b.prototype = Object.create(e.prototype, n), Object.defineProperty(b.prototype, "constructor", {
    value: b,
    writable: !0,
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(b, "super", {
    value: e.prototype
  }), t && Object.assign(b.prototype, t);
}, wb = (b, e, t, n) => {
  let s, o, h;
  const c = {};
  if (e = e || {}, b == null)
    return e;
  do {
    for (s = Object.getOwnPropertyNames(b), o = s.length; o-- > 0; )
      h = s[o], (!n || n(h, b, e)) && !c[h] && (e[h] = b[h], c[h] = !0);
    b = t !== !1 && Al(b);
  } while (b && (!t || t(b, e)) && b !== Object.prototype);
  return e;
}, Sb = (b, e, t) => {
  b = String(b), (t === void 0 || t > b.length) && (t = b.length), t -= e.length;
  const n = b.indexOf(e, t);
  return n !== -1 && n === t;
}, Mb = (b) => {
  if (!b)
    return null;
  if (Ea(b))
    return b;
  let e = b.length;
  if (!vd(e))
    return null;
  const t = new Array(e);
  for (; e-- > 0; )
    t[e] = b[e];
  return t;
}, Cb = ((b) => (e) => b && e instanceof b)(typeof Uint8Array < "u" && Al(Uint8Array)), Ab = (b, e) => {
  const n = (b && b[Tl]).call(b);
  let s;
  for (; (s = n.next()) && !s.done; ) {
    const o = s.value;
    e.call(b, o[0], o[1]);
  }
}, Tb = (b, e) => {
  let t;
  const n = [];
  for (; (t = b.exec(e)) !== null; )
    n.push(t);
  return n;
}, Lb = ps("HTMLFormElement"), Bb = (b) => b.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(t, n, s) {
  return n.toUpperCase() + s;
}), Bf = (({ hasOwnProperty: b }) => (e, t) => b.call(e, t))(Object.prototype), kb = ps("RegExp"), xd = (b, e) => {
  const t = Object.getOwnPropertyDescriptors(b), n = {};
  go(t, (s, o) => {
    let h;
    (h = e(s, o, b)) !== !1 && (n[o] = h || s);
  }), Object.defineProperties(b, n);
}, Eb = (b) => {
  xd(b, (e, t) => {
    if (Ir(b) && ["arguments", "caller", "callee"].indexOf(t) !== -1)
      return !1;
    const n = b[t];
    if (Ir(n)) {
      if (e.enumerable = !1, "writable" in e) {
        e.writable = !1;
        return;
      }
      e.set || (e.set = () => {
        throw Error("Can not rewrite read-only method '" + t + "'");
      });
    }
  });
}, Ib = (b, e) => {
  const t = {}, n = (s) => {
    s.forEach((o) => {
      t[o] = !0;
    });
  };
  return Ea(b) ? n(b) : n(String(b).split(e)), t;
}, Pb = () => {
}, Ob = (b, e) => b != null && Number.isFinite(b = +b) ? b : e;
function Nb(b) {
  return !!(b && Ir(b.append) && b[md] === "FormData" && b[Tl]);
}
const Rb = (b) => {
  const e = new Array(10), t = (n, s) => {
    if (fo(n)) {
      if (e.indexOf(n) >= 0)
        return;
      if (co(n))
        return n;
      if (!("toJSON" in n)) {
        e[s] = n;
        const o = Ea(n) ? [] : {};
        return go(n, (h, c) => {
          const _ = t(h, s + 1);
          !Ba(_) && (o[c] = _);
        }), e[s] = void 0, o;
      }
    }
    return n;
  };
  return t(b, 0);
}, Db = ps("AsyncFunction"), zb = (b) => b && (fo(b) || Ir(b)) && Ir(b.then) && Ir(b.catch), wd = ((b, e) => b ? setImmediate : e ? ((t, n) => (ha.addEventListener(
  "message",
  ({ source: s, data: o }) => {
    s === ha && o === t && n.length && n.shift()();
  },
  !1
), (s) => {
  n.push(s), ha.postMessage(t, "*");
}))(`axios@${Math.random()}`, []) : (t) => setTimeout(t))(typeof setImmediate == "function", Ir(ha.postMessage)), Fb = typeof queueMicrotask < "u" ? queueMicrotask.bind(ha) : typeof process < "u" && process.nextTick || wd, Ub = (b) => b != null && Ir(b[Tl]), wt = {
  isArray: Ea,
  isArrayBuffer: _d,
  isBuffer: co,
  isFormData: fb,
  isArrayBufferView: eb,
  isString: tb,
  isNumber: vd,
  isBoolean: ib,
  isObject: fo,
  isPlainObject: al,
  isEmptyObject: nb,
  isReadableStream: gb,
  isRequest: pb,
  isResponse: mb,
  isHeaders: _b,
  isUndefined: Ba,
  isDate: rb,
  isFile: sb,
  isReactNativeBlob: ab,
  isReactNative: ob,
  isBlob: lb,
  isRegExp: kb,
  isFunction: Ir,
  isStream: ub,
  isURLSearchParams: db,
  isTypedArray: Cb,
  isFileList: hb,
  forEach: go,
  merge: Hh,
  extend: yb,
  trim: vb,
  stripBOM: bb,
  inherits: xb,
  toFlatObject: wb,
  kindOf: Ll,
  kindOfTest: ps,
  endsWith: Sb,
  toArray: Mb,
  forEachEntry: Ab,
  matchAll: Tb,
  isHTMLForm: Lb,
  hasOwnProperty: Bf,
  hasOwnProp: Bf,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: xd,
  freezeMethods: Eb,
  toObjectSet: Ib,
  toCamelCase: Bb,
  noop: Pb,
  toFiniteNumber: Ob,
  findKey: yd,
  global: ha,
  isContextDefined: bd,
  isSpecCompliantForm: Nb,
  toJSONObject: Rb,
  isAsyncFn: Db,
  isThenable: zb,
  setImmediate: wd,
  asap: Fb,
  isIterable: Ub
};
class fr extends Error {
  static from(e, t, n, s, o, h) {
    const c = new fr(e.message, t || e.code, n, s, o);
    return c.cause = e, c.name = e.name, e.status != null && c.status == null && (c.status = e.status), h && Object.assign(c, h), c;
  }
  /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */
  constructor(e, t, n, s, o) {
    super(e), Object.defineProperty(this, "message", {
      value: e,
      enumerable: !0,
      writable: !0,
      configurable: !0
    }), this.name = "AxiosError", this.isAxiosError = !0, t && (this.code = t), n && (this.config = n), s && (this.request = s), o && (this.response = o, this.status = o.status);
  }
  toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: wt.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
}
fr.ERR_BAD_OPTION_VALUE = "ERR_BAD_OPTION_VALUE";
fr.ERR_BAD_OPTION = "ERR_BAD_OPTION";
fr.ECONNABORTED = "ECONNABORTED";
fr.ETIMEDOUT = "ETIMEDOUT";
fr.ERR_NETWORK = "ERR_NETWORK";
fr.ERR_FR_TOO_MANY_REDIRECTS = "ERR_FR_TOO_MANY_REDIRECTS";
fr.ERR_DEPRECATED = "ERR_DEPRECATED";
fr.ERR_BAD_RESPONSE = "ERR_BAD_RESPONSE";
fr.ERR_BAD_REQUEST = "ERR_BAD_REQUEST";
fr.ERR_CANCELED = "ERR_CANCELED";
fr.ERR_NOT_SUPPORT = "ERR_NOT_SUPPORT";
fr.ERR_INVALID_URL = "ERR_INVALID_URL";
fr.ERR_FORM_DATA_DEPTH_EXCEEDED = "ERR_FORM_DATA_DEPTH_EXCEEDED";
const Ui = fr, Vb = null;
function Yh(b) {
  return wt.isPlainObject(b) || wt.isArray(b);
}
function Sd(b) {
  return wt.endsWith(b, "[]") ? b.slice(0, -2) : b;
}
function kh(b, e, t) {
  return b ? b.concat(e).map(function(s, o) {
    return s = Sd(s), !t && o ? "[" + s + "]" : s;
  }).join(t ? "." : "") : e;
}
function Hb(b) {
  return wt.isArray(b) && !b.some(Yh);
}
const Yb = wt.toFlatObject(wt, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function kl(b, e, t) {
  if (!wt.isObject(b))
    throw new TypeError("target must be an object");
  e = e || new FormData(), t = wt.toFlatObject(
    t,
    {
      metaTokens: !0,
      dots: !1,
      indexes: !1
    },
    !1,
    function(Q, D) {
      return !wt.isUndefined(D[Q]);
    }
  );
  const n = t.metaTokens, s = t.visitor || P, o = t.dots, h = t.indexes, c = t.Blob || typeof Blob < "u" && Blob, _ = t.maxDepth === void 0 ? 100 : t.maxDepth, x = c && wt.isSpecCompliantForm(e);
  if (!wt.isFunction(s))
    throw new TypeError("visitor must be a function");
  function B(F) {
    if (F === null)
      return "";
    if (wt.isDate(F))
      return F.toISOString();
    if (wt.isBoolean(F))
      return F.toString();
    if (!x && wt.isBlob(F))
      throw new Ui("Blob is not supported. Use a Buffer instead.");
    return wt.isArrayBuffer(F) || wt.isTypedArray(F) ? x && typeof Blob == "function" ? new Blob([F]) : Buffer.from(F) : F;
  }
  function P(F, Q, D) {
    let te = F;
    if (wt.isReactNative(e) && wt.isReactNativeBlob(F))
      return e.append(kh(D, Q, o), B(F)), !1;
    if (F && !D && typeof F == "object") {
      if (wt.endsWith(Q, "{}"))
        Q = n ? Q : Q.slice(0, -2), F = JSON.stringify(F);
      else if (wt.isArray(F) && Hb(F) || (wt.isFileList(F) || wt.endsWith(Q, "[]")) && (te = wt.toArray(F)))
        return Q = Sd(Q), te.forEach(function(le, fe) {
          !(wt.isUndefined(le) || le === null) && e.append(
            // eslint-disable-next-line no-nested-ternary
            h === !0 ? kh([Q], fe, o) : h === null ? Q : Q + "[]",
            B(le)
          );
        }), !1;
    }
    return Yh(F) ? !0 : (e.append(kh(D, Q, o), B(F)), !1);
  }
  const U = [], M = Object.assign(Yb, {
    defaultVisitor: P,
    convertValue: B,
    isVisitable: Yh
  });
  function Z(F, Q, D = 0) {
    if (!wt.isUndefined(F)) {
      if (D > _)
        throw new Ui(
          "Object is too deeply nested (" + D + " levels). Max depth: " + _,
          Ui.ERR_FORM_DATA_DEPTH_EXCEEDED
        );
      if (U.indexOf(F) !== -1)
        throw Error("Circular reference detected in " + Q.join("."));
      U.push(F), wt.forEach(F, function(ee, le) {
        (!(wt.isUndefined(ee) || ee === null) && s.call(e, ee, wt.isString(le) ? le.trim() : le, Q, M)) === !0 && Z(ee, Q ? Q.concat(le) : [le], D + 1);
      }), U.pop();
    }
  }
  if (!wt.isObject(b))
    throw new TypeError("data must be an object");
  return Z(b), e;
}
function kf(b) {
  const e = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+"
  };
  return encodeURIComponent(b).replace(/[!'()~]|%20/g, function(n) {
    return e[n];
  });
}
function nu(b, e) {
  this._pairs = [], b && kl(b, this, e);
}
const Md = nu.prototype;
Md.append = function(e, t) {
  this._pairs.push([e, t]);
};
Md.toString = function(e) {
  const t = e ? function(n) {
    return e.call(this, n, kf);
  } : kf;
  return this._pairs.map(function(s) {
    return t(s[0]) + "=" + t(s[1]);
  }, "").join("&");
};
function Gb(b) {
  return encodeURIComponent(b).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function Cd(b, e, t) {
  if (!e)
    return b;
  const n = t && t.encode || Gb, s = wt.isFunction(t) ? {
    serialize: t
  } : t, o = s && s.serialize;
  let h;
  if (o ? h = o(e, s) : h = wt.isURLSearchParams(e) ? e.toString() : new nu(e, s).toString(n), h) {
    const c = b.indexOf("#");
    c !== -1 && (b = b.slice(0, c)), b += (b.indexOf("?") === -1 ? "?" : "&") + h;
  }
  return b;
}
class jb {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(e, t, n) {
    return this.handlers.push({
      fulfilled: e,
      rejected: t,
      synchronous: n ? n.synchronous : !1,
      runWhen: n ? n.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */
  eject(e) {
    this.handlers[e] && (this.handlers[e] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(e) {
    wt.forEach(this.handlers, function(n) {
      n !== null && e(n);
    });
  }
}
const Ef = jb, ru = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1,
  legacyInterceptorReqResOrdering: !0
}, Wb = typeof URLSearchParams < "u" ? URLSearchParams : nu, Zb = typeof FormData < "u" ? FormData : null, qb = typeof Blob < "u" ? Blob : null, $b = {
  isBrowser: !0,
  classes: {
    URLSearchParams: Wb,
    FormData: Zb,
    Blob: qb
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, su = typeof window < "u" && typeof document < "u", Gh = typeof navigator == "object" && navigator || void 0, Xb = su && (!Gh || ["ReactNative", "NativeScript", "NS"].indexOf(Gh.product) < 0), Kb = (() => typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function")(), Jb = su && window.location.href || "http://localhost", Qb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: su,
  hasStandardBrowserEnv: Xb,
  hasStandardBrowserWebWorkerEnv: Kb,
  navigator: Gh,
  origin: Jb
}, Symbol.toStringTag, { value: "Module" })), cr = {
  ...Qb,
  ...$b
};
function ex(b, e) {
  return kl(b, new cr.classes.URLSearchParams(), {
    visitor: function(t, n, s, o) {
      return cr.isNode && wt.isBuffer(t) ? (this.append(n, t.toString("base64")), !1) : o.defaultVisitor.apply(this, arguments);
    },
    ...e
  });
}
function tx(b) {
  return wt.matchAll(/\w+|\[(\w*)]/g, b).map((e) => e[0] === "[]" ? "" : e[1] || e[0]);
}
function ix(b) {
  const e = {}, t = Object.keys(b);
  let n;
  const s = t.length;
  let o;
  for (n = 0; n < s; n++)
    o = t[n], e[o] = b[o];
  return e;
}
function Ad(b) {
  function e(t, n, s, o) {
    let h = t[o++];
    if (h === "__proto__")
      return !0;
    const c = Number.isFinite(+h), _ = o >= t.length;
    return h = !h && wt.isArray(s) ? s.length : h, _ ? (wt.hasOwnProp(s, h) ? s[h] = wt.isArray(s[h]) ? s[h].concat(n) : [s[h], n] : s[h] = n, !c) : ((!s[h] || !wt.isObject(s[h])) && (s[h] = []), e(t, n, s[h], o) && wt.isArray(s[h]) && (s[h] = ix(s[h])), !c);
  }
  if (wt.isFormData(b) && wt.isFunction(b.entries)) {
    const t = {};
    return wt.forEachEntry(b, (n, s) => {
      e(tx(n), s, t, 0);
    }), t;
  }
  return null;
}
const wa = (b, e) => b != null && wt.hasOwnProp(b, e) ? b[e] : void 0;
function nx(b, e, t) {
  if (wt.isString(b))
    try {
      return (e || JSON.parse)(b), wt.trim(b);
    } catch (n) {
      if (n.name !== "SyntaxError")
        throw n;
    }
  return (t || JSON.stringify)(b);
}
const au = {
  transitional: ru,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [
    function(e, t) {
      const n = t.getContentType() || "", s = n.indexOf("application/json") > -1, o = wt.isObject(e);
      if (o && wt.isHTMLForm(e) && (e = new FormData(e)), wt.isFormData(e))
        return s ? JSON.stringify(Ad(e)) : e;
      if (wt.isArrayBuffer(e) || wt.isBuffer(e) || wt.isStream(e) || wt.isFile(e) || wt.isBlob(e) || wt.isReadableStream(e))
        return e;
      if (wt.isArrayBufferView(e))
        return e.buffer;
      if (wt.isURLSearchParams(e))
        return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
      let c;
      if (o) {
        const _ = wa(this, "formSerializer");
        if (n.indexOf("application/x-www-form-urlencoded") > -1)
          return ex(e, _).toString();
        if ((c = wt.isFileList(e)) || n.indexOf("multipart/form-data") > -1) {
          const x = wa(this, "env"), B = x && x.FormData;
          return kl(
            c ? { "files[]": e } : e,
            B && new B(),
            _
          );
        }
      }
      return o || s ? (t.setContentType("application/json", !1), nx(e)) : e;
    }
  ],
  transformResponse: [
    function(e) {
      const t = wa(this, "transitional") || au.transitional, n = t && t.forcedJSONParsing, s = wa(this, "responseType"), o = s === "json";
      if (wt.isResponse(e) || wt.isReadableStream(e))
        return e;
      if (e && wt.isString(e) && (n && !s || o)) {
        const c = !(t && t.silentJSONParsing) && o;
        try {
          return JSON.parse(e, wa(this, "parseReviver"));
        } catch (_) {
          if (c)
            throw _.name === "SyntaxError" ? Ui.from(_, Ui.ERR_BAD_RESPONSE, this, null, wa(this, "response")) : _;
        }
      }
      return e;
    }
  ],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: cr.classes.FormData,
    Blob: cr.classes.Blob
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
wt.forEach(["delete", "get", "head", "post", "put", "patch"], (b) => {
  au.headers[b] = {};
});
const ou = au, rx = wt.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), sx = (b) => {
  const e = {};
  let t, n, s;
  return b && b.split(`
`).forEach(function(h) {
    s = h.indexOf(":"), t = h.substring(0, s).trim().toLowerCase(), n = h.substring(s + 1).trim(), !(!t || e[t] && rx[t]) && (t === "set-cookie" ? e[t] ? e[t].push(n) : e[t] = [n] : e[t] = e[t] ? e[t] + ", " + n : n);
  }), e;
}, If = Symbol("internals"), ax = /[^\x09\x20-\x7E\x80-\xFF]/g;
function ox(b) {
  let e = 0, t = b.length;
  for (; e < t; ) {
    const n = b.charCodeAt(e);
    if (n !== 9 && n !== 32)
      break;
    e += 1;
  }
  for (; t > e; ) {
    const n = b.charCodeAt(t - 1);
    if (n !== 9 && n !== 32)
      break;
    t -= 1;
  }
  return e === 0 && t === b.length ? b : b.slice(e, t);
}
function Wa(b) {
  return b && String(b).trim().toLowerCase();
}
function lx(b) {
  return ox(b.replace(ax, ""));
}
function ol(b) {
  return b === !1 || b == null ? b : wt.isArray(b) ? b.map(ol) : lx(String(b));
}
function hx(b) {
  const e = /* @__PURE__ */ Object.create(null), t = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let n;
  for (; n = t.exec(b); )
    e[n[1]] = n[2];
  return e;
}
const ux = (b) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(b.trim());
function Eh(b, e, t, n, s) {
  if (wt.isFunction(n))
    return n.call(this, e, t);
  if (s && (e = t), !!wt.isString(e)) {
    if (wt.isString(n))
      return e.indexOf(n) !== -1;
    if (wt.isRegExp(n))
      return n.test(e);
  }
}
function cx(b) {
  return b.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (e, t, n) => t.toUpperCase() + n);
}
function fx(b, e) {
  const t = wt.toCamelCase(" " + e);
  ["get", "set", "has"].forEach((n) => {
    Object.defineProperty(b, n + t, {
      value: function(s, o, h) {
        return this[n].call(this, e, s, o, h);
      },
      configurable: !0
    });
  });
}
class El {
  constructor(e) {
    e && this.set(e);
  }
  set(e, t, n) {
    const s = this;
    function o(c, _, x) {
      const B = Wa(_);
      if (!B)
        throw new Error("header name must be a non-empty string");
      const P = wt.findKey(s, B);
      (!P || s[P] === void 0 || x === !0 || x === void 0 && s[P] !== !1) && (s[P || _] = ol(c));
    }
    const h = (c, _) => wt.forEach(c, (x, B) => o(x, B, _));
    if (wt.isPlainObject(e) || e instanceof this.constructor)
      h(e, t);
    else if (wt.isString(e) && (e = e.trim()) && !ux(e))
      h(sx(e), t);
    else if (wt.isObject(e) && wt.isIterable(e)) {
      let c = {}, _, x;
      for (const B of e) {
        if (!wt.isArray(B))
          throw TypeError("Object iterator must return a key-value pair");
        c[x = B[0]] = (_ = c[x]) ? wt.isArray(_) ? [..._, B[1]] : [_, B[1]] : B[1];
      }
      h(c, t);
    } else
      e != null && o(t, e, n);
    return this;
  }
  get(e, t) {
    if (e = Wa(e), e) {
      const n = wt.findKey(this, e);
      if (n) {
        const s = this[n];
        if (!t)
          return s;
        if (t === !0)
          return hx(s);
        if (wt.isFunction(t))
          return t.call(this, s, n);
        if (wt.isRegExp(t))
          return t.exec(s);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, t) {
    if (e = Wa(e), e) {
      const n = wt.findKey(this, e);
      return !!(n && this[n] !== void 0 && (!t || Eh(this, this[n], n, t)));
    }
    return !1;
  }
  delete(e, t) {
    const n = this;
    let s = !1;
    function o(h) {
      if (h = Wa(h), h) {
        const c = wt.findKey(n, h);
        c && (!t || Eh(n, n[c], c, t)) && (delete n[c], s = !0);
      }
    }
    return wt.isArray(e) ? e.forEach(o) : o(e), s;
  }
  clear(e) {
    const t = Object.keys(this);
    let n = t.length, s = !1;
    for (; n--; ) {
      const o = t[n];
      (!e || Eh(this, this[o], o, e, !0)) && (delete this[o], s = !0);
    }
    return s;
  }
  normalize(e) {
    const t = this, n = {};
    return wt.forEach(this, (s, o) => {
      const h = wt.findKey(n, o);
      if (h) {
        t[h] = ol(s), delete t[o];
        return;
      }
      const c = e ? cx(o) : String(o).trim();
      c !== o && delete t[o], t[c] = ol(s), n[c] = !0;
    }), this;
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    const t = /* @__PURE__ */ Object.create(null);
    return wt.forEach(this, (n, s) => {
      n != null && n !== !1 && (t[s] = e && wt.isArray(n) ? n.join(", ") : n);
    }), t;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, t]) => e + ": " + t).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...t) {
    const n = new this(e);
    return t.forEach((s) => n.set(s)), n;
  }
  static accessor(e) {
    const n = (this[If] = this[If] = {
      accessors: {}
    }).accessors, s = this.prototype;
    function o(h) {
      const c = Wa(h);
      n[c] || (fx(s, h), n[c] = !0);
    }
    return wt.isArray(e) ? e.forEach(o) : o(e), this;
  }
}
El.accessor([
  "Content-Type",
  "Content-Length",
  "Accept",
  "Accept-Encoding",
  "User-Agent",
  "Authorization"
]);
wt.reduceDescriptors(El.prototype, ({ value: b }, e) => {
  let t = e[0].toUpperCase() + e.slice(1);
  return {
    get: () => b,
    set(n) {
      this[t] = n;
    }
  };
});
wt.freezeMethods(El);
const gs = El;
function Ih(b, e) {
  const t = this || ou, n = e || t, s = gs.from(n.headers);
  let o = n.data;
  return wt.forEach(b, function(c) {
    o = c.call(t, o, s.normalize(), e ? e.status : void 0);
  }), s.normalize(), o;
}
function Td(b) {
  return !!(b && b.__CANCEL__);
}
class dx extends Ui {
  /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */
  constructor(e, t, n) {
    super(e ?? "canceled", Ui.ERR_CANCELED, t, n), this.name = "CanceledError", this.__CANCEL__ = !0;
  }
}
const po = dx;
function Ld(b, e, t) {
  const n = t.config.validateStatus;
  !t.status || !n || n(t.status) ? b(t) : e(
    new Ui(
      "Request failed with status code " + t.status,
      [Ui.ERR_BAD_REQUEST, Ui.ERR_BAD_RESPONSE][Math.floor(t.status / 100) - 4],
      t.config,
      t.request,
      t
    )
  );
}
function gx(b) {
  const e = /^([-+\w]{1,25})(:?\/\/|:)/.exec(b);
  return e && e[1] || "";
}
function px(b, e) {
  b = b || 10;
  const t = new Array(b), n = new Array(b);
  let s = 0, o = 0, h;
  return e = e !== void 0 ? e : 1e3, function(_) {
    const x = Date.now(), B = n[o];
    h || (h = x), t[s] = _, n[s] = x;
    let P = o, U = 0;
    for (; P !== s; )
      U += t[P++], P = P % b;
    if (s = (s + 1) % b, s === o && (o = (o + 1) % b), x - h < e)
      return;
    const M = B && x - B;
    return M ? Math.round(U * 1e3 / M) : void 0;
  };
}
function mx(b, e) {
  let t = 0, n = 1e3 / e, s, o;
  const h = (x, B = Date.now()) => {
    t = B, s = null, o && (clearTimeout(o), o = null), b(...x);
  };
  return [(...x) => {
    const B = Date.now(), P = B - t;
    P >= n ? h(x, B) : (s = x, o || (o = setTimeout(() => {
      o = null, h(s);
    }, n - P)));
  }, () => s && h(s)];
}
const _l = (b, e, t = 3) => {
  let n = 0;
  const s = px(50, 250);
  return mx((o) => {
    const h = o.loaded, c = o.lengthComputable ? o.total : void 0, _ = c != null ? Math.min(h, c) : h, x = Math.max(0, _ - n), B = s(x);
    n = Math.max(n, _);
    const P = {
      loaded: _,
      total: c,
      progress: c ? _ / c : void 0,
      bytes: x,
      rate: B || void 0,
      estimated: B && c ? (c - _) / B : void 0,
      event: o,
      lengthComputable: c != null,
      [e ? "download" : "upload"]: !0
    };
    b(P);
  }, t);
}, Pf = (b, e) => {
  const t = b != null;
  return [
    (n) => e[0]({
      lengthComputable: t,
      total: b,
      loaded: n
    }),
    e[1]
  ];
}, Of = (b) => (...e) => wt.asap(() => b(...e)), _x = cr.hasStandardBrowserEnv ? ((b, e) => (t) => (t = new URL(t, cr.origin), b.protocol === t.protocol && b.host === t.host && (e || b.port === t.port)))(
  new URL(cr.origin),
  cr.navigator && /(msie|trident)/i.test(cr.navigator.userAgent)
) : () => !0, vx = cr.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(b, e, t, n, s, o, h) {
      if (typeof document > "u")
        return;
      const c = [`${b}=${encodeURIComponent(e)}`];
      wt.isNumber(t) && c.push(`expires=${new Date(t).toUTCString()}`), wt.isString(n) && c.push(`path=${n}`), wt.isString(s) && c.push(`domain=${s}`), o === !0 && c.push("secure"), wt.isString(h) && c.push(`SameSite=${h}`), document.cookie = c.join("; ");
    },
    read(b) {
      if (typeof document > "u")
        return null;
      const e = document.cookie.match(new RegExp("(?:^|; )" + b + "=([^;]*)"));
      return e ? decodeURIComponent(e[1]) : null;
    },
    remove(b) {
      this.write(b, "", Date.now() - 864e5, "/");
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function yx(b) {
  return typeof b != "string" ? !1 : /^([a-z][a-z\d+\-.]*:)?\/\//i.test(b);
}
function bx(b, e) {
  return e ? b.replace(/\/?\/$/, "") + "/" + e.replace(/^\/+/, "") : b;
}
function Bd(b, e, t) {
  let n = !yx(e);
  return b && (n || t === !1) ? bx(b, e) : e;
}
const Nf = (b) => b instanceof gs ? { ...b } : b;
function fa(b, e) {
  e = e || {};
  const t = /* @__PURE__ */ Object.create(null);
  Object.defineProperty(t, "hasOwnProperty", {
    value: Object.prototype.hasOwnProperty,
    enumerable: !1,
    writable: !0,
    configurable: !0
  });
  function n(x, B, P, U) {
    return wt.isPlainObject(x) && wt.isPlainObject(B) ? wt.merge.call({ caseless: U }, x, B) : wt.isPlainObject(B) ? wt.merge({}, B) : wt.isArray(B) ? B.slice() : B;
  }
  function s(x, B, P, U) {
    if (wt.isUndefined(B)) {
      if (!wt.isUndefined(x))
        return n(void 0, x, P, U);
    } else
      return n(x, B, P, U);
  }
  function o(x, B) {
    if (!wt.isUndefined(B))
      return n(void 0, B);
  }
  function h(x, B) {
    if (wt.isUndefined(B)) {
      if (!wt.isUndefined(x))
        return n(void 0, x);
    } else
      return n(void 0, B);
  }
  function c(x, B, P) {
    if (wt.hasOwnProp(e, P))
      return n(x, B);
    if (wt.hasOwnProp(b, P))
      return n(void 0, x);
  }
  const _ = {
    url: o,
    method: o,
    data: o,
    baseURL: h,
    transformRequest: h,
    transformResponse: h,
    paramsSerializer: h,
    timeout: h,
    timeoutMessage: h,
    withCredentials: h,
    withXSRFToken: h,
    adapter: h,
    responseType: h,
    xsrfCookieName: h,
    xsrfHeaderName: h,
    onUploadProgress: h,
    onDownloadProgress: h,
    decompress: h,
    maxContentLength: h,
    maxBodyLength: h,
    beforeRedirect: h,
    transport: h,
    httpAgent: h,
    httpsAgent: h,
    cancelToken: h,
    socketPath: h,
    allowedSocketPaths: h,
    responseEncoding: h,
    validateStatus: c,
    headers: (x, B, P) => s(Nf(x), Nf(B), P, !0)
  };
  return wt.forEach(Object.keys({ ...b, ...e }), function(B) {
    if (B === "__proto__" || B === "constructor" || B === "prototype")
      return;
    const P = wt.hasOwnProp(_, B) ? _[B] : s, U = wt.hasOwnProp(b, B) ? b[B] : void 0, M = wt.hasOwnProp(e, B) ? e[B] : void 0, Z = P(U, M, B);
    wt.isUndefined(Z) && P !== c || (t[B] = Z);
  }), t;
}
const kd = (b) => {
  const e = fa({}, b), t = (U) => wt.hasOwnProp(e, U) ? e[U] : void 0, n = t("data");
  let s = t("withXSRFToken");
  const o = t("xsrfHeaderName"), h = t("xsrfCookieName");
  let c = t("headers");
  const _ = t("auth"), x = t("baseURL"), B = t("allowAbsoluteUrls"), P = t("url");
  if (e.headers = c = gs.from(c), e.url = Cd(
    Bd(x, P, B),
    b.params,
    b.paramsSerializer
  ), _ && c.set(
    "Authorization",
    "Basic " + btoa(
      (_.username || "") + ":" + (_.password ? unescape(encodeURIComponent(_.password)) : "")
    )
  ), wt.isFormData(n)) {
    if (cr.hasStandardBrowserEnv || cr.hasStandardBrowserWebWorkerEnv)
      c.setContentType(void 0);
    else if (wt.isFunction(n.getHeaders)) {
      const U = n.getHeaders(), M = ["content-type", "content-length"];
      Object.entries(U).forEach(([Z, F]) => {
        M.includes(Z.toLowerCase()) && c.set(Z, F);
      });
    }
  }
  if (cr.hasStandardBrowserEnv && (wt.isFunction(s) && (s = s(e)), s === !0 || s == null && _x(e.url))) {
    const M = o && h && vx.read(h);
    M && c.set(o, M);
  }
  return e;
}, xx = typeof XMLHttpRequest < "u", wx = xx && function(b) {
  return new Promise(function(t, n) {
    const s = kd(b);
    let o = s.data;
    const h = gs.from(s.headers).normalize();
    let { responseType: c, onUploadProgress: _, onDownloadProgress: x } = s, B, P, U, M, Z;
    function F() {
      M && M(), Z && Z(), s.cancelToken && s.cancelToken.unsubscribe(B), s.signal && s.signal.removeEventListener("abort", B);
    }
    let Q = new XMLHttpRequest();
    Q.open(s.method.toUpperCase(), s.url, !0), Q.timeout = s.timeout;
    function D() {
      if (!Q)
        return;
      const ee = gs.from(
        "getAllResponseHeaders" in Q && Q.getAllResponseHeaders()
      ), fe = {
        data: !c || c === "text" || c === "json" ? Q.responseText : Q.response,
        status: Q.status,
        statusText: Q.statusText,
        headers: ee,
        config: b,
        request: Q
      };
      Ld(
        function(W) {
          t(W), F();
        },
        function(W) {
          n(W), F();
        },
        fe
      ), Q = null;
    }
    "onloadend" in Q ? Q.onloadend = D : Q.onreadystatechange = function() {
      !Q || Q.readyState !== 4 || Q.status === 0 && !(Q.responseURL && Q.responseURL.indexOf("file:") === 0) || setTimeout(D);
    }, Q.onabort = function() {
      Q && (n(new Ui("Request aborted", Ui.ECONNABORTED, b, Q)), Q = null);
    }, Q.onerror = function(le) {
      const fe = le && le.message ? le.message : "Network Error", X = new Ui(fe, Ui.ERR_NETWORK, b, Q);
      X.event = le || null, n(X), Q = null;
    }, Q.ontimeout = function() {
      let le = s.timeout ? "timeout of " + s.timeout + "ms exceeded" : "timeout exceeded";
      const fe = s.transitional || ru;
      s.timeoutErrorMessage && (le = s.timeoutErrorMessage), n(
        new Ui(
          le,
          fe.clarifyTimeoutError ? Ui.ETIMEDOUT : Ui.ECONNABORTED,
          b,
          Q
        )
      ), Q = null;
    }, o === void 0 && h.setContentType(null), "setRequestHeader" in Q && wt.forEach(h.toJSON(), function(le, fe) {
      Q.setRequestHeader(fe, le);
    }), wt.isUndefined(s.withCredentials) || (Q.withCredentials = !!s.withCredentials), c && c !== "json" && (Q.responseType = s.responseType), x && ([U, Z] = _l(x, !0), Q.addEventListener("progress", U)), _ && Q.upload && ([P, M] = _l(_), Q.upload.addEventListener("progress", P), Q.upload.addEventListener("loadend", M)), (s.cancelToken || s.signal) && (B = (ee) => {
      Q && (n(!ee || ee.type ? new po(null, b, Q) : ee), Q.abort(), Q = null);
    }, s.cancelToken && s.cancelToken.subscribe(B), s.signal && (s.signal.aborted ? B() : s.signal.addEventListener("abort", B)));
    const te = gx(s.url);
    if (te && cr.protocols.indexOf(te) === -1) {
      n(
        new Ui(
          "Unsupported protocol " + te + ":",
          Ui.ERR_BAD_REQUEST,
          b
        )
      );
      return;
    }
    Q.send(o || null);
  });
}, Sx = (b, e) => {
  const { length: t } = b = b ? b.filter(Boolean) : [];
  if (e || t) {
    let n = new AbortController(), s;
    const o = function(x) {
      if (!s) {
        s = !0, c();
        const B = x instanceof Error ? x : this.reason;
        n.abort(
          B instanceof Ui ? B : new po(B instanceof Error ? B.message : B)
        );
      }
    };
    let h = e && setTimeout(() => {
      h = null, o(new Ui(`timeout of ${e}ms exceeded`, Ui.ETIMEDOUT));
    }, e);
    const c = () => {
      b && (h && clearTimeout(h), h = null, b.forEach((x) => {
        x.unsubscribe ? x.unsubscribe(o) : x.removeEventListener("abort", o);
      }), b = null);
    };
    b.forEach((x) => x.addEventListener("abort", o));
    const { signal: _ } = n;
    return _.unsubscribe = () => wt.asap(c), _;
  }
}, Mx = Sx, Cx = function* (b, e) {
  let t = b.byteLength;
  if (!e || t < e) {
    yield b;
    return;
  }
  let n = 0, s;
  for (; n < t; )
    s = n + e, yield b.slice(n, s), n = s;
}, Ax = async function* (b, e) {
  for await (const t of Tx(b))
    yield* Cx(t, e);
}, Tx = async function* (b) {
  if (b[Symbol.asyncIterator]) {
    yield* b;
    return;
  }
  const e = b.getReader();
  try {
    for (; ; ) {
      const { done: t, value: n } = await e.read();
      if (t)
        break;
      yield n;
    }
  } finally {
    await e.cancel();
  }
}, Rf = (b, e, t, n) => {
  const s = Ax(b, e);
  let o = 0, h, c = (_) => {
    h || (h = !0, n && n(_));
  };
  return new ReadableStream(
    {
      async pull(_) {
        try {
          const { done: x, value: B } = await s.next();
          if (x) {
            c(), _.close();
            return;
          }
          let P = B.byteLength;
          if (t) {
            let U = o += P;
            t(U);
          }
          _.enqueue(new Uint8Array(B));
        } catch (x) {
          throw c(x), x;
        }
      },
      cancel(_) {
        return c(_), s.return();
      }
    },
    {
      highWaterMark: 2
    }
  );
}, Df = 64 * 1024, { isFunction: el } = wt, Lx = (({ Request: b, Response: e }) => ({
  Request: b,
  Response: e
}))(wt.global), { ReadableStream: zf, TextEncoder: Ff } = wt.global, Uf = (b, ...e) => {
  try {
    return !!b(...e);
  } catch {
    return !1;
  }
}, Bx = (b) => {
  b = wt.merge.call(
    {
      skipUndefined: !0
    },
    Lx,
    b
  );
  const { fetch: e, Request: t, Response: n } = b, s = e ? el(e) : typeof fetch == "function", o = el(t), h = el(n);
  if (!s)
    return !1;
  const c = s && el(zf), _ = s && (typeof Ff == "function" ? ((Z) => (F) => Z.encode(F))(new Ff()) : async (Z) => new Uint8Array(await new t(Z).arrayBuffer())), x = o && c && Uf(() => {
    let Z = !1;
    const F = new t(cr.origin, {
      body: new zf(),
      method: "POST",
      get duplex() {
        return Z = !0, "half";
      }
    }), Q = F.headers.has("Content-Type");
    return F.body != null && F.body.cancel(), Z && !Q;
  }), B = h && c && Uf(() => wt.isReadableStream(new n("").body)), P = {
    stream: B && ((Z) => Z.body)
  };
  s && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((Z) => {
    !P[Z] && (P[Z] = (F, Q) => {
      let D = F && F[Z];
      if (D)
        return D.call(F);
      throw new Ui(
        `Response type '${Z}' is not supported`,
        Ui.ERR_NOT_SUPPORT,
        Q
      );
    });
  });
  const U = async (Z) => {
    if (Z == null)
      return 0;
    if (wt.isBlob(Z))
      return Z.size;
    if (wt.isSpecCompliantForm(Z))
      return (await new t(cr.origin, {
        method: "POST",
        body: Z
      }).arrayBuffer()).byteLength;
    if (wt.isArrayBufferView(Z) || wt.isArrayBuffer(Z))
      return Z.byteLength;
    if (wt.isURLSearchParams(Z) && (Z = Z + ""), wt.isString(Z))
      return (await _(Z)).byteLength;
  }, M = async (Z, F) => {
    const Q = wt.toFiniteNumber(Z.getContentLength());
    return Q ?? U(F);
  };
  return async (Z) => {
    let {
      url: F,
      method: Q,
      data: D,
      signal: te,
      cancelToken: ee,
      timeout: le,
      onDownloadProgress: fe,
      onUploadProgress: X,
      responseType: W,
      headers: je,
      withCredentials: ke = "same-origin",
      fetchOptions: Ye
    } = kd(Z), pt = e || fetch;
    W = W ? (W + "").toLowerCase() : "text";
    let Le = Mx(
      [te, ee && ee.toAbortSignal()],
      le
    ), $e = null;
    const ce = Le && Le.unsubscribe && (() => {
      Le.unsubscribe();
    });
    let ht;
    try {
      if (X && x && Q !== "get" && Q !== "head" && (ht = await M(je, D)) !== 0) {
        let rt = new t(F, {
          method: "POST",
          body: D,
          duplex: "half"
        }), tt;
        if (wt.isFormData(D) && (tt = rt.headers.get("content-type")) && je.setContentType(tt), rt.body) {
          const [Kt, qt] = Pf(
            ht,
            _l(Of(X))
          );
          D = Rf(rt.body, Df, Kt, qt);
        }
      }
      wt.isString(ke) || (ke = ke ? "include" : "omit");
      const De = o && "credentials" in t.prototype;
      if (wt.isFormData(D)) {
        const rt = je.getContentType();
        rt && /^multipart\/form-data/i.test(rt) && !/boundary=/i.test(rt) && je.delete("content-type");
      }
      const ft = {
        ...Ye,
        signal: Le,
        method: Q.toUpperCase(),
        headers: je.normalize().toJSON(),
        body: D,
        duplex: "half",
        credentials: De ? ke : void 0
      };
      $e = o && new t(F, ft);
      let Yt = await (o ? pt($e, Ye) : pt(F, ft));
      const We = B && (W === "stream" || W === "response");
      if (B && (fe || We && ce)) {
        const rt = {};
        ["status", "statusText", "headers"].forEach((Lt) => {
          rt[Lt] = Yt[Lt];
        });
        const tt = wt.toFiniteNumber(Yt.headers.get("content-length")), [Kt, qt] = fe && Pf(
          tt,
          _l(Of(fe), !0)
        ) || [];
        Yt = new n(
          Rf(Yt.body, Df, Kt, () => {
            qt && qt(), ce && ce();
          }),
          rt
        );
      }
      W = W || "text";
      let It = await P[wt.findKey(P, W) || "text"](
        Yt,
        Z
      );
      return !We && ce && ce(), await new Promise((rt, tt) => {
        Ld(rt, tt, {
          data: It,
          headers: gs.from(Yt.headers),
          status: Yt.status,
          statusText: Yt.statusText,
          config: Z,
          request: $e
        });
      });
    } catch (De) {
      throw ce && ce(), De && De.name === "TypeError" && /Load failed|fetch/i.test(De.message) ? Object.assign(
        new Ui(
          "Network Error",
          Ui.ERR_NETWORK,
          Z,
          $e,
          De && De.response
        ),
        {
          cause: De.cause || De
        }
      ) : Ui.from(De, De && De.code, Z, $e, De && De.response);
    }
  };
}, kx = /* @__PURE__ */ new Map(), Ed = (b) => {
  let e = b && b.env || {};
  const { fetch: t, Request: n, Response: s } = e, o = [n, s, t];
  let h = o.length, c = h, _, x, B = kx;
  for (; c--; )
    _ = o[c], x = B.get(_), x === void 0 && B.set(_, x = c ? /* @__PURE__ */ new Map() : Bx(e)), B = x;
  return x;
};
Ed();
const lu = {
  http: Vb,
  xhr: wx,
  fetch: {
    get: Ed
  }
};
wt.forEach(lu, (b, e) => {
  if (b) {
    try {
      Object.defineProperty(b, "name", { value: e });
    } catch {
    }
    Object.defineProperty(b, "adapterName", { value: e });
  }
});
const Vf = (b) => `- ${b}`, Ex = (b) => wt.isFunction(b) || b === null || b === !1;
function Ix(b, e) {
  b = wt.isArray(b) ? b : [b];
  const { length: t } = b;
  let n, s;
  const o = {};
  for (let h = 0; h < t; h++) {
    n = b[h];
    let c;
    if (s = n, !Ex(n) && (s = lu[(c = String(n)).toLowerCase()], s === void 0))
      throw new Ui(`Unknown adapter '${c}'`);
    if (s && (wt.isFunction(s) || (s = s.get(e))))
      break;
    o[c || "#" + h] = s;
  }
  if (!s) {
    const h = Object.entries(o).map(
      ([_, x]) => `adapter ${_} ` + (x === !1 ? "is not supported by the environment" : "is not available in the build")
    );
    let c = t ? h.length > 1 ? `since :
` + h.map(Vf).join(`
`) : " " + Vf(h[0]) : "as no adapter specified";
    throw new Ui(
      "There is no suitable adapter to dispatch the request " + c,
      "ERR_NOT_SUPPORT"
    );
  }
  return s;
}
const Id = {
  /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */
  getAdapter: Ix,
  /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */
  adapters: lu
};
function Ph(b) {
  if (b.cancelToken && b.cancelToken.throwIfRequested(), b.signal && b.signal.aborted)
    throw new po(null, b);
}
function Hf(b) {
  return Ph(b), b.headers = gs.from(b.headers), b.data = Ih.call(b, b.transformRequest), ["post", "put", "patch"].indexOf(b.method) !== -1 && b.headers.setContentType("application/x-www-form-urlencoded", !1), Id.getAdapter(b.adapter || ou.adapter, b)(b).then(
    function(n) {
      return Ph(b), n.data = Ih.call(b, b.transformResponse, n), n.headers = gs.from(n.headers), n;
    },
    function(n) {
      return Td(n) || (Ph(b), n && n.response && (n.response.data = Ih.call(
        b,
        b.transformResponse,
        n.response
      ), n.response.headers = gs.from(n.response.headers))), Promise.reject(n);
    }
  );
}
const Pd = "1.15.2", Il = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((b, e) => {
  Il[b] = function(n) {
    return typeof n === b || "a" + (e < 1 ? "n " : " ") + b;
  };
});
const Yf = {};
Il.transitional = function(e, t, n) {
  function s(o, h) {
    return "[Axios v" + Pd + "] Transitional option '" + o + "'" + h + (n ? ". " + n : "");
  }
  return (o, h, c) => {
    if (e === !1)
      throw new Ui(
        s(h, " has been removed" + (t ? " in " + t : "")),
        Ui.ERR_DEPRECATED
      );
    return t && !Yf[h] && (Yf[h] = !0, console.warn(
      s(
        h,
        " has been deprecated since v" + t + " and will be removed in the near future"
      )
    )), e ? e(o, h, c) : !0;
  };
};
Il.spelling = function(e) {
  return (t, n) => (console.warn(`${n} is likely a misspelling of ${e}`), !0);
};
function Px(b, e, t) {
  if (typeof b != "object")
    throw new Ui("options must be an object", Ui.ERR_BAD_OPTION_VALUE);
  const n = Object.keys(b);
  let s = n.length;
  for (; s-- > 0; ) {
    const o = n[s], h = Object.prototype.hasOwnProperty.call(e, o) ? e[o] : void 0;
    if (h) {
      const c = b[o], _ = c === void 0 || h(c, o, b);
      if (_ !== !0)
        throw new Ui(
          "option " + o + " must be " + _,
          Ui.ERR_BAD_OPTION_VALUE
        );
      continue;
    }
    if (t !== !0)
      throw new Ui("Unknown option " + o, Ui.ERR_BAD_OPTION);
  }
}
const ll = {
  assertOptions: Px,
  validators: Il
}, ts = ll.validators;
class vl {
  constructor(e) {
    this.defaults = e || {}, this.interceptors = {
      request: new Ef(),
      response: new Ef()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(e, t) {
    try {
      return await this._request(e, t);
    } catch (n) {
      if (n instanceof Error) {
        let s = {};
        Error.captureStackTrace ? Error.captureStackTrace(s) : s = new Error();
        const o = (() => {
          if (!s.stack)
            return "";
          const h = s.stack.indexOf(`
`);
          return h === -1 ? "" : s.stack.slice(h + 1);
        })();
        try {
          if (!n.stack)
            n.stack = o;
          else if (o) {
            const h = o.indexOf(`
`), c = h === -1 ? -1 : o.indexOf(`
`, h + 1), _ = c === -1 ? "" : o.slice(c + 1);
            String(n.stack).endsWith(_) || (n.stack += `
` + o);
          }
        } catch {
        }
      }
      throw n;
    }
  }
  _request(e, t) {
    typeof e == "string" ? (t = t || {}, t.url = e) : t = e || {}, t = fa(this.defaults, t);
    const { transitional: n, paramsSerializer: s, headers: o } = t;
    n !== void 0 && ll.assertOptions(
      n,
      {
        silentJSONParsing: ts.transitional(ts.boolean),
        forcedJSONParsing: ts.transitional(ts.boolean),
        clarifyTimeoutError: ts.transitional(ts.boolean),
        legacyInterceptorReqResOrdering: ts.transitional(ts.boolean)
      },
      !1
    ), s != null && (wt.isFunction(s) ? t.paramsSerializer = {
      serialize: s
    } : ll.assertOptions(
      s,
      {
        encode: ts.function,
        serialize: ts.function
      },
      !0
    )), t.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? t.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : t.allowAbsoluteUrls = !0), ll.assertOptions(
      t,
      {
        baseUrl: ts.spelling("baseURL"),
        withXsrfToken: ts.spelling("withXSRFToken")
      },
      !0
    ), t.method = (t.method || this.defaults.method || "get").toLowerCase();
    let h = o && wt.merge(o.common, o[t.method]);
    o && wt.forEach(["delete", "get", "head", "post", "put", "patch", "common"], (Z) => {
      delete o[Z];
    }), t.headers = gs.concat(h, o);
    const c = [];
    let _ = !0;
    this.interceptors.request.forEach(function(F) {
      if (typeof F.runWhen == "function" && F.runWhen(t) === !1)
        return;
      _ = _ && F.synchronous;
      const Q = t.transitional || ru;
      Q && Q.legacyInterceptorReqResOrdering ? c.unshift(F.fulfilled, F.rejected) : c.push(F.fulfilled, F.rejected);
    });
    const x = [];
    this.interceptors.response.forEach(function(F) {
      x.push(F.fulfilled, F.rejected);
    });
    let B, P = 0, U;
    if (!_) {
      const Z = [Hf.bind(this), void 0];
      for (Z.unshift(...c), Z.push(...x), U = Z.length, B = Promise.resolve(t); P < U; )
        B = B.then(Z[P++], Z[P++]);
      return B;
    }
    U = c.length;
    let M = t;
    for (; P < U; ) {
      const Z = c[P++], F = c[P++];
      try {
        M = Z(M);
      } catch (Q) {
        F.call(this, Q);
        break;
      }
    }
    try {
      B = Hf.call(this, M);
    } catch (Z) {
      return Promise.reject(Z);
    }
    for (P = 0, U = x.length; P < U; )
      B = B.then(x[P++], x[P++]);
    return B;
  }
  getUri(e) {
    e = fa(this.defaults, e);
    const t = Bd(e.baseURL, e.url, e.allowAbsoluteUrls);
    return Cd(t, e.params, e.paramsSerializer);
  }
}
wt.forEach(["delete", "get", "head", "options"], function(e) {
  vl.prototype[e] = function(t, n) {
    return this.request(
      fa(n || {}, {
        method: e,
        url: t,
        data: (n || {}).data
      })
    );
  };
});
wt.forEach(["post", "put", "patch"], function(e) {
  function t(n) {
    return function(o, h, c) {
      return this.request(
        fa(c || {}, {
          method: e,
          headers: n ? {
            "Content-Type": "multipart/form-data"
          } : {},
          url: o,
          data: h
        })
      );
    };
  }
  vl.prototype[e] = t(), vl.prototype[e + "Form"] = t(!0);
});
const hl = vl;
class hu {
  constructor(e) {
    if (typeof e != "function")
      throw new TypeError("executor must be a function.");
    let t;
    this.promise = new Promise(function(o) {
      t = o;
    });
    const n = this;
    this.promise.then((s) => {
      if (!n._listeners)
        return;
      let o = n._listeners.length;
      for (; o-- > 0; )
        n._listeners[o](s);
      n._listeners = null;
    }), this.promise.then = (s) => {
      let o;
      const h = new Promise((c) => {
        n.subscribe(c), o = c;
      }).then(s);
      return h.cancel = function() {
        n.unsubscribe(o);
      }, h;
    }, e(function(o, h, c) {
      n.reason || (n.reason = new po(o, h, c), t(n.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(e) {
    if (this.reason) {
      e(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(e) : this._listeners = [e];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(e) {
    if (!this._listeners)
      return;
    const t = this._listeners.indexOf(e);
    t !== -1 && this._listeners.splice(t, 1);
  }
  toAbortSignal() {
    const e = new AbortController(), t = (n) => {
      e.abort(n);
    };
    return this.subscribe(t), e.signal.unsubscribe = () => this.unsubscribe(t), e.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let e;
    return {
      token: new hu(function(s) {
        e = s;
      }),
      cancel: e
    };
  }
}
const Ox = hu;
function Nx(b) {
  return function(t) {
    return b.apply(null, t);
  };
}
function Rx(b) {
  return wt.isObject(b) && b.isAxiosError === !0;
}
const jh = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
  WebServerIsDown: 521,
  ConnectionTimedOut: 522,
  OriginIsUnreachable: 523,
  TimeoutOccurred: 524,
  SslHandshakeFailed: 525,
  InvalidSslCertificate: 526
};
Object.entries(jh).forEach(([b, e]) => {
  jh[e] = b;
});
const Dx = jh;
function Od(b) {
  const e = new hl(b), t = pd(hl.prototype.request, e);
  return wt.extend(t, hl.prototype, e, { allOwnKeys: !0 }), wt.extend(t, e, null, { allOwnKeys: !0 }), t.create = function(s) {
    return Od(fa(b, s));
  }, t;
}
const Zn = Od(ou);
Zn.Axios = hl;
Zn.CanceledError = po;
Zn.CancelToken = Ox;
Zn.isCancel = Td;
Zn.VERSION = Pd;
Zn.toFormData = kl;
Zn.AxiosError = Ui;
Zn.Cancel = Zn.CanceledError;
Zn.all = function(e) {
  return Promise.all(e);
};
Zn.spread = Nx;
Zn.isAxiosError = Rx;
Zn.mergeConfig = fa;
Zn.AxiosHeaders = gs;
Zn.formToJSON = (b) => Ad(wt.isHTMLForm(b) ? new FormData(b) : b);
Zn.getAdapter = Id.getAdapter;
Zn.HttpStatusCode = Dx;
Zn.default = Zn;
const Gf = Zn;
class jf {
  constructor(e, t, n = !0) {
    this.tasksUrl = e, this.token = t, this.upload = async (s, o) => await this.uploadFileChunked(s, s.type, Zakeke.generateUUID(), o), this.uploadFileChunked = async (s, o, h, c, _) => {
      if (await this.resumableUpload(s, o, h, _) === "OK") {
        let B = await this.createTask(h, c);
        if (B !== -1) {
          let P = await this.getResultFromTask(B);
          if (P)
            return P.files;
        } else
          throw "Upload failed";
      }
      return null;
    }, this.resumableUpload = async (s, o, h, c) => new Promise((_, x) => {
      let B = new Resumable({
        target: Zakeke.config.baseApiUrl + "filechunks/upload",
        generateUniqueIdentifier: function() {
          return h;
        },
        maxFiles: 1,
        testChunks: !1,
        headers: this.headers,
        query: { resumableType: o },
        simultaneousUploads: 3
      });
      B.addFile(s), B.on("fileError", function(P, U) {
        _("KO"), console.error("fileError", P, U);
      }), B.on("error", function(P, U) {
        _("KO"), console.error("error", P, U);
      }), B.on("progress", function() {
        let P = B.progress() * 100;
        c && c(P);
      }), B.on("fileAdded", function(P, U) {
        B.upload();
      }), B.on("complete", function() {
        _("OK");
      });
    }), this.createTask = async (s, o) => {
      let h = { fileID: s, options: o }, c = await Gf.post(Zakeke.config.baseApiUrl + this.tasksUrl, h, { headers: this.headers });
      return c ? c.data.taskID : -1;
    }, this.getResultFromTask = async (s) => {
      let o = 0;
      for (; ; ) {
        try {
          let h = await Gf.get(
            Zakeke.config.baseApiUrl + this.tasksUrl + "/results/" + s,
            { headers: this.headers }
          );
          if (h && h.data.state === 2)
            return h.data;
          if (h && h.data.state === 3)
            return null;
        } catch {
          return null;
        }
        if (o++, o > 200)
          return null;
        await new Promise((h) => setTimeout(h, 1e3));
      }
    }, n ? this.headers = {
      Authorization: "Bearer " + this.token,
      "Accept-Language": "en-US"
    } : this.headers = {
      "X-Auth-Token": this.token,
      "Accept-Language": "en-US"
    };
  }
}
class ci {
}
ci.Environment = {
  //EnvironmentTextureName: "environmentSpecular.dds",
  EnvironmentTextureName: "environmentSpecular_0af79b7524dc4cd4825eae49c5d9e22fae220fd.env",
  GroundTextureCDNUrl: "https://cdn.zakeke.com/cdn/3d/assets/environments/backgroundGround9.png",
  SkyboxTextureCDNUrl: "https://cdn.zakeke.com/cdn/3d/assets/environments/backgroundSkybox.dds",
  //EnvironmentTextureCDNUrl: "https://zakekecdn.azureedge.net/cdn/3d/assets/environments/environmentSpecular.dds"
  //EnvironmentTextureCDNUrl: "https://cdn.zakeke.com/cdn/3d/assets/environments/environmentSpecular.dds"
  EnvironmentTextureCDNUrl: "https://zakekecdn.blob.core.windows.net/cdn/3d/assets/environments/environmentSpecular_0af79b7524dc4cd4825eae49c5d9e22fae220fd.env"
};
ci.TryonReferences = {
  RootUrl: "https://cdn.zakeke.com/cdn/3d/assets/tryon/references/",
  ReferenceGlassesFrameName: "Reference Glasses Frame",
  ReferenceGlassesFrameFileName: "Reference_Glasses_Frame_001.json",
  EyewearName: "glasses_VTO_Reference",
  EyewearURL: "Eyewear_VTO_Reference.babylon",
  EyewearDownloadableURL: "Eyewear_VTO_Reference.glb",
  ScarvesName: "scarves_VTO_Reference",
  ScarvesURL: "Scarves_VTO_Reference.babylon",
  ScarvesDownloadableURL: "Scarves_VTO_Reference.glb",
  EarringsName: "earrings_VTO_Reference",
  EarringsURL: "Earrings_VTO_Reference.babylon",
  EarringsDownloadableURL: "Earrings_VTO_Reference.glb",
  HeadwearName: "headwear_VTO_Reference",
  HeadwearURL: "Headwear_VTO_Reference.babylon",
  HeadwearDownloadableURL: "Headwear_VTO_Reference.glb",
  NecklaceName: "necklace_VTO_Reference",
  NecklaceURL: "Necklace_VTO_Reference.babylon",
  NecklaceDownloadableURL: "Necklace_VTO_Reference.glb",
  ShoeName: "foot_VTO_Reference",
  ShoeURL: "Foot_VTO_Reference.babylon",
  ShoeDownloadableURL: "Foot_VTO_Reference.glb"
};
ci.Shapes = {
  RootUrl: "https://cdn.zakeke.com/cdn/3d/assets/shapes/",
  RoundedCubeName: "Rounded Cube",
  RoundedCubeFileName: "rounded_cube.babylon",
  RoundedCylinderName: "Rounded Cylinder",
  RoundedCylinderFileName: "rounded_cylinder.babylon",
  MatBallName: "Mat Ball",
  MatBallFileName: "mat_ball.babylon",
  MaleHeadName: "Group48944",
  MaleHeadFileName: "DemoHead.babylon",
  FemaleHeadName: "Group12208",
  FemaleHeadFileName: "FemaleHead.babylon",
  PokemonBallName: "PokemonBall",
  PokemonBallFileName: "PokemonBall.babylon",
  ShaderBallName: "Elements",
  ShaderBallFileName: "ShaderBall.babylon",
  BootsFolder: "boots/",
  BootsName: "shoe",
  BootsFileName: "boots.incremental.babylon",
  SuzanneName: "Suzanne",
  SuzanneFileName: "suzanne.babylon",
  StepPyramidName: "Pyramid",
  StepPyramidFileName: "step-pyramid.babylon",
  TeapotName: "Teapot",
  TeapotFileName: "teapot.babylon",
  AlloyWheelName: "Wheel",
  AlloyWheelFolder: "alloy_wheel/",
  AlloyWheelFileName: "alloy_wheel.incremental.babylon"
};
class Ms {
  /**
   * Checks for a matching suffix at the end of a string (for ES5 and lower)
   * @param str Source string
   * @param suffix Suffix to search for in the source string
   * @returns Boolean indicating whether the suffix was found (true) or not (false)
   */
  static EndsWith(e, t) {
    return e.indexOf(t, e.length - t.length) !== -1;
  }
  /**
   * Checks for a matching suffix at the beginning of a string (for ES5 and lower)
   * @param str Source string
   * @param suffix Suffix to search for in the source string
   * @returns Boolean indicating whether the suffix was found (true) or not (false)
   */
  static StartsWith(e, t) {
    return e.indexOf(t) === 0;
  }
  /**
   * Decodes a buffer into a string
   * @param buffer The buffer to decode
   * @returns The decoded string
   */
  static Decode(e) {
    if (typeof TextDecoder < "u")
      return new TextDecoder().decode(e);
    let t = "";
    for (let n = 0; n < e.byteLength; n++)
      t += String.fromCharCode(e[n]);
    return t;
  }
  /**
   * Encode a buffer to a base64 string
   * @param buffer defines the buffer to encode
   * @returns the encoded string
   */
  static EncodeArrayBufferToBase64(e) {
    for (var t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", n = "", s, o, h, c, _, x, B, P = 0, U = ArrayBuffer.isView(e) ? new Uint8Array(e.buffer, e.byteOffset, e.byteLength) : new Uint8Array(e); P < U.length; )
      s = U[P++], o = P < U.length ? U[P++] : Number.NaN, h = P < U.length ? U[P++] : Number.NaN, c = s >> 2, _ = (s & 3) << 4 | o >> 4, x = (o & 15) << 2 | h >> 6, B = h & 63, isNaN(o) ? x = B = 64 : isNaN(h) && (B = 64), n += t.charAt(c) + t.charAt(_) + t.charAt(x) + t.charAt(B);
    return n;
  }
}
class zx {
  constructor() {
    this._mesh = null, this._scene = null, this._facesOfVertices = null, this._meshVerticesPositions = null, this._meshVerticesNormals = null, this._meshIndices = null, this._meshPositions = null, this._meshFacesNormals = null, this._sharedFacesOfVertices = {};
  }
  dispose() {
  }
  resetDataModel() {
    this._facesOfVertices = null, this._meshVerticesPositions = null, this._meshVerticesNormals = null, this._meshIndices = null, this._meshPositions = null, this._meshFacesNormals = null, this._sharedFacesOfVertices = {};
  }
  prepareDataModel() {
    if (this.resetDataModel(), this._mesh && this._scene && (this._facesOfVertices = [], this._sharedFacesOfVertices = {}, this._meshVerticesPositions = this._mesh.getVerticesData(BABYLON.VertexBuffer.PositionKind), this._meshVerticesNormals = this._mesh.getVerticesData(BABYLON.VertexBuffer.NormalKind), this._meshIndices = this._mesh.getIndices(), this._meshPositions = [], this._meshFacesNormals = [], this._meshVerticesPositions && this._meshVerticesNormals && this._meshIndices)) {
      for (let e = 0; e < this._meshVerticesPositions.length; e += 3)
        this._meshPositions.push(new BABYLON.Vector3(this._meshVerticesPositions[e], this._meshVerticesPositions[e + 1], this._meshVerticesPositions[e + 2]));
      for (let e = 0; e < this._mesh.getTotalIndices() / 3; e++)
        this._computeFaceNormal(e);
      this._getFacesOfVertices();
    }
  }
  _getFaceVerticesIndex(e) {
    return this._meshIndices ? {
      v1: this._meshIndices[e * 3],
      v2: this._meshIndices[e * 3 + 1],
      v3: this._meshIndices[e * 3 + 2]
    } : null;
  }
  // La normale ad una faccia è calcolata come prodotto vettoriale (cross product)
  // tra i vettori che connettono gli spigoli
  _computeFaceNormal(e) {
    if (this._meshPositions && this._meshIndices && this._meshFacesNormals) {
      const t = this._getFaceVerticesIndex(e);
      if (t) {
        const n = this._meshPositions[t.v1].subtract(this._meshPositions[t.v2]), s = this._meshPositions[t.v3].subtract(this._meshPositions[t.v2]);
        this._meshFacesNormals[e] = BABYLON.Vector3.Normalize(BABYLON.Vector3.Cross(n, s));
      }
    }
  }
  _getPositionKey(e) {
    return `${e.x}_${e.y}_${e.z}`;
  }
  // Determina le facce di ogni vertice sia considerando vertici uguali ripetuti più volte (_facesOfVertices)
  // che quelle condivise da uno stesso vertice ripetuto (_sharedFacesOfVertices). Queste ultime saranno
  // quelle che verranno considerate per il calcolo della normale risultante da tutte le facce che hanno
  // un vertice come spigolo.
  _getFacesOfVertices() {
    if (this._mesh && this._meshPositions && this._meshIndices) {
      this._sharedFacesOfVertices = {}, this._facesOfVertices = [];
      for (let e = 0; e < this._meshPositions.length; e++) {
        this._facesOfVertices[e] = [];
        const t = this._meshPositions[e], n = this._getPositionKey(t);
        this._sharedFacesOfVertices.hasOwnProperty(n) || (this._sharedFacesOfVertices[n] = /* @__PURE__ */ new Set());
      }
      for (let e = 0; e < this._meshIndices.length; e++) {
        const t = this._meshIndices[e], n = e / 3 | 0;
        this._facesOfVertices[t].push(n);
        const s = this._meshPositions[t], o = this._getPositionKey(s);
        this._sharedFacesOfVertices.hasOwnProperty(o) && this._sharedFacesOfVertices[o].add(n);
      }
    }
  }
  expandMesh(e, t = 0.01) {
    if (e instanceof BABYLON.Mesh && (this._mesh = e, this._scene = e.getScene(), this.prepareDataModel(), this._meshPositions && this._meshVerticesPositions && this._meshVerticesNormals)) {
      for (let n = 0; n < this._meshPositions.length; n++) {
        const s = this._meshPositions[n], o = this._getVertexComputedNormal(n);
        if (o) {
          const h = o.scale(t);
          s.addInPlace(h), this._meshVerticesPositions[n * 3] = s.x, this._meshVerticesPositions[n * 3 + 1] = s.y, this._meshVerticesPositions[n * 3 + 2] = s.z;
        }
      }
      this._mesh.markVerticesDataAsUpdatable(BABYLON.VertexBuffer.PositionKind, !0), this._mesh.updateVerticesData(BABYLON.VertexBuffer.PositionKind, this._meshVerticesPositions), this._mesh.computeWorldMatrix(!0);
    }
  }
  _reComputeNormals() {
    const e = [];
    if (this._meshPositions && this._facesOfVertices) {
      for (let n = 0; n < this._meshPositions.length; n++) {
        const s = this._facesOfVertices[n];
        for (let o = 0; o < s.length; o++)
          e[s[o]] = !0;
      }
      let t;
      for (t in e)
        this._computeFaceNormal(t);
      for (t in e) {
        const n = this._getFaceVerticesIndex(t);
        n && (this._computeNormal(n.v1), this._computeNormal(n.v2), this._computeNormal(n.v3));
      }
    }
  }
  _getVertexComputedNormal(e) {
    let t = null;
    if (this._meshPositions && this._meshFacesNormals) {
      const n = this._meshPositions, s = this._meshFacesNormals, o = n[e], h = this._getPositionKey(o);
      if (this._sharedFacesOfVertices.hasOwnProperty(h)) {
        const c = this._sharedFacesOfVertices[h];
        t = BABYLON.Vector3.Zero(), c.forEach((_) => {
          const x = s[_];
          t && x && (t = t.add(x));
        }), t = BABYLON.Vector3.Normalize(t.scale(1 / c.size));
      }
    }
    return t;
  }
  _computeNormal(e) {
    const t = this._getVertexComputedNormal(e);
    t && this._meshVerticesNormals && (this._meshVerticesNormals[e * 3] = t.x, this._meshVerticesNormals[e * 3 + 1] = t.y, this._meshVerticesNormals[e * 3 + 2] = t.z);
  }
}
class Fx {
  static async convertGlbToUsdz(e) {
    return new Promise((t, n) => {
      let s = null;
      new THREE.GLTFLoader().load(e, async function(h) {
        h.scene.updateWorldMatrix(!0, !0);
        const _ = await new THREE.USDZExporter().parse(h.scene);
        s = new Blob([_], { type: "model/vnd.usdz+zip" }), t(s);
      });
    });
  }
}
var ss = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function uu(b) {
  return b && b.__esModule && Object.prototype.hasOwnProperty.call(b, "default") ? b.default : b;
}
function Ux(b) {
  if (b.__esModule)
    return b;
  var e = b.default;
  if (typeof e == "function") {
    var t = function n() {
      return this instanceof n ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    t.prototype = e.prototype;
  } else
    t = {};
  return Object.defineProperty(t, "__esModule", { value: !0 }), Object.keys(b).forEach(function(n) {
    var s = Object.getOwnPropertyDescriptor(b, n);
    Object.defineProperty(t, n, s.get ? s : {
      enumerable: !0,
      get: function() {
        return b[n];
      }
    });
  }), t;
}
function Xa(b) {
  throw new Error('Could not dynamically require "' + b + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var Nd = { exports: {} };
/*!

JSZip v3.10.1 - A JavaScript class for generating and reading zip files
<http://stuartk.com/jszip>

(c) 2009-2016 Stuart Knightley <stuart [at] stuartk.com>
Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/main/LICENSE.markdown.

JSZip uses the library pako released under the MIT license :
https://github.com/nodeca/pako/blob/main/LICENSE
*/
(function(b, e) {
  (function(t) {
    b.exports = t();
  })(function() {
    return function t(n, s, o) {
      function h(x, B) {
        if (!s[x]) {
          if (!n[x]) {
            var P = typeof Xa == "function" && Xa;
            if (!B && P)
              return P(x, !0);
            if (c)
              return c(x, !0);
            var U = new Error("Cannot find module '" + x + "'");
            throw U.code = "MODULE_NOT_FOUND", U;
          }
          var M = s[x] = { exports: {} };
          n[x][0].call(M.exports, function(Z) {
            var F = n[x][1][Z];
            return h(F || Z);
          }, M, M.exports, t, n, s, o);
        }
        return s[x].exports;
      }
      for (var c = typeof Xa == "function" && Xa, _ = 0; _ < o.length; _++)
        h(o[_]);
      return h;
    }({ 1: [function(t, n, s) {
      var o = t("./utils"), h = t("./support"), c = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
      s.encode = function(_) {
        for (var x, B, P, U, M, Z, F, Q = [], D = 0, te = _.length, ee = te, le = o.getTypeOf(_) !== "string"; D < _.length; )
          ee = te - D, P = le ? (x = _[D++], B = D < te ? _[D++] : 0, D < te ? _[D++] : 0) : (x = _.charCodeAt(D++), B = D < te ? _.charCodeAt(D++) : 0, D < te ? _.charCodeAt(D++) : 0), U = x >> 2, M = (3 & x) << 4 | B >> 4, Z = 1 < ee ? (15 & B) << 2 | P >> 6 : 64, F = 2 < ee ? 63 & P : 64, Q.push(c.charAt(U) + c.charAt(M) + c.charAt(Z) + c.charAt(F));
        return Q.join("");
      }, s.decode = function(_) {
        var x, B, P, U, M, Z, F = 0, Q = 0, D = "data:";
        if (_.substr(0, D.length) === D)
          throw new Error("Invalid base64 input, it looks like a data url.");
        var te, ee = 3 * (_ = _.replace(/[^A-Za-z0-9+/=]/g, "")).length / 4;
        if (_.charAt(_.length - 1) === c.charAt(64) && ee--, _.charAt(_.length - 2) === c.charAt(64) && ee--, ee % 1 != 0)
          throw new Error("Invalid base64 input, bad content length.");
        for (te = h.uint8array ? new Uint8Array(0 | ee) : new Array(0 | ee); F < _.length; )
          x = c.indexOf(_.charAt(F++)) << 2 | (U = c.indexOf(_.charAt(F++))) >> 4, B = (15 & U) << 4 | (M = c.indexOf(_.charAt(F++))) >> 2, P = (3 & M) << 6 | (Z = c.indexOf(_.charAt(F++))), te[Q++] = x, M !== 64 && (te[Q++] = B), Z !== 64 && (te[Q++] = P);
        return te;
      };
    }, { "./support": 30, "./utils": 32 }], 2: [function(t, n, s) {
      var o = t("./external"), h = t("./stream/DataWorker"), c = t("./stream/Crc32Probe"), _ = t("./stream/DataLengthProbe");
      function x(B, P, U, M, Z) {
        this.compressedSize = B, this.uncompressedSize = P, this.crc32 = U, this.compression = M, this.compressedContent = Z;
      }
      x.prototype = { getContentWorker: function() {
        var B = new h(o.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new _("data_length")), P = this;
        return B.on("end", function() {
          if (this.streamInfo.data_length !== P.uncompressedSize)
            throw new Error("Bug : uncompressed data size mismatch");
        }), B;
      }, getCompressedWorker: function() {
        return new h(o.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize", this.compressedSize).withStreamInfo("uncompressedSize", this.uncompressedSize).withStreamInfo("crc32", this.crc32).withStreamInfo("compression", this.compression);
      } }, x.createWorkerFrom = function(B, P, U) {
        return B.pipe(new c()).pipe(new _("uncompressedSize")).pipe(P.compressWorker(U)).pipe(new _("compressedSize")).withStreamInfo("compression", P);
      }, n.exports = x;
    }, { "./external": 6, "./stream/Crc32Probe": 25, "./stream/DataLengthProbe": 26, "./stream/DataWorker": 27 }], 3: [function(t, n, s) {
      var o = t("./stream/GenericWorker");
      s.STORE = { magic: "\0\0", compressWorker: function() {
        return new o("STORE compression");
      }, uncompressWorker: function() {
        return new o("STORE decompression");
      } }, s.DEFLATE = t("./flate");
    }, { "./flate": 7, "./stream/GenericWorker": 28 }], 4: [function(t, n, s) {
      var o = t("./utils"), h = function() {
        for (var c, _ = [], x = 0; x < 256; x++) {
          c = x;
          for (var B = 0; B < 8; B++)
            c = 1 & c ? 3988292384 ^ c >>> 1 : c >>> 1;
          _[x] = c;
        }
        return _;
      }();
      n.exports = function(c, _) {
        return c !== void 0 && c.length ? o.getTypeOf(c) !== "string" ? function(x, B, P, U) {
          var M = h, Z = U + P;
          x ^= -1;
          for (var F = U; F < Z; F++)
            x = x >>> 8 ^ M[255 & (x ^ B[F])];
          return -1 ^ x;
        }(0 | _, c, c.length, 0) : function(x, B, P, U) {
          var M = h, Z = U + P;
          x ^= -1;
          for (var F = U; F < Z; F++)
            x = x >>> 8 ^ M[255 & (x ^ B.charCodeAt(F))];
          return -1 ^ x;
        }(0 | _, c, c.length, 0) : 0;
      };
    }, { "./utils": 32 }], 5: [function(t, n, s) {
      s.base64 = !1, s.binary = !1, s.dir = !1, s.createFolders = !0, s.date = null, s.compression = null, s.compressionOptions = null, s.comment = null, s.unixPermissions = null, s.dosPermissions = null;
    }, {}], 6: [function(t, n, s) {
      var o = null;
      o = typeof Promise < "u" ? Promise : t("lie"), n.exports = { Promise: o };
    }, { lie: 37 }], 7: [function(t, n, s) {
      var o = typeof Uint8Array < "u" && typeof Uint16Array < "u" && typeof Uint32Array < "u", h = t("pako"), c = t("./utils"), _ = t("./stream/GenericWorker"), x = o ? "uint8array" : "array";
      function B(P, U) {
        _.call(this, "FlateWorker/" + P), this._pako = null, this._pakoAction = P, this._pakoOptions = U, this.meta = {};
      }
      s.magic = "\b\0", c.inherits(B, _), B.prototype.processChunk = function(P) {
        this.meta = P.meta, this._pako === null && this._createPako(), this._pako.push(c.transformTo(x, P.data), !1);
      }, B.prototype.flush = function() {
        _.prototype.flush.call(this), this._pako === null && this._createPako(), this._pako.push([], !0);
      }, B.prototype.cleanUp = function() {
        _.prototype.cleanUp.call(this), this._pako = null;
      }, B.prototype._createPako = function() {
        this._pako = new h[this._pakoAction]({ raw: !0, level: this._pakoOptions.level || -1 });
        var P = this;
        this._pako.onData = function(U) {
          P.push({ data: U, meta: P.meta });
        };
      }, s.compressWorker = function(P) {
        return new B("Deflate", P);
      }, s.uncompressWorker = function() {
        return new B("Inflate", {});
      };
    }, { "./stream/GenericWorker": 28, "./utils": 32, pako: 38 }], 8: [function(t, n, s) {
      function o(M, Z) {
        var F, Q = "";
        for (F = 0; F < Z; F++)
          Q += String.fromCharCode(255 & M), M >>>= 8;
        return Q;
      }
      function h(M, Z, F, Q, D, te) {
        var ee, le, fe = M.file, X = M.compression, W = te !== x.utf8encode, je = c.transformTo("string", te(fe.name)), ke = c.transformTo("string", x.utf8encode(fe.name)), Ye = fe.comment, pt = c.transformTo("string", te(Ye)), Le = c.transformTo("string", x.utf8encode(Ye)), $e = ke.length !== fe.name.length, ce = Le.length !== Ye.length, ht = "", De = "", ft = "", Yt = fe.dir, We = fe.date, It = { crc32: 0, compressedSize: 0, uncompressedSize: 0 };
        Z && !F || (It.crc32 = M.crc32, It.compressedSize = M.compressedSize, It.uncompressedSize = M.uncompressedSize);
        var rt = 0;
        Z && (rt |= 8), W || !$e && !ce || (rt |= 2048);
        var tt = 0, Kt = 0;
        Yt && (tt |= 16), D === "UNIX" ? (Kt = 798, tt |= function(Lt, Ci) {
          var ji = Lt;
          return Lt || (ji = Ci ? 16893 : 33204), (65535 & ji) << 16;
        }(fe.unixPermissions, Yt)) : (Kt = 20, tt |= function(Lt) {
          return 63 & (Lt || 0);
        }(fe.dosPermissions)), ee = We.getUTCHours(), ee <<= 6, ee |= We.getUTCMinutes(), ee <<= 5, ee |= We.getUTCSeconds() / 2, le = We.getUTCFullYear() - 1980, le <<= 4, le |= We.getUTCMonth() + 1, le <<= 5, le |= We.getUTCDate(), $e && (De = o(1, 1) + o(B(je), 4) + ke, ht += "up" + o(De.length, 2) + De), ce && (ft = o(1, 1) + o(B(pt), 4) + Le, ht += "uc" + o(ft.length, 2) + ft);
        var qt = "";
        return qt += `
\0`, qt += o(rt, 2), qt += X.magic, qt += o(ee, 2), qt += o(le, 2), qt += o(It.crc32, 4), qt += o(It.compressedSize, 4), qt += o(It.uncompressedSize, 4), qt += o(je.length, 2), qt += o(ht.length, 2), { fileRecord: P.LOCAL_FILE_HEADER + qt + je + ht, dirRecord: P.CENTRAL_FILE_HEADER + o(Kt, 2) + qt + o(pt.length, 2) + "\0\0\0\0" + o(tt, 4) + o(Q, 4) + je + ht + pt };
      }
      var c = t("../utils"), _ = t("../stream/GenericWorker"), x = t("../utf8"), B = t("../crc32"), P = t("../signature");
      function U(M, Z, F, Q) {
        _.call(this, "ZipFileWorker"), this.bytesWritten = 0, this.zipComment = Z, this.zipPlatform = F, this.encodeFileName = Q, this.streamFiles = M, this.accumulate = !1, this.contentBuffer = [], this.dirRecords = [], this.currentSourceOffset = 0, this.entriesCount = 0, this.currentFile = null, this._sources = [];
      }
      c.inherits(U, _), U.prototype.push = function(M) {
        var Z = M.meta.percent || 0, F = this.entriesCount, Q = this._sources.length;
        this.accumulate ? this.contentBuffer.push(M) : (this.bytesWritten += M.data.length, _.prototype.push.call(this, { data: M.data, meta: { currentFile: this.currentFile, percent: F ? (Z + 100 * (F - Q - 1)) / F : 100 } }));
      }, U.prototype.openedSource = function(M) {
        this.currentSourceOffset = this.bytesWritten, this.currentFile = M.file.name;
        var Z = this.streamFiles && !M.file.dir;
        if (Z) {
          var F = h(M, Z, !1, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
          this.push({ data: F.fileRecord, meta: { percent: 0 } });
        } else
          this.accumulate = !0;
      }, U.prototype.closedSource = function(M) {
        this.accumulate = !1;
        var Z = this.streamFiles && !M.file.dir, F = h(M, Z, !0, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
        if (this.dirRecords.push(F.dirRecord), Z)
          this.push({ data: function(Q) {
            return P.DATA_DESCRIPTOR + o(Q.crc32, 4) + o(Q.compressedSize, 4) + o(Q.uncompressedSize, 4);
          }(M), meta: { percent: 100 } });
        else
          for (this.push({ data: F.fileRecord, meta: { percent: 0 } }); this.contentBuffer.length; )
            this.push(this.contentBuffer.shift());
        this.currentFile = null;
      }, U.prototype.flush = function() {
        for (var M = this.bytesWritten, Z = 0; Z < this.dirRecords.length; Z++)
          this.push({ data: this.dirRecords[Z], meta: { percent: 100 } });
        var F = this.bytesWritten - M, Q = function(D, te, ee, le, fe) {
          var X = c.transformTo("string", fe(le));
          return P.CENTRAL_DIRECTORY_END + "\0\0\0\0" + o(D, 2) + o(D, 2) + o(te, 4) + o(ee, 4) + o(X.length, 2) + X;
        }(this.dirRecords.length, F, M, this.zipComment, this.encodeFileName);
        this.push({ data: Q, meta: { percent: 100 } });
      }, U.prototype.prepareNextSource = function() {
        this.previous = this._sources.shift(), this.openedSource(this.previous.streamInfo), this.isPaused ? this.previous.pause() : this.previous.resume();
      }, U.prototype.registerPrevious = function(M) {
        this._sources.push(M);
        var Z = this;
        return M.on("data", function(F) {
          Z.processChunk(F);
        }), M.on("end", function() {
          Z.closedSource(Z.previous.streamInfo), Z._sources.length ? Z.prepareNextSource() : Z.end();
        }), M.on("error", function(F) {
          Z.error(F);
        }), this;
      }, U.prototype.resume = function() {
        return !!_.prototype.resume.call(this) && (!this.previous && this._sources.length ? (this.prepareNextSource(), !0) : this.previous || this._sources.length || this.generatedError ? void 0 : (this.end(), !0));
      }, U.prototype.error = function(M) {
        var Z = this._sources;
        if (!_.prototype.error.call(this, M))
          return !1;
        for (var F = 0; F < Z.length; F++)
          try {
            Z[F].error(M);
          } catch {
          }
        return !0;
      }, U.prototype.lock = function() {
        _.prototype.lock.call(this);
        for (var M = this._sources, Z = 0; Z < M.length; Z++)
          M[Z].lock();
      }, n.exports = U;
    }, { "../crc32": 4, "../signature": 23, "../stream/GenericWorker": 28, "../utf8": 31, "../utils": 32 }], 9: [function(t, n, s) {
      var o = t("../compressions"), h = t("./ZipFileWorker");
      s.generateWorker = function(c, _, x) {
        var B = new h(_.streamFiles, x, _.platform, _.encodeFileName), P = 0;
        try {
          c.forEach(function(U, M) {
            P++;
            var Z = function(te, ee) {
              var le = te || ee, fe = o[le];
              if (!fe)
                throw new Error(le + " is not a valid compression method !");
              return fe;
            }(M.options.compression, _.compression), F = M.options.compressionOptions || _.compressionOptions || {}, Q = M.dir, D = M.date;
            M._compressWorker(Z, F).withStreamInfo("file", { name: U, dir: Q, date: D, comment: M.comment || "", unixPermissions: M.unixPermissions, dosPermissions: M.dosPermissions }).pipe(B);
          }), B.entriesCount = P;
        } catch (U) {
          B.error(U);
        }
        return B;
      };
    }, { "../compressions": 3, "./ZipFileWorker": 8 }], 10: [function(t, n, s) {
      function o() {
        if (!(this instanceof o))
          return new o();
        if (arguments.length)
          throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
        this.files = /* @__PURE__ */ Object.create(null), this.comment = null, this.root = "", this.clone = function() {
          var h = new o();
          for (var c in this)
            typeof this[c] != "function" && (h[c] = this[c]);
          return h;
        };
      }
      (o.prototype = t("./object")).loadAsync = t("./load"), o.support = t("./support"), o.defaults = t("./defaults"), o.version = "3.10.1", o.loadAsync = function(h, c) {
        return new o().loadAsync(h, c);
      }, o.external = t("./external"), n.exports = o;
    }, { "./defaults": 5, "./external": 6, "./load": 11, "./object": 15, "./support": 30 }], 11: [function(t, n, s) {
      var o = t("./utils"), h = t("./external"), c = t("./utf8"), _ = t("./zipEntries"), x = t("./stream/Crc32Probe"), B = t("./nodejsUtils");
      function P(U) {
        return new h.Promise(function(M, Z) {
          var F = U.decompressed.getContentWorker().pipe(new x());
          F.on("error", function(Q) {
            Z(Q);
          }).on("end", function() {
            F.streamInfo.crc32 !== U.decompressed.crc32 ? Z(new Error("Corrupted zip : CRC32 mismatch")) : M();
          }).resume();
        });
      }
      n.exports = function(U, M) {
        var Z = this;
        return M = o.extend(M || {}, { base64: !1, checkCRC32: !1, optimizedBinaryString: !1, createFolders: !1, decodeFileName: c.utf8decode }), B.isNode && B.isStream(U) ? h.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")) : o.prepareContent("the loaded zip file", U, !0, M.optimizedBinaryString, M.base64).then(function(F) {
          var Q = new _(M);
          return Q.load(F), Q;
        }).then(function(F) {
          var Q = [h.Promise.resolve(F)], D = F.files;
          if (M.checkCRC32)
            for (var te = 0; te < D.length; te++)
              Q.push(P(D[te]));
          return h.Promise.all(Q);
        }).then(function(F) {
          for (var Q = F.shift(), D = Q.files, te = 0; te < D.length; te++) {
            var ee = D[te], le = ee.fileNameStr, fe = o.resolve(ee.fileNameStr);
            Z.file(fe, ee.decompressed, { binary: !0, optimizedBinaryString: !0, date: ee.date, dir: ee.dir, comment: ee.fileCommentStr.length ? ee.fileCommentStr : null, unixPermissions: ee.unixPermissions, dosPermissions: ee.dosPermissions, createFolders: M.createFolders }), ee.dir || (Z.file(fe).unsafeOriginalName = le);
          }
          return Q.zipComment.length && (Z.comment = Q.zipComment), Z;
        });
      };
    }, { "./external": 6, "./nodejsUtils": 14, "./stream/Crc32Probe": 25, "./utf8": 31, "./utils": 32, "./zipEntries": 33 }], 12: [function(t, n, s) {
      var o = t("../utils"), h = t("../stream/GenericWorker");
      function c(_, x) {
        h.call(this, "Nodejs stream input adapter for " + _), this._upstreamEnded = !1, this._bindStream(x);
      }
      o.inherits(c, h), c.prototype._bindStream = function(_) {
        var x = this;
        (this._stream = _).pause(), _.on("data", function(B) {
          x.push({ data: B, meta: { percent: 0 } });
        }).on("error", function(B) {
          x.isPaused ? this.generatedError = B : x.error(B);
        }).on("end", function() {
          x.isPaused ? x._upstreamEnded = !0 : x.end();
        });
      }, c.prototype.pause = function() {
        return !!h.prototype.pause.call(this) && (this._stream.pause(), !0);
      }, c.prototype.resume = function() {
        return !!h.prototype.resume.call(this) && (this._upstreamEnded ? this.end() : this._stream.resume(), !0);
      }, n.exports = c;
    }, { "../stream/GenericWorker": 28, "../utils": 32 }], 13: [function(t, n, s) {
      var o = t("readable-stream").Readable;
      function h(c, _, x) {
        o.call(this, _), this._helper = c;
        var B = this;
        c.on("data", function(P, U) {
          B.push(P) || B._helper.pause(), x && x(U);
        }).on("error", function(P) {
          B.emit("error", P);
        }).on("end", function() {
          B.push(null);
        });
      }
      t("../utils").inherits(h, o), h.prototype._read = function() {
        this._helper.resume();
      }, n.exports = h;
    }, { "../utils": 32, "readable-stream": 16 }], 14: [function(t, n, s) {
      n.exports = { isNode: typeof Buffer < "u", newBufferFrom: function(o, h) {
        if (Buffer.from && Buffer.from !== Uint8Array.from)
          return Buffer.from(o, h);
        if (typeof o == "number")
          throw new Error('The "data" argument must not be a number');
        return new Buffer(o, h);
      }, allocBuffer: function(o) {
        if (Buffer.alloc)
          return Buffer.alloc(o);
        var h = new Buffer(o);
        return h.fill(0), h;
      }, isBuffer: function(o) {
        return Buffer.isBuffer(o);
      }, isStream: function(o) {
        return o && typeof o.on == "function" && typeof o.pause == "function" && typeof o.resume == "function";
      } };
    }, {}], 15: [function(t, n, s) {
      function o(fe, X, W) {
        var je, ke = c.getTypeOf(X), Ye = c.extend(W || {}, B);
        Ye.date = Ye.date || /* @__PURE__ */ new Date(), Ye.compression !== null && (Ye.compression = Ye.compression.toUpperCase()), typeof Ye.unixPermissions == "string" && (Ye.unixPermissions = parseInt(Ye.unixPermissions, 8)), Ye.unixPermissions && 16384 & Ye.unixPermissions && (Ye.dir = !0), Ye.dosPermissions && 16 & Ye.dosPermissions && (Ye.dir = !0), Ye.dir && (fe = D(fe)), Ye.createFolders && (je = Q(fe)) && te.call(this, je, !0);
        var pt = ke === "string" && Ye.binary === !1 && Ye.base64 === !1;
        W && W.binary !== void 0 || (Ye.binary = !pt), (X instanceof P && X.uncompressedSize === 0 || Ye.dir || !X || X.length === 0) && (Ye.base64 = !1, Ye.binary = !0, X = "", Ye.compression = "STORE", ke = "string");
        var Le = null;
        Le = X instanceof P || X instanceof _ ? X : Z.isNode && Z.isStream(X) ? new F(fe, X) : c.prepareContent(fe, X, Ye.binary, Ye.optimizedBinaryString, Ye.base64);
        var $e = new U(fe, Le, Ye);
        this.files[fe] = $e;
      }
      var h = t("./utf8"), c = t("./utils"), _ = t("./stream/GenericWorker"), x = t("./stream/StreamHelper"), B = t("./defaults"), P = t("./compressedObject"), U = t("./zipObject"), M = t("./generate"), Z = t("./nodejsUtils"), F = t("./nodejs/NodejsStreamInputAdapter"), Q = function(fe) {
        fe.slice(-1) === "/" && (fe = fe.substring(0, fe.length - 1));
        var X = fe.lastIndexOf("/");
        return 0 < X ? fe.substring(0, X) : "";
      }, D = function(fe) {
        return fe.slice(-1) !== "/" && (fe += "/"), fe;
      }, te = function(fe, X) {
        return X = X !== void 0 ? X : B.createFolders, fe = D(fe), this.files[fe] || o.call(this, fe, null, { dir: !0, createFolders: X }), this.files[fe];
      };
      function ee(fe) {
        return Object.prototype.toString.call(fe) === "[object RegExp]";
      }
      var le = { load: function() {
        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
      }, forEach: function(fe) {
        var X, W, je;
        for (X in this.files)
          je = this.files[X], (W = X.slice(this.root.length, X.length)) && X.slice(0, this.root.length) === this.root && fe(W, je);
      }, filter: function(fe) {
        var X = [];
        return this.forEach(function(W, je) {
          fe(W, je) && X.push(je);
        }), X;
      }, file: function(fe, X, W) {
        if (arguments.length !== 1)
          return fe = this.root + fe, o.call(this, fe, X, W), this;
        if (ee(fe)) {
          var je = fe;
          return this.filter(function(Ye, pt) {
            return !pt.dir && je.test(Ye);
          });
        }
        var ke = this.files[this.root + fe];
        return ke && !ke.dir ? ke : null;
      }, folder: function(fe) {
        if (!fe)
          return this;
        if (ee(fe))
          return this.filter(function(ke, Ye) {
            return Ye.dir && fe.test(ke);
          });
        var X = this.root + fe, W = te.call(this, X), je = this.clone();
        return je.root = W.name, je;
      }, remove: function(fe) {
        fe = this.root + fe;
        var X = this.files[fe];
        if (X || (fe.slice(-1) !== "/" && (fe += "/"), X = this.files[fe]), X && !X.dir)
          delete this.files[fe];
        else
          for (var W = this.filter(function(ke, Ye) {
            return Ye.name.slice(0, fe.length) === fe;
          }), je = 0; je < W.length; je++)
            delete this.files[W[je].name];
        return this;
      }, generate: function() {
        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
      }, generateInternalStream: function(fe) {
        var X, W = {};
        try {
          if ((W = c.extend(fe || {}, { streamFiles: !1, compression: "STORE", compressionOptions: null, type: "", platform: "DOS", comment: null, mimeType: "application/zip", encodeFileName: h.utf8encode })).type = W.type.toLowerCase(), W.compression = W.compression.toUpperCase(), W.type === "binarystring" && (W.type = "string"), !W.type)
            throw new Error("No output type specified.");
          c.checkSupport(W.type), W.platform !== "darwin" && W.platform !== "freebsd" && W.platform !== "linux" && W.platform !== "sunos" || (W.platform = "UNIX"), W.platform === "win32" && (W.platform = "DOS");
          var je = W.comment || this.comment || "";
          X = M.generateWorker(this, W, je);
        } catch (ke) {
          (X = new _("error")).error(ke);
        }
        return new x(X, W.type || "string", W.mimeType);
      }, generateAsync: function(fe, X) {
        return this.generateInternalStream(fe).accumulate(X);
      }, generateNodeStream: function(fe, X) {
        return (fe = fe || {}).type || (fe.type = "nodebuffer"), this.generateInternalStream(fe).toNodejsStream(X);
      } };
      n.exports = le;
    }, { "./compressedObject": 2, "./defaults": 5, "./generate": 9, "./nodejs/NodejsStreamInputAdapter": 12, "./nodejsUtils": 14, "./stream/GenericWorker": 28, "./stream/StreamHelper": 29, "./utf8": 31, "./utils": 32, "./zipObject": 35 }], 16: [function(t, n, s) {
      n.exports = t("stream");
    }, { stream: void 0 }], 17: [function(t, n, s) {
      var o = t("./DataReader");
      function h(c) {
        o.call(this, c);
        for (var _ = 0; _ < this.data.length; _++)
          c[_] = 255 & c[_];
      }
      t("../utils").inherits(h, o), h.prototype.byteAt = function(c) {
        return this.data[this.zero + c];
      }, h.prototype.lastIndexOfSignature = function(c) {
        for (var _ = c.charCodeAt(0), x = c.charCodeAt(1), B = c.charCodeAt(2), P = c.charCodeAt(3), U = this.length - 4; 0 <= U; --U)
          if (this.data[U] === _ && this.data[U + 1] === x && this.data[U + 2] === B && this.data[U + 3] === P)
            return U - this.zero;
        return -1;
      }, h.prototype.readAndCheckSignature = function(c) {
        var _ = c.charCodeAt(0), x = c.charCodeAt(1), B = c.charCodeAt(2), P = c.charCodeAt(3), U = this.readData(4);
        return _ === U[0] && x === U[1] && B === U[2] && P === U[3];
      }, h.prototype.readData = function(c) {
        if (this.checkOffset(c), c === 0)
          return [];
        var _ = this.data.slice(this.zero + this.index, this.zero + this.index + c);
        return this.index += c, _;
      }, n.exports = h;
    }, { "../utils": 32, "./DataReader": 18 }], 18: [function(t, n, s) {
      var o = t("../utils");
      function h(c) {
        this.data = c, this.length = c.length, this.index = 0, this.zero = 0;
      }
      h.prototype = { checkOffset: function(c) {
        this.checkIndex(this.index + c);
      }, checkIndex: function(c) {
        if (this.length < this.zero + c || c < 0)
          throw new Error("End of data reached (data length = " + this.length + ", asked index = " + c + "). Corrupted zip ?");
      }, setIndex: function(c) {
        this.checkIndex(c), this.index = c;
      }, skip: function(c) {
        this.setIndex(this.index + c);
      }, byteAt: function() {
      }, readInt: function(c) {
        var _, x = 0;
        for (this.checkOffset(c), _ = this.index + c - 1; _ >= this.index; _--)
          x = (x << 8) + this.byteAt(_);
        return this.index += c, x;
      }, readString: function(c) {
        return o.transformTo("string", this.readData(c));
      }, readData: function() {
      }, lastIndexOfSignature: function() {
      }, readAndCheckSignature: function() {
      }, readDate: function() {
        var c = this.readInt(4);
        return new Date(Date.UTC(1980 + (c >> 25 & 127), (c >> 21 & 15) - 1, c >> 16 & 31, c >> 11 & 31, c >> 5 & 63, (31 & c) << 1));
      } }, n.exports = h;
    }, { "../utils": 32 }], 19: [function(t, n, s) {
      var o = t("./Uint8ArrayReader");
      function h(c) {
        o.call(this, c);
      }
      t("../utils").inherits(h, o), h.prototype.readData = function(c) {
        this.checkOffset(c);
        var _ = this.data.slice(this.zero + this.index, this.zero + this.index + c);
        return this.index += c, _;
      }, n.exports = h;
    }, { "../utils": 32, "./Uint8ArrayReader": 21 }], 20: [function(t, n, s) {
      var o = t("./DataReader");
      function h(c) {
        o.call(this, c);
      }
      t("../utils").inherits(h, o), h.prototype.byteAt = function(c) {
        return this.data.charCodeAt(this.zero + c);
      }, h.prototype.lastIndexOfSignature = function(c) {
        return this.data.lastIndexOf(c) - this.zero;
      }, h.prototype.readAndCheckSignature = function(c) {
        return c === this.readData(4);
      }, h.prototype.readData = function(c) {
        this.checkOffset(c);
        var _ = this.data.slice(this.zero + this.index, this.zero + this.index + c);
        return this.index += c, _;
      }, n.exports = h;
    }, { "../utils": 32, "./DataReader": 18 }], 21: [function(t, n, s) {
      var o = t("./ArrayReader");
      function h(c) {
        o.call(this, c);
      }
      t("../utils").inherits(h, o), h.prototype.readData = function(c) {
        if (this.checkOffset(c), c === 0)
          return new Uint8Array(0);
        var _ = this.data.subarray(this.zero + this.index, this.zero + this.index + c);
        return this.index += c, _;
      }, n.exports = h;
    }, { "../utils": 32, "./ArrayReader": 17 }], 22: [function(t, n, s) {
      var o = t("../utils"), h = t("../support"), c = t("./ArrayReader"), _ = t("./StringReader"), x = t("./NodeBufferReader"), B = t("./Uint8ArrayReader");
      n.exports = function(P) {
        var U = o.getTypeOf(P);
        return o.checkSupport(U), U !== "string" || h.uint8array ? U === "nodebuffer" ? new x(P) : h.uint8array ? new B(o.transformTo("uint8array", P)) : new c(o.transformTo("array", P)) : new _(P);
      };
    }, { "../support": 30, "../utils": 32, "./ArrayReader": 17, "./NodeBufferReader": 19, "./StringReader": 20, "./Uint8ArrayReader": 21 }], 23: [function(t, n, s) {
      s.LOCAL_FILE_HEADER = "PK", s.CENTRAL_FILE_HEADER = "PK", s.CENTRAL_DIRECTORY_END = "PK", s.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x07", s.ZIP64_CENTRAL_DIRECTORY_END = "PK", s.DATA_DESCRIPTOR = "PK\x07\b";
    }, {}], 24: [function(t, n, s) {
      var o = t("./GenericWorker"), h = t("../utils");
      function c(_) {
        o.call(this, "ConvertWorker to " + _), this.destType = _;
      }
      h.inherits(c, o), c.prototype.processChunk = function(_) {
        this.push({ data: h.transformTo(this.destType, _.data), meta: _.meta });
      }, n.exports = c;
    }, { "../utils": 32, "./GenericWorker": 28 }], 25: [function(t, n, s) {
      var o = t("./GenericWorker"), h = t("../crc32");
      function c() {
        o.call(this, "Crc32Probe"), this.withStreamInfo("crc32", 0);
      }
      t("../utils").inherits(c, o), c.prototype.processChunk = function(_) {
        this.streamInfo.crc32 = h(_.data, this.streamInfo.crc32 || 0), this.push(_);
      }, n.exports = c;
    }, { "../crc32": 4, "../utils": 32, "./GenericWorker": 28 }], 26: [function(t, n, s) {
      var o = t("../utils"), h = t("./GenericWorker");
      function c(_) {
        h.call(this, "DataLengthProbe for " + _), this.propName = _, this.withStreamInfo(_, 0);
      }
      o.inherits(c, h), c.prototype.processChunk = function(_) {
        if (_) {
          var x = this.streamInfo[this.propName] || 0;
          this.streamInfo[this.propName] = x + _.data.length;
        }
        h.prototype.processChunk.call(this, _);
      }, n.exports = c;
    }, { "../utils": 32, "./GenericWorker": 28 }], 27: [function(t, n, s) {
      var o = t("../utils"), h = t("./GenericWorker");
      function c(_) {
        h.call(this, "DataWorker");
        var x = this;
        this.dataIsReady = !1, this.index = 0, this.max = 0, this.data = null, this.type = "", this._tickScheduled = !1, _.then(function(B) {
          x.dataIsReady = !0, x.data = B, x.max = B && B.length || 0, x.type = o.getTypeOf(B), x.isPaused || x._tickAndRepeat();
        }, function(B) {
          x.error(B);
        });
      }
      o.inherits(c, h), c.prototype.cleanUp = function() {
        h.prototype.cleanUp.call(this), this.data = null;
      }, c.prototype.resume = function() {
        return !!h.prototype.resume.call(this) && (!this._tickScheduled && this.dataIsReady && (this._tickScheduled = !0, o.delay(this._tickAndRepeat, [], this)), !0);
      }, c.prototype._tickAndRepeat = function() {
        this._tickScheduled = !1, this.isPaused || this.isFinished || (this._tick(), this.isFinished || (o.delay(this._tickAndRepeat, [], this), this._tickScheduled = !0));
      }, c.prototype._tick = function() {
        if (this.isPaused || this.isFinished)
          return !1;
        var _ = null, x = Math.min(this.max, this.index + 16384);
        if (this.index >= this.max)
          return this.end();
        switch (this.type) {
          case "string":
            _ = this.data.substring(this.index, x);
            break;
          case "uint8array":
            _ = this.data.subarray(this.index, x);
            break;
          case "array":
          case "nodebuffer":
            _ = this.data.slice(this.index, x);
        }
        return this.index = x, this.push({ data: _, meta: { percent: this.max ? this.index / this.max * 100 : 0 } });
      }, n.exports = c;
    }, { "../utils": 32, "./GenericWorker": 28 }], 28: [function(t, n, s) {
      function o(h) {
        this.name = h || "default", this.streamInfo = {}, this.generatedError = null, this.extraStreamInfo = {}, this.isPaused = !0, this.isFinished = !1, this.isLocked = !1, this._listeners = { data: [], end: [], error: [] }, this.previous = null;
      }
      o.prototype = { push: function(h) {
        this.emit("data", h);
      }, end: function() {
        if (this.isFinished)
          return !1;
        this.flush();
        try {
          this.emit("end"), this.cleanUp(), this.isFinished = !0;
        } catch (h) {
          this.emit("error", h);
        }
        return !0;
      }, error: function(h) {
        return !this.isFinished && (this.isPaused ? this.generatedError = h : (this.isFinished = !0, this.emit("error", h), this.previous && this.previous.error(h), this.cleanUp()), !0);
      }, on: function(h, c) {
        return this._listeners[h].push(c), this;
      }, cleanUp: function() {
        this.streamInfo = this.generatedError = this.extraStreamInfo = null, this._listeners = [];
      }, emit: function(h, c) {
        if (this._listeners[h])
          for (var _ = 0; _ < this._listeners[h].length; _++)
            this._listeners[h][_].call(this, c);
      }, pipe: function(h) {
        return h.registerPrevious(this);
      }, registerPrevious: function(h) {
        if (this.isLocked)
          throw new Error("The stream '" + this + "' has already been used.");
        this.streamInfo = h.streamInfo, this.mergeStreamInfo(), this.previous = h;
        var c = this;
        return h.on("data", function(_) {
          c.processChunk(_);
        }), h.on("end", function() {
          c.end();
        }), h.on("error", function(_) {
          c.error(_);
        }), this;
      }, pause: function() {
        return !this.isPaused && !this.isFinished && (this.isPaused = !0, this.previous && this.previous.pause(), !0);
      }, resume: function() {
        if (!this.isPaused || this.isFinished)
          return !1;
        var h = this.isPaused = !1;
        return this.generatedError && (this.error(this.generatedError), h = !0), this.previous && this.previous.resume(), !h;
      }, flush: function() {
      }, processChunk: function(h) {
        this.push(h);
      }, withStreamInfo: function(h, c) {
        return this.extraStreamInfo[h] = c, this.mergeStreamInfo(), this;
      }, mergeStreamInfo: function() {
        for (var h in this.extraStreamInfo)
          Object.prototype.hasOwnProperty.call(this.extraStreamInfo, h) && (this.streamInfo[h] = this.extraStreamInfo[h]);
      }, lock: function() {
        if (this.isLocked)
          throw new Error("The stream '" + this + "' has already been used.");
        this.isLocked = !0, this.previous && this.previous.lock();
      }, toString: function() {
        var h = "Worker " + this.name;
        return this.previous ? this.previous + " -> " + h : h;
      } }, n.exports = o;
    }, {}], 29: [function(t, n, s) {
      var o = t("../utils"), h = t("./ConvertWorker"), c = t("./GenericWorker"), _ = t("../base64"), x = t("../support"), B = t("../external"), P = null;
      if (x.nodestream)
        try {
          P = t("../nodejs/NodejsStreamOutputAdapter");
        } catch {
        }
      function U(Z, F) {
        return new B.Promise(function(Q, D) {
          var te = [], ee = Z._internalType, le = Z._outputType, fe = Z._mimeType;
          Z.on("data", function(X, W) {
            te.push(X), F && F(W);
          }).on("error", function(X) {
            te = [], D(X);
          }).on("end", function() {
            try {
              var X = function(W, je, ke) {
                switch (W) {
                  case "blob":
                    return o.newBlob(o.transformTo("arraybuffer", je), ke);
                  case "base64":
                    return _.encode(je);
                  default:
                    return o.transformTo(W, je);
                }
              }(le, function(W, je) {
                var ke, Ye = 0, pt = null, Le = 0;
                for (ke = 0; ke < je.length; ke++)
                  Le += je[ke].length;
                switch (W) {
                  case "string":
                    return je.join("");
                  case "array":
                    return Array.prototype.concat.apply([], je);
                  case "uint8array":
                    for (pt = new Uint8Array(Le), ke = 0; ke < je.length; ke++)
                      pt.set(je[ke], Ye), Ye += je[ke].length;
                    return pt;
                  case "nodebuffer":
                    return Buffer.concat(je);
                  default:
                    throw new Error("concat : unsupported type '" + W + "'");
                }
              }(ee, te), fe);
              Q(X);
            } catch (W) {
              D(W);
            }
            te = [];
          }).resume();
        });
      }
      function M(Z, F, Q) {
        var D = F;
        switch (F) {
          case "blob":
          case "arraybuffer":
            D = "uint8array";
            break;
          case "base64":
            D = "string";
        }
        try {
          this._internalType = D, this._outputType = F, this._mimeType = Q, o.checkSupport(D), this._worker = Z.pipe(new h(D)), Z.lock();
        } catch (te) {
          this._worker = new c("error"), this._worker.error(te);
        }
      }
      M.prototype = { accumulate: function(Z) {
        return U(this, Z);
      }, on: function(Z, F) {
        var Q = this;
        return Z === "data" ? this._worker.on(Z, function(D) {
          F.call(Q, D.data, D.meta);
        }) : this._worker.on(Z, function() {
          o.delay(F, arguments, Q);
        }), this;
      }, resume: function() {
        return o.delay(this._worker.resume, [], this._worker), this;
      }, pause: function() {
        return this._worker.pause(), this;
      }, toNodejsStream: function(Z) {
        if (o.checkSupport("nodestream"), this._outputType !== "nodebuffer")
          throw new Error(this._outputType + " is not supported by this method");
        return new P(this, { objectMode: this._outputType !== "nodebuffer" }, Z);
      } }, n.exports = M;
    }, { "../base64": 1, "../external": 6, "../nodejs/NodejsStreamOutputAdapter": 13, "../support": 30, "../utils": 32, "./ConvertWorker": 24, "./GenericWorker": 28 }], 30: [function(t, n, s) {
      if (s.base64 = !0, s.array = !0, s.string = !0, s.arraybuffer = typeof ArrayBuffer < "u" && typeof Uint8Array < "u", s.nodebuffer = typeof Buffer < "u", s.uint8array = typeof Uint8Array < "u", typeof ArrayBuffer > "u")
        s.blob = !1;
      else {
        var o = new ArrayBuffer(0);
        try {
          s.blob = new Blob([o], { type: "application/zip" }).size === 0;
        } catch {
          try {
            var h = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder)();
            h.append(o), s.blob = h.getBlob("application/zip").size === 0;
          } catch {
            s.blob = !1;
          }
        }
      }
      try {
        s.nodestream = !!t("readable-stream").Readable;
      } catch {
        s.nodestream = !1;
      }
    }, { "readable-stream": 16 }], 31: [function(t, n, s) {
      for (var o = t("./utils"), h = t("./support"), c = t("./nodejsUtils"), _ = t("./stream/GenericWorker"), x = new Array(256), B = 0; B < 256; B++)
        x[B] = 252 <= B ? 6 : 248 <= B ? 5 : 240 <= B ? 4 : 224 <= B ? 3 : 192 <= B ? 2 : 1;
      x[254] = x[254] = 1;
      function P() {
        _.call(this, "utf-8 decode"), this.leftOver = null;
      }
      function U() {
        _.call(this, "utf-8 encode");
      }
      s.utf8encode = function(M) {
        return h.nodebuffer ? c.newBufferFrom(M, "utf-8") : function(Z) {
          var F, Q, D, te, ee, le = Z.length, fe = 0;
          for (te = 0; te < le; te++)
            (64512 & (Q = Z.charCodeAt(te))) == 55296 && te + 1 < le && (64512 & (D = Z.charCodeAt(te + 1))) == 56320 && (Q = 65536 + (Q - 55296 << 10) + (D - 56320), te++), fe += Q < 128 ? 1 : Q < 2048 ? 2 : Q < 65536 ? 3 : 4;
          for (F = h.uint8array ? new Uint8Array(fe) : new Array(fe), te = ee = 0; ee < fe; te++)
            (64512 & (Q = Z.charCodeAt(te))) == 55296 && te + 1 < le && (64512 & (D = Z.charCodeAt(te + 1))) == 56320 && (Q = 65536 + (Q - 55296 << 10) + (D - 56320), te++), Q < 128 ? F[ee++] = Q : (Q < 2048 ? F[ee++] = 192 | Q >>> 6 : (Q < 65536 ? F[ee++] = 224 | Q >>> 12 : (F[ee++] = 240 | Q >>> 18, F[ee++] = 128 | Q >>> 12 & 63), F[ee++] = 128 | Q >>> 6 & 63), F[ee++] = 128 | 63 & Q);
          return F;
        }(M);
      }, s.utf8decode = function(M) {
        return h.nodebuffer ? o.transformTo("nodebuffer", M).toString("utf-8") : function(Z) {
          var F, Q, D, te, ee = Z.length, le = new Array(2 * ee);
          for (F = Q = 0; F < ee; )
            if ((D = Z[F++]) < 128)
              le[Q++] = D;
            else if (4 < (te = x[D]))
              le[Q++] = 65533, F += te - 1;
            else {
              for (D &= te === 2 ? 31 : te === 3 ? 15 : 7; 1 < te && F < ee; )
                D = D << 6 | 63 & Z[F++], te--;
              1 < te ? le[Q++] = 65533 : D < 65536 ? le[Q++] = D : (D -= 65536, le[Q++] = 55296 | D >> 10 & 1023, le[Q++] = 56320 | 1023 & D);
            }
          return le.length !== Q && (le.subarray ? le = le.subarray(0, Q) : le.length = Q), o.applyFromCharCode(le);
        }(M = o.transformTo(h.uint8array ? "uint8array" : "array", M));
      }, o.inherits(P, _), P.prototype.processChunk = function(M) {
        var Z = o.transformTo(h.uint8array ? "uint8array" : "array", M.data);
        if (this.leftOver && this.leftOver.length) {
          if (h.uint8array) {
            var F = Z;
            (Z = new Uint8Array(F.length + this.leftOver.length)).set(this.leftOver, 0), Z.set(F, this.leftOver.length);
          } else
            Z = this.leftOver.concat(Z);
          this.leftOver = null;
        }
        var Q = function(te, ee) {
          var le;
          for ((ee = ee || te.length) > te.length && (ee = te.length), le = ee - 1; 0 <= le && (192 & te[le]) == 128; )
            le--;
          return le < 0 || le === 0 ? ee : le + x[te[le]] > ee ? le : ee;
        }(Z), D = Z;
        Q !== Z.length && (h.uint8array ? (D = Z.subarray(0, Q), this.leftOver = Z.subarray(Q, Z.length)) : (D = Z.slice(0, Q), this.leftOver = Z.slice(Q, Z.length))), this.push({ data: s.utf8decode(D), meta: M.meta });
      }, P.prototype.flush = function() {
        this.leftOver && this.leftOver.length && (this.push({ data: s.utf8decode(this.leftOver), meta: {} }), this.leftOver = null);
      }, s.Utf8DecodeWorker = P, o.inherits(U, _), U.prototype.processChunk = function(M) {
        this.push({ data: s.utf8encode(M.data), meta: M.meta });
      }, s.Utf8EncodeWorker = U;
    }, { "./nodejsUtils": 14, "./stream/GenericWorker": 28, "./support": 30, "./utils": 32 }], 32: [function(t, n, s) {
      var o = t("./support"), h = t("./base64"), c = t("./nodejsUtils"), _ = t("./external");
      function x(F) {
        return F;
      }
      function B(F, Q) {
        for (var D = 0; D < F.length; ++D)
          Q[D] = 255 & F.charCodeAt(D);
        return Q;
      }
      t("setimmediate"), s.newBlob = function(F, Q) {
        s.checkSupport("blob");
        try {
          return new Blob([F], { type: Q });
        } catch {
          try {
            var D = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder)();
            return D.append(F), D.getBlob(Q);
          } catch {
            throw new Error("Bug : can't construct the Blob.");
          }
        }
      };
      var P = { stringifyByChunk: function(F, Q, D) {
        var te = [], ee = 0, le = F.length;
        if (le <= D)
          return String.fromCharCode.apply(null, F);
        for (; ee < le; )
          Q === "array" || Q === "nodebuffer" ? te.push(String.fromCharCode.apply(null, F.slice(ee, Math.min(ee + D, le)))) : te.push(String.fromCharCode.apply(null, F.subarray(ee, Math.min(ee + D, le)))), ee += D;
        return te.join("");
      }, stringifyByChar: function(F) {
        for (var Q = "", D = 0; D < F.length; D++)
          Q += String.fromCharCode(F[D]);
        return Q;
      }, applyCanBeUsed: { uint8array: function() {
        try {
          return o.uint8array && String.fromCharCode.apply(null, new Uint8Array(1)).length === 1;
        } catch {
          return !1;
        }
      }(), nodebuffer: function() {
        try {
          return o.nodebuffer && String.fromCharCode.apply(null, c.allocBuffer(1)).length === 1;
        } catch {
          return !1;
        }
      }() } };
      function U(F) {
        var Q = 65536, D = s.getTypeOf(F), te = !0;
        if (D === "uint8array" ? te = P.applyCanBeUsed.uint8array : D === "nodebuffer" && (te = P.applyCanBeUsed.nodebuffer), te)
          for (; 1 < Q; )
            try {
              return P.stringifyByChunk(F, D, Q);
            } catch {
              Q = Math.floor(Q / 2);
            }
        return P.stringifyByChar(F);
      }
      function M(F, Q) {
        for (var D = 0; D < F.length; D++)
          Q[D] = F[D];
        return Q;
      }
      s.applyFromCharCode = U;
      var Z = {};
      Z.string = { string: x, array: function(F) {
        return B(F, new Array(F.length));
      }, arraybuffer: function(F) {
        return Z.string.uint8array(F).buffer;
      }, uint8array: function(F) {
        return B(F, new Uint8Array(F.length));
      }, nodebuffer: function(F) {
        return B(F, c.allocBuffer(F.length));
      } }, Z.array = { string: U, array: x, arraybuffer: function(F) {
        return new Uint8Array(F).buffer;
      }, uint8array: function(F) {
        return new Uint8Array(F);
      }, nodebuffer: function(F) {
        return c.newBufferFrom(F);
      } }, Z.arraybuffer = { string: function(F) {
        return U(new Uint8Array(F));
      }, array: function(F) {
        return M(new Uint8Array(F), new Array(F.byteLength));
      }, arraybuffer: x, uint8array: function(F) {
        return new Uint8Array(F);
      }, nodebuffer: function(F) {
        return c.newBufferFrom(new Uint8Array(F));
      } }, Z.uint8array = { string: U, array: function(F) {
        return M(F, new Array(F.length));
      }, arraybuffer: function(F) {
        return F.buffer;
      }, uint8array: x, nodebuffer: function(F) {
        return c.newBufferFrom(F);
      } }, Z.nodebuffer = { string: U, array: function(F) {
        return M(F, new Array(F.length));
      }, arraybuffer: function(F) {
        return Z.nodebuffer.uint8array(F).buffer;
      }, uint8array: function(F) {
        return M(F, new Uint8Array(F.length));
      }, nodebuffer: x }, s.transformTo = function(F, Q) {
        if (Q = Q || "", !F)
          return Q;
        s.checkSupport(F);
        var D = s.getTypeOf(Q);
        return Z[D][F](Q);
      }, s.resolve = function(F) {
        for (var Q = F.split("/"), D = [], te = 0; te < Q.length; te++) {
          var ee = Q[te];
          ee === "." || ee === "" && te !== 0 && te !== Q.length - 1 || (ee === ".." ? D.pop() : D.push(ee));
        }
        return D.join("/");
      }, s.getTypeOf = function(F) {
        return typeof F == "string" ? "string" : Object.prototype.toString.call(F) === "[object Array]" ? "array" : o.nodebuffer && c.isBuffer(F) ? "nodebuffer" : o.uint8array && F instanceof Uint8Array ? "uint8array" : o.arraybuffer && F instanceof ArrayBuffer ? "arraybuffer" : void 0;
      }, s.checkSupport = function(F) {
        if (!o[F.toLowerCase()])
          throw new Error(F + " is not supported by this platform");
      }, s.MAX_VALUE_16BITS = 65535, s.MAX_VALUE_32BITS = -1, s.pretty = function(F) {
        var Q, D, te = "";
        for (D = 0; D < (F || "").length; D++)
          te += "\\x" + ((Q = F.charCodeAt(D)) < 16 ? "0" : "") + Q.toString(16).toUpperCase();
        return te;
      }, s.delay = function(F, Q, D) {
        setImmediate(function() {
          F.apply(D || null, Q || []);
        });
      }, s.inherits = function(F, Q) {
        function D() {
        }
        D.prototype = Q.prototype, F.prototype = new D();
      }, s.extend = function() {
        var F, Q, D = {};
        for (F = 0; F < arguments.length; F++)
          for (Q in arguments[F])
            Object.prototype.hasOwnProperty.call(arguments[F], Q) && D[Q] === void 0 && (D[Q] = arguments[F][Q]);
        return D;
      }, s.prepareContent = function(F, Q, D, te, ee) {
        return _.Promise.resolve(Q).then(function(le) {
          return o.blob && (le instanceof Blob || ["[object File]", "[object Blob]"].indexOf(Object.prototype.toString.call(le)) !== -1) && typeof FileReader < "u" ? new _.Promise(function(fe, X) {
            var W = new FileReader();
            W.onload = function(je) {
              fe(je.target.result);
            }, W.onerror = function(je) {
              X(je.target.error);
            }, W.readAsArrayBuffer(le);
          }) : le;
        }).then(function(le) {
          var fe = s.getTypeOf(le);
          return fe ? (fe === "arraybuffer" ? le = s.transformTo("uint8array", le) : fe === "string" && (ee ? le = h.decode(le) : D && te !== !0 && (le = function(X) {
            return B(X, o.uint8array ? new Uint8Array(X.length) : new Array(X.length));
          }(le))), le) : _.Promise.reject(new Error("Can't read the data of '" + F + "'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"));
        });
      };
    }, { "./base64": 1, "./external": 6, "./nodejsUtils": 14, "./support": 30, setimmediate: 54 }], 33: [function(t, n, s) {
      var o = t("./reader/readerFor"), h = t("./utils"), c = t("./signature"), _ = t("./zipEntry"), x = t("./support");
      function B(P) {
        this.files = [], this.loadOptions = P;
      }
      B.prototype = { checkSignature: function(P) {
        if (!this.reader.readAndCheckSignature(P)) {
          this.reader.index -= 4;
          var U = this.reader.readString(4);
          throw new Error("Corrupted zip or bug: unexpected signature (" + h.pretty(U) + ", expected " + h.pretty(P) + ")");
        }
      }, isSignature: function(P, U) {
        var M = this.reader.index;
        this.reader.setIndex(P);
        var Z = this.reader.readString(4) === U;
        return this.reader.setIndex(M), Z;
      }, readBlockEndOfCentral: function() {
        this.diskNumber = this.reader.readInt(2), this.diskWithCentralDirStart = this.reader.readInt(2), this.centralDirRecordsOnThisDisk = this.reader.readInt(2), this.centralDirRecords = this.reader.readInt(2), this.centralDirSize = this.reader.readInt(4), this.centralDirOffset = this.reader.readInt(4), this.zipCommentLength = this.reader.readInt(2);
        var P = this.reader.readData(this.zipCommentLength), U = x.uint8array ? "uint8array" : "array", M = h.transformTo(U, P);
        this.zipComment = this.loadOptions.decodeFileName(M);
      }, readBlockZip64EndOfCentral: function() {
        this.zip64EndOfCentralSize = this.reader.readInt(8), this.reader.skip(4), this.diskNumber = this.reader.readInt(4), this.diskWithCentralDirStart = this.reader.readInt(4), this.centralDirRecordsOnThisDisk = this.reader.readInt(8), this.centralDirRecords = this.reader.readInt(8), this.centralDirSize = this.reader.readInt(8), this.centralDirOffset = this.reader.readInt(8), this.zip64ExtensibleData = {};
        for (var P, U, M, Z = this.zip64EndOfCentralSize - 44; 0 < Z; )
          P = this.reader.readInt(2), U = this.reader.readInt(4), M = this.reader.readData(U), this.zip64ExtensibleData[P] = { id: P, length: U, value: M };
      }, readBlockZip64EndOfCentralLocator: function() {
        if (this.diskWithZip64CentralDirStart = this.reader.readInt(4), this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8), this.disksCount = this.reader.readInt(4), 1 < this.disksCount)
          throw new Error("Multi-volumes zip are not supported");
      }, readLocalFiles: function() {
        var P, U;
        for (P = 0; P < this.files.length; P++)
          U = this.files[P], this.reader.setIndex(U.localHeaderOffset), this.checkSignature(c.LOCAL_FILE_HEADER), U.readLocalPart(this.reader), U.handleUTF8(), U.processAttributes();
      }, readCentralDir: function() {
        var P;
        for (this.reader.setIndex(this.centralDirOffset); this.reader.readAndCheckSignature(c.CENTRAL_FILE_HEADER); )
          (P = new _({ zip64: this.zip64 }, this.loadOptions)).readCentralPart(this.reader), this.files.push(P);
        if (this.centralDirRecords !== this.files.length && this.centralDirRecords !== 0 && this.files.length === 0)
          throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
      }, readEndOfCentral: function() {
        var P = this.reader.lastIndexOfSignature(c.CENTRAL_DIRECTORY_END);
        if (P < 0)
          throw this.isSignature(0, c.LOCAL_FILE_HEADER) ? new Error("Corrupted zip: can't find end of central directory") : new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html");
        this.reader.setIndex(P);
        var U = P;
        if (this.checkSignature(c.CENTRAL_DIRECTORY_END), this.readBlockEndOfCentral(), this.diskNumber === h.MAX_VALUE_16BITS || this.diskWithCentralDirStart === h.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === h.MAX_VALUE_16BITS || this.centralDirRecords === h.MAX_VALUE_16BITS || this.centralDirSize === h.MAX_VALUE_32BITS || this.centralDirOffset === h.MAX_VALUE_32BITS) {
          if (this.zip64 = !0, (P = this.reader.lastIndexOfSignature(c.ZIP64_CENTRAL_DIRECTORY_LOCATOR)) < 0)
            throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
          if (this.reader.setIndex(P), this.checkSignature(c.ZIP64_CENTRAL_DIRECTORY_LOCATOR), this.readBlockZip64EndOfCentralLocator(), !this.isSignature(this.relativeOffsetEndOfZip64CentralDir, c.ZIP64_CENTRAL_DIRECTORY_END) && (this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(c.ZIP64_CENTRAL_DIRECTORY_END), this.relativeOffsetEndOfZip64CentralDir < 0))
            throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
          this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir), this.checkSignature(c.ZIP64_CENTRAL_DIRECTORY_END), this.readBlockZip64EndOfCentral();
        }
        var M = this.centralDirOffset + this.centralDirSize;
        this.zip64 && (M += 20, M += 12 + this.zip64EndOfCentralSize);
        var Z = U - M;
        if (0 < Z)
          this.isSignature(U, c.CENTRAL_FILE_HEADER) || (this.reader.zero = Z);
        else if (Z < 0)
          throw new Error("Corrupted zip: missing " + Math.abs(Z) + " bytes.");
      }, prepareReader: function(P) {
        this.reader = o(P);
      }, load: function(P) {
        this.prepareReader(P), this.readEndOfCentral(), this.readCentralDir(), this.readLocalFiles();
      } }, n.exports = B;
    }, { "./reader/readerFor": 22, "./signature": 23, "./support": 30, "./utils": 32, "./zipEntry": 34 }], 34: [function(t, n, s) {
      var o = t("./reader/readerFor"), h = t("./utils"), c = t("./compressedObject"), _ = t("./crc32"), x = t("./utf8"), B = t("./compressions"), P = t("./support");
      function U(M, Z) {
        this.options = M, this.loadOptions = Z;
      }
      U.prototype = { isEncrypted: function() {
        return (1 & this.bitFlag) == 1;
      }, useUTF8: function() {
        return (2048 & this.bitFlag) == 2048;
      }, readLocalPart: function(M) {
        var Z, F;
        if (M.skip(22), this.fileNameLength = M.readInt(2), F = M.readInt(2), this.fileName = M.readData(this.fileNameLength), M.skip(F), this.compressedSize === -1 || this.uncompressedSize === -1)
          throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");
        if ((Z = function(Q) {
          for (var D in B)
            if (Object.prototype.hasOwnProperty.call(B, D) && B[D].magic === Q)
              return B[D];
          return null;
        }(this.compressionMethod)) === null)
          throw new Error("Corrupted zip : compression " + h.pretty(this.compressionMethod) + " unknown (inner file : " + h.transformTo("string", this.fileName) + ")");
        this.decompressed = new c(this.compressedSize, this.uncompressedSize, this.crc32, Z, M.readData(this.compressedSize));
      }, readCentralPart: function(M) {
        this.versionMadeBy = M.readInt(2), M.skip(2), this.bitFlag = M.readInt(2), this.compressionMethod = M.readString(2), this.date = M.readDate(), this.crc32 = M.readInt(4), this.compressedSize = M.readInt(4), this.uncompressedSize = M.readInt(4);
        var Z = M.readInt(2);
        if (this.extraFieldsLength = M.readInt(2), this.fileCommentLength = M.readInt(2), this.diskNumberStart = M.readInt(2), this.internalFileAttributes = M.readInt(2), this.externalFileAttributes = M.readInt(4), this.localHeaderOffset = M.readInt(4), this.isEncrypted())
          throw new Error("Encrypted zip are not supported");
        M.skip(Z), this.readExtraFields(M), this.parseZIP64ExtraField(M), this.fileComment = M.readData(this.fileCommentLength);
      }, processAttributes: function() {
        this.unixPermissions = null, this.dosPermissions = null;
        var M = this.versionMadeBy >> 8;
        this.dir = !!(16 & this.externalFileAttributes), M == 0 && (this.dosPermissions = 63 & this.externalFileAttributes), M == 3 && (this.unixPermissions = this.externalFileAttributes >> 16 & 65535), this.dir || this.fileNameStr.slice(-1) !== "/" || (this.dir = !0);
      }, parseZIP64ExtraField: function() {
        if (this.extraFields[1]) {
          var M = o(this.extraFields[1].value);
          this.uncompressedSize === h.MAX_VALUE_32BITS && (this.uncompressedSize = M.readInt(8)), this.compressedSize === h.MAX_VALUE_32BITS && (this.compressedSize = M.readInt(8)), this.localHeaderOffset === h.MAX_VALUE_32BITS && (this.localHeaderOffset = M.readInt(8)), this.diskNumberStart === h.MAX_VALUE_32BITS && (this.diskNumberStart = M.readInt(4));
        }
      }, readExtraFields: function(M) {
        var Z, F, Q, D = M.index + this.extraFieldsLength;
        for (this.extraFields || (this.extraFields = {}); M.index + 4 < D; )
          Z = M.readInt(2), F = M.readInt(2), Q = M.readData(F), this.extraFields[Z] = { id: Z, length: F, value: Q };
        M.setIndex(D);
      }, handleUTF8: function() {
        var M = P.uint8array ? "uint8array" : "array";
        if (this.useUTF8())
          this.fileNameStr = x.utf8decode(this.fileName), this.fileCommentStr = x.utf8decode(this.fileComment);
        else {
          var Z = this.findExtraFieldUnicodePath();
          if (Z !== null)
            this.fileNameStr = Z;
          else {
            var F = h.transformTo(M, this.fileName);
            this.fileNameStr = this.loadOptions.decodeFileName(F);
          }
          var Q = this.findExtraFieldUnicodeComment();
          if (Q !== null)
            this.fileCommentStr = Q;
          else {
            var D = h.transformTo(M, this.fileComment);
            this.fileCommentStr = this.loadOptions.decodeFileName(D);
          }
        }
      }, findExtraFieldUnicodePath: function() {
        var M = this.extraFields[28789];
        if (M) {
          var Z = o(M.value);
          return Z.readInt(1) !== 1 || _(this.fileName) !== Z.readInt(4) ? null : x.utf8decode(Z.readData(M.length - 5));
        }
        return null;
      }, findExtraFieldUnicodeComment: function() {
        var M = this.extraFields[25461];
        if (M) {
          var Z = o(M.value);
          return Z.readInt(1) !== 1 || _(this.fileComment) !== Z.readInt(4) ? null : x.utf8decode(Z.readData(M.length - 5));
        }
        return null;
      } }, n.exports = U;
    }, { "./compressedObject": 2, "./compressions": 3, "./crc32": 4, "./reader/readerFor": 22, "./support": 30, "./utf8": 31, "./utils": 32 }], 35: [function(t, n, s) {
      function o(Z, F, Q) {
        this.name = Z, this.dir = Q.dir, this.date = Q.date, this.comment = Q.comment, this.unixPermissions = Q.unixPermissions, this.dosPermissions = Q.dosPermissions, this._data = F, this._dataBinary = Q.binary, this.options = { compression: Q.compression, compressionOptions: Q.compressionOptions };
      }
      var h = t("./stream/StreamHelper"), c = t("./stream/DataWorker"), _ = t("./utf8"), x = t("./compressedObject"), B = t("./stream/GenericWorker");
      o.prototype = { internalStream: function(Z) {
        var F = null, Q = "string";
        try {
          if (!Z)
            throw new Error("No output type specified.");
          var D = (Q = Z.toLowerCase()) === "string" || Q === "text";
          Q !== "binarystring" && Q !== "text" || (Q = "string"), F = this._decompressWorker();
          var te = !this._dataBinary;
          te && !D && (F = F.pipe(new _.Utf8EncodeWorker())), !te && D && (F = F.pipe(new _.Utf8DecodeWorker()));
        } catch (ee) {
          (F = new B("error")).error(ee);
        }
        return new h(F, Q, "");
      }, async: function(Z, F) {
        return this.internalStream(Z).accumulate(F);
      }, nodeStream: function(Z, F) {
        return this.internalStream(Z || "nodebuffer").toNodejsStream(F);
      }, _compressWorker: function(Z, F) {
        if (this._data instanceof x && this._data.compression.magic === Z.magic)
          return this._data.getCompressedWorker();
        var Q = this._decompressWorker();
        return this._dataBinary || (Q = Q.pipe(new _.Utf8EncodeWorker())), x.createWorkerFrom(Q, Z, F);
      }, _decompressWorker: function() {
        return this._data instanceof x ? this._data.getContentWorker() : this._data instanceof B ? this._data : new c(this._data);
      } };
      for (var P = ["asText", "asBinary", "asNodeBuffer", "asUint8Array", "asArrayBuffer"], U = function() {
        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
      }, M = 0; M < P.length; M++)
        o.prototype[P[M]] = U;
      n.exports = o;
    }, { "./compressedObject": 2, "./stream/DataWorker": 27, "./stream/GenericWorker": 28, "./stream/StreamHelper": 29, "./utf8": 31 }], 36: [function(t, n, s) {
      (function(o) {
        var h, c, _ = o.MutationObserver || o.WebKitMutationObserver;
        if (_) {
          var x = 0, B = new _(Z), P = o.document.createTextNode("");
          B.observe(P, { characterData: !0 }), h = function() {
            P.data = x = ++x % 2;
          };
        } else if (o.setImmediate || o.MessageChannel === void 0)
          h = "document" in o && "onreadystatechange" in o.document.createElement("script") ? function() {
            var F = o.document.createElement("script");
            F.onreadystatechange = function() {
              Z(), F.onreadystatechange = null, F.parentNode.removeChild(F), F = null;
            }, o.document.documentElement.appendChild(F);
          } : function() {
            setTimeout(Z, 0);
          };
        else {
          var U = new o.MessageChannel();
          U.port1.onmessage = Z, h = function() {
            U.port2.postMessage(0);
          };
        }
        var M = [];
        function Z() {
          var F, Q;
          c = !0;
          for (var D = M.length; D; ) {
            for (Q = M, M = [], F = -1; ++F < D; )
              Q[F]();
            D = M.length;
          }
          c = !1;
        }
        n.exports = function(F) {
          M.push(F) !== 1 || c || h();
        };
      }).call(this, typeof ss < "u" ? ss : typeof self < "u" ? self : typeof window < "u" ? window : {});
    }, {}], 37: [function(t, n, s) {
      var o = t("immediate");
      function h() {
      }
      var c = {}, _ = ["REJECTED"], x = ["FULFILLED"], B = ["PENDING"];
      function P(D) {
        if (typeof D != "function")
          throw new TypeError("resolver must be a function");
        this.state = B, this.queue = [], this.outcome = void 0, D !== h && F(this, D);
      }
      function U(D, te, ee) {
        this.promise = D, typeof te == "function" && (this.onFulfilled = te, this.callFulfilled = this.otherCallFulfilled), typeof ee == "function" && (this.onRejected = ee, this.callRejected = this.otherCallRejected);
      }
      function M(D, te, ee) {
        o(function() {
          var le;
          try {
            le = te(ee);
          } catch (fe) {
            return c.reject(D, fe);
          }
          le === D ? c.reject(D, new TypeError("Cannot resolve promise with itself")) : c.resolve(D, le);
        });
      }
      function Z(D) {
        var te = D && D.then;
        if (D && (typeof D == "object" || typeof D == "function") && typeof te == "function")
          return function() {
            te.apply(D, arguments);
          };
      }
      function F(D, te) {
        var ee = !1;
        function le(W) {
          ee || (ee = !0, c.reject(D, W));
        }
        function fe(W) {
          ee || (ee = !0, c.resolve(D, W));
        }
        var X = Q(function() {
          te(fe, le);
        });
        X.status === "error" && le(X.value);
      }
      function Q(D, te) {
        var ee = {};
        try {
          ee.value = D(te), ee.status = "success";
        } catch (le) {
          ee.status = "error", ee.value = le;
        }
        return ee;
      }
      (n.exports = P).prototype.finally = function(D) {
        if (typeof D != "function")
          return this;
        var te = this.constructor;
        return this.then(function(ee) {
          return te.resolve(D()).then(function() {
            return ee;
          });
        }, function(ee) {
          return te.resolve(D()).then(function() {
            throw ee;
          });
        });
      }, P.prototype.catch = function(D) {
        return this.then(null, D);
      }, P.prototype.then = function(D, te) {
        if (typeof D != "function" && this.state === x || typeof te != "function" && this.state === _)
          return this;
        var ee = new this.constructor(h);
        return this.state !== B ? M(ee, this.state === x ? D : te, this.outcome) : this.queue.push(new U(ee, D, te)), ee;
      }, U.prototype.callFulfilled = function(D) {
        c.resolve(this.promise, D);
      }, U.prototype.otherCallFulfilled = function(D) {
        M(this.promise, this.onFulfilled, D);
      }, U.prototype.callRejected = function(D) {
        c.reject(this.promise, D);
      }, U.prototype.otherCallRejected = function(D) {
        M(this.promise, this.onRejected, D);
      }, c.resolve = function(D, te) {
        var ee = Q(Z, te);
        if (ee.status === "error")
          return c.reject(D, ee.value);
        var le = ee.value;
        if (le)
          F(D, le);
        else {
          D.state = x, D.outcome = te;
          for (var fe = -1, X = D.queue.length; ++fe < X; )
            D.queue[fe].callFulfilled(te);
        }
        return D;
      }, c.reject = function(D, te) {
        D.state = _, D.outcome = te;
        for (var ee = -1, le = D.queue.length; ++ee < le; )
          D.queue[ee].callRejected(te);
        return D;
      }, P.resolve = function(D) {
        return D instanceof this ? D : c.resolve(new this(h), D);
      }, P.reject = function(D) {
        var te = new this(h);
        return c.reject(te, D);
      }, P.all = function(D) {
        var te = this;
        if (Object.prototype.toString.call(D) !== "[object Array]")
          return this.reject(new TypeError("must be an array"));
        var ee = D.length, le = !1;
        if (!ee)
          return this.resolve([]);
        for (var fe = new Array(ee), X = 0, W = -1, je = new this(h); ++W < ee; )
          ke(D[W], W);
        return je;
        function ke(Ye, pt) {
          te.resolve(Ye).then(function(Le) {
            fe[pt] = Le, ++X !== ee || le || (le = !0, c.resolve(je, fe));
          }, function(Le) {
            le || (le = !0, c.reject(je, Le));
          });
        }
      }, P.race = function(D) {
        var te = this;
        if (Object.prototype.toString.call(D) !== "[object Array]")
          return this.reject(new TypeError("must be an array"));
        var ee = D.length, le = !1;
        if (!ee)
          return this.resolve([]);
        for (var fe = -1, X = new this(h); ++fe < ee; )
          W = D[fe], te.resolve(W).then(function(je) {
            le || (le = !0, c.resolve(X, je));
          }, function(je) {
            le || (le = !0, c.reject(X, je));
          });
        var W;
        return X;
      };
    }, { immediate: 36 }], 38: [function(t, n, s) {
      var o = {};
      (0, t("./lib/utils/common").assign)(o, t("./lib/deflate"), t("./lib/inflate"), t("./lib/zlib/constants")), n.exports = o;
    }, { "./lib/deflate": 39, "./lib/inflate": 40, "./lib/utils/common": 41, "./lib/zlib/constants": 44 }], 39: [function(t, n, s) {
      var o = t("./zlib/deflate"), h = t("./utils/common"), c = t("./utils/strings"), _ = t("./zlib/messages"), x = t("./zlib/zstream"), B = Object.prototype.toString, P = 0, U = -1, M = 0, Z = 8;
      function F(D) {
        if (!(this instanceof F))
          return new F(D);
        this.options = h.assign({ level: U, method: Z, chunkSize: 16384, windowBits: 15, memLevel: 8, strategy: M, to: "" }, D || {});
        var te = this.options;
        te.raw && 0 < te.windowBits ? te.windowBits = -te.windowBits : te.gzip && 0 < te.windowBits && te.windowBits < 16 && (te.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new x(), this.strm.avail_out = 0;
        var ee = o.deflateInit2(this.strm, te.level, te.method, te.windowBits, te.memLevel, te.strategy);
        if (ee !== P)
          throw new Error(_[ee]);
        if (te.header && o.deflateSetHeader(this.strm, te.header), te.dictionary) {
          var le;
          if (le = typeof te.dictionary == "string" ? c.string2buf(te.dictionary) : B.call(te.dictionary) === "[object ArrayBuffer]" ? new Uint8Array(te.dictionary) : te.dictionary, (ee = o.deflateSetDictionary(this.strm, le)) !== P)
            throw new Error(_[ee]);
          this._dict_set = !0;
        }
      }
      function Q(D, te) {
        var ee = new F(te);
        if (ee.push(D, !0), ee.err)
          throw ee.msg || _[ee.err];
        return ee.result;
      }
      F.prototype.push = function(D, te) {
        var ee, le, fe = this.strm, X = this.options.chunkSize;
        if (this.ended)
          return !1;
        le = te === ~~te ? te : te === !0 ? 4 : 0, typeof D == "string" ? fe.input = c.string2buf(D) : B.call(D) === "[object ArrayBuffer]" ? fe.input = new Uint8Array(D) : fe.input = D, fe.next_in = 0, fe.avail_in = fe.input.length;
        do {
          if (fe.avail_out === 0 && (fe.output = new h.Buf8(X), fe.next_out = 0, fe.avail_out = X), (ee = o.deflate(fe, le)) !== 1 && ee !== P)
            return this.onEnd(ee), !(this.ended = !0);
          fe.avail_out !== 0 && (fe.avail_in !== 0 || le !== 4 && le !== 2) || (this.options.to === "string" ? this.onData(c.buf2binstring(h.shrinkBuf(fe.output, fe.next_out))) : this.onData(h.shrinkBuf(fe.output, fe.next_out)));
        } while ((0 < fe.avail_in || fe.avail_out === 0) && ee !== 1);
        return le === 4 ? (ee = o.deflateEnd(this.strm), this.onEnd(ee), this.ended = !0, ee === P) : le !== 2 || (this.onEnd(P), !(fe.avail_out = 0));
      }, F.prototype.onData = function(D) {
        this.chunks.push(D);
      }, F.prototype.onEnd = function(D) {
        D === P && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = h.flattenChunks(this.chunks)), this.chunks = [], this.err = D, this.msg = this.strm.msg;
      }, s.Deflate = F, s.deflate = Q, s.deflateRaw = function(D, te) {
        return (te = te || {}).raw = !0, Q(D, te);
      }, s.gzip = function(D, te) {
        return (te = te || {}).gzip = !0, Q(D, te);
      };
    }, { "./utils/common": 41, "./utils/strings": 42, "./zlib/deflate": 46, "./zlib/messages": 51, "./zlib/zstream": 53 }], 40: [function(t, n, s) {
      var o = t("./zlib/inflate"), h = t("./utils/common"), c = t("./utils/strings"), _ = t("./zlib/constants"), x = t("./zlib/messages"), B = t("./zlib/zstream"), P = t("./zlib/gzheader"), U = Object.prototype.toString;
      function M(F) {
        if (!(this instanceof M))
          return new M(F);
        this.options = h.assign({ chunkSize: 16384, windowBits: 0, to: "" }, F || {});
        var Q = this.options;
        Q.raw && 0 <= Q.windowBits && Q.windowBits < 16 && (Q.windowBits = -Q.windowBits, Q.windowBits === 0 && (Q.windowBits = -15)), !(0 <= Q.windowBits && Q.windowBits < 16) || F && F.windowBits || (Q.windowBits += 32), 15 < Q.windowBits && Q.windowBits < 48 && !(15 & Q.windowBits) && (Q.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new B(), this.strm.avail_out = 0;
        var D = o.inflateInit2(this.strm, Q.windowBits);
        if (D !== _.Z_OK)
          throw new Error(x[D]);
        this.header = new P(), o.inflateGetHeader(this.strm, this.header);
      }
      function Z(F, Q) {
        var D = new M(Q);
        if (D.push(F, !0), D.err)
          throw D.msg || x[D.err];
        return D.result;
      }
      M.prototype.push = function(F, Q) {
        var D, te, ee, le, fe, X, W = this.strm, je = this.options.chunkSize, ke = this.options.dictionary, Ye = !1;
        if (this.ended)
          return !1;
        te = Q === ~~Q ? Q : Q === !0 ? _.Z_FINISH : _.Z_NO_FLUSH, typeof F == "string" ? W.input = c.binstring2buf(F) : U.call(F) === "[object ArrayBuffer]" ? W.input = new Uint8Array(F) : W.input = F, W.next_in = 0, W.avail_in = W.input.length;
        do {
          if (W.avail_out === 0 && (W.output = new h.Buf8(je), W.next_out = 0, W.avail_out = je), (D = o.inflate(W, _.Z_NO_FLUSH)) === _.Z_NEED_DICT && ke && (X = typeof ke == "string" ? c.string2buf(ke) : U.call(ke) === "[object ArrayBuffer]" ? new Uint8Array(ke) : ke, D = o.inflateSetDictionary(this.strm, X)), D === _.Z_BUF_ERROR && Ye === !0 && (D = _.Z_OK, Ye = !1), D !== _.Z_STREAM_END && D !== _.Z_OK)
            return this.onEnd(D), !(this.ended = !0);
          W.next_out && (W.avail_out !== 0 && D !== _.Z_STREAM_END && (W.avail_in !== 0 || te !== _.Z_FINISH && te !== _.Z_SYNC_FLUSH) || (this.options.to === "string" ? (ee = c.utf8border(W.output, W.next_out), le = W.next_out - ee, fe = c.buf2string(W.output, ee), W.next_out = le, W.avail_out = je - le, le && h.arraySet(W.output, W.output, ee, le, 0), this.onData(fe)) : this.onData(h.shrinkBuf(W.output, W.next_out)))), W.avail_in === 0 && W.avail_out === 0 && (Ye = !0);
        } while ((0 < W.avail_in || W.avail_out === 0) && D !== _.Z_STREAM_END);
        return D === _.Z_STREAM_END && (te = _.Z_FINISH), te === _.Z_FINISH ? (D = o.inflateEnd(this.strm), this.onEnd(D), this.ended = !0, D === _.Z_OK) : te !== _.Z_SYNC_FLUSH || (this.onEnd(_.Z_OK), !(W.avail_out = 0));
      }, M.prototype.onData = function(F) {
        this.chunks.push(F);
      }, M.prototype.onEnd = function(F) {
        F === _.Z_OK && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = h.flattenChunks(this.chunks)), this.chunks = [], this.err = F, this.msg = this.strm.msg;
      }, s.Inflate = M, s.inflate = Z, s.inflateRaw = function(F, Q) {
        return (Q = Q || {}).raw = !0, Z(F, Q);
      }, s.ungzip = Z;
    }, { "./utils/common": 41, "./utils/strings": 42, "./zlib/constants": 44, "./zlib/gzheader": 47, "./zlib/inflate": 49, "./zlib/messages": 51, "./zlib/zstream": 53 }], 41: [function(t, n, s) {
      var o = typeof Uint8Array < "u" && typeof Uint16Array < "u" && typeof Int32Array < "u";
      s.assign = function(_) {
        for (var x = Array.prototype.slice.call(arguments, 1); x.length; ) {
          var B = x.shift();
          if (B) {
            if (typeof B != "object")
              throw new TypeError(B + "must be non-object");
            for (var P in B)
              B.hasOwnProperty(P) && (_[P] = B[P]);
          }
        }
        return _;
      }, s.shrinkBuf = function(_, x) {
        return _.length === x ? _ : _.subarray ? _.subarray(0, x) : (_.length = x, _);
      };
      var h = { arraySet: function(_, x, B, P, U) {
        if (x.subarray && _.subarray)
          _.set(x.subarray(B, B + P), U);
        else
          for (var M = 0; M < P; M++)
            _[U + M] = x[B + M];
      }, flattenChunks: function(_) {
        var x, B, P, U, M, Z;
        for (x = P = 0, B = _.length; x < B; x++)
          P += _[x].length;
        for (Z = new Uint8Array(P), x = U = 0, B = _.length; x < B; x++)
          M = _[x], Z.set(M, U), U += M.length;
        return Z;
      } }, c = { arraySet: function(_, x, B, P, U) {
        for (var M = 0; M < P; M++)
          _[U + M] = x[B + M];
      }, flattenChunks: function(_) {
        return [].concat.apply([], _);
      } };
      s.setTyped = function(_) {
        _ ? (s.Buf8 = Uint8Array, s.Buf16 = Uint16Array, s.Buf32 = Int32Array, s.assign(s, h)) : (s.Buf8 = Array, s.Buf16 = Array, s.Buf32 = Array, s.assign(s, c));
      }, s.setTyped(o);
    }, {}], 42: [function(t, n, s) {
      var o = t("./common"), h = !0, c = !0;
      try {
        String.fromCharCode.apply(null, [0]);
      } catch {
        h = !1;
      }
      try {
        String.fromCharCode.apply(null, new Uint8Array(1));
      } catch {
        c = !1;
      }
      for (var _ = new o.Buf8(256), x = 0; x < 256; x++)
        _[x] = 252 <= x ? 6 : 248 <= x ? 5 : 240 <= x ? 4 : 224 <= x ? 3 : 192 <= x ? 2 : 1;
      function B(P, U) {
        if (U < 65537 && (P.subarray && c || !P.subarray && h))
          return String.fromCharCode.apply(null, o.shrinkBuf(P, U));
        for (var M = "", Z = 0; Z < U; Z++)
          M += String.fromCharCode(P[Z]);
        return M;
      }
      _[254] = _[254] = 1, s.string2buf = function(P) {
        var U, M, Z, F, Q, D = P.length, te = 0;
        for (F = 0; F < D; F++)
          (64512 & (M = P.charCodeAt(F))) == 55296 && F + 1 < D && (64512 & (Z = P.charCodeAt(F + 1))) == 56320 && (M = 65536 + (M - 55296 << 10) + (Z - 56320), F++), te += M < 128 ? 1 : M < 2048 ? 2 : M < 65536 ? 3 : 4;
        for (U = new o.Buf8(te), F = Q = 0; Q < te; F++)
          (64512 & (M = P.charCodeAt(F))) == 55296 && F + 1 < D && (64512 & (Z = P.charCodeAt(F + 1))) == 56320 && (M = 65536 + (M - 55296 << 10) + (Z - 56320), F++), M < 128 ? U[Q++] = M : (M < 2048 ? U[Q++] = 192 | M >>> 6 : (M < 65536 ? U[Q++] = 224 | M >>> 12 : (U[Q++] = 240 | M >>> 18, U[Q++] = 128 | M >>> 12 & 63), U[Q++] = 128 | M >>> 6 & 63), U[Q++] = 128 | 63 & M);
        return U;
      }, s.buf2binstring = function(P) {
        return B(P, P.length);
      }, s.binstring2buf = function(P) {
        for (var U = new o.Buf8(P.length), M = 0, Z = U.length; M < Z; M++)
          U[M] = P.charCodeAt(M);
        return U;
      }, s.buf2string = function(P, U) {
        var M, Z, F, Q, D = U || P.length, te = new Array(2 * D);
        for (M = Z = 0; M < D; )
          if ((F = P[M++]) < 128)
            te[Z++] = F;
          else if (4 < (Q = _[F]))
            te[Z++] = 65533, M += Q - 1;
          else {
            for (F &= Q === 2 ? 31 : Q === 3 ? 15 : 7; 1 < Q && M < D; )
              F = F << 6 | 63 & P[M++], Q--;
            1 < Q ? te[Z++] = 65533 : F < 65536 ? te[Z++] = F : (F -= 65536, te[Z++] = 55296 | F >> 10 & 1023, te[Z++] = 56320 | 1023 & F);
          }
        return B(te, Z);
      }, s.utf8border = function(P, U) {
        var M;
        for ((U = U || P.length) > P.length && (U = P.length), M = U - 1; 0 <= M && (192 & P[M]) == 128; )
          M--;
        return M < 0 || M === 0 ? U : M + _[P[M]] > U ? M : U;
      };
    }, { "./common": 41 }], 43: [function(t, n, s) {
      n.exports = function(o, h, c, _) {
        for (var x = 65535 & o | 0, B = o >>> 16 & 65535 | 0, P = 0; c !== 0; ) {
          for (c -= P = 2e3 < c ? 2e3 : c; B = B + (x = x + h[_++] | 0) | 0, --P; )
            ;
          x %= 65521, B %= 65521;
        }
        return x | B << 16 | 0;
      };
    }, {}], 44: [function(t, n, s) {
      n.exports = { Z_NO_FLUSH: 0, Z_PARTIAL_FLUSH: 1, Z_SYNC_FLUSH: 2, Z_FULL_FLUSH: 3, Z_FINISH: 4, Z_BLOCK: 5, Z_TREES: 6, Z_OK: 0, Z_STREAM_END: 1, Z_NEED_DICT: 2, Z_ERRNO: -1, Z_STREAM_ERROR: -2, Z_DATA_ERROR: -3, Z_BUF_ERROR: -5, Z_NO_COMPRESSION: 0, Z_BEST_SPEED: 1, Z_BEST_COMPRESSION: 9, Z_DEFAULT_COMPRESSION: -1, Z_FILTERED: 1, Z_HUFFMAN_ONLY: 2, Z_RLE: 3, Z_FIXED: 4, Z_DEFAULT_STRATEGY: 0, Z_BINARY: 0, Z_TEXT: 1, Z_UNKNOWN: 2, Z_DEFLATED: 8 };
    }, {}], 45: [function(t, n, s) {
      var o = function() {
        for (var h, c = [], _ = 0; _ < 256; _++) {
          h = _;
          for (var x = 0; x < 8; x++)
            h = 1 & h ? 3988292384 ^ h >>> 1 : h >>> 1;
          c[_] = h;
        }
        return c;
      }();
      n.exports = function(h, c, _, x) {
        var B = o, P = x + _;
        h ^= -1;
        for (var U = x; U < P; U++)
          h = h >>> 8 ^ B[255 & (h ^ c[U])];
        return -1 ^ h;
      };
    }, {}], 46: [function(t, n, s) {
      var o, h = t("../utils/common"), c = t("./trees"), _ = t("./adler32"), x = t("./crc32"), B = t("./messages"), P = 0, U = 4, M = 0, Z = -2, F = -1, Q = 4, D = 2, te = 8, ee = 9, le = 286, fe = 30, X = 19, W = 2 * le + 1, je = 15, ke = 3, Ye = 258, pt = Ye + ke + 1, Le = 42, $e = 113, ce = 1, ht = 2, De = 3, ft = 4;
      function Yt(_e, Ct) {
        return _e.msg = B[Ct], Ct;
      }
      function We(_e) {
        return (_e << 1) - (4 < _e ? 9 : 0);
      }
      function It(_e) {
        for (var Ct = _e.length; 0 <= --Ct; )
          _e[Ct] = 0;
      }
      function rt(_e) {
        var Ct = _e.state, yt = Ct.pending;
        yt > _e.avail_out && (yt = _e.avail_out), yt !== 0 && (h.arraySet(_e.output, Ct.pending_buf, Ct.pending_out, yt, _e.next_out), _e.next_out += yt, Ct.pending_out += yt, _e.total_out += yt, _e.avail_out -= yt, Ct.pending -= yt, Ct.pending === 0 && (Ct.pending_out = 0));
      }
      function tt(_e, Ct) {
        c._tr_flush_block(_e, 0 <= _e.block_start ? _e.block_start : -1, _e.strstart - _e.block_start, Ct), _e.block_start = _e.strstart, rt(_e.strm);
      }
      function Kt(_e, Ct) {
        _e.pending_buf[_e.pending++] = Ct;
      }
      function qt(_e, Ct) {
        _e.pending_buf[_e.pending++] = Ct >>> 8 & 255, _e.pending_buf[_e.pending++] = 255 & Ct;
      }
      function Lt(_e, Ct) {
        var yt, Re, Ee = _e.max_chain_length, et = _e.strstart, kt = _e.prev_length, mt = _e.nice_match, Qe = _e.strstart > _e.w_size - pt ? _e.strstart - (_e.w_size - pt) : 0, bt = _e.window, Gt = _e.w_mask, He = _e.prev, i = _e.strstart + Ye, r = bt[et + kt - 1], a = bt[et + kt];
        _e.prev_length >= _e.good_match && (Ee >>= 2), mt > _e.lookahead && (mt = _e.lookahead);
        do
          if (bt[(yt = Ct) + kt] === a && bt[yt + kt - 1] === r && bt[yt] === bt[et] && bt[++yt] === bt[et + 1]) {
            et += 2, yt++;
            do
              ;
            while (bt[++et] === bt[++yt] && bt[++et] === bt[++yt] && bt[++et] === bt[++yt] && bt[++et] === bt[++yt] && bt[++et] === bt[++yt] && bt[++et] === bt[++yt] && bt[++et] === bt[++yt] && bt[++et] === bt[++yt] && et < i);
            if (Re = Ye - (i - et), et = i - Ye, kt < Re) {
              if (_e.match_start = Ct, mt <= (kt = Re))
                break;
              r = bt[et + kt - 1], a = bt[et + kt];
            }
          }
        while ((Ct = He[Ct & Gt]) > Qe && --Ee != 0);
        return kt <= _e.lookahead ? kt : _e.lookahead;
      }
      function Ci(_e) {
        var Ct, yt, Re, Ee, et, kt, mt, Qe, bt, Gt, He = _e.w_size;
        do {
          if (Ee = _e.window_size - _e.lookahead - _e.strstart, _e.strstart >= He + (He - pt)) {
            for (h.arraySet(_e.window, _e.window, He, He, 0), _e.match_start -= He, _e.strstart -= He, _e.block_start -= He, Ct = yt = _e.hash_size; Re = _e.head[--Ct], _e.head[Ct] = He <= Re ? Re - He : 0, --yt; )
              ;
            for (Ct = yt = He; Re = _e.prev[--Ct], _e.prev[Ct] = He <= Re ? Re - He : 0, --yt; )
              ;
            Ee += He;
          }
          if (_e.strm.avail_in === 0)
            break;
          if (kt = _e.strm, mt = _e.window, Qe = _e.strstart + _e.lookahead, bt = Ee, Gt = void 0, Gt = kt.avail_in, bt < Gt && (Gt = bt), yt = Gt === 0 ? 0 : (kt.avail_in -= Gt, h.arraySet(mt, kt.input, kt.next_in, Gt, Qe), kt.state.wrap === 1 ? kt.adler = _(kt.adler, mt, Gt, Qe) : kt.state.wrap === 2 && (kt.adler = x(kt.adler, mt, Gt, Qe)), kt.next_in += Gt, kt.total_in += Gt, Gt), _e.lookahead += yt, _e.lookahead + _e.insert >= ke)
            for (et = _e.strstart - _e.insert, _e.ins_h = _e.window[et], _e.ins_h = (_e.ins_h << _e.hash_shift ^ _e.window[et + 1]) & _e.hash_mask; _e.insert && (_e.ins_h = (_e.ins_h << _e.hash_shift ^ _e.window[et + ke - 1]) & _e.hash_mask, _e.prev[et & _e.w_mask] = _e.head[_e.ins_h], _e.head[_e.ins_h] = et, et++, _e.insert--, !(_e.lookahead + _e.insert < ke)); )
              ;
        } while (_e.lookahead < pt && _e.strm.avail_in !== 0);
      }
      function ji(_e, Ct) {
        for (var yt, Re; ; ) {
          if (_e.lookahead < pt) {
            if (Ci(_e), _e.lookahead < pt && Ct === P)
              return ce;
            if (_e.lookahead === 0)
              break;
          }
          if (yt = 0, _e.lookahead >= ke && (_e.ins_h = (_e.ins_h << _e.hash_shift ^ _e.window[_e.strstart + ke - 1]) & _e.hash_mask, yt = _e.prev[_e.strstart & _e.w_mask] = _e.head[_e.ins_h], _e.head[_e.ins_h] = _e.strstart), yt !== 0 && _e.strstart - yt <= _e.w_size - pt && (_e.match_length = Lt(_e, yt)), _e.match_length >= ke)
            if (Re = c._tr_tally(_e, _e.strstart - _e.match_start, _e.match_length - ke), _e.lookahead -= _e.match_length, _e.match_length <= _e.max_lazy_match && _e.lookahead >= ke) {
              for (_e.match_length--; _e.strstart++, _e.ins_h = (_e.ins_h << _e.hash_shift ^ _e.window[_e.strstart + ke - 1]) & _e.hash_mask, yt = _e.prev[_e.strstart & _e.w_mask] = _e.head[_e.ins_h], _e.head[_e.ins_h] = _e.strstart, --_e.match_length != 0; )
                ;
              _e.strstart++;
            } else
              _e.strstart += _e.match_length, _e.match_length = 0, _e.ins_h = _e.window[_e.strstart], _e.ins_h = (_e.ins_h << _e.hash_shift ^ _e.window[_e.strstart + 1]) & _e.hash_mask;
          else
            Re = c._tr_tally(_e, 0, _e.window[_e.strstart]), _e.lookahead--, _e.strstart++;
          if (Re && (tt(_e, !1), _e.strm.avail_out === 0))
            return ce;
        }
        return _e.insert = _e.strstart < ke - 1 ? _e.strstart : ke - 1, Ct === U ? (tt(_e, !0), _e.strm.avail_out === 0 ? De : ft) : _e.last_lit && (tt(_e, !1), _e.strm.avail_out === 0) ? ce : ht;
      }
      function _i(_e, Ct) {
        for (var yt, Re, Ee; ; ) {
          if (_e.lookahead < pt) {
            if (Ci(_e), _e.lookahead < pt && Ct === P)
              return ce;
            if (_e.lookahead === 0)
              break;
          }
          if (yt = 0, _e.lookahead >= ke && (_e.ins_h = (_e.ins_h << _e.hash_shift ^ _e.window[_e.strstart + ke - 1]) & _e.hash_mask, yt = _e.prev[_e.strstart & _e.w_mask] = _e.head[_e.ins_h], _e.head[_e.ins_h] = _e.strstart), _e.prev_length = _e.match_length, _e.prev_match = _e.match_start, _e.match_length = ke - 1, yt !== 0 && _e.prev_length < _e.max_lazy_match && _e.strstart - yt <= _e.w_size - pt && (_e.match_length = Lt(_e, yt), _e.match_length <= 5 && (_e.strategy === 1 || _e.match_length === ke && 4096 < _e.strstart - _e.match_start) && (_e.match_length = ke - 1)), _e.prev_length >= ke && _e.match_length <= _e.prev_length) {
            for (Ee = _e.strstart + _e.lookahead - ke, Re = c._tr_tally(_e, _e.strstart - 1 - _e.prev_match, _e.prev_length - ke), _e.lookahead -= _e.prev_length - 1, _e.prev_length -= 2; ++_e.strstart <= Ee && (_e.ins_h = (_e.ins_h << _e.hash_shift ^ _e.window[_e.strstart + ke - 1]) & _e.hash_mask, yt = _e.prev[_e.strstart & _e.w_mask] = _e.head[_e.ins_h], _e.head[_e.ins_h] = _e.strstart), --_e.prev_length != 0; )
              ;
            if (_e.match_available = 0, _e.match_length = ke - 1, _e.strstart++, Re && (tt(_e, !1), _e.strm.avail_out === 0))
              return ce;
          } else if (_e.match_available) {
            if ((Re = c._tr_tally(_e, 0, _e.window[_e.strstart - 1])) && tt(_e, !1), _e.strstart++, _e.lookahead--, _e.strm.avail_out === 0)
              return ce;
          } else
            _e.match_available = 1, _e.strstart++, _e.lookahead--;
        }
        return _e.match_available && (Re = c._tr_tally(_e, 0, _e.window[_e.strstart - 1]), _e.match_available = 0), _e.insert = _e.strstart < ke - 1 ? _e.strstart : ke - 1, Ct === U ? (tt(_e, !0), _e.strm.avail_out === 0 ? De : ft) : _e.last_lit && (tt(_e, !1), _e.strm.avail_out === 0) ? ce : ht;
      }
      function Wt(_e, Ct, yt, Re, Ee) {
        this.good_length = _e, this.max_lazy = Ct, this.nice_length = yt, this.max_chain = Re, this.func = Ee;
      }
      function $t() {
        this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = te, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new h.Buf16(2 * W), this.dyn_dtree = new h.Buf16(2 * (2 * fe + 1)), this.bl_tree = new h.Buf16(2 * (2 * X + 1)), It(this.dyn_ltree), It(this.dyn_dtree), It(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new h.Buf16(je + 1), this.heap = new h.Buf16(2 * le + 1), It(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new h.Buf16(2 * le + 1), It(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
      }
      function ei(_e) {
        var Ct;
        return _e && _e.state ? (_e.total_in = _e.total_out = 0, _e.data_type = D, (Ct = _e.state).pending = 0, Ct.pending_out = 0, Ct.wrap < 0 && (Ct.wrap = -Ct.wrap), Ct.status = Ct.wrap ? Le : $e, _e.adler = Ct.wrap === 2 ? 0 : 1, Ct.last_flush = P, c._tr_init(Ct), M) : Yt(_e, Z);
      }
      function tn(_e) {
        var Ct = ei(_e);
        return Ct === M && function(yt) {
          yt.window_size = 2 * yt.w_size, It(yt.head), yt.max_lazy_match = o[yt.level].max_lazy, yt.good_match = o[yt.level].good_length, yt.nice_match = o[yt.level].nice_length, yt.max_chain_length = o[yt.level].max_chain, yt.strstart = 0, yt.block_start = 0, yt.lookahead = 0, yt.insert = 0, yt.match_length = yt.prev_length = ke - 1, yt.match_available = 0, yt.ins_h = 0;
        }(_e.state), Ct;
      }
      function Fi(_e, Ct, yt, Re, Ee, et) {
        if (!_e)
          return Z;
        var kt = 1;
        if (Ct === F && (Ct = 6), Re < 0 ? (kt = 0, Re = -Re) : 15 < Re && (kt = 2, Re -= 16), Ee < 1 || ee < Ee || yt !== te || Re < 8 || 15 < Re || Ct < 0 || 9 < Ct || et < 0 || Q < et)
          return Yt(_e, Z);
        Re === 8 && (Re = 9);
        var mt = new $t();
        return (_e.state = mt).strm = _e, mt.wrap = kt, mt.gzhead = null, mt.w_bits = Re, mt.w_size = 1 << mt.w_bits, mt.w_mask = mt.w_size - 1, mt.hash_bits = Ee + 7, mt.hash_size = 1 << mt.hash_bits, mt.hash_mask = mt.hash_size - 1, mt.hash_shift = ~~((mt.hash_bits + ke - 1) / ke), mt.window = new h.Buf8(2 * mt.w_size), mt.head = new h.Buf16(mt.hash_size), mt.prev = new h.Buf16(mt.w_size), mt.lit_bufsize = 1 << Ee + 6, mt.pending_buf_size = 4 * mt.lit_bufsize, mt.pending_buf = new h.Buf8(mt.pending_buf_size), mt.d_buf = 1 * mt.lit_bufsize, mt.l_buf = 3 * mt.lit_bufsize, mt.level = Ct, mt.strategy = et, mt.method = yt, tn(_e);
      }
      o = [new Wt(0, 0, 0, 0, function(_e, Ct) {
        var yt = 65535;
        for (yt > _e.pending_buf_size - 5 && (yt = _e.pending_buf_size - 5); ; ) {
          if (_e.lookahead <= 1) {
            if (Ci(_e), _e.lookahead === 0 && Ct === P)
              return ce;
            if (_e.lookahead === 0)
              break;
          }
          _e.strstart += _e.lookahead, _e.lookahead = 0;
          var Re = _e.block_start + yt;
          if ((_e.strstart === 0 || _e.strstart >= Re) && (_e.lookahead = _e.strstart - Re, _e.strstart = Re, tt(_e, !1), _e.strm.avail_out === 0) || _e.strstart - _e.block_start >= _e.w_size - pt && (tt(_e, !1), _e.strm.avail_out === 0))
            return ce;
        }
        return _e.insert = 0, Ct === U ? (tt(_e, !0), _e.strm.avail_out === 0 ? De : ft) : (_e.strstart > _e.block_start && (tt(_e, !1), _e.strm.avail_out), ce);
      }), new Wt(4, 4, 8, 4, ji), new Wt(4, 5, 16, 8, ji), new Wt(4, 6, 32, 32, ji), new Wt(4, 4, 16, 16, _i), new Wt(8, 16, 32, 32, _i), new Wt(8, 16, 128, 128, _i), new Wt(8, 32, 128, 256, _i), new Wt(32, 128, 258, 1024, _i), new Wt(32, 258, 258, 4096, _i)], s.deflateInit = function(_e, Ct) {
        return Fi(_e, Ct, te, 15, 8, 0);
      }, s.deflateInit2 = Fi, s.deflateReset = tn, s.deflateResetKeep = ei, s.deflateSetHeader = function(_e, Ct) {
        return _e && _e.state ? _e.state.wrap !== 2 ? Z : (_e.state.gzhead = Ct, M) : Z;
      }, s.deflate = function(_e, Ct) {
        var yt, Re, Ee, et;
        if (!_e || !_e.state || 5 < Ct || Ct < 0)
          return _e ? Yt(_e, Z) : Z;
        if (Re = _e.state, !_e.output || !_e.input && _e.avail_in !== 0 || Re.status === 666 && Ct !== U)
          return Yt(_e, _e.avail_out === 0 ? -5 : Z);
        if (Re.strm = _e, yt = Re.last_flush, Re.last_flush = Ct, Re.status === Le)
          if (Re.wrap === 2)
            _e.adler = 0, Kt(Re, 31), Kt(Re, 139), Kt(Re, 8), Re.gzhead ? (Kt(Re, (Re.gzhead.text ? 1 : 0) + (Re.gzhead.hcrc ? 2 : 0) + (Re.gzhead.extra ? 4 : 0) + (Re.gzhead.name ? 8 : 0) + (Re.gzhead.comment ? 16 : 0)), Kt(Re, 255 & Re.gzhead.time), Kt(Re, Re.gzhead.time >> 8 & 255), Kt(Re, Re.gzhead.time >> 16 & 255), Kt(Re, Re.gzhead.time >> 24 & 255), Kt(Re, Re.level === 9 ? 2 : 2 <= Re.strategy || Re.level < 2 ? 4 : 0), Kt(Re, 255 & Re.gzhead.os), Re.gzhead.extra && Re.gzhead.extra.length && (Kt(Re, 255 & Re.gzhead.extra.length), Kt(Re, Re.gzhead.extra.length >> 8 & 255)), Re.gzhead.hcrc && (_e.adler = x(_e.adler, Re.pending_buf, Re.pending, 0)), Re.gzindex = 0, Re.status = 69) : (Kt(Re, 0), Kt(Re, 0), Kt(Re, 0), Kt(Re, 0), Kt(Re, 0), Kt(Re, Re.level === 9 ? 2 : 2 <= Re.strategy || Re.level < 2 ? 4 : 0), Kt(Re, 3), Re.status = $e);
          else {
            var kt = te + (Re.w_bits - 8 << 4) << 8;
            kt |= (2 <= Re.strategy || Re.level < 2 ? 0 : Re.level < 6 ? 1 : Re.level === 6 ? 2 : 3) << 6, Re.strstart !== 0 && (kt |= 32), kt += 31 - kt % 31, Re.status = $e, qt(Re, kt), Re.strstart !== 0 && (qt(Re, _e.adler >>> 16), qt(Re, 65535 & _e.adler)), _e.adler = 1;
          }
        if (Re.status === 69)
          if (Re.gzhead.extra) {
            for (Ee = Re.pending; Re.gzindex < (65535 & Re.gzhead.extra.length) && (Re.pending !== Re.pending_buf_size || (Re.gzhead.hcrc && Re.pending > Ee && (_e.adler = x(_e.adler, Re.pending_buf, Re.pending - Ee, Ee)), rt(_e), Ee = Re.pending, Re.pending !== Re.pending_buf_size)); )
              Kt(Re, 255 & Re.gzhead.extra[Re.gzindex]), Re.gzindex++;
            Re.gzhead.hcrc && Re.pending > Ee && (_e.adler = x(_e.adler, Re.pending_buf, Re.pending - Ee, Ee)), Re.gzindex === Re.gzhead.extra.length && (Re.gzindex = 0, Re.status = 73);
          } else
            Re.status = 73;
        if (Re.status === 73)
          if (Re.gzhead.name) {
            Ee = Re.pending;
            do {
              if (Re.pending === Re.pending_buf_size && (Re.gzhead.hcrc && Re.pending > Ee && (_e.adler = x(_e.adler, Re.pending_buf, Re.pending - Ee, Ee)), rt(_e), Ee = Re.pending, Re.pending === Re.pending_buf_size)) {
                et = 1;
                break;
              }
              et = Re.gzindex < Re.gzhead.name.length ? 255 & Re.gzhead.name.charCodeAt(Re.gzindex++) : 0, Kt(Re, et);
            } while (et !== 0);
            Re.gzhead.hcrc && Re.pending > Ee && (_e.adler = x(_e.adler, Re.pending_buf, Re.pending - Ee, Ee)), et === 0 && (Re.gzindex = 0, Re.status = 91);
          } else
            Re.status = 91;
        if (Re.status === 91)
          if (Re.gzhead.comment) {
            Ee = Re.pending;
            do {
              if (Re.pending === Re.pending_buf_size && (Re.gzhead.hcrc && Re.pending > Ee && (_e.adler = x(_e.adler, Re.pending_buf, Re.pending - Ee, Ee)), rt(_e), Ee = Re.pending, Re.pending === Re.pending_buf_size)) {
                et = 1;
                break;
              }
              et = Re.gzindex < Re.gzhead.comment.length ? 255 & Re.gzhead.comment.charCodeAt(Re.gzindex++) : 0, Kt(Re, et);
            } while (et !== 0);
            Re.gzhead.hcrc && Re.pending > Ee && (_e.adler = x(_e.adler, Re.pending_buf, Re.pending - Ee, Ee)), et === 0 && (Re.status = 103);
          } else
            Re.status = 103;
        if (Re.status === 103 && (Re.gzhead.hcrc ? (Re.pending + 2 > Re.pending_buf_size && rt(_e), Re.pending + 2 <= Re.pending_buf_size && (Kt(Re, 255 & _e.adler), Kt(Re, _e.adler >> 8 & 255), _e.adler = 0, Re.status = $e)) : Re.status = $e), Re.pending !== 0) {
          if (rt(_e), _e.avail_out === 0)
            return Re.last_flush = -1, M;
        } else if (_e.avail_in === 0 && We(Ct) <= We(yt) && Ct !== U)
          return Yt(_e, -5);
        if (Re.status === 666 && _e.avail_in !== 0)
          return Yt(_e, -5);
        if (_e.avail_in !== 0 || Re.lookahead !== 0 || Ct !== P && Re.status !== 666) {
          var mt = Re.strategy === 2 ? function(Qe, bt) {
            for (var Gt; ; ) {
              if (Qe.lookahead === 0 && (Ci(Qe), Qe.lookahead === 0)) {
                if (bt === P)
                  return ce;
                break;
              }
              if (Qe.match_length = 0, Gt = c._tr_tally(Qe, 0, Qe.window[Qe.strstart]), Qe.lookahead--, Qe.strstart++, Gt && (tt(Qe, !1), Qe.strm.avail_out === 0))
                return ce;
            }
            return Qe.insert = 0, bt === U ? (tt(Qe, !0), Qe.strm.avail_out === 0 ? De : ft) : Qe.last_lit && (tt(Qe, !1), Qe.strm.avail_out === 0) ? ce : ht;
          }(Re, Ct) : Re.strategy === 3 ? function(Qe, bt) {
            for (var Gt, He, i, r, a = Qe.window; ; ) {
              if (Qe.lookahead <= Ye) {
                if (Ci(Qe), Qe.lookahead <= Ye && bt === P)
                  return ce;
                if (Qe.lookahead === 0)
                  break;
              }
              if (Qe.match_length = 0, Qe.lookahead >= ke && 0 < Qe.strstart && (He = a[i = Qe.strstart - 1]) === a[++i] && He === a[++i] && He === a[++i]) {
                r = Qe.strstart + Ye;
                do
                  ;
                while (He === a[++i] && He === a[++i] && He === a[++i] && He === a[++i] && He === a[++i] && He === a[++i] && He === a[++i] && He === a[++i] && i < r);
                Qe.match_length = Ye - (r - i), Qe.match_length > Qe.lookahead && (Qe.match_length = Qe.lookahead);
              }
              if (Qe.match_length >= ke ? (Gt = c._tr_tally(Qe, 1, Qe.match_length - ke), Qe.lookahead -= Qe.match_length, Qe.strstart += Qe.match_length, Qe.match_length = 0) : (Gt = c._tr_tally(Qe, 0, Qe.window[Qe.strstart]), Qe.lookahead--, Qe.strstart++), Gt && (tt(Qe, !1), Qe.strm.avail_out === 0))
                return ce;
            }
            return Qe.insert = 0, bt === U ? (tt(Qe, !0), Qe.strm.avail_out === 0 ? De : ft) : Qe.last_lit && (tt(Qe, !1), Qe.strm.avail_out === 0) ? ce : ht;
          }(Re, Ct) : o[Re.level].func(Re, Ct);
          if (mt !== De && mt !== ft || (Re.status = 666), mt === ce || mt === De)
            return _e.avail_out === 0 && (Re.last_flush = -1), M;
          if (mt === ht && (Ct === 1 ? c._tr_align(Re) : Ct !== 5 && (c._tr_stored_block(Re, 0, 0, !1), Ct === 3 && (It(Re.head), Re.lookahead === 0 && (Re.strstart = 0, Re.block_start = 0, Re.insert = 0))), rt(_e), _e.avail_out === 0))
            return Re.last_flush = -1, M;
        }
        return Ct !== U ? M : Re.wrap <= 0 ? 1 : (Re.wrap === 2 ? (Kt(Re, 255 & _e.adler), Kt(Re, _e.adler >> 8 & 255), Kt(Re, _e.adler >> 16 & 255), Kt(Re, _e.adler >> 24 & 255), Kt(Re, 255 & _e.total_in), Kt(Re, _e.total_in >> 8 & 255), Kt(Re, _e.total_in >> 16 & 255), Kt(Re, _e.total_in >> 24 & 255)) : (qt(Re, _e.adler >>> 16), qt(Re, 65535 & _e.adler)), rt(_e), 0 < Re.wrap && (Re.wrap = -Re.wrap), Re.pending !== 0 ? M : 1);
      }, s.deflateEnd = function(_e) {
        var Ct;
        return _e && _e.state ? (Ct = _e.state.status) !== Le && Ct !== 69 && Ct !== 73 && Ct !== 91 && Ct !== 103 && Ct !== $e && Ct !== 666 ? Yt(_e, Z) : (_e.state = null, Ct === $e ? Yt(_e, -3) : M) : Z;
      }, s.deflateSetDictionary = function(_e, Ct) {
        var yt, Re, Ee, et, kt, mt, Qe, bt, Gt = Ct.length;
        if (!_e || !_e.state || (et = (yt = _e.state).wrap) === 2 || et === 1 && yt.status !== Le || yt.lookahead)
          return Z;
        for (et === 1 && (_e.adler = _(_e.adler, Ct, Gt, 0)), yt.wrap = 0, Gt >= yt.w_size && (et === 0 && (It(yt.head), yt.strstart = 0, yt.block_start = 0, yt.insert = 0), bt = new h.Buf8(yt.w_size), h.arraySet(bt, Ct, Gt - yt.w_size, yt.w_size, 0), Ct = bt, Gt = yt.w_size), kt = _e.avail_in, mt = _e.next_in, Qe = _e.input, _e.avail_in = Gt, _e.next_in = 0, _e.input = Ct, Ci(yt); yt.lookahead >= ke; ) {
          for (Re = yt.strstart, Ee = yt.lookahead - (ke - 1); yt.ins_h = (yt.ins_h << yt.hash_shift ^ yt.window[Re + ke - 1]) & yt.hash_mask, yt.prev[Re & yt.w_mask] = yt.head[yt.ins_h], yt.head[yt.ins_h] = Re, Re++, --Ee; )
            ;
          yt.strstart = Re, yt.lookahead = ke - 1, Ci(yt);
        }
        return yt.strstart += yt.lookahead, yt.block_start = yt.strstart, yt.insert = yt.lookahead, yt.lookahead = 0, yt.match_length = yt.prev_length = ke - 1, yt.match_available = 0, _e.next_in = mt, _e.input = Qe, _e.avail_in = kt, yt.wrap = et, M;
      }, s.deflateInfo = "pako deflate (from Nodeca project)";
    }, { "../utils/common": 41, "./adler32": 43, "./crc32": 45, "./messages": 51, "./trees": 52 }], 47: [function(t, n, s) {
      n.exports = function() {
        this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
      };
    }, {}], 48: [function(t, n, s) {
      n.exports = function(o, h) {
        var c, _, x, B, P, U, M, Z, F, Q, D, te, ee, le, fe, X, W, je, ke, Ye, pt, Le, $e, ce, ht;
        c = o.state, _ = o.next_in, ce = o.input, x = _ + (o.avail_in - 5), B = o.next_out, ht = o.output, P = B - (h - o.avail_out), U = B + (o.avail_out - 257), M = c.dmax, Z = c.wsize, F = c.whave, Q = c.wnext, D = c.window, te = c.hold, ee = c.bits, le = c.lencode, fe = c.distcode, X = (1 << c.lenbits) - 1, W = (1 << c.distbits) - 1;
        e:
          do {
            ee < 15 && (te += ce[_++] << ee, ee += 8, te += ce[_++] << ee, ee += 8), je = le[te & X];
            t:
              for (; ; ) {
                if (te >>>= ke = je >>> 24, ee -= ke, (ke = je >>> 16 & 255) === 0)
                  ht[B++] = 65535 & je;
                else {
                  if (!(16 & ke)) {
                    if (!(64 & ke)) {
                      je = le[(65535 & je) + (te & (1 << ke) - 1)];
                      continue t;
                    }
                    if (32 & ke) {
                      c.mode = 12;
                      break e;
                    }
                    o.msg = "invalid literal/length code", c.mode = 30;
                    break e;
                  }
                  Ye = 65535 & je, (ke &= 15) && (ee < ke && (te += ce[_++] << ee, ee += 8), Ye += te & (1 << ke) - 1, te >>>= ke, ee -= ke), ee < 15 && (te += ce[_++] << ee, ee += 8, te += ce[_++] << ee, ee += 8), je = fe[te & W];
                  i:
                    for (; ; ) {
                      if (te >>>= ke = je >>> 24, ee -= ke, !(16 & (ke = je >>> 16 & 255))) {
                        if (!(64 & ke)) {
                          je = fe[(65535 & je) + (te & (1 << ke) - 1)];
                          continue i;
                        }
                        o.msg = "invalid distance code", c.mode = 30;
                        break e;
                      }
                      if (pt = 65535 & je, ee < (ke &= 15) && (te += ce[_++] << ee, (ee += 8) < ke && (te += ce[_++] << ee, ee += 8)), M < (pt += te & (1 << ke) - 1)) {
                        o.msg = "invalid distance too far back", c.mode = 30;
                        break e;
                      }
                      if (te >>>= ke, ee -= ke, (ke = B - P) < pt) {
                        if (F < (ke = pt - ke) && c.sane) {
                          o.msg = "invalid distance too far back", c.mode = 30;
                          break e;
                        }
                        if ($e = D, (Le = 0) === Q) {
                          if (Le += Z - ke, ke < Ye) {
                            for (Ye -= ke; ht[B++] = D[Le++], --ke; )
                              ;
                            Le = B - pt, $e = ht;
                          }
                        } else if (Q < ke) {
                          if (Le += Z + Q - ke, (ke -= Q) < Ye) {
                            for (Ye -= ke; ht[B++] = D[Le++], --ke; )
                              ;
                            if (Le = 0, Q < Ye) {
                              for (Ye -= ke = Q; ht[B++] = D[Le++], --ke; )
                                ;
                              Le = B - pt, $e = ht;
                            }
                          }
                        } else if (Le += Q - ke, ke < Ye) {
                          for (Ye -= ke; ht[B++] = D[Le++], --ke; )
                            ;
                          Le = B - pt, $e = ht;
                        }
                        for (; 2 < Ye; )
                          ht[B++] = $e[Le++], ht[B++] = $e[Le++], ht[B++] = $e[Le++], Ye -= 3;
                        Ye && (ht[B++] = $e[Le++], 1 < Ye && (ht[B++] = $e[Le++]));
                      } else {
                        for (Le = B - pt; ht[B++] = ht[Le++], ht[B++] = ht[Le++], ht[B++] = ht[Le++], 2 < (Ye -= 3); )
                          ;
                        Ye && (ht[B++] = ht[Le++], 1 < Ye && (ht[B++] = ht[Le++]));
                      }
                      break;
                    }
                }
                break;
              }
          } while (_ < x && B < U);
        _ -= Ye = ee >> 3, te &= (1 << (ee -= Ye << 3)) - 1, o.next_in = _, o.next_out = B, o.avail_in = _ < x ? x - _ + 5 : 5 - (_ - x), o.avail_out = B < U ? U - B + 257 : 257 - (B - U), c.hold = te, c.bits = ee;
      };
    }, {}], 49: [function(t, n, s) {
      var o = t("../utils/common"), h = t("./adler32"), c = t("./crc32"), _ = t("./inffast"), x = t("./inftrees"), B = 1, P = 2, U = 0, M = -2, Z = 1, F = 852, Q = 592;
      function D(Le) {
        return (Le >>> 24 & 255) + (Le >>> 8 & 65280) + ((65280 & Le) << 8) + ((255 & Le) << 24);
      }
      function te() {
        this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new o.Buf16(320), this.work = new o.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
      }
      function ee(Le) {
        var $e;
        return Le && Le.state ? ($e = Le.state, Le.total_in = Le.total_out = $e.total = 0, Le.msg = "", $e.wrap && (Le.adler = 1 & $e.wrap), $e.mode = Z, $e.last = 0, $e.havedict = 0, $e.dmax = 32768, $e.head = null, $e.hold = 0, $e.bits = 0, $e.lencode = $e.lendyn = new o.Buf32(F), $e.distcode = $e.distdyn = new o.Buf32(Q), $e.sane = 1, $e.back = -1, U) : M;
      }
      function le(Le) {
        var $e;
        return Le && Le.state ? (($e = Le.state).wsize = 0, $e.whave = 0, $e.wnext = 0, ee(Le)) : M;
      }
      function fe(Le, $e) {
        var ce, ht;
        return Le && Le.state ? (ht = Le.state, $e < 0 ? (ce = 0, $e = -$e) : (ce = 1 + ($e >> 4), $e < 48 && ($e &= 15)), $e && ($e < 8 || 15 < $e) ? M : (ht.window !== null && ht.wbits !== $e && (ht.window = null), ht.wrap = ce, ht.wbits = $e, le(Le))) : M;
      }
      function X(Le, $e) {
        var ce, ht;
        return Le ? (ht = new te(), (Le.state = ht).window = null, (ce = fe(Le, $e)) !== U && (Le.state = null), ce) : M;
      }
      var W, je, ke = !0;
      function Ye(Le) {
        if (ke) {
          var $e;
          for (W = new o.Buf32(512), je = new o.Buf32(32), $e = 0; $e < 144; )
            Le.lens[$e++] = 8;
          for (; $e < 256; )
            Le.lens[$e++] = 9;
          for (; $e < 280; )
            Le.lens[$e++] = 7;
          for (; $e < 288; )
            Le.lens[$e++] = 8;
          for (x(B, Le.lens, 0, 288, W, 0, Le.work, { bits: 9 }), $e = 0; $e < 32; )
            Le.lens[$e++] = 5;
          x(P, Le.lens, 0, 32, je, 0, Le.work, { bits: 5 }), ke = !1;
        }
        Le.lencode = W, Le.lenbits = 9, Le.distcode = je, Le.distbits = 5;
      }
      function pt(Le, $e, ce, ht) {
        var De, ft = Le.state;
        return ft.window === null && (ft.wsize = 1 << ft.wbits, ft.wnext = 0, ft.whave = 0, ft.window = new o.Buf8(ft.wsize)), ht >= ft.wsize ? (o.arraySet(ft.window, $e, ce - ft.wsize, ft.wsize, 0), ft.wnext = 0, ft.whave = ft.wsize) : (ht < (De = ft.wsize - ft.wnext) && (De = ht), o.arraySet(ft.window, $e, ce - ht, De, ft.wnext), (ht -= De) ? (o.arraySet(ft.window, $e, ce - ht, ht, 0), ft.wnext = ht, ft.whave = ft.wsize) : (ft.wnext += De, ft.wnext === ft.wsize && (ft.wnext = 0), ft.whave < ft.wsize && (ft.whave += De))), 0;
      }
      s.inflateReset = le, s.inflateReset2 = fe, s.inflateResetKeep = ee, s.inflateInit = function(Le) {
        return X(Le, 15);
      }, s.inflateInit2 = X, s.inflate = function(Le, $e) {
        var ce, ht, De, ft, Yt, We, It, rt, tt, Kt, qt, Lt, Ci, ji, _i, Wt, $t, ei, tn, Fi, _e, Ct, yt, Re, Ee = 0, et = new o.Buf8(4), kt = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];
        if (!Le || !Le.state || !Le.output || !Le.input && Le.avail_in !== 0)
          return M;
        (ce = Le.state).mode === 12 && (ce.mode = 13), Yt = Le.next_out, De = Le.output, It = Le.avail_out, ft = Le.next_in, ht = Le.input, We = Le.avail_in, rt = ce.hold, tt = ce.bits, Kt = We, qt = It, Ct = U;
        e:
          for (; ; )
            switch (ce.mode) {
              case Z:
                if (ce.wrap === 0) {
                  ce.mode = 13;
                  break;
                }
                for (; tt < 16; ) {
                  if (We === 0)
                    break e;
                  We--, rt += ht[ft++] << tt, tt += 8;
                }
                if (2 & ce.wrap && rt === 35615) {
                  et[ce.check = 0] = 255 & rt, et[1] = rt >>> 8 & 255, ce.check = c(ce.check, et, 2, 0), tt = rt = 0, ce.mode = 2;
                  break;
                }
                if (ce.flags = 0, ce.head && (ce.head.done = !1), !(1 & ce.wrap) || (((255 & rt) << 8) + (rt >> 8)) % 31) {
                  Le.msg = "incorrect header check", ce.mode = 30;
                  break;
                }
                if ((15 & rt) != 8) {
                  Le.msg = "unknown compression method", ce.mode = 30;
                  break;
                }
                if (tt -= 4, _e = 8 + (15 & (rt >>>= 4)), ce.wbits === 0)
                  ce.wbits = _e;
                else if (_e > ce.wbits) {
                  Le.msg = "invalid window size", ce.mode = 30;
                  break;
                }
                ce.dmax = 1 << _e, Le.adler = ce.check = 1, ce.mode = 512 & rt ? 10 : 12, tt = rt = 0;
                break;
              case 2:
                for (; tt < 16; ) {
                  if (We === 0)
                    break e;
                  We--, rt += ht[ft++] << tt, tt += 8;
                }
                if (ce.flags = rt, (255 & ce.flags) != 8) {
                  Le.msg = "unknown compression method", ce.mode = 30;
                  break;
                }
                if (57344 & ce.flags) {
                  Le.msg = "unknown header flags set", ce.mode = 30;
                  break;
                }
                ce.head && (ce.head.text = rt >> 8 & 1), 512 & ce.flags && (et[0] = 255 & rt, et[1] = rt >>> 8 & 255, ce.check = c(ce.check, et, 2, 0)), tt = rt = 0, ce.mode = 3;
              case 3:
                for (; tt < 32; ) {
                  if (We === 0)
                    break e;
                  We--, rt += ht[ft++] << tt, tt += 8;
                }
                ce.head && (ce.head.time = rt), 512 & ce.flags && (et[0] = 255 & rt, et[1] = rt >>> 8 & 255, et[2] = rt >>> 16 & 255, et[3] = rt >>> 24 & 255, ce.check = c(ce.check, et, 4, 0)), tt = rt = 0, ce.mode = 4;
              case 4:
                for (; tt < 16; ) {
                  if (We === 0)
                    break e;
                  We--, rt += ht[ft++] << tt, tt += 8;
                }
                ce.head && (ce.head.xflags = 255 & rt, ce.head.os = rt >> 8), 512 & ce.flags && (et[0] = 255 & rt, et[1] = rt >>> 8 & 255, ce.check = c(ce.check, et, 2, 0)), tt = rt = 0, ce.mode = 5;
              case 5:
                if (1024 & ce.flags) {
                  for (; tt < 16; ) {
                    if (We === 0)
                      break e;
                    We--, rt += ht[ft++] << tt, tt += 8;
                  }
                  ce.length = rt, ce.head && (ce.head.extra_len = rt), 512 & ce.flags && (et[0] = 255 & rt, et[1] = rt >>> 8 & 255, ce.check = c(ce.check, et, 2, 0)), tt = rt = 0;
                } else
                  ce.head && (ce.head.extra = null);
                ce.mode = 6;
              case 6:
                if (1024 & ce.flags && (We < (Lt = ce.length) && (Lt = We), Lt && (ce.head && (_e = ce.head.extra_len - ce.length, ce.head.extra || (ce.head.extra = new Array(ce.head.extra_len)), o.arraySet(ce.head.extra, ht, ft, Lt, _e)), 512 & ce.flags && (ce.check = c(ce.check, ht, Lt, ft)), We -= Lt, ft += Lt, ce.length -= Lt), ce.length))
                  break e;
                ce.length = 0, ce.mode = 7;
              case 7:
                if (2048 & ce.flags) {
                  if (We === 0)
                    break e;
                  for (Lt = 0; _e = ht[ft + Lt++], ce.head && _e && ce.length < 65536 && (ce.head.name += String.fromCharCode(_e)), _e && Lt < We; )
                    ;
                  if (512 & ce.flags && (ce.check = c(ce.check, ht, Lt, ft)), We -= Lt, ft += Lt, _e)
                    break e;
                } else
                  ce.head && (ce.head.name = null);
                ce.length = 0, ce.mode = 8;
              case 8:
                if (4096 & ce.flags) {
                  if (We === 0)
                    break e;
                  for (Lt = 0; _e = ht[ft + Lt++], ce.head && _e && ce.length < 65536 && (ce.head.comment += String.fromCharCode(_e)), _e && Lt < We; )
                    ;
                  if (512 & ce.flags && (ce.check = c(ce.check, ht, Lt, ft)), We -= Lt, ft += Lt, _e)
                    break e;
                } else
                  ce.head && (ce.head.comment = null);
                ce.mode = 9;
              case 9:
                if (512 & ce.flags) {
                  for (; tt < 16; ) {
                    if (We === 0)
                      break e;
                    We--, rt += ht[ft++] << tt, tt += 8;
                  }
                  if (rt !== (65535 & ce.check)) {
                    Le.msg = "header crc mismatch", ce.mode = 30;
                    break;
                  }
                  tt = rt = 0;
                }
                ce.head && (ce.head.hcrc = ce.flags >> 9 & 1, ce.head.done = !0), Le.adler = ce.check = 0, ce.mode = 12;
                break;
              case 10:
                for (; tt < 32; ) {
                  if (We === 0)
                    break e;
                  We--, rt += ht[ft++] << tt, tt += 8;
                }
                Le.adler = ce.check = D(rt), tt = rt = 0, ce.mode = 11;
              case 11:
                if (ce.havedict === 0)
                  return Le.next_out = Yt, Le.avail_out = It, Le.next_in = ft, Le.avail_in = We, ce.hold = rt, ce.bits = tt, 2;
                Le.adler = ce.check = 1, ce.mode = 12;
              case 12:
                if ($e === 5 || $e === 6)
                  break e;
              case 13:
                if (ce.last) {
                  rt >>>= 7 & tt, tt -= 7 & tt, ce.mode = 27;
                  break;
                }
                for (; tt < 3; ) {
                  if (We === 0)
                    break e;
                  We--, rt += ht[ft++] << tt, tt += 8;
                }
                switch (ce.last = 1 & rt, tt -= 1, 3 & (rt >>>= 1)) {
                  case 0:
                    ce.mode = 14;
                    break;
                  case 1:
                    if (Ye(ce), ce.mode = 20, $e !== 6)
                      break;
                    rt >>>= 2, tt -= 2;
                    break e;
                  case 2:
                    ce.mode = 17;
                    break;
                  case 3:
                    Le.msg = "invalid block type", ce.mode = 30;
                }
                rt >>>= 2, tt -= 2;
                break;
              case 14:
                for (rt >>>= 7 & tt, tt -= 7 & tt; tt < 32; ) {
                  if (We === 0)
                    break e;
                  We--, rt += ht[ft++] << tt, tt += 8;
                }
                if ((65535 & rt) != (rt >>> 16 ^ 65535)) {
                  Le.msg = "invalid stored block lengths", ce.mode = 30;
                  break;
                }
                if (ce.length = 65535 & rt, tt = rt = 0, ce.mode = 15, $e === 6)
                  break e;
              case 15:
                ce.mode = 16;
              case 16:
                if (Lt = ce.length) {
                  if (We < Lt && (Lt = We), It < Lt && (Lt = It), Lt === 0)
                    break e;
                  o.arraySet(De, ht, ft, Lt, Yt), We -= Lt, ft += Lt, It -= Lt, Yt += Lt, ce.length -= Lt;
                  break;
                }
                ce.mode = 12;
                break;
              case 17:
                for (; tt < 14; ) {
                  if (We === 0)
                    break e;
                  We--, rt += ht[ft++] << tt, tt += 8;
                }
                if (ce.nlen = 257 + (31 & rt), rt >>>= 5, tt -= 5, ce.ndist = 1 + (31 & rt), rt >>>= 5, tt -= 5, ce.ncode = 4 + (15 & rt), rt >>>= 4, tt -= 4, 286 < ce.nlen || 30 < ce.ndist) {
                  Le.msg = "too many length or distance symbols", ce.mode = 30;
                  break;
                }
                ce.have = 0, ce.mode = 18;
              case 18:
                for (; ce.have < ce.ncode; ) {
                  for (; tt < 3; ) {
                    if (We === 0)
                      break e;
                    We--, rt += ht[ft++] << tt, tt += 8;
                  }
                  ce.lens[kt[ce.have++]] = 7 & rt, rt >>>= 3, tt -= 3;
                }
                for (; ce.have < 19; )
                  ce.lens[kt[ce.have++]] = 0;
                if (ce.lencode = ce.lendyn, ce.lenbits = 7, yt = { bits: ce.lenbits }, Ct = x(0, ce.lens, 0, 19, ce.lencode, 0, ce.work, yt), ce.lenbits = yt.bits, Ct) {
                  Le.msg = "invalid code lengths set", ce.mode = 30;
                  break;
                }
                ce.have = 0, ce.mode = 19;
              case 19:
                for (; ce.have < ce.nlen + ce.ndist; ) {
                  for (; Wt = (Ee = ce.lencode[rt & (1 << ce.lenbits) - 1]) >>> 16 & 255, $t = 65535 & Ee, !((_i = Ee >>> 24) <= tt); ) {
                    if (We === 0)
                      break e;
                    We--, rt += ht[ft++] << tt, tt += 8;
                  }
                  if ($t < 16)
                    rt >>>= _i, tt -= _i, ce.lens[ce.have++] = $t;
                  else {
                    if ($t === 16) {
                      for (Re = _i + 2; tt < Re; ) {
                        if (We === 0)
                          break e;
                        We--, rt += ht[ft++] << tt, tt += 8;
                      }
                      if (rt >>>= _i, tt -= _i, ce.have === 0) {
                        Le.msg = "invalid bit length repeat", ce.mode = 30;
                        break;
                      }
                      _e = ce.lens[ce.have - 1], Lt = 3 + (3 & rt), rt >>>= 2, tt -= 2;
                    } else if ($t === 17) {
                      for (Re = _i + 3; tt < Re; ) {
                        if (We === 0)
                          break e;
                        We--, rt += ht[ft++] << tt, tt += 8;
                      }
                      tt -= _i, _e = 0, Lt = 3 + (7 & (rt >>>= _i)), rt >>>= 3, tt -= 3;
                    } else {
                      for (Re = _i + 7; tt < Re; ) {
                        if (We === 0)
                          break e;
                        We--, rt += ht[ft++] << tt, tt += 8;
                      }
                      tt -= _i, _e = 0, Lt = 11 + (127 & (rt >>>= _i)), rt >>>= 7, tt -= 7;
                    }
                    if (ce.have + Lt > ce.nlen + ce.ndist) {
                      Le.msg = "invalid bit length repeat", ce.mode = 30;
                      break;
                    }
                    for (; Lt--; )
                      ce.lens[ce.have++] = _e;
                  }
                }
                if (ce.mode === 30)
                  break;
                if (ce.lens[256] === 0) {
                  Le.msg = "invalid code -- missing end-of-block", ce.mode = 30;
                  break;
                }
                if (ce.lenbits = 9, yt = { bits: ce.lenbits }, Ct = x(B, ce.lens, 0, ce.nlen, ce.lencode, 0, ce.work, yt), ce.lenbits = yt.bits, Ct) {
                  Le.msg = "invalid literal/lengths set", ce.mode = 30;
                  break;
                }
                if (ce.distbits = 6, ce.distcode = ce.distdyn, yt = { bits: ce.distbits }, Ct = x(P, ce.lens, ce.nlen, ce.ndist, ce.distcode, 0, ce.work, yt), ce.distbits = yt.bits, Ct) {
                  Le.msg = "invalid distances set", ce.mode = 30;
                  break;
                }
                if (ce.mode = 20, $e === 6)
                  break e;
              case 20:
                ce.mode = 21;
              case 21:
                if (6 <= We && 258 <= It) {
                  Le.next_out = Yt, Le.avail_out = It, Le.next_in = ft, Le.avail_in = We, ce.hold = rt, ce.bits = tt, _(Le, qt), Yt = Le.next_out, De = Le.output, It = Le.avail_out, ft = Le.next_in, ht = Le.input, We = Le.avail_in, rt = ce.hold, tt = ce.bits, ce.mode === 12 && (ce.back = -1);
                  break;
                }
                for (ce.back = 0; Wt = (Ee = ce.lencode[rt & (1 << ce.lenbits) - 1]) >>> 16 & 255, $t = 65535 & Ee, !((_i = Ee >>> 24) <= tt); ) {
                  if (We === 0)
                    break e;
                  We--, rt += ht[ft++] << tt, tt += 8;
                }
                if (Wt && !(240 & Wt)) {
                  for (ei = _i, tn = Wt, Fi = $t; Wt = (Ee = ce.lencode[Fi + ((rt & (1 << ei + tn) - 1) >> ei)]) >>> 16 & 255, $t = 65535 & Ee, !(ei + (_i = Ee >>> 24) <= tt); ) {
                    if (We === 0)
                      break e;
                    We--, rt += ht[ft++] << tt, tt += 8;
                  }
                  rt >>>= ei, tt -= ei, ce.back += ei;
                }
                if (rt >>>= _i, tt -= _i, ce.back += _i, ce.length = $t, Wt === 0) {
                  ce.mode = 26;
                  break;
                }
                if (32 & Wt) {
                  ce.back = -1, ce.mode = 12;
                  break;
                }
                if (64 & Wt) {
                  Le.msg = "invalid literal/length code", ce.mode = 30;
                  break;
                }
                ce.extra = 15 & Wt, ce.mode = 22;
              case 22:
                if (ce.extra) {
                  for (Re = ce.extra; tt < Re; ) {
                    if (We === 0)
                      break e;
                    We--, rt += ht[ft++] << tt, tt += 8;
                  }
                  ce.length += rt & (1 << ce.extra) - 1, rt >>>= ce.extra, tt -= ce.extra, ce.back += ce.extra;
                }
                ce.was = ce.length, ce.mode = 23;
              case 23:
                for (; Wt = (Ee = ce.distcode[rt & (1 << ce.distbits) - 1]) >>> 16 & 255, $t = 65535 & Ee, !((_i = Ee >>> 24) <= tt); ) {
                  if (We === 0)
                    break e;
                  We--, rt += ht[ft++] << tt, tt += 8;
                }
                if (!(240 & Wt)) {
                  for (ei = _i, tn = Wt, Fi = $t; Wt = (Ee = ce.distcode[Fi + ((rt & (1 << ei + tn) - 1) >> ei)]) >>> 16 & 255, $t = 65535 & Ee, !(ei + (_i = Ee >>> 24) <= tt); ) {
                    if (We === 0)
                      break e;
                    We--, rt += ht[ft++] << tt, tt += 8;
                  }
                  rt >>>= ei, tt -= ei, ce.back += ei;
                }
                if (rt >>>= _i, tt -= _i, ce.back += _i, 64 & Wt) {
                  Le.msg = "invalid distance code", ce.mode = 30;
                  break;
                }
                ce.offset = $t, ce.extra = 15 & Wt, ce.mode = 24;
              case 24:
                if (ce.extra) {
                  for (Re = ce.extra; tt < Re; ) {
                    if (We === 0)
                      break e;
                    We--, rt += ht[ft++] << tt, tt += 8;
                  }
                  ce.offset += rt & (1 << ce.extra) - 1, rt >>>= ce.extra, tt -= ce.extra, ce.back += ce.extra;
                }
                if (ce.offset > ce.dmax) {
                  Le.msg = "invalid distance too far back", ce.mode = 30;
                  break;
                }
                ce.mode = 25;
              case 25:
                if (It === 0)
                  break e;
                if (Lt = qt - It, ce.offset > Lt) {
                  if ((Lt = ce.offset - Lt) > ce.whave && ce.sane) {
                    Le.msg = "invalid distance too far back", ce.mode = 30;
                    break;
                  }
                  Ci = Lt > ce.wnext ? (Lt -= ce.wnext, ce.wsize - Lt) : ce.wnext - Lt, Lt > ce.length && (Lt = ce.length), ji = ce.window;
                } else
                  ji = De, Ci = Yt - ce.offset, Lt = ce.length;
                for (It < Lt && (Lt = It), It -= Lt, ce.length -= Lt; De[Yt++] = ji[Ci++], --Lt; )
                  ;
                ce.length === 0 && (ce.mode = 21);
                break;
              case 26:
                if (It === 0)
                  break e;
                De[Yt++] = ce.length, It--, ce.mode = 21;
                break;
              case 27:
                if (ce.wrap) {
                  for (; tt < 32; ) {
                    if (We === 0)
                      break e;
                    We--, rt |= ht[ft++] << tt, tt += 8;
                  }
                  if (qt -= It, Le.total_out += qt, ce.total += qt, qt && (Le.adler = ce.check = ce.flags ? c(ce.check, De, qt, Yt - qt) : h(ce.check, De, qt, Yt - qt)), qt = It, (ce.flags ? rt : D(rt)) !== ce.check) {
                    Le.msg = "incorrect data check", ce.mode = 30;
                    break;
                  }
                  tt = rt = 0;
                }
                ce.mode = 28;
              case 28:
                if (ce.wrap && ce.flags) {
                  for (; tt < 32; ) {
                    if (We === 0)
                      break e;
                    We--, rt += ht[ft++] << tt, tt += 8;
                  }
                  if (rt !== (4294967295 & ce.total)) {
                    Le.msg = "incorrect length check", ce.mode = 30;
                    break;
                  }
                  tt = rt = 0;
                }
                ce.mode = 29;
              case 29:
                Ct = 1;
                break e;
              case 30:
                Ct = -3;
                break e;
              case 31:
                return -4;
              case 32:
              default:
                return M;
            }
        return Le.next_out = Yt, Le.avail_out = It, Le.next_in = ft, Le.avail_in = We, ce.hold = rt, ce.bits = tt, (ce.wsize || qt !== Le.avail_out && ce.mode < 30 && (ce.mode < 27 || $e !== 4)) && pt(Le, Le.output, Le.next_out, qt - Le.avail_out) ? (ce.mode = 31, -4) : (Kt -= Le.avail_in, qt -= Le.avail_out, Le.total_in += Kt, Le.total_out += qt, ce.total += qt, ce.wrap && qt && (Le.adler = ce.check = ce.flags ? c(ce.check, De, qt, Le.next_out - qt) : h(ce.check, De, qt, Le.next_out - qt)), Le.data_type = ce.bits + (ce.last ? 64 : 0) + (ce.mode === 12 ? 128 : 0) + (ce.mode === 20 || ce.mode === 15 ? 256 : 0), (Kt == 0 && qt === 0 || $e === 4) && Ct === U && (Ct = -5), Ct);
      }, s.inflateEnd = function(Le) {
        if (!Le || !Le.state)
          return M;
        var $e = Le.state;
        return $e.window && ($e.window = null), Le.state = null, U;
      }, s.inflateGetHeader = function(Le, $e) {
        var ce;
        return Le && Le.state && 2 & (ce = Le.state).wrap ? ((ce.head = $e).done = !1, U) : M;
      }, s.inflateSetDictionary = function(Le, $e) {
        var ce, ht = $e.length;
        return Le && Le.state ? (ce = Le.state).wrap !== 0 && ce.mode !== 11 ? M : ce.mode === 11 && h(1, $e, ht, 0) !== ce.check ? -3 : pt(Le, $e, ht, ht) ? (ce.mode = 31, -4) : (ce.havedict = 1, U) : M;
      }, s.inflateInfo = "pako inflate (from Nodeca project)";
    }, { "../utils/common": 41, "./adler32": 43, "./crc32": 45, "./inffast": 48, "./inftrees": 50 }], 50: [function(t, n, s) {
      var o = t("../utils/common"), h = [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0], c = [16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78], _ = [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0], x = [16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 24, 25, 25, 26, 26, 27, 27, 28, 28, 29, 29, 64, 64];
      n.exports = function(B, P, U, M, Z, F, Q, D) {
        var te, ee, le, fe, X, W, je, ke, Ye, pt = D.bits, Le = 0, $e = 0, ce = 0, ht = 0, De = 0, ft = 0, Yt = 0, We = 0, It = 0, rt = 0, tt = null, Kt = 0, qt = new o.Buf16(16), Lt = new o.Buf16(16), Ci = null, ji = 0;
        for (Le = 0; Le <= 15; Le++)
          qt[Le] = 0;
        for ($e = 0; $e < M; $e++)
          qt[P[U + $e]]++;
        for (De = pt, ht = 15; 1 <= ht && qt[ht] === 0; ht--)
          ;
        if (ht < De && (De = ht), ht === 0)
          return Z[F++] = 20971520, Z[F++] = 20971520, D.bits = 1, 0;
        for (ce = 1; ce < ht && qt[ce] === 0; ce++)
          ;
        for (De < ce && (De = ce), Le = We = 1; Le <= 15; Le++)
          if (We <<= 1, (We -= qt[Le]) < 0)
            return -1;
        if (0 < We && (B === 0 || ht !== 1))
          return -1;
        for (Lt[1] = 0, Le = 1; Le < 15; Le++)
          Lt[Le + 1] = Lt[Le] + qt[Le];
        for ($e = 0; $e < M; $e++)
          P[U + $e] !== 0 && (Q[Lt[P[U + $e]]++] = $e);
        if (W = B === 0 ? (tt = Ci = Q, 19) : B === 1 ? (tt = h, Kt -= 257, Ci = c, ji -= 257, 256) : (tt = _, Ci = x, -1), Le = ce, X = F, Yt = $e = rt = 0, le = -1, fe = (It = 1 << (ft = De)) - 1, B === 1 && 852 < It || B === 2 && 592 < It)
          return 1;
        for (; ; ) {
          for (je = Le - Yt, Ye = Q[$e] < W ? (ke = 0, Q[$e]) : Q[$e] > W ? (ke = Ci[ji + Q[$e]], tt[Kt + Q[$e]]) : (ke = 96, 0), te = 1 << Le - Yt, ce = ee = 1 << ft; Z[X + (rt >> Yt) + (ee -= te)] = je << 24 | ke << 16 | Ye | 0, ee !== 0; )
            ;
          for (te = 1 << Le - 1; rt & te; )
            te >>= 1;
          if (te !== 0 ? (rt &= te - 1, rt += te) : rt = 0, $e++, --qt[Le] == 0) {
            if (Le === ht)
              break;
            Le = P[U + Q[$e]];
          }
          if (De < Le && (rt & fe) !== le) {
            for (Yt === 0 && (Yt = De), X += ce, We = 1 << (ft = Le - Yt); ft + Yt < ht && !((We -= qt[ft + Yt]) <= 0); )
              ft++, We <<= 1;
            if (It += 1 << ft, B === 1 && 852 < It || B === 2 && 592 < It)
              return 1;
            Z[le = rt & fe] = De << 24 | ft << 16 | X - F | 0;
          }
        }
        return rt !== 0 && (Z[X + rt] = Le - Yt << 24 | 64 << 16 | 0), D.bits = De, 0;
      };
    }, { "../utils/common": 41 }], 51: [function(t, n, s) {
      n.exports = { 2: "need dictionary", 1: "stream end", 0: "", "-1": "file error", "-2": "stream error", "-3": "data error", "-4": "insufficient memory", "-5": "buffer error", "-6": "incompatible version" };
    }, {}], 52: [function(t, n, s) {
      var o = t("../utils/common"), h = 0, c = 1;
      function _(Ee) {
        for (var et = Ee.length; 0 <= --et; )
          Ee[et] = 0;
      }
      var x = 0, B = 29, P = 256, U = P + 1 + B, M = 30, Z = 19, F = 2 * U + 1, Q = 15, D = 16, te = 7, ee = 256, le = 16, fe = 17, X = 18, W = [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0], je = [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13], ke = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7], Ye = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], pt = new Array(2 * (U + 2));
      _(pt);
      var Le = new Array(2 * M);
      _(Le);
      var $e = new Array(512);
      _($e);
      var ce = new Array(256);
      _(ce);
      var ht = new Array(B);
      _(ht);
      var De, ft, Yt, We = new Array(M);
      function It(Ee, et, kt, mt, Qe) {
        this.static_tree = Ee, this.extra_bits = et, this.extra_base = kt, this.elems = mt, this.max_length = Qe, this.has_stree = Ee && Ee.length;
      }
      function rt(Ee, et) {
        this.dyn_tree = Ee, this.max_code = 0, this.stat_desc = et;
      }
      function tt(Ee) {
        return Ee < 256 ? $e[Ee] : $e[256 + (Ee >>> 7)];
      }
      function Kt(Ee, et) {
        Ee.pending_buf[Ee.pending++] = 255 & et, Ee.pending_buf[Ee.pending++] = et >>> 8 & 255;
      }
      function qt(Ee, et, kt) {
        Ee.bi_valid > D - kt ? (Ee.bi_buf |= et << Ee.bi_valid & 65535, Kt(Ee, Ee.bi_buf), Ee.bi_buf = et >> D - Ee.bi_valid, Ee.bi_valid += kt - D) : (Ee.bi_buf |= et << Ee.bi_valid & 65535, Ee.bi_valid += kt);
      }
      function Lt(Ee, et, kt) {
        qt(Ee, kt[2 * et], kt[2 * et + 1]);
      }
      function Ci(Ee, et) {
        for (var kt = 0; kt |= 1 & Ee, Ee >>>= 1, kt <<= 1, 0 < --et; )
          ;
        return kt >>> 1;
      }
      function ji(Ee, et, kt) {
        var mt, Qe, bt = new Array(Q + 1), Gt = 0;
        for (mt = 1; mt <= Q; mt++)
          bt[mt] = Gt = Gt + kt[mt - 1] << 1;
        for (Qe = 0; Qe <= et; Qe++) {
          var He = Ee[2 * Qe + 1];
          He !== 0 && (Ee[2 * Qe] = Ci(bt[He]++, He));
        }
      }
      function _i(Ee) {
        var et;
        for (et = 0; et < U; et++)
          Ee.dyn_ltree[2 * et] = 0;
        for (et = 0; et < M; et++)
          Ee.dyn_dtree[2 * et] = 0;
        for (et = 0; et < Z; et++)
          Ee.bl_tree[2 * et] = 0;
        Ee.dyn_ltree[2 * ee] = 1, Ee.opt_len = Ee.static_len = 0, Ee.last_lit = Ee.matches = 0;
      }
      function Wt(Ee) {
        8 < Ee.bi_valid ? Kt(Ee, Ee.bi_buf) : 0 < Ee.bi_valid && (Ee.pending_buf[Ee.pending++] = Ee.bi_buf), Ee.bi_buf = 0, Ee.bi_valid = 0;
      }
      function $t(Ee, et, kt, mt) {
        var Qe = 2 * et, bt = 2 * kt;
        return Ee[Qe] < Ee[bt] || Ee[Qe] === Ee[bt] && mt[et] <= mt[kt];
      }
      function ei(Ee, et, kt) {
        for (var mt = Ee.heap[kt], Qe = kt << 1; Qe <= Ee.heap_len && (Qe < Ee.heap_len && $t(et, Ee.heap[Qe + 1], Ee.heap[Qe], Ee.depth) && Qe++, !$t(et, mt, Ee.heap[Qe], Ee.depth)); )
          Ee.heap[kt] = Ee.heap[Qe], kt = Qe, Qe <<= 1;
        Ee.heap[kt] = mt;
      }
      function tn(Ee, et, kt) {
        var mt, Qe, bt, Gt, He = 0;
        if (Ee.last_lit !== 0)
          for (; mt = Ee.pending_buf[Ee.d_buf + 2 * He] << 8 | Ee.pending_buf[Ee.d_buf + 2 * He + 1], Qe = Ee.pending_buf[Ee.l_buf + He], He++, mt === 0 ? Lt(Ee, Qe, et) : (Lt(Ee, (bt = ce[Qe]) + P + 1, et), (Gt = W[bt]) !== 0 && qt(Ee, Qe -= ht[bt], Gt), Lt(Ee, bt = tt(--mt), kt), (Gt = je[bt]) !== 0 && qt(Ee, mt -= We[bt], Gt)), He < Ee.last_lit; )
            ;
        Lt(Ee, ee, et);
      }
      function Fi(Ee, et) {
        var kt, mt, Qe, bt = et.dyn_tree, Gt = et.stat_desc.static_tree, He = et.stat_desc.has_stree, i = et.stat_desc.elems, r = -1;
        for (Ee.heap_len = 0, Ee.heap_max = F, kt = 0; kt < i; kt++)
          bt[2 * kt] !== 0 ? (Ee.heap[++Ee.heap_len] = r = kt, Ee.depth[kt] = 0) : bt[2 * kt + 1] = 0;
        for (; Ee.heap_len < 2; )
          bt[2 * (Qe = Ee.heap[++Ee.heap_len] = r < 2 ? ++r : 0)] = 1, Ee.depth[Qe] = 0, Ee.opt_len--, He && (Ee.static_len -= Gt[2 * Qe + 1]);
        for (et.max_code = r, kt = Ee.heap_len >> 1; 1 <= kt; kt--)
          ei(Ee, bt, kt);
        for (Qe = i; kt = Ee.heap[1], Ee.heap[1] = Ee.heap[Ee.heap_len--], ei(Ee, bt, 1), mt = Ee.heap[1], Ee.heap[--Ee.heap_max] = kt, Ee.heap[--Ee.heap_max] = mt, bt[2 * Qe] = bt[2 * kt] + bt[2 * mt], Ee.depth[Qe] = (Ee.depth[kt] >= Ee.depth[mt] ? Ee.depth[kt] : Ee.depth[mt]) + 1, bt[2 * kt + 1] = bt[2 * mt + 1] = Qe, Ee.heap[1] = Qe++, ei(Ee, bt, 1), 2 <= Ee.heap_len; )
          ;
        Ee.heap[--Ee.heap_max] = Ee.heap[1], function(a, l) {
          var u, d, v, p, y, S, L = l.dyn_tree, E = l.max_code, A = l.stat_desc.static_tree, T = l.stat_desc.has_stree, G = l.stat_desc.extra_bits, R = l.stat_desc.extra_base, Y = l.stat_desc.max_length, k = 0;
          for (p = 0; p <= Q; p++)
            a.bl_count[p] = 0;
          for (L[2 * a.heap[a.heap_max] + 1] = 0, u = a.heap_max + 1; u < F; u++)
            Y < (p = L[2 * L[2 * (d = a.heap[u]) + 1] + 1] + 1) && (p = Y, k++), L[2 * d + 1] = p, E < d || (a.bl_count[p]++, y = 0, R <= d && (y = G[d - R]), S = L[2 * d], a.opt_len += S * (p + y), T && (a.static_len += S * (A[2 * d + 1] + y)));
          if (k !== 0) {
            do {
              for (p = Y - 1; a.bl_count[p] === 0; )
                p--;
              a.bl_count[p]--, a.bl_count[p + 1] += 2, a.bl_count[Y]--, k -= 2;
            } while (0 < k);
            for (p = Y; p !== 0; p--)
              for (d = a.bl_count[p]; d !== 0; )
                E < (v = a.heap[--u]) || (L[2 * v + 1] !== p && (a.opt_len += (p - L[2 * v + 1]) * L[2 * v], L[2 * v + 1] = p), d--);
          }
        }(Ee, et), ji(bt, r, Ee.bl_count);
      }
      function _e(Ee, et, kt) {
        var mt, Qe, bt = -1, Gt = et[1], He = 0, i = 7, r = 4;
        for (Gt === 0 && (i = 138, r = 3), et[2 * (kt + 1) + 1] = 65535, mt = 0; mt <= kt; mt++)
          Qe = Gt, Gt = et[2 * (mt + 1) + 1], ++He < i && Qe === Gt || (He < r ? Ee.bl_tree[2 * Qe] += He : Qe !== 0 ? (Qe !== bt && Ee.bl_tree[2 * Qe]++, Ee.bl_tree[2 * le]++) : He <= 10 ? Ee.bl_tree[2 * fe]++ : Ee.bl_tree[2 * X]++, bt = Qe, r = (He = 0) === Gt ? (i = 138, 3) : Qe === Gt ? (i = 6, 3) : (i = 7, 4));
      }
      function Ct(Ee, et, kt) {
        var mt, Qe, bt = -1, Gt = et[1], He = 0, i = 7, r = 4;
        for (Gt === 0 && (i = 138, r = 3), mt = 0; mt <= kt; mt++)
          if (Qe = Gt, Gt = et[2 * (mt + 1) + 1], !(++He < i && Qe === Gt)) {
            if (He < r)
              for (; Lt(Ee, Qe, Ee.bl_tree), --He != 0; )
                ;
            else
              Qe !== 0 ? (Qe !== bt && (Lt(Ee, Qe, Ee.bl_tree), He--), Lt(Ee, le, Ee.bl_tree), qt(Ee, He - 3, 2)) : He <= 10 ? (Lt(Ee, fe, Ee.bl_tree), qt(Ee, He - 3, 3)) : (Lt(Ee, X, Ee.bl_tree), qt(Ee, He - 11, 7));
            bt = Qe, r = (He = 0) === Gt ? (i = 138, 3) : Qe === Gt ? (i = 6, 3) : (i = 7, 4);
          }
      }
      _(We);
      var yt = !1;
      function Re(Ee, et, kt, mt) {
        qt(Ee, (x << 1) + (mt ? 1 : 0), 3), function(Qe, bt, Gt, He) {
          Wt(Qe), He && (Kt(Qe, Gt), Kt(Qe, ~Gt)), o.arraySet(Qe.pending_buf, Qe.window, bt, Gt, Qe.pending), Qe.pending += Gt;
        }(Ee, et, kt, !0);
      }
      s._tr_init = function(Ee) {
        yt || (function() {
          var et, kt, mt, Qe, bt, Gt = new Array(Q + 1);
          for (Qe = mt = 0; Qe < B - 1; Qe++)
            for (ht[Qe] = mt, et = 0; et < 1 << W[Qe]; et++)
              ce[mt++] = Qe;
          for (ce[mt - 1] = Qe, Qe = bt = 0; Qe < 16; Qe++)
            for (We[Qe] = bt, et = 0; et < 1 << je[Qe]; et++)
              $e[bt++] = Qe;
          for (bt >>= 7; Qe < M; Qe++)
            for (We[Qe] = bt << 7, et = 0; et < 1 << je[Qe] - 7; et++)
              $e[256 + bt++] = Qe;
          for (kt = 0; kt <= Q; kt++)
            Gt[kt] = 0;
          for (et = 0; et <= 143; )
            pt[2 * et + 1] = 8, et++, Gt[8]++;
          for (; et <= 255; )
            pt[2 * et + 1] = 9, et++, Gt[9]++;
          for (; et <= 279; )
            pt[2 * et + 1] = 7, et++, Gt[7]++;
          for (; et <= 287; )
            pt[2 * et + 1] = 8, et++, Gt[8]++;
          for (ji(pt, U + 1, Gt), et = 0; et < M; et++)
            Le[2 * et + 1] = 5, Le[2 * et] = Ci(et, 5);
          De = new It(pt, W, P + 1, U, Q), ft = new It(Le, je, 0, M, Q), Yt = new It(new Array(0), ke, 0, Z, te);
        }(), yt = !0), Ee.l_desc = new rt(Ee.dyn_ltree, De), Ee.d_desc = new rt(Ee.dyn_dtree, ft), Ee.bl_desc = new rt(Ee.bl_tree, Yt), Ee.bi_buf = 0, Ee.bi_valid = 0, _i(Ee);
      }, s._tr_stored_block = Re, s._tr_flush_block = function(Ee, et, kt, mt) {
        var Qe, bt, Gt = 0;
        0 < Ee.level ? (Ee.strm.data_type === 2 && (Ee.strm.data_type = function(He) {
          var i, r = 4093624447;
          for (i = 0; i <= 31; i++, r >>>= 1)
            if (1 & r && He.dyn_ltree[2 * i] !== 0)
              return h;
          if (He.dyn_ltree[18] !== 0 || He.dyn_ltree[20] !== 0 || He.dyn_ltree[26] !== 0)
            return c;
          for (i = 32; i < P; i++)
            if (He.dyn_ltree[2 * i] !== 0)
              return c;
          return h;
        }(Ee)), Fi(Ee, Ee.l_desc), Fi(Ee, Ee.d_desc), Gt = function(He) {
          var i;
          for (_e(He, He.dyn_ltree, He.l_desc.max_code), _e(He, He.dyn_dtree, He.d_desc.max_code), Fi(He, He.bl_desc), i = Z - 1; 3 <= i && He.bl_tree[2 * Ye[i] + 1] === 0; i--)
            ;
          return He.opt_len += 3 * (i + 1) + 5 + 5 + 4, i;
        }(Ee), Qe = Ee.opt_len + 3 + 7 >>> 3, (bt = Ee.static_len + 3 + 7 >>> 3) <= Qe && (Qe = bt)) : Qe = bt = kt + 5, kt + 4 <= Qe && et !== -1 ? Re(Ee, et, kt, mt) : Ee.strategy === 4 || bt === Qe ? (qt(Ee, 2 + (mt ? 1 : 0), 3), tn(Ee, pt, Le)) : (qt(Ee, 4 + (mt ? 1 : 0), 3), function(He, i, r, a) {
          var l;
          for (qt(He, i - 257, 5), qt(He, r - 1, 5), qt(He, a - 4, 4), l = 0; l < a; l++)
            qt(He, He.bl_tree[2 * Ye[l] + 1], 3);
          Ct(He, He.dyn_ltree, i - 1), Ct(He, He.dyn_dtree, r - 1);
        }(Ee, Ee.l_desc.max_code + 1, Ee.d_desc.max_code + 1, Gt + 1), tn(Ee, Ee.dyn_ltree, Ee.dyn_dtree)), _i(Ee), mt && Wt(Ee);
      }, s._tr_tally = function(Ee, et, kt) {
        return Ee.pending_buf[Ee.d_buf + 2 * Ee.last_lit] = et >>> 8 & 255, Ee.pending_buf[Ee.d_buf + 2 * Ee.last_lit + 1] = 255 & et, Ee.pending_buf[Ee.l_buf + Ee.last_lit] = 255 & kt, Ee.last_lit++, et === 0 ? Ee.dyn_ltree[2 * kt]++ : (Ee.matches++, et--, Ee.dyn_ltree[2 * (ce[kt] + P + 1)]++, Ee.dyn_dtree[2 * tt(et)]++), Ee.last_lit === Ee.lit_bufsize - 1;
      }, s._tr_align = function(Ee) {
        qt(Ee, 2, 3), Lt(Ee, ee, pt), function(et) {
          et.bi_valid === 16 ? (Kt(et, et.bi_buf), et.bi_buf = 0, et.bi_valid = 0) : 8 <= et.bi_valid && (et.pending_buf[et.pending++] = 255 & et.bi_buf, et.bi_buf >>= 8, et.bi_valid -= 8);
        }(Ee);
      };
    }, { "../utils/common": 41 }], 53: [function(t, n, s) {
      n.exports = function() {
        this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
      };
    }, {}], 54: [function(t, n, s) {
      (function(o) {
        (function(h, c) {
          if (!h.setImmediate) {
            var _, x, B, P, U = 1, M = {}, Z = !1, F = h.document, Q = Object.getPrototypeOf && Object.getPrototypeOf(h);
            Q = Q && Q.setTimeout ? Q : h, _ = {}.toString.call(h.process) === "[object process]" ? function(le) {
              process.nextTick(function() {
                te(le);
              });
            } : function() {
              if (h.postMessage && !h.importScripts) {
                var le = !0, fe = h.onmessage;
                return h.onmessage = function() {
                  le = !1;
                }, h.postMessage("", "*"), h.onmessage = fe, le;
              }
            }() ? (P = "setImmediate$" + Math.random() + "$", h.addEventListener ? h.addEventListener("message", ee, !1) : h.attachEvent("onmessage", ee), function(le) {
              h.postMessage(P + le, "*");
            }) : h.MessageChannel ? ((B = new MessageChannel()).port1.onmessage = function(le) {
              te(le.data);
            }, function(le) {
              B.port2.postMessage(le);
            }) : F && "onreadystatechange" in F.createElement("script") ? (x = F.documentElement, function(le) {
              var fe = F.createElement("script");
              fe.onreadystatechange = function() {
                te(le), fe.onreadystatechange = null, x.removeChild(fe), fe = null;
              }, x.appendChild(fe);
            }) : function(le) {
              setTimeout(te, 0, le);
            }, Q.setImmediate = function(le) {
              typeof le != "function" && (le = new Function("" + le));
              for (var fe = new Array(arguments.length - 1), X = 0; X < fe.length; X++)
                fe[X] = arguments[X + 1];
              var W = { callback: le, args: fe };
              return M[U] = W, _(U), U++;
            }, Q.clearImmediate = D;
          }
          function D(le) {
            delete M[le];
          }
          function te(le) {
            if (Z)
              setTimeout(te, 0, le);
            else {
              var fe = M[le];
              if (fe) {
                Z = !0;
                try {
                  (function(X) {
                    var W = X.callback, je = X.args;
                    switch (je.length) {
                      case 0:
                        W();
                        break;
                      case 1:
                        W(je[0]);
                        break;
                      case 2:
                        W(je[0], je[1]);
                        break;
                      case 3:
                        W(je[0], je[1], je[2]);
                        break;
                      default:
                        W.apply(c, je);
                    }
                  })(fe);
                } finally {
                  D(le), Z = !1;
                }
              }
            }
          }
          function ee(le) {
            le.source === h && typeof le.data == "string" && le.data.indexOf(P) === 0 && te(+le.data.slice(P.length));
          }
        })(typeof self > "u" ? o === void 0 ? this : o : self);
      }).call(this, typeof ss < "u" ? ss : typeof self < "u" ? self : typeof window < "u" ? window : {});
    }, {}] }, {}, [10])(10);
  });
})(Nd);
var Vx = Nd.exports;
const Wf = /* @__PURE__ */ uu(Vx), Rd = class Mn {
  constructor(e) {
    this._hemiLight = null, this._pointLight = null, this._onPrePointerObservableObserver = null, this._isPointerDown = !1, this._radiusScale = 0.85, this._positionScale = 0.5, this._limitLowerRadius = !0, this._zoomEnabled = !0, this._minZoomPerc = null, this._maxZoomPerc = null, this._cameraZoom = null, this._minZObserver = null, this._cameraPivot = null, this._resizableCanvas3DGenerator = new Jy(), this.parentNode = null, this.enableShadows = !1, this.areShadowVisible = !0, this.setInitialZoomToBoundingBox = !0, this.changeRotationDirection = !1, this.initialZoomToBBInertiaDamping = 0.68, this._initialZoomToBBModelSizeRadius = 0.7, this.initialZoomToBBScrollZoomEnabled = !0, this.initialZoomToBBScrollLowerLimit = 2, this.initialZoomToBBScrollUpperLimit = 2, this.animateIntro = !1, this._defHemiLightID = "f90aba65-3b60-44ac-87f4-1b6441aee44b", this._defPointLightID = "b6491635-c471-45a4-bbb8-3f08556e5b3c", this._targetAnimationID = "6225769c-0113-4236-ab17-c39d24013de4", this._radiusAnimationID = "6f946c2f-af8d-46ab-9bea-9e22dedc4e9d", this._alphaAnimationID = "10713520-fe06-4cbf-bc6a-bab881d516e6", this._betaAnimationID = "6096ba34-852a-4423-bab3-dc97c1a9268f", this._dummyMaterialID = "081796b8-0908-44dc-a38a-d786b14cA6fc", this._loadingMaterials = {}, this._authorizationToken = null, this.getVTOMeshes = () => {
      const t = [
        "vto_reference",
        "ground",
        "shadowGround",
        "shadow",
        "skybox",
        "environment",
        "axes",
        "grid",
        "boundingbox",
        "highlight",
        "EditControl",
        "guideCtl",
        "bxAxis",
        "byAxis",
        "bzAxis",
        "xAxis",
        "yAxis",
        "zAxis",
        "pALL",
        "pXZ",
        "pZY",
        "pYX",
        "pickPlanes",
        "tarnsCtl",
        "X",
        "Y",
        "Z",
        "XZ",
        "ZY",
        "YX",
        "ALL",
        "tEndX",
        "tEndY",
        "tEndZ",
        "XZ",
        "ZY",
        "YX",
        "tEndAll"
      ], n = (c) => t.filter((_) => c.toLowerCase() === _.toLowerCase()).length > 0, s = (c) => c.toLowerCase().includes("vto_reference"), o = this._scene.meshes.filter((c) => s(c.name)), h = this._scene.meshes.filter((c) => !n(c.name) && !s(c.name));
      return {
        tryonReferencesModels: o,
        userMeshes: h
      };
    }, this._loadedMeshes = [], this._isLoading = !1, this._lastVisibilityStates = /* @__PURE__ */ new Map(), this._scene = e, this._engine = e.getEngine(), this._camera = e.activeCamera, this._canvas = e.getEngine().getRenderingCanvas(), this.init();
  }
  get initialZoomToBBModelSizeRadius() {
    return console.log("Getting initialZoomToBBModelSizeRadius: ", this._initialZoomToBBModelSizeRadius), this._initialZoomToBBModelSizeRadius;
  }
  set initialZoomToBBModelSizeRadius(e) {
    console.log("Setting initialZoomToBBModelSizeRadius to: ", e), this._initialZoomToBBModelSizeRadius = e;
  }
  get camera() {
    return this._camera;
  }
  /**
   * Imposta il token di autorizzazione per le chiamate API
   * @param token Il token di autorizzazione
   */
  setAuthorizationToken(e) {
    this._authorizationToken = e;
  }
  /**
   * Ottiene il token di autorizzazione attualmente impostato
   * @returns Il token di autorizzazione o null se non impostato
   */
  getAuthorizationToken() {
    return this._authorizationToken;
  }
  static checkAllMaterialTextureReady(e) {
    const t = e.getActiveTextures();
    for (let n = 0; n < t.length; n++) {
      const s = t[n];
      if (s.isReady())
        s instanceof BABYLON.ProceduralTexture && s.getEffect();
      else
        return !1;
    }
    return !0;
  }
  removeDefaultBackground(e) {
    e && (this._scene.clearColor = new BABYLON.Color4(0, 0, 0, 0));
  }
  setUpSceneToneMapping(e) {
    var h, c, _, x;
    const t = (h = e == null ? void 0 : e.getCameraConfig()) == null ? void 0 : h.get("toneMappingEnabled");
    t != null && (this._scene.imageProcessingConfiguration.toneMappingEnabled = t);
    const n = (c = e == null ? void 0 : e.getCameraConfig()) == null ? void 0 : c.get("toneMappingType");
    n != null && (this._scene.imageProcessingConfiguration.toneMappingType = n);
    const s = (_ = e == null ? void 0 : e.getGeneralConfig()) == null ? void 0 : _.get("exposure"), o = (x = e == null ? void 0 : e.getGeneralConfig()) == null ? void 0 : x.get("contrast");
    o && (this._scene.imageProcessingConfiguration.contrast = o), s && (this._scene.imageProcessingConfiguration.exposure = s);
  }
  cleanUnusedMaterialsMappings(e) {
    if (!e)
      return;
    const t = e.get("materialMappings"), n = this.getAllMaterials().filter((o) => t.find((h) => h.get("sceneMaterialID") === o.id)), s = new Zakeke.SceneMaterialMappings();
    for (const o of t.toArray()) {
      const h = o.get("sceneMaterialID");
      n.find((c) => c.id === h) ? s.push(o) : e.removeMappingForSceneMaterial(h);
    }
    e.set("materialMappings", s);
  }
  static whenAllMaterialTexturesAreReady(e) {
    return new Promise((t, n) => {
      if (this.checkAllMaterialTextureReady(e))
        t();
      else {
        let s = setInterval(() => {
          this.checkAllMaterialTextureReady(e) && (clearInterval(s), t());
        }, 5);
      }
    });
  }
  static whenTextureIsReadyAsync(e) {
    return new Promise((t, n) => {
      if (e.isReady())
        t();
      else {
        let s = setInterval(() => {
          e.isReady() && (clearInterval(s), e instanceof BABYLON.ProceduralTexture && e.getEffect(), t());
        }, 5);
      }
    });
  }
  static whenMeshMaterialIsReady(e) {
    return new Promise((t, n) => {
      let s = setInterval(() => {
        (!e.material || e.material.isReady(e)) && (clearInterval(s), t());
      }, 5);
    });
  }
  static whenMaterialIsReadyForSubMeshAsync(e, t, n) {
    return new Promise((s, o) => {
      if (e.isReadyForSubMesh(t, n))
        Logger.info(`Material ${e.name} ready`), s();
      else {
        Logger.info(`Material ${e.name} NOT ready`);
        let h = setInterval(() => {
          e.isReadyForSubMesh(t, n) && (!t.material || t.material != e || t.material.isReady(t)) && (Logger.info(`Material ${e.name} ready`), clearInterval(h), s());
        }, 5);
      }
    });
  }
  static getMeshGeometry(e) {
    if (e.geometry)
      return e.geometry;
    const n = e.getScene().getGeometries();
    for (let s = 0; s < n.length; s++) {
      const o = n[s];
      if (o.meshes.find((h) => h === e))
        return o;
    }
    return null;
  }
  static checkMeshIsReady(e) {
    if (e instanceof BABYLON.Mesh) {
      if (e._checkDelayState(), e.delayLoadState === BABYLON.Constants.DELAYLOADSTATE_NOTLOADED)
        return !1;
      if (!e.geometry) {
        const n = e.getScene().getGeometries();
        for (let s = 0; s < n.length; s++) {
          const o = n[s];
          if (o.meshes.find((h) => h === e) && !o.isReady())
            return !1;
        }
      }
      if (e.geometry && !e.geometry.isReady())
        return !1;
      for (let t = 0; t < e.getChildMeshes().length; t++) {
        const n = e.getChildMeshes()[t];
        if (!this.checkMeshIsReady(n))
          return !1;
      }
    }
    return e.isReady(!0);
  }
  static checkAllMeshesAreReady(e) {
    let t = !0;
    for (let n = 0; n < e.length; n++)
      this.checkMeshIsReady(e[n]) || (t = !1);
    return t;
  }
  static whenAllMeshesAreReadyAsync(e) {
    return new Promise((t, n) => {
      if (this.checkAllMeshesAreReady(e))
        t();
      else {
        let s = setInterval(() => {
          this.checkAllMeshesAreReady(e) && (clearInterval(s), t());
        }, 5);
      }
    });
  }
  static async whenAllVisibleMeshesAreReadyAsync(e) {
    await this.whenAllMeshesAreReadyAsync(e);
  }
  static whenMeshIsReadyAsync(e) {
    return new Promise((t, n) => {
      if (this.checkMeshIsReady(e))
        t();
      else {
        let s = setInterval(() => {
          this.checkMeshIsReady(e) && (clearInterval(s), t());
        }, 100);
      }
    });
  }
  static visibleMeshesRequireDelayedLoading(e) {
    const t = e.meshes.filter((n) => n.isVisible);
    for (let n = 0; n < t.length; n++)
      if (this.meshRequiresDelayedLoading(t[n]))
        return !0;
    return !1;
  }
  static meshRequiresDelayedLoading(e) {
    if (e instanceof BABYLON.Mesh) {
      if (e.delayLoadState === BABYLON.Constants.DELAYLOADSTATE_NOTLOADED || e.delayLoadState === BABYLON.Constants.DELAYLOADSTATE_LOADING)
        return !0;
      const t = Mn.getMeshGeometry(e);
      if (t && (t.delayLoadState === BABYLON.Constants.DELAYLOADSTATE_LOADING || t.delayLoadState === BABYLON.Constants.DELAYLOADSTATE_NOTLOADED))
        return !0;
    }
    return !1;
  }
  materialRequiresDelayedLoading(e) {
    return this._scene.getMaterialByID(e) ? !1 : !!(this._scene.metadata && this._scene.metadata.delayedMaterials && this._scene.metadata.delayedMaterials.hasOwnProperty(e) || this._scene.metadata && this._scene.metadata.offloadedMaterials && this._scene.metadata.offloadedMaterials.hasOwnProperty(e));
  }
  /**
   * Recupera il token di autenticazione con strategia di fallback
   * @returns Il token di autenticazione o null se non trovato
   */
  getAuthToken() {
    if (this._authorizationToken && this._authorizationToken.trim() !== "")
      return this._authorizationToken;
    if (window.token && typeof window.token == "string" && window.token.trim() !== "")
      return window.token;
    try {
      console.log("strategia cookie");
      const e = document.cookie.split(";");
      for (let t of e) {
        const [n, s] = t.trim().split("=");
        if (n === "zakeke_token" && s && s.trim() !== "")
          return decodeURIComponent(s);
      }
    } catch (e) {
      console.warn("Error accessing cookies for zakeke_token:", e);
    }
    try {
      if (this._scene && this._scene.metadata && this._scene.metadata.viewer) {
        const e = this._scene.metadata.viewer;
        if (e._authorizationToken && typeof e._authorizationToken == "string" && e._authorizationToken.trim() !== "")
          return e._authorizationToken;
      }
      if (window.sceneEditor && window.sceneEditor._authorizationToken) {
        const e = window.sceneEditor._authorizationToken;
        if (e && typeof e == "string" && e.trim() !== "")
          return e;
      }
      if (window.sceneViewer && window.sceneViewer._authorizationToken) {
        const e = window.sceneViewer._authorizationToken;
        if (e && typeof e == "string" && e.trim() !== "")
          return e;
      }
    } catch (e) {
      console.warn("Error accessing viewer/editor token:", e);
    }
    if (typeof MPlaza < "u" && MPlaza.UserIdentity)
      try {
        if (window.userIdentity && typeof window.userIdentity.get == "function") {
          const e = window.userIdentity.get("token");
          if (e && typeof e == "string" && e.trim() !== "")
            return e;
        }
      } catch (e) {
        console.warn("Error accessing MPlaza.UserIdentity token:", e);
      }
    if (this._scene.metadata && this._scene.metadata.authToken) {
      const e = this._scene.metadata.authToken;
      if (e && typeof e == "string" && e.trim() !== "")
        return e;
    }
    if (typeof Zakeke < "u" && Zakeke.config)
      try {
        const e = Zakeke.config;
        if (e.authToken && typeof e.authToken == "string" && e.authToken.trim() !== "")
          return e.authToken;
        if (e.token && typeof e.token == "string" && e.token.trim() !== "")
          return e.token;
      } catch (e) {
        console.warn("Error accessing Zakeke.config token:", e);
      }
    try {
      const e = localStorage.getItem("authToken") || localStorage.getItem("token") || localStorage.getItem("zakeke_token");
      if (e && e.trim() !== "")
        return e;
    } catch (e) {
      console.warn("Error accessing localStorage token:", e);
    }
    try {
      const e = sessionStorage.getItem("authToken") || sessionStorage.getItem("token") || sessionStorage.getItem("zakeke_token");
      if (e && e.trim() !== "")
        return e;
    } catch (e) {
      console.warn("Error accessing sessionStorage token:", e);
    }
    return console.warn("No authentication token found in any fallback strategy"), null;
  }
  init() {
    this._onPrePointerObservableObserver = this._scene.onPrePointerObservable.add((e) => {
      if (e.type === BABYLON.PointerEventTypes.POINTERDOWN) {
        this._isPointerDown = !0;
        return;
      }
      e.type === BABYLON.PointerEventTypes.POINTERUP && (this._isPointerDown = !1);
    });
  }
  dispose() {
    this._scene && this._onPrePointerObservableObserver && this._scene.onPrePointerObservable.remove(this._onPrePointerObservableObserver), this._camera && this._minZObserver && (this._camera.onAfterCheckInputsObservable.remove(this._minZObserver), this._minZObserver = null);
  }
  switchFullScreen(e) {
    document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement ? this.quitFullscreen(e || this._canvas) : this.launchFullscreen(e || this._canvas), this._canvas && (this._canvas.width = document.body.clientWidth, this._canvas.height = document.body.clientHeight, this.adjustCamera(void 0, !0, !0, !1));
  }
  quitFullscreen(e) {
    let t = document.exitFullscreen || document.webkitExitFullscreen || document.msExitFullscreen || document.mozCancelFullScreen;
    t && t.call(document);
  }
  launchFullscreen(e) {
    let t = e.requestFullscreen || e.webkitRequestFullscreen || e.msRequestFullscreen || e.mozRequestFullScreen;
    t && t.call(e);
  }
  getMeshHierarchySize(e) {
    let t = e.getHierarchyBoundingVectors(!0);
    return t.max.subtract(t.min);
  }
  getMeshHierarchyCenter(e) {
    const t = e.getHierarchyBoundingVectors(!0), n = t.max.subtract(t.min);
    return t.min.add(n.scale(0.5));
  }
  getSceneBoundingInfo() {
    if (!this._scene)
      return null;
    const e = this.getWorldExtends();
    return e ? new BABYLON.BoundingInfo(e.min, e.max) : null;
  }
  setupShadows(e) {
    var fe, X, W, je, ke, Ye, pt, Le, $e, ce, ht, De, ft, Yt, We, It, rt;
    if (!e)
      return;
    const t = (fe = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : fe.get("enableShadows");
    t != null && (this.enableShadows = t), this.areShadowVisible || (this.enableShadows = !1);
    const n = (X = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : X.get("shadowMapSize"), s = (W = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : W.get("contactHardeningUVRatio"), o = (je = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : je.get("useContactHardeningShadow"), h = (ke = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : ke.get("useBlurCloseExponentialShadowMap"), c = (Ye = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : Ye.get("usePercentageCloserFiltering"), _ = (pt = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : pt.get("usePoissonSampling"), x = (Le = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : Le.get("useKernelBlur"), B = ($e = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : $e.get("blurBoxOffset"), P = (ce = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : ce.get("blurScale"), U = (ht = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : ht.get("blurKernel"), M = (De = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : De.get("depthScale"), Z = (ft = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : ft.get("shadowDarkness"), F = (Yt = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : Yt.get("shadowMinZ"), Q = (We = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : We.get("shadowMaxZ");
    if (!this.enableShadows) {
      const tt = (It = this._scene) == null ? void 0 : It.getMeshByName("shadowGround");
      tt && tt.dispose();
      const Kt = (rt = this._scene) == null ? void 0 : rt.getMaterialByName("shadowMaterial");
      Kt && Kt.dispose();
      const qt = this._scene.getLightByName("shadowDirectionalLight");
      qt && qt.dispose();
      return;
    }
    if (!this._scene)
      throw new Error("Scene is not defined");
    const D = this._scene.getLightByName("shadowDirectionalLight"), te = new BABYLON.Vector3(0, -2, 0), ee = D ?? new BABYLON.DirectionalLight("shadowDirectionalLight", te, this._scene);
    ee.intensity = 0, ee.shadowMinZ = F ?? void 0, ee.shadowMaxZ = Q ?? void 0, Mn._shadowGenerator = new BABYLON.ShadowGenerator(Number(n), ee), Mn._shadowGenerator.usePoissonSampling = !!_, Mn._shadowGenerator.usePercentageCloserFiltering = !!c, Mn._shadowGenerator.useBlurCloseExponentialShadowMap = !!h, Mn._shadowGenerator.useKernelBlur = !!x, Mn._shadowGenerator.blurBoxOffset = Number(B), Mn._shadowGenerator.blurScale = Number(P), Mn._shadowGenerator.blurKernel = Number(U), Mn._shadowGenerator.depthScale = Number(M), Mn._shadowGenerator.setDarkness(Number(Z)), Mn._shadowGenerator.useContactHardeningShadow = !!o, Mn._shadowGenerator.contactHardeningLightSizeUVRatio = Number(s), Mn._shadowGenerator.transparencyShadow = !0, Mn._shadowGenerator.enableSoftTransparentShadow = !0;
    const le = Mn._shadowGenerator.getShadowMap();
    this._scene.meshes.forEach((tt) => {
      var Kt;
      (Kt = le == null ? void 0 : le.renderList) == null || Kt.push(tt);
    }), this.createGroundFromBoundingBox(e);
  }
  setShadowsVisibility(e) {
    Mn._shadowGenerator && (this.areShadowVisible = e);
  }
  pauseAllAnimations() {
    var e;
    this._scene && ((e = this._scene.animationGroups) == null || e.forEach((t) => t.pause()));
  }
  /**
   * Deprecated (keeping only for backwards-compat), use pauseAllAnimations instead or _scene
   * directly
   */
  stopAllAnimations() {
    this.pauseAllAnimations();
  }
  hasAnimations() {
    return this._scene ? this._scene.animationGroups.length > 0 : !1;
  }
  playAnimations() {
    this._scene && this.hasAnimations() && this._scene.animationGroups[0].play();
  }
  setupAnimations(e) {
    var _;
    const t = e == null ? void 0 : e.getAnimationsConfig(), n = !!(t != null && t.get("runAtStart")), s = !!(t != null && t.get("loop")), o = (t == null ? void 0 : t.get("speed")) || 1, h = (_ = this._scene) == null ? void 0 : _.animationGroups, c = h && this._scene.animationGroups.length > 0;
    if (h && h.forEach((x) => {
      x.stop(), x.reset();
    }), n && c) {
      const x = h[0];
      x.start(s, o, x.from, x.to, !1);
    }
  }
  createGroundFromBoundingBox(e) {
    var M, Z, F, Q, D, te, ee, le, fe;
    if (!e)
      return;
    const t = (M = this._scene) == null ? void 0 : M.getMeshByName("shadowGround");
    t && t.dispose();
    const n = (Z = this._scene) == null ? void 0 : Z.getMaterialByName("shadowMaterial");
    n && n.dispose();
    const s = (F = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : F.get("enableShadows");
    if (s != null && (this.enableShadows = s), !this.enableShadows) {
      console.log("Shadows are not enabled");
      return;
    }
    const o = this.getSceneBoundingInfo();
    if (!o || !o.boundingBox) {
      console.error("Cannot create ground: No bounding box information available.");
      return;
    }
    const h = (Q = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : Q.get("shadowHexColor"), c = (D = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : D.get("groundSizeMultiplierWidth"), _ = (te = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : te.get("groundSizeMultiplierLength"), x = o.boundingBox.minimumWorld, P = o.boundingBox.maximumWorld.subtract(x), U = x.add(P.scale(0.5));
    if (this._scene !== null) {
      const X = BABYLON.MeshBuilder.CreateGround(
        "shadowGround",
        {
          width: P.x * Number(c),
          height: P.z * Number(_)
        },
        this._scene
      );
      X.position = new BABYLON.Vector3(U.x, x.y, U.z), X.rotation.y = Math.PI;
      const W = new BABYLON.ShadowOnlyMaterial("bbmat", this._scene);
      X.material = W, X.receiveShadows = !0, X.material.shadowColor = BABYLON.Color3.FromHexString(
        String(h)
      ), X.metadata = { AR: !1, isRealMesh: !1 };
      const je = (ee = Mn._shadowGenerator) == null ? void 0 : ee.getShadowMap();
      Mn._shadowGenerator && je ? ((le = je.renderList) == null || le.push(X), X.receiveShadows = !0) : console.error("Failed to add ground mesh to shadow map render list.");
    } else
      console.error("Cannot create ground: Scene is null.");
    console.log("Shadow ground created"), (fe = this._scene) == null || fe.render();
  }
  userIsMoving() {
    return !this._camera || !(this._camera instanceof BABYLON.ArcRotateCamera) ? !1 : this._camera.inertialAlphaOffset !== 0 || this._camera.inertialBetaOffset !== 0 || this._camera.inertialRadiusOffset !== 0 || this._camera.inertialPanningX !== 0 || this._camera.inertialPanningY !== 0 || this._isPointerDown;
  }
  cameraIsMoving() {
    return !this._camera || !(this._camera instanceof BABYLON.ArcRotateCamera) ? !1 : this._camera.inertialAlphaOffset !== 0 || this._camera.inertialBetaOffset !== 0 || this._camera.inertialRadiusOffset !== 0 || this._camera.inertialPanningX !== 0 || this._camera.inertialPanningY !== 0;
  }
  cameraLimitsReached() {
    return !this._camera || !(this._camera instanceof BABYLON.ArcRotateCamera) ? !1 : this._camera.lowerRadiusLimit !== void 0 && this._camera.lowerRadiusLimit !== null && this._camera.radius === this._camera.lowerRadiusLimit || this._camera.upperRadiusLimit !== void 0 && this._camera.upperRadiusLimit !== null && this._camera.radius === this._camera.upperRadiusLimit;
  }
  restoreCameraState() {
    this._camera && this._camera.restoreState();
  }
  isTextureWithUrl(e) {
    return e && (e instanceof BABYLON.Texture || e instanceof BABYLON.CubeTexture || e instanceof BABYLON.HDRCubeTexture || e instanceof BABYLON.ColorGradingTexture || e instanceof BABYLON.EquiRectangularCubeTexture);
  }
  getTextureUrl(e) {
    if (e && (e instanceof BABYLON.Texture || e instanceof BABYLON.CubeTexture || e instanceof BABYLON.HDRCubeTexture || e instanceof BABYLON.ColorGradingTexture || e instanceof BABYLON.EquiRectangularCubeTexture)) {
      let t = e.url;
      if (e.getInternalTexture) {
        const n = e.getInternalTexture();
        n && n.url && (t = n.url);
      }
      return t;
    }
    return null;
  }
  isEditControl(e) {
    return e && (e.name == "EditoControl" || e.metadata && e.metadata.isEditControl);
  }
  isRealMesh(e) {
    return !(this.isEditControl(e) || e.metadata && (e.metadata.boundingBox || e.metadata.isAxis || e.metadata.isGround || e.metadata.isEnvironmentNode || e.metadata.hasOwnProperty("isRealMesh") && !e.metadata.isRealMesh));
  }
  meshFineTuningSettings(e) {
    return e.metadata && e.metadata.hasOwnProperty("tryOnFineTuningSettings") && e.metadata.tryOnFineTuningSettings ? e.metadata.tryOnFineTuningSettings : null;
  }
  meshHasParent(e, t) {
    if (this._scene) {
      let n = this._scene.getMeshById(e);
      if (n)
        for (; n.parent; ) {
          if (n.parent.id === t)
            return !0;
          n = n.parent;
        }
    }
    return !1;
  }
  countSceneMeshes() {
    let e = 0;
    return this._scene && this._scene.meshes.forEach((t) => {
      this.isRealMesh(t) && e++;
    }), e;
  }
  sceneHasRealMeshes() {
    for (let e = 0; e < this._scene.meshes.length; e++)
      if (this.isRealMesh(this._scene.meshes[e]))
        return !0;
    return !1;
  }
  getSceneMeshes() {
    const e = [];
    return this._scene && this._scene.meshes.forEach((t) => {
      this.isRealMesh(t) && e.push(t);
    }), e;
  }
  getSceneMeshesByName(e) {
    let t = [];
    if (this._scene) {
      const s = function(o) {
        return o.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      };
      if (e) {
        var n = new RegExp(s(e).replace(/\\\*/g, ".*"), "i");
        for (let o = 0; o < this._scene.meshes.length; o++) {
          const h = this._scene.meshes[o];
          this.isRealMesh(h) && h.name && n.test(h.name) && t.push(h);
        }
      }
    }
    return t;
  }
  isVisibleMesh(e) {
    return this.isRealMesh(e) && e.isVisible;
  }
  getVisibleMeshes() {
    const e = [];
    return this._scene.meshes.forEach((t) => {
      this.isVisibleMesh(t) && e.push(t);
    }), e;
  }
  getInvisibleMeshes() {
    const e = [];
    return this._scene.meshes.forEach((t) => {
      this.isRealMesh(t) && !t.isVisible && e.push(t);
    }), e;
  }
  getSubMesh(e, t) {
    return e.subMeshes && e.subMeshes.length > 0 && t >= 0 && t < e.subMeshes.length ? e.subMeshes[t] : null;
  }
  getMeshHierarchy(e) {
    const t = [];
    let n = this._scene.getMeshById(e);
    if (!n)
      return t;
    let s = (o) => {
      t.push(o);
      let h = o.getChildMeshes(!0);
      for (let c = 0; c < h.length; c++)
        s(h[c]);
    };
    return s(n), t;
  }
  getTryOnMeshHierarchy(e) {
    const t = [];
    let n = this._scene.getMeshById(e);
    if (!n)
      return t;
    let s = (o) => {
      t.push(o);
      let h = o.getChildMeshes(!0);
      for (const c of h)
        (this.isVisibleCanvasMesh(c) || this.isVisibleTryOnMesh(c)) && s(c);
    };
    return s(n), t;
  }
  isVisibleCanvasMesh(e) {
    return this.isCanvasMesh(e) && e.isVisible;
  }
  isCanvasMesh(e) {
    return !e || !e.metadata ? !1 : e.metadata.hasOwnProperty("iscanvasMesh") && typeof e.metadata.iscanvasMesh == "boolean" ? e.metadata.iscanvasMesh : !1;
  }
  isAREnabledForMesh(e) {
    return e ? !e.metadata || e.metadata.AR === void 0 || e.metadata.AR === null || typeof e.metadata.AR != "boolean" ? !0 : e.metadata.AR : !1;
  }
  isTryOnEnabledForMesh(e) {
    return e ? !e.metadata || e.metadata.TryOn === void 0 || e.metadata.TryOn === null || typeof e.metadata.TryOn != "boolean" ? !0 : e.metadata.TryOn : !1;
  }
  isVisibleTryOnMesh(e) {
    return this.isTryOnEnabledForMesh(e) && this.isVisibleMesh(e);
  }
  getMeshesForAR() {
    const e = [];
    return this._scene && this._scene.meshes.forEach((t) => {
      (this.isRealMesh(t) || this.isCanvasMesh(t)) && t.isVisible && this.isAREnabledForMesh(t) && e.push(t);
    }), e;
  }
  checkMaterialsForAR() {
    const e = this.getMeshesMaterials(this.getMeshesForAR());
    for (let t = 0; t < e.length; t++) {
      const n = e[t];
      if (!(n instanceof BABYLON.PBRMaterial) && !(n instanceof BABYLON.PBRMetallicRoughnessMaterial) && !(n instanceof BABYLON.StandardMaterial))
        return !1;
    }
    return !0;
  }
  getMeshesMaterials(e) {
    const t = [], n = [];
    for (let s = 0; s < e.length; s++) {
      let o = e[s];
      if (o.material)
        if (o.material instanceof BABYLON.MultiMaterial)
          for (let h = 0; h < o.material.subMaterials.length; h++) {
            let c = o.material.subMaterials[h];
            c && t.indexOf(c.id) === -1 && (n.push(c), t.push(c.id));
          }
        else
          t.indexOf(o.material.id) === -1 && (n.push(o.material), t.push(o.material.id));
    }
    return n;
  }
  getMeshMaterials(e) {
    const t = [];
    if (e && e.material)
      if (e.material instanceof BABYLON.MultiMaterial)
        for (let n = 0; n < e.material.subMaterials.length; n++) {
          let s = e.material.subMaterials[n];
          s && t.push(s);
        }
      else
        t.push(e.material);
    return t;
  }
  getHiddenMeshTotalVertices() {
    return this.getTotalVertices((e) => !e.isVisible);
  }
  getTotalVertices(e) {
    let t = 0;
    return this._scene && this._scene.meshes.forEach((n) => {
      this.isRealMesh(n) && (e && !e(n) || (t += n.getTotalVertices()));
    }), t;
  }
  getHiddenMeshTotalIndices() {
    return this.getTotalIndices((e) => !e.isVisible);
  }
  getTotalIndices(e) {
    let t = 0;
    return this._scene && this._scene.meshes.forEach((n) => {
      this.isRealMesh(n) && (e && !e(n) || (t += n.getTotalIndices()));
    }), t;
  }
  getAllMaterials() {
    const e = [];
    return this._scene && this._scene.materials.forEach((t) => {
      t.metadata && (t.metadata.isRealMaterial !== void 0 && !t.metadata.isRealMaterial || t.metadata.isEnvironmentNode !== void 0 && t.metadata.isEnvironmentNode) || t.id !== "groundMaterial" && t.id !== "default material" && e.push(t);
    }), e;
  }
  getMeshesUsingMaterial(e) {
    const t = [], n = this.getSceneMeshes();
    for (let s = 0; s < n.length; s++) {
      const o = n[s];
      this.isMeshUsingMaterial(o, e) && t.push(o);
    }
    return t;
  }
  isMeshUsingMaterial(e, t) {
    if (e.material) {
      if (e.material.id === t)
        return !0;
      if (e.material instanceof BABYLON.MultiMaterial)
        for (let n = 0; n < e.material.subMaterials.length; n++) {
          const s = e.material.subMaterials[n];
          if (s && s.id === t)
            return !0;
        }
    }
    return !1;
  }
  getAllUnusedMaterials() {
    const e = this.getAllMaterials(), t = [];
    for (let n = 0; n < e.length; n++) {
      const s = e[n];
      this.getMeshesUsingMaterial(s.id).length === 0 && t.push(s);
    }
    return t;
  }
  async getSceneScreenshotAsync(e, t) {
    if (!this._camera)
      return "";
    let n = { width: e, height: t };
    return await BABYLON.Tools.CreateScreenshotAsync(this._engine, this._camera, n, "image/png");
  }
  containsPBRMaterials() {
    if (this._scene) {
      for (let e = 0; e < this._scene.materials.length; e++)
        if (this._scene.materials[e] instanceof BABYLON.PBRBaseMaterial)
          return !0;
    }
    return !1;
  }
  getMeshesForTryOn() {
    const e = [];
    return this._scene && this._scene.meshes.forEach((t) => {
      (this.isRealMesh(t) || this.isCanvasMesh(t)) && t.isVisible && this.isTryOnEnabledForMesh(t) && e.push(t);
    }), e;
  }
  setupLights() {
    this._hemiLight = null, this._pointLight = null;
    let e = null, t = null;
    this._scene.lights.forEach((n) => {
      n instanceof BABYLON.HemisphericLight && (e === null && (e = n), n.id === this._defHemiLightID && (this._hemiLight = n)), n instanceof BABYLON.PointLight && (t === null && (t = n), n.id === this._defPointLightID && (this._pointLight = n));
    }), this._hemiLight === null && (e !== null ? this._hemiLight = e : (this._hemiLight = new BABYLON.HemisphericLight(
      "Default Hemispheric Light",
      BABYLON.Vector3.Up(),
      this._scene
    ), this._hemiLight.intensity = 0.5), this._hemiLight && (this._hemiLight.id = this._defHemiLightID)), this._pointLight === null && (t !== null ? this._pointLight = t : (this._pointLight = new BABYLON.PointLight(
      "Default Point Light",
      new BABYLON.Vector3(0, 5, 0),
      this._scene
    ), this._pointLight.intensity = 0.5), this._pointLight && (this._pointLight.id = this._defPointLightID));
  }
  setUpCustomLights(e) {
    Object.entries(e).forEach((t) => {
      const n = t[0], s = t[1].position, o = t[1].general.intensity, h = t[1].general.visible, c = {
        position: s,
        intensity: o,
        visible: h
      };
      this.createOrUpdateLight(n, c);
    });
  }
  createOrUpdateLight(e, t) {
    const n = this._scene.getLightByName(e);
    if (n && (this._scene.removeLight(n), n.dispose()), !t.visible)
      return;
    const s = new BABYLON.Vector3(t.position.x, t.position.y, t.position.z);
    let o;
    e.match(/directional/i) ? (o = new BABYLON.DirectionalLight(e, s, this._scene), o.intensity = t.intensity, o.id = Zakeke.generateUUID()) : e.match(/pointLight/i) ? (o = new BABYLON.PointLight(e, s, this._scene), o.intensity = t.intensity, o.id = Zakeke.generateUUID()) : e.match(/hemisphere/i) && (o = new BABYLON.HemisphericLight(e, s, this._scene), o.intensity = t.intensity, o.id = Zakeke.generateUUID());
  }
  getDefaultHemisphericLight() {
    return this._hemiLight;
  }
  getDefaultPointLight() {
    return this._pointLight;
  }
  isDefaultLight(e) {
    return e.id == this._defHemiLightID || e.id == this._defPointLightID;
  }
  setUpCameraByOptions(e) {
    if (e && this._scene) {
      let t = this._scene.cameras.find((n) => n instanceof BABYLON.ArcRotateCamera);
      e && t instanceof BABYLON.ArcRotateCamera && (t.beta = e.beta ?? t.beta, t.alpha = e.alpha ?? t.alpha, t.fov = e.fov ?? t.fov);
    }
  }
  setupCamera() {
    if (this._scene) {
      let e = this._scene.cameras.find((t) => t instanceof BABYLON.ArcRotateCamera);
      e ? this._camera = e : (this._camera = new BABYLON.ArcRotateCamera("camera1", 0, 0, 0, BABYLON.Vector3.Zero(), this._scene), this._camera.setPosition(new BABYLON.Vector3(0, 3, -8))), this.setupCameraLimits(), this._canvas && this._camera.attachControl(this._canvas, !1);
    }
  }
  setCameraRadiusParameters(e) {
    if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      this._camera.lowerRadiusLimit = e * (this._zoomEnabled ? 0.01 : 1), this._camera.upperRadiusLimit = e * (this._zoomEnabled ? 3 : 1), this._camera.wheelPrecision = 100 / e, this._camera.pinchPrecision = 100 / e, this._camera.minZ = e * 0.01, this._camera.maxZ = e * 1e3, this._camera.speed = e * 0.2, this._camera.wheelDeltaPercentage = 0.01, this._camera.pinchDeltaPercentage = 6e-4, this._camera.panningSensibility = 0, this._camera.wheelPrecision = 100 / e, this._camera.panningAxis = BABYLON.Vector3.Zero(), this._camera.panningInertia = 0;
      const t = this._camera.inputs.attached.pointers;
      t && (t.multiTouchPanning = !1, t.multiTouchPanAndZoom = !1), this._camera.radius = e, this._minZObserver || (this._minZObserver = this._camera.onAfterCheckInputsObservable.add(() => {
        this._camera && this._camera instanceof BABYLON.ArcRotateCamera && (this._camera.minZ = Math.max(0.01, this._camera.radius * 0.01));
      }));
    }
  }
  removeCameraLimits() {
    this._camera && this._camera instanceof BABYLON.ArcRotateCamera && (this._camera.lowerRadiusLimit = null, this._camera.upperRadiusLimit = null, this._camera.minZ = 1, this._camera.maxZ = 1e4);
  }
  getWorldExtends() {
    return this._scene ? this._scene.getWorldExtends((e) => this.isRealMesh(e) && e.isVisible) : null;
  }
  getCameraWorldExtends() {
    let e = null;
    if (this._scene) {
      let t = this._cameraPivot;
      if (!t)
        for (let n = 0; n < this._scene.meshes.length; n++) {
          const s = this._scene.meshes[n];
          if (s.metadata && s.metadata.isCameraPivot !== void 0 && s.metadata.isCameraPivot) {
            t = s;
            break;
          }
        }
      t && (e = this._scene.getWorldExtends((n) => n === t || this.meshHasParent(n.id, t.id)));
    }
    return e || (e = this.getWorldExtends()), e;
  }
  /**
   * Configura i parametri di input touch della camera (panning, pinch-to-zoom, observer minZ).
   * NON dipende da worldExtends, quindi funziona sempre anche se le mesh sono appena
   * diventate visibili (es. dopo Show Object action) e i world extends non sono ancora validi.
   */
  configureCameraTouchInput() {
    if (!this._camera || !(this._camera instanceof BABYLON.ArcRotateCamera))
      return;
    this._camera.panningSensibility = 0, this._camera.panningAxis = BABYLON.Vector3.Zero(), this._camera.panningInertia = 0, this._camera.pinchDeltaPercentage = 6e-4, this._camera.wheelDeltaPercentage = 0.01;
    const e = this._camera.inputs.attached.pointers;
    e && (e.multiTouchPanning = !1, e.multiTouchPanAndZoom = !1), this._minZObserver || (this._minZObserver = this._camera.onAfterCheckInputsObservable.add(() => {
      this._camera && this._camera instanceof BABYLON.ArcRotateCamera && (this._camera.minZ = Math.max(0.01, this._camera.radius * 0.01));
    }));
  }
  setupCameraLimits(e) {
    if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      if (e == null) {
        let n = this.getCameraWorldExtends();
        n && (e = n);
      }
      if (!e)
        return;
      const t = e.max.subtract(e.min);
      if (isFinite(t.length())) {
        this.removeCameraLimits();
        const n = this.calculateCameraRadius(e);
        if (this.setCameraRadiusParameters(n), this._limitLowerRadius && this._scene.meshes.length && this._zoomEnabled) {
          this._camera.useFramingBehavior = !0;
          const s = this._camera.getBehaviorByName("Framing");
          s && s instanceof BABYLON.FramingBehavior && (s.elevationReturnTime = -1, this._minZoomPerc !== null && this._minZoomPerc !== void 0 && this._minZoomPerc > 0 && (this._camera.lowerRadiusLimit = n * this._minZoomPerc), this._maxZoomPerc !== null && this._maxZoomPerc !== void 0 && this._maxZoomPerc > 0 && (this._camera.upperRadiusLimit = n * this._maxZoomPerc));
        }
      }
    }
  }
  adjustCamera(e, t = !0, n = !0, s = !0, o = !1) {
    if (!this._camera || !(this._camera instanceof BABYLON.ArcRotateCamera))
      return;
    let h = this.getCameraWorldExtends();
    if (!h)
      return;
    const c = h.max.subtract(h.min);
    if (!isFinite(c.length()))
      return;
    const _ = h.min.add(c.scale(0.5));
    this.removeCameraLimits();
    const x = this.calculateCameraRadius(h);
    let B = this._camera.alpha;
    t || (B = -(Math.PI / 2), e && e === "gltf" && (B += Math.PI));
    let P = this._camera.beta;
    n || (P = Math.PI / 2 - 0.3);
    let U = _.clone(), M = h.min.y, Z = h.max.y, F = M + (Z - M) * this._positionScale;
    if (U.y = F, !s)
      this._camera.alpha = B, this._camera.beta = P, this._camera.radius = x, this._camera.target = U, this.setupCameraLimits(h);
    else {
      if (o) {
        const Q = this.calculateCameraRadius(h);
        this._camera.radius = Q;
      }
      this.animateCameraToFinalParamters(B, P, x, U, 2, () => {
        this.setupCameraLimits(h);
      });
    }
  }
  normalizeAngleOfView(e, t) {
    const n = BABYLON.Vector3.Zero(), s = new BABYLON.ArcRotateCamera("ghostCamera", e, t, 1, n, this._scene), o = s.position;
    return s.dispose(), this.computeCameraAngleOfView(n, o);
  }
  computeCameraAngleOfView(e, t) {
    const n = new BABYLON.ArcRotateCamera("ghostCamera", 0, 0, 0, e, this._scene);
    n.setPosition(t);
    const s = n.alpha, o = n.beta;
    return n.dispose(), {
      alpha: s,
      beta: o
    };
  }
  moveCamera(e, t) {
    var n = new BABYLON.ArcRotateCamera("ghostCamera", 0, 0, 0, e, this._scene);
    n.setPosition(t);
    var s = n.alpha, o = n.beta, h = n.radius;
    n.dispose(), this.moveCameraToFinalParameters(s, o, h, e), this.configureCameraTouchInput();
  }
  animateCamera(e, t, n, s) {
    var o = new BABYLON.ArcRotateCamera("ghostCamera", 0, 0, 0, e, this._scene);
    o.setPosition(t);
    var h = o.alpha, c = o.beta, _ = o.radius;
    o.dispose(), this.configureCameraTouchInput(), this.animateCameraToFinalParamters(h, c, _, e, n, s);
  }
  // riporta angle nel range -180, + 180
  wrapPi(e) {
    if (Math.abs(e) > Math.PI) {
      var t = 2 * Math.PI, n = Math.floor((e + Math.PI) * (1 / t));
      e -= n * t;
    }
    return e;
  }
  wrap2Pi(e) {
    let t = e % (Math.PI * 2);
    return t < 0 && (t += Math.PI * 2), t;
  }
  zoomIn() {
    this.zoom(0.85);
  }
  zoomOut() {
    this.zoom(1.15);
  }
  zoom(e) {
    if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      let n = this._camera.radius, s = this._camera.lowerRadiusLimit !== null && this._camera.lowerRadiusLimit !== void 0 ? this._camera.lowerRadiusLimit : 0, o = Math.max(0, s), h = Number.MAX_VALUE;
      this._camera.upperRadiusLimit != null && (h = this._camera.upperRadiusLimit);
      var t = Math.max(o, Math.min(h, n * e));
      t !== n && this.animateCameraToFinalParamters(
        this._camera.alpha,
        this._camera.beta,
        t,
        this._camera.target,
        0.5
      );
    }
  }
  moveCameraToFinalParameters(e, t, n, s) {
    !this._camera || !(this._camera instanceof BABYLON.ArcRotateCamera) || (this._camera.target = s, this._camera.alpha = e, this._camera.beta = t, this._camera.radius = n);
  }
  animateCameraToFinalParamters(e, t, n, s, o, h) {
    if (!this._camera || !(this._camera instanceof BABYLON.ArcRotateCamera))
      return;
    let c = this._camera.radius, _ = () => {
      if (this._camera) {
        this._scene.stopAnimation(this._camera);
        for (let Le = 0; Le < this._camera.animations.length; Le++)
          this._camera.animations[Le], this._camera.animations.splice(Le--, 1);
      }
    };
    _();
    let x = this._camera.alpha;
    !this._camera.lowerAlphaLimit && !this._camera.upperAlphaLimit && (x = this.wrap2Pi(this._camera.alpha));
    let B = this._camera.beta;
    !this._camera.lowerBetaLimit && !this._camera.upperBetaLimit && (B = this.wrap2Pi(this._camera.beta));
    let P = isFinite(e) ? this.wrapPi(e) : x;
    Math.abs(x - P) > Math.PI && (P += Math.PI * 2);
    let U = isFinite(t) ? this.wrapPi(t) : B;
    Math.abs(B - U) > Math.PI && (U += Math.PI * 2);
    let M = 2;
    o && typeof o == "number" && o > 0 && (M = o);
    let Z = 60, F = Math.floor(M * Z), te = this._camera.target.subtract(s).length() / this._camera.radius, ee = [], le = new BABYLON.CubicEase();
    le.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEINOUT);
    let fe = null;
    this._camera.target !== s && (te >= 5e-3 ? (fe = new BABYLON.Animation(
      "camTargetAnimation",
      "target",
      Z,
      BABYLON.Animation.ANIMATIONTYPE_VECTOR3,
      BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE
    ), ee = [
      {
        frame: 0,
        value: this._camera.target
      },
      {
        frame: F,
        value: s
      }
    ], fe.setKeys(ee), fe.setEasingFunction(le)) : this._camera.target = s);
    let X = null;
    x !== P && (X = new BABYLON.Animation(
      "camAlphaAnimation",
      "alpha",
      Z,
      BABYLON.Animation.ANIMATIONTYPE_FLOAT,
      BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE
    ), ee = [
      {
        frame: 0,
        value: x
      },
      {
        frame: F,
        value: P
      }
    ], X.setKeys(ee), X.setEasingFunction(le));
    let W = null;
    B !== U && (W = new BABYLON.Animation(
      "camBetaAnimation",
      "beta",
      Z,
      BABYLON.Animation.ANIMATIONTYPE_FLOAT,
      BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE
    ), ee = [
      {
        frame: 0,
        value: B
      },
      {
        frame: F,
        value: U
      }
    ], W.setKeys(ee), W.setEasingFunction(le));
    let je = Math.abs(this._camera.radius - n) / this._camera.radius, ke = null;
    this._camera.radius !== n && (je >= 5e-3 ? (ke = new BABYLON.Animation(
      "camRadiusAnimation",
      "radius",
      Z,
      BABYLON.Animation.ANIMATIONTYPE_FLOAT,
      BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE
    ), ee = [
      {
        frame: 0,
        value: c
      },
      {
        frame: F,
        value: n
      }
    ], ke.setKeys(ee), ke.setEasingFunction(le)) : this._camera.radius = n);
    let Ye = this._camera.animations.length;
    if (fe && this._camera.animations.push(fe), X && this._camera.animations.push(X), W && this._camera.animations.push(W), ke && this._camera.animations.push(ke), this._camera.animations.length > Ye) {
      var pt = this._scene.beginAnimation(this._camera, 0, F, !1, 1);
      pt.onAnimationEnd = () => {
        _(), this.setupShaderMaterialsCameraPosition(), h && h();
      };
    } else
      h && h();
  }
  //Returns the frustum slope based on the canvas ratio and camera FOV
  //returns The frustum slope represented as a Vector2 with X and Y slopes
  getFrustumSlope() {
    let e = this._camera;
    if (!e)
      return BABYLON.Vector2.Zero();
    let n = this._engine.getAspectRatio(e), s = Math.tan(e.fov / 2), o = s * n;
    return new BABYLON.Vector2(o, s);
  }
  calculateCameraRadius(e) {
    if (e == null) {
      let n = this.getCameraWorldExtends();
      n && (e = n);
    }
    if (!e)
      return 1;
    var t = this.calculateLowerRadiusFromModelBoundingSphere(e.min, e.max);
    return isFinite(t) || (t = 1), t + (this._cameraZoom ?? 0);
  }
  // Calculates the lowest radius for the camera based on the bounding box of the mesh.
  calculateLowerRadiusFromModelBoundingSphere(e, t) {
    const s = t.subtract(e).length(), o = this.getFrustumSlope(), h = s * 0.5, c = this._radiusScale, _ = h * c, x = _ * Math.sqrt(1 + 1 / (o.x * o.x)), B = _ * Math.sqrt(1 + 1 / (o.y * o.y));
    let P = Math.max(x, B);
    var U = this._camera;
    return !U || !(U instanceof BABYLON.ArcRotateCamera) ? 0 : (U.upperRadiusLimit && (P = P > U.upperRadiusLimit ? U.upperRadiusLimit : P), P);
  }
  getWorldCenter(e) {
    if (e == null) {
      let s = this.getCameraWorldExtends();
      s && (e = s);
    }
    if (!e)
      return null;
    let t = e.max.subtract(e.min);
    return isFinite(t.length()) ? e.min.add(t.scale(0.5)) : null;
  }
  getCameraWorldCenter(e) {
    if (e == null) {
      let s = this.getCameraWorldExtends();
      s && (e = s);
    }
    if (!e)
      return null;
    let t = e.max.subtract(e.min);
    return isFinite(t.length()) ? e.min.add(t.scale(0.5)) : null;
  }
  getCameraRadius(e) {
    if (e == null) {
      let s = this.getCameraWorldExtends();
      s && (e = s);
    }
    if (!e)
      return null;
    let t = e.max.subtract(e.min);
    return isFinite(t.length()) ? this.calculateCameraRadius(e) : null;
  }
  setCameraLimitLowerRadius(e, t = !1) {
    if (this._limitLowerRadius = e, this.setupCameraLimits(), t && this._camera && this._camera instanceof BABYLON.ArcRotateCamera && this.sceneHasRealMeshes()) {
      let n = this._camera.target.clone(), s = this.getCameraWorldExtends();
      if (s) {
        let o = s.min.y, h = s.max.y, c = o + (h - o) * this._positionScale;
        n.y = c, this.animateCameraToFinalParamters(
          this._camera.alpha,
          this._camera.beta,
          this._camera.radius,
          n,
          0.5
        );
      }
    }
  }
  setCameraPositionScale(e, t = !1) {
    if (this._positionScale = e, t && this._camera && this._camera instanceof BABYLON.ArcRotateCamera && this.sceneHasRealMeshes()) {
      var n = this._camera.target.clone(), s = this.getCameraWorldExtends();
      if (s) {
        var o = s.min.y, h = s.max.y, c = o + (h - o) * this._positionScale;
        n.y = c, this.animateCameraToFinalParamters(
          this._camera.alpha,
          this._camera.beta,
          this._camera.radius,
          n,
          0.5
        );
      }
    }
  }
  setCameraPositionFOV(e) {
    this._camera && this._camera instanceof BABYLON.ArcRotateCamera && (this._camera.fov = e);
  }
  getCameraPivot() {
    return this._cameraPivot;
  }
  setCameraPivot(e) {
    this._cameraPivot = e, this.adjustCamera(void 0, !0, !0, !0);
  }
  setZoomEnabled(e) {
    this._zoomEnabled = e, this.adjustCamera(void 0, !0, !0, !0);
  }
  setMinZoomPerc(e) {
    const t = e ?? null;
    t !== this._minZoomPerc && (this._minZoomPerc = t, this.adjustCamera(void 0, !0, !0, !1));
  }
  setMaxZoomPerc(e) {
    const t = e ?? null;
    t !== this._maxZoomPerc && (this._maxZoomPerc = t, this.adjustCamera(void 0, !0, !0, !1));
  }
  setCameraZoom(e) {
    e != null && this._camera && this._camera instanceof BABYLON.ArcRotateCamera && (this._cameraZoom = -(e / 10), this.adjustCamera(void 0, !0, !0, !1));
  }
  setCameraAlphaLimits(e, t) {
    if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      const n = this.normalizeAngleOfView(this._camera.alpha, this._camera.beta).alpha;
      this.setCameraLowerAlphaLimit(e), this.setCameraUpperAlphaLimit(t), this._camera.alpha = n;
    }
  }
  setCameraLowerAlphaLimit(e) {
    if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera)
      if (e == null)
        this._camera.lowerAlphaLimit = null;
      else {
        let t = this.normalizeAngleOfView(e, this._camera.beta).alpha;
        this._camera.upperAlphaLimit && t > this._camera.upperAlphaLimit && (this._camera.upperAlphaLimit += Math.PI * 2), this._camera.lowerAlphaLimit = t;
      }
  }
  setCameraUpperAlphaLimit(e) {
    if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera)
      if (e == null)
        this._camera.upperAlphaLimit = null;
      else {
        let t = this.normalizeAngleOfView(e, this._camera.beta).alpha;
        this._camera.lowerAlphaLimit && t < this._camera.lowerAlphaLimit && (t += Math.PI * 2), this._camera.upperAlphaLimit = t;
      }
  }
  setCameraLowerBetaLimit(e) {
    if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera)
      if (e == null)
        this._camera.lowerBetaLimit = 0.01;
      else {
        let t = this.normalizeAngleOfView(this._camera.alpha, e).beta;
        this._camera.upperBetaLimit && t > this._camera.upperBetaLimit && (this._camera.upperBetaLimit += Math.PI * 2), this._camera.lowerBetaLimit = t;
      }
  }
  setCameraUpperBetaLimit(e) {
    if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera)
      if (e == null)
        this._camera.upperBetaLimit = Math.PI - 0.01;
      else {
        let t = this.normalizeAngleOfView(this._camera.alpha, e).beta;
        this._camera.lowerBetaLimit && t < this._camera.lowerBetaLimit && (this._camera.lowerBetaLimit -= Math.PI * 2), this._camera.upperBetaLimit = t;
      }
  }
  setCameraBetaLimits(e, t) {
    if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      const n = this.normalizeAngleOfView(this._camera.alpha, this._camera.beta).beta;
      this.setCameraLowerBetaLimit(e), this.setCameraUpperBetaLimit(t), this._camera.beta = n;
    }
  }
  zoomOnMesh(e) {
    if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      this._camera.useFramingBehavior = !0;
      const t = this._camera.getBehaviorByName("Framing");
      t && t instanceof BABYLON.FramingBehavior && (t.framingTime = 0, t.elevationReturnTime = -1, t.radiusScale = this._radiusScale, t.positionScale = this._positionScale, t.zoomOnMeshHierarchy(e));
    }
  }
  async takeScreenshotAsync(e, t) {
    if (!this._camera)
      return "";
    const n = { width: e, height: t };
    return await BABYLON.Tools.CreateScreenshotAsync(this._engine, this._camera, n, "image/png");
  }
  async takeContentScreenshotAsync(e, t, n) {
    if (!this._camera)
      return "";
    var s = this._scene.clearColor.clone();
    this._scene.clearColor = n || new BABYLON.Color4(0, 0, 0, 0), this._scene.render();
    let o = { width: e, height: t };
    const h = BABYLON.Tools.CreateScreenshotAsync(this._engine, this._camera, o, "image/png");
    this._scene.render(), this._scene.getEngine().endFrame();
    const c = await h;
    return this._scene.clearColor = s, c;
  }
  async takeMaterialScreenshotAsync(e, t, n) {
    let s = this._scene.getMaterialByID(e);
    if (!s)
      return "";
    let o = this.getVisibleMeshes();
    for (let U = 0; U < o.length; U++) {
      var h = o[U];
      h.isVisible = !1;
    }
    let c = this._scene.clearColor.clone();
    this._scene.clearColor = new BABYLON.Color4(0, 0, 0, 0);
    let _ = BABYLON.Mesh.CreateSphere("temp_sphere", 32, 2, this._scene);
    _.material = s;
    let x = new BABYLON.ArcRotateCamera("temp_camera", 0, 0, 0, BABYLON.Vector3.Zero(), this._scene);
    x.setPosition(new BABYLON.Vector3(0, 0, -4)), this._scene.activeCamera = x, this._scene.render();
    let B = { width: t, height: n }, P = await BABYLON.Tools.CreateScreenshotAsync(this._engine, x, B, "image/png");
    this._scene.clearColor = c, _.dispose();
    for (let U = 0; U < o.length; U++) {
      var h = o[U];
      h.isVisible = !0;
    }
    return this._scene.activeCamera = this._camera, x.dispose(), P;
  }
  getScenePBRMaterials() {
    const e = [];
    return this._scene && this._scene.materials.forEach((t) => {
      t instanceof BABYLON.PBRBaseMaterial && e.push(t);
    }), e;
  }
  resetPBRMaterialsImageProcessingConfiguration() {
    var e = this.getScenePBRMaterials();
    e.forEach((t) => {
      this.adjustPBRMaterialImageProcessingConfiguration(t);
    });
  }
  adjustPBRMaterialImageProcessingConfiguration(e) {
    e instanceof BABYLON.PBRMaterial && e.imageProcessingConfiguration && (e.imageProcessingConfiguration.colorGradingWithGreenDepth = !1, e.imageProcessingConfiguration.colorGradingBGR = !1, e.imageProcessingConfiguration.exposure = 1, e.imageProcessingConfiguration.toneMappingEnabled = !1, e.imageProcessingConfiguration.contrast = 1);
  }
  animateMeshToFinalParameters(e, t, n, s, o, h = 2, c) {
    if (this._scene && e) {
      e.id;
      const B = () => {
        this._scene.stopAnimation(e);
        for (let le = 0; le < e.animations.length; le++)
          e.animations.splice(le--, 1);
      };
      B();
      const P = h, U = 60, M = Math.floor(P * U);
      let Z, F = null;
      e.position !== t && (F = new BABYLON.Animation(
        "positionAnimation",
        "position",
        U,
        BABYLON.Animation.ANIMATIONTYPE_VECTOR3,
        BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE
      ), Z = [
        {
          frame: 0,
          value: e.position
        },
        {
          frame: M,
          value: t
        }
      ], F.setKeys(Z));
      let Q = null, D = null;
      if (e.rotationQuaternion == null) {
        var _;
        n != null ? _ = n.clone() : _ = s.toEulerAngles().clone(), e.rotation != _ && (Q = new BABYLON.Animation(
          "eulerAnimation",
          "rotation",
          U,
          BABYLON.Animation.ANIMATIONTYPE_VECTOR3,
          BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE
        ), Z = [
          {
            frame: 0,
            value: e.rotation
          },
          {
            frame: M,
            value: _
          }
        ], Q.setKeys(Z));
      } else {
        let le;
        s != null ? le = s.clone() : (le = BABYLON.Quaternion.Identity(), le.copyFrom(BABYLON.Quaternion.RotationYawPitchRoll(n.y, n.x, n.z))), D = new BABYLON.Animation(
          "quaternionAnimation",
          "rotationQuaternion",
          U,
          BABYLON.Animation.ANIMATIONTYPE_QUATERNION,
          BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE
        ), Z = [
          {
            frame: 0,
            value: e.rotationQuaternion
          },
          {
            frame: M,
            value: le
          }
        ], D.setKeys(Z);
      }
      let te = null;
      e.scaling !== o && (te = new BABYLON.Animation(
        "scalingAnimation",
        "scaling",
        U,
        BABYLON.Animation.ANIMATIONTYPE_VECTOR3,
        BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE
      ), Z = [
        {
          frame: 0,
          value: e.scaling
        },
        {
          frame: M,
          value: o
        }
      ], te.setKeys(Z));
      let ee = e.animations.length;
      if (F && e.animations.push(F), Q && e.animations.push(Q), D && e.animations.push(D), te && e.animations.push(te), e.animations.length > ee) {
        var x = this._scene.beginAnimation(e, 0, M, !1, 1);
        x.onAnimationEnd = () => {
          B(), c && c();
        };
      }
    }
  }
  getMaterialsUsingTexture(e) {
    var t = this.getTextureMaterialsMap();
    return this._scene.materials.forEach((n) => {
      var s = this.getTexturesForMaterial(n);
      s.forEach((o) => {
        t.hasOwnProperty(o.uid) || (t[o.uid] = []), t[o.uid].push(n);
      });
    }), t.hasOwnProperty(e.uid) ? t[e.uid] : [];
  }
  getTextureMaterialsMap() {
    let e = {};
    return this._scene && this._scene.materials.forEach((t) => {
      var n = this.getTexturesForMaterial(t);
      n.forEach((s) => {
        e.hasOwnProperty(s.uid) || (e[s.uid] = []), e[s.uid].push(t);
      });
    }), e;
  }
  // Recupera tutte le texture di un materiale
  getTexturesForMaterial(e) {
    return e.getActiveTextures();
  }
  getTexturesExclusivelyForMaterial(e) {
    let t = this.getTexturesForMaterial(e), n = this.getTextureMaterialsMap();
    for (var s = 0; s < t.length; s++) {
      let h = t[s];
      var o = n.hasOwnProperty(h.uid) ? n[h.uid] : [];
      o.length > 1 && t.splice(s--, 1);
    }
    return t;
  }
  getStandardMaterialTextures(e) {
    return e.getActiveTextures();
  }
  getPBRBaseSimpleMaterialTextures(e) {
    return e.getActiveTextures();
  }
  getPBRMaterialTextures(e) {
    return e.getActiveTextures();
  }
  getPBRMetallicRoughnessMaterialTextures(e) {
    return e.getActiveTextures();
  }
  getPBRSpecularGlossinessMaterialTextures(e) {
    return e.getActiveTextures();
  }
  getNewPBRMaterialTextures(e) {
    return e.getActiveTextures();
  }
  createMeshesFromSubMeshes(e) {
    let t = e.getChildMeshes(!0);
    for (let o = 0; o < t.length; o++)
      this.createMeshesFromSubMeshes(t[o]);
    let n = [];
    if (e.subMeshes && e.subMeshes.length > 0)
      for (let o = 0; o < e.subMeshes.length; o++) {
        let h = this.createMeshFromSubMesh(e, o);
        h && n.push(h);
      }
    let s = new BABYLON.VertexData();
    s.positions = [], s.indices = [], s.normals = [], s.uvs = [], s.uvs2 = [], s.applyToMesh(e, !0), e.subMeshes = [], e.material = null, n.forEach((o) => {
      o.parent = e;
    });
  }
  createMeshFromSubMesh(e, t, n) {
    let s = null, o = e.subMeshes[t], h = e.getVerticesData(BABYLON.VertexBuffer.PositionKind), c = e.getVerticesData(BABYLON.VertexBuffer.NormalKind), _ = e.getIndices();
    if (h && c && _) {
      let B = h.slice(
        3 * o.verticesStart,
        3 * (o.verticesStart + o.verticesCount)
      ), P = c.slice(
        3 * o.verticesStart,
        3 * (o.verticesStart + o.verticesCount)
      ), U = _.slice(o.indexStart, o.indexStart + o.indexCount), M = null;
      if (e.isVerticesDataPresent(BABYLON.VertexBuffer.UVKind)) {
        let Q = e.getVerticesData(BABYLON.VertexBuffer.UVKind);
        Q && (M = Q.slice(2 * o.verticesStart, 2 * (o.verticesStart + o.verticesCount)));
      }
      var x = null;
      if (e.isVerticesDataPresent(BABYLON.VertexBuffer.UV2Kind)) {
        let Q = e.getVerticesData(BABYLON.VertexBuffer.UV2Kind);
        Q && (x = Q.slice(
          2 * o.verticesStart,
          2 * (o.verticesStart + o.verticesCount)
        ));
      }
      for (let Q = 0; Q < U.length; Q++)
        U[Q] -= o.verticesStart;
      let Z = new BABYLON.Mesh(n || e.name + "_part_" + o._id, this._scene), F = new BABYLON.VertexData();
      F.positions = B, F.normals = P, F.indices = U, M && (F.uvs = M), x && (F.uvs2 = x), F.applyToMesh(Z), e.material && (Z.material = e.material instanceof BABYLON.MultiMaterial ? e.material.subMaterials[o.materialIndex] : e.material);
    }
    return s;
  }
  getNextIncrementalName(e) {
    let t = e;
    if (e) {
      let c;
      for (var n = 0; this._scene.getMeshByName(t); ) {
        if (!c) {
          c = e;
          var s = e.lastIndexOf("_");
          if (s > 0) {
            var o = e.substring(s + 1), h = parseInt(o);
            h.toString() === o && (c = e.substring(0, s));
          }
        }
        n++, t = c + "_" + n;
      }
    }
    return t;
  }
  createBox(e, t) {
    let n = t || "Box";
    n = this.getNextIncrementalName(n);
    let s = BABYLON.Mesh.CreateBox(n, 5, this._scene);
    return s.id = Zakeke.generateUUID(), e && (s.parent = e), s;
  }
  createBoundingBox(e, t) {
    let n = t || "BoundingBox";
    n = this.getNextIncrementalName(n);
    const s = e ? e.getHierarchyBoundingVectors() : this.getWorldExtends();
    if (!s)
      return this.createBox(e, t);
    const o = s.min, h = s.max, c = new BABYLON.BoundingInfo(o, h), _ = h.subtract(o);
    if (!isFinite(_.length()))
      return this.createBox(e, t);
    const x = h.x - o.x, B = h.y - o.y, P = h.z - o.z, U = BABYLON.VertexData.CreateBox({ width: x, height: B, depth: P }), M = new BABYLON.Mesh(n, this._scene);
    return U.applyToMesh(M), M.position.copyFrom(c.boundingBox.centerWorld), M.refreshBoundingInfo(), e && e.parent && (M.parent = e.parent), M;
  }
  createSphere(e, t) {
    let n = t || "Sphere";
    n = this.getNextIncrementalName(n);
    const s = BABYLON.Mesh.CreateSphere(n, 30, 5, this._scene);
    return s.id = Zakeke.generateUUID(), e && (s.parent = e), s;
  }
  createPlane(e, t) {
    let n = t || "Plane";
    n = this.getNextIncrementalName(n);
    const s = BABYLON.Mesh.CreatePlane(n, 10, this._scene);
    return s.id = Zakeke.generateUUID(), e && (s.parent = e), s;
  }
  createDisc(e, t) {
    let n = t || "Disc";
    n = this.getNextIncrementalName(n);
    const s = BABYLON.MeshBuilder.CreateDisc(n, { tessellation: 70 }, this._scene);
    return s.id = Zakeke.generateUUID(), e && (s.parent = e), s;
  }
  createCylinder(e, t) {
    let n = t || "Cylinder";
    n = this.getNextIncrementalName(n);
    const s = BABYLON.Mesh.CreateCylinder(n, 6, 6, 6, 30, 1, this._scene, !1);
    return s.id = Zakeke.generateUUID(), e && (s.parent = e), s;
  }
  createTorus(e, t) {
    let n = t || "Torus";
    n = this.getNextIncrementalName(n);
    const s = BABYLON.Mesh.CreateTorus(n, 8, 1, 50, this._scene, !1);
    return s.id = Zakeke.generateUUID(), e && (s.parent = e), s;
  }
  createKnot(e, t) {
    let n = t || "Knot";
    n = this.getNextIncrementalName(n);
    const s = BABYLON.Mesh.CreateTorusKnot(n, 2, 0.5, 128, 64, 2, 3, this._scene);
    return s.id = Zakeke.generateUUID(), e && (s.parent = e), s;
  }
  createRibbon(e, t) {
    let n = t || "Ribbon";
    n = this.getNextIncrementalName(n);
    const s = function(_) {
      for (var x = [], B = -10; B < 10; B++)
        x.push(new BABYLON.Vector3(_, B, Math.sin(_ / 3) * 5 * Math.exp(-(B - _) * (B - _) / 60) + B / 3));
      return x;
    };
    for (var o = [], h = 0; h < 20; h++)
      o[h] = s(h);
    const c = BABYLON.Mesh.CreateRibbon("ribbon", o, !1, !1, 0, this._scene);
    return c.id = Zakeke.generateUUID(), e && (c.parent = e), c;
  }
  async createRoundedCubeAsync(e, t, n) {
    const s = ci.Shapes.RoundedCubeName, o = ci.Shapes.RootUrl, h = ci.Shapes.RoundedCubeFileName;
    let c = t || "Rounded Cube";
    return c = this.getNextIncrementalName(c), await this.importPrimitiveShapeAsync(s, o, h, e, c, n);
  }
  async createRoundedCylinderAsync(e, t, n) {
    const s = ci.Shapes.RoundedCylinderName, o = ci.Shapes.RootUrl, h = ci.Shapes.RoundedCylinderFileName;
    let c = t || "Rounded Cylinder";
    return c = this.getNextIncrementalName(c), await this.importPrimitiveShapeAsync(s, o, h, e, c, n);
  }
  async createMatBallAsync(e, t, n) {
    const s = ci.Shapes.MatBallName, o = ci.Shapes.RootUrl, h = ci.Shapes.MatBallFileName;
    let c = t || "Mat Ball";
    return c = this.getNextIncrementalName(c), await this.importPrimitiveShapeAsync(s, o, h, e, c, n);
  }
  async createMaleHeadAsync(e, t, n) {
    const s = ci.Shapes.MaleHeadName, o = ci.Shapes.RootUrl, h = ci.Shapes.MaleHeadFileName;
    let c = t || "Male Head";
    return c = this.getNextIncrementalName(c), await this.importPrimitiveShapeAsync(s, o, h, e, c, n);
  }
  async createFemaleHeadAsync(e, t, n) {
    const s = ci.Shapes.FemaleHeadName, o = ci.Shapes.RootUrl, h = ci.Shapes.FemaleHeadFileName;
    let c = t || "Female Head";
    return c = this.getNextIncrementalName(c), await this.importPrimitiveShapeAsync(s, o, h, e, c, n);
  }
  async createPokemonBallAsync(e, t, n) {
    const s = ci.Shapes.PokemonBallName, o = ci.Shapes.RootUrl, h = ci.Shapes.PokemonBallFileName;
    let c = t || "Pokemon Ball";
    return c = this.getNextIncrementalName(c), await this.importPrimitiveShapeAsync(s, o, h, e, c, n);
  }
  async createShaderBallAsync(e, t, n) {
    const s = ci.Shapes.ShaderBallName, o = ci.Shapes.RootUrl, h = ci.Shapes.ShaderBallFileName;
    let c = t || "Shader Ball";
    return c = this.getNextIncrementalName(c), await this.importPrimitiveShapeAsync(s, o, h, e, c, n);
  }
  async createBootsAsync(e, t, n) {
    const s = ci.Shapes.BootsName, o = ci.Shapes.RootUrl, h = ci.Shapes.BootsFolder, c = ci.Shapes.BootsFileName;
    let _ = t || "Boots";
    return _ = this.getNextIncrementalName(_), await this.importPrimitiveShapeAsync(s, o + h, c, e, _, n);
  }
  async createSuzanneAsync(e, t, n) {
    const s = ci.Shapes.SuzanneName, o = ci.Shapes.RootUrl, h = ci.Shapes.SuzanneFileName;
    let c = t || "Suzanne";
    return c = this.getNextIncrementalName(c), await this.importPrimitiveShapeAsync(s, o, h, e, c, n);
  }
  async createStepPyramidAsync(e, t, n) {
    const s = ci.Shapes.StepPyramidName, o = ci.Shapes.RootUrl, h = ci.Shapes.StepPyramidFileName;
    let c = t || "Step Pyramid";
    return c = this.getNextIncrementalName(c), await this.importPrimitiveShapeAsync(s, o, h, e, c, n);
  }
  async createTeapotAsync(e, t, n) {
    const s = ci.Shapes.TeapotName, o = ci.Shapes.RootUrl, h = ci.Shapes.TeapotFileName;
    let c = t || "Teapot";
    return c = this.getNextIncrementalName(c), await this.importPrimitiveShapeAsync(s, o, h, e, c, n);
  }
  async createAlloyWheelAsync(e, t, n) {
    const s = ci.Shapes.AlloyWheelName, o = ci.Shapes.RootUrl, h = ci.Shapes.AlloyWheelFolder, c = ci.Shapes.AlloyWheelFileName;
    let _ = t || "Wheel";
    return _ = this.getNextIncrementalName(_), await this.importPrimitiveShapeAsync(s, o + h, c, e, _, n);
  }
  async createTryonReferenceGlassesFrameAsync(e, t, n) {
    const s = ci.TryonReferences.ReferenceGlassesFrameName, o = ci.TryonReferences.RootUrl, h = ci.TryonReferences.ReferenceGlassesFrameFileName;
    let c = t || "Reference Glasses Frame";
    return c = this.getNextIncrementalName(c), await this.importPrimitiveShapeAsync(s, o, h, e, c, n);
  }
  async createTryOnReferenceModelsAsync(e, t, n, s) {
    return await this.importPrimitiveShapeAsync(
      "",
      ci.TryonReferences.RootUrl,
      n,
      e,
      t,
      s,
      !0
    );
  }
  async importPrimitiveShapeAsync(e, t, n, s, o, h, c = !1) {
    let _ = [], x = await BABYLON.SceneLoader.ImportMeshAsync(e, t, n, this._scene, h);
    if (x && x.meshes) {
      _ = x.meshes;
      for (let B = 0; B < _.length; B++) {
        let P = _[B];
        if (P.name === "__root__") {
          let U = P.getChildMeshes();
          for (let M = 0; M < U.length; M++) {
            let Z = U[M];
            Z.parent = null;
          }
          P.dispose(), _.splice(B--, 1);
          continue;
        }
        P.id = Zakeke.generateUUID(), s && (P.parent = s);
      }
    }
    return _;
  }
  setTryOnReferenceVisible(e) {
    const { tryonReferencesModels: t } = this.getVTOMeshes();
    t.forEach((n) => {
      n.isVisible = e;
    });
  }
  setTryOnReferenceEnabled(e) {
    const { tryonReferencesModels: t } = this.getVTOMeshes();
    t.forEach((n) => {
      n.setEnabled(e);
    });
  }
  isTryOnReferenceVisible() {
    const { tryonReferencesModels: e } = this.getVTOMeshes();
    return e.length > 0 && e[0].isVisible;
  }
  transformEntireScene(e, t, n, s) {
    var h;
    const o = (h = this._scene) == null ? void 0 : h.meshes;
    o == null || o.forEach((c) => {
      c.parent == null && c.setParent(s);
    }), e && (s.position = new BABYLON.Vector3(e.x, e.y, e.z)), t && (s.rotation = new BABYLON.Vector3(t.x, t.y, t.z)), n && (s.scaling = new BABYLON.Vector3(n.x, n.y, n.z)), o == null || o.forEach((c) => {
      c.parent == s && c.setParent(null);
    });
  }
  scaleSceneToTryonReferenceModels(e) {
    this.setSceneScalePercentageForVTO(100, e), this.setScenePositionPercentageForVTO(0, 0, 0, e);
  }
  getSceneScalingPercentageForVTO() {
    const { userMeshes: e, tryonReferencesModels: t } = this.getVTOMeshes();
    if (t.length === 0 || e.length === 0)
      return 100;
    const n = this._scene.getWorldExtends((M) => t.includes(M)), s = this._scene.getWorldExtends((M) => e.includes(M)), o = n.max.x - n.min.x, h = n.max.y - n.min.y, c = n.max.z - n.min.z, _ = s.max.x - s.min.x, x = s.max.y - s.min.y, B = s.max.z - s.min.z;
    return 1 / Math.min(
      o / _,
      h / x,
      c / B
    ) * 100;
  }
  setSceneScalePercentageForVTO(e, t) {
    const { userMeshes: n, tryonReferencesModels: s } = this.getVTOMeshes();
    if (s.length === 0 || n.length === 0)
      return;
    const o = this._scene.getWorldExtends((D) => s.includes(D)), h = this._scene.getWorldExtends((D) => n.includes(D)), c = o.max.x - o.min.x, _ = o.max.y - o.min.y, x = o.max.z - o.min.z, B = h.max.x - h.min.x, P = h.max.y - h.min.y, U = h.max.z - h.min.z, M = Math.min(
      c / B,
      _ / P,
      x / U
    ), { x: Z, y: F, z: Q } = this.getScenePositionPercentageForVTO();
    n.filter((D) => !D.parent).forEach((D) => {
      D.scaling.scaleInPlace(M), D.scaling.scaleInPlace(e / 100), t === "shoes" && D.scaling.scaleInPlace(1.3);
    }), this.setScenePositionPercentageForVTO(Z, F, Q);
  }
  getScenePositionPercentageForVTO() {
    const { userMeshes: e, tryonReferencesModels: t } = this.getVTOMeshes();
    if (t.length === 0 || e.length === 0)
      return { x: 0, y: 0, z: 0 };
    const n = this._scene.getWorldExtends((_) => t.includes(_)), s = this._scene.getWorldExtends((_) => e.includes(_)), o = n.max.add(n.min).scale(0.5), c = s.max.add(s.min).scale(0.5).subtract(o);
    return {
      x: c.x / (n.max.x - n.min.x) * 100,
      y: c.y / (n.max.y - n.min.y) * 100,
      z: c.z / (n.max.z - n.min.z) * 100
    };
  }
  setScenePositionPercentageForVTO(e, t, n, s) {
    const { userMeshes: o, tryonReferencesModels: h } = this.getVTOMeshes();
    if (h.length === 0 || o.length === 0)
      return;
    const c = this._scene.getWorldExtends((M) => h.includes(M)), _ = this._scene.getWorldExtends((M) => o.includes(M)), x = c.max.add(c.min).scale(0.5), B = _.max.add(_.min).scale(0.5), P = x.subtract(B), U = new BABYLON.Vector3(
      e / 100 * (c.max.x - c.min.x),
      t / 100 * (c.max.y - c.min.y),
      n / 100 * (c.max.z - c.min.z)
    );
    o.filter((M) => !M.parent).forEach((M) => {
      M.position.addInPlace(P), M.position.addInPlace(U), s === "shoes" && (console.log("shoes down and scale up to 0.3"), M.position.y = 0);
    });
  }
  getSceneRotationForVTO() {
    var h;
    const { userMeshes: e, tryonReferencesModels: t } = this.getVTOMeshes();
    if (t.length === 0 || e.length === 0)
      return { x: 0, y: 0, z: 0 };
    const n = e.filter((c) => !c.parent)[0], s = ((h = n.rotationQuaternion) == null ? void 0 : h.toEulerAngles()) ?? n.rotation, o = {
      x: s.x / Math.PI * 180,
      y: s.y / Math.PI * 180,
      z: s.z / Math.PI * 180
    };
    return o.x = o.x < 0 ? 360 + o.x : o.x, o.y = o.y < 0 ? 360 + o.y : o.y, o.z = o.z < 0 ? 360 + o.z : o.z, o;
  }
  setSceneRotationForVTO(e, t, n) {
    const { userMeshes: s, tryonReferencesModels: o } = this.getVTOMeshes();
    if (o.length === 0 || s.length === 0)
      return;
    const h = new BABYLON.Vector3(e / 180 * Math.PI, t / 180 * Math.PI, n / 180 * Math.PI);
    s.filter((c) => !c.parent).forEach((c) => {
      c.rotation = h;
    });
  }
  setVTOReferenceVisible(e) {
    const { tryonReferencesModels: t } = this.getVTOMeshes();
    t.forEach((n) => {
      n.isVisible = e;
    });
  }
  replaceTransformNodeWithMesh(e) {
    let t = null;
    if (this._scene) {
      const n = e.parent, s = e.getChildren();
      t = new BABYLON.Mesh(e.name, this._scene, n), t.id = Zakeke.generateUUID(), t.scaling = e.scaling.clone(), t.position = e.position.clone(), t.rotation = e.rotation.clone(), e.rotationQuaternion && (t.rotationQuaternion = e.rotationQuaternion.clone()), s.forEach((o) => o.parent = t), e.dispose(), e.animations.forEach((o) => {
        t.animations.push(o.clone());
      }), this._scene.animationGroups.forEach((o) => {
        o.targetedAnimations.forEach((h) => {
          h.target === e && (h.target = t);
        });
      }), this._scene.skeletons.forEach((o) => {
        o.bones.forEach((h) => {
          h.getTransformNode() === e && h.linkTransformNode(t);
        });
      });
    }
    return t;
  }
  // import 3d model from a remote url
  async importMeshesFromUrlAsync(e, t, n, s, o, h) {
    let c;
    BABYLON.GLTFFileLoader.IncrementalLoading = !1, BABYLON.SceneLoader.OnPluginActivatedObservable.add((Z) => {
      c = Z.name;
    });
    let _ = [];
    const x = await BABYLON.SceneLoader.ImportMeshAsync(
      "",
      e,
      void 0,
      this._scene,
      n,
      o
    );
    x && (x.meshes.forEach((Z) => {
      Z.id = Zakeke.generateUUID(), _.push(Z), this.getMeshMaterials(Z).forEach((Q) => Q.id = Zakeke.generateUUID());
    }), x.transformNodes.forEach((Z) => {
      Z.id = Zakeke.generateUUID();
      const F = this.replaceTransformNodeWithMesh(Z);
      F && _.push(F);
    }), x.geometries.forEach((Z) => Z.id = Zakeke.generateUUID()));
    let B = BABYLON.Tools.GetFilename(e), P = B, U = B.lastIndexOf(".");
    U !== -1 && (P = B.substr(0, U));
    const M = _.filter((Z) => !Z.parent);
    if (M.length > 1 || M.length === 1 && M[0].name !== "__root__") {
      const Z = new BABYLON.Mesh(P, this._scene);
      Z.id = Zakeke.generateUUID(), Z.metadata = {
        isRealMesh: !0,
        isGroup: !0
      }, _.push(Z), M.forEach((F) => {
        F.setParent(Z);
      }), c === "obj" && (Z.scaling = new BABYLON.Vector3(-Z.scaling.x, Z.scaling.y, Z.scaling.z), Z.rotation = new BABYLON.Vector3(0, Math.PI, 0));
    } else if (M.length === 1) {
      const Z = M[0];
      if (Z.name === "__root__") {
        let Q = BABYLON.Tools.GetFilename(e), D = B.lastIndexOf(".");
        D !== -1 && (Q = B.substring(0, D)), Z.name = Q, c === "obj" && (Z.scaling = new BABYLON.Vector3(-Z.scaling.x, Z.scaling.y, -Z.scaling.z), Z.rotation = new BABYLON.Vector3(0, Math.PI, 0));
      }
      if (["gltf", "glb", "obj"].includes(c)) {
        Z.name += "_transforms", Z.metadata = {
          isGltfTransformNode: !0
        };
        const Q = new BABYLON.Mesh(P, this._scene);
        Q.id = Zakeke.generateUUID(), Q.metadata = {
          isRealMesh: !0,
          isGroup: !0
        }, _.push(Q), Z.parent = Q;
      }
    }
    if (!h && c === "gltf" || c === "glb") {
      const Z = [];
      _.forEach((F) => {
        if (F instanceof BABYLON.Mesh) {
          const D = BABYLON.VertexData.ExtractFromMesh(F), te = ["uvs", "uvs2", "uvs3", "uvs4", "uvs5", "uvs6"];
          for (const ee of te)
            if (D && D[ee] && D[ee].length > 0)
              for (let le = 0; le < D[ee].length; le += 2)
                D[ee][le + 1] = 1 - D[ee][le + 1];
          D.applyToMesh(F);
        }
        this.getMeshMaterials(F).forEach((D) => {
          Z.includes(D) || Z.push(D);
        });
      }), Z.forEach((F) => {
        F.getActiveTextures().forEach((Q) => {
          Q instanceof BABYLON.Texture && (Q.vScale *= -1);
        });
      });
    }
    return this.adjustCamera(c, !1, !1, s, !0), this.setupShaderMaterialsCameraPosition(), _;
  }
  setupShaderMaterialsCameraPosition() {
    if (this._scene)
      for (let t = 0; t < this._scene.materials.length; t++) {
        var e = this._scene.materials[t];
        this.setupShaderMaterialCameraPosition(e);
      }
  }
  setupShaderMaterialCameraPosition(e) {
    if (this._scene && e && e instanceof BABYLON.ShaderMaterial) {
      const t = this._scene.activeCamera;
      t && e.setVector3("cameraPosition", t.position);
    }
  }
  getSceneCmScalingFactor(e = null, t = null) {
    let n = null;
    if (this._scene) {
      let o = null;
      for (let h = 0; h < this._scene.meshes.length; h++) {
        var s = this._scene.meshes[h];
        if (s.metadata && s.metadata.sizecm) {
          o = s;
          break;
        }
      }
      if (e && t && (o = t), o) {
        const h = o.getHierarchyBoundingVectors(), c = h.min, _ = h.max, x = _.subtract(c);
        if (isFinite(x.length())) {
          const B = _.x - c.x, P = _.y - c.y, U = _.z - c.z, M = e || o.metadata.sizecm;
          return M.width !== void 0 && typeof M.width == "number" && !isNaN(M.width) && B !== 0 ? n = M.width / B : M.height !== void 0 && typeof M.height == "number" && !isNaN(M.height) && P !== 0 ? n = M.height / P : M.depth !== void 0 && typeof M.depth == "number" && !isNaN(M.depth) && U !== 0 && (n = M.depth / U), n;
        }
      }
    }
    return n;
  }
  async exportSceneToUsdzAsync(e, t, n, s, o = null, h = null, c = !0) {
    const _ = this.getMeshesForAR();
    let x = e || "scene";
    return x = x.replace(/[^a-z0-9]/gi, "_").toLowerCase(), await this.exportMeshesToARAsync(
      x,
      t,
      _,
      n,
      s,
      "usdz",
      o,
      h,
      c
    );
  }
  async exportMeshToUsdzAsync(e, t, n = null, s = null, o = !0) {
    const h = this.getMeshHierarchy(t.id);
    let c = t.name.replace(/[^a-z0-9]/gi, "_").toLowerCase();
    return await this.exportMeshesToARAsync(
      c,
      e,
      h,
      void 0,
      void 0,
      "usdz",
      n,
      s,
      o
    );
  }
  async exportSceneToRemoteGlTFAsync(e, t, n, s, o = null, h = null, c = !0) {
    const _ = this.getMeshesForAR();
    let x = e || "scene";
    return x = x.replace(/[^a-z0-9]/gi, "_").toLowerCase(), await this.exportMeshesToARAsync(
      x,
      t,
      _,
      n,
      s,
      "glTF",
      o,
      h,
      c
    );
  }
  async exportMeshToRemoteGlTFAsync(e, t, n = null, s = null, o = !0) {
    const h = this.getMeshHierarchy(t.id);
    let c = t.name.replace(/[^a-z0-9]/gi, "_").toLowerCase();
    return await this.exportMeshesToARAsync(
      c,
      e,
      h,
      void 0,
      void 0,
      "glTF",
      n,
      s,
      o
    );
  }
  async exportSceneToRemoteGLBAsync(e, t, n, s, o = null, h = null, c = !0) {
    const _ = this.getMeshesForAR();
    let x = e || "scene";
    return x = x.replace(/[^a-z0-9]/gi, "_").toLowerCase(), await this.exportMeshesToARAsync(
      x,
      t,
      _,
      n,
      s,
      "glb",
      o,
      h,
      c
    );
  }
  async exportMeshToRemoteGLBAsync(e, t, n = null, s = null, o = !0) {
    const h = this.getMeshHierarchy(t.id);
    let c = t.name.replace(/[^a-z0-9]/gi, "_").toLowerCase();
    return await this.exportMeshesToARAsync(
      c,
      e,
      h,
      void 0,
      void 0,
      "glb",
      n,
      s,
      o
    );
  }
  async exportSceneToARMultiformatAsync(e, t, n = ["usdz", "glb", "png"], s, o, h = null, c = null, _ = !0) {
    const x = this.getMeshesForAR();
    let B = e || "scene";
    return B = B.replace(/[^a-z0-9]/gi, "_").toLowerCase(), await this.exportMeshesToARMultiformatAsync(
      B,
      t,
      x,
      n,
      h,
      c,
      _,
      s,
      o
    );
  }
  async exportMeshToARMultiformatAsync(e, t, n = ["usdz", "glb", "png"], s = null, o = null, h = !0, c, _) {
    const x = this.getMeshHierarchy(t.id);
    let B = t.name.replace(/[^a-z0-9]/gi, "_").toLowerCase();
    return await this.exportMeshesToARMultiformatAsync(
      B,
      e,
      x,
      n,
      s,
      o,
      h,
      c,
      _
    );
  }
  convertGltfTransformNodes(e) {
    const t = [];
    return e.filter((n) => n.metadata && n.metadata.isGltfTransformNode).forEach((n) => {
      const s = new BABYLON.TransformNode(n.name + "-transform-node", this._scene);
      s.scaling.z = -1;
      const o = new BABYLON.Quaternion();
      o.set(0, 1, 0, 0), s.rotationQuaternion = o, t.push([n, n.parent, s]), n.setParent(s);
    }), t;
  }
  restoreGltfTransformNodes(e) {
    e.forEach(([t, n, s]) => {
      t.setParent(n), s.dispose();
    });
  }
  async getGltfBlobForARExport(e, t, n) {
    var _;
    const s = this.convertGltfTransformNodes(n);
    (_ = this._scene) == null || _.render();
    const o = {
      meshes: n,
      materials: this.getMeshesMaterials(n),
      transformNodes: this._scene.transformNodes,
      lights: void 0,
      exportTextureUrls: t != null,
      rootUrl: t,
      shouldExportNode: (x) => {
        for (let B = 0; B < n.length; B++)
          if (n[B] === x)
            return !0;
        return !1;
      }
    }, h = await BABYLON.GLTF2Export.GLTFAsync(this._scene, e, o);
    if (h) {
      const x = new Wf(), B = h.serverImages && h.glTFFiles.hasOwnProperty("TextureUrls.txt") ? h.serverImages : [];
      for (var c in h.glTFFiles)
        if (B.indexOf(c) === -1) {
          let U = h.glTFFiles[c];
          Ms.EndsWith(c, ".gltf") || Ms.EndsWith(c, ".bin") ? x.file(c, U, {
            compression: "DEFLATE",
            compressionOptions: {
              level: 9
              // force a compression and a compression level for this file
            }
          }) : x.file(c, U, {
            compression: "STORE"
            // no compression
          });
        }
      this.restoreGltfTransformNodes(s), this._scene.render();
      let P = await x.generateAsync({ type: "blob" });
      if (P)
        return P = P, P.lastModifiedDate = /* @__PURE__ */ new Date(), P.name = "arobj.zip", P;
    }
    return null;
  }
  async exportMeshToGLBBlob(e, t) {
    const n = this.getTryOnMeshHierarchy(t), s = this.convertGltfTransformNodes(n), o = {
      meshes: n,
      materials: this.getMeshesMaterials(n),
      transformNodes: void 0,
      lights: void 0,
      exportTextureUrls: e != null,
      rootUrl: e,
      shouldExportNode: (_) => {
        for (let x = 0; x < n.length; x++)
          if (n[x] === _)
            return !0;
        return !1;
      }
    }, h = await BABYLON.GLTF2Export.GLBAsync(this._scene, "model", o).catch((_) => (console.error(_), null));
    let c = null;
    if (h && h.glTFFiles) {
      for (let _ in h.glTFFiles)
        if (Ms.EndsWith(_, ".glb")) {
          const x = new wf(), B = await h.glTFFiles[_].arrayBuffer(), P = x.readBinary(B);
          P.getRoot().listNodes().filter((Z) => Z.getParent() === null || Z.getParent() instanceof ro).forEach((Z) => {
          });
          const M = x.writeBinary(P);
          c = new Blob([M], { type: "model/gltf-binary" });
        }
    }
    return this.restoreGltfTransformNodes(s), c;
  }
  async exportMeshesToARAsync(e, t, n, s, o, h = "usdz", c = null, _ = null, x = !0) {
    let B = "";
    if (console.log("sono in exportMeshesToARAsync ==> window token ", window.token), s && o && Zakeke.config) {
      const P = Zakeke.config.baseApiUrl + "artasks/cachedresults/" + s + "/" + o + "/" + h;
      try {
        B = await jQuery.ajax({
          url: P,
          cache: !1,
          contentType: !1,
          processData: !1,
          type: "GET"
        });
      } catch {
        B = "";
      }
    }
    if (!B) {
      console.log("sono in !cachedArFile  ==> window token ", window.token);
      const P = this.getAuthToken();
      if (!P)
        return console.error("No authentication token available"), "";
      let U = this.getSceneCmScalingFactor(c, _);
      const M = await this.getGltfBlobForARExport(e, t, n);
      if (M) {
        const Z = {
          flipTextures: !0,
          formats: [h]
        };
        s && (Z.sceneID = s), o && (Z.sceneCode = o), U && (Z.scale = U);
        let F = !0;
        window.isOwin != null && (F = window.isOwin);
        const D = await new jf("artasks", P, F).upload(M, Z);
        D && D.length > 0 && (B = D[0].arFileUrl);
      }
    }
    return B;
  }
  async exportMeshesToARMultiformatAsync(e, t, n, s = ["usdz", "glb", "png"], o = null, h = null, c = !0, _, x) {
    let B = [], P = [];
    if (_ && x && Zakeke.config)
      for (let U = 0; U < s.length; U++) {
        const M = s[U], Z = Zakeke.config.baseApiUrl + "artasks/cachedresults/" + _ + "/" + x + "/" + M;
        try {
          const F = await jQuery.ajax({
            url: Z,
            cache: !1,
            contentType: !1,
            processData: !1,
            type: "GET"
          });
          F && P.push({ format: M, arFileUrl: F });
        } catch {
        }
        B = P;
      }
    if (P.length !== s.length) {
      const U = this.getAuthToken();
      if (console.log(
        "sono in cachedArFiles.length !== formats.length  ==> provo a recuperare il token con getAuthToken ",
        U
      ), !U)
        return console.error("No authentication token available"), B;
      const M = this.getSceneCmScalingFactor(o, h), Z = P.map((D) => D.format), F = s.filter((D) => !Z.includes(D)), Q = await this.getGltfBlobForARExport(e, t, n);
      if (Q) {
        const D = {
          flipTextures: !0,
          formats: F
          // Escludo i formati cachati
        };
        _ && (D.sceneID = _), x && (D.sceneCode = x), M && (D.scale = M);
        let te = !0;
        window.isOwin !== void 0 && (te = window.isOwin);
        const le = await new jf("artasks", U, te).upload(Q, D);
        if (le && le.length > 0)
          for (const fe of le)
            fe && fe.arFileUrl && B.push({ format: fe.format, arFileUrl: fe.arFileUrl });
      }
    }
    return B;
  }
  // Metodi per esportazione on-the-fly client side
  async exportSceneToLocalGlTFBlobsAsync() {
    const e = Zakeke.generateUUID(), t = this.getSceneToGltfExportOptions(), n = await BABYLON.GLTF2Export.GLTFAsync(this._scene, e, t);
    let s = [];
    for (let o in n.glTFFiles)
      s.push(n.glTFFiles[o]);
    return s;
  }
  async exportSceneToLocalGlTFUrlsAsync() {
    const e = [], t = Zakeke.generateUUID(), n = this.getSceneToGltfExportOptions(), s = await BABYLON.GLTF2Export.GLTFAsync(this._scene, t, n);
    if (s)
      for (let h in s.glTFFiles) {
        var o = s.glTFFiles[h];
        e.push(this.getGltfFileUrl(h, o));
      }
    return e;
  }
  async downloadSceneLocalGltfAsync() {
    const e = Zakeke.generateUUID(), t = this.getSceneToGltfExportOptions(), n = await BABYLON.GLTF2Export.GLTFAsync(this._scene, e, t);
    n && n.downloadFiles();
  }
  async exportSceneToLocalGLBBlobAsync() {
    const e = await this.getSceneLocalGLBBlobInfoAsync();
    return e ? e.blob : null;
  }
  async exportSceneToLocalGLBBase64Async() {
    let e = null;
    const t = await this.getSceneLocalGLBBlobInfoAsync();
    if (t && t.blob instanceof Blob) {
      let n = new FileReader();
      n.readAsDataURL(t.blob), n.onloadend = () => {
        let s = n.result;
        typeof s == "string" && (e = s);
      };
    }
    return e;
  }
  async exportSceneToLocalGLBUrlAsync() {
    let e = null;
    const t = await this.getSceneLocalGLBBlobInfoAsync();
    return t && t.name && t.blob instanceof Blob && (e = this.getGltfFileUrl(t.name, t.blob)), e;
  }
  async downloadSceneLocalGLBAsync() {
    var n;
    (n = this._scene) == null || n.meshes.forEach((s) => {
      s.isVisible = !0;
    });
    const e = await this.getSceneLocalGLBBlobInfoAsync();
    if (e && e.name && e.blob instanceof Blob) {
      let s = this.getGltfFileUrl(e.name, e.blob);
      var t = document.createElement("a");
      document.body.appendChild(t), t.setAttribute("type", "hidden"), t.download = e.name, t.href = s, t.click(), document.body.removeChild(t), URL.revokeObjectURL(s);
    }
  }
  async getSceneLocalGLBBlobInfoAsync(e = null, t = null) {
    let n = {
      name: null,
      blob: null
    };
    const s = Zakeke.generateUUID(), o = this.getSceneToGltfExportOptions();
    let h = await BABYLON.GLTF2Export.GLBAsync(this._scene, s, o).catch((c) => (console.error(c), null));
    if (h && h.glTFFiles) {
      for (let c in h.glTFFiles)
        if (Ms.EndsWith(c, ".glb")) {
          let _ = this.getSceneCmScalingFactor(), x = 1;
          _ && (x = _ / 100);
          const B = BABYLON.Quaternion.RotationAxis(BABYLON.Axis.Y, 2 * Math.PI), P = new wf(), U = await h.glTFFiles[c].arrayBuffer(), M = P.readBinary(U), Z = M.getRoot().listNodes().filter((ee) => ee.getParent() === null || ee.getParent() instanceof ro), F = [0, 1, 0, 0], Q = Z.every((ee) => {
            const le = ee.getRotation();
            return F.length === le.length && F.every((fe, X) => fe === le[X]);
          });
          Z.forEach((ee) => {
            ee.setScale([x, x, x]), Q && ee.setRotation([B.x, B.y, B.z, B.w]);
          });
          const D = P.writeBinary(M), te = new Blob([D], { type: "model/gltf-binary" });
          n.name = c, n.blob = te;
          break;
        }
    }
    return n;
  }
  // -----------------------------------------------------------------------
  // Metodi per exportazione della scena in USDZ su client (on-the-fly)
  async exportSceneToLocalUSDZBlobAsync() {
    const e = await this.getSceneLocalUSDZBlobInfoAsync();
    return e ? e.blob : null;
  }
  async exportSceneToLocalUSDZBase64Async() {
    let e = null;
    const t = await this.getSceneLocalUSDZBlobInfoAsync();
    if (t && t.blob instanceof Blob) {
      let n = new FileReader();
      n.readAsDataURL(t.blob), n.onloadend = () => {
        let s = n.result;
        typeof s == "string" && (e = s);
      };
    }
    return e;
  }
  async exportSceneToLocalUSDZUrlAsync() {
    let e = null;
    const t = await this.getSceneLocalUSDZBlobInfoAsync();
    return t && t.name && t.blob instanceof Blob && (e = this.getUsdzFileUrl(t.name, t.blob)), e;
  }
  async downloadSceneLocalUSDZAsync() {
    const e = await this.getSceneLocalUSDZBlobInfoAsync();
    if (e && e.name && e.blob instanceof Blob) {
      let n = this.getUsdzFileUrl(e.name, e.blob);
      var t = document.createElement("a");
      document.body.appendChild(t), t.setAttribute("type", "hidden"), t.download = e.name, t.href = n, t.click(), document.body.removeChild(t), URL.revokeObjectURL(n);
    }
  }
  async getSceneLocalUSDZBlobInfoAsync() {
    let e = {
      name: null,
      blob: null
    };
    const t = await this.getSceneLocalGLBBlobInfoAsync();
    if (t && t.name && t.blob && t.blob instanceof Blob) {
      const n = this.getGltfFileUrl(t.name, t.blob), s = await Fx.convertGlbToUsdz(n);
      e.name = t.name.replace(".glb", ".usdz"), e.blob = s;
    }
    return e;
  }
  // -----------------------------------------------------------------------
  getSceneToGltfExportOptions() {
    var e = this.getMeshesForAR(), t = {
      meshes: e,
      materials: this.getMeshesMaterials(e),
      transformNodes: void 0,
      lights: void 0,
      exportTextureUrls: !1,
      rootUrl: null,
      shouldExportNode: (n) => {
        for (var s = 0; s < e.length; s++)
          if (e[s] === n)
            return !0;
        return !1;
      }
    };
    return t;
  }
  getGltfFileUrl(e, t) {
    var n = void 0;
    return Ms.EndsWith(e, ".glb") ? n = { type: "model/gltf-binary" } : Ms.EndsWith(e, ".bin") ? n = { type: "application/octet-stream" } : Ms.EndsWith(e, ".gltf") ? n = { type: "model/gltf+json" } : Ms.EndsWith(e, ".jpeg") ? n = { type: "image/jpeg" } : Ms.EndsWith(e, ".png") && (n = { type: "image/png" }), window.URL.createObjectURL(new Blob([t], n));
  }
  getUsdzFileUrl(e, t) {
    var n = { type: "model/vnd.usdz+zip" };
    return window.URL.createObjectURL(new Blob([t], n));
  }
  exportSceneToBabylon() {
    const e = BABYLON.SceneSerializer.Serialize(this._scene);
    return JSON.stringify(e);
  }
  exportVisibleMeshesToBabylon() {
    const e = this.getVisibleMeshes(), t = BABYLON.SceneSerializer.SerializeMesh(e, !1, !1);
    return JSON.stringify(t);
  }
  downloadImageFromBase64(e, t, n) {
    var s = document.createElement("a");
    s.href = e, s.download = t, s.click(), s.remove();
  }
  getStandardMaterialTextureType(e, t) {
    return e.diffuseTexture === t ? "diffuse" : e.emissiveTexture === t ? "emissive" : e.ambientTexture === t ? "ambient" : e.lightmapTexture === t ? "lightmap" : e.opacityTexture === t ? "opacity" : e.specularTexture === t ? "specular" : e.reflectionTexture === t ? "reflection" : e.refractionTexture === t ? "refraction" : e.bumpTexture === t ? "bump" : null;
  }
  getPBRMetallicRoughnessMaterialTextureType(e, t) {
    return e.environmentTexture === t ? "environment" : e.normalTexture === t ? "normal" : e.emissiveTexture === t ? "emissive" : e.occlusionTexture === t ? "occlusion" : e.baseTexture === t ? "base" : e.metallicRoughnessTexture === t ? "metallicRoughness" : null;
  }
  getPBRSpecularGlossinessMaterialTextureType(e, t) {
    return e.environmentTexture === t ? "environment" : e.normalTexture === t ? "normal" : e.emissiveTexture === t ? "emissive" : e.occlusionTexture === t ? "occlusion" : e.diffuseTexture === t ? "diffuse" : e.specularGlossinessTexture === t ? "specularGlossiness" : null;
  }
  getPBRMaterialTextureType(e, t) {
    if (e.cameraColorGradingTexture === t)
      return "cameraColorGrading";
    if (e.albedoTexture === t)
      return "albedo";
    if (e.ambientTexture === t)
      return "ambient";
    if (e.opacityTexture === t)
      return "opacity";
    if (e.reflectionTexture === t)
      return "reflection";
    if (e.emissiveTexture === t)
      return "emissive";
    if (e.reflectivityTexture === t)
      return "reflectivity";
    if (e.metallicTexture === t)
      return "metallic";
    if (e.microSurfaceTexture === t)
      return "microSurface";
    if (e.bumpTexture === t)
      return "bump";
    if (e.lightmapTexture === t)
      return "lightmap";
    if (e.refractionTexture === t)
      return "refraction";
    if (e.clearCoat) {
      if (e.clearCoat.texture === t)
        return "clearCoat";
      if (e.clearCoat.bumpTexture === t)
        return "clearCoat_bump";
      if (e.clearCoat.tintTexture === t)
        return "clearCoat_tint";
      if (e.clearCoat.textureRoughness === t)
        return "clearCoat_textureRoughness";
      if (e.clearCoat.texture === t)
        return "clearCoat_texture";
    }
    if (e.anisotropy && e.anisotropy.texture === t)
      return "anisotropy_texture";
    if (e.sheen) {
      if (e.sheen.texture === t)
        return "sheen_texture";
      if (e.sheen.textureRoughness === t)
        return "sheen_textureRoughness";
    }
    if (e.subSurface) {
      if (e.subSurface.thicknessTexture === t)
        return "subSurface_thickness";
      if (e.subSurface.refractionIntensityTexture === t)
        return "subSurface_refractionIntensity";
      if (e.subSurface.translucencyIntensityTexture === t)
        return "subSurface_translucencyIntensity";
    }
    return null;
  }
  getZakekePBRMaterialTextureType(e, t) {
    return e.albedoTexture === t ? "albedo" : e.bumpTexture === t ? "bump" : e.reflectionTexture === t ? "reflection" : e.matCapReflectionTexture === t ? "matCapReflection" : e.reflectivityTexture === t ? "reflectivity" : e.microsurfaceTexture === t ? "microsurface" : e.ambientTexture === t ? "ambient" : e.aoTexture === t ? "ao" : e.opacityTexture === t ? "opacity" : null;
  }
  getMaterialTextureType(e, t) {
    return e instanceof BABYLON.StandardMaterial ? this.getStandardMaterialTextureType(e, t) : e instanceof BABYLON.PBRMetallicRoughnessMaterial ? this.getPBRMetallicRoughnessMaterialTextureType(e, t) : e instanceof BABYLON.PBRSpecularGlossinessMaterial ? this.getPBRSpecularGlossinessMaterialTextureType(e, t) : e instanceof BABYLON.PBRMaterial ? this.getPBRMaterialTextureType(e, t) : e instanceof Zakeke.PBRMaterial ? this.getZakekePBRMaterialTextureType(e, t) : null;
  }
  getMaterialTexture(e, t) {
    if (e instanceof BABYLON.StandardMaterial)
      switch (t) {
        case "diffuse":
          return e.diffuseTexture;
        case "emissive":
          return e.emissiveTexture;
        case "ambient":
          return e.ambientTexture;
        case "lightmap":
          return e.lightmapTexture;
        case "opacity":
          return e.opacityTexture;
        case "specular":
          return e.specularTexture;
        case "reflection":
          return e.reflectionTexture;
        case "refraction":
          return e.refractionTexture;
        case "bump":
          return e.bumpTexture;
      }
    else if (e instanceof BABYLON.PBRMetallicRoughnessMaterial)
      switch (t) {
        case "environment":
        case "normal":
        case "emissive":
        case "occlusion":
        case "base":
        case "metallicRoughness":
          return e[`${t}Texture`];
      }
    else if (e instanceof BABYLON.PBRSpecularGlossinessMaterial)
      switch (t) {
        case "environment":
        case "normal":
        case "emissive":
        case "occlusion":
        case "diffuse":
        case "specularGlossiness":
          return e[`${t}Texture`];
      }
    else if (e instanceof BABYLON.PBRMaterial)
      switch (t) {
        case "cameraColorGrading":
          return e.cameraColorGradingTexture;
        case "albedo":
        case "ambient":
        case "opacity":
        case "reflection":
        case "emissive":
        case "reflectivity":
        case "metallic":
        case "microSurface":
        case "bump":
        case "lightmap":
          return e[`${t}Texture`];
        case "refraction":
          return e.refractionTexture;
        case "environmentBRDF":
          return e.environmentBRDFTexture;
        case "clearCoat_texture":
          return e.clearCoat.texture;
        case "clearCoat_bump":
          return e.clearCoat.bumpTexture;
        case "clearCoat_tint":
          return e.clearCoat.tintTexture;
        case "clearCoat_textureRoughness":
          return e.clearCoat.textureRoughness;
        case "anisotropy_texture":
          return e.anisotropy.texture;
        case "sheen_texture":
          return e.sheen.texture;
        case "sheen_textureRoughness":
          return e.sheen.textureRoughness;
        case "subSurface_thickness":
          return e.subSurface.thicknessTexture;
        case "subSurface_translucencyIntensity":
          return e.subSurface.translucencyIntensityTexture;
        case "subSurface_refractionIntensity":
          return e.subSurface.refractionIntensityTexture;
      }
    else if (e instanceof Zakeke.PBRMaterial)
      switch (t) {
        case "albedo":
          return e.albedoTexture;
        case "bump":
          return e.bumpTexture;
        case "reflection":
          return e.reflectionTexture;
        case "matCapReflection":
          return e.matCapReflectionTexture;
        case "reflectivity":
          return e.reflectivityTexture;
        case "microsurface":
          return e.microsurfaceTexture;
        case "ambient":
          return e.ambientTexture;
        case "ao":
          return e.aoTexture;
        case "opacity":
          return e.opacityTexture;
      }
    return null;
  }
  applyTexture(e, t, n) {
    if (e && n == "lightmap" && (e.coordinatesIndex = 1, (t instanceof BABYLON.StandardMaterial || t instanceof BABYLON.PBRMaterial || t instanceof BABYLON.PBRBaseSimpleMaterial) && (t.useLightmapAsShadowmap = !0)), t instanceof BABYLON.StandardMaterial)
      switch (n) {
        case "diffuse":
          t.diffuseTexture = e;
          break;
        case "emissive":
          t.emissiveTexture = e;
          break;
        case "ambient":
          t.ambientTexture = e;
          break;
        case "lightmap":
          t.lightmapTexture = e;
          break;
        case "opacity":
          t.opacityTexture = e;
          break;
        case "specular":
          t.specularTexture = e;
          break;
        case "reflection":
          t.reflectionTexture = e;
          break;
        case "refraction":
          t.refractionTexture = e;
          break;
        case "bump":
          t.bumpTexture = e;
          break;
      }
    else if (t instanceof BABYLON.PBRMetallicRoughnessMaterial)
      switch (n) {
        case "environment":
        case "normal":
        case "emissive":
        case "occlusion":
        case "base":
        case "metallicRoughness":
          t[`${n}Texture`] = e;
          break;
      }
    else if (t instanceof BABYLON.PBRSpecularGlossinessMaterial)
      switch (n) {
        case "environment":
        case "normal":
        case "emissive":
        case "occlusion":
        case "diffuse":
        case "specularGlossiness":
          t[`${n}Texture`] = e;
          break;
      }
    else if (t instanceof BABYLON.PBRMaterial)
      switch (n) {
        case "cameraColorGrading":
          t.cameraColorGradingTexture = e;
          break;
        case "albedo":
        case "ambient":
        case "opacity":
        case "reflection":
        case "emissive":
        case "reflectivity":
        case "metallic":
        case "microSurface":
        case "bump":
        case "lightmap":
          t[`${n}Texture`] = e;
          break;
        case "refraction":
          t.refractionTexture = e;
          break;
        case "environmentBRDF":
          t.environmentBRDFTexture = e;
          break;
        case "clearCoat_texture":
          t.clearCoat.texture = e;
          break;
        case "clearCoat_bump":
          t.clearCoat.bumpTexture = e;
          break;
        case "clearCoat_tint":
          t.clearCoat.tintTexture = e;
          break;
        case "clearCoat_textureRoughness":
          t.clearCoat.textureRoughness = e;
          break;
        case "anisotropy_texture":
          t.anisotropy.texture = e;
          break;
        case "sheen_texture":
          t.sheen.texture = e;
          break;
        case "sheen_textureRoughness":
          t.sheen.textureRoughness = e;
          break;
        case "subSurface_thickness":
          t.subSurface.thicknessTexture = e;
          break;
        case "subSurface_translucencyIntensity":
          t.subSurface.translucencyIntensityTexture = e;
          break;
        case "subSurface_refractionIntensity":
          t.subSurface.refractionIntensityTexture = e;
          break;
      }
    else if (t instanceof BABYLON.ShaderMaterial)
      e && e instanceof BABYLON.Texture ? t.setTexture(n, e) : t.removeTexture(n);
    else if (t instanceof Zakeke.PBRMaterial)
      switch (n) {
        case "albedo":
          t.albedoTexture = e;
          break;
        case "bump":
          t.bumpTexture = e;
          break;
        case "reflection":
          t.reflectionTexture = e;
          break;
        case "matCapReflection":
          t.matCapReflectionTexture = e;
          break;
        case "reflectivity":
          t.reflectivityTexture = e;
          break;
        case "microsurface":
          t.microsurfaceTexture = e;
          break;
        case "ambient":
          t.ambientTexture = e;
          break;
        case "ao":
          t.aoTexture = e;
          break;
        case "opacity":
          t.opacityTexture = e;
          break;
      }
  }
  applyTextureOnSerializedMaterial(e, t, n, s) {
    if (e && n == "lightmap" && (e.coordinatesIndex = 1, (s === "BABYLON.StandardMaterial" || s === "BABYLON.PBRMaterial" || s === "BABYLON.PBRBaseSimpleMaterial") && (t.useLightmapAsShadowmap = !0)), s === "BABYLON.StandardMaterial")
      t[`${n}Texture`] = e;
    else if (s === "BABYLON.PBRMetallicRoughnessMaterial")
      t[`${n}Texture`] = e;
    else if (s === "BABYLON.PBRSpecularGlossinessMaterial")
      t[`${n}Texture`] = e;
    else if (s === "BABYLON.PBRMaterial")
      switch (n) {
        case "cameraColorGrading":
          t.cameraColorGradingTexture = e;
          break;
        case "albedo":
        case "ambient":
        case "opacity":
        case "reflection":
        case "emissive":
        case "reflectivity":
        case "metallic":
        case "microSurface":
        case "bump":
        case "lightmap":
        case "refraction":
          t[`${n}Texture`] = e;
          break;
        case "environmentBRDF":
          t.environmentBRDFTexture = e;
          break;
        case "clearCoat_texture":
          t.clearCoat.texture = e;
          break;
        case "clearCoat_bump":
          t.clearCoat.bumpTexture = e;
          break;
        case "clearCoat_tint":
          t.clearCoat.tintTexture = e;
          break;
        case "clearCoat_textureRoughness":
          t.clearCoat.textureRoughness = e;
          break;
        case "anisotropy_texture":
          t.anisotropy.texture = e;
          break;
        case "sheen_texture":
          t.sheen.texture = e;
          break;
        case "sheen_textureRoughness":
          t.sheen.textureRoughness = e;
          break;
        case "subSurface_thickness":
          t.subSurface.thicknessTexture = e;
          break;
        case "subSurface_translucencyIntensity":
          t.subSurface.translucencyIntensityTexture = e;
          break;
        case "subSurface_refractionIntensity":
          t.subSurface.refractionIntensityTexture = e;
          break;
      }
    else
      s === "Zakeke.PBRMaterial" && (t[`${n}Texture`] = e);
  }
  getSerializedMaterialTexture(e, t, n) {
    if (n === "BABYLON.StandardMaterial")
      return e[`${t}Texture`];
    if (n === "BABYLON.PBRMetallicRoughnessMaterial")
      return e[`${t}Texture`];
    if (n === "BABYLON.PBRSpecularGlossinessMaterial")
      return e[`${t}Texture`];
    if (n === "BABYLON.PBRMaterial")
      switch (t) {
        case "cameraColorGrading":
          return e.cameraColorGradingTexture;
        case "albedo":
        case "ambient":
        case "opacity":
        case "reflection":
        case "emissive":
        case "reflectivity":
        case "metallic":
        case "microSurface":
        case "bump":
        case "lightmap":
        case "refraction":
          return e[`${t}Texture`];
        case "environmentBRDF":
          return e.environmentBRDFTexture;
        case "clearCoat_texture":
          return e.clearCoat.texture;
        case "clearCoat_bump":
          return e.clearCoat.bumpTexture;
        case "clearCoat_tint":
          return e.clearCoat.tintTexture;
        case "clearCoat_textureRoughness":
          return e.clearCoat.textureRoughness;
        case "anisotropy_texture":
          return e.anisotropy.texture;
        case "sheen_texture":
          return e.sheen.texture;
        case "sheen_textureRoughness":
          return e.sheen.textureRoughness;
        case "subSurface_thickness":
          return e.subSurface.thicknessTexture;
        case "subSurface_translucencyIntensity":
          return e.subSurface.translucencyIntensityTexture;
        case "subSurface_refractionIntensity":
          return e.subSurface.refractionIntensityTexture;
      }
    else if (n === "Zakeke.PBRMaterial")
      return e[`${t}Texture`];
    return null;
  }
  getMaterialTypeName(e) {
    return e instanceof BABYLON.StandardMaterial ? "BABYLON.StandardMaterial" : e instanceof BABYLON.PBRMetallicRoughnessMaterial ? "BABYLON.PBRMetallicRoughnessMaterial" : e instanceof BABYLON.PBRSpecularGlossinessMaterial ? "BABYLON.PBRSpecularGlossinessMaterial" : e instanceof BABYLON.PBRMaterial ? "BABYLON.PBRMaterial" : e instanceof BABYLON.ShaderMaterial ? "BABYLON.ShaderMaterial" : e instanceof Zakeke.PBRMaterial ? "Zakeke.PBRMaterial" : "BABYLON.StandardMaterial";
  }
  async exportMeshToBabylon(e) {
    const t = this.getMeshHierarchy(e.id);
    return await this.exportMeshesToBabylon(t);
  }
  async exportMeshesToBabylon(e) {
    const t = this.getMeshesMaterials(e), n = e.map((o) => ({ id: o.id, doNotSerialize: o.doNotSerialize })), s = t.map((o) => ({ id: o.id, doNotSerialize: o.doNotSerialize }));
    e.forEach((o) => o.doNotSerialize = !1), t.forEach((o) => o.doNotSerialize = !1);
    try {
      const o = {};
      for (let _ = 0; _ < t.length; _++) {
        const x = t[_], B = x.id, P = this.getMaterialDynamicTextures(x);
        if (P.length > 0) {
          o[B] = {
            materialType: this.getMaterialTypeName(x),
            textures: []
          };
          for (let U = 0; U < P.length; U++) {
            const M = P[U], Z = Zakeke.generateUUID(), F = this.getMaterialTextureType(x, M), Q = await this.exportTextureToBase64Async(M, "image/png");
            if (F && Q) {
              const D = {
                id: Z,
                type: F,
                base64String: Q,
                isProcedural: M instanceof BABYLON.ProceduralTexture
              };
              o[B].textures.push(D);
            }
          }
        }
      }
      const h = BABYLON.SceneSerializer.SerializeMesh(e, !1, !1);
      for (const _ of h.materials) {
        const x = Object.getOwnPropertyNames(_).filter(
          (P) => P.slice(-7) === "Texture" && typeof _[P] == "object"
        ), B = _.id;
        if (o.hasOwnProperty(B)) {
          const P = o[B], U = P.materialType, M = P.textures;
          for (const Z of M) {
            const F = this.getSerializedMaterialTexture(
              _,
              Z.type,
              P.materialType
            );
            if (F) {
              if (Z.isProcedural) {
                const Q = new BABYLON.Texture(
                  Z.base64String,
                  this._scene,
                  void 0,
                  void 0,
                  void 0,
                  void 0
                );
                await Mn.whenTextureIsReadyAsync(Q), Q.uScale = F.uScale, Q.vScale = F.vScale, Q.uOffset = F.uOffset, Q.vOffset = F.vOffset, Q.uAng = F.uAng, Q.vAng = F.vAng, Q.level = F.level, Q.coordinatesIndex = F.coordinatesIndex, Q.coordinatesMode = F.coordinatesMode, Q.wrapU = F.wrapU, Q.wrapV = F.wrapV;
                const D = Q.serialize();
                D.url = Z.base64String, D.name = "prcedural texture", this.applyTextureOnSerializedMaterial(
                  D,
                  _,
                  Z.type,
                  U
                ), Q.dispose();
              }
            } else
              F.url = Z.base64String, F.name = "dynamic texture";
          }
        }
      }
      let c = JSON.stringify(h);
      return e.forEach((_) => {
        var x;
        return _.doNotSerialize = (x = n.find((B) => B.id === _.id)) == null ? void 0 : x.doNotSerialize;
      }), t.forEach(
        (_) => _.doNotSerialize = s.find((x) => x.id === _.id).doNotSerialize
      ), c;
    } finally {
      e.forEach((o) => {
        var h;
        return o.doNotSerialize = (h = n.find((c) => c.id === o.id)) == null ? void 0 : h.doNotSerialize;
      }), t.forEach(
        (o) => o.doNotSerialize = s.find((h) => h.id === o.id).doNotSerialize
      );
    }
  }
  async exportMeshesForTyOnToBabylon() {
    const e = this.getMeshesForTryOn();
    return await this.exportMeshesToBabylon(e);
  }
  downloadBlob(e) {
    const t = URL.createObjectURL(e), n = document.createElement("a");
    n.download = "mesh.json", n.href = t, n.click(), URL.revokeObjectURL(t);
  }
  async downloadMeshBabylonAsync(e) {
    const t = await this.exportMeshToBabylon(e);
    if (t) {
      const n = new Blob([t], { type: "application/json" });
      this.downloadBlob(n);
    }
  }
  async downloadMeshesBabylonAsync(e) {
    const t = await this.exportMeshesToBabylon(e);
    if (t) {
      const n = new Blob([t], { type: "application/json" });
      this.downloadBlob(n);
    }
  }
  async loadAllDelayedMaterialFromZip(e, t, n) {
    console.log("Loading delayed materials from zip");
    const s = e + `materials_${t}.zip`, h = await (await fetch(s)).blob(), c = new File([h], "materials.zip", { type: "application/zip" }), _ = new Wf();
    await _.loadAsync(c);
    const x = _.file(/\.json$/) || [], B = [], P = [];
    if (x.length === 0)
      throw console.warn("No material files found in the zip archive."), new Error("No material files found in the zip archive.");
    for (const [U, M] of x.entries()) {
      const Z = M.name.match(/material_\d+_(.*)\.json/);
      if (!Z)
        continue;
      const F = Z[1].replace(/_/g, "-");
      P.push(
        new Promise(async (Q, D) => {
          console.log("Loading material: " + F);
          try {
            const te = await M.async("string"), ee = JSON.parse(te), le = BABYLON.Material.Parse(ee, this._scene, e);
            le ? (le.metadata = le.metadata || {}, le.metadata.fromZip = !0, B.push(le), await (n == null ? void 0 : n(U + 1, x.length)), Q(le)) : D(new Error("Failed to parse material " + F));
          } catch (te) {
            D(te);
          }
        })
      );
    }
    return await Promise.all(P), B;
  }
  // In case loadAllDelayedMaterialAsync failed, we can cleanup all temporary materials.
  // They're recognized by the metadata property `fromZip` set to true.
  async cleanupAllTemporaryMaterialsAsync() {
    try {
      const e = this._scene.materials.filter((t) => {
        var n;
        return (n = t.metadata) == null ? void 0 : n.fromZip;
      });
      console.log("Cleaning up temporary materials loaded from zip, found:", e.length), e.forEach((t) => {
        t.dispose(!1, !0);
      });
    } catch (e) {
      console.warn("Error during cleanup of temporary materials:", e);
    }
  }
  async loadAllDelayedMaterialsAsync(e, t) {
    let n = [];
    if (this._scene && this._scene.metadata && this._scene.metadata.delayedMaterials) {
      var s = {};
      for (var o in this._scene.metadata.delayedMaterials)
        s[o] = {
          name: this._scene.metadata.delayedMaterials[o].name,
          file: this._scene.metadata.delayedMaterials[o].file
        };
      n = await this.loadMaterialsAsync(e, s, t);
    }
    return n;
  }
  async loadDelayedMaterialsAsync(e, t) {
    let n = [];
    if (this._scene && this._scene.metadata && this._scene.metadata.delayedMaterials) {
      for (var s = {}, o = 0; o < t.length; o++)
        this._scene.metadata.delayedMaterials.hasOwnProperty(t[o]) && (s[t[o]] = {
          name: this._scene.metadata.delayedMaterials[t[o]].name,
          file: this._scene.metadata.delayedMaterials[t[o]].file
        });
      n = await this.loadMaterialsAsync(e, s);
    }
    return n;
  }
  async loadDelayedMaterialAsync(e, t) {
    if (this._scene && this._scene.metadata && this._scene.metadata.delayedMaterials) {
      var n = {};
      if (this._scene.metadata.delayedMaterials.hasOwnProperty(t)) {
        n[t] = {
          name: this._scene.metadata.delayedMaterials[t].name,
          file: this._scene.metadata.delayedMaterials[t].file
        };
        let s = await this.loadMaterialsAsync(e, n);
        if (s.length > 0)
          return s[0];
      }
    }
    return null;
  }
  async loadMaterialsAsync(e, t, n) {
    const s = [];
    let o = [];
    for (let c in t) {
      const _ = this._scene.getMaterialByID(c);
      if (_)
        s.push(_);
      else {
        const x = t[c];
        o.push(this.loadMaterialInternalAsync(c, e, x.file));
      }
    }
    const h = await Promise.all(o);
    for (let c = 0; c < h.length; c++) {
      const _ = h[c], x = JSON.parse(_), B = BABYLON.Material.Parse(x, this._scene, e);
      B && (console.debug("Waiting for material ready: " + B.id + " - " + B.name), this._scene.useDelayedTextureLoading || await Mn.whenAllMaterialTexturesAreReady(B), Logger.info("Material ready: " + B.id + " - " + B.name), s.push(B), await (n == null ? void 0 : n(c + 1, h.length)));
    }
    return this.setupShaderMaterialsCameraPosition(), s;
  }
  loadMaterialInternalAsync(e, t, n) {
    if (Logger.info("Loading delayed material: " + e), this._loadingMaterials.hasOwnProperty(e))
      return this._loadingMaterials[e];
    let s = Ms.EndsWith(t, "/") ? "" : "/";
    var o = t + s + n;
    let h = new Promise((c, _) => {
      BABYLON.Tools.LoadFile(
        o,
        (x) => {
          Logger.info("Loaded delayed material: " + e), c(x), delete this._loadingMaterials[e];
        },
        void 0,
        void 0,
        !1,
        (x, B) => {
          _(B), delete this._loadingMaterials[e];
        }
      );
    });
    return this._loadingMaterials[e] = h, h;
  }
  showMesh(e) {
    this.showHideMesh(e, !0);
  }
  hideMesh(e) {
    this.showHideMesh(e, !1);
  }
  showHideMesh(e, t) {
    var n = (o, h) => {
      o.isVisible = h;
      var c = o.getChildMeshes(!0);
      c && c.forEach((_) => {
        n(_, h);
      });
    }, s = this._scene.getMeshById(e);
    s && n(s, t);
  }
  changeMaterialColor(e, t, n) {
    for (let s = 0; s < this._scene.meshes.length && this._scene.meshes[s].material !== e; s++)
      ;
    t && e[t] !== void 0 && (e[t] = n);
  }
  applyMaterialByName(e, t) {
    if (this._scene) {
      let n = this._scene.getMaterialByName(e);
      n && this.applyMaterial(n, t);
    }
  }
  applyMaterial(e, t) {
    var n = (s) => {
      if (s.subMeshes && s.subMeshes.length > 0 && s.material && s.material instanceof BABYLON.MultiMaterial)
        for (let h = 0; h < s.subMeshes.length; h++) {
          let c = s.subMeshes[h];
          this.applyMaterialToSubMesh(e, s, c);
        }
      else
        s.material = e;
      var o = s.getChildMeshes(!0);
      o && o.forEach((h) => {
        n(h);
      });
    };
    t && n(t);
  }
  applyMaterialToSubMeshByName(e, t, n) {
    var s = this._scene.getMaterialByName(e);
    s && this.applyMaterialToSubMesh(s, t, n);
  }
  applyMaterialToSubMesh(e, t, n) {
    const s = n.materialIndex, o = t || n.getMesh();
    o.material instanceof BABYLON.MultiMaterial && s >= 0 && s < o.material.subMaterials.length && (o.material.subMaterials[s] = e);
  }
  getSubMeshMaterial(e, t) {
    const n = t.materialIndex, s = e || t.getMesh();
    return s.material instanceof BABYLON.MultiMaterial && n >= 0 && n < s.material.subMaterials.length ? s.material.subMaterials[n] : null;
  }
  async prefetchTexturesFormMeshAsync(e) {
    e.material && await this.prefetchTexturesForMaterialAsync(e.material);
    var t = e.getChildMeshes(!0);
    for (let n = 0; n < t.length; n++) {
      let s = t[n];
      s.material && await this.prefetchTexturesForMaterialAsync(s.material);
    }
  }
  async prefetchTexturesForMaterialAsync(e) {
    if (e) {
      var t = this.getTexturesForMaterial(e);
      for (let n = 0; n < t.length; n++)
        await Mn.whenTextureIsReadyAsync(t[n]);
    }
  }
  checkDelayState(e) {
    e instanceof BABYLON.Mesh && e._checkDelayState();
    var t = e.getChildMeshes(!0);
    t.forEach((n) => this.checkDelayState(n));
  }
  // Crea una nuova mesh data da una minima espansione di quella passata in input
  // in modo che ne costituisca un rivestimento
  createEnvelopeMesh(e) {
    let t = 0.01;
    const n = e.getHierarchyBoundingVectors();
    if (n) {
      const o = n.min, h = n.max;
      t = new BABYLON.BoundingInfo(o, h).boundingSphere.radius * 5e-3;
    }
    const s = this.cloneMesh(e.id, !0, !0);
    return s && s instanceof BABYLON.Mesh && this.expandMesh(s, t), s;
  }
  expandMesh(e, t) {
    const n = new zx();
    if (e && e instanceof BABYLON.Mesh) {
      n.expandMesh(e, t);
      const s = e.getChildMeshes();
      for (const o of s)
        o instanceof BABYLON.Mesh && n.expandMesh(o, t);
    }
  }
  cloneMesh(e, t = !1, n = !1) {
    let s = null;
    if (this._scene) {
      const o = this._scene.getMeshById(e);
      if (o) {
        const h = this.getNextIncrementalName(o.name);
        if (s = o.clone(h, o.parent), s) {
          s.id = Zakeke.generateUUID(), t && this.duplicateGeometry(o, s, n);
          const c = s.getChildMeshes();
          for (const _ of c) {
            const x = this._scene.getMeshById(_.id);
            _.id = Zakeke.generateUUID();
            const B = _.parent ? _.parent.name : null;
            if (B) {
              const P = _.name.indexOf(B + ".") + B.length + 1;
              _.name = _.name.substr(P);
            }
            x && t && this.duplicateGeometry(x, _, n);
          }
        }
      }
    }
    return s;
  }
  duplicateGeometry(e, t, n = !1) {
    if (e instanceof BABYLON.Mesh && t instanceof BABYLON.Mesh) {
      const s = BABYLON.VertexData.ExtractFromMesh(e, !0, !0);
      return new BABYLON.Geometry(
        Zakeke.generateUUID(),
        t.getScene(),
        s,
        n,
        t
      );
    }
    return null;
  }
  // Material metadata
  getSceneMaterialMetadata(e) {
    return this._scene && this._scene.metadata && this._scene.metadata.materialsMetadata && this._scene.metadata.materialsMetadata.hasOwnProperty(e) ? this._scene.metadata.materialsMetadata[e] : null;
  }
  getOrCreateSceneMaterialMetadata(e) {
    let t = this.getSceneMaterialMetadata(e);
    return t || (t = {}, this._scene.metadata || (this._scene.metadata = {}), this._scene.metadata.materialsMetadata || (this._scene.metadata.materialsMetadata = {}), this._scene.metadata.materialsMetadata[e] = t), t;
  }
  removeSceneMaterialMetadata(e) {
    this._scene.metadata && this._scene.metadata.materialsMetadata && this._scene.metadata.materialsMetadata.hasOwnProperty(e) && delete this._scene.metadata.materialsMetadata[e];
  }
  offloadAllUnusedMaterials() {
    this.getAllUnusedMaterials().forEach((t) => this.offloadMaterial(t.id));
  }
  // Salva la serializzazione del materiale e lo rimuove dalla scena (eliminando anche le relative texture).
  // Lo scopo è quello di liberare la memoria occupata dalle texture
  offloadMaterial(e) {
    const t = this._scene.getMaterialByID(e);
    t && t.id !== "default material" && this.getMeshesUsingMaterial(e).length === 0 && (Logger.info("Offloading material: " + t.id + " - " + t.name), this._scene.metadata || (this._scene.metadata = {}), this._scene.metadata.offloadedMaterials || (this._scene.metadata.offloadedMaterials = {}), this._scene.metadata.offloadedMaterials[e] = this.getOffloadedMaterialInfo(t), Logger.info("Disposing material: " + e), t.dispose(!1, !0));
  }
  getOffloadedMaterialInfo(e) {
    return { name: e.name, data: e.serialize() };
  }
  // Il materiale restituito dalla versione sincrona potrebbe non essere pronto per l'applicazione alla mesh
  loadAllOffloadedMaterials(e) {
    let t = [];
    return this._scene && this._scene.metadata && this._scene.metadata.offloadedMaterials && (t = this.loadOffloadedMaterials(e, this._scene.metadata.offloadedMaterials)), t;
  }
  loadOffloadedMaterialsByIDs(e, t) {
    let n = [];
    if (this._scene && this._scene.metadata && this._scene.metadata.offloadedMaterials) {
      const s = {};
      for (let o = 0; o < t.length; o++)
        this._scene.metadata.offloadedMaterials.hasOwnProperty(t[o]) && (s[t[o]] = {
          name: this._scene.metadata.offloadedMaterials[t[o]].name,
          data: this._scene.metadata.offloadedMaterials[t[o]].data
        });
      n = this.loadOffloadedMaterials(e, s);
    }
    return n;
  }
  loadOffloadedMaterial(e, t) {
    if (this._scene && this._scene.metadata && this._scene.metadata.offloadedMaterials) {
      const n = {};
      if (this._scene.metadata.offloadedMaterials.hasOwnProperty(t)) {
        n[t] = {
          name: this._scene.metadata.offloadedMaterials[t].name,
          data: this._scene.metadata.offloadedMaterials[t].data
        };
        const s = this.loadOffloadedMaterials(e, n);
        if (s.length > 0)
          return s[0];
      }
    }
    return null;
  }
  loadOffloadedMaterials(e, t) {
    const n = [];
    for (const s in t) {
      const o = t[s], h = this.loadOffloadedMaterialInternal(s, o.name, e, o.data);
      h && n.push(h);
    }
    return n;
  }
  // Il nome viene passato solo ai fini del log
  loadOffloadedMaterialInternal(e, t, n, s) {
    const o = this._scene.getMaterialByID(e);
    if (o)
      return o;
    const h = t ? ` - ${t}` : "";
    return Logger.info("Loading offloaded material: " + e + h), BABYLON.Material.Parse(s, this._scene, n);
  }
  // Nella versione asincrona si aspetta che tutte le texture del materiale caricato siano pronte
  async loadAllOffloadedMaterialsAsync(e) {
    let t = [];
    return this._scene && this._scene.metadata && this._scene.metadata.offloadedMaterials && (t = await this.loadOffloadedMaterialsAsync(e, this._scene.metadata.offloadedMaterials)), t;
  }
  async loadOffloadedMaterialsByIDsAsync(e, t) {
    let n = [];
    if (this._scene && this._scene.metadata && this._scene.metadata.offloadedMaterials) {
      const s = {};
      for (let o = 0; o < t.length; o++)
        this._scene.metadata.offloadedMaterials.hasOwnProperty(t[o]) && (s[t[o]] = {
          name: this._scene.metadata.offloadedMaterials[t[o]].name,
          data: this._scene.metadata.offloadedMaterials[t[o]].data
        });
      n = await this.loadOffloadedMaterialsAsync(e, s);
    }
    return n;
  }
  async loadOffloadedMaterialAsync(e, t) {
    if (this._scene && this._scene.metadata && this._scene.metadata.offloadedMaterials) {
      const n = {};
      if (this._scene.metadata.offloadedMaterials.hasOwnProperty(t)) {
        n[t] = {
          name: this._scene.metadata.offloadedMaterials[t].name,
          data: this._scene.metadata.offloadedMaterials[t].data
        };
        const s = await this.loadOffloadedMaterialsAsync(e, n);
        if (s.length > 0)
          return s[0];
      }
    }
    return null;
  }
  async loadOffloadedMaterialsAsync(e, t) {
    const n = [], s = [];
    for (const h in t) {
      const c = t[h];
      s.push(this.loadOffloadedMaterialInternalAsync(h, c.name, e, c.data));
    }
    return (await Promise.all(s)).forEach((h) => {
      h && n.push(h);
    }), n;
  }
  // Il nome viene passato solo ai fini del log
  async loadOffloadedMaterialInternalAsync(e, t, n, s) {
    const o = this._scene.getMaterialByID(e);
    if (o)
      return o;
    const h = t ? ` - ${t}` : "";
    Logger.info("Loading offloaded material: " + e + h);
    const c = BABYLON.Material.Parse(s, this._scene, n);
    return c ? (Logger.info("Waiting for material ready: " + e + h), await Mn.whenAllMaterialTexturesAreReady(c), Logger.info("Material ready: " + e + h)) : Logger.info("No material was created from offloaded material: " + e + h), c;
  }
  loadTextureFiles(e, t) {
    if (e)
      for (let n = 0; n < t.length; n++) {
        const s = t[n], o = /^(?:\/|[a-z]+:\/\/)/.test(s);
        let h = s;
        o || (h = e + s);
        const c = h.lastIndexOf("."), _ = c > -1 ? h.substring(c).toLowerCase() : "";
        _ === ".dds" || _ === ".env" || _ === ".hdr" ? BABYLON.Tools.LoadFile(h, () => {
        }) : (_ === ".png" || _ === ".jpg") && BABYLON.Tools.LoadImage(
          h,
          (Z) => {
          },
          function() {
          },
          null
        );
      }
  }
  // Recupera il materiale specificato, eventualmente caricandolo da remoto (delayed) oppure dalla cache (offloaded)
  async getOrLoadMaterialAsync(e, t) {
    let n = this._scene.getMaterialByID(e);
    return !n && this._scene.metadata && (this._scene.metadata.offloadedMaterials && this._scene.metadata.offloadedMaterials.hasOwnProperty(e) ? n = await this.loadOffloadedMaterialAsync(t, e) : this._scene.metadata.delayedMaterials && this._scene.metadata.delayedMaterials.hasOwnProperty(e) && (n = await this.loadDelayedMaterialAsync(t, e))), n;
  }
  getOrCreateDummyMaterial() {
    let e = this._scene.getMaterialByID(this._dummyMaterialID);
    return e || (e = new BABYLON.StandardMaterial("Dummy Material", this._scene), e.id = this._dummyMaterialID, e.metadata = { isRealMaterial: !1 }), e;
  }
  isDummyMaterial(e) {
    return e.id === this._dummyMaterialID;
  }
  meshHasDummyMaterial(e, t) {
    var n;
    if (e.subMeshes && e.subMeshes.length > 0 && e.material && e.material instanceof BABYLON.MultiMaterial)
      for (let s = 0; s < e.subMeshes.length; s++) {
        const h = e.subMeshes[s].materialIndex;
        if (e.material.subMaterials[h] && ((n = e.material.subMaterials[h]) == null ? void 0 : n.id) === this._dummyMaterialID)
          return !0;
      }
    else if (e.material && e.material.id === this._dummyMaterialID)
      return !0;
    if (t) {
      const s = e.getChildMeshes(!0);
      for (const o of s)
        if (this.meshHasDummyMaterial(o, !0))
          return !0;
    }
    return !1;
  }
  getMeshDelayedMaterialIDs(e) {
    var n;
    const t = [];
    if (e.subMeshes && e.subMeshes.length > 0 && e.material && e.material instanceof BABYLON.MultiMaterial)
      for (let s = 0; s < e.subMeshes.length; s++) {
        const h = e.subMeshes[s].materialIndex;
        if (e.material.subMaterials[h] && ((n = e.material.subMaterials[h]) == null ? void 0 : n.id) === this._dummyMaterialID) {
          const c = `${e.id}_${h}`;
          if (this._scene.metadata && this._scene.metadata.originalMeshMaterials.hasOwnProperty(c)) {
            const _ = this._scene.metadata.originalMeshMaterials[c];
            this._scene.metadata.delayedMaterials.hasOwnProperty(_) && t.indexOf(_) === -1 && t.push(_);
          }
        }
      }
    else if (e.material && e.material.id === this._dummyMaterialID && this._scene.metadata && this._scene.metadata.delayedMaterials && this._scene.metadata.originalMeshMaterials.hasOwnProperty(e.id)) {
      const s = this._scene.metadata.originalMeshMaterials[e.id];
      this._scene.metadata.delayedMaterials.hasOwnProperty(s) && t.indexOf(s) === -1 && t.push(s);
    }
    return e.getChildMeshes().forEach(
      (s) => Array.prototype.push.apply(t, this.getMeshDelayedMaterialIDs(s))
    ), t;
  }
  getMeshOffloadedMaterialIDs(e) {
    var n;
    const t = [];
    if (e.subMeshes && e.subMeshes.length > 0 && e.material && e.material instanceof BABYLON.MultiMaterial)
      for (let s = 0; s < e.subMeshes.length; s++) {
        const h = e.subMeshes[s].materialIndex;
        if (e.material.subMaterials[h] && ((n = e.material.subMaterials[h]) == null ? void 0 : n.id) === this._dummyMaterialID) {
          const c = `${e.id}_${h}`;
          if (this._scene.metadata && this._scene.metadata.originalMeshMaterials.hasOwnProperty(c)) {
            const _ = this._scene.metadata.originalMeshMaterials[c];
            this._scene.metadata.offloadedMaterials.hasOwnProperty(_) && t.indexOf(_) === -1 && t.push(_);
          }
        }
      }
    else if (e.material && e.material.id === this._dummyMaterialID && this._scene.metadata && this._scene.metadata.offloadedMaterials && this._scene.metadata.originalMeshMaterials.hasOwnProperty(e.id)) {
      const s = this._scene.metadata.originalMeshMaterials[e.id];
      this._scene.metadata.offloadedMaterials.hasOwnProperty(s) && t.indexOf(s) === -1 && t.push(s);
    }
    return e.getChildMeshes().forEach(
      (s) => Array.prototype.push.apply(t, this.getMeshOffloadedMaterialIDs(s))
    ), t;
  }
  setDummyMaterialToInvisibleMeshes() {
    this.getInvisibleMeshes().forEach((t) => {
      this.setMeshDummyMaterial(t, !1);
    });
  }
  setMeshDummyMaterial(e, t) {
    this._scene.metadata || (this._scene.metadata = {}), this._scene.metadata.originalMeshMaterials || (this._scene.metadata.originalMeshMaterials = {});
    const n = this.getOrCreateDummyMaterial();
    if (e.material)
      if (e.subMeshes && e.subMeshes.length > 0 && e.material instanceof BABYLON.MultiMaterial)
        for (let s = 0; s < e.subMeshes.length; s++) {
          const h = e.subMeshes[s].materialIndex, c = e.material.subMaterials[h];
          if (c && !this.isDummyMaterial(c)) {
            const _ = `${e.id}_${h}`;
            this._scene.metadata.originalMeshMaterials[_] = c.id, e.material.subMaterials[h] = n;
          }
        }
      else
        e.material && !this.isDummyMaterial(e.material) && (this._scene.metadata.originalMeshMaterials[e.id] = e.material.id, e.material = n);
    t && e.getChildMeshes().forEach((s) => this.setMeshDummyMaterial(s, !0));
  }
  // Il metodo è sincrono perché mi aspetto che tutti i materiali originali siano già presenti nella scena
  unsetAllDummyMaterials() {
    for (let e = 0; e < this._scene.meshes.length; e++)
      this.unsetMeshDummyMaterial(this._scene.meshes[e], !1);
  }
  // Il metodo è asincrono perché ci sia aspetta che non tutti i materiali siano presenti nella scena, in qual caso verranno caricati
  async unsetAllDummyMaterialsAsync(e) {
    for (let t = 0; t < this._scene.meshes.length; t++)
      await this.unsetMeshDummyMaterialAsync(this._scene.meshes[t], e, !1);
  }
  // Il metodo è sincrono perché mi aspetto che i materiali originali siano tutti gà presenti nella scena
  unsetMeshDummyMaterial(e, t) {
    var n;
    if (this._scene.metadata && this._scene.metadata.originalMeshMaterials) {
      if (e.subMeshes && e.subMeshes.length > 0 && e.material && e.material instanceof BABYLON.MultiMaterial)
        for (let s = 0; s < e.subMeshes.length; s++) {
          const h = e.subMeshes[s].materialIndex;
          if (e.material.subMaterials[h] && ((n = e.material.subMaterials[h]) == null ? void 0 : n.id) === this._dummyMaterialID) {
            const c = `${e.id}_${h}`;
            if (this._scene.metadata.originalMeshMaterials.hasOwnProperty(c)) {
              const _ = this._scene.metadata.originalMeshMaterials[c], x = this._scene.getMaterialByID(_);
              x && (e.material.subMaterials[h] = x, delete this._scene.metadata.originalMeshMaterials[c]);
            }
          }
        }
      else if (e.material && e.material.id === this._dummyMaterialID && this._scene.metadata && this._scene.metadata.originalMeshMaterials.hasOwnProperty(e.id)) {
        const s = this._scene.metadata.originalMeshMaterials[e.id], o = this._scene.getMaterialByID(s);
        o && (e.material = o, delete this._scene.metadata.originalMeshMaterials[e.id]);
      }
      t && e.getChildMeshes().forEach((s) => this.unsetMeshDummyMaterial(s, !0));
    }
  }
  // Il metodo è asincrono perché ci si aspetta che non tutti i materiali siano presenti sulla scena, nel qual caso verranno caricati
  async unsetMeshDummyMaterialAsync(e, t, n) {
    var s;
    if (this._scene.metadata && this._scene.metadata.originalMeshMaterials) {
      if (e.subMeshes && e.subMeshes.length > 0 && e.material && e.material instanceof BABYLON.MultiMaterial)
        for (let o = 0; o < e.subMeshes.length; o++) {
          const c = e.subMeshes[o].materialIndex;
          if (e.material.subMaterials[c] && ((s = e.material.subMaterials[c]) == null ? void 0 : s.id) === this._dummyMaterialID) {
            const _ = `${e.id}_${c}`;
            if (this._scene.metadata.originalMeshMaterials.hasOwnProperty(_)) {
              const x = this._scene.metadata.originalMeshMaterials[_], B = await this.getOrLoadMaterialAsync(x, t);
              e.material.subMaterials[c] = B, delete this._scene.metadata.originalMeshMaterials[_];
            }
          }
        }
      else if (e.material && e.material.id === this._dummyMaterialID && this._scene.metadata && this._scene.metadata.originalMeshMaterials.hasOwnProperty(e.id)) {
        const o = this._scene.metadata.originalMeshMaterials[e.id], h = await this.getOrLoadMaterialAsync(o, t);
        e.material = h, delete this._scene.metadata.originalMeshMaterials[e.id];
      }
      if (n) {
        const o = e.getChildMeshes();
        for (const h of o)
          await this.unsetMeshDummyMaterialAsync(h, t, !0);
      }
    }
  }
  async reloadAllLoadingErrorTexturesAsync(e) {
    for (const t of this._scene.textures)
      await this.reloadLoadingErrorTextureAsync(e, t);
  }
  async reloadMaterialLoadingErrorTexturesAsync(e, t) {
    for (const n of t.getActiveTextures())
      await this.reloadLoadingErrorTextureAsync(e, n);
  }
  reloadLoadingErrorTextureAsync(e, t) {
    if (t instanceof BABYLON.Texture && t.url) {
      const s = t.getInternalTexture();
      if (t.loadingError || s && s.loadingError) {
        const o = t.url, h = /^(?:\/|[a-z]+:\/\/)/.test(t.url);
        var n = t.url;
        return h || (n = e + t.url), new Promise((c, _) => {
          t.updateURL(
            n,
            null,
            () => {
              t.url = o, c();
            },
            void 0,
            () => {
              t.url = o, _();
            }
          );
        });
      }
    }
    return Promise.resolve();
  }
  isTextureLoadingError(e) {
    if (e.loadingError)
      return !0;
    const t = e.getInternalTexture();
    return t !== null && t.loadingError;
  }
  materialHasLoadingErrorTextues(e) {
    return e.getActiveTextures().some((t) => this.isTextureLoadingError(t));
  }
  // A dynamic texture is a procedural texture or a texture created from a Blob
  getMaterialDynamicTextures(e) {
    return e.getActiveTextures().filter(
      (n) => n instanceof BABYLON.ProceduralTexture || n instanceof BABYLON.Texture && n.url && n.url.indexOf("blob:") !== -1
    );
  }
  exportTextureToBase64Async(e, t = "image/png", n = !1) {
    return Promise.resolve().then(async () => {
      const s = await this.getPixelsFromTexture(e);
      if (!s)
        return null;
      const o = e.getSize();
      if (e.mimeType)
        switch (e.mimeType) {
          case "image/jpeg":
            t = "image/jpeg";
            break;
          case "image/png":
            t = "image/png";
            break;
        }
      return this.createBase64FromCanvasAsync(s, o.width, o.height, t, n);
    });
  }
  createBase64FromCanvasAsync(e, t, n, s, o = !1) {
    return new Promise(async (h, c) => {
      const _ = BABYLON.Constants.TEXTURETYPE_UNSIGNED_INT, x = this._scene, B = x.getEngine(), P = B.createRawTexture(
        e,
        t,
        n,
        BABYLON.Constants.TEXTUREFORMAT_RGBA,
        !1,
        o,
        BABYLON.Texture.NEAREST_SAMPLINGMODE,
        null,
        _
      );
      await BABYLON.TextureTools.ApplyPostProcess(
        "pass",
        P,
        x,
        _,
        BABYLON.Constants.TEXTURE_NEAREST_SAMPLINGMODE,
        BABYLON.Constants.TEXTUREFORMAT_RGBA
      );
      const U = await B._readTexturePixels(P, t, n), M = await BABYLON.Tools.DumpDataAsync(
        t,
        n,
        U,
        s,
        void 0,
        !0,
        !1
      );
      h(M);
    });
  }
  getPixelsFromTexture(e) {
    return e.textureType === BABYLON.Constants.TEXTURETYPE_UNSIGNED_INT, e.readPixels();
  }
  comparePBRMaterials(e, t) {
    (e.albedoColor && !t.albedoColor || !e.albedoColor && t.albedoColor || e.albedoColor && t.albedoColor && !e.albedoColor.equals(t.albedoColor)) && console.log("albedoColor"), e.allowShaderHotSwapping !== t.allowShaderHotSwapping && console.log("allowShaderHotSwapping"), e.alphaCutOff !== t.alphaCutOff && console.log("alphaCutOff"), (e.ambientColor && !t.ambientColor || !e.ambientColor && t.ambientColor || e.ambientColor && t.ambientColor && !e.ambientColor.equals(t.ambientColor)) && console.log("ambientColor"), e.ambientTextureStrength !== t.ambientTextureStrength && console.log("ambientTextureStrength"), this.compareAnisotropy(e.anisotropy, t.anisotropy), this.compareBRDF(e.brdf, t.brdf), this.compareClearCoat(e.clearCoat, t.clearCoat), e.depthFunction !== t.depthFunction && console.log("depthFunction"), this.compareDetailMap(e.detailMap, t.detailMap), e.directIntensity !== t.directIntensity && console.log("directIntensity"), e.disableBumpMap !== t.disableBumpMap && console.log("disableBumpMap"), e.disableColorWrite !== t.disableColorWrite && console.log("disableColorWrite"), e.disableDepthWrite !== t.disableDepthWrite && console.log("disableDepthWrite"), e.disableLighting !== t.disableLighting && console.log("disableLighting"), (e.emissiveColor && !t.emissiveColor || !e.emissiveColor && t.emissiveColor || e.emissiveColor && t.emissiveColor && !e.emissiveColor.equals(t.emissiveColor)) && console.log("emissiveColor"), e.emissiveIntensity !== t.emissiveIntensity && console.log("emissiveIntensity"), e.enableSpecularAntiAliasing !== t.enableSpecularAntiAliasing && console.log("enableSpecularAntiAliasing"), e.environmentIntensity !== t.environmentIntensity && console.log("environmentIntensity"), e.forceAlphaTest !== t.forceAlphaTest && console.log("forceAlphaTest"), e.forceDepthWrite !== t.forceDepthWrite && console.log("forceDepthWrite"), e.forceIrradianceInFragment !== t.forceIrradianceInFragment && console.log("forceIrradianceInFragment"), e.forceNormalForward !== t.forceNormalForward && console.log("forceNormalForward"), e.invertNormalMapX !== t.invertNormalMapX && console.log("invertNormalMapX"), e.invertNormalMapY !== t.invertNormalMapY && console.log("invertNormalMapY"), e.maxSimultaneousLights !== t.maxSimultaneousLights && console.log("maxSimultaneousLights"), e.metallic !== t.metallic && console.log("metallic"), e.metallicF0Factor !== t.metallicF0Factor && console.log("metallicF0Factor"), (e.metallicReflectanceColor && !t.metallicReflectanceColor || !e.metallicReflectanceColor && t.metallicReflectanceColor || e.metallicReflectanceColor && t.metallicReflectanceColor && !e.metallicReflectanceColor.equals(t.metallicReflectanceColor)) && console.log("metallicReflectanceColor"), e.microSurface !== t.microSurface && console.log("microSurface"), e.parallaxScaleBias !== t.parallaxScaleBias && console.log("parallaxScaleBias"), e.pointSize !== t.pointSize && console.log("pointSize"), this.comparePrePassConfiguration(e.prePassConfiguration, t.prePassConfiguration), (e.reflectionColor && !t.reflectionColor || !e.reflectionColor && t.reflectionColor || e.reflectionColor && t.reflectionColor && !e.reflectionColor.equals(t.reflectionColor)) && console.log("reflectionColor"), (e.reflectivityColor && !t.reflectivityColor || !e.reflectivityColor && t.reflectivityColor || e.reflectivityColor && t.reflectivityColor && !e.reflectivityColor.equals(t.reflectivityColor)) && console.log("reflectivityColor"), e.roughness !== t.roughness && console.log("roughness"), e.separateCullingPass !== t.separateCullingPass && console.log("separateCullingPass"), this.compareSheen(e.sheen, t.sheen), e.sideOrientation !== t.sideOrientation && console.log("sideOrientation"), e.specularIntensity !== t.specularIntensity && console.log("specularIntensity"), this.compareSubSurface(e.subSurface, t.subSurface), e.twoSidedLighting !== t.twoSidedLighting && console.log("twoSidedLighting"), e.unlit !== t.unlit && console.log("unlit"), e.useAlphaFresnel !== t.useAlphaFresnel && console.log("useAlphaFresnel"), e.useAlphaFromAlbedoTexture !== t.useAlphaFromAlbedoTexture && console.log("useAlphaFromAlbedoTexture"), e.useAmbientInGrayScale !== t.useAmbientInGrayScale && console.log("useAmbientInGrayScale"), e.useAmbientOcclusionFromMetallicTextureRed !== t.useAmbientOcclusionFromMetallicTextureRed && console.log("useAmbientOcclusionFromMetallicTextureRed"), e.useAutoMicroSurfaceFromReflectivityMap !== t.useAutoMicroSurfaceFromReflectivityMap && console.log("useAutoMicroSurfaceFromReflectivityMap"), e.useHorizonOcclusion !== t.useHorizonOcclusion && console.log("useHorizonOcclusion"), e.useLightmapAsShadowmap !== t.useLightmapAsShadowmap && console.log("useLightmapAsShadowmap"), e.useLinearAlphaFresnel !== t.useLinearAlphaFresnel && console.log("useLinearAlphaFresnel"), e.useMetallnessFromMetallicTextureBlue !== t.useMetallnessFromMetallicTextureBlue && console.log("useMetallnessFromMetallicTextureBlue"), e.useMicroSurfaceFromReflectivityMapAlpha !== t.useMicroSurfaceFromReflectivityMapAlpha && console.log("useMicroSurfaceFromReflectivityMapAlpha"), e.useObjectSpaceNormalMap !== t.useObjectSpaceNormalMap && console.log("useObjectSpaceNormalMap"), e.useOnlyMetallicFromMetallicReflectanceTexture !== t.useOnlyMetallicFromMetallicReflectanceTexture && console.log("useOnlyMetallicFromMetallicReflectanceTexture"), e.useParallax !== t.useParallax && console.log("useParallax"), e.useParallaxOcclusion !== t.useParallaxOcclusion && console.log("useParallaxOcclusion"), e.useRadianceOcclusion !== t.useRadianceOcclusion && console.log("useRadianceOcclusion"), e.useRadianceOverAlpha !== t.useRadianceOverAlpha && console.log("useRadianceOverAlpha"), e.useRoughnessFromMetallicTextureAlpha !== t.useRoughnessFromMetallicTextureAlpha && console.log("useRoughnessFromMetallicTextureAlpha"), e.useRoughnessFromMetallicTextureGreen !== t.useRoughnessFromMetallicTextureGreen && console.log("useRoughnessFromMetallicTextureGreen"), e.useSpecularOverAlpha !== t.useSpecularOverAlpha && console.log("useSpecularOverAlpha"), e.zOffset !== t.zOffset && console.log("zOffset"), e.zOffsetUnits !== t.zOffsetUnits && console.log("zOffsetUnits"), e.alpha !== t.alpha && console.log("alpha"), e.alphaMode !== t.alphaMode && console.log("alphaMode"), e.backFaceCulling !== t.backFaceCulling && console.log("backFaceCulling"), this.compareCameraCurve("", e.cameraColorCurves, t.cameraColorCurves), e.cameraColorCurvesEnabled !== t.cameraColorCurvesEnabled && console.log("cameraColorCurvesEnabled"), e.cameraColorGradingEnabled !== t.cameraColorGradingEnabled && console.log("cameraColorGradingEnabled"), e.cameraContrast !== t.cameraContrast && console.log("cameraContrast"), e.cameraExposure !== t.cameraExposure && console.log("cameraExposure"), e.cameraToneMappingEnabled !== t.cameraToneMappingEnabled && console.log("cameraToneMappingEnabled"), e.canRenderToMRT !== t.canRenderToMRT && console.log("canRenderToMRT"), e.cullBackFaces !== t.cullBackFaces && console.log("cullBackFaces"), e.fillMode !== t.fillMode && console.log("fillMode"), e.fogEnabled !== t.fogEnabled && console.log("fogEnabled"), e.hasRenderTargetTextures !== t.hasRenderTargetTextures && console.log("hasRenderTargetTextures"), this.compareImageProcessingConfiguration(e.imageProcessingConfiguration, t.imageProcessingConfiguration), e.indexOfRefraction !== t.indexOfRefraction && console.log("indexOfRefraction"), e.invertRefractionY !== t.invertRefractionY && console.log("invertRefractionY"), e.isFrozen !== t.isFrozen && console.log("isFrozen"), e.isPrePassCapable !== t.isPrePassCapable && console.log("isPrePassCapable"), e.linkRefractionWithTransparency !== t.linkRefractionWithTransparency && console.log("linkRefractionWithTransparency"), e.needDepthPrePass !== t.needDepthPrePass && console.log("needDepthPrePass"), e.realTimeFiltering !== t.realTimeFiltering && console.log("realTimeFiltering"), e.realTimeFilteringQuality !== t.realTimeFilteringQuality && console.log("realTimeFilteringQuality"), e.transparencyMode !== t.transparencyMode && console.log("transparencyMode"), e.useGLTFLightFalloff !== t.useGLTFLightFalloff && console.log("useGLTFLightFalloff"), e.useLogarithmicDepth !== t.useLogarithmicDepth && console.log("useLogarithmicDepth"), e.usePhysicalLightFalloff !== t.usePhysicalLightFalloff && console.log("usePhysicalLightFalloff"), this.compareTexture("albedo", e.albedoTexture, t.albedoTexture), this.compareTexture("emissive", e.emissiveTexture, t.emissiveTexture);
  }
  compareAnisotropy(e, t) {
    const n = "anisotropy";
    (e.direction && !t.direction || !e.direction && t.direction || e.direction && t.direction && !e.direction.equals(t.direction)) && console.log(n + " - direction"), e.intensity !== t.intensity && console.log(n + " - intensity"), e.isEnabled !== t.isEnabled && console.log(n + " - isEnabled");
  }
  compareBRDF(e, t) {
    const n = "brdf";
    e.useEnergyConservation !== t.useEnergyConservation && console.log(n + " - useEnergyConservation"), e.useSmithVisibilityHeightCorrelated !== t.useSmithVisibilityHeightCorrelated && console.log(n + " - useSmithVisibilityHeightCorrelated"), e.useSpecularGlossinessInputEnergyConservation !== t.useSpecularGlossinessInputEnergyConservation && console.log(n + " - useSpecularGlossinessInputEnergyConservation"), e.useSphericalHarmonics !== t.useSphericalHarmonics && console.log(n + " - useSphericalHarmonics");
  }
  compareClearCoat(e, t) {
    const n = "clearCoat";
    e.indexOfRefraction !== t.indexOfRefraction && console.log(n + " - indexOfRefraction"), e.intensity !== t.intensity && console.log(n + " - intensity"), e.isEnabled !== t.isEnabled && console.log(n + " - isEnabled"), e.isTintEnabled !== t.isTintEnabled && console.log(n + " - isTintEnabled"), e.roughness !== t.roughness && console.log(n + " - roughness"), (e.tintColor && !t.tintColor || !e.tintColor && t.tintColor || e.tintColor && t.tintColor && !e.tintColor.equals(t.tintColor)) && console.log(n + " - tintColor"), e.tintColorAtDistance !== t.tintColorAtDistance && console.log(n + " - tintColorAtDistance"), e.tintThickness !== t.tintThickness && console.log(n + " - tintThickness"), e.useRoughnessFromMainTexture != t.useRoughnessFromMainTexture && console.log(n + " - useRoughnessFromMainTexture");
  }
  compareDetailMap(e, t) {
    const n = "detailMap";
    e.bumpLevel !== t.bumpLevel && console.log(n + " - bumpLevel"), e.diffuseBlendLevel !== t.diffuseBlendLevel && console.log(n + " - diffuseBlendLevel"), e.isEnabled !== t.isEnabled && console.log(n + " - isEnabled"), e.normalBlendMethod !== t.normalBlendMethod && console.log(n + " - normalBlendMethod"), e.roughnessBlendLevel !== t.roughnessBlendLevel && console.log(n + " - roughnessBlendLevel");
  }
  comparePrePassConfiguration(e, t) {
    const n = "PrePassConfiguration";
    (e.currentViewProjection && !t.currentViewProjection || !e.currentViewProjection && t.currentViewProjection || e.currentViewProjection && t.currentViewProjection && !e.currentViewProjection.equals(t.currentViewProjection)) && console.log(n + " - currentViewProjection"), (e.previousViewProjection && !t.previousViewProjection || !e.previousViewProjection && t.previousViewProjection || e.previousViewProjection && t.previousViewProjection && !e.previousViewProjection.equals(t.previousViewProjection)) && console.log(n + " - previousViewProjection");
  }
  compareSheen(e, t) {
    const n = "Sheen";
    e.albedoScaling !== t.albedoScaling && console.log(n + " - albedoScaling"), (e.color && !t.color || !e.color && t.color || e.color && t.color && !e.color.equals(t.color)) && console.log(n + " - color"), e.intensity !== t.intensity && console.log(n + " - intensity"), e.isEnabled !== t.isEnabled && console.log(n + " - isEnabled"), e.linkSheenWithAlbedo !== t.linkSheenWithAlbedo && console.log(n + " - linkSheenWithAlbedo"), e.roughness !== t.roughness && console.log(n + " - roughness"), e.useRoughnessFromMainTexture !== t.useRoughnessFromMainTexture && console.log(n + " - useRoughnessFromMainTexture");
  }
  compareSubSurface(e, t) {
    const n = "SubSurface";
    (e.diffusionDistance && !t.diffusionDistance || !e.diffusionDistance && t.diffusionDistance || e.diffusionDistance && t.diffusionDistance && !e.diffusionDistance.equals(t.diffusionDistance)) && console.log(n + " - diffusionDistance"), e.indexOfRefraction !== t.indexOfRefraction && console.log(n + " - indexOfRefraction"), e.invertRefractionY !== t.invertRefractionY && console.log(n + " - invertRefractionY"), e.isRefractionEnabled !== t.isRefractionEnabled && console.log(n + " - isRefractionEnabled"), e.isScatteringEnabled !== t.isScatteringEnabled && console.log(n + " - isScatteringEnabled"), e.isTranslucencyEnabled !== t.isTranslucencyEnabled && console.log(n + " - isTranslucencyEnabled"), e.linkRefractionWithTransparency !== t.linkRefractionWithTransparency && console.log(n + " - linkRefractionWithTransparency"), e.maximumThickness !== t.maximumThickness && console.log(n + " - maximumThickness"), e.minimumThickness !== t.minimumThickness && console.log(n + " - minimumThickness"), e.refractionIntensity !== t.refractionIntensity && console.log(n + " - refractionIntensity"), (e.tintColor && !t.tintColor || !e.tintColor && t.tintColor || e.tintColor && t.tintColor && !e.tintColor.equals(t.tintColor)) && console.log(n + " - tintColor"), e.tintColorAtDistance !== t.tintColorAtDistance && console.log(n + " - tintColorAtDistance"), e.translucencyIntensity !== t.translucencyIntensity && console.log(n + " - translucencyIntensity"), e.useAlbedoToTintRefraction !== t.useAlbedoToTintRefraction && console.log(n + " - useAlbedoToTintRefraction"), e.useAlbedoToTintTranslucency !== t.useAlbedoToTintTranslucency && console.log(n + " - useAlbedoToTintTranslucency"), e.useGltfStyleTextures !== t.useGltfStyleTextures && console.log(n + " - useGltfStyleTextures"), e.useMaskFromThicknessTexture !== t.useMaskFromThicknessTexture && console.log(n + " - useMaskFromThicknessTexture"), e.useThicknessAsDepth !== t.useThicknessAsDepth && console.log(n + " - useThicknessAsDepth");
  }
  compareCameraCurve(e, t, n) {
    if ((t === null && n !== null || t !== null && n === null) && console.log("cameraColorCurves"), t && n) {
      const s = e ? e + " - cameraColorCurves" : "cameraColorCurves";
      t.globalDensity !== n.globalDensity && console.log(s + " - globalDensity"), t.globalExposure !== n.globalExposure && console.log(s + "- globalExposure"), t.globalHue !== n.globalHue && console.log(s + " - globalHue"), t.globalSaturation !== n.globalSaturation && console.log(s + " - globalSaturation"), t.highlightsDensity !== n.highlightsDensity && console.log(s + " - highlightsDensity"), t.highlightsExposure !== n.highlightsExposure && console.log(s + " - highlightsExposure"), t.highlightsHue !== n.highlightsHue && console.log(s + " - highlightsHue"), t.highlightsSaturation !== n.highlightsSaturation && console.log(s + " - highlightsSaturation"), t.midtonesDensity !== n.midtonesDensity && console.log(s + " - midtonesDensity"), t.midtonesExposure !== n.midtonesExposure && console.log(s + " - midtonesExposure"), t.midtonesHue !== n.midtonesHue && console.log(s + " - midtonesHue"), t.midtonesSaturation !== n.midtonesSaturation && console.log(s + " - midtonesSaturation"), t.shadowsDensity !== n.shadowsDensity && console.log(s + " - shadowsDensity"), t.shadowsExposure !== n.shadowsExposure && console.log(s + " - shadowsExposure"), t.shadowsHue !== n.shadowsHue && console.log(s + " - shadowsHue"), t.shadowsSaturation !== n.shadowsSaturation && console.log(s + " - shadowsSaturation");
    }
  }
  compareImageProcessingConfiguration(e, t) {
    const n = "imageProcessingConfiguration";
    this.compareCameraCurve(n, e.colorCurves, t.colorCurves), e.vignetteCameraFov !== t.vignetteCameraFov && console.log(n + " - vignetteCameraFov"), e.vignetteCentreX !== t.vignetteCentreX && console.log(n + " - vignetteCentreX"), e.vignetteCentreY !== t.vignetteCentreY && console.log(n + " - vignetteCentreY"), (e.vignetteColor && !t.vignetteColor || !e.vignetteColor && t.vignetteColor || e.vignetteColor && t.vignetteColor && !e.vignetteColor.equals(t.vignetteColor)) && console.log(n + " - vignetteColor"), e.vignetteStretch !== t.vignetteStretch && console.log(n + " - vignetteStretch"), e.vignetteWeight !== t.vignetteWeight && console.log(n + " - vignetteWeight"), e.applyByPostProcess !== t.applyByPostProcess && console.log(n + " - applyByPostProcess"), e.colorCurvesEnabled !== t.colorCurvesEnabled && console.log(n + " - colorCurvesEnabled"), e.colorGradingBGR !== t.colorGradingBGR && console.log(n + " - colorGradingBGR"), e.colorGradingEnabled !== t.colorGradingEnabled && console.log(n + " - colorGradingEnabled"), e.colorGradingWithGreenDepth !== t.colorGradingWithGreenDepth && console.log(n + " - colorGradingWithGreenDepth"), e.contrast !== t.contrast && console.log(n + " - contrast"), e.exposure !== t.exposure && console.log(n + " - exposure"), e.isEnabled !== t.isEnabled && console.log(n + " - isEnabled"), e.toneMappingEnabled !== t.toneMappingEnabled && console.log(n + " - toneMappingEnabled"), e.toneMappingType !== t.toneMappingType && console.log(n + " - toneMappingType"), e.vignetteBlendMode !== t.vignetteBlendMode && console.log(n + " - vignetteBlendMode"), e.vignetteEnabled !== t.vignetteEnabled && console.log(n + " - vignetteEnabled");
  }
  compareTexture(e, t, n) {
    if (t && !n || !t && n) {
      console.log(e);
      return;
    }
    if (t instanceof BABYLON.Texture && !(n instanceof BABYLON.Texture) || n instanceof BABYLON.Texture && !(t instanceof BABYLON.Texture)) {
      console.log(e);
      return;
    }
    t && n && (t.anisotropicFilteringLevel !== n.anisotropicFilteringLevel && console.log(e + " - anisotropicFilteringLevel"), t instanceof BABYLON.Texture && n instanceof BABYLON.Texture && (t.homogeneousRotationInUVTransform !== n.homogeneousRotationInUVTransform && console.log(e + " - homogeneousRotationInUVTransform"), t.uAng !== n.uAng && console.log(e + " - uAng"), t.uOffset !== n.uOffset && console.log(e + " - uOffset"), t.uRotationCenter !== n.uRotationCenter && console.log(e + " - uRotationCenterSearch"), t.uScale !== n.uScale && console.log(e + " - uScale"), t.vAng !== n.vAng && console.log(e + " - vAng"), t.vOffset !== n.vOffset && console.log(e + " - vOffset"), t.vRotationCenter !== n.vRotationCenter && console.log(e + " - vRotationCenterSearch"), t.vScale !== n.vScale && console.log(e + " - vScale"), t.wAng !== n.wAng && console.log(e + " - wAng"), t.wRotationCenter !== n.wRotationCenter && console.log(e + " - wRotationCenterSearch"), t.invertY !== n.invertY && console.log(e + " - invertY"), t.mimeType !== n.mimeType && console.log(e + " - mimeType")), t.invertZ !== n.invertZ && console.log(e + " - invertZ"), t.isRenderTarget !== n.isRenderTarget && console.log(e + " - isRenderTarget"), t.level !== n.level && console.log(e + " - level"), t.wrapR !== n.wrapR && console.log(e + " - wrapR"), t.canRescale !== n.canRescale && console.log(e + " - canRescale"), t.coordinatesIndex !== n.coordinatesIndex && console.log(e + " - coordinatesIndex"), t.coordinatesMode !== n.coordinatesMode && console.log(e + " - coordinatesMode"), t.gammaSpace !== n.gammaSpace && console.log(e + " - gammaSpace"), t.getAlphaFromRGB !== n.getAlphaFromRGB && console.log(e + " - getAlphaFromRGB"), t.hasAlpha !== n.hasAlpha && console.log(e + "- hasAlpha"), t.is2DArray !== n.is2DArray && console.log(e + " - is2DArray"), t.is3D !== n.is3D && console.log(e + " - is3D"), t.isBlocking !== n.isBlocking && console.log(e + " - isBlocking"), t.isCube !== n.isCube && console.log(e + " - isCube"), t.isRGBD !== n.isRGBD && console.log(e + " - isRGBD"), t.linearSpecularLOD !== n.linearSpecularLOD && console.log(e + " - linearSpecularLOD"), t.lodGenerationOffset !== n.lodGenerationOffset && console.log(e + " - lodGenerationOffset"), t.lodGenerationScale !== n.lodGenerationScale && console.log(e + " - lodGenerationScale"), t.noMipmap !== n.noMipmap && console.log(e + " - noMipmap"), t.samplingMode !== n.samplingMode && console.log(e + " - samplingMode"), t.textureFormat !== n.textureFormat && console.log(e + " - textureFormat"), t.textureType !== n.textureType && console.log(e + " - textureType"), t.wrapU !== n.wrapU && console.log(e + " - wrapU"), t.wrapV !== n.wrapV && console.log(e + " - wrapV"));
  }
  async showResizableCanvas(e, t, n, s, o, h, c, _, x, B, P, U) {
    if (!this._isLoading) {
      if (this._isLoading = !0, this._scene) {
        this.clearResizableMeshes();
        const M = await this._resizableCanvas3DGenerator.generatePreview3D(
          {
            width: e,
            height: t,
            depth: n,
            borderRadius: s,
            radiusResolution: 0.1,
            type: o,
            borderColor: h,
            columns: c,
            rows: _,
            useCheckerTexture: !1,
            backgroundUrl: P,
            backgroundColor: B,
            shape: U
          },
          this._scene
        ), Z = await BABYLON.SceneLoader.ImportMeshAsync(
          "",
          "",
          "data:" + JSON.stringify(M)
        );
        this._loadedMeshes.push(...Z.meshes);
        const F = Z.meshes[0], Q = 2 / Math.max(e, t);
        if (F.scaling.scaleInPlace(Q), F.position.z = 0, F.rotate(BABYLON.Axis.Y, Math.PI, BABYLON.Space.LOCAL), this.camera && this.camera instanceof BABYLON.ArcRotateCamera && this.camera.setPosition(new BABYLON.Vector3(0, 1, 4)), !this._scene.lights.find((ee) => ee.name === "resizableLight")) {
          console.log("Creating light...");
          const ee = new BABYLON.HemisphericLight(
            "resizableLight",
            new BABYLON.Vector3(0.1, 1, 0.1),
            this._scene
          );
          ee.groundColor = new BABYLON.Color3(0.6, 0.6, 0.6), ee.intensity = 1;
          const le = this.getDefaultHemisphericLight();
          le && this._scene.removeLight(le);
        }
        const te = Z.meshes.find((ee) => !ee.parent);
        return te.metadata = {
          isResizable: !0,
          AR: !0,
          sizecm: {
            height: t / x
          }
        }, this._isLoading = !1, Z.meshes;
      }
      return this._isLoading = !1, null;
    }
  }
  /**
   * Remove all meshes from the scene
   */
  clearResizableMeshes() {
    this._scene.meshes.filter((e) => {
      var t;
      return (t = e.metadata) == null ? void 0 : t.isResizable;
    }).forEach((e) => e.dispose());
  }
  switchMode(e) {
    var s;
    console.log("Switch 3D mode", e);
    const t = this._scene.lights.find((o) => o.name === "resizableLight"), n = this.getDefaultHemisphericLight();
    e === "resizable" ? this._lastVisibilityStates.size === 0 && ((s = this._scene) == null || s.meshes.forEach((o) => {
      (!o.metadata || !o.metadata.isResizable) && (this._lastVisibilityStates.set(o, o.isVisible), o.isVisible = !1);
    })) : (t && (t.dispose(), this._scene.removeLight(t)), n && this._scene.addLight(n), this._lastVisibilityStates.forEach((o, h) => h.isVisible = o), this._lastVisibilityStates.clear(), this.clearResizableMeshes());
  }
  async rotate(e, t, n) {
    return new Promise((s) => {
      if (this._scene) {
        console.log(`Rotating scene on axis ${t} by ${e} degrees`);
        const o = e * Math.PI / 180;
        this._scene.meshes.filter((h) => !h.parent).forEach((h) => {
          if (!n)
            h.rotate(t, o, BABYLON.Space.WORLD), s();
          else {
            const c = h.rotationQuaternion ?? h.rotation.toQuaternion(), _ = BABYLON.Quaternion.RotationAxis(t, o).multiply(
              c
            ), x = BABYLON.Animation.CreateAndStartAnimation(
              h.id + "rotation",
              h,
              "rotationQuaternion",
              60,
              20,
              c,
              _,
              BABYLON.Animation.ANIMATIONLOOPMODE_CONSTANT,
              void 0,
              () => {
                x == null || x.stop(), s();
              }
            );
          }
        });
      }
    });
  }
  // ===== CAMERA ROTATION METHODS =====
  /**
   * Ruota la camera a sinistra di un angolo specificato.
   * @param degrees Angolo in gradi (default: 5)
   * @param animate Se true, anima il movimento (default: true)
   */
  rotateCameraLeft(e = 5, t = !0) {
    this.rotateCameraHorizontal(-e, t);
  }
  /**
   * Ruota la camera a destra di un angolo specificato.
   * @param degrees Angolo in gradi (default: 5)
   * @param animate Se true, anima il movimento (default: true)
   */
  rotateCameraRight(e = 5, t = !0) {
    this.rotateCameraHorizontal(e, t);
  }
  /**
   * Ruota la camera verso l'alto di un angolo specificato.
   * @param degrees Angolo in gradi (default: 5)
   * @param animate Se true, anima il movimento (default: true)
   */
  rotateCameraUp(e = 5, t = !0) {
    this.rotateCameraVertical(-e, t);
  }
  /**
   * Ruota la camera verso il basso di un angolo specificato.
   * @param degrees Angolo in gradi (default: 5)
   * @param animate Se true, anima il movimento (default: true)
   */
  rotateCameraDown(e = 5, t = !0) {
    this.rotateCameraVertical(e, t);
  }
  /**
   * Ruota la camera orizzontalmente (attorno all'asse Y).
   * @param degrees Angolo in gradi (positivo = destra, negativo = sinistra)
   * @param animate Se true, anima il movimento
   */
  rotateCameraHorizontal(e, t = !0) {
    if (!this._camera || !(this._camera instanceof BABYLON.ArcRotateCamera))
      return;
    const n = e * Math.PI / 180;
    let s = this._camera.alpha + n;
    this._camera.lowerAlphaLimit !== null && this._camera.lowerAlphaLimit !== void 0 && (s = Math.max(this._camera.lowerAlphaLimit, s)), this._camera.upperAlphaLimit !== null && this._camera.upperAlphaLimit !== void 0 && (s = Math.min(this._camera.upperAlphaLimit, s)), t ? this.animateCameraToFinalParamters(
      s,
      this._camera.beta,
      this._camera.radius,
      this._camera.target,
      0.3
    ) : this._camera.alpha = s;
  }
  /**
   * Ruota la camera verticalmente (attorno all'asse orizzontale).
   * @param degrees Angolo in gradi (positivo = giù, negativo = su)
   * @param animate Se true, anima il movimento
   */
  rotateCameraVertical(e, t = !0) {
    if (!this._camera || !(this._camera instanceof BABYLON.ArcRotateCamera))
      return;
    const n = e * Math.PI / 180;
    let s = this._camera.beta + n;
    s = Math.max(0.1, Math.min(Math.PI - 0.1, s)), this._camera.lowerBetaLimit !== null && this._camera.lowerBetaLimit !== void 0 && (s = Math.max(this._camera.lowerBetaLimit, s)), this._camera.upperBetaLimit !== null && this._camera.upperBetaLimit !== void 0 && (s = Math.min(this._camera.upperBetaLimit, s)), t ? this.animateCameraToFinalParamters(
      this._camera.alpha,
      s,
      this._camera.radius,
      this._camera.target,
      0.3
    ) : this._camera.beta = s;
  }
};
Rd._shadowGenerator = null;
let mi = Rd;
class $s extends BABYLON.ProceduralTexture {
  constructor(e, t, n, s, o, h, c) {
    super(e, t, n, s, h, c), this._initializing = !1, this._baseTexture = o, this.updateShaderUniforms();
  }
  get initializing() {
    return this._initializing;
  }
  get baseTexture() {
    return this._baseTexture;
  }
  set baseTexture(e) {
    this._baseTexture = e, this.updateShaderUniforms();
  }
  isReadyAsync() {
    return mi.whenTextureIsReadyAsync(this);
  }
  dispose() {
    super.dispose(), this._baseTexture && this._baseTexture.dispose();
  }
  beginInit() {
    this._initializing = !0;
  }
  endInit() {
    this._initializing = !1, this.updateShaderUniforms();
  }
  updateShaderUniforms() {
    this._initializing || this.setBaseTextureUniform();
  }
  setBaseTextureUniform() {
    this.setTexture("uSampler", this._baseTexture);
  }
}
const cu = class Dd extends $s {
  constructor(e, t, n, s, o, h) {
    super(e, t, Dd.FRAGMENT_SHADER, n, s, o, h), this._blur = 1 / 512, this.updateShaderUniforms();
  }
  //@BABYLON.serialize()
  get blur() {
    return this._blur / (1 / 7e3);
  }
  set blur(e) {
    this._blur = 1 / 7e3 * e, this.updateShaderUniforms();
  }
  dispose() {
    super.dispose();
  }
  updateShaderUniforms() {
    if (super.updateShaderUniforms(), this.initializing)
      return;
    const e = this._blur != null ? this._blur : 1 / 512;
    this.setFloat("blur", e);
  }
  /**
  * Render the texture to its associated render target.
  * @param useCameraPostProcess Define if camera post process should be applied to the texture
  */
  render(e) {
    super.render(e);
  }
  /**
    * Resize the texture to new value.
    * @param size Define the new size the texture should have
    * @param generateMipMaps Define whether the new texture should create mip maps
    */
  resize(e, t) {
    super.resize(e, t), this.updateShaderUniforms();
  }
  //public serialize(): any {
  //    var serializationObject = BABYLON.SerializationHelper.Serialize(this, super.serialize());
  //    serializationObject.customType = BlurXProceduralTexture.CUSTOM_TYPE;
  //    return serializationObject;
  //}
  //public static Parse(parsedTexture: any, scene: BABYLON.Scene, rootUrl: string): BlurXProceduralTexture {
  //    var texture = BABYLON.SerializationHelper.Parse(() => new BlurXProceduralTexture(parsedTexture.name, parsedTexture._size, scene, undefined, parsedTexture._generateMipMaps), parsedTexture, scene, rootUrl);
  //    return texture;
  //}
};
cu.FRAGMENT_SHADER = "zakeke_BlurXProceduralTexture";
cu.CUSTOM_TYPE = "Zakeke.BlurXProceduralTexture";
let so = cu;
const Hx = [
  "precision mediump float;",
  "varying vec2 vUV;",
  "varying vec4 vColor;",
  "uniform float blur;",
  "uniform sampler2D uSampler;",
  "void main(void) {",
  "   vec4 sum = vec4(0.0);",
  "   sum += texture2D(uSampler, vec2(vUV.x - 4.0*blur, vUV.y)) * 0.05;",
  "   sum += texture2D(uSampler, vec2(vUV.x - 3.0*blur, vUV.y)) * 0.09;",
  "   sum += texture2D(uSampler, vec2(vUV.x - 2.0*blur, vUV.y)) * 0.12;",
  "   sum += texture2D(uSampler, vec2(vUV.x - blur, vUV.y)) * 0.15;",
  "   sum += texture2D(uSampler, vec2(vUV.x, vUV.y)) * 0.16;",
  "   sum += texture2D(uSampler, vec2(vUV.x + blur, vUV.y)) * 0.15;",
  "   sum += texture2D(uSampler, vec2(vUV.x + 2.0*blur, vUV.y)) * 0.12;",
  "   sum += texture2D(uSampler, vec2(vUV.x + 3.0*blur, vUV.y)) * 0.09;",
  "   sum += texture2D(uSampler, vec2(vUV.x + 4.0*blur, vUV.y)) * 0.05;",
  "   gl_FragColor = sum;",
  "}"
], Yx = Hx.join(`
`);
BABYLON.Effect.ShadersStore[`${so.FRAGMENT_SHADER}PixelShader`] = Yx;
const fu = class zd extends $s {
  constructor(e, t, n, s, o, h) {
    super(e, t, zd.FRAGMENT_SHADER, n, s, o, h), this._blur = 1 / 512, this.updateShaderUniforms();
  }
  get blur() {
    return this._blur / (1 / 7e3);
  }
  set blur(e) {
    this._blur = 1 / 7e3 * e, this.updateShaderUniforms();
  }
  dispose() {
    super.dispose();
  }
  updateShaderUniforms() {
    if (super.updateShaderUniforms(), this.initializing)
      return;
    const e = this._blur != null ? this._blur : 1 / 512;
    this.setFloat("blur", e);
  }
  /**
  * Render the texture to its associated render target.
  * @param useCameraPostProcess Define if camera post process should be applied to the texture
  */
  render(e) {
    super.render(e);
  }
  /**
    * Resize the texture to new value.
    * @param size Define the new size the texture should have
    * @param generateMipMaps Define whether the new texture should create mip maps
    */
  resize(e, t) {
    super.resize(e, t), this.updateShaderUniforms();
  }
  //public serialize(): any {
  //    var serializationObject = BABYLON.SerializationHelper.Serialize(this, super.serialize());
  //    serializationObject.customType = BlurYProceduralTexture.CUSTOM_TYPE;
  //    return serializationObject;
  //}
  //public static Parse(parsedTexture: any, scene: BABYLON.Scene, rootUrl: string): BlurYProceduralTexture {
  //    var texture = BABYLON.SerializationHelper.Parse(() => new BlurYProceduralTexture(parsedTexture.name, parsedTexture._size, scene, undefined, parsedTexture._generateMipMaps), parsedTexture, scene, rootUrl);
  //    return texture;
  //}
};
fu.FRAGMENT_SHADER = "zakeke_BlurYProceduralTexture";
fu.CUSTOM_TYPE = "Zakeke.BlurYProceduralTexture";
let ao = fu;
const Gx = [
  "precision mediump float;",
  "varying vec2 vUV;",
  "varying vec4 vColor;",
  "uniform float blur;",
  "uniform sampler2D uSampler;",
  "void main(void) {",
  "   vec4 sum = vec4(0.0);",
  "   sum += texture2D(uSampler, vec2(vUV.x, vUV.y - 4.0*blur)) * 0.05;",
  "   sum += texture2D(uSampler, vec2(vUV.x, vUV.y - 3.0*blur)) * 0.09;",
  "   sum += texture2D(uSampler, vec2(vUV.x, vUV.y - 2.0*blur)) * 0.12;",
  "   sum += texture2D(uSampler, vec2(vUV.x, vUV.y - blur)) * 0.15;",
  "   sum += texture2D(uSampler, vec2(vUV.x, vUV.y)) * 0.16;",
  "   sum += texture2D(uSampler, vec2(vUV.x, vUV.y + blur)) * 0.15;",
  "   sum += texture2D(uSampler, vec2(vUV.x, vUV.y + 2.0*blur)) * 0.12;",
  "   sum += texture2D(uSampler, vec2(vUV.x, vUV.y + 3.0*blur)) * 0.09;",
  "   sum += texture2D(uSampler, vec2(vUV.x, vUV.y + 4.0*blur)) * 0.05;",
  "   gl_FragColor = sum;",
  "}"
], jx = Gx.join(`
`);
BABYLON.Effect.ShadersStore[`${ao.FRAGMENT_SHADER}PixelShader`] = jx;
const du = class Fd extends $s {
  constructor(e, t, n, s, o, h) {
    super(e, t, Fd.FRAGMENT_SHADER, n, s, o, h), this._foreColor = new BABYLON.Vector3(1, 1, 1), this._backColor = new BABYLON.Vector3(0, 0, 0), this.updateShaderUniforms();
  }
  //@BABYLON.serializeAsVector3()
  get foreColor() {
    return this._foreColor;
  }
  set foreColor(e) {
    this._foreColor = e, this.updateShaderUniforms();
  }
  //@BABYLON.serializeAsVector3()
  get backColor() {
    return this._backColor;
  }
  set backColor(e) {
    this._backColor = e, this.updateShaderUniforms();
  }
  dispose() {
    super.dispose();
  }
  updateShaderUniforms() {
    if (super.updateShaderUniforms(), this.initializing)
      return;
    const e = this._foreColor || new BABYLON.Vector3(1, 1, 1), t = this._backColor || new BABYLON.Vector3(0, 0, 0);
    this.setVector3("foreColor", e), this.setVector3("backColor", t);
  }
  /**
  * Render the texture to its associated render target.
  * @param useCameraPostProcess Define if camera post process should be applied to the texture
  */
  render(e) {
    super.render(e);
  }
  /**
  * Resize the texture to new value.
  * @param size Define the new size the texture should have
  * @param generateMipMaps Define whether the new texture should create mip maps
  */
  resize(e, t) {
    super.resize(e, t), this.updateShaderUniforms();
  }
  /*
      public serialize(): any {
          var serializationObject = BABYLON.SerializationHelper.Serialize(this, super.serialize());
          serializationObject.customType = ForegroundBackgroundProceduralTexture.CUSTOM_TYPE;
          return serializationObject;
      }
  
      public static Parse(parsedTexture: any, scene: BABYLON.Scene, rootUrl: string): ForegroundBackgroundProceduralTexture {
          var texture = BABYLON.SerializationHelper.Parse(() => new ForegroundBackgroundProceduralTexture(parsedTexture.name, parsedTexture._size, scene, undefined, parsedTexture._generateMipMaps), parsedTexture, scene, rootUrl);
          return texture;
      }
      */
};
du.FRAGMENT_SHADER = "zakeke_ForegroundBackgroundProceduralTexture";
du.CUSTOM_TYPE = "Zakeke.ForegroundBackgroundProceduralTexture";
let oo = du;
const Wx = [
  "precision mediump float;",
  "varying vec2 vUV;",
  "uniform sampler2D uSampler;",
  "uniform vec3 foreColor;",
  "uniform vec3 backColor;",
  "void main(void) {",
  "   // background color",
  "   vec4 background = vec4(backColor.xyz, 1);",
  "   vec4 foreground = vec4(foreColor.xyz, 1);",
  "   // texel",
  "	vec4 t0 = texture2D(uSampler, vUV.xy);",
  "   // change in white",
  "   t0 = vec4(foreground.xyz, t0.a);",
  "   gl_FragColor = mix(background, t0, t0.a);",
  "}"
], Zx = Wx.join(`
`);
BABYLON.Effect.ShadersStore[`${oo.FRAGMENT_SHADER}PixelShader`] = Zx;
const gu = class Ud extends $s {
  constructor(e, t, n, s, o, h) {
    super(e, t, Ud.FRAGMENT_SHADER, n, s, o, h), this._offset = new BABYLON.Vector2(0, 0), this.updateShaderUniforms();
  }
  //@BABYLON.serializeAsVector2()
  get offset() {
    return this._offset;
  }
  set offset(e) {
    this._offset = e, this.updateShaderUniforms();
  }
  dispose() {
    super.dispose();
  }
  updateShaderUniforms() {
    if (super.updateShaderUniforms(), this.initializing)
      return;
    const e = this.getRenderSize(), t = this._offset || new BABYLON.Vector2();
    this.setVector2("offset", new BABYLON.Vector2(t.x / e, t.y / e));
  }
  /**
  * Render the texture to its associated render target.
  * @param useCameraPostProcess Define if camera post process should be applied to the texture
  */
  render(e) {
    super.render(e);
  }
  /**
  * Resize the texture to new value.
  * @param size Define the new size the texture should have
  * @param generateMipMaps Define whether the new texture should create mip maps
  */
  resize(e, t) {
    super.resize(e, t), this.updateShaderUniforms();
  }
  /*
      public serialize(): any {
          var serializationObject = BABYLON.SerializationHelper.Serialize(this, super.serialize());
          serializationObject.customType = MoveProceduralTexture.CUSTOM_TYPE;
          return serializationObject;
      }
  
      public static Parse(parsedTexture: any, scene: BABYLON.Scene, rootUrl: string): MoveProceduralTexture {
          var texture = BABYLON.SerializationHelper.Parse(() => new MoveProceduralTexture(parsedTexture.name, parsedTexture._size, scene, undefined, parsedTexture._generateMipMaps), parsedTexture, scene, rootUrl);
          return texture;
      }
      */
};
gu.FRAGMENT_SHADER = "zakeke_MoveProceduralTexture";
gu.CUSTOM_TYPE = "Zakeke.MoveProceduralTexture";
let pu = gu;
const qx = [
  "precision mediump float;",
  "varying vec2 vUV;",
  "uniform sampler2D uSampler;",
  "uniform vec2 offset;",
  "void main(void) {",
  "   // translated texel",
  "   gl_FragColor = texture2D(uSampler, vec2(vUV.x - offset.x, vUV.y + offset.y));",
  //'   gl_FragColor = texture2D(uSampler, vUV.xy - offset);',
  "}"
], $x = qx.join(`
`);
BABYLON.Effect.ShadersStore[`${pu.FRAGMENT_SHADER}PixelShader`] = $x;
const mu = class Vd extends $s {
  constructor(e, t, n, s, o, h, c) {
    super(e, t, Vd.FRAGMENT_SHADER, n, s, h, c), this._blendTexture = o, this.updateShaderUniforms();
  }
  //@BABYLON.serializeAsTexture()
  get blendTexture() {
    return this._blendTexture;
  }
  set blendTexture(e) {
    this._blendTexture = e, this.updateShaderUniforms();
  }
  dispose() {
    super.dispose(), this._blendTexture && this._blendTexture.dispose();
  }
  updateShaderUniforms() {
    if (super.updateShaderUniforms(), !this.initializing) {
      var e = new BABYLON.Vector2(1, 1);
      this.baseTexture && (e = new BABYLON.Vector2(this.baseTexture.uScale, this.baseTexture.vScale)), this.setVector2("uSamplerScale", e), this.setTexture("uBlendSampler", this._blendTexture);
      var t = new BABYLON.Vector2(1, 1);
      this._blendTexture && (t = new BABYLON.Vector2(this._blendTexture.uScale, this._blendTexture.vScale)), this.setVector2("uBlendScale", t);
    }
  }
  /**
  * Render the texture to its associated render target.
  * @param useCameraPostProcess Define if camera post process should be applied to the texture
  */
  render(e) {
    super.render(e);
  }
  /**
    * Resize the texture to new value.
    * @param size Define the new size the texture should have
    * @param generateMipMaps Define whether the new texture should create mip maps
    */
  resize(e, t) {
    super.resize(e, t), this.updateShaderUniforms();
  }
};
mu.FRAGMENT_SHADER = "zakeke_MultiplyProceduralTexture";
mu.CUSTOM_TYPE = "Zakeke.MultiplyProceduralTexture";
let to = mu;
const Xx = [
  "precision mediump float;",
  "varying vec2 vUV;",
  "uniform sampler2D uSampler;",
  "uniform sampler2D uBlendSampler;",
  "uniform vec2 uSamplerScale;",
  "uniform vec2 uBlendScale;",
  "void main(void) {",
  "	vec4 base = texture2D(uSampler, vUV.xy*uSamplerScale);",
  "	vec4 blend = texture2D(uBlendSampler, vUV.xy*uBlendScale);",
  "   gl_FragColor = base * blend;",
  "}"
], Kx = Xx.join(`
`);
BABYLON.Effect.ShadersStore[`${to.FRAGMENT_SHADER}PixelShader`] = Kx;
const _u = class Hd extends $s {
  constructor(e, t, n, s, o, h) {
    super(e, t, Hd.FRAGMENT_SHADER, n, s, o, h), this._bias = 50, this._invertR = !1, this._invertG = !1, this._bevel = !1, this._intensity = 0.5, this.updateShaderUniforms();
  }
  get bias() {
    return this._bias == null ? 50 : this._bias;
  }
  set bias(e) {
    this._bias = e, this.updateShaderUniforms();
  }
  get invertR() {
    return this._invertR == null ? !1 : this._invertR;
  }
  set invertR(e) {
    this._invertR = e, this.updateShaderUniforms();
  }
  get invertG() {
    return this._invertG == null ? !1 : this._invertG;
  }
  set invertG(e) {
    this._invertG = e, this.updateShaderUniforms();
  }
  get bevel() {
    return this._bevel == null ? !1 : this._bevel;
  }
  set bevel(e) {
    this._bevel = e, this.updateShaderUniforms();
  }
  get intensity() {
    return this._intensity == null ? 0.5 : this._intensity;
  }
  set intensity(e) {
    this._intensity = e, this.updateShaderUniforms();
  }
  dispose() {
    super.dispose();
  }
  updateShaderUniforms() {
    if (super.updateShaderUniforms(), !this.initializing) {
      var e = this.getRenderSize(), t = e < 1024 ? e * 2 : e;
      this.setFloat("size", e), this.setVector2("u_textureSize", new BABYLON.Vector2(e, e)), this.setVector3("dimensions", new BABYLON.Vector3(t, t, 0)), this.setFloat("bias", this.bias), this.setFloat("invertR", this.invertR ? -1 : 1), this.setFloat("invertG", this.invertG ? -1 : 1), this.setFloat("bevel", this.bevel ? 1 : 0), this.setFloat("intensity", this.intensity);
    }
  }
  /**
  * Render the texture to its associated render target.
  * @param useCameraPostProcess Define if camera post process should be applied to the texture
  */
  render(e) {
    super.render(e);
  }
  /**
    * Resize the texture to new value.
    * @param size Define the new size the texture should have
    * @param generateMipMaps Define whether the new texture should create mip maps
    */
  resize(e, t) {
    super.resize(e, t), this.updateShaderUniforms();
  }
};
_u.FRAGMENT_SHADER = "zakeke_normalMapProceduralTexture";
_u.CUSTOM_TYPE = "Zakeke.NormalMapProceduralTexture";
let Yd = _u;
const Jx = [
  "precision mediump float;",
  "varying vec2 vUV;",
  "uniform vec3 dimensions;",
  "uniform sampler2D uSampler;",
  "uniform vec2 u_textureSize;",
  "uniform float bias;",
  "uniform float invertR;",
  "uniform float invertG;",
  "uniform float bevel;",
  "uniform float intensity;",
  "void main(void) {",
  "   vec2 step = vec2(1.0, 1.0) / dimensions.xy;",
  "   vec4 black = vec4(0, 0, 0, 1);",
  "	vec4 bk = vec4(1, 1, 1, 1);",
  "	vec4 t0 = texture2D(uSampler, vUV.xy + vec2(0.0, 0.0));",
  "	vec4 t1 = texture2D(uSampler, vUV.xy + vec2(step.x, 0.0));",
  "	vec4 t2 = texture2D(uSampler, vUV.xy + vec2(-step.x, 0.0));",
  "	vec4 t3 = texture2D(uSampler, vUV.xy + vec2(0.0, step.y));",
  "	vec4 t4 = texture2D(uSampler, vUV.xy + vec2(0.0, -step.y));",
  "   if (bevel != 0.0) ",
  "   {",
  "      t0 = vec4(0, 0, 0, t0.a);",
  "      t1 = vec4(0, 0, 0, t1.a);",
  "      t2 = vec4(0, 0, 0, t2.a);",
  "      t3 = vec4(0, 0, 0, t3.a);",
  "      t4 = vec4(0, 0, 0, t4.a);",
  "   }",
  "	t0 = mix(bk, t0, t0.a);",
  "	t1 = mix(bk, t1, t1.a);",
  "	t2 = mix(bk, t2, t2.a);",
  "	t3 = mix(bk, t3, t3.a);",
  "	t4 = mix(bk, t4, t4.a);",
  "	float d0 = abs(t0.r);",
  "	float d1 = abs(t1.r);",
  "	float d2 = abs(t2.r);",
  "	float d3 = abs(t3.r);",
  "	float d4 = abs(t4.r);",
  "	float dx = ((d2 - d0) + (d0 - d1)) * intensity;",
  "	float dy = ((d4 - d0) + (d0 - d3)) * intensity;",
  "	vec4 normal = vec4(normalize(vec3(dx * invertR, dy * invertG, 1.0 - ((bias - 0.1) / 100.0))), 1.0);",
  "	gl_FragColor = vec4(normal.xyz * 0.5 + 0.5, 1.0);",
  "}"
], Qx = Jx.join(`
`);
BABYLON.Effect.ShadersStore[`${Yd.FRAGMENT_SHADER}PixelShader`] = Qx;
const vu = class Gd extends $s {
  constructor(e, t, n, s, o, h, c) {
    super(e, t, Gd.FRAGMENT_SHADER, n, s, h, c), this._opacity = 1, this.updateShaderUniforms();
  }
  get opacity() {
    return this._opacity == null ? 1 : this._opacity;
  }
  set opacity(e) {
    this._opacity = e, this.updateShaderUniforms();
  }
  dispose() {
    super.dispose();
  }
  updateShaderUniforms() {
    super.updateShaderUniforms(), !this.initializing && this.setFloat("opacity", this.opacity);
  }
  /**
  * Render the texture to its associated render target.
  * @param useCameraPostProcess Define if camera post process should be applied to the texture
  */
  render(e) {
    super.render(e);
  }
  /**
    * Resize the texture to new value.
    * @param size Define the new size the texture should have
    * @param generateMipMaps Define whether the new texture should create mip maps
    */
  resize(e, t) {
    super.resize(e, t), this.updateShaderUniforms();
  }
};
vu.FRAGMENT_SHADER = "zakeke_OpacityProceduralTexture";
vu.CUSTOM_TYPE = "Zakeke.OpacityProceduralTexture";
let ew = vu;
const tw = [
  "precision mediump float;",
  "varying vec2 vUV;",
  "uniform sampler2D uSampler;",
  "uniform float opacity;",
  "void main(void) {",
  "	vec4 color = texture2D(uSampler, vUV.xy);",
  "   color.a = opacity;",
  "   gl_FragColor = color;",
  "}"
], iw = tw.join(`
`);
BABYLON.Effect.ShadersStore[`${ew.FRAGMENT_SHADER}PixelShader`] = iw;
const yu = class jd extends $s {
  constructor(e, t, n, s, o, h, c) {
    super(e, t, jd.FRAGMENT_SHADER, n, s, h, c), this._blendTexture = o, this.updateShaderUniforms();
  }
  //@BABYLON.serializeAsTexture()
  get blendTexture() {
    return this._blendTexture;
  }
  set blendTexture(e) {
    this._blendTexture = e, this.updateShaderUniforms();
  }
  dispose() {
    super.dispose(), this._blendTexture && this._blendTexture.dispose();
  }
  updateShaderUniforms() {
    if (super.updateShaderUniforms(), !this.initializing) {
      var e = new BABYLON.Vector2(1, 1);
      this.baseTexture && (e = new BABYLON.Vector2(this.baseTexture.uScale, this.baseTexture.vScale)), this.setVector2("uSamplerScale", e), this.setTexture("uBlendSampler", this._blendTexture);
      var t = new BABYLON.Vector2(1, 1);
      this._blendTexture && (t = new BABYLON.Vector2(this._blendTexture.uScale, this._blendTexture.vScale)), this.setVector2("uBlendScale", t);
    }
  }
  /**
  * Render the texture to its associated render target.
  * @param useCameraPostProcess Define if camera post process should be applied to the texture
  */
  render(e) {
    super.render(e);
  }
  /**
    * Resize the texture to new value.
    * @param size Define the new size the texture should have
    * @param generateMipMaps Define whether the new texture should create mip maps
    */
  resize(e, t) {
    super.resize(e, t), this.updateShaderUniforms();
  }
};
yu.FRAGMENT_SHADER = "zakeke_OverlayProceduralTexture";
yu.CUSTOM_TYPE = "Zakeke.OverlayProceduralTexture";
let ul = yu;
var nw = [
  "precision mediump float;",
  "varying vec2 vUV;",
  "uniform sampler2D uSampler;",
  "uniform sampler2D uBlendSampler;",
  "uniform vec2 uSamplerScale;",
  "uniform vec2 uBlendScale;",
  "float BlendOverlayf(float base, float blend)",
  "{",
  "   return (base < 0.5 ? (2.0 * base * blend) : (1.0 - 2.0 * (1.0 - base) * (1.0 - blend)));",
  "}",
  "vec4 BlendOverlay(vec4 base, vec4 blend)",
  "{",
  "   return vec4(BlendOverlayf(base.r, blend.r), BlendOverlayf(base.g, blend.g), BlendOverlayf(base.b, blend.b), BlendOverlayf(base.a, blend.a));",
  "}",
  "void main(void) {",
  "	vec4 base = texture2D(uSampler, vUV.xy*uSamplerScale);",
  "	vec4 blend = texture2D(uBlendSampler, vUV.xy*uBlendScale);",
  "   gl_FragColor = BlendOverlay(base, blend);",
  "}"
], rw = nw.join(`
`);
BABYLON.Effect.ShadersStore[`${ul.FRAGMENT_SHADER}PixelShader`] = rw;
const bu = class cl extends BABYLON.ProceduralTexture {
  constructor(e, t, n = null, s, o) {
    super(e, t, cl.FRAGMENT_SHADER, n, s, o), this._baseTexture = null, this._blendTexture = null, this.updateShaderUniforms();
  }
  dispose() {
    this._baseTexture && this._baseTexture.dispose(), this._blendTexture && this._blendTexture.dispose();
  }
  updateShaderUniforms() {
    this._baseTexture ? (this.setTexture("uSampler", this._baseTexture), this.setInt("hasSampler", 1), this.setVector2("uSamplerScale", new BABYLON.Vector2(this._baseTexture.uScale, this._baseTexture.vScale))) : (this.setInt("hasSampler", 0), this.setVector2("uSamplerScale", new BABYLON.Vector2(1, 1))), this._blendTexture ? (this.setTexture("uBlendSampler", this._blendTexture), this.setInt("hasBlend", 1), this.setVector2("uBlendScale", new BABYLON.Vector2(this._blendTexture.uScale, this._blendTexture.vScale))) : (this.setInt("hasBlend", 0), this.setVector2("uBlendScale", new BABYLON.Vector2(1, 1))), this.setFloat("size", this.getRenderSize());
  }
  render(e) {
    super.render(e);
  }
  resize(e, t) {
    super.resize(e, t), this.updateShaderUniforms();
  }
  isReady() {
    return this._baseTexture && !this._baseTexture.isReady() || this._blendTexture && !this._blendTexture.isReady() ? !1 : super.isReady();
  }
  //@BABYLON.serializeAsTexture()
  get baseTexture() {
    return this._baseTexture;
  }
  set baseTexture(e) {
    this._baseTexture = e, this.updateShaderUniforms();
  }
  //@BABYLON.serializeAsTexture()
  get blendTexture() {
    return this._blendTexture;
  }
  set blendTexture(e) {
    this._blendTexture = e, this.updateShaderUniforms();
  }
  /**
   * Serializes this normal map procedural texture
   * @returns a serialized normal map procedural texture object
   */
  serialize() {
    var e = BABYLON.SerializationHelper.Serialize(this, super.serialize());
    return e.customType = cl.CUSTOM_TYPE, this.baseTexture ? e.baseTexture = this.baseTexture.serialize() : e.baseTexture = null, this.blendTexture ? e.blendTexture = this.blendTexture.serialize() : e.blendTexture = null, e;
  }
  /**
   * Creates a Normal Map Procedural Texture from parsed normal map procedural texture data
   * @param parsedTexture defines parsed texture data
   * @param scene defines the current scene
   * @param rootUrl defines the root URL containing normal map procedural texture information
   * @returns a parsed Normal Map Procedural Texture
   */
  static Parse(e, t, n) {
    var s = BABYLON.SerializationHelper.Parse(
      () => new cl(
        e.name,
        e._size,
        t,
        void 0,
        e._generateMipMaps
      ),
      e,
      t,
      n
    );
    return e.baseTexture && (s.baseTexture = BABYLON.Texture.Parse(e.baseTexture, t, n)), e.blendTexture && (s.blendTexture = BABYLON.Texture.Parse(e.blendTexture, t, n)), s;
  }
};
bu.FRAGMENT_SHADER = "zakeke_BlendProceduralTexture";
bu.CUSTOM_TYPE = "Zakeke.BlendProceduralTexture";
let Wd = bu;
var sw = [
  "precision mediump float;",
  "varying vec2 vUV;",
  "uniform sampler2D uSampler;",
  "uniform sampler2D uBlendSampler;",
  "uniform vec2 uSamplerScale;",
  "uniform vec2 uBlendScale;",
  "uniform bool hasSampler;",
  "uniform bool hasBlend;",
  "float BlendOverlayf(float base, float blend)",
  "{",
  "   return (base < 0.5 ? (2.0 * base * blend) : (1.0 - 2.0 * (1.0 - base) * (1.0 - blend)));",
  "}",
  "vec4 BlendOverlay(vec4 base, vec4 blend)",
  "{",
  "   return vec4(BlendOverlayf(base.r, blend.r), BlendOverlayf(base.g, blend.g), BlendOverlayf(base.b, blend.b), BlendOverlayf(base.a, blend.a));",
  "}",
  "void main(void) {",
  "   if (!hasSampler && !hasBlend)",
  "   {",
  "       gl_FragColor = vec4(1.0, 1.0, 1.0, 1.0);",
  "       return;",
  "   }",
  "   if (hasSampler && !hasBlend)",
  "   {",
  "       gl_FragColor = texture2D(uSampler, vUV.xy*uSamplerScale);",
  "       return;",
  "   }",
  "   if (!hasSampler && hasBlend)",
  "   {",
  "       gl_FragColor = texture2D(uBlendSampler, vUV.xy*uBlendScale);",
  "       return;",
  "   }",
  "   vec4 base = texture2D(uSampler, vUV.xy*uSamplerScale);",
  "   vec4 blend = texture2D(uBlendSampler, vUV.xy*uBlendScale);",
  "   gl_FragColor = BlendOverlay(base, blend);",
  "}"
], aw = sw.join(`
`);
BABYLON.Effect.ShadersStore[`${Wd.FRAGMENT_SHADER}PixelShader`] = aw;
BABYLON.RegisterClass("Zakeke.BlendProceduralTexture", Wd);
class Zd {
  constructor() {
  }
  getSubmeshIdx(e) {
    let t = e.lastIndexOf("-");
    if (t != -1) {
      e = e.substring(0, t);
      let n = Number(e.substring(t + 1));
      if (n && !isNaN(n))
        return n;
    }
    return null;
  }
  getRegExp(e, t) {
    if ((t & MPlaza.SceneElementType.SubMesh) == MPlaza.SceneElementType.SubMesh) {
      let n = e.lastIndexOf("-");
      n != -1 && (e = e.substring(0, n), Number(e.substring(n + 1)));
    }
    return new RegExp(this.escapeRegExp(e).replace(/\\\*/g, ".*"), "i");
  }
  getElements(e, t, n, s, o) {
    const h = [], c = s.split(";");
    for (let _ = 0; _ < c.length; _++) {
      const x = c[_];
      let B = x, P = this.getRegExp(x, o);
      if ((o & MPlaza.SceneElementType.Mesh) == MPlaza.SceneElementType.Mesh) {
        const U = this.getMeshes(e, t, n, P, B);
        Array.prototype.push.apply(h, U);
      }
      if ((o & MPlaza.SceneElementType.SubMesh) == MPlaza.SceneElementType.SubMesh) {
        let U = this.getSubmeshIdx(B);
        if (U) {
          const M = this.getSubMeshes(e, t, n, P, B, U);
          Array.prototype.push.apply(h, M);
        }
      }
      if ((o & MPlaza.SceneElementType.Material) == MPlaza.SceneElementType.Material) {
        const U = this.getMaterials(e, t, n, P, B);
        Array.prototype.push.apply(h, U);
      }
      if ((o & MPlaza.SceneElementType.Light) == MPlaza.SceneElementType.Light) {
        const U = this.getLights(e, t, n, P, B);
        Array.prototype.push.apply(h, U);
      }
      if ((o & MPlaza.SceneElementType.Camera) == MPlaza.SceneElementType.Camera) {
        const U = this.getCameras(e, t, n, P, B);
        Array.prototype.push.apply(h, U);
      }
      if ((o & MPlaza.SceneElementType.CameraLocation) == MPlaza.SceneElementType.CameraLocation) {
        const U = this.getCameraLocations(e, t, n, P);
        Array.prototype.push.apply(h, U);
      }
    }
    return h;
  }
  getMeshElements(e, t, n, s, o) {
    const h = [], c = s.split(";");
    for (let _ = 0; _ < c.length; _++) {
      const x = c[_];
      let B = x, P = this.getRegExp(x, o);
      if ((o & MPlaza.SceneElementType.Mesh) == MPlaza.SceneElementType.Mesh) {
        const U = this.getMeshes(e, t, n, P, B);
        Array.prototype.push.apply(h, U);
      }
    }
    return h;
  }
  getSubMeshElements(e, t, n, s, o) {
    const h = [], c = s.split(";");
    for (let _ = 0; _ < c.length; _++) {
      const x = c[_];
      let B = x, P = this.getRegExp(x, o);
      if ((o & MPlaza.SceneElementType.SubMesh) == MPlaza.SceneElementType.SubMesh) {
        let U = this.getSubmeshIdx(B);
        if (U) {
          const M = this.getSubMeshes(e, t, n, P, B, U);
          Array.prototype.push.apply(h, M);
        }
      }
    }
    return h;
  }
  getMaterialElements(e, t, n, s, o) {
    const h = [], c = s.split(";");
    for (let _ = 0; _ < c.length; _++) {
      const x = c[_];
      let B = x, P = this.getRegExp(x, o);
      if ((o & MPlaza.SceneElementType.Material) == MPlaza.SceneElementType.Material) {
        const U = this.getMaterials(e, t, n, P, B);
        Array.prototype.push.apply(h, U);
      }
    }
    return h;
  }
  getLightElements(e, t, n, s, o) {
    const h = [], c = s.split(";");
    for (let _ = 0; _ < c.length; _++) {
      const x = c[_];
      let B = x, P = this.getRegExp(x, o);
      if ((o & MPlaza.SceneElementType.Light) == MPlaza.SceneElementType.Light) {
        const U = this.getLights(e, t, n, P, B);
        Array.prototype.push.apply(h, U);
      }
    }
    return h;
  }
  getCameraElements(e, t, n, s, o) {
    const h = [], c = s.split(";");
    for (let _ = 0; _ < c.length; _++) {
      const x = c[_];
      let B = x, P = this.getRegExp(x, o);
      if ((o & MPlaza.SceneElementType.Camera) == MPlaza.SceneElementType.Camera) {
        const U = this.getCameras(e, t, n, P, B);
        Array.prototype.push.apply(h, U);
      }
    }
    return h;
  }
  getCameraLocationElements(e, t, n, s, o) {
    const h = [], c = s.split(";");
    for (let _ = 0; _ < c.length; _++) {
      const x = c[_];
      let B = this.getRegExp(x, o);
      if ((o & MPlaza.SceneElementType.CameraLocation) == MPlaza.SceneElementType.CameraLocation) {
        const P = this.getCameraLocations(e, t, n, B);
        Array.prototype.push.apply(h, P);
      }
    }
    return h;
  }
  getOffloadedElementIDs(e, t, n, s, o) {
    const h = [], c = s.split(";");
    for (let P = 0; P < c.length; P++) {
      const U = c[P];
      let M = U;
      if ((o & MPlaza.SceneElementType.SubMesh) == MPlaza.SceneElementType.SubMesh) {
        var _ = U.lastIndexOf("-");
        _ != -1 && (M = U.substring(0, _), Number(U.substring(_ + 1)));
      }
      var x = new RegExp(this.escapeRegExp(M).replace(/\\\*/g, ".*"), "i");
      if ((o & MPlaza.SceneElementType.Material) == MPlaza.SceneElementType.Material) {
        var B = this.getOffloadedMaterialIDs(e, t, n, x, M);
        Array.prototype.push.apply(h, B);
      }
    }
    return h;
  }
  getDelayedElementIDs(e, t, n, s, o) {
    const h = [], c = s.split(";");
    for (let P = 0; P < c.length; P++) {
      const U = c[P];
      let M = U;
      if ((o & MPlaza.SceneElementType.SubMesh) == MPlaza.SceneElementType.SubMesh) {
        var _ = U.lastIndexOf("-");
        _ != -1 && (M = U.substring(0, _), Number(U.substring(_ + 1)));
      }
      var x = new RegExp(this.escapeRegExp(M).replace(/\\\*/g, ".*"), "i");
      if ((o & MPlaza.SceneElementType.Material) == MPlaza.SceneElementType.Material) {
        var B = this.getDelayedMaterialIDs(e, t, n, x, M);
        Array.prototype.push.apply(h, B);
      }
    }
    return h;
  }
  getMeshes(e, t, n, s, o) {
    const h = [];
    if (t && t instanceof BABYLON.Scene)
      for (let c = 0; c < t.meshes.length; c++) {
        const _ = t.meshes[c];
        (_.name && s.test(_.name) || _.id && _.id == o) && this.verifyFilter(_.id, n) && h.push(_);
      }
    return h;
  }
  getSubMeshes(e, t, n, s, o, h) {
    const c = [];
    if (t && t instanceof BABYLON.Scene)
      for (let _ = 0; _ < t.meshes.length; _++) {
        const x = t.meshes[_];
        (x.name && s.test(x.name) || x.id && x.id == o) && this.verifyFilter(x.id, n) && h < x.subMeshes.length && h >= 0 && c.push(x.subMeshes[h]);
      }
    return c;
  }
  getMaterials(e, t, n, s, o) {
    const h = [];
    if (t && t instanceof BABYLON.Scene)
      for (let c = 0; c < t.materials.length; c++) {
        const _ = t.materials[c];
        (_.name && s.test(_.name) || _.id && _.id == o || _.metadata && !_.metadata.isRealMaterial && _.metadata.originalMaterialID == o) && this.verifyFilter(_.id, n) && h.push(_);
      }
    return h;
  }
  getOffloadedMaterialIDs(e, t, n, s, o) {
    const h = [];
    if (t && t instanceof BABYLON.Scene && t.metadata && t.metadata.offloadedMaterials)
      for (let c in t.metadata.offloadedMaterials) {
        const _ = t.metadata.offloadedMaterials[c];
        (_.name && s.test(_.name) || c && c == o) && this.verifyFilter(c, n) && h.push(c);
      }
    return h;
  }
  getDelayedMaterialIDs(e, t, n, s, o) {
    const h = [];
    if (t && t instanceof BABYLON.Scene && t.metadata && t.metadata.delayedMaterials)
      for (let c in t.metadata.delayedMaterials) {
        const _ = t.metadata.delayedMaterials[c];
        (_.name && s.test(_.name) || c && c == o) && this.verifyFilter(c, n) && h.push(c);
      }
    return h;
  }
  getLights(e, t, n, s, o) {
    const h = [];
    if (t && t instanceof BABYLON.Scene)
      for (let c = 0; c < t.lights.length; c++) {
        const _ = t.lights[c];
        (_.name && s.test(_.name) || _.id && _.id == o) && this.verifyFilter(_.id, n) && h.push(_);
      }
    return h;
  }
  getCameras(e, t, n, s, o) {
    const h = [];
    if (t && t instanceof BABYLON.Scene)
      for (let c = 0; c < t.cameras.length; c++) {
        const _ = t.cameras[c];
        (_.name && s.test(_.name) || _.id && _.id == o) && this.verifyFilter(_.id, n) && h.push(_);
      }
    return h;
  }
  getCameraLocations(e, t, n, s) {
    var o = [];
    if (e && e instanceof Zakeke.Scene)
      for (var h = 0; h < e.get("cameraLocations").length; h++) {
        var c = e.get("cameraLocations").at(h), _ = c.getLocationID(), x = c.get("name");
        (x && s.test(x) || _ && s.test(_)) && this.verifyFilter(_, n) && o.push(c);
      }
    return o;
  }
  getYesNoElements(e, t, n, s, o) {
    const h = { yes: [], no: [] }, c = s.split(";");
    for (let _ = 0; _ < c.length; _++) {
      const x = c[_];
      let B = x, P = 0;
      if ((o & MPlaza.SceneElementType.SubMesh) == MPlaza.SceneElementType.SubMesh) {
        let M = x.lastIndexOf("-");
        if (M != -1) {
          B = x.substring(0, M);
          let Z = Number(x.substring(M + 1));
          Z && !isNaN(Z) && (P = Z);
        }
      }
      const U = new RegExp(this.escapeRegExp(B).replace(/\\\*/g, ".*"), "i");
      if ((o & MPlaza.SceneElementType.Mesh) == MPlaza.SceneElementType.Mesh) {
        const M = this.getYesNoMeshes(e, t, n, U);
        Array.prototype.push.apply(h.yes, M.yes), Array.prototype.push.apply(h.no, M.no);
      }
      if ((o & MPlaza.SceneElementType.SubMesh) == MPlaza.SceneElementType.SubMesh) {
        const M = this.getYesNoSubMeshes(e, t, n, U, P);
        Array.prototype.push.apply(h.yes, M.yes), Array.prototype.push.apply(h.no, M.no);
      }
      if ((o & MPlaza.SceneElementType.Material) == MPlaza.SceneElementType.Material) {
        const M = this.getYesNoMaterials(e, t, n, U);
        Array.prototype.push.apply(h.yes, M.yes), Array.prototype.push.apply(h.no, M.no);
      }
      if ((o & MPlaza.SceneElementType.Light) == MPlaza.SceneElementType.Light) {
        const M = this.getYesNoLights(e, t, n, U);
        Array.prototype.push.apply(h.yes, M.yes), Array.prototype.push.apply(h.no, M.no);
      }
      if ((o & MPlaza.SceneElementType.Camera) == MPlaza.SceneElementType.Camera) {
        const M = this.getYesNoCameras(e, t, n, U);
        Array.prototype.push.apply(h.yes, M.yes), Array.prototype.push.apply(h.no, M.no);
      }
      if ((o & MPlaza.SceneElementType.CameraLocation) == MPlaza.SceneElementType.CameraLocation) {
        const M = this.getYesNoCameraLocations(e, t, n, U);
        Array.prototype.push.apply(h.yes, M.yes), Array.prototype.push.apply(h.no, M.no);
      }
    }
    return h;
  }
  getYesNoMeshes(e, t, n, s) {
    const o = { yes: [], no: [] };
    if (t && t instanceof BABYLON.Scene)
      for (let h = 0; h < t.meshes.length; h++) {
        let c = t.meshes[h], _ = o.no;
        (c.name && s.test(c.name) || c.id && s.test(c.id)) && this.verifyFilter(c.id, n) && (_ = o.yes), _.push(c);
      }
    return o;
  }
  getYesNoSubMeshes(e, t, n, s, o) {
    const h = { yes: [], no: [] };
    if (t && t instanceof BABYLON.Scene)
      for (let c = 0; c < t.meshes.length; c++) {
        let _ = t.meshes[c];
        if ((_.name && s.test(_.name) || _.id && s.test(_.id)) && this.verifyFilter(_.id, n) && _.subMeshes)
          for (let x = 0; x < _.subMeshes.length; x++)
            x == o ? h.yes.push(_.subMeshes[x]) : h.no.push(_.subMeshes[x]);
      }
    return h;
  }
  getYesNoMaterials(e, t, n, s) {
    const o = { yes: [], no: [] };
    if (t && t instanceof BABYLON.Scene)
      for (let h = 0; h < t.materials.length; h++) {
        let c = t.materials[h];
        (c.name && s.test(c.name) || c.id && s.test(c.id)) && this.verifyFilter(c.id, n) ? o.yes.push(c) : o.no.push(c);
      }
    return o;
  }
  getYesNoLights(e, t, n, s) {
    const o = { yes: [], no: [] };
    if (t && t instanceof BABYLON.Scene)
      for (let h = 0; h < t.lights.length; h++) {
        let c = t.lights[h];
        (c.name && s.test(c.name) || c.id && s.test(c.id)) && this.verifyFilter(c.id, n) ? o.yes.push(c) : o.no.push(c);
      }
    return o;
  }
  getYesNoCameras(e, t, n, s) {
    const o = { yes: [], no: [] };
    if (t && t instanceof BABYLON.Scene)
      for (let h = 0; h < t.cameras.length; h++) {
        let c = t.cameras[h];
        (c.name && s.test(c.name) || c.id && s.test(c.id)) && this.verifyFilter(c.id, n) ? o.yes.push(c) : o.no.push(c);
      }
    return o;
  }
  getYesNoCameraLocations(e, t, n, s) {
    const o = { yes: [], no: [] };
    if (e && e instanceof Zakeke.Scene)
      for (let h = 0; h < e.get("cameraLocations").length; h++) {
        let c = e.get("cameraLocations").at(h), _ = c.getLocationID(), x = c.get("name");
        (x && s.test(x) || _ && s.test(_)) && this.verifyFilter(_, n) ? o.yes.push(c) : o.no.push(c);
      }
    return o;
  }
  escapeRegExp(e) {
    return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }
  verifyFilter(e, t) {
    return !t || t.length == 0 ? !0 : t.indexOf(e) !== -1;
  }
}
class ow {
  constructor(e, t, n) {
    this._zkModel = null, this._sceneHelper = null, this._deviceType = MPlaza.DeviceType.All, this._meshDesignRefreshRequiredListeners = [], this._beginAssetsLoadingListeners = [], this._endAssetsLoadingListeners = [], this._useMaterialOffloading = !1, this._prefetchMeshes = !0, this._prefetchMaterials = !0, Logger.info("[SceneActionExecutor] Constructor called"), this._zkScene = e, this._scene = t, this._sceneHelper = new mi(t), this._elementSelector = new Zd(), n && (this._zkModel = n), Logger.info(`[SceneActionExecutor] Initialized successfully | Device type: ${this._deviceType}`);
  }
  get deviceType() {
    return this._deviceType;
  }
  set deviceType(e) {
    this._deviceType != e && (this._deviceType = e);
  }
  get useMaterialOffloading() {
    return this._useMaterialOffloading;
  }
  set useMaterialOffloading(e) {
    this._useMaterialOffloading != e && (this._useMaterialOffloading = e);
  }
  get prefetchMeshes() {
    return this._prefetchMeshes;
  }
  set prefetchMeshes(e) {
    this._prefetchMeshes !== e && (this._prefetchMeshes = e);
  }
  get prefetchMaterials() {
    return this._prefetchMaterials;
  }
  set prefetchMaterials(e) {
    this._prefetchMaterials !== e && (this._prefetchMaterials = e);
  }
  dispose() {
    this._sceneHelper && (this._sceneHelper.dispose(), this._sceneHelper = null);
  }
  // -------------------------------------------------------
  // Events
  // -------------------------------------------------------
  addMeshDesignRefreshRequiredListeners(e) {
    this._meshDesignRefreshRequiredListeners.push(e);
  }
  fireMeshDesignRefreshRequiredEvent(e, t) {
    const n = { meshes: e, effect: t };
    for (let s = 0; s < this._meshDesignRefreshRequiredListeners.length; ++s)
      this._meshDesignRefreshRequiredListeners[s](n);
  }
  addBeginAssetsLoadingListener(e) {
    this._beginAssetsLoadingListeners.push(e);
  }
  fireBeginAssetsLoadingEvent() {
    for (let e = 0; e < this._beginAssetsLoadingListeners.length; ++e)
      this._beginAssetsLoadingListeners[e]();
  }
  addEndAssetsLoadingListener(e) {
    this._endAssetsLoadingListeners.push(e);
  }
  fireEndAssetsLoadingEvent() {
    for (let e = 0; e < this._endAssetsLoadingListeners.length; ++e)
      this._endAssetsLoadingListeners[e]();
  }
  // -------------------------------------------------------
  // Actions Helpers Methods
  // -------------------------------------------------------
  isActionForDevice(e) {
    const t = e.get("deviceTypes");
    return Logger.info(`[IsActionForDevice] Checking device compatibility | DeviceType from action: ${t} | Current device: ${this._deviceType}`), t === MPlaza.DeviceType.Any || t === MPlaza.DeviceType.All ? (Logger.info("[IsActionForDevice] ✓ Action is for Any/All devices"), !0) : (t & this._deviceType) === this._deviceType ? (Logger.info("[IsActionForDevice] ✓ Action matches current device"), !0) : (Logger.warn("[IsActionForDevice] ❌ Action not compatible with current device"), !1);
  }
  // ad una mesh vengono associati dei dati aggiuntivi che servono per l'utilizzo dei filtri.
  // Un filtro consente di creare un contesto di mesh da associare ad una opzione di un attributo.
  // Quando si utilizza un'azione di tipo filtro, verranno visualizzate solo le mesh specificate dal filtro.
  // Per esempio, per un orologio potrei avere un attributo "modello" con le opzioni "classico", "moderno", "sportivo".
  // Selezionando un modello, potrebbe essere utile attivare solo le mesh che hanno a che fare con il
  // modello selezionato. Questo consentirebbe di specificare azioni su altre opzioni indipendentemente dal modello.
  // Ad esempio potrei avere un altro attributo "vetro" con le opzioni "zaffiro" e "normale" con le azioni
  // che visualizzano il vetro nel materiale selezionato, diverso per modello.
  // Un filtro è relativo ad un attributo, così da permettere la definizione di contesti più restrittivi
  // andando a cumulare filtri relativi ad attributi diversi.
  // Inizializza la struttura dati associata ad una mesh
  setupMeshData(e) {
    e.data || (e.data = {
      filters: {},
      toShow: e.isVisible
    });
  }
  // Imposta il filtro legato ad un attributo (da un'azione filtro)
  async setMeshFilterAsync(e, t, n) {
    this.setupMeshData(e), e.data.filters[t] = n, await this.chekMeshVisibilityAsync(e);
  }
  // Richiede la visibilità di una mesh (da un'azione show/hide)
  async setMeshVisibilityAsync(e, t) {
    this.setupMeshData(e), e.data.toShow = t, await this.chekMeshVisibilityAsync(e);
  }
  // Determina se dopo l'applicazione di un filtro o una richiesta di visibilità
  // la mesh debba essere mostrata o nascosta. Il risultato andrà ad agire sulla
  // effettiva visibilità della mesh, secondo l'espressione booleana:
  // mesh.isVisible = F1 && F2 && ... && Fn && toShow
  async chekMeshVisibilityAsync(e) {
    let t = null;
    if (e && e.data && (t = e.data.toShow, t))
      for (const n in e.data.filters)
        t = t && e.data.filters[n];
    if (t !== null && this._sceneHelper) {
      if (t) {
        const n = this._zkScene.get("rootUrl");
        n && await this._sceneHelper.unsetMeshDummyMaterialAsync(e, n, !0), await mi.whenMeshIsReadyAsync(e);
      }
      this._sceneHelper.showHideMesh(e.id, t);
    }
  }
  getMeshByID(e) {
    return this._scene.getMeshByID(e);
  }
  getMaterialByID(e) {
    return this._scene.getMaterialByID(e);
  }
  setCameraLocation(e) {
    const t = this._zkScene.getCameraLocation(e);
    if (t) {
      const n = new BABYLON.Vector3(
        t.get("px"),
        t.get("py"),
        t.get("pz")
      ), s = new BABYLON.Vector3(
        t.get("tx"),
        t.get("ty"),
        t.get("tz")
      );
      this._sceneHelper && this._sceneHelper.animateCamera(s, n, 0.5);
    }
  }
  adjustCamera(e) {
    this._sceneHelper && (e !== void 0 && typeof e == "boolean" ? this._sceneHelper.adjustCamera(void 0, void 0, void 0, e) : this._sceneHelper.adjustCamera());
  }
  zoomIn() {
    this._sceneHelper && this._sceneHelper.zoomIn();
  }
  zoomOut() {
    this._sceneHelper && this._sceneHelper.zoomOut();
  }
  zoom(e) {
    this._sceneHelper && this._sceneHelper.zoom(e);
  }
  setCameraPivot(e) {
    if (this._sceneHelper) {
      const t = e ? this._scene.getMeshByID(e) : null;
      this._sceneHelper.setCameraPivot(t);
    }
  }
  setCameraZoomEnabled(e) {
    this._sceneHelper && this._sceneHelper.setZoomEnabled(e);
  }
  async setMeshMaterial(e, t) {
    if (this._sceneHelper) {
      await mi.whenAllMaterialTexturesAreReady(e);
      const n = t.material;
      Logger.info(
        `Setting material to mesh | mesh: ${t.id} - ${t.name} | material: ${e.id} - ${e.name}`
      ), this._sceneHelper.applyMaterial(e, t), this._useMaterialOffloading && n && this._sceneHelper.offloadMaterial(n.id);
    }
  }
  async setSubmeshMaterial(e, t, n) {
    if (this._sceneHelper) {
      await mi.whenAllMaterialTexturesAreReady(e);
      const s = this._sceneHelper.getSubMeshMaterial(t, n);
      this._sceneHelper.applyMaterialToSubMesh(e, t, n), this._useMaterialOffloading && s && this._sceneHelper.offloadMaterial(s.id);
    }
  }
  getMaterialFromActionValue(e) {
    if (this._elementSelector) {
      const t = e.get("value");
      if (t != null && t != null) {
        let n = this._scene.getMaterialByID(t);
        return n || (n = this._scene.getMaterialByName(t)), n;
      }
    }
    return null;
  }
  getDelayedMaterialIDFromAction(e) {
    if (this._zkScene && this._scene && this._elementSelector && e && e instanceof MPlaza.AttributeSceneAction && this._scene.metadata && this._scene.metadata.delayedMaterials) {
      const t = e.get("value");
      if (t != null && t != null) {
        if (this._scene.metadata.delayedMaterials.hasOwnProperty(t))
          return t;
        for (let n in this._scene.metadata.delayedMaterials)
          if (this._scene.metadata.delayedMaterials[n].name === t)
            return n;
      }
    }
    return null;
  }
  async checkDelayedMaterial(e) {
    let t = this.getMaterialByID(e);
    if (!t && this._sceneHelper) {
      const n = this._zkScene.get("rootUrl");
      n != null && n != null && (t = await this._sceneHelper.loadDelayedMaterialAsync(n, e));
    }
    return t;
  }
  getOffloadedMaterialIDFromAction(e) {
    if (this._zkScene && this._scene && this._elementSelector && e && e instanceof MPlaza.AttributeSceneAction && this._scene.metadata && this._scene.metadata.offloadedMaterials) {
      const t = e.get("value");
      if (t != null) {
        if (this._scene.metadata.offloadedMaterials.hasOwnProperty(t))
          return t;
        for (let n in this._scene.metadata.offloadedMaterials)
          if (this._scene.metadata.offloadedMaterials[n].name === t)
            return n;
      }
    }
    return null;
  }
  async checkOffloadedMaterialAsync(e) {
    let t = this.getMaterialByID(e);
    if (!t && this._sceneHelper) {
      const n = this._zkScene.get("rootUrl");
      n != null && (t = await this._sceneHelper.loadOffloadedMaterialAsync(n, e));
    }
    return t;
  }
  // Recupera il materiale specificato nel valore di un'azione, eventualmente caricandolo da remoto (delayed) oppure dalla cache (offloaded)
  async getDeepMaterialFromActionValueAsync(e) {
    let t = this.getMaterialFromActionValue(e);
    if (!t && this._sceneHelper) {
      const n = this._zkScene.get("rootUrl");
      if (n != null) {
        let s = this.getOffloadedMaterialIDFromAction(e);
        s ? (Logger.info("Requesting offloaded material - id: ", s), t = await this._sceneHelper.loadOffloadedMaterialAsync(n, s), Logger.info("Obtained offloaded material - id: ", s)) : (s = this.getDelayedMaterialIDFromAction(e), s && (Logger.info("Requesting delayed material - id: ", s), t = await this._sceneHelper.loadDelayedMaterialAsync(n, s), Logger.info("Obtained delayed material - id: ", s)));
      }
    }
    return t;
  }
  scriptRequiresDelayedLoading(e) {
    for (let t = 0; t < e.length; t++) {
      const n = e[t];
      if (this.actionsRequireDelayedLoading(n.actions))
        return !0;
    }
    return !1;
  }
  actionsRequireDelayedLoading(e) {
    for (let t = 0; t < e.length; t++)
      if (this.actionRequiresDelayedLoading(e[t]))
        return !0;
    return !1;
  }
  actionRequiresDelayedLoading(e) {
    if (this._sceneHelper && e.get("actionTypeID") === MPlaza.SceneActionType.ShowHideMesh && e.get("value") === "show") {
      const t = e.get("selector");
      if (t != null) {
        const n = this._elementSelector.getElements(
          this._zkScene,
          this._scene,
          null,
          t,
          MPlaza.SceneElementType.Mesh
        );
        for (let s = 0; s < n.length; s++) {
          const o = n[s];
          if (o instanceof BABYLON.AbstractMesh && !o.isVisible) {
            const h = this._sceneHelper.getMeshDelayedMaterialIDs(o), c = this._sceneHelper.getMeshOffloadedMaterialIDs(o);
            if (h.length > 0 || c.length > 0 || mi.meshRequiresDelayedLoading(o))
              return !0;
          }
        }
      }
    }
    if ((e.get("actionTypeID") === MPlaza.SceneActionType.SetMeshMaterial || e.get("actionTypeID") === MPlaza.SceneActionType.SetSubMeshMaterial || e.get("actionTypeID") === MPlaza.SceneActionType.SetMaterialColor || e.get("actionTypeID") === MPlaza.SceneActionType.SetMeshDesignMaterial) && !this.getMaterialFromActionValue(e) && (this.getDelayedMaterialIDFromAction(e) || this.getOffloadedMaterialIDFromAction(e)))
      return !0;
    if (e.get("actionTypeID") === MPlaza.SceneActionType.SetMaterialColor) {
      const t = e.get("selector");
      if (t != null) {
        const n = this._elementSelector.getDelayedElementIDs(
          this._zkScene,
          this._scene,
          null,
          t,
          MPlaza.SceneElementType.Material
        ), s = this._elementSelector.getOffloadedElementIDs(
          this._zkScene,
          this._scene,
          null,
          t,
          MPlaza.SceneElementType.Material
        );
        if (n.length > 0 || s.length > 0)
          return !0;
      }
    }
    return !1;
  }
  async getAllMaterialElementsAsync(e) {
    const t = [];
    if (this._zkScene && this._scene && this._sceneHelper && this._elementSelector) {
      const n = this._elementSelector.getMaterialElements(
        this._zkScene,
        this._scene,
        null,
        e,
        MPlaza.SceneElementType.Material
      );
      Array.prototype.push.apply(t, n);
      const s = n.map((_) => _.id), o = this._elementSelector.getDelayedElementIDs(
        this._zkScene,
        this._scene,
        null,
        e,
        MPlaza.SceneElementType.Material
      ), h = this._elementSelector.getOffloadedElementIDs(
        this._zkScene,
        this._scene,
        null,
        e,
        MPlaza.SceneElementType.Material
      ), c = this._zkScene.get("rootUrl");
      if (c != null) {
        const _ = [];
        if (o.forEach((B) => {
          s.indexOf(B) === -1 && _.push(B);
        }), _.length > 0) {
          const B = await this._sceneHelper.loadDelayedMaterialsAsync(
            c,
            _
          );
          Array.prototype.push.apply(t, B);
        }
        const x = [];
        if (h.forEach((B) => {
          s.indexOf(B) === -1 && x.push(B);
        }), x.length > 0) {
          const B = await this._sceneHelper.loadOffloadedMaterialsByIDsAsync(
            c,
            x
          );
          Array.prototype.push.apply(t, B);
        }
      }
    }
    return t;
  }
  // Uno script è un array di oggetti ognuno dei quali rappresenta le azioni da eseguire
  // conseguentemente alla selezione di un valore per un attributo
  // si suppone che le azioni siano già ordinate per ordine di esecuzione
  // script: [{attributeID, selectedValue, actions}]
  async executeScriptAsync(e) {
    Logger.info("[ExecuteScript] ========== SCRIPT EXECUTION START =========="), Logger.info(`[ExecuteScript] Script length: ${e.length} script actions`);
    const t = this.scriptRequiresDelayedLoading(e);
    Logger.info(`[ExecuteScript] Requires delayed loading: ${t}`), t && this.fireBeginAssetsLoadingEvent();
    for (let n = 0; n < e.length; n++) {
      const s = e[n];
      Logger.info(`[ExecuteScript] >>> Processing script action ${n + 1}/${e.length} | AttributeID: ${s.attributeID} | Value: ${s.selectedValue} | Actions: ${s.actions.length}`), await this.executeActionsAsync(
        s.attributeID,
        s.selectedValue,
        s.actions,
        !1
      );
    }
    t && this.fireEndAssetsLoadingEvent(), Logger.info("[ExecuteScript] ========== SCRIPT EXECUTION COMPLETED ==========");
  }
  async executeActionsAsync(e, t, n, s = !0) {
    if (Logger.info("[ExecuteActions] ========== STARTING ACTIONS EXECUTION =========="), Logger.info(`[ExecuteActions] AttributeID: ${e} | SelectedValue: ${t} | Actions count: ${n.length}`), n.length > 0) {
      const o = this.actionsRequireDelayedLoading(n);
      s && o && this.fireBeginAssetsLoadingEvent(), await this.checkActionsAssetsAreReadyAsync(n);
      for (let h = 0; h < n.length; h++) {
        const c = n[h];
        Logger.info(`[ExecuteActions] >>> Processing action ${h + 1}/${n.length} | Type: ${c.get("actionTypeID")} | Selector: '${c.get("selector")}'`), await this.executeActionAsync(e, t, c);
      }
      s && o && this.fireEndAssetsLoadingEvent(), Logger.info("[ExecuteActions] ========== ACTIONS EXECUTION COMPLETED ==========");
    }
  }
  // Esegue una singola azione generata dalla selezione di un attributo
  // action: MPlaza.AttributeSceneAction
  async executeActionAsync(e, t, n) {
    if (!this.isActionForDevice(n)) {
      Logger.info(`[ExecuteAction] ❌ Action not for device | ActionType: ${n.get("actionTypeID")} | DeviceType: ${this._deviceType}`);
      return;
    }
    const s = n.get("actionTypeID"), o = n.get("selector"), h = n.get("value"), c = n.get("propertyName");
    if (Logger.info("[ExecuteAction] ========== EXECUTING ACTION =========="), Logger.info(`[ExecuteAction] AttributeID: ${e} | SelectedValue: ${t}`), Logger.info(`[ExecuteAction] ActionTypeID: ${s} | Selector: '${o}' | Value: '${h}'`), Logger.info(`[ExecuteAction] PropertyName: '${c}'`), console.log(`🔥 EXECUTING ACTION ${s} - ${o} - ${h}`), n) {
      switch (s) {
        case MPlaza.SceneActionType.Filter:
          await this.executeFilterActionAsync(e, t, n);
          break;
        case MPlaza.SceneActionType.ShowHideMesh:
          await this.executeShowHideActionAsync(e, t, n);
          break;
        case MPlaza.SceneActionType.SetMeshMaterial:
          await this.executeSetMeshMaterialActionAsync(e, t, n);
          break;
        case MPlaza.SceneActionType.SetSubMeshMaterial:
          await this.executeSetSubMeshMaterialActionAsync(e, t, n);
          break;
        case MPlaza.SceneActionType.SetMaterialColor:
          await this.executeSetMaterialColorActionAsync(e, t, n);
          break;
        case MPlaza.SceneActionType.SetCameraLocation:
          await this.executeSetCameraLocationActionAsync(e, t, n);
          break;
        case MPlaza.SceneActionType.AdjustCamera:
          await this.executeAdjustCameraActionAsync(e, t, n);
          break;
        case MPlaza.SceneActionType.SetCameraPivot:
          await this.executeSetCameraPivotActionAsync(e, t, n);
          break;
        case MPlaza.SceneActionType.ResetCameraPivot:
          await this.executeResetCameraPivotActionAsync(e, t, n);
          break;
        case MPlaza.SceneActionType.EnableDiableZoom:
          await this.executeEnableDisableZoomActionAsync(e, t, n);
          break;
        case MPlaza.SceneActionType.SetMeshDesignMaterial:
          await this.executeSetMeshDesignMaterialActionAsync(e, t, n);
          break;
        case MPlaza.SceneActionType.SetMeshDesignEffect:
          await this.executeSetMeshDesignEffectActionAsync(e, t, n);
          break;
        case MPlaza.SceneActionType.SetMaterialParameter:
          console.log(`🎯 MATCHED SetMaterialParameter case! Type: ${s}`), console.warn(`🎯 MATCHED SetMaterialParameter case! Type: ${s}`), Logger.info(`[ExecuteAction] ✓ CALLING SetMaterialParameter action | Type: ${s}`), await this.executeSetMaterialParameterActionAsync(e, t, n);
          break;
      }
      Logger.info(`[ExecuteAction] ✓ Action execution completed | ActionType: ${s}`);
    } else
      Logger.warn("[ExecuteAction] ❌ No action provided to execute");
  }
  async executeFilterActionAsync(e, t, n) {
    if (this.isActionForDevice(n) && e !== null && this._zkScene && this._scene && this._sceneHelper && this._elementSelector && n && n instanceof MPlaza.AttributeSceneAction) {
      const s = n.get("selector");
      if (s != null) {
        const o = this._elementSelector.getYesNoElements(
          this._zkScene,
          this._scene,
          null,
          s,
          MPlaza.SceneElementType.Mesh
        ), h = n.get("value") === "enable";
        for (let c = 0; c < o.yes.length; c++)
          await this.setMeshFilterAsync(o.yes[c], e, h);
        for (let c = 0; c < o.no.length; c++)
          await this.setMeshFilterAsync(o.yes[c], e, !h);
      }
    }
  }
  async executeShowHideActionAsync(e, t, n) {
    if (this.isActionForDevice(n) && this._zkScene && this._scene && this._sceneHelper && this._elementSelector && n && n instanceof MPlaza.AttributeSceneAction) {
      const s = n.get("selector");
      if (s != null) {
        const o = this._elementSelector.getMeshElements(
          this._zkScene,
          this._scene,
          null,
          s,
          MPlaza.SceneElementType.Mesh
        ), h = n.get("value") === "show";
        for (let c = 0; c < o.length; c++)
          await this.setMeshVisibilityAsync(o[c], h);
      }
    }
  }
  async executeSetMeshMaterialActionAsync(e, t, n) {
    if (this.isActionForDevice(n) && this._zkScene && this._scene && this._sceneHelper && this._elementSelector && n && n instanceof MPlaza.AttributeSceneAction) {
      const s = n.get("selector");
      if (s != null) {
        const o = this._elementSelector.getMeshElements(
          this._zkScene,
          this._scene,
          null,
          s,
          MPlaza.SceneElementType.Mesh
        ), h = await this.getDeepMaterialFromActionValueAsync(n);
        if (h)
          for (let c = 0; c < o.length; c++)
            await this.setMeshMaterial(h, o[c]);
      }
    }
  }
  async executeSetSubMeshMaterialActionAsync(e, t, n) {
    if (this.isActionForDevice(n) && this._zkScene && this._scene && this._sceneHelper && this._elementSelector && n && n instanceof MPlaza.AttributeSceneAction) {
      const s = n.get("selector");
      if (s != null) {
        const o = this._elementSelector.getSubMeshElements(
          this._zkScene,
          this._scene,
          null,
          s,
          MPlaza.SceneElementType.SubMesh
        ), h = await this.getDeepMaterialFromActionValueAsync(n);
        if (h)
          for (let c = 0; c < o.length; c++)
            await this.setSubmeshMaterial(h, null, o[c]);
      }
    }
  }
  async executeSetMaterialColorActionAsync(e, t, n) {
    if (this.isActionForDevice(n) && this._zkScene && this._scene && this._sceneHelper && this._elementSelector && n && n instanceof MPlaza.AttributeSceneAction) {
      const s = n.get("selector");
      if (s != null) {
        Logger.info(`[SetMaterialColor] Start | selector: '${s}'`);
        const o = await this.getAllMaterialElementsAsync(s);
        Logger.info(`[SetMaterialColor] Found ${o.length} material(s)`);
        const h = n.get("propertyName");
        let c = n.get("value");
        if (h && c) {
          if (Logger.info(`[SetMaterialColor] PropertyName: '${h}' | Original value: '${c}'`), t) {
            const x = c;
            c = c.replace(/%value%/g, t), x !== c && Logger.info(
              `[SetMaterialColor] Replaced %value% with '${t}' | Result: '${c}'`
            );
          }
          const _ = BABYLON.Color3.FromHexString(c);
          Logger.info(`[SetMaterialColor] Applying color ${c} to ${o.length} material(s)`);
          for (let x = 0; x < o.length; x++)
            Logger.info(
              `[SetMaterialColor] Applying to material '${o[x].id}' - property '${h}'`
            ), this._sceneHelper.changeMaterialColor(
              o[x],
              h,
              _
            );
          Logger.info("[SetMaterialColor] Completed successfully");
        } else
          Logger.warn(
            `[SetMaterialColor] Missing propertyName or value | propertyName: ${h} | value: ${c}`
          );
      } else
        Logger.warn("[SetMaterialColor] No selector specified");
    }
  }
  async executeSetCameraLocationActionAsync(e, t, n) {
    if (this.isActionForDevice(n) && this._zkScene && this._scene && this._elementSelector && n && n instanceof MPlaza.AttributeSceneAction) {
      const s = n.get("value");
      let o = null;
      if (s)
        for (let h = 0; h < this._zkScene.get("cameraLocations").length; h++) {
          const c = this._zkScene.get("cameraLocations").at(h);
          if (c.get("locationID") === s || c.get("name") === s) {
            o = c;
            break;
          }
        }
      o !== null && this.setCameraLocation(o.get("locationID"));
    }
  }
  async executeAdjustCameraActionAsync(e, t, n) {
    this.isActionForDevice(n) && this._zkScene && this._scene && this._sceneHelper && this._elementSelector && n && n instanceof MPlaza.AttributeSceneAction && this._sceneHelper.adjustCamera();
  }
  async executeSetCameraPivotActionAsync(e, t, n) {
    if (this.isActionForDevice(n) && this._zkScene && this._scene && this._elementSelector && n && n instanceof MPlaza.AttributeSceneAction) {
      const s = n.get("value");
      let o = null;
      if (s)
        for (let h = 0; h < this._scene.meshes.length; h++) {
          const c = this._scene.meshes[h];
          if (c.id === s || c.name === s) {
            o = c;
            break;
          }
        }
      o && this.setCameraPivot(o.id);
    }
  }
  async executeResetCameraPivotActionAsync(e, t, n) {
    this.isActionForDevice(n) && this.setCameraPivot(null);
  }
  async executeEnableDisableZoomActionAsync(e, t, n) {
    if (this.isActionForDevice(n) && this._zkScene && this._scene && this._elementSelector && n && n instanceof MPlaza.AttributeSceneAction) {
      const s = n.get("value") === "enable";
      this.setCameraZoomEnabled(s);
    }
  }
  async executeSetMeshDesignMaterialActionAsync(e, t, n) {
    if (this._zkScene && this._scene && this._elementSelector && n && n instanceof MPlaza.AttributeSceneAction) {
      const s = n.get("selector");
      if (s != null && s != null) {
        const o = this._elementSelector.getMeshElements(
          this._zkScene,
          this._scene,
          null,
          s,
          MPlaza.SceneElementType.Mesh
        ), h = await this.getDeepMaterialFromActionValueAsync(n);
        if (h) {
          for (let c = 0; c < o.length; c++) {
            const _ = o[c];
            _.metadata = _.metadata || {}, _.metadata.designMaterialID = h.id;
          }
          this.fireMeshDesignRefreshRequiredEvent(o, null);
        }
      }
    }
  }
  async executeSetMeshDesignEffectActionAsync(e, t, n) {
    if (this.isActionForDevice(n) && this._zkScene && this._scene && this._elementSelector && n && n instanceof MPlaza.AttributeSceneAction) {
      const s = n.get("selector");
      if (s != null && s != null) {
        let o = this._elementSelector.getMeshElements(
          this._zkScene,
          this._scene,
          null,
          s,
          MPlaza.SceneElementType.Mesh
        ), h = n.get("value"), c = null;
        if (h != null && h != null && this._zkModel)
          for (let x = 0; x < this._zkModel.get("scenes").length; x++) {
            const B = this._zkModel.get("scenes").at(x);
            if (B.get("isDefault")) {
              const P = B.get("meshDesignEffects");
              if (P)
                for (let U = 0; U < P.length; U++) {
                  const M = P.at(U);
                  if (M.get("effectID") === h || M.get("name") === h) {
                    c = M;
                    break;
                  }
                }
            }
            if (c)
              break;
          }
        let _ = null;
        if (c) {
          const x = c.get("materialID");
          x && (_ = await this.checkOffloadedMaterialAsync(x), _ || (_ = await this.checkDelayedMaterial(x)));
        }
        this.fireMeshDesignRefreshRequiredEvent(o, c);
      }
    }
  }
  async executeSetMaterialParameterActionAsync(e, t, n) {
    if (console.log(">>>>>>> SET MATERIAL PARAMETER ACTION CALLED! <<<<<<<"), console.warn(">>>>>>> SET MATERIAL PARAMETER ACTION CALLED! <<<<<<<"), console.error(">>>>>>> SET MATERIAL PARAMETER ACTION CALLED! <<<<<<<"), Logger.info("[SetMaterialParameter] >>>>>>>>>> METHOD CALLED <<<<<<<<<<"), Logger.info(`[SetMaterialParameter] Input parameters - AttributeID: ${e} | SelectedValue: ${t}`), !this.isActionForDevice(n)) {
      Logger.warn("[SetMaterialParameter] ❌ Action not for device, exiting");
      return;
    }
    if (Logger.info("[SetMaterialParameter] ========== START =========="), Logger.info(`[SetMaterialParameter] AttributeID: ${e} | SelectedValue: ${t}`), this._zkScene && this._scene && this._elementSelector && n && n instanceof MPlaza.AttributeSceneAction) {
      console.log("🔍 All dependencies OK, proceeding...");
      const s = n.get("selector");
      if (console.log(`🎯 Material selector: '${s}'`), Logger.info(`[SetMaterialParameter] Selector expression: '${s}'`), s == null) {
        console.error("❌ No selector found!"), Logger.warn("[SetMaterialParameter] ❌ Action has no selector (material)");
        return;
      }
      const o = this._elementSelector.getMaterialElements(
        this._zkScene,
        this._scene,
        null,
        s,
        MPlaza.SceneElementType.Material
      );
      if (console.log(`📦 Found ${o.length} materials for selector`), Logger.info(`[SetMaterialParameter] Found ${o.length} material(s) matching selector`), !o || o.length === 0) {
        console.error(`❌ NO MATERIALS FOUND for selector: '${s}'`), Logger.warn(`[SetMaterialParameter] ❌ No materials found for selector '${s}'`);
        return;
      }
      o.forEach((_, x) => {
        console.log(`📋 Material[${x}]: id='${_.id}' name='${_.name}' type='${_.getClassName()}'`), Logger.info(`[SetMaterialParameter]   Material[${x}]: id='${_.id}' name='${_.name}'`), x === 0 && this.analyzeMaterialStructure(_);
      });
      const h = n.get("propertyName"), c = n.get("value");
      if (console.log("🎨 Property details:"), console.log(`   PropertyPath: '${h}'`), console.log(`   PropertyValue: '${c}'`), Logger.info(`[SetMaterialParameter] PropertyPath (dot notation): '${h}'`), Logger.info(`[SetMaterialParameter] PropertyValue: '${c}'`), !h) {
        console.error("❌ NO PROPERTY NAME found in action"), Logger.warn("[SetMaterialParameter] ❌ No propertyName found in action");
        return;
      }
      console.log(`🚀 Starting to apply property to ${o.length} material(s)...`), Logger.info(`[SetMaterialParameter] Applying property to ${o.length} material(s)...`);
      for (let _ = 0; _ < o.length; _++) {
        const x = o[_];
        console.log(`🔧 Processing material[${_}]: '${x.id}' (${x.getClassName()})`), Logger.info(`[SetMaterialParameter] >>> Processing material[${_}]: '${x.id}'`), this.applyMaterialProperty(x, h, c);
      }
      console.log("✅ SetMaterialParameter completed successfully!"), Logger.info("[SetMaterialParameter] ========== COMPLETED ==========");
    } else
      Logger.warn("[SetMaterialParameter] ❌ Missing required dependencies (_zkScene, _scene, _elementSelector)");
  }
  // Helper method per analizzare la struttura di un materiale
  analyzeMaterialStructure(e) {
    console.log(`🔍 Material Analysis for: ${e.id} (${e.getClassName()})`);
    const t = e, n = [], s = {};
    for (const o in t)
      if (t.hasOwnProperty(o)) {
        const h = t[o];
        if (h && typeof h == "object" && h.constructor && h.constructor.name && h.constructor.name !== "Color3" && h.constructor.name !== "Vector3" && h.constructor.name !== "Texture" && !Array.isArray(h)) {
          const c = [];
          for (const _ in h)
            h.hasOwnProperty(_) && c.push(_);
          c.length > 0 && (s[o] = c);
        }
        (typeof h == "string" || typeof h == "number" || typeof h == "boolean" || h && h.constructor && (h.constructor.name === "Color3" || h.constructor.name === "Vector3")) && n.push(`${o} (${typeof h}${h.constructor ? " - " + h.constructor.name : ""})`);
      }
    console.log(`📋 Direct Properties (${n.length}):`, n.slice(0, 10)), console.log("🏗️ Nested Properties:", s);
  }
  applyMaterialProperty(e, t, n) {
    try {
      const s = this.normalizePropertyPath(t);
      console.log("🔨 ApplyMaterialProperty START"), console.log(`   Material: '${e.id}' (${e.getClassName()})`), console.log(`   Path (original): '${t}'`), console.log(`   Path (normalized): '${s}'`), console.log(`   Value: '${n}' (${typeof n})`), Logger.info(
        `[ApplyMaterialProperty] Start | Material: '${e.id}' | Path: '${t}' → '${s}' | Value: '${n}'`
      ), this.ensureSubPropertyEnabled(e, s);
      const o = this.resolveMaterialPropertyPath(e, s);
      if (!o) {
        console.error(`❌ Cannot resolve property path '${s}' on material '${e.id}'`), Logger.error(`[ApplyMaterialProperty] ❌ Cannot resolve property path '${s}' on material '${e.id}'`);
        return;
      }
      if (console.log(`✅ Resolved path: ${o.description}`), Logger.info(`[ApplyMaterialProperty] ✅ Resolved path: ${o.description}`), this.isTextureProperty(s)) {
        console.log("🖼️ TEXTURE property detected"), Logger.info("[ApplyMaterialProperty] ✓ Detected TEXTURE property");
        try {
          console.log("🖼️ Calling applyTextureProperty..."), Logger.info(`[ApplyMaterialProperty] Calling applyTextureProperty with path: '${s}' and value: '${n}'`), this.applyTextureProperty(e, s, n), console.log("🖼️ applyTextureProperty completed"), Logger.info("[ApplyMaterialProperty] ✓ Texture property applied successfully");
        } catch (h) {
          console.error("❌ Error in applyTextureProperty:", h), Logger.error("[ApplyMaterialProperty] ❌ Error in applyTextureProperty:", h);
        }
        return;
      }
      if (typeof n == "string" && n.startsWith("#")) {
        console.log("🎨 COLOR property detected (hex format)"), Logger.info("[ApplyMaterialProperty] ✓ Detected COLOR property (hex format)"), this.applySmartColorProperty(e, o, n), Logger.info("[ApplyMaterialProperty] ✓ Color property applied successfully");
        return;
      }
      console.log("⚙️ STANDARD property detected"), Logger.info("[ApplyMaterialProperty] ✓ Detected STANDARD property (boolean/number/string)"), this.applySmartStandardProperty(e, o, n), Logger.info("[ApplyMaterialProperty] ✓ Standard property applied successfully");
    } catch (s) {
      Logger.error(
        `[ApplyMaterialProperty] ❌ Error applying property '${t}' to material '${e.id}'`,
        s
      );
    }
  }
  /**
   * Normalizza il propertyPath per correggere casi malformati e inconsistenze
   * Es: "clearcoat.clearCoat_bumpTexture" → "clearCoat_bumpTexture"
   * Es: "anisotropic.anisotropy.texture" → "anisotropy.texture"
   * Es: "subsurface.tintColor" → "subSurface.tintColor"
   */
  normalizePropertyPath(e) {
    console.log(`🔧 [NormalizePropertyPath] Input: '${e}'`);
    const t = {
      subsurface: "subSurface",
      anisotropic: "anisotropy"
    };
    let n = e;
    for (const [s, o] of Object.entries(t)) {
      const h = new RegExp(`\\b${s}\\b`, "gi");
      n = n.replace(h, o);
    }
    if (n !== e && console.log(`🔧 [NormalizePropertyPath] Fixed property names: '${e}' → '${n}'`), n.includes(".")) {
      const s = n.split(".");
      if (s.length === 3 && s[0].toLowerCase() === s[1].toLowerCase())
        n = s[1] + "." + s[2], console.log(`🔧 [NormalizePropertyPath] Removed duplicate prefix: '${e}' → '${n}'`);
      else if (s.length === 2) {
        const o = s[0].toLowerCase();
        s[1].toLowerCase().startsWith(o + "_") && (n = s[1], console.log(`🔧 [NormalizePropertyPath] Fixed malformed underscore path: '${e}' → '${n}'`));
      }
    }
    return n !== e && Logger.info(`[NormalizePropertyPath] Normalized: '${e}' → '${n}'`), n;
  }
  /**
   * Abilita automaticamente le sotto-proprietà (clearCoat, sheen, subSurface, anisotropy) 
   * quando si sta per applicare una texture o proprietà su di esse
   */
  ensureSubPropertyEnabled(e, t) {
    const n = e;
    t.toLowerCase().includes("clearcoat") && (n.clearCoat.isEnabled || (n.clearCoat.isEnabled = !0, Logger.info(`[EnsureSubPropertyEnabled] ✅ Enabled clearCoat for material '${e.id}'`), console.log(`✅ Enabled clearCoat for material '${e.id}'`))), t.toLowerCase().includes("sheen") && (n.sheen.isEnabled || (n.sheen.isEnabled = !0, Logger.info(`[EnsureSubPropertyEnabled] ✅ Enabled sheen for material '${e.id}'`), console.log(`✅ Enabled sheen for material '${e.id}'`))), t.toLowerCase().includes("subsurface") && (n.subSurface.isEnabled || (n.subSurface.isEnabled = !0, Logger.info(`[EnsureSubPropertyEnabled] ✅ Enabled subSurface for material '${e.id}'`), console.log(`✅ Enabled subSurface for material '${e.id}'`))), t.toLowerCase().includes("anisotropy") && (n.anisotropy.isEnabled || (n.anisotropy.isEnabled = !0, Logger.info(`[EnsureSubPropertyEnabled] ✅ Enabled anisotropy for material '${e.id}'`), console.log(`✅ Enabled anisotropy for material '${e.id}'`)));
  }
  isTextureProperty(e) {
    return e.endsWith("Texture") || e.includes("_texture") || e.includes("TextureRoughnessTexture") || e.includes("bumpTexture") || e.includes("tintTexture");
  }
  applyTextureProperty(e, t, n) {
    console.log(`🖼️ [ApplyTextureProperty] ENTRY - Material: '${e.id}' | Path: '${t}' | URL: '${n}'`), Logger.info(`[ApplyTextureProperty] ENTRY - Material: '${e.id}' | Path: '${t}' | URL: '${n}'`);
    try {
      Logger.info(
        `[ApplyTextureProperty] Material: '${e.id}' | Path: '${t}' | URL: '${n}'`
      ), this.ensureSubPropertyEnabled(e, t), Logger.info(`[ApplyTextureProperty] Step 2: 🚩 Loading texture from URL: '${n}'`), Logger.info("[ApplyTextureProperty] 🔄 Step 2: Converting propertyPath to textureType..."), console.log(`[ApplyTextureProperty] 🔄 Step 2: Converting propertyPath '${t}' to textureType...`);
      const s = this.convertPropertyPathToTextureType(t);
      if (Logger.info(`[ApplyTextureProperty] Step 2: 🛠️ Converting propertyPath '${t}' to textureType '${s}'`), !s) {
        Logger.warn(`[ApplyTextureProperty] ❌ Step 2 FAILED: Could not convert propertyPath '${t}' to texture type`), console.error("[ApplyTextureProperty] ❌ Step 2 FAILED: Could not convert propertyPath");
        return;
      }
      if (Logger.info(`[ApplyTextureProperty] ✅ Step 2 SUCCESS: textureType = '${s}'`), console.log(`[ApplyTextureProperty] ✅ Step 2 SUCCESS: textureType = '${s}'`), Logger.info("[ApplyTextureProperty] 🚦 About to proceed to Step 3..."), console.log("[ApplyTextureProperty] 🚦 About to proceed to Step 3..."), Logger.info("[ApplyTextureProperty] 🔍 Step 3: Checking SceneHelper availability..."), console.log("[ApplyTextureProperty] 🔍 Step 3: SceneHelper check:", {
        hasSceneHelper: !!this._sceneHelper,
        sceneHelperType: typeof this._sceneHelper,
        sceneHelperValue: this._sceneHelper
      }), !this._sceneHelper) {
        Logger.warn("[ApplyTextureProperty] ❌ Step 3 FAILED: SceneHelper not available, trying to recreate..."), console.error("[ApplyTextureProperty] ❌ Step 3 FAILED: SceneHelper not available");
        try {
          this._sceneHelper = new mi(this._scene), Logger.info("[ApplyTextureProperty] ✅ SceneHelper recreated successfully"), console.log("[ApplyTextureProperty] ✅ SceneHelper recreated successfully");
        } catch (h) {
          Logger.error("[ApplyTextureProperty] ❌ Failed to recreate SceneHelper:", h), console.error("[ApplyTextureProperty] ❌ Failed to recreate SceneHelper:", h);
          return;
        }
      }
      Logger.info("[ApplyTextureProperty] ✅ Step 3 SUCCESS: SceneHelper is available"), console.log("[ApplyTextureProperty] ✅ Step 3 SUCCESS: SceneHelper is available"), Logger.info("[ApplyTextureProperty] 🏗️ Step 4: Creating BABYLON.Texture object..."), console.log("[ApplyTextureProperty] 🏗️ Step 4: Creating BABYLON.Texture with params:", {
        url: n,
        noMipMap: !1,
        invertY: !0,
        samplingMode: "TRILINEAR"
      });
      const o = new BABYLON.Texture(
        n,
        this._scene,
        !1,
        // noMipMap: false (genera mipmaps come nel backoffice)
        !0,
        // invertY: true (default nel backoffice)
        BABYLON.Texture.TRILINEAR_SAMPLINGMODE,
        // sampling mode
        () => {
          Logger.info("[ApplyTextureProperty] 🔥 Texture onLoad callback fired!"), console.log("[ApplyTextureProperty] 🔥 Texture onLoad callback fired!"), this._scene.render();
        },
        (h) => {
          Logger.warn(`[ApplyTextureProperty] ❌ Texture onError callback fired: ${h}`), console.error("[ApplyTextureProperty] ❌ Texture onError callback fired:", h);
        }
      );
      Logger.info("[ApplyTextureProperty] ✅ Step 5: Texture object created"), console.log("[ApplyTextureProperty] ✅ Step 5: Texture object created:", o), Logger.info("[ApplyTextureProperty] 📝 Step 6: Setting texture metadata..."), console.log("[ApplyTextureProperty] 📝 Step 6: Setting texture metadata..."), o.metadata = { fileUrl: n }, o.name = t, Logger.info("[ApplyTextureProperty] ✅ Step 6: Metadata set"), console.log(`[ApplyTextureProperty] ✅ Step 6: Metadata set - name: '${t}', fileUrl: '${n}'`), Logger.info("[ApplyTextureProperty] ⏳ Step 7: Calling SceneHelper.whenTextureIsReadyAsync()..."), console.log("[ApplyTextureProperty] ⏳ Step 7: Calling SceneHelper.whenTextureIsReadyAsync()..."), console.log("[ApplyTextureProperty] Texture object:", o), console.log("[ApplyTextureProperty] Texture.isReady():", o.isReady ? o.isReady() : "isReady() not available"), console.log("[ApplyTextureProperty] SceneHelper.whenTextureIsReadyAsync exists?", typeof mi.whenTextureIsReadyAsync), mi.whenTextureIsReadyAsync(o).then(() => {
        var c, _, x, B, P, U;
        Logger.info("[ApplyTextureProperty] 🎉 Step 8: Texture is ready! Applying now..."), console.log("[ApplyTextureProperty] 🎉 Step 8: Texture is ready! Applying now..."), Logger.info("[ApplyTextureProperty] 🔧 Step 9: Calling SceneHelper.applyTexture()..."), console.log("[ApplyTextureProperty] 🔧 Step 9: Parameters - texture:", o, "material:", e, "type:", s), this._sceneHelper.applyTexture(o, e, s), Logger.info("[ApplyTextureProperty] ✅ Step 10: Applied texture via SceneHelper"), console.log("[ApplyTextureProperty] ✅ Step 10: Applied texture via SceneHelper"), Logger.info("[ApplyTextureProperty] 🔄 Step 11: Calling markMaterialDirty()..."), console.log("[ApplyTextureProperty] 🔄 Step 11: Calling markMaterialDirty()..."), this.markMaterialDirty(e), Logger.info("[ApplyTextureProperty] ✅ Step 12: markMaterialDirty() completed"), console.log("[ApplyTextureProperty] ✅ Step 12: markMaterialDirty() completed"), Logger.info("[ApplyTextureProperty] 🎨 Step 13: Calling scene.render()..."), console.log("[ApplyTextureProperty] 🎨 Step 13: Calling scene.render()..."), this._scene.render(), Logger.info("[ApplyTextureProperty] ✅ Step 14: scene.render() completed"), console.log("[ApplyTextureProperty] ✅ Step 14: scene.render() completed");
        const h = e;
        Logger.info("[ApplyTextureProperty] 📊 Step 15: Checking material state..."), console.log(`[DEBUG] 🎨 Step 15: Stato materiale '${e.id}' dopo applicazione texture:`), console.log("  - albedoTexture:", h.albedoTexture), console.log("  - albedoColor:", h.albedoColor), console.log("  - texture.isReady():", (_ = (c = h.albedoTexture) == null ? void 0 : c.isReady) == null ? void 0 : _.call(c)), console.log("  - material.isReady():", (x = h.isReady) == null ? void 0 : x.call(h)), console.log("  - material.alpha:", h.alpha), console.log("  - material.disableLighting:", h.disableLighting), Logger.info(`[DEBUG] albedoTexture: ${h.albedoTexture ? "SET ✅" : "NULL ❌"}`), Logger.info(`[DEBUG] albedoColor: ${h.albedoColor}`), Logger.info(`[DEBUG] texture.isReady: ${(P = (B = h.albedoTexture) == null ? void 0 : B.isReady) == null ? void 0 : P.call(B)}`), Logger.info(`[DEBUG] material.isReady: ${(U = h.isReady) == null ? void 0 : U.call(h)}`), Logger.info("[ApplyTextureProperty] 🏁 TEXTURE APPLICATION COMPLETE!"), console.log("[ApplyTextureProperty] 🏁 TEXTURE APPLICATION COMPLETE!");
      }).catch((h) => {
        Logger.error("[ApplyTextureProperty] ❌ ERROR in Step 8 - Promise rejected:", h), console.error("[ApplyTextureProperty] ❌ ERROR in Step 8 - Promise rejected:", h), console.error("[ApplyTextureProperty] Error stack:", h == null ? void 0 : h.stack);
      });
    } catch (s) {
      Logger.error(
        `[ApplyTextureProperty] ❌ Error applying texture property '${t}' to material '${e.id}'`,
        s
      );
    }
  }
  /**
   * Converte un property path (es: "albedoTexture", "albedo.albedoTexture", "clearCoat_textureRoughnessTexture") 
   * in texture type per SceneHelper (es: "albedo", "clearCoat_textureRoughness")
   */
  convertPropertyPathToTextureType(e) {
    if (console.log(`[convertPropertyPathToTextureType] 🔄 Input: '${e}'`), Logger.info(`[convertPropertyPathToTextureType] Input: '${e}'`), e.includes(".")) {
      console.log("[convertPropertyPathToTextureType] 📍 Detected DOT notation");
      const s = e.split("."), o = s[0], h = s[1];
      console.log(`[convertPropertyPathToTextureType]   Base: '${o}', Texture: '${h}'`);
      let c = h;
      c.endsWith("Texture") && (c = c.substring(0, c.length - 7));
      const _ = o;
      return console.log(`[convertPropertyPathToTextureType] ✅ Dot notation result: '${_}'`), Logger.info(`[convertPropertyPathToTextureType] Converted dot notation '${e}' → '${_}'`), _;
    }
    if (e.includes("_")) {
      console.log("[convertPropertyPathToTextureType] 🔗 Detected UNDERSCORE notation");
      let s = e;
      return s.endsWith("Texture") && (s = s.substring(0, s.length - 7)), console.log(`[convertPropertyPathToTextureType] ✅ Underscore notation result: '${s}'`), Logger.info(`[convertPropertyPathToTextureType] Converted underscore notation '${e}' → '${s}'`), s;
    }
    console.log("[convertPropertyPathToTextureType] 🗺️ Using DIRECT mapping");
    const n = {
      albedoTexture: "albedo",
      bumpTexture: "bump",
      metallicTexture: "metallic",
      reflectivityTexture: "reflectivity",
      emissiveTexture: "emissive",
      opacityTexture: "opacity",
      ambientTexture: "ambient",
      microsurfaceTexture: "microSurface",
      reflectionTexture: "reflection",
      matCapReflectionTexture: "matCapReflection",
      aoTexture: "ao"
    }[e] || null;
    return n ? (console.log(`[convertPropertyPathToTextureType] ✅ Direct mapping result: '${n}'`), Logger.info(`[convertPropertyPathToTextureType] Converted via direct mapping '${e}' → '${n}'`)) : (console.error(`[convertPropertyPathToTextureType] ❌ No mapping found for '${e}'`), Logger.warn(`[convertPropertyPathToTextureType] No mapping found for '${e}'`)), n;
  }
  /**
   * Fallback alla logica precedente per texture non mappabili
   */
  applyTexturePropertyFallback(e, t, n) {
    Logger.info(`[ApplyTexturePropertyFallback] Using direct assignment for '${t}'`);
    const s = e;
    t === "albedoTexture" ? (s.albedoTexture = n, this.markMaterialDirty(s), Logger.info(`[ApplyTexturePropertyFallback] ✓ Set albedoTexture for material '${e.id}'`)) : t === "bumpTexture" ? (s.bumpTexture = n, this.markMaterialDirty(s), Logger.info(`[ApplyTexturePropertyFallback] ✓ Set bumpTexture for material '${e.id}'`)) : Logger.warn(
      `[ApplyTexturePropertyFallback] ❌ Unknown texture property: ${t} for material '${e.id}'`
    );
  }
  removeTextureProperty(e, t) {
    Logger.info(`[RemoveTextureProperty] Material: '${e.id}' | Path: '${t}'`);
    const n = e;
    t === "clearCoat_textureRoughnessTexture" ? n.clearCoat && (n.clearCoat.texture = null, Logger.info(`[RemoveTextureProperty] ✓ Removed clearCoat.texture for material '${e.id}'`)) : t === "clearCoat_bumpTexture" ? n.clearCoat && (n.clearCoat.bumpTexture = null, Logger.info(`[RemoveTextureProperty] ✓ Removed clearCoat.bumpTexture for material '${e.id}'`)) : t === "clearCoat_tintTexture" ? n.clearCoat && (n.clearCoat.tintTexture = null, Logger.info(`[RemoveTextureProperty] ✓ Removed clearCoat.tintTexture for material '${e.id}'`)) : t === "subSurface_thicknessTexture" ? n.subSurface && (n.subSurface.thicknessTexture = null, Logger.info(
      `[RemoveTextureProperty] ✓ Removed subSurface.thicknessTexture for material '${e.id}'`
    )) : t === "subSurface_tint_tintColorTexture" ? n.subSurface && (n.subSurface.tintColorTexture = null, Logger.info(
      `[RemoveTextureProperty] ✓ Removed subSurface.tintColorTexture for material '${e.id}'`
    )) : t === "subSurface_refractionTexture" ? n.subSurface && (n.subSurface.refractionTexture = null, Logger.info(
      `[RemoveTextureProperty] ✓ Removed subSurface.refractionTexture for material '${e.id}'`
    )) : t === "albedoTexture" ? (n.albedoTexture = null, Logger.info(`[RemoveTextureProperty] ✓ Removed albedoTexture for material '${e.id}'`)) : t === "bumpTexture" ? (n.bumpTexture = null, Logger.info(`[RemoveTextureProperty] ✓ Removed bumpTexture for material '${e.id}'`)) : t === "metallicTexture" ? (n.metallicTexture = null, Logger.info(`[RemoveTextureProperty] ✓ Removed metallicTexture for material '${e.id}'`)) : t === "reflectivityTexture" ? (n.reflectivityTexture = null, Logger.info(`[RemoveTextureProperty] ✓ Removed reflectivityTexture for material '${e.id}'`)) : t === "emissiveTexture" ? (n.emissiveTexture = null, Logger.info(`[RemoveTextureProperty] ✓ Removed emissiveTexture for material '${e.id}'`)) : t === "opacityTexture" ? (n.opacityTexture = null, Logger.info(`[RemoveTextureProperty] ✓ Removed opacityTexture for material '${e.id}'`)) : t === "ambientTexture" ? (n.ambientTexture = null, Logger.info(`[RemoveTextureProperty] ✓ Removed ambientTexture for material '${e.id}'`)) : Logger.warn(`[RemoveTextureProperty] ❌ Unknown texture property: ${t}`);
  }
  applyColorProperty(e, t, n) {
    try {
      console.log("🎨 ApplyColorProperty START"), console.log(`   Material: '${e.id}'`), console.log(`   Path: '${t}'`), console.log(`   Hex: '${n}'`), Logger.info(
        `[ApplyColorProperty] Material: '${e.id}' | Path: '${t}' | Hex: '${n}'`
      );
      const s = BABYLON.Color3.FromHexString(n);
      console.log(`🌈 Converted to Color3: R=${s.r.toFixed(3)}, G=${s.g.toFixed(3)}, B=${s.b.toFixed(3)}`), Logger.info(
        `[ApplyColorProperty] Converted to Color3: R=${s.r.toFixed(3)}, G=${s.g.toFixed(
          3
        )}, B=${s.b.toFixed(3)}`
      );
      const o = t.split(".");
      if (console.log(`📍 Path parts: [${o.join(" → ")}]`), Logger.info(`[ApplyColorProperty] Path parts: [${o.join(" → ")}]`), o.length === 2 && o[0] === "albedo") {
        const x = o[1];
        if (console.log(`🔍 Checking for direct property: '${x}'`), e.hasOwnProperty(x)) {
          console.log(`🔄 Smart fix: Found direct property '${x}' instead of '${t}'`), Logger.info(`[ApplyColorProperty] Smart fix: Using direct property '${x}' instead of nested path`);
          const B = e[x];
          e[x] = s, console.log(`✅ Applied color directly to '${x}'!`), console.log(`   Old value: ${B}`), console.log(`   New value: ${n} (Color3)`), Logger.info(`[ApplyColorProperty] ✓ Set direct property '${x}' | Old: ${B} | New: ${n}`);
          return;
        } else
          console.log(`⚠️ Direct property '${x}' not found, trying nested path...`);
      }
      let h = e;
      for (let x = 0; x < o.length - 1; x++) {
        const B = o[x];
        if (console.log(`🔍 Checking property: '${B}' on ${h.constructor.name}`), h[B] === void 0 || h[B] === null) {
          console.error(`❌ Property '${B}' does not exist on material '${e.id}'`), Logger.warn(
            `[ApplyColorProperty] ❌ Property path '${t}' is invalid: '${B}' does not exist on material '${e.id}'`
          );
          return;
        }
        console.log(`✅ Found property: '${B}'`), Logger.info(`[ApplyColorProperty] Navigating: ${B}`), h = h[B];
      }
      const c = o[o.length - 1], _ = h[c];
      console.log(`🎯 Setting final property: '${c}'`), console.log(`   Old value: ${_}`), console.log(`   New value: ${n} (Color3)`), h[c] = s, console.log("✅ Color property applied successfully!"), Logger.info(
        `[ApplyColorProperty] ✓ Set color property '${t}' to material '${e.id}' | Old: ${_} | New: ${n}`
      );
    } catch (s) {
      Logger.error(
        `[ApplyColorProperty] ❌ Error applying color property '${t}' to material '${e.id}'`,
        s
      );
    }
  }
  applyStandardProperty(e, t, n) {
    try {
      Logger.info(
        `[ApplyStandardProperty] Material: '${e.id}' | Path: '${t}' | Value: '${n}' | Type: ${typeof n}`
      );
      const s = t.split(".");
      if (Logger.info(`[ApplyStandardProperty] Path parts: [${s.join(" → ")}]`), s.length === 2 && s[0] === "albedo") {
        const x = s[1];
        if (e.hasOwnProperty(x)) {
          Logger.info(`[ApplyStandardProperty] Smart fix: Using direct property '${x}' instead of nested path`);
          const B = e[x];
          let P = n;
          if (typeof B == "boolean")
            P = n === "true" || n === !0;
          else if (typeof B == "number") {
            if (P = parseFloat(n), isNaN(P)) {
              Logger.warn(`[ApplyStandardProperty] ❌ Cannot convert '${n}' to number for property '${t}'`);
              return;
            }
          } else
            typeof B == "string" && (P = String(n));
          e[x] = P, Logger.info(`[ApplyStandardProperty] ✓ Set direct property '${x}' | Old: ${B} | New: ${P}`);
          return;
        }
      }
      let o = e;
      for (let x = 0; x < s.length - 1; x++) {
        const B = s[x];
        if (o[B] === void 0 || o[B] === null) {
          Logger.warn(
            `[ApplyStandardProperty] ❌ Property path '${t}' is invalid: '${B}' does not exist on material '${e.id}'`
          );
          return;
        }
        Logger.info(`[ApplyStandardProperty] Navigating: ${B}`), o = o[B];
      }
      const h = s[s.length - 1], c = o[h];
      Logger.info(
        `[ApplyStandardProperty] Final property: '${h}' | Old value: '${c}' | Old type: ${typeof c}`
      );
      let _ = n;
      if (typeof c == "boolean")
        _ = n === "true" || n === !0, Logger.info(
          `[ApplyStandardProperty] Type conversion: String → Boolean | "${n}" → ${_}`
        );
      else if (typeof c == "number") {
        if (_ = parseFloat(n), isNaN(_)) {
          Logger.warn(
            `[ApplyStandardProperty] ❌ Cannot convert '${n}' to number for property '${t}'`
          );
          return;
        }
        Logger.info(
          `[ApplyStandardProperty] Type conversion: String → Number | "${n}" → ${_}`
        );
      } else if (typeof c == "string")
        _ = String(n), Logger.info(
          `[ApplyStandardProperty] Type conversion: String → String | "${n}" → "${_}"`
        );
      else if (c instanceof BABYLON.Color3)
        if (typeof n == "string" && n.startsWith("#"))
          _ = BABYLON.Color3.FromHexString(n), Logger.info(`[ApplyStandardProperty] Type conversion: Hex → Color3 | "${n}" → Color3`);
        else {
          Logger.warn(
            `[ApplyStandardProperty] ❌ Expected hex color for property '${t}', got: ${n}`
          );
          return;
        }
      else
        Logger.info("[ApplyStandardProperty] No type conversion needed, using value as-is");
      o[h] = _, Logger.info(
        `[ApplyStandardProperty] ✓ Set property '${t}' to material '${e.id}' | Old: ${c} | New: ${_}`
      );
    } catch (s) {
      Logger.error(
        `[ApplyStandardProperty] ❌ Error applying standard property '${t}' to material '${e.id}'`,
        s
      );
    }
  }
  async prefetchMeshesForUnselectedOptionsAsync(e) {
    if (this._zkScene && this._scene && this._elementSelector && this._sceneHelper && this._prefetchMeshes)
      for (let t = 0; t < e.length; t++) {
        const n = e[t];
        if (n && n instanceof MPlaza.AttributeSceneAction && n.get("actionTypeID") === MPlaza.SceneActionType.ShowHideMesh && n.get("value") == "show") {
          const s = n.get("selector");
          if (s != null && s != null) {
            const o = this._elementSelector.getElements(
              this._zkScene,
              this._scene,
              null,
              s,
              MPlaza.SceneElementType.Mesh
            );
            for (let h = 0; h < o.length; h++) {
              const c = o[h];
              if (c instanceof BABYLON.AbstractMesh && !c.isVisible) {
                this._sceneHelper.checkDelayState(c);
                const _ = c.material;
                _ && await this._sceneHelper.prefetchTexturesForMaterialAsync(_);
              }
            }
          }
        }
      }
  }
  async checkActionsAssetsAreReadyAsync(e) {
    if (this._zkScene && this._scene && this._elementSelector && this._sceneHelper) {
      for (let t = 0; t < e.length; t++) {
        const n = e[t], s = [];
        if (n && n instanceof MPlaza.AttributeSceneAction && n.get("actionTypeID") === MPlaza.SceneActionType.ShowHideMesh && n.get("value") === "show") {
          const o = n.get("selector");
          if (o != null) {
            const h = this._elementSelector.getElements(
              this._zkScene,
              this._scene,
              null,
              o,
              MPlaza.SceneElementType.Mesh
            );
            for (let c = 0; c < h.length; c++) {
              const _ = h[c];
              if (_ instanceof BABYLON.AbstractMesh && !_.isVisible) {
                const x = this._zkScene.get("rootUrl");
                if (x) {
                  const B = this._sceneHelper.getMeshDelayedMaterialIDs(_), P = this._sceneHelper.getMeshOffloadedMaterialIDs(_);
                  B.length > 0 && await this._sceneHelper.loadDelayedMaterialsAsync(
                    x,
                    B
                  ), P.length > 0 && await this._sceneHelper.loadOffloadedMaterialsByIDsAsync(
                    x,
                    P
                  );
                }
                s.push(_);
              }
            }
          }
        }
        await mi.whenAllMeshesAreReadyAsync(s);
      }
      for (let t = 0; t < e.length; t++) {
        const n = e[t];
        if (n && n instanceof MPlaza.AttributeSceneAction) {
          if (n.get("actionTypeID") === MPlaza.SceneActionType.SetMeshMaterial || n.get("actionTypeID") === MPlaza.SceneActionType.SetSubMeshMaterial) {
            let s = this.getMaterialFromActionValue(n);
            s || (s = await this.getDeepMaterialFromActionValueAsync(n));
          }
          if (n.get("actionTypeID") === MPlaza.SceneActionType.SetMaterialColor) {
            const s = n.get("selector");
            s != null && await this.getAllMaterialElementsAsync(s);
          }
        }
      }
    }
  }
  async prefetchDataForUnselectedOptionsAsync(e) {
  }
  // Nuovo metodo per risolvere dinamicamente i path delle proprietà basandosi sulla struttura reale del materiale
  resolveMaterialPropertyPath(e, t) {
    try {
      if (console.log(`🔍 Resolving property path: '${t}' on ${e.getClassName()}`), t.includes("_")) {
        const o = t.split("_"), h = o[0], c = o.slice(1).join("_");
        console.log(`🔗 Underscore notation detected: subProperty='${h}', finalProperty='${c}'`);
        const _ = e;
        if (_[h] !== void 0 && _[h] !== null) {
          const x = _[h];
          if (x[c] !== void 0)
            return console.log(`✅ Found underscore notation property: material.${h}.${c}`), {
              target: x,
              property: c,
              description: `Underscore notation: material.${h}.${c}`
            };
          console.warn(`⚠️ Property '${c}' not found in material.${h}`);
        } else
          console.warn(`⚠️ Sub-property '${h}' not found on material`);
      }
      const n = t.split("."), s = n[n.length - 1];
      if (n.length === 1 && e[s] !== void 0)
        return console.log(`✅ Found direct property: ${s}`), {
          target: e,
          property: s,
          description: `Direct property: material.${s}`
        };
      if (n.length > 1) {
        let o = e;
        for (let h = 0; h < n.length - 1; h++) {
          const c = n[h];
          if (o[c] !== void 0 && o[c] !== null)
            o = o[c];
          else {
            o = null;
            break;
          }
        }
        if (o && o[s] !== void 0)
          return console.log(`✅ Found nested property: ${t}`), {
            target: o,
            property: s,
            description: `Nested property: material.${t}`
          };
        if (e[s] !== void 0)
          return console.log(`✅ Found direct property as fallback: ${s} (from ${t})`), {
            target: e,
            property: s,
            description: `Direct property (fallback): material.${s} (requested: ${t})`
          };
      }
      return console.error(`❌ Property '${t}' not found on material`), null;
    } catch (n) {
      return console.error(`❌ Error resolving property path '${t}':`, n), null;
    }
  }
  applySmartColorProperty(e, t, n) {
    try {
      console.log("🎨 ApplySmartColorProperty START"), console.log(`   ${t.description}`), console.log(`   Hex: '${n}'`);
      const s = BABYLON.Color3.FromHexString(n);
      console.log(`🌈 Converted to Color3: R=${s.r.toFixed(3)}, G=${s.g.toFixed(3)}, B=${s.b.toFixed(3)}`);
      const o = t.target[t.property];
      console.log(`   Old value: ${o}`), t.target[t.property] = s, console.log("✅ Smart color property applied successfully!"), Logger.info(`[ApplySmartColorProperty] ✓ Set ${t.description} | Old: ${o} | New: ${n}`);
    } catch (s) {
      console.error("❌ Error in applySmartColorProperty:", s), Logger.error(`[ApplySmartColorProperty] ❌ Error: ${s}`);
    }
  }
  applySmartStandardProperty(e, t, n) {
    try {
      console.log("⚙️ ApplySmartStandardProperty START"), console.log(`   ${t.description}`), console.log(`   Value: '${n}' (${typeof n})`);
      const s = t.target[t.property];
      console.log(`   Old value: '${s}' (${typeof s})`);
      let o = n;
      if (typeof s == "boolean")
        o = n === "true" || n === !0, console.log(`🔄 Type conversion: String → Boolean | "${n}" → ${o}`);
      else if (typeof s == "number") {
        if (o = parseFloat(n), isNaN(o)) {
          console.error(`❌ Cannot convert '${n}' to number`);
          return;
        }
        console.log(`🔄 Type conversion: String → Number | "${n}" → ${o}`);
      } else if (typeof s == "string")
        o = String(n), console.log(`🔄 Type conversion: String → String | "${n}" → "${o}"`);
      else if (s instanceof BABYLON.Color3)
        if (typeof n == "string" && n.startsWith("#"))
          o = BABYLON.Color3.FromHexString(n), console.log(`🔄 Type conversion: Hex → Color3 | "${n}" → Color3`);
        else {
          console.error(`❌ Expected hex color, got: ${n}`);
          return;
        }
      t.target[t.property] = o, console.log("✅ Smart standard property applied successfully!"), Logger.info(`[ApplySmartStandardProperty] ✓ Set ${t.description} | Old: ${s} | New: ${o}`);
    } catch (s) {
      console.error("❌ Error in applySmartStandardProperty:", s), Logger.error(`[ApplySmartStandardProperty] ❌ Error: ${s}`);
    }
  }
  /**
   * Forza il refresh del materiale dopo l'assegnazione di texture
   */
  markMaterialDirty(e) {
    try {
      typeof e.markDirty == "function" ? (e.markDirty(), Logger.info(`[MarkMaterialDirty] ✓ Called material.markDirty() for '${e.id}'`)) : typeof e._markAllSubMeshesAsTexturesDirty == "function" ? (e._markAllSubMeshesAsTexturesDirty(), Logger.info(`[MarkMaterialDirty] ✓ Called _markAllSubMeshesAsTexturesDirty() for '${e.id}'`)) : (this._scene.markAllMaterialsAsDirty(BABYLON.Material.TextureDirtyFlag), Logger.info("[MarkMaterialDirty] ✓ Marked all materials as texture dirty for scene"));
    } catch (t) {
      Logger.warn(`[MarkMaterialDirty] ⚠️ Could not mark material '${e.id}' as dirty: ${t}`);
    }
  }
}
class lw {
  constructor() {
    this._zkScene = null, this._scene = null, this._sceneHelper = null, this._meshLocationCache = {}, this._cameraAnimationCompletedListeners = [], this._meshAnimationCompletedListeners = [], this._beforeSaveMeshLocationListeners = [], this._afterSaveMeshLocationListeners = [];
  }
  dispose() {
    for (; this._cameraAnimationCompletedListeners.length > 0; )
      this._cameraAnimationCompletedListeners.pop();
    for (; this._meshAnimationCompletedListeners.length > 0; )
      this._meshAnimationCompletedListeners.pop();
    for (; this._beforeSaveMeshLocationListeners.length > 0; )
      this._beforeSaveMeshLocationListeners.pop();
    for (; this._afterSaveMeshLocationListeners.length > 0; )
      this._afterSaveMeshLocationListeners.pop();
    this.disposeSceneHelper();
  }
  setScene(e) {
    this._scene = e, this.resetSceneHelper(), this.resetCache();
  }
  setModel(e) {
    this._zkScene = e, this.resetCache();
  }
  setModelAndScene(e, t) {
    this._zkScene = e, this._scene = t, this.resetSceneHelper(), this.resetCache();
  }
  resetCache() {
    this._meshLocationCache = {};
  }
  invalidateCache(e) {
    this._meshLocationCache && delete this._meshLocationCache[e];
  }
  disposeSceneHelper() {
    this._sceneHelper && (this._sceneHelper.dispose(), this._sceneHelper = null);
  }
  resetSceneHelper() {
    this.disposeSceneHelper(), this._scene && (this._sceneHelper = new mi(this._scene));
  }
  clearMeshLocations() {
    if (this._zkScene) {
      const e = this._zkScene.get("meshLocations");
      for (; e.length > 0; )
        e.remove(e.at(0));
    }
  }
  async setMeshLocationByID(e) {
    if (this._zkScene && this._scene) {
      const t = this._zkScene.getMeshLocation(e);
      t && await this.setMeshLocation(t);
    }
  }
  async setMeshLocation(e) {
    if (this._zkScene && this._scene && this._sceneHelper) {
      let x, B = !0;
      if (e) {
        let P = e.get("locationID");
        if (B = e.get("adjustCamera"), this._meshLocationCache.hasOwnProperty(P))
          x = this._meshLocationCache[P];
        else {
          let U = e.get("data"), M = null;
          if (typeof U == "string") {
            let Z = window.atob(U), F = Z.length, Q = new Uint8Array(F);
            for (let te = 0; te < F; te++)
              Q[te] = Z.charCodeAt(te);
            let D = Q.buffer;
            M = new Uint8Array(D);
          } else
            Object.prototype.toString.call(U) === "[object Array]" && (M = Uint8Array.from(U));
          if (M != null) {
            let Z = LZString.decompressFromUint8Array(M);
            if (x = JSON.parse(Z), x) {
              for (var t in x) {
                var n = x[t];
                n.p && (n.p = new BABYLON.Vector3(n.p.x, n.p.y, n.p.z)), n.rE && (n.rE = new BABYLON.Vector3(n.rE.x, n.rE.y, n.rE.z)), n.rQ && (n.rQ = new BABYLON.Quaternion(n.rQ.x, n.rQ.y, n.rQ.z, n.rQ.w)), n.s && (n.s = new BABYLON.Vector3(n.s.x, n.s.y, n.s.z));
              }
              this._meshLocationCache[P] = x;
            }
          }
        }
      }
      if (x) {
        const P = [];
        if (B && x.hasOwnProperty("wemin") && x.hasOwnProperty("wemax")) {
          var s = {
            min: new BABYLON.Vector3(x.wemin.x, x.wemin.y, x.wemin.z),
            max: new BABYLON.Vector3(x.wemax.x, x.wemax.y, x.wemax.z)
          };
          let U = this._sceneHelper.camera;
          if (U && U instanceof BABYLON.ArcRotateCamera) {
            U.upperRadiusLimit = null;
            var o = this._sceneHelper.calculateCameraRadius(s), h = this._sceneHelper.getWorldCenter(s);
            h && (this._sceneHelper.setCameraRadiusParameters(o), P.push(new Promise((M) => {
              U && U instanceof BABYLON.ArcRotateCamera && this._sceneHelper.animateCameraToFinalParamters(U.alpha, U.beta, o, h, 1, () => {
                this._sceneHelper && (this._sceneHelper.setupCameraLimits(s), this.fireCameraAnimationCompletedEvent(), M());
              });
            })));
          }
        }
        for (var c = 0; c < this._scene.meshes.length; c++) {
          var _ = this._scene.meshes[c], t = _.id;
          if (x.hasOwnProperty(t)) {
            var n = x[t];
            P.push(new Promise((Z) => {
              this._sceneHelper.animateMeshToFinalParameters(_, n.p, n.rE, n.rQ, n.s, 1, () => {
                this.fireMeshAnimationCompletedEvent(), Z();
              });
            }));
          }
        }
        await Promise.all(P);
      }
    }
  }
  saveMeshLocation(e) {
    if (this._zkScene && this._scene) {
      var t = new Zakeke.SceneMeshLocation();
      t.set("name", e), this.updateMeshLocation(t), this._zkScene.get("meshLocations").push(t);
    }
  }
  saveExplodedMeshLocation() {
    if (this._zkScene && this._scene) {
      var e = this._zkScene.getOrCreateExplodedMeshLocation();
      this.updateMeshLocation(e);
    }
  }
  saveCollapsedMeshLocation() {
    if (this._zkScene && this._scene) {
      var e = this._zkScene.getOrCreateCollapsedMeshLocation();
      this.updateMeshLocation(e);
    }
  }
  updateMeshLocation(e) {
    if (this.fireBeforeSaveMeshLocationEvent(), this._scene && this._sceneHelper) {
      var t = this.getMeshPRSs(), n = this._sceneHelper.getWorldExtends();
      if (n) {
        let c = {
          x: n.min.x,
          y: n.min.y,
          z: n.min.z
        }, _ = {
          x: n.max.x,
          y: n.max.y,
          z: n.max.z
        };
        t.wemin = c, t.wemax = _;
      }
      var s = JSON.stringify(t);
      let o = LZString.compressToUint8Array(s), h = [].slice.call(o);
      e.set("data", h), this.invalidateCache(e.get("locationID"));
    }
    this.fireAfterSaveMeshLocationEvent();
  }
  getMeshPRSs() {
    let e = {
      wemin: void 0,
      wemax: void 0
    };
    if (this._scene && this._sceneHelper)
      for (let t = 0; t < this._scene.meshes.length; t++) {
        const n = this._scene.meshes[t];
        if (this._sceneHelper.isRealMesh(n)) {
          let s = n.id, o = {
            p: void 0,
            rQ: void 0,
            rE: void 0,
            s: void 0
          }, h = {
            x: n.position.x,
            y: n.position.y,
            z: n.position.z
          };
          if (o.p = h, n.rotationQuaternion == null) {
            o.rQ = null;
            let _ = {
              x: n.rotation.x,
              y: n.rotation.y,
              z: n.rotation.z
            };
            o.rE = _;
          } else {
            let _ = {
              w: n.rotationQuaternion.w,
              x: n.rotationQuaternion.x,
              y: n.rotationQuaternion.y,
              z: n.rotationQuaternion.z
            };
            o.rQ = _, o.rE = null;
          }
          let c = {
            x: n.scaling.x,
            y: n.scaling.y,
            z: n.scaling.z
          };
          o.s = c, e[s] = o;
        }
      }
    return e;
  }
  async explodeMeshes() {
    if (this._zkScene) {
      let e = this._zkScene.getFirstExplodedMeshLocation();
      e && await this.setMeshLocation(e);
    }
  }
  async collapseMeshes() {
    if (this._zkScene) {
      let e = this._zkScene.getFirstCollapsedMeshLocation();
      e && await this.setMeshLocation(e);
    }
  }
  // Events
  fireCameraAnimationCompletedEvent() {
    for (let e = 0; e < this._cameraAnimationCompletedListeners.length; ++e)
      this._cameraAnimationCompletedListeners[e]();
  }
  addCameraAnimationCompletedListener(e) {
    this._cameraAnimationCompletedListeners.push(e);
  }
  fireMeshAnimationCompletedEvent() {
    for (let e = 0; e < this._meshAnimationCompletedListeners.length; ++e)
      this._meshAnimationCompletedListeners[e]();
  }
  addMeshAnimationCompletedListener(e) {
    this._meshAnimationCompletedListeners.push(e);
  }
  fireBeforeSaveMeshLocationEvent() {
    for (let e = 0; e < this._beforeSaveMeshLocationListeners.length; ++e)
      this._beforeSaveMeshLocationListeners[e]();
  }
  addBeforeSaveMeshLocationListener(e) {
    this._beforeSaveMeshLocationListeners.push(e);
  }
  fireAfterSaveMeshLocationEvent() {
    for (let e = 0; e < this._afterSaveMeshLocationListeners.length; ++e)
      this._afterSaveMeshLocationListeners[e]();
  }
  addAfterSaveMeshLocationListener(e) {
    this._afterSaveMeshLocationListeners.push(e);
  }
}
class hw {
  constructor(e, t) {
    this._glowLayer = null, this._zkScene = e, this._scene = t, this._sceneHelper = new mi(this._scene), this._glowLayer = this._scene.getGlowLayerByName("glow");
  }
  get enabled() {
    const e = this.getGlowConfig();
    return e && e.get("enabled") != null && typeof e.get("enabled") == "boolean" && e.get("enabled"), !1;
  }
  set enabled(e) {
    var t = this.getOrCreateGlowConfig();
    t && t.set("enabled", e), this.update();
  }
  get intensity() {
    const e = this.getGlowConfig();
    return e && e.get("intensity") != null && typeof e.get("intensity") == "number" && e.get("intensity"), 1;
  }
  set intensity(e) {
    var t = this.getOrCreateGlowConfig();
    t && t.set("intensity", e), this.update();
  }
  get blurSize() {
    const e = this.getGlowConfig();
    return e && e.get("blurSize") != null && typeof e.get("blurSize") == "number" && e.get("blurSize"), 1;
  }
  set blurSize(e) {
    var t = this.getOrCreateGlowConfig();
    t && t.set("blurSize", e), this.update();
  }
  dispose() {
    this.destroyGlowLayer();
  }
  destroyGlowLayer() {
    this._glowLayer && (this._glowLayer.dispose(), this._glowLayer = null);
  }
  createOrUpdateGlowLayer(e, t) {
    this._glowLayer || (this._glowLayer = new BABYLON.GlowLayer("glow", this._scene)), this._glowLayer && (this._glowLayer.intensity = e, this._glowLayer.blurKernelSize = t);
  }
  update() {
    if (this._scene) {
      var e = this.getGlowConfig();
      if (e) {
        const t = this.enabled, n = this.intensity, s = this.blurSize;
        t ? this.createOrUpdateGlowLayer(n, s) : this.destroyGlowLayer();
      } else
        this.destroyGlowLayer();
    }
  }
  turnOffGlow() {
    this.destroyGlowLayer();
  }
  turnOnGlow() {
    this.update();
  }
  sanityCheck() {
    return this._scene && this._scene instanceof BABYLON.Scene && this._zkScene && this._zkScene instanceof Zakeke.Scene && this._zkScene.get("config") != null && this._zkScene.get("config") != null && this._zkScene.get("config") instanceof Zakeke.SceneConfig;
  }
  isGlowEnabledForMesh(e) {
    return e ? e.metadata && e.metadata.enableGlow : !1;
  }
  // La possibilità di abilitare solo alcune mesh al glow viene disabilitata
  // perché c'è il problema che l'effetto glow è visibile attraverso le mesh
  // per cui il glow è diabilitato
  enableGlowForMesh(e) {
  }
  disableGlowForMesh(e) {
  }
  getGlowConfig() {
    if (this.sanityCheck()) {
      let e = this._zkScene.getGlowConfig();
      if (e)
        return e;
    }
    return null;
  }
  getOrCreateGlowConfig() {
    return this.sanityCheck() ? this._zkScene.getOrCreateGlowConfig() : null;
  }
}
class xu {
  /**
   * Constructor
   * @param workers Array of workers to use for actions
   */
  constructor(e) {
    this._pendingActions = new Array(), this._workerInfos = e.map((t) => ({
      worker: t,
      active: !1
    }));
  }
  /**
   * Terminates all workers and clears any pending actions.
   */
  dispose() {
    for (const e of this._workerInfos)
      e.worker.terminate();
    delete this._workerInfos, delete this._pendingActions;
  }
  /**
   * Pushes an action to the worker pool. If all the workers are active, the action will be
   * pended until a worker has completed its action.
   * @param action The action to perform. Call onComplete when the action is complete.
   */
  push(e) {
    for (const t of this._workerInfos)
      if (!t.active) {
        this._execute(t, e);
        return;
      }
    this._pendingActions.push(e);
  }
  _execute(e, t) {
    e.active = !0, t(e.worker, () => {
      e.active = !1;
      const n = this._pendingActions.shift();
      n && this._execute(e, n);
    });
  }
}
function qd(b) {
  return typeof importScripts == "function" ? (importScripts(b), Promise.resolve()) : new Promise((e, t) => {
    BABYLON.Tools.LoadScript(b, () => {
      e();
    }, (n) => {
      t(new Error(n));
    });
  });
}
function $d(b) {
  if (b.length == 0)
    return Promise.resolve();
  let e = [];
  for (let t = 0; t < b.length; t++)
    e.push(qd(b[t]));
  return new Promise((t) => {
    Promise.all(e).then(() => t());
  });
}
function Xd(b, e, t) {
  return new MakeIncremental().getSceneIncrementalFiles(b, e, t);
}
function uw() {
  let b;
  onmessage = (e) => {
    const t = e.data;
    switch (t.id) {
      case "init": {
        const n = t.urls;
        b = $d(n), postMessage("done");
        break;
      }
      case "makeIncremental": {
        if (!b)
          throw new Error("Worker not initialized");
        b.then(() => {
          const n = t.sceneJson, s = t.version, o = t.options, h = Xd(n, s, o);
          postMessage({ id: "result", files: h }), postMessage("done");
        });
        break;
      }
    }
  };
}
function cw(b) {
  return typeof document != "object" || typeof b != "string" ? b : BABYLON.Tools.GetAbsoluteUrl(b);
}
const yl = class Sa {
  static GetDefaultNumWorkers() {
    return typeof navigator != "object" || !navigator.hardwareConcurrency ? 1 : Math.min(Math.floor(navigator.hardwareConcurrency * 0.5), 2);
  }
  /**
   * Default instance for the incremental file maker
   */
  static get Default() {
    return Sa._Default || (Sa._Default = new Sa([])), Sa._Default;
  }
  /**
   * Constructor
   * @param numWorkers The number of workers for async operations. Specify `0` to disable web workers and run synchronously in the current context.
  */
  constructor(e, t = Sa.DefaultNumWorkers) {
    const n = e.map((s) => cw(s));
    if (t && typeof Worker == "function") {
      const s = `${qd}${$d}${Xd}(${uw})()`, o = URL.createObjectURL(new Blob([s], { type: "application/javascript" })), h = new Array(t);
      for (let c = 0; c < h.length; c++)
        h[c] = new Promise((_, x) => {
          const B = new Worker(o), P = (M) => {
            B.removeEventListener("error", P), B.removeEventListener("message", U), x(M);
          }, U = (M) => {
            M.data === "done" && (B.removeEventListener("error", P), B.removeEventListener("message", U), _(B));
          };
          B.addEventListener("error", P), B.addEventListener("message", U), B.postMessage({
            id: "init",
            urls: n
          });
        });
      this._workerPoolPromise = Promise.all(h).then((c) => new xu(c));
    }
  }
  dispose() {
  }
  /**
   * Returns a promise that resolves when ready. Call this manually to ensure draco compression is ready before use.
   * @returns a promise that resolves when ready
   */
  whenReadyAsync() {
    return this._workerPoolPromise ? this._workerPoolPromise.then(() => {
    }) : Promise.resolve();
  }
  getIncrementalFilesAsync(e, t, n) {
    if (this._workerPoolPromise)
      return this._workerPoolPromise.then((s) => new Promise((o, h) => {
        s.push((c, _) => {
          let x = [];
          const B = (U) => {
            c.removeEventListener("error", B), c.removeEventListener("message", P), h(U), _();
          }, P = (U) => {
            U.data === "done" ? (c.removeEventListener("error", B), c.removeEventListener("message", P), o(x), _()) : U.data.id === "result" && (x = U.data.files);
          };
          c.addEventListener("error", B), c.addEventListener("message", P), c.postMessage({ id: "makeIncremental", sceneJson: e, version: t, options: n });
        });
      }));
    throw new Error("Incremental file worker is not available");
  }
};
yl.DefaultNumWorkers = yl.GetDefaultNumWorkers();
yl._Default = null;
let fw = yl;
var Kd = { exports: {} };
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */
(function(b) {
  (function(e, t) {
    b.exports = e.document ? t(e, !0) : function(n) {
      if (!n.document)
        throw new Error("jQuery requires a window with a document");
      return t(n);
    };
  })(typeof window < "u" ? window : ss, function(e, t) {
    var n = [], s = Object.getPrototypeOf, o = n.slice, h = n.flat ? function(w) {
      return n.flat.call(w);
    } : function(w) {
      return n.concat.apply([], w);
    }, c = n.push, _ = n.indexOf, x = {}, B = x.toString, P = x.hasOwnProperty, U = P.toString, M = U.call(Object), Z = {}, F = function(O) {
      return typeof O == "function" && typeof O.nodeType != "number" && typeof O.item != "function";
    }, Q = function(O) {
      return O != null && O === O.window;
    }, D = e.document, te = {
      type: !0,
      src: !0,
      nonce: !0,
      noModule: !0
    };
    function ee(w, O, J) {
      J = J || D;
      var re, ge, me = J.createElement("script");
      if (me.text = w, O)
        for (re in te)
          ge = O[re] || O.getAttribute && O.getAttribute(re), ge && me.setAttribute(re, ge);
      J.head.appendChild(me).parentNode.removeChild(me);
    }
    function le(w) {
      return w == null ? w + "" : typeof w == "object" || typeof w == "function" ? x[B.call(w)] || "object" : typeof w;
    }
    var fe = "3.7.1", X = /HTML$/i, W = function(w, O) {
      return new W.fn.init(w, O);
    };
    W.fn = W.prototype = {
      // The current version of jQuery being used
      jquery: fe,
      constructor: W,
      // The default length of a jQuery object is 0
      length: 0,
      toArray: function() {
        return o.call(this);
      },
      // Get the Nth element in the matched element set OR
      // Get the whole matched element set as a clean array
      get: function(w) {
        return w == null ? o.call(this) : w < 0 ? this[w + this.length] : this[w];
      },
      // Take an array of elements and push it onto the stack
      // (returning the new matched element set)
      pushStack: function(w) {
        var O = W.merge(this.constructor(), w);
        return O.prevObject = this, O;
      },
      // Execute a callback for every element in the matched set.
      each: function(w) {
        return W.each(this, w);
      },
      map: function(w) {
        return this.pushStack(W.map(this, function(O, J) {
          return w.call(O, J, O);
        }));
      },
      slice: function() {
        return this.pushStack(o.apply(this, arguments));
      },
      first: function() {
        return this.eq(0);
      },
      last: function() {
        return this.eq(-1);
      },
      even: function() {
        return this.pushStack(W.grep(this, function(w, O) {
          return (O + 1) % 2;
        }));
      },
      odd: function() {
        return this.pushStack(W.grep(this, function(w, O) {
          return O % 2;
        }));
      },
      eq: function(w) {
        var O = this.length, J = +w + (w < 0 ? O : 0);
        return this.pushStack(J >= 0 && J < O ? [this[J]] : []);
      },
      end: function() {
        return this.prevObject || this.constructor();
      },
      // For internal use only.
      // Behaves like an Array's method, not like a jQuery method.
      push: c,
      sort: n.sort,
      splice: n.splice
    }, W.extend = W.fn.extend = function() {
      var w, O, J, re, ge, me, xe = arguments[0] || {}, Ue = 1, ze = arguments.length, Ze = !1;
      for (typeof xe == "boolean" && (Ze = xe, xe = arguments[Ue] || {}, Ue++), typeof xe != "object" && !F(xe) && (xe = {}), Ue === ze && (xe = this, Ue--); Ue < ze; Ue++)
        if ((w = arguments[Ue]) != null)
          for (O in w)
            re = w[O], !(O === "__proto__" || xe === re) && (Ze && re && (W.isPlainObject(re) || (ge = Array.isArray(re))) ? (J = xe[O], ge && !Array.isArray(J) ? me = [] : !ge && !W.isPlainObject(J) ? me = {} : me = J, ge = !1, xe[O] = W.extend(Ze, me, re)) : re !== void 0 && (xe[O] = re));
      return xe;
    }, W.extend({
      // Unique for each copy of jQuery on the page
      expando: "jQuery" + (fe + Math.random()).replace(/\D/g, ""),
      // Assume jQuery is ready without the ready module
      isReady: !0,
      error: function(w) {
        throw new Error(w);
      },
      noop: function() {
      },
      isPlainObject: function(w) {
        var O, J;
        return !w || B.call(w) !== "[object Object]" ? !1 : (O = s(w), O ? (J = P.call(O, "constructor") && O.constructor, typeof J == "function" && U.call(J) === M) : !0);
      },
      isEmptyObject: function(w) {
        var O;
        for (O in w)
          return !1;
        return !0;
      },
      // Evaluates a script in a provided context; falls back to the global one
      // if not specified.
      globalEval: function(w, O, J) {
        ee(w, { nonce: O && O.nonce }, J);
      },
      each: function(w, O) {
        var J, re = 0;
        if (je(w))
          for (J = w.length; re < J && O.call(w[re], re, w[re]) !== !1; re++)
            ;
        else
          for (re in w)
            if (O.call(w[re], re, w[re]) === !1)
              break;
        return w;
      },
      // Retrieve the text value of an array of DOM nodes
      text: function(w) {
        var O, J = "", re = 0, ge = w.nodeType;
        if (!ge)
          for (; O = w[re++]; )
            J += W.text(O);
        return ge === 1 || ge === 11 ? w.textContent : ge === 9 ? w.documentElement.textContent : ge === 3 || ge === 4 ? w.nodeValue : J;
      },
      // results is for internal usage only
      makeArray: function(w, O) {
        var J = O || [];
        return w != null && (je(Object(w)) ? W.merge(
          J,
          typeof w == "string" ? [w] : w
        ) : c.call(J, w)), J;
      },
      inArray: function(w, O, J) {
        return O == null ? -1 : _.call(O, w, J);
      },
      isXMLDoc: function(w) {
        var O = w && w.namespaceURI, J = w && (w.ownerDocument || w).documentElement;
        return !X.test(O || J && J.nodeName || "HTML");
      },
      // Support: Android <=4.0 only, PhantomJS 1 only
      // push.apply(_, arraylike) throws on ancient WebKit
      merge: function(w, O) {
        for (var J = +O.length, re = 0, ge = w.length; re < J; re++)
          w[ge++] = O[re];
        return w.length = ge, w;
      },
      grep: function(w, O, J) {
        for (var re, ge = [], me = 0, xe = w.length, Ue = !J; me < xe; me++)
          re = !O(w[me], me), re !== Ue && ge.push(w[me]);
        return ge;
      },
      // arg is for internal usage only
      map: function(w, O, J) {
        var re, ge, me = 0, xe = [];
        if (je(w))
          for (re = w.length; me < re; me++)
            ge = O(w[me], me, J), ge != null && xe.push(ge);
        else
          for (me in w)
            ge = O(w[me], me, J), ge != null && xe.push(ge);
        return h(xe);
      },
      // A global GUID counter for objects
      guid: 1,
      // jQuery.support is not used in Core but other projects attach their
      // properties to it so it needs to exist.
      support: Z
    }), typeof Symbol == "function" && (W.fn[Symbol.iterator] = n[Symbol.iterator]), W.each(
      "Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),
      function(w, O) {
        x["[object " + O + "]"] = O.toLowerCase();
      }
    );
    function je(w) {
      var O = !!w && "length" in w && w.length, J = le(w);
      return F(w) || Q(w) ? !1 : J === "array" || O === 0 || typeof O == "number" && O > 0 && O - 1 in w;
    }
    function ke(w, O) {
      return w.nodeName && w.nodeName.toLowerCase() === O.toLowerCase();
    }
    var Ye = n.pop, pt = n.sort, Le = n.splice, $e = "[\\x20\\t\\r\\n\\f]", ce = new RegExp(
      "^" + $e + "+|((?:^|[^\\\\])(?:\\\\.)*)" + $e + "+$",
      "g"
    );
    W.contains = function(w, O) {
      var J = O && O.parentNode;
      return w === J || !!(J && J.nodeType === 1 && // Support: IE 9 - 11+
      // IE doesn't have `contains` on SVG.
      (w.contains ? w.contains(J) : w.compareDocumentPosition && w.compareDocumentPosition(J) & 16));
    };
    var ht = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function De(w, O) {
      return O ? w === "\0" ? "�" : w.slice(0, -1) + "\\" + w.charCodeAt(w.length - 1).toString(16) + " " : "\\" + w;
    }
    W.escapeSelector = function(w) {
      return (w + "").replace(ht, De);
    };
    var ft = D, Yt = c;
    (function() {
      var w, O, J, re, ge, me = Yt, xe, Ue, ze, Ze, At, Bt = W.expando, lt = 0, Ft = 0, fi = Bn(), si = Bn(), di = Bn(), xn = Bn(), wn = function(Pe, Ke) {
        return Pe === Ke && (ge = !0), 0;
      }, an = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", xi = "(?:\\\\[\\da-fA-F]{1,6}" + $e + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", ki = "\\[" + $e + "*(" + xi + ")(?:" + $e + // Operator (capture 2)
      "*([*^$|!~]?=)" + $e + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
      `*(?:'((?:\\\\.|[^\\\\'])*)'|"((?:\\\\.|[^\\\\"])*)"|(` + xi + "))|)" + $e + "*\\]", Dn = ":(" + xi + `)(?:\\((('((?:\\\\.|[^\\\\'])*)'|"((?:\\\\.|[^\\\\"])*)")|((?:\\\\.|[^\\\\()[\\]]|` + ki + ")*)|.*)\\)|)", Ni = new RegExp($e + "+", "g"), Qi = new RegExp("^" + $e + "*," + $e + "*"), ar = new RegExp("^" + $e + "*([>+~]|" + $e + ")" + $e + "*"), pr = new RegExp($e + "|>"), pn = new RegExp(Dn), Ar = new RegExp("^" + xi + "$"), Yn = {
        ID: new RegExp("^#(" + xi + ")"),
        CLASS: new RegExp("^\\.(" + xi + ")"),
        TAG: new RegExp("^(" + xi + "|[*])"),
        ATTR: new RegExp("^" + ki),
        PSEUDO: new RegExp("^" + Dn),
        CHILD: new RegExp(
          "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + $e + "*(even|odd|(([+-]|)(\\d*)n|)" + $e + "*(?:([+-]|)" + $e + "*(\\d+)|))" + $e + "*\\)|)",
          "i"
        ),
        bool: new RegExp("^(?:" + an + ")$", "i"),
        // For use in libraries implementing .is()
        // We use this for POS matching in `select`
        needsContext: new RegExp("^" + $e + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + $e + "*((?:-\\d)?\\d*)" + $e + "*\\)|)(?=[^-]|$)", "i")
      }, Qt = /^(?:input|select|textarea|button)$/i, qn = /^h\d$/i, Gn = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, Dr = /[+~]/, Si = new RegExp("\\\\[\\da-fA-F]{1,6}" + $e + "?|\\\\([^\\r\\n\\f])", "g"), hn = function(Pe, Ke) {
        var ct = "0x" + Pe.slice(1) - 65536;
        return Ke || (ct < 0 ? String.fromCharCode(ct + 65536) : String.fromCharCode(ct >> 10 | 55296, ct & 1023 | 56320));
      }, Jt = function() {
        On();
      }, Ln = $n(
        function(Pe) {
          return Pe.disabled === !0 && ke(Pe, "fieldset");
        },
        { dir: "parentNode", next: "legend" }
      );
      function gi() {
        try {
          return xe.activeElement;
        } catch {
        }
      }
      try {
        me.apply(
          n = o.call(ft.childNodes),
          ft.childNodes
        ), n[ft.childNodes.length].nodeType;
      } catch {
        me = {
          apply: function(Ke, ct) {
            Yt.apply(Ke, o.call(ct));
          },
          call: function(Ke) {
            Yt.apply(Ke, o.call(arguments, 1));
          }
        };
      }
      function Bi(Pe, Ke, ct, xt) {
        var Tt, Oe, qe, K, oe, Me, Be, ot = Ke && Ke.ownerDocument, ut = Ke ? Ke.nodeType : 9;
        if (ct = ct || [], typeof Pe != "string" || !Pe || ut !== 1 && ut !== 9 && ut !== 11)
          return ct;
        if (!xt && (On(Ke), Ke = Ke || xe, ze)) {
          if (ut !== 11 && (oe = Gn.exec(Pe)))
            if (Tt = oe[1]) {
              if (ut === 9)
                if (qe = Ke.getElementById(Tt)) {
                  if (qe.id === Tt)
                    return me.call(ct, qe), ct;
                } else
                  return ct;
              else if (ot && (qe = ot.getElementById(Tt)) && Bi.contains(Ke, qe) && qe.id === Tt)
                return me.call(ct, qe), ct;
            } else {
              if (oe[2])
                return me.apply(ct, Ke.getElementsByTagName(Pe)), ct;
              if ((Tt = oe[3]) && Ke.getElementsByClassName)
                return me.apply(ct, Ke.getElementsByClassName(Tt)), ct;
            }
          if (!xn[Pe + " "] && (!Ze || !Ze.test(Pe))) {
            if (Be = Pe, ot = Ke, ut === 1 && (pr.test(Pe) || ar.test(Pe))) {
              for (ot = Dr.test(Pe) && Ki(Ke.parentNode) || Ke, (ot != Ke || !Z.scope) && ((K = Ke.getAttribute("id")) ? K = W.escapeSelector(K) : Ke.setAttribute("id", K = Bt)), Me = tr(Pe), Oe = Me.length; Oe--; )
                Me[Oe] = (K ? "#" + K : ":scope") + " " + Ur(Me[Oe]);
              Be = Me.join(",");
            }
            try {
              return me.apply(
                ct,
                ot.querySelectorAll(Be)
              ), ct;
            } catch {
              xn(Pe, !0);
            } finally {
              K === Bt && Ke.removeAttribute("id");
            }
          }
        }
        return lr(Pe.replace(ce, "$1"), Ke, ct, xt);
      }
      function Bn() {
        var Pe = [];
        function Ke(ct, xt) {
          return Pe.push(ct + " ") > O.cacheLength && delete Ke[Pe.shift()], Ke[ct + " "] = xt;
        }
        return Ke;
      }
      function ui(Pe) {
        return Pe[Bt] = !0, Pe;
      }
      function un(Pe) {
        var Ke = xe.createElement("fieldset");
        try {
          return !!Pe(Ke);
        } catch {
          return !1;
        } finally {
          Ke.parentNode && Ke.parentNode.removeChild(Ke), Ke = null;
        }
      }
      function zr(Pe) {
        return function(Ke) {
          return ke(Ke, "input") && Ke.type === Pe;
        };
      }
      function Js(Pe) {
        return function(Ke) {
          return (ke(Ke, "input") || ke(Ke, "button")) && Ke.type === Pe;
        };
      }
      function $r(Pe) {
        return function(Ke) {
          return "form" in Ke ? Ke.parentNode && Ke.disabled === !1 ? "label" in Ke ? "label" in Ke.parentNode ? Ke.parentNode.disabled === Pe : Ke.disabled === Pe : Ke.isDisabled === Pe || // Where there is no isDisabled, check manually
          Ke.isDisabled !== !Pe && Ln(Ke) === Pe : Ke.disabled === Pe : "label" in Ke ? Ke.disabled === Pe : !1;
        };
      }
      function Fr(Pe) {
        return ui(function(Ke) {
          return Ke = +Ke, ui(function(ct, xt) {
            for (var Tt, Oe = Pe([], ct.length, Ke), qe = Oe.length; qe--; )
              ct[Tt = Oe[qe]] && (ct[Tt] = !(xt[Tt] = ct[Tt]));
          });
        });
      }
      function Ki(Pe) {
        return Pe && typeof Pe.getElementsByTagName < "u" && Pe;
      }
      function On(Pe) {
        var Ke, ct = Pe ? Pe.ownerDocument || Pe : ft;
        return ct == xe || ct.nodeType !== 9 || !ct.documentElement || (xe = ct, Ue = xe.documentElement, ze = !W.isXMLDoc(xe), At = Ue.matches || Ue.webkitMatchesSelector || Ue.msMatchesSelector, Ue.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
        // two documents; shallow comparisons work.
        // eslint-disable-next-line eqeqeq
        ft != xe && (Ke = xe.defaultView) && Ke.top !== Ke && Ke.addEventListener("unload", Jt), Z.getById = un(function(xt) {
          return Ue.appendChild(xt).id = W.expando, !xe.getElementsByName || !xe.getElementsByName(W.expando).length;
        }), Z.disconnectedMatch = un(function(xt) {
          return At.call(xt, "*");
        }), Z.scope = un(function() {
          return xe.querySelectorAll(":scope");
        }), Z.cssHas = un(function() {
          try {
            return xe.querySelector(":has(*,:jqfake)"), !1;
          } catch {
            return !0;
          }
        }), Z.getById ? (O.filter.ID = function(xt) {
          var Tt = xt.replace(Si, hn);
          return function(Oe) {
            return Oe.getAttribute("id") === Tt;
          };
        }, O.find.ID = function(xt, Tt) {
          if (typeof Tt.getElementById < "u" && ze) {
            var Oe = Tt.getElementById(xt);
            return Oe ? [Oe] : [];
          }
        }) : (O.filter.ID = function(xt) {
          var Tt = xt.replace(Si, hn);
          return function(Oe) {
            var qe = typeof Oe.getAttributeNode < "u" && Oe.getAttributeNode("id");
            return qe && qe.value === Tt;
          };
        }, O.find.ID = function(xt, Tt) {
          if (typeof Tt.getElementById < "u" && ze) {
            var Oe, qe, K, oe = Tt.getElementById(xt);
            if (oe) {
              if (Oe = oe.getAttributeNode("id"), Oe && Oe.value === xt)
                return [oe];
              for (K = Tt.getElementsByName(xt), qe = 0; oe = K[qe++]; )
                if (Oe = oe.getAttributeNode("id"), Oe && Oe.value === xt)
                  return [oe];
            }
            return [];
          }
        }), O.find.TAG = function(xt, Tt) {
          return typeof Tt.getElementsByTagName < "u" ? Tt.getElementsByTagName(xt) : Tt.querySelectorAll(xt);
        }, O.find.CLASS = function(xt, Tt) {
          if (typeof Tt.getElementsByClassName < "u" && ze)
            return Tt.getElementsByClassName(xt);
        }, Ze = [], un(function(xt) {
          var Tt;
          Ue.appendChild(xt).innerHTML = "<a id='" + Bt + "' href='' disabled='disabled'></a><select id='" + Bt + "-\r\\' disabled='disabled'><option selected=''></option></select>", xt.querySelectorAll("[selected]").length || Ze.push("\\[" + $e + "*(?:value|" + an + ")"), xt.querySelectorAll("[id~=" + Bt + "-]").length || Ze.push("~="), xt.querySelectorAll("a#" + Bt + "+*").length || Ze.push(".#.+[+~]"), xt.querySelectorAll(":checked").length || Ze.push(":checked"), Tt = xe.createElement("input"), Tt.setAttribute("type", "hidden"), xt.appendChild(Tt).setAttribute("name", "D"), Ue.appendChild(xt).disabled = !0, xt.querySelectorAll(":disabled").length !== 2 && Ze.push(":enabled", ":disabled"), Tt = xe.createElement("input"), Tt.setAttribute("name", ""), xt.appendChild(Tt), xt.querySelectorAll("[name='']").length || Ze.push("\\[" + $e + "*name" + $e + "*=" + $e + `*(?:''|"")`);
        }), Z.cssHas || Ze.push(":has"), Ze = Ze.length && new RegExp(Ze.join("|")), wn = function(xt, Tt) {
          if (xt === Tt)
            return ge = !0, 0;
          var Oe = !xt.compareDocumentPosition - !Tt.compareDocumentPosition;
          return Oe || (Oe = (xt.ownerDocument || xt) == (Tt.ownerDocument || Tt) ? xt.compareDocumentPosition(Tt) : (
            // Otherwise we know they are disconnected
            1
          ), Oe & 1 || !Z.sortDetached && Tt.compareDocumentPosition(xt) === Oe ? xt === xe || xt.ownerDocument == ft && Bi.contains(ft, xt) ? -1 : Tt === xe || Tt.ownerDocument == ft && Bi.contains(ft, Tt) ? 1 : re ? _.call(re, xt) - _.call(re, Tt) : 0 : Oe & 4 ? -1 : 1);
        }), xe;
      }
      Bi.matches = function(Pe, Ke) {
        return Bi(Pe, null, null, Ke);
      }, Bi.matchesSelector = function(Pe, Ke) {
        if (On(Pe), ze && !xn[Ke + " "] && (!Ze || !Ze.test(Ke)))
          try {
            var ct = At.call(Pe, Ke);
            if (ct || Z.disconnectedMatch || // As well, disconnected nodes are said to be in a document
            // fragment in IE 9
            Pe.document && Pe.document.nodeType !== 11)
              return ct;
          } catch {
            xn(Ke, !0);
          }
        return Bi(Ke, xe, null, [Pe]).length > 0;
      }, Bi.contains = function(Pe, Ke) {
        return (Pe.ownerDocument || Pe) != xe && On(Pe), W.contains(Pe, Ke);
      }, Bi.attr = function(Pe, Ke) {
        (Pe.ownerDocument || Pe) != xe && On(Pe);
        var ct = O.attrHandle[Ke.toLowerCase()], xt = ct && P.call(O.attrHandle, Ke.toLowerCase()) ? ct(Pe, Ke, !ze) : void 0;
        return xt !== void 0 ? xt : Pe.getAttribute(Ke);
      }, Bi.error = function(Pe) {
        throw new Error("Syntax error, unrecognized expression: " + Pe);
      }, W.uniqueSort = function(Pe) {
        var Ke, ct = [], xt = 0, Tt = 0;
        if (ge = !Z.sortStable, re = !Z.sortStable && o.call(Pe, 0), pt.call(Pe, wn), ge) {
          for (; Ke = Pe[Tt++]; )
            Ke === Pe[Tt] && (xt = ct.push(Tt));
          for (; xt--; )
            Le.call(Pe, ct[xt], 1);
        }
        return re = null, Pe;
      }, W.fn.uniqueSort = function() {
        return this.pushStack(W.uniqueSort(o.apply(this)));
      }, O = W.expr = {
        // Can be adjusted by the user
        cacheLength: 50,
        createPseudo: ui,
        match: Yn,
        attrHandle: {},
        find: {},
        relative: {
          ">": { dir: "parentNode", first: !0 },
          " ": { dir: "parentNode" },
          "+": { dir: "previousSibling", first: !0 },
          "~": { dir: "previousSibling" }
        },
        preFilter: {
          ATTR: function(Pe) {
            return Pe[1] = Pe[1].replace(Si, hn), Pe[3] = (Pe[3] || Pe[4] || Pe[5] || "").replace(Si, hn), Pe[2] === "~=" && (Pe[3] = " " + Pe[3] + " "), Pe.slice(0, 4);
          },
          CHILD: function(Pe) {
            return Pe[1] = Pe[1].toLowerCase(), Pe[1].slice(0, 3) === "nth" ? (Pe[3] || Bi.error(Pe[0]), Pe[4] = +(Pe[4] ? Pe[5] + (Pe[6] || 1) : 2 * (Pe[3] === "even" || Pe[3] === "odd")), Pe[5] = +(Pe[7] + Pe[8] || Pe[3] === "odd")) : Pe[3] && Bi.error(Pe[0]), Pe;
          },
          PSEUDO: function(Pe) {
            var Ke, ct = !Pe[6] && Pe[2];
            return Yn.CHILD.test(Pe[0]) ? null : (Pe[3] ? Pe[2] = Pe[4] || Pe[5] || "" : ct && pn.test(ct) && // Get excess from tokenize (recursively)
            (Ke = tr(ct, !0)) && // advance to the next closing parenthesis
            (Ke = ct.indexOf(")", ct.length - Ke) - ct.length) && (Pe[0] = Pe[0].slice(0, Ke), Pe[2] = ct.slice(0, Ke)), Pe.slice(0, 3));
          }
        },
        filter: {
          TAG: function(Pe) {
            var Ke = Pe.replace(Si, hn).toLowerCase();
            return Pe === "*" ? function() {
              return !0;
            } : function(ct) {
              return ke(ct, Ke);
            };
          },
          CLASS: function(Pe) {
            var Ke = fi[Pe + " "];
            return Ke || (Ke = new RegExp("(^|" + $e + ")" + Pe + "(" + $e + "|$)")) && fi(Pe, function(ct) {
              return Ke.test(
                typeof ct.className == "string" && ct.className || typeof ct.getAttribute < "u" && ct.getAttribute("class") || ""
              );
            });
          },
          ATTR: function(Pe, Ke, ct) {
            return function(xt) {
              var Tt = Bi.attr(xt, Pe);
              return Tt == null ? Ke === "!=" : Ke ? (Tt += "", Ke === "=" ? Tt === ct : Ke === "!=" ? Tt !== ct : Ke === "^=" ? ct && Tt.indexOf(ct) === 0 : Ke === "*=" ? ct && Tt.indexOf(ct) > -1 : Ke === "$=" ? ct && Tt.slice(-ct.length) === ct : Ke === "~=" ? (" " + Tt.replace(Ni, " ") + " ").indexOf(ct) > -1 : Ke === "|=" ? Tt === ct || Tt.slice(0, ct.length + 1) === ct + "-" : !1) : !0;
            };
          },
          CHILD: function(Pe, Ke, ct, xt, Tt) {
            var Oe = Pe.slice(0, 3) !== "nth", qe = Pe.slice(-4) !== "last", K = Ke === "of-type";
            return xt === 1 && Tt === 0 ? (
              // Shortcut for :nth-*(n)
              function(oe) {
                return !!oe.parentNode;
              }
            ) : function(oe, Me, Be) {
              var ot, ut, St, Zt, yi, Yi = Oe !== qe ? "nextSibling" : "previousSibling", Nn = oe.parentNode, mn = K && oe.nodeName.toLowerCase(), mr = !Be && !K, jn = !1;
              if (Nn) {
                if (Oe) {
                  for (; Yi; ) {
                    for (St = oe; St = St[Yi]; )
                      if (K ? ke(St, mn) : St.nodeType === 1)
                        return !1;
                    yi = Yi = Pe === "only" && !yi && "nextSibling";
                  }
                  return !0;
                }
                if (yi = [qe ? Nn.firstChild : Nn.lastChild], qe && mr) {
                  for (ut = Nn[Bt] || (Nn[Bt] = {}), ot = ut[Pe] || [], Zt = ot[0] === lt && ot[1], jn = Zt && ot[2], St = Zt && Nn.childNodes[Zt]; St = ++Zt && St && St[Yi] || // Fallback to seeking `elem` from the start
                  (jn = Zt = 0) || yi.pop(); )
                    if (St.nodeType === 1 && ++jn && St === oe) {
                      ut[Pe] = [lt, Zt, jn];
                      break;
                    }
                } else if (mr && (ut = oe[Bt] || (oe[Bt] = {}), ot = ut[Pe] || [], Zt = ot[0] === lt && ot[1], jn = Zt), jn === !1)
                  for (; (St = ++Zt && St && St[Yi] || (jn = Zt = 0) || yi.pop()) && !((K ? ke(St, mn) : St.nodeType === 1) && ++jn && (mr && (ut = St[Bt] || (St[Bt] = {}), ut[Pe] = [lt, jn]), St === oe)); )
                    ;
                return jn -= Tt, jn === xt || jn % xt === 0 && jn / xt >= 0;
              }
            };
          },
          PSEUDO: function(Pe, Ke) {
            var ct, xt = O.pseudos[Pe] || O.setFilters[Pe.toLowerCase()] || Bi.error("unsupported pseudo: " + Pe);
            return xt[Bt] ? xt(Ke) : xt.length > 1 ? (ct = [Pe, Pe, "", Ke], O.setFilters.hasOwnProperty(Pe.toLowerCase()) ? ui(function(Tt, Oe) {
              for (var qe, K = xt(Tt, Ke), oe = K.length; oe--; )
                qe = _.call(Tt, K[oe]), Tt[qe] = !(Oe[qe] = K[oe]);
            }) : function(Tt) {
              return xt(Tt, 0, ct);
            }) : xt;
          }
        },
        pseudos: {
          // Potentially complex pseudos
          not: ui(function(Pe) {
            var Ke = [], ct = [], xt = bs(Pe.replace(ce, "$1"));
            return xt[Bt] ? ui(function(Tt, Oe, qe, K) {
              for (var oe, Me = xt(Tt, null, K, []), Be = Tt.length; Be--; )
                (oe = Me[Be]) && (Tt[Be] = !(Oe[Be] = oe));
            }) : function(Tt, Oe, qe) {
              return Ke[0] = Tt, xt(Ke, null, qe, ct), Ke[0] = null, !ct.pop();
            };
          }),
          has: ui(function(Pe) {
            return function(Ke) {
              return Bi(Pe, Ke).length > 0;
            };
          }),
          contains: ui(function(Pe) {
            return Pe = Pe.replace(Si, hn), function(Ke) {
              return (Ke.textContent || W.text(Ke)).indexOf(Pe) > -1;
            };
          }),
          // "Whether an element is represented by a :lang() selector
          // is based solely on the element's language value
          // being equal to the identifier C,
          // or beginning with the identifier C immediately followed by "-".
          // The matching of C against the element's language value is performed case-insensitively.
          // The identifier C does not have to be a valid language name."
          // https://www.w3.org/TR/selectors/#lang-pseudo
          lang: ui(function(Pe) {
            return Ar.test(Pe || "") || Bi.error("unsupported lang: " + Pe), Pe = Pe.replace(Si, hn).toLowerCase(), function(Ke) {
              var ct;
              do
                if (ct = ze ? Ke.lang : Ke.getAttribute("xml:lang") || Ke.getAttribute("lang"))
                  return ct = ct.toLowerCase(), ct === Pe || ct.indexOf(Pe + "-") === 0;
              while ((Ke = Ke.parentNode) && Ke.nodeType === 1);
              return !1;
            };
          }),
          // Miscellaneous
          target: function(Pe) {
            var Ke = e.location && e.location.hash;
            return Ke && Ke.slice(1) === Pe.id;
          },
          root: function(Pe) {
            return Pe === Ue;
          },
          focus: function(Pe) {
            return Pe === gi() && xe.hasFocus() && !!(Pe.type || Pe.href || ~Pe.tabIndex);
          },
          // Boolean properties
          enabled: $r(!1),
          disabled: $r(!0),
          checked: function(Pe) {
            return ke(Pe, "input") && !!Pe.checked || ke(Pe, "option") && !!Pe.selected;
          },
          selected: function(Pe) {
            return Pe.parentNode && Pe.parentNode.selectedIndex, Pe.selected === !0;
          },
          // Contents
          empty: function(Pe) {
            for (Pe = Pe.firstChild; Pe; Pe = Pe.nextSibling)
              if (Pe.nodeType < 6)
                return !1;
            return !0;
          },
          parent: function(Pe) {
            return !O.pseudos.empty(Pe);
          },
          // Element/input types
          header: function(Pe) {
            return qn.test(Pe.nodeName);
          },
          input: function(Pe) {
            return Qt.test(Pe.nodeName);
          },
          button: function(Pe) {
            return ke(Pe, "input") && Pe.type === "button" || ke(Pe, "button");
          },
          text: function(Pe) {
            var Ke;
            return ke(Pe, "input") && Pe.type === "text" && // Support: IE <10 only
            // New HTML5 attribute values (e.g., "search") appear
            // with elem.type === "text"
            ((Ke = Pe.getAttribute("type")) == null || Ke.toLowerCase() === "text");
          },
          // Position-in-collection
          first: Fr(function() {
            return [0];
          }),
          last: Fr(function(Pe, Ke) {
            return [Ke - 1];
          }),
          eq: Fr(function(Pe, Ke, ct) {
            return [ct < 0 ? ct + Ke : ct];
          }),
          even: Fr(function(Pe, Ke) {
            for (var ct = 0; ct < Ke; ct += 2)
              Pe.push(ct);
            return Pe;
          }),
          odd: Fr(function(Pe, Ke) {
            for (var ct = 1; ct < Ke; ct += 2)
              Pe.push(ct);
            return Pe;
          }),
          lt: Fr(function(Pe, Ke, ct) {
            var xt;
            for (ct < 0 ? xt = ct + Ke : ct > Ke ? xt = Ke : xt = ct; --xt >= 0; )
              Pe.push(xt);
            return Pe;
          }),
          gt: Fr(function(Pe, Ke, ct) {
            for (var xt = ct < 0 ? ct + Ke : ct; ++xt < Ke; )
              Pe.push(xt);
            return Pe;
          })
        }
      }, O.pseudos.nth = O.pseudos.eq;
      for (w in { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 })
        O.pseudos[w] = zr(w);
      for (w in { submit: !0, reset: !0 })
        O.pseudos[w] = Js(w);
      function or() {
      }
      or.prototype = O.filters = O.pseudos, O.setFilters = new or();
      function tr(Pe, Ke) {
        var ct, xt, Tt, Oe, qe, K, oe, Me = si[Pe + " "];
        if (Me)
          return Ke ? 0 : Me.slice(0);
        for (qe = Pe, K = [], oe = O.preFilter; qe; ) {
          (!ct || (xt = Qi.exec(qe))) && (xt && (qe = qe.slice(xt[0].length) || qe), K.push(Tt = [])), ct = !1, (xt = ar.exec(qe)) && (ct = xt.shift(), Tt.push({
            value: ct,
            // Cast descendant combinators to space
            type: xt[0].replace(ce, " ")
          }), qe = qe.slice(ct.length));
          for (Oe in O.filter)
            (xt = Yn[Oe].exec(qe)) && (!oe[Oe] || (xt = oe[Oe](xt))) && (ct = xt.shift(), Tt.push({
              value: ct,
              type: Oe,
              matches: xt
            }), qe = qe.slice(ct.length));
          if (!ct)
            break;
        }
        return Ke ? qe.length : qe ? Bi.error(Pe) : (
          // Cache the tokens
          si(Pe, K).slice(0)
        );
      }
      function Ur(Pe) {
        for (var Ke = 0, ct = Pe.length, xt = ""; Ke < ct; Ke++)
          xt += Pe[Ke].value;
        return xt;
      }
      function $n(Pe, Ke, ct) {
        var xt = Ke.dir, Tt = Ke.next, Oe = Tt || xt, qe = ct && Oe === "parentNode", K = Ft++;
        return Ke.first ? (
          // Check against closest ancestor/preceding element
          function(oe, Me, Be) {
            for (; oe = oe[xt]; )
              if (oe.nodeType === 1 || qe)
                return Pe(oe, Me, Be);
            return !1;
          }
        ) : (
          // Check against all ancestor/preceding elements
          function(oe, Me, Be) {
            var ot, ut, St = [lt, K];
            if (Be) {
              for (; oe = oe[xt]; )
                if ((oe.nodeType === 1 || qe) && Pe(oe, Me, Be))
                  return !0;
            } else
              for (; oe = oe[xt]; )
                if (oe.nodeType === 1 || qe)
                  if (ut = oe[Bt] || (oe[Bt] = {}), Tt && ke(oe, Tt))
                    oe = oe[xt] || oe;
                  else {
                    if ((ot = ut[Oe]) && ot[0] === lt && ot[1] === K)
                      return St[2] = ot[2];
                    if (ut[Oe] = St, St[2] = Pe(oe, Me, Be))
                      return !0;
                  }
            return !1;
          }
        );
      }
      function Pi(Pe) {
        return Pe.length > 1 ? function(Ke, ct, xt) {
          for (var Tt = Pe.length; Tt--; )
            if (!Pe[Tt](Ke, ct, xt))
              return !1;
          return !0;
        } : Pe[0];
      }
      function ls(Pe, Ke, ct) {
        for (var xt = 0, Tt = Ke.length; xt < Tt; xt++)
          Bi(Pe, Ke[xt], ct);
        return ct;
      }
      function ys(Pe, Ke, ct, xt, Tt) {
        for (var Oe, qe = [], K = 0, oe = Pe.length, Me = Ke != null; K < oe; K++)
          (Oe = Pe[K]) && (!ct || ct(Oe, xt, Tt)) && (qe.push(Oe), Me && Ke.push(K));
        return qe;
      }
      function Ls(Pe, Ke, ct, xt, Tt, Oe) {
        return xt && !xt[Bt] && (xt = Ls(xt)), Tt && !Tt[Bt] && (Tt = Ls(Tt, Oe)), ui(function(qe, K, oe, Me) {
          var Be, ot, ut, St, Zt = [], yi = [], Yi = K.length, Nn = qe || ls(
            Ke || "*",
            oe.nodeType ? [oe] : oe,
            []
          ), mn = Pe && (qe || !Ke) ? ys(Nn, Zt, Pe, oe, Me) : Nn;
          if (ct ? (St = Tt || (qe ? Pe : Yi || xt) ? (
            // ...intermediate processing is necessary
            []
          ) : (
            // ...otherwise use results directly
            K
          ), ct(mn, St, oe, Me)) : St = mn, xt)
            for (Be = ys(St, yi), xt(Be, [], oe, Me), ot = Be.length; ot--; )
              (ut = Be[ot]) && (St[yi[ot]] = !(mn[yi[ot]] = ut));
          if (qe) {
            if (Tt || Pe) {
              if (Tt) {
                for (Be = [], ot = St.length; ot--; )
                  (ut = St[ot]) && Be.push(mn[ot] = ut);
                Tt(null, St = [], Be, Me);
              }
              for (ot = St.length; ot--; )
                (ut = St[ot]) && (Be = Tt ? _.call(qe, ut) : Zt[ot]) > -1 && (qe[Be] = !(K[Be] = ut));
            }
          } else
            St = ys(
              St === K ? St.splice(Yi, St.length) : St
            ), Tt ? Tt(null, K, St, Me) : me.apply(K, St);
        });
      }
      function Jn(Pe) {
        for (var Ke, ct, xt, Tt = Pe.length, Oe = O.relative[Pe[0].type], qe = Oe || O.relative[" "], K = Oe ? 1 : 0, oe = $n(function(ot) {
          return ot === Ke;
        }, qe, !0), Me = $n(function(ot) {
          return _.call(Ke, ot) > -1;
        }, qe, !0), Be = [function(ot, ut, St) {
          var Zt = !Oe && (St || ut != J) || ((Ke = ut).nodeType ? oe(ot, ut, St) : Me(ot, ut, St));
          return Ke = null, Zt;
        }]; K < Tt; K++)
          if (ct = O.relative[Pe[K].type])
            Be = [$n(Pi(Be), ct)];
          else {
            if (ct = O.filter[Pe[K].type].apply(null, Pe[K].matches), ct[Bt]) {
              for (xt = ++K; xt < Tt && !O.relative[Pe[xt].type]; xt++)
                ;
              return Ls(
                K > 1 && Pi(Be),
                K > 1 && Ur(
                  // If the preceding token was a descendant combinator, insert an implicit any-element `*`
                  Pe.slice(0, K - 1).concat({ value: Pe[K - 2].type === " " ? "*" : "" })
                ).replace(ce, "$1"),
                ct,
                K < xt && Jn(Pe.slice(K, xt)),
                xt < Tt && Jn(Pe = Pe.slice(xt)),
                xt < Tt && Ur(Pe)
              );
            }
            Be.push(ct);
          }
        return Pi(Be);
      }
      function zn(Pe, Ke) {
        var ct = Ke.length > 0, xt = Pe.length > 0, Tt = function(Oe, qe, K, oe, Me) {
          var Be, ot, ut, St = 0, Zt = "0", yi = Oe && [], Yi = [], Nn = J, mn = Oe || xt && O.find.TAG("*", Me), mr = lt += Nn == null ? 1 : Math.random() || 0.1, jn = mn.length;
          for (Me && (J = qe == xe || qe || Me); Zt !== jn && (Be = mn[Zt]) != null; Zt++) {
            if (xt && Be) {
              for (ot = 0, !qe && Be.ownerDocument != xe && (On(Be), K = !ze); ut = Pe[ot++]; )
                if (ut(Be, qe || xe, K)) {
                  me.call(oe, Be);
                  break;
                }
              Me && (lt = mr);
            }
            ct && ((Be = !ut && Be) && St--, Oe && yi.push(Be));
          }
          if (St += Zt, ct && Zt !== St) {
            for (ot = 0; ut = Ke[ot++]; )
              ut(yi, Yi, qe, K);
            if (Oe) {
              if (St > 0)
                for (; Zt--; )
                  yi[Zt] || Yi[Zt] || (Yi[Zt] = Ye.call(oe));
              Yi = ys(Yi);
            }
            me.apply(oe, Yi), Me && !Oe && Yi.length > 0 && St + Ke.length > 1 && W.uniqueSort(oe);
          }
          return Me && (lt = mr, J = Nn), yi;
        };
        return ct ? ui(Tt) : Tt;
      }
      function bs(Pe, Ke) {
        var ct, xt = [], Tt = [], Oe = di[Pe + " "];
        if (!Oe) {
          for (Ke || (Ke = tr(Pe)), ct = Ke.length; ct--; )
            Oe = Jn(Ke[ct]), Oe[Bt] ? xt.push(Oe) : Tt.push(Oe);
          Oe = di(
            Pe,
            zn(Tt, xt)
          ), Oe.selector = Pe;
        }
        return Oe;
      }
      function lr(Pe, Ke, ct, xt) {
        var Tt, Oe, qe, K, oe, Me = typeof Pe == "function" && Pe, Be = !xt && tr(Pe = Me.selector || Pe);
        if (ct = ct || [], Be.length === 1) {
          if (Oe = Be[0] = Be[0].slice(0), Oe.length > 2 && (qe = Oe[0]).type === "ID" && Ke.nodeType === 9 && ze && O.relative[Oe[1].type]) {
            if (Ke = (O.find.ID(
              qe.matches[0].replace(Si, hn),
              Ke
            ) || [])[0], Ke)
              Me && (Ke = Ke.parentNode);
            else
              return ct;
            Pe = Pe.slice(Oe.shift().value.length);
          }
          for (Tt = Yn.needsContext.test(Pe) ? 0 : Oe.length; Tt-- && (qe = Oe[Tt], !O.relative[K = qe.type]); )
            if ((oe = O.find[K]) && (xt = oe(
              qe.matches[0].replace(Si, hn),
              Dr.test(Oe[0].type) && Ki(Ke.parentNode) || Ke
            ))) {
              if (Oe.splice(Tt, 1), Pe = xt.length && Ur(Oe), !Pe)
                return me.apply(ct, xt), ct;
              break;
            }
        }
        return (Me || bs(Pe, Be))(
          xt,
          Ke,
          !ze,
          ct,
          !Ke || Dr.test(Pe) && Ki(Ke.parentNode) || Ke
        ), ct;
      }
      Z.sortStable = Bt.split("").sort(wn).join("") === Bt, On(), Z.sortDetached = un(function(Pe) {
        return Pe.compareDocumentPosition(xe.createElement("fieldset")) & 1;
      }), W.find = Bi, W.expr[":"] = W.expr.pseudos, W.unique = W.uniqueSort, Bi.compile = bs, Bi.select = lr, Bi.setDocument = On, Bi.tokenize = tr, Bi.escape = W.escapeSelector, Bi.getText = W.text, Bi.isXML = W.isXMLDoc, Bi.selectors = W.expr, Bi.support = W.support, Bi.uniqueSort = W.uniqueSort;
    })();
    var We = function(w, O, J) {
      for (var re = [], ge = J !== void 0; (w = w[O]) && w.nodeType !== 9; )
        if (w.nodeType === 1) {
          if (ge && W(w).is(J))
            break;
          re.push(w);
        }
      return re;
    }, It = function(w, O) {
      for (var J = []; w; w = w.nextSibling)
        w.nodeType === 1 && w !== O && J.push(w);
      return J;
    }, rt = W.expr.match.needsContext, tt = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    function Kt(w, O, J) {
      return F(O) ? W.grep(w, function(re, ge) {
        return !!O.call(re, ge, re) !== J;
      }) : O.nodeType ? W.grep(w, function(re) {
        return re === O !== J;
      }) : typeof O != "string" ? W.grep(w, function(re) {
        return _.call(O, re) > -1 !== J;
      }) : W.filter(O, w, J);
    }
    W.filter = function(w, O, J) {
      var re = O[0];
      return J && (w = ":not(" + w + ")"), O.length === 1 && re.nodeType === 1 ? W.find.matchesSelector(re, w) ? [re] : [] : W.find.matches(w, W.grep(O, function(ge) {
        return ge.nodeType === 1;
      }));
    }, W.fn.extend({
      find: function(w) {
        var O, J, re = this.length, ge = this;
        if (typeof w != "string")
          return this.pushStack(W(w).filter(function() {
            for (O = 0; O < re; O++)
              if (W.contains(ge[O], this))
                return !0;
          }));
        for (J = this.pushStack([]), O = 0; O < re; O++)
          W.find(w, ge[O], J);
        return re > 1 ? W.uniqueSort(J) : J;
      },
      filter: function(w) {
        return this.pushStack(Kt(this, w || [], !1));
      },
      not: function(w) {
        return this.pushStack(Kt(this, w || [], !0));
      },
      is: function(w) {
        return !!Kt(
          this,
          // If this is a positional/relative selector, check membership in the returned set
          // so $("p:first").is("p:last") won't return true for a doc with two "p".
          typeof w == "string" && rt.test(w) ? W(w) : w || [],
          !1
        ).length;
      }
    });
    var qt, Lt = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, Ci = W.fn.init = function(w, O, J) {
      var re, ge;
      if (!w)
        return this;
      if (J = J || qt, typeof w == "string")
        if (w[0] === "<" && w[w.length - 1] === ">" && w.length >= 3 ? re = [null, w, null] : re = Lt.exec(w), re && (re[1] || !O))
          if (re[1]) {
            if (O = O instanceof W ? O[0] : O, W.merge(this, W.parseHTML(
              re[1],
              O && O.nodeType ? O.ownerDocument || O : D,
              !0
            )), tt.test(re[1]) && W.isPlainObject(O))
              for (re in O)
                F(this[re]) ? this[re](O[re]) : this.attr(re, O[re]);
            return this;
          } else
            return ge = D.getElementById(re[2]), ge && (this[0] = ge, this.length = 1), this;
        else
          return !O || O.jquery ? (O || J).find(w) : this.constructor(O).find(w);
      else {
        if (w.nodeType)
          return this[0] = w, this.length = 1, this;
        if (F(w))
          return J.ready !== void 0 ? J.ready(w) : (
            // Execute immediately if ready is not present
            w(W)
          );
      }
      return W.makeArray(w, this);
    };
    Ci.prototype = W.fn, qt = W(D);
    var ji = /^(?:parents|prev(?:Until|All))/, _i = {
      children: !0,
      contents: !0,
      next: !0,
      prev: !0
    };
    W.fn.extend({
      has: function(w) {
        var O = W(w, this), J = O.length;
        return this.filter(function() {
          for (var re = 0; re < J; re++)
            if (W.contains(this, O[re]))
              return !0;
        });
      },
      closest: function(w, O) {
        var J, re = 0, ge = this.length, me = [], xe = typeof w != "string" && W(w);
        if (!rt.test(w)) {
          for (; re < ge; re++)
            for (J = this[re]; J && J !== O; J = J.parentNode)
              if (J.nodeType < 11 && (xe ? xe.index(J) > -1 : (
                // Don't pass non-elements to jQuery#find
                J.nodeType === 1 && W.find.matchesSelector(J, w)
              ))) {
                me.push(J);
                break;
              }
        }
        return this.pushStack(me.length > 1 ? W.uniqueSort(me) : me);
      },
      // Determine the position of an element within the set
      index: function(w) {
        return w ? typeof w == "string" ? _.call(W(w), this[0]) : _.call(
          this,
          // If it receives a jQuery object, the first element is used
          w.jquery ? w[0] : w
        ) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
      },
      add: function(w, O) {
        return this.pushStack(
          W.uniqueSort(
            W.merge(this.get(), W(w, O))
          )
        );
      },
      addBack: function(w) {
        return this.add(
          w == null ? this.prevObject : this.prevObject.filter(w)
        );
      }
    });
    function Wt(w, O) {
      for (; (w = w[O]) && w.nodeType !== 1; )
        ;
      return w;
    }
    W.each({
      parent: function(w) {
        var O = w.parentNode;
        return O && O.nodeType !== 11 ? O : null;
      },
      parents: function(w) {
        return We(w, "parentNode");
      },
      parentsUntil: function(w, O, J) {
        return We(w, "parentNode", J);
      },
      next: function(w) {
        return Wt(w, "nextSibling");
      },
      prev: function(w) {
        return Wt(w, "previousSibling");
      },
      nextAll: function(w) {
        return We(w, "nextSibling");
      },
      prevAll: function(w) {
        return We(w, "previousSibling");
      },
      nextUntil: function(w, O, J) {
        return We(w, "nextSibling", J);
      },
      prevUntil: function(w, O, J) {
        return We(w, "previousSibling", J);
      },
      siblings: function(w) {
        return It((w.parentNode || {}).firstChild, w);
      },
      children: function(w) {
        return It(w.firstChild);
      },
      contents: function(w) {
        return w.contentDocument != null && // Support: IE 11+
        // <object> elements with no `data` attribute has an object
        // `contentDocument` with a `null` prototype.
        s(w.contentDocument) ? w.contentDocument : (ke(w, "template") && (w = w.content || w), W.merge([], w.childNodes));
      }
    }, function(w, O) {
      W.fn[w] = function(J, re) {
        var ge = W.map(this, O, J);
        return w.slice(-5) !== "Until" && (re = J), re && typeof re == "string" && (ge = W.filter(re, ge)), this.length > 1 && (_i[w] || W.uniqueSort(ge), ji.test(w) && ge.reverse()), this.pushStack(ge);
      };
    });
    var $t = /[^\x20\t\r\n\f]+/g;
    function ei(w) {
      var O = {};
      return W.each(w.match($t) || [], function(J, re) {
        O[re] = !0;
      }), O;
    }
    W.Callbacks = function(w) {
      w = typeof w == "string" ? ei(w) : W.extend({}, w);
      var O, J, re, ge, me = [], xe = [], Ue = -1, ze = function() {
        for (ge = ge || w.once, re = O = !0; xe.length; Ue = -1)
          for (J = xe.shift(); ++Ue < me.length; )
            me[Ue].apply(J[0], J[1]) === !1 && w.stopOnFalse && (Ue = me.length, J = !1);
        w.memory || (J = !1), O = !1, ge && (J ? me = [] : me = "");
      }, Ze = {
        // Add a callback or a collection of callbacks to the list
        add: function() {
          return me && (J && !O && (Ue = me.length - 1, xe.push(J)), function At(Bt) {
            W.each(Bt, function(lt, Ft) {
              F(Ft) ? (!w.unique || !Ze.has(Ft)) && me.push(Ft) : Ft && Ft.length && le(Ft) !== "string" && At(Ft);
            });
          }(arguments), J && !O && ze()), this;
        },
        // Remove a callback from the list
        remove: function() {
          return W.each(arguments, function(At, Bt) {
            for (var lt; (lt = W.inArray(Bt, me, lt)) > -1; )
              me.splice(lt, 1), lt <= Ue && Ue--;
          }), this;
        },
        // Check if a given callback is in the list.
        // If no argument is given, return whether or not list has callbacks attached.
        has: function(At) {
          return At ? W.inArray(At, me) > -1 : me.length > 0;
        },
        // Remove all callbacks from the list
        empty: function() {
          return me && (me = []), this;
        },
        // Disable .fire and .add
        // Abort any current/pending executions
        // Clear all callbacks and values
        disable: function() {
          return ge = xe = [], me = J = "", this;
        },
        disabled: function() {
          return !me;
        },
        // Disable .fire
        // Also disable .add unless we have memory (since it would have no effect)
        // Abort any pending executions
        lock: function() {
          return ge = xe = [], !J && !O && (me = J = ""), this;
        },
        locked: function() {
          return !!ge;
        },
        // Call all callbacks with the given context and arguments
        fireWith: function(At, Bt) {
          return ge || (Bt = Bt || [], Bt = [At, Bt.slice ? Bt.slice() : Bt], xe.push(Bt), O || ze()), this;
        },
        // Call all the callbacks with the given arguments
        fire: function() {
          return Ze.fireWith(this, arguments), this;
        },
        // To know if the callbacks have already been called at least once
        fired: function() {
          return !!re;
        }
      };
      return Ze;
    };
    function tn(w) {
      return w;
    }
    function Fi(w) {
      throw w;
    }
    function _e(w, O, J, re) {
      var ge;
      try {
        w && F(ge = w.promise) ? ge.call(w).done(O).fail(J) : w && F(ge = w.then) ? ge.call(w, O, J) : O.apply(void 0, [w].slice(re));
      } catch (me) {
        J.apply(void 0, [me]);
      }
    }
    W.extend({
      Deferred: function(w) {
        var O = [
          // action, add listener, callbacks,
          // ... .then handlers, argument index, [final state]
          [
            "notify",
            "progress",
            W.Callbacks("memory"),
            W.Callbacks("memory"),
            2
          ],
          [
            "resolve",
            "done",
            W.Callbacks("once memory"),
            W.Callbacks("once memory"),
            0,
            "resolved"
          ],
          [
            "reject",
            "fail",
            W.Callbacks("once memory"),
            W.Callbacks("once memory"),
            1,
            "rejected"
          ]
        ], J = "pending", re = {
          state: function() {
            return J;
          },
          always: function() {
            return ge.done(arguments).fail(arguments), this;
          },
          catch: function(me) {
            return re.then(null, me);
          },
          // Keep pipe for back-compat
          pipe: function() {
            var me = arguments;
            return W.Deferred(function(xe) {
              W.each(O, function(Ue, ze) {
                var Ze = F(me[ze[4]]) && me[ze[4]];
                ge[ze[1]](function() {
                  var At = Ze && Ze.apply(this, arguments);
                  At && F(At.promise) ? At.promise().progress(xe.notify).done(xe.resolve).fail(xe.reject) : xe[ze[0] + "With"](
                    this,
                    Ze ? [At] : arguments
                  );
                });
              }), me = null;
            }).promise();
          },
          then: function(me, xe, Ue) {
            var ze = 0;
            function Ze(At, Bt, lt, Ft) {
              return function() {
                var fi = this, si = arguments, di = function() {
                  var wn, an;
                  if (!(At < ze)) {
                    if (wn = lt.apply(fi, si), wn === Bt.promise())
                      throw new TypeError("Thenable self-resolution");
                    an = wn && // Support: Promises/A+ section 2.3.4
                    // https://promisesaplus.com/#point-64
                    // Only check objects and functions for thenability
                    (typeof wn == "object" || typeof wn == "function") && wn.then, F(an) ? Ft ? an.call(
                      wn,
                      Ze(ze, Bt, tn, Ft),
                      Ze(ze, Bt, Fi, Ft)
                    ) : (ze++, an.call(
                      wn,
                      Ze(ze, Bt, tn, Ft),
                      Ze(ze, Bt, Fi, Ft),
                      Ze(
                        ze,
                        Bt,
                        tn,
                        Bt.notifyWith
                      )
                    )) : (lt !== tn && (fi = void 0, si = [wn]), (Ft || Bt.resolveWith)(fi, si));
                  }
                }, xn = Ft ? di : function() {
                  try {
                    di();
                  } catch (wn) {
                    W.Deferred.exceptionHook && W.Deferred.exceptionHook(
                      wn,
                      xn.error
                    ), At + 1 >= ze && (lt !== Fi && (fi = void 0, si = [wn]), Bt.rejectWith(fi, si));
                  }
                };
                At ? xn() : (W.Deferred.getErrorHook ? xn.error = W.Deferred.getErrorHook() : W.Deferred.getStackHook && (xn.error = W.Deferred.getStackHook()), e.setTimeout(xn));
              };
            }
            return W.Deferred(function(At) {
              O[0][3].add(
                Ze(
                  0,
                  At,
                  F(Ue) ? Ue : tn,
                  At.notifyWith
                )
              ), O[1][3].add(
                Ze(
                  0,
                  At,
                  F(me) ? me : tn
                )
              ), O[2][3].add(
                Ze(
                  0,
                  At,
                  F(xe) ? xe : Fi
                )
              );
            }).promise();
          },
          // Get a promise for this deferred
          // If obj is provided, the promise aspect is added to the object
          promise: function(me) {
            return me != null ? W.extend(me, re) : re;
          }
        }, ge = {};
        return W.each(O, function(me, xe) {
          var Ue = xe[2], ze = xe[5];
          re[xe[1]] = Ue.add, ze && Ue.add(
            function() {
              J = ze;
            },
            // rejected_callbacks.disable
            // fulfilled_callbacks.disable
            O[3 - me][2].disable,
            // rejected_handlers.disable
            // fulfilled_handlers.disable
            O[3 - me][3].disable,
            // progress_callbacks.lock
            O[0][2].lock,
            // progress_handlers.lock
            O[0][3].lock
          ), Ue.add(xe[3].fire), ge[xe[0]] = function() {
            return ge[xe[0] + "With"](this === ge ? void 0 : this, arguments), this;
          }, ge[xe[0] + "With"] = Ue.fireWith;
        }), re.promise(ge), w && w.call(ge, ge), ge;
      },
      // Deferred helper
      when: function(w) {
        var O = arguments.length, J = O, re = Array(J), ge = o.call(arguments), me = W.Deferred(), xe = function(Ue) {
          return function(ze) {
            re[Ue] = this, ge[Ue] = arguments.length > 1 ? o.call(arguments) : ze, --O || me.resolveWith(re, ge);
          };
        };
        if (O <= 1 && (_e(
          w,
          me.done(xe(J)).resolve,
          me.reject,
          !O
        ), me.state() === "pending" || F(ge[J] && ge[J].then)))
          return me.then();
        for (; J--; )
          _e(ge[J], xe(J), me.reject);
        return me.promise();
      }
    });
    var Ct = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    W.Deferred.exceptionHook = function(w, O) {
      e.console && e.console.warn && w && Ct.test(w.name) && e.console.warn(
        "jQuery.Deferred exception: " + w.message,
        w.stack,
        O
      );
    }, W.readyException = function(w) {
      e.setTimeout(function() {
        throw w;
      });
    };
    var yt = W.Deferred();
    W.fn.ready = function(w) {
      return yt.then(w).catch(function(O) {
        W.readyException(O);
      }), this;
    }, W.extend({
      // Is the DOM ready to be used? Set to true once it occurs.
      isReady: !1,
      // A counter to track how many items to wait for before
      // the ready event fires. See trac-6781
      readyWait: 1,
      // Handle when the DOM is ready
      ready: function(w) {
        (w === !0 ? --W.readyWait : W.isReady) || (W.isReady = !0, !(w !== !0 && --W.readyWait > 0) && yt.resolveWith(D, [W]));
      }
    }), W.ready.then = yt.then;
    function Re() {
      D.removeEventListener("DOMContentLoaded", Re), e.removeEventListener("load", Re), W.ready();
    }
    D.readyState === "complete" || D.readyState !== "loading" && !D.documentElement.doScroll ? e.setTimeout(W.ready) : (D.addEventListener("DOMContentLoaded", Re), e.addEventListener("load", Re));
    var Ee = function(w, O, J, re, ge, me, xe) {
      var Ue = 0, ze = w.length, Ze = J == null;
      if (le(J) === "object") {
        ge = !0;
        for (Ue in J)
          Ee(w, O, Ue, J[Ue], !0, me, xe);
      } else if (re !== void 0 && (ge = !0, F(re) || (xe = !0), Ze && (xe ? (O.call(w, re), O = null) : (Ze = O, O = function(At, Bt, lt) {
        return Ze.call(W(At), lt);
      })), O))
        for (; Ue < ze; Ue++)
          O(
            w[Ue],
            J,
            xe ? re : re.call(w[Ue], Ue, O(w[Ue], J))
          );
      return ge ? w : Ze ? O.call(w) : ze ? O(w[0], J) : me;
    }, et = /^-ms-/, kt = /-([a-z])/g;
    function mt(w, O) {
      return O.toUpperCase();
    }
    function Qe(w) {
      return w.replace(et, "ms-").replace(kt, mt);
    }
    var bt = function(w) {
      return w.nodeType === 1 || w.nodeType === 9 || !+w.nodeType;
    };
    function Gt() {
      this.expando = W.expando + Gt.uid++;
    }
    Gt.uid = 1, Gt.prototype = {
      cache: function(w) {
        var O = w[this.expando];
        return O || (O = {}, bt(w) && (w.nodeType ? w[this.expando] = O : Object.defineProperty(w, this.expando, {
          value: O,
          configurable: !0
        }))), O;
      },
      set: function(w, O, J) {
        var re, ge = this.cache(w);
        if (typeof O == "string")
          ge[Qe(O)] = J;
        else
          for (re in O)
            ge[Qe(re)] = O[re];
        return ge;
      },
      get: function(w, O) {
        return O === void 0 ? this.cache(w) : (
          // Always use camelCase key (gh-2257)
          w[this.expando] && w[this.expando][Qe(O)]
        );
      },
      access: function(w, O, J) {
        return O === void 0 || O && typeof O == "string" && J === void 0 ? this.get(w, O) : (this.set(w, O, J), J !== void 0 ? J : O);
      },
      remove: function(w, O) {
        var J, re = w[this.expando];
        if (re !== void 0) {
          if (O !== void 0)
            for (Array.isArray(O) ? O = O.map(Qe) : (O = Qe(O), O = O in re ? [O] : O.match($t) || []), J = O.length; J--; )
              delete re[O[J]];
          (O === void 0 || W.isEmptyObject(re)) && (w.nodeType ? w[this.expando] = void 0 : delete w[this.expando]);
        }
      },
      hasData: function(w) {
        var O = w[this.expando];
        return O !== void 0 && !W.isEmptyObject(O);
      }
    };
    var He = new Gt(), i = new Gt(), r = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, a = /[A-Z]/g;
    function l(w) {
      return w === "true" ? !0 : w === "false" ? !1 : w === "null" ? null : w === +w + "" ? +w : r.test(w) ? JSON.parse(w) : w;
    }
    function u(w, O, J) {
      var re;
      if (J === void 0 && w.nodeType === 1)
        if (re = "data-" + O.replace(a, "-$&").toLowerCase(), J = w.getAttribute(re), typeof J == "string") {
          try {
            J = l(J);
          } catch {
          }
          i.set(w, O, J);
        } else
          J = void 0;
      return J;
    }
    W.extend({
      hasData: function(w) {
        return i.hasData(w) || He.hasData(w);
      },
      data: function(w, O, J) {
        return i.access(w, O, J);
      },
      removeData: function(w, O) {
        i.remove(w, O);
      },
      // TODO: Now that all calls to _data and _removeData have been replaced
      // with direct calls to dataPriv methods, these can be deprecated.
      _data: function(w, O, J) {
        return He.access(w, O, J);
      },
      _removeData: function(w, O) {
        He.remove(w, O);
      }
    }), W.fn.extend({
      data: function(w, O) {
        var J, re, ge, me = this[0], xe = me && me.attributes;
        if (w === void 0) {
          if (this.length && (ge = i.get(me), me.nodeType === 1 && !He.get(me, "hasDataAttrs"))) {
            for (J = xe.length; J--; )
              xe[J] && (re = xe[J].name, re.indexOf("data-") === 0 && (re = Qe(re.slice(5)), u(me, re, ge[re])));
            He.set(me, "hasDataAttrs", !0);
          }
          return ge;
        }
        return typeof w == "object" ? this.each(function() {
          i.set(this, w);
        }) : Ee(this, function(Ue) {
          var ze;
          if (me && Ue === void 0)
            return ze = i.get(me, w), ze !== void 0 || (ze = u(me, w), ze !== void 0) ? ze : void 0;
          this.each(function() {
            i.set(this, w, Ue);
          });
        }, null, O, arguments.length > 1, null, !0);
      },
      removeData: function(w) {
        return this.each(function() {
          i.remove(this, w);
        });
      }
    }), W.extend({
      queue: function(w, O, J) {
        var re;
        if (w)
          return O = (O || "fx") + "queue", re = He.get(w, O), J && (!re || Array.isArray(J) ? re = He.access(w, O, W.makeArray(J)) : re.push(J)), re || [];
      },
      dequeue: function(w, O) {
        O = O || "fx";
        var J = W.queue(w, O), re = J.length, ge = J.shift(), me = W._queueHooks(w, O), xe = function() {
          W.dequeue(w, O);
        };
        ge === "inprogress" && (ge = J.shift(), re--), ge && (O === "fx" && J.unshift("inprogress"), delete me.stop, ge.call(w, xe, me)), !re && me && me.empty.fire();
      },
      // Not public - generate a queueHooks object, or return the current one
      _queueHooks: function(w, O) {
        var J = O + "queueHooks";
        return He.get(w, J) || He.access(w, J, {
          empty: W.Callbacks("once memory").add(function() {
            He.remove(w, [O + "queue", J]);
          })
        });
      }
    }), W.fn.extend({
      queue: function(w, O) {
        var J = 2;
        return typeof w != "string" && (O = w, w = "fx", J--), arguments.length < J ? W.queue(this[0], w) : O === void 0 ? this : this.each(function() {
          var re = W.queue(this, w, O);
          W._queueHooks(this, w), w === "fx" && re[0] !== "inprogress" && W.dequeue(this, w);
        });
      },
      dequeue: function(w) {
        return this.each(function() {
          W.dequeue(this, w);
        });
      },
      clearQueue: function(w) {
        return this.queue(w || "fx", []);
      },
      // Get a promise resolved when queues of a certain type
      // are emptied (fx is the type by default)
      promise: function(w, O) {
        var J, re = 1, ge = W.Deferred(), me = this, xe = this.length, Ue = function() {
          --re || ge.resolveWith(me, [me]);
        };
        for (typeof w != "string" && (O = w, w = void 0), w = w || "fx"; xe--; )
          J = He.get(me[xe], w + "queueHooks"), J && J.empty && (re++, J.empty.add(Ue));
        return Ue(), ge.promise(O);
      }
    });
    var d = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source, v = new RegExp("^(?:([+-])=|)(" + d + ")([a-z%]*)$", "i"), p = ["Top", "Right", "Bottom", "Left"], y = D.documentElement, S = function(w) {
      return W.contains(w.ownerDocument, w);
    }, L = { composed: !0 };
    y.getRootNode && (S = function(w) {
      return W.contains(w.ownerDocument, w) || w.getRootNode(L) === w.ownerDocument;
    });
    var E = function(w, O) {
      return w = O || w, w.style.display === "none" || w.style.display === "" && // Otherwise, check computed style
      // Support: Firefox <=43 - 45
      // Disconnected elements can have computed display: none, so first confirm that elem is
      // in the document.
      S(w) && W.css(w, "display") === "none";
    };
    function A(w, O, J, re) {
      var ge, me, xe = 20, Ue = re ? function() {
        return re.cur();
      } : function() {
        return W.css(w, O, "");
      }, ze = Ue(), Ze = J && J[3] || (W.cssNumber[O] ? "" : "px"), At = w.nodeType && (W.cssNumber[O] || Ze !== "px" && +ze) && v.exec(W.css(w, O));
      if (At && At[3] !== Ze) {
        for (ze = ze / 2, Ze = Ze || At[3], At = +ze || 1; xe--; )
          W.style(w, O, At + Ze), (1 - me) * (1 - (me = Ue() / ze || 0.5)) <= 0 && (xe = 0), At = At / me;
        At = At * 2, W.style(w, O, At + Ze), J = J || [];
      }
      return J && (At = +At || +ze || 0, ge = J[1] ? At + (J[1] + 1) * J[2] : +J[2], re && (re.unit = Ze, re.start = At, re.end = ge)), ge;
    }
    var T = {};
    function G(w) {
      var O, J = w.ownerDocument, re = w.nodeName, ge = T[re];
      return ge || (O = J.body.appendChild(J.createElement(re)), ge = W.css(O, "display"), O.parentNode.removeChild(O), ge === "none" && (ge = "block"), T[re] = ge, ge);
    }
    function R(w, O) {
      for (var J, re, ge = [], me = 0, xe = w.length; me < xe; me++)
        re = w[me], re.style && (J = re.style.display, O ? (J === "none" && (ge[me] = He.get(re, "display") || null, ge[me] || (re.style.display = "")), re.style.display === "" && E(re) && (ge[me] = G(re))) : J !== "none" && (ge[me] = "none", He.set(re, "display", J)));
      for (me = 0; me < xe; me++)
        ge[me] != null && (w[me].style.display = ge[me]);
      return w;
    }
    W.fn.extend({
      show: function() {
        return R(this, !0);
      },
      hide: function() {
        return R(this);
      },
      toggle: function(w) {
        return typeof w == "boolean" ? w ? this.show() : this.hide() : this.each(function() {
          E(this) ? W(this).show() : W(this).hide();
        });
      }
    });
    var Y = /^(?:checkbox|radio)$/i, k = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i, z = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
      var w = D.createDocumentFragment(), O = w.appendChild(D.createElement("div")), J = D.createElement("input");
      J.setAttribute("type", "radio"), J.setAttribute("checked", "checked"), J.setAttribute("name", "t"), O.appendChild(J), Z.checkClone = O.cloneNode(!0).cloneNode(!0).lastChild.checked, O.innerHTML = "<textarea>x</textarea>", Z.noCloneChecked = !!O.cloneNode(!0).lastChild.defaultValue, O.innerHTML = "<option></option>", Z.option = !!O.lastChild;
    })();
    var C = {
      // XHTML parsers do not magically insert elements in the
      // same way that tag soup parsers do. So we cannot shorten
      // this by omitting <tbody> or other required elements.
      thead: [1, "<table>", "</table>"],
      col: [2, "<table><colgroup>", "</colgroup></table>"],
      tr: [2, "<table><tbody>", "</tbody></table>"],
      td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
      _default: [0, "", ""]
    };
    C.tbody = C.tfoot = C.colgroup = C.caption = C.thead, C.th = C.td, Z.option || (C.optgroup = C.option = [1, "<select multiple='multiple'>", "</select>"]);
    function I(w, O) {
      var J;
      return typeof w.getElementsByTagName < "u" ? J = w.getElementsByTagName(O || "*") : typeof w.querySelectorAll < "u" ? J = w.querySelectorAll(O || "*") : J = [], O === void 0 || O && ke(w, O) ? W.merge([w], J) : J;
    }
    function j(w, O) {
      for (var J = 0, re = w.length; J < re; J++)
        He.set(
          w[J],
          "globalEval",
          !O || He.get(O[J], "globalEval")
        );
    }
    var q = /<|&#?\w+;/;
    function H(w, O, J, re, ge) {
      for (var me, xe, Ue, ze, Ze, At, Bt = O.createDocumentFragment(), lt = [], Ft = 0, fi = w.length; Ft < fi; Ft++)
        if (me = w[Ft], me || me === 0)
          if (le(me) === "object")
            W.merge(lt, me.nodeType ? [me] : me);
          else if (!q.test(me))
            lt.push(O.createTextNode(me));
          else {
            for (xe = xe || Bt.appendChild(O.createElement("div")), Ue = (k.exec(me) || ["", ""])[1].toLowerCase(), ze = C[Ue] || C._default, xe.innerHTML = ze[1] + W.htmlPrefilter(me) + ze[2], At = ze[0]; At--; )
              xe = xe.lastChild;
            W.merge(lt, xe.childNodes), xe = Bt.firstChild, xe.textContent = "";
          }
      for (Bt.textContent = "", Ft = 0; me = lt[Ft++]; ) {
        if (re && W.inArray(me, re) > -1) {
          ge && ge.push(me);
          continue;
        }
        if (Ze = S(me), xe = I(Bt.appendChild(me), "script"), Ze && j(xe), J)
          for (At = 0; me = xe[At++]; )
            z.test(me.type || "") && J.push(me);
      }
      return Bt;
    }
    var ie = /^([^.]*)(?:\.(.+)|)/;
    function ae() {
      return !0;
    }
    function he() {
      return !1;
    }
    function pe(w, O, J, re, ge, me) {
      var xe, Ue;
      if (typeof O == "object") {
        typeof J != "string" && (re = re || J, J = void 0);
        for (Ue in O)
          pe(w, Ue, J, re, O[Ue], me);
        return w;
      }
      if (re == null && ge == null ? (ge = J, re = J = void 0) : ge == null && (typeof J == "string" ? (ge = re, re = void 0) : (ge = re, re = J, J = void 0)), ge === !1)
        ge = he;
      else if (!ge)
        return w;
      return me === 1 && (xe = ge, ge = function(ze) {
        return W().off(ze), xe.apply(this, arguments);
      }, ge.guid = xe.guid || (xe.guid = W.guid++)), w.each(function() {
        W.event.add(this, O, ge, re, J);
      });
    }
    W.event = {
      global: {},
      add: function(w, O, J, re, ge) {
        var me, xe, Ue, ze, Ze, At, Bt, lt, Ft, fi, si, di = He.get(w);
        if (bt(w))
          for (J.handler && (me = J, J = me.handler, ge = me.selector), ge && W.find.matchesSelector(y, ge), J.guid || (J.guid = W.guid++), (ze = di.events) || (ze = di.events = /* @__PURE__ */ Object.create(null)), (xe = di.handle) || (xe = di.handle = function(xn) {
            return typeof W < "u" && W.event.triggered !== xn.type ? W.event.dispatch.apply(w, arguments) : void 0;
          }), O = (O || "").match($t) || [""], Ze = O.length; Ze--; )
            Ue = ie.exec(O[Ze]) || [], Ft = si = Ue[1], fi = (Ue[2] || "").split(".").sort(), Ft && (Bt = W.event.special[Ft] || {}, Ft = (ge ? Bt.delegateType : Bt.bindType) || Ft, Bt = W.event.special[Ft] || {}, At = W.extend({
              type: Ft,
              origType: si,
              data: re,
              handler: J,
              guid: J.guid,
              selector: ge,
              needsContext: ge && W.expr.match.needsContext.test(ge),
              namespace: fi.join(".")
            }, me), (lt = ze[Ft]) || (lt = ze[Ft] = [], lt.delegateCount = 0, (!Bt.setup || Bt.setup.call(w, re, fi, xe) === !1) && w.addEventListener && w.addEventListener(Ft, xe)), Bt.add && (Bt.add.call(w, At), At.handler.guid || (At.handler.guid = J.guid)), ge ? lt.splice(lt.delegateCount++, 0, At) : lt.push(At), W.event.global[Ft] = !0);
      },
      // Detach an event or set of events from an element
      remove: function(w, O, J, re, ge) {
        var me, xe, Ue, ze, Ze, At, Bt, lt, Ft, fi, si, di = He.hasData(w) && He.get(w);
        if (!(!di || !(ze = di.events))) {
          for (O = (O || "").match($t) || [""], Ze = O.length; Ze--; ) {
            if (Ue = ie.exec(O[Ze]) || [], Ft = si = Ue[1], fi = (Ue[2] || "").split(".").sort(), !Ft) {
              for (Ft in ze)
                W.event.remove(w, Ft + O[Ze], J, re, !0);
              continue;
            }
            for (Bt = W.event.special[Ft] || {}, Ft = (re ? Bt.delegateType : Bt.bindType) || Ft, lt = ze[Ft] || [], Ue = Ue[2] && new RegExp("(^|\\.)" + fi.join("\\.(?:.*\\.|)") + "(\\.|$)"), xe = me = lt.length; me--; )
              At = lt[me], (ge || si === At.origType) && (!J || J.guid === At.guid) && (!Ue || Ue.test(At.namespace)) && (!re || re === At.selector || re === "**" && At.selector) && (lt.splice(me, 1), At.selector && lt.delegateCount--, Bt.remove && Bt.remove.call(w, At));
            xe && !lt.length && ((!Bt.teardown || Bt.teardown.call(w, fi, di.handle) === !1) && W.removeEvent(w, Ft, di.handle), delete ze[Ft]);
          }
          W.isEmptyObject(ze) && He.remove(w, "handle events");
        }
      },
      dispatch: function(w) {
        var O, J, re, ge, me, xe, Ue = new Array(arguments.length), ze = W.event.fix(w), Ze = (He.get(this, "events") || /* @__PURE__ */ Object.create(null))[ze.type] || [], At = W.event.special[ze.type] || {};
        for (Ue[0] = ze, O = 1; O < arguments.length; O++)
          Ue[O] = arguments[O];
        if (ze.delegateTarget = this, !(At.preDispatch && At.preDispatch.call(this, ze) === !1)) {
          for (xe = W.event.handlers.call(this, ze, Ze), O = 0; (ge = xe[O++]) && !ze.isPropagationStopped(); )
            for (ze.currentTarget = ge.elem, J = 0; (me = ge.handlers[J++]) && !ze.isImmediatePropagationStopped(); )
              (!ze.rnamespace || me.namespace === !1 || ze.rnamespace.test(me.namespace)) && (ze.handleObj = me, ze.data = me.data, re = ((W.event.special[me.origType] || {}).handle || me.handler).apply(ge.elem, Ue), re !== void 0 && (ze.result = re) === !1 && (ze.preventDefault(), ze.stopPropagation()));
          return At.postDispatch && At.postDispatch.call(this, ze), ze.result;
        }
      },
      handlers: function(w, O) {
        var J, re, ge, me, xe, Ue = [], ze = O.delegateCount, Ze = w.target;
        if (ze && // Support: IE <=9
        // Black-hole SVG <use> instance trees (trac-13180)
        Ze.nodeType && // Support: Firefox <=42
        // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
        // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
        // Support: IE 11 only
        // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
        !(w.type === "click" && w.button >= 1)) {
          for (; Ze !== this; Ze = Ze.parentNode || this)
            if (Ze.nodeType === 1 && !(w.type === "click" && Ze.disabled === !0)) {
              for (me = [], xe = {}, J = 0; J < ze; J++)
                re = O[J], ge = re.selector + " ", xe[ge] === void 0 && (xe[ge] = re.needsContext ? W(ge, this).index(Ze) > -1 : W.find(ge, this, null, [Ze]).length), xe[ge] && me.push(re);
              me.length && Ue.push({ elem: Ze, handlers: me });
            }
        }
        return Ze = this, ze < O.length && Ue.push({ elem: Ze, handlers: O.slice(ze) }), Ue;
      },
      addProp: function(w, O) {
        Object.defineProperty(W.Event.prototype, w, {
          enumerable: !0,
          configurable: !0,
          get: F(O) ? function() {
            if (this.originalEvent)
              return O(this.originalEvent);
          } : function() {
            if (this.originalEvent)
              return this.originalEvent[w];
          },
          set: function(J) {
            Object.defineProperty(this, w, {
              enumerable: !0,
              configurable: !0,
              writable: !0,
              value: J
            });
          }
        });
      },
      fix: function(w) {
        return w[W.expando] ? w : new W.Event(w);
      },
      special: {
        load: {
          // Prevent triggered image.load events from bubbling to window.load
          noBubble: !0
        },
        click: {
          // Utilize native event to ensure correct state for checkable inputs
          setup: function(w) {
            var O = this || w;
            return Y.test(O.type) && O.click && ke(O, "input") && se(O, "click", !0), !1;
          },
          trigger: function(w) {
            var O = this || w;
            return Y.test(O.type) && O.click && ke(O, "input") && se(O, "click"), !0;
          },
          // For cross-browser consistency, suppress native .click() on links
          // Also prevent it if we're currently inside a leveraged native-event stack
          _default: function(w) {
            var O = w.target;
            return Y.test(O.type) && O.click && ke(O, "input") && He.get(O, "click") || ke(O, "a");
          }
        },
        beforeunload: {
          postDispatch: function(w) {
            w.result !== void 0 && w.originalEvent && (w.originalEvent.returnValue = w.result);
          }
        }
      }
    };
    function se(w, O, J) {
      if (!J) {
        He.get(w, O) === void 0 && W.event.add(w, O, ae);
        return;
      }
      He.set(w, O, !1), W.event.add(w, O, {
        namespace: !1,
        handler: function(re) {
          var ge, me = He.get(this, O);
          if (re.isTrigger & 1 && this[O]) {
            if (me)
              (W.event.special[O] || {}).delegateType && re.stopPropagation();
            else if (me = o.call(arguments), He.set(this, O, me), this[O](), ge = He.get(this, O), He.set(this, O, !1), me !== ge)
              return re.stopImmediatePropagation(), re.preventDefault(), ge;
          } else
            me && (He.set(this, O, W.event.trigger(
              me[0],
              me.slice(1),
              this
            )), re.stopPropagation(), re.isImmediatePropagationStopped = ae);
        }
      });
    }
    W.removeEvent = function(w, O, J) {
      w.removeEventListener && w.removeEventListener(O, J);
    }, W.Event = function(w, O) {
      if (!(this instanceof W.Event))
        return new W.Event(w, O);
      w && w.type ? (this.originalEvent = w, this.type = w.type, this.isDefaultPrevented = w.defaultPrevented || w.defaultPrevented === void 0 && // Support: Android <=2.3 only
      w.returnValue === !1 ? ae : he, this.target = w.target && w.target.nodeType === 3 ? w.target.parentNode : w.target, this.currentTarget = w.currentTarget, this.relatedTarget = w.relatedTarget) : this.type = w, O && W.extend(this, O), this.timeStamp = w && w.timeStamp || Date.now(), this[W.expando] = !0;
    }, W.Event.prototype = {
      constructor: W.Event,
      isDefaultPrevented: he,
      isPropagationStopped: he,
      isImmediatePropagationStopped: he,
      isSimulated: !1,
      preventDefault: function() {
        var w = this.originalEvent;
        this.isDefaultPrevented = ae, w && !this.isSimulated && w.preventDefault();
      },
      stopPropagation: function() {
        var w = this.originalEvent;
        this.isPropagationStopped = ae, w && !this.isSimulated && w.stopPropagation();
      },
      stopImmediatePropagation: function() {
        var w = this.originalEvent;
        this.isImmediatePropagationStopped = ae, w && !this.isSimulated && w.stopImmediatePropagation(), this.stopPropagation();
      }
    }, W.each({
      altKey: !0,
      bubbles: !0,
      cancelable: !0,
      changedTouches: !0,
      ctrlKey: !0,
      detail: !0,
      eventPhase: !0,
      metaKey: !0,
      pageX: !0,
      pageY: !0,
      shiftKey: !0,
      view: !0,
      char: !0,
      code: !0,
      charCode: !0,
      key: !0,
      keyCode: !0,
      button: !0,
      buttons: !0,
      clientX: !0,
      clientY: !0,
      offsetX: !0,
      offsetY: !0,
      pointerId: !0,
      pointerType: !0,
      screenX: !0,
      screenY: !0,
      targetTouches: !0,
      toElement: !0,
      touches: !0,
      which: !0
    }, W.event.addProp), W.each({ focus: "focusin", blur: "focusout" }, function(w, O) {
      function J(re) {
        if (D.documentMode) {
          var ge = He.get(this, "handle"), me = W.event.fix(re);
          me.type = re.type === "focusin" ? "focus" : "blur", me.isSimulated = !0, ge(re), me.target === me.currentTarget && ge(me);
        } else
          W.event.simulate(
            O,
            re.target,
            W.event.fix(re)
          );
      }
      W.event.special[w] = {
        // Utilize native event if possible so blur/focus sequence is correct
        setup: function() {
          var re;
          if (se(this, w, !0), D.documentMode)
            re = He.get(this, O), re || this.addEventListener(O, J), He.set(this, O, (re || 0) + 1);
          else
            return !1;
        },
        trigger: function() {
          return se(this, w), !0;
        },
        teardown: function() {
          var re;
          if (D.documentMode)
            re = He.get(this, O) - 1, re ? He.set(this, O, re) : (this.removeEventListener(O, J), He.remove(this, O));
          else
            return !1;
        },
        // Suppress native focus or blur if we're currently inside
        // a leveraged native-event stack
        _default: function(re) {
          return He.get(re.target, w);
        },
        delegateType: O
      }, W.event.special[O] = {
        setup: function() {
          var re = this.ownerDocument || this.document || this, ge = D.documentMode ? this : re, me = He.get(ge, O);
          me || (D.documentMode ? this.addEventListener(O, J) : re.addEventListener(w, J, !0)), He.set(ge, O, (me || 0) + 1);
        },
        teardown: function() {
          var re = this.ownerDocument || this.document || this, ge = D.documentMode ? this : re, me = He.get(ge, O) - 1;
          me ? He.set(ge, O, me) : (D.documentMode ? this.removeEventListener(O, J) : re.removeEventListener(w, J, !0), He.remove(ge, O));
        }
      };
    }), W.each({
      mouseenter: "mouseover",
      mouseleave: "mouseout",
      pointerenter: "pointerover",
      pointerleave: "pointerout"
    }, function(w, O) {
      W.event.special[w] = {
        delegateType: O,
        bindType: O,
        handle: function(J) {
          var re, ge = this, me = J.relatedTarget, xe = J.handleObj;
          return (!me || me !== ge && !W.contains(ge, me)) && (J.type = xe.origType, re = xe.handler.apply(this, arguments), J.type = O), re;
        }
      };
    }), W.fn.extend({
      on: function(w, O, J, re) {
        return pe(this, w, O, J, re);
      },
      one: function(w, O, J, re) {
        return pe(this, w, O, J, re, 1);
      },
      off: function(w, O, J) {
        var re, ge;
        if (w && w.preventDefault && w.handleObj)
          return re = w.handleObj, W(w.delegateTarget).off(
            re.namespace ? re.origType + "." + re.namespace : re.origType,
            re.selector,
            re.handler
          ), this;
        if (typeof w == "object") {
          for (ge in w)
            this.off(ge, O, w[ge]);
          return this;
        }
        return (O === !1 || typeof O == "function") && (J = O, O = void 0), J === !1 && (J = he), this.each(function() {
          W.event.remove(this, w, J, O);
        });
      }
    });
    var de = /<script|<style|<link/i, ve = /checked\s*(?:[^=]|=\s*.checked.)/i, we = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    function Se(w, O) {
      return ke(w, "table") && ke(O.nodeType !== 11 ? O : O.firstChild, "tr") && W(w).children("tbody")[0] || w;
    }
    function Ae(w) {
      return w.type = (w.getAttribute("type") !== null) + "/" + w.type, w;
    }
    function Ge(w) {
      return (w.type || "").slice(0, 5) === "true/" ? w.type = w.type.slice(5) : w.removeAttribute("type"), w;
    }
    function Je(w, O) {
      var J, re, ge, me, xe, Ue, ze;
      if (O.nodeType === 1) {
        if (He.hasData(w) && (me = He.get(w), ze = me.events, ze)) {
          He.remove(O, "handle events");
          for (ge in ze)
            for (J = 0, re = ze[ge].length; J < re; J++)
              W.event.add(O, ge, ze[ge][J]);
        }
        i.hasData(w) && (xe = i.access(w), Ue = W.extend({}, xe), i.set(O, Ue));
      }
    }
    function it(w, O) {
      var J = O.nodeName.toLowerCase();
      J === "input" && Y.test(w.type) ? O.checked = w.checked : (J === "input" || J === "textarea") && (O.defaultValue = w.defaultValue);
    }
    function gt(w, O, J, re) {
      O = h(O);
      var ge, me, xe, Ue, ze, Ze, At = 0, Bt = w.length, lt = Bt - 1, Ft = O[0], fi = F(Ft);
      if (fi || Bt > 1 && typeof Ft == "string" && !Z.checkClone && ve.test(Ft))
        return w.each(function(si) {
          var di = w.eq(si);
          fi && (O[0] = Ft.call(this, si, di.html())), gt(di, O, J, re);
        });
      if (Bt && (ge = H(O, w[0].ownerDocument, !1, w, re), me = ge.firstChild, ge.childNodes.length === 1 && (ge = me), me || re)) {
        for (xe = W.map(I(ge, "script"), Ae), Ue = xe.length; At < Bt; At++)
          ze = ge, At !== lt && (ze = W.clone(ze, !0, !0), Ue && W.merge(xe, I(ze, "script"))), J.call(w[At], ze, At);
        if (Ue)
          for (Ze = xe[xe.length - 1].ownerDocument, W.map(xe, Ge), At = 0; At < Ue; At++)
            ze = xe[At], z.test(ze.type || "") && !He.access(ze, "globalEval") && W.contains(Ze, ze) && (ze.src && (ze.type || "").toLowerCase() !== "module" ? W._evalUrl && !ze.noModule && W._evalUrl(ze.src, {
              nonce: ze.nonce || ze.getAttribute("nonce")
            }, Ze) : ee(ze.textContent.replace(we, ""), ze, Ze));
      }
      return w;
    }
    function Ne(w, O, J) {
      for (var re, ge = O ? W.filter(O, w) : w, me = 0; (re = ge[me]) != null; me++)
        !J && re.nodeType === 1 && W.cleanData(I(re)), re.parentNode && (J && S(re) && j(I(re, "script")), re.parentNode.removeChild(re));
      return w;
    }
    W.extend({
      htmlPrefilter: function(w) {
        return w;
      },
      clone: function(w, O, J) {
        var re, ge, me, xe, Ue = w.cloneNode(!0), ze = S(w);
        if (!Z.noCloneChecked && (w.nodeType === 1 || w.nodeType === 11) && !W.isXMLDoc(w))
          for (xe = I(Ue), me = I(w), re = 0, ge = me.length; re < ge; re++)
            it(me[re], xe[re]);
        if (O)
          if (J)
            for (me = me || I(w), xe = xe || I(Ue), re = 0, ge = me.length; re < ge; re++)
              Je(me[re], xe[re]);
          else
            Je(w, Ue);
        return xe = I(Ue, "script"), xe.length > 0 && j(xe, !ze && I(w, "script")), Ue;
      },
      cleanData: function(w) {
        for (var O, J, re, ge = W.event.special, me = 0; (J = w[me]) !== void 0; me++)
          if (bt(J)) {
            if (O = J[He.expando]) {
              if (O.events)
                for (re in O.events)
                  ge[re] ? W.event.remove(J, re) : W.removeEvent(J, re, O.handle);
              J[He.expando] = void 0;
            }
            J[i.expando] && (J[i.expando] = void 0);
          }
      }
    }), W.fn.extend({
      detach: function(w) {
        return Ne(this, w, !0);
      },
      remove: function(w) {
        return Ne(this, w);
      },
      text: function(w) {
        return Ee(this, function(O) {
          return O === void 0 ? W.text(this) : this.empty().each(function() {
            (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) && (this.textContent = O);
          });
        }, null, w, arguments.length);
      },
      append: function() {
        return gt(this, arguments, function(w) {
          if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
            var O = Se(this, w);
            O.appendChild(w);
          }
        });
      },
      prepend: function() {
        return gt(this, arguments, function(w) {
          if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
            var O = Se(this, w);
            O.insertBefore(w, O.firstChild);
          }
        });
      },
      before: function() {
        return gt(this, arguments, function(w) {
          this.parentNode && this.parentNode.insertBefore(w, this);
        });
      },
      after: function() {
        return gt(this, arguments, function(w) {
          this.parentNode && this.parentNode.insertBefore(w, this.nextSibling);
        });
      },
      empty: function() {
        for (var w, O = 0; (w = this[O]) != null; O++)
          w.nodeType === 1 && (W.cleanData(I(w, !1)), w.textContent = "");
        return this;
      },
      clone: function(w, O) {
        return w = w ?? !1, O = O ?? w, this.map(function() {
          return W.clone(this, w, O);
        });
      },
      html: function(w) {
        return Ee(this, function(O) {
          var J = this[0] || {}, re = 0, ge = this.length;
          if (O === void 0 && J.nodeType === 1)
            return J.innerHTML;
          if (typeof O == "string" && !de.test(O) && !C[(k.exec(O) || ["", ""])[1].toLowerCase()]) {
            O = W.htmlPrefilter(O);
            try {
              for (; re < ge; re++)
                J = this[re] || {}, J.nodeType === 1 && (W.cleanData(I(J, !1)), J.innerHTML = O);
              J = 0;
            } catch {
            }
          }
          J && this.empty().append(O);
        }, null, w, arguments.length);
      },
      replaceWith: function() {
        var w = [];
        return gt(this, arguments, function(O) {
          var J = this.parentNode;
          W.inArray(this, w) < 0 && (W.cleanData(I(this)), J && J.replaceChild(O, this));
        }, w);
      }
    }), W.each({
      appendTo: "append",
      prependTo: "prepend",
      insertBefore: "before",
      insertAfter: "after",
      replaceAll: "replaceWith"
    }, function(w, O) {
      W.fn[w] = function(J) {
        for (var re, ge = [], me = W(J), xe = me.length - 1, Ue = 0; Ue <= xe; Ue++)
          re = Ue === xe ? this : this.clone(!0), W(me[Ue])[O](re), c.apply(ge, re.get());
        return this.pushStack(ge);
      };
    });
    var Fe = new RegExp("^(" + d + ")(?!px)[a-z%]+$", "i"), st = /^--/, _t = function(w) {
      var O = w.ownerDocument.defaultView;
      return (!O || !O.opener) && (O = e), O.getComputedStyle(w);
    }, vt = function(w, O, J) {
      var re, ge, me = {};
      for (ge in O)
        me[ge] = w.style[ge], w.style[ge] = O[ge];
      re = J.call(w);
      for (ge in O)
        w.style[ge] = me[ge];
      return re;
    }, Rt = new RegExp(p.join("|"), "i");
    (function() {
      function w() {
        if (Ze) {
          ze.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0", Ze.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%", y.appendChild(ze).appendChild(Ze);
          var At = e.getComputedStyle(Ze);
          J = At.top !== "1%", Ue = O(At.marginLeft) === 12, Ze.style.right = "60%", me = O(At.right) === 36, re = O(At.width) === 36, Ze.style.position = "absolute", ge = O(Ze.offsetWidth / 3) === 12, y.removeChild(ze), Ze = null;
        }
      }
      function O(At) {
        return Math.round(parseFloat(At));
      }
      var J, re, ge, me, xe, Ue, ze = D.createElement("div"), Ze = D.createElement("div");
      Ze.style && (Ze.style.backgroundClip = "content-box", Ze.cloneNode(!0).style.backgroundClip = "", Z.clearCloneStyle = Ze.style.backgroundClip === "content-box", W.extend(Z, {
        boxSizingReliable: function() {
          return w(), re;
        },
        pixelBoxStyles: function() {
          return w(), me;
        },
        pixelPosition: function() {
          return w(), J;
        },
        reliableMarginLeft: function() {
          return w(), Ue;
        },
        scrollboxSize: function() {
          return w(), ge;
        },
        // Support: IE 9 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Behavior in IE 9 is more subtle than in newer versions & it passes
        // some versions of this test; make sure not to make it pass there!
        //
        // Support: Firefox 70+
        // Only Firefox includes border widths
        // in computed dimensions. (gh-4529)
        reliableTrDimensions: function() {
          var At, Bt, lt, Ft;
          return xe == null && (At = D.createElement("table"), Bt = D.createElement("tr"), lt = D.createElement("div"), At.style.cssText = "position:absolute;left:-11111px;border-collapse:separate", Bt.style.cssText = "box-sizing:content-box;border:1px solid", Bt.style.height = "1px", lt.style.height = "9px", lt.style.display = "block", y.appendChild(At).appendChild(Bt).appendChild(lt), Ft = e.getComputedStyle(Bt), xe = parseInt(Ft.height, 10) + parseInt(Ft.borderTopWidth, 10) + parseInt(Ft.borderBottomWidth, 10) === Bt.offsetHeight, y.removeChild(At)), xe;
        }
      }));
    })();
    function Et(w, O, J) {
      var re, ge, me, xe, Ue = st.test(O), ze = w.style;
      return J = J || _t(w), J && (xe = J.getPropertyValue(O) || J[O], Ue && xe && (xe = xe.replace(ce, "$1") || void 0), xe === "" && !S(w) && (xe = W.style(w, O)), !Z.pixelBoxStyles() && Fe.test(xe) && Rt.test(O) && (re = ze.width, ge = ze.minWidth, me = ze.maxWidth, ze.minWidth = ze.maxWidth = ze.width = xe, xe = J.width, ze.width = re, ze.minWidth = ge, ze.maxWidth = me)), xe !== void 0 ? (
        // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        xe + ""
      ) : xe;
    }
    function Ht(w, O) {
      return {
        get: function() {
          if (w()) {
            delete this.get;
            return;
          }
          return (this.get = O).apply(this, arguments);
        }
      };
    }
    var jt = ["Webkit", "Moz", "ms"], Vt = D.createElement("div").style, Mi = {};
    function Li(w) {
      for (var O = w[0].toUpperCase() + w.slice(1), J = jt.length; J--; )
        if (w = jt[J] + O, w in Vt)
          return w;
    }
    function Ai(w) {
      var O = W.cssProps[w] || Mi[w];
      return O || (w in Vt ? w : Mi[w] = Li(w) || w);
    }
    var vi = /^(none|table(?!-c[ea]).+)/, ri = { position: "absolute", visibility: "hidden", display: "block" }, Nt = {
      letterSpacing: "0",
      fontWeight: "400"
    };
    function Di(w, O, J) {
      var re = v.exec(O);
      return re ? (
        // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, re[2] - (J || 0)) + (re[3] || "px")
      ) : O;
    }
    function li(w, O, J, re, ge, me) {
      var xe = O === "width" ? 1 : 0, Ue = 0, ze = 0, Ze = 0;
      if (J === (re ? "border" : "content"))
        return 0;
      for (; xe < 4; xe += 2)
        J === "margin" && (Ze += W.css(w, J + p[xe], !0, ge)), re ? (J === "content" && (ze -= W.css(w, "padding" + p[xe], !0, ge)), J !== "margin" && (ze -= W.css(w, "border" + p[xe] + "Width", !0, ge))) : (ze += W.css(w, "padding" + p[xe], !0, ge), J !== "padding" ? ze += W.css(w, "border" + p[xe] + "Width", !0, ge) : Ue += W.css(w, "border" + p[xe] + "Width", !0, ge));
      return !re && me >= 0 && (ze += Math.max(0, Math.ceil(
        w["offset" + O[0].toUpperCase() + O.slice(1)] - me - ze - Ue - 0.5
        // If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
        // Use an explicit zero to avoid NaN (gh-3964)
      )) || 0), ze + Ze;
    }
    function nn(w, O, J) {
      var re = _t(w), ge = !Z.boxSizingReliable() || J, me = ge && W.css(w, "boxSizing", !1, re) === "border-box", xe = me, Ue = Et(w, O, re), ze = "offset" + O[0].toUpperCase() + O.slice(1);
      if (Fe.test(Ue)) {
        if (!J)
          return Ue;
        Ue = "auto";
      }
      return (!Z.boxSizingReliable() && me || // Support: IE 10 - 11+, Edge 15 - 18+
      // IE/Edge misreport `getComputedStyle` of table rows with width/height
      // set in CSS while `offset*` properties report correct values.
      // Interestingly, in some cases IE 9 doesn't suffer from this issue.
      !Z.reliableTrDimensions() && ke(w, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
      // This happens for inline elements with no explicit setting (gh-3571)
      Ue === "auto" || // Support: Android <=4.1 - 4.3 only
      // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
      !parseFloat(Ue) && W.css(w, "display", !1, re) === "inline") && // Make sure the element is visible & connected
      w.getClientRects().length && (me = W.css(w, "boxSizing", !1, re) === "border-box", xe = ze in w, xe && (Ue = w[ze])), Ue = parseFloat(Ue) || 0, Ue + li(
        w,
        O,
        J || (me ? "border" : "content"),
        xe,
        re,
        // Provide the current computed size to request scroll gutter calculation (gh-3589)
        Ue
      ) + "px";
    }
    W.extend({
      // Add in style property hooks for overriding the default
      // behavior of getting and setting a style property
      cssHooks: {
        opacity: {
          get: function(w, O) {
            if (O) {
              var J = Et(w, "opacity");
              return J === "" ? "1" : J;
            }
          }
        }
      },
      // Don't automatically add "px" to these possibly-unitless properties
      cssNumber: {
        animationIterationCount: !0,
        aspectRatio: !0,
        borderImageSlice: !0,
        columnCount: !0,
        flexGrow: !0,
        flexShrink: !0,
        fontWeight: !0,
        gridArea: !0,
        gridColumn: !0,
        gridColumnEnd: !0,
        gridColumnStart: !0,
        gridRow: !0,
        gridRowEnd: !0,
        gridRowStart: !0,
        lineHeight: !0,
        opacity: !0,
        order: !0,
        orphans: !0,
        scale: !0,
        widows: !0,
        zIndex: !0,
        zoom: !0,
        // SVG-related
        fillOpacity: !0,
        floodOpacity: !0,
        stopOpacity: !0,
        strokeMiterlimit: !0,
        strokeOpacity: !0
      },
      // Add in properties whose names you wish to fix before
      // setting or getting the value
      cssProps: {},
      // Get and set the style property on a DOM Node
      style: function(w, O, J, re) {
        if (!(!w || w.nodeType === 3 || w.nodeType === 8 || !w.style)) {
          var ge, me, xe, Ue = Qe(O), ze = st.test(O), Ze = w.style;
          if (ze || (O = Ai(Ue)), xe = W.cssHooks[O] || W.cssHooks[Ue], J !== void 0) {
            if (me = typeof J, me === "string" && (ge = v.exec(J)) && ge[1] && (J = A(w, O, ge), me = "number"), J == null || J !== J)
              return;
            me === "number" && !ze && (J += ge && ge[3] || (W.cssNumber[Ue] ? "" : "px")), !Z.clearCloneStyle && J === "" && O.indexOf("background") === 0 && (Ze[O] = "inherit"), (!xe || !("set" in xe) || (J = xe.set(w, J, re)) !== void 0) && (ze ? Ze.setProperty(O, J) : Ze[O] = J);
          } else
            return xe && "get" in xe && (ge = xe.get(w, !1, re)) !== void 0 ? ge : Ze[O];
        }
      },
      css: function(w, O, J, re) {
        var ge, me, xe, Ue = Qe(O), ze = st.test(O);
        return ze || (O = Ai(Ue)), xe = W.cssHooks[O] || W.cssHooks[Ue], xe && "get" in xe && (ge = xe.get(w, !0, J)), ge === void 0 && (ge = Et(w, O, re)), ge === "normal" && O in Nt && (ge = Nt[O]), J === "" || J ? (me = parseFloat(ge), J === !0 || isFinite(me) ? me || 0 : ge) : ge;
      }
    }), W.each(["height", "width"], function(w, O) {
      W.cssHooks[O] = {
        get: function(J, re, ge) {
          if (re)
            return vi.test(W.css(J, "display")) && // Support: Safari 8+
            // Table columns in Safari have non-zero offsetWidth & zero
            // getBoundingClientRect().width unless display is changed.
            // Support: IE <=11 only
            // Running getBoundingClientRect on a disconnected node
            // in IE throws an error.
            (!J.getClientRects().length || !J.getBoundingClientRect().width) ? vt(J, ri, function() {
              return nn(J, O, ge);
            }) : nn(J, O, ge);
        },
        set: function(J, re, ge) {
          var me, xe = _t(J), Ue = !Z.scrollboxSize() && xe.position === "absolute", ze = Ue || ge, Ze = ze && W.css(J, "boxSizing", !1, xe) === "border-box", At = ge ? li(
            J,
            O,
            ge,
            Ze,
            xe
          ) : 0;
          return Ze && Ue && (At -= Math.ceil(
            J["offset" + O[0].toUpperCase() + O.slice(1)] - parseFloat(xe[O]) - li(J, O, "border", !1, xe) - 0.5
          )), At && (me = v.exec(re)) && (me[3] || "px") !== "px" && (J.style[O] = re, re = W.css(J, O)), Di(J, re, At);
        }
      };
    }), W.cssHooks.marginLeft = Ht(
      Z.reliableMarginLeft,
      function(w, O) {
        if (O)
          return (parseFloat(Et(w, "marginLeft")) || w.getBoundingClientRect().left - vt(w, { marginLeft: 0 }, function() {
            return w.getBoundingClientRect().left;
          })) + "px";
      }
    ), W.each({
      margin: "",
      padding: "",
      border: "Width"
    }, function(w, O) {
      W.cssHooks[w + O] = {
        expand: function(J) {
          for (var re = 0, ge = {}, me = typeof J == "string" ? J.split(" ") : [J]; re < 4; re++)
            ge[w + p[re] + O] = me[re] || me[re - 2] || me[0];
          return ge;
        }
      }, w !== "margin" && (W.cssHooks[w + O].set = Di);
    }), W.fn.extend({
      css: function(w, O) {
        return Ee(this, function(J, re, ge) {
          var me, xe, Ue = {}, ze = 0;
          if (Array.isArray(re)) {
            for (me = _t(J), xe = re.length; ze < xe; ze++)
              Ue[re[ze]] = W.css(J, re[ze], !1, me);
            return Ue;
          }
          return ge !== void 0 ? W.style(J, re, ge) : W.css(J, re);
        }, w, O, arguments.length > 1);
      }
    });
    function Vi(w, O, J, re, ge) {
      return new Vi.prototype.init(w, O, J, re, ge);
    }
    W.Tween = Vi, Vi.prototype = {
      constructor: Vi,
      init: function(w, O, J, re, ge, me) {
        this.elem = w, this.prop = J, this.easing = ge || W.easing._default, this.options = O, this.start = this.now = this.cur(), this.end = re, this.unit = me || (W.cssNumber[J] ? "" : "px");
      },
      cur: function() {
        var w = Vi.propHooks[this.prop];
        return w && w.get ? w.get(this) : Vi.propHooks._default.get(this);
      },
      run: function(w) {
        var O, J = Vi.propHooks[this.prop];
        return this.options.duration ? this.pos = O = W.easing[this.easing](
          w,
          this.options.duration * w,
          0,
          1,
          this.options.duration
        ) : this.pos = O = w, this.now = (this.end - this.start) * O + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), J && J.set ? J.set(this) : Vi.propHooks._default.set(this), this;
      }
    }, Vi.prototype.init.prototype = Vi.prototype, Vi.propHooks = {
      _default: {
        get: function(w) {
          var O;
          return w.elem.nodeType !== 1 || w.elem[w.prop] != null && w.elem.style[w.prop] == null ? w.elem[w.prop] : (O = W.css(w.elem, w.prop, ""), !O || O === "auto" ? 0 : O);
        },
        set: function(w) {
          W.fx.step[w.prop] ? W.fx.step[w.prop](w) : w.elem.nodeType === 1 && (W.cssHooks[w.prop] || w.elem.style[Ai(w.prop)] != null) ? W.style(w.elem, w.prop, w.now + w.unit) : w.elem[w.prop] = w.now;
        }
      }
    }, Vi.propHooks.scrollTop = Vi.propHooks.scrollLeft = {
      set: function(w) {
        w.elem.nodeType && w.elem.parentNode && (w.elem[w.prop] = w.now);
      }
    }, W.easing = {
      linear: function(w) {
        return w;
      },
      swing: function(w) {
        return 0.5 - Math.cos(w * Math.PI) / 2;
      },
      _default: "swing"
    }, W.fx = Vi.prototype.init, W.fx.step = {};
    var Wi, Ji, Hi = /^(?:toggle|show|hide)$/, $i = /queueHooks$/;
    function _n() {
      Ji && (D.hidden === !1 && e.requestAnimationFrame ? e.requestAnimationFrame(_n) : e.setTimeout(_n, W.fx.interval), W.fx.tick());
    }
    function Xi() {
      return e.setTimeout(function() {
        Wi = void 0;
      }), Wi = Date.now();
    }
    function cn(w, O) {
      var J, re = 0, ge = { height: w };
      for (O = O ? 1 : 0; re < 4; re += 2 - O)
        J = p[re], ge["margin" + J] = ge["padding" + J] = w;
      return O && (ge.opacity = ge.width = w), ge;
    }
    function Cn(w, O, J) {
      for (var re, ge = (An.tweeners[O] || []).concat(An.tweeners["*"]), me = 0, xe = ge.length; me < xe; me++)
        if (re = ge[me].call(J, O, w))
          return re;
    }
    function Zr(w, O, J) {
      var re, ge, me, xe, Ue, ze, Ze, At, Bt = "width" in O || "height" in O, lt = this, Ft = {}, fi = w.style, si = w.nodeType && E(w), di = He.get(w, "fxshow");
      J.queue || (xe = W._queueHooks(w, "fx"), xe.unqueued == null && (xe.unqueued = 0, Ue = xe.empty.fire, xe.empty.fire = function() {
        xe.unqueued || Ue();
      }), xe.unqueued++, lt.always(function() {
        lt.always(function() {
          xe.unqueued--, W.queue(w, "fx").length || xe.empty.fire();
        });
      }));
      for (re in O)
        if (ge = O[re], Hi.test(ge)) {
          if (delete O[re], me = me || ge === "toggle", ge === (si ? "hide" : "show"))
            if (ge === "show" && di && di[re] !== void 0)
              si = !0;
            else
              continue;
          Ft[re] = di && di[re] || W.style(w, re);
        }
      if (ze = !W.isEmptyObject(O), !(!ze && W.isEmptyObject(Ft))) {
        Bt && w.nodeType === 1 && (J.overflow = [fi.overflow, fi.overflowX, fi.overflowY], Ze = di && di.display, Ze == null && (Ze = He.get(w, "display")), At = W.css(w, "display"), At === "none" && (Ze ? At = Ze : (R([w], !0), Ze = w.style.display || Ze, At = W.css(w, "display"), R([w]))), (At === "inline" || At === "inline-block" && Ze != null) && W.css(w, "float") === "none" && (ze || (lt.done(function() {
          fi.display = Ze;
        }), Ze == null && (At = fi.display, Ze = At === "none" ? "" : At)), fi.display = "inline-block")), J.overflow && (fi.overflow = "hidden", lt.always(function() {
          fi.overflow = J.overflow[0], fi.overflowX = J.overflow[1], fi.overflowY = J.overflow[2];
        })), ze = !1;
        for (re in Ft)
          ze || (di ? "hidden" in di && (si = di.hidden) : di = He.access(w, "fxshow", { display: Ze }), me && (di.hidden = !si), si && R([w], !0), lt.done(function() {
            si || R([w]), He.remove(w, "fxshow");
            for (re in Ft)
              W.style(w, re, Ft[re]);
          })), ze = Cn(si ? di[re] : 0, re, lt), re in di || (di[re] = ze.start, si && (ze.end = ze.start, ze.start = 0));
      }
    }
    function Pr(w, O) {
      var J, re, ge, me, xe;
      for (J in w)
        if (re = Qe(J), ge = O[re], me = w[J], Array.isArray(me) && (ge = me[1], me = w[J] = me[0]), J !== re && (w[re] = me, delete w[J]), xe = W.cssHooks[re], xe && "expand" in xe) {
          me = xe.expand(me), delete w[re];
          for (J in me)
            J in w || (w[J] = me[J], O[J] = ge);
        } else
          O[re] = ge;
    }
    function An(w, O, J) {
      var re, ge, me = 0, xe = An.prefilters.length, Ue = W.Deferred().always(function() {
        delete ze.elem;
      }), ze = function() {
        if (ge)
          return !1;
        for (var Bt = Wi || Xi(), lt = Math.max(0, Ze.startTime + Ze.duration - Bt), Ft = lt / Ze.duration || 0, fi = 1 - Ft, si = 0, di = Ze.tweens.length; si < di; si++)
          Ze.tweens[si].run(fi);
        return Ue.notifyWith(w, [Ze, fi, lt]), fi < 1 && di ? lt : (di || Ue.notifyWith(w, [Ze, 1, 0]), Ue.resolveWith(w, [Ze]), !1);
      }, Ze = Ue.promise({
        elem: w,
        props: W.extend({}, O),
        opts: W.extend(!0, {
          specialEasing: {},
          easing: W.easing._default
        }, J),
        originalProperties: O,
        originalOptions: J,
        startTime: Wi || Xi(),
        duration: J.duration,
        tweens: [],
        createTween: function(Bt, lt) {
          var Ft = W.Tween(
            w,
            Ze.opts,
            Bt,
            lt,
            Ze.opts.specialEasing[Bt] || Ze.opts.easing
          );
          return Ze.tweens.push(Ft), Ft;
        },
        stop: function(Bt) {
          var lt = 0, Ft = Bt ? Ze.tweens.length : 0;
          if (ge)
            return this;
          for (ge = !0; lt < Ft; lt++)
            Ze.tweens[lt].run(1);
          return Bt ? (Ue.notifyWith(w, [Ze, 1, 0]), Ue.resolveWith(w, [Ze, Bt])) : Ue.rejectWith(w, [Ze, Bt]), this;
        }
      }), At = Ze.props;
      for (Pr(At, Ze.opts.specialEasing); me < xe; me++)
        if (re = An.prefilters[me].call(Ze, w, At, Ze.opts), re)
          return F(re.stop) && (W._queueHooks(Ze.elem, Ze.opts.queue).stop = re.stop.bind(re)), re;
      return W.map(At, Cn, Ze), F(Ze.opts.start) && Ze.opts.start.call(w, Ze), Ze.progress(Ze.opts.progress).done(Ze.opts.done, Ze.opts.complete).fail(Ze.opts.fail).always(Ze.opts.always), W.fx.timer(
        W.extend(ze, {
          elem: w,
          anim: Ze,
          queue: Ze.opts.queue
        })
      ), Ze;
    }
    W.Animation = W.extend(An, {
      tweeners: {
        "*": [function(w, O) {
          var J = this.createTween(w, O);
          return A(J.elem, w, v.exec(O), J), J;
        }]
      },
      tweener: function(w, O) {
        F(w) ? (O = w, w = ["*"]) : w = w.match($t);
        for (var J, re = 0, ge = w.length; re < ge; re++)
          J = w[re], An.tweeners[J] = An.tweeners[J] || [], An.tweeners[J].unshift(O);
      },
      prefilters: [Zr],
      prefilter: function(w, O) {
        O ? An.prefilters.unshift(w) : An.prefilters.push(w);
      }
    }), W.speed = function(w, O, J) {
      var re = w && typeof w == "object" ? W.extend({}, w) : {
        complete: J || !J && O || F(w) && w,
        duration: w,
        easing: J && O || O && !F(O) && O
      };
      return W.fx.off ? re.duration = 0 : typeof re.duration != "number" && (re.duration in W.fx.speeds ? re.duration = W.fx.speeds[re.duration] : re.duration = W.fx.speeds._default), (re.queue == null || re.queue === !0) && (re.queue = "fx"), re.old = re.complete, re.complete = function() {
        F(re.old) && re.old.call(this), re.queue && W.dequeue(this, re.queue);
      }, re;
    }, W.fn.extend({
      fadeTo: function(w, O, J, re) {
        return this.filter(E).css("opacity", 0).show().end().animate({ opacity: O }, w, J, re);
      },
      animate: function(w, O, J, re) {
        var ge = W.isEmptyObject(w), me = W.speed(O, J, re), xe = function() {
          var Ue = An(this, W.extend({}, w), me);
          (ge || He.get(this, "finish")) && Ue.stop(!0);
        };
        return xe.finish = xe, ge || me.queue === !1 ? this.each(xe) : this.queue(me.queue, xe);
      },
      stop: function(w, O, J) {
        var re = function(ge) {
          var me = ge.stop;
          delete ge.stop, me(J);
        };
        return typeof w != "string" && (J = O, O = w, w = void 0), O && this.queue(w || "fx", []), this.each(function() {
          var ge = !0, me = w != null && w + "queueHooks", xe = W.timers, Ue = He.get(this);
          if (me)
            Ue[me] && Ue[me].stop && re(Ue[me]);
          else
            for (me in Ue)
              Ue[me] && Ue[me].stop && $i.test(me) && re(Ue[me]);
          for (me = xe.length; me--; )
            xe[me].elem === this && (w == null || xe[me].queue === w) && (xe[me].anim.stop(J), ge = !1, xe.splice(me, 1));
          (ge || !J) && W.dequeue(this, w);
        });
      },
      finish: function(w) {
        return w !== !1 && (w = w || "fx"), this.each(function() {
          var O, J = He.get(this), re = J[w + "queue"], ge = J[w + "queueHooks"], me = W.timers, xe = re ? re.length : 0;
          for (J.finish = !0, W.queue(this, w, []), ge && ge.stop && ge.stop.call(this, !0), O = me.length; O--; )
            me[O].elem === this && me[O].queue === w && (me[O].anim.stop(!0), me.splice(O, 1));
          for (O = 0; O < xe; O++)
            re[O] && re[O].finish && re[O].finish.call(this);
          delete J.finish;
        });
      }
    }), W.each(["toggle", "show", "hide"], function(w, O) {
      var J = W.fn[O];
      W.fn[O] = function(re, ge, me) {
        return re == null || typeof re == "boolean" ? J.apply(this, arguments) : this.animate(cn(O, !0), re, ge, me);
      };
    }), W.each({
      slideDown: cn("show"),
      slideUp: cn("hide"),
      slideToggle: cn("toggle"),
      fadeIn: { opacity: "show" },
      fadeOut: { opacity: "hide" },
      fadeToggle: { opacity: "toggle" }
    }, function(w, O) {
      W.fn[w] = function(J, re, ge) {
        return this.animate(O, J, re, ge);
      };
    }), W.timers = [], W.fx.tick = function() {
      var w, O = 0, J = W.timers;
      for (Wi = Date.now(); O < J.length; O++)
        w = J[O], !w() && J[O] === w && J.splice(O--, 1);
      J.length || W.fx.stop(), Wi = void 0;
    }, W.fx.timer = function(w) {
      W.timers.push(w), W.fx.start();
    }, W.fx.interval = 13, W.fx.start = function() {
      Ji || (Ji = !0, _n());
    }, W.fx.stop = function() {
      Ji = null;
    }, W.fx.speeds = {
      slow: 600,
      fast: 200,
      // Default speed
      _default: 400
    }, W.fn.delay = function(w, O) {
      return w = W.fx && W.fx.speeds[w] || w, O = O || "fx", this.queue(O, function(J, re) {
        var ge = e.setTimeout(J, w);
        re.stop = function() {
          e.clearTimeout(ge);
        };
      });
    }, function() {
      var w = D.createElement("input"), O = D.createElement("select"), J = O.appendChild(D.createElement("option"));
      w.type = "checkbox", Z.checkOn = w.value !== "", Z.optSelected = J.selected, w = D.createElement("input"), w.value = "t", w.type = "radio", Z.radioValue = w.value === "t";
    }();
    var qr, Vn = W.expr.attrHandle;
    W.fn.extend({
      attr: function(w, O) {
        return Ee(this, W.attr, w, O, arguments.length > 1);
      },
      removeAttr: function(w) {
        return this.each(function() {
          W.removeAttr(this, w);
        });
      }
    }), W.extend({
      attr: function(w, O, J) {
        var re, ge, me = w.nodeType;
        if (!(me === 3 || me === 8 || me === 2)) {
          if (typeof w.getAttribute > "u")
            return W.prop(w, O, J);
          if ((me !== 1 || !W.isXMLDoc(w)) && (ge = W.attrHooks[O.toLowerCase()] || (W.expr.match.bool.test(O) ? qr : void 0)), J !== void 0) {
            if (J === null) {
              W.removeAttr(w, O);
              return;
            }
            return ge && "set" in ge && (re = ge.set(w, J, O)) !== void 0 ? re : (w.setAttribute(O, J + ""), J);
          }
          return ge && "get" in ge && (re = ge.get(w, O)) !== null ? re : (re = W.find.attr(w, O), re ?? void 0);
        }
      },
      attrHooks: {
        type: {
          set: function(w, O) {
            if (!Z.radioValue && O === "radio" && ke(w, "input")) {
              var J = w.value;
              return w.setAttribute("type", O), J && (w.value = J), O;
            }
          }
        }
      },
      removeAttr: function(w, O) {
        var J, re = 0, ge = O && O.match($t);
        if (ge && w.nodeType === 1)
          for (; J = ge[re++]; )
            w.removeAttribute(J);
      }
    }), qr = {
      set: function(w, O, J) {
        return O === !1 ? W.removeAttr(w, J) : w.setAttribute(J, J), J;
      }
    }, W.each(W.expr.match.bool.source.match(/\w+/g), function(w, O) {
      var J = Vn[O] || W.find.attr;
      Vn[O] = function(re, ge, me) {
        var xe, Ue, ze = ge.toLowerCase();
        return me || (Ue = Vn[ze], Vn[ze] = xe, xe = J(re, ge, me) != null ? ze : null, Vn[ze] = Ue), xe;
      };
    });
    var dr = /^(?:input|select|textarea|button)$/i, Hn = /^(?:a|area)$/i;
    W.fn.extend({
      prop: function(w, O) {
        return Ee(this, W.prop, w, O, arguments.length > 1);
      },
      removeProp: function(w) {
        return this.each(function() {
          delete this[W.propFix[w] || w];
        });
      }
    }), W.extend({
      prop: function(w, O, J) {
        var re, ge, me = w.nodeType;
        if (!(me === 3 || me === 8 || me === 2))
          return (me !== 1 || !W.isXMLDoc(w)) && (O = W.propFix[O] || O, ge = W.propHooks[O]), J !== void 0 ? ge && "set" in ge && (re = ge.set(w, J, O)) !== void 0 ? re : w[O] = J : ge && "get" in ge && (re = ge.get(w, O)) !== null ? re : w[O];
      },
      propHooks: {
        tabIndex: {
          get: function(w) {
            var O = W.find.attr(w, "tabindex");
            return O ? parseInt(O, 10) : dr.test(w.nodeName) || Hn.test(w.nodeName) && w.href ? 0 : -1;
          }
        }
      },
      propFix: {
        for: "htmlFor",
        class: "className"
      }
    }), Z.optSelected || (W.propHooks.selected = {
      get: function(w) {
        var O = w.parentNode;
        return O && O.parentNode && O.parentNode.selectedIndex, null;
      },
      set: function(w) {
        var O = w.parentNode;
        O && (O.selectedIndex, O.parentNode && O.parentNode.selectedIndex);
      }
    }), W.each([
      "tabIndex",
      "readOnly",
      "maxLength",
      "cellSpacing",
      "cellPadding",
      "rowSpan",
      "colSpan",
      "useMap",
      "frameBorder",
      "contentEditable"
    ], function() {
      W.propFix[this.toLowerCase()] = this;
    });
    function fn(w) {
      var O = w.match($t) || [];
      return O.join(" ");
    }
    function dn(w) {
      return w.getAttribute && w.getAttribute("class") || "";
    }
    function bn(w) {
      return Array.isArray(w) ? w : typeof w == "string" ? w.match($t) || [] : [];
    }
    W.fn.extend({
      addClass: function(w) {
        var O, J, re, ge, me, xe;
        return F(w) ? this.each(function(Ue) {
          W(this).addClass(w.call(this, Ue, dn(this)));
        }) : (O = bn(w), O.length ? this.each(function() {
          if (re = dn(this), J = this.nodeType === 1 && " " + fn(re) + " ", J) {
            for (me = 0; me < O.length; me++)
              ge = O[me], J.indexOf(" " + ge + " ") < 0 && (J += ge + " ");
            xe = fn(J), re !== xe && this.setAttribute("class", xe);
          }
        }) : this);
      },
      removeClass: function(w) {
        var O, J, re, ge, me, xe;
        return F(w) ? this.each(function(Ue) {
          W(this).removeClass(w.call(this, Ue, dn(this)));
        }) : arguments.length ? (O = bn(w), O.length ? this.each(function() {
          if (re = dn(this), J = this.nodeType === 1 && " " + fn(re) + " ", J) {
            for (me = 0; me < O.length; me++)
              for (ge = O[me]; J.indexOf(" " + ge + " ") > -1; )
                J = J.replace(" " + ge + " ", " ");
            xe = fn(J), re !== xe && this.setAttribute("class", xe);
          }
        }) : this) : this.attr("class", "");
      },
      toggleClass: function(w, O) {
        var J, re, ge, me, xe = typeof w, Ue = xe === "string" || Array.isArray(w);
        return F(w) ? this.each(function(ze) {
          W(this).toggleClass(
            w.call(this, ze, dn(this), O),
            O
          );
        }) : typeof O == "boolean" && Ue ? O ? this.addClass(w) : this.removeClass(w) : (J = bn(w), this.each(function() {
          if (Ue)
            for (me = W(this), ge = 0; ge < J.length; ge++)
              re = J[ge], me.hasClass(re) ? me.removeClass(re) : me.addClass(re);
          else
            (w === void 0 || xe === "boolean") && (re = dn(this), re && He.set(this, "__className__", re), this.setAttribute && this.setAttribute(
              "class",
              re || w === !1 ? "" : He.get(this, "__className__") || ""
            ));
        }));
      },
      hasClass: function(w) {
        var O, J, re = 0;
        for (O = " " + w + " "; J = this[re++]; )
          if (J.nodeType === 1 && (" " + fn(dn(J)) + " ").indexOf(O) > -1)
            return !0;
        return !1;
      }
    });
    var sn = /\r/g;
    W.fn.extend({
      val: function(w) {
        var O, J, re, ge = this[0];
        return arguments.length ? (re = F(w), this.each(function(me) {
          var xe;
          this.nodeType === 1 && (re ? xe = w.call(this, me, W(this).val()) : xe = w, xe == null ? xe = "" : typeof xe == "number" ? xe += "" : Array.isArray(xe) && (xe = W.map(xe, function(Ue) {
            return Ue == null ? "" : Ue + "";
          })), O = W.valHooks[this.type] || W.valHooks[this.nodeName.toLowerCase()], (!O || !("set" in O) || O.set(this, xe, "value") === void 0) && (this.value = xe));
        })) : ge ? (O = W.valHooks[ge.type] || W.valHooks[ge.nodeName.toLowerCase()], O && "get" in O && (J = O.get(ge, "value")) !== void 0 ? J : (J = ge.value, typeof J == "string" ? J.replace(sn, "") : J ?? "")) : void 0;
      }
    }), W.extend({
      valHooks: {
        option: {
          get: function(w) {
            var O = W.find.attr(w, "value");
            return O ?? // Support: IE <=10 - 11 only
            // option.text throws exceptions (trac-14686, trac-14858)
            // Strip and collapse whitespace
            // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
            fn(W.text(w));
          }
        },
        select: {
          get: function(w) {
            var O, J, re, ge = w.options, me = w.selectedIndex, xe = w.type === "select-one", Ue = xe ? null : [], ze = xe ? me + 1 : ge.length;
            for (me < 0 ? re = ze : re = xe ? me : 0; re < ze; re++)
              if (J = ge[re], (J.selected || re === me) && // Don't return options that are disabled or in a disabled optgroup
              !J.disabled && (!J.parentNode.disabled || !ke(J.parentNode, "optgroup"))) {
                if (O = W(J).val(), xe)
                  return O;
                Ue.push(O);
              }
            return Ue;
          },
          set: function(w, O) {
            for (var J, re, ge = w.options, me = W.makeArray(O), xe = ge.length; xe--; )
              re = ge[xe], (re.selected = W.inArray(W.valHooks.option.get(re), me) > -1) && (J = !0);
            return J || (w.selectedIndex = -1), me;
          }
        }
      }
    }), W.each(["radio", "checkbox"], function() {
      W.valHooks[this] = {
        set: function(w, O) {
          if (Array.isArray(O))
            return w.checked = W.inArray(W(w).val(), O) > -1;
        }
      }, Z.checkOn || (W.valHooks[this].get = function(w) {
        return w.getAttribute("value") === null ? "on" : w.value;
      });
    });
    var ni = e.location, gn = { guid: Date.now() }, rn = /\?/;
    W.parseXML = function(w) {
      var O, J;
      if (!w || typeof w != "string")
        return null;
      try {
        O = new e.DOMParser().parseFromString(w, "text/xml");
      } catch {
      }
      return J = O && O.getElementsByTagName("parsererror")[0], (!O || J) && W.error("Invalid XML: " + (J ? W.map(J.childNodes, function(re) {
        return re.textContent;
      }).join(`
`) : w)), O;
    };
    var Pn = /^(?:focusinfocus|focusoutblur)$/, gr = function(w) {
      w.stopPropagation();
    };
    W.extend(W.event, {
      trigger: function(w, O, J, re) {
        var ge, me, xe, Ue, ze, Ze, At, Bt, lt = [J || D], Ft = P.call(w, "type") ? w.type : w, fi = P.call(w, "namespace") ? w.namespace.split(".") : [];
        if (me = Bt = xe = J = J || D, !(J.nodeType === 3 || J.nodeType === 8) && !Pn.test(Ft + W.event.triggered) && (Ft.indexOf(".") > -1 && (fi = Ft.split("."), Ft = fi.shift(), fi.sort()), ze = Ft.indexOf(":") < 0 && "on" + Ft, w = w[W.expando] ? w : new W.Event(Ft, typeof w == "object" && w), w.isTrigger = re ? 2 : 3, w.namespace = fi.join("."), w.rnamespace = w.namespace ? new RegExp("(^|\\.)" + fi.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, w.result = void 0, w.target || (w.target = J), O = O == null ? [w] : W.makeArray(O, [w]), At = W.event.special[Ft] || {}, !(!re && At.trigger && At.trigger.apply(J, O) === !1))) {
          if (!re && !At.noBubble && !Q(J)) {
            for (Ue = At.delegateType || Ft, Pn.test(Ue + Ft) || (me = me.parentNode); me; me = me.parentNode)
              lt.push(me), xe = me;
            xe === (J.ownerDocument || D) && lt.push(xe.defaultView || xe.parentWindow || e);
          }
          for (ge = 0; (me = lt[ge++]) && !w.isPropagationStopped(); )
            Bt = me, w.type = ge > 1 ? Ue : At.bindType || Ft, Ze = (He.get(me, "events") || /* @__PURE__ */ Object.create(null))[w.type] && He.get(me, "handle"), Ze && Ze.apply(me, O), Ze = ze && me[ze], Ze && Ze.apply && bt(me) && (w.result = Ze.apply(me, O), w.result === !1 && w.preventDefault());
          return w.type = Ft, !re && !w.isDefaultPrevented() && (!At._default || At._default.apply(lt.pop(), O) === !1) && bt(J) && ze && F(J[Ft]) && !Q(J) && (xe = J[ze], xe && (J[ze] = null), W.event.triggered = Ft, w.isPropagationStopped() && Bt.addEventListener(Ft, gr), J[Ft](), w.isPropagationStopped() && Bt.removeEventListener(Ft, gr), W.event.triggered = void 0, xe && (J[ze] = xe)), w.result;
        }
      },
      // Piggyback on a donor event to simulate a different one
      // Used only for `focus(in | out)` events
      simulate: function(w, O, J) {
        var re = W.extend(
          new W.Event(),
          J,
          {
            type: w,
            isSimulated: !0
          }
        );
        W.event.trigger(re, null, O);
      }
    }), W.fn.extend({
      trigger: function(w, O) {
        return this.each(function() {
          W.event.trigger(w, O, this);
        });
      },
      triggerHandler: function(w, O) {
        var J = this[0];
        if (J)
          return W.event.trigger(w, O, J, !0);
      }
    });
    var Or = /\[\]$/, xr = /\r?\n/g, wr = /^(?:submit|button|image|reset|file)$/i, g = /^(?:input|select|textarea|keygen)/i;
    function V(w, O, J, re) {
      var ge;
      if (Array.isArray(O))
        W.each(O, function(me, xe) {
          J || Or.test(w) ? re(w, xe) : V(
            w + "[" + (typeof xe == "object" && xe != null ? me : "") + "]",
            xe,
            J,
            re
          );
        });
      else if (!J && le(O) === "object")
        for (ge in O)
          V(w + "[" + ge + "]", O[ge], J, re);
      else
        re(w, O);
    }
    W.param = function(w, O) {
      var J, re = [], ge = function(me, xe) {
        var Ue = F(xe) ? xe() : xe;
        re[re.length] = encodeURIComponent(me) + "=" + encodeURIComponent(Ue ?? "");
      };
      if (w == null)
        return "";
      if (Array.isArray(w) || w.jquery && !W.isPlainObject(w))
        W.each(w, function() {
          ge(this.name, this.value);
        });
      else
        for (J in w)
          V(J, w[J], O, ge);
      return re.join("&");
    }, W.fn.extend({
      serialize: function() {
        return W.param(this.serializeArray());
      },
      serializeArray: function() {
        return this.map(function() {
          var w = W.prop(this, "elements");
          return w ? W.makeArray(w) : this;
        }).filter(function() {
          var w = this.type;
          return this.name && !W(this).is(":disabled") && g.test(this.nodeName) && !wr.test(w) && (this.checked || !Y.test(w));
        }).map(function(w, O) {
          var J = W(this).val();
          return J == null ? null : Array.isArray(J) ? W.map(J, function(re) {
            return { name: O.name, value: re.replace(xr, `\r
`) };
          }) : { name: O.name, value: J.replace(xr, `\r
`) };
        }).get();
      }
    });
    var ue = /%20/g, ye = /#.*$/, Ie = /([?&])_=[^&]*/, nt = /^(.*?):[ \t]*([^\r\n]*)$/mg, dt = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, zt = /^(?:GET|HEAD)$/, Xt = /^\/\//, hi = {}, ii = {}, oi = "*/".concat("*"), vn = D.createElement("a");
    vn.href = ni.href;
    function rr(w) {
      return function(O, J) {
        typeof O != "string" && (J = O, O = "*");
        var re, ge = 0, me = O.toLowerCase().match($t) || [];
        if (F(J))
          for (; re = me[ge++]; )
            re[0] === "+" ? (re = re.slice(1) || "*", (w[re] = w[re] || []).unshift(J)) : (w[re] = w[re] || []).push(J);
      };
    }
    function Tn(w, O, J, re) {
      var ge = {}, me = w === ii;
      function xe(Ue) {
        var ze;
        return ge[Ue] = !0, W.each(w[Ue] || [], function(Ze, At) {
          var Bt = At(O, J, re);
          if (typeof Bt == "string" && !me && !ge[Bt])
            return O.dataTypes.unshift(Bt), xe(Bt), !1;
          if (me)
            return !(ze = Bt);
        }), ze;
      }
      return xe(O.dataTypes[0]) || !ge["*"] && xe("*");
    }
    function Sr(w, O) {
      var J, re, ge = W.ajaxSettings.flatOptions || {};
      for (J in O)
        O[J] !== void 0 && ((ge[J] ? w : re || (re = {}))[J] = O[J]);
      return re && W.extend(!0, w, re), w;
    }
    function Mr(w, O, J) {
      for (var re, ge, me, xe, Ue = w.contents, ze = w.dataTypes; ze[0] === "*"; )
        ze.shift(), re === void 0 && (re = w.mimeType || O.getResponseHeader("Content-Type"));
      if (re) {
        for (ge in Ue)
          if (Ue[ge] && Ue[ge].test(re)) {
            ze.unshift(ge);
            break;
          }
      }
      if (ze[0] in J)
        me = ze[0];
      else {
        for (ge in J) {
          if (!ze[0] || w.converters[ge + " " + ze[0]]) {
            me = ge;
            break;
          }
          xe || (xe = ge);
        }
        me = me || xe;
      }
      if (me)
        return me !== ze[0] && ze.unshift(me), J[me];
    }
    function sr(w, O, J, re) {
      var ge, me, xe, Ue, ze, Ze = {}, At = w.dataTypes.slice();
      if (At[1])
        for (xe in w.converters)
          Ze[xe.toLowerCase()] = w.converters[xe];
      for (me = At.shift(); me; )
        if (w.responseFields[me] && (J[w.responseFields[me]] = O), !ze && re && w.dataFilter && (O = w.dataFilter(O, w.dataType)), ze = me, me = At.shift(), me) {
          if (me === "*")
            me = ze;
          else if (ze !== "*" && ze !== me) {
            if (xe = Ze[ze + " " + me] || Ze["* " + me], !xe) {
              for (ge in Ze)
                if (Ue = ge.split(" "), Ue[1] === me && (xe = Ze[ze + " " + Ue[0]] || Ze["* " + Ue[0]], xe)) {
                  xe === !0 ? xe = Ze[ge] : Ze[ge] !== !0 && (me = Ue[0], At.unshift(Ue[1]));
                  break;
                }
            }
            if (xe !== !0)
              if (xe && w.throws)
                O = xe(O);
              else
                try {
                  O = xe(O);
                } catch (Bt) {
                  return {
                    state: "parsererror",
                    error: xe ? Bt : "No conversion from " + ze + " to " + me
                  };
                }
          }
        }
      return { state: "success", data: O };
    }
    W.extend({
      // Counter for holding the number of active queries
      active: 0,
      // Last-Modified header cache for next request
      lastModified: {},
      etag: {},
      ajaxSettings: {
        url: ni.href,
        type: "GET",
        isLocal: dt.test(ni.protocol),
        global: !0,
        processData: !0,
        async: !0,
        contentType: "application/x-www-form-urlencoded; charset=UTF-8",
        /*
        timeout: 0,
        data: null,
        dataType: null,
        username: null,
        password: null,
        cache: null,
        throws: false,
        traditional: false,
        headers: {},
        */
        accepts: {
          "*": oi,
          text: "text/plain",
          html: "text/html",
          xml: "application/xml, text/xml",
          json: "application/json, text/javascript"
        },
        contents: {
          xml: /\bxml\b/,
          html: /\bhtml/,
          json: /\bjson\b/
        },
        responseFields: {
          xml: "responseXML",
          text: "responseText",
          json: "responseJSON"
        },
        // Data converters
        // Keys separate source (or catchall "*") and destination types with a single space
        converters: {
          // Convert anything to text
          "* text": String,
          // Text to html (true = no transformation)
          "text html": !0,
          // Evaluate text as a json expression
          "text json": JSON.parse,
          // Parse text as xml
          "text xml": W.parseXML
        },
        // For options that shouldn't be deep extended:
        // you can add your own custom options here if
        // and when you create one that shouldn't be
        // deep extended (see ajaxExtend)
        flatOptions: {
          url: !0,
          context: !0
        }
      },
      // Creates a full fledged settings object into target
      // with both ajaxSettings and settings fields.
      // If target is omitted, writes into ajaxSettings.
      ajaxSetup: function(w, O) {
        return O ? (
          // Building a settings object
          Sr(Sr(w, W.ajaxSettings), O)
        ) : (
          // Extending ajaxSettings
          Sr(W.ajaxSettings, w)
        );
      },
      ajaxPrefilter: rr(hi),
      ajaxTransport: rr(ii),
      // Main method
      ajax: function(w, O) {
        typeof w == "object" && (O = w, w = void 0), O = O || {};
        var J, re, ge, me, xe, Ue, ze, Ze, At, Bt, lt = W.ajaxSetup({}, O), Ft = lt.context || lt, fi = lt.context && (Ft.nodeType || Ft.jquery) ? W(Ft) : W.event, si = W.Deferred(), di = W.Callbacks("once memory"), xn = lt.statusCode || {}, wn = {}, an = {}, xi = "canceled", ki = {
          readyState: 0,
          // Builds headers hashtable if needed
          getResponseHeader: function(Ni) {
            var Qi;
            if (ze) {
              if (!me)
                for (me = {}; Qi = nt.exec(ge); )
                  me[Qi[1].toLowerCase() + " "] = (me[Qi[1].toLowerCase() + " "] || []).concat(Qi[2]);
              Qi = me[Ni.toLowerCase() + " "];
            }
            return Qi == null ? null : Qi.join(", ");
          },
          // Raw string
          getAllResponseHeaders: function() {
            return ze ? ge : null;
          },
          // Caches the header
          setRequestHeader: function(Ni, Qi) {
            return ze == null && (Ni = an[Ni.toLowerCase()] = an[Ni.toLowerCase()] || Ni, wn[Ni] = Qi), this;
          },
          // Overrides response content-type header
          overrideMimeType: function(Ni) {
            return ze == null && (lt.mimeType = Ni), this;
          },
          // Status-dependent callbacks
          statusCode: function(Ni) {
            var Qi;
            if (Ni)
              if (ze)
                ki.always(Ni[ki.status]);
              else
                for (Qi in Ni)
                  xn[Qi] = [xn[Qi], Ni[Qi]];
            return this;
          },
          // Cancel the request
          abort: function(Ni) {
            var Qi = Ni || xi;
            return J && J.abort(Qi), Dn(0, Qi), this;
          }
        };
        if (si.promise(ki), lt.url = ((w || lt.url || ni.href) + "").replace(Xt, ni.protocol + "//"), lt.type = O.method || O.type || lt.method || lt.type, lt.dataTypes = (lt.dataType || "*").toLowerCase().match($t) || [""], lt.crossDomain == null) {
          Ue = D.createElement("a");
          try {
            Ue.href = lt.url, Ue.href = Ue.href, lt.crossDomain = vn.protocol + "//" + vn.host != Ue.protocol + "//" + Ue.host;
          } catch {
            lt.crossDomain = !0;
          }
        }
        if (lt.data && lt.processData && typeof lt.data != "string" && (lt.data = W.param(lt.data, lt.traditional)), Tn(hi, lt, O, ki), ze)
          return ki;
        Ze = W.event && lt.global, Ze && W.active++ === 0 && W.event.trigger("ajaxStart"), lt.type = lt.type.toUpperCase(), lt.hasContent = !zt.test(lt.type), re = lt.url.replace(ye, ""), lt.hasContent ? lt.data && lt.processData && (lt.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && (lt.data = lt.data.replace(ue, "+")) : (Bt = lt.url.slice(re.length), lt.data && (lt.processData || typeof lt.data == "string") && (re += (rn.test(re) ? "&" : "?") + lt.data, delete lt.data), lt.cache === !1 && (re = re.replace(Ie, "$1"), Bt = (rn.test(re) ? "&" : "?") + "_=" + gn.guid++ + Bt), lt.url = re + Bt), lt.ifModified && (W.lastModified[re] && ki.setRequestHeader("If-Modified-Since", W.lastModified[re]), W.etag[re] && ki.setRequestHeader("If-None-Match", W.etag[re])), (lt.data && lt.hasContent && lt.contentType !== !1 || O.contentType) && ki.setRequestHeader("Content-Type", lt.contentType), ki.setRequestHeader(
          "Accept",
          lt.dataTypes[0] && lt.accepts[lt.dataTypes[0]] ? lt.accepts[lt.dataTypes[0]] + (lt.dataTypes[0] !== "*" ? ", " + oi + "; q=0.01" : "") : lt.accepts["*"]
        );
        for (At in lt.headers)
          ki.setRequestHeader(At, lt.headers[At]);
        if (lt.beforeSend && (lt.beforeSend.call(Ft, ki, lt) === !1 || ze))
          return ki.abort();
        if (xi = "abort", di.add(lt.complete), ki.done(lt.success), ki.fail(lt.error), J = Tn(ii, lt, O, ki), !J)
          Dn(-1, "No Transport");
        else {
          if (ki.readyState = 1, Ze && fi.trigger("ajaxSend", [ki, lt]), ze)
            return ki;
          lt.async && lt.timeout > 0 && (xe = e.setTimeout(function() {
            ki.abort("timeout");
          }, lt.timeout));
          try {
            ze = !1, J.send(wn, Dn);
          } catch (Ni) {
            if (ze)
              throw Ni;
            Dn(-1, Ni);
          }
        }
        function Dn(Ni, Qi, ar, pr) {
          var pn, Ar, Yn, Qt, qn, Gn = Qi;
          ze || (ze = !0, xe && e.clearTimeout(xe), J = void 0, ge = pr || "", ki.readyState = Ni > 0 ? 4 : 0, pn = Ni >= 200 && Ni < 300 || Ni === 304, ar && (Qt = Mr(lt, ki, ar)), !pn && W.inArray("script", lt.dataTypes) > -1 && W.inArray("json", lt.dataTypes) < 0 && (lt.converters["text script"] = function() {
          }), Qt = sr(lt, Qt, ki, pn), pn ? (lt.ifModified && (qn = ki.getResponseHeader("Last-Modified"), qn && (W.lastModified[re] = qn), qn = ki.getResponseHeader("etag"), qn && (W.etag[re] = qn)), Ni === 204 || lt.type === "HEAD" ? Gn = "nocontent" : Ni === 304 ? Gn = "notmodified" : (Gn = Qt.state, Ar = Qt.data, Yn = Qt.error, pn = !Yn)) : (Yn = Gn, (Ni || !Gn) && (Gn = "error", Ni < 0 && (Ni = 0))), ki.status = Ni, ki.statusText = (Qi || Gn) + "", pn ? si.resolveWith(Ft, [Ar, Gn, ki]) : si.rejectWith(Ft, [ki, Gn, Yn]), ki.statusCode(xn), xn = void 0, Ze && fi.trigger(
            pn ? "ajaxSuccess" : "ajaxError",
            [ki, lt, pn ? Ar : Yn]
          ), di.fireWith(Ft, [ki, Gn]), Ze && (fi.trigger("ajaxComplete", [ki, lt]), --W.active || W.event.trigger("ajaxStop")));
        }
        return ki;
      },
      getJSON: function(w, O, J) {
        return W.get(w, O, J, "json");
      },
      getScript: function(w, O) {
        return W.get(w, void 0, O, "script");
      }
    }), W.each(["get", "post"], function(w, O) {
      W[O] = function(J, re, ge, me) {
        return F(re) && (me = me || ge, ge = re, re = void 0), W.ajax(W.extend({
          url: J,
          type: O,
          dataType: me,
          data: re,
          success: ge
        }, W.isPlainObject(J) && J));
      };
    }), W.ajaxPrefilter(function(w) {
      var O;
      for (O in w.headers)
        O.toLowerCase() === "content-type" && (w.contentType = w.headers[O] || "");
    }), W._evalUrl = function(w, O, J) {
      return W.ajax({
        url: w,
        // Make this explicit, since user can override this through ajaxSetup (trac-11264)
        type: "GET",
        dataType: "script",
        cache: !0,
        async: !1,
        global: !1,
        // Only evaluate the response if it is successful (gh-4126)
        // dataFilter is not invoked for failure responses, so using it instead
        // of the default converter is kludgy but it works.
        converters: {
          "text script": function() {
          }
        },
        dataFilter: function(re) {
          W.globalEval(re, O, J);
        }
      });
    }, W.fn.extend({
      wrapAll: function(w) {
        var O;
        return this[0] && (F(w) && (w = w.call(this[0])), O = W(w, this[0].ownerDocument).eq(0).clone(!0), this[0].parentNode && O.insertBefore(this[0]), O.map(function() {
          for (var J = this; J.firstElementChild; )
            J = J.firstElementChild;
          return J;
        }).append(this)), this;
      },
      wrapInner: function(w) {
        return F(w) ? this.each(function(O) {
          W(this).wrapInner(w.call(this, O));
        }) : this.each(function() {
          var O = W(this), J = O.contents();
          J.length ? J.wrapAll(w) : O.append(w);
        });
      },
      wrap: function(w) {
        var O = F(w);
        return this.each(function(J) {
          W(this).wrapAll(O ? w.call(this, J) : w);
        });
      },
      unwrap: function(w) {
        return this.parent(w).not("body").each(function() {
          W(this).replaceWith(this.childNodes);
        }), this;
      }
    }), W.expr.pseudos.hidden = function(w) {
      return !W.expr.pseudos.visible(w);
    }, W.expr.pseudos.visible = function(w) {
      return !!(w.offsetWidth || w.offsetHeight || w.getClientRects().length);
    }, W.ajaxSettings.xhr = function() {
      try {
        return new e.XMLHttpRequest();
      } catch {
      }
    };
    var Cr = {
      // File protocol always yields status code 0, assume 200
      0: 200,
      // Support: IE <=9 only
      // trac-1450: sometimes IE returns 1223 when it should be 204
      1223: 204
    }, os = W.ajaxSettings.xhr();
    Z.cors = !!os && "withCredentials" in os, Z.ajax = os = !!os, W.ajaxTransport(function(w) {
      var O, J;
      if (Z.cors || os && !w.crossDomain)
        return {
          send: function(re, ge) {
            var me, xe = w.xhr();
            if (xe.open(
              w.type,
              w.url,
              w.async,
              w.username,
              w.password
            ), w.xhrFields)
              for (me in w.xhrFields)
                xe[me] = w.xhrFields[me];
            w.mimeType && xe.overrideMimeType && xe.overrideMimeType(w.mimeType), !w.crossDomain && !re["X-Requested-With"] && (re["X-Requested-With"] = "XMLHttpRequest");
            for (me in re)
              xe.setRequestHeader(me, re[me]);
            O = function(Ue) {
              return function() {
                O && (O = J = xe.onload = xe.onerror = xe.onabort = xe.ontimeout = xe.onreadystatechange = null, Ue === "abort" ? xe.abort() : Ue === "error" ? typeof xe.status != "number" ? ge(0, "error") : ge(
                  // File: protocol always yields status 0; see trac-8605, trac-14207
                  xe.status,
                  xe.statusText
                ) : ge(
                  Cr[xe.status] || xe.status,
                  xe.statusText,
                  // Support: IE <=9 only
                  // IE9 has no XHR2 but throws on binary (trac-11426)
                  // For XHR2 non-text, let the caller handle it (gh-2498)
                  (xe.responseType || "text") !== "text" || typeof xe.responseText != "string" ? { binary: xe.response } : { text: xe.responseText },
                  xe.getAllResponseHeaders()
                ));
              };
            }, xe.onload = O(), J = xe.onerror = xe.ontimeout = O("error"), xe.onabort !== void 0 ? xe.onabort = J : xe.onreadystatechange = function() {
              xe.readyState === 4 && e.setTimeout(function() {
                O && J();
              });
            }, O = O("abort");
            try {
              xe.send(w.hasContent && w.data || null);
            } catch (Ue) {
              if (O)
                throw Ue;
            }
          },
          abort: function() {
            O && O();
          }
        };
    }), W.ajaxPrefilter(function(w) {
      w.crossDomain && (w.contents.script = !1);
    }), W.ajaxSetup({
      accepts: {
        script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
      },
      contents: {
        script: /\b(?:java|ecma)script\b/
      },
      converters: {
        "text script": function(w) {
          return W.globalEval(w), w;
        }
      }
    }), W.ajaxPrefilter("script", function(w) {
      w.cache === void 0 && (w.cache = !1), w.crossDomain && (w.type = "GET");
    }), W.ajaxTransport("script", function(w) {
      if (w.crossDomain || w.scriptAttrs) {
        var O, J;
        return {
          send: function(re, ge) {
            O = W("<script>").attr(w.scriptAttrs || {}).prop({ charset: w.scriptCharset, src: w.url }).on("load error", J = function(me) {
              O.remove(), J = null, me && ge(me.type === "error" ? 404 : 200, me.type);
            }), D.head.appendChild(O[0]);
          },
          abort: function() {
            J && J();
          }
        };
      }
    });
    var Sn = [], Nr = /(=)\?(?=&|$)|\?\?/;
    W.ajaxSetup({
      jsonp: "callback",
      jsonpCallback: function() {
        var w = Sn.pop() || W.expando + "_" + gn.guid++;
        return this[w] = !0, w;
      }
    }), W.ajaxPrefilter("json jsonp", function(w, O, J) {
      var re, ge, me, xe = w.jsonp !== !1 && (Nr.test(w.url) ? "url" : typeof w.data == "string" && (w.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && Nr.test(w.data) && "data");
      if (xe || w.dataTypes[0] === "jsonp")
        return re = w.jsonpCallback = F(w.jsonpCallback) ? w.jsonpCallback() : w.jsonpCallback, xe ? w[xe] = w[xe].replace(Nr, "$1" + re) : w.jsonp !== !1 && (w.url += (rn.test(w.url) ? "&" : "?") + w.jsonp + "=" + re), w.converters["script json"] = function() {
          return me || W.error(re + " was not called"), me[0];
        }, w.dataTypes[0] = "json", ge = e[re], e[re] = function() {
          me = arguments;
        }, J.always(function() {
          ge === void 0 ? W(e).removeProp(re) : e[re] = ge, w[re] && (w.jsonpCallback = O.jsonpCallback, Sn.push(re)), me && F(ge) && ge(me[0]), me = ge = void 0;
        }), "script";
    }), Z.createHTMLDocument = function() {
      var w = D.implementation.createHTMLDocument("").body;
      return w.innerHTML = "<form></form><form></form>", w.childNodes.length === 2;
    }(), W.parseHTML = function(w, O, J) {
      if (typeof w != "string")
        return [];
      typeof O == "boolean" && (J = O, O = !1);
      var re, ge, me;
      return O || (Z.createHTMLDocument ? (O = D.implementation.createHTMLDocument(""), re = O.createElement("base"), re.href = D.location.href, O.head.appendChild(re)) : O = D), ge = tt.exec(w), me = !J && [], ge ? [O.createElement(ge[1])] : (ge = H([w], O, me), me && me.length && W(me).remove(), W.merge([], ge.childNodes));
    }, W.fn.load = function(w, O, J) {
      var re, ge, me, xe = this, Ue = w.indexOf(" ");
      return Ue > -1 && (re = fn(w.slice(Ue)), w = w.slice(0, Ue)), F(O) ? (J = O, O = void 0) : O && typeof O == "object" && (ge = "POST"), xe.length > 0 && W.ajax({
        url: w,
        // If "type" variable is undefined, then "GET" method will be used.
        // Make value of this field explicit since
        // user can override it through ajaxSetup method
        type: ge || "GET",
        dataType: "html",
        data: O
      }).done(function(ze) {
        me = arguments, xe.html(re ? (
          // If a selector was specified, locate the right elements in a dummy div
          // Exclude scripts to avoid IE 'Permission Denied' errors
          W("<div>").append(W.parseHTML(ze)).find(re)
        ) : (
          // Otherwise use the full result
          ze
        ));
      }).always(J && function(ze, Ze) {
        xe.each(function() {
          J.apply(this, me || [ze.responseText, Ze, ze]);
        });
      }), this;
    }, W.expr.pseudos.animated = function(w) {
      return W.grep(W.timers, function(O) {
        return w === O.elem;
      }).length;
    }, W.offset = {
      setOffset: function(w, O, J) {
        var re, ge, me, xe, Ue, ze, Ze, At = W.css(w, "position"), Bt = W(w), lt = {};
        At === "static" && (w.style.position = "relative"), Ue = Bt.offset(), me = W.css(w, "top"), ze = W.css(w, "left"), Ze = (At === "absolute" || At === "fixed") && (me + ze).indexOf("auto") > -1, Ze ? (re = Bt.position(), xe = re.top, ge = re.left) : (xe = parseFloat(me) || 0, ge = parseFloat(ze) || 0), F(O) && (O = O.call(w, J, W.extend({}, Ue))), O.top != null && (lt.top = O.top - Ue.top + xe), O.left != null && (lt.left = O.left - Ue.left + ge), "using" in O ? O.using.call(w, lt) : Bt.css(lt);
      }
    }, W.fn.extend({
      // offset() relates an element's border box to the document origin
      offset: function(w) {
        if (arguments.length)
          return w === void 0 ? this : this.each(function(ge) {
            W.offset.setOffset(this, w, ge);
          });
        var O, J, re = this[0];
        if (re)
          return re.getClientRects().length ? (O = re.getBoundingClientRect(), J = re.ownerDocument.defaultView, {
            top: O.top + J.pageYOffset,
            left: O.left + J.pageXOffset
          }) : { top: 0, left: 0 };
      },
      // position() relates an element's margin box to its offset parent's padding box
      // This corresponds to the behavior of CSS absolute positioning
      position: function() {
        if (this[0]) {
          var w, O, J, re = this[0], ge = { top: 0, left: 0 };
          if (W.css(re, "position") === "fixed")
            O = re.getBoundingClientRect();
          else {
            for (O = this.offset(), J = re.ownerDocument, w = re.offsetParent || J.documentElement; w && (w === J.body || w === J.documentElement) && W.css(w, "position") === "static"; )
              w = w.parentNode;
            w && w !== re && w.nodeType === 1 && (ge = W(w).offset(), ge.top += W.css(w, "borderTopWidth", !0), ge.left += W.css(w, "borderLeftWidth", !0));
          }
          return {
            top: O.top - ge.top - W.css(re, "marginTop", !0),
            left: O.left - ge.left - W.css(re, "marginLeft", !0)
          };
        }
      },
      // This method will return documentElement in the following cases:
      // 1) For the element inside the iframe without offsetParent, this method will return
      //    documentElement of the parent window
      // 2) For the hidden or detached element
      // 3) For body or html element, i.e. in case of the html node - it will return itself
      //
      // but those exceptions were never presented as a real life use-cases
      // and might be considered as more preferable results.
      //
      // This logic, however, is not guaranteed and can change at any point in the future
      offsetParent: function() {
        return this.map(function() {
          for (var w = this.offsetParent; w && W.css(w, "position") === "static"; )
            w = w.offsetParent;
          return w || y;
        });
      }
    }), W.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function(w, O) {
      var J = O === "pageYOffset";
      W.fn[w] = function(re) {
        return Ee(this, function(ge, me, xe) {
          var Ue;
          if (Q(ge) ? Ue = ge : ge.nodeType === 9 && (Ue = ge.defaultView), xe === void 0)
            return Ue ? Ue[O] : ge[me];
          Ue ? Ue.scrollTo(
            J ? Ue.pageXOffset : xe,
            J ? xe : Ue.pageYOffset
          ) : ge[me] = xe;
        }, w, re, arguments.length);
      };
    }), W.each(["top", "left"], function(w, O) {
      W.cssHooks[O] = Ht(
        Z.pixelPosition,
        function(J, re) {
          if (re)
            return re = Et(J, O), Fe.test(re) ? W(J).position()[O] + "px" : re;
        }
      );
    }), W.each({ Height: "height", Width: "width" }, function(w, O) {
      W.each({
        padding: "inner" + w,
        content: O,
        "": "outer" + w
      }, function(J, re) {
        W.fn[re] = function(ge, me) {
          var xe = arguments.length && (J || typeof ge != "boolean"), Ue = J || (ge === !0 || me === !0 ? "margin" : "border");
          return Ee(this, function(ze, Ze, At) {
            var Bt;
            return Q(ze) ? re.indexOf("outer") === 0 ? ze["inner" + w] : ze.document.documentElement["client" + w] : ze.nodeType === 9 ? (Bt = ze.documentElement, Math.max(
              ze.body["scroll" + w],
              Bt["scroll" + w],
              ze.body["offset" + w],
              Bt["offset" + w],
              Bt["client" + w]
            )) : At === void 0 ? (
              // Get width or height on the element, requesting but not forcing parseFloat
              W.css(ze, Ze, Ue)
            ) : (
              // Set width or height on the element
              W.style(ze, Ze, At, Ue)
            );
          }, O, xe ? ge : void 0, xe);
        };
      });
    }), W.each([
      "ajaxStart",
      "ajaxStop",
      "ajaxComplete",
      "ajaxError",
      "ajaxSuccess",
      "ajaxSend"
    ], function(w, O) {
      W.fn[O] = function(J) {
        return this.on(O, J);
      };
    }), W.fn.extend({
      bind: function(w, O, J) {
        return this.on(w, null, O, J);
      },
      unbind: function(w, O) {
        return this.off(w, null, O);
      },
      delegate: function(w, O, J, re) {
        return this.on(O, w, J, re);
      },
      undelegate: function(w, O, J) {
        return arguments.length === 1 ? this.off(w, "**") : this.off(O, w || "**", J);
      },
      hover: function(w, O) {
        return this.on("mouseenter", w).on("mouseleave", O || w);
      }
    }), W.each(
      "blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "),
      function(w, O) {
        W.fn[O] = function(J, re) {
          return arguments.length > 0 ? this.on(O, null, J, re) : this.trigger(O);
        };
      }
    );
    var Rr = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    W.proxy = function(w, O) {
      var J, re, ge;
      if (typeof O == "string" && (J = w[O], O = w, w = J), !!F(w))
        return re = o.call(arguments, 2), ge = function() {
          return w.apply(O || this, re.concat(o.call(arguments)));
        }, ge.guid = w.guid = w.guid || W.guid++, ge;
    }, W.holdReady = function(w) {
      w ? W.readyWait++ : W.ready(!0);
    }, W.isArray = Array.isArray, W.parseJSON = JSON.parse, W.nodeName = ke, W.isFunction = F, W.isWindow = Q, W.camelCase = Qe, W.type = le, W.now = Date.now, W.isNumeric = function(w) {
      var O = W.type(w);
      return (O === "number" || O === "string") && // parseFloat NaNs numeric-cast false positives ("")
      // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
      // subtraction forces infinities to NaN
      !isNaN(w - parseFloat(w));
    }, W.trim = function(w) {
      return w == null ? "" : (w + "").replace(Rr, "$1");
    };
    var vs = e.jQuery, Ts = e.$;
    return W.noConflict = function(w) {
      return e.$ === W && (e.$ = Ts), w && e.jQuery === W && (e.jQuery = vs), W;
    }, typeof t > "u" && (e.jQuery = e.$ = W), W;
  });
})(Kd);
var dw = Kd.exports;
const zs = /* @__PURE__ */ uu(dw);
function T1() {
  const b = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream, e = window.devicePixelRatio || 1, t = {
    width: window.screen.width * e,
    height: window.screen.height * e
  };
  return !!(b && t.width === 1125 && t.height === 2436);
}
function L1() {
  return /android/i.test(navigator.userAgent);
}
function B1() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !self.MSStream || navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
}
function gw() {
  const b = navigator.userAgent || navigator.vendor || self.opera;
  return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
    b
  ) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
    b.substr(0, 4)
  );
}
function k1() {
  const b = document.compatMode === "CSS1Compat";
  return {
    l: window.pageXOffset || (b ? document.documentElement.scrollLeft : document.body.scrollLeft),
    t: window.pageYOffset || (b ? document.documentElement.scrollTop : document.body.scrollTop),
    w: window.innerWidth || (b ? document.documentElement.clientWidth : document.body.clientWidth),
    h: window.innerHeight || (b ? document.documentElement.clientHeight : document.body.clientHeight)
  };
}
function E1(b, e, t) {
  var n = (b * 299 + e * 587 + t * 114) / 1e3;
  return n >= 128 ? "black" : "white";
}
function I1(b) {
  var e = parseInt(b.substr(0, 2), 16), t = parseInt(b.substr(2, 2), 16), n = parseInt(b.substr(4, 2), 16), s = (e * 299 + t * 587 + n * 114) / 1e3;
  return s >= 128 ? "black" : "white";
}
function oa(b, e) {
  return typeof e > "u" || typeof e === null ? !1 : function(n, s) {
    let o = s !== s, h;
    return !o && typeof Array.prototype.indexOf == "function" ? (h = Array.prototype.indexOf, h.call(n, s) > -1) : (h = function(c, _) {
      var x = -1, B = -1;
      for (x = 0; x < c.length; x++) {
        var P = c[x];
        if (o && P !== P || P === _) {
          B = x;
          break;
        }
      }
      return B;
    }, h(n, s) > -1);
  }(b, e);
}
function pw(b) {
  b = String(b).replace(/[^0-9a-f]/gi, ""), b.length < 6 && (b = b[0] + b[0] + b[1] + b[1] + b[2] + b[2]);
  var e = parseInt(b.substr(0 * 2, 2), 16), t = parseInt(b.substr(1 * 2, 2), 16), n = parseInt(b.substr(2 * 2, 2), 16), s = Math.sqrt(e * e * 0.241 + t * t * 0.691 + n * n * 0.068);
  return s;
}
function mw(b) {
  return pw(b) < 130;
}
function _w(b, e = 0) {
  b = String(b).replace(/[^0-9a-f]/gi, ""), b.length < 6 && (b = b[0] + b[0] + b[1] + b[1] + b[2] + b[2]), e = e || 0;
  var t = "#", n, s;
  for (s = 0; s < 3; s++)
    n = parseInt(b.substr(s * 2, 2), 16), n = Math.round(Math.min(Math.max(0, n + n * e), 255)).toString(16), t += ("00" + n).substr(n.length);
  return t;
}
function vw(b, e, t, n) {
  var s = new Image(), o = zs("<canvas>"), h = o[0], c = h.getContext("2d");
  s.crossOrigin = "anonymous", s.onload = function() {
    if (o.attr({ width: s.width, height: s.height }), c = h.getContext("2d"), c) {
      c.drawImage(s, 0, 0);
      let _ = Jd(h, s.width, s.height, e, t);
      n && n(_);
    } else
      alert("Get a real browser!");
  }, s.src = b;
}
async function Wh(b) {
  return new Promise((e, t) => {
    const n = new Image(), s = zs("<canvas>");
    let o = s[0], h = o.getContext("2d");
    n.crossOrigin = "anonymous", n.onload = function() {
      if (s.attr({ width: n.width, height: n.height }), h = o.getContext("2d"), h) {
        h.drawImage(n, 0, 0);
        let c = yw(o);
        e(c);
      } else
        t(new Error("HTML5 Canvas not supported"));
    }, n.src = b;
  });
}
function yw(b) {
  const e = b.getContext("2d");
  if (!e)
    return null;
  const t = b.width, n = b.height, o = e.getImageData(0, 0, b.width, b.height).data, h = (Q, D) => o[(t * D + Q) * 4 + 3], c = (Q) => Q < 10, _ = (Q) => {
    const D = Q ? 1 : -1;
    for (var te = Q ? 0 : n - 1; Q ? te < n : te > -1; te += D)
      for (var ee = 0; ee < t; ee++)
        if (!c(h(ee, te)))
          return te;
    return null;
  }, x = (Q) => {
    const D = Q ? 1 : -1;
    for (var te = Q ? 0 : t - 1; Q ? te < t : te > -1; te += D)
      for (var ee = 0; ee < n; ee++)
        if (!c(h(te, ee)))
          return te;
    return null;
  }, B = _(!0), P = _(!1), U = x(!0), M = x(!1);
  if (B != null && P != null && U != null && M != null) {
    const Q = M - U + 1, D = P - B + 1, ee = zs("<canvas>").attr({ width: Q, height: D })[0];
    var Z = ee.getContext("2d");
    if (!Z)
      return null;
    Z.drawImage(b, U, B, Q, D, 0, 0, Q, D), Z.getImageData(0, 0, ee.width, ee.height);
    var F = ee.toDataURL();
    return F;
  } else
    return null;
}
async function bw(b, e, t = 30) {
  return new Promise((n, s) => {
    const o = new Image();
    o.crossOrigin = "anonymous", o.onload = () => {
      const c = zs("<canvas>").attr({ width: o.width, height: o.height })[0], _ = c.getContext("2d");
      if (!_)
        return s(new Error("Canvas 2D not supported"));
      _.drawImage(o, 0, 0);
      const x = xw(c, e, t);
      n(x);
    }, o.onerror = () => s(new Error("Failed to load image for crop")), o.src = b;
  });
}
function xw(b, e, t) {
  const n = b.getContext("2d");
  if (!n)
    return null;
  const s = b.width, o = b.height, h = n.getImageData(0, 0, s, o).data;
  let c = 255, _ = 255, x = 255, B = !1;
  if (e === "transparent")
    B = !0;
  else if (e === !0)
    h[3] < 10 ? B = !0 : (c = h[0], _ = h[1], x = h[2]);
  else if (typeof e == "string") {
    const W = ww(e);
    c = W.r, _ = W.g, x = W.b;
  }
  const P = (W, je) => {
    const ke = (s * je + W) * 4;
    return B ? h[ke + 3] < t : Math.abs(h[ke] - c) < t && Math.abs(h[ke + 1] - _) < t && Math.abs(h[ke + 2] - x) < t;
  }, U = (W) => {
    const je = W ? 1 : -1;
    for (let ke = W ? 0 : o - 1; W ? ke < o : ke > -1; ke += je)
      for (let Ye = 0; Ye < s; Ye++)
        if (!P(Ye, ke))
          return ke;
    return null;
  }, M = (W) => {
    const je = W ? 1 : -1;
    for (let ke = W ? 0 : s - 1; W ? ke < s : ke > -1; ke += je)
      for (let Ye = 0; Ye < o; Ye++)
        if (!P(ke, Ye))
          return ke;
    return null;
  }, Z = U(!0), F = U(!1), Q = M(!0), D = M(!1);
  if (Z == null || F == null || Q == null || D == null)
    return null;
  const te = D - Q + 1, ee = F - Z + 1, fe = zs("<canvas>").attr({ width: te, height: ee })[0], X = fe.getContext("2d");
  return X ? (X.drawImage(b, Q, Z, te, ee, 0, 0, te, ee), fe.toDataURL()) : null;
}
function ww(b) {
  return b = b.replace(/^#/, ""), b.length === 3 && (b = b[0] + b[0] + b[1] + b[1] + b[2] + b[2]), {
    r: parseInt(b.substring(0, 2), 16),
    g: parseInt(b.substring(2, 4), 16),
    b: parseInt(b.substring(4, 6), 16)
  };
}
async function P1(b, e, t) {
  return new Promise((n, s) => {
    const o = new Image(), h = zs("<canvas>");
    let c = h[0], _ = c.getContext("2d");
    o.crossOrigin = "anonymous", o.onload = function() {
      if (h.attr({ width: o.width, height: o.height }), _ = c.getContext("2d"), _) {
        _.drawImage(o, 0, 0);
        let x = Jd(c, o.width, o.height, e, t);
        n(x);
      } else
        s(new Error("HTML5 Canvas not supported"));
    }, o.src = b;
  });
}
function Jd(b, e, t, n, s) {
  const o = b.getContext("2d");
  if (!o)
    return null;
  const c = o.getImageData(0, 0, b.width, b.height).data, _ = (te, ee) => c[(e * ee + te) * 4 + 3], x = (te) => te === 0, B = (te) => {
    const ee = te ? 1 : -1;
    for (var le = te ? 0 : t - 1; te ? le < t : le > -1; le += ee)
      for (var fe = 0; fe < e; fe++)
        if (!x(_(fe, le)))
          return le;
    return null;
  }, P = (te) => {
    const ee = te ? 1 : -1;
    for (var le = te ? 0 : e - 1; te ? le < e : le > -1; le += ee)
      for (var fe = 0; fe < t; fe++)
        if (!x(_(le, fe)))
          return le;
    return null;
  }, U = B(!0), M = B(!1), Z = P(!0), F = P(!1);
  if (U != null && M != null && Z != null && F != null) {
    const te = F - Z, ee = M - U, le = n, fe = s, X = le / te, W = fe / ee;
    let je = te * X, ke = ee * X;
    ke > fe && (je = te * W, ke = ee * W);
    const pt = zs("<canvas>").attr({ width: le, height: fe })[0];
    var Q = pt.getContext("2d");
    if (!Q)
      return null;
    Q.drawImage(
      b,
      Z,
      U,
      te,
      ee,
      (le - je) / 2,
      (fe - ke) / 2,
      je,
      ke
    ), Q.getImageData(0, 0, pt.width, pt.height);
    var D = pt.toDataURL();
    return D;
  } else
    return null;
}
async function Sw(b, e, t, n) {
  return new Promise((s) => {
    const o = new Image();
    o.crossOrigin = "anonymous", o.onload = function() {
      let c = zs("<canvas>")[0], _ = c.getContext("2d");
      if (_) {
        c.width = e, c.height = t;
        const x = Math.min(e / o.width, t / o.height), B = o.width * x, P = o.height * x;
        _.drawImage(
          o,
          0,
          0,
          o.width,
          o.height,
          (e - B + n) / 2,
          (t - P + n) / 2,
          B - n,
          P - n
        );
        const U = c.toDataURL();
        s(U);
      }
    }, o.src = b;
  });
}
function O1(b, e, t) {
  var n = zs("<canvas>");
  n.attr({ width: e, height: t });
  var s = n[0], o = s.getContext("2d");
  if (o) {
    o.fillStyle = b, o.fillRect(0, 0, e, t);
    var h = s.toDataURL();
    return h;
  } else
    return null;
}
function N1(b, e) {
  return b ? b.match(new RegExp(".[^]{1," + e + "}", "g")) : null;
}
function R1(b) {
  let e = 0, t, n;
  if (b.length === 0)
    return e;
  for (t = 0; t < b.length; t++)
    n = b.charCodeAt(t), e = (e << 5) - e + n, e |= 0;
  return e;
}
function D1(b) {
  var e = document.createElement("a");
  return e.href = b, e.href;
}
function Qd(b) {
  for (var e = atob(b.split(",")[1]), t = b.split(",")[0].split(":")[1].split(";")[0], n = new ArrayBuffer(e.length), s = new Uint8Array(n), o = 0; o < e.length; o++)
    s[o] = e.charCodeAt(o);
  var h = new Blob([n], { type: t });
  return h;
}
function z1(b, e) {
  if (typeof b != "number" && b < 1)
    throw new RangeError("Length must be a positive integer!");
  e === void 0 && (e = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ");
  let t = "";
  const n = e.length;
  for (var s = 0; s < b; s++)
    t += e.charAt(Math.floor(Math.random() * n));
  return t;
}
async function F1(b, e) {
  return new Promise((t) => {
    const n = new Uint8Array(b), s = new Blob([n], { type: e }), h = (window.URL || window.webkitURL).createObjectURL(s), c = new Image();
    c.src = h, c.onload = async () => {
      const _ = document.createElement("canvas"), x = _.getContext("2d");
      _.width = c.width, _.height = c.height, x.translate(0, c.height), x.scale(1, -1), x.drawImage(c, 0, 0), _.toBlob((B) => {
        const P = new FileReader();
        P.addEventListener("loadend", () => {
          const U = P.result;
          t(U);
        }), P.readAsArrayBuffer(B);
      }, e);
    };
  });
}
function tl(b) {
  return b instanceof BABYLON.PBRMaterial;
}
function U1() {
  const b = new URL(window.location.href);
  return new URLSearchParams(b.search);
}
class Mw {
  constructor() {
    this.previewFiles = {};
  }
  downloadFiles() {
    function e(t, n) {
      return t.toLowerCase().indexOf(n, t.length - n.length) !== -1;
    }
    for (let t in this.previewFiles) {
      let n = null;
      const s = this.previewFiles[t];
      if (typeof s == "string" ? n = Qd(s) : n = s, n) {
        let o = null;
        if (e(t, ".jpeg") || e(t, ".jpg") ? o = { type: "image/jpeg" } : e(t, ".png") && (o = { type: "image/png" }), o) {
          let h = document.createElement("a");
          document.body.appendChild(h), h.setAttribute("type", "hidden"), h.download = t, h.href = window.URL.createObjectURL(new Blob([n], o)), h.click();
        }
      }
    }
  }
}
class lo {
  static async getPreviewsAsync(e, t, n, s, o = !0) {
    await e.whenReadyAsync();
    const h = new Cw(e, t, n, s), c = await h.getPreviewsAsync(o);
    return h.dispose(), c;
  }
  static async downloadPreviewsAsync(e, t, n, s) {
    (await lo.getPreviewsAsync(e, t, n, s)).downloadFiles();
  }
}
class Cw {
  constructor(e, t, n, s) {
    this._width = 256, this._height = 256, this._crop = !1, this._materials = [], this._localEngine = null, this._hostingScene = null, this._hostingSceneHelper = null, this._hostingMesh = null, this._scene = e, this._rootUrl = t, this._materialIDs = n, this._options = s || {}, this.setupPreviewSize(), this._options.crop != null && (this._crop = this._options.crop), this.readMaterials();
  }
  dispose() {
    this.disposeHostingScene(), this.disposeLocalEngine();
  }
  getLocalEngine() {
    if (!this._localEngine) {
      const e = document.createElement("canvas");
      e.id = "MaterialPreviewCanvas", e.width = 1024, e.height = 1024, this._localEngine = new BABYLON.Engine(e, !0, {
        premultipliedAlpha: !1,
        preserveDrawingBuffer: !0
      }), this._localEngine.setSize(this._width, this._height);
    }
    return this._localEngine;
  }
  disposeLocalEngine() {
    this._localEngine && this._localEngine.dispose();
  }
  disposeHostingScene() {
    this._hostingSceneHelper && (this._hostingSceneHelper.dispose(), this._hostingSceneHelper = null), this._hostingScene && (this._hostingScene.dispose(), this._hostingScene = null);
  }
  setupPreviewSize() {
    let e = this._options;
    e.width != null && e.height == null ? (this._width = e.width, this._height = e.width) : e.width == null && e.height != null ? (this._width = e.height, this._height = e.height) : e.width != null && e.height != null && (this._width = e.width, this._height = e.height);
  }
  readMaterials() {
    this._materialIDs.forEach((e) => {
      const t = this._scene.getMaterialByID(e);
      t && this._materials.push(t);
    });
  }
  async downloadPreviewsAsync() {
    (await this.getPreviewsAsync()).downloadFiles();
  }
  async getPreviewsAsync(e = !0) {
    const t = this.getLocalEngine();
    this._hostingScene = new BABYLON.Scene(t), this._hostingSceneHelper = new mi(this._hostingScene), this._hostingSceneHelper.setupCamera();
    const n = this._hostingScene.activeCamera;
    return n && (/firefox/i.test(navigator.userAgent) || new BABYLON.PassPostProcess("scale_pass", 4, n, BABYLON.Texture.BILINEAR_SAMPLINGMODE), new BABYLON.PassPostProcess("scale_pass", 2, n, BABYLON.Texture.BILINEAR_SAMPLINGMODE), new BABYLON.PassPostProcess("scale_pass", 1, n, BABYLON.Texture.BILINEAR_SAMPLINGMODE)), new Promise((s) => {
      const o = new BABYLON.CubeTexture(
        ci.Environment.EnvironmentTextureCDNUrl,
        this._hostingScene,
        null,
        !1,
        null,
        async () => {
          if (!this._hostingScene || !this._hostingSceneHelper)
            return;
          this._hostingScene.environmentTexture = o, this._hostingSceneHelper.setupLights(), this._hostingMesh = this._hostingSceneHelper.createSphere(null), this._hostingSceneHelper.adjustCamera(void 0, void 0, void 0, !1);
          const h = new Mw();
          for (let c = 0; c < this._materials.length; c++) {
            const _ = this._materials[c];
            await this.createMaterialPreviewFileAsync(_, h, e);
          }
          this.disposeHostingScene(), this.disposeLocalEngine(), s(h);
        },
        null,
        void 0,
        !0,
        void 0,
        !0
      );
    });
  }
  async createMaterialPreviewFileAsync(e, t, n = !0) {
    if (this._hostingScene && this._hostingSceneHelper && this._hostingMesh) {
      const s = e.serialize(), o = BABYLON.Material.Parse(s, this._hostingScene, this._rootUrl);
      if (o) {
        this._hostingMesh.material = o, await mi.whenMeshMaterialIsReady(this._hostingMesh), this._hostingScene.render();
        let h = await this._hostingSceneHelper.takeContentScreenshotAsync(this._width, this._height);
        if (this._crop) {
          const x = await Wh(h);
          x && (h = x);
        }
        let c = o.name.replace(/[^a-z0-9]/gi, "_").toLowerCase();
        c = this.getNextIncrementalName(c, ".png", t) + ".png", Logger.info("preview: " + c);
        let _ = h;
        n && (_ = Qd(h)), t.previewFiles[c] = _;
      }
    }
  }
  getNextIncrementalName(e, t, n) {
    let s = e;
    if (e) {
      let _, x = 0;
      for (; n.previewFiles.hasOwnProperty(s + t); ) {
        if (!_) {
          _ = e;
          var o = e.lastIndexOf("_");
          if (o > 0) {
            var h = e.substring(o + 1), c = parseInt(h);
            c.toString() === h && (_ = e.substring(0, o));
          }
        }
        x++, s = _ + "_" + x;
      }
    }
    return s;
  }
}
class Aw {
  constructor(e, t, n, s) {
    this._bias = 50, this._invertR = !1, this._invertG = !1, this._preBlurEnabled = !1, this._preBlur = 3, this._postBlurEnabled = !1, this._postBlur = 3, this._bevel = !0, this._intensity = 0.5, this._activeTextures = [], this._preBlurXTexture = null, this._preBlurYTexture = null, this._normalMapTexture = null, this._postBlurXTexture = null, this._postBlurYTexture = null, this._baseTexture = e, this._size = t, this._scene = s, this.init(n);
  }
  init(e) {
    for (this._bias = e.get("bias"), this._invertR = e.get("invertR"), this._invertG = e.get("invertG"), this._bevel = e.get("bevel"), this._intensity = e.get("intensity"), this._preBlurEnabled = e.get("preBlurEnabled"), this._preBlur = e.get("preBlur"), this._postBlurEnabled = e.get("postBlurEnabled"), this._postBlur = e.get("postBlur"); this._activeTextures.length > 0; )
      this._activeTextures.pop();
    this.updateTextures();
  }
  updateTextures() {
    let e = this.updatePreBlurTexture();
    e = this.updateNormalmapTexture(e), e = this.updatePostBlurTexture(e);
  }
  updatePreBlurTexture() {
    let e = this._baseTexture;
    return this._preBlurEnabled && (this._preBlurXTexture ? this._preBlurXTexture.baseTexture = this._baseTexture : this._preBlurXTexture = new so("preBlurX", this._size, this._scene, this._baseTexture, void 0, !1), this._preBlurXTexture.beginInit(), this._preBlurXTexture.blur = this._preBlur, this._preBlurXTexture.refreshRate = 0, this._preBlurXTexture.endInit(), this._activeTextures.push(this._preBlurXTexture), this._preBlurYTexture ? this._preBlurYTexture.baseTexture = this._preBlurXTexture : this._preBlurYTexture = new ao("preBlurY", this._size, this._scene, this._preBlurXTexture, void 0, !1), this._preBlurYTexture.beginInit(), this._preBlurYTexture.blur = this._preBlur, this._preBlurYTexture.refreshRate = 0, this._preBlurYTexture.endInit(), this._activeTextures.push(this._preBlurYTexture), e = this._preBlurYTexture), e;
  }
  updateNormalmapTexture(e) {
    return this._normalMapTexture ? this._normalMapTexture.baseTexture = e : this._normalMapTexture = new Yd("procNormal", this._size, this._scene, e, void 0, !1), this._normalMapTexture.beginInit(), this._normalMapTexture.bias = this._bias, this._normalMapTexture.invertR = this._invertR, this._normalMapTexture.invertG = this._invertG, this._normalMapTexture.bevel = this._bevel, this._normalMapTexture.intensity = this._intensity, this._normalMapTexture.refreshRate = 0, this._normalMapTexture.endInit(), this._activeTextures.push(this._normalMapTexture), this._normalMapTexture;
  }
  updatePostBlurTexture(e) {
    let t = e;
    return this._postBlurEnabled && (this._postBlurXTexture ? this._postBlurXTexture.baseTexture = e : this._postBlurXTexture = new so("postBlurX", this._size, this._scene, e, void 0, !1), this._postBlurXTexture && (this._postBlurXTexture.beginInit(), this._postBlurXTexture.blur = this._postBlur, this._postBlurXTexture.refreshRate = 0, this._postBlurXTexture.endInit(), this._activeTextures.push(this._postBlurXTexture), this._postBlurYTexture ? this._postBlurYTexture.baseTexture = this._postBlurXTexture : this._postBlurYTexture = new ao("postBlurY", this._size, this._scene, this._postBlurXTexture, void 0, !1), this._postBlurYTexture && (this._postBlurYTexture.beginInit(), this._postBlurYTexture.blur = this._postBlur, this._postBlurYTexture.refreshRate = 0, this._postBlurYTexture.endInit(), this._activeTextures.push(this._postBlurYTexture), t = this._postBlurYTexture))), t;
  }
  dispose() {
    this._preBlurXTexture && (this._preBlurXTexture.dispose(), this._preBlurXTexture = null), this._preBlurYTexture && (this._preBlurYTexture.dispose(), this._preBlurYTexture = null), this._normalMapTexture && (this._normalMapTexture.dispose(), this._normalMapTexture = null), this._postBlurXTexture && (this._postBlurXTexture.dispose(), this._postBlurXTexture = null), this._postBlurYTexture && (this._postBlurYTexture.dispose(), this._postBlurYTexture = null);
  }
  async getNormalMapTextureAsync(e, t) {
    return await this.updateAsync(e, t), this._activeTextures.length > 0 ? this._activeTextures[this._activeTextures.length - 1] : null;
  }
  async updateAsync(e, t) {
    if (this.init(t), this._activeTextures.length > 0) {
      this._activeTextures[0].baseTexture = e;
      for (var n = 0; n < this._activeTextures.length; n++)
        await this._activeTextures[n].isReadyAsync(), this._activeTextures[n].render();
    }
  }
}
class Tw {
  constructor(e, t, n, s) {
    this._baseTexture = e, this._size = t, this._scene = s, this._mask = new oo("mask", this._size, this._scene, this._baseTexture), this._mask.backColor = new BABYLON.Vector3(0, 0, 0), this._mask.foreColor = new BABYLON.Vector3(1, 1, 1), this._mask.refreshRate = 0, this._shadow = new oo("shadow", this._size, this._scene, this._baseTexture), this._shadow.backColor = new BABYLON.Vector3(0.1, 0.1, 0.1), this._shadow.foreColor = new BABYLON.Vector3(1, 1, 1), this._shadow.refreshRate = 0, this._shadowBlurX = new so("shadow_blurX", this._size, this._scene, this._shadow), this._shadowBlurX.blur = 5, this._shadowBlurX.refreshRate = 0, this._shadowBlurY = new ao("shadow_blurY", this._size, this._scene, this._shadowBlurX), this._shadowBlurY.blur = 5, this._shadowBlurY.refreshRate = 0, this._shadowMove = new pu("shadow_move", this._size, this._scene, this._shadowBlurY), this._shadowMove.offset = new BABYLON.Vector2(2.5, 2.5), this._shadowMove.refreshRate = 0, this._lightmap = new to("lightmap", this._size, this._scene, this._shadowMove, this._mask), this._lightmap.refreshRate = 0, this.updateParameters(n);
  }
  updateParameters(e) {
    if (e) {
      let t = new BABYLON.Vector3(0, 0, 0);
      if (e.get("color")) {
        const x = BABYLON.Color3.FromHexString(e.get("color"));
        t = new BABYLON.Vector3(x.r, x.g, x.b);
      }
      this._shadow.backColor = t;
      let n = 1, s = 135;
      e.get("angle") !== void 0 && e.get("angle") !== null && (s = e.get("angle")), e.get("distance") != null && e.get("distance") !== null && (n = e.get("distance"));
      let o = s * Math.PI / 180;
      o = this.wrapPi(o);
      const h = Math.cos(o) * n, c = Math.sin(o) * n;
      this._shadowMove.offset = new BABYLON.Vector2(-h, c);
      let _ = 5;
      e.get("size") !== void 0 && e.get("size") !== null && (_ = Math.max(0, Math.min(100, e.get("size")))), this._shadowBlurX.blur = _, this._shadowBlurY.blur = _;
    }
  }
  // riporta angle nel range -180, + 180
  wrapPi(e) {
    if (Math.abs(e) > Math.PI) {
      var t = 2 * Math.PI, n = Math.floor((e + Math.PI) * (1 / t));
      e -= n * t;
    }
    return e;
  }
  dispose() {
    this._mask.dispose(), this._shadow.dispose(), this._shadowBlurX.dispose(), this._shadowBlurY.dispose(), this._shadowMove.dispose(), this._lightmap.dispose();
  }
  async getInnerShadowTextureAsync(e) {
    return await this.updateAsync(e), this._lightmap;
  }
  async updateAsync(e, t) {
    this.updateParameters(t), this._baseTexture = e, await mi.whenTextureIsReadyAsync(this._baseTexture), this._mask.baseTexture = this._baseTexture, await this._mask.isReadyAsync(), this._mask.render(), this._shadow.baseTexture = this._baseTexture, await this._shadow.isReadyAsync(), this._shadow.render(), await this._shadowBlurX.isReadyAsync(), this._shadowBlurX.render(), await this._shadowBlurY.isReadyAsync(), this._shadowBlurY.render(), await this._shadowMove.isReadyAsync(), this._shadowMove.render(), await this._lightmap.isReadyAsync(), this._lightmap.render();
  }
  //private whenTextureIsReadyAsync(texture: BABYLON.Texture): Promise<void> {
  //    return new Promise<void>((resolve, reject) => {
  //        if (texture.isReady())
  //            resolve();
  //        else {
  //            let t = setInterval(() => {
  //                if (texture.isReady()) {
  //                    clearInterval(t);
  //                    resolve();
  //                }
  //            }, 5);
  //        }
  //    });
  //}
}
class Lw {
  constructor(e, t, n, s) {
    this._size = t, this._baseTexture = e, this._scene = s, this._shadow = new oo("shadow", this._size, this._scene, this._baseTexture), this._shadow.backColor = new BABYLON.Vector3(1, 1, 1), this._shadow.foreColor = new BABYLON.Vector3(0.2, 0.2, 0.2), this._shadow.refreshRate = 0, this._shadowBlurX = new so("shadow_blurX", this._size, this._scene, this._shadow), this._shadowBlurX.blur = 15, this._shadowBlurX.refreshRate = 0, this._shadowBlurY = new ao("shadow_blurY", this._size, this._scene, this._shadowBlurX), this._shadowBlurY.blur = 15, this._shadowBlurY.refreshRate = 0, this._shadowMove = new pu("shadow_move", this._size, this._scene, this._shadowBlurY), this._shadowMove.offset = new BABYLON.Vector2(2.5, 2.5), this._shadowMove.refreshRate = 0, this.updateParameters(n);
  }
  updateParameters(e) {
    if (e) {
      var t = new BABYLON.Vector3(0, 0, 0);
      if (e.get("color")) {
        var n = BABYLON.Color3.FromHexString(e.get("color"));
        t = new BABYLON.Vector3(n.r, n.g, n.b);
      }
      this._shadow.foreColor = t;
      let s = 1, o = 135;
      e.get("angle") !== void 0 && e.get("angle") !== null && (o = e.get("angle")), e.get("distance") != null && e.get("distance") !== null && (s = e.get("distance"));
      let h = o * Math.PI / 180;
      h = this.wrapPi(h);
      const c = Math.cos(h) * s, _ = Math.sin(h) * s;
      this._shadowMove.offset = new BABYLON.Vector2(-c, _);
      let x = 5;
      e.get("size") !== void 0 && e.get("size") !== null && (x = Math.max(0, Math.min(100, e.get("size")))), this._shadowBlurX.blur = x, this._shadowBlurY.blur = x;
    }
  }
  wrapPi(e) {
    if (Math.abs(e) > Math.PI) {
      var t = 2 * Math.PI, n = Math.floor((e + Math.PI) * (1 / t));
      e -= n * t;
    }
    return e;
  }
  dispose() {
    this._shadow.dispose(), this._shadowBlurX.dispose(), this._shadowBlurY.dispose(), this._shadowMove.dispose();
  }
  async getOuterShadowTextureAsync(e) {
    return await this.updateAsync(e), this._shadowMove;
  }
  async updateAsync(e, t) {
    this.updateParameters(t), this._baseTexture = e, await mi.whenTextureIsReadyAsync(this._baseTexture), this._shadow.baseTexture = this._baseTexture, await this._shadow.isReadyAsync(), this._shadow.render(), await this._shadowBlurX.isReadyAsync(), this._shadowBlurX.render(), await this._shadowBlurY.isReadyAsync(), this._shadowBlurY.render(), await this._shadowMove.isReadyAsync(), this._shadowMove.render();
  }
  //private whenTextureIsReadyAsync(texture: BABYLON.Texture): Promise<void> {
  //    return new Promise<void>((resolve, reject) => {
  //        if (texture.isReady())
  //            resolve();
  //        else {
  //            let t = setInterval(() => {
  //                if (texture.isReady()) {
  //                    clearInterval(t);
  //                    resolve();
  //                }
  //            }, 5);
  //        }
  //    });
  //}
}
globalThis && globalThis.__awaiter;
globalThis && globalThis.__generator;
function Oh(b, e, t) {
  e === void 0 && (e = 50), t === void 0 && (t = {
    isImmediate: !1
  });
  var n;
  return function() {
    for (var s = [], o = 0; o < arguments.length; o++)
      s[o] = arguments[o];
    var h = this, c = function() {
      n = void 0, t.isImmediate || b.apply(h, s);
    }, _ = t.isImmediate && n === void 0;
    n !== void 0 && clearTimeout(n), n = setTimeout(c, e), _ && b.apply(h, s);
  };
}
const Zf = /android/i.test(navigator.userAgent), qf = /iPad|iPhone|iPod/.test(navigator.userAgent) && !self.MSStream || navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1, eg = class As {
  constructor(e, t, n, s, o, h, c, _ = !0, x, B = 0) {
    this._subMesh = null, this._isRefreshing = !1, this._showDesign = !0, this._viewRotation = 0, this._designTextureResolution = 1024, this._effect = null, this._meshSide = null, this._side = null, this._isDisposed = !1, this._baseWidth = As.DEFAULT_SIZE, this._baseHeight = As.DEFAULT_SIZE, this._textureWidth = As.DEFAULT_SIZE, this._textureHeight = As.DEFAULT_SIZE, this._coordinatesIndex = 0, this._currentVisibliity = !0, this._canvasMesh = null, this._originalCanvasMeshPosition = null, this._originalCanvasMeshScaling = null, this._normalmapMaterial = null, this._originalMaterial = null, this._blankDataUrl = null, this._innerCanvasMesh = null, this._outerCanvasMesh = null, this._ownDynamicMaterial = !1, this._dynamicMaterial = null, this._dynamicTexture = null, this._normalmapTexture = null, this._dynamicOpacityTexture = null, this._ownOldDynamicMaterial = !1, this._oldDynamicMaterial = null, this._originalDiffuseTexture = null, this._combinedDiffuseTexture = null, this._originalMeshNormalmapTexture = null, this._originalDesignNormalmapTexture = null, this._meshCombinedNormalmapTexture = null, this._designCombinedNormalmapTexture = null, this._originalMeshLightmapTexture = null, this._originalDesignLightmapTexture = null, this._meshCombinedLightmapTexture = null, this._designCombinedLightmapTexture = null, this._innerShadowTexture = null, this._outerShadowTexture = null, this._context = null, this._canvas = null, this._canvasID = Zakeke.generateUUID(), this._customizer = null, this._renderingNeededListeners = [], this._proceduralNormalMap = null, this._innerShadowGenerator = null, this._outerShadowGenerator = null, this._debouncedUpdateDynamicTexture = null, this._originalViewMatrixValues = null, this._grids = [], this._lastUpdateTextureWasDynamic = !0, this.isFirstRender = !0, this._scene = e, this._sceneHelper = new mi(e), this._zkScene = t, this._mesh = n, this._subMesh = s, this._zkModel = o, this._zkDesign = h, this._grids = c, this._showDesign = _, this._viewRotation = B, x && (this._effect = x);
  }
  get showDesign() {
    return this._showDesign;
  }
  set showDesign(e) {
    this._showDesign != e && (this._showDesign = e);
  }
  get rotation() {
    return this._viewRotation;
  }
  set rotation(e) {
    this._viewRotation != e && (this._viewRotation = e);
  }
  get side() {
    return this._side;
  }
  // Temporary until we can access internal matrix (speak with Matteo)
  getInternalCustomizer() {
    return this._customizer;
  }
  // Factory method for async object creation and initialization
  static async createMeshDesignManagerAsync(e, t, n, s, o, h, c, _ = !0, x, B = 0) {
    const P = new As(
      e,
      t,
      n,
      s,
      o,
      h,
      c,
      _,
      x,
      B
    );
    return await P.initAsync(), P;
  }
  async initAsync() {
    const e = this._zkScene.get("rootUrl");
    e && await this._sceneHelper.unsetMeshDummyMaterialAsync(this._mesh, e, !0), this.setupMeshSide(), this.setupTextureSize(), this.checkDefaultEffect(), this.refreshModelSide(), await this.setupClonedObjectsAsync(), await this.setupCanvasAsync(), await this.setupDynamicMaterialAsync(), await this.refreshAsync();
  }
  isForMesh(e, t) {
    return !e || !this._mesh || e.id !== this._mesh.id ? !1 : !this._subMesh && !t ? !0 : !this._subMesh || !t ? !1 : t.materialIndex === this._subMesh.materialIndex;
  }
  getMeshID() {
    return this._mesh ? this._mesh.id : null;
  }
  getSubMeshIdx() {
    return this._subMesh ? this._subMesh.materialIndex : 0;
  }
  getMaterialIDForDesign() {
    let e;
    return this._effect && this._effect.get("materialID") ? e = this._effect.get("materialID") : this._mesh && this._mesh.metadata && this._mesh.metadata.designMaterialID ? e = this._mesh.metadata.designMaterialID : this._meshSide && this._meshSide.get("materialID") && (e = this._meshSide.get("materialID")), e;
  }
  getDesignConfig() {
    let e;
    return this._effect && this._effect.get("config") ? e = this._effect.get("config") : this._meshSide && this._meshSide.get("config") && (e = this._meshSide.get("config")), e || (e = new MPlaza.MeshDesignConfig()), e;
  }
  dispose() {
    this._isDisposed = !0, this._customizer && (this._customizer.clearMemoryForIOS(), this._customizer = null), this.disposeOuterInnerCanvasMeshes(), this._canvasMesh && (this._canvasMesh.dispose(), this._canvasMesh = null, this._originalCanvasMeshPosition = null, this._originalCanvasMeshScaling = null), this.disposeDynamicMaterial(), this._dynamicOpacityTexture && (this._dynamicOpacityTexture.dispose(), this._dynamicOpacityTexture = null), this._dynamicTexture && (this._dynamicTexture.dispose(), this._dynamicTexture = null), this._renderingNeededListeners = [], $("#" + this._canvasID).remove(), this.restoreOrignalMaterial(), this.disposeNormalmapMaterial(), this._proceduralNormalMap && (this._proceduralNormalMap.dispose(), this._proceduralNormalMap = null), this._innerShadowGenerator && (this._innerShadowGenerator.dispose(), this._innerShadowGenerator = null), this._combinedDiffuseTexture && (this._combinedDiffuseTexture.dispose(), this._combinedDiffuseTexture = null), this._meshCombinedNormalmapTexture && (this._meshCombinedNormalmapTexture.dispose(), this._meshCombinedNormalmapTexture = null), this._designCombinedNormalmapTexture && (this._designCombinedNormalmapTexture.dispose(), this._designCombinedNormalmapTexture = null), this._meshCombinedLightmapTexture && (this._meshCombinedLightmapTexture.dispose(), this._meshCombinedLightmapTexture = null), this._designCombinedLightmapTexture && (this._designCombinedLightmapTexture.dispose(), this._designCombinedLightmapTexture = null);
  }
  disposeOuterInnerCanvasMeshes() {
    this._innerCanvasMesh && (this._innerCanvasMesh.dispose(), this._innerCanvasMesh = null), this._outerCanvasMesh && (this._outerCanvasMesh.dispose(), this._outerCanvasMesh = null);
  }
  disposeNormalmapMaterial() {
    this._normalmapMaterial && this._originalMaterial && this._normalmapMaterial.id !== this._originalMaterial.id && this._sceneHelper.getMeshesUsingMaterial(this._normalmapMaterial.id).length == 0 && (this._normalmapMaterial.dispose(), this._normalmapMaterial = null), this._originalMeshNormalmapTexture = null, this._originalMeshLightmapTexture = null;
  }
  disposeDynamicMaterial() {
    this._ownDynamicMaterial && this._dynamicMaterial && this._dynamicMaterial.dispose(), this._dynamicMaterial = null, this._originalDesignNormalmapTexture = null, this._originalDesignLightmapTexture = null;
  }
  disposeOldDynamicMaterial() {
    this._ownOldDynamicMaterial && this._oldDynamicMaterial && this._dynamicMaterial && this._oldDynamicMaterial != this._dynamicMaterial && this._oldDynamicMaterial.dispose(), this._oldDynamicMaterial = null;
  }
  createCanvasMeshClone(e) {
    if (this._canvasMesh) {
      const t = this._canvasMesh.clone(e + " - clone outer", null);
      if (t)
        return t.id = Zakeke.generateUUID(), this._canvasMesh.metadata && this._canvasMesh.metadata.AR !== void 0 && this._canvasMesh.metadata.AR !== null && (t.metadata || (t.metadata = {}), t.metadata.AR = this._canvasMesh.metadata.AR), t;
    }
    return null;
  }
  expandCanvasMesh(e) {
    if (!this._mesh || !this._canvasMesh)
      return;
    this.disposeOuterInnerCanvasMeshes();
    const t = this.getMeshHierarchySize(this._mesh), n = this.getMeshHierarchySize(this._canvasMesh);
    if (!t.equals(n))
      return;
    let s = 4e-3;
    e && (s += e);
    const o = 0.2;
    if (this._outerCanvasMesh = this.createCanvasMeshClone(this._mesh.name + " outer clone"), this._canvasMesh.isVisible = !1, this._outerCanvasMesh)
      if (Math.abs(t.x) <= 0.01 || Math.abs(t.y) <= 0.01 || Math.abs(t.z) <= 0.01) {
        const x = this._mesh.getVerticesData(BABYLON.VertexBuffer.NormalKind), B = BABYLON.Vector3.FromArray(
          x,
          0
        ).normalize();
        this._outerCanvasMesh.position = this._outerCanvasMesh.position.add(B.scale(o));
      } else {
        const x = [...this._canvasMesh.getVerticesData(BABYLON.VertexBuffer.PositionKind)], B = [...this._canvasMesh.getVerticesData(BABYLON.VertexBuffer.NormalKind)];
        for (var h = 0; h < x.length; h += 3) {
          const M = new BABYLON.Vector3(B[h], B[h + 1], B[h + 2]), Z = new BABYLON.Vector3(
            x[h] + M.x * s,
            x[h + 1] + M.y * s,
            x[h + 2] + M.z * s
          );
          x[h] = Z.x, x[h + 1] = Z.y, x[h + 2] = Z.z;
        }
        const P = BABYLON.VertexData.ExtractFromMesh(this._canvasMesh, !0, !0);
        P.positions = x;
        const U = new BABYLON.Geometry(this._canvasMesh.name + " outer geometry", this._scene);
        P.applyToGeometry(U), U.applyToMesh(this._outerCanvasMesh), this._scene.render();
      }
  }
  // Nel caso in cui la mesh non sia un piano, espande la mesh clone in modo che
  // racchiuda quella originale e che eviti il problema z- fighting.
  // Nel caso in cui si tratti di un piano (o di un disco o equivalenti), la mesh clone verrà solo
  // spostata leggermente nella direzione della normale al piano
  // Tale possibilità verrà sfruttata soprattutto in fase di esportazione in altro formato che non preveda
  // proprietà simili al zOffset di Babylon JS
  expandCanvasMesh_old() {
    if (!this._mesh || !this._canvasMesh)
      return;
    const e = 0.01, t = 1 + e, n = this.getMeshHierarchySize(this._mesh), s = this.getMeshHierarchySize(this._canvasMesh);
    if (!n.equals(s))
      return;
    const o = 0.1;
    if (Math.abs(n.x) <= o || Math.abs(n.y) <= o || Math.abs(n.z) <= o) {
      let c = this._mesh.getVerticesData(BABYLON.VertexBuffer.NormalKind), _ = BABYLON.Vector3.FromArray(
        c,
        0
      ).normalize();
      this._canvasMesh.position = this._canvasMesh.position.add(_.scale(e));
    } else {
      let c = this._canvasMesh.scaling;
      c = c.multiplyByFloats(t, t, t), this._canvasMesh.scaling = c;
      let _ = this.getMeshHierarchyCenter(this._mesh), x = this.getMeshHierarchyCenter(this._canvasMesh);
      const B = _.subtract(x);
      B.equals(BABYLON.Vector3.Zero()) || this._canvasMesh.position.addInPlace(B);
    }
  }
  contractCanvasMesh() {
    this._canvasMesh && (this._canvasMesh.isVisible = !0), this.disposeOuterInnerCanvasMeshes();
  }
  // Riporta la mesh clone allo stato originale, continuando a sfruttare unicamente la proprietà
  // zOffset per superare il problema dello z-fighting
  contractCanvasMesh_old() {
    if (!this._mesh || !this._canvasMesh || !this._originalCanvasMeshScaling || !this._originalCanvasMeshPosition)
      return;
    this._canvasMesh.scaling = this._originalCanvasMeshScaling, this._canvasMesh.position = this._originalCanvasMeshPosition;
    const e = this.getMeshHierarchyCenter(this._mesh), t = this.getMeshHierarchyCenter(this._canvasMesh), n = e.subtract(t);
    n.equals(BABYLON.Vector3.Zero()) || this._canvasMesh.position.addInPlace(n);
  }
  setupMeshSide() {
    if (this._meshSide = null, this._coordinatesIndex = 0, this._zkModel && this._mesh && this._mesh.id)
      for (let n = 0; n < this._zkModel.get("scenes").length; n++) {
        var e = this._zkModel.get("scenes").at(n);
        if (e.get("isDefault"))
          for (let s = 0; s < e.get("meshSides").length; s++) {
            var t = e.get("meshSides").at(s);
            if (t.get("meshID") == this._mesh.id) {
              this._meshSide = t, this._meshSide.get("uvChannel") >= 0 && (this._coordinatesIndex = this._meshSide.get("uvChannel"));
              return;
            }
          }
      }
  }
  setupTextureSize() {
    this._meshSide && (!Zf && !qf ? (this._baseWidth = this._meshSide.getOrCreateConfig().getDesktopTextureResolutionWidth() ?? As.DEFAULT_SIZE, this._baseHeight = this._meshSide.getOrCreateConfig().getDesktopTextureResolutionHeight() ?? As.DEFAULT_SIZE) : Zf ? (this._baseWidth = this._meshSide.getOrCreateConfig().getMobileTextureResolutionWidth() ?? As.DEFAULT_SIZE, this._baseHeight = this._meshSide.getOrCreateConfig().getMobileTextureResolutionHeight() ?? As.DEFAULT_SIZE) : qf && (this._baseWidth = 512, this._baseHeight = 512)), console.log("Texture size: " + this._baseWidth + "x" + this._baseHeight);
  }
  checkDefaultEffect() {
    if (!this._effect && this._meshSide) {
      var e = this._meshSide.getParentModel();
      if (e && e instanceof MPlaza.ModelScene) {
        let t = this.getMeshID();
        if (t) {
          let n = e.getDefaultDesignEffect(t, this.getSubMeshIdx());
          n && (this._effect = n);
        }
      }
    }
  }
  getAllSides() {
    const e = [];
    return this._zkModel.get("colors").each((t) => {
      t.get("sides").each((n) => {
        e.find((s) => s.get("sideID") == n.get("sideID")) || e.push(n);
      });
    }), e;
  }
  // Recupera il lato del modello corrispondente alla mesh in input
  // Del lato abbiamo solo sideID, mentre per il modello i lati sono per colore. Recuperiamo il colorID
  // in base agli elementi del design, considerando buono il primo colore con elementi grafici
  refreshModelSide() {
    if (this._side = null, this._meshSide && this._zkDesign) {
      const e = this._meshSide.get("sideID"), t = this._meshSide.tempID;
      let n = null;
      if (n = this.getAllSides().find(function(s) {
        return s.get("sideID") == e;
      }) || null, n) {
        let s = null;
        for (const o of this._zkDesign.get("designItems").models)
          if (s = o, s.isOnSide(n)) {
            const h = s && s.get("areas").length > 0 ? s.get("areas").at(0).get("colorID") : null;
            h && this._zkModel.get("colors").each(function(c) {
              c.get("colorID") == h && c.get("sides").each(function(_) {
                (_.tempID ? _.tempID == t : _.get("sideID") == e) && (n = _);
              });
            });
            break;
          }
        this._side = n;
      }
    }
  }
  async setupClonedObjectsAsync() {
    if (this._side) {
      for (var e = 0; e < this._scene.meshes.length; e++) {
        let t = this._scene.meshes[e];
        if (t && t.metadata && t.metadata.originalMeshID && t.metadata.originalMeshID == this._mesh.id) {
          this._canvasMesh = t, this._canvasMesh.isVisible = this._currentVisibliity, this._normalmapMaterial = this._mesh.material, this._originalMeshNormalmapTexture = this.getMaterialNormalmap(this._normalmapMaterial), this._originalMeshLightmapTexture = this.getMaterialLightmap(this._normalmapMaterial);
          break;
        }
      }
      if (!this._canvasMesh) {
        let t = this._mesh.name + " - clone";
        this._canvasMesh = this._mesh.clone(t, null), this._canvasMesh && (this._canvasMesh.id = Zakeke.generateUUID(), this._canvasMesh.isVisible = this._currentVisibliity, this._canvasMesh.doNotSerialize = !0, this._canvasMesh.isPickable = !1, this._canvasMesh.metadata = {}, this._canvasMesh.metadata.originalMeshID = this._mesh.id, this._canvasMesh.metadata.isRealMesh = !1, this._canvasMesh.metadata.iscanvasMesh = !0, this._mesh.metadata && this._mesh.metadata.AR !== void 0 && this._mesh.metadata.AR !== null && (this._canvasMesh.metadata.AR = this._mesh.metadata.AR));
      }
      this._canvasMesh && (this._originalCanvasMeshPosition = this._canvasMesh.position, this._originalCanvasMeshScaling = this._canvasMesh.scaling), this._normalmapMaterial || await this.setupNormalmapMaterialAsync();
    }
  }
  // Prepara il materiale per la normalmap da applicare alla mesh originale
  // posizionata sotto quella su cui è apposto il design.
  // Tale materiale viene utilizzato anche per l'eventuale lightmap di dropshadow (outer shadow)
  // quindi il nome andrebbe cambiato
  async setupNormalmapMaterialAsync() {
    this.disposeNormalmapMaterial(), this._originalMaterial = this._mesh.material;
    let e = Zakeke.generateUUID(), t = "normalmapMaterial - " + e;
    this._originalMaterial ? (t = this._originalMaterial.name + " - normalmap", this._normalmapMaterial = await this.cloneMaterialAsync(this._originalMaterial, t)) : this._normalmapMaterial = new BABYLON.StandardMaterial(t, this._scene), this._normalmapMaterial && (this._normalmapMaterial.id = e, this._normalmapMaterial.doNotSerialize = !0, this._normalmapMaterial.metadata = {}, this._originalMaterial ? this._normalmapMaterial.metadata.originalMaterialID = this._originalMaterial.id : this._normalmapMaterial.metadata.originalMaterialID = null, this._normalmapMaterial.metadata.isRealMaterial = !1, this._originalMeshNormalmapTexture = this.getMaterialNormalmap(this._normalmapMaterial), this._originalMeshLightmapTexture = this.getMaterialLightmap(this._normalmapMaterial));
  }
  // private getOriginalTexture(): BABYLON.Texture | null {
  //     if (this._originalMaterial) {
  //         var propertyName = this.getMaterialDiffuseTexturePropertyName(this._originalMaterial);
  //         if (!this._originalMaterial[propertyName])
  //             return null;
  //         return this._originalMaterial[propertyName];
  //     }
  //     return null;
  // }
  getMaterialDiffuseTexturePropertyName(e) {
    return e instanceof BABYLON.StandardMaterial ? "diffuseTexture" : e instanceof BABYLON.PBRMetallicRoughnessMaterial ? "baseTexture" : e instanceof BABYLON.PBRSpecularGlossinessMaterial ? "diffuseTexture" : e instanceof BABYLON.PBRMaterial || e instanceof Zakeke.PBRMaterial ? "albedoTexture" : "diffuseTexture";
  }
  getMaterialOpacityTexturePropertyName(e) {
    return e instanceof BABYLON.StandardMaterial ? "opacityTexture" : e instanceof BABYLON.PBRMetallicRoughnessMaterial || e instanceof BABYLON.PBRSpecularGlossinessMaterial ? null : (e instanceof BABYLON.PBRMaterial || e instanceof Zakeke.PBRMaterial, "opacityTexture");
  }
  getMaterialNormalmapTexturePropertyName(e) {
    return e instanceof BABYLON.StandardMaterial ? "bumpTexture" : e instanceof BABYLON.PBRMetallicRoughnessMaterial || e instanceof BABYLON.PBRSpecularGlossinessMaterial ? "normalTexture" : (e instanceof BABYLON.PBRMaterial || e instanceof Zakeke.PBRMaterial, "bumpTexture");
  }
  getMaterialLightmapTexturePropertyName(e) {
    return e instanceof BABYLON.StandardMaterial ? "ambientTexture" : e instanceof BABYLON.PBRMetallicRoughnessMaterial || e instanceof BABYLON.PBRSpecularGlossinessMaterial ? "occlusionTexture" : e instanceof BABYLON.PBRMaterial ? "ambientTexture" : e instanceof Zakeke.PBRMaterial ? "aoTexture" : "lightmapTexture";
  }
  getMaterialDiffuse(e) {
    let t = this.getMaterialDiffuseTexturePropertyName(e);
    return e[t];
  }
  getMaterialNormalmap(e) {
    if (!e)
      return null;
    let t = this.getMaterialNormalmapTexturePropertyName(e);
    return e[t];
  }
  getMaterialLightmap(e) {
    if (!e)
      return null;
    let t = this.getMaterialLightmapTexturePropertyName(e);
    return e[t];
  }
  getMaterialOpacity(e) {
    if (!e)
      return null;
    let t = this.getMaterialOpacityTexturePropertyName(e);
    return t ? e[t] : null;
  }
  setMaterialLightmap(e, t) {
    if (e) {
      var n = this.getMaterialLightmapTexturePropertyName(e);
      n && (e[n] = t, e instanceof Zakeke.PBRMaterial && (e.useAOTextureAsLightmap = !0));
    }
  }
  setTextureWrapping(e) {
    e && (e.wrapU = BABYLON.Texture.CLAMP_ADDRESSMODE, e.wrapV = BABYLON.Texture.CLAMP_ADDRESSMODE);
  }
  async setupCanvasAsync() {
    if (this._side && this._canvasMesh && this._meshSide && !this._isRefreshing) {
      this._isRefreshing = !0;
      var e = this._baseWidth;
      this._meshSide.get("percWidth") > 0 && (e *= this._meshSide.get("percWidth"));
      var t = this._baseHeight;
      this._meshSide.get("percHeight") > 0 && (t *= this._meshSide.get("percHeight")), this._textureWidth = e, this._textureHeight = t;
      var n = $("<canvas>", { id: this._canvasID }).attr({ width: e, height: t });
      this._canvas = n[0], this._context = this._canvas.getContext("2d"), this._context && (this._context.imageSmoothingQuality = "high", this._context.imageSmoothingEnabled = !0, this._customizer = new MPlaza.Customizer(!0, !1, this._canvas, !0), this._blankDataUrl = this._canvas.toDataURL(), this._customizer.showSideImage = !1, this._customizer.model = this._zkModel, this._customizer.fitToScreenMargin = this._zkScene.getFitToScreenMargin(), this._customizer.setGrids(this._grids), this._customizer.setDesign(this._zkDesign), await new Promise(async (s) => {
        var o, h;
        await ((o = this._customizer) == null ? void 0 : o.setSide(this._side)), (h = this._customizer) == null || h.refresh({ boundsToAreas: !0 }, async () => {
          if (this._customizer) {
            if (this._meshSide) {
              let c = this._meshSide.get("matrix");
              if (c) {
                const _ = JSON.parse(c);
                let x = new this._customizer.paper.Matrix(_);
                this._customizer.paper.view.matrix = x, this._customizer.paper.view.update();
              }
            }
            await this.updateDynamicTextureAsync();
          }
          s();
        });
      }));
    }
    this._isRefreshing = !1;
  }
  setCustomizerGrids(e) {
    var t;
    this._grids = e, (t = this._customizer) == null || t.setGrids(e);
  }
  // Ripristino il materiale originale sulla mesh, a meno che non sia stato già cambiato
  restoreOrignalMaterial() {
    this._mesh && this._originalMaterial && this._mesh.material && this._normalmapMaterial && this._mesh.material.id === this._normalmapMaterial.id && (this._mesh.material = this._originalMaterial);
  }
  getMeshesUsingMaterial(e) {
    for (var t = [], n = this._scene.meshes, s = 0; s < n.length; s++) {
      var o = n[s];
      if (o.material) {
        if (o.material.id == e)
          t.push(o);
        else if (o.material instanceof BABYLON.MultiMaterial)
          for (var h = 0; h < o.material.subMaterials.length; h++) {
            let c = o.material.subMaterials[h];
            if (c != null && c.id === e) {
              t.push(o);
              break;
            }
          }
      }
    }
    return t;
  }
  async checkNormalmapMaterialAsync() {
    this._mesh && this._normalmapMaterial && (!this._mesh.material || this._mesh.material.id !== this._normalmapMaterial.id) && await this.setupNormalmapMaterialAsync();
  }
  // Se il materiale associato alla mesh è cambiato lo ricrea
  async checkDynamicMaterialAsync() {
    let e = this.getMaterialIDForDesign();
    e && this._side && this._canvasMesh && this._meshSide && this._dynamicMaterial && this._dynamicMaterial.id != e && await this.setupDynamicMaterialAsync();
  }
  async setupDynamicMaterialAsync() {
    if (this._side && this._canvasMesh && this._meshSide) {
      this._ownOldDynamicMaterial = this._ownDynamicMaterial, this._oldDynamicMaterial = this._dynamicMaterial;
      var e = this.getMaterialIDForDesign();
      if (e) {
        this._zkScene.get("rootUrl") && await this._sceneHelper.loadDelayedMaterialAsync(this._zkScene.get("rootUrl"), e);
        let t = this._scene.getMaterialById(e);
        t && (this._dynamicMaterial = await this.cloneMaterialAsync(t, t.name + " - clone"), this._ownDynamicMaterial = !0);
      }
      if (!this._dynamicMaterial) {
        if (this._mesh.material && this._mesh.material instanceof BABYLON.PBRBaseMaterial) {
          const t = new BABYLON.PBRMaterial(
            "dynamicMaterial",
            this._scene
          );
          t.enableSpecularAntiAliasing = !0, t.backFaceCulling = !1, t.albedoColor = BABYLON.Color3.White(), t.reflectivityColor = BABYLON.Color3.Black(), t.transparencyMode = this._zkScene.getDefaultDesignMaterialTransparencyMode(), t.useAlphaFromAlbedoTexture = !0, this._mesh.material.subSurface.indexOfRefraction != null && (t.subSurface.indexOfRefraction = this._mesh.material.subSurface.indexOfRefraction), tl(this._mesh.material) && this._mesh.material.roughness != null && (t.roughness = this._mesh.material.roughness), tl(this._mesh.material) && this._mesh.material.metallic != null && (t.metallic = this._mesh.material.metallic), tl(this._mesh.material) && this._mesh.material.reflectionTexture != null && (t.reflectionTexture = this._mesh.material.reflectionTexture), tl(this._mesh.material) && this._mesh.material.microSurface != null && (t.microSurface = this._mesh.material.microSurface), this._dynamicMaterial = t;
        } else
          this._dynamicMaterial = new BABYLON.StandardMaterial("dynamicMaterial", this._scene), this._dynamicMaterial.backFaceCulling = !1, this._dynamicMaterial.specularColor = BABYLON.Color3.Black(), this._dynamicMaterial.ambientColor = BABYLON.Color3.White(), this._dynamicMaterial.diffuseColor = BABYLON.Color3.White();
        this._dynamicMaterial.id = Zakeke.generateUUID(), this._ownDynamicMaterial = !0;
      }
      this._dynamicMaterial.zOffset = -1, this._dynamicMaterial.metadata = { isRealMaterial: !1 }, this._dynamicMaterial.doNotSerialize = this._ownDynamicMaterial, this._originalDiffuseTexture = this.getMaterialDiffuse(this._dynamicMaterial), this._originalDesignNormalmapTexture = this.getMaterialNormalmap(this._dynamicMaterial), this._originalDesignLightmapTexture = this.getMaterialLightmap(this._dynamicMaterial);
    }
  }
  /*
      private whenTextureIsReadyAsync(texture: BABYLON.BaseTexture): Promise<void> {
          return new Promise<void>((resolve, reject) => {
  
              let t = setInterval(() => {
                  if (texture.isReady()) {
                      clearInterval(t);
                      if (texture instanceof BABYLON.ProceduralTexture)
                          texture.getEffect();
                      resolve();
                  }
              }, 5);
  
          });
      }
      */
  async cloneMaterialAsync(e, t) {
    if (e) {
      var n = e.getActiveTextures();
      n.forEach(async (o) => {
        await mi.whenTextureIsReadyAsync(o);
      });
      var s = t || e.name + " - clone";
      if (e instanceof BABYLON.ShaderMaterial) {
        const o = this._zkScene.get("rootUrl");
        if (!o)
          return null;
        let h = e.serialize();
        return BABYLON.Material.Parse(h, this._scene, o);
      } else
        return e.clone(s);
    }
    return null;
  }
  getMeshHierarchySize(e) {
    let t = e.getHierarchyBoundingVectors(!0);
    return t.max.subtract(t.min);
  }
  getMeshHierarchyCenter(e) {
    let t = e.getHierarchyBoundingVectors(!0), n = t.max.subtract(t.min);
    return t.min.add(n.scale(0.5));
  }
  async refreshAsync(e) {
    this._isRefreshing || (this._isRefreshing = !0, typeof e < "u" && (this._effect = e), await this.checkDynamicMaterialAsync(), await this.checkNormalmapMaterialAsync(), this.refreshModelSide(), await new Promise(async (t) => {
      var n, s, o;
      if (this._meshSide && this.side && this._customizer) {
        if (await ((n = this._customizer) == null ? void 0 : n.setSide(this.side)), await ((s = this._customizer) == null ? void 0 : s.updateGrids()), (o = this._customizer) == null || o.adaptZoomToSideAreas(!1), this._meshSide && this._customizer) {
          let h = this._meshSide.get("matrix");
          if (h) {
            const c = JSON.parse(h);
            let _ = new this._customizer.paper.Matrix(c);
            if (this._customizer.paper.view.matrix = _, this._customizer.paper.view.rotation += -this._viewRotation, this._textureWidth !== 1024) {
              const x = 1024 / this._textureWidth;
              let B = new paper.Matrix();
              B = B.scale(1 / x, 1 / x);
              const P = _.prepend(B);
              this._customizer.paper.view.matrix = P;
            }
          } else
            this._customizer.paper.view.rotation = -this._viewRotation;
          this._customizer.paper.view.update();
        }
        await this.updateDynamicTextureAsync(), t();
      } else
        t();
    }), this._isRefreshing = !1);
  }
  async updateDynamicTextureAsync() {
    if (this.isFirstRender) {
      await this.updateDynamicTextureInternalAsync(), this.isFirstRender = !1;
      return;
    }
    this._debouncedUpdateDynamicTexture || (this._debouncedUpdateDynamicTexture = Oh(this.updateDynamicTextureInternalAsync, 10)), this._debouncedUpdateDynamicTexture();
  }
  async updateDynamicTextureInternalAsync(e = !0) {
    if (Logger.info("updateDynamicTextureInternal"), !this._side || !this._meshSide || !this._canvas || !this._canvasMesh || !this._dynamicMaterial)
      return;
    const t = this.getDesignConfig(), n = this._lastUpdateTextureWasDynamic != e;
    this._lastUpdateTextureWasDynamic = e, await this.checkDynamicMaterialAsync(), await this.checkNormalmapMaterialAsync();
    let s = t.getDiffuseEnabled(), o = t.getDiffuseBlendMode(), h = t.getDiffuseLevel();
    o !== "normal" && o !== "multiply" && o !== "overlay" && (o = "normal");
    const c = t.getOpacityEnabled();
    t.getOrCreateOpacityConfig();
    const _ = t.getNormalmapEnabled(), x = t.getOrCreateNormalmapConfig(), B = t.getInnerShadowEnabled(), P = t.getOrCreateInnerShadowConfig(), U = t.getOuterShadowEnabled(), M = t.getOrCreateOuterShadowConfig();
    let Z = "diffuseTexture";
    const F = this._meshSide.get("materialTexture");
    F ? Z = F : Z = this.getMaterialDiffuseTexturePropertyName(this._dynamicMaterial);
    let Q = this.getMaterialOpacityTexturePropertyName(this._dynamicMaterial), D = this._dynamicTexture;
    n && D && (D.dispose(), this._dynamicTexture = null);
    let te = this._canvas.toDataURL(), ee = te == this._blankDataUrl, le = this.dataURItoBlob(te), X = (window.URL || window.webkitURL).createObjectURL(le);
    this._dynamicTexture || (e ? (this._dynamicTexture = new BABYLON.DynamicTexture("dynamicTexture", this._canvas, this._scene), this._dynamicTexture.hasAlpha = !0) : (this._dynamicTexture = new BABYLON.Texture(X, this._scene), this._dynamicTexture.hasAlpha = !0)), e ? this._dynamicTexture.update() : await mi.whenTextureIsReadyAsync(this._dynamicTexture), !ee && this._dynamicTexture && (_ && await this.updateNormalmapTextureAsync(x), B && await this.updateInnerShadowTextureAsync(P), U && await this.updateOuterShadowTextureAsync(M), c && await this.updateOpacityTextureAsync(), this._originalDiffuseTexture && s && o !== "normal" && await this.combineDiffuseTexturesAsync(o, h), this._showDesign && (s && Z && (o === "normal" || !this._originalDiffuseTexture || !this._combinedDiffuseTexture ? (this._dynamicTexture.coordinatesIndex = this._coordinatesIndex, this.setTextureWrapping(this._dynamicTexture), this._dynamicMaterial[Z] = this._dynamicTexture) : this._combinedDiffuseTexture && (this._combinedDiffuseTexture.coordinatesIndex = this._coordinatesIndex, this.setTextureWrapping(this._combinedDiffuseTexture), this._dynamicMaterial[Z] = this._combinedDiffuseTexture), this._dynamicMaterial[Z].hasAlpha = !1, this._dynamicMaterial[Z].hasAlpha = !0), !s && Z && !this.compareTextures(
      this._dynamicMaterial[Z],
      this._originalDiffuseTexture
    ) && (this._dynamicMaterial[Z] = this._originalDiffuseTexture), c && Q && this._dynamicOpacityTexture && (this._dynamicOpacityTexture.coordinatesIndex = this._coordinatesIndex, this.setTextureWrapping(this._dynamicOpacityTexture), this._dynamicMaterial instanceof BABYLON.ShaderMaterial ? this._dynamicMaterial.setTexture(
      Q,
      this._dynamicOpacityTexture
    ) : this._dynamicMaterial[Q] = this._dynamicOpacityTexture), !c && Q && (this._dynamicMaterial[Q] = null), this._canvasMesh.material !== this._dynamicMaterial && (this._canvasMesh.material = this._dynamicMaterial), _ && this._normalmapTexture ? await this.setNormalmapTextureAsync(x) : (this.resetMeshNormalmapTexture(), this.resetDesignNormalmapTexture()), B && this._innerShadowTexture ? await this.setInnerShadowTextureAsync(P) : this.removeInnerShadowTexture(), U && this._outerShadowTexture ? await this.setOuterShadowTextureAsync(M) : this.removeOuterShadowTexture(), this.disposeOldDynamicMaterial(), this._canvasMesh.isVisible = this._currentVisibliity && t.getShowDesign())), ee && (this._canvasMesh.isVisible = !1), this.fireRenderingNeededEvent();
  }
  resetDynamicTextures() {
    if (this._dynamicMaterial) {
      let e = "diffuseTexture";
      const t = this._meshSide ? this._meshSide.get("materialTexture") : null;
      t ? e = t : e = this.getMaterialDiffuseTexturePropertyName(this._dynamicMaterial), e && !this.compareTextures(
        this._dynamicMaterial[e],
        this._originalDiffuseTexture
      ) && (this._dynamicMaterial[e] = this._originalDiffuseTexture || new BABYLON.Texture(this._blankDataUrl, this._scene), this._dynamicMaterial[e].hasAlpha = !1, this._dynamicMaterial[e].hasAlpha = !0), this.resetDesignNormalmapTexture();
      let n = this.getMaterialOpacityTexturePropertyName(this._dynamicMaterial);
      n && (this._dynamicMaterial[n] = null), this.removeInnerShadowTexture();
    }
    this._normalmapMaterial && (this.resetMeshNormalmapTexture(), this.removeOuterShadowTexture());
  }
  async updateOpacityTextureAsync() {
    this._dynamicTexture && (await mi.whenTextureIsReadyAsync(this._dynamicTexture), this._dynamicOpacityTexture || (this._dynamicOpacityTexture = new oo(
      "dynamicOpacity",
      this._textureWidth,
      this._scene,
      this._dynamicTexture
    ), this._dynamicOpacityTexture.backColor = new BABYLON.Vector3(0, 0, 0), this._dynamicOpacityTexture.foreColor = new BABYLON.Vector3(1, 1, 1), this._dynamicOpacityTexture.refreshRate = 0, this._dynamicOpacityTexture.getAlphaFromRGB = !0), this._dynamicOpacityTexture && (this._dynamicOpacityTexture.baseTexture = this._dynamicTexture, await mi.whenTextureIsReadyAsync(this._dynamicOpacityTexture), this._dynamicOpacityTexture.render()));
  }
  async combineDiffuseTexturesAsync(e, t) {
    if (!this._originalDiffuseTexture || !this._dynamicTexture)
      return;
    await mi.whenTextureIsReadyAsync(this._originalDiffuseTexture), await mi.whenTextureIsReadyAsync(this._dynamicTexture);
    const n = t === 0 ? this._dynamicTexture : this._originalDiffuseTexture, s = t === 0 ? this._originalDiffuseTexture : this._dynamicTexture;
    this._combinedDiffuseTexture || (e == "multiply" ? this._combinedDiffuseTexture = new to(
      "multiplyDiffuse",
      this._textureWidth,
      this._scene,
      n,
      s
    ) : this._combinedDiffuseTexture = new ul(
      "overlayDiffuse",
      this._textureWidth,
      this._scene,
      n,
      s
    ), this._combinedDiffuseTexture.refreshRate = 0), this._combinedDiffuseTexture && (this._combinedDiffuseTexture.baseTexture = n, this._combinedDiffuseTexture.blendTexture = s, await mi.whenTextureIsReadyAsync(this._combinedDiffuseTexture), this._combinedDiffuseTexture.render());
  }
  // NORMAL MAP
  async updateNormalmapTextureAsync(e) {
    this._dynamicTexture && (await mi.whenTextureIsReadyAsync(this._dynamicTexture), this._proceduralNormalMap || (this._proceduralNormalMap = new Aw(
      this._dynamicTexture,
      this._textureWidth,
      e,
      this._scene
    )), this._normalmapTexture = await this._proceduralNormalMap.getNormalMapTextureAsync(
      this._dynamicTexture,
      e
    ), this._normalmapTexture && (this._normalmapTexture.coordinatesIndex = this._coordinatesIndex));
  }
  // Aggiorna i materiali con la normalmapTexture
  // La complicazione principale qui è che le normalmap eventualmente devono essere combinate con quelle preesistenti
  // sul materiale. Inoltre, essendo i materiali clonati (per non modificare quelli originari) è necessario controllare
  // che le texture siano pronte
  async setNormalmapTextureAsync(e) {
    var s;
    let t = this._normalmapTexture, n = this._normalmapTexture;
    if (e.get("showOnMesh") && this._originalMeshNormalmapTexture && this._normalmapTexture && (await this.combineMeshNormalmapTexturesAsync(), this._meshCombinedNormalmapTexture && (t = this._meshCombinedNormalmapTexture)), e.get("showOnDesign") && this._originalDesignNormalmapTexture && this._normalmapTexture && (await this.combineDesignNormalmapTexturesAsync(), this._designCombinedNormalmapTexture && (n = this._designCombinedNormalmapTexture)), this._normalmapMaterial && t) {
      t.coordinatesIndex = this._coordinatesIndex, this.setTextureWrapping(t);
      const o = this.getMaterialNormalmapTexturePropertyName(this._normalmapMaterial);
      e.get("showOnMesh") ? this._normalmapMaterial[o] = t : this.resetMeshNormalmapTexture(), this._mesh.material !== this._normalmapMaterial && (this._mesh.material = this._normalmapMaterial, this._mesh.metadata || (this._mesh.metadata = {}), this._mesh.metadata.originalNormalmapMaterialID = (s = this._originalMaterial) == null ? void 0 : s.id);
    }
    if (this._dynamicMaterial && n) {
      n.coordinatesIndex = this._coordinatesIndex, this.setTextureWrapping(n);
      const o = this.getMaterialNormalmapTexturePropertyName(this._dynamicMaterial);
      e.get("showOnDesign") ? this._dynamicMaterial[o] = n : this.resetDesignNormalmapTexture();
    }
  }
  async combineMeshNormalmapTexturesAsync() {
    !this._originalMeshNormalmapTexture || !this._normalmapTexture || (await mi.whenTextureIsReadyAsync(this._originalMeshNormalmapTexture), await mi.whenTextureIsReadyAsync(this._normalmapTexture), this._meshCombinedNormalmapTexture || (this._meshCombinedNormalmapTexture = new ul(
      "overlayMeshNormal",
      this._textureWidth,
      this._scene,
      this._originalMeshNormalmapTexture,
      this._normalmapTexture
    ), this._meshCombinedNormalmapTexture.refreshRate = 0), this._meshCombinedNormalmapTexture && (this._meshCombinedNormalmapTexture.baseTexture = this._originalMeshNormalmapTexture, this._meshCombinedNormalmapTexture.blendTexture = this._normalmapTexture, await mi.whenTextureIsReadyAsync(this._meshCombinedNormalmapTexture), this._meshCombinedNormalmapTexture.render()));
  }
  resetMeshNormalmapTexture() {
    if (this._normalmapMaterial) {
      const e = this.getMaterialNormalmapTexturePropertyName(this._normalmapMaterial);
      this.compareTextures(
        this._normalmapMaterial[e],
        this._originalMeshNormalmapTexture
      ) || (this._originalMeshNormalmapTexture ? this._normalmapMaterial[e] = this._originalMeshNormalmapTexture : this._normalmapMaterial[e] = null);
    }
  }
  resetDesignNormalmapTexture() {
    if (this._dynamicMaterial) {
      const e = this.getMaterialNormalmapTexturePropertyName(this._dynamicMaterial);
      this.compareTextures(
        this._dynamicMaterial[e],
        this._originalDesignNormalmapTexture
      ) || (this._originalDesignNormalmapTexture ? this._dynamicMaterial[e] = this._originalDesignNormalmapTexture : this._dynamicMaterial[e] = null);
    }
  }
  async combineDesignNormalmapTexturesAsync() {
    !this._originalDesignNormalmapTexture || !this._normalmapTexture || (await mi.whenTextureIsReadyAsync(this._originalDesignNormalmapTexture), await mi.whenTextureIsReadyAsync(this._normalmapTexture), this._designCombinedNormalmapTexture || (this._designCombinedNormalmapTexture = new ul(
      "overlayDesignNormal",
      this._textureWidth,
      this._scene,
      this._originalDesignNormalmapTexture,
      this._normalmapTexture
    ), this._designCombinedNormalmapTexture.refreshRate = 0), this._designCombinedNormalmapTexture && (this._designCombinedNormalmapTexture.baseTexture = this._originalDesignNormalmapTexture, this._designCombinedNormalmapTexture.blendTexture = this._normalmapTexture, await mi.whenTextureIsReadyAsync(this._designCombinedNormalmapTexture), this._designCombinedNormalmapTexture.render()));
  }
  // INNER SHADOW
  async updateInnerShadowTextureAsync(e) {
    this._dynamicTexture && (await mi.whenTextureIsReadyAsync(this._dynamicTexture), this._innerShadowGenerator ? await this._innerShadowGenerator.updateAsync(this._dynamicTexture, e) : (this._innerShadowGenerator = new Tw(
      this._dynamicTexture,
      this._textureWidth,
      e,
      this._scene
    ), this._innerShadowTexture = await this._innerShadowGenerator.getInnerShadowTextureAsync(
      this._dynamicTexture
    ), this._innerShadowTexture.coordinatesIndex = this._coordinatesIndex));
  }
  async setInnerShadowTextureAsync(e) {
    let t = this._innerShadowTexture;
    this._originalDesignLightmapTexture && this._innerShadowTexture && (await this.combineDesignLightmapTexturesAsync(), this._designCombinedLightmapTexture && (t = this._designCombinedLightmapTexture)), t && (t.coordinatesIndex = this._coordinatesIndex, this.setTextureWrapping(t), this.setMaterialLightmap(this._dynamicMaterial, t));
  }
  async combineDesignLightmapTexturesAsync() {
    !this._originalDesignLightmapTexture || !this._innerShadowTexture || (await mi.whenTextureIsReadyAsync(this._originalDesignLightmapTexture), await mi.whenTextureIsReadyAsync(this._innerShadowTexture), this._designCombinedLightmapTexture || (this._designCombinedLightmapTexture = new to(
      "overlayDesignLightmaps",
      this._textureWidth,
      this._scene,
      this._originalDesignLightmapTexture,
      this._innerShadowTexture
    ), this._designCombinedLightmapTexture.refreshRate = 0), this._designCombinedLightmapTexture && (this._designCombinedLightmapTexture.baseTexture = this._originalDesignLightmapTexture, this._designCombinedLightmapTexture.blendTexture = this._innerShadowTexture, await mi.whenTextureIsReadyAsync(this._designCombinedLightmapTexture), this._designCombinedLightmapTexture.render()));
  }
  removeInnerShadowTexture() {
    if (this._dynamicMaterial) {
      let e = this.getMaterialLightmap(this._dynamicMaterial), t = this._originalDesignLightmapTexture;
      this.compareTextures(e, t) || this.setMaterialLightmap(this._dynamicMaterial, t);
    }
  }
  // OUTER SHADOW
  async updateOuterShadowTextureAsync(e) {
    this._dynamicTexture && (await mi.whenTextureIsReadyAsync(this._dynamicTexture), this._outerShadowGenerator ? await this._outerShadowGenerator.updateAsync(this._dynamicTexture, e) : (this._outerShadowGenerator = new Lw(
      this._dynamicTexture,
      this._textureWidth,
      e,
      this._scene
    ), this._outerShadowTexture = await this._outerShadowGenerator.getOuterShadowTextureAsync(
      this._dynamicTexture
    ), this._outerShadowTexture.coordinatesIndex = this._coordinatesIndex));
  }
  async setOuterShadowTextureAsync(e) {
    let t = this._outerShadowTexture;
    this._originalMeshLightmapTexture && this._outerShadowTexture && (await this.combineMeshLightmapTexturesAsync(), this._meshCombinedLightmapTexture && (t = this._meshCombinedLightmapTexture)), t && (t.coordinatesIndex = this._coordinatesIndex, this.setTextureWrapping(t), this.setMaterialLightmap(this._normalmapMaterial, t), this._mesh.material !== this._normalmapMaterial && (this._mesh.material = this._normalmapMaterial));
  }
  async combineMeshLightmapTexturesAsync() {
    !this._originalMeshLightmapTexture || !this._outerShadowTexture || this._isDisposed || (await mi.whenTextureIsReadyAsync(this._originalMeshLightmapTexture), await mi.whenTextureIsReadyAsync(this._outerShadowTexture), this._meshCombinedLightmapTexture || (this._meshCombinedLightmapTexture = new to(
      "overlayMeshLightmap",
      this._textureWidth,
      this._scene,
      this._originalMeshLightmapTexture,
      this._outerShadowTexture
    ), this._meshCombinedLightmapTexture.refreshRate = 0), this._meshCombinedLightmapTexture && (this._meshCombinedLightmapTexture.baseTexture = this._originalMeshLightmapTexture, this._meshCombinedLightmapTexture.blendTexture = this._outerShadowTexture, await mi.whenTextureIsReadyAsync(this._meshCombinedLightmapTexture), this._meshCombinedLightmapTexture.render()));
  }
  removeOuterShadowTexture() {
    if (this._normalmapMaterial) {
      const e = this.getMaterialLightmap(this._normalmapMaterial), t = this._originalMeshLightmapTexture;
      this.compareTextures(e, t) || this.setMaterialLightmap(this._normalmapMaterial, t);
    }
  }
  compareTextures(e, t) {
    return typeof e > "u" && typeof t > "u" || e === null && t === null ? !0 : !e || !t ? !1 : e === t;
  }
  dataURItoBlob(e) {
    let t = atob(e.split(",")[1]), n = e.split(",")[0].split(":")[1].split(";")[0], s = new ArrayBuffer(t.length), o = new Uint8Array(s);
    for (let c = 0; c < t.length; c++)
      o[c] = t.charCodeAt(c);
    return new Blob([s], { type: n });
  }
  downloadImage(e, t) {
    let n = this.dataURItoBlob(e), s = window.URL.createObjectURL(n), o = t || "image.png", h = document.createElement("a");
    h.download = o, h.innerHTML = "Download File", h.href = s, h.onclick = (c) => {
      document.body.removeChild(h);
    }, h.style.display = "none", h.setAttribute("type", "hidden"), document.body.appendChild(h), h.click();
  }
  setDesignMeshVisibility(e) {
    this._currentVisibliity = e, this._canvasMesh && (this._canvasMesh.isVisible = e);
  }
  getItemsInfo() {
    return this._customizer ? this._customizer.getItemsInfo() : [];
  }
  removeItem(e) {
    this._customizer && this._customizer.removeItemByGuid(e);
  }
  addItemText(e) {
    this._customizer && this._customizer.addTextElement(null, e, !1);
  }
  setItemText(e, t) {
    var n, s, o;
    this._customizer && (this._customizer.modifyTextElementContentByGuid(e, t), (o = (s = (n = this._customizer.paper) == null ? void 0 : n.project) == null ? void 0 : s.view) == null || o.update());
  }
  async refreshTextureOnly() {
    var e, t, n;
    this._customizer && ((n = (t = (e = this._customizer.paper) == null ? void 0 : e.project) == null ? void 0 : t.view) == null || n.update()), await this.updateDynamicTextureInternalAsync(!0);
  }
  /**
   * Get font weights from font variations
   * Returns array of {style, weight} for available font faces
   */
  getFontWeights(e) {
    let t = e.faces.map((U) => U.variation), n = t.filter((U) => U.startsWith("i")).map((U) => parseInt(U.charAt(U.length - 1)) * 100), s = t.filter((U) => U.startsWith("n")).map((U) => parseInt(U.charAt(U.length - 1)) * 100), o = s.filter((U) => U <= 500).sort((U, M) => M - U)[0], h = n.filter((U) => U <= 500).sort((U, M) => M - U)[0], c = s.filter((U) => U == 700), _ = (c.length ? c : s.filter((U) => U > 500)).sort((U, M) => U - M)[0], x = n.filter((U) => U == _);
    x = x.length ? x : n.filter((U) => U == 700);
    let B = (x.length ? x : n.filter((U) => U > 500)).sort((U, M) => U - M)[0];
    const P = [];
    return o && P.push({ style: "normal", weight: o }), _ && P.push({ style: "normal", weight: _ }), h && P.push({ style: "italic", weight: h }), B && P.push({ style: "italic", weight: B }), P;
  }
  setItemBold(e, t, n) {
    var s, o;
    if (this._customizer) {
      let h = this._customizer.findItemByGuid(e);
      if (h) {
        let x = this._customizer.getTextItemInfo(h).fontWeight.split(" ").includes("italic") ? "italic" : "normal";
        const B = this.getFontWeights(n);
        let P;
        if (x === "italic") {
          const U = B.filter((M) => M.style === "italic");
          if (t) {
            const M = U.filter((Z) => Z.weight > 500).sort((Z, F) => Z.weight - F.weight)[0];
            P = M == null ? void 0 : M.weight;
          } else {
            const M = U.filter((Z) => Z.weight <= 500).sort((Z, F) => F.weight - Z.weight)[0];
            P = M == null ? void 0 : M.weight;
          }
          if (P === void 0) {
            const M = B.filter((Z) => Z.style === "normal");
            if (t) {
              const Z = M.filter((F) => F.weight > 500).sort((F, Q) => F.weight - Q.weight)[0];
              P = (Z == null ? void 0 : Z.weight) || ((s = M[0]) == null ? void 0 : s.weight);
            } else {
              const Z = M.filter((F) => F.weight <= 500).sort((F, Q) => Q.weight - F.weight)[0];
              P = (Z == null ? void 0 : Z.weight) || ((o = M[0]) == null ? void 0 : o.weight);
            }
            x = "normal";
          }
        } else {
          const U = B.filter((M) => M.style === "normal");
          if (t) {
            const M = U.filter((Z) => Z.weight > 500).sort((Z, F) => Z.weight - F.weight)[0];
            P = M == null ? void 0 : M.weight;
          } else {
            const M = U.filter((Z) => Z.weight <= 500).sort((Z, F) => F.weight - Z.weight)[0];
            P = M == null ? void 0 : M.weight;
          }
          P === void 0 && U.length > 0 && (P = U[0].weight);
        }
        if (P !== void 0) {
          let U = x === "italic" ? `italic ${P}` : P.toString();
          this._customizer.modifyTextElementFontWeight(h, U);
        }
      }
    }
  }
  setItemItalic(e, t, n) {
    var s, o;
    if (this._customizer) {
      let h = this._customizer.findItemByGuid(e);
      if (h) {
        let _ = this._customizer.getTextItemInfo(h).fontWeight.split(" "), x = !1;
        for (let U of _) {
          let M = parseInt(U);
          if (!isNaN(M)) {
            x = M > 500;
            break;
          }
        }
        const B = this.getFontWeights(n);
        let P;
        if (t) {
          const U = B.filter((M) => M.style === "italic");
          if (x) {
            const M = U.filter((Z) => Z.weight > 500).sort((Z, F) => Z.weight - F.weight)[0];
            P = M == null ? void 0 : M.weight;
          } else {
            const M = U.filter((Z) => Z.weight <= 500).sort((Z, F) => F.weight - Z.weight)[0];
            P = M == null ? void 0 : M.weight;
          }
          if (P === void 0) {
            const M = B.filter((Z) => Z.style === "normal");
            if (x) {
              const Z = M.filter((F) => F.weight > 500).sort((F, Q) => F.weight - Q.weight)[0];
              P = (Z == null ? void 0 : Z.weight) || ((s = M[0]) == null ? void 0 : s.weight);
            } else {
              const Z = M.filter((F) => F.weight <= 500).sort((F, Q) => Q.weight - F.weight)[0];
              P = (Z == null ? void 0 : Z.weight) || ((o = M[0]) == null ? void 0 : o.weight);
            }
            t = !1;
          }
        } else {
          const U = B.filter((M) => M.style === "normal");
          if (x) {
            const M = U.filter((Z) => Z.weight > 500).sort((Z, F) => Z.weight - F.weight)[0];
            P = M == null ? void 0 : M.weight;
          } else {
            const M = U.filter((Z) => Z.weight <= 500).sort((Z, F) => F.weight - Z.weight)[0];
            P = M == null ? void 0 : M.weight;
          }
          P === void 0 && U.length > 0 && (P = U[0].weight);
        }
        if (P !== void 0) {
          let U = t ? `italic ${P}` : P.toString();
          this._customizer.modifyTextElementFontWeight(h, U);
        }
      }
    }
  }
  setItemColor(e, t) {
    this._customizer && this._customizer.modifyTextElementFillColorByGuid(e, t);
  }
  setItemFontFamily(e, t) {
    this._customizer && this._customizer.modifyTextElementFontFamilyByGuid(e, t);
  }
  setItemFontWeight(e, t, n) {
    if (!this._customizer)
      return;
    if (n) {
      const h = this.getFontWeights(n).map((c) => c.weight);
      h.length > 0 && (t = h.reduce(
        (c, _) => Math.abs(_ - t) < Math.abs(c - t) ? _ : c
      ));
    }
    let s = this._customizer.findItemByGuid(e);
    if (s) {
      let _ = (this._customizer.getTextItemInfo(s).fontWeight.split(" ").includes("italic") ? "italic" : "normal") === "italic" ? `italic ${t}` : t.toString();
      this._customizer.modifyTextElementFontWeight(s, _);
    }
  }
  async addItemImage(e) {
    return this._customizer ? await this._customizer.insertImageById(e) : null;
  }
  async setItemImage(e, t) {
    this._customizer && await this._customizer.replaceImageByGuid(e, t);
  }
  setItemTextOnPath(e, t) {
    if (this._customizer) {
      let n = this._customizer.findItemByGuid(e);
      t ? this._customizer.convertToTextOnPath(n) : this._customizer.convertToTextArea(n);
    }
  }
  removeItemImage(e) {
    this._customizer && this._customizer.removeImageByGuid(e);
  }
  async setItemSize(e, t, n) {
    this._customizer && await this._customizer.setItemSize(e, t, n);
  }
  setItemConstraints(e, t) {
    this._customizer && this._customizer.setItemConstraints(e, t);
  }
  setDesignPrintingMethod(e) {
    this._customizer && this._side && this._customizer.setDesignPrintingMethod(e, this._side.get("sideID"));
  }
  containsItem(e) {
    if (this._customizer) {
      const t = this._customizer.findItemByGuid(e);
      return t != null && t != null;
    }
    return !1;
  }
  // -------------------------------------------------------------
  // Events
  // -------------------------------------------------------------
  addNotifyMessageListener(e) {
    if (this._customizer) {
      const t = this._customizer;
      let n = Oh(
        (s, o, h, c, _, x, B, P, U) => {
          e(
            t.side.getSideID(),
            s,
            o,
            h,
            c,
            _,
            P.requiredWidth,
            P.requiredHeight,
            U
          );
        },
        50
      );
      t.addNotifyMessageListeners(n);
    }
  }
  addRemoveMessageListener(e) {
    if (this._customizer) {
      const t = this._customizer;
      let n = Oh((s) => {
        e(t.side.getSideID(), s);
      }, 50);
      t.addRemoveMessageListeners(n);
    }
  }
  setEventMessages(e) {
    this._customizer && this._customizer.setCustomizedMessages(e);
  }
  fireRenderingNeededEvent() {
    for (let e = 0; e < this._renderingNeededListeners.length; ++e)
      this._renderingNeededListeners[e]();
  }
  addRenderingNeededListener(e) {
    this._renderingNeededListeners.push(e);
  }
  // -------------------------------------------------------------
  // Design view transformation
  // -------------------------------------------------------------
  translateDesignView(e, t) {
    if (this._meshSide && this._customizer) {
      let h = this._meshSide.get("matrix") || JSON.stringify(this._customizer.paper.view.matrix.values);
      var n = JSON.parse(h), s = this._customizer.getTranslatedMatrixValues(n, e, t), o = JSON.stringify(s);
      this._meshSide.set("matrix", o);
    }
  }
  rotateDesignView(e, t, n) {
    if (this._meshSide && this._customizer) {
      var s = this._meshSide.get("matrix") || JSON.stringify(this._customizer.paper.view.matrix.values), o = JSON.parse(s), h = this._customizer.getRotatedMatrixValues(o, e, t, n), c = JSON.stringify(h);
      this._meshSide.set("matrix", c);
    }
  }
  scaleDesignView(e, t, n, s) {
    if (this._meshSide && this._customizer) {
      var o = this._meshSide.get("matrix") || JSON.stringify(this._customizer.paper.view.matrix.values), h = JSON.parse(o), c = this._customizer.getScaledMatrixValues(h, e, t, n, s), _ = JSON.stringify(c);
      this._meshSide.set("matrix", _);
    }
  }
  async setDesignViewTextureUVChannelAsync(e) {
    this._meshSide && (this._meshSide.set("uvChannel", e), await this.updateDynamicTextureAsync());
  }
  async setDesignViewFormFactorAsync(e, t) {
    this._meshSide && (this._meshSide.set("percWidth", e), this._meshSide.set("percHeight", t), await this.refreshAsync());
  }
  async changeToDynamicTexture() {
    await this.updateDynamicTextureInternalAsync(!0);
  }
  async changeToRasterizedTexture() {
    await this.updateDynamicTextureInternalAsync(!1);
  }
  moveItemUp(e) {
    console.log("MeshDesignManager.moveItemUp", e), this._customizer && this._customizer.moveItemUp(e);
  }
  moveItemDown(e) {
    console.log("MeshDesignManager.moveItemDown", e), this._customizer && this._customizer.moveItemDown(e);
  }
};
eg.DEFAULT_SIZE = 1024;
let tg = eg;
class Bw {
  constructor(e, t, n, s, o = !0) {
    this._rotation = 0, this._grids = [], this._meshDesignManagers = [], this._renderingNeededListeners = [], this._designNotifyMessageListeners = [], this._designRemoveMessageListeners = [], this._designEventMessages = [], this._meshDesignManagersRefreshing = /* @__PURE__ */ new Set(), this._scene = e, this._zkScene = t, this._zkModel = n, this._zkDesign = s, this._showDesign = o, this.init();
  }
  get showDesign() {
    return this._showDesign;
  }
  set showDesign(e) {
    this._showDesign != e && (this._showDesign = e, this._meshDesignManagers.forEach((t) => t.showDesign = e));
  }
  get rotation() {
    return this._rotation;
  }
  set rotation(e) {
    this._rotation != e && (this._rotation = e, this._meshDesignManagers.forEach((t) => t.rotation = e));
  }
  dispose() {
    this._meshDesignManagers.forEach((e) => e.dispose());
  }
  init() {
  }
  isForModels(e, t, n) {
    return this._scene == e && this._zkModel == t && this._zkDesign == n;
  }
  getDefaultModelScene() {
    if (this._zkModel) {
      let e = this._zkModel.get("scenes").findWhere({ isDefault: !0 });
      if (e)
        return e;
    }
    return null;
  }
  getModelSceneMeshSide(e, t = 0) {
    if (this._scene && this._zkModel) {
      const n = this.getDefaultModelScene();
      if (n)
        for (let s = 0; s < n.get("meshSides").length; s++) {
          let o = n.get("meshSides").at(s);
          if (o.get("meshID") == e && o.get("subMeshID") == t)
            return o;
        }
    }
    return null;
  }
  async refreshAsync() {
    if (this._scene && this._zkModel && this._zkDesign) {
      const e = this.getDefaultModelScene();
      if (e) {
        let t = null, n = null, s = null;
        for (let o = 0; o < this._meshDesignManagers.length; o++) {
          t = this._meshDesignManagers[o];
          let h = !1;
          for (let _ = 0; _ < e.get("meshSides").length; _++)
            if (s = e.get("meshSides").at(_), s.get("meshID") == t.getMeshID() && s.get("subMeshID") == t.getSubMeshIdx()) {
              h = !0;
              break;
            }
          let c = !0;
          if (h) {
            let _ = t.getMeshID();
            _ && (n = this._scene.getMeshByID(_), n && (c = n.isVisible));
          }
          (!h || !c) && (t.dispose(), this._meshDesignManagers.splice(o--, 1));
        }
        for (let o = 0; o < e.get("meshSides").length; o++) {
          s = e.get("meshSides").at(o);
          const h = s.get("meshID"), c = s.get("subMeshID");
          h && await this.refreshMeshDesignAsync(h, c);
        }
      }
    }
  }
  isValidEffectForMesh(e, t, n) {
    if (n && n instanceof MPlaza.ModelSceneMeshDesignEffect) {
      const s = n.getParentModel();
      if (s && s instanceof MPlaza.ModelScene)
        return s.isEffectForMesh(e, t, n.get("effectID"));
    }
    return !1;
  }
  async refreshMeshDesignAsync(e, t = 0, n) {
    const s = this._scene.getMeshByID(e);
    let o = n;
    if (n && !this.isValidEffectForMesh(e, t, n) && (o = void 0), s && s.isVisible) {
      let h = null;
      s.subMeshes && s.subMeshes.length > 0 && t >= 0 && t < s.subMeshes.length && (h = s.subMeshes[t]);
      let c = this.getMeshDesignMananger(s, h);
      if (c)
        c.showDesign = this._showDesign, c.rotation = this._rotation, await c.refreshAsync(o);
      else {
        c = await tg.createMeshDesignManagerAsync(
          this._scene,
          this._zkScene,
          s,
          h,
          this._zkModel,
          this._zkDesign,
          this._grids,
          this._showDesign,
          o,
          this.rotation
        ), c.addRenderingNeededListener(() => this.fireRenderingNeededEvent()), c.setEventMessages(this._designEventMessages);
        for (let _ of this._designNotifyMessageListeners)
          c.addNotifyMessageListener(_);
        for (let _ of this._designRemoveMessageListeners)
          c.addRemoveMessageListener(_);
        this._meshDesignManagers.push(c);
      }
    }
  }
  getMeshDesignMananger(e, t) {
    for (let n = 0; n < this._meshDesignManagers.length; n++) {
      const s = this._meshDesignManagers[n];
      if (s.isForMesh(e, t))
        return s;
    }
    return null;
  }
  clearMeshDesignManagers() {
    this._meshDesignManagers = [];
  }
  setCustomizerGrids(e) {
    this._grids = e, this._meshDesignManagers.forEach((t) => t.setCustomizerGrids(e));
  }
  getItemsInfo(e) {
    let t = [];
    for (let n = 0; n < this._meshDesignManagers.length; n++) {
      const o = this._meshDesignManagers[n].getItemsInfo();
      for (let h = 0; h < o.length; h++) {
        const c = o[h];
        let _ = !1;
        for (let x = 0; x < t.length; x++)
          if (t[x].itemGuid == c.itemGuid) {
            _ = !0;
            break;
          }
        _ || t.push(c);
      }
    }
    if (e) {
      const n = e.getItemsInfo();
      for (let s = 0; s < n.length; s++) {
        const o = n[s];
        let h = !1;
        for (let c = 0; c < t.length; c++)
          if (t[c].itemGuid == o.itemGuid) {
            h = !0;
            break;
          }
        h || t.push(o);
      }
    }
    return t;
  }
  async execOnMeshManagersContainingItem(e, t) {
    for (const n of this._meshDesignManagers)
      n.containsItem(e) && await t(n);
  }
  removeItem(e) {
    this.execOnMeshManagersContainingItem(e, async (t) => t.removeItem(e));
  }
  moveItemUp(e) {
    console.log("sceneDesignManager moveItemUp", e), this.execOnMeshManagersContainingItem(e, async (t) => t.moveItemUp(e));
  }
  moveItemDown(e) {
    console.log("sceneDesignManager moveItemDown", e), this.execOnMeshManagersContainingItem(e, async (t) => t.moveItemDown(e));
  }
  addItemText(e, t) {
    let n = this._meshDesignManagers.find((s) => s.side != null && s.side.get("sideID") === t);
    n && n.addItemText(e);
  }
  async addItemImage(e, t) {
    let n = this._meshDesignManagers.find((s) => s.side != null && s.side.get("sideID") === t);
    return n ? await n.addItemImage(e) : null;
  }
  setItemText(e, t) {
    this.execOnMeshManagersContainingItem(e, async (n) => n.setItemText(e, t));
  }
  async refreshTextureForItem(e) {
    await this.execOnMeshManagersContainingItem(e, async (t) => t.refreshTextureOnly());
  }
  setItemItalic(e, t, n) {
    this.execOnMeshManagersContainingItem(e, async (s) => s.setItemItalic(e, t, n));
  }
  setItemBold(e, t, n) {
    this.execOnMeshManagersContainingItem(e, async (s) => s.setItemBold(e, t, n));
  }
  setItemColor(e, t) {
    this.execOnMeshManagersContainingItem(e, async (n) => n.setItemColor(e, t));
  }
  setItemFontFamily(e, t) {
    this.execOnMeshManagersContainingItem(e, async (n) => n.setItemFontFamily(e, t));
  }
  async setItemImage(e, t) {
    await this.execOnMeshManagersContainingItem(e, async (n) => n.setItemImage(e, t));
  }
  async setItemSize(e, t, n) {
    await this.execOnMeshManagersContainingItem(e, async (s) => s.setItemSize(e, t, n));
  }
  setItemConstraints(e, t) {
    this.execOnMeshManagersContainingItem(e, async (n) => n.setItemConstraints(e, t));
  }
  setItemTextOnPath(e, t, n) {
    const s = this._meshDesignManagers.find(
      (o) => o.side != null && o.side.get("sideID") === t
    );
    s && s.setItemTextOnPath(e, n);
  }
  removeItemImage(e) {
    this.execOnMeshManagersContainingItem(e, async (t) => t.removeItemImage(e));
  }
  setDesignVisibility(e, t) {
    const n = this._scene.getMeshByID(e);
    if (n) {
      const s = this.getMeshDesignMananger(n, n.subMeshes.length > 0 ? n.subMeshes[0] : null);
      s && s.setDesignMeshVisibility(t);
    }
  }
  setDesignPrintingMethod(e, t) {
    let n = this._meshDesignManagers.find((s) => s.side != null && s.side.get("sideID") === t);
    n && n.setDesignPrintingMethod(e);
  }
  getDesignItemsJson() {
    let e = "";
    for (let t = 0; t < this._zkDesign.get("designItems").length; t++)
      e && (e += `
`), e += this._zkDesign.get("designItems").at(t).get("json");
    return e;
  }
  getDesignID() {
    return this._zkDesign.getDesignID();
  }
  // -------------------------------------------------------------
  // Events
  // -------------------------------------------------------------
  fireRenderingNeededEvent() {
    for (let e = 0; e < this._renderingNeededListeners.length; ++e)
      this._renderingNeededListeners[e]();
  }
  addRenderingNeededListener(e) {
    this._renderingNeededListeners.push(e);
  }
  addNotifyMessageListener(e) {
    this._designNotifyMessageListeners.push(e);
    for (let t of this._meshDesignManagers)
      t.addNotifyMessageListener(e);
  }
  addRemoveMessageListener(e) {
    this._designRemoveMessageListeners.push(e);
    for (let t of this._meshDesignManagers)
      t.addRemoveMessageListener(e);
  }
  setEventMessages(e) {
    this._designEventMessages = e;
    for (let t of this._meshDesignManagers)
      t.setEventMessages(e);
  }
  // -------------------------------------------------------------
  // Design view transformation
  // -------------------------------------------------------------
  translateDesignView(e, t, n, s) {
    const o = this.getMeshDesignMananger(e, t);
    o && o.translateDesignView(n, s);
  }
  rotateDesignView(e, t, n, s, o) {
    const h = this.getMeshDesignMananger(e, t);
    h && h.rotateDesignView(n, s, o);
  }
  scaleDesignView(e, t, n, s, o, h) {
    const c = this.getMeshDesignMananger(e, t);
    c && c.scaleDesignView(n, s, o, h);
  }
  async setDesignViewTextureUVChannelAsync(e, t, n) {
    const s = this.getMeshDesignMananger(e, t);
    s && await s.setDesignViewTextureUVChannelAsync(n);
  }
  async setDesignViewFormFactorAsync(e, t, n, s) {
    const o = this.getMeshDesignMananger(e, t);
    o && await o.setDesignViewFormFactorAsync(n, s);
  }
  // -------------------------------------------------------------
  // Mesh - Side connection
  // -------------------------------------------------------------
  async connectMeshToModelSideAsync(e, t, n) {
    let s = this.getModelSceneMeshSide(e, t);
    if (!s && this._scene && this._zkModel) {
      let o = this._scene.getMeshByID(e);
      if (o && o.subMeshes && o.subMeshes.length > 0 && t >= 0 && t < o.subMeshes.length) {
        o.subMeshes[t];
        let h = this.getDefaultModelScene();
        h && (s = new MPlaza.ModelSceneMeshSide(), s.set("meshID", e), s.set("subMeshID", t), s.set("sideID", n), h.get("meshSides").add(s), await this.refreshAsync());
      }
    }
  }
  expandCanvasMeshes(e) {
    console.log("expandRatio ", e), this._meshDesignManagers.forEach((t) => t.expandCanvasMesh(e));
  }
  contractCanvasMeshes() {
    this._meshDesignManagers.forEach((e) => e.contractCanvasMesh());
  }
  async changeToRasterizedTextures() {
    for (const e of this._meshDesignManagers)
      await e.changeToRasterizedTexture();
    console.log("All tasks for rasterized textures completed.");
  }
  async changeToDynamicTextures() {
    for (const e of this._meshDesignManagers)
      await e.changeToDynamicTexture();
    console.log("All dynamic textures changes completed.");
  }
}
const is = "base_model";
class V1 {
  constructor(e, t, n) {
    this._zkModel = e, this._zkScene = t, this._scene = n, this._sceneHelper = new mi(n);
  }
  /**
   * Replace the product model, used when discarding changes
   * @param newModel The new model to replace the current one
   */
  replaceModel(e) {
    this._zkModel = e;
  }
  getOrCreateMaterialsForVariant(e) {
    const t = this.getVariantMeshes(e), n = [];
    return t.forEach((s) => {
      const o = this._scene.getMeshById(s);
      o && o.getChildMeshes().forEach((h) => n.push(h));
    }), this.hasVariantCustomModel(e) ? this.getMaterialsForMeshes(n) : (this.getMaterialsForMeshes(n).forEach((o) => {
      this.isSceneMaterialForVariant(o) || this.setVariableMaterialID(o.id);
    }), this.getVariantMaterials(e));
  }
  // restituisce tutti materiali della scena per cui è possibile specificare se sono
  // variabili o meno in base alle varianti del prodotto. Da tale elenco verranno esclusi
  // tutti i materiali che sono stati già clonati per rappresentare la variazione.
  // verranno esclusi anche tutti i materiali che comunque sono stati marcati (metadata)
  // come materiali creati ad hoc per una preview di prodotto (isForPreview = true)
  // e verranno esclusi tutti i materiali non assegnati a nessuna mesh.
  // Verranno considerati quindi tutti i materiali non clonati assegnati ad almeno una mesh (direttamente
  // o indirettamente)
  getPossibleVariableMaterials() {
    const e = this._sceneHelper.getAllMaterials(), t = [];
    for (let n = 0; n < e.length; n++) {
      const s = e[n], o = this.getMeshesUsingMaterial(s.id), h = this.isSceneMaterialForVariant(s);
      o.length > 0 && !h && t.push(s);
    }
    return t;
  }
  // Restituisce l'elenco dei materiali della scena già selezionati come variabili
  getVariableMaterials() {
    const e = [], t = this._zkModel.getPreview3D();
    if (t) {
      const n = t.getVariantsAttributeOptions();
      if (n)
        for (let s = 0; s < n.get("variableMaterials").length; s++) {
          let o = n.get("variableMaterials").at(s).get("materialID"), h = this._scene.getMaterialById(o);
          h && e.push(h);
        }
    }
    return e;
  }
  getVariableMaterialsSelection() {
    const t = this.getVariableMaterials().map((o) => o.id);
    return this.getPossibleVariableMaterials().map((o) => ({
      id: o.id,
      name: o.name,
      selected: t.indexOf(o.id) != -1
    }));
  }
  getVariantMaterialsWithOriginal(e) {
    const t = [], n = this._zkModel.getPreview3D();
    if (n && e && e instanceof MPlaza.Color) {
      const s = this.getVariantID(e), o = n.getVariantsAttributeOptions();
      if (o) {
        const h = o.getVariantOption(s);
        if (h)
          for (let c = 0; c < h.get("materials").length; c++) {
            const _ = h.get("materials").at(c), x = _.get("optionMaterialID"), B = this._scene.getMaterialById(x), P = _.get("variableMaterialID"), U = this._scene.getMaterialById(P);
            B && U && t.push({ material: B, variableMaterial: U });
          }
      }
    }
    return t;
  }
  // Per tutti i materiali impostati come variabili, verifica che questi materiali esistano ancora.
  // Se un materiale esiste, aggiorna l'indicazione delle mesh alle quali è impostato e le azioni per opzione.
  // Se un materiale non esiste, lo elimina tra i materiali variabili.
  updateVariableMaterials() {
    const e = this._zkModel.getPreview3D();
    if (e) {
      const t = e.getVariantsAttributeOptions();
      if (t) {
        const n = [], s = [];
        for (let o = 0; o < t.get("variableMaterials").length; o++) {
          const c = t.get("variableMaterials").at(o).get("materialID");
          this._scene.getMaterialById(c) ? n.push(c) : s.push(c);
        }
        n.forEach((o) => this.setVariableMaterialID(o)), s.forEach((o) => this.unsetVariableMaterialID(o));
      }
    }
  }
  // Imposta un materiale come NON variabile per variante. Questo significa che vanno eliminate
  // tutte le eventuali azioni relative al materiale ed eventualmente le opzioni
  unsetVariableMaterialID(e) {
    const t = this._zkModel.getPreview3D();
    if (t) {
      const n = t.getVariantsAttributeOptions();
      if (n) {
        const s = this._zkModel.getAttributeByGuid(n.get("attributeGuid")), o = n.get("variableMaterials").getVariableMaterial(e);
        if (o) {
          const c = this._scene.getMaterialById(e);
          if (c)
            for (let _ = 0; _ < o.get("meshes").length; _++) {
              const x = this._scene.getMeshById(o.get("meshes")[_]);
              x && this._sceneHelper.applyMaterial(c, x);
            }
        }
        n.removeVariableMaterial(e);
        const h = [];
        for (let c = 0; c < n.get("variantOptions").length; c++) {
          const _ = n.get("variantOptions").at(c);
          let x = null;
          s && (x = s.getOptionByGuid(_.get("optionGuid")));
          const B = [];
          for (let P = 0; P < _.get("materials").length; P++) {
            const U = _.get("materials").at(P);
            if (U.get("variableMaterialID") === e) {
              for (let M = 0; M < U.get("actions").length; M++) {
                const Z = U.get("actions").at(M);
                if (x) {
                  const F = x.get("actions").getActionByGuid(Z.get("actionGuid"));
                  F && x.get("actions").remove(F);
                }
              }
              this.deleteSceneMaterial(U.get("optionMaterialID")), B.push(U);
            }
          }
          _.get("materials").remove(B), _.get("materials").length === 0 && h.push(_);
        }
        for (let c = 0; c < h.length; c++)
          this.removeVariantOption(n, h[c]);
      }
    }
  }
  // Imposta un materiale come variabile. Vengono generati i materiali cloni per le varie opzioni
  // e create le azioni di trasformazione della scena che impostano il materiale sulle varie mesh
  setVariableMaterialID(e) {
    const t = this._scene.getMaterialById(e);
    if (t) {
      const n = this.getMeshesUsingMaterial(t.id), s = n.map((_) => _.id), h = this._zkModel.getOrCreatePreview3D().getOrCreateVariantsAttributeOptions();
      h.setVariableMaterial(e, s);
      const c = [];
      for (let _ = 0; _ < this._zkModel.get("colors").length; _++) {
        const x = this._zkModel.get("colors").at(_), B = this.getVariantID(x);
        c.push(B), this.checkVariantOption(h, t, n, x);
      }
      for (let _ = 0; _ < h.get("variantOptions").length; _++) {
        const x = h.get("variantOptions").at(_);
        c.indexOf(x.get("variantID")) === -1 && this.removeVariantOption(h, x);
      }
    }
  }
  getVariantAttribute() {
    const e = this._zkModel.getPreview3D();
    if (!e)
      return null;
    const t = e.getVariantsAttributeOptions();
    if (!t)
      return null;
    let n = null;
    return t.get("attributeGuid") && (n = this._zkModel.getAttributeByGuid(t.get("attributeGuid"))), n || (n = this._zkModel.get("attributes").getAttributeByCode("variants_attribute")), n;
  }
  checkVariantOption(e, t, n, s) {
    const o = this.getVariantID(s);
    let h = e.get("variantOptions").getVariantOption(o);
    h || (h = this.createVariantOption(e, s)), this.checkVariantOptionMaterial(e, h, t, n, s);
  }
  createVariantOption(e, t) {
    const n = this.getVariantID(t), s = this.getOrCreateVariantAttribute(e), o = this.getOrCreateVariantAttributeOption(e, t, s), h = new MPlaza.VariantOption();
    return h.set("variantID", n), h.set("optionGuid", o.get("optionGuid")), e.get("variantOptions").push(h), h;
  }
  removeVariantOption(e, t) {
    const n = this._zkModel.getAttributeByGuid(e.get("attributeGuid"));
    if (n) {
      const s = n.getOptionByGuid(t.get("optionGuid"));
      s && n.get("options").remove(s);
    }
    for (let s = 0; s < t.get("materials").length; s++) {
      const h = t.get("materials").at(s).get("optionMaterialID");
      this.deleteSceneMaterial(h);
    }
    e.get("variantOptions").remove(t);
  }
  getOrCreateVariantAttribute(e) {
    let t = this.getVariantAttribute();
    if (!t) {
      for (let n = 0; n < e.get("variantOptions").length; n++)
        this.removeVariantOption(
          e,
          e.get("variantOptions").at(n)
        );
      t = new MPlaza.Attribute(), t.set("attributeGuid", MPlaza.generateUUID()), t.set("name", "Variants attribute"), t.set("attributeCode", "variants_attribute"), t.set("attributeTypeID", MPlaza.AttributeType.Options), this._zkModel.get("attributes").push(t);
    }
    return e.set("attributeGuid", t.get("attributeGuid")), t;
  }
  getOrCreateVariantAttributeOption(e, t, n) {
    const s = this.getVariantID(t);
    let o = n.getOptionByCode(s);
    return o || (o = new MPlaza.AttributeOption(), o.set("optionCode", s), o.set("name", t.get("name")), n.get("options").push(o)), o;
  }
  getVariantID(e) {
    return `${e.getModelID()}_${e.getColorID()}`;
  }
  checkVariantOptionMaterial(e, t, n, s, o) {
    const h = this.getVariantID(o);
    let c = null;
    for (let _ = 0; _ < t.get("materials").length; _++) {
      const x = t.get("materials").at(_);
      if (x.get("variableMaterialID") === n.id) {
        c = x;
        break;
      }
    }
    if (!c) {
      let _ = this.getSceneMaterialForVariant(h, n.id);
      if (!_) {
        const x = `${n.name} - ${o.get("name")}`;
        _ = this.cloneSceneMaterial(n.id, void 0, x), _ && this.setupSceneMaterialForVariant(_, h, n.id);
      }
      _ && (c = new MPlaza.VariantOptionMaterial(), c.set("optionMaterialID", _.id), c.set("variableMaterialID", n.id), t.get("materials").push(c));
    }
    c && this.checkVariantOptionActions(
      e,
      t,
      c,
      n,
      s,
      o
    );
  }
  // Una materiale creato per una variante viene marcato con dei metadati. Questo significa che i materiali creati in altro modo
  // e con i materiali giusti verrano riconosciuti e utilizzati per le azioni delle opzioni
  setupSceneMaterialForVariant(e, t, n) {
    const s = this.getOrCreateSceneMaterialMetadata(e.id);
    s.isForPreview = !0, s.autoCreate = !0, s.variantID = t, s.variableMaterialID = n;
  }
  getSceneMaterialForVariant(e, t) {
    const n = this._sceneHelper.getAllMaterials();
    for (let s = 0; s < n.length; s++) {
      const o = n[s], h = this.getSceneMaterialMetadata(o.id);
      if (h && h.isForPreview && h.variantID === e && h.variableMaterialID === t)
        return n[s];
    }
    return null;
  }
  isSceneMaterialForVariant(e) {
    if (!e)
      return !1;
    const t = this.getSceneMaterialMetadata(e.id);
    return t && t.isForPreview;
  }
  canDeleteSceneMaterialForVariant(e) {
    if (!e)
      return !1;
    const t = this.getSceneMaterialMetadata(e.id);
    return !t || t.isForPreview === void 0 || t.isForPreview === null || t.autoCreate === void 0 || t.autoCreate === null ? !0 : t.isForPreview && t.autoCreate;
  }
  getSceneMaterialMetadata(e) {
    return this._sceneHelper.getSceneMaterialMetadata(e);
  }
  getOrCreateSceneMaterialMetadata(e) {
    return this._sceneHelper.getOrCreateSceneMaterialMetadata(e);
  }
  removeSceneMaterialMetadata(e) {
    this._sceneHelper.removeSceneMaterialMetadata(e);
  }
  // Clona un materiale
  cloneSceneMaterial(e, t, n) {
    let s = this._scene.getMaterialById(e), o = null;
    if (s) {
      const h = n || `${s.name} - clone`;
      if (o = s.clone(h), o) {
        const c = t || MPlaza.generateUUID();
        o.id = c;
        const _ = this._zkScene.getMappingForSceneMaterial(s.id);
        if (_) {
          const x = _.get("libraryMaterialID");
          this._zkScene.mapLibraryMaterial(x, o.id);
          const B = this._sceneHelper.getTexturesForMaterial(o), P = this._sceneHelper.getTexturesForMaterial(o);
          for (let U = 0; U < P.length; U++) {
            const M = P[U], Z = B[U];
            M.materialMapping = Z.materialMapping;
          }
        }
      }
    }
    return o;
  }
  deleteSceneMaterial(e) {
    const t = this._scene.getMaterialByID(e);
    if (t && this.canDeleteSceneMaterialForVariant(t)) {
      this.removeSceneMaterialMetadata(e);
      const n = this._zkScene.getLibraryShaderMaterialIDForSceneMaterial(e);
      n && this._zkScene.unregisterShaderMaterial(n), this._zkScene.removeMappingForSceneMaterial(t.id);
      const s = this._sceneHelper.getTexturesExclusivelyForMaterial(t);
      t.dispose();
      for (let o = 0; o < s.length; o++)
        s[o].dispose();
    }
  }
  checkVariantOptionActions(e, t, n, s, o, h) {
    let c = [];
    o.forEach((P) => c.push(P.id));
    let _ = this.getOrCreateVariantAttribute(e), x = this.getOrCreateVariantAttributeOption(e, h, _);
    for (let P = 0; P < o.length; P++) {
      let U = o[P], M = n.get("actions").getActionForMesh(U.id);
      if (!M) {
        let Z = new MPlaza.AttributeSceneAction();
        Z.set("name", ""), Z.set("actionTypeID", MPlaza.SceneActionType.SetMeshMaterial), Z.set("sceneElementTypeID", MPlaza.SceneElementType.Mesh), Z.set("selector", U.id), Z.set("value", n.get("optionMaterialID")), x.get("actions").push(Z), M = new MPlaza.VariantOptionMaterialAction(), M.set("actionGuid", Z.get("actionGuid")), M.set("meshID", U.id), n.get("actions").push(M);
      }
    }
    let B = [];
    for (let P = 0; P < n.get("actions").length; P++) {
      let U = n.get("actions").at(P);
      if (c.indexOf(U.get("meshID")) === -1) {
        let M = x.getActionByGuid(U.get("actionGuid"));
        M && x.get("actions").remove(M), B.push(U);
      }
    }
    n.get("actions").remove(B);
  }
  isMaterialReal(e) {
    var s, o;
    const t = ((s = e.metadata) == null ? void 0 : s.isRealMaterial) !== !1 && e.id !== "default material", n = ((o = e.metadata) == null ? void 0 : o.isDesignMaterial) === !0;
    return t && !n;
  }
  getVariantMaterials(e) {
    let t = [];
    const n = this._zkModel.getPreview3D();
    if (n && e && e instanceof MPlaza.Color) {
      const s = this.getVariantID(e), o = n.getVariantsAttributeOptions();
      if (o) {
        const h = o.getVariantOption(s);
        if (h)
          for (let c = 0; c < h.get("materials").length; c++) {
            const x = h.get("materials").at(c).get("optionMaterialID"), B = this._scene.getMaterialById(x);
            B && this.isMaterialReal(B) && t.push(B);
          }
      }
    }
    return t;
  }
  getSelectedAttributeOption(e) {
    let t = {
      attributeID: null,
      attributeGuid: null,
      optionID: null,
      optionGuid: null
    };
    const n = this._zkModel.getPreview3D();
    if (n && e && e instanceof MPlaza.Color) {
      const s = this.getVariantID(e), o = n.getVariantsAttributeOptions();
      if (o && o.get("attributeGuid")) {
        const h = this._zkModel.getAttributeByGuid(o.get("attributeGuid"));
        if (h) {
          const c = o.getVariantOption(s);
          if (c) {
            const _ = h.getOptionByGuid(c.get("optionGuid"));
            _ && (t.attributeID = h.get("attributeID"), t.attributeGuid = h.get("attributeGuid"), t.optionID = _.get("optionID"), t.optionGuid = _.get("optionGuid"));
          }
        }
      }
    }
    return t;
  }
  resetOriginaMaterialsOnMeshes() {
    const e = this._zkModel.getPreview3D();
    if (e) {
      const t = e.getVariantsAttributeOptions();
      if (t)
        for (let n = 0; n < t.get("variableMaterials").length; n++) {
          const s = t.get("variableMaterials").at(n), o = s.get("materialID"), h = s.get("meshes"), c = this._scene.getMaterialByID(o);
          if (c)
            for (let _ = 0; _ < h.length; _++) {
              const x = this._scene.getMeshById(s.get("meshes")[_]);
              x && this._sceneHelper.applyMaterial(c, x);
            }
        }
    }
  }
  // Una mesh usa un materiale se sulla mesh è impostato direttamente quel materiale o se sulla mesh è
  // attualmente impostato un materiale creato ad hoc per la preview 3D e che deriva dal materiale in oggetto (clone)
  getMeshesUsingMaterial(e) {
    const t = [], n = this._sceneHelper.getSceneMeshes();
    for (let s = 0; s < n.length; s++) {
      const o = n[s];
      if (this._sceneHelper.isMeshUsingMaterial(o, e))
        t.push(o);
      else {
        const h = this._sceneHelper.getMeshMaterials(o);
        for (let c = 0; c < h.length; c++) {
          const _ = h[c], x = this.getSceneMaterialMetadata(_.id);
          if (x && x.isForPreview && x.variableMaterialID && x.variableMaterialID === e) {
            t.push(o);
            break;
          }
        }
      }
    }
    return t;
  }
  getMaterialsForMeshes(e) {
    const t = e.map((s) => typeof s == "string" ? this._scene.getMeshById(s) : s), n = [];
    for (let s = 0; s < t.length; s++) {
      const o = t[s];
      if (o) {
        const h = this._sceneHelper.getMeshMaterials(o);
        for (let c = 0; c < h.length; c++) {
          const _ = h[c];
          n.indexOf(_) === -1 && this.isMaterialReal(_) && n.push(_);
        }
      }
    }
    return n;
  }
  // Restituisce l'elenco delle mesh associate ad una variante
  // Se la variante non ha mesh associate, restituisce le mesh base
  getVariantMeshes(e) {
    const t = this._zkModel.getPreview3D();
    if (!t)
      return [is];
    const n = t == null ? void 0 : t.getVariantsAttributeOptions();
    if (!n)
      return [is];
    const s = this.getVariantID(e), o = n.get("variantOptions").getVariantOption(s);
    if (!o)
      return [is];
    const h = o.get("meshes");
    return h.length > 0 ? h : [is];
  }
  /**
   * Given a mesh, returns the variant it is associated with.
   * If the mesh is not associated with any variant, it returns null, which would be the base mesh.
   * It is used for AR, to know which variant was used for the measurement.
   * @param meshID The ID of the mesh to get the variant for.
   * @returns The variant associated with the mesh, or null if the mesh is not associated with any variant.
   */
  getVariantByMeshID(e) {
    const t = this._zkModel.getPreview3D();
    if (!t)
      return null;
    const n = t.getVariantsAttributeOptions();
    if (!n)
      return null;
    for (let s = 0; s < this._zkModel.get("colors").length; s++) {
      const o = this._zkModel.get("colors").at(s), h = this.getVariantID(o), c = n.getVariantOption(h);
      if (c && c.get("meshes").indexOf(e) !== -1)
        return o;
    }
    return null;
  }
  /**
   * Check if a variant has custom meshes associated with it.
   * @param modelColor  The color of the variant to check.
   * @returns True if the variant has custom meshes, false otherwise.
   */
  hasVariantCustomModel(e) {
    const t = this.getVariantMeshes(e);
    return !(t.length === 1 && t[0] === is);
  }
  /**
   * Set the meshes associated with a variant.
   * @param modelColor The color of the variant to set meshes for.
   * @param meshIDs The list of mesh IDs to set as variant meshes.
   */
  setVariantMeshes(e, t) {
    const s = this._zkModel.getOrCreatePreview3D().getOrCreateVariantsAttributeOptions(), o = this.getVariantID(e);
    let h = s.get("variantOptions").getVariantOption(o);
    h || (h = this.createVariantOption(s, e)), h.set("meshes", t), this.refreshOptionsShowHideVariantModels();
  }
  /**
   * Remove all meshes associated with a variant.
   * @param modelColor The color of the variant to remove meshes from.
   */
  removeVariantMeshes(e) {
    const n = this._zkModel.getOrCreatePreview3D().getOrCreateVariantsAttributeOptions(), s = this.getVariantID(e);
    let o = n.get("variantOptions").getVariantOption(s);
    if (o) {
      const h = o.get("meshes");
      for (const c of h) {
        const _ = this._scene.getMeshById(c);
        _ == null || _.dispose(!1, !0);
      }
      o.set("meshes", []);
    }
    this.updateVariableMaterials(), this.refreshOptionsShowHideVariantModels();
  }
  /**
   * Set the current base meshes for the scene.
   * @param meshIDs The list of mesh IDs to set as base meshes.
   */
  setBaseMeshes(e) {
    let t = this._scene.getMeshById(is);
    t || (t = new BABYLON.Mesh(is, this._scene), t.id = is);
    for (const n of e) {
      const s = this._scene.getMeshById(n);
      s && s.setParent(t);
    }
  }
  /**
   * Remove current base meshes from the scene.
   */
  removeBaseMeshes() {
    const e = this._scene.getMeshById(is);
    if (e) {
      const t = e.getChildMeshes(!0);
      for (const n of t)
        n.setParent(null);
    }
  }
  /**
   * Upgrade an old preview 3D scene to the new base mesh system.
   */
  upgradeToBaseMeshes() {
    this._scene.getMeshById(is) !== null || this.setBaseMeshes(
      this._scene.meshes.filter((t) => !t.parent && t.id !== is).map((t) => t.id) ?? []
    );
  }
  /**
   * This method will create or update all options by setting the correct show/hide actions
   * to show the base model or the variant model.
   */
  refreshOptionsShowHideVariantModels() {
    const t = this._zkModel.getOrCreatePreview3D().getOrCreateVariantsAttributeOptions(), n = this.getOrCreateVariantAttribute(t);
    for (let s = 0; s < this._zkModel.get("colors").length; s++) {
      const o = this._zkModel.get("colors").at(s), h = this.getVariantID(o);
      let c = t.get("variantOptions").getVariantOption(h);
      c || (c = this.createVariantOption(t, o));
      const _ = this.getOrCreateVariantAttributeOption(t, o, n);
      let x = _.get("actions").find(
        (B) => B.get("selector") === "*" && B.get("actionTypeID") === MPlaza.SceneActionType.ShowHideMesh
      );
      x || (x = new MPlaza.AttributeSceneAction(), x.set("name", ""), x.set("actionTypeID", MPlaza.SceneActionType.ShowHideMesh), x.set("sceneElementTypeID", MPlaza.SceneElementType.Mesh), x.set("selector", "*"), x.set("value", "hide"), _.get("actions").push(x));
      for (let B = 0; B < _.get("actions").length; B++) {
        const P = _.get("actions").at(B);
        P.get("actionTypeID") === MPlaza.SceneActionType.ShowHideMesh && P.get("selector") !== "*" && (_.get("actions").remove(P), B--);
      }
      if ((c == null ? void 0 : c.get("meshes").length) === 0) {
        const B = new MPlaza.AttributeSceneAction();
        B.set("name", ""), B.set("actionTypeID", MPlaza.SceneActionType.ShowHideMesh), B.set("sceneElementTypeID", MPlaza.SceneElementType.Mesh), B.set("selector", is), B.set("value", "show"), _.get("actions").push(B);
      } else
        for (const B of c.get("meshes")) {
          const P = new MPlaza.AttributeSceneAction();
          P.set("name", ""), P.set("actionTypeID", MPlaza.SceneActionType.ShowHideMesh), P.set("sceneElementTypeID", MPlaza.SceneElementType.Mesh), P.set("selector", B), P.set("value", "show"), _.get("actions").push(P);
        }
    }
  }
  // Design materials
  setDesignMaterialForVariantEnabled(e, t) {
    var c;
    const n = this.hasVariantCustomModel(e) ? e.get("colorID") : null, s = this._zkModel.get("scenes").at(0).get("meshSides").filter((_) => _.get("colorID") === n), o = (c = s.at(0)) == null ? void 0 : c.get("materialID");
    let h = o ? this._scene.getMaterialById(o) : null;
    t || (s.forEach((_) => {
      _.set("materialID", null);
    }), h && (s.some(
      (x) => x.get("materialID") === h.id
    ) || h.dispose())), t && !h && (h = new BABYLON.PBRMaterial("Design material", this._scene), h.id = Zakeke.generateUUID(), h.zOffset = -1, h.metallic = 0.5, h.roughness = 0.2, s.forEach((_) => {
      _.set("materialID", h.id);
    }));
  }
  getDesignMaterialForVariant(e) {
    const t = this.hasVariantCustomModel(e) ? e.get("colorID") : null, n = this._zkModel.get("scenes").at(0).get("meshSides").find((o) => o.get("colorID") === t), s = n ? n.get("materialID") : null;
    return s ? this._scene.getMaterialById(s) : null;
  }
}
function ig(b) {
  return typeof importScripts == "function" ? (importScripts(b), Promise.resolve()) : new Promise((e, t) => {
    BABYLON.Tools.LoadScript(b, () => {
      e();
    }, (n) => {
      t(new Error(n));
    });
  });
}
function kw(b) {
  return new Promise((e, t) => {
    BABYLON.Tools.LoadFile(b, (n) => {
      e(n);
    }, void 0, void 0, !0, (n, s) => {
      t(s);
    });
  });
}
function Zh(b, e, t) {
  const n = e && b || t;
  if (n)
    return ig(n).then(() => new Promise((s) => {
      DracoDecoderModule({ wasmBinary: e }).then((o) => {
        s({ module: o });
      });
    }));
}
function qh(b, e, t, n, s) {
  const o = new b.DecoderBuffer();
  o.Init(e, e.byteLength);
  const h = new b.Decoder();
  let c, _;
  try {
    const B = h.GetEncodedGeometryType(o);
    switch (B) {
      case b.TRIANGULAR_MESH:
        c = new b.Mesh(), _ = h.DecodeBufferToMesh(o, c);
        break;
      case b.POINT_CLOUD:
        c = new b.PointCloud(), _ = h.DecodeBufferToPointCloud(o, c);
        break;
      default:
        throw new Error(`Invalid geometry type ${B}`);
    }
    if (!_.ok() || !c.ptr)
      throw new Error(_.error_msg());
    const P = c.num_points();
    if (B === b.TRIANGULAR_MESH) {
      const M = c.num_faces(), Z = new b.DracoInt32Array();
      try {
        const F = new Uint32Array(M * 3);
        for (let Q = 0; Q < M; Q++) {
          h.GetFaceFromMesh(c, Q, Z);
          const D = Q * 3;
          F[D + 0] = Z.GetValue(0), F[D + 1] = Z.GetValue(1), F[D + 2] = Z.GetValue(2);
        }
        n(F);
      } finally {
        b.destroy(Z);
      }
    }
    const U = (M, Z) => {
      const F = new b.DracoFloat32Array();
      try {
        h.GetAttributeFloatForAllPoints(c, Z, F);
        const Q = new Float32Array(P * Z.num_components());
        for (let D = 0; D < Q.length; D++)
          Q[D] = F.GetValue(D);
        s(M, Q);
      } finally {
        b.destroy(F);
      }
    };
    if (t)
      for (const M in t) {
        const Z = t[M], F = h.GetAttributeByUniqueId(c, Z);
        U(M, F);
      }
    else {
      const M = {
        position: "POSITION",
        normal: "NORMAL",
        color: "COLOR",
        uv: "TEX_COORD",
        uv2: "TEX_COORD",
        uv3: "TEX_COORD",
        uv4: "TEX_COORD",
        uv5: "TEX_COORD",
        uv6: "TEX_COORD"
      }, Z = /^uv(\d+)$/;
      for (const F in M) {
        const Q = F.match(Z);
        let D = -1;
        if (Q && Q.length > 1) {
          var x = parseInt(Q[1], 10);
          const te = h.GetAttributeId(c, b.TEX_COORD);
          te !== -1 && (D = te + x - 1);
        } else
          D = h.GetAttributeId(c, b[M[F]]);
        if (D !== -1) {
          const te = h.GetAttributeByUniqueId(c, D);
          te && te.size() > 0 && U(F, te);
        }
      }
    }
  } finally {
    c && b.destroy(c), b.destroy(h), b.destroy(o);
  }
}
function Ew() {
  let b;
  onmessage = (e) => {
    const t = e.data;
    switch (t.id) {
      case "init": {
        const n = t.decoder;
        b = Zh(n.wasmUrl, n.wasmBinary, n.fallbackUrl), postMessage("done");
        break;
      }
      case "decodeMesh": {
        if (!b)
          throw new Error("Draco decoder module is not available");
        b.then((n) => {
          qh(n.module, t.dataView, t.attributes, (s) => {
            postMessage({ id: "indices", value: s }, [s.buffer]);
          }, (s, o) => {
            postMessage({ id: s, value: o }, [o.buffer]);
          }), postMessage("done");
        });
        break;
      }
    }
  };
}
function Nh(b) {
  return typeof document != "object" || typeof b != "string" ? b : BABYLON.Tools.GetAbsoluteUrl(b);
}
const ho = class js {
  /**
   * Returns true if the decoder configuration is available.
   */
  static get DecoderAvailable() {
    const e = js.Configuration.decoder;
    return !!(e.wasmUrl && e.wasmBinaryUrl && typeof WebAssembly == "object" || e.fallbackUrl);
  }
  static GetDefaultNumWorkers() {
    return typeof navigator != "object" || !navigator.hardwareConcurrency ? 1 : Math.min(Math.floor(navigator.hardwareConcurrency * 0.5), 1);
  }
  /**
   * Default instance for the draco compression object.
   */
  static get Default() {
    return js._Default || (js._Default = new js()), js._Default;
  }
  /**
   * Constructor
   * @param numWorkers The number of workers for async operations. Specify `0` to disable web workers and run synchronously in the current context.
   */
  constructor(e = js.DefaultNumWorkers) {
    const t = js.Configuration.decoder, n = t.wasmUrl && t.wasmBinaryUrl && typeof WebAssembly == "object" ? kw(Nh(t.wasmBinaryUrl)) : Promise.resolve(void 0);
    e && typeof Worker == "function" ? this._workerPoolPromise = n.then((s) => {
      const o = `${ig}${Zh}${qh}(${Ew})()`, h = URL.createObjectURL(new Blob([o], { type: "application/javascript" })), c = new Array(e);
      for (let _ = 0; _ < c.length; _++)
        c[_] = new Promise((x, B) => {
          const P = new Worker(h), U = (Z) => {
            P.removeEventListener("error", U), P.removeEventListener("message", M), B(Z);
          }, M = (Z) => {
            Z.data === "done" && (P.removeEventListener("error", U), P.removeEventListener("message", M), x(P));
          };
          P.addEventListener("error", U), P.addEventListener("message", M), P.postMessage({
            id: "init",
            decoder: {
              wasmUrl: Nh(t.wasmUrl),
              wasmBinary: s,
              fallbackUrl: Nh(t.fallbackUrl)
            }
          });
        });
      return Promise.all(c).then((_) => new xu(_));
    }) : this._decoderModulePromise = n.then((s) => Zh(t.wasmUrl, s, t.fallbackUrl));
  }
  /**
   * Stop all async operations and release resources.
   */
  dispose() {
  }
  /**
   * Returns a promise that resolves when ready. Call this manually to ensure draco compression is ready before use.
   * @returns a promise that resolves when ready
   */
  whenReadyAsync() {
    return this._workerPoolPromise ? this._workerPoolPromise.then(() => {
    }) : this._decoderModulePromise ? this._decoderModulePromise.then(() => {
    }) : Promise.resolve();
  }
  /**
    * Decode Draco compressed mesh data to vertex data.
    * @param data The ArrayBuffer or ArrayBufferView for the Draco compression data
    * @param attributes A map of attributes from vertex buffer kinds to Draco unique ids
    * @returns A promise that resolves with the decoded vertex data
    */
  decodeMeshAsync(e, t) {
    const n = e instanceof ArrayBuffer ? new Uint8Array(e) : e;
    if (this._workerPoolPromise)
      return this._workerPoolPromise.then((s) => new Promise((o, h) => {
        s.push((c, _) => {
          const x = new BABYLON.VertexData(), B = (M) => {
            c.removeEventListener("error", B), c.removeEventListener("message", P), h(M), _();
          }, P = (M) => {
            M.data === "done" ? (c.removeEventListener("error", B), c.removeEventListener("message", P), o(x), _()) : M.data.id === "indices" ? x.indices = M.data.value : x.set(M.data.value, M.data.id);
          };
          c.addEventListener("error", B), c.addEventListener("message", P);
          const U = new Uint8Array(n.byteLength);
          U.set(new Uint8Array(n.buffer, n.byteOffset, n.byteLength)), c.postMessage({ id: "decodeMesh", dataView: U, attributes: t }, [U.buffer]);
        });
      }));
    if (this._decoderModulePromise)
      return this._decoderModulePromise.then((s) => {
        const o = new BABYLON.VertexData();
        return qh(s.module, n, t, (h) => {
          o.indices = h;
        }, (h, c) => {
          o.set(c, h);
        }), o;
      });
    throw new Error("Draco decoder module is not available");
  }
};
ho.Configuration = {
  decoder: {
    //wasmUrl: getAbsoluteUrl("/Scripts/libs/draco/draco_wasm_wrapper.js"),
    //wasmBinaryUrl: getAbsoluteUrl("/Scripts/libs/draco/draco_decoder.wasm"),
    //fallbackUrl: getAbsoluteUrl("/Scripts/libs/draco/draco_decoder.js")
    /*
    wasmUrl: "https://preview.babylonjs.com/draco_wasm_wrapper_gltf.js",
    wasmBinaryUrl: "https://preview.babylonjs.com/draco_decoder_gltf.wasm",
    fallbackUrl: "https://preview.babylonjs.com/draco_decoder_gltf.js"
    */
    wasmUrl: "https://cdn.zakeke.com/cdn/Scripts/draco/1.3.4/rev.1/draco_wasm_wrapper.js",
    wasmBinaryUrl: "https://cdn.zakeke.com/cdn/Scripts/draco/1.3.4/rev.1/draco_decoder.wasm",
    fallbackUrl: "https://cdn.zakeke.com/cdn/Scripts/draco/1.3.4/rev.1/draco_decoder.js"
  }
};
ho.DefaultNumWorkers = ho.GetDefaultNumWorkers();
ho._Default = null;
let Iw = ho;
class ng {
  constructor(e, t, n = !1) {
    this._originalSceneClearColor = null, this._originalCameraAutoRotate = null, this._environmentHelper = null, this._shadowLight = null, this._isHologram = !1, this._zkScene = e, this._scene = t, this._sceneHelper = new mi(this._scene), this._isHologram = n;
  }
  get zkScene() {
    return this._zkScene;
  }
  get scene() {
    return this._scene;
  }
  get isHologram() {
    return this._isHologram;
  }
  set isHologram(e) {
    this._isHologram = e, this.update();
  }
  dispose() {
    this._shadowLight && this._shadowLight.dispose(), this._environmentHelper && (this._environmentHelper.dispose(), this._environmentHelper = null), this.removeOldSkybox();
  }
  update() {
    this.configureScene(), this.configureCamera(), this.configureSkybox();
  }
  configureSkybox() {
    this.removeOldSkybox(), this._isHologram || this.createSkybox();
  }
  removeOldSkybox() {
    const e = this.getSkyboxMesh(), t = this.getSkyboxMaterial();
    e && e.dispose(), t && t.dispose();
  }
  createSkybox() {
    var n, s;
    this.getGeneralConfig();
    const e = this.getEnvironmentConfig(), t = this.getSkyboxConfig();
    if (t && t.get("createSkybox") != null && t.get("createSkybox")) {
      e && e.get("sizeAuto") != null && e.get("sizeAuto") != null && typeof e.get("sizeAuto") == "boolean" && e.get("sizeAuto");
      let o = null;
      t.get("size") != null && typeof t.get("size") == "number" && (o = t.get("size"));
      let h = null;
      t.get("texture") != null && typeof t.get("texture") == "string" && (h = t.get("texture"));
      let c = 0;
      t.get("blur") > 0 && (c = t.get("blur"));
      let _ = null;
      t.get("extensions") != null && t.get("extensions") != null && Object.prototype.toString.call(t.get("extensions")) === "[object Array]" && ((n = t.get("extensions")) == null ? void 0 : n.length) === 6 && (_ = t.get("extensions"));
      let x = null;
      if (t.get("files") != null && t.get("files") != null && Object.prototype.toString.call(t.get("files")) === "[object Array]" && ((s = t.get("files")) == null ? void 0 : s.length) === 6 && (x = t.get("files")), h) {
        let B = null;
        if (h.endsWith(".dds") ? B = BABYLON.CubeTexture.CreateFromPrefilteredData(h, this._scene) : h.endsWith(".hdr") ? B = new BABYLON.HDRCubeTexture(h, this._scene, 256, !1, !0, !1, !0) : h.endsWith(".env") ? B = new BABYLON.CubeTexture(
          h,
          this._scene,
          null,
          !1,
          null,
          void 0,
          null,
          void 0,
          !0,
          void 0,
          !0
        ) : h.endsWith(".basis") ? B = BABYLON.CubeTexture.CreateFromPrefilteredData(h, this._scene) : _ && x ? B = new BABYLON.CubeTexture(h, this._scene, _, !1, x, void 0) : B = BABYLON.CubeTexture.CreateFromPrefilteredData(h, this._scene), B) {
          let P = 1e3;
          o != null && o > 0 ? P = o : P = (this._scene.activeCamera.maxZ - this._scene.activeCamera.minZ) / 2;
          const U = this._scene.createDefaultSkybox(B, !0, P, c, !1);
          if (U) {
            U.metadata = { isSkyboxMesh: !0, isRealMesh: !1 }, U.doNotSerialize = !0;
            const M = U.material;
            M && (M.metadata = { isSkyboxMaterial: !0, isRealMaterial: !1 }, M.doNotSerialize = !0);
          }
        }
      }
    }
  }
  getSkyboxMesh() {
    return this._scene.meshes.find((t) => t.metadata && t.metadata.isSkyboxMesh) || null;
  }
  getSkyboxMaterial() {
    let e = this._scene.materials.find((t) => t.metadata && t.metadata.isSkyboxMaterial);
    return e || null;
  }
  getSkyboxTexture() {
    const e = this.getSkyboxMaterial();
    return e ? e.reflectionTexture : null;
  }
  update_OLD() {
    this.configureScene(), this.configureCamera(), this.configureEnvironment();
  }
  configureScene() {
    if (this._scene) {
      if (this._scene.clearColor = new BABYLON.Color4(0, 0, 0, 0), this._originalSceneClearColor = this._scene.clearColor.clone(), this._isHologram) {
        this._scene.clearColor = new BABYLON.Color4(0, 0, 0, 1);
        return;
      }
      var e = this.getGeneralConfig();
      if (e) {
        let t = null;
        e.get("backgroundAlpha") != null && e.get("backgroundAlpha") != null && typeof e.get("backgroundAlpha") == "number" && (t = e.get("backgroundAlpha"));
        let n = null;
        if (e.get("backgroundColor") != null && typeof e.get("backgroundColor") == "string" && this.isValidHexColor(e.get("backgroundColor")) && (n = e.get("backgroundColor")), t || n) {
          this._originalSceneClearColor = this._scene.clearColor;
          let s = this._scene.clearColor;
          if (n != null) {
            let o = BABYLON.Color3.FromHexString(n);
            s.r = o.r, s.g = o.g, s.b = o.b;
          }
          t != null && (s.a = t);
        }
      }
    }
  }
  configureEnvironment() {
    if (this._environmentHelper && (this._environmentHelper.dispose(), this._environmentHelper = null), this._shadowLight && (this._shadowLight.dispose(), this._shadowLight = null), this._sceneHelper.countSceneMeshes() != 0) {
      var e = this.buildEnvironmentHelperOptions();
      if (e) {
        this._environmentHelper = this._scene.createDefaultEnvironment(e);
        const t = this.getEnvironmentSceneNodes();
        for (let n = 0; n < t.length; n++) {
          const s = t[n];
          s && (this.setDoNotSerialize(s), s.metadata || (s.metadata = {}), s.metadata.isEnvironmentNode = !0, s instanceof BABYLON.AbstractMesh && (s.isPickable = !1, s.metadata.isRealMesh = !1), s instanceof BABYLON.Material && (s.metadata.isRealMaterial = !1));
        }
      }
    }
  }
  buildEnvironmentHelperOptions() {
    let e = null;
    const t = this.getGeneralConfig(), n = this.getEnvironmentConfig(), s = this.getSkyboxConfig(), o = this.getGroundConfig(), h = this.getCameraConfig();
    let c = null;
    t && t.get("environmentTexture") != null && t.get("environmentTexture") != null && (c = t.get("environmentTexture"));
    let _ = null;
    h && h.get("contrast") != null && typeof h.get("contrast") == "number" && (_ = h.get("contrast"));
    let x = null;
    h && h.get("exposure") != null && typeof h.get("exposure") == "number" && (x = h.get("exposure"));
    let B = null;
    h && h.get("toneMappingEnabled") != null && typeof h.get("toneMappingEnabled") == "boolean" && (B = h.get("toneMappingEnabled"));
    let P = null;
    n && n.get("sizeAuto") != null && n.get("sizeAuto") != null && typeof n.get("sizeAuto") == "boolean" && (P = n.get("sizeAuto"));
    let U = null;
    n && n.get("mainColor") != null && typeof n.get("mainColor") == "string" && this.isValidHexColor(n.get("mainColor")) && (U = n.get("mainColor"));
    let M = null;
    o && o.get("size") != null && typeof o.get("size") == "number" && (M = o.get("size"));
    let Z = null;
    o && o.get("color") != null && typeof o.get("color") == "string" && this.isValidHexColor(o.get("color")) && (Z = o.get("color"));
    let F = null;
    o && o.get("enableShadow") != null && typeof o.get("enableShadow") == "boolean" && (F = o.get("enableShadow"));
    let Q = null;
    o && o.get("shadowLevel") != null && typeof o.get("shadowLevel") == "number" && (Q = o.get("shadowLevel"));
    let D = null;
    o && o.get("enableMirror") != null && typeof o.get("enableMirror") == "boolean" && (D = o.get("enableMirror"));
    let te = null;
    o && o.get("texture") != null && typeof o.get("texture") == "string" && (te = o.get("texture"));
    let ee = null;
    o && o.get("opacity") != null && typeof o.get("opacity") == "number" && (ee = o.get("opacity"));
    let le = null;
    o && o.get("mirrorBlurKernel") != null && typeof o.get("mirrorBlurKernel") == "number" && (le = o.get("mirrorBlurKernel"));
    let fe = null;
    s && s.get("size") != null && typeof s.get("size") == "number" && (fe = s.get("size"));
    let X = null;
    s && s.get("color") != null && typeof s.get("color") == "string" && this.isValidHexColor(s.get("color")) && (X = s.get("color"));
    let W = null;
    s && s.get("texture") != null && typeof s.get("texture") == "string" && (W = s.get("texture"));
    let je = c != null || _ != null || x != null || B;
    return (s || o || je) && (e = e || {
      createSkybox: s && s.get("createSkybox"),
      createGround: o && o.get("createGround")
    }, e.setupImageProcessing = !1, c != null && (e.environmentTexture = c), (e.createSkybox || e.createGround) && (P != null && (e.sizeAuto = P), U != null && (e.mainColor = BABYLON.Color3.FromHexString(U)), e.createGround && (!e.sizeAuto && M != null && (e.groundSize = M), !e.mainColor && Z != null && (e.groundColor = BABYLON.Color3.FromHexString(Z)), F != null && (e.enableGroundShadow = F), e.enableGroundShadow && this.createShadowLight(), Q != null && (e.groundShadowLevel = Q), D != null && (e.enableGroundMirror = D), te != null && (e.groundTexture = te), ee != null && (e.groundOpacity = ee), e.enableGroundMirror && le != null && (e.groundMirrorBlurKernel = le)), e.createSkybox && (!e.sizeAuto && fe != null && (e.skyboxSize = fe), !e.mainColor && X != null && (e.skyboxColor = BABYLON.Color3.FromHexString(X)), W != null && (e.skyboxTexture = W)), h && (_ != null && (e.cameraContrast = _), x != null && (e.cameraExposure = x), B != null && (e.toneMappingEnabled = B)))), e && (!e.environmentTexture && !this._scene.environmentTexture && (e.environmentTexture = ci.Environment.EnvironmentTextureCDNUrl), e.createGround != null && e.createGround && !e.groundTexture && (e.groundTexture = ci.Environment.GroundTextureCDNUrl), e.createSkybox != null && e.createSkybox && !e.skyboxTexture && (e.skyboxTexture = ci.Environment.SkyboxTextureCDNUrl)), e;
  }
  createShadowLight() {
    if (this._shadowLight && (this._shadowLight.dispose(), this._shadowLight = null), this._scene && this._sceneHelper) {
      var e = this._sceneHelper.getSceneBoundingInfo();
      if (e && e.boundingBox) {
        const n = e.boundingBox.vectorsWorld, s = Number(n[1].x - n[0].x), o = Number(n[1].y - n[0].y), h = Number(n[1].z - n[0].z), c = e.boundingBox.centerWorld;
        e.boundingBox.maximumWorld;
        const _ = c.x + s * 2.67, x = c.y + o * 4.5, B = c.z + h * 1, P = new BABYLON.Vector3(_, x, B);
        let M = c.subtract(P);
        M = BABYLON.Vector3.Normalize(M), M = new BABYLON.Vector3(-2, -3, 1), this._shadowLight = new BABYLON.DirectionalLight("shadowLight", M, this._scene), this._shadowLight.position = P, this._shadowLight.intensity = 0.1;
        var t = new BABYLON.ShadowGenerator(512, this._shadowLight);
        t.useBlurExponentialShadowMap = !0, t.useKernelBlur = !0, t.usePercentageCloserFiltering = !0, t.blurKernel = 32;
        for (let Z = 0; Z < this._scene.meshes.length; Z++) {
          const F = this._scene.meshes[Z];
          !this.isEnvironmentNode(F) && this._sceneHelper.isRealMesh(F) && (F.receiveShadows = !1, t.addShadowCaster(F));
        }
      }
    }
  }
  configureCamera() {
    if (!this._scene || !this._scene.activeCamera || !(this._scene.activeCamera instanceof BABYLON.ArcRotateCamera))
      return;
    const e = this.getCameraConfig();
    if (e) {
      const t = this._scene.activeCamera;
      this._originalCameraAutoRotate = t.useAutoRotationBehavior;
      let n = e.get("autoRotate");
      t.useAutoRotationBehavior = n != null && n;
      let s = t.getBehaviorByName("AutoRotation"), o = Number(e.get("rotationSpeed")), h = e.get("changeRotationDirection");
      if (n && o) {
        let c = h ? -1 : 1;
        s.idleRotationSpeed = o * c;
      }
    }
  }
  sanityCheck() {
    return this._scene && this._scene instanceof BABYLON.Scene && this._zkScene && this._zkScene instanceof Zakeke.Scene && this._zkScene.get("config") != null && this._zkScene.get("config") != null && this._zkScene.get("config") instanceof Zakeke.SceneConfig;
  }
  getSceneConfig() {
    if (this.sanityCheck()) {
      let e = this._zkScene.getSceneConfig();
      if (e != null && e != null)
        return e;
    }
    return null;
  }
  getGeneralConfig() {
    if (this.sanityCheck()) {
      let e = this._zkScene.getGeneralConfig();
      if (e != null && e != null)
        return e;
    }
    return null;
  }
  getEnvironmentConfig() {
    if (this.sanityCheck()) {
      let e = this._zkScene.getEnvironmentConfig();
      if (e != null && e != null)
        return e;
    }
    return null;
  }
  getSkyboxConfig() {
    if (this.sanityCheck()) {
      let e = this._zkScene.getSkyboxConfig();
      if (e != null && e != null)
        return e;
    }
    return null;
  }
  getGroundConfig() {
    if (this.sanityCheck()) {
      let e = this._zkScene.getGroundConfig();
      if (e != null && e != null)
        return e;
    }
    return null;
  }
  getCameraConfig() {
    if (this.sanityCheck()) {
      let e = this._zkScene.getCameraConfig();
      if (e != null && e != null)
        return e;
    }
    return null;
  }
  isValidHexColor(e) {
    return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(e);
  }
  getEnvironmentSceneNodes() {
    const e = [];
    return this._environmentHelper && (this._environmentHelper.rootMesh && e.push(this._environmentHelper.rootMesh), this._environmentHelper.skybox && e.push(this._environmentHelper.skybox), this._environmentHelper.skyboxMaterial && e.push(this._environmentHelper.skyboxMaterial), this._environmentHelper.skyboxTexture && e.push(this._environmentHelper.skyboxTexture), this._environmentHelper.ground && e.push(this._environmentHelper.ground), this._environmentHelper.groundMaterial && e.push(this._environmentHelper.groundMaterial), this._environmentHelper.groundTexture && e.push(this._environmentHelper.groundTexture), this._environmentHelper.groundMirror && e.push(this._environmentHelper.groundMirror), this._shadowLight && e.push(this._shadowLight)), e;
  }
  isEnvironmentNode(e) {
    const t = this.getEnvironmentSceneNodes();
    for (let n = 0; n < t.length; n++)
      if (e == t[n])
        return !0;
    return !1;
  }
  setDoNotSerialize(e) {
    (e instanceof BABYLON.AbstractMesh || e instanceof BABYLON.Material || e instanceof BABYLON.Light) && (e.doNotSerialize = !0);
  }
  reset() {
    this._scene && (this._originalSceneClearColor && (this._scene.clearColor = this._originalSceneClearColor), this._originalCameraAutoRotate != null && this._scene.activeCamera && this._scene.activeCamera instanceof BABYLON.ArcRotateCamera && (this._scene.activeCamera.useAutoRotationBehavior = this._originalCameraAutoRotate), this._environmentHelper && this._environmentHelper.updateOptions({}));
  }
}
function rg(b) {
  return typeof importScripts == "function" ? (importScripts(b), Promise.resolve()) : new Promise((e, t) => {
    BABYLON.Tools.LoadScript(
      b,
      () => {
        e();
      },
      (n) => {
        t(new Error(n));
      }
    );
  });
}
function sg(b) {
  if (b.length == 0)
    return Promise.resolve();
  let e = [];
  for (let t = 0; t < b.length; t++)
    e.push(rg(b[t]));
  return new Promise((t) => {
    Promise.all(e).then(() => t());
  });
}
function ag(b, e) {
  return b ? b.match(new RegExp(".[^]{1," + e + "}", "g")) : null;
}
function og(b, e, t) {
  let n = "scene_" + e + ".babylon", s = b;
  const o = [];
  if (s.length <= 5e6) {
    let c = !1;
    s.length > 180 && s.length <= 1e6 && (s = LZString.compressToUint8Array(s), n = "compressed_" + n, c = !0);
    let _ = null;
    if (!c)
      _ = new Blob([s], { type: "text/plain" });
    else {
      let x = s.buffer;
      _ = new Blob([x]);
    }
    _ && o.push({
      name: n,
      blob: _
    });
  } else {
    let c = ag(s, 8e5);
    if (c)
      for (let _ = 0; _ < c.length; _++) {
        let x = c[_], B = n + "_part_" + _, P = !1;
        x.length > 180 && (x = LZString.compressToUint8Array(x), B = "compressed_" + B, P = !0);
        let U = null;
        if (!P)
          U = new Blob([x], { type: "text/plain" });
        else {
          var h = x.buffer;
          U = new Blob([h]);
        }
        U && o.push({
          name: B,
          blob: U
        }), t(_ / c.length * 100);
      }
  }
  return o;
}
function Pw(b) {
  return typeof document != "object" || typeof b != "string" ? b : BABYLON.Tools.GetAbsoluteUrl(b);
}
function Ow() {
  let b;
  onmessage = (e) => {
    const t = e.data;
    switch (t.id) {
      case "init": {
        const n = t.urls;
        b = sg(n), postMessage("done");
        break;
      }
      case "makeBlobs": {
        if (!b)
          throw new Error("Worker not initialized");
        b.then(() => {
          const n = t.json, s = t.version, o = og(n, s, (h) => {
            postMessage({ id: "progress", perc: h });
          });
          postMessage({ id: "result", blobInfos: o }), postMessage("done");
        });
        break;
      }
    }
  };
}
const bl = class Ma {
  static GetDefaultNumWorkers() {
    return typeof navigator != "object" || !navigator.hardwareConcurrency ? 1 : Math.min(Math.floor(navigator.hardwareConcurrency * 0.5), 2);
  }
  /**
   * Default instance for the draco compression object.
   */
  static get Default() {
    return Ma._Default || (Ma._Default = new Ma([])), Ma._Default;
  }
  /**
   * Constructor
   * @param numWorkers The number of workers for async operations. Specify `0` to disable web workers and run synchronously in the current context.
   */
  constructor(e, t = Ma.DefaultNumWorkers) {
    const n = e.map((s) => Pw(s));
    if (t && typeof Worker == "function") {
      const s = `${rg}${sg}${ag}${og}(${Ow})()`, o = URL.createObjectURL(new Blob([s], { type: "application/javascript" })), h = new Array(t);
      for (let c = 0; c < h.length; c++)
        h[c] = new Promise((_, x) => {
          const B = new Worker(o), P = (M) => {
            B.removeEventListener("error", P), B.removeEventListener("message", U), x(M);
          }, U = (M) => {
            M.data === "done" && (B.removeEventListener("error", P), B.removeEventListener("message", U), _(B));
          };
          B.addEventListener("error", P), B.addEventListener("message", U), B.postMessage({
            id: "init",
            urls: n
          });
        });
      this._workerPoolPromise = Promise.all(h).then((c) => new xu(c));
    }
  }
  dispose() {
  }
  /**
   * Returns a promise that resolves when ready. Call this manually to ensure draco compression is ready before use.
   * @returns a promise that resolves when ready
   */
  whenReadyAsync() {
    return this._workerPoolPromise ? this._workerPoolPromise.then(() => {
    }) : Promise.resolve();
  }
  getSceneBlobsAsync(e, t, n) {
    if (this._workerPoolPromise)
      return this._workerPoolPromise.then((s) => new Promise((o, h) => {
        s.push((c, _) => {
          let x = [];
          const B = (U) => {
            c.removeEventListener("error", B), c.removeEventListener("message", P), h(U), _();
          }, P = (U) => {
            U.data === "done" ? (c.removeEventListener("error", B), c.removeEventListener("message", P), o(x), _()) : U.data.id === "progress" ? n(U.data.perc) : U.data.id === "result" && (x = U.data.blobInfos);
          };
          c.addEventListener("error", B), c.addEventListener("message", P), c.postMessage({ id: "makeBlobs", json: e, version: t });
        });
      }));
    throw new Error("SceneToBlob worker is not available");
  }
};
bl.DefaultNumWorkers = bl.GetDefaultNumWorkers();
bl._Default = null;
let Nw = bl;
class Pl {
  static openSceneViewer(e, t, n = !0, s = null) {
    if (this._fallbackInvoked)
      return;
    const o = self.location.toString(), h = new URL(o), c = new URL(e), _ = new URLSearchParams(c.search);
    if (h.hash = this._noArViewerSigil, _.set("mode", "ar_preferred"), _.has("disable_occlusion") || _.set("disable_occlusion", "true"), n || _.set("resizable", "false"), s && s.toLowerCase() === "wall" && _.set("enable_vertical_placement", "true"), _.has("sound")) {
      const P = new URL(_.get("sound"), o);
      _.set("sound", P.toString());
    }
    if (_.has("link")) {
      const P = new URL(_.get("link"), o);
      _.set("link", P.toString());
    }
    const x = `intent://arvr.google.com/scene-viewer/1.0?${_.toString() + "&file=" + encodeURIComponent(
      c.toString()
    )}#Intent;scheme=https;package=com.google.ar.core;action=android.intent.action.VIEW;S.browser_fallback_url=${encodeURIComponent(h.toString())};end;`;
    console.log(x);
    const B = () => {
      self.location.hash === this._noArViewerSigil && !this._fallbackInvoked && (this._fallbackInvoked = !0, t && t(), self.history.back());
    };
    self.addEventListener("hashchange", B, { once: !0 }), this._anchor.setAttribute("href", x), this._anchor.setAttribute("target", "_blank"), document.body.appendChild(this._anchor), this._anchor.click();
  }
}
Pl._anchor = document.createElement("a");
Pl._linkOrTitle = /(link|title)(=|&)|(\?|&)(link|title)$/;
Pl._noArViewerSigil = "#model-viewer-no-ar-fallback";
Pl._fallbackInvoked = !1;
class Rw {
  constructor(e, t, n) {
    this._meshesInfoPoints = {}, this._infoPoints = [], this._imageUrls = [], this._currentIdx = 0, this._imagePanel = null, this._loadingText = null, this._image = null, this._closeImageButton = null, this._moveNextImageButton = null, this._movePrevImageButton = null, this._isOnMoveNextButton = !1, this._isOnMovePrevButton = !1, this._lastCameraPosition = null, this.onBeforeShowImages = null, this.onAfterShowImages = null, this._infoPointsShown = !0, this._canShowInfoPointsContent = !0, this._infoPointPickedListeners = [], this._infoPointContentShownListeners = [], this._infoPointContentHiddenListeners = [], this._renderingNeededListeners = [], this.CLOSE_SVG = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='24' viewBox='0 0 24 24' width='24'%3E%3Cg id='mdi-close' style='fill:§color§'%3E%3Cpath d='M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'/%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3C/g%3E%3C/svg%3E", this.CHEVRON_LEFT_SVG = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='24' viewBox='0 0 24 24' width='24'%3E%3Cg id='mdi-chevron-left'%3E%3Cpath fill='§color§' d='M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z' /%3E%3C/g%3E%3C/svg%3E", this.CHEVRON_RIGHT_SVG = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='24' viewBox='0 0 24 24' width='24'%3E%3Cg id='mdi-chevron-right'%3E%3Cpath fill='§color§' d='M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z' /%3E%3C/g%3E%3C/svg%3E", this._zkScene = e, this._scene = t, this._sceneHelper = new mi(t), this._style = {}, this.setDefaultStyle(), n && this.setStyle(n), this._rootContainer = BABYLON.GUI.AdvancedDynamicTexture.CreateFullscreenUI("UI", !0, this._scene);
  }
  get infoPointsShown() {
    return this._infoPointsShown;
  }
  get canShowInfoPointsContent() {
    return this._canShowInfoPointsContent;
  }
  set canShowInfoPointsContent(e) {
    this._canShowInfoPointsContent = e, this.hideImages();
  }
  dispose() {
    this._renderingNeededListeners = [], this._rootContainer.dispose();
  }
  setDefaultStyle() {
    this._style.infoPointsStyle = {
      borderColor: "#ffffff",
      innerPointColor: "#ffffff",
      color: "#a01c20",
      highlightColor: "#bb2025"
    }, this._style.imagePanelStyle = {
      backgroundColor: this._scene.clearColor.toHexString(),
      loadingTextColor: "#ffffff",
      buttonsBorderColor: "#a01c20",
      buttonsColor: "#a01c20",
      buttonsBorderHighlightColor: "#bb2025",
      buttonsHighlightColor: "#bb2025",
      buttonsIconColor: "white"
    };
  }
  setStyle(e) {
    e ? (e.infoPointsStyle && (this._style.infoPointsStyle || (this._style.infoPointsStyle = {}), e.infoPointsStyle.borderColor && (this._style.infoPointsStyle.borderColor = e.infoPointsStyle.borderColor), e.infoPointsStyle.innerPointColor && (this._style.infoPointsStyle.innerPointColor = e.infoPointsStyle.innerPointColor), e.infoPointsStyle.color && (this._style.infoPointsStyle.color = e.infoPointsStyle.color), e.infoPointsStyle.highlightColor && (this._style.infoPointsStyle.highlightColor = e.infoPointsStyle.highlightColor)), e.imagePanelStyle && (this._style.imagePanelStyle || (this._style.imagePanelStyle = {}), e.imagePanelStyle.backgroundColor && (this._style.imagePanelStyle.backgroundColor = e.imagePanelStyle.backgroundColor), e.imagePanelStyle.loadingTextColor && (this._style.imagePanelStyle.loadingTextColor = e.imagePanelStyle.loadingTextColor), e.imagePanelStyle.buttonsBorderColor && (this._style.imagePanelStyle.buttonsBorderColor = e.imagePanelStyle.buttonsBorderColor), e.imagePanelStyle.buttonsColor && (this._style.imagePanelStyle.buttonsColor = e.imagePanelStyle.buttonsColor), e.imagePanelStyle.buttonsBorderHighlightColor && (this._style.imagePanelStyle.buttonsBorderHighlightColor = e.imagePanelStyle.buttonsBorderHighlightColor), e.imagePanelStyle.buttonsHighlightColor && (this._style.imagePanelStyle.buttonsHighlightColor = e.imagePanelStyle.buttonsHighlightColor), e.imagePanelStyle.buttonsIconColor && (this._style.imagePanelStyle.buttonsIconColor = e.imagePanelStyle.buttonsIconColor))) : this.setDefaultStyle();
  }
  applyStyle(e) {
    this.setStyle(e), this.refresh();
  }
  showInfoPoints() {
    this.hideImages(), this.getAllInfoPoints().forEach((e) => e.isVisible = !0), this._infoPointsShown = !0, this.fireRenderingNeededEvent();
  }
  hideInfoPoints() {
    this.hideImages(), this.getAllInfoPoints().forEach((e) => e.isVisible = !1), this._infoPointsShown = !1, this.fireRenderingNeededEvent();
  }
  refresh() {
    this.hideImages(), this.refreshInfoPoints(), this.updateGuiElementsStyle(), this.fireRenderingNeededEvent();
  }
  getAllInfoPoints() {
    const e = [];
    for (const t in this._meshesInfoPoints)
      e.push(this._meshesInfoPoints[t]);
    return e;
  }
  refreshInfoPoints() {
    for (let e = 0; e < this._scene.meshes.length; e++) {
      const t = this._scene.meshes[e], n = t.metadata && t.metadata.showInfoPoints && (t.isVisible || t.metadata.forceShowInfoPoints), s = t.material, o = s ? this.getMaterialPhotoUrls(s) : [];
      if (n && o.length > 0) {
        const h = this.getOrCreateMeshInfoPoint(t);
        this.updateInfoPointUrls(h, o);
      } else
        this.removeMeshInfoPoints(t);
    }
  }
  removeMeshInfoPoints(e) {
    this._meshesInfoPoints.hasOwnProperty(e.id) && (this._meshesInfoPoints[e.id].dispose(), delete this._meshesInfoPoints[e.id]);
  }
  getOrCreateMeshInfoPoint(e) {
    if (this._meshesInfoPoints.hasOwnProperty(e.id))
      return this._meshesInfoPoints[e.id];
    const t = this.createMeshInfoPoint(e);
    return this._meshesInfoPoints[e.id] = t, t;
  }
  updateInfoPointUrls(e, t) {
    e.metadata || (e.metadata = {}), e.metadata.urls = t;
  }
  createMeshInfoPoint(e) {
    var s, o, h, c;
    const t = new BABYLON.GUI.Ellipse("infoPoint");
    t.width = "29px", t.height = "29px", t.color = ((s = this._style.infoPointsStyle) == null ? void 0 : s.borderColor) || "#dddddd", t.thickness = 4, t.background = ((o = this._style.infoPointsStyle) == null ? void 0 : o.color) || "#a01c20", t.alpha = 1, t.onPointerEnterObservable.add((_) => {
      var x;
      t.background = ((x = this._style.infoPointsStyle) == null ? void 0 : x.highlightColor) || "#bb2025", this.fireRenderingNeededEvent();
    }), t.onPointerOutObservable.add((_) => {
      var x;
      t.background = ((x = this._style.infoPointsStyle) == null ? void 0 : x.color) || "#a01c20", this.fireRenderingNeededEvent();
    }), this._rootContainer.addControl(t);
    const n = new BABYLON.GUI.Ellipse("innerPoint");
    return n.width = 0.29, n.height = 0.29, n.color = ((h = this._style.infoPointsStyle) == null ? void 0 : h.innerPointColor) || "White", n.thickness = 0, n.background = ((c = this._style.infoPointsStyle) == null ? void 0 : c.innerPointColor) || "White", t.addControl(n), t.linkWithMesh(e), t.linkOffsetY = 0, t.shadowBlur = 6, t.shadowOffsetX = 2, t.shadowOffsetY = 2, t.isPointerBlocker = !0, t.hoverCursor = "pointer", t.onPointerClickObservable.add((_) => {
      if (t.metadata && t.metadata.urls) {
        const x = {
          meshID: e.id,
          materialID: e.material ? e.material.id : null,
          materialPhotoUrl: t.metadata.urls
        };
        this.fireInfoPointPickedEvent(x), this.showImages(t.metadata.urls);
      }
      this.fireRenderingNeededEvent();
    }), t;
  }
  getMaterialInfoPoint(e) {
    for (let t = 0; t < this._infoPoints.length; t++) {
      const n = this._infoPoints[t];
      if (n.metadata && n.metadata.materialID && n.metadata.materialID === e)
        return n;
    }
    return null;
  }
  getMaterialPhotoUrls(e) {
    return this._zkScene.get("materialPhotos").getMaterialPhotoUrls(e.id);
  }
  getOrCreateImagePanel() {
    return this._imagePanel || this.createImagePanel(), this._imagePanel;
  }
  createImagePanel() {
    var t;
    const e = new BABYLON.GUI.Rectangle("imagePanel");
    return e.background = ((t = this._style.imagePanelStyle) == null ? void 0 : t.backgroundColor) || this._scene.clearColor.toHexString(), e.width = 1, e.height = 1, e.zIndex = 1e4, e.isVisible = !1, this._imagePanel = e, this._rootContainer.addControl(e), this.addCloseButton(e), this.addMoveNextImageButton(e), this.addMovePrevImageButton(e), e;
  }
  addCloseButton(e) {
    var o, h, c;
    const t = new BABYLON.GUI.StackPanel("closePanel");
    t.height = "48px", t.width = "48px", t.horizontalAlignment = BABYLON.GUI.Control.HORIZONTAL_ALIGNMENT_RIGHT, t.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_TOP, t.isVertical = !1, t.zIndex = 10003, e.addControl(t);
    const n = new BABYLON.GUI.Rectangle("closeRect");
    n.width = "24px", n.height = "24px", n.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_CENTER, n.horizontalAlignment = BABYLON.GUI.Control.HORIZONTAL_ALIGNMENT_LEFT, n.background = ((o = this._style.imagePanelStyle) == null ? void 0 : o.buttonsColor) || "#a01c20", n.color = ((h = this._style.imagePanelStyle) == null ? void 0 : h.buttonsBorderColor) || "#a01c20", n.isPointerBlocker = !0, n.hoverCursor = "pointer", n.onPointerEnterObservable.add((_) => {
      var x, B;
      n.background = ((x = this._style.imagePanelStyle) == null ? void 0 : x.buttonsHighlightColor) || "#bb2025", n.color = ((B = this._style.imagePanelStyle) == null ? void 0 : B.buttonsBorderHighlightColor) || "#bb2025", this.fireRenderingNeededEvent();
    }), n.onPointerOutObservable.add((_) => {
      var x, B;
      n.background = ((x = this._style.imagePanelStyle) == null ? void 0 : x.buttonsColor) || "#a01c20", n.color = ((B = this._style.imagePanelStyle) == null ? void 0 : B.buttonsBorderColor) || "#a01c20", this.fireRenderingNeededEvent();
    }), n.onPointerClickObservable.add((_) => {
      this.hideImages(), this.fireRenderingNeededEvent();
    }), t.addControl(n);
    const s = new BABYLON.GUI.Image("close", this.getCloseSvg(((c = this._style.imagePanelStyle) == null ? void 0 : c.buttonsIconColor) || "white"));
    s.width = 1, s.height = 1, s.stretch = BABYLON.GUI.Image.STRETCH_UNIFORM, n.addControl(s), this._closeImageButton = t;
  }
  addMoveNextImageButton(e) {
    var o, h, c;
    const t = new BABYLON.GUI.StackPanel("rightPanel");
    t.width = "48px", t.height = "48px", t.paddingRight = "24px", t.horizontalAlignment = BABYLON.GUI.Control.HORIZONTAL_ALIGNMENT_RIGHT, t.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_CENTER, t.isVertical = !1, t.zIndex = 10003, t.alpha = 0.3, t.isVisible = !1, e.addControl(t);
    const n = new BABYLON.GUI.Rectangle("rightRect");
    n.width = "24px", n.height = "48px", n.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_CENTER, n.horizontalAlignment = BABYLON.GUI.Control.HORIZONTAL_ALIGNMENT_LEFT, n.background = ((o = this._style.imagePanelStyle) == null ? void 0 : o.buttonsColor) || "#a01c20", n.color = ((h = this._style.imagePanelStyle) == null ? void 0 : h.buttonsBorderColor) || "#a01c20", n.isPointerBlocker = !0, n.hoverCursor = "pointer", n.onPointerEnterObservable.add((_) => {
      var x, B;
      this._isOnMoveNextButton = !0, n.background = ((x = this._style.imagePanelStyle) == null ? void 0 : x.buttonsHighlightColor) || "#bb2025", n.color = ((B = this._style.imagePanelStyle) == null ? void 0 : B.buttonsBorderHighlightColor) || "#bb2025", this.updateMoveNextImageButton(), this.fireRenderingNeededEvent();
    }), n.onPointerOutObservable.add((_) => {
      var x, B;
      this._isOnMoveNextButton = !1, n.background = ((x = this._style.imagePanelStyle) == null ? void 0 : x.buttonsColor) || "#a01c20", n.color = ((B = this._style.imagePanelStyle) == null ? void 0 : B.buttonsBorderColor) || "#a01c20", this.updateMoveNextImageButton(), this.fireRenderingNeededEvent();
    }), n.onPointerClickObservable.add((_) => {
      this.moveNextImage(), this.fireRenderingNeededEvent();
    }), t.addControl(n);
    const s = new BABYLON.GUI.Image("move-next", this.getChevronRightSvg(((c = this._style.imagePanelStyle) == null ? void 0 : c.buttonsIconColor) || "white"));
    s.width = 1, s.height = 1, s.stretch = BABYLON.GUI.Image.STRETCH_UNIFORM, s.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_CENTER, n.addControl(s), this._moveNextImageButton = t;
  }
  addMovePrevImageButton(e) {
    var o, h, c;
    const t = new BABYLON.GUI.StackPanel("leftPanel");
    t.width = "48px", t.height = "48px", t.paddingLeft = "24px", t.horizontalAlignment = BABYLON.GUI.Control.HORIZONTAL_ALIGNMENT_LEFT, t.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_CENTER, t.isVertical = !1, t.alpha = 0.3, t.zIndex = 10003, t.isVisible = !1, e.addControl(t);
    const n = new BABYLON.GUI.Rectangle("leftRect");
    n.width = "24px", n.height = "48px", n.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_CENTER, n.horizontalAlignment = BABYLON.GUI.Control.HORIZONTAL_ALIGNMENT_RIGHT, n.background = ((o = this._style.imagePanelStyle) == null ? void 0 : o.buttonsColor) || "#a01c20", n.color = ((h = this._style.imagePanelStyle) == null ? void 0 : h.buttonsBorderColor) || "#a01c20", n.isPointerBlocker = !0, n.hoverCursor = "pointer", n.onPointerEnterObservable.add((_) => {
      var x, B;
      this._isOnMovePrevButton = !0, n.background = ((x = this._style.imagePanelStyle) == null ? void 0 : x.buttonsHighlightColor) || "#bb2025", n.color = ((B = this._style.imagePanelStyle) == null ? void 0 : B.buttonsBorderHighlightColor) || "#bb2025", this.updateMovePrevImageButton(), this.fireRenderingNeededEvent();
    }), n.onPointerOutObservable.add((_) => {
      var x, B;
      this._isOnMovePrevButton = !1, n.background = ((x = this._style.imagePanelStyle) == null ? void 0 : x.buttonsColor) || "#a01c20", n.color = ((B = this._style.imagePanelStyle) == null ? void 0 : B.buttonsBorderColor) || "#a01c20", this.updateMovePrevImageButton(), this.fireRenderingNeededEvent();
    }), n.onPointerClickObservable.add((_) => {
      this.movePrevImage(), this.fireRenderingNeededEvent();
    }), t.addControl(n);
    const s = new BABYLON.GUI.Image("move-prev", this.getChevronLeftSvg(((c = this._style.imagePanelStyle) == null ? void 0 : c.buttonsIconColor) || "white"));
    s.width = 1, s.height = 1, s.stretch = BABYLON.GUI.Image.STRETCH_UNIFORM, s.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_CENTER, n.addControl(s), this._movePrevImageButton = t;
  }
  updateMoveNextImageButton() {
    this._moveNextImageButton && (this._imageUrls.length <= 1 ? this._moveNextImageButton.isVisible = !1 : (this._moveNextImageButton.isVisible = !0, this._moveNextImageButton.alpha = this.canMoveNextImage() ? this._isOnMoveNextButton ? 1 : 0.3 : 0.1));
  }
  updateMovePrevImageButton() {
    this._movePrevImageButton && (this._imageUrls.length <= 1 ? this._movePrevImageButton.isVisible = !1 : (this._movePrevImageButton.isVisible = !0, this._movePrevImageButton.alpha = this.canMovePrevImage() ? this._isOnMovePrevButton ? 1 : 0.3 : 0.1));
  }
  showImages(e) {
    this._canShowInfoPointsContent && (this._currentIdx = 0, this._imageUrls = e, this._isOnMoveNextButton = !1, this._isOnMovePrevButton = !1, this.getOrCreateImagePanel(), this._imagePanel && (this.onBeforeShowImages && this.onBeforeShowImages(), this.updateMoveNextImageButton(), this.updateMovePrevImageButton(), this._imagePanel.isVisible = !0, this.showCurrentImage(), this.fireInfoPointContentShownEvent()), this.fireRenderingNeededEvent());
  }
  moveNextImage() {
    this.canMoveNextImage() && (this._currentIdx++, this.showCurrentImage(), this.updateMoveNextImageButton(), this.updateMovePrevImageButton(), this.fireRenderingNeededEvent());
  }
  movePrevImage() {
    this.canMovePrevImage() && (this._currentIdx--, this.showCurrentImage(), this.updateMoveNextImageButton(), this.updateMovePrevImageButton(), this.fireRenderingNeededEvent());
  }
  showCurrentImage() {
    this._currentIdx >= 0 && this._currentIdx < this._imageUrls.length && this.showImage(this._imageUrls[this._currentIdx]);
  }
  canMoveNextImage() {
    return this._imageUrls.length > 0 && this._currentIdx < this._imageUrls.length - 1;
  }
  canMovePrevImage() {
    return this._imageUrls.length > 0 && this._currentIdx > 0;
  }
  hideImages() {
    this._imagePanel && (this._imagePanel.isVisible = !1, this.onAfterShowImages && this.onAfterShowImages(), this.fireInfoPointContentHiddenEvent(), this.fireRenderingNeededEvent());
  }
  showImage(e) {
    if (this._imagePanel) {
      this._image && (this._imagePanel.removeControl(this._image), this._image.isVisible = !1, this._image.dispose(), this._image = null), this.showLoadingText();
      const t = new BABYLON.GUI.Image("but", e);
      t.width = 1, t.height = 1, t.isVisible = !0, t.zIndex = 10002, t.stretch = BABYLON.GUI.Image.STRETCH_UNIFORM, t.onImageLoadedObservable.add((n) => {
        this.hideLoadingText();
      }), this._imagePanel.addControl(t), this._image = t, this.fireRenderingNeededEvent();
    }
  }
  /**
   * Update info points visibility and return true if at least one info point has been updated.
   * 
   * @return {boolean} Return true if any info point has been updated.
   */
  updateInfoPointsVisibility() {
    let e = !1;
    if (this._scene.activeCamera && (!this._lastCameraPosition || !this._lastCameraPosition.equals(this._scene.activeCamera.position))) {
      this._lastCameraPosition = this._scene.activeCamera.position.clone();
      for (const t in this._meshesInfoPoints) {
        const n = this._scene.getMeshByID(t);
        n && (this.updateMeshInfoPointVisibility(n, this._meshesInfoPoints[t]), e = !0);
      }
    }
    return e;
  }
  drawRay(e, t) {
    let n = t.subtract(e);
    n = n.normalize();
    const s = t.subtract(e).length() * 2, o = new BABYLON.Ray(e, n, s);
    BABYLON.RayHelper.CreateAndShow(o, this._scene, new BABYLON.Color3(1, 1, 0.1));
  }
  updateMeshInfoPointVisibility(e, t) {
    if (this._scene.activeCamera) {
      const n = this._sceneHelper.getMeshHierarchyCenter(e), s = this._scene.activeCamera.position;
      let o = n.subtract(s);
      o = o.normalize();
      const h = n.subtract(s).length() * 2, c = new BABYLON.Ray(s, o, h), _ = this._scene.pickWithRay(c);
      _ && _.pickedMesh && (t.alpha = _.pickedMesh === e ? 1 : 0.2);
    }
  }
  getCloseSvg(e) {
    return this.getSvg(this.CLOSE_SVG, e);
  }
  getChevronLeftSvg(e) {
    return this.getSvg(this.CHEVRON_LEFT_SVG, e);
  }
  getChevronRightSvg(e) {
    return this.getSvg(this.CHEVRON_RIGHT_SVG, e);
  }
  getSvg(e, t) {
    return e.replace("§color§", encodeURIComponent(t));
  }
  // -------------------------------------------------------------
  // Events 
  // -------------------------------------------------------------
  // picked
  fireInfoPointPickedEvent(e) {
    for (let t = 0; t < this._infoPointPickedListeners.length; t++)
      this._infoPointPickedListeners[t](e);
  }
  addInfoPointPickedListener(e) {
    this._infoPointPickedListeners.push(e);
  }
  addInfoPointPickedListenerRange(e) {
    this._infoPointPickedListeners.push(...e);
  }
  // Content shown
  fireInfoPointContentShownEvent() {
    for (let e = 0; e < this._infoPointContentShownListeners.length; e++)
      this._infoPointContentShownListeners[e]();
  }
  addInfoPointContentShownListener(e) {
    this._infoPointContentShownListeners.push(e);
  }
  addInfoPointContentShownListenerRange(e) {
    this._infoPointContentShownListeners.push(...e);
  }
  // content hidden
  fireInfoPointContentHiddenEvent() {
    for (let e = 0; e < this._infoPointContentHiddenListeners.length; e++)
      this._infoPointContentHiddenListeners[e]();
  }
  addInfoPointContentHiddenListener(e) {
    this._infoPointContentHiddenListeners.push(e);
  }
  addInfoPointContentHiddenListenerRange(e) {
    this._infoPointContentHiddenListeners.push(...e);
  }
  // Rendering Needed
  fireRenderingNeededEvent() {
    for (let e = 0; e < this._renderingNeededListeners.length; ++e)
      this._renderingNeededListeners[e]();
  }
  addRenderingNeededListener(e) {
    this._renderingNeededListeners.push(e);
  }
  showLoadingText() {
    var e;
    if (this._loadingText) {
      this._loadingText.isVisible = !0;
      return;
    }
    this._imagePanel && (this._loadingText = new BABYLON.GUI.TextBlock("loading"), this._loadingText.text = "Loading...", this._loadingText.left = 0.5, this._loadingText.top = 0.7, this._loadingText.zIndex = 10001, this._loadingText.color = ((e = this._style.imagePanelStyle) == null ? void 0 : e.loadingTextColor) || "white", this._imagePanel.addControl(this._loadingText), this.fireRenderingNeededEvent());
  }
  hideLoadingText() {
    this._loadingText && (this._loadingText.isVisible = !1), this.fireRenderingNeededEvent();
  }
  updateGuiElementsStyle() {
    this.updateMeshInfoPointsStyle(), this.updateImagePanelStyle(), this.fireRenderingNeededEvent();
  }
  updateMeshInfoPointsStyle() {
    this.getAllInfoPoints().forEach((e) => {
      var n, s, o;
      e.color = ((n = this._style.infoPointsStyle) == null ? void 0 : n.borderColor) || "#dddddd", e.background = ((s = this._style.infoPointsStyle) == null ? void 0 : s.color) || "#a01c20";
      const t = e.getChildByName("innerPoint");
      t && t instanceof BABYLON.GUI.Container && (t.background = ((o = this._style.infoPointsStyle) == null ? void 0 : o.innerPointColor) || "White");
    });
  }
  updateImagePanelStyle() {
    var e, t, n, s, o, h, c, _;
    if (this._imagePanel) {
      this._imagePanel.background = ((e = this._style.imagePanelStyle) == null ? void 0 : e.backgroundColor) || this._scene.clearColor.toHexString();
      const x = this._imagePanel.getChildByName("closePanel");
      if (x && x instanceof BABYLON.GUI.Container) {
        const U = x.getChildByName("closeRect");
        U && U instanceof BABYLON.GUI.Container && (U.background = ((t = this._style.imagePanelStyle) == null ? void 0 : t.buttonsColor) || "#a01c20", U.color = ((n = this._style.imagePanelStyle) == null ? void 0 : n.buttonsBorderColor) || "#a01c20");
      }
      const B = this._imagePanel.getChildByName("rightPanel");
      if (B && B instanceof BABYLON.GUI.Container) {
        const U = B.getChildByName("rightRect");
        U && U instanceof BABYLON.GUI.Container && (U.background = ((s = this._style.imagePanelStyle) == null ? void 0 : s.buttonsColor) || "#a01c20", U.color = ((o = this._style.imagePanelStyle) == null ? void 0 : o.buttonsBorderColor) || "#a01c20");
      }
      const P = this._imagePanel.getChildByName("leftPanel");
      if (P && P instanceof BABYLON.GUI.Container) {
        const U = P.getChildByName("leftRect");
        U && U instanceof BABYLON.GUI.Container && (U.background = ((h = this._style.imagePanelStyle) == null ? void 0 : h.buttonsColor) || "#a01c20", U.color = ((c = this._style.imagePanelStyle) == null ? void 0 : c.buttonsBorderColor) || "#a01c20");
      }
      this._loadingText && (this._loadingText.color = ((_ = this._style.imagePanelStyle) == null ? void 0 : _.loadingTextColor) || "white");
    }
  }
}
var lg = /* @__PURE__ */ ((b) => (b[b.NotSelected = 0] = "NotSelected", b[b.Eyewear = 1] = "Eyewear", b[b.Scarves = 2] = "Scarves", b[b.Earrings = 3] = "Earrings", b[b.Headwear = 4] = "Headwear", b[b.Necklace = 5] = "Necklace", b[b.Shoes = 6] = "Shoes", b[b.Watches = 7] = "Watches", b[b.Bracelet = 8] = "Bracelet", b))(lg || {}), hg = /* @__PURE__ */ ((b) => (b[b.NotSelected = 0] = "NotSelected", b[b.Mazing = 1] = "Mazing", b[b.Banuba = 2] = "Banuba", b[b.DeepAR = 3] = "DeepAR", b))(hg || {}), Ds = /* @__PURE__ */ ((b) => (b.VirtualTryOn = "try_on", b.GlassPupillaryDistanceTool = "pd", b.StyleButton = "styleButton", b.MandatoryPupillaryDistance = "mandatoryPD", b))(Ds || {}), Dw = /* @__PURE__ */ ((b) => (b.Neutral = "neutral.hdr", b.Light = "light.hdr", b.Bright = "bright.hdr", b.Studio = "studio.hdr", b.Court = "court.hdr", b))(Dw || {}), zw = /* @__PURE__ */ ((b) => (b.ViewProduct = "VIEW_PRODUCT", b.ViewArProdutc = "VIEW_AR_PRODUCT", b))(zw || {}), Fw = (
  /** @class */
  function() {
    function b(e) {
      var t = this;
      if (this._axisRoot = null, this._axes = [], this._sceneEditor = e, !e.engine)
        throw Error("LightsLayer requires a valid Babylon JS 3D Engine");
      var n = e.engine;
      if (!e.scene)
        throw Error("LightsLayer requires a valid Babylon JS 3D Scene");
      this._editorScene = e.scene, this._scene = new BABYLON.Scene(n), this._scene.autoClear = !1, this._scene.postProcessesEnabled = !1, this._sceneEditor.addPreUpdateListener(function() {
        return t.onPreUpdate();
      }), this._sceneEditor.addPostUpdateListener(function() {
        return t.onPostUpdate();
      }), this.createAxes();
    }
    return b.prototype.dispose = function() {
      this._scene && (this._scene.dispose(), delete this._scene);
    }, b.prototype.onPreUpdate = function() {
      if (this._scene) {
        var e = this._editorScene.activeCamera;
        if (e && (this._scene.activeCamera = e, this._axisRoot)) {
          var t = BABYLON.Vector3.Distance(e.position, this._axisRoot.position) * 0.03;
          this._axisRoot.scaling = new BABYLON.Vector3(t, t, t), this._axisRoot.computeWorldMatrix(!0);
        }
      }
    }, b.prototype.onPostUpdate = function() {
    }, b.prototype.createAxes = function() {
      var e = this, t = 10, n = this._scene, s = new BABYLON.Mesh("axisRoot", n);
      s.isVisible = this._sceneEditor.canShowAxes();
      var o = function(U, M, Z) {
        var F = new BABYLON.DynamicTexture("DynamicTexture", 50, n, !0);
        F.hasAlpha = !0, F.drawText(U, 5, 40, "bold 36px Arial", M, "transparent", !0);
        var Q = BABYLON.MeshBuilder.CreatePlane("TextPlane", { size: Z, updatable: !0 }, n), D = new BABYLON.StandardMaterial("TextPlaneMaterial", n);
        return D.metadata = { isRealMaterial: !1 }, D.backFaceCulling = !1, D.specularColor = new BABYLON.Color3(0, 0, 0), D.diffuseTexture = F, Q.material = D, Q.metadata = { isRealMesh: !1, isAxis: !0 }, Q.parent = s, Q.isVisible = e._sceneEditor.canShowAxes(), Q;
      }, h = BABYLON.Mesh.CreateLines("axisX", [
        BABYLON.Vector3.Zero(),
        new BABYLON.Vector3(t, 0, 0),
        new BABYLON.Vector3(t * 0.95, 0.05 * t, 0),
        new BABYLON.Vector3(t, 0, 0),
        new BABYLON.Vector3(t * 0.95, -0.05 * t, 0)
      ], n);
      h.metadata = { isRealMesh: !1, isAxis: !0 }, h.color = new BABYLON.Color3(1, 0, 0), h.parent = s, h.isVisible = this._sceneEditor.canShowAxes();
      var c = o("X", "red", t / 10);
      c.position = new BABYLON.Vector3(0.9 * t, -0.05 * t, 0);
      var _ = BABYLON.Mesh.CreateLines("axisY", [
        BABYLON.Vector3.Zero(),
        new BABYLON.Vector3(0, t, 0),
        new BABYLON.Vector3(-0.05 * t, t * 0.95, 0),
        new BABYLON.Vector3(0, t, 0),
        new BABYLON.Vector3(0.05 * t, t * 0.95, 0)
      ], n);
      _.metadata = { isRealMesh: !1, isAxis: !0 }, _.color = new BABYLON.Color3(0, 1, 0), _.parent = s, _.isVisible = this._sceneEditor.canShowAxes();
      var x = o("Y", "green", t / 10);
      x.position = new BABYLON.Vector3(0, 0.9 * t, -0.05 * t);
      var B = BABYLON.Mesh.CreateLines("axisZ", [
        BABYLON.Vector3.Zero(),
        new BABYLON.Vector3(0, 0, t),
        new BABYLON.Vector3(0, -0.05 * t, t * 0.95),
        new BABYLON.Vector3(0, 0, t),
        new BABYLON.Vector3(0, 0.05 * t, t * 0.95)
      ], n);
      B.metadata = { isRealMesh: !1, isAxis: !0 }, B.color = new BABYLON.Color3(0, 0, 1), B.parent = s, B.isVisible = this._sceneEditor.canShowAxes();
      var P = o("Z", "blue", t / 10);
      P.position = new BABYLON.Vector3(0, 0.05 * t, 0.9 * t), this._axisRoot = s, this._axes.push(s, h, _, B, c, x, P);
    }, b.prototype.refresh = function() {
      for (var e = 0; e < this._axes.length; e++) {
        var t = this._axes[e];
        t.isVisible = this._sceneEditor.canShowAxes();
      }
    }, b.prototype.render = function() {
      this._scene && this._scene.activeCamera && this._scene.render();
    }, b.prototype.getScene = function() {
      return this._scene;
    }, b;
  }()
), Uw = (
  /** @class */
  function() {
    function b(e) {
      var t = this;
      if (this._lightMeshes = [], this._lightSelectedListeners = [], this._sceneEditor = e, !e.engine)
        throw Error("LightsLayer requires a valid Babylon JS 3D Engine");
      var n = e.engine;
      if (!e.scene)
        throw Error("LightsLayer requires a valid Babylon JS 3D Scene");
      this._editorScene = e.scene, this._scene = new BABYLON.Scene(n), this._scene.autoClear = !1, this._scene.postProcessesEnabled = !1, this._scene.onPointerDown = this.onPointerDown, this._sceneEditorPreUpdate = function() {
        return t.onPreUpdate();
      }, this._sceneEditorPostUpdate = function() {
        return t.onPostUpdate();
      }, this._sceneEditor.addPreUpdateListener(this._sceneEditorPreUpdate), this._sceneEditor.addPostUpdateListener(this._sceneEditorPostUpdate);
    }
    return b.prototype.dispose = function() {
      this._sceneEditor && (this._sceneEditor.removePreUpdateListener(this._sceneEditorPreUpdate), this._sceneEditor.removePostUpdateListener(this._sceneEditorPostUpdate)), this._scene && (this._scene.dispose(), delete this._scene);
    }, b.prototype.onPreUpdate = function() {
      this._scene.activeCamera = this._editorScene.activeCamera;
    }, b.prototype.onPostUpdate = function() {
      this._scene.getEngine();
      for (var e = 0; e < this._lightMeshes.length; e++) {
        var t = this._lightMeshes[e], n = this._editorScene.getLightByID(t.id);
        n && this.configureLightMesh(t, n);
      }
    }, b.prototype.onPointerDown = function(e, t, n) {
      if (t.hit && t.pickedMesh) {
        var s = { name: t.pickedMesh.name, id: t.pickedMesh.id };
        this.fireLightSelectedEvent(s);
      }
    }, b.prototype.refresh = function() {
      this.updateLightMeshes();
    }, b.prototype.updateLightMeshes = function() {
      if (this._scene && this._sceneEditor) {
        for (var e = 0; e < this._editorScene.lights.length; e++) {
          var t = this._editorScene.lights[e], n = this._scene.getMeshByID(t.id);
          n ? this.configureLightMesh(n, t) : this._lightMeshes.push(this.createLightMesh(t));
        }
        for (var e = 0; e < this._lightMeshes.length; e++) {
          var n = this._lightMeshes[e], t = this._editorScene.getLightByID(n.id);
          t || (n.dispose(), this._lightMeshes.splice(e--, 1));
        }
      }
    }, b.prototype.createLightMesh = function(e) {
      var t = new BABYLON.Texture(b._lightTexture, this._scene);
      t.hasAlpha = !0;
      var n = new BABYLON.StandardMaterial("LightMeshMaterial_" + e.id, this._scene);
      n.emissiveColor = BABYLON.Color3.White(), n.useAlphaFromDiffuseTexture = !0, n.disableDepthWrite = !1, n.diffuseTexture = t;
      var s = BABYLON.Mesh.CreatePlane(e.name, 1, this._scene);
      return s.id = e.id, s.billboardMode = BABYLON.Mesh.BILLBOARDMODE_ALL, s.material = n, this.configureLightMesh(s, e), s;
    }, b.prototype.clearLightMeshes = function() {
      if (this._scene)
        for (; this._lightMeshes.length > 0; ) {
          var e = this._lightMeshes.pop();
          e && e.dispose();
        }
    }, b.prototype.configureLightMesh = function(e, t) {
      var n = this._editorScene.activeCamera;
      if (n && e && t) {
        e.position = t.getAbsolutePosition();
        var s = BABYLON.Vector3.Distance(n.position, e.position) * 0.03;
        e.scaling = new BABYLON.Vector3(s, s, s), e.computeWorldMatrix(!0), e.isVisible = this._sceneEditor.canShowLights();
      }
    }, b.prototype.render = function() {
      this._scene && this._scene.render();
    }, b.prototype.getScene = function() {
      return this._scene;
    }, b.prototype.fireLightSelectedEvent = function(e) {
      for (var t = 0; t < this._lightSelectedListeners.length; ++t)
        this._lightSelectedListeners[t](e);
    }, b.prototype.addLightSelectedListener = function(e) {
      this._lightSelectedListeners.push(e);
    }, b._lightTexture = "data:image/png;base64,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", b;
  }()
);
class Vw {
  /**
   * Create a new EventState
   * @param mask defines the mask associated with this state
   * @param skipNextObservers defines a flag which will instruct the observable to skip following observers when set to true
   * @param target defines the original target of the state
   * @param currentTarget defines the current target of the state
   */
  constructor(e, t = !1, n, s) {
    this.skipNextObservers = !1, this.mask = 0, this.initalize(e, t, n, s);
  }
  /**
   * Initialize the current event state
   * @param mask defines the mask associated with this state
   * @param skipNextObservers defines a flag which will instruct the observable to skip following observers when set to true
   * @param target defines the original target of the state
   * @param currentTarget defines the current target of the state
   * @returns the current event state
   */
  initalize(e, t = !1, n, s) {
    return this.mask = e, this.skipNextObservers = t, this.target = n, this.currentTarget = s, this;
  }
}
class Hw {
  /**
   * Creates a new observer
   * @param callback defines the callback to call when the observer is notified
   * @param mask defines the mask of the observer (used to filter notifications)
   * @param scope defines the current scope used to restore the JS context
   */
  constructor(e, t, n = null) {
    this.callback = e, this.mask = t, this.scope = n, this._willBeUnregistered = !1, this.unregisterOnNextCall = !1;
  }
}
class ug {
  constructor() {
    this._observers = null, this._observables = null;
  }
  /**
   * Release associated resources
   */
  dispose() {
    if (this._observers && this._observables)
      for (var e = 0; e < this._observers.length; e++)
        this._observables[e].remove(this._observers[e]);
    this._observers = null, this._observables = null;
  }
  /**
   * Raise a callback when one of the observable will notify
   * @param observables defines a list of observables to watch
   * @param callback defines the callback to call on notification
   * @param mask defines the mask used to filter notifications
   * @param scope defines the current scope used to restore the JS context
   * @returns the new MultiObserver
   */
  static Watch(e, t, n = 0, s = null) {
    let o = new ug();
    o._observers = new Array(), o._observables = e;
    for (var h of e) {
      let c = h.add(t, n, !1, s);
      c && o._observers.push(c);
    }
    return o;
  }
}
class cg {
  /**
   * Creates a new observable
   * @param onObserverAdded defines a callback to call when a new observer is added
   */
  constructor(e) {
    this._observers = new Array(), this._onObserverAdded = null, this._eventState = new Vw(0), e && (this._onObserverAdded = e);
  }
  /**
   * Gets the list of observers
   */
  get observers() {
    return this._observers;
  }
  /**
   * Create a new Observer with the specified callback
   * @param callback the callback that will be executed for that Observer
   * @param mask the mask used to filter observers
   * @param insertFirst if true the callback will be inserted at the first position, hence executed before the others ones. If false (default behavior) the callback will be inserted at the last position, executed after all the others already present.
   * @param scope optional scope for the callback to be called from
   * @param unregisterOnFirstCall defines if the observer as to be unregistered after the next notification
   * @returns the new observer created for the callback
   */
  add(e, t = 0, n = !1, s = null, o = !1) {
    if (!e)
      return null;
    var h = new Hw(e, t, s);
    return h.unregisterOnNextCall = o, n ? this._observers.unshift(h) : this._observers.push(h), this._onObserverAdded && this._onObserverAdded(h), h;
  }
  /**
   * Create a new Observer with the specified callback and unregisters after the next notification
   * @param callback the callback that will be executed for that Observer
   * @returns the new observer created for the callback
   */
  addOnce(e) {
    return this.add(e, void 0, void 0, void 0, !0);
  }
  /**
   * Remove an Observer from the Observable object
   * @param observer the instance of the Observer to remove
   * @returns false if it doesn't belong to this Observable
   */
  remove(e) {
    if (!e)
      return !1;
    var t = this._observers.indexOf(e);
    return t !== -1 ? (this._deferUnregister(e), !0) : !1;
  }
  /**
   * Remove a callback from the Observable object
   * @param callback the callback to remove
   * @param scope optional scope. If used only the callbacks with this scope will be removed
   * @returns false if it doesn't belong to this Observable
  */
  removeCallback(e, t) {
    for (var n = 0; n < this._observers.length; n++) {
      const s = this._observers[n];
      if (!s._willBeUnregistered && s.callback === e && (!t || t === s.scope))
        return this._deferUnregister(s), !0;
    }
    return !1;
  }
  _deferUnregister(e) {
    e.unregisterOnNextCall = !1, e._willBeUnregistered = !0, setTimeout(() => {
      this._remove(e);
    }, 0);
  }
  // This should only be called when not iterating over _observers to avoid callback skipping.
  // Removes an observer from the _observer Array.
  _remove(e) {
    if (!e)
      return !1;
    var t = this._observers.indexOf(e);
    return t !== -1 ? (this._observers.splice(t, 1), !0) : !1;
  }
  /**
   * Moves the observable to the top of the observer list making it get called first when notified
   * @param observer the observer to move
   */
  makeObserverTopPriority(e) {
    this._remove(e), this._observers.unshift(e);
  }
  /**
   * Moves the observable to the bottom of the observer list making it get called last when notified
   * @param observer the observer to move
   */
  makeObserverBottomPriority(e) {
    this._remove(e), this._observers.push(e);
  }
  /**
   * Notify all Observers by calling their respective callback with the given data
   * Will return true if all observers were executed, false if an observer set skipNextObservers to true, then prevent the subsequent ones to execute
   * @param eventData defines the data to send to all observers
   * @param mask defines the mask of the current notification (observers with incompatible mask (ie mask & observer.mask === 0) will not be notified)
   * @param target defines the original target of the state
   * @param currentTarget defines the current target of the state
   * @returns false if the complete observer chain was not processed (because one observer set the skipNextObservers to true)
   */
  notifyObservers(e, t = 0, n, s) {
    if (!this._observers.length)
      return !0;
    let o = this._eventState;
    o.mask = t, o.target = n, o.currentTarget = s, o.skipNextObservers = !1, o.lastReturnValue = e;
    for (var h of this._observers)
      if (!h._willBeUnregistered && (h.mask & t && (h.scope ? o.lastReturnValue = h.callback.apply(h.scope, [e, o]) : o.lastReturnValue = h.callback(e, o), h.unregisterOnNextCall && this._deferUnregister(h)), o.skipNextObservers))
        return !1;
    return !0;
  }
  /**
   * Calling this will execute each callback, expecting it to be a promise or return a value.
   * If at any point in the chain one function fails, the promise will fail and the execution will not continue.
   * This is useful when a chain of events (sometimes async events) is needed to initialize a certain object
   * and it is crucial that all callbacks will be executed.
   * The order of the callbacks is kept, callbacks are not executed parallel.
   *
   * @param eventData The data to be sent to each callback
   * @param mask is used to filter observers defaults to 0
   * @param target defines the callback target (see EventState)
   * @param currentTarget defines he current object in the bubbling phase
   * @returns {Promise<T>} will return a Promise than resolves when all callbacks executed successfully.
   */
  notifyObserversWithPromise(e, t = 0, n, s) {
    let o = Promise.resolve(e);
    if (!this._observers.length)
      return o;
    let h = this._eventState;
    return h.mask = t, h.target = n, h.currentTarget = s, h.skipNextObservers = !1, this._observers.forEach((c) => {
      h.skipNextObservers || c._willBeUnregistered || c.mask & t && (c.scope ? o = o.then((_) => (h.lastReturnValue = _, c.callback.apply(c.scope, [e, h]))) : o = o.then((_) => (h.lastReturnValue = _, c.callback(e, h))), c.unregisterOnNextCall && this._deferUnregister(c));
    }), o.then(() => e);
  }
  /**
   * Notify a specific observer
   * @param observer defines the observer to notify
   * @param eventData defines the data to be sent to each callback
   * @param mask is used to filter observers defaults to 0
   */
  notifyObserver(e, t, n = 0) {
    let s = this._eventState;
    s.mask = n, s.skipNextObservers = !1, e.callback(t, s);
  }
  /**
   * Gets a boolean indicating if the observable has at least one observer
   * @returns true is the Observable has at least one Observer registered
   */
  hasObservers() {
    return this._observers.length > 0;
  }
  /**
  * Clear the list of observers
  */
  clear() {
    this._observers = new Array(), this._onObserverAdded = null;
  }
  /**
   * Clone the current observable
   * @returns a new observable
   */
  clone() {
    var e = new cg();
    return e._observers = this._observers.slice(0), e;
  }
  /**
   * Does this observable handles observer registered with a given mask
   * @param mask defines the mask to be tested
   * @return whether or not one observer registered with the given mask is handeled
  **/
  hasSpecificMask(e = 0) {
    for (var t of this._observers)
      if (t.mask & e || t.mask === e)
        return !0;
    return !1;
  }
}
class $f {
  /**
   * Creates a new Database
  */
  constructor() {
    this._idbFactory = typeof window < "u" ? window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB : indexedDB, this._db = null, this._hasReachedQuota = !1, this._isSupported = !0;
  }
  openAsync() {
    return new Promise((e, t) => this.open(e, t));
  }
  /**
   * Open the database and make it available
   * @param successCallback defines the callback to call on success
   * @param errorCallback defines the callback to call on error
   */
  open(e, t) {
    const n = () => {
      this._isSupported = !1, t && t();
    };
    if (!this._idbFactory)
      this._isSupported = !1, t && t();
    else if (this._db)
      e && e();
    else {
      this._hasReachedQuota = !1, this._isSupported = !0;
      const s = this._idbFactory.open("zakeke", 1);
      s.onerror = () => {
        n();
      }, s.onblocked = () => {
        Logger.info("IDB request blocked. Please reload the page."), n();
      }, s.onsuccess = () => {
        this._db = s.result, e();
      }, s.onupgradeneeded = (o) => {
        if (this._db = o.target.result, this._db)
          try {
            this._db.createObjectStore("files", { keyPath: "fileId" });
          } catch (h) {
            Logger.info("Error while creating object stores. Exception: " + h.message), n();
          }
      };
    }
  }
  loadFileAsync(e) {
    return new Promise((t, n) => {
      if (this._isSupported && this._db) {
        const s = "files";
        let o;
        const h = this._db.transaction([s]);
        h.oncomplete = () => {
          t(o ? o.data : null);
        }, h.onabort = () => {
          t(null);
        };
        const c = h.objectStore(s).get(e);
        c.onsuccess = (_) => {
          o = _.target.result;
        }, c.onerror = () => {
          Logger.info("Error loading file " + e + " from DB."), t(null);
        };
      } else
        Logger.info("Error: IndexedDB not supported by your browser or Zakeke database is not open."), n("IndexedDB not supported or Db is not open");
    });
  }
  saveFileAsync(e, t) {
    return new Promise((n, s) => {
      if (this._isSupported) {
        const o = "files";
        if (!this._hasReachedQuota && this._db) {
          const h = this._db.transaction([o], "readwrite");
          h.onabort = (x) => {
            const B = x.srcElement.error;
            B && B.name === "QuotaExceededError" && (this._hasReachedQuota = !0, s("Quota Exceeded"));
          }, h.oncomplete = () => {
            Logger.info("File saved successfully"), n();
          };
          const c = { fileId: e, data: t }, _ = h.objectStore(o).put(c);
          _.onsuccess = () => {
          }, _.onerror = () => {
            Logger.info("Error in DB add file request in Zakeke3D.Database."), s("Error in DB add file request");
          };
        } else {
          const h = this._hasReachedQuota ? "Quota has been reached" : "Database closed";
          s(h);
        }
      } else
        Logger.info("Error: IndexedDB not supported by your browser or Zakeke database is not open."), s("IndexedDB not supported or Db is not open");
    });
  }
  deleteFileAsync(e) {
    return new Promise((t, n) => {
      if (this._isSupported && this._db) {
        const s = "files", o = this._db.transaction([s]);
        o.oncomplete = () => {
          t();
        }, o.onabort = () => {
          n("aborted cancellation");
        };
        const h = o.objectStore(s).get(e);
        h.onerror = () => {
          Logger.info("Error deleting file " + e + " from DB."), n("Error deleting file from DB");
        };
      } else
        Logger.info("Error: IndexedDB not supported by your browser or Zakeke database is not open."), n("IndexedDB not supported or Db is not open");
    });
  }
}
var xl = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
xl.exports;
(function(b, e) {
  (function() {
    var t, n = "4.18.1", s = 200, o = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", h = "Expected a function", c = "Invalid `variable` option passed into `_.template`", _ = "Invalid `imports` option passed into `_.template`", x = "__lodash_hash_undefined__", B = 500, P = "__lodash_placeholder__", U = 1, M = 2, Z = 4, F = 1, Q = 2, D = 1, te = 2, ee = 4, le = 8, fe = 16, X = 32, W = 64, je = 128, ke = 256, Ye = 512, pt = 30, Le = "...", $e = 800, ce = 16, ht = 1, De = 2, ft = 3, Yt = 1 / 0, We = 9007199254740991, It = 17976931348623157e292, rt = 0 / 0, tt = 4294967295, Kt = tt - 1, qt = tt >>> 1, Lt = [
      ["ary", je],
      ["bind", D],
      ["bindKey", te],
      ["curry", le],
      ["curryRight", fe],
      ["flip", Ye],
      ["partial", X],
      ["partialRight", W],
      ["rearg", ke]
    ], Ci = "[object Arguments]", ji = "[object Array]", _i = "[object AsyncFunction]", Wt = "[object Boolean]", $t = "[object Date]", ei = "[object DOMException]", tn = "[object Error]", Fi = "[object Function]", _e = "[object GeneratorFunction]", Ct = "[object Map]", yt = "[object Number]", Re = "[object Null]", Ee = "[object Object]", et = "[object Promise]", kt = "[object Proxy]", mt = "[object RegExp]", Qe = "[object Set]", bt = "[object String]", Gt = "[object Symbol]", He = "[object Undefined]", i = "[object WeakMap]", r = "[object WeakSet]", a = "[object ArrayBuffer]", l = "[object DataView]", u = "[object Float32Array]", d = "[object Float64Array]", v = "[object Int8Array]", p = "[object Int16Array]", y = "[object Int32Array]", S = "[object Uint8Array]", L = "[object Uint8ClampedArray]", E = "[object Uint16Array]", A = "[object Uint32Array]", T = /\b__p \+= '';/g, G = /\b(__p \+=) '' \+/g, R = /(__e\(.*?\)|\b__t\)) \+\n'';/g, Y = /&(?:amp|lt|gt|quot|#39);/g, k = /[&<>"']/g, z = RegExp(Y.source), C = RegExp(k.source), I = /<%-([\s\S]+?)%>/g, j = /<%([\s\S]+?)%>/g, q = /<%=([\s\S]+?)%>/g, H = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, ie = /^\w*$/, ae = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, he = /[\\^$.*+?()[\]{}|]/g, pe = RegExp(he.source), se = /^\s+/, de = /\s/, ve = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, we = /\{\n\/\* \[wrapped with (.+)\] \*/, Se = /,? & /, Ae = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, Ge = /[()=,{}\[\]\/\s]/, Je = /\\(\\)?/g, it = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, gt = /\w*$/, Ne = /^[-+]0x[0-9a-f]+$/i, Fe = /^0b[01]+$/i, st = /^\[object .+?Constructor\]$/, _t = /^0o[0-7]+$/i, vt = /^(?:0|[1-9]\d*)$/, Rt = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Et = /($^)/, Ht = /['\n\r\u2028\u2029\\]/g, jt = "\\ud800-\\udfff", Vt = "\\u0300-\\u036f", Mi = "\\ufe20-\\ufe2f", Li = "\\u20d0-\\u20ff", Ai = Vt + Mi + Li, vi = "\\u2700-\\u27bf", ri = "a-z\\xdf-\\xf6\\xf8-\\xff", Nt = "\\xac\\xb1\\xd7\\xf7", Di = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", li = "\\u2000-\\u206f", nn = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Vi = "A-Z\\xc0-\\xd6\\xd8-\\xde", Wi = "\\ufe0e\\ufe0f", Ji = Nt + Di + li + nn, Hi = "['’]", $i = "[" + jt + "]", _n = "[" + Ji + "]", Xi = "[" + Ai + "]", cn = "\\d+", Cn = "[" + vi + "]", Zr = "[" + ri + "]", Pr = "[^" + jt + Ji + cn + vi + ri + Vi + "]", An = "\\ud83c[\\udffb-\\udfff]", qr = "(?:" + Xi + "|" + An + ")", Vn = "[^" + jt + "]", dr = "(?:\\ud83c[\\udde6-\\uddff]){2}", Hn = "[\\ud800-\\udbff][\\udc00-\\udfff]", fn = "[" + Vi + "]", dn = "\\u200d", bn = "(?:" + Zr + "|" + Pr + ")", sn = "(?:" + fn + "|" + Pr + ")", ni = "(?:" + Hi + "(?:d|ll|m|re|s|t|ve))?", gn = "(?:" + Hi + "(?:D|LL|M|RE|S|T|VE))?", rn = qr + "?", Pn = "[" + Wi + "]?", gr = "(?:" + dn + "(?:" + [Vn, dr, Hn].join("|") + ")" + Pn + rn + ")*", Or = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", xr = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", wr = Pn + rn + gr, g = "(?:" + [Cn, dr, Hn].join("|") + ")" + wr, V = "(?:" + [Vn + Xi + "?", Xi, dr, Hn, $i].join("|") + ")", ue = RegExp(Hi, "g"), ye = RegExp(Xi, "g"), Ie = RegExp(An + "(?=" + An + ")|" + V + wr, "g"), nt = RegExp([
      fn + "?" + Zr + "+" + ni + "(?=" + [_n, fn, "$"].join("|") + ")",
      sn + "+" + gn + "(?=" + [_n, fn + bn, "$"].join("|") + ")",
      fn + "?" + bn + "+" + ni,
      fn + "+" + gn,
      xr,
      Or,
      cn,
      g
    ].join("|"), "g"), dt = RegExp("[" + dn + jt + Ai + Wi + "]"), zt = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, Xt = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], hi = -1, ii = {};
    ii[u] = ii[d] = ii[v] = ii[p] = ii[y] = ii[S] = ii[L] = ii[E] = ii[A] = !0, ii[Ci] = ii[ji] = ii[a] = ii[Wt] = ii[l] = ii[$t] = ii[tn] = ii[Fi] = ii[Ct] = ii[yt] = ii[Ee] = ii[mt] = ii[Qe] = ii[bt] = ii[i] = !1;
    var oi = {};
    oi[Ci] = oi[ji] = oi[a] = oi[l] = oi[Wt] = oi[$t] = oi[u] = oi[d] = oi[v] = oi[p] = oi[y] = oi[Ct] = oi[yt] = oi[Ee] = oi[mt] = oi[Qe] = oi[bt] = oi[Gt] = oi[S] = oi[L] = oi[E] = oi[A] = !0, oi[tn] = oi[Fi] = oi[i] = !1;
    var vn = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, rr = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, Tn = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, Sr = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, Mr = parseFloat, sr = parseInt, Cr = typeof ss == "object" && ss && ss.Object === Object && ss, os = typeof self == "object" && self && self.Object === Object && self, Sn = Cr || os || Function("return this")(), Nr = e && !e.nodeType && e, Rr = Nr && !0 && b && !b.nodeType && b, vs = Rr && Rr.exports === Nr, Ts = vs && Cr.process, w = function() {
      try {
        var Oe = Rr && Rr.require && Rr.require("util").types;
        return Oe || Ts && Ts.binding && Ts.binding("util");
      } catch {
      }
    }(), O = w && w.isArrayBuffer, J = w && w.isDate, re = w && w.isMap, ge = w && w.isRegExp, me = w && w.isSet, xe = w && w.isTypedArray;
    function Ue(Oe, qe, K) {
      switch (K.length) {
        case 0:
          return Oe.call(qe);
        case 1:
          return Oe.call(qe, K[0]);
        case 2:
          return Oe.call(qe, K[0], K[1]);
        case 3:
          return Oe.call(qe, K[0], K[1], K[2]);
      }
      return Oe.apply(qe, K);
    }
    function ze(Oe, qe, K, oe) {
      for (var Me = -1, Be = Oe == null ? 0 : Oe.length; ++Me < Be; ) {
        var ot = Oe[Me];
        qe(oe, ot, K(ot), Oe);
      }
      return oe;
    }
    function Ze(Oe, qe) {
      for (var K = -1, oe = Oe == null ? 0 : Oe.length; ++K < oe && qe(Oe[K], K, Oe) !== !1; )
        ;
      return Oe;
    }
    function At(Oe, qe) {
      for (var K = Oe == null ? 0 : Oe.length; K-- && qe(Oe[K], K, Oe) !== !1; )
        ;
      return Oe;
    }
    function Bt(Oe, qe) {
      for (var K = -1, oe = Oe == null ? 0 : Oe.length; ++K < oe; )
        if (!qe(Oe[K], K, Oe))
          return !1;
      return !0;
    }
    function lt(Oe, qe) {
      for (var K = -1, oe = Oe == null ? 0 : Oe.length, Me = 0, Be = []; ++K < oe; ) {
        var ot = Oe[K];
        qe(ot, K, Oe) && (Be[Me++] = ot);
      }
      return Be;
    }
    function Ft(Oe, qe) {
      var K = Oe == null ? 0 : Oe.length;
      return !!K && ar(Oe, qe, 0) > -1;
    }
    function fi(Oe, qe, K) {
      for (var oe = -1, Me = Oe == null ? 0 : Oe.length; ++oe < Me; )
        if (K(qe, Oe[oe]))
          return !0;
      return !1;
    }
    function si(Oe, qe) {
      for (var K = -1, oe = Oe == null ? 0 : Oe.length, Me = Array(oe); ++K < oe; )
        Me[K] = qe(Oe[K], K, Oe);
      return Me;
    }
    function di(Oe, qe) {
      for (var K = -1, oe = qe.length, Me = Oe.length; ++K < oe; )
        Oe[Me + K] = qe[K];
      return Oe;
    }
    function xn(Oe, qe, K, oe) {
      var Me = -1, Be = Oe == null ? 0 : Oe.length;
      for (oe && Be && (K = Oe[++Me]); ++Me < Be; )
        K = qe(K, Oe[Me], Me, Oe);
      return K;
    }
    function wn(Oe, qe, K, oe) {
      var Me = Oe == null ? 0 : Oe.length;
      for (oe && Me && (K = Oe[--Me]); Me--; )
        K = qe(K, Oe[Me], Me, Oe);
      return K;
    }
    function an(Oe, qe) {
      for (var K = -1, oe = Oe == null ? 0 : Oe.length; ++K < oe; )
        if (qe(Oe[K], K, Oe))
          return !0;
      return !1;
    }
    var xi = Yn("length");
    function ki(Oe) {
      return Oe.split("");
    }
    function Dn(Oe) {
      return Oe.match(Ae) || [];
    }
    function Ni(Oe, qe, K) {
      var oe;
      return K(Oe, function(Me, Be, ot) {
        if (qe(Me, Be, ot))
          return oe = Be, !1;
      }), oe;
    }
    function Qi(Oe, qe, K, oe) {
      for (var Me = Oe.length, Be = K + (oe ? 1 : -1); oe ? Be-- : ++Be < Me; )
        if (qe(Oe[Be], Be, Oe))
          return Be;
      return -1;
    }
    function ar(Oe, qe, K) {
      return qe === qe ? ys(Oe, qe, K) : Qi(Oe, pn, K);
    }
    function pr(Oe, qe, K, oe) {
      for (var Me = K - 1, Be = Oe.length; ++Me < Be; )
        if (oe(Oe[Me], qe))
          return Me;
      return -1;
    }
    function pn(Oe) {
      return Oe !== Oe;
    }
    function Ar(Oe, qe) {
      var K = Oe == null ? 0 : Oe.length;
      return K ? Dr(Oe, qe) / K : rt;
    }
    function Yn(Oe) {
      return function(qe) {
        return qe == null ? t : qe[Oe];
      };
    }
    function Qt(Oe) {
      return function(qe) {
        return Oe == null ? t : Oe[qe];
      };
    }
    function qn(Oe, qe, K, oe, Me) {
      return Me(Oe, function(Be, ot, ut) {
        K = oe ? (oe = !1, Be) : qe(K, Be, ot, ut);
      }), K;
    }
    function Gn(Oe, qe) {
      var K = Oe.length;
      for (Oe.sort(qe); K--; )
        Oe[K] = Oe[K].value;
      return Oe;
    }
    function Dr(Oe, qe) {
      for (var K, oe = -1, Me = Oe.length; ++oe < Me; ) {
        var Be = qe(Oe[oe]);
        Be !== t && (K = K === t ? Be : K + Be);
      }
      return K;
    }
    function Si(Oe, qe) {
      for (var K = -1, oe = Array(Oe); ++K < Oe; )
        oe[K] = qe(K);
      return oe;
    }
    function hn(Oe, qe) {
      return si(qe, function(K) {
        return [K, Oe[K]];
      });
    }
    function Jt(Oe) {
      return Oe && Oe.slice(0, bs(Oe) + 1).replace(se, "");
    }
    function Ln(Oe) {
      return function(qe) {
        return Oe(qe);
      };
    }
    function gi(Oe, qe) {
      return si(qe, function(K) {
        return Oe[K];
      });
    }
    function Bi(Oe, qe) {
      return Oe.has(qe);
    }
    function Bn(Oe, qe) {
      for (var K = -1, oe = Oe.length; ++K < oe && ar(qe, Oe[K], 0) > -1; )
        ;
      return K;
    }
    function ui(Oe, qe) {
      for (var K = Oe.length; K-- && ar(qe, Oe[K], 0) > -1; )
        ;
      return K;
    }
    function un(Oe, qe) {
      for (var K = Oe.length, oe = 0; K--; )
        Oe[K] === qe && ++oe;
      return oe;
    }
    var zr = Qt(vn), Js = Qt(rr);
    function $r(Oe) {
      return "\\" + Sr[Oe];
    }
    function Fr(Oe, qe) {
      return Oe == null ? t : Oe[qe];
    }
    function Ki(Oe) {
      return dt.test(Oe);
    }
    function On(Oe) {
      return zt.test(Oe);
    }
    function or(Oe) {
      for (var qe, K = []; !(qe = Oe.next()).done; )
        K.push(qe.value);
      return K;
    }
    function tr(Oe) {
      var qe = -1, K = Array(Oe.size);
      return Oe.forEach(function(oe, Me) {
        K[++qe] = [Me, oe];
      }), K;
    }
    function Ur(Oe, qe) {
      return function(K) {
        return Oe(qe(K));
      };
    }
    function $n(Oe, qe) {
      for (var K = -1, oe = Oe.length, Me = 0, Be = []; ++K < oe; ) {
        var ot = Oe[K];
        (ot === qe || ot === P) && (Oe[K] = P, Be[Me++] = K);
      }
      return Be;
    }
    function Pi(Oe) {
      var qe = -1, K = Array(Oe.size);
      return Oe.forEach(function(oe) {
        K[++qe] = oe;
      }), K;
    }
    function ls(Oe) {
      var qe = -1, K = Array(Oe.size);
      return Oe.forEach(function(oe) {
        K[++qe] = [oe, oe];
      }), K;
    }
    function ys(Oe, qe, K) {
      for (var oe = K - 1, Me = Oe.length; ++oe < Me; )
        if (Oe[oe] === qe)
          return oe;
      return -1;
    }
    function Ls(Oe, qe, K) {
      for (var oe = K + 1; oe--; )
        if (Oe[oe] === qe)
          return oe;
      return oe;
    }
    function Jn(Oe) {
      return Ki(Oe) ? Pe(Oe) : xi(Oe);
    }
    function zn(Oe) {
      return Ki(Oe) ? Ke(Oe) : ki(Oe);
    }
    function bs(Oe) {
      for (var qe = Oe.length; qe-- && de.test(Oe.charAt(qe)); )
        ;
      return qe;
    }
    var lr = Qt(Tn);
    function Pe(Oe) {
      for (var qe = Ie.lastIndex = 0; Ie.test(Oe); )
        ++qe;
      return qe;
    }
    function Ke(Oe) {
      return Oe.match(Ie) || [];
    }
    function ct(Oe) {
      return Oe.match(nt) || [];
    }
    var xt = function Oe(qe) {
      qe = qe == null ? Sn : Tt.defaults(Sn.Object(), qe, Tt.pick(Sn, Xt));
      var K = qe.Array, oe = qe.Date, Me = qe.Error, Be = qe.Function, ot = qe.Math, ut = qe.Object, St = qe.RegExp, Zt = qe.String, yi = qe.TypeError, Yi = K.prototype, Nn = Be.prototype, mn = ut.prototype, mr = qe["__core-js_shared__"], jn = Nn.toString, on = mn.hasOwnProperty, wg = 0, Au = function() {
        var f = /[^.]+$/.exec(mr && mr.keys && mr.keys.IE_PROTO || "");
        return f ? "Symbol(src)_1." + f : "";
      }(), mo = mn.toString, Sg = jn.call(ut), Mg = Sn._, Cg = St(
        "^" + jn.call(on).replace(he, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), _o = vs ? qe.Buffer : t, Fs = qe.Symbol, vo = qe.Uint8Array, Tu = _o ? _o.allocUnsafe : t, yo = Ur(ut.getPrototypeOf, ut), Lu = ut.create, Bu = mn.propertyIsEnumerable, bo = Yi.splice, ku = Fs ? Fs.isConcatSpreadable : t, Ia = Fs ? Fs.iterator : t, Qs = Fs ? Fs.toStringTag : t, xo = function() {
        try {
          var f = ra(ut, "defineProperty");
          return f({}, "", {}), f;
        } catch {
        }
      }(), Ag = qe.clearTimeout !== Sn.clearTimeout && qe.clearTimeout, Tg = oe && oe.now !== Sn.Date.now && oe.now, Lg = qe.setTimeout !== Sn.setTimeout && qe.setTimeout, wo = ot.ceil, So = ot.floor, Ol = ut.getOwnPropertySymbols, Bg = _o ? _o.isBuffer : t, Eu = qe.isFinite, kg = Yi.join, Eg = Ur(ut.keys, ut), Xn = ot.max, hr = ot.min, Ig = oe.now, Pg = qe.parseInt, Iu = ot.random, Og = Yi.reverse, Nl = ra(qe, "DataView"), Pa = ra(qe, "Map"), Rl = ra(qe, "Promise"), ga = ra(qe, "Set"), Oa = ra(qe, "WeakMap"), Na = ra(ut, "create"), Mo = Oa && new Oa(), pa = {}, Ng = sa(Nl), Rg = sa(Pa), Dg = sa(Rl), zg = sa(ga), Fg = sa(Oa), Co = Fs ? Fs.prototype : t, Ra = Co ? Co.valueOf : t, Pu = Co ? Co.toString : t;
      function Ce(f) {
        if (Rn(f) && !Ei(f) && !(f instanceof Zi)) {
          if (f instanceof Xr)
            return f;
          if (on.call(f, "__wrapped__"))
            return Oc(f);
        }
        return new Xr(f);
      }
      var ma = function() {
        function f() {
        }
        return function(m) {
          if (!kn(m))
            return {};
          if (Lu)
            return Lu(m);
          f.prototype = m;
          var N = new f();
          return f.prototype = t, N;
        };
      }();
      function Ao() {
      }
      function Xr(f, m) {
        this.__wrapped__ = f, this.__actions__ = [], this.__chain__ = !!m, this.__index__ = 0, this.__values__ = t;
      }
      Ce.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: I,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: j,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: q,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: Ce
        }
      }, Ce.prototype = Ao.prototype, Ce.prototype.constructor = Ce, Xr.prototype = ma(Ao.prototype), Xr.prototype.constructor = Xr;
      function Zi(f) {
        this.__wrapped__ = f, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = tt, this.__views__ = [];
      }
      function Ug() {
        var f = new Zi(this.__wrapped__);
        return f.__actions__ = Tr(this.__actions__), f.__dir__ = this.__dir__, f.__filtered__ = this.__filtered__, f.__iteratees__ = Tr(this.__iteratees__), f.__takeCount__ = this.__takeCount__, f.__views__ = Tr(this.__views__), f;
      }
      function Vg() {
        if (this.__filtered__) {
          var f = new Zi(this);
          f.__dir__ = -1, f.__filtered__ = !0;
        } else
          f = this.clone(), f.__dir__ *= -1;
        return f;
      }
      function Hg() {
        var f = this.__wrapped__.value(), m = this.__dir__, N = Ei(f), ne = m < 0, be = N ? f.length : 0, Te = em(0, be, this.__views__), Ve = Te.start, Xe = Te.end, at = Xe - Ve, Pt = ne ? Xe : Ve - 1, Ot = this.__iteratees__, Ut = Ot.length, ti = 0, ai = hr(at, this.__takeCount__);
        if (!N || !ne && be == at && ai == at)
          return nc(f, this.__actions__);
        var wi = [];
        e:
          for (; at-- && ti < ai; ) {
            Pt += m;
            for (var Ri = -1, pi = f[Pt]; ++Ri < Ut; ) {
              var Gi = Ot[Ri], qi = Gi.iteratee, Yr = Gi.type, yr = qi(pi);
              if (Yr == De)
                pi = yr;
              else if (!yr) {
                if (Yr == ht)
                  continue e;
                break e;
              }
            }
            wi[ti++] = pi;
          }
        return wi;
      }
      Zi.prototype = ma(Ao.prototype), Zi.prototype.constructor = Zi;
      function ea(f) {
        var m = -1, N = f == null ? 0 : f.length;
        for (this.clear(); ++m < N; ) {
          var ne = f[m];
          this.set(ne[0], ne[1]);
        }
      }
      function Yg() {
        this.__data__ = Na ? Na(null) : {}, this.size = 0;
      }
      function Gg(f) {
        var m = this.has(f) && delete this.__data__[f];
        return this.size -= m ? 1 : 0, m;
      }
      function jg(f) {
        var m = this.__data__;
        if (Na) {
          var N = m[f];
          return N === x ? t : N;
        }
        return on.call(m, f) ? m[f] : t;
      }
      function Wg(f) {
        var m = this.__data__;
        return Na ? m[f] !== t : on.call(m, f);
      }
      function Zg(f, m) {
        var N = this.__data__;
        return this.size += this.has(f) ? 0 : 1, N[f] = Na && m === t ? x : m, this;
      }
      ea.prototype.clear = Yg, ea.prototype.delete = Gg, ea.prototype.get = jg, ea.prototype.has = Wg, ea.prototype.set = Zg;
      function Bs(f) {
        var m = -1, N = f == null ? 0 : f.length;
        for (this.clear(); ++m < N; ) {
          var ne = f[m];
          this.set(ne[0], ne[1]);
        }
      }
      function qg() {
        this.__data__ = [], this.size = 0;
      }
      function $g(f) {
        var m = this.__data__, N = To(m, f);
        if (N < 0)
          return !1;
        var ne = m.length - 1;
        return N == ne ? m.pop() : bo.call(m, N, 1), --this.size, !0;
      }
      function Xg(f) {
        var m = this.__data__, N = To(m, f);
        return N < 0 ? t : m[N][1];
      }
      function Kg(f) {
        return To(this.__data__, f) > -1;
      }
      function Jg(f, m) {
        var N = this.__data__, ne = To(N, f);
        return ne < 0 ? (++this.size, N.push([f, m])) : N[ne][1] = m, this;
      }
      Bs.prototype.clear = qg, Bs.prototype.delete = $g, Bs.prototype.get = Xg, Bs.prototype.has = Kg, Bs.prototype.set = Jg;
      function ks(f) {
        var m = -1, N = f == null ? 0 : f.length;
        for (this.clear(); ++m < N; ) {
          var ne = f[m];
          this.set(ne[0], ne[1]);
        }
      }
      function Qg() {
        this.size = 0, this.__data__ = {
          hash: new ea(),
          map: new (Pa || Bs)(),
          string: new ea()
        };
      }
      function ep(f) {
        var m = Fo(this, f).delete(f);
        return this.size -= m ? 1 : 0, m;
      }
      function tp(f) {
        return Fo(this, f).get(f);
      }
      function ip(f) {
        return Fo(this, f).has(f);
      }
      function np(f, m) {
        var N = Fo(this, f), ne = N.size;
        return N.set(f, m), this.size += N.size == ne ? 0 : 1, this;
      }
      ks.prototype.clear = Qg, ks.prototype.delete = ep, ks.prototype.get = tp, ks.prototype.has = ip, ks.prototype.set = np;
      function ta(f) {
        var m = -1, N = f == null ? 0 : f.length;
        for (this.__data__ = new ks(); ++m < N; )
          this.add(f[m]);
      }
      function rp(f) {
        return this.__data__.set(f, x), this;
      }
      function sp(f) {
        return this.__data__.has(f);
      }
      ta.prototype.add = ta.prototype.push = rp, ta.prototype.has = sp;
      function hs(f) {
        var m = this.__data__ = new Bs(f);
        this.size = m.size;
      }
      function ap() {
        this.__data__ = new Bs(), this.size = 0;
      }
      function op(f) {
        var m = this.__data__, N = m.delete(f);
        return this.size = m.size, N;
      }
      function lp(f) {
        return this.__data__.get(f);
      }
      function hp(f) {
        return this.__data__.has(f);
      }
      function up(f, m) {
        var N = this.__data__;
        if (N instanceof Bs) {
          var ne = N.__data__;
          if (!Pa || ne.length < s - 1)
            return ne.push([f, m]), this.size = ++N.size, this;
          N = this.__data__ = new ks(ne);
        }
        return N.set(f, m), this.size = N.size, this;
      }
      hs.prototype.clear = ap, hs.prototype.delete = op, hs.prototype.get = lp, hs.prototype.has = hp, hs.prototype.set = up;
      function Ou(f, m) {
        var N = Ei(f), ne = !N && aa(f), be = !N && !ne && Gs(f), Te = !N && !ne && !be && ba(f), Ve = N || ne || be || Te, Xe = Ve ? Si(f.length, Zt) : [], at = Xe.length;
        for (var Pt in f)
          (m || on.call(f, Pt)) && !(Ve && // Safari 9 has enumerable `arguments.length` in strict mode.
          (Pt == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          be && (Pt == "offset" || Pt == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          Te && (Pt == "buffer" || Pt == "byteLength" || Pt == "byteOffset") || // Skip index properties.
          Ps(Pt, at))) && Xe.push(Pt);
        return Xe;
      }
      function Nu(f) {
        var m = f.length;
        return m ? f[Zl(0, m - 1)] : t;
      }
      function cp(f, m) {
        return Uo(Tr(f), ia(m, 0, f.length));
      }
      function fp(f) {
        return Uo(Tr(f));
      }
      function Dl(f, m, N) {
        (N !== t && !cs(f[m], N) || N === t && !(m in f)) && xs(f, m, N);
      }
      function Da(f, m, N) {
        var ne = f[m];
        (!(on.call(f, m) && cs(ne, N)) || N === t && !(m in f)) && xs(f, m, N);
      }
      function To(f, m) {
        for (var N = f.length; N--; )
          if (cs(f[N][0], m))
            return N;
        return -1;
      }
      function dp(f, m, N, ne) {
        return Us(f, function(be, Te, Ve) {
          m(ne, be, N(be), Ve);
        }), ne;
      }
      function Ru(f, m) {
        return f && Ss(m, Qn(m), f);
      }
      function gp(f, m) {
        return f && Ss(m, Br(m), f);
      }
      function xs(f, m, N) {
        m == "__proto__" && xo ? xo(f, m, {
          configurable: !0,
          enumerable: !0,
          value: N,
          writable: !0
        }) : f[m] = N;
      }
      function zl(f, m) {
        for (var N = -1, ne = m.length, be = K(ne), Te = f == null; ++N < ne; )
          be[N] = Te ? t : yh(f, m[N]);
        return be;
      }
      function ia(f, m, N) {
        return f === f && (N !== t && (f = f <= N ? f : N), m !== t && (f = f >= m ? f : m)), f;
      }
      function Kr(f, m, N, ne, be, Te) {
        var Ve, Xe = m & U, at = m & M, Pt = m & Z;
        if (N && (Ve = be ? N(f, ne, be, Te) : N(f)), Ve !== t)
          return Ve;
        if (!kn(f))
          return f;
        var Ot = Ei(f);
        if (Ot) {
          if (Ve = im(f), !Xe)
            return Tr(f, Ve);
        } else {
          var Ut = ur(f), ti = Ut == Fi || Ut == _e;
          if (Gs(f))
            return ac(f, Xe);
          if (Ut == Ee || Ut == Ci || ti && !be) {
            if (Ve = at || ti ? {} : Cc(f), !Xe)
              return at ? jp(f, gp(Ve, f)) : Gp(f, Ru(Ve, f));
          } else {
            if (!oi[Ut])
              return be ? f : {};
            Ve = nm(f, Ut, Xe);
          }
        }
        Te || (Te = new hs());
        var ai = Te.get(f);
        if (ai)
          return ai;
        Te.set(f, Ve), ef(f) ? f.forEach(function(pi) {
          Ve.add(Kr(pi, m, N, pi, f, Te));
        }) : Jc(f) && f.forEach(function(pi, Gi) {
          Ve.set(Gi, Kr(pi, m, N, Gi, f, Te));
        });
        var wi = Pt ? at ? rh : nh : at ? Br : Qn, Ri = Ot ? t : wi(f);
        return Ze(Ri || f, function(pi, Gi) {
          Ri && (Gi = pi, pi = f[Gi]), Da(Ve, Gi, Kr(pi, m, N, Gi, f, Te));
        }), Ve;
      }
      function pp(f) {
        var m = Qn(f);
        return function(N) {
          return Du(N, f, m);
        };
      }
      function Du(f, m, N) {
        var ne = N.length;
        if (f == null)
          return !ne;
        for (f = ut(f); ne--; ) {
          var be = N[ne], Te = m[be], Ve = f[be];
          if (Ve === t && !(be in f) || !Te(Ve))
            return !1;
        }
        return !0;
      }
      function zu(f, m, N) {
        if (typeof f != "function")
          throw new yi(h);
        return Ga(function() {
          f.apply(t, N);
        }, m);
      }
      function za(f, m, N, ne) {
        var be = -1, Te = Ft, Ve = !0, Xe = f.length, at = [], Pt = m.length;
        if (!Xe)
          return at;
        N && (m = si(m, Ln(N))), ne ? (Te = fi, Ve = !1) : m.length >= s && (Te = Bi, Ve = !1, m = new ta(m));
        e:
          for (; ++be < Xe; ) {
            var Ot = f[be], Ut = N == null ? Ot : N(Ot);
            if (Ot = ne || Ot !== 0 ? Ot : 0, Ve && Ut === Ut) {
              for (var ti = Pt; ti--; )
                if (m[ti] === Ut)
                  continue e;
              at.push(Ot);
            } else
              Te(m, Ut, ne) || at.push(Ot);
          }
        return at;
      }
      var Us = cc(ws), Fu = cc(Ul, !0);
      function mp(f, m) {
        var N = !0;
        return Us(f, function(ne, be, Te) {
          return N = !!m(ne, be, Te), N;
        }), N;
      }
      function Lo(f, m, N) {
        for (var ne = -1, be = f.length; ++ne < be; ) {
          var Te = f[ne], Ve = m(Te);
          if (Ve != null && (Xe === t ? Ve === Ve && !Hr(Ve) : N(Ve, Xe)))
            var Xe = Ve, at = Te;
        }
        return at;
      }
      function _p(f, m, N, ne) {
        var be = f.length;
        for (N = Oi(N), N < 0 && (N = -N > be ? 0 : be + N), ne = ne === t || ne > be ? be : Oi(ne), ne < 0 && (ne += be), ne = N > ne ? 0 : nf(ne); N < ne; )
          f[N++] = m;
        return f;
      }
      function Uu(f, m) {
        var N = [];
        return Us(f, function(ne, be, Te) {
          m(ne, be, Te) && N.push(ne);
        }), N;
      }
      function ir(f, m, N, ne, be) {
        var Te = -1, Ve = f.length;
        for (N || (N = sm), be || (be = []); ++Te < Ve; ) {
          var Xe = f[Te];
          m > 0 && N(Xe) ? m > 1 ? ir(Xe, m - 1, N, ne, be) : di(be, Xe) : ne || (be[be.length] = Xe);
        }
        return be;
      }
      var Fl = fc(), Vu = fc(!0);
      function ws(f, m) {
        return f && Fl(f, m, Qn);
      }
      function Ul(f, m) {
        return f && Vu(f, m, Qn);
      }
      function Bo(f, m) {
        return lt(m, function(N) {
          return Os(f[N]);
        });
      }
      function na(f, m) {
        m = Hs(m, f);
        for (var N = 0, ne = m.length; f != null && N < ne; )
          f = f[us(m[N++])];
        return N && N == ne ? f : t;
      }
      function Hu(f, m, N) {
        var ne = m(f);
        return Ei(f) ? ne : di(ne, N(f));
      }
      function _r(f) {
        return f == null ? f === t ? He : Re : Qs && Qs in ut(f) ? Qp(f) : fm(f);
      }
      function Vl(f, m) {
        return f > m;
      }
      function vp(f, m) {
        return f != null && on.call(f, m);
      }
      function yp(f, m) {
        return f != null && m in ut(f);
      }
      function bp(f, m, N) {
        return f >= hr(m, N) && f < Xn(m, N);
      }
      function Hl(f, m, N) {
        for (var ne = N ? fi : Ft, be = f[0].length, Te = f.length, Ve = Te, Xe = K(Te), at = 1 / 0, Pt = []; Ve--; ) {
          var Ot = f[Ve];
          Ve && m && (Ot = si(Ot, Ln(m))), at = hr(Ot.length, at), Xe[Ve] = !N && (m || be >= 120 && Ot.length >= 120) ? new ta(Ve && Ot) : t;
        }
        Ot = f[0];
        var Ut = -1, ti = Xe[0];
        e:
          for (; ++Ut < be && Pt.length < at; ) {
            var ai = Ot[Ut], wi = m ? m(ai) : ai;
            if (ai = N || ai !== 0 ? ai : 0, !(ti ? Bi(ti, wi) : ne(Pt, wi, N))) {
              for (Ve = Te; --Ve; ) {
                var Ri = Xe[Ve];
                if (!(Ri ? Bi(Ri, wi) : ne(f[Ve], wi, N)))
                  continue e;
              }
              ti && ti.push(wi), Pt.push(ai);
            }
          }
        return Pt;
      }
      function xp(f, m, N, ne) {
        return ws(f, function(be, Te, Ve) {
          m(ne, N(be), Te, Ve);
        }), ne;
      }
      function Fa(f, m, N) {
        m = Hs(m, f), f = Bc(f, m);
        var ne = f == null ? f : f[us(Qr(m))];
        return ne == null ? t : Ue(ne, f, N);
      }
      function Yu(f) {
        return Rn(f) && _r(f) == Ci;
      }
      function wp(f) {
        return Rn(f) && _r(f) == a;
      }
      function Sp(f) {
        return Rn(f) && _r(f) == $t;
      }
      function Ua(f, m, N, ne, be) {
        return f === m ? !0 : f == null || m == null || !Rn(f) && !Rn(m) ? f !== f && m !== m : Mp(f, m, N, ne, Ua, be);
      }
      function Mp(f, m, N, ne, be, Te) {
        var Ve = Ei(f), Xe = Ei(m), at = Ve ? ji : ur(f), Pt = Xe ? ji : ur(m);
        at = at == Ci ? Ee : at, Pt = Pt == Ci ? Ee : Pt;
        var Ot = at == Ee, Ut = Pt == Ee, ti = at == Pt;
        if (ti && Gs(f)) {
          if (!Gs(m))
            return !1;
          Ve = !0, Ot = !1;
        }
        if (ti && !Ot)
          return Te || (Te = new hs()), Ve || ba(f) ? wc(f, m, N, ne, be, Te) : Kp(f, m, at, N, ne, be, Te);
        if (!(N & F)) {
          var ai = Ot && on.call(f, "__wrapped__"), wi = Ut && on.call(m, "__wrapped__");
          if (ai || wi) {
            var Ri = ai ? f.value() : f, pi = wi ? m.value() : m;
            return Te || (Te = new hs()), be(Ri, pi, N, ne, Te);
          }
        }
        return ti ? (Te || (Te = new hs()), Jp(f, m, N, ne, be, Te)) : !1;
      }
      function Cp(f) {
        return Rn(f) && ur(f) == Ct;
      }
      function Yl(f, m, N, ne) {
        var be = N.length, Te = be, Ve = !ne;
        if (f == null)
          return !Te;
        for (f = ut(f); be--; ) {
          var Xe = N[be];
          if (Ve && Xe[2] ? Xe[1] !== f[Xe[0]] : !(Xe[0] in f))
            return !1;
        }
        for (; ++be < Te; ) {
          Xe = N[be];
          var at = Xe[0], Pt = f[at], Ot = Xe[1];
          if (Ve && Xe[2]) {
            if (Pt === t && !(at in f))
              return !1;
          } else {
            var Ut = new hs();
            if (ne)
              var ti = ne(Pt, Ot, at, f, m, Ut);
            if (!(ti === t ? Ua(Ot, Pt, F | Q, ne, Ut) : ti))
              return !1;
          }
        }
        return !0;
      }
      function Gu(f) {
        if (!kn(f) || om(f))
          return !1;
        var m = Os(f) ? Cg : st;
        return m.test(sa(f));
      }
      function Ap(f) {
        return Rn(f) && _r(f) == mt;
      }
      function Tp(f) {
        return Rn(f) && ur(f) == Qe;
      }
      function Lp(f) {
        return Rn(f) && Wo(f.length) && !!ii[_r(f)];
      }
      function ju(f) {
        return typeof f == "function" ? f : f == null ? kr : typeof f == "object" ? Ei(f) ? qu(f[0], f[1]) : Zu(f) : pf(f);
      }
      function Gl(f) {
        if (!Ya(f))
          return Eg(f);
        var m = [];
        for (var N in ut(f))
          on.call(f, N) && N != "constructor" && m.push(N);
        return m;
      }
      function Bp(f) {
        if (!kn(f))
          return cm(f);
        var m = Ya(f), N = [];
        for (var ne in f)
          ne == "constructor" && (m || !on.call(f, ne)) || N.push(ne);
        return N;
      }
      function jl(f, m) {
        return f < m;
      }
      function Wu(f, m) {
        var N = -1, ne = Lr(f) ? K(f.length) : [];
        return Us(f, function(be, Te, Ve) {
          ne[++N] = m(be, Te, Ve);
        }), ne;
      }
      function Zu(f) {
        var m = ah(f);
        return m.length == 1 && m[0][2] ? Tc(m[0][0], m[0][1]) : function(N) {
          return N === f || Yl(N, f, m);
        };
      }
      function qu(f, m) {
        return lh(f) && Ac(m) ? Tc(us(f), m) : function(N) {
          var ne = yh(N, f);
          return ne === t && ne === m ? bh(N, f) : Ua(m, ne, F | Q);
        };
      }
      function ko(f, m, N, ne, be) {
        f !== m && Fl(m, function(Te, Ve) {
          if (be || (be = new hs()), kn(Te))
            kp(f, m, Ve, N, ko, ne, be);
          else {
            var Xe = ne ? ne(uh(f, Ve), Te, Ve + "", f, m, be) : t;
            Xe === t && (Xe = Te), Dl(f, Ve, Xe);
          }
        }, Br);
      }
      function kp(f, m, N, ne, be, Te, Ve) {
        var Xe = uh(f, N), at = uh(m, N), Pt = Ve.get(at);
        if (Pt) {
          Dl(f, N, Pt);
          return;
        }
        var Ot = Te ? Te(Xe, at, N + "", f, m, Ve) : t, Ut = Ot === t;
        if (Ut) {
          var ti = Ei(at), ai = !ti && Gs(at), wi = !ti && !ai && ba(at);
          Ot = at, ti || ai || wi ? Ei(Xe) ? Ot = Xe : Fn(Xe) ? Ot = Tr(Xe) : ai ? (Ut = !1, Ot = ac(at, !0)) : wi ? (Ut = !1, Ot = oc(at, !0)) : Ot = [] : ja(at) || aa(at) ? (Ot = Xe, aa(Xe) ? Ot = rf(Xe) : (!kn(Xe) || Os(Xe)) && (Ot = Cc(at))) : Ut = !1;
        }
        Ut && (Ve.set(at, Ot), be(Ot, at, ne, Te, Ve), Ve.delete(at)), Dl(f, N, Ot);
      }
      function $u(f, m) {
        var N = f.length;
        if (N)
          return m += m < 0 ? N : 0, Ps(m, N) ? f[m] : t;
      }
      function Xu(f, m, N) {
        m.length ? m = si(m, function(Te) {
          return Ei(Te) ? function(Ve) {
            return na(Ve, Te.length === 1 ? Te[0] : Te);
          } : Te;
        }) : m = [kr];
        var ne = -1;
        m = si(m, Ln(bi()));
        var be = Wu(f, function(Te, Ve, Xe) {
          var at = si(m, function(Pt) {
            return Pt(Te);
          });
          return { criteria: at, index: ++ne, value: Te };
        });
        return Gn(be, function(Te, Ve) {
          return Yp(Te, Ve, N);
        });
      }
      function Ep(f, m) {
        return Ku(f, m, function(N, ne) {
          return bh(f, ne);
        });
      }
      function Ku(f, m, N) {
        for (var ne = -1, be = m.length, Te = {}; ++ne < be; ) {
          var Ve = m[ne], Xe = na(f, Ve);
          N(Xe, Ve) && Va(Te, Hs(Ve, f), Xe);
        }
        return Te;
      }
      function Ip(f) {
        return function(m) {
          return na(m, f);
        };
      }
      function Wl(f, m, N, ne) {
        var be = ne ? pr : ar, Te = -1, Ve = m.length, Xe = f;
        for (f === m && (m = Tr(m)), N && (Xe = si(f, Ln(N))); ++Te < Ve; )
          for (var at = 0, Pt = m[Te], Ot = N ? N(Pt) : Pt; (at = be(Xe, Ot, at, ne)) > -1; )
            Xe !== f && bo.call(Xe, at, 1), bo.call(f, at, 1);
        return f;
      }
      function Ju(f, m) {
        for (var N = f ? m.length : 0, ne = N - 1; N--; ) {
          var be = m[N];
          if (N == ne || be !== Te) {
            var Te = be;
            Ps(be) ? bo.call(f, be, 1) : Xl(f, be);
          }
        }
        return f;
      }
      function Zl(f, m) {
        return f + So(Iu() * (m - f + 1));
      }
      function Pp(f, m, N, ne) {
        for (var be = -1, Te = Xn(wo((m - f) / (N || 1)), 0), Ve = K(Te); Te--; )
          Ve[ne ? Te : ++be] = f, f += N;
        return Ve;
      }
      function ql(f, m) {
        var N = "";
        if (!f || m < 1 || m > We)
          return N;
        do
          m % 2 && (N += f), m = So(m / 2), m && (f += f);
        while (m);
        return N;
      }
      function zi(f, m) {
        return ch(Lc(f, m, kr), f + "");
      }
      function Op(f) {
        return Nu(xa(f));
      }
      function Np(f, m) {
        var N = xa(f);
        return Uo(N, ia(m, 0, N.length));
      }
      function Va(f, m, N, ne) {
        if (!kn(f))
          return f;
        m = Hs(m, f);
        for (var be = -1, Te = m.length, Ve = Te - 1, Xe = f; Xe != null && ++be < Te; ) {
          var at = us(m[be]), Pt = N;
          if (at === "__proto__" || at === "constructor" || at === "prototype")
            return f;
          if (be != Ve) {
            var Ot = Xe[at];
            Pt = ne ? ne(Ot, at, Xe) : t, Pt === t && (Pt = kn(Ot) ? Ot : Ps(m[be + 1]) ? [] : {});
          }
          Da(Xe, at, Pt), Xe = Xe[at];
        }
        return f;
      }
      var Qu = Mo ? function(f, m) {
        return Mo.set(f, m), f;
      } : kr, Rp = xo ? function(f, m) {
        return xo(f, "toString", {
          configurable: !0,
          enumerable: !1,
          value: wh(m),
          writable: !0
        });
      } : kr;
      function Dp(f) {
        return Uo(xa(f));
      }
      function Jr(f, m, N) {
        var ne = -1, be = f.length;
        m < 0 && (m = -m > be ? 0 : be + m), N = N > be ? be : N, N < 0 && (N += be), be = m > N ? 0 : N - m >>> 0, m >>>= 0;
        for (var Te = K(be); ++ne < be; )
          Te[ne] = f[ne + m];
        return Te;
      }
      function zp(f, m) {
        var N;
        return Us(f, function(ne, be, Te) {
          return N = m(ne, be, Te), !N;
        }), !!N;
      }
      function Eo(f, m, N) {
        var ne = 0, be = f == null ? ne : f.length;
        if (typeof m == "number" && m === m && be <= qt) {
          for (; ne < be; ) {
            var Te = ne + be >>> 1, Ve = f[Te];
            Ve !== null && !Hr(Ve) && (N ? Ve <= m : Ve < m) ? ne = Te + 1 : be = Te;
          }
          return be;
        }
        return $l(f, m, kr, N);
      }
      function $l(f, m, N, ne) {
        var be = 0, Te = f == null ? 0 : f.length;
        if (Te === 0)
          return 0;
        m = N(m);
        for (var Ve = m !== m, Xe = m === null, at = Hr(m), Pt = m === t; be < Te; ) {
          var Ot = So((be + Te) / 2), Ut = N(f[Ot]), ti = Ut !== t, ai = Ut === null, wi = Ut === Ut, Ri = Hr(Ut);
          if (Ve)
            var pi = ne || wi;
          else
            Pt ? pi = wi && (ne || ti) : Xe ? pi = wi && ti && (ne || !ai) : at ? pi = wi && ti && !ai && (ne || !Ri) : ai || Ri ? pi = !1 : pi = ne ? Ut <= m : Ut < m;
          pi ? be = Ot + 1 : Te = Ot;
        }
        return hr(Te, Kt);
      }
      function ec(f, m) {
        for (var N = -1, ne = f.length, be = 0, Te = []; ++N < ne; ) {
          var Ve = f[N], Xe = m ? m(Ve) : Ve;
          if (!N || !cs(Xe, at)) {
            var at = Xe;
            Te[be++] = Ve === 0 ? 0 : Ve;
          }
        }
        return Te;
      }
      function tc(f) {
        return typeof f == "number" ? f : Hr(f) ? rt : +f;
      }
      function Vr(f) {
        if (typeof f == "string")
          return f;
        if (Ei(f))
          return si(f, Vr) + "";
        if (Hr(f))
          return Pu ? Pu.call(f) : "";
        var m = f + "";
        return m == "0" && 1 / f == -Yt ? "-0" : m;
      }
      function Vs(f, m, N) {
        var ne = -1, be = Ft, Te = f.length, Ve = !0, Xe = [], at = Xe;
        if (N)
          Ve = !1, be = fi;
        else if (Te >= s) {
          var Pt = m ? null : $p(f);
          if (Pt)
            return Pi(Pt);
          Ve = !1, be = Bi, at = new ta();
        } else
          at = m ? [] : Xe;
        e:
          for (; ++ne < Te; ) {
            var Ot = f[ne], Ut = m ? m(Ot) : Ot;
            if (Ot = N || Ot !== 0 ? Ot : 0, Ve && Ut === Ut) {
              for (var ti = at.length; ti--; )
                if (at[ti] === Ut)
                  continue e;
              m && at.push(Ut), Xe.push(Ot);
            } else
              be(at, Ut, N) || (at !== Xe && at.push(Ut), Xe.push(Ot));
          }
        return Xe;
      }
      function Xl(f, m) {
        m = Hs(m, f);
        var N = -1, ne = m.length;
        if (!ne)
          return !0;
        for (; ++N < ne; ) {
          var be = us(m[N]);
          if (be === "__proto__" && !on.call(f, "__proto__") || (be === "constructor" || be === "prototype") && N < ne - 1)
            return !1;
        }
        var Te = Bc(f, m);
        return Te == null || delete Te[us(Qr(m))];
      }
      function ic(f, m, N, ne) {
        return Va(f, m, N(na(f, m)), ne);
      }
      function Io(f, m, N, ne) {
        for (var be = f.length, Te = ne ? be : -1; (ne ? Te-- : ++Te < be) && m(f[Te], Te, f); )
          ;
        return N ? Jr(f, ne ? 0 : Te, ne ? Te + 1 : be) : Jr(f, ne ? Te + 1 : 0, ne ? be : Te);
      }
      function nc(f, m) {
        var N = f;
        return N instanceof Zi && (N = N.value()), xn(m, function(ne, be) {
          return be.func.apply(be.thisArg, di([ne], be.args));
        }, N);
      }
      function Kl(f, m, N) {
        var ne = f.length;
        if (ne < 2)
          return ne ? Vs(f[0]) : [];
        for (var be = -1, Te = K(ne); ++be < ne; )
          for (var Ve = f[be], Xe = -1; ++Xe < ne; )
            Xe != be && (Te[be] = za(Te[be] || Ve, f[Xe], m, N));
        return Vs(ir(Te, 1), m, N);
      }
      function rc(f, m, N) {
        for (var ne = -1, be = f.length, Te = m.length, Ve = {}; ++ne < be; ) {
          var Xe = ne < Te ? m[ne] : t;
          N(Ve, f[ne], Xe);
        }
        return Ve;
      }
      function Jl(f) {
        return Fn(f) ? f : [];
      }
      function Ql(f) {
        return typeof f == "function" ? f : kr;
      }
      function Hs(f, m) {
        return Ei(f) ? f : lh(f, m) ? [f] : Pc(ln(f));
      }
      var Fp = zi;
      function Ys(f, m, N) {
        var ne = f.length;
        return N = N === t ? ne : N, !m && N >= ne ? f : Jr(f, m, N);
      }
      var sc = Ag || function(f) {
        return Sn.clearTimeout(f);
      };
      function ac(f, m) {
        if (m)
          return f.slice();
        var N = f.length, ne = Tu ? Tu(N) : new f.constructor(N);
        return f.copy(ne), ne;
      }
      function eh(f) {
        var m = new f.constructor(f.byteLength);
        return new vo(m).set(new vo(f)), m;
      }
      function Up(f, m) {
        var N = m ? eh(f.buffer) : f.buffer;
        return new f.constructor(N, f.byteOffset, f.byteLength);
      }
      function Vp(f) {
        var m = new f.constructor(f.source, gt.exec(f));
        return m.lastIndex = f.lastIndex, m;
      }
      function Hp(f) {
        return Ra ? ut(Ra.call(f)) : {};
      }
      function oc(f, m) {
        var N = m ? eh(f.buffer) : f.buffer;
        return new f.constructor(N, f.byteOffset, f.length);
      }
      function lc(f, m) {
        if (f !== m) {
          var N = f !== t, ne = f === null, be = f === f, Te = Hr(f), Ve = m !== t, Xe = m === null, at = m === m, Pt = Hr(m);
          if (!Xe && !Pt && !Te && f > m || Te && Ve && at && !Xe && !Pt || ne && Ve && at || !N && at || !be)
            return 1;
          if (!ne && !Te && !Pt && f < m || Pt && N && be && !ne && !Te || Xe && N && be || !Ve && be || !at)
            return -1;
        }
        return 0;
      }
      function Yp(f, m, N) {
        for (var ne = -1, be = f.criteria, Te = m.criteria, Ve = be.length, Xe = N.length; ++ne < Ve; ) {
          var at = lc(be[ne], Te[ne]);
          if (at) {
            if (ne >= Xe)
              return at;
            var Pt = N[ne];
            return at * (Pt == "desc" ? -1 : 1);
          }
        }
        return f.index - m.index;
      }
      function hc(f, m, N, ne) {
        for (var be = -1, Te = f.length, Ve = N.length, Xe = -1, at = m.length, Pt = Xn(Te - Ve, 0), Ot = K(at + Pt), Ut = !ne; ++Xe < at; )
          Ot[Xe] = m[Xe];
        for (; ++be < Ve; )
          (Ut || be < Te) && (Ot[N[be]] = f[be]);
        for (; Pt--; )
          Ot[Xe++] = f[be++];
        return Ot;
      }
      function uc(f, m, N, ne) {
        for (var be = -1, Te = f.length, Ve = -1, Xe = N.length, at = -1, Pt = m.length, Ot = Xn(Te - Xe, 0), Ut = K(Ot + Pt), ti = !ne; ++be < Ot; )
          Ut[be] = f[be];
        for (var ai = be; ++at < Pt; )
          Ut[ai + at] = m[at];
        for (; ++Ve < Xe; )
          (ti || be < Te) && (Ut[ai + N[Ve]] = f[be++]);
        return Ut;
      }
      function Tr(f, m) {
        var N = -1, ne = f.length;
        for (m || (m = K(ne)); ++N < ne; )
          m[N] = f[N];
        return m;
      }
      function Ss(f, m, N, ne) {
        var be = !N;
        N || (N = {});
        for (var Te = -1, Ve = m.length; ++Te < Ve; ) {
          var Xe = m[Te], at = ne ? ne(N[Xe], f[Xe], Xe, N, f) : t;
          at === t && (at = f[Xe]), be ? xs(N, Xe, at) : Da(N, Xe, at);
        }
        return N;
      }
      function Gp(f, m) {
        return Ss(f, oh(f), m);
      }
      function jp(f, m) {
        return Ss(f, Sc(f), m);
      }
      function Po(f, m) {
        return function(N, ne) {
          var be = Ei(N) ? ze : dp, Te = m ? m() : {};
          return be(N, f, bi(ne, 2), Te);
        };
      }
      function _a(f) {
        return zi(function(m, N) {
          var ne = -1, be = N.length, Te = be > 1 ? N[be - 1] : t, Ve = be > 2 ? N[2] : t;
          for (Te = f.length > 3 && typeof Te == "function" ? (be--, Te) : t, Ve && vr(N[0], N[1], Ve) && (Te = be < 3 ? t : Te, be = 1), m = ut(m); ++ne < be; ) {
            var Xe = N[ne];
            Xe && f(m, Xe, ne, Te);
          }
          return m;
        });
      }
      function cc(f, m) {
        return function(N, ne) {
          if (N == null)
            return N;
          if (!Lr(N))
            return f(N, ne);
          for (var be = N.length, Te = m ? be : -1, Ve = ut(N); (m ? Te-- : ++Te < be) && ne(Ve[Te], Te, Ve) !== !1; )
            ;
          return N;
        };
      }
      function fc(f) {
        return function(m, N, ne) {
          for (var be = -1, Te = ut(m), Ve = ne(m), Xe = Ve.length; Xe--; ) {
            var at = Ve[f ? Xe : ++be];
            if (N(Te[at], at, Te) === !1)
              break;
          }
          return m;
        };
      }
      function Wp(f, m, N) {
        var ne = m & D, be = Ha(f);
        function Te() {
          var Ve = this && this !== Sn && this instanceof Te ? be : f;
          return Ve.apply(ne ? N : this, arguments);
        }
        return Te;
      }
      function dc(f) {
        return function(m) {
          m = ln(m);
          var N = Ki(m) ? zn(m) : t, ne = N ? N[0] : m.charAt(0), be = N ? Ys(N, 1).join("") : m.slice(1);
          return ne[f]() + be;
        };
      }
      function va(f) {
        return function(m) {
          return xn(df(ff(m).replace(ue, "")), f, "");
        };
      }
      function Ha(f) {
        return function() {
          var m = arguments;
          switch (m.length) {
            case 0:
              return new f();
            case 1:
              return new f(m[0]);
            case 2:
              return new f(m[0], m[1]);
            case 3:
              return new f(m[0], m[1], m[2]);
            case 4:
              return new f(m[0], m[1], m[2], m[3]);
            case 5:
              return new f(m[0], m[1], m[2], m[3], m[4]);
            case 6:
              return new f(m[0], m[1], m[2], m[3], m[4], m[5]);
            case 7:
              return new f(m[0], m[1], m[2], m[3], m[4], m[5], m[6]);
          }
          var N = ma(f.prototype), ne = f.apply(N, m);
          return kn(ne) ? ne : N;
        };
      }
      function Zp(f, m, N) {
        var ne = Ha(f);
        function be() {
          for (var Te = arguments.length, Ve = K(Te), Xe = Te, at = ya(be); Xe--; )
            Ve[Xe] = arguments[Xe];
          var Pt = Te < 3 && Ve[0] !== at && Ve[Te - 1] !== at ? [] : $n(Ve, at);
          if (Te -= Pt.length, Te < N)
            return vc(
              f,
              m,
              Oo,
              be.placeholder,
              t,
              Ve,
              Pt,
              t,
              t,
              N - Te
            );
          var Ot = this && this !== Sn && this instanceof be ? ne : f;
          return Ue(Ot, this, Ve);
        }
        return be;
      }
      function gc(f) {
        return function(m, N, ne) {
          var be = ut(m);
          if (!Lr(m)) {
            var Te = bi(N, 3);
            m = Qn(m), N = function(Xe) {
              return Te(be[Xe], Xe, be);
            };
          }
          var Ve = f(m, N, ne);
          return Ve > -1 ? be[Te ? m[Ve] : Ve] : t;
        };
      }
      function pc(f) {
        return Is(function(m) {
          var N = m.length, ne = N, be = Xr.prototype.thru;
          for (f && m.reverse(); ne--; ) {
            var Te = m[ne];
            if (typeof Te != "function")
              throw new yi(h);
            if (be && !Ve && zo(Te) == "wrapper")
              var Ve = new Xr([], !0);
          }
          for (ne = Ve ? ne : N; ++ne < N; ) {
            Te = m[ne];
            var Xe = zo(Te), at = Xe == "wrapper" ? sh(Te) : t;
            at && hh(at[0]) && at[1] == (je | le | X | ke) && !at[4].length && at[9] == 1 ? Ve = Ve[zo(at[0])].apply(Ve, at[3]) : Ve = Te.length == 1 && hh(Te) ? Ve[Xe]() : Ve.thru(Te);
          }
          return function() {
            var Pt = arguments, Ot = Pt[0];
            if (Ve && Pt.length == 1 && Ei(Ot))
              return Ve.plant(Ot).value();
            for (var Ut = 0, ti = N ? m[Ut].apply(this, Pt) : Ot; ++Ut < N; )
              ti = m[Ut].call(this, ti);
            return ti;
          };
        });
      }
      function Oo(f, m, N, ne, be, Te, Ve, Xe, at, Pt) {
        var Ot = m & je, Ut = m & D, ti = m & te, ai = m & (le | fe), wi = m & Ye, Ri = ti ? t : Ha(f);
        function pi() {
          for (var Gi = arguments.length, qi = K(Gi), Yr = Gi; Yr--; )
            qi[Yr] = arguments[Yr];
          if (ai)
            var yr = ya(pi), Gr = un(qi, yr);
          if (ne && (qi = hc(qi, ne, be, ai)), Te && (qi = uc(qi, Te, Ve, ai)), Gi -= Gr, ai && Gi < Pt) {
            var Un = $n(qi, yr);
            return vc(
              f,
              m,
              Oo,
              pi.placeholder,
              N,
              qi,
              Un,
              Xe,
              at,
              Pt - Gi
            );
          }
          var fs = Ut ? N : this, Rs = ti ? fs[f] : f;
          return Gi = qi.length, Xe ? qi = dm(qi, Xe) : wi && Gi > 1 && qi.reverse(), Ot && at < Gi && (qi.length = at), this && this !== Sn && this instanceof pi && (Rs = Ri || Ha(Rs)), Rs.apply(fs, qi);
        }
        return pi;
      }
      function mc(f, m) {
        return function(N, ne) {
          return xp(N, f, m(ne), {});
        };
      }
      function No(f, m) {
        return function(N, ne) {
          var be;
          if (N === t && ne === t)
            return m;
          if (N !== t && (be = N), ne !== t) {
            if (be === t)
              return ne;
            typeof N == "string" || typeof ne == "string" ? (N = Vr(N), ne = Vr(ne)) : (N = tc(N), ne = tc(ne)), be = f(N, ne);
          }
          return be;
        };
      }
      function th(f) {
        return Is(function(m) {
          return m = si(m, Ln(bi())), zi(function(N) {
            var ne = this;
            return f(m, function(be) {
              return Ue(be, ne, N);
            });
          });
        });
      }
      function Ro(f, m) {
        m = m === t ? " " : Vr(m);
        var N = m.length;
        if (N < 2)
          return N ? ql(m, f) : m;
        var ne = ql(m, wo(f / Jn(m)));
        return Ki(m) ? Ys(zn(ne), 0, f).join("") : ne.slice(0, f);
      }
      function qp(f, m, N, ne) {
        var be = m & D, Te = Ha(f);
        function Ve() {
          for (var Xe = -1, at = arguments.length, Pt = -1, Ot = ne.length, Ut = K(Ot + at), ti = this && this !== Sn && this instanceof Ve ? Te : f; ++Pt < Ot; )
            Ut[Pt] = ne[Pt];
          for (; at--; )
            Ut[Pt++] = arguments[++Xe];
          return Ue(ti, be ? N : this, Ut);
        }
        return Ve;
      }
      function _c(f) {
        return function(m, N, ne) {
          return ne && typeof ne != "number" && vr(m, N, ne) && (N = ne = t), m = Ns(m), N === t ? (N = m, m = 0) : N = Ns(N), ne = ne === t ? m < N ? 1 : -1 : Ns(ne), Pp(m, N, ne, f);
        };
      }
      function Do(f) {
        return function(m, N) {
          return typeof m == "string" && typeof N == "string" || (m = es(m), N = es(N)), f(m, N);
        };
      }
      function vc(f, m, N, ne, be, Te, Ve, Xe, at, Pt) {
        var Ot = m & le, Ut = Ot ? Ve : t, ti = Ot ? t : Ve, ai = Ot ? Te : t, wi = Ot ? t : Te;
        m |= Ot ? X : W, m &= ~(Ot ? W : X), m & ee || (m &= ~(D | te));
        var Ri = [
          f,
          m,
          be,
          ai,
          Ut,
          wi,
          ti,
          Xe,
          at,
          Pt
        ], pi = N.apply(t, Ri);
        return hh(f) && kc(pi, Ri), pi.placeholder = ne, Ec(pi, f, m);
      }
      function ih(f) {
        var m = ot[f];
        return function(N, ne) {
          if (N = es(N), ne = ne == null ? 0 : hr(Oi(ne), 292), ne && Eu(N)) {
            var be = (ln(N) + "e").split("e"), Te = m(be[0] + "e" + (+be[1] + ne));
            return be = (ln(Te) + "e").split("e"), +(be[0] + "e" + (+be[1] - ne));
          }
          return m(N);
        };
      }
      var $p = ga && 1 / Pi(new ga([, -0]))[1] == Yt ? function(f) {
        return new ga(f);
      } : Ch;
      function yc(f) {
        return function(m) {
          var N = ur(m);
          return N == Ct ? tr(m) : N == Qe ? ls(m) : hn(m, f(m));
        };
      }
      function Es(f, m, N, ne, be, Te, Ve, Xe) {
        var at = m & te;
        if (!at && typeof f != "function")
          throw new yi(h);
        var Pt = ne ? ne.length : 0;
        if (Pt || (m &= ~(X | W), ne = be = t), Ve = Ve === t ? Ve : Xn(Oi(Ve), 0), Xe = Xe === t ? Xe : Oi(Xe), Pt -= be ? be.length : 0, m & W) {
          var Ot = ne, Ut = be;
          ne = be = t;
        }
        var ti = at ? t : sh(f), ai = [
          f,
          m,
          N,
          ne,
          be,
          Ot,
          Ut,
          Te,
          Ve,
          Xe
        ];
        if (ti && um(ai, ti), f = ai[0], m = ai[1], N = ai[2], ne = ai[3], be = ai[4], Xe = ai[9] = ai[9] === t ? at ? 0 : f.length : Xn(ai[9] - Pt, 0), !Xe && m & (le | fe) && (m &= ~(le | fe)), !m || m == D)
          var wi = Wp(f, m, N);
        else
          m == le || m == fe ? wi = Zp(f, m, Xe) : (m == X || m == (D | X)) && !be.length ? wi = qp(f, m, N, ne) : wi = Oo.apply(t, ai);
        var Ri = ti ? Qu : kc;
        return Ec(Ri(wi, ai), f, m);
      }
      function bc(f, m, N, ne) {
        return f === t || cs(f, mn[N]) && !on.call(ne, N) ? m : f;
      }
      function xc(f, m, N, ne, be, Te) {
        return kn(f) && kn(m) && (Te.set(m, f), ko(f, m, t, xc, Te), Te.delete(m)), f;
      }
      function Xp(f) {
        return ja(f) ? t : f;
      }
      function wc(f, m, N, ne, be, Te) {
        var Ve = N & F, Xe = f.length, at = m.length;
        if (Xe != at && !(Ve && at > Xe))
          return !1;
        var Pt = Te.get(f), Ot = Te.get(m);
        if (Pt && Ot)
          return Pt == m && Ot == f;
        var Ut = -1, ti = !0, ai = N & Q ? new ta() : t;
        for (Te.set(f, m), Te.set(m, f); ++Ut < Xe; ) {
          var wi = f[Ut], Ri = m[Ut];
          if (ne)
            var pi = Ve ? ne(Ri, wi, Ut, m, f, Te) : ne(wi, Ri, Ut, f, m, Te);
          if (pi !== t) {
            if (pi)
              continue;
            ti = !1;
            break;
          }
          if (ai) {
            if (!an(m, function(Gi, qi) {
              if (!Bi(ai, qi) && (wi === Gi || be(wi, Gi, N, ne, Te)))
                return ai.push(qi);
            })) {
              ti = !1;
              break;
            }
          } else if (!(wi === Ri || be(wi, Ri, N, ne, Te))) {
            ti = !1;
            break;
          }
        }
        return Te.delete(f), Te.delete(m), ti;
      }
      function Kp(f, m, N, ne, be, Te, Ve) {
        switch (N) {
          case l:
            if (f.byteLength != m.byteLength || f.byteOffset != m.byteOffset)
              return !1;
            f = f.buffer, m = m.buffer;
          case a:
            return !(f.byteLength != m.byteLength || !Te(new vo(f), new vo(m)));
          case Wt:
          case $t:
          case yt:
            return cs(+f, +m);
          case tn:
            return f.name == m.name && f.message == m.message;
          case mt:
          case bt:
            return f == m + "";
          case Ct:
            var Xe = tr;
          case Qe:
            var at = ne & F;
            if (Xe || (Xe = Pi), f.size != m.size && !at)
              return !1;
            var Pt = Ve.get(f);
            if (Pt)
              return Pt == m;
            ne |= Q, Ve.set(f, m);
            var Ot = wc(Xe(f), Xe(m), ne, be, Te, Ve);
            return Ve.delete(f), Ot;
          case Gt:
            if (Ra)
              return Ra.call(f) == Ra.call(m);
        }
        return !1;
      }
      function Jp(f, m, N, ne, be, Te) {
        var Ve = N & F, Xe = nh(f), at = Xe.length, Pt = nh(m), Ot = Pt.length;
        if (at != Ot && !Ve)
          return !1;
        for (var Ut = at; Ut--; ) {
          var ti = Xe[Ut];
          if (!(Ve ? ti in m : on.call(m, ti)))
            return !1;
        }
        var ai = Te.get(f), wi = Te.get(m);
        if (ai && wi)
          return ai == m && wi == f;
        var Ri = !0;
        Te.set(f, m), Te.set(m, f);
        for (var pi = Ve; ++Ut < at; ) {
          ti = Xe[Ut];
          var Gi = f[ti], qi = m[ti];
          if (ne)
            var Yr = Ve ? ne(qi, Gi, ti, m, f, Te) : ne(Gi, qi, ti, f, m, Te);
          if (!(Yr === t ? Gi === qi || be(Gi, qi, N, ne, Te) : Yr)) {
            Ri = !1;
            break;
          }
          pi || (pi = ti == "constructor");
        }
        if (Ri && !pi) {
          var yr = f.constructor, Gr = m.constructor;
          yr != Gr && "constructor" in f && "constructor" in m && !(typeof yr == "function" && yr instanceof yr && typeof Gr == "function" && Gr instanceof Gr) && (Ri = !1);
        }
        return Te.delete(f), Te.delete(m), Ri;
      }
      function Is(f) {
        return ch(Lc(f, t, Dc), f + "");
      }
      function nh(f) {
        return Hu(f, Qn, oh);
      }
      function rh(f) {
        return Hu(f, Br, Sc);
      }
      var sh = Mo ? function(f) {
        return Mo.get(f);
      } : Ch;
      function zo(f) {
        for (var m = f.name + "", N = pa[m], ne = on.call(pa, m) ? N.length : 0; ne--; ) {
          var be = N[ne], Te = be.func;
          if (Te == null || Te == f)
            return be.name;
        }
        return m;
      }
      function ya(f) {
        var m = on.call(Ce, "placeholder") ? Ce : f;
        return m.placeholder;
      }
      function bi() {
        var f = Ce.iteratee || Sh;
        return f = f === Sh ? ju : f, arguments.length ? f(arguments[0], arguments[1]) : f;
      }
      function Fo(f, m) {
        var N = f.__data__;
        return am(m) ? N[typeof m == "string" ? "string" : "hash"] : N.map;
      }
      function ah(f) {
        for (var m = Qn(f), N = m.length; N--; ) {
          var ne = m[N], be = f[ne];
          m[N] = [ne, be, Ac(be)];
        }
        return m;
      }
      function ra(f, m) {
        var N = Fr(f, m);
        return Gu(N) ? N : t;
      }
      function Qp(f) {
        var m = on.call(f, Qs), N = f[Qs];
        try {
          f[Qs] = t;
          var ne = !0;
        } catch {
        }
        var be = mo.call(f);
        return ne && (m ? f[Qs] = N : delete f[Qs]), be;
      }
      var oh = Ol ? function(f) {
        return f == null ? [] : (f = ut(f), lt(Ol(f), function(m) {
          return Bu.call(f, m);
        }));
      } : Ah, Sc = Ol ? function(f) {
        for (var m = []; f; )
          di(m, oh(f)), f = yo(f);
        return m;
      } : Ah, ur = _r;
      (Nl && ur(new Nl(new ArrayBuffer(1))) != l || Pa && ur(new Pa()) != Ct || Rl && ur(Rl.resolve()) != et || ga && ur(new ga()) != Qe || Oa && ur(new Oa()) != i) && (ur = function(f) {
        var m = _r(f), N = m == Ee ? f.constructor : t, ne = N ? sa(N) : "";
        if (ne)
          switch (ne) {
            case Ng:
              return l;
            case Rg:
              return Ct;
            case Dg:
              return et;
            case zg:
              return Qe;
            case Fg:
              return i;
          }
        return m;
      });
      function em(f, m, N) {
        for (var ne = -1, be = N.length; ++ne < be; ) {
          var Te = N[ne], Ve = Te.size;
          switch (Te.type) {
            case "drop":
              f += Ve;
              break;
            case "dropRight":
              m -= Ve;
              break;
            case "take":
              m = hr(m, f + Ve);
              break;
            case "takeRight":
              f = Xn(f, m - Ve);
              break;
          }
        }
        return { start: f, end: m };
      }
      function tm(f) {
        var m = f.match(we);
        return m ? m[1].split(Se) : [];
      }
      function Mc(f, m, N) {
        m = Hs(m, f);
        for (var ne = -1, be = m.length, Te = !1; ++ne < be; ) {
          var Ve = us(m[ne]);
          if (!(Te = f != null && N(f, Ve)))
            break;
          f = f[Ve];
        }
        return Te || ++ne != be ? Te : (be = f == null ? 0 : f.length, !!be && Wo(be) && Ps(Ve, be) && (Ei(f) || aa(f)));
      }
      function im(f) {
        var m = f.length, N = new f.constructor(m);
        return m && typeof f[0] == "string" && on.call(f, "index") && (N.index = f.index, N.input = f.input), N;
      }
      function Cc(f) {
        return typeof f.constructor == "function" && !Ya(f) ? ma(yo(f)) : {};
      }
      function nm(f, m, N) {
        var ne = f.constructor;
        switch (m) {
          case a:
            return eh(f);
          case Wt:
          case $t:
            return new ne(+f);
          case l:
            return Up(f, N);
          case u:
          case d:
          case v:
          case p:
          case y:
          case S:
          case L:
          case E:
          case A:
            return oc(f, N);
          case Ct:
            return new ne();
          case yt:
          case bt:
            return new ne(f);
          case mt:
            return Vp(f);
          case Qe:
            return new ne();
          case Gt:
            return Hp(f);
        }
      }
      function rm(f, m) {
        var N = m.length;
        if (!N)
          return f;
        var ne = N - 1;
        return m[ne] = (N > 1 ? "& " : "") + m[ne], m = m.join(N > 2 ? ", " : " "), f.replace(ve, `{
/* [wrapped with ` + m + `] */
`);
      }
      function sm(f) {
        return Ei(f) || aa(f) || !!(ku && f && f[ku]);
      }
      function Ps(f, m) {
        var N = typeof f;
        return m = m ?? We, !!m && (N == "number" || N != "symbol" && vt.test(f)) && f > -1 && f % 1 == 0 && f < m;
      }
      function vr(f, m, N) {
        if (!kn(N))
          return !1;
        var ne = typeof m;
        return (ne == "number" ? Lr(N) && Ps(m, N.length) : ne == "string" && m in N) ? cs(N[m], f) : !1;
      }
      function lh(f, m) {
        if (Ei(f))
          return !1;
        var N = typeof f;
        return N == "number" || N == "symbol" || N == "boolean" || f == null || Hr(f) ? !0 : ie.test(f) || !H.test(f) || m != null && f in ut(m);
      }
      function am(f) {
        var m = typeof f;
        return m == "string" || m == "number" || m == "symbol" || m == "boolean" ? f !== "__proto__" : f === null;
      }
      function hh(f) {
        var m = zo(f), N = Ce[m];
        if (typeof N != "function" || !(m in Zi.prototype))
          return !1;
        if (f === N)
          return !0;
        var ne = sh(N);
        return !!ne && f === ne[0];
      }
      function om(f) {
        return !!Au && Au in f;
      }
      var lm = mr ? Os : Th;
      function Ya(f) {
        var m = f && f.constructor, N = typeof m == "function" && m.prototype || mn;
        return f === N;
      }
      function Ac(f) {
        return f === f && !kn(f);
      }
      function Tc(f, m) {
        return function(N) {
          return N == null ? !1 : N[f] === m && (m !== t || f in ut(N));
        };
      }
      function hm(f) {
        var m = Go(f, function(ne) {
          return N.size === B && N.clear(), ne;
        }), N = m.cache;
        return m;
      }
      function um(f, m) {
        var N = f[1], ne = m[1], be = N | ne, Te = be < (D | te | je), Ve = ne == je && N == le || ne == je && N == ke && f[7].length <= m[8] || ne == (je | ke) && m[7].length <= m[8] && N == le;
        if (!(Te || Ve))
          return f;
        ne & D && (f[2] = m[2], be |= N & D ? 0 : ee);
        var Xe = m[3];
        if (Xe) {
          var at = f[3];
          f[3] = at ? hc(at, Xe, m[4]) : Xe, f[4] = at ? $n(f[3], P) : m[4];
        }
        return Xe = m[5], Xe && (at = f[5], f[5] = at ? uc(at, Xe, m[6]) : Xe, f[6] = at ? $n(f[5], P) : m[6]), Xe = m[7], Xe && (f[7] = Xe), ne & je && (f[8] = f[8] == null ? m[8] : hr(f[8], m[8])), f[9] == null && (f[9] = m[9]), f[0] = m[0], f[1] = be, f;
      }
      function cm(f) {
        var m = [];
        if (f != null)
          for (var N in ut(f))
            m.push(N);
        return m;
      }
      function fm(f) {
        return mo.call(f);
      }
      function Lc(f, m, N) {
        return m = Xn(m === t ? f.length - 1 : m, 0), function() {
          for (var ne = arguments, be = -1, Te = Xn(ne.length - m, 0), Ve = K(Te); ++be < Te; )
            Ve[be] = ne[m + be];
          be = -1;
          for (var Xe = K(m + 1); ++be < m; )
            Xe[be] = ne[be];
          return Xe[m] = N(Ve), Ue(f, this, Xe);
        };
      }
      function Bc(f, m) {
        return m.length < 2 ? f : na(f, Jr(m, 0, -1));
      }
      function dm(f, m) {
        for (var N = f.length, ne = hr(m.length, N), be = Tr(f); ne--; ) {
          var Te = m[ne];
          f[ne] = Ps(Te, N) ? be[Te] : t;
        }
        return f;
      }
      function uh(f, m) {
        if (!(m === "constructor" && typeof f[m] == "function") && m != "__proto__")
          return f[m];
      }
      var kc = Ic(Qu), Ga = Lg || function(f, m) {
        return Sn.setTimeout(f, m);
      }, ch = Ic(Rp);
      function Ec(f, m, N) {
        var ne = m + "";
        return ch(f, rm(ne, gm(tm(ne), N)));
      }
      function Ic(f) {
        var m = 0, N = 0;
        return function() {
          var ne = Ig(), be = ce - (ne - N);
          if (N = ne, be > 0) {
            if (++m >= $e)
              return arguments[0];
          } else
            m = 0;
          return f.apply(t, arguments);
        };
      }
      function Uo(f, m) {
        var N = -1, ne = f.length, be = ne - 1;
        for (m = m === t ? ne : m; ++N < m; ) {
          var Te = Zl(N, be), Ve = f[Te];
          f[Te] = f[N], f[N] = Ve;
        }
        return f.length = m, f;
      }
      var Pc = hm(function(f) {
        var m = [];
        return f.charCodeAt(0) === 46 && m.push(""), f.replace(ae, function(N, ne, be, Te) {
          m.push(be ? Te.replace(Je, "$1") : ne || N);
        }), m;
      });
      function us(f) {
        if (typeof f == "string" || Hr(f))
          return f;
        var m = f + "";
        return m == "0" && 1 / f == -Yt ? "-0" : m;
      }
      function sa(f) {
        if (f != null) {
          try {
            return jn.call(f);
          } catch {
          }
          try {
            return f + "";
          } catch {
          }
        }
        return "";
      }
      function gm(f, m) {
        return Ze(Lt, function(N) {
          var ne = "_." + N[0];
          m & N[1] && !Ft(f, ne) && f.push(ne);
        }), f.sort();
      }
      function Oc(f) {
        if (f instanceof Zi)
          return f.clone();
        var m = new Xr(f.__wrapped__, f.__chain__);
        return m.__actions__ = Tr(f.__actions__), m.__index__ = f.__index__, m.__values__ = f.__values__, m;
      }
      function pm(f, m, N) {
        (N ? vr(f, m, N) : m === t) ? m = 1 : m = Xn(Oi(m), 0);
        var ne = f == null ? 0 : f.length;
        if (!ne || m < 1)
          return [];
        for (var be = 0, Te = 0, Ve = K(wo(ne / m)); be < ne; )
          Ve[Te++] = Jr(f, be, be += m);
        return Ve;
      }
      function mm(f) {
        for (var m = -1, N = f == null ? 0 : f.length, ne = 0, be = []; ++m < N; ) {
          var Te = f[m];
          Te && (be[ne++] = Te);
        }
        return be;
      }
      function _m() {
        var f = arguments.length;
        if (!f)
          return [];
        for (var m = K(f - 1), N = arguments[0], ne = f; ne--; )
          m[ne - 1] = arguments[ne];
        return di(Ei(N) ? Tr(N) : [N], ir(m, 1));
      }
      var vm = zi(function(f, m) {
        return Fn(f) ? za(f, ir(m, 1, Fn, !0)) : [];
      }), ym = zi(function(f, m) {
        var N = Qr(m);
        return Fn(N) && (N = t), Fn(f) ? za(f, ir(m, 1, Fn, !0), bi(N, 2)) : [];
      }), bm = zi(function(f, m) {
        var N = Qr(m);
        return Fn(N) && (N = t), Fn(f) ? za(f, ir(m, 1, Fn, !0), t, N) : [];
      });
      function xm(f, m, N) {
        var ne = f == null ? 0 : f.length;
        return ne ? (m = N || m === t ? 1 : Oi(m), Jr(f, m < 0 ? 0 : m, ne)) : [];
      }
      function wm(f, m, N) {
        var ne = f == null ? 0 : f.length;
        return ne ? (m = N || m === t ? 1 : Oi(m), m = ne - m, Jr(f, 0, m < 0 ? 0 : m)) : [];
      }
      function Sm(f, m) {
        return f && f.length ? Io(f, bi(m, 3), !0, !0) : [];
      }
      function Mm(f, m) {
        return f && f.length ? Io(f, bi(m, 3), !0) : [];
      }
      function Cm(f, m, N, ne) {
        var be = f == null ? 0 : f.length;
        return be ? (N && typeof N != "number" && vr(f, m, N) && (N = 0, ne = be), _p(f, m, N, ne)) : [];
      }
      function Nc(f, m, N) {
        var ne = f == null ? 0 : f.length;
        if (!ne)
          return -1;
        var be = N == null ? 0 : Oi(N);
        return be < 0 && (be = Xn(ne + be, 0)), Qi(f, bi(m, 3), be);
      }
      function Rc(f, m, N) {
        var ne = f == null ? 0 : f.length;
        if (!ne)
          return -1;
        var be = ne - 1;
        return N !== t && (be = Oi(N), be = N < 0 ? Xn(ne + be, 0) : hr(be, ne - 1)), Qi(f, bi(m, 3), be, !0);
      }
      function Dc(f) {
        var m = f == null ? 0 : f.length;
        return m ? ir(f, 1) : [];
      }
      function Am(f) {
        var m = f == null ? 0 : f.length;
        return m ? ir(f, Yt) : [];
      }
      function Tm(f, m) {
        var N = f == null ? 0 : f.length;
        return N ? (m = m === t ? 1 : Oi(m), ir(f, m)) : [];
      }
      function Lm(f) {
        for (var m = -1, N = f == null ? 0 : f.length, ne = {}; ++m < N; ) {
          var be = f[m];
          xs(ne, be[0], be[1]);
        }
        return ne;
      }
      function zc(f) {
        return f && f.length ? f[0] : t;
      }
      function Bm(f, m, N) {
        var ne = f == null ? 0 : f.length;
        if (!ne)
          return -1;
        var be = N == null ? 0 : Oi(N);
        return be < 0 && (be = Xn(ne + be, 0)), ar(f, m, be);
      }
      function km(f) {
        var m = f == null ? 0 : f.length;
        return m ? Jr(f, 0, -1) : [];
      }
      var Em = zi(function(f) {
        var m = si(f, Jl);
        return m.length && m[0] === f[0] ? Hl(m) : [];
      }), Im = zi(function(f) {
        var m = Qr(f), N = si(f, Jl);
        return m === Qr(N) ? m = t : N.pop(), N.length && N[0] === f[0] ? Hl(N, bi(m, 2)) : [];
      }), Pm = zi(function(f) {
        var m = Qr(f), N = si(f, Jl);
        return m = typeof m == "function" ? m : t, m && N.pop(), N.length && N[0] === f[0] ? Hl(N, t, m) : [];
      });
      function Om(f, m) {
        return f == null ? "" : kg.call(f, m);
      }
      function Qr(f) {
        var m = f == null ? 0 : f.length;
        return m ? f[m - 1] : t;
      }
      function Nm(f, m, N) {
        var ne = f == null ? 0 : f.length;
        if (!ne)
          return -1;
        var be = ne;
        return N !== t && (be = Oi(N), be = be < 0 ? Xn(ne + be, 0) : hr(be, ne - 1)), m === m ? Ls(f, m, be) : Qi(f, pn, be, !0);
      }
      function Rm(f, m) {
        return f && f.length ? $u(f, Oi(m)) : t;
      }
      var Dm = zi(Fc);
      function Fc(f, m) {
        return f && f.length && m && m.length ? Wl(f, m) : f;
      }
      function zm(f, m, N) {
        return f && f.length && m && m.length ? Wl(f, m, bi(N, 2)) : f;
      }
      function Fm(f, m, N) {
        return f && f.length && m && m.length ? Wl(f, m, t, N) : f;
      }
      var Um = Is(function(f, m) {
        var N = f == null ? 0 : f.length, ne = zl(f, m);
        return Ju(f, si(m, function(be) {
          return Ps(be, N) ? +be : be;
        }).sort(lc)), ne;
      });
      function Vm(f, m) {
        var N = [];
        if (!(f && f.length))
          return N;
        var ne = -1, be = [], Te = f.length;
        for (m = bi(m, 3); ++ne < Te; ) {
          var Ve = f[ne];
          m(Ve, ne, f) && (N.push(Ve), be.push(ne));
        }
        return Ju(f, be), N;
      }
      function fh(f) {
        return f == null ? f : Og.call(f);
      }
      function Hm(f, m, N) {
        var ne = f == null ? 0 : f.length;
        return ne ? (N && typeof N != "number" && vr(f, m, N) ? (m = 0, N = ne) : (m = m == null ? 0 : Oi(m), N = N === t ? ne : Oi(N)), Jr(f, m, N)) : [];
      }
      function Ym(f, m) {
        return Eo(f, m);
      }
      function Gm(f, m, N) {
        return $l(f, m, bi(N, 2));
      }
      function jm(f, m) {
        var N = f == null ? 0 : f.length;
        if (N) {
          var ne = Eo(f, m);
          if (ne < N && cs(f[ne], m))
            return ne;
        }
        return -1;
      }
      function Wm(f, m) {
        return Eo(f, m, !0);
      }
      function Zm(f, m, N) {
        return $l(f, m, bi(N, 2), !0);
      }
      function qm(f, m) {
        var N = f == null ? 0 : f.length;
        if (N) {
          var ne = Eo(f, m, !0) - 1;
          if (cs(f[ne], m))
            return ne;
        }
        return -1;
      }
      function $m(f) {
        return f && f.length ? ec(f) : [];
      }
      function Xm(f, m) {
        return f && f.length ? ec(f, bi(m, 2)) : [];
      }
      function Km(f) {
        var m = f == null ? 0 : f.length;
        return m ? Jr(f, 1, m) : [];
      }
      function Jm(f, m, N) {
        return f && f.length ? (m = N || m === t ? 1 : Oi(m), Jr(f, 0, m < 0 ? 0 : m)) : [];
      }
      function Qm(f, m, N) {
        var ne = f == null ? 0 : f.length;
        return ne ? (m = N || m === t ? 1 : Oi(m), m = ne - m, Jr(f, m < 0 ? 0 : m, ne)) : [];
      }
      function e_(f, m) {
        return f && f.length ? Io(f, bi(m, 3), !1, !0) : [];
      }
      function t_(f, m) {
        return f && f.length ? Io(f, bi(m, 3)) : [];
      }
      var i_ = zi(function(f) {
        return Vs(ir(f, 1, Fn, !0));
      }), n_ = zi(function(f) {
        var m = Qr(f);
        return Fn(m) && (m = t), Vs(ir(f, 1, Fn, !0), bi(m, 2));
      }), r_ = zi(function(f) {
        var m = Qr(f);
        return m = typeof m == "function" ? m : t, Vs(ir(f, 1, Fn, !0), t, m);
      });
      function s_(f) {
        return f && f.length ? Vs(f) : [];
      }
      function a_(f, m) {
        return f && f.length ? Vs(f, bi(m, 2)) : [];
      }
      function o_(f, m) {
        return m = typeof m == "function" ? m : t, f && f.length ? Vs(f, t, m) : [];
      }
      function dh(f) {
        if (!(f && f.length))
          return [];
        var m = 0;
        return f = lt(f, function(N) {
          if (Fn(N))
            return m = Xn(N.length, m), !0;
        }), Si(m, function(N) {
          return si(f, Yn(N));
        });
      }
      function Uc(f, m) {
        if (!(f && f.length))
          return [];
        var N = dh(f);
        return m == null ? N : si(N, function(ne) {
          return Ue(m, t, ne);
        });
      }
      var l_ = zi(function(f, m) {
        return Fn(f) ? za(f, m) : [];
      }), h_ = zi(function(f) {
        return Kl(lt(f, Fn));
      }), u_ = zi(function(f) {
        var m = Qr(f);
        return Fn(m) && (m = t), Kl(lt(f, Fn), bi(m, 2));
      }), c_ = zi(function(f) {
        var m = Qr(f);
        return m = typeof m == "function" ? m : t, Kl(lt(f, Fn), t, m);
      }), f_ = zi(dh);
      function d_(f, m) {
        return rc(f || [], m || [], Da);
      }
      function g_(f, m) {
        return rc(f || [], m || [], Va);
      }
      var p_ = zi(function(f) {
        var m = f.length, N = m > 1 ? f[m - 1] : t;
        return N = typeof N == "function" ? (f.pop(), N) : t, Uc(f, N);
      });
      function Vc(f) {
        var m = Ce(f);
        return m.__chain__ = !0, m;
      }
      function m_(f, m) {
        return m(f), f;
      }
      function Vo(f, m) {
        return m(f);
      }
      var __ = Is(function(f) {
        var m = f.length, N = m ? f[0] : 0, ne = this.__wrapped__, be = function(Te) {
          return zl(Te, f);
        };
        return m > 1 || this.__actions__.length || !(ne instanceof Zi) || !Ps(N) ? this.thru(be) : (ne = ne.slice(N, +N + (m ? 1 : 0)), ne.__actions__.push({
          func: Vo,
          args: [be],
          thisArg: t
        }), new Xr(ne, this.__chain__).thru(function(Te) {
          return m && !Te.length && Te.push(t), Te;
        }));
      });
      function v_() {
        return Vc(this);
      }
      function y_() {
        return new Xr(this.value(), this.__chain__);
      }
      function b_() {
        this.__values__ === t && (this.__values__ = tf(this.value()));
        var f = this.__index__ >= this.__values__.length, m = f ? t : this.__values__[this.__index__++];
        return { done: f, value: m };
      }
      function x_() {
        return this;
      }
      function w_(f) {
        for (var m, N = this; N instanceof Ao; ) {
          var ne = Oc(N);
          ne.__index__ = 0, ne.__values__ = t, m ? be.__wrapped__ = ne : m = ne;
          var be = ne;
          N = N.__wrapped__;
        }
        return be.__wrapped__ = f, m;
      }
      function S_() {
        var f = this.__wrapped__;
        if (f instanceof Zi) {
          var m = f;
          return this.__actions__.length && (m = new Zi(this)), m = m.reverse(), m.__actions__.push({
            func: Vo,
            args: [fh],
            thisArg: t
          }), new Xr(m, this.__chain__);
        }
        return this.thru(fh);
      }
      function M_() {
        return nc(this.__wrapped__, this.__actions__);
      }
      var C_ = Po(function(f, m, N) {
        on.call(f, N) ? ++f[N] : xs(f, N, 1);
      });
      function A_(f, m, N) {
        var ne = Ei(f) ? Bt : mp;
        return N && vr(f, m, N) && (m = t), ne(f, bi(m, 3));
      }
      function T_(f, m) {
        var N = Ei(f) ? lt : Uu;
        return N(f, bi(m, 3));
      }
      var L_ = gc(Nc), B_ = gc(Rc);
      function k_(f, m) {
        return ir(Ho(f, m), 1);
      }
      function E_(f, m) {
        return ir(Ho(f, m), Yt);
      }
      function I_(f, m, N) {
        return N = N === t ? 1 : Oi(N), ir(Ho(f, m), N);
      }
      function Hc(f, m) {
        var N = Ei(f) ? Ze : Us;
        return N(f, bi(m, 3));
      }
      function Yc(f, m) {
        var N = Ei(f) ? At : Fu;
        return N(f, bi(m, 3));
      }
      var P_ = Po(function(f, m, N) {
        on.call(f, N) ? f[N].push(m) : xs(f, N, [m]);
      });
      function O_(f, m, N, ne) {
        f = Lr(f) ? f : xa(f), N = N && !ne ? Oi(N) : 0;
        var be = f.length;
        return N < 0 && (N = Xn(be + N, 0)), Zo(f) ? N <= be && f.indexOf(m, N) > -1 : !!be && ar(f, m, N) > -1;
      }
      var N_ = zi(function(f, m, N) {
        var ne = -1, be = typeof m == "function", Te = Lr(f) ? K(f.length) : [];
        return Us(f, function(Ve) {
          Te[++ne] = be ? Ue(m, Ve, N) : Fa(Ve, m, N);
        }), Te;
      }), R_ = Po(function(f, m, N) {
        xs(f, N, m);
      });
      function Ho(f, m) {
        var N = Ei(f) ? si : Wu;
        return N(f, bi(m, 3));
      }
      function D_(f, m, N, ne) {
        return f == null ? [] : (Ei(m) || (m = m == null ? [] : [m]), N = ne ? t : N, Ei(N) || (N = N == null ? [] : [N]), Xu(f, m, N));
      }
      var z_ = Po(function(f, m, N) {
        f[N ? 0 : 1].push(m);
      }, function() {
        return [[], []];
      });
      function F_(f, m, N) {
        var ne = Ei(f) ? xn : qn, be = arguments.length < 3;
        return ne(f, bi(m, 4), N, be, Us);
      }
      function U_(f, m, N) {
        var ne = Ei(f) ? wn : qn, be = arguments.length < 3;
        return ne(f, bi(m, 4), N, be, Fu);
      }
      function V_(f, m) {
        var N = Ei(f) ? lt : Uu;
        return N(f, jo(bi(m, 3)));
      }
      function H_(f) {
        var m = Ei(f) ? Nu : Op;
        return m(f);
      }
      function Y_(f, m, N) {
        (N ? vr(f, m, N) : m === t) ? m = 1 : m = Oi(m);
        var ne = Ei(f) ? cp : Np;
        return ne(f, m);
      }
      function G_(f) {
        var m = Ei(f) ? fp : Dp;
        return m(f);
      }
      function j_(f) {
        if (f == null)
          return 0;
        if (Lr(f))
          return Zo(f) ? Jn(f) : f.length;
        var m = ur(f);
        return m == Ct || m == Qe ? f.size : Gl(f).length;
      }
      function W_(f, m, N) {
        var ne = Ei(f) ? an : zp;
        return N && vr(f, m, N) && (m = t), ne(f, bi(m, 3));
      }
      var Z_ = zi(function(f, m) {
        if (f == null)
          return [];
        var N = m.length;
        return N > 1 && vr(f, m[0], m[1]) ? m = [] : N > 2 && vr(m[0], m[1], m[2]) && (m = [m[0]]), Xu(f, ir(m, 1), []);
      }), Yo = Tg || function() {
        return Sn.Date.now();
      };
      function q_(f, m) {
        if (typeof m != "function")
          throw new yi(h);
        return f = Oi(f), function() {
          if (--f < 1)
            return m.apply(this, arguments);
        };
      }
      function Gc(f, m, N) {
        return m = N ? t : m, m = f && m == null ? f.length : m, Es(f, je, t, t, t, t, m);
      }
      function jc(f, m) {
        var N;
        if (typeof m != "function")
          throw new yi(h);
        return f = Oi(f), function() {
          return --f > 0 && (N = m.apply(this, arguments)), f <= 1 && (m = t), N;
        };
      }
      var gh = zi(function(f, m, N) {
        var ne = D;
        if (N.length) {
          var be = $n(N, ya(gh));
          ne |= X;
        }
        return Es(f, ne, m, N, be);
      }), Wc = zi(function(f, m, N) {
        var ne = D | te;
        if (N.length) {
          var be = $n(N, ya(Wc));
          ne |= X;
        }
        return Es(m, ne, f, N, be);
      });
      function Zc(f, m, N) {
        m = N ? t : m;
        var ne = Es(f, le, t, t, t, t, t, m);
        return ne.placeholder = Zc.placeholder, ne;
      }
      function qc(f, m, N) {
        m = N ? t : m;
        var ne = Es(f, fe, t, t, t, t, t, m);
        return ne.placeholder = qc.placeholder, ne;
      }
      function $c(f, m, N) {
        var ne, be, Te, Ve, Xe, at, Pt = 0, Ot = !1, Ut = !1, ti = !0;
        if (typeof f != "function")
          throw new yi(h);
        m = es(m) || 0, kn(N) && (Ot = !!N.leading, Ut = "maxWait" in N, Te = Ut ? Xn(es(N.maxWait) || 0, m) : Te, ti = "trailing" in N ? !!N.trailing : ti);
        function ai(Un) {
          var fs = ne, Rs = be;
          return ne = be = t, Pt = Un, Ve = f.apply(Rs, fs), Ve;
        }
        function wi(Un) {
          return Pt = Un, Xe = Ga(Gi, m), Ot ? ai(Un) : Ve;
        }
        function Ri(Un) {
          var fs = Un - at, Rs = Un - Pt, mf = m - fs;
          return Ut ? hr(mf, Te - Rs) : mf;
        }
        function pi(Un) {
          var fs = Un - at, Rs = Un - Pt;
          return at === t || fs >= m || fs < 0 || Ut && Rs >= Te;
        }
        function Gi() {
          var Un = Yo();
          if (pi(Un))
            return qi(Un);
          Xe = Ga(Gi, Ri(Un));
        }
        function qi(Un) {
          return Xe = t, ti && ne ? ai(Un) : (ne = be = t, Ve);
        }
        function Yr() {
          Xe !== t && sc(Xe), Pt = 0, ne = at = be = Xe = t;
        }
        function yr() {
          return Xe === t ? Ve : qi(Yo());
        }
        function Gr() {
          var Un = Yo(), fs = pi(Un);
          if (ne = arguments, be = this, at = Un, fs) {
            if (Xe === t)
              return wi(at);
            if (Ut)
              return sc(Xe), Xe = Ga(Gi, m), ai(at);
          }
          return Xe === t && (Xe = Ga(Gi, m)), Ve;
        }
        return Gr.cancel = Yr, Gr.flush = yr, Gr;
      }
      var $_ = zi(function(f, m) {
        return zu(f, 1, m);
      }), X_ = zi(function(f, m, N) {
        return zu(f, es(m) || 0, N);
      });
      function K_(f) {
        return Es(f, Ye);
      }
      function Go(f, m) {
        if (typeof f != "function" || m != null && typeof m != "function")
          throw new yi(h);
        var N = function() {
          var ne = arguments, be = m ? m.apply(this, ne) : ne[0], Te = N.cache;
          if (Te.has(be))
            return Te.get(be);
          var Ve = f.apply(this, ne);
          return N.cache = Te.set(be, Ve) || Te, Ve;
        };
        return N.cache = new (Go.Cache || ks)(), N;
      }
      Go.Cache = ks;
      function jo(f) {
        if (typeof f != "function")
          throw new yi(h);
        return function() {
          var m = arguments;
          switch (m.length) {
            case 0:
              return !f.call(this);
            case 1:
              return !f.call(this, m[0]);
            case 2:
              return !f.call(this, m[0], m[1]);
            case 3:
              return !f.call(this, m[0], m[1], m[2]);
          }
          return !f.apply(this, m);
        };
      }
      function J_(f) {
        return jc(2, f);
      }
      var Q_ = Fp(function(f, m) {
        m = m.length == 1 && Ei(m[0]) ? si(m[0], Ln(bi())) : si(ir(m, 1), Ln(bi()));
        var N = m.length;
        return zi(function(ne) {
          for (var be = -1, Te = hr(ne.length, N); ++be < Te; )
            ne[be] = m[be].call(this, ne[be]);
          return Ue(f, this, ne);
        });
      }), ph = zi(function(f, m) {
        var N = $n(m, ya(ph));
        return Es(f, X, t, m, N);
      }), Xc = zi(function(f, m) {
        var N = $n(m, ya(Xc));
        return Es(f, W, t, m, N);
      }), e0 = Is(function(f, m) {
        return Es(f, ke, t, t, t, m);
      });
      function t0(f, m) {
        if (typeof f != "function")
          throw new yi(h);
        return m = m === t ? m : Oi(m), zi(f, m);
      }
      function i0(f, m) {
        if (typeof f != "function")
          throw new yi(h);
        return m = m == null ? 0 : Xn(Oi(m), 0), zi(function(N) {
          var ne = N[m], be = Ys(N, 0, m);
          return ne && di(be, ne), Ue(f, this, be);
        });
      }
      function n0(f, m, N) {
        var ne = !0, be = !0;
        if (typeof f != "function")
          throw new yi(h);
        return kn(N) && (ne = "leading" in N ? !!N.leading : ne, be = "trailing" in N ? !!N.trailing : be), $c(f, m, {
          leading: ne,
          maxWait: m,
          trailing: be
        });
      }
      function r0(f) {
        return Gc(f, 1);
      }
      function s0(f, m) {
        return ph(Ql(m), f);
      }
      function a0() {
        if (!arguments.length)
          return [];
        var f = arguments[0];
        return Ei(f) ? f : [f];
      }
      function o0(f) {
        return Kr(f, Z);
      }
      function l0(f, m) {
        return m = typeof m == "function" ? m : t, Kr(f, Z, m);
      }
      function h0(f) {
        return Kr(f, U | Z);
      }
      function u0(f, m) {
        return m = typeof m == "function" ? m : t, Kr(f, U | Z, m);
      }
      function c0(f, m) {
        return m == null || Du(f, m, Qn(m));
      }
      function cs(f, m) {
        return f === m || f !== f && m !== m;
      }
      var f0 = Do(Vl), d0 = Do(function(f, m) {
        return f >= m;
      }), aa = Yu(function() {
        return arguments;
      }()) ? Yu : function(f) {
        return Rn(f) && on.call(f, "callee") && !Bu.call(f, "callee");
      }, Ei = K.isArray, g0 = O ? Ln(O) : wp;
      function Lr(f) {
        return f != null && Wo(f.length) && !Os(f);
      }
      function Fn(f) {
        return Rn(f) && Lr(f);
      }
      function p0(f) {
        return f === !0 || f === !1 || Rn(f) && _r(f) == Wt;
      }
      var Gs = Bg || Th, m0 = J ? Ln(J) : Sp;
      function _0(f) {
        return Rn(f) && f.nodeType === 1 && !ja(f);
      }
      function v0(f) {
        if (f == null)
          return !0;
        if (Lr(f) && (Ei(f) || typeof f == "string" || typeof f.splice == "function" || Gs(f) || ba(f) || aa(f)))
          return !f.length;
        var m = ur(f);
        if (m == Ct || m == Qe)
          return !f.size;
        if (Ya(f))
          return !Gl(f).length;
        for (var N in f)
          if (on.call(f, N))
            return !1;
        return !0;
      }
      function y0(f, m) {
        return Ua(f, m);
      }
      function b0(f, m, N) {
        N = typeof N == "function" ? N : t;
        var ne = N ? N(f, m) : t;
        return ne === t ? Ua(f, m, t, N) : !!ne;
      }
      function mh(f) {
        if (!Rn(f))
          return !1;
        var m = _r(f);
        return m == tn || m == ei || typeof f.message == "string" && typeof f.name == "string" && !ja(f);
      }
      function x0(f) {
        return typeof f == "number" && Eu(f);
      }
      function Os(f) {
        if (!kn(f))
          return !1;
        var m = _r(f);
        return m == Fi || m == _e || m == _i || m == kt;
      }
      function Kc(f) {
        return typeof f == "number" && f == Oi(f);
      }
      function Wo(f) {
        return typeof f == "number" && f > -1 && f % 1 == 0 && f <= We;
      }
      function kn(f) {
        var m = typeof f;
        return f != null && (m == "object" || m == "function");
      }
      function Rn(f) {
        return f != null && typeof f == "object";
      }
      var Jc = re ? Ln(re) : Cp;
      function w0(f, m) {
        return f === m || Yl(f, m, ah(m));
      }
      function S0(f, m, N) {
        return N = typeof N == "function" ? N : t, Yl(f, m, ah(m), N);
      }
      function M0(f) {
        return Qc(f) && f != +f;
      }
      function C0(f) {
        if (lm(f))
          throw new Me(o);
        return Gu(f);
      }
      function A0(f) {
        return f === null;
      }
      function T0(f) {
        return f == null;
      }
      function Qc(f) {
        return typeof f == "number" || Rn(f) && _r(f) == yt;
      }
      function ja(f) {
        if (!Rn(f) || _r(f) != Ee)
          return !1;
        var m = yo(f);
        if (m === null)
          return !0;
        var N = on.call(m, "constructor") && m.constructor;
        return typeof N == "function" && N instanceof N && jn.call(N) == Sg;
      }
      var _h = ge ? Ln(ge) : Ap;
      function L0(f) {
        return Kc(f) && f >= -We && f <= We;
      }
      var ef = me ? Ln(me) : Tp;
      function Zo(f) {
        return typeof f == "string" || !Ei(f) && Rn(f) && _r(f) == bt;
      }
      function Hr(f) {
        return typeof f == "symbol" || Rn(f) && _r(f) == Gt;
      }
      var ba = xe ? Ln(xe) : Lp;
      function B0(f) {
        return f === t;
      }
      function k0(f) {
        return Rn(f) && ur(f) == i;
      }
      function E0(f) {
        return Rn(f) && _r(f) == r;
      }
      var I0 = Do(jl), P0 = Do(function(f, m) {
        return f <= m;
      });
      function tf(f) {
        if (!f)
          return [];
        if (Lr(f))
          return Zo(f) ? zn(f) : Tr(f);
        if (Ia && f[Ia])
          return or(f[Ia]());
        var m = ur(f), N = m == Ct ? tr : m == Qe ? Pi : xa;
        return N(f);
      }
      function Ns(f) {
        if (!f)
          return f === 0 ? f : 0;
        if (f = es(f), f === Yt || f === -Yt) {
          var m = f < 0 ? -1 : 1;
          return m * It;
        }
        return f === f ? f : 0;
      }
      function Oi(f) {
        var m = Ns(f), N = m % 1;
        return m === m ? N ? m - N : m : 0;
      }
      function nf(f) {
        return f ? ia(Oi(f), 0, tt) : 0;
      }
      function es(f) {
        if (typeof f == "number")
          return f;
        if (Hr(f))
          return rt;
        if (kn(f)) {
          var m = typeof f.valueOf == "function" ? f.valueOf() : f;
          f = kn(m) ? m + "" : m;
        }
        if (typeof f != "string")
          return f === 0 ? f : +f;
        f = Jt(f);
        var N = Fe.test(f);
        return N || _t.test(f) ? sr(f.slice(2), N ? 2 : 8) : Ne.test(f) ? rt : +f;
      }
      function rf(f) {
        return Ss(f, Br(f));
      }
      function O0(f) {
        return f ? ia(Oi(f), -We, We) : f === 0 ? f : 0;
      }
      function ln(f) {
        return f == null ? "" : Vr(f);
      }
      var N0 = _a(function(f, m) {
        if (Ya(m) || Lr(m)) {
          Ss(m, Qn(m), f);
          return;
        }
        for (var N in m)
          on.call(m, N) && Da(f, N, m[N]);
      }), sf = _a(function(f, m) {
        Ss(m, Br(m), f);
      }), af = _a(function(f, m, N, ne) {
        Ss(m, Br(m), f, ne);
      }), vh = _a(function(f, m, N, ne) {
        Ss(m, Qn(m), f, ne);
      }), R0 = Is(zl);
      function D0(f, m) {
        var N = ma(f);
        return m == null ? N : Ru(N, m);
      }
      var z0 = zi(function(f, m) {
        f = ut(f);
        var N = -1, ne = m.length, be = ne > 2 ? m[2] : t;
        for (be && vr(m[0], m[1], be) && (ne = 1); ++N < ne; )
          for (var Te = m[N], Ve = Br(Te), Xe = -1, at = Ve.length; ++Xe < at; ) {
            var Pt = Ve[Xe], Ot = f[Pt];
            (Ot === t || cs(Ot, mn[Pt]) && !on.call(f, Pt)) && (f[Pt] = Te[Pt]);
          }
        return f;
      }), F0 = zi(function(f) {
        return f.push(t, xc), Ue(of, t, f);
      });
      function U0(f, m) {
        return Ni(f, bi(m, 3), ws);
      }
      function V0(f, m) {
        return Ni(f, bi(m, 3), Ul);
      }
      function H0(f, m) {
        return f == null ? f : Fl(f, bi(m, 3), Br);
      }
      function Y0(f, m) {
        return f == null ? f : Vu(f, bi(m, 3), Br);
      }
      function G0(f, m) {
        return f && ws(f, bi(m, 3));
      }
      function j0(f, m) {
        return f && Ul(f, bi(m, 3));
      }
      function W0(f) {
        return f == null ? [] : Bo(f, Qn(f));
      }
      function Z0(f) {
        return f == null ? [] : Bo(f, Br(f));
      }
      function yh(f, m, N) {
        var ne = f == null ? t : na(f, m);
        return ne === t ? N : ne;
      }
      function q0(f, m) {
        return f != null && Mc(f, m, vp);
      }
      function bh(f, m) {
        return f != null && Mc(f, m, yp);
      }
      var $0 = mc(function(f, m, N) {
        m != null && typeof m.toString != "function" && (m = mo.call(m)), f[m] = N;
      }, wh(kr)), X0 = mc(function(f, m, N) {
        m != null && typeof m.toString != "function" && (m = mo.call(m)), on.call(f, m) ? f[m].push(N) : f[m] = [N];
      }, bi), K0 = zi(Fa);
      function Qn(f) {
        return Lr(f) ? Ou(f) : Gl(f);
      }
      function Br(f) {
        return Lr(f) ? Ou(f, !0) : Bp(f);
      }
      function J0(f, m) {
        var N = {};
        return m = bi(m, 3), ws(f, function(ne, be, Te) {
          xs(N, m(ne, be, Te), ne);
        }), N;
      }
      function Q0(f, m) {
        var N = {};
        return m = bi(m, 3), ws(f, function(ne, be, Te) {
          xs(N, be, m(ne, be, Te));
        }), N;
      }
      var ev = _a(function(f, m, N) {
        ko(f, m, N);
      }), of = _a(function(f, m, N, ne) {
        ko(f, m, N, ne);
      }), tv = Is(function(f, m) {
        var N = {};
        if (f == null)
          return N;
        var ne = !1;
        m = si(m, function(Te) {
          return Te = Hs(Te, f), ne || (ne = Te.length > 1), Te;
        }), Ss(f, rh(f), N), ne && (N = Kr(N, U | M | Z, Xp));
        for (var be = m.length; be--; )
          Xl(N, m[be]);
        return N;
      });
      function iv(f, m) {
        return lf(f, jo(bi(m)));
      }
      var nv = Is(function(f, m) {
        return f == null ? {} : Ep(f, m);
      });
      function lf(f, m) {
        if (f == null)
          return {};
        var N = si(rh(f), function(ne) {
          return [ne];
        });
        return m = bi(m), Ku(f, N, function(ne, be) {
          return m(ne, be[0]);
        });
      }
      function rv(f, m, N) {
        m = Hs(m, f);
        var ne = -1, be = m.length;
        for (be || (be = 1, f = t); ++ne < be; ) {
          var Te = f == null ? t : f[us(m[ne])];
          Te === t && (ne = be, Te = N), f = Os(Te) ? Te.call(f) : Te;
        }
        return f;
      }
      function sv(f, m, N) {
        return f == null ? f : Va(f, m, N);
      }
      function av(f, m, N, ne) {
        return ne = typeof ne == "function" ? ne : t, f == null ? f : Va(f, m, N, ne);
      }
      var hf = yc(Qn), uf = yc(Br);
      function ov(f, m, N) {
        var ne = Ei(f), be = ne || Gs(f) || ba(f);
        if (m = bi(m, 4), N == null) {
          var Te = f && f.constructor;
          be ? N = ne ? new Te() : [] : kn(f) ? N = Os(Te) ? ma(yo(f)) : {} : N = {};
        }
        return (be ? Ze : ws)(f, function(Ve, Xe, at) {
          return m(N, Ve, Xe, at);
        }), N;
      }
      function lv(f, m) {
        return f == null ? !0 : Xl(f, m);
      }
      function hv(f, m, N) {
        return f == null ? f : ic(f, m, Ql(N));
      }
      function uv(f, m, N, ne) {
        return ne = typeof ne == "function" ? ne : t, f == null ? f : ic(f, m, Ql(N), ne);
      }
      function xa(f) {
        return f == null ? [] : gi(f, Qn(f));
      }
      function cv(f) {
        return f == null ? [] : gi(f, Br(f));
      }
      function fv(f, m, N) {
        return N === t && (N = m, m = t), N !== t && (N = es(N), N = N === N ? N : 0), m !== t && (m = es(m), m = m === m ? m : 0), ia(es(f), m, N);
      }
      function dv(f, m, N) {
        return m = Ns(m), N === t ? (N = m, m = 0) : N = Ns(N), f = es(f), bp(f, m, N);
      }
      function gv(f, m, N) {
        if (N && typeof N != "boolean" && vr(f, m, N) && (m = N = t), N === t && (typeof m == "boolean" ? (N = m, m = t) : typeof f == "boolean" && (N = f, f = t)), f === t && m === t ? (f = 0, m = 1) : (f = Ns(f), m === t ? (m = f, f = 0) : m = Ns(m)), f > m) {
          var ne = f;
          f = m, m = ne;
        }
        if (N || f % 1 || m % 1) {
          var be = Iu();
          return hr(f + be * (m - f + Mr("1e-" + ((be + "").length - 1))), m);
        }
        return Zl(f, m);
      }
      var pv = va(function(f, m, N) {
        return m = m.toLowerCase(), f + (N ? cf(m) : m);
      });
      function cf(f) {
        return xh(ln(f).toLowerCase());
      }
      function ff(f) {
        return f = ln(f), f && f.replace(Rt, zr).replace(ye, "");
      }
      function mv(f, m, N) {
        f = ln(f), m = Vr(m);
        var ne = f.length;
        N = N === t ? ne : ia(Oi(N), 0, ne);
        var be = N;
        return N -= m.length, N >= 0 && f.slice(N, be) == m;
      }
      function _v(f) {
        return f = ln(f), f && C.test(f) ? f.replace(k, Js) : f;
      }
      function vv(f) {
        return f = ln(f), f && pe.test(f) ? f.replace(he, "\\$&") : f;
      }
      var yv = va(function(f, m, N) {
        return f + (N ? "-" : "") + m.toLowerCase();
      }), bv = va(function(f, m, N) {
        return f + (N ? " " : "") + m.toLowerCase();
      }), xv = dc("toLowerCase");
      function wv(f, m, N) {
        f = ln(f), m = Oi(m);
        var ne = m ? Jn(f) : 0;
        if (!m || ne >= m)
          return f;
        var be = (m - ne) / 2;
        return Ro(So(be), N) + f + Ro(wo(be), N);
      }
      function Sv(f, m, N) {
        f = ln(f), m = Oi(m);
        var ne = m ? Jn(f) : 0;
        return m && ne < m ? f + Ro(m - ne, N) : f;
      }
      function Mv(f, m, N) {
        f = ln(f), m = Oi(m);
        var ne = m ? Jn(f) : 0;
        return m && ne < m ? Ro(m - ne, N) + f : f;
      }
      function Cv(f, m, N) {
        return N || m == null ? m = 0 : m && (m = +m), Pg(ln(f).replace(se, ""), m || 0);
      }
      function Av(f, m, N) {
        return (N ? vr(f, m, N) : m === t) ? m = 1 : m = Oi(m), ql(ln(f), m);
      }
      function Tv() {
        var f = arguments, m = ln(f[0]);
        return f.length < 3 ? m : m.replace(f[1], f[2]);
      }
      var Lv = va(function(f, m, N) {
        return f + (N ? "_" : "") + m.toLowerCase();
      });
      function Bv(f, m, N) {
        return N && typeof N != "number" && vr(f, m, N) && (m = N = t), N = N === t ? tt : N >>> 0, N ? (f = ln(f), f && (typeof m == "string" || m != null && !_h(m)) && (m = Vr(m), !m && Ki(f)) ? Ys(zn(f), 0, N) : f.split(m, N)) : [];
      }
      var kv = va(function(f, m, N) {
        return f + (N ? " " : "") + xh(m);
      });
      function Ev(f, m, N) {
        return f = ln(f), N = N == null ? 0 : ia(Oi(N), 0, f.length), m = Vr(m), f.slice(N, N + m.length) == m;
      }
      function Iv(f, m, N) {
        var ne = Ce.templateSettings;
        N && vr(f, m, N) && (m = t), f = ln(f), m = vh({}, m, ne, bc);
        var be = vh({}, m.imports, ne.imports, bc), Te = Qn(be), Ve = gi(be, Te);
        Ze(Te, function(pi) {
          if (Ge.test(pi))
            throw new Me(_);
        });
        var Xe, at, Pt = 0, Ot = m.interpolate || Et, Ut = "__p += '", ti = St(
          (m.escape || Et).source + "|" + Ot.source + "|" + (Ot === q ? it : Et).source + "|" + (m.evaluate || Et).source + "|$",
          "g"
        ), ai = "//# sourceURL=" + (on.call(m, "sourceURL") ? (m.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++hi + "]") + `
`;
        f.replace(ti, function(pi, Gi, qi, Yr, yr, Gr) {
          return qi || (qi = Yr), Ut += f.slice(Pt, Gr).replace(Ht, $r), Gi && (Xe = !0, Ut += `' +
__e(` + Gi + `) +
'`), yr && (at = !0, Ut += `';
` + yr + `;
__p += '`), qi && (Ut += `' +
((__t = (` + qi + `)) == null ? '' : __t) +
'`), Pt = Gr + pi.length, pi;
        }), Ut += `';
`;
        var wi = on.call(m, "variable") && m.variable;
        if (!wi)
          Ut = `with (obj) {
` + Ut + `
}
`;
        else if (Ge.test(wi))
          throw new Me(c);
        Ut = (at ? Ut.replace(T, "") : Ut).replace(G, "$1").replace(R, "$1;"), Ut = "function(" + (wi || "obj") + `) {
` + (wi ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (Xe ? ", __e = _.escape" : "") + (at ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + Ut + `return __p
}`;
        var Ri = gf(function() {
          return Be(Te, ai + "return " + Ut).apply(t, Ve);
        });
        if (Ri.source = Ut, mh(Ri))
          throw Ri;
        return Ri;
      }
      function Pv(f) {
        return ln(f).toLowerCase();
      }
      function Ov(f) {
        return ln(f).toUpperCase();
      }
      function Nv(f, m, N) {
        if (f = ln(f), f && (N || m === t))
          return Jt(f);
        if (!f || !(m = Vr(m)))
          return f;
        var ne = zn(f), be = zn(m), Te = Bn(ne, be), Ve = ui(ne, be) + 1;
        return Ys(ne, Te, Ve).join("");
      }
      function Rv(f, m, N) {
        if (f = ln(f), f && (N || m === t))
          return f.slice(0, bs(f) + 1);
        if (!f || !(m = Vr(m)))
          return f;
        var ne = zn(f), be = ui(ne, zn(m)) + 1;
        return Ys(ne, 0, be).join("");
      }
      function Dv(f, m, N) {
        if (f = ln(f), f && (N || m === t))
          return f.replace(se, "");
        if (!f || !(m = Vr(m)))
          return f;
        var ne = zn(f), be = Bn(ne, zn(m));
        return Ys(ne, be).join("");
      }
      function zv(f, m) {
        var N = pt, ne = Le;
        if (kn(m)) {
          var be = "separator" in m ? m.separator : be;
          N = "length" in m ? Oi(m.length) : N, ne = "omission" in m ? Vr(m.omission) : ne;
        }
        f = ln(f);
        var Te = f.length;
        if (Ki(f)) {
          var Ve = zn(f);
          Te = Ve.length;
        }
        if (N >= Te)
          return f;
        var Xe = N - Jn(ne);
        if (Xe < 1)
          return ne;
        var at = Ve ? Ys(Ve, 0, Xe).join("") : f.slice(0, Xe);
        if (be === t)
          return at + ne;
        if (Ve && (Xe += at.length - Xe), _h(be)) {
          if (f.slice(Xe).search(be)) {
            var Pt, Ot = at;
            for (be.global || (be = St(be.source, ln(gt.exec(be)) + "g")), be.lastIndex = 0; Pt = be.exec(Ot); )
              var Ut = Pt.index;
            at = at.slice(0, Ut === t ? Xe : Ut);
          }
        } else if (f.indexOf(Vr(be), Xe) != Xe) {
          var ti = at.lastIndexOf(be);
          ti > -1 && (at = at.slice(0, ti));
        }
        return at + ne;
      }
      function Fv(f) {
        return f = ln(f), f && z.test(f) ? f.replace(Y, lr) : f;
      }
      var Uv = va(function(f, m, N) {
        return f + (N ? " " : "") + m.toUpperCase();
      }), xh = dc("toUpperCase");
      function df(f, m, N) {
        return f = ln(f), m = N ? t : m, m === t ? On(f) ? ct(f) : Dn(f) : f.match(m) || [];
      }
      var gf = zi(function(f, m) {
        try {
          return Ue(f, t, m);
        } catch (N) {
          return mh(N) ? N : new Me(N);
        }
      }), Vv = Is(function(f, m) {
        return Ze(m, function(N) {
          N = us(N), xs(f, N, gh(f[N], f));
        }), f;
      });
      function Hv(f) {
        var m = f == null ? 0 : f.length, N = bi();
        return f = m ? si(f, function(ne) {
          if (typeof ne[1] != "function")
            throw new yi(h);
          return [N(ne[0]), ne[1]];
        }) : [], zi(function(ne) {
          for (var be = -1; ++be < m; ) {
            var Te = f[be];
            if (Ue(Te[0], this, ne))
              return Ue(Te[1], this, ne);
          }
        });
      }
      function Yv(f) {
        return pp(Kr(f, U));
      }
      function wh(f) {
        return function() {
          return f;
        };
      }
      function Gv(f, m) {
        return f == null || f !== f ? m : f;
      }
      var jv = pc(), Wv = pc(!0);
      function kr(f) {
        return f;
      }
      function Sh(f) {
        return ju(typeof f == "function" ? f : Kr(f, U));
      }
      function Zv(f) {
        return Zu(Kr(f, U));
      }
      function qv(f, m) {
        return qu(f, Kr(m, U));
      }
      var $v = zi(function(f, m) {
        return function(N) {
          return Fa(N, f, m);
        };
      }), Xv = zi(function(f, m) {
        return function(N) {
          return Fa(f, N, m);
        };
      });
      function Mh(f, m, N) {
        var ne = Qn(m), be = Bo(m, ne);
        N == null && !(kn(m) && (be.length || !ne.length)) && (N = m, m = f, f = this, be = Bo(m, Qn(m)));
        var Te = !(kn(N) && "chain" in N) || !!N.chain, Ve = Os(f);
        return Ze(be, function(Xe) {
          var at = m[Xe];
          f[Xe] = at, Ve && (f.prototype[Xe] = function() {
            var Pt = this.__chain__;
            if (Te || Pt) {
              var Ot = f(this.__wrapped__), Ut = Ot.__actions__ = Tr(this.__actions__);
              return Ut.push({ func: at, args: arguments, thisArg: f }), Ot.__chain__ = Pt, Ot;
            }
            return at.apply(f, di([this.value()], arguments));
          });
        }), f;
      }
      function Kv() {
        return Sn._ === this && (Sn._ = Mg), this;
      }
      function Ch() {
      }
      function Jv(f) {
        return f = Oi(f), zi(function(m) {
          return $u(m, f);
        });
      }
      var Qv = th(si), ey = th(Bt), ty = th(an);
      function pf(f) {
        return lh(f) ? Yn(us(f)) : Ip(f);
      }
      function iy(f) {
        return function(m) {
          return f == null ? t : na(f, m);
        };
      }
      var ny = _c(), ry = _c(!0);
      function Ah() {
        return [];
      }
      function Th() {
        return !1;
      }
      function sy() {
        return {};
      }
      function ay() {
        return "";
      }
      function oy() {
        return !0;
      }
      function ly(f, m) {
        if (f = Oi(f), f < 1 || f > We)
          return [];
        var N = tt, ne = hr(f, tt);
        m = bi(m), f -= tt;
        for (var be = Si(ne, m); ++N < f; )
          m(N);
        return be;
      }
      function hy(f) {
        return Ei(f) ? si(f, us) : Hr(f) ? [f] : Tr(Pc(ln(f)));
      }
      function uy(f) {
        var m = ++wg;
        return ln(f) + m;
      }
      var cy = No(function(f, m) {
        return f + m;
      }, 0), fy = ih("ceil"), dy = No(function(f, m) {
        return f / m;
      }, 1), gy = ih("floor");
      function py(f) {
        return f && f.length ? Lo(f, kr, Vl) : t;
      }
      function my(f, m) {
        return f && f.length ? Lo(f, bi(m, 2), Vl) : t;
      }
      function _y(f) {
        return Ar(f, kr);
      }
      function vy(f, m) {
        return Ar(f, bi(m, 2));
      }
      function yy(f) {
        return f && f.length ? Lo(f, kr, jl) : t;
      }
      function by(f, m) {
        return f && f.length ? Lo(f, bi(m, 2), jl) : t;
      }
      var xy = No(function(f, m) {
        return f * m;
      }, 1), wy = ih("round"), Sy = No(function(f, m) {
        return f - m;
      }, 0);
      function My(f) {
        return f && f.length ? Dr(f, kr) : 0;
      }
      function Cy(f, m) {
        return f && f.length ? Dr(f, bi(m, 2)) : 0;
      }
      return Ce.after = q_, Ce.ary = Gc, Ce.assign = N0, Ce.assignIn = sf, Ce.assignInWith = af, Ce.assignWith = vh, Ce.at = R0, Ce.before = jc, Ce.bind = gh, Ce.bindAll = Vv, Ce.bindKey = Wc, Ce.castArray = a0, Ce.chain = Vc, Ce.chunk = pm, Ce.compact = mm, Ce.concat = _m, Ce.cond = Hv, Ce.conforms = Yv, Ce.constant = wh, Ce.countBy = C_, Ce.create = D0, Ce.curry = Zc, Ce.curryRight = qc, Ce.debounce = $c, Ce.defaults = z0, Ce.defaultsDeep = F0, Ce.defer = $_, Ce.delay = X_, Ce.difference = vm, Ce.differenceBy = ym, Ce.differenceWith = bm, Ce.drop = xm, Ce.dropRight = wm, Ce.dropRightWhile = Sm, Ce.dropWhile = Mm, Ce.fill = Cm, Ce.filter = T_, Ce.flatMap = k_, Ce.flatMapDeep = E_, Ce.flatMapDepth = I_, Ce.flatten = Dc, Ce.flattenDeep = Am, Ce.flattenDepth = Tm, Ce.flip = K_, Ce.flow = jv, Ce.flowRight = Wv, Ce.fromPairs = Lm, Ce.functions = W0, Ce.functionsIn = Z0, Ce.groupBy = P_, Ce.initial = km, Ce.intersection = Em, Ce.intersectionBy = Im, Ce.intersectionWith = Pm, Ce.invert = $0, Ce.invertBy = X0, Ce.invokeMap = N_, Ce.iteratee = Sh, Ce.keyBy = R_, Ce.keys = Qn, Ce.keysIn = Br, Ce.map = Ho, Ce.mapKeys = J0, Ce.mapValues = Q0, Ce.matches = Zv, Ce.matchesProperty = qv, Ce.memoize = Go, Ce.merge = ev, Ce.mergeWith = of, Ce.method = $v, Ce.methodOf = Xv, Ce.mixin = Mh, Ce.negate = jo, Ce.nthArg = Jv, Ce.omit = tv, Ce.omitBy = iv, Ce.once = J_, Ce.orderBy = D_, Ce.over = Qv, Ce.overArgs = Q_, Ce.overEvery = ey, Ce.overSome = ty, Ce.partial = ph, Ce.partialRight = Xc, Ce.partition = z_, Ce.pick = nv, Ce.pickBy = lf, Ce.property = pf, Ce.propertyOf = iy, Ce.pull = Dm, Ce.pullAll = Fc, Ce.pullAllBy = zm, Ce.pullAllWith = Fm, Ce.pullAt = Um, Ce.range = ny, Ce.rangeRight = ry, Ce.rearg = e0, Ce.reject = V_, Ce.remove = Vm, Ce.rest = t0, Ce.reverse = fh, Ce.sampleSize = Y_, Ce.set = sv, Ce.setWith = av, Ce.shuffle = G_, Ce.slice = Hm, Ce.sortBy = Z_, Ce.sortedUniq = $m, Ce.sortedUniqBy = Xm, Ce.split = Bv, Ce.spread = i0, Ce.tail = Km, Ce.take = Jm, Ce.takeRight = Qm, Ce.takeRightWhile = e_, Ce.takeWhile = t_, Ce.tap = m_, Ce.throttle = n0, Ce.thru = Vo, Ce.toArray = tf, Ce.toPairs = hf, Ce.toPairsIn = uf, Ce.toPath = hy, Ce.toPlainObject = rf, Ce.transform = ov, Ce.unary = r0, Ce.union = i_, Ce.unionBy = n_, Ce.unionWith = r_, Ce.uniq = s_, Ce.uniqBy = a_, Ce.uniqWith = o_, Ce.unset = lv, Ce.unzip = dh, Ce.unzipWith = Uc, Ce.update = hv, Ce.updateWith = uv, Ce.values = xa, Ce.valuesIn = cv, Ce.without = l_, Ce.words = df, Ce.wrap = s0, Ce.xor = h_, Ce.xorBy = u_, Ce.xorWith = c_, Ce.zip = f_, Ce.zipObject = d_, Ce.zipObjectDeep = g_, Ce.zipWith = p_, Ce.entries = hf, Ce.entriesIn = uf, Ce.extend = sf, Ce.extendWith = af, Mh(Ce, Ce), Ce.add = cy, Ce.attempt = gf, Ce.camelCase = pv, Ce.capitalize = cf, Ce.ceil = fy, Ce.clamp = fv, Ce.clone = o0, Ce.cloneDeep = h0, Ce.cloneDeepWith = u0, Ce.cloneWith = l0, Ce.conformsTo = c0, Ce.deburr = ff, Ce.defaultTo = Gv, Ce.divide = dy, Ce.endsWith = mv, Ce.eq = cs, Ce.escape = _v, Ce.escapeRegExp = vv, Ce.every = A_, Ce.find = L_, Ce.findIndex = Nc, Ce.findKey = U0, Ce.findLast = B_, Ce.findLastIndex = Rc, Ce.findLastKey = V0, Ce.floor = gy, Ce.forEach = Hc, Ce.forEachRight = Yc, Ce.forIn = H0, Ce.forInRight = Y0, Ce.forOwn = G0, Ce.forOwnRight = j0, Ce.get = yh, Ce.gt = f0, Ce.gte = d0, Ce.has = q0, Ce.hasIn = bh, Ce.head = zc, Ce.identity = kr, Ce.includes = O_, Ce.indexOf = Bm, Ce.inRange = dv, Ce.invoke = K0, Ce.isArguments = aa, Ce.isArray = Ei, Ce.isArrayBuffer = g0, Ce.isArrayLike = Lr, Ce.isArrayLikeObject = Fn, Ce.isBoolean = p0, Ce.isBuffer = Gs, Ce.isDate = m0, Ce.isElement = _0, Ce.isEmpty = v0, Ce.isEqual = y0, Ce.isEqualWith = b0, Ce.isError = mh, Ce.isFinite = x0, Ce.isFunction = Os, Ce.isInteger = Kc, Ce.isLength = Wo, Ce.isMap = Jc, Ce.isMatch = w0, Ce.isMatchWith = S0, Ce.isNaN = M0, Ce.isNative = C0, Ce.isNil = T0, Ce.isNull = A0, Ce.isNumber = Qc, Ce.isObject = kn, Ce.isObjectLike = Rn, Ce.isPlainObject = ja, Ce.isRegExp = _h, Ce.isSafeInteger = L0, Ce.isSet = ef, Ce.isString = Zo, Ce.isSymbol = Hr, Ce.isTypedArray = ba, Ce.isUndefined = B0, Ce.isWeakMap = k0, Ce.isWeakSet = E0, Ce.join = Om, Ce.kebabCase = yv, Ce.last = Qr, Ce.lastIndexOf = Nm, Ce.lowerCase = bv, Ce.lowerFirst = xv, Ce.lt = I0, Ce.lte = P0, Ce.max = py, Ce.maxBy = my, Ce.mean = _y, Ce.meanBy = vy, Ce.min = yy, Ce.minBy = by, Ce.stubArray = Ah, Ce.stubFalse = Th, Ce.stubObject = sy, Ce.stubString = ay, Ce.stubTrue = oy, Ce.multiply = xy, Ce.nth = Rm, Ce.noConflict = Kv, Ce.noop = Ch, Ce.now = Yo, Ce.pad = wv, Ce.padEnd = Sv, Ce.padStart = Mv, Ce.parseInt = Cv, Ce.random = gv, Ce.reduce = F_, Ce.reduceRight = U_, Ce.repeat = Av, Ce.replace = Tv, Ce.result = rv, Ce.round = wy, Ce.runInContext = Oe, Ce.sample = H_, Ce.size = j_, Ce.snakeCase = Lv, Ce.some = W_, Ce.sortedIndex = Ym, Ce.sortedIndexBy = Gm, Ce.sortedIndexOf = jm, Ce.sortedLastIndex = Wm, Ce.sortedLastIndexBy = Zm, Ce.sortedLastIndexOf = qm, Ce.startCase = kv, Ce.startsWith = Ev, Ce.subtract = Sy, Ce.sum = My, Ce.sumBy = Cy, Ce.template = Iv, Ce.times = ly, Ce.toFinite = Ns, Ce.toInteger = Oi, Ce.toLength = nf, Ce.toLower = Pv, Ce.toNumber = es, Ce.toSafeInteger = O0, Ce.toString = ln, Ce.toUpper = Ov, Ce.trim = Nv, Ce.trimEnd = Rv, Ce.trimStart = Dv, Ce.truncate = zv, Ce.unescape = Fv, Ce.uniqueId = uy, Ce.upperCase = Uv, Ce.upperFirst = xh, Ce.each = Hc, Ce.eachRight = Yc, Ce.first = zc, Mh(Ce, function() {
        var f = {};
        return ws(Ce, function(m, N) {
          on.call(Ce.prototype, N) || (f[N] = m);
        }), f;
      }(), { chain: !1 }), Ce.VERSION = n, Ze(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(f) {
        Ce[f].placeholder = Ce;
      }), Ze(["drop", "take"], function(f, m) {
        Zi.prototype[f] = function(N) {
          N = N === t ? 1 : Xn(Oi(N), 0);
          var ne = this.__filtered__ && !m ? new Zi(this) : this.clone();
          return ne.__filtered__ ? ne.__takeCount__ = hr(N, ne.__takeCount__) : ne.__views__.push({
            size: hr(N, tt),
            type: f + (ne.__dir__ < 0 ? "Right" : "")
          }), ne;
        }, Zi.prototype[f + "Right"] = function(N) {
          return this.reverse()[f](N).reverse();
        };
      }), Ze(["filter", "map", "takeWhile"], function(f, m) {
        var N = m + 1, ne = N == ht || N == ft;
        Zi.prototype[f] = function(be) {
          var Te = this.clone();
          return Te.__iteratees__.push({
            iteratee: bi(be, 3),
            type: N
          }), Te.__filtered__ = Te.__filtered__ || ne, Te;
        };
      }), Ze(["head", "last"], function(f, m) {
        var N = "take" + (m ? "Right" : "");
        Zi.prototype[f] = function() {
          return this[N](1).value()[0];
        };
      }), Ze(["initial", "tail"], function(f, m) {
        var N = "drop" + (m ? "" : "Right");
        Zi.prototype[f] = function() {
          return this.__filtered__ ? new Zi(this) : this[N](1);
        };
      }), Zi.prototype.compact = function() {
        return this.filter(kr);
      }, Zi.prototype.find = function(f) {
        return this.filter(f).head();
      }, Zi.prototype.findLast = function(f) {
        return this.reverse().find(f);
      }, Zi.prototype.invokeMap = zi(function(f, m) {
        return typeof f == "function" ? new Zi(this) : this.map(function(N) {
          return Fa(N, f, m);
        });
      }), Zi.prototype.reject = function(f) {
        return this.filter(jo(bi(f)));
      }, Zi.prototype.slice = function(f, m) {
        f = Oi(f);
        var N = this;
        return N.__filtered__ && (f > 0 || m < 0) ? new Zi(N) : (f < 0 ? N = N.takeRight(-f) : f && (N = N.drop(f)), m !== t && (m = Oi(m), N = m < 0 ? N.dropRight(-m) : N.take(m - f)), N);
      }, Zi.prototype.takeRightWhile = function(f) {
        return this.reverse().takeWhile(f).reverse();
      }, Zi.prototype.toArray = function() {
        return this.take(tt);
      }, ws(Zi.prototype, function(f, m) {
        var N = /^(?:filter|find|map|reject)|While$/.test(m), ne = /^(?:head|last)$/.test(m), be = Ce[ne ? "take" + (m == "last" ? "Right" : "") : m], Te = ne || /^find/.test(m);
        be && (Ce.prototype[m] = function() {
          var Ve = this.__wrapped__, Xe = ne ? [1] : arguments, at = Ve instanceof Zi, Pt = Xe[0], Ot = at || Ei(Ve), Ut = function(Gi) {
            var qi = be.apply(Ce, di([Gi], Xe));
            return ne && ti ? qi[0] : qi;
          };
          Ot && N && typeof Pt == "function" && Pt.length != 1 && (at = Ot = !1);
          var ti = this.__chain__, ai = !!this.__actions__.length, wi = Te && !ti, Ri = at && !ai;
          if (!Te && Ot) {
            Ve = Ri ? Ve : new Zi(this);
            var pi = f.apply(Ve, Xe);
            return pi.__actions__.push({ func: Vo, args: [Ut], thisArg: t }), new Xr(pi, ti);
          }
          return wi && Ri ? f.apply(this, Xe) : (pi = this.thru(Ut), wi ? ne ? pi.value()[0] : pi.value() : pi);
        });
      }), Ze(["pop", "push", "shift", "sort", "splice", "unshift"], function(f) {
        var m = Yi[f], N = /^(?:push|sort|unshift)$/.test(f) ? "tap" : "thru", ne = /^(?:pop|shift)$/.test(f);
        Ce.prototype[f] = function() {
          var be = arguments;
          if (ne && !this.__chain__) {
            var Te = this.value();
            return m.apply(Ei(Te) ? Te : [], be);
          }
          return this[N](function(Ve) {
            return m.apply(Ei(Ve) ? Ve : [], be);
          });
        };
      }), ws(Zi.prototype, function(f, m) {
        var N = Ce[m];
        if (N) {
          var ne = N.name + "";
          on.call(pa, ne) || (pa[ne] = []), pa[ne].push({ name: m, func: N });
        }
      }), pa[Oo(t, te).name] = [{
        name: "wrapper",
        func: t
      }], Zi.prototype.clone = Ug, Zi.prototype.reverse = Vg, Zi.prototype.value = Hg, Ce.prototype.at = __, Ce.prototype.chain = v_, Ce.prototype.commit = y_, Ce.prototype.next = b_, Ce.prototype.plant = w_, Ce.prototype.reverse = S_, Ce.prototype.toJSON = Ce.prototype.valueOf = Ce.prototype.value = M_, Ce.prototype.first = Ce.prototype.head, Ia && (Ce.prototype[Ia] = x_), Ce;
    }, Tt = xt();
    Rr ? ((Rr.exports = Tt)._ = Tt, Nr._ = Tt) : Sn._ = Tt;
  }).call(ss);
})(xl, xl.exports);
var Yw = xl.exports, fg = { exports: {} };
const Gw = {}, jw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Gw
}, Symbol.toStringTag, { value: "Module" })), Xf = /* @__PURE__ */ Ux(jw);
var il = { exports: {} }, Kf;
function Ww() {
  return Kf || (Kf = 1, function(b, e) {
    (function(t, n) {
      n(e);
    })(ss, function(t) {
      var n = [509, 0, 227, 0, 150, 4, 294, 9, 1368, 2, 2, 1, 6, 3, 41, 2, 5, 0, 166, 1, 574, 3, 9, 9, 7, 9, 32, 4, 318, 1, 78, 5, 71, 10, 50, 3, 123, 2, 54, 14, 32, 10, 3, 1, 11, 3, 46, 10, 8, 0, 46, 9, 7, 2, 37, 13, 2, 9, 6, 1, 45, 0, 13, 2, 49, 13, 9, 3, 2, 11, 83, 11, 7, 0, 3, 0, 158, 11, 6, 9, 7, 3, 56, 1, 2, 6, 3, 1, 3, 2, 10, 0, 11, 1, 3, 6, 4, 4, 68, 8, 2, 0, 3, 0, 2, 3, 2, 4, 2, 0, 15, 1, 83, 17, 10, 9, 5, 0, 82, 19, 13, 9, 214, 6, 3, 8, 28, 1, 83, 16, 16, 9, 82, 12, 9, 9, 7, 19, 58, 14, 5, 9, 243, 14, 166, 9, 71, 5, 2, 1, 3, 3, 2, 0, 2, 1, 13, 9, 120, 6, 3, 6, 4, 0, 29, 9, 41, 6, 2, 3, 9, 0, 10, 10, 47, 15, 199, 7, 137, 9, 54, 7, 2, 7, 17, 9, 57, 21, 2, 13, 123, 5, 4, 0, 2, 1, 2, 6, 2, 0, 9, 9, 49, 4, 2, 1, 2, 4, 9, 9, 55, 9, 266, 3, 10, 1, 2, 0, 49, 6, 4, 4, 14, 10, 5350, 0, 7, 14, 11465, 27, 2343, 9, 87, 9, 39, 4, 60, 6, 26, 9, 535, 9, 470, 0, 2, 54, 8, 3, 82, 0, 12, 1, 19628, 1, 4178, 9, 519, 45, 3, 22, 543, 4, 4, 5, 9, 7, 3, 6, 31, 3, 149, 2, 1418, 49, 513, 54, 5, 49, 9, 0, 15, 0, 23, 4, 2, 14, 1361, 6, 2, 16, 3, 6, 2, 1, 2, 4, 101, 0, 161, 6, 10, 9, 357, 0, 62, 13, 499, 13, 245, 1, 2, 9, 233, 0, 3, 0, 8, 1, 6, 0, 475, 6, 110, 6, 6, 9, 4759, 9, 787719, 239], s = [0, 11, 2, 25, 2, 18, 2, 1, 2, 14, 3, 13, 35, 122, 70, 52, 268, 28, 4, 48, 48, 31, 14, 29, 6, 37, 11, 29, 3, 35, 5, 7, 2, 4, 43, 157, 19, 35, 5, 35, 5, 39, 9, 51, 13, 10, 2, 14, 2, 6, 2, 1, 2, 10, 2, 14, 2, 6, 2, 1, 4, 51, 13, 310, 10, 21, 11, 7, 25, 5, 2, 41, 2, 8, 70, 5, 3, 0, 2, 43, 2, 1, 4, 0, 3, 22, 11, 22, 10, 30, 66, 18, 2, 1, 11, 21, 11, 25, 7, 25, 39, 55, 7, 1, 65, 0, 16, 3, 2, 2, 2, 28, 43, 28, 4, 28, 36, 7, 2, 27, 28, 53, 11, 21, 11, 18, 14, 17, 111, 72, 56, 50, 14, 50, 14, 35, 39, 27, 10, 22, 251, 41, 7, 1, 17, 5, 57, 28, 11, 0, 9, 21, 43, 17, 47, 20, 28, 22, 13, 52, 58, 1, 3, 0, 14, 44, 33, 24, 27, 35, 30, 0, 3, 0, 9, 34, 4, 0, 13, 47, 15, 3, 22, 0, 2, 0, 36, 17, 2, 24, 20, 1, 64, 6, 2, 0, 2, 3, 2, 14, 2, 9, 8, 46, 39, 7, 3, 1, 3, 21, 2, 6, 2, 1, 2, 4, 4, 0, 19, 0, 13, 4, 31, 9, 2, 0, 3, 0, 2, 37, 2, 0, 26, 0, 2, 0, 45, 52, 19, 3, 21, 2, 31, 47, 21, 1, 2, 0, 185, 46, 42, 3, 37, 47, 21, 0, 60, 42, 14, 0, 72, 26, 38, 6, 186, 43, 117, 63, 32, 7, 3, 0, 3, 7, 2, 1, 2, 23, 16, 0, 2, 0, 95, 7, 3, 38, 17, 0, 2, 0, 29, 0, 11, 39, 8, 0, 22, 0, 12, 45, 20, 0, 19, 72, 200, 32, 32, 8, 2, 36, 18, 0, 50, 29, 113, 6, 2, 1, 2, 37, 22, 0, 26, 5, 2, 1, 2, 31, 15, 0, 24, 43, 261, 18, 16, 0, 2, 12, 2, 33, 125, 0, 80, 921, 103, 110, 18, 195, 2637, 96, 16, 1071, 18, 5, 26, 3994, 6, 582, 6842, 29, 1763, 568, 8, 30, 18, 78, 18, 29, 19, 47, 17, 3, 32, 20, 6, 18, 433, 44, 212, 63, 33, 24, 3, 24, 45, 74, 6, 0, 67, 12, 65, 1, 2, 0, 15, 4, 10, 7381, 42, 31, 98, 114, 8702, 3, 2, 6, 2, 1, 2, 290, 16, 0, 30, 2, 3, 0, 15, 3, 9, 395, 2309, 106, 6, 12, 4, 8, 8, 9, 5991, 84, 2, 70, 2, 1, 3, 0, 3, 1, 3, 3, 2, 11, 2, 0, 2, 6, 2, 64, 2, 3, 3, 7, 2, 6, 2, 27, 2, 3, 2, 4, 2, 0, 4, 6, 2, 339, 3, 24, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 7, 1845, 30, 7, 5, 262, 61, 147, 44, 11, 6, 17, 0, 322, 29, 19, 43, 485, 27, 229, 29, 3, 0, 208, 30, 2, 2, 2, 1, 2, 6, 3, 4, 10, 1, 225, 6, 2, 3, 2, 1, 2, 14, 2, 196, 60, 67, 8, 0, 1205, 3, 2, 26, 2, 1, 2, 0, 3, 0, 2, 9, 2, 3, 2, 0, 2, 0, 7, 0, 5, 0, 2, 0, 2, 0, 2, 2, 2, 1, 2, 0, 3, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 1, 2, 0, 3, 3, 2, 6, 2, 3, 2, 3, 2, 0, 2, 9, 2, 16, 6, 2, 2, 4, 2, 16, 4421, 42719, 33, 4381, 3, 5773, 3, 7472, 16, 621, 2467, 541, 1507, 4938, 6, 8489], o = "‌‍·̀-ͯ·҃-֑҇-ׇֽֿׁׂׅׄؐ-ًؚ-٩ٰۖ-ۜ۟-۪ۤۧۨ-ۭ۰-۹ܑܰ-݊ަ-ް߀-߉߫-߽߳ࠖ-࠙ࠛ-ࠣࠥ-ࠧࠩ-࡙࠭-࡛ࢗ-࢟࣊-ࣣ࣡-ःऺ-़ा-ॏ॑-ॗॢॣ०-९ঁ-ঃ়া-ৄেৈো-্ৗৢৣ০-৯৾ਁ-ਃ਼ਾ-ੂੇੈੋ-੍ੑ੦-ੱੵઁ-ઃ઼ા-ૅે-ૉો-્ૢૣ૦-૯ૺ-૿ଁ-ଃ଼ା-ୄେୈୋ-୍୕-ୗୢୣ୦-୯ஂா-ூெ-ைொ-்ௗ௦-௯ఀ-ఄ఼ా-ౄె-ైొ-్ౕౖౢౣ౦-౯ಁ-ಃ಼ಾ-ೄೆ-ೈೊ-್ೕೖೢೣ೦-೯ೳഀ-ഃ഻഼ാ-ൄെ-ൈൊ-്ൗൢൣ൦-൯ඁ-ඃ්ා-ුූෘ-ෟ෦-෯ෲෳัิ-ฺ็-๎๐-๙ັິ-ຼ່-໎໐-໙༘༙༠-༩༹༵༷༾༿ཱ-྄྆྇ྍ-ྗྙ-ྼ࿆ါ-ှ၀-၉ၖ-ၙၞ-ၠၢ-ၤၧ-ၭၱ-ၴႂ-ႍႏ-ႝ፝-፟፩-፱ᜒ-᜕ᜲ-᜴ᝒᝓᝲᝳ឴-៓៝០-៩᠋-᠍᠏-᠙ᢩᤠ-ᤫᤰ-᤻᥆-᥏᧐-᧚ᨗ-ᨛᩕ-ᩞ᩠-᩿᩼-᪉᪐-᪙᪰-᪽ᪿ-᫝᫠-᫫ᬀ-ᬄ᬴-᭄᭐-᭙᭫-᭳ᮀ-ᮂᮡ-ᮭ᮰-᮹᯦-᯳ᰤ-᰷᱀-᱉᱐-᱙᳐-᳔᳒-᳨᳭᳴᳷-᳹᷀-᷿‌‍‿⁀⁔⃐-⃥⃜⃡-⃰⳯-⵿⳱ⷠ-〪ⷿ-゙゚〯・꘠-꘩꙯ꙴ-꙽ꚞꚟ꛰꛱ꠂ꠆ꠋꠣ-ꠧ꠬ꢀꢁꢴ-ꣅ꣐-꣙꣠-꣱ꣿ-꤉ꤦ-꤭ꥇ-꥓ꦀ-ꦃ꦳-꧀꧐-꧙ꧥ꧰-꧹ꨩ-ꨶꩃꩌꩍ꩐-꩙ꩻ-ꩽꪰꪲ-ꪴꪷꪸꪾ꪿꫁ꫫ-ꫯꫵ꫶ꯣ-ꯪ꯬꯭꯰-꯹ﬞ︀-️︠-︯︳︴﹍-﹏０-９＿･", h = "ªµºÀ-ÖØ-öø-ˁˆ-ˑˠ-ˤˬˮͰ-ʹͶͷͺ-ͽͿΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԯԱ-Ֆՙՠ-ֈא-תׯ-ײؠ-يٮٯٱ-ۓەۥۦۮۯۺ-ۼۿܐܒ-ܯݍ-ޥޱߊ-ߪߴߵߺࠀ-ࠕࠚࠤࠨࡀ-ࡘࡠ-ࡪࡰ-ࢇࢉ-࢏ࢠ-ࣉऄ-हऽॐक़-ॡॱ-ঀঅ-ঌএঐও-নপ-রলশ-হঽৎড়ঢ়য়-ৡৰৱৼਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਖ਼-ੜਫ਼ੲ-ੴઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽૐૠૡૹଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽଡ଼ଢ଼ୟ-ୡୱஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹௐఅ-ఌఎ-ఐఒ-నప-హఽౘ-ౚ౜ౝౠౡಀಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽ೜-ೞೠೡೱೲഄ-ഌഎ-ഐഒ-ഺഽൎൔ-ൖൟ-ൡൺ-ൿඅ-ඖක-නඳ-රලව-ෆก-ะาำเ-ๆກຂຄຆ-ຊຌ-ຣລວ-ະາຳຽເ-ໄໆໜ-ໟༀཀ-ཇཉ-ཬྈ-ྌက-ဪဿၐ-ၕၚ-ၝၡၥၦၮ-ၰၵ-ႁႎႠ-ჅჇჍა-ჺჼ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᎠ-Ᏽᏸ-ᏽᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛮ-ᛸᜀ-ᜑᜟ-ᜱᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳៗៜᠠ-ᡸᢀ-ᢨᢪᢰ-ᣵᤀ-ᤞᥐ-ᥭᥰ-ᥴᦀ-ᦫᦰ-ᧉᨀ-ᨖᨠ-ᩔᪧᬅ-ᬳᭅ-ᭌᮃ-ᮠᮮᮯᮺ-ᯥᰀ-ᰣᱍ-ᱏᱚ-ᱽᲀ-ᲊᲐ-ᲺᲽ-Ჿᳩ-ᳬᳮ-ᳳᳵᳶᳺᴀ-ᶿḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼⁱⁿₐ-ₜℂℇℊ-ℓℕ℘-ℝℤΩℨK-ℹℼ-ℿⅅ-ⅉⅎⅠ-ↈⰀ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞ々-〇〡-〩〱-〵〸-〼ぁ-ゖ゛-ゟァ-ヺー-ヿㄅ-ㄯㄱ-ㆎㆠ-ㆿㇰ-ㇿ㐀-䶿一-ꒌꓐ-ꓽꔀ-ꘌꘐ-ꘟꘪꘫꙀ-ꙮꙿ-ꚝꚠ-ꛯꜗ-ꜟꜢ-ꞈꞋ-Ƛ꟱-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢꡀ-ꡳꢂ-ꢳꣲ-ꣷꣻꣽꣾꤊ-ꤥꤰ-ꥆꥠ-ꥼꦄ-ꦲꧏꧠ-ꧤꧦ-ꧯꧺ-ꧾꨀ-ꨨꩀ-ꩂꩄ-ꩋꩠ-ꩶꩺꩾ-ꪯꪱꪵꪶꪹ-ꪽꫀꫂꫛ-ꫝꫠ-ꫪꫲ-ꫴꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꬰ-ꭚꭜ-ꭩꭰ-ꯢ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎ﬀ-ﬆﬓ-ﬗיִײַ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼＡ-Ｚａ-ｚｦ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ", c = {
        3: "abstract boolean byte char class double enum export extends final float goto implements import int interface long native package private protected public short static super synchronized throws transient volatile",
        5: "class enum extends super const export import",
        6: "enum",
        strict: "implements interface let package private protected public static yield",
        strictBind: "eval arguments"
      }, _ = "break case catch continue debugger default do else finally for function if return switch throw try var while with null true false instanceof typeof void delete new in this", x = {
        5: _,
        "5module": _ + " export import",
        6: _ + " const class extends export import super"
      }, B = /^in(stanceof)?$/, P = new RegExp("[" + h + "]"), U = new RegExp("[" + h + o + "]");
      function M(g, V) {
        for (var ue = 65536, ye = 0; ye < V.length; ye += 2) {
          if (ue += V[ye], ue > g)
            return !1;
          if (ue += V[ye + 1], ue >= g)
            return !0;
        }
        return !1;
      }
      function Z(g, V) {
        return g < 65 ? g === 36 : g < 91 ? !0 : g < 97 ? g === 95 : g < 123 ? !0 : g <= 65535 ? g >= 170 && P.test(String.fromCharCode(g)) : V === !1 ? !1 : M(g, s);
      }
      function F(g, V) {
        return g < 48 ? g === 36 : g < 58 ? !0 : g < 65 ? !1 : g < 91 ? !0 : g < 97 ? g === 95 : g < 123 ? !0 : g <= 65535 ? g >= 170 && U.test(String.fromCharCode(g)) : V === !1 ? !1 : M(g, s) || M(g, n);
      }
      var Q = function(V, ue) {
        ue === void 0 && (ue = {}), this.label = V, this.keyword = ue.keyword, this.beforeExpr = !!ue.beforeExpr, this.startsExpr = !!ue.startsExpr, this.isLoop = !!ue.isLoop, this.isAssign = !!ue.isAssign, this.prefix = !!ue.prefix, this.postfix = !!ue.postfix, this.binop = ue.binop || null, this.updateContext = null;
      };
      function D(g, V) {
        return new Q(g, { beforeExpr: !0, binop: V });
      }
      var te = { beforeExpr: !0 }, ee = { startsExpr: !0 }, le = {};
      function fe(g, V) {
        return V === void 0 && (V = {}), V.keyword = g, le[g] = new Q(g, V);
      }
      var X = {
        num: new Q("num", ee),
        regexp: new Q("regexp", ee),
        string: new Q("string", ee),
        name: new Q("name", ee),
        privateId: new Q("privateId", ee),
        eof: new Q("eof"),
        // Punctuation token types.
        bracketL: new Q("[", { beforeExpr: !0, startsExpr: !0 }),
        bracketR: new Q("]"),
        braceL: new Q("{", { beforeExpr: !0, startsExpr: !0 }),
        braceR: new Q("}"),
        parenL: new Q("(", { beforeExpr: !0, startsExpr: !0 }),
        parenR: new Q(")"),
        comma: new Q(",", te),
        semi: new Q(";", te),
        colon: new Q(":", te),
        dot: new Q("."),
        question: new Q("?", te),
        questionDot: new Q("?."),
        arrow: new Q("=>", te),
        template: new Q("template"),
        invalidTemplate: new Q("invalidTemplate"),
        ellipsis: new Q("...", te),
        backQuote: new Q("`", ee),
        dollarBraceL: new Q("${", { beforeExpr: !0, startsExpr: !0 }),
        // Operators. These carry several kinds of properties to help the
        // parser use them properly (the presence of these properties is
        // what categorizes them as operators).
        //
        // `binop`, when present, specifies that this operator is a binary
        // operator, and will refer to its precedence.
        //
        // `prefix` and `postfix` mark the operator as a prefix or postfix
        // unary operator.
        //
        // `isAssign` marks all of `=`, `+=`, `-=` etcetera, which act as
        // binary operators with a very low precedence, that should result
        // in AssignmentExpression nodes.
        eq: new Q("=", { beforeExpr: !0, isAssign: !0 }),
        assign: new Q("_=", { beforeExpr: !0, isAssign: !0 }),
        incDec: new Q("++/--", { prefix: !0, postfix: !0, startsExpr: !0 }),
        prefix: new Q("!/~", { beforeExpr: !0, prefix: !0, startsExpr: !0 }),
        logicalOR: D("||", 1),
        logicalAND: D("&&", 2),
        bitwiseOR: D("|", 3),
        bitwiseXOR: D("^", 4),
        bitwiseAND: D("&", 5),
        equality: D("==/!=/===/!==", 6),
        relational: D("</>/<=/>=", 7),
        bitShift: D("<</>>/>>>", 8),
        plusMin: new Q("+/-", { beforeExpr: !0, binop: 9, prefix: !0, startsExpr: !0 }),
        modulo: D("%", 10),
        star: D("*", 10),
        slash: D("/", 10),
        starstar: new Q("**", { beforeExpr: !0 }),
        coalesce: D("??", 1),
        // Keyword token types.
        _break: fe("break"),
        _case: fe("case", te),
        _catch: fe("catch"),
        _continue: fe("continue"),
        _debugger: fe("debugger"),
        _default: fe("default", te),
        _do: fe("do", { isLoop: !0, beforeExpr: !0 }),
        _else: fe("else", te),
        _finally: fe("finally"),
        _for: fe("for", { isLoop: !0 }),
        _function: fe("function", ee),
        _if: fe("if"),
        _return: fe("return", te),
        _switch: fe("switch"),
        _throw: fe("throw", te),
        _try: fe("try"),
        _var: fe("var"),
        _const: fe("const"),
        _while: fe("while", { isLoop: !0 }),
        _with: fe("with"),
        _new: fe("new", { beforeExpr: !0, startsExpr: !0 }),
        _this: fe("this", ee),
        _super: fe("super", ee),
        _class: fe("class", ee),
        _extends: fe("extends", te),
        _export: fe("export"),
        _import: fe("import", ee),
        _null: fe("null", ee),
        _true: fe("true", ee),
        _false: fe("false", ee),
        _in: fe("in", { beforeExpr: !0, binop: 7 }),
        _instanceof: fe("instanceof", { beforeExpr: !0, binop: 7 }),
        _typeof: fe("typeof", { beforeExpr: !0, prefix: !0, startsExpr: !0 }),
        _void: fe("void", { beforeExpr: !0, prefix: !0, startsExpr: !0 }),
        _delete: fe("delete", { beforeExpr: !0, prefix: !0, startsExpr: !0 })
      }, W = /\r\n?|\n|\u2028|\u2029/, je = new RegExp(W.source, "g");
      function ke(g) {
        return g === 10 || g === 13 || g === 8232 || g === 8233;
      }
      function Ye(g, V, ue) {
        ue === void 0 && (ue = g.length);
        for (var ye = V; ye < ue; ye++) {
          var Ie = g.charCodeAt(ye);
          if (ke(Ie))
            return ye < ue - 1 && Ie === 13 && g.charCodeAt(ye + 1) === 10 ? ye + 2 : ye + 1;
        }
        return -1;
      }
      var pt = /[\u1680\u2000-\u200a\u202f\u205f\u3000\ufeff]/, Le = /(?:\s|\/\/.*|\/\*[^]*?\*\/)*/g, $e = Object.prototype, ce = $e.hasOwnProperty, ht = $e.toString, De = Object.hasOwn || function(g, V) {
        return ce.call(g, V);
      }, ft = Array.isArray || function(g) {
        return ht.call(g) === "[object Array]";
      }, Yt = /* @__PURE__ */ Object.create(null);
      function We(g) {
        return Yt[g] || (Yt[g] = new RegExp("^(?:" + g.replace(/ /g, "|") + ")$"));
      }
      function It(g) {
        return g <= 65535 ? String.fromCharCode(g) : (g -= 65536, String.fromCharCode((g >> 10) + 55296, (g & 1023) + 56320));
      }
      var rt = /(?:[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/, tt = function(V, ue) {
        this.line = V, this.column = ue;
      };
      tt.prototype.offset = function(V) {
        return new tt(this.line, this.column + V);
      };
      var Kt = function(V, ue, ye) {
        this.start = ue, this.end = ye, V.sourceFile !== null && (this.source = V.sourceFile);
      };
      function qt(g, V) {
        for (var ue = 1, ye = 0; ; ) {
          var Ie = Ye(g, ye, V);
          if (Ie < 0)
            return new tt(ue, V - ye);
          ++ue, ye = Ie;
        }
      }
      var Lt = {
        // `ecmaVersion` indicates the ECMAScript version to parse. Must be
        // either 3, 5, 6 (or 2015), 7 (2016), 8 (2017), 9 (2018), 10
        // (2019), 11 (2020), 12 (2021), 13 (2022), 14 (2023), or `"latest"`
        // (the latest version the library supports). This influences
        // support for strict mode, the set of reserved words, and support
        // for new syntax features.
        ecmaVersion: null,
        // `sourceType` indicates the mode the code should be parsed in.
        // Can be either `"script"`, `"module"` or `"commonjs"`. This influences global
        // strict mode and parsing of `import` and `export` declarations.
        sourceType: "script",
        // `onInsertedSemicolon` can be a callback that will be called when
        // a semicolon is automatically inserted. It will be passed the
        // position of the inserted semicolon as an offset, and if
        // `locations` is enabled, it is given the location as a `{line,
        // column}` object as second argument.
        onInsertedSemicolon: null,
        // `onTrailingComma` is similar to `onInsertedSemicolon`, but for
        // trailing commas.
        onTrailingComma: null,
        // By default, reserved words are only enforced if ecmaVersion >= 5.
        // Set `allowReserved` to a boolean value to explicitly turn this on
        // an off. When this option has the value "never", reserved words
        // and keywords can also not be used as property names.
        allowReserved: null,
        // When enabled, a return at the top level is not considered an
        // error.
        allowReturnOutsideFunction: !1,
        // When enabled, import/export statements are not constrained to
        // appearing at the top of the program, and an import.meta expression
        // in a script isn't considered an error.
        allowImportExportEverywhere: !1,
        // By default, await identifiers are allowed to appear at the top-level scope only if ecmaVersion >= 2022.
        // When enabled, await identifiers are allowed to appear at the top-level scope,
        // but they are still not allowed in non-async functions.
        allowAwaitOutsideFunction: null,
        // When enabled, super identifiers are not constrained to
        // appearing in methods and do not raise an error when they appear elsewhere.
        allowSuperOutsideMethod: null,
        // When enabled, hashbang directive in the beginning of file is
        // allowed and treated as a line comment. Enabled by default when
        // `ecmaVersion` >= 2023.
        allowHashBang: !1,
        // By default, the parser will verify that private properties are
        // only used in places where they are valid and have been declared.
        // Set this to false to turn such checks off.
        checkPrivateFields: !0,
        // When `locations` is on, `loc` properties holding objects with
        // `start` and `end` properties in `{line, column}` form (with
        // line being 1-based and column 0-based) will be attached to the
        // nodes.
        locations: !1,
        // A function can be passed as `onToken` option, which will
        // cause Acorn to call that function with object in the same
        // format as tokens returned from `tokenizer().getToken()`. Note
        // that you are not allowed to call the parser from the
        // callback—that will corrupt its internal state.
        onToken: null,
        // A function can be passed as `onComment` option, which will
        // cause Acorn to call that function with `(block, text, start,
        // end)` parameters whenever a comment is skipped. `block` is a
        // boolean indicating whether this is a block (`/* */`) comment,
        // `text` is the content of the comment, and `start` and `end` are
        // character offsets that denote the start and end of the comment.
        // When the `locations` option is on, two more parameters are
        // passed, the full `{line, column}` locations of the start and
        // end of the comments. Note that you are not allowed to call the
        // parser from the callback—that will corrupt its internal state.
        // When this option has an array as value, objects representing the
        // comments are pushed to it.
        onComment: null,
        // Nodes have their start and end characters offsets recorded in
        // `start` and `end` properties (directly on the node, rather than
        // the `loc` object, which holds line/column data. To also add a
        // [semi-standardized][range] `range` property holding a `[start,
        // end]` array with the same numbers, set the `ranges` option to
        // `true`.
        //
        // [range]: https://bugzilla.mozilla.org/show_bug.cgi?id=745678
        ranges: !1,
        // It is possible to parse multiple files into a single AST by
        // passing the tree produced by parsing the first file as
        // `program` option in subsequent parses. This will add the
        // toplevel forms of the parsed file to the `Program` (top) node
        // of an existing parse tree.
        program: null,
        // When `locations` is on, you can pass this to record the source
        // file in every node's `loc` object.
        sourceFile: null,
        // This value, if given, is stored in every node, whether
        // `locations` is on or off.
        directSourceFile: null,
        // When enabled, parenthesized expressions are represented by
        // (non-standard) ParenthesizedExpression nodes
        preserveParens: !1
      }, Ci = !1;
      function ji(g) {
        var V = {};
        for (var ue in Lt)
          V[ue] = g && De(g, ue) ? g[ue] : Lt[ue];
        if (V.ecmaVersion === "latest" ? V.ecmaVersion = 1e8 : V.ecmaVersion == null ? (!Ci && typeof console == "object" && console.warn && (Ci = !0, console.warn(`Since Acorn 8.0.0, options.ecmaVersion is required.
Defaulting to 2020, but this will stop working in the future.`)), V.ecmaVersion = 11) : V.ecmaVersion >= 2015 && (V.ecmaVersion -= 2009), V.allowReserved == null && (V.allowReserved = V.ecmaVersion < 5), (!g || g.allowHashBang == null) && (V.allowHashBang = V.ecmaVersion >= 14), ft(V.onToken)) {
          var ye = V.onToken;
          V.onToken = function(Ie) {
            return ye.push(Ie);
          };
        }
        if (ft(V.onComment) && (V.onComment = _i(V, V.onComment)), V.sourceType === "commonjs" && V.allowAwaitOutsideFunction)
          throw new Error("Cannot use allowAwaitOutsideFunction with sourceType: commonjs");
        return V;
      }
      function _i(g, V) {
        return function(ue, ye, Ie, nt, dt, zt) {
          var Xt = {
            type: ue ? "Block" : "Line",
            value: ye,
            start: Ie,
            end: nt
          };
          g.locations && (Xt.loc = new Kt(this, dt, zt)), g.ranges && (Xt.range = [Ie, nt]), V.push(Xt);
        };
      }
      var Wt = 1, $t = 2, ei = 4, tn = 8, Fi = 16, _e = 32, Ct = 64, yt = 128, Re = 256, Ee = 512, et = 1024, kt = Wt | $t | Re;
      function mt(g, V) {
        return $t | (g ? ei : 0) | (V ? tn : 0);
      }
      var Qe = 0, bt = 1, Gt = 2, He = 3, i = 4, r = 5, a = function(V, ue, ye) {
        this.options = V = ji(V), this.sourceFile = V.sourceFile, this.keywords = We(x[V.ecmaVersion >= 6 ? 6 : V.sourceType === "module" ? "5module" : 5]);
        var Ie = "";
        V.allowReserved !== !0 && (Ie = c[V.ecmaVersion >= 6 ? 6 : V.ecmaVersion === 5 ? 5 : 3], V.sourceType === "module" && (Ie += " await")), this.reservedWords = We(Ie);
        var nt = (Ie ? Ie + " " : "") + c.strict;
        this.reservedWordsStrict = We(nt), this.reservedWordsStrictBind = We(nt + " " + c.strictBind), this.input = String(ue), this.containsEsc = !1, ye ? (this.pos = ye, this.lineStart = this.input.lastIndexOf(`
`, ye - 1) + 1, this.curLine = this.input.slice(0, this.lineStart).split(W).length) : (this.pos = this.lineStart = 0, this.curLine = 1), this.type = X.eof, this.value = null, this.start = this.end = this.pos, this.startLoc = this.endLoc = this.curPosition(), this.lastTokEndLoc = this.lastTokStartLoc = null, this.lastTokStart = this.lastTokEnd = this.pos, this.context = this.initialContext(), this.exprAllowed = !0, this.inModule = V.sourceType === "module", this.strict = this.inModule || this.strictDirective(this.pos), this.potentialArrowAt = -1, this.potentialArrowInForAwait = !1, this.yieldPos = this.awaitPos = this.awaitIdentPos = 0, this.labels = [], this.undefinedExports = /* @__PURE__ */ Object.create(null), this.pos === 0 && V.allowHashBang && this.input.slice(0, 2) === "#!" && this.skipLineComment(2), this.scopeStack = [], this.enterScope(
          this.options.sourceType === "commonjs" ? $t : Wt
        ), this.regexpState = null, this.privateNameStack = [];
      }, l = { inFunction: { configurable: !0 }, inGenerator: { configurable: !0 }, inAsync: { configurable: !0 }, canAwait: { configurable: !0 }, allowReturn: { configurable: !0 }, allowSuper: { configurable: !0 }, allowDirectSuper: { configurable: !0 }, treatFunctionsAsVar: { configurable: !0 }, allowNewDotTarget: { configurable: !0 }, allowUsing: { configurable: !0 }, inClassStaticBlock: { configurable: !0 } };
      a.prototype.parse = function() {
        var V = this.options.program || this.startNode();
        return this.nextToken(), this.parseTopLevel(V);
      }, l.inFunction.get = function() {
        return (this.currentVarScope().flags & $t) > 0;
      }, l.inGenerator.get = function() {
        return (this.currentVarScope().flags & tn) > 0;
      }, l.inAsync.get = function() {
        return (this.currentVarScope().flags & ei) > 0;
      }, l.canAwait.get = function() {
        for (var g = this.scopeStack.length - 1; g >= 0; g--) {
          var V = this.scopeStack[g], ue = V.flags;
          if (ue & (Re | Ee))
            return !1;
          if (ue & $t)
            return (ue & ei) > 0;
        }
        return this.inModule && this.options.ecmaVersion >= 13 || this.options.allowAwaitOutsideFunction;
      }, l.allowReturn.get = function() {
        return !!(this.inFunction || this.options.allowReturnOutsideFunction && this.currentVarScope().flags & Wt);
      }, l.allowSuper.get = function() {
        var g = this.currentThisScope(), V = g.flags;
        return (V & Ct) > 0 || this.options.allowSuperOutsideMethod;
      }, l.allowDirectSuper.get = function() {
        return (this.currentThisScope().flags & yt) > 0;
      }, l.treatFunctionsAsVar.get = function() {
        return this.treatFunctionsAsVarInScope(this.currentScope());
      }, l.allowNewDotTarget.get = function() {
        for (var g = this.scopeStack.length - 1; g >= 0; g--) {
          var V = this.scopeStack[g], ue = V.flags;
          if (ue & (Re | Ee) || ue & $t && !(ue & Fi))
            return !0;
        }
        return !1;
      }, l.allowUsing.get = function() {
        var g = this.currentScope(), V = g.flags;
        return !(V & et || !this.inModule && V & Wt);
      }, l.inClassStaticBlock.get = function() {
        return (this.currentVarScope().flags & Re) > 0;
      }, a.extend = function() {
        for (var V = [], ue = arguments.length; ue--; )
          V[ue] = arguments[ue];
        for (var ye = this, Ie = 0; Ie < V.length; Ie++)
          ye = V[Ie](ye);
        return ye;
      }, a.parse = function(V, ue) {
        return new this(ue, V).parse();
      }, a.parseExpressionAt = function(V, ue, ye) {
        var Ie = new this(ye, V, ue);
        return Ie.nextToken(), Ie.parseExpression();
      }, a.tokenizer = function(V, ue) {
        return new this(ue, V);
      }, Object.defineProperties(a.prototype, l);
      var u = a.prototype, d = /^(?:'((?:\\[^]|[^'\\])*?)'|"((?:\\[^]|[^"\\])*?)")/;
      u.strictDirective = function(g) {
        if (this.options.ecmaVersion < 5)
          return !1;
        for (; ; ) {
          Le.lastIndex = g, g += Le.exec(this.input)[0].length;
          var V = d.exec(this.input.slice(g));
          if (!V)
            return !1;
          if ((V[1] || V[2]) === "use strict") {
            Le.lastIndex = g + V[0].length;
            var ue = Le.exec(this.input), ye = ue.index + ue[0].length, Ie = this.input.charAt(ye);
            return Ie === ";" || Ie === "}" || W.test(ue[0]) && !(/[(`.[+\-/*%<>=,?^&]/.test(Ie) || Ie === "!" && this.input.charAt(ye + 1) === "=");
          }
          g += V[0].length, Le.lastIndex = g, g += Le.exec(this.input)[0].length, this.input[g] === ";" && g++;
        }
      }, u.eat = function(g) {
        return this.type === g ? (this.next(), !0) : !1;
      }, u.isContextual = function(g) {
        return this.type === X.name && this.value === g && !this.containsEsc;
      }, u.eatContextual = function(g) {
        return this.isContextual(g) ? (this.next(), !0) : !1;
      }, u.expectContextual = function(g) {
        this.eatContextual(g) || this.unexpected();
      }, u.canInsertSemicolon = function() {
        return this.type === X.eof || this.type === X.braceR || W.test(this.input.slice(this.lastTokEnd, this.start));
      }, u.insertSemicolon = function() {
        if (this.canInsertSemicolon())
          return this.options.onInsertedSemicolon && this.options.onInsertedSemicolon(this.lastTokEnd, this.lastTokEndLoc), !0;
      }, u.semicolon = function() {
        !this.eat(X.semi) && !this.insertSemicolon() && this.unexpected();
      }, u.afterTrailingComma = function(g, V) {
        if (this.type === g)
          return this.options.onTrailingComma && this.options.onTrailingComma(this.lastTokStart, this.lastTokStartLoc), V || this.next(), !0;
      }, u.expect = function(g) {
        this.eat(g) || this.unexpected();
      }, u.unexpected = function(g) {
        this.raise(g ?? this.start, "Unexpected token");
      };
      var v = function() {
        this.shorthandAssign = this.trailingComma = this.parenthesizedAssign = this.parenthesizedBind = this.doubleProto = -1;
      };
      u.checkPatternErrors = function(g, V) {
        if (g) {
          g.trailingComma > -1 && this.raiseRecoverable(g.trailingComma, "Comma is not permitted after the rest element");
          var ue = V ? g.parenthesizedAssign : g.parenthesizedBind;
          ue > -1 && this.raiseRecoverable(ue, V ? "Assigning to rvalue" : "Parenthesized pattern");
        }
      }, u.checkExpressionErrors = function(g, V) {
        if (!g)
          return !1;
        var ue = g.shorthandAssign, ye = g.doubleProto;
        if (!V)
          return ue >= 0 || ye >= 0;
        ue >= 0 && this.raise(ue, "Shorthand property assignments are valid only in destructuring patterns"), ye >= 0 && this.raiseRecoverable(ye, "Redefinition of __proto__ property");
      }, u.checkYieldAwaitInDefaultParams = function() {
        this.yieldPos && (!this.awaitPos || this.yieldPos < this.awaitPos) && this.raise(this.yieldPos, "Yield expression cannot be a default value"), this.awaitPos && this.raise(this.awaitPos, "Await expression cannot be a default value");
      }, u.isSimpleAssignTarget = function(g) {
        return g.type === "ParenthesizedExpression" ? this.isSimpleAssignTarget(g.expression) : g.type === "Identifier" || g.type === "MemberExpression";
      };
      var p = a.prototype;
      p.parseTopLevel = function(g) {
        var V = /* @__PURE__ */ Object.create(null);
        for (g.body || (g.body = []); this.type !== X.eof; ) {
          var ue = this.parseStatement(null, !0, V);
          g.body.push(ue);
        }
        if (this.inModule)
          for (var ye = 0, Ie = Object.keys(this.undefinedExports); ye < Ie.length; ye += 1) {
            var nt = Ie[ye];
            this.raiseRecoverable(this.undefinedExports[nt].start, "Export '" + nt + "' is not defined");
          }
        return this.adaptDirectivePrologue(g.body), this.next(), g.sourceType = this.options.sourceType === "commonjs" ? "script" : this.options.sourceType, this.finishNode(g, "Program");
      };
      var y = { kind: "loop" }, S = { kind: "switch" };
      p.isLet = function(g) {
        if (this.options.ecmaVersion < 6 || !this.isContextual("let"))
          return !1;
        Le.lastIndex = this.pos;
        var V = Le.exec(this.input), ue = this.pos + V[0].length, ye = this.fullCharCodeAt(ue);
        if (ye === 91 || ye === 92)
          return !0;
        if (g)
          return !1;
        if (ye === 123)
          return !0;
        if (Z(ye)) {
          var Ie = ue;
          do
            ue += ye <= 65535 ? 1 : 2;
          while (F(ye = this.fullCharCodeAt(ue)));
          if (ye === 92)
            return !0;
          var nt = this.input.slice(Ie, ue);
          if (!B.test(nt))
            return !0;
        }
        return !1;
      }, p.isAsyncFunction = function() {
        if (this.options.ecmaVersion < 8 || !this.isContextual("async"))
          return !1;
        Le.lastIndex = this.pos;
        var g = Le.exec(this.input), V = this.pos + g[0].length, ue;
        return !W.test(this.input.slice(this.pos, V)) && this.input.slice(V, V + 8) === "function" && (V + 8 === this.input.length || !(F(ue = this.fullCharCodeAt(V + 8)) || ue === 92));
      }, p.isUsingKeyword = function(g, V) {
        if (this.options.ecmaVersion < 17 || !this.isContextual(g ? "await" : "using"))
          return !1;
        Le.lastIndex = this.pos;
        var ue = Le.exec(this.input), ye = this.pos + ue[0].length;
        if (W.test(this.input.slice(this.pos, ye)))
          return !1;
        if (g) {
          var Ie = ye + 5, nt;
          if (this.input.slice(ye, Ie) !== "using" || Ie === this.input.length || F(nt = this.fullCharCodeAt(Ie)) || nt === 92)
            return !1;
          Le.lastIndex = Ie;
          var dt = Le.exec(this.input);
          if (ye = Ie + dt[0].length, dt && W.test(this.input.slice(Ie, ye)))
            return !1;
        }
        var zt = this.fullCharCodeAt(ye);
        if (!Z(zt) && zt !== 92)
          return !1;
        var Xt = ye;
        do
          ye += zt <= 65535 ? 1 : 2;
        while (F(zt = this.fullCharCodeAt(ye)));
        if (zt === 92)
          return !0;
        var hi = this.input.slice(Xt, ye);
        return !(B.test(hi) || V && hi === "of");
      }, p.isAwaitUsing = function(g) {
        return this.isUsingKeyword(!0, g);
      }, p.isUsing = function(g) {
        return this.isUsingKeyword(!1, g);
      }, p.parseStatement = function(g, V, ue) {
        var ye = this.type, Ie = this.startNode(), nt;
        switch (this.isLet(g) && (ye = X._var, nt = "let"), ye) {
          case X._break:
          case X._continue:
            return this.parseBreakContinueStatement(Ie, ye.keyword);
          case X._debugger:
            return this.parseDebuggerStatement(Ie);
          case X._do:
            return this.parseDoStatement(Ie);
          case X._for:
            return this.parseForStatement(Ie);
          case X._function:
            return g && (this.strict || g !== "if" && g !== "label") && this.options.ecmaVersion >= 6 && this.unexpected(), this.parseFunctionStatement(Ie, !1, !g);
          case X._class:
            return g && this.unexpected(), this.parseClass(Ie, !0);
          case X._if:
            return this.parseIfStatement(Ie);
          case X._return:
            return this.parseReturnStatement(Ie);
          case X._switch:
            return this.parseSwitchStatement(Ie);
          case X._throw:
            return this.parseThrowStatement(Ie);
          case X._try:
            return this.parseTryStatement(Ie);
          case X._const:
          case X._var:
            return nt = nt || this.value, g && nt !== "var" && this.unexpected(), this.parseVarStatement(Ie, nt);
          case X._while:
            return this.parseWhileStatement(Ie);
          case X._with:
            return this.parseWithStatement(Ie);
          case X.braceL:
            return this.parseBlock(!0, Ie);
          case X.semi:
            return this.parseEmptyStatement(Ie);
          case X._export:
          case X._import:
            if (this.options.ecmaVersion > 10 && ye === X._import) {
              Le.lastIndex = this.pos;
              var dt = Le.exec(this.input), zt = this.pos + dt[0].length, Xt = this.input.charCodeAt(zt);
              if (Xt === 40 || Xt === 46)
                return this.parseExpressionStatement(Ie, this.parseExpression());
            }
            return this.options.allowImportExportEverywhere || (V || this.raise(this.start, "'import' and 'export' may only appear at the top level"), this.inModule || this.raise(this.start, "'import' and 'export' may appear only with 'sourceType: module'")), ye === X._import ? this.parseImport(Ie) : this.parseExport(Ie, ue);
          default:
            if (this.isAsyncFunction())
              return g && this.unexpected(), this.next(), this.parseFunctionStatement(Ie, !0, !g);
            var hi = this.isAwaitUsing(!1) ? "await using" : this.isUsing(!1) ? "using" : null;
            if (hi)
              return this.allowUsing || this.raise(this.start, "Using declaration cannot appear in the top level when source type is `script` or in the bare case statement"), hi === "await using" && (this.canAwait || this.raise(this.start, "Await using cannot appear outside of async function"), this.next()), this.next(), this.parseVar(Ie, !1, hi), this.semicolon(), this.finishNode(Ie, "VariableDeclaration");
            var ii = this.value, oi = this.parseExpression();
            return ye === X.name && oi.type === "Identifier" && this.eat(X.colon) ? this.parseLabeledStatement(Ie, ii, oi, g) : this.parseExpressionStatement(Ie, oi);
        }
      }, p.parseBreakContinueStatement = function(g, V) {
        var ue = V === "break";
        this.next(), this.eat(X.semi) || this.insertSemicolon() ? g.label = null : this.type !== X.name ? this.unexpected() : (g.label = this.parseIdent(), this.semicolon());
        for (var ye = 0; ye < this.labels.length; ++ye) {
          var Ie = this.labels[ye];
          if ((g.label == null || Ie.name === g.label.name) && (Ie.kind != null && (ue || Ie.kind === "loop") || g.label && ue))
            break;
        }
        return ye === this.labels.length && this.raise(g.start, "Unsyntactic " + V), this.finishNode(g, ue ? "BreakStatement" : "ContinueStatement");
      }, p.parseDebuggerStatement = function(g) {
        return this.next(), this.semicolon(), this.finishNode(g, "DebuggerStatement");
      }, p.parseDoStatement = function(g) {
        return this.next(), this.labels.push(y), g.body = this.parseStatement("do"), this.labels.pop(), this.expect(X._while), g.test = this.parseParenExpression(), this.options.ecmaVersion >= 6 ? this.eat(X.semi) : this.semicolon(), this.finishNode(g, "DoWhileStatement");
      }, p.parseForStatement = function(g) {
        this.next();
        var V = this.options.ecmaVersion >= 9 && this.canAwait && this.eatContextual("await") ? this.lastTokStart : -1;
        if (this.labels.push(y), this.enterScope(0), this.expect(X.parenL), this.type === X.semi)
          return V > -1 && this.unexpected(V), this.parseFor(g, null);
        var ue = this.isLet();
        if (this.type === X._var || this.type === X._const || ue) {
          var ye = this.startNode(), Ie = ue ? "let" : this.value;
          return this.next(), this.parseVar(ye, !0, Ie), this.finishNode(ye, "VariableDeclaration"), this.parseForAfterInit(g, ye, V);
        }
        var nt = this.isContextual("let"), dt = !1, zt = this.isUsing(!0) ? "using" : this.isAwaitUsing(!0) ? "await using" : null;
        if (zt) {
          var Xt = this.startNode();
          return this.next(), zt === "await using" && (this.canAwait || this.raise(this.start, "Await using cannot appear outside of async function"), this.next()), this.parseVar(Xt, !0, zt), this.finishNode(Xt, "VariableDeclaration"), this.parseForAfterInit(g, Xt, V);
        }
        var hi = this.containsEsc, ii = new v(), oi = this.start, vn = V > -1 ? this.parseExprSubscripts(ii, "await") : this.parseExpression(!0, ii);
        return this.type === X._in || (dt = this.options.ecmaVersion >= 6 && this.isContextual("of")) ? (V > -1 ? (this.type === X._in && this.unexpected(V), g.await = !0) : dt && this.options.ecmaVersion >= 8 && (vn.start === oi && !hi && vn.type === "Identifier" && vn.name === "async" ? this.unexpected() : this.options.ecmaVersion >= 9 && (g.await = !1)), nt && dt && this.raise(vn.start, "The left-hand side of a for-of loop may not start with 'let'."), this.toAssignable(vn, !1, ii), this.checkLValPattern(vn), this.parseForIn(g, vn)) : (this.checkExpressionErrors(ii, !0), V > -1 && this.unexpected(V), this.parseFor(g, vn));
      }, p.parseForAfterInit = function(g, V, ue) {
        return (this.type === X._in || this.options.ecmaVersion >= 6 && this.isContextual("of")) && V.declarations.length === 1 ? (this.options.ecmaVersion >= 9 && (this.type === X._in ? ue > -1 && this.unexpected(ue) : g.await = ue > -1), this.parseForIn(g, V)) : (ue > -1 && this.unexpected(ue), this.parseFor(g, V));
      }, p.parseFunctionStatement = function(g, V, ue) {
        return this.next(), this.parseFunction(g, E | (ue ? 0 : A), !1, V);
      }, p.parseIfStatement = function(g) {
        return this.next(), g.test = this.parseParenExpression(), g.consequent = this.parseStatement("if"), g.alternate = this.eat(X._else) ? this.parseStatement("if") : null, this.finishNode(g, "IfStatement");
      }, p.parseReturnStatement = function(g) {
        return this.allowReturn || this.raise(this.start, "'return' outside of function"), this.next(), this.eat(X.semi) || this.insertSemicolon() ? g.argument = null : (g.argument = this.parseExpression(), this.semicolon()), this.finishNode(g, "ReturnStatement");
      }, p.parseSwitchStatement = function(g) {
        this.next(), g.discriminant = this.parseParenExpression(), g.cases = [], this.expect(X.braceL), this.labels.push(S), this.enterScope(et);
        for (var V, ue = !1; this.type !== X.braceR; )
          if (this.type === X._case || this.type === X._default) {
            var ye = this.type === X._case;
            V && this.finishNode(V, "SwitchCase"), g.cases.push(V = this.startNode()), V.consequent = [], this.next(), ye ? V.test = this.parseExpression() : (ue && this.raiseRecoverable(this.lastTokStart, "Multiple default clauses"), ue = !0, V.test = null), this.expect(X.colon);
          } else
            V || this.unexpected(), V.consequent.push(this.parseStatement(null));
        return this.exitScope(), V && this.finishNode(V, "SwitchCase"), this.next(), this.labels.pop(), this.finishNode(g, "SwitchStatement");
      }, p.parseThrowStatement = function(g) {
        return this.next(), W.test(this.input.slice(this.lastTokEnd, this.start)) && this.raise(this.lastTokEnd, "Illegal newline after throw"), g.argument = this.parseExpression(), this.semicolon(), this.finishNode(g, "ThrowStatement");
      };
      var L = [];
      p.parseCatchClauseParam = function() {
        var g = this.parseBindingAtom(), V = g.type === "Identifier";
        return this.enterScope(V ? _e : 0), this.checkLValPattern(g, V ? i : Gt), this.expect(X.parenR), g;
      }, p.parseTryStatement = function(g) {
        if (this.next(), g.block = this.parseBlock(), g.handler = null, this.type === X._catch) {
          var V = this.startNode();
          this.next(), this.eat(X.parenL) ? V.param = this.parseCatchClauseParam() : (this.options.ecmaVersion < 10 && this.unexpected(), V.param = null, this.enterScope(0)), V.body = this.parseBlock(!1), this.exitScope(), g.handler = this.finishNode(V, "CatchClause");
        }
        return g.finalizer = this.eat(X._finally) ? this.parseBlock() : null, !g.handler && !g.finalizer && this.raise(g.start, "Missing catch or finally clause"), this.finishNode(g, "TryStatement");
      }, p.parseVarStatement = function(g, V, ue) {
        return this.next(), this.parseVar(g, !1, V, ue), this.semicolon(), this.finishNode(g, "VariableDeclaration");
      }, p.parseWhileStatement = function(g) {
        return this.next(), g.test = this.parseParenExpression(), this.labels.push(y), g.body = this.parseStatement("while"), this.labels.pop(), this.finishNode(g, "WhileStatement");
      }, p.parseWithStatement = function(g) {
        return this.strict && this.raise(this.start, "'with' in strict mode"), this.next(), g.object = this.parseParenExpression(), g.body = this.parseStatement("with"), this.finishNode(g, "WithStatement");
      }, p.parseEmptyStatement = function(g) {
        return this.next(), this.finishNode(g, "EmptyStatement");
      }, p.parseLabeledStatement = function(g, V, ue, ye) {
        for (var Ie = 0, nt = this.labels; Ie < nt.length; Ie += 1) {
          var dt = nt[Ie];
          dt.name === V && this.raise(ue.start, "Label '" + V + "' is already declared");
        }
        for (var zt = this.type.isLoop ? "loop" : this.type === X._switch ? "switch" : null, Xt = this.labels.length - 1; Xt >= 0; Xt--) {
          var hi = this.labels[Xt];
          if (hi.statementStart === g.start)
            hi.statementStart = this.start, hi.kind = zt;
          else
            break;
        }
        return this.labels.push({ name: V, kind: zt, statementStart: this.start }), g.body = this.parseStatement(ye ? ye.indexOf("label") === -1 ? ye + "label" : ye : "label"), this.labels.pop(), g.label = ue, this.finishNode(g, "LabeledStatement");
      }, p.parseExpressionStatement = function(g, V) {
        return g.expression = V, this.semicolon(), this.finishNode(g, "ExpressionStatement");
      }, p.parseBlock = function(g, V, ue) {
        for (g === void 0 && (g = !0), V === void 0 && (V = this.startNode()), V.body = [], this.expect(X.braceL), g && this.enterScope(0); this.type !== X.braceR; ) {
          var ye = this.parseStatement(null);
          V.body.push(ye);
        }
        return ue && (this.strict = !1), this.next(), g && this.exitScope(), this.finishNode(V, "BlockStatement");
      }, p.parseFor = function(g, V) {
        return g.init = V, this.expect(X.semi), g.test = this.type === X.semi ? null : this.parseExpression(), this.expect(X.semi), g.update = this.type === X.parenR ? null : this.parseExpression(), this.expect(X.parenR), g.body = this.parseStatement("for"), this.exitScope(), this.labels.pop(), this.finishNode(g, "ForStatement");
      }, p.parseForIn = function(g, V) {
        var ue = this.type === X._in;
        return this.next(), V.type === "VariableDeclaration" && V.declarations[0].init != null && (!ue || this.options.ecmaVersion < 8 || this.strict || V.kind !== "var" || V.declarations[0].id.type !== "Identifier") && this.raise(
          V.start,
          (ue ? "for-in" : "for-of") + " loop variable declaration may not have an initializer"
        ), g.left = V, g.right = ue ? this.parseExpression() : this.parseMaybeAssign(), this.expect(X.parenR), g.body = this.parseStatement("for"), this.exitScope(), this.labels.pop(), this.finishNode(g, ue ? "ForInStatement" : "ForOfStatement");
      }, p.parseVar = function(g, V, ue, ye) {
        for (g.declarations = [], g.kind = ue; ; ) {
          var Ie = this.startNode();
          if (this.parseVarId(Ie, ue), this.eat(X.eq) ? Ie.init = this.parseMaybeAssign(V) : !ye && ue === "const" && !(this.type === X._in || this.options.ecmaVersion >= 6 && this.isContextual("of")) ? this.unexpected() : !ye && (ue === "using" || ue === "await using") && this.options.ecmaVersion >= 17 && this.type !== X._in && !this.isContextual("of") ? this.raise(this.lastTokEnd, "Missing initializer in " + ue + " declaration") : !ye && Ie.id.type !== "Identifier" && !(V && (this.type === X._in || this.isContextual("of"))) ? this.raise(this.lastTokEnd, "Complex binding patterns require an initialization value") : Ie.init = null, g.declarations.push(this.finishNode(Ie, "VariableDeclarator")), !this.eat(X.comma))
            break;
        }
        return g;
      }, p.parseVarId = function(g, V) {
        g.id = V === "using" || V === "await using" ? this.parseIdent() : this.parseBindingAtom(), this.checkLValPattern(g.id, V === "var" ? bt : Gt, !1);
      };
      var E = 1, A = 2, T = 4;
      p.parseFunction = function(g, V, ue, ye, Ie) {
        this.initFunction(g), (this.options.ecmaVersion >= 9 || this.options.ecmaVersion >= 6 && !ye) && (this.type === X.star && V & A && this.unexpected(), g.generator = this.eat(X.star)), this.options.ecmaVersion >= 8 && (g.async = !!ye), V & E && (g.id = V & T && this.type !== X.name ? null : this.parseIdent(), g.id && !(V & A) && this.checkLValSimple(g.id, this.strict || g.generator || g.async ? this.treatFunctionsAsVar ? bt : Gt : He));
        var nt = this.yieldPos, dt = this.awaitPos, zt = this.awaitIdentPos;
        return this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, this.enterScope(mt(g.async, g.generator)), V & E || (g.id = this.type === X.name ? this.parseIdent() : null), this.parseFunctionParams(g), this.parseFunctionBody(g, ue, !1, Ie), this.yieldPos = nt, this.awaitPos = dt, this.awaitIdentPos = zt, this.finishNode(g, V & E ? "FunctionDeclaration" : "FunctionExpression");
      }, p.parseFunctionParams = function(g) {
        this.expect(X.parenL), g.params = this.parseBindingList(X.parenR, !1, this.options.ecmaVersion >= 8), this.checkYieldAwaitInDefaultParams();
      }, p.parseClass = function(g, V) {
        this.next();
        var ue = this.strict;
        this.strict = !0, this.parseClassId(g, V), this.parseClassSuper(g);
        var ye = this.enterClassBody(), Ie = this.startNode(), nt = !1;
        for (Ie.body = [], this.expect(X.braceL); this.type !== X.braceR; ) {
          var dt = this.parseClassElement(g.superClass !== null);
          dt && (Ie.body.push(dt), dt.type === "MethodDefinition" && dt.kind === "constructor" ? (nt && this.raiseRecoverable(dt.start, "Duplicate constructor in the same class"), nt = !0) : dt.key && dt.key.type === "PrivateIdentifier" && G(ye, dt) && this.raiseRecoverable(dt.key.start, "Identifier '#" + dt.key.name + "' has already been declared"));
        }
        return this.strict = ue, this.next(), g.body = this.finishNode(Ie, "ClassBody"), this.exitClassBody(), this.finishNode(g, V ? "ClassDeclaration" : "ClassExpression");
      }, p.parseClassElement = function(g) {
        if (this.eat(X.semi))
          return null;
        var V = this.options.ecmaVersion, ue = this.startNode(), ye = "", Ie = !1, nt = !1, dt = "method", zt = !1;
        if (this.eatContextual("static")) {
          if (V >= 13 && this.eat(X.braceL))
            return this.parseClassStaticBlock(ue), ue;
          this.isClassElementNameStart() || this.type === X.star ? zt = !0 : ye = "static";
        }
        if (ue.static = zt, !ye && V >= 8 && this.eatContextual("async") && ((this.isClassElementNameStart() || this.type === X.star) && !this.canInsertSemicolon() ? nt = !0 : ye = "async"), !ye && (V >= 9 || !nt) && this.eat(X.star) && (Ie = !0), !ye && !nt && !Ie) {
          var Xt = this.value;
          (this.eatContextual("get") || this.eatContextual("set")) && (this.isClassElementNameStart() ? dt = Xt : ye = Xt);
        }
        if (ye ? (ue.computed = !1, ue.key = this.startNodeAt(this.lastTokStart, this.lastTokStartLoc), ue.key.name = ye, this.finishNode(ue.key, "Identifier")) : this.parseClassElementName(ue), V < 13 || this.type === X.parenL || dt !== "method" || Ie || nt) {
          var hi = !ue.static && R(ue, "constructor"), ii = hi && g;
          hi && dt !== "method" && this.raise(ue.key.start, "Constructor can't have get/set modifier"), ue.kind = hi ? "constructor" : dt, this.parseClassMethod(ue, Ie, nt, ii);
        } else
          this.parseClassField(ue);
        return ue;
      }, p.isClassElementNameStart = function() {
        return this.type === X.name || this.type === X.privateId || this.type === X.num || this.type === X.string || this.type === X.bracketL || this.type.keyword;
      }, p.parseClassElementName = function(g) {
        this.type === X.privateId ? (this.value === "constructor" && this.raise(this.start, "Classes can't have an element named '#constructor'"), g.computed = !1, g.key = this.parsePrivateIdent()) : this.parsePropertyName(g);
      }, p.parseClassMethod = function(g, V, ue, ye) {
        var Ie = g.key;
        g.kind === "constructor" ? (V && this.raise(Ie.start, "Constructor can't be a generator"), ue && this.raise(Ie.start, "Constructor can't be an async method")) : g.static && R(g, "prototype") && this.raise(Ie.start, "Classes may not have a static property named prototype");
        var nt = g.value = this.parseMethod(V, ue, ye);
        return g.kind === "get" && nt.params.length !== 0 && this.raiseRecoverable(nt.start, "getter should have no params"), g.kind === "set" && nt.params.length !== 1 && this.raiseRecoverable(nt.start, "setter should have exactly one param"), g.kind === "set" && nt.params[0].type === "RestElement" && this.raiseRecoverable(nt.params[0].start, "Setter cannot use rest params"), this.finishNode(g, "MethodDefinition");
      }, p.parseClassField = function(g) {
        return R(g, "constructor") ? this.raise(g.key.start, "Classes can't have a field named 'constructor'") : g.static && R(g, "prototype") && this.raise(g.key.start, "Classes can't have a static field named 'prototype'"), this.eat(X.eq) ? (this.enterScope(Ee | Ct), g.value = this.parseMaybeAssign(), this.exitScope()) : g.value = null, this.semicolon(), this.finishNode(g, "PropertyDefinition");
      }, p.parseClassStaticBlock = function(g) {
        g.body = [];
        var V = this.labels;
        for (this.labels = [], this.enterScope(Re | Ct); this.type !== X.braceR; ) {
          var ue = this.parseStatement(null);
          g.body.push(ue);
        }
        return this.next(), this.exitScope(), this.labels = V, this.finishNode(g, "StaticBlock");
      }, p.parseClassId = function(g, V) {
        this.type === X.name ? (g.id = this.parseIdent(), V && this.checkLValSimple(g.id, Gt, !1)) : (V === !0 && this.unexpected(), g.id = null);
      }, p.parseClassSuper = function(g) {
        g.superClass = this.eat(X._extends) ? this.parseExprSubscripts(null, !1) : null;
      }, p.enterClassBody = function() {
        var g = { declared: /* @__PURE__ */ Object.create(null), used: [] };
        return this.privateNameStack.push(g), g.declared;
      }, p.exitClassBody = function() {
        var g = this.privateNameStack.pop(), V = g.declared, ue = g.used;
        if (this.options.checkPrivateFields)
          for (var ye = this.privateNameStack.length, Ie = ye === 0 ? null : this.privateNameStack[ye - 1], nt = 0; nt < ue.length; ++nt) {
            var dt = ue[nt];
            De(V, dt.name) || (Ie ? Ie.used.push(dt) : this.raiseRecoverable(dt.start, "Private field '#" + dt.name + "' must be declared in an enclosing class"));
          }
      };
      function G(g, V) {
        var ue = V.key.name, ye = g[ue], Ie = "true";
        return V.type === "MethodDefinition" && (V.kind === "get" || V.kind === "set") && (Ie = (V.static ? "s" : "i") + V.kind), ye === "iget" && Ie === "iset" || ye === "iset" && Ie === "iget" || ye === "sget" && Ie === "sset" || ye === "sset" && Ie === "sget" ? (g[ue] = "true", !1) : ye ? !0 : (g[ue] = Ie, !1);
      }
      function R(g, V) {
        var ue = g.computed, ye = g.key;
        return !ue && (ye.type === "Identifier" && ye.name === V || ye.type === "Literal" && ye.value === V);
      }
      p.parseExportAllDeclaration = function(g, V) {
        return this.options.ecmaVersion >= 11 && (this.eatContextual("as") ? (g.exported = this.parseModuleExportName(), this.checkExport(V, g.exported, this.lastTokStart)) : g.exported = null), this.expectContextual("from"), this.type !== X.string && this.unexpected(), g.source = this.parseExprAtom(), this.options.ecmaVersion >= 16 && (g.attributes = this.parseWithClause()), this.semicolon(), this.finishNode(g, "ExportAllDeclaration");
      }, p.parseExport = function(g, V) {
        if (this.next(), this.eat(X.star))
          return this.parseExportAllDeclaration(g, V);
        if (this.eat(X._default))
          return this.checkExport(V, "default", this.lastTokStart), g.declaration = this.parseExportDefaultDeclaration(), this.finishNode(g, "ExportDefaultDeclaration");
        if (this.shouldParseExportStatement())
          g.declaration = this.parseExportDeclaration(g), g.declaration.type === "VariableDeclaration" ? this.checkVariableExport(V, g.declaration.declarations) : this.checkExport(V, g.declaration.id, g.declaration.id.start), g.specifiers = [], g.source = null, this.options.ecmaVersion >= 16 && (g.attributes = []);
        else {
          if (g.declaration = null, g.specifiers = this.parseExportSpecifiers(V), this.eatContextual("from"))
            this.type !== X.string && this.unexpected(), g.source = this.parseExprAtom(), this.options.ecmaVersion >= 16 && (g.attributes = this.parseWithClause());
          else {
            for (var ue = 0, ye = g.specifiers; ue < ye.length; ue += 1) {
              var Ie = ye[ue];
              this.checkUnreserved(Ie.local), this.checkLocalExport(Ie.local), Ie.local.type === "Literal" && this.raise(Ie.local.start, "A string literal cannot be used as an exported binding without `from`.");
            }
            g.source = null, this.options.ecmaVersion >= 16 && (g.attributes = []);
          }
          this.semicolon();
        }
        return this.finishNode(g, "ExportNamedDeclaration");
      }, p.parseExportDeclaration = function(g) {
        return this.parseStatement(null);
      }, p.parseExportDefaultDeclaration = function() {
        var g;
        if (this.type === X._function || (g = this.isAsyncFunction())) {
          var V = this.startNode();
          return this.next(), g && this.next(), this.parseFunction(V, E | T, !1, g);
        } else if (this.type === X._class) {
          var ue = this.startNode();
          return this.parseClass(ue, "nullableID");
        } else {
          var ye = this.parseMaybeAssign();
          return this.semicolon(), ye;
        }
      }, p.checkExport = function(g, V, ue) {
        g && (typeof V != "string" && (V = V.type === "Identifier" ? V.name : V.value), De(g, V) && this.raiseRecoverable(ue, "Duplicate export '" + V + "'"), g[V] = !0);
      }, p.checkPatternExport = function(g, V) {
        var ue = V.type;
        if (ue === "Identifier")
          this.checkExport(g, V, V.start);
        else if (ue === "ObjectPattern")
          for (var ye = 0, Ie = V.properties; ye < Ie.length; ye += 1) {
            var nt = Ie[ye];
            this.checkPatternExport(g, nt);
          }
        else if (ue === "ArrayPattern")
          for (var dt = 0, zt = V.elements; dt < zt.length; dt += 1) {
            var Xt = zt[dt];
            Xt && this.checkPatternExport(g, Xt);
          }
        else
          ue === "Property" ? this.checkPatternExport(g, V.value) : ue === "AssignmentPattern" ? this.checkPatternExport(g, V.left) : ue === "RestElement" && this.checkPatternExport(g, V.argument);
      }, p.checkVariableExport = function(g, V) {
        if (g)
          for (var ue = 0, ye = V; ue < ye.length; ue += 1) {
            var Ie = ye[ue];
            this.checkPatternExport(g, Ie.id);
          }
      }, p.shouldParseExportStatement = function() {
        return this.type.keyword === "var" || this.type.keyword === "const" || this.type.keyword === "class" || this.type.keyword === "function" || this.isLet() || this.isAsyncFunction();
      }, p.parseExportSpecifier = function(g) {
        var V = this.startNode();
        return V.local = this.parseModuleExportName(), V.exported = this.eatContextual("as") ? this.parseModuleExportName() : V.local, this.checkExport(
          g,
          V.exported,
          V.exported.start
        ), this.finishNode(V, "ExportSpecifier");
      }, p.parseExportSpecifiers = function(g) {
        var V = [], ue = !0;
        for (this.expect(X.braceL); !this.eat(X.braceR); ) {
          if (ue)
            ue = !1;
          else if (this.expect(X.comma), this.afterTrailingComma(X.braceR))
            break;
          V.push(this.parseExportSpecifier(g));
        }
        return V;
      }, p.parseImport = function(g) {
        return this.next(), this.type === X.string ? (g.specifiers = L, g.source = this.parseExprAtom()) : (g.specifiers = this.parseImportSpecifiers(), this.expectContextual("from"), g.source = this.type === X.string ? this.parseExprAtom() : this.unexpected()), this.options.ecmaVersion >= 16 && (g.attributes = this.parseWithClause()), this.semicolon(), this.finishNode(g, "ImportDeclaration");
      }, p.parseImportSpecifier = function() {
        var g = this.startNode();
        return g.imported = this.parseModuleExportName(), this.eatContextual("as") ? g.local = this.parseIdent() : (this.checkUnreserved(g.imported), g.local = g.imported), this.checkLValSimple(g.local, Gt), this.finishNode(g, "ImportSpecifier");
      }, p.parseImportDefaultSpecifier = function() {
        var g = this.startNode();
        return g.local = this.parseIdent(), this.checkLValSimple(g.local, Gt), this.finishNode(g, "ImportDefaultSpecifier");
      }, p.parseImportNamespaceSpecifier = function() {
        var g = this.startNode();
        return this.next(), this.expectContextual("as"), g.local = this.parseIdent(), this.checkLValSimple(g.local, Gt), this.finishNode(g, "ImportNamespaceSpecifier");
      }, p.parseImportSpecifiers = function() {
        var g = [], V = !0;
        if (this.type === X.name && (g.push(this.parseImportDefaultSpecifier()), !this.eat(X.comma)))
          return g;
        if (this.type === X.star)
          return g.push(this.parseImportNamespaceSpecifier()), g;
        for (this.expect(X.braceL); !this.eat(X.braceR); ) {
          if (V)
            V = !1;
          else if (this.expect(X.comma), this.afterTrailingComma(X.braceR))
            break;
          g.push(this.parseImportSpecifier());
        }
        return g;
      }, p.parseWithClause = function() {
        var g = [];
        if (!this.eat(X._with))
          return g;
        this.expect(X.braceL);
        for (var V = {}, ue = !0; !this.eat(X.braceR); ) {
          if (ue)
            ue = !1;
          else if (this.expect(X.comma), this.afterTrailingComma(X.braceR))
            break;
          var ye = this.parseImportAttribute(), Ie = ye.key.type === "Identifier" ? ye.key.name : ye.key.value;
          De(V, Ie) && this.raiseRecoverable(ye.key.start, "Duplicate attribute key '" + Ie + "'"), V[Ie] = !0, g.push(ye);
        }
        return g;
      }, p.parseImportAttribute = function() {
        var g = this.startNode();
        return g.key = this.type === X.string ? this.parseExprAtom() : this.parseIdent(this.options.allowReserved !== "never"), this.expect(X.colon), this.type !== X.string && this.unexpected(), g.value = this.parseExprAtom(), this.finishNode(g, "ImportAttribute");
      }, p.parseModuleExportName = function() {
        if (this.options.ecmaVersion >= 13 && this.type === X.string) {
          var g = this.parseLiteral(this.value);
          return rt.test(g.value) && this.raise(g.start, "An export name cannot include a lone surrogate."), g;
        }
        return this.parseIdent(!0);
      }, p.adaptDirectivePrologue = function(g) {
        for (var V = 0; V < g.length && this.isDirectiveCandidate(g[V]); ++V)
          g[V].directive = g[V].expression.raw.slice(1, -1);
      }, p.isDirectiveCandidate = function(g) {
        return this.options.ecmaVersion >= 5 && g.type === "ExpressionStatement" && g.expression.type === "Literal" && typeof g.expression.value == "string" && // Reject parenthesized strings.
        (this.input[g.start] === '"' || this.input[g.start] === "'");
      };
      var Y = a.prototype;
      Y.toAssignable = function(g, V, ue) {
        if (this.options.ecmaVersion >= 6 && g)
          switch (g.type) {
            case "Identifier":
              this.inAsync && g.name === "await" && this.raise(g.start, "Cannot use 'await' as identifier inside an async function");
              break;
            case "ObjectPattern":
            case "ArrayPattern":
            case "AssignmentPattern":
            case "RestElement":
              break;
            case "ObjectExpression":
              g.type = "ObjectPattern", ue && this.checkPatternErrors(ue, !0);
              for (var ye = 0, Ie = g.properties; ye < Ie.length; ye += 1) {
                var nt = Ie[ye];
                this.toAssignable(nt, V), nt.type === "RestElement" && (nt.argument.type === "ArrayPattern" || nt.argument.type === "ObjectPattern") && this.raise(nt.argument.start, "Unexpected token");
              }
              break;
            case "Property":
              g.kind !== "init" && this.raise(g.key.start, "Object pattern can't contain getter or setter"), this.toAssignable(g.value, V);
              break;
            case "ArrayExpression":
              g.type = "ArrayPattern", ue && this.checkPatternErrors(ue, !0), this.toAssignableList(g.elements, V);
              break;
            case "SpreadElement":
              g.type = "RestElement", this.toAssignable(g.argument, V), g.argument.type === "AssignmentPattern" && this.raise(g.argument.start, "Rest elements cannot have a default value");
              break;
            case "AssignmentExpression":
              g.operator !== "=" && this.raise(g.left.end, "Only '=' operator can be used for specifying default value."), g.type = "AssignmentPattern", delete g.operator, this.toAssignable(g.left, V);
              break;
            case "ParenthesizedExpression":
              this.toAssignable(g.expression, V, ue);
              break;
            case "ChainExpression":
              this.raiseRecoverable(g.start, "Optional chaining cannot appear in left-hand side");
              break;
            case "MemberExpression":
              if (!V)
                break;
            default:
              this.raise(g.start, "Assigning to rvalue");
          }
        else
          ue && this.checkPatternErrors(ue, !0);
        return g;
      }, Y.toAssignableList = function(g, V) {
        for (var ue = g.length, ye = 0; ye < ue; ye++) {
          var Ie = g[ye];
          Ie && this.toAssignable(Ie, V);
        }
        if (ue) {
          var nt = g[ue - 1];
          this.options.ecmaVersion === 6 && V && nt && nt.type === "RestElement" && nt.argument.type !== "Identifier" && this.unexpected(nt.argument.start);
        }
        return g;
      }, Y.parseSpread = function(g) {
        var V = this.startNode();
        return this.next(), V.argument = this.parseMaybeAssign(!1, g), this.finishNode(V, "SpreadElement");
      }, Y.parseRestBinding = function() {
        var g = this.startNode();
        return this.next(), this.options.ecmaVersion === 6 && this.type !== X.name && this.unexpected(), g.argument = this.parseBindingAtom(), this.finishNode(g, "RestElement");
      }, Y.parseBindingAtom = function() {
        if (this.options.ecmaVersion >= 6)
          switch (this.type) {
            case X.bracketL:
              var g = this.startNode();
              return this.next(), g.elements = this.parseBindingList(X.bracketR, !0, !0), this.finishNode(g, "ArrayPattern");
            case X.braceL:
              return this.parseObj(!0);
          }
        return this.parseIdent();
      }, Y.parseBindingList = function(g, V, ue, ye) {
        for (var Ie = [], nt = !0; !this.eat(g); )
          if (nt ? nt = !1 : this.expect(X.comma), V && this.type === X.comma)
            Ie.push(null);
          else {
            if (ue && this.afterTrailingComma(g))
              break;
            if (this.type === X.ellipsis) {
              var dt = this.parseRestBinding();
              this.parseBindingListItem(dt), Ie.push(dt), this.type === X.comma && this.raiseRecoverable(this.start, "Comma is not permitted after the rest element"), this.expect(g);
              break;
            } else
              Ie.push(this.parseAssignableListItem(ye));
          }
        return Ie;
      }, Y.parseAssignableListItem = function(g) {
        var V = this.parseMaybeDefault(this.start, this.startLoc);
        return this.parseBindingListItem(V), V;
      }, Y.parseBindingListItem = function(g) {
        return g;
      }, Y.parseMaybeDefault = function(g, V, ue) {
        if (ue = ue || this.parseBindingAtom(), this.options.ecmaVersion < 6 || !this.eat(X.eq))
          return ue;
        var ye = this.startNodeAt(g, V);
        return ye.left = ue, ye.right = this.parseMaybeAssign(), this.finishNode(ye, "AssignmentPattern");
      }, Y.checkLValSimple = function(g, V, ue) {
        V === void 0 && (V = Qe);
        var ye = V !== Qe;
        switch (g.type) {
          case "Identifier":
            this.strict && this.reservedWordsStrictBind.test(g.name) && this.raiseRecoverable(g.start, (ye ? "Binding " : "Assigning to ") + g.name + " in strict mode"), ye && (V === Gt && g.name === "let" && this.raiseRecoverable(g.start, "let is disallowed as a lexically bound name"), ue && (De(ue, g.name) && this.raiseRecoverable(g.start, "Argument name clash"), ue[g.name] = !0), V !== r && this.declareName(g.name, V, g.start));
            break;
          case "ChainExpression":
            this.raiseRecoverable(g.start, "Optional chaining cannot appear in left-hand side");
            break;
          case "MemberExpression":
            ye && this.raiseRecoverable(g.start, "Binding member expression");
            break;
          case "ParenthesizedExpression":
            return ye && this.raiseRecoverable(g.start, "Binding parenthesized expression"), this.checkLValSimple(g.expression, V, ue);
          default:
            this.raise(g.start, (ye ? "Binding" : "Assigning to") + " rvalue");
        }
      }, Y.checkLValPattern = function(g, V, ue) {
        switch (V === void 0 && (V = Qe), g.type) {
          case "ObjectPattern":
            for (var ye = 0, Ie = g.properties; ye < Ie.length; ye += 1) {
              var nt = Ie[ye];
              this.checkLValInnerPattern(nt, V, ue);
            }
            break;
          case "ArrayPattern":
            for (var dt = 0, zt = g.elements; dt < zt.length; dt += 1) {
              var Xt = zt[dt];
              Xt && this.checkLValInnerPattern(Xt, V, ue);
            }
            break;
          default:
            this.checkLValSimple(g, V, ue);
        }
      }, Y.checkLValInnerPattern = function(g, V, ue) {
        switch (V === void 0 && (V = Qe), g.type) {
          case "Property":
            this.checkLValInnerPattern(g.value, V, ue);
            break;
          case "AssignmentPattern":
            this.checkLValPattern(g.left, V, ue);
            break;
          case "RestElement":
            this.checkLValPattern(g.argument, V, ue);
            break;
          default:
            this.checkLValPattern(g, V, ue);
        }
      };
      var k = function(V, ue, ye, Ie, nt) {
        this.token = V, this.isExpr = !!ue, this.preserveSpace = !!ye, this.override = Ie, this.generator = !!nt;
      }, z = {
        b_stat: new k("{", !1),
        b_expr: new k("{", !0),
        b_tmpl: new k("${", !1),
        p_stat: new k("(", !1),
        p_expr: new k("(", !0),
        q_tmpl: new k("`", !0, !0, function(g) {
          return g.tryReadTemplateToken();
        }),
        f_stat: new k("function", !1),
        f_expr: new k("function", !0),
        f_expr_gen: new k("function", !0, !1, null, !0),
        f_gen: new k("function", !1, !1, null, !0)
      }, C = a.prototype;
      C.initialContext = function() {
        return [z.b_stat];
      }, C.curContext = function() {
        return this.context[this.context.length - 1];
      }, C.braceIsBlock = function(g) {
        var V = this.curContext();
        return V === z.f_expr || V === z.f_stat ? !0 : g === X.colon && (V === z.b_stat || V === z.b_expr) ? !V.isExpr : g === X._return || g === X.name && this.exprAllowed ? W.test(this.input.slice(this.lastTokEnd, this.start)) : g === X._else || g === X.semi || g === X.eof || g === X.parenR || g === X.arrow ? !0 : g === X.braceL ? V === z.b_stat : g === X._var || g === X._const || g === X.name ? !1 : !this.exprAllowed;
      }, C.inGeneratorContext = function() {
        for (var g = this.context.length - 1; g >= 1; g--) {
          var V = this.context[g];
          if (V.token === "function")
            return V.generator;
        }
        return !1;
      }, C.updateContext = function(g) {
        var V, ue = this.type;
        ue.keyword && g === X.dot ? this.exprAllowed = !1 : (V = ue.updateContext) ? V.call(this, g) : this.exprAllowed = ue.beforeExpr;
      }, C.overrideContext = function(g) {
        this.curContext() !== g && (this.context[this.context.length - 1] = g);
      }, X.parenR.updateContext = X.braceR.updateContext = function() {
        if (this.context.length === 1) {
          this.exprAllowed = !0;
          return;
        }
        var g = this.context.pop();
        g === z.b_stat && this.curContext().token === "function" && (g = this.context.pop()), this.exprAllowed = !g.isExpr;
      }, X.braceL.updateContext = function(g) {
        this.context.push(this.braceIsBlock(g) ? z.b_stat : z.b_expr), this.exprAllowed = !0;
      }, X.dollarBraceL.updateContext = function() {
        this.context.push(z.b_tmpl), this.exprAllowed = !0;
      }, X.parenL.updateContext = function(g) {
        var V = g === X._if || g === X._for || g === X._with || g === X._while;
        this.context.push(V ? z.p_stat : z.p_expr), this.exprAllowed = !0;
      }, X.incDec.updateContext = function() {
      }, X._function.updateContext = X._class.updateContext = function(g) {
        g.beforeExpr && g !== X._else && !(g === X.semi && this.curContext() !== z.p_stat) && !(g === X._return && W.test(this.input.slice(this.lastTokEnd, this.start))) && !((g === X.colon || g === X.braceL) && this.curContext() === z.b_stat) ? this.context.push(z.f_expr) : this.context.push(z.f_stat), this.exprAllowed = !1;
      }, X.colon.updateContext = function() {
        this.curContext().token === "function" && this.context.pop(), this.exprAllowed = !0;
      }, X.backQuote.updateContext = function() {
        this.curContext() === z.q_tmpl ? this.context.pop() : this.context.push(z.q_tmpl), this.exprAllowed = !1;
      }, X.star.updateContext = function(g) {
        if (g === X._function) {
          var V = this.context.length - 1;
          this.context[V] === z.f_expr ? this.context[V] = z.f_expr_gen : this.context[V] = z.f_gen;
        }
        this.exprAllowed = !0;
      }, X.name.updateContext = function(g) {
        var V = !1;
        this.options.ecmaVersion >= 6 && g !== X.dot && (this.value === "of" && !this.exprAllowed || this.value === "yield" && this.inGeneratorContext()) && (V = !0), this.exprAllowed = V;
      };
      var I = a.prototype;
      I.checkPropClash = function(g, V, ue) {
        if (!(this.options.ecmaVersion >= 9 && g.type === "SpreadElement") && !(this.options.ecmaVersion >= 6 && (g.computed || g.method || g.shorthand))) {
          var ye = g.key, Ie;
          switch (ye.type) {
            case "Identifier":
              Ie = ye.name;
              break;
            case "Literal":
              Ie = String(ye.value);
              break;
            default:
              return;
          }
          var nt = g.kind;
          if (this.options.ecmaVersion >= 6) {
            Ie === "__proto__" && nt === "init" && (V.proto && (ue ? ue.doubleProto < 0 && (ue.doubleProto = ye.start) : this.raiseRecoverable(ye.start, "Redefinition of __proto__ property")), V.proto = !0);
            return;
          }
          Ie = "$" + Ie;
          var dt = V[Ie];
          if (dt) {
            var zt;
            nt === "init" ? zt = this.strict && dt.init || dt.get || dt.set : zt = dt.init || dt[nt], zt && this.raiseRecoverable(ye.start, "Redefinition of property");
          } else
            dt = V[Ie] = {
              init: !1,
              get: !1,
              set: !1
            };
          dt[nt] = !0;
        }
      }, I.parseExpression = function(g, V) {
        var ue = this.start, ye = this.startLoc, Ie = this.parseMaybeAssign(g, V);
        if (this.type === X.comma) {
          var nt = this.startNodeAt(ue, ye);
          for (nt.expressions = [Ie]; this.eat(X.comma); )
            nt.expressions.push(this.parseMaybeAssign(g, V));
          return this.finishNode(nt, "SequenceExpression");
        }
        return Ie;
      }, I.parseMaybeAssign = function(g, V, ue) {
        if (this.isContextual("yield")) {
          if (this.inGenerator)
            return this.parseYield(g);
          this.exprAllowed = !1;
        }
        var ye = !1, Ie = -1, nt = -1, dt = -1;
        V ? (Ie = V.parenthesizedAssign, nt = V.trailingComma, dt = V.doubleProto, V.parenthesizedAssign = V.trailingComma = -1) : (V = new v(), ye = !0);
        var zt = this.start, Xt = this.startLoc;
        (this.type === X.parenL || this.type === X.name) && (this.potentialArrowAt = this.start, this.potentialArrowInForAwait = g === "await");
        var hi = this.parseMaybeConditional(g, V);
        if (ue && (hi = ue.call(this, hi, zt, Xt)), this.type.isAssign) {
          var ii = this.startNodeAt(zt, Xt);
          return ii.operator = this.value, this.type === X.eq && (hi = this.toAssignable(hi, !1, V)), ye || (V.parenthesizedAssign = V.trailingComma = V.doubleProto = -1), V.shorthandAssign >= hi.start && (V.shorthandAssign = -1), this.type === X.eq ? this.checkLValPattern(hi) : this.checkLValSimple(hi), ii.left = hi, this.next(), ii.right = this.parseMaybeAssign(g), dt > -1 && (V.doubleProto = dt), this.finishNode(ii, "AssignmentExpression");
        } else
          ye && this.checkExpressionErrors(V, !0);
        return Ie > -1 && (V.parenthesizedAssign = Ie), nt > -1 && (V.trailingComma = nt), hi;
      }, I.parseMaybeConditional = function(g, V) {
        var ue = this.start, ye = this.startLoc, Ie = this.parseExprOps(g, V);
        if (this.checkExpressionErrors(V))
          return Ie;
        if (this.eat(X.question)) {
          var nt = this.startNodeAt(ue, ye);
          return nt.test = Ie, nt.consequent = this.parseMaybeAssign(), this.expect(X.colon), nt.alternate = this.parseMaybeAssign(g), this.finishNode(nt, "ConditionalExpression");
        }
        return Ie;
      }, I.parseExprOps = function(g, V) {
        var ue = this.start, ye = this.startLoc, Ie = this.parseMaybeUnary(V, !1, !1, g);
        return this.checkExpressionErrors(V) || Ie.start === ue && Ie.type === "ArrowFunctionExpression" ? Ie : this.parseExprOp(Ie, ue, ye, -1, g);
      }, I.parseExprOp = function(g, V, ue, ye, Ie) {
        var nt = this.type.binop;
        if (nt != null && (!Ie || this.type !== X._in) && nt > ye) {
          var dt = this.type === X.logicalOR || this.type === X.logicalAND, zt = this.type === X.coalesce;
          zt && (nt = X.logicalAND.binop);
          var Xt = this.value;
          this.next();
          var hi = this.start, ii = this.startLoc, oi = this.parseExprOp(this.parseMaybeUnary(null, !1, !1, Ie), hi, ii, nt, Ie), vn = this.buildBinary(V, ue, g, oi, Xt, dt || zt);
          return (dt && this.type === X.coalesce || zt && (this.type === X.logicalOR || this.type === X.logicalAND)) && this.raiseRecoverable(this.start, "Logical expressions and coalesce expressions cannot be mixed. Wrap either by parentheses"), this.parseExprOp(vn, V, ue, ye, Ie);
        }
        return g;
      }, I.buildBinary = function(g, V, ue, ye, Ie, nt) {
        ye.type === "PrivateIdentifier" && this.raise(ye.start, "Private identifier can only be left side of binary expression");
        var dt = this.startNodeAt(g, V);
        return dt.left = ue, dt.operator = Ie, dt.right = ye, this.finishNode(dt, nt ? "LogicalExpression" : "BinaryExpression");
      }, I.parseMaybeUnary = function(g, V, ue, ye) {
        var Ie = this.start, nt = this.startLoc, dt;
        if (this.isContextual("await") && this.canAwait)
          dt = this.parseAwait(ye), V = !0;
        else if (this.type.prefix) {
          var zt = this.startNode(), Xt = this.type === X.incDec;
          zt.operator = this.value, zt.prefix = !0, this.next(), zt.argument = this.parseMaybeUnary(null, !0, Xt, ye), this.checkExpressionErrors(g, !0), Xt ? this.checkLValSimple(zt.argument) : this.strict && zt.operator === "delete" && j(zt.argument) ? this.raiseRecoverable(zt.start, "Deleting local variable in strict mode") : zt.operator === "delete" && q(zt.argument) ? this.raiseRecoverable(zt.start, "Private fields can not be deleted") : V = !0, dt = this.finishNode(zt, Xt ? "UpdateExpression" : "UnaryExpression");
        } else if (!V && this.type === X.privateId)
          (ye || this.privateNameStack.length === 0) && this.options.checkPrivateFields && this.unexpected(), dt = this.parsePrivateIdent(), this.type !== X._in && this.unexpected();
        else {
          if (dt = this.parseExprSubscripts(g, ye), this.checkExpressionErrors(g))
            return dt;
          for (; this.type.postfix && !this.canInsertSemicolon(); ) {
            var hi = this.startNodeAt(Ie, nt);
            hi.operator = this.value, hi.prefix = !1, hi.argument = dt, this.checkLValSimple(dt), this.next(), dt = this.finishNode(hi, "UpdateExpression");
          }
        }
        if (!ue && this.eat(X.starstar))
          if (V)
            this.unexpected(this.lastTokStart);
          else
            return this.buildBinary(Ie, nt, dt, this.parseMaybeUnary(null, !1, !1, ye), "**", !1);
        else
          return dt;
      };
      function j(g) {
        return g.type === "Identifier" || g.type === "ParenthesizedExpression" && j(g.expression);
      }
      function q(g) {
        return g.type === "MemberExpression" && g.property.type === "PrivateIdentifier" || g.type === "ChainExpression" && q(g.expression) || g.type === "ParenthesizedExpression" && q(g.expression);
      }
      I.parseExprSubscripts = function(g, V) {
        var ue = this.start, ye = this.startLoc, Ie = this.parseExprAtom(g, V);
        if (Ie.type === "ArrowFunctionExpression" && this.input.slice(this.lastTokStart, this.lastTokEnd) !== ")")
          return Ie;
        var nt = this.parseSubscripts(Ie, ue, ye, !1, V);
        return g && nt.type === "MemberExpression" && (g.parenthesizedAssign >= nt.start && (g.parenthesizedAssign = -1), g.parenthesizedBind >= nt.start && (g.parenthesizedBind = -1), g.trailingComma >= nt.start && (g.trailingComma = -1)), nt;
      }, I.parseSubscripts = function(g, V, ue, ye, Ie) {
        for (var nt = this.options.ecmaVersion >= 8 && g.type === "Identifier" && g.name === "async" && this.lastTokEnd === g.end && !this.canInsertSemicolon() && g.end - g.start === 5 && this.potentialArrowAt === g.start, dt = !1; ; ) {
          var zt = this.parseSubscript(g, V, ue, ye, nt, dt, Ie);
          if (zt.optional && (dt = !0), zt === g || zt.type === "ArrowFunctionExpression") {
            if (dt) {
              var Xt = this.startNodeAt(V, ue);
              Xt.expression = zt, zt = this.finishNode(Xt, "ChainExpression");
            }
            return zt;
          }
          g = zt;
        }
      }, I.shouldParseAsyncArrow = function() {
        return !this.canInsertSemicolon() && this.eat(X.arrow);
      }, I.parseSubscriptAsyncArrow = function(g, V, ue, ye) {
        return this.parseArrowExpression(this.startNodeAt(g, V), ue, !0, ye);
      }, I.parseSubscript = function(g, V, ue, ye, Ie, nt, dt) {
        var zt = this.options.ecmaVersion >= 11, Xt = zt && this.eat(X.questionDot);
        ye && Xt && this.raise(this.lastTokStart, "Optional chaining cannot appear in the callee of new expressions");
        var hi = this.eat(X.bracketL);
        if (hi || Xt && this.type !== X.parenL && this.type !== X.backQuote || this.eat(X.dot)) {
          var ii = this.startNodeAt(V, ue);
          ii.object = g, hi ? (ii.property = this.parseExpression(), this.expect(X.bracketR)) : this.type === X.privateId && g.type !== "Super" ? ii.property = this.parsePrivateIdent() : ii.property = this.parseIdent(this.options.allowReserved !== "never"), ii.computed = !!hi, zt && (ii.optional = Xt), g = this.finishNode(ii, "MemberExpression");
        } else if (!ye && this.eat(X.parenL)) {
          var oi = new v(), vn = this.yieldPos, rr = this.awaitPos, Tn = this.awaitIdentPos;
          this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0;
          var Sr = this.parseExprList(X.parenR, this.options.ecmaVersion >= 8, !1, oi);
          if (Ie && !Xt && this.shouldParseAsyncArrow())
            return this.checkPatternErrors(oi, !1), this.checkYieldAwaitInDefaultParams(), this.awaitIdentPos > 0 && this.raise(this.awaitIdentPos, "Cannot use 'await' as identifier inside an async function"), this.yieldPos = vn, this.awaitPos = rr, this.awaitIdentPos = Tn, this.parseSubscriptAsyncArrow(V, ue, Sr, dt);
          this.checkExpressionErrors(oi, !0), this.yieldPos = vn || this.yieldPos, this.awaitPos = rr || this.awaitPos, this.awaitIdentPos = Tn || this.awaitIdentPos;
          var Mr = this.startNodeAt(V, ue);
          Mr.callee = g, Mr.arguments = Sr, zt && (Mr.optional = Xt), g = this.finishNode(Mr, "CallExpression");
        } else if (this.type === X.backQuote) {
          (Xt || nt) && this.raise(this.start, "Optional chaining cannot appear in the tag of tagged template expressions");
          var sr = this.startNodeAt(V, ue);
          sr.tag = g, sr.quasi = this.parseTemplate({ isTagged: !0 }), g = this.finishNode(sr, "TaggedTemplateExpression");
        }
        return g;
      }, I.parseExprAtom = function(g, V, ue) {
        this.type === X.slash && this.readRegexp();
        var ye, Ie = this.potentialArrowAt === this.start;
        switch (this.type) {
          case X._super:
            return this.allowSuper || this.raise(this.start, "'super' keyword outside a method"), ye = this.startNode(), this.next(), this.type === X.parenL && !this.allowDirectSuper && this.raise(ye.start, "super() call outside constructor of a subclass"), this.type !== X.dot && this.type !== X.bracketL && this.type !== X.parenL && this.unexpected(), this.finishNode(ye, "Super");
          case X._this:
            return ye = this.startNode(), this.next(), this.finishNode(ye, "ThisExpression");
          case X.name:
            var nt = this.start, dt = this.startLoc, zt = this.containsEsc, Xt = this.parseIdent(!1);
            if (this.options.ecmaVersion >= 8 && !zt && Xt.name === "async" && !this.canInsertSemicolon() && this.eat(X._function))
              return this.overrideContext(z.f_expr), this.parseFunction(this.startNodeAt(nt, dt), 0, !1, !0, V);
            if (Ie && !this.canInsertSemicolon()) {
              if (this.eat(X.arrow))
                return this.parseArrowExpression(this.startNodeAt(nt, dt), [Xt], !1, V);
              if (this.options.ecmaVersion >= 8 && Xt.name === "async" && this.type === X.name && !zt && (!this.potentialArrowInForAwait || this.value !== "of" || this.containsEsc))
                return Xt = this.parseIdent(!1), (this.canInsertSemicolon() || !this.eat(X.arrow)) && this.unexpected(), this.parseArrowExpression(this.startNodeAt(nt, dt), [Xt], !0, V);
            }
            return Xt;
          case X.regexp:
            var hi = this.value;
            return ye = this.parseLiteral(hi.value), ye.regex = { pattern: hi.pattern, flags: hi.flags }, ye;
          case X.num:
          case X.string:
            return this.parseLiteral(this.value);
          case X._null:
          case X._true:
          case X._false:
            return ye = this.startNode(), ye.value = this.type === X._null ? null : this.type === X._true, ye.raw = this.type.keyword, this.next(), this.finishNode(ye, "Literal");
          case X.parenL:
            var ii = this.start, oi = this.parseParenAndDistinguishExpression(Ie, V);
            return g && (g.parenthesizedAssign < 0 && !this.isSimpleAssignTarget(oi) && (g.parenthesizedAssign = ii), g.parenthesizedBind < 0 && (g.parenthesizedBind = ii)), oi;
          case X.bracketL:
            return ye = this.startNode(), this.next(), ye.elements = this.parseExprList(X.bracketR, !0, !0, g), this.finishNode(ye, "ArrayExpression");
          case X.braceL:
            return this.overrideContext(z.b_expr), this.parseObj(!1, g);
          case X._function:
            return ye = this.startNode(), this.next(), this.parseFunction(ye, 0);
          case X._class:
            return this.parseClass(this.startNode(), !1);
          case X._new:
            return this.parseNew();
          case X.backQuote:
            return this.parseTemplate();
          case X._import:
            return this.options.ecmaVersion >= 11 ? this.parseExprImport(ue) : this.unexpected();
          default:
            return this.parseExprAtomDefault();
        }
      }, I.parseExprAtomDefault = function() {
        this.unexpected();
      }, I.parseExprImport = function(g) {
        var V = this.startNode();
        if (this.containsEsc && this.raiseRecoverable(this.start, "Escape sequence in keyword import"), this.next(), this.type === X.parenL && !g)
          return this.parseDynamicImport(V);
        if (this.type === X.dot) {
          var ue = this.startNodeAt(V.start, V.loc && V.loc.start);
          return ue.name = "import", V.meta = this.finishNode(ue, "Identifier"), this.parseImportMeta(V);
        } else
          this.unexpected();
      }, I.parseDynamicImport = function(g) {
        if (this.next(), g.source = this.parseMaybeAssign(), this.options.ecmaVersion >= 16)
          this.eat(X.parenR) ? g.options = null : (this.expect(X.comma), this.afterTrailingComma(X.parenR) ? g.options = null : (g.options = this.parseMaybeAssign(), this.eat(X.parenR) || (this.expect(X.comma), this.afterTrailingComma(X.parenR) || this.unexpected())));
        else if (!this.eat(X.parenR)) {
          var V = this.start;
          this.eat(X.comma) && this.eat(X.parenR) ? this.raiseRecoverable(V, "Trailing comma is not allowed in import()") : this.unexpected(V);
        }
        return this.finishNode(g, "ImportExpression");
      }, I.parseImportMeta = function(g) {
        this.next();
        var V = this.containsEsc;
        return g.property = this.parseIdent(!0), g.property.name !== "meta" && this.raiseRecoverable(g.property.start, "The only valid meta property for import is 'import.meta'"), V && this.raiseRecoverable(g.start, "'import.meta' must not contain escaped characters"), this.options.sourceType !== "module" && !this.options.allowImportExportEverywhere && this.raiseRecoverable(g.start, "Cannot use 'import.meta' outside a module"), this.finishNode(g, "MetaProperty");
      }, I.parseLiteral = function(g) {
        var V = this.startNode();
        return V.value = g, V.raw = this.input.slice(this.start, this.end), V.raw.charCodeAt(V.raw.length - 1) === 110 && (V.bigint = V.value != null ? V.value.toString() : V.raw.slice(0, -1).replace(/_/g, "")), this.next(), this.finishNode(V, "Literal");
      }, I.parseParenExpression = function() {
        this.expect(X.parenL);
        var g = this.parseExpression();
        return this.expect(X.parenR), g;
      }, I.shouldParseArrow = function(g) {
        return !this.canInsertSemicolon();
      }, I.parseParenAndDistinguishExpression = function(g, V) {
        var ue = this.start, ye = this.startLoc, Ie, nt = this.options.ecmaVersion >= 8;
        if (this.options.ecmaVersion >= 6) {
          this.next();
          var dt = this.start, zt = this.startLoc, Xt = [], hi = !0, ii = !1, oi = new v(), vn = this.yieldPos, rr = this.awaitPos, Tn;
          for (this.yieldPos = 0, this.awaitPos = 0; this.type !== X.parenR; )
            if (hi ? hi = !1 : this.expect(X.comma), nt && this.afterTrailingComma(X.parenR, !0)) {
              ii = !0;
              break;
            } else if (this.type === X.ellipsis) {
              Tn = this.start, Xt.push(this.parseParenItem(this.parseRestBinding())), this.type === X.comma && this.raiseRecoverable(
                this.start,
                "Comma is not permitted after the rest element"
              );
              break;
            } else
              Xt.push(this.parseMaybeAssign(!1, oi, this.parseParenItem));
          var Sr = this.lastTokEnd, Mr = this.lastTokEndLoc;
          if (this.expect(X.parenR), g && this.shouldParseArrow(Xt) && this.eat(X.arrow))
            return this.checkPatternErrors(oi, !1), this.checkYieldAwaitInDefaultParams(), this.yieldPos = vn, this.awaitPos = rr, this.parseParenArrowList(ue, ye, Xt, V);
          (!Xt.length || ii) && this.unexpected(this.lastTokStart), Tn && this.unexpected(Tn), this.checkExpressionErrors(oi, !0), this.yieldPos = vn || this.yieldPos, this.awaitPos = rr || this.awaitPos, Xt.length > 1 ? (Ie = this.startNodeAt(dt, zt), Ie.expressions = Xt, this.finishNodeAt(Ie, "SequenceExpression", Sr, Mr)) : Ie = Xt[0];
        } else
          Ie = this.parseParenExpression();
        if (this.options.preserveParens) {
          var sr = this.startNodeAt(ue, ye);
          return sr.expression = Ie, this.finishNode(sr, "ParenthesizedExpression");
        } else
          return Ie;
      }, I.parseParenItem = function(g) {
        return g;
      }, I.parseParenArrowList = function(g, V, ue, ye) {
        return this.parseArrowExpression(this.startNodeAt(g, V), ue, !1, ye);
      };
      var H = [];
      I.parseNew = function() {
        this.containsEsc && this.raiseRecoverable(this.start, "Escape sequence in keyword new");
        var g = this.startNode();
        if (this.next(), this.options.ecmaVersion >= 6 && this.type === X.dot) {
          var V = this.startNodeAt(g.start, g.loc && g.loc.start);
          V.name = "new", g.meta = this.finishNode(V, "Identifier"), this.next();
          var ue = this.containsEsc;
          return g.property = this.parseIdent(!0), g.property.name !== "target" && this.raiseRecoverable(g.property.start, "The only valid meta property for new is 'new.target'"), ue && this.raiseRecoverable(g.start, "'new.target' must not contain escaped characters"), this.allowNewDotTarget || this.raiseRecoverable(g.start, "'new.target' can only be used in functions and class static block"), this.finishNode(g, "MetaProperty");
        }
        var ye = this.start, Ie = this.startLoc;
        return g.callee = this.parseSubscripts(this.parseExprAtom(null, !1, !0), ye, Ie, !0, !1), this.eat(X.parenL) ? g.arguments = this.parseExprList(X.parenR, this.options.ecmaVersion >= 8, !1) : g.arguments = H, this.finishNode(g, "NewExpression");
      }, I.parseTemplateElement = function(g) {
        var V = g.isTagged, ue = this.startNode();
        return this.type === X.invalidTemplate ? (V || this.raiseRecoverable(this.start, "Bad escape sequence in untagged template literal"), ue.value = {
          raw: this.value.replace(/\r\n?/g, `
`),
          cooked: null
        }) : ue.value = {
          raw: this.input.slice(this.start, this.end).replace(/\r\n?/g, `
`),
          cooked: this.value
        }, this.next(), ue.tail = this.type === X.backQuote, this.finishNode(ue, "TemplateElement");
      }, I.parseTemplate = function(g) {
        g === void 0 && (g = {});
        var V = g.isTagged;
        V === void 0 && (V = !1);
        var ue = this.startNode();
        this.next(), ue.expressions = [];
        var ye = this.parseTemplateElement({ isTagged: V });
        for (ue.quasis = [ye]; !ye.tail; )
          this.type === X.eof && this.raise(this.pos, "Unterminated template literal"), this.expect(X.dollarBraceL), ue.expressions.push(this.parseExpression()), this.expect(X.braceR), ue.quasis.push(ye = this.parseTemplateElement({ isTagged: V }));
        return this.next(), this.finishNode(ue, "TemplateLiteral");
      }, I.isAsyncProp = function(g) {
        return !g.computed && g.key.type === "Identifier" && g.key.name === "async" && (this.type === X.name || this.type === X.num || this.type === X.string || this.type === X.bracketL || this.type.keyword || this.options.ecmaVersion >= 9 && this.type === X.star) && !W.test(this.input.slice(this.lastTokEnd, this.start));
      }, I.parseObj = function(g, V) {
        var ue = this.startNode(), ye = !0, Ie = {};
        for (ue.properties = [], this.next(); !this.eat(X.braceR); ) {
          if (ye)
            ye = !1;
          else if (this.expect(X.comma), this.options.ecmaVersion >= 5 && this.afterTrailingComma(X.braceR))
            break;
          var nt = this.parseProperty(g, V);
          g || this.checkPropClash(nt, Ie, V), ue.properties.push(nt);
        }
        return this.finishNode(ue, g ? "ObjectPattern" : "ObjectExpression");
      }, I.parseProperty = function(g, V) {
        var ue = this.startNode(), ye, Ie, nt, dt;
        if (this.options.ecmaVersion >= 9 && this.eat(X.ellipsis))
          return g ? (ue.argument = this.parseIdent(!1), this.type === X.comma && this.raiseRecoverable(this.start, "Comma is not permitted after the rest element"), this.finishNode(ue, "RestElement")) : (ue.argument = this.parseMaybeAssign(!1, V), this.type === X.comma && V && V.trailingComma < 0 && (V.trailingComma = this.start), this.finishNode(ue, "SpreadElement"));
        this.options.ecmaVersion >= 6 && (ue.method = !1, ue.shorthand = !1, (g || V) && (nt = this.start, dt = this.startLoc), g || (ye = this.eat(X.star)));
        var zt = this.containsEsc;
        return this.parsePropertyName(ue), !g && !zt && this.options.ecmaVersion >= 8 && !ye && this.isAsyncProp(ue) ? (Ie = !0, ye = this.options.ecmaVersion >= 9 && this.eat(X.star), this.parsePropertyName(ue)) : Ie = !1, this.parsePropertyValue(ue, g, ye, Ie, nt, dt, V, zt), this.finishNode(ue, "Property");
      }, I.parseGetterSetter = function(g) {
        var V = g.key.name;
        this.parsePropertyName(g), g.value = this.parseMethod(!1), g.kind = V;
        var ue = g.kind === "get" ? 0 : 1;
        if (g.value.params.length !== ue) {
          var ye = g.value.start;
          g.kind === "get" ? this.raiseRecoverable(ye, "getter should have no params") : this.raiseRecoverable(ye, "setter should have exactly one param");
        } else
          g.kind === "set" && g.value.params[0].type === "RestElement" && this.raiseRecoverable(g.value.params[0].start, "Setter cannot use rest params");
      }, I.parsePropertyValue = function(g, V, ue, ye, Ie, nt, dt, zt) {
        (ue || ye) && this.type === X.colon && this.unexpected(), this.eat(X.colon) ? (g.value = V ? this.parseMaybeDefault(this.start, this.startLoc) : this.parseMaybeAssign(!1, dt), g.kind = "init") : this.options.ecmaVersion >= 6 && this.type === X.parenL ? (V && this.unexpected(), g.method = !0, g.value = this.parseMethod(ue, ye), g.kind = "init") : !V && !zt && this.options.ecmaVersion >= 5 && !g.computed && g.key.type === "Identifier" && (g.key.name === "get" || g.key.name === "set") && this.type !== X.comma && this.type !== X.braceR && this.type !== X.eq ? ((ue || ye) && this.unexpected(), this.parseGetterSetter(g)) : this.options.ecmaVersion >= 6 && !g.computed && g.key.type === "Identifier" ? ((ue || ye) && this.unexpected(), this.checkUnreserved(g.key), g.key.name === "await" && !this.awaitIdentPos && (this.awaitIdentPos = Ie), V ? g.value = this.parseMaybeDefault(Ie, nt, this.copyNode(g.key)) : this.type === X.eq && dt ? (dt.shorthandAssign < 0 && (dt.shorthandAssign = this.start), g.value = this.parseMaybeDefault(Ie, nt, this.copyNode(g.key))) : g.value = this.copyNode(g.key), g.kind = "init", g.shorthand = !0) : this.unexpected();
      }, I.parsePropertyName = function(g) {
        if (this.options.ecmaVersion >= 6) {
          if (this.eat(X.bracketL))
            return g.computed = !0, g.key = this.parseMaybeAssign(), this.expect(X.bracketR), g.key;
          g.computed = !1;
        }
        return g.key = this.type === X.num || this.type === X.string ? this.parseExprAtom() : this.parseIdent(this.options.allowReserved !== "never");
      }, I.initFunction = function(g) {
        g.id = null, this.options.ecmaVersion >= 6 && (g.generator = g.expression = !1), this.options.ecmaVersion >= 8 && (g.async = !1);
      }, I.parseMethod = function(g, V, ue) {
        var ye = this.startNode(), Ie = this.yieldPos, nt = this.awaitPos, dt = this.awaitIdentPos;
        return this.initFunction(ye), this.options.ecmaVersion >= 6 && (ye.generator = g), this.options.ecmaVersion >= 8 && (ye.async = !!V), this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, this.enterScope(mt(V, ye.generator) | Ct | (ue ? yt : 0)), this.expect(X.parenL), ye.params = this.parseBindingList(X.parenR, !1, this.options.ecmaVersion >= 8), this.checkYieldAwaitInDefaultParams(), this.parseFunctionBody(ye, !1, !0, !1), this.yieldPos = Ie, this.awaitPos = nt, this.awaitIdentPos = dt, this.finishNode(ye, "FunctionExpression");
      }, I.parseArrowExpression = function(g, V, ue, ye) {
        var Ie = this.yieldPos, nt = this.awaitPos, dt = this.awaitIdentPos;
        return this.enterScope(mt(ue, !1) | Fi), this.initFunction(g), this.options.ecmaVersion >= 8 && (g.async = !!ue), this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, g.params = this.toAssignableList(V, !0), this.parseFunctionBody(g, !0, !1, ye), this.yieldPos = Ie, this.awaitPos = nt, this.awaitIdentPos = dt, this.finishNode(g, "ArrowFunctionExpression");
      }, I.parseFunctionBody = function(g, V, ue, ye) {
        var Ie = V && this.type !== X.braceL, nt = this.strict, dt = !1;
        if (Ie)
          g.body = this.parseMaybeAssign(ye), g.expression = !0, this.checkParams(g, !1);
        else {
          var zt = this.options.ecmaVersion >= 7 && !this.isSimpleParamList(g.params);
          (!nt || zt) && (dt = this.strictDirective(this.end), dt && zt && this.raiseRecoverable(g.start, "Illegal 'use strict' directive in function with non-simple parameter list"));
          var Xt = this.labels;
          this.labels = [], dt && (this.strict = !0), this.checkParams(g, !nt && !dt && !V && !ue && this.isSimpleParamList(g.params)), this.strict && g.id && this.checkLValSimple(g.id, r), g.body = this.parseBlock(!1, void 0, dt && !nt), g.expression = !1, this.adaptDirectivePrologue(g.body.body), this.labels = Xt;
        }
        this.exitScope();
      }, I.isSimpleParamList = function(g) {
        for (var V = 0, ue = g; V < ue.length; V += 1) {
          var ye = ue[V];
          if (ye.type !== "Identifier")
            return !1;
        }
        return !0;
      }, I.checkParams = function(g, V) {
        for (var ue = /* @__PURE__ */ Object.create(null), ye = 0, Ie = g.params; ye < Ie.length; ye += 1) {
          var nt = Ie[ye];
          this.checkLValInnerPattern(nt, bt, V ? null : ue);
        }
      }, I.parseExprList = function(g, V, ue, ye) {
        for (var Ie = [], nt = !0; !this.eat(g); ) {
          if (nt)
            nt = !1;
          else if (this.expect(X.comma), V && this.afterTrailingComma(g))
            break;
          var dt = void 0;
          ue && this.type === X.comma ? dt = null : this.type === X.ellipsis ? (dt = this.parseSpread(ye), ye && this.type === X.comma && ye.trailingComma < 0 && (ye.trailingComma = this.start)) : dt = this.parseMaybeAssign(!1, ye), Ie.push(dt);
        }
        return Ie;
      }, I.checkUnreserved = function(g) {
        var V = g.start, ue = g.end, ye = g.name;
        if (this.inGenerator && ye === "yield" && this.raiseRecoverable(V, "Cannot use 'yield' as identifier inside a generator"), this.inAsync && ye === "await" && this.raiseRecoverable(V, "Cannot use 'await' as identifier inside an async function"), !(this.currentThisScope().flags & kt) && ye === "arguments" && this.raiseRecoverable(V, "Cannot use 'arguments' in class field initializer"), this.inClassStaticBlock && (ye === "arguments" || ye === "await") && this.raise(V, "Cannot use " + ye + " in class static initialization block"), this.keywords.test(ye) && this.raise(V, "Unexpected keyword '" + ye + "'"), !(this.options.ecmaVersion < 6 && this.input.slice(V, ue).indexOf("\\") !== -1)) {
          var Ie = this.strict ? this.reservedWordsStrict : this.reservedWords;
          Ie.test(ye) && (!this.inAsync && ye === "await" && this.raiseRecoverable(V, "Cannot use keyword 'await' outside an async function"), this.raiseRecoverable(V, "The keyword '" + ye + "' is reserved"));
        }
      }, I.parseIdent = function(g) {
        var V = this.parseIdentNode();
        return this.next(!!g), this.finishNode(V, "Identifier"), g || (this.checkUnreserved(V), V.name === "await" && !this.awaitIdentPos && (this.awaitIdentPos = V.start)), V;
      }, I.parseIdentNode = function() {
        var g = this.startNode();
        return this.type === X.name ? g.name = this.value : this.type.keyword ? (g.name = this.type.keyword, (g.name === "class" || g.name === "function") && (this.lastTokEnd !== this.lastTokStart + 1 || this.input.charCodeAt(this.lastTokStart) !== 46) && this.context.pop(), this.type = X.name) : this.unexpected(), g;
      }, I.parsePrivateIdent = function() {
        var g = this.startNode();
        return this.type === X.privateId ? g.name = this.value : this.unexpected(), this.next(), this.finishNode(g, "PrivateIdentifier"), this.options.checkPrivateFields && (this.privateNameStack.length === 0 ? this.raise(g.start, "Private field '#" + g.name + "' must be declared in an enclosing class") : this.privateNameStack[this.privateNameStack.length - 1].used.push(g)), g;
      }, I.parseYield = function(g) {
        this.yieldPos || (this.yieldPos = this.start);
        var V = this.startNode();
        return this.next(), this.type === X.semi || this.canInsertSemicolon() || this.type !== X.star && !this.type.startsExpr ? (V.delegate = !1, V.argument = null) : (V.delegate = this.eat(X.star), V.argument = this.parseMaybeAssign(g)), this.finishNode(V, "YieldExpression");
      }, I.parseAwait = function(g) {
        this.awaitPos || (this.awaitPos = this.start);
        var V = this.startNode();
        return this.next(), V.argument = this.parseMaybeUnary(null, !0, !1, g), this.finishNode(V, "AwaitExpression");
      };
      var ie = a.prototype;
      ie.raise = function(g, V) {
        var ue = qt(this.input, g);
        V += " (" + ue.line + ":" + ue.column + ")", this.sourceFile && (V += " in " + this.sourceFile);
        var ye = new SyntaxError(V);
        throw ye.pos = g, ye.loc = ue, ye.raisedAt = this.pos, ye;
      }, ie.raiseRecoverable = ie.raise, ie.curPosition = function() {
        if (this.options.locations)
          return new tt(this.curLine, this.pos - this.lineStart);
      };
      var ae = a.prototype, he = function(V) {
        this.flags = V, this.var = [], this.lexical = [], this.functions = [];
      };
      ae.enterScope = function(g) {
        this.scopeStack.push(new he(g));
      }, ae.exitScope = function() {
        this.scopeStack.pop();
      }, ae.treatFunctionsAsVarInScope = function(g) {
        return g.flags & $t || !this.inModule && g.flags & Wt;
      }, ae.declareName = function(g, V, ue) {
        var ye = !1;
        if (V === Gt) {
          var Ie = this.currentScope();
          ye = Ie.lexical.indexOf(g) > -1 || Ie.functions.indexOf(g) > -1 || Ie.var.indexOf(g) > -1, Ie.lexical.push(g), this.inModule && Ie.flags & Wt && delete this.undefinedExports[g];
        } else if (V === i) {
          var nt = this.currentScope();
          nt.lexical.push(g);
        } else if (V === He) {
          var dt = this.currentScope();
          this.treatFunctionsAsVar ? ye = dt.lexical.indexOf(g) > -1 : ye = dt.lexical.indexOf(g) > -1 || dt.var.indexOf(g) > -1, dt.functions.push(g);
        } else
          for (var zt = this.scopeStack.length - 1; zt >= 0; --zt) {
            var Xt = this.scopeStack[zt];
            if (Xt.lexical.indexOf(g) > -1 && !(Xt.flags & _e && Xt.lexical[0] === g) || !this.treatFunctionsAsVarInScope(Xt) && Xt.functions.indexOf(g) > -1) {
              ye = !0;
              break;
            }
            if (Xt.var.push(g), this.inModule && Xt.flags & Wt && delete this.undefinedExports[g], Xt.flags & kt)
              break;
          }
        ye && this.raiseRecoverable(ue, "Identifier '" + g + "' has already been declared");
      }, ae.checkLocalExport = function(g) {
        this.scopeStack[0].lexical.indexOf(g.name) === -1 && this.scopeStack[0].var.indexOf(g.name) === -1 && (this.undefinedExports[g.name] = g);
      }, ae.currentScope = function() {
        return this.scopeStack[this.scopeStack.length - 1];
      }, ae.currentVarScope = function() {
        for (var g = this.scopeStack.length - 1; ; g--) {
          var V = this.scopeStack[g];
          if (V.flags & (kt | Ee | Re))
            return V;
        }
      }, ae.currentThisScope = function() {
        for (var g = this.scopeStack.length - 1; ; g--) {
          var V = this.scopeStack[g];
          if (V.flags & (kt | Ee | Re) && !(V.flags & Fi))
            return V;
        }
      };
      var pe = function(V, ue, ye) {
        this.type = "", this.start = ue, this.end = 0, V.options.locations && (this.loc = new Kt(V, ye)), V.options.directSourceFile && (this.sourceFile = V.options.directSourceFile), V.options.ranges && (this.range = [ue, 0]);
      }, se = a.prototype;
      se.startNode = function() {
        return new pe(this, this.start, this.startLoc);
      }, se.startNodeAt = function(g, V) {
        return new pe(this, g, V);
      };
      function de(g, V, ue, ye) {
        return g.type = V, g.end = ue, this.options.locations && (g.loc.end = ye), this.options.ranges && (g.range[1] = ue), g;
      }
      se.finishNode = function(g, V) {
        return de.call(this, g, V, this.lastTokEnd, this.lastTokEndLoc);
      }, se.finishNodeAt = function(g, V, ue, ye) {
        return de.call(this, g, V, ue, ye);
      }, se.copyNode = function(g) {
        var V = new pe(this, g.start, this.startLoc);
        for (var ue in g)
          V[ue] = g[ue];
        return V;
      };
      var ve = "Berf Beria_Erfe Gara Garay Gukh Gurung_Khema Hrkt Katakana_Or_Hiragana Kawi Kirat_Rai Krai Nag_Mundari Nagm Ol_Onal Onao Sidetic Sidt Sunu Sunuwar Tai_Yo Tayo Todhri Todr Tolong_Siki Tols Tulu_Tigalari Tutg Unknown Zzzz", we = "ASCII ASCII_Hex_Digit AHex Alphabetic Alpha Any Assigned Bidi_Control Bidi_C Bidi_Mirrored Bidi_M Case_Ignorable CI Cased Changes_When_Casefolded CWCF Changes_When_Casemapped CWCM Changes_When_Lowercased CWL Changes_When_NFKC_Casefolded CWKCF Changes_When_Titlecased CWT Changes_When_Uppercased CWU Dash Default_Ignorable_Code_Point DI Deprecated Dep Diacritic Dia Emoji Emoji_Component Emoji_Modifier Emoji_Modifier_Base Emoji_Presentation Extender Ext Grapheme_Base Gr_Base Grapheme_Extend Gr_Ext Hex_Digit Hex IDS_Binary_Operator IDSB IDS_Trinary_Operator IDST ID_Continue IDC ID_Start IDS Ideographic Ideo Join_Control Join_C Logical_Order_Exception LOE Lowercase Lower Math Noncharacter_Code_Point NChar Pattern_Syntax Pat_Syn Pattern_White_Space Pat_WS Quotation_Mark QMark Radical Regional_Indicator RI Sentence_Terminal STerm Soft_Dotted SD Terminal_Punctuation Term Unified_Ideograph UIdeo Uppercase Upper Variation_Selector VS White_Space space XID_Continue XIDC XID_Start XIDS", Se = we + " Extended_Pictographic", Ae = Se, Ge = Ae + " EBase EComp EMod EPres ExtPict", Je = Ge, it = Je, gt = {
        9: we,
        10: Se,
        11: Ae,
        12: Ge,
        13: Je,
        14: it
      }, Ne = "Basic_Emoji Emoji_Keycap_Sequence RGI_Emoji_Modifier_Sequence RGI_Emoji_Flag_Sequence RGI_Emoji_Tag_Sequence RGI_Emoji_ZWJ_Sequence RGI_Emoji", Fe = {
        9: "",
        10: "",
        11: "",
        12: "",
        13: "",
        14: Ne
      }, st = "Cased_Letter LC Close_Punctuation Pe Connector_Punctuation Pc Control Cc cntrl Currency_Symbol Sc Dash_Punctuation Pd Decimal_Number Nd digit Enclosing_Mark Me Final_Punctuation Pf Format Cf Initial_Punctuation Pi Letter L Letter_Number Nl Line_Separator Zl Lowercase_Letter Ll Mark M Combining_Mark Math_Symbol Sm Modifier_Letter Lm Modifier_Symbol Sk Nonspacing_Mark Mn Number N Open_Punctuation Ps Other C Other_Letter Lo Other_Number No Other_Punctuation Po Other_Symbol So Paragraph_Separator Zp Private_Use Co Punctuation P punct Separator Z Space_Separator Zs Spacing_Mark Mc Surrogate Cs Symbol S Titlecase_Letter Lt Unassigned Cn Uppercase_Letter Lu", _t = "Adlam Adlm Ahom Anatolian_Hieroglyphs Hluw Arabic Arab Armenian Armn Avestan Avst Balinese Bali Bamum Bamu Bassa_Vah Bass Batak Batk Bengali Beng Bhaiksuki Bhks Bopomofo Bopo Brahmi Brah Braille Brai Buginese Bugi Buhid Buhd Canadian_Aboriginal Cans Carian Cari Caucasian_Albanian Aghb Chakma Cakm Cham Cham Cherokee Cher Common Zyyy Coptic Copt Qaac Cuneiform Xsux Cypriot Cprt Cyrillic Cyrl Deseret Dsrt Devanagari Deva Duployan Dupl Egyptian_Hieroglyphs Egyp Elbasan Elba Ethiopic Ethi Georgian Geor Glagolitic Glag Gothic Goth Grantha Gran Greek Grek Gujarati Gujr Gurmukhi Guru Han Hani Hangul Hang Hanunoo Hano Hatran Hatr Hebrew Hebr Hiragana Hira Imperial_Aramaic Armi Inherited Zinh Qaai Inscriptional_Pahlavi Phli Inscriptional_Parthian Prti Javanese Java Kaithi Kthi Kannada Knda Katakana Kana Kayah_Li Kali Kharoshthi Khar Khmer Khmr Khojki Khoj Khudawadi Sind Lao Laoo Latin Latn Lepcha Lepc Limbu Limb Linear_A Lina Linear_B Linb Lisu Lisu Lycian Lyci Lydian Lydi Mahajani Mahj Malayalam Mlym Mandaic Mand Manichaean Mani Marchen Marc Masaram_Gondi Gonm Meetei_Mayek Mtei Mende_Kikakui Mend Meroitic_Cursive Merc Meroitic_Hieroglyphs Mero Miao Plrd Modi Mongolian Mong Mro Mroo Multani Mult Myanmar Mymr Nabataean Nbat New_Tai_Lue Talu Newa Newa Nko Nkoo Nushu Nshu Ogham Ogam Ol_Chiki Olck Old_Hungarian Hung Old_Italic Ital Old_North_Arabian Narb Old_Permic Perm Old_Persian Xpeo Old_South_Arabian Sarb Old_Turkic Orkh Oriya Orya Osage Osge Osmanya Osma Pahawh_Hmong Hmng Palmyrene Palm Pau_Cin_Hau Pauc Phags_Pa Phag Phoenician Phnx Psalter_Pahlavi Phlp Rejang Rjng Runic Runr Samaritan Samr Saurashtra Saur Sharada Shrd Shavian Shaw Siddham Sidd SignWriting Sgnw Sinhala Sinh Sora_Sompeng Sora Soyombo Soyo Sundanese Sund Syloti_Nagri Sylo Syriac Syrc Tagalog Tglg Tagbanwa Tagb Tai_Le Tale Tai_Tham Lana Tai_Viet Tavt Takri Takr Tamil Taml Tangut Tang Telugu Telu Thaana Thaa Thai Thai Tibetan Tibt Tifinagh Tfng Tirhuta Tirh Ugaritic Ugar Vai Vaii Warang_Citi Wara Yi Yiii Zanabazar_Square Zanb", vt = _t + " Dogra Dogr Gunjala_Gondi Gong Hanifi_Rohingya Rohg Makasar Maka Medefaidrin Medf Old_Sogdian Sogo Sogdian Sogd", Rt = vt + " Elymaic Elym Nandinagari Nand Nyiakeng_Puachue_Hmong Hmnp Wancho Wcho", Et = Rt + " Chorasmian Chrs Diak Dives_Akuru Khitan_Small_Script Kits Yezi Yezidi", Ht = Et + " Cypro_Minoan Cpmn Old_Uyghur Ougr Tangsa Tnsa Toto Vithkuqi Vith", jt = Ht + " " + ve, Vt = {
        9: _t,
        10: vt,
        11: Rt,
        12: Et,
        13: Ht,
        14: jt
      }, Mi = {};
      function Li(g) {
        var V = Mi[g] = {
          binary: We(gt[g] + " " + st),
          binaryOfStrings: We(Fe[g]),
          nonBinary: {
            General_Category: We(st),
            Script: We(Vt[g])
          }
        };
        V.nonBinary.Script_Extensions = V.nonBinary.Script, V.nonBinary.gc = V.nonBinary.General_Category, V.nonBinary.sc = V.nonBinary.Script, V.nonBinary.scx = V.nonBinary.Script_Extensions;
      }
      for (var Ai = 0, vi = [9, 10, 11, 12, 13, 14]; Ai < vi.length; Ai += 1) {
        var ri = vi[Ai];
        Li(ri);
      }
      var Nt = a.prototype, Di = function(V, ue) {
        this.parent = V, this.base = ue || this;
      };
      Di.prototype.separatedFrom = function(V) {
        for (var ue = this; ue; ue = ue.parent)
          for (var ye = V; ye; ye = ye.parent)
            if (ue.base === ye.base && ue !== ye)
              return !0;
        return !1;
      }, Di.prototype.sibling = function() {
        return new Di(this.parent, this.base);
      };
      var li = function(V) {
        this.parser = V, this.validFlags = "gim" + (V.options.ecmaVersion >= 6 ? "uy" : "") + (V.options.ecmaVersion >= 9 ? "s" : "") + (V.options.ecmaVersion >= 13 ? "d" : "") + (V.options.ecmaVersion >= 15 ? "v" : ""), this.unicodeProperties = Mi[V.options.ecmaVersion >= 14 ? 14 : V.options.ecmaVersion], this.source = "", this.flags = "", this.start = 0, this.switchU = !1, this.switchV = !1, this.switchN = !1, this.pos = 0, this.lastIntValue = 0, this.lastStringValue = "", this.lastAssertionIsQuantifiable = !1, this.numCapturingParens = 0, this.maxBackReference = 0, this.groupNames = /* @__PURE__ */ Object.create(null), this.backReferenceNames = [], this.branchID = null;
      };
      li.prototype.reset = function(V, ue, ye) {
        var Ie = ye.indexOf("v") !== -1, nt = ye.indexOf("u") !== -1;
        this.start = V | 0, this.source = ue + "", this.flags = ye, Ie && this.parser.options.ecmaVersion >= 15 ? (this.switchU = !0, this.switchV = !0, this.switchN = !0) : (this.switchU = nt && this.parser.options.ecmaVersion >= 6, this.switchV = !1, this.switchN = nt && this.parser.options.ecmaVersion >= 9);
      }, li.prototype.raise = function(V) {
        this.parser.raiseRecoverable(this.start, "Invalid regular expression: /" + this.source + "/: " + V);
      }, li.prototype.at = function(V, ue) {
        ue === void 0 && (ue = !1);
        var ye = this.source, Ie = ye.length;
        if (V >= Ie)
          return -1;
        var nt = ye.charCodeAt(V);
        if (!(ue || this.switchU) || nt <= 55295 || nt >= 57344 || V + 1 >= Ie)
          return nt;
        var dt = ye.charCodeAt(V + 1);
        return dt >= 56320 && dt <= 57343 ? (nt << 10) + dt - 56613888 : nt;
      }, li.prototype.nextIndex = function(V, ue) {
        ue === void 0 && (ue = !1);
        var ye = this.source, Ie = ye.length;
        if (V >= Ie)
          return Ie;
        var nt = ye.charCodeAt(V), dt;
        return !(ue || this.switchU) || nt <= 55295 || nt >= 57344 || V + 1 >= Ie || (dt = ye.charCodeAt(V + 1)) < 56320 || dt > 57343 ? V + 1 : V + 2;
      }, li.prototype.current = function(V) {
        return V === void 0 && (V = !1), this.at(this.pos, V);
      }, li.prototype.lookahead = function(V) {
        return V === void 0 && (V = !1), this.at(this.nextIndex(this.pos, V), V);
      }, li.prototype.advance = function(V) {
        V === void 0 && (V = !1), this.pos = this.nextIndex(this.pos, V);
      }, li.prototype.eat = function(V, ue) {
        return ue === void 0 && (ue = !1), this.current(ue) === V ? (this.advance(ue), !0) : !1;
      }, li.prototype.eatChars = function(V, ue) {
        ue === void 0 && (ue = !1);
        for (var ye = this.pos, Ie = 0, nt = V; Ie < nt.length; Ie += 1) {
          var dt = nt[Ie], zt = this.at(ye, ue);
          if (zt === -1 || zt !== dt)
            return !1;
          ye = this.nextIndex(ye, ue);
        }
        return this.pos = ye, !0;
      }, Nt.validateRegExpFlags = function(g) {
        for (var V = g.validFlags, ue = g.flags, ye = !1, Ie = !1, nt = 0; nt < ue.length; nt++) {
          var dt = ue.charAt(nt);
          V.indexOf(dt) === -1 && this.raise(g.start, "Invalid regular expression flag"), ue.indexOf(dt, nt + 1) > -1 && this.raise(g.start, "Duplicate regular expression flag"), dt === "u" && (ye = !0), dt === "v" && (Ie = !0);
        }
        this.options.ecmaVersion >= 15 && ye && Ie && this.raise(g.start, "Invalid regular expression flag");
      };
      function nn(g) {
        for (var V in g)
          return !0;
        return !1;
      }
      Nt.validateRegExpPattern = function(g) {
        this.regexp_pattern(g), !g.switchN && this.options.ecmaVersion >= 9 && nn(g.groupNames) && (g.switchN = !0, this.regexp_pattern(g));
      }, Nt.regexp_pattern = function(g) {
        g.pos = 0, g.lastIntValue = 0, g.lastStringValue = "", g.lastAssertionIsQuantifiable = !1, g.numCapturingParens = 0, g.maxBackReference = 0, g.groupNames = /* @__PURE__ */ Object.create(null), g.backReferenceNames.length = 0, g.branchID = null, this.regexp_disjunction(g), g.pos !== g.source.length && (g.eat(
          41
          /* ) */
        ) && g.raise("Unmatched ')'"), (g.eat(
          93
          /* ] */
        ) || g.eat(
          125
          /* } */
        )) && g.raise("Lone quantifier brackets")), g.maxBackReference > g.numCapturingParens && g.raise("Invalid escape");
        for (var V = 0, ue = g.backReferenceNames; V < ue.length; V += 1) {
          var ye = ue[V];
          g.groupNames[ye] || g.raise("Invalid named capture referenced");
        }
      }, Nt.regexp_disjunction = function(g) {
        var V = this.options.ecmaVersion >= 16;
        for (V && (g.branchID = new Di(g.branchID, null)), this.regexp_alternative(g); g.eat(
          124
          /* | */
        ); )
          V && (g.branchID = g.branchID.sibling()), this.regexp_alternative(g);
        V && (g.branchID = g.branchID.parent), this.regexp_eatQuantifier(g, !0) && g.raise("Nothing to repeat"), g.eat(
          123
          /* { */
        ) && g.raise("Lone quantifier brackets");
      }, Nt.regexp_alternative = function(g) {
        for (; g.pos < g.source.length && this.regexp_eatTerm(g); )
          ;
      }, Nt.regexp_eatTerm = function(g) {
        return this.regexp_eatAssertion(g) ? (g.lastAssertionIsQuantifiable && this.regexp_eatQuantifier(g) && g.switchU && g.raise("Invalid quantifier"), !0) : (g.switchU ? this.regexp_eatAtom(g) : this.regexp_eatExtendedAtom(g)) ? (this.regexp_eatQuantifier(g), !0) : !1;
      }, Nt.regexp_eatAssertion = function(g) {
        var V = g.pos;
        if (g.lastAssertionIsQuantifiable = !1, g.eat(
          94
          /* ^ */
        ) || g.eat(
          36
          /* $ */
        ))
          return !0;
        if (g.eat(
          92
          /* \ */
        )) {
          if (g.eat(
            66
            /* B */
          ) || g.eat(
            98
            /* b */
          ))
            return !0;
          g.pos = V;
        }
        if (g.eat(
          40
          /* ( */
        ) && g.eat(
          63
          /* ? */
        )) {
          var ue = !1;
          if (this.options.ecmaVersion >= 9 && (ue = g.eat(
            60
            /* < */
          )), g.eat(
            61
            /* = */
          ) || g.eat(
            33
            /* ! */
          ))
            return this.regexp_disjunction(g), g.eat(
              41
              /* ) */
            ) || g.raise("Unterminated group"), g.lastAssertionIsQuantifiable = !ue, !0;
        }
        return g.pos = V, !1;
      }, Nt.regexp_eatQuantifier = function(g, V) {
        return V === void 0 && (V = !1), this.regexp_eatQuantifierPrefix(g, V) ? (g.eat(
          63
          /* ? */
        ), !0) : !1;
      }, Nt.regexp_eatQuantifierPrefix = function(g, V) {
        return g.eat(
          42
          /* * */
        ) || g.eat(
          43
          /* + */
        ) || g.eat(
          63
          /* ? */
        ) || this.regexp_eatBracedQuantifier(g, V);
      }, Nt.regexp_eatBracedQuantifier = function(g, V) {
        var ue = g.pos;
        if (g.eat(
          123
          /* { */
        )) {
          var ye = 0, Ie = -1;
          if (this.regexp_eatDecimalDigits(g) && (ye = g.lastIntValue, g.eat(
            44
            /* , */
          ) && this.regexp_eatDecimalDigits(g) && (Ie = g.lastIntValue), g.eat(
            125
            /* } */
          )))
            return Ie !== -1 && Ie < ye && !V && g.raise("numbers out of order in {} quantifier"), !0;
          g.switchU && !V && g.raise("Incomplete quantifier"), g.pos = ue;
        }
        return !1;
      }, Nt.regexp_eatAtom = function(g) {
        return this.regexp_eatPatternCharacters(g) || g.eat(
          46
          /* . */
        ) || this.regexp_eatReverseSolidusAtomEscape(g) || this.regexp_eatCharacterClass(g) || this.regexp_eatUncapturingGroup(g) || this.regexp_eatCapturingGroup(g);
      }, Nt.regexp_eatReverseSolidusAtomEscape = function(g) {
        var V = g.pos;
        if (g.eat(
          92
          /* \ */
        )) {
          if (this.regexp_eatAtomEscape(g))
            return !0;
          g.pos = V;
        }
        return !1;
      }, Nt.regexp_eatUncapturingGroup = function(g) {
        var V = g.pos;
        if (g.eat(
          40
          /* ( */
        )) {
          if (g.eat(
            63
            /* ? */
          )) {
            if (this.options.ecmaVersion >= 16) {
              var ue = this.regexp_eatModifiers(g), ye = g.eat(
                45
                /* - */
              );
              if (ue || ye) {
                for (var Ie = 0; Ie < ue.length; Ie++) {
                  var nt = ue.charAt(Ie);
                  ue.indexOf(nt, Ie + 1) > -1 && g.raise("Duplicate regular expression modifiers");
                }
                if (ye) {
                  var dt = this.regexp_eatModifiers(g);
                  !ue && !dt && g.current() === 58 && g.raise("Invalid regular expression modifiers");
                  for (var zt = 0; zt < dt.length; zt++) {
                    var Xt = dt.charAt(zt);
                    (dt.indexOf(Xt, zt + 1) > -1 || ue.indexOf(Xt) > -1) && g.raise("Duplicate regular expression modifiers");
                  }
                }
              }
            }
            if (g.eat(
              58
              /* : */
            )) {
              if (this.regexp_disjunction(g), g.eat(
                41
                /* ) */
              ))
                return !0;
              g.raise("Unterminated group");
            }
          }
          g.pos = V;
        }
        return !1;
      }, Nt.regexp_eatCapturingGroup = function(g) {
        if (g.eat(
          40
          /* ( */
        )) {
          if (this.options.ecmaVersion >= 9 ? this.regexp_groupSpecifier(g) : g.current() === 63 && g.raise("Invalid group"), this.regexp_disjunction(g), g.eat(
            41
            /* ) */
          ))
            return g.numCapturingParens += 1, !0;
          g.raise("Unterminated group");
        }
        return !1;
      }, Nt.regexp_eatModifiers = function(g) {
        for (var V = "", ue = 0; (ue = g.current()) !== -1 && Vi(ue); )
          V += It(ue), g.advance();
        return V;
      };
      function Vi(g) {
        return g === 105 || g === 109 || g === 115;
      }
      Nt.regexp_eatExtendedAtom = function(g) {
        return g.eat(
          46
          /* . */
        ) || this.regexp_eatReverseSolidusAtomEscape(g) || this.regexp_eatCharacterClass(g) || this.regexp_eatUncapturingGroup(g) || this.regexp_eatCapturingGroup(g) || this.regexp_eatInvalidBracedQuantifier(g) || this.regexp_eatExtendedPatternCharacter(g);
      }, Nt.regexp_eatInvalidBracedQuantifier = function(g) {
        return this.regexp_eatBracedQuantifier(g, !0) && g.raise("Nothing to repeat"), !1;
      }, Nt.regexp_eatSyntaxCharacter = function(g) {
        var V = g.current();
        return Wi(V) ? (g.lastIntValue = V, g.advance(), !0) : !1;
      };
      function Wi(g) {
        return g === 36 || g >= 40 && g <= 43 || g === 46 || g === 63 || g >= 91 && g <= 94 || g >= 123 && g <= 125;
      }
      Nt.regexp_eatPatternCharacters = function(g) {
        for (var V = g.pos, ue = 0; (ue = g.current()) !== -1 && !Wi(ue); )
          g.advance();
        return g.pos !== V;
      }, Nt.regexp_eatExtendedPatternCharacter = function(g) {
        var V = g.current();
        return V !== -1 && V !== 36 && !(V >= 40 && V <= 43) && V !== 46 && V !== 63 && V !== 91 && V !== 94 && V !== 124 ? (g.advance(), !0) : !1;
      }, Nt.regexp_groupSpecifier = function(g) {
        if (g.eat(
          63
          /* ? */
        )) {
          this.regexp_eatGroupName(g) || g.raise("Invalid group");
          var V = this.options.ecmaVersion >= 16, ue = g.groupNames[g.lastStringValue];
          if (ue)
            if (V)
              for (var ye = 0, Ie = ue; ye < Ie.length; ye += 1) {
                var nt = Ie[ye];
                nt.separatedFrom(g.branchID) || g.raise("Duplicate capture group name");
              }
            else
              g.raise("Duplicate capture group name");
          V ? (ue || (g.groupNames[g.lastStringValue] = [])).push(g.branchID) : g.groupNames[g.lastStringValue] = !0;
        }
      }, Nt.regexp_eatGroupName = function(g) {
        if (g.lastStringValue = "", g.eat(
          60
          /* < */
        )) {
          if (this.regexp_eatRegExpIdentifierName(g) && g.eat(
            62
            /* > */
          ))
            return !0;
          g.raise("Invalid capture group name");
        }
        return !1;
      }, Nt.regexp_eatRegExpIdentifierName = function(g) {
        if (g.lastStringValue = "", this.regexp_eatRegExpIdentifierStart(g)) {
          for (g.lastStringValue += It(g.lastIntValue); this.regexp_eatRegExpIdentifierPart(g); )
            g.lastStringValue += It(g.lastIntValue);
          return !0;
        }
        return !1;
      }, Nt.regexp_eatRegExpIdentifierStart = function(g) {
        var V = g.pos, ue = this.options.ecmaVersion >= 11, ye = g.current(ue);
        return g.advance(ue), ye === 92 && this.regexp_eatRegExpUnicodeEscapeSequence(g, ue) && (ye = g.lastIntValue), Ji(ye) ? (g.lastIntValue = ye, !0) : (g.pos = V, !1);
      };
      function Ji(g) {
        return Z(g, !0) || g === 36 || g === 95;
      }
      Nt.regexp_eatRegExpIdentifierPart = function(g) {
        var V = g.pos, ue = this.options.ecmaVersion >= 11, ye = g.current(ue);
        return g.advance(ue), ye === 92 && this.regexp_eatRegExpUnicodeEscapeSequence(g, ue) && (ye = g.lastIntValue), Hi(ye) ? (g.lastIntValue = ye, !0) : (g.pos = V, !1);
      };
      function Hi(g) {
        return F(g, !0) || g === 36 || g === 95 || g === 8204 || g === 8205;
      }
      Nt.regexp_eatAtomEscape = function(g) {
        return this.regexp_eatBackReference(g) || this.regexp_eatCharacterClassEscape(g) || this.regexp_eatCharacterEscape(g) || g.switchN && this.regexp_eatKGroupName(g) ? !0 : (g.switchU && (g.current() === 99 && g.raise("Invalid unicode escape"), g.raise("Invalid escape")), !1);
      }, Nt.regexp_eatBackReference = function(g) {
        var V = g.pos;
        if (this.regexp_eatDecimalEscape(g)) {
          var ue = g.lastIntValue;
          if (g.switchU)
            return ue > g.maxBackReference && (g.maxBackReference = ue), !0;
          if (ue <= g.numCapturingParens)
            return !0;
          g.pos = V;
        }
        return !1;
      }, Nt.regexp_eatKGroupName = function(g) {
        if (g.eat(
          107
          /* k */
        )) {
          if (this.regexp_eatGroupName(g))
            return g.backReferenceNames.push(g.lastStringValue), !0;
          g.raise("Invalid named reference");
        }
        return !1;
      }, Nt.regexp_eatCharacterEscape = function(g) {
        return this.regexp_eatControlEscape(g) || this.regexp_eatCControlLetter(g) || this.regexp_eatZero(g) || this.regexp_eatHexEscapeSequence(g) || this.regexp_eatRegExpUnicodeEscapeSequence(g, !1) || !g.switchU && this.regexp_eatLegacyOctalEscapeSequence(g) || this.regexp_eatIdentityEscape(g);
      }, Nt.regexp_eatCControlLetter = function(g) {
        var V = g.pos;
        if (g.eat(
          99
          /* c */
        )) {
          if (this.regexp_eatControlLetter(g))
            return !0;
          g.pos = V;
        }
        return !1;
      }, Nt.regexp_eatZero = function(g) {
        return g.current() === 48 && !Hn(g.lookahead()) ? (g.lastIntValue = 0, g.advance(), !0) : !1;
      }, Nt.regexp_eatControlEscape = function(g) {
        var V = g.current();
        return V === 116 ? (g.lastIntValue = 9, g.advance(), !0) : V === 110 ? (g.lastIntValue = 10, g.advance(), !0) : V === 118 ? (g.lastIntValue = 11, g.advance(), !0) : V === 102 ? (g.lastIntValue = 12, g.advance(), !0) : V === 114 ? (g.lastIntValue = 13, g.advance(), !0) : !1;
      }, Nt.regexp_eatControlLetter = function(g) {
        var V = g.current();
        return $i(V) ? (g.lastIntValue = V % 32, g.advance(), !0) : !1;
      };
      function $i(g) {
        return g >= 65 && g <= 90 || g >= 97 && g <= 122;
      }
      Nt.regexp_eatRegExpUnicodeEscapeSequence = function(g, V) {
        V === void 0 && (V = !1);
        var ue = g.pos, ye = V || g.switchU;
        if (g.eat(
          117
          /* u */
        )) {
          if (this.regexp_eatFixedHexDigits(g, 4)) {
            var Ie = g.lastIntValue;
            if (ye && Ie >= 55296 && Ie <= 56319) {
              var nt = g.pos;
              if (g.eat(
                92
                /* \ */
              ) && g.eat(
                117
                /* u */
              ) && this.regexp_eatFixedHexDigits(g, 4)) {
                var dt = g.lastIntValue;
                if (dt >= 56320 && dt <= 57343)
                  return g.lastIntValue = (Ie - 55296) * 1024 + (dt - 56320) + 65536, !0;
              }
              g.pos = nt, g.lastIntValue = Ie;
            }
            return !0;
          }
          if (ye && g.eat(
            123
            /* { */
          ) && this.regexp_eatHexDigits(g) && g.eat(
            125
            /* } */
          ) && _n(g.lastIntValue))
            return !0;
          ye && g.raise("Invalid unicode escape"), g.pos = ue;
        }
        return !1;
      };
      function _n(g) {
        return g >= 0 && g <= 1114111;
      }
      Nt.regexp_eatIdentityEscape = function(g) {
        if (g.switchU)
          return this.regexp_eatSyntaxCharacter(g) ? !0 : g.eat(
            47
            /* / */
          ) ? (g.lastIntValue = 47, !0) : !1;
        var V = g.current();
        return V !== 99 && (!g.switchN || V !== 107) ? (g.lastIntValue = V, g.advance(), !0) : !1;
      }, Nt.regexp_eatDecimalEscape = function(g) {
        g.lastIntValue = 0;
        var V = g.current();
        if (V >= 49 && V <= 57) {
          do
            g.lastIntValue = 10 * g.lastIntValue + (V - 48), g.advance();
          while ((V = g.current()) >= 48 && V <= 57);
          return !0;
        }
        return !1;
      };
      var Xi = 0, cn = 1, Cn = 2;
      Nt.regexp_eatCharacterClassEscape = function(g) {
        var V = g.current();
        if (Zr(V))
          return g.lastIntValue = -1, g.advance(), cn;
        var ue = !1;
        if (g.switchU && this.options.ecmaVersion >= 9 && ((ue = V === 80) || V === 112)) {
          g.lastIntValue = -1, g.advance();
          var ye;
          if (g.eat(
            123
            /* { */
          ) && (ye = this.regexp_eatUnicodePropertyValueExpression(g)) && g.eat(
            125
            /* } */
          ))
            return ue && ye === Cn && g.raise("Invalid property name"), ye;
          g.raise("Invalid property name");
        }
        return Xi;
      };
      function Zr(g) {
        return g === 100 || g === 68 || g === 115 || g === 83 || g === 119 || g === 87;
      }
      Nt.regexp_eatUnicodePropertyValueExpression = function(g) {
        var V = g.pos;
        if (this.regexp_eatUnicodePropertyName(g) && g.eat(
          61
          /* = */
        )) {
          var ue = g.lastStringValue;
          if (this.regexp_eatUnicodePropertyValue(g)) {
            var ye = g.lastStringValue;
            return this.regexp_validateUnicodePropertyNameAndValue(g, ue, ye), cn;
          }
        }
        if (g.pos = V, this.regexp_eatLoneUnicodePropertyNameOrValue(g)) {
          var Ie = g.lastStringValue;
          return this.regexp_validateUnicodePropertyNameOrValue(g, Ie);
        }
        return Xi;
      }, Nt.regexp_validateUnicodePropertyNameAndValue = function(g, V, ue) {
        De(g.unicodeProperties.nonBinary, V) || g.raise("Invalid property name"), g.unicodeProperties.nonBinary[V].test(ue) || g.raise("Invalid property value");
      }, Nt.regexp_validateUnicodePropertyNameOrValue = function(g, V) {
        if (g.unicodeProperties.binary.test(V))
          return cn;
        if (g.switchV && g.unicodeProperties.binaryOfStrings.test(V))
          return Cn;
        g.raise("Invalid property name");
      }, Nt.regexp_eatUnicodePropertyName = function(g) {
        var V = 0;
        for (g.lastStringValue = ""; Pr(V = g.current()); )
          g.lastStringValue += It(V), g.advance();
        return g.lastStringValue !== "";
      };
      function Pr(g) {
        return $i(g) || g === 95;
      }
      Nt.regexp_eatUnicodePropertyValue = function(g) {
        var V = 0;
        for (g.lastStringValue = ""; An(V = g.current()); )
          g.lastStringValue += It(V), g.advance();
        return g.lastStringValue !== "";
      };
      function An(g) {
        return Pr(g) || Hn(g);
      }
      Nt.regexp_eatLoneUnicodePropertyNameOrValue = function(g) {
        return this.regexp_eatUnicodePropertyValue(g);
      }, Nt.regexp_eatCharacterClass = function(g) {
        if (g.eat(
          91
          /* [ */
        )) {
          var V = g.eat(
            94
            /* ^ */
          ), ue = this.regexp_classContents(g);
          return g.eat(
            93
            /* ] */
          ) || g.raise("Unterminated character class"), V && ue === Cn && g.raise("Negated character class may contain strings"), !0;
        }
        return !1;
      }, Nt.regexp_classContents = function(g) {
        return g.current() === 93 ? cn : g.switchV ? this.regexp_classSetExpression(g) : (this.regexp_nonEmptyClassRanges(g), cn);
      }, Nt.regexp_nonEmptyClassRanges = function(g) {
        for (; this.regexp_eatClassAtom(g); ) {
          var V = g.lastIntValue;
          if (g.eat(
            45
            /* - */
          ) && this.regexp_eatClassAtom(g)) {
            var ue = g.lastIntValue;
            g.switchU && (V === -1 || ue === -1) && g.raise("Invalid character class"), V !== -1 && ue !== -1 && V > ue && g.raise("Range out of order in character class");
          }
        }
      }, Nt.regexp_eatClassAtom = function(g) {
        var V = g.pos;
        if (g.eat(
          92
          /* \ */
        )) {
          if (this.regexp_eatClassEscape(g))
            return !0;
          if (g.switchU) {
            var ue = g.current();
            (ue === 99 || bn(ue)) && g.raise("Invalid class escape"), g.raise("Invalid escape");
          }
          g.pos = V;
        }
        var ye = g.current();
        return ye !== 93 ? (g.lastIntValue = ye, g.advance(), !0) : !1;
      }, Nt.regexp_eatClassEscape = function(g) {
        var V = g.pos;
        if (g.eat(
          98
          /* b */
        ))
          return g.lastIntValue = 8, !0;
        if (g.switchU && g.eat(
          45
          /* - */
        ))
          return g.lastIntValue = 45, !0;
        if (!g.switchU && g.eat(
          99
          /* c */
        )) {
          if (this.regexp_eatClassControlLetter(g))
            return !0;
          g.pos = V;
        }
        return this.regexp_eatCharacterClassEscape(g) || this.regexp_eatCharacterEscape(g);
      }, Nt.regexp_classSetExpression = function(g) {
        var V = cn, ue;
        if (!this.regexp_eatClassSetRange(g))
          if (ue = this.regexp_eatClassSetOperand(g)) {
            ue === Cn && (V = Cn);
            for (var ye = g.pos; g.eatChars(
              [38, 38]
              /* && */
            ); ) {
              if (g.current() !== 38 && (ue = this.regexp_eatClassSetOperand(g))) {
                ue !== Cn && (V = cn);
                continue;
              }
              g.raise("Invalid character in character class");
            }
            if (ye !== g.pos)
              return V;
            for (; g.eatChars(
              [45, 45]
              /* -- */
            ); )
              this.regexp_eatClassSetOperand(g) || g.raise("Invalid character in character class");
            if (ye !== g.pos)
              return V;
          } else
            g.raise("Invalid character in character class");
        for (; ; )
          if (!this.regexp_eatClassSetRange(g)) {
            if (ue = this.regexp_eatClassSetOperand(g), !ue)
              return V;
            ue === Cn && (V = Cn);
          }
      }, Nt.regexp_eatClassSetRange = function(g) {
        var V = g.pos;
        if (this.regexp_eatClassSetCharacter(g)) {
          var ue = g.lastIntValue;
          if (g.eat(
            45
            /* - */
          ) && this.regexp_eatClassSetCharacter(g)) {
            var ye = g.lastIntValue;
            return ue !== -1 && ye !== -1 && ue > ye && g.raise("Range out of order in character class"), !0;
          }
          g.pos = V;
        }
        return !1;
      }, Nt.regexp_eatClassSetOperand = function(g) {
        return this.regexp_eatClassSetCharacter(g) ? cn : this.regexp_eatClassStringDisjunction(g) || this.regexp_eatNestedClass(g);
      }, Nt.regexp_eatNestedClass = function(g) {
        var V = g.pos;
        if (g.eat(
          91
          /* [ */
        )) {
          var ue = g.eat(
            94
            /* ^ */
          ), ye = this.regexp_classContents(g);
          if (g.eat(
            93
            /* ] */
          ))
            return ue && ye === Cn && g.raise("Negated character class may contain strings"), ye;
          g.pos = V;
        }
        if (g.eat(
          92
          /* \ */
        )) {
          var Ie = this.regexp_eatCharacterClassEscape(g);
          if (Ie)
            return Ie;
          g.pos = V;
        }
        return null;
      }, Nt.regexp_eatClassStringDisjunction = function(g) {
        var V = g.pos;
        if (g.eatChars(
          [92, 113]
          /* \q */
        )) {
          if (g.eat(
            123
            /* { */
          )) {
            var ue = this.regexp_classStringDisjunctionContents(g);
            if (g.eat(
              125
              /* } */
            ))
              return ue;
          } else
            g.raise("Invalid escape");
          g.pos = V;
        }
        return null;
      }, Nt.regexp_classStringDisjunctionContents = function(g) {
        for (var V = this.regexp_classString(g); g.eat(
          124
          /* | */
        ); )
          this.regexp_classString(g) === Cn && (V = Cn);
        return V;
      }, Nt.regexp_classString = function(g) {
        for (var V = 0; this.regexp_eatClassSetCharacter(g); )
          V++;
        return V === 1 ? cn : Cn;
      }, Nt.regexp_eatClassSetCharacter = function(g) {
        var V = g.pos;
        if (g.eat(
          92
          /* \ */
        ))
          return this.regexp_eatCharacterEscape(g) || this.regexp_eatClassSetReservedPunctuator(g) ? !0 : g.eat(
            98
            /* b */
          ) ? (g.lastIntValue = 8, !0) : (g.pos = V, !1);
        var ue = g.current();
        return ue < 0 || ue === g.lookahead() && qr(ue) || Vn(ue) ? !1 : (g.advance(), g.lastIntValue = ue, !0);
      };
      function qr(g) {
        return g === 33 || g >= 35 && g <= 38 || g >= 42 && g <= 44 || g === 46 || g >= 58 && g <= 64 || g === 94 || g === 96 || g === 126;
      }
      function Vn(g) {
        return g === 40 || g === 41 || g === 45 || g === 47 || g >= 91 && g <= 93 || g >= 123 && g <= 125;
      }
      Nt.regexp_eatClassSetReservedPunctuator = function(g) {
        var V = g.current();
        return dr(V) ? (g.lastIntValue = V, g.advance(), !0) : !1;
      };
      function dr(g) {
        return g === 33 || g === 35 || g === 37 || g === 38 || g === 44 || g === 45 || g >= 58 && g <= 62 || g === 64 || g === 96 || g === 126;
      }
      Nt.regexp_eatClassControlLetter = function(g) {
        var V = g.current();
        return Hn(V) || V === 95 ? (g.lastIntValue = V % 32, g.advance(), !0) : !1;
      }, Nt.regexp_eatHexEscapeSequence = function(g) {
        var V = g.pos;
        if (g.eat(
          120
          /* x */
        )) {
          if (this.regexp_eatFixedHexDigits(g, 2))
            return !0;
          g.switchU && g.raise("Invalid escape"), g.pos = V;
        }
        return !1;
      }, Nt.regexp_eatDecimalDigits = function(g) {
        var V = g.pos, ue = 0;
        for (g.lastIntValue = 0; Hn(ue = g.current()); )
          g.lastIntValue = 10 * g.lastIntValue + (ue - 48), g.advance();
        return g.pos !== V;
      };
      function Hn(g) {
        return g >= 48 && g <= 57;
      }
      Nt.regexp_eatHexDigits = function(g) {
        var V = g.pos, ue = 0;
        for (g.lastIntValue = 0; fn(ue = g.current()); )
          g.lastIntValue = 16 * g.lastIntValue + dn(ue), g.advance();
        return g.pos !== V;
      };
      function fn(g) {
        return g >= 48 && g <= 57 || g >= 65 && g <= 70 || g >= 97 && g <= 102;
      }
      function dn(g) {
        return g >= 65 && g <= 70 ? 10 + (g - 65) : g >= 97 && g <= 102 ? 10 + (g - 97) : g - 48;
      }
      Nt.regexp_eatLegacyOctalEscapeSequence = function(g) {
        if (this.regexp_eatOctalDigit(g)) {
          var V = g.lastIntValue;
          if (this.regexp_eatOctalDigit(g)) {
            var ue = g.lastIntValue;
            V <= 3 && this.regexp_eatOctalDigit(g) ? g.lastIntValue = V * 64 + ue * 8 + g.lastIntValue : g.lastIntValue = V * 8 + ue;
          } else
            g.lastIntValue = V;
          return !0;
        }
        return !1;
      }, Nt.regexp_eatOctalDigit = function(g) {
        var V = g.current();
        return bn(V) ? (g.lastIntValue = V - 48, g.advance(), !0) : (g.lastIntValue = 0, !1);
      };
      function bn(g) {
        return g >= 48 && g <= 55;
      }
      Nt.regexp_eatFixedHexDigits = function(g, V) {
        var ue = g.pos;
        g.lastIntValue = 0;
        for (var ye = 0; ye < V; ++ye) {
          var Ie = g.current();
          if (!fn(Ie))
            return g.pos = ue, !1;
          g.lastIntValue = 16 * g.lastIntValue + dn(Ie), g.advance();
        }
        return !0;
      };
      var sn = function(V) {
        this.type = V.type, this.value = V.value, this.start = V.start, this.end = V.end, V.options.locations && (this.loc = new Kt(V, V.startLoc, V.endLoc)), V.options.ranges && (this.range = [V.start, V.end]);
      }, ni = a.prototype;
      ni.next = function(g) {
        !g && this.type.keyword && this.containsEsc && this.raiseRecoverable(this.start, "Escape sequence in keyword " + this.type.keyword), this.options.onToken && this.options.onToken(new sn(this)), this.lastTokEnd = this.end, this.lastTokStart = this.start, this.lastTokEndLoc = this.endLoc, this.lastTokStartLoc = this.startLoc, this.nextToken();
      }, ni.getToken = function() {
        return this.next(), new sn(this);
      }, typeof Symbol < "u" && (ni[Symbol.iterator] = function() {
        var g = this;
        return {
          next: function() {
            var V = g.getToken();
            return {
              done: V.type === X.eof,
              value: V
            };
          }
        };
      }), ni.nextToken = function() {
        var g = this.curContext();
        if ((!g || !g.preserveSpace) && this.skipSpace(), this.start = this.pos, this.options.locations && (this.startLoc = this.curPosition()), this.pos >= this.input.length)
          return this.finishToken(X.eof);
        if (g.override)
          return g.override(this);
        this.readToken(this.fullCharCodeAtPos());
      }, ni.readToken = function(g) {
        return Z(g, this.options.ecmaVersion >= 6) || g === 92 ? this.readWord() : this.getTokenFromCode(g);
      }, ni.fullCharCodeAt = function(g) {
        var V = this.input.charCodeAt(g);
        if (V <= 55295 || V >= 56320)
          return V;
        var ue = this.input.charCodeAt(g + 1);
        return ue <= 56319 || ue >= 57344 ? V : (V << 10) + ue - 56613888;
      }, ni.fullCharCodeAtPos = function() {
        return this.fullCharCodeAt(this.pos);
      }, ni.skipBlockComment = function() {
        var g = this.options.onComment && this.curPosition(), V = this.pos, ue = this.input.indexOf("*/", this.pos += 2);
        if (ue === -1 && this.raise(this.pos - 2, "Unterminated comment"), this.pos = ue + 2, this.options.locations)
          for (var ye = void 0, Ie = V; (ye = Ye(this.input, Ie, this.pos)) > -1; )
            ++this.curLine, Ie = this.lineStart = ye;
        this.options.onComment && this.options.onComment(
          !0,
          this.input.slice(V + 2, ue),
          V,
          this.pos,
          g,
          this.curPosition()
        );
      }, ni.skipLineComment = function(g) {
        for (var V = this.pos, ue = this.options.onComment && this.curPosition(), ye = this.input.charCodeAt(this.pos += g); this.pos < this.input.length && !ke(ye); )
          ye = this.input.charCodeAt(++this.pos);
        this.options.onComment && this.options.onComment(
          !1,
          this.input.slice(V + g, this.pos),
          V,
          this.pos,
          ue,
          this.curPosition()
        );
      }, ni.skipSpace = function() {
        e:
          for (; this.pos < this.input.length; ) {
            var g = this.input.charCodeAt(this.pos);
            switch (g) {
              case 32:
              case 160:
                ++this.pos;
                break;
              case 13:
                this.input.charCodeAt(this.pos + 1) === 10 && ++this.pos;
              case 10:
              case 8232:
              case 8233:
                ++this.pos, this.options.locations && (++this.curLine, this.lineStart = this.pos);
                break;
              case 47:
                switch (this.input.charCodeAt(this.pos + 1)) {
                  case 42:
                    this.skipBlockComment();
                    break;
                  case 47:
                    this.skipLineComment(2);
                    break;
                  default:
                    break e;
                }
                break;
              default:
                if (g > 8 && g < 14 || g >= 5760 && pt.test(String.fromCharCode(g)))
                  ++this.pos;
                else
                  break e;
            }
          }
      }, ni.finishToken = function(g, V) {
        this.end = this.pos, this.options.locations && (this.endLoc = this.curPosition());
        var ue = this.type;
        this.type = g, this.value = V, this.updateContext(ue);
      }, ni.readToken_dot = function() {
        var g = this.input.charCodeAt(this.pos + 1);
        if (g >= 48 && g <= 57)
          return this.readNumber(!0);
        var V = this.input.charCodeAt(this.pos + 2);
        return this.options.ecmaVersion >= 6 && g === 46 && V === 46 ? (this.pos += 3, this.finishToken(X.ellipsis)) : (++this.pos, this.finishToken(X.dot));
      }, ni.readToken_slash = function() {
        var g = this.input.charCodeAt(this.pos + 1);
        return this.exprAllowed ? (++this.pos, this.readRegexp()) : g === 61 ? this.finishOp(X.assign, 2) : this.finishOp(X.slash, 1);
      }, ni.readToken_mult_modulo_exp = function(g) {
        var V = this.input.charCodeAt(this.pos + 1), ue = 1, ye = g === 42 ? X.star : X.modulo;
        return this.options.ecmaVersion >= 7 && g === 42 && V === 42 && (++ue, ye = X.starstar, V = this.input.charCodeAt(this.pos + 2)), V === 61 ? this.finishOp(X.assign, ue + 1) : this.finishOp(ye, ue);
      }, ni.readToken_pipe_amp = function(g) {
        var V = this.input.charCodeAt(this.pos + 1);
        if (V === g) {
          if (this.options.ecmaVersion >= 12) {
            var ue = this.input.charCodeAt(this.pos + 2);
            if (ue === 61)
              return this.finishOp(X.assign, 3);
          }
          return this.finishOp(g === 124 ? X.logicalOR : X.logicalAND, 2);
        }
        return V === 61 ? this.finishOp(X.assign, 2) : this.finishOp(g === 124 ? X.bitwiseOR : X.bitwiseAND, 1);
      }, ni.readToken_caret = function() {
        var g = this.input.charCodeAt(this.pos + 1);
        return g === 61 ? this.finishOp(X.assign, 2) : this.finishOp(X.bitwiseXOR, 1);
      }, ni.readToken_plus_min = function(g) {
        var V = this.input.charCodeAt(this.pos + 1);
        return V === g ? V === 45 && !this.inModule && this.input.charCodeAt(this.pos + 2) === 62 && (this.lastTokEnd === 0 || W.test(this.input.slice(this.lastTokEnd, this.pos))) ? (this.skipLineComment(3), this.skipSpace(), this.nextToken()) : this.finishOp(X.incDec, 2) : V === 61 ? this.finishOp(X.assign, 2) : this.finishOp(X.plusMin, 1);
      }, ni.readToken_lt_gt = function(g) {
        var V = this.input.charCodeAt(this.pos + 1), ue = 1;
        return V === g ? (ue = g === 62 && this.input.charCodeAt(this.pos + 2) === 62 ? 3 : 2, this.input.charCodeAt(this.pos + ue) === 61 ? this.finishOp(X.assign, ue + 1) : this.finishOp(X.bitShift, ue)) : V === 33 && g === 60 && !this.inModule && this.input.charCodeAt(this.pos + 2) === 45 && this.input.charCodeAt(this.pos + 3) === 45 ? (this.skipLineComment(4), this.skipSpace(), this.nextToken()) : (V === 61 && (ue = 2), this.finishOp(X.relational, ue));
      }, ni.readToken_eq_excl = function(g) {
        var V = this.input.charCodeAt(this.pos + 1);
        return V === 61 ? this.finishOp(X.equality, this.input.charCodeAt(this.pos + 2) === 61 ? 3 : 2) : g === 61 && V === 62 && this.options.ecmaVersion >= 6 ? (this.pos += 2, this.finishToken(X.arrow)) : this.finishOp(g === 61 ? X.eq : X.prefix, 1);
      }, ni.readToken_question = function() {
        var g = this.options.ecmaVersion;
        if (g >= 11) {
          var V = this.input.charCodeAt(this.pos + 1);
          if (V === 46) {
            var ue = this.input.charCodeAt(this.pos + 2);
            if (ue < 48 || ue > 57)
              return this.finishOp(X.questionDot, 2);
          }
          if (V === 63) {
            if (g >= 12) {
              var ye = this.input.charCodeAt(this.pos + 2);
              if (ye === 61)
                return this.finishOp(X.assign, 3);
            }
            return this.finishOp(X.coalesce, 2);
          }
        }
        return this.finishOp(X.question, 1);
      }, ni.readToken_numberSign = function() {
        var g = this.options.ecmaVersion, V = 35;
        if (g >= 13 && (++this.pos, V = this.fullCharCodeAtPos(), Z(V, !0) || V === 92))
          return this.finishToken(X.privateId, this.readWord1());
        this.raise(this.pos, "Unexpected character '" + It(V) + "'");
      }, ni.getTokenFromCode = function(g) {
        switch (g) {
          case 46:
            return this.readToken_dot();
          case 40:
            return ++this.pos, this.finishToken(X.parenL);
          case 41:
            return ++this.pos, this.finishToken(X.parenR);
          case 59:
            return ++this.pos, this.finishToken(X.semi);
          case 44:
            return ++this.pos, this.finishToken(X.comma);
          case 91:
            return ++this.pos, this.finishToken(X.bracketL);
          case 93:
            return ++this.pos, this.finishToken(X.bracketR);
          case 123:
            return ++this.pos, this.finishToken(X.braceL);
          case 125:
            return ++this.pos, this.finishToken(X.braceR);
          case 58:
            return ++this.pos, this.finishToken(X.colon);
          case 96:
            if (this.options.ecmaVersion < 6)
              break;
            return ++this.pos, this.finishToken(X.backQuote);
          case 48:
            var V = this.input.charCodeAt(this.pos + 1);
            if (V === 120 || V === 88)
              return this.readRadixNumber(16);
            if (this.options.ecmaVersion >= 6) {
              if (V === 111 || V === 79)
                return this.readRadixNumber(8);
              if (V === 98 || V === 66)
                return this.readRadixNumber(2);
            }
          case 49:
          case 50:
          case 51:
          case 52:
          case 53:
          case 54:
          case 55:
          case 56:
          case 57:
            return this.readNumber(!1);
          case 34:
          case 39:
            return this.readString(g);
          case 47:
            return this.readToken_slash();
          case 37:
          case 42:
            return this.readToken_mult_modulo_exp(g);
          case 124:
          case 38:
            return this.readToken_pipe_amp(g);
          case 94:
            return this.readToken_caret();
          case 43:
          case 45:
            return this.readToken_plus_min(g);
          case 60:
          case 62:
            return this.readToken_lt_gt(g);
          case 61:
          case 33:
            return this.readToken_eq_excl(g);
          case 63:
            return this.readToken_question();
          case 126:
            return this.finishOp(X.prefix, 1);
          case 35:
            return this.readToken_numberSign();
        }
        this.raise(this.pos, "Unexpected character '" + It(g) + "'");
      }, ni.finishOp = function(g, V) {
        var ue = this.input.slice(this.pos, this.pos + V);
        return this.pos += V, this.finishToken(g, ue);
      }, ni.readRegexp = function() {
        for (var g, V, ue = this.pos; ; ) {
          this.pos >= this.input.length && this.raise(ue, "Unterminated regular expression");
          var ye = this.input.charAt(this.pos);
          if (W.test(ye) && this.raise(ue, "Unterminated regular expression"), g)
            g = !1;
          else {
            if (ye === "[")
              V = !0;
            else if (ye === "]" && V)
              V = !1;
            else if (ye === "/" && !V)
              break;
            g = ye === "\\";
          }
          ++this.pos;
        }
        var Ie = this.input.slice(ue, this.pos);
        ++this.pos;
        var nt = this.pos, dt = this.readWord1();
        this.containsEsc && this.unexpected(nt);
        var zt = this.regexpState || (this.regexpState = new li(this));
        zt.reset(ue, Ie, dt), this.validateRegExpFlags(zt), this.validateRegExpPattern(zt);
        var Xt = null;
        try {
          Xt = new RegExp(Ie, dt);
        } catch {
        }
        return this.finishToken(X.regexp, { pattern: Ie, flags: dt, value: Xt });
      }, ni.readInt = function(g, V, ue) {
        for (var ye = this.options.ecmaVersion >= 12 && V === void 0, Ie = ue && this.input.charCodeAt(this.pos) === 48, nt = this.pos, dt = 0, zt = 0, Xt = 0, hi = V ?? 1 / 0; Xt < hi; ++Xt, ++this.pos) {
          var ii = this.input.charCodeAt(this.pos), oi = void 0;
          if (ye && ii === 95) {
            Ie && this.raiseRecoverable(this.pos, "Numeric separator is not allowed in legacy octal numeric literals"), zt === 95 && this.raiseRecoverable(this.pos, "Numeric separator must be exactly one underscore"), Xt === 0 && this.raiseRecoverable(this.pos, "Numeric separator is not allowed at the first of digits"), zt = ii;
            continue;
          }
          if (ii >= 97 ? oi = ii - 97 + 10 : ii >= 65 ? oi = ii - 65 + 10 : ii >= 48 && ii <= 57 ? oi = ii - 48 : oi = 1 / 0, oi >= g)
            break;
          zt = ii, dt = dt * g + oi;
        }
        return ye && zt === 95 && this.raiseRecoverable(this.pos - 1, "Numeric separator is not allowed at the last of digits"), this.pos === nt || V != null && this.pos - nt !== V ? null : dt;
      };
      function gn(g, V) {
        return V ? parseInt(g, 8) : parseFloat(g.replace(/_/g, ""));
      }
      function rn(g) {
        return typeof BigInt != "function" ? null : BigInt(g.replace(/_/g, ""));
      }
      ni.readRadixNumber = function(g) {
        var V = this.pos;
        this.pos += 2;
        var ue = this.readInt(g);
        return ue == null && this.raise(this.start + 2, "Expected number in radix " + g), this.options.ecmaVersion >= 11 && this.input.charCodeAt(this.pos) === 110 ? (ue = rn(this.input.slice(V, this.pos)), ++this.pos) : Z(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number"), this.finishToken(X.num, ue);
      }, ni.readNumber = function(g) {
        var V = this.pos;
        !g && this.readInt(10, void 0, !0) === null && this.raise(V, "Invalid number");
        var ue = this.pos - V >= 2 && this.input.charCodeAt(V) === 48;
        ue && this.strict && this.raise(V, "Invalid number");
        var ye = this.input.charCodeAt(this.pos);
        if (!ue && !g && this.options.ecmaVersion >= 11 && ye === 110) {
          var Ie = rn(this.input.slice(V, this.pos));
          return ++this.pos, Z(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number"), this.finishToken(X.num, Ie);
        }
        ue && /[89]/.test(this.input.slice(V, this.pos)) && (ue = !1), ye === 46 && !ue && (++this.pos, this.readInt(10), ye = this.input.charCodeAt(this.pos)), (ye === 69 || ye === 101) && !ue && (ye = this.input.charCodeAt(++this.pos), (ye === 43 || ye === 45) && ++this.pos, this.readInt(10) === null && this.raise(V, "Invalid number")), Z(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number");
        var nt = gn(this.input.slice(V, this.pos), ue);
        return this.finishToken(X.num, nt);
      }, ni.readCodePoint = function() {
        var g = this.input.charCodeAt(this.pos), V;
        if (g === 123) {
          this.options.ecmaVersion < 6 && this.unexpected();
          var ue = ++this.pos;
          V = this.readHexChar(this.input.indexOf("}", this.pos) - this.pos), ++this.pos, V > 1114111 && this.invalidStringToken(ue, "Code point out of bounds");
        } else
          V = this.readHexChar(4);
        return V;
      }, ni.readString = function(g) {
        for (var V = "", ue = ++this.pos; ; ) {
          this.pos >= this.input.length && this.raise(this.start, "Unterminated string constant");
          var ye = this.input.charCodeAt(this.pos);
          if (ye === g)
            break;
          ye === 92 ? (V += this.input.slice(ue, this.pos), V += this.readEscapedChar(!1), ue = this.pos) : ye === 8232 || ye === 8233 ? (this.options.ecmaVersion < 10 && this.raise(this.start, "Unterminated string constant"), ++this.pos, this.options.locations && (this.curLine++, this.lineStart = this.pos)) : (ke(ye) && this.raise(this.start, "Unterminated string constant"), ++this.pos);
        }
        return V += this.input.slice(ue, this.pos++), this.finishToken(X.string, V);
      };
      var Pn = {};
      ni.tryReadTemplateToken = function() {
        this.inTemplateElement = !0;
        try {
          this.readTmplToken();
        } catch (g) {
          if (g === Pn)
            this.readInvalidTemplateToken();
          else
            throw g;
        }
        this.inTemplateElement = !1;
      }, ni.invalidStringToken = function(g, V) {
        if (this.inTemplateElement && this.options.ecmaVersion >= 9)
          throw Pn;
        this.raise(g, V);
      }, ni.readTmplToken = function() {
        for (var g = "", V = this.pos; ; ) {
          this.pos >= this.input.length && this.raise(this.start, "Unterminated template");
          var ue = this.input.charCodeAt(this.pos);
          if (ue === 96 || ue === 36 && this.input.charCodeAt(this.pos + 1) === 123)
            return this.pos === this.start && (this.type === X.template || this.type === X.invalidTemplate) ? ue === 36 ? (this.pos += 2, this.finishToken(X.dollarBraceL)) : (++this.pos, this.finishToken(X.backQuote)) : (g += this.input.slice(V, this.pos), this.finishToken(X.template, g));
          if (ue === 92)
            g += this.input.slice(V, this.pos), g += this.readEscapedChar(!0), V = this.pos;
          else if (ke(ue)) {
            switch (g += this.input.slice(V, this.pos), ++this.pos, ue) {
              case 13:
                this.input.charCodeAt(this.pos) === 10 && ++this.pos;
              case 10:
                g += `
`;
                break;
              default:
                g += String.fromCharCode(ue);
                break;
            }
            this.options.locations && (++this.curLine, this.lineStart = this.pos), V = this.pos;
          } else
            ++this.pos;
        }
      }, ni.readInvalidTemplateToken = function() {
        for (; this.pos < this.input.length; this.pos++)
          switch (this.input[this.pos]) {
            case "\\":
              ++this.pos;
              break;
            case "$":
              if (this.input[this.pos + 1] !== "{")
                break;
            case "`":
              return this.finishToken(X.invalidTemplate, this.input.slice(this.start, this.pos));
            case "\r":
              this.input[this.pos + 1] === `
` && ++this.pos;
            case `
`:
            case "\u2028":
            case "\u2029":
              ++this.curLine, this.lineStart = this.pos + 1;
              break;
          }
        this.raise(this.start, "Unterminated template");
      }, ni.readEscapedChar = function(g) {
        var V = this.input.charCodeAt(++this.pos);
        switch (++this.pos, V) {
          case 110:
            return `
`;
          case 114:
            return "\r";
          case 120:
            return String.fromCharCode(this.readHexChar(2));
          case 117:
            return It(this.readCodePoint());
          case 116:
            return "	";
          case 98:
            return "\b";
          case 118:
            return "\v";
          case 102:
            return "\f";
          case 13:
            this.input.charCodeAt(this.pos) === 10 && ++this.pos;
          case 10:
            return this.options.locations && (this.lineStart = this.pos, ++this.curLine), "";
          case 56:
          case 57:
            if (this.strict && this.invalidStringToken(
              this.pos - 1,
              "Invalid escape sequence"
            ), g) {
              var ue = this.pos - 1;
              this.invalidStringToken(
                ue,
                "Invalid escape sequence in template string"
              );
            }
          default:
            if (V >= 48 && V <= 55) {
              var ye = this.input.substr(this.pos - 1, 3).match(/^[0-7]+/)[0], Ie = parseInt(ye, 8);
              return Ie > 255 && (ye = ye.slice(0, -1), Ie = parseInt(ye, 8)), this.pos += ye.length - 1, V = this.input.charCodeAt(this.pos), (ye !== "0" || V === 56 || V === 57) && (this.strict || g) && this.invalidStringToken(
                this.pos - 1 - ye.length,
                g ? "Octal literal in template string" : "Octal literal in strict mode"
              ), String.fromCharCode(Ie);
            }
            return ke(V) ? (this.options.locations && (this.lineStart = this.pos, ++this.curLine), "") : String.fromCharCode(V);
        }
      }, ni.readHexChar = function(g) {
        var V = this.pos, ue = this.readInt(16, g);
        return ue === null && this.invalidStringToken(V, "Bad character escape sequence"), ue;
      }, ni.readWord1 = function() {
        this.containsEsc = !1;
        for (var g = "", V = !0, ue = this.pos, ye = this.options.ecmaVersion >= 6; this.pos < this.input.length; ) {
          var Ie = this.fullCharCodeAtPos();
          if (F(Ie, ye))
            this.pos += Ie <= 65535 ? 1 : 2;
          else if (Ie === 92) {
            this.containsEsc = !0, g += this.input.slice(ue, this.pos);
            var nt = this.pos;
            this.input.charCodeAt(++this.pos) !== 117 && this.invalidStringToken(this.pos, "Expecting Unicode escape sequence \\uXXXX"), ++this.pos;
            var dt = this.readCodePoint();
            (V ? Z : F)(dt, ye) || this.invalidStringToken(nt, "Invalid Unicode escape"), g += It(dt), ue = this.pos;
          } else
            break;
          V = !1;
        }
        return g + this.input.slice(ue, this.pos);
      }, ni.readWord = function() {
        var g = this.readWord1(), V = X.name;
        return this.keywords.test(g) && (V = le[g]), this.finishToken(V, g);
      };
      var gr = "8.16.0";
      a.acorn = {
        Parser: a,
        version: gr,
        defaultOptions: Lt,
        Position: tt,
        SourceLocation: Kt,
        getLineInfo: qt,
        Node: pe,
        TokenType: Q,
        tokTypes: X,
        keywordTypes: le,
        TokContext: k,
        tokContexts: z,
        isIdentifierChar: F,
        isIdentifierStart: Z,
        Token: sn,
        isNewLine: ke,
        lineBreak: W,
        lineBreakG: je,
        nonASCIIwhitespace: pt
      };
      function Or(g, V) {
        return a.parse(g, V);
      }
      function xr(g, V, ue) {
        return a.parseExpressionAt(g, V, ue);
      }
      function wr(g, V) {
        return a.tokenizer(g, V);
      }
      t.Node = pe, t.Parser = a, t.Position = tt, t.SourceLocation = Kt, t.TokContext = k, t.Token = sn, t.TokenType = Q, t.defaultOptions = Lt, t.getLineInfo = qt, t.isIdentifierChar = F, t.isIdentifierStart = Z, t.isNewLine = ke, t.keywordTypes = le, t.lineBreak = W, t.lineBreakG = je, t.nonASCIIwhitespace = pt, t.parse = Or, t.parseExpressionAt = xr, t.tokContexts = z, t.tokTypes = X, t.tokenizer = wr, t.version = gr;
    });
  }(il, il.exports)), il.exports;
}
/*!
 * Paper.js v0.12.18 - The Swiss Army Knife of Vector Graphics Scripting.
 * http://paperjs.org/
 *
 * Copyright (c) 2011 - 2020, Jürg Lehni & Jonathan Puckey
 * http://juerglehni.com/ & https://puckey.studio/
 *
 * Distributed under the MIT license. See LICENSE file for details.
 *
 * All rights reserved.
 *
 * Date: Wed Jul 17 14:57:24 2024 +0200
 *
 ***
 *
 * Straps.js - Class inheritance library with support for bean-style accessors
 *
 * Copyright (c) 2006 - 2020 Jürg Lehni
 * http://juerglehni.com/
 *
 * Distributed under the MIT license.
 *
 ***
 *
 * Acorn.js
 * https://marijnhaverbeke.nl/acorn/
 *
 * Acorn is a tiny, fast JavaScript parser written in JavaScript,
 * created by Marijn Haverbeke and released under an MIT license.
 *
 */
(function(b) {
  (function(e, t) {
    e = e || Xf;
    var n = e.window, s = e.document, o = new function() {
      var i = /^(statics|enumerable|beans|preserve)$/, r = [], a = r.slice, l = Object.create, u = Object.getOwnPropertyDescriptor, d = Object.defineProperty, v = r.forEach || function(A, T) {
        for (var G = 0, R = this.length; G < R; G++)
          A.call(T, this[G], G, this);
      }, p = function(A, T) {
        for (var G in this)
          this.hasOwnProperty(G) && A.call(T, this[G], G, this);
      }, y = Object.assign || function(A) {
        for (var T = 1, G = arguments.length; T < G; T++) {
          var R = arguments[T];
          for (var Y in R)
            R.hasOwnProperty(Y) && (A[Y] = R[Y]);
        }
        return A;
      }, S = function(A, T, G) {
        if (A) {
          var R = u(A, "length");
          (R && typeof R.value == "number" ? v : p).call(A, T, G = G || A);
        }
        return G;
      };
      function L(A, T, G, R, Y) {
        var k = {};
        function z(H, ie) {
          ie = ie || (ie = u(T, H)) && (ie.get ? ie : ie.value), typeof ie == "string" && ie[0] === "#" && (ie = A[ie.substring(1)] || ie);
          var ae = typeof ie == "function", he = ie, pe = Y || ae && !ie.base ? ie && ie.get ? H in A : A[H] : null, se;
          (!Y || !pe) && (ae && pe && (ie.base = pe), ae && R !== !1 && (se = H.match(/^([gs]et|is)(([A-Z])(.*))$/)) && (k[se[3].toLowerCase() + se[4]] = se[2]), (!he || ae || !he.get || typeof he.get != "function" || !E.isPlainObject(he)) && (he = { value: he, writable: !0 }), (u(A, H) || { configurable: !0 }).configurable && (he.configurable = !0, he.enumerable = G ?? !se), d(A, H, he));
        }
        if (T) {
          for (var C in T)
            T.hasOwnProperty(C) && !i.test(C) && z(C);
          for (var C in k) {
            var I = k[C], j = A["set" + I], q = A["get" + I] || j && A["is" + I];
            q && (R === !0 || q.length === 0) && z(C, { get: q, set: j });
          }
        }
        return A;
      }
      function E() {
        for (var A = 0, T = arguments.length; A < T; A++) {
          var G = arguments[A];
          G && y(this, G);
        }
        return this;
      }
      return L(E, {
        inject: function(A) {
          if (A) {
            var T = A.statics === !0 ? A : A.statics, G = A.beans, R = A.preserve;
            T !== A && L(this.prototype, A, A.enumerable, G, R), L(this, T, null, G, R);
          }
          for (var Y = 1, k = arguments.length; Y < k; Y++)
            this.inject(arguments[Y]);
          return this;
        },
        extend: function() {
          for (var A = this, T, G, R = 0, Y, k = arguments.length; R < k && !(T && G); R++)
            Y = arguments[R], T = T || Y.initialize, G = G || Y.prototype;
          return T = T || function() {
            A.apply(this, arguments);
          }, G = T.prototype = G || l(this.prototype), d(
            G,
            "constructor",
            { value: T, writable: !0, configurable: !0 }
          ), L(T, this), arguments.length && this.inject.apply(T, arguments), T.base = A, T;
        }
      }).inject({
        enumerable: !1,
        initialize: E,
        set: E,
        inject: function() {
          for (var A = 0, T = arguments.length; A < T; A++) {
            var G = arguments[A];
            G && L(this, G, G.enumerable, G.beans, G.preserve);
          }
          return this;
        },
        extend: function() {
          var A = l(this);
          return A.inject.apply(A, arguments);
        },
        each: function(A, T) {
          return S(this, A, T);
        },
        clone: function() {
          return new this.constructor(this);
        },
        statics: {
          set: y,
          each: S,
          create: l,
          define: d,
          describe: u,
          clone: function(A) {
            return y(new A.constructor(), A);
          },
          isPlainObject: function(A) {
            var T = A != null && A.constructor;
            return T && (T === Object || T === E || T.name === "Object");
          },
          pick: function(A, T) {
            return A !== t ? A : T;
          },
          slice: function(A, T, G) {
            return a.call(A, T, G);
          }
        }
      });
    }();
    b.exports = o, o.inject({
      enumerable: !1,
      toString: function() {
        return this._id != null ? (this._class || "Object") + (this._name ? " '" + this._name + "'" : " @" + this._id) : "{ " + o.each(this, function(i, r) {
          if (!/^_/.test(r)) {
            var a = typeof i;
            this.push(r + ": " + (a === "number" ? B.instance.number(i) : a === "string" ? "'" + i + "'" : i));
          }
        }, []).join(", ") + " }";
      },
      getClassName: function() {
        return this._class || "";
      },
      importJSON: function(i) {
        return o.importJSON(i, this);
      },
      exportJSON: function(i) {
        return o.exportJSON(this, i);
      },
      toJSON: function() {
        return o.serialize(this);
      },
      set: function(i, r) {
        return i && o.filter(this, i, r, this._prioritize), this;
      }
    }, {
      beans: !1,
      statics: {
        exports: {},
        extend: function i() {
          var r = i.base.apply(this, arguments), a = r.prototype._class;
          return a && !o.exports[a] && (o.exports[a] = r), r;
        },
        equals: function(i, r) {
          if (i === r)
            return !0;
          if (i && i.equals)
            return i.equals(r);
          if (r && r.equals)
            return r.equals(i);
          if (i && r && typeof i == "object" && typeof r == "object") {
            if (Array.isArray(i) && Array.isArray(r)) {
              var a = i.length;
              if (a !== r.length)
                return !1;
              for (; a--; )
                if (!o.equals(i[a], r[a]))
                  return !1;
            } else {
              var l = Object.keys(i), a = l.length;
              if (a !== Object.keys(r).length)
                return !1;
              for (; a--; ) {
                var u = l[a];
                if (!(r.hasOwnProperty(u) && o.equals(i[u], r[u])))
                  return !1;
              }
            }
            return !0;
          }
          return !1;
        },
        read: function(i, r, a, l) {
          if (this === o) {
            var u = this.peek(i, r);
            return i.__index++, u;
          }
          var d = this.prototype, v = d._readIndex, p = r || v && i.__index || 0, y = i.length, S = i[p];
          if (l = l || y - p, S instanceof this || a && a.readNull && S == null && l <= 1)
            return v && (i.__index = p + 1), S && a && a.clone ? S.clone() : S;
          if (S = o.create(d), v && (S.__read = !0), S = S.initialize.apply(S, p > 0 || p + l < y ? o.slice(i, p, p + l) : i) || S, v) {
            i.__index = p + S.__read;
            var L = S.__filtered;
            L && (i.__filtered = L, S.__filtered = t), S.__read = t;
          }
          return S;
        },
        peek: function(i, r) {
          return i[i.__index = r || i.__index || 0];
        },
        remain: function(i) {
          return i.length - (i.__index || 0);
        },
        readList: function(i, r, a, l) {
          for (var u = [], d, v = r || 0, p = l ? v + l : i.length, y = v; y < p; y++)
            u.push(Array.isArray(d = i[y]) ? this.read(d, 0, a) : this.read(i, y, a, 1));
          return u;
        },
        readNamed: function(i, r, a, l, u) {
          var d = this.getNamed(i, r), v = d !== t;
          if (v) {
            var p = i.__filtered;
            if (!p) {
              var y = this.getSource(i);
              p = i.__filtered = o.create(y), p.__unfiltered = y;
            }
            p[r] = t;
          }
          return this.read(v ? [d] : i, a, l, u);
        },
        readSupported: function(i, r) {
          var a = this.getSource(i), l = this, u = !1;
          return a && Object.keys(a).forEach(function(d) {
            if (d in r) {
              var v = l.readNamed(i, d);
              v !== t && (r[d] = v), u = !0;
            }
          }), u;
        },
        getSource: function(i) {
          var r = i.__source;
          if (r === t) {
            var a = i.length === 1 && i[0];
            r = i.__source = a && o.isPlainObject(a) ? a : null;
          }
          return r;
        },
        getNamed: function(i, r) {
          var a = this.getSource(i);
          if (a)
            return r ? a[r] : i.__filtered || a;
        },
        hasNamed: function(i, r) {
          return !!this.getNamed(i, r);
        },
        filter: function(i, r, a, l) {
          var u;
          function d(L) {
            if (!(a && L in a) && !(u && L in u)) {
              var E = r[L];
              E !== t && (i[L] = E);
            }
          }
          if (l) {
            for (var v = {}, p = 0, y, S = l.length; p < S; p++)
              (y = l[p]) in r && (d(y), v[y] = !0);
            u = v;
          }
          return Object.keys(r.__unfiltered || r).forEach(d), i;
        },
        isPlainValue: function(i, r) {
          return o.isPlainObject(i) || Array.isArray(i) || r && typeof i == "string";
        },
        serialize: function(i, r, a, l) {
          r = r || {};
          var u = !l, d;
          if (u && (r.formatter = new B(r.precision), l = {
            length: 0,
            definitions: {},
            references: {},
            add: function(E, A) {
              var T = "#" + E._id, G = this.references[T];
              if (!G) {
                this.length++;
                var R = A.call(E), Y = E._class;
                Y && R[0] !== Y && R.unshift(Y), this.definitions[T] = R, G = this.references[T] = [T];
              }
              return G;
            }
          }), i && i._serialize) {
            d = i._serialize(r, l);
            var v = i._class;
            v && !i._compactSerialize && (u || !a) && d[0] !== v && d.unshift(v);
          } else if (Array.isArray(i)) {
            d = [];
            for (var p = 0, y = i.length; p < y; p++)
              d[p] = o.serialize(i[p], r, a, l);
          } else if (o.isPlainObject(i)) {
            d = {};
            for (var S = Object.keys(i), p = 0, y = S.length; p < y; p++) {
              var L = S[p];
              d[L] = o.serialize(
                i[L],
                r,
                a,
                l
              );
            }
          } else
            typeof i == "number" ? d = r.formatter.number(i, r.precision) : d = i;
          return u && l.length > 0 ? [["dictionary", l.definitions], d] : d;
        },
        deserialize: function(i, r, a, l, u) {
          var d = i, v = !a, p = v && i && i.length && i[0][0] === "dictionary";
          if (a = a || {}, Array.isArray(i)) {
            var y = i[0], S = y === "dictionary";
            if (i.length == 1 && /^#/.test(y))
              return a.dictionary[y];
            y = o.exports[y], d = [];
            for (var L = y ? 1 : 0, E = i.length; L < E; L++)
              d.push(o.deserialize(
                i[L],
                r,
                a,
                S,
                p
              ));
            if (y) {
              var A = d;
              r ? d = r(y, A, v || u) : d = new y(A);
            }
          } else if (o.isPlainObject(i)) {
            d = {}, l && (a.dictionary = d);
            for (var T in i)
              d[T] = o.deserialize(i[T], r, a);
          }
          return p ? d[1] : d;
        },
        exportJSON: function(i, r) {
          var a = o.serialize(i, r);
          return r && r.asString == !1 ? a : JSON.stringify(a);
        },
        importJSON: function(i, r) {
          return o.deserialize(
            typeof i == "string" ? JSON.parse(i) : i,
            function(a, l, u) {
              var d = u && r && r.constructor === a, v = d ? r : o.create(a.prototype);
              if (l.length === 1 && v instanceof X && (d || !(v instanceof je))) {
                var p = l[0];
                o.isPlainObject(p) && (p.insert = !1, d && (l = l.concat([X.INSERT])));
              }
              return (d ? v.set : a).apply(v, l), d && (r = null), v;
            }
          );
        },
        push: function(i, r) {
          var a = r.length;
          if (a < 4096)
            i.push.apply(i, r);
          else {
            var l = i.length;
            i.length += a;
            for (var u = 0; u < a; u++)
              i[l + u] = r[u];
          }
          return i;
        },
        splice: function(i, r, a, l) {
          var u = r && r.length, d = a === t;
          a = d ? i.length : a, a > i.length && (a = i.length);
          for (var v = 0; v < u; v++)
            r[v]._index = a + v;
          if (d)
            return o.push(i, r), [];
          var p = [a, l];
          r && o.push(p, r);
          for (var y = i.splice.apply(i, p), v = 0, S = y.length; v < S; v++)
            y[v]._index = t;
          for (var v = a + u, S = i.length; v < S; v++)
            i[v]._index = v;
          return y;
        },
        capitalize: function(i) {
          return i.replace(/\b[a-z]/g, function(r) {
            return r.toUpperCase();
          });
        },
        camelize: function(i) {
          return i.replace(/-(.)/g, function(r, a) {
            return a.toUpperCase();
          });
        },
        hyphenate: function(i) {
          return i.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
        }
      }
    });
    var h = {
      on: function(i, r) {
        if (typeof i != "string")
          o.each(i, function(d, v) {
            this.on(v, d);
          }, this);
        else {
          var a = this._eventTypes, l = a && a[i], u = this._callbacks = this._callbacks || {};
          u = u[i] = u[i] || [], u.indexOf(r) === -1 && (u.push(r), l && l.install && u.length === 1 && l.install.call(this, i));
        }
        return this;
      },
      off: function(i, r) {
        if (typeof i != "string") {
          o.each(i, function(v, p) {
            this.off(p, v);
          }, this);
          return;
        }
        var a = this._eventTypes, l = a && a[i], u = this._callbacks && this._callbacks[i], d;
        return u && (!r || (d = u.indexOf(r)) !== -1 && u.length === 1 ? (l && l.uninstall && l.uninstall.call(this, i), delete this._callbacks[i]) : d !== -1 && u.splice(d, 1)), this;
      },
      once: function(i, r) {
        return this.on(i, function a() {
          r.apply(this, arguments), this.off(i, a);
        });
      },
      emit: function(i, r) {
        var a = this._callbacks && this._callbacks[i];
        if (!a)
          return !1;
        var l = o.slice(arguments, 1), u = r && r.target && !r.currentTarget;
        a = a.slice(), u && (r.currentTarget = this);
        for (var d = 0, v = a.length; d < v; d++)
          if (a[d].apply(this, l) == !1) {
            r && r.stop && r.stop();
            break;
          }
        return u && delete r.currentTarget, !0;
      },
      responds: function(i) {
        return !!(this._callbacks && this._callbacks[i]);
      },
      attach: "#on",
      detach: "#off",
      fire: "#emit",
      _installEvents: function(i) {
        var r = this._eventTypes, a = this._callbacks, l = i ? "install" : "uninstall";
        if (r) {
          for (var u in a)
            if (a[u].length > 0) {
              var d = r[u], v = d && d[l];
              v && v.call(this, u);
            }
        }
      },
      statics: {
        inject: function i(r) {
          var a = r._events;
          if (a) {
            var l = {};
            o.each(a, function(u, d) {
              var v = typeof u == "string", p = v ? u : d, y = o.capitalize(p), S = p.substring(2).toLowerCase();
              l[S] = v ? {} : u, p = "_" + p, r["get" + y] = function() {
                return this[p];
              }, r["set" + y] = function(L) {
                var E = this[p];
                E && this.off(S, E), L && this.on(S, L), this[p] = L;
              };
            }), r._eventTypes = l;
          }
          return i.base.apply(this, arguments);
        }
      }
    }, c = o.extend({
      _class: "PaperScope",
      initialize: function i() {
        He = this, this.settings = new o({
          applyMatrix: !0,
          insertItems: !0,
          handleSize: 4,
          hitTolerance: 0
        }), this.project = null, this.projects = [], this.tools = [], this._id = i._id++, i._scopes[this._id] = this;
        var r = i.prototype;
        if (!this.support) {
          var a = mt.getContext(1, 1) || {};
          r.support = {
            nativeDash: "setLineDash" in a || "mozDash" in a,
            nativeBlendModes: Qe.nativeModes
          }, mt.release(a);
        }
        if (!this.agent) {
          var l = e.navigator.userAgent.toLowerCase(), u = (/(darwin|win|mac|linux|freebsd|sunos)/.exec(l) || [])[0], d = u === "darwin" ? "mac" : u, v = r.agent = r.browser = { platform: d };
          d && (v[d] = !0), l.replace(
            /(opera|chrome|safari|webkit|firefox|msie|trident|atom|node|jsdom)\/?\s*([.\d]+)(?:.*version\/([.\d]+))?(?:.*rv\:v?([.\d]+))?/g,
            function(p, y, S, L, E) {
              if (!v.chrome) {
                var A = y === "opera" ? L : /^(node|trident)$/.test(y) ? E : S;
                v.version = A, v.versionNumber = parseFloat(A), y = { trident: "msie", jsdom: "node" }[y] || y, v.name = y, v[y] = !0;
              }
            }
          ), v.chrome && delete v.webkit, v.atom && delete v.chrome;
        }
      },
      version: "0.12.18",
      getView: function() {
        var i = this.project;
        return i && i._view;
      },
      getPaper: function() {
        return this;
      },
      execute: function(i, r) {
        var a = He.PaperScript.execute(i, this, r);
        return ei.updateFocus(), a;
      },
      install: function(i) {
        var r = this;
        o.each(["project", "view", "tool"], function(l) {
          o.define(i, l, {
            configurable: !0,
            get: function() {
              return r[l];
            }
          });
        });
        for (var a in this)
          !/^_/.test(a) && this[a] && (i[a] = this[a]);
      },
      setup: function(i) {
        return He = this, this.project = new fe(i), this;
      },
      createCanvas: function(i, r) {
        return mt.getCanvas(i, r);
      },
      activate: function() {
        He = this;
      },
      clear: function() {
        for (var i = this.projects, r = this.tools, a = i.length - 1; a >= 0; a--)
          i[a].remove();
        for (var a = r.length - 1; a >= 0; a--)
          r[a].remove();
      },
      remove: function() {
        this.clear(), delete c._scopes[this._id];
      },
      statics: new function() {
        function i(r) {
          return r += "Attribute", function(a, l) {
            return a[r](l) || a[r]("data-paper-" + l);
          };
        }
        return {
          _scopes: {},
          _id: 0,
          get: function(r) {
            return this._scopes[r] || null;
          },
          getAttribute: i("get"),
          hasAttribute: i("has")
        };
      }()
    }), _ = o.extend(h, {
      initialize: function(i) {
        this._scope = He, this._index = this._scope[this._list].push(this) - 1, (i || !this._scope[this._reference]) && this.activate();
      },
      activate: function() {
        if (!this._scope)
          return !1;
        var i = this._scope[this._reference];
        return i && i !== this && i.emit("deactivate"), this._scope[this._reference] = this, this.emit("activate", i), !0;
      },
      isActive: function() {
        return this._scope[this._reference] === this;
      },
      remove: function() {
        return this._index == null ? !1 : (o.splice(this._scope[this._list], null, this._index, 1), this._scope[this._reference] == this && (this._scope[this._reference] = null), this._scope = null, !0);
      },
      getView: function() {
        return this._scope.getView();
      }
    }), x = {
      findItemBoundsCollisions: function(i, r, a) {
        function l(v) {
          for (var p = new Array(v.length), y = 0; y < v.length; y++) {
            var S = v[y].getBounds();
            p[y] = [S.left, S.top, S.right, S.bottom];
          }
          return p;
        }
        var u = l(i), d = !r || r === i ? u : l(r);
        return this.findBoundsCollisions(u, d, a || 0);
      },
      findCurveBoundsCollisions: function(i, r, a, l) {
        function u(A) {
          for (var T = Math.min, G = Math.max, R = new Array(A.length), Y = 0; Y < A.length; Y++) {
            var k = A[Y];
            R[Y] = [
              T(k[0], k[2], k[4], k[6]),
              T(k[1], k[3], k[5], k[7]),
              G(k[0], k[2], k[4], k[6]),
              G(k[1], k[3], k[5], k[7])
            ];
          }
          return R;
        }
        var d = u(i), v = !r || r === i ? d : u(r);
        if (l) {
          for (var p = this.findBoundsCollisions(
            d,
            v,
            a || 0,
            !1,
            !0
          ), y = this.findBoundsCollisions(
            d,
            v,
            a || 0,
            !0,
            !0
          ), S = [], L = 0, E = p.length; L < E; L++)
            S[L] = { hor: p[L], ver: y[L] };
          return S;
        }
        return this.findBoundsCollisions(d, v, a || 0);
      },
      findBoundsCollisions: function(i, r, a, l, u) {
        var d = !r || i === r, v = d ? i : i.concat(r), p = i.length, y = v.length;
        function S(Je, it, gt) {
          for (var Ne = 0, Fe = Je.length; Ne < Fe; ) {
            var st = Fe + Ne >>> 1;
            v[Je[st]][it] < gt ? Ne = st + 1 : Fe = st;
          }
          return Ne - 1;
        }
        for (var L = l ? 1 : 0, E = L + 2, A = l ? 0 : 1, T = A + 2, G = new Array(y), R = 0; R < y; R++)
          G[R] = R;
        G.sort(function(Je, it) {
          return v[Je][L] - v[it][L];
        });
        for (var Y = [], k = new Array(p), R = 0; R < y; R++) {
          var z = G[R], C = v[z], I = d ? z : z - p, j = z < p, q = d || !j, H = j ? [] : null;
          if (Y.length) {
            var ie = S(
              Y,
              E,
              C[L] - a
            ) + 1;
            if (Y.splice(0, ie), d && u) {
              H = H.concat(Y);
              for (var ae = 0; ae < Y.length; ae++) {
                var he = Y[ae];
                k[he].push(I);
              }
            } else
              for (var pe = C[T], se = C[A], ae = 0; ae < Y.length; ae++) {
                var he = Y[ae], de = v[he], ve = he < p, we = d || he >= p;
                (u || (j && we || q && ve) && pe >= de[A] - a && se <= de[T] + a) && (j && we && H.push(
                  d ? he : he - p
                ), q && ve && k[he].push(I));
              }
          }
          if (j && (i === r && H.push(z), k[z] = H), Y.length) {
            var Se = C[E], Ae = S(Y, E, Se);
            Y.splice(Ae + 1, 0, z);
          } else
            Y.push(z);
        }
        for (var R = 0; R < k.length; R++) {
          var Ge = k[R];
          Ge && Ge.sort(function(it, gt) {
            return it - gt;
          });
        }
        return k;
      }
    }, B = o.extend({
      initialize: function(i) {
        this.precision = o.pick(i, 5), this.multiplier = Math.pow(10, this.precision);
      },
      number: function(i) {
        return this.precision < 16 ? Math.round(i * this.multiplier) / this.multiplier : i;
      },
      pair: function(i, r, a) {
        return this.number(i) + (a || ",") + this.number(r);
      },
      point: function(i, r) {
        return this.number(i.x) + (r || ",") + this.number(i.y);
      },
      size: function(i, r) {
        return this.number(i.width) + (r || ",") + this.number(i.height);
      },
      rectangle: function(i, r) {
        return this.point(i, r) + (r || ",") + this.size(i, r);
      }
    });
    B.instance = new B();
    var P = new function() {
      var i = [
        [0.5773502691896257],
        [0, 0.7745966692414834],
        [0.33998104358485626, 0.8611363115940526],
        [0, 0.5384693101056831, 0.906179845938664],
        [0.2386191860831969, 0.6612093864662645, 0.932469514203152],
        [0, 0.4058451513773972, 0.7415311855993945, 0.9491079123427585],
        [0.1834346424956498, 0.525532409916329, 0.7966664774136267, 0.9602898564975363],
        [0, 0.3242534234038089, 0.6133714327005904, 0.8360311073266358, 0.9681602395076261],
        [0.14887433898163122, 0.4333953941292472, 0.6794095682990244, 0.8650633666889845, 0.9739065285171717],
        [0, 0.26954315595234496, 0.5190961292068118, 0.7301520055740494, 0.8870625997680953, 0.978228658146057],
        [0.1252334085114689, 0.3678314989981802, 0.5873179542866175, 0.7699026741943047, 0.9041172563704749, 0.9815606342467192],
        [0, 0.2304583159551348, 0.44849275103644687, 0.6423493394403402, 0.8015780907333099, 0.9175983992229779, 0.9841830547185881],
        [0.10805494870734367, 0.31911236892788974, 0.5152486363581541, 0.6872929048116855, 0.827201315069765, 0.9284348836635735, 0.9862838086968123],
        [0, 0.20119409399743451, 0.3941513470775634, 0.5709721726085388, 0.7244177313601701, 0.8482065834104272, 0.937273392400706, 0.9879925180204854],
        [0.09501250983763744, 0.2816035507792589, 0.45801677765722737, 0.6178762444026438, 0.755404408355003, 0.8656312023878318, 0.9445750230732326, 0.9894009349916499]
      ], r = [
        [1],
        [0.8888888888888888, 0.5555555555555556],
        [0.6521451548625461, 0.34785484513745385],
        [0.5688888888888889, 0.47862867049936647, 0.23692688505618908],
        [0.46791393457269104, 0.3607615730481386, 0.17132449237917036],
        [0.4179591836734694, 0.3818300505051189, 0.27970539148927664, 0.1294849661688697],
        [0.362683783378362, 0.31370664587788727, 0.22238103445337448, 0.10122853629037626],
        [0.3302393550012598, 0.31234707704000286, 0.26061069640293544, 0.1806481606948574, 0.08127438836157441],
        [0.29552422471475287, 0.26926671930999635, 0.21908636251598204, 0.1494513491505806, 0.06667134430868814],
        [0.2729250867779006, 0.26280454451024665, 0.23319376459199048, 0.18629021092773426, 0.1255803694649046, 0.05566856711617366],
        [0.24914704581340277, 0.2334925365383548, 0.20316742672306592, 0.16007832854334622, 0.10693932599531843, 0.04717533638651183],
        [0.2325515532308739, 0.22628318026289723, 0.2078160475368885, 0.17814598076194574, 0.13887351021978725, 0.09212149983772845, 0.04048400476531588],
        [0.2152638534631578, 0.2051984637212956, 0.18553839747793782, 0.15720316715819355, 0.12151857068790319, 0.08015808715976021, 0.03511946033175186],
        [0.2025782419255613, 0.19843148532711158, 0.1861610000155622, 0.16626920581699392, 0.13957067792615432, 0.10715922046717194, 0.07036604748810812, 0.03075324199611727],
        [0.1894506104550685, 0.18260341504492358, 0.16915651939500254, 0.14959598881657674, 0.12462897125553388, 0.09515851168249279, 0.062253523938647894, 0.027152459411754096]
      ], a = Math.abs, l = Math.sqrt, u = Math.pow, d = Math.log2 || function(E) {
        return Math.log(E) * Math.LOG2E;
      }, v = 1e-12, p = 112e-18;
      function y(E, A, T) {
        return E < A ? A : E > T ? T : E;
      }
      function S(E, A, T) {
        function G(ie) {
          var ae = ie * 134217729, he = ie - ae, pe = he + ae, se = ie - pe;
          return [pe, se];
        }
        var R = A * A - E * T, Y = A * A + E * T;
        if (a(R) * 3 < Y) {
          var k = G(E), z = G(A), C = G(T), I = A * A, j = z[0] * z[0] - I + 2 * z[0] * z[1] + z[1] * z[1], q = E * T, H = k[0] * C[0] - q + k[0] * C[1] + k[1] * C[0] + k[1] * C[1];
          R = I - q + (j - H);
        }
        return R;
      }
      function L() {
        var E = Math.max.apply(Math, arguments);
        return E && (E < 1e-8 || E > 1e8) ? u(2, -Math.round(d(E))) : 0;
      }
      return {
        EPSILON: v,
        MACHINE_EPSILON: p,
        CURVETIME_EPSILON: 1e-8,
        GEOMETRIC_EPSILON: 1e-7,
        TRIGONOMETRIC_EPSILON: 1e-8,
        ANGULAR_EPSILON: 1e-5,
        KAPPA: 4 * (l(2) - 1) / 3,
        isZero: function(E) {
          return E >= -v && E <= v;
        },
        isMachineZero: function(E) {
          return E >= -p && E <= p;
        },
        clamp: y,
        integrate: function(E, A, T, G) {
          for (var R = i[G - 2], Y = r[G - 2], k = (T - A) * 0.5, z = k + A, C = 0, I = G + 1 >> 1, j = G & 1 ? Y[C++] * E(z) : 0; C < I; ) {
            var q = k * R[C];
            j += Y[C++] * (E(z + q) + E(z - q));
          }
          return k * j;
        },
        findRoot: function(E, A, T, G, R, Y, k) {
          for (var z = 0; z < Y; z++) {
            var C = E(T), I = C / A(T), j = T - I;
            if (a(I) < k) {
              T = j;
              break;
            }
            C > 0 ? (R = T, T = j <= G ? (G + R) * 0.5 : j) : (G = T, T = j >= R ? (G + R) * 0.5 : j);
          }
          return y(T, G, R);
        },
        solveQuadratic: function(E, A, T, G, R, Y) {
          var k, z = 1 / 0;
          if (a(E) < v) {
            if (a(A) < v)
              return a(T) < v ? -1 : 0;
            k = -T / A;
          } else {
            A *= -0.5;
            var C = S(E, A, T);
            if (C && a(C) < p) {
              var I = L(a(E), a(A), a(T));
              I && (E *= I, A *= I, T *= I, C = S(E, A, T));
            }
            if (C >= -p) {
              var j = C < 0 ? 0 : l(C), q = A + (A < 0 ? -j : j);
              q === 0 ? (k = T / E, z = -k) : (k = q / E, z = T / q);
            }
          }
          var H = 0, ie = R == null, ae = R - v, he = Y + v;
          return isFinite(k) && (ie || k > ae && k < he) && (G[H++] = ie ? k : y(k, R, Y)), z !== k && isFinite(z) && (ie || z > ae && z < he) && (G[H++] = ie ? z : y(z, R, Y)), H;
        },
        solveCubic: function(E, A, T, G, R, Y, k) {
          var z = L(a(E), a(A), a(T), a(G)), C, I, j, q, H;
          z && (E *= z, A *= z, T *= z, G *= z);
          function ie(Ae) {
            C = Ae;
            var Ge = E * C;
            I = Ge + A, j = I * C + T, q = (Ge + I) * C + j, H = j * C + G;
          }
          if (a(E) < v)
            E = A, I = T, j = G, C = 1 / 0;
          else if (a(G) < v)
            I = A, j = T, C = 0;
          else {
            ie(-(A / E) / 3);
            var ae = H / E, he = u(a(ae), 1 / 3), pe = ae < 0 ? -1 : 1, se = -q / E, de = se > 0 ? 1.324717957244746 * Math.max(he, l(se)) : he, ve = C - pe * de;
            if (ve !== C) {
              do
                ie(ve), ve = q === 0 ? C : C - H / q / (1 + p);
              while (pe * ve > pe * C);
              a(E) * C * C > a(G / C) && (j = -G / C, I = (j - T) / C);
            }
          }
          var we = P.solveQuadratic(E, I, j, R, Y, k), Se = Y == null;
          return isFinite(C) && (we === 0 || we > 0 && C !== R[0] && C !== R[1]) && (Se || C > Y - v && C < k + v) && (R[we++] = Se ? C : y(C, Y, k)), we;
        }
      };
    }(), U = {
      _id: 1,
      _pools: {},
      get: function(i) {
        if (i) {
          var r = this._pools[i];
          return r || (r = this._pools[i] = { _id: 1 }), r._id++;
        } else
          return this._id++;
      }
    }, M = o.extend({
      _class: "Point",
      _readIndex: !0,
      initialize: function(r, a) {
        var l = typeof r, u = this.__read, d = 0;
        if (l === "number") {
          var v = typeof a == "number";
          this._set(r, v ? a : r), u && (d = v ? 2 : 1);
        } else if (l === "undefined" || r === null)
          this._set(0, 0), u && (d = r === null ? 1 : 0);
        else {
          var p = l === "string" ? r.split(/[\s,]+/) || [] : r;
          d = 1, Array.isArray(p) ? this._set(+p[0], +(p.length > 1 ? p[1] : p[0])) : "x" in p ? this._set(p.x || 0, p.y || 0) : "width" in p ? this._set(p.width || 0, p.height || 0) : "angle" in p ? (this._set(p.length || 0, 0), this.setAngle(p.angle || 0)) : (this._set(0, 0), d = 0);
        }
        return u && (this.__read = d), this;
      },
      set: "#initialize",
      _set: function(i, r) {
        return this.x = i, this.y = r, this;
      },
      equals: function(i) {
        return this === i || i && (this.x === i.x && this.y === i.y || Array.isArray(i) && this.x === i[0] && this.y === i[1]) || !1;
      },
      clone: function() {
        return new M(this.x, this.y);
      },
      toString: function() {
        var i = B.instance;
        return "{ x: " + i.number(this.x) + ", y: " + i.number(this.y) + " }";
      },
      _serialize: function(i) {
        var r = i.formatter;
        return [r.number(this.x), r.number(this.y)];
      },
      getLength: function() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
      },
      setLength: function(i) {
        if (this.isZero()) {
          var r = this._angle || 0;
          this._set(
            Math.cos(r) * i,
            Math.sin(r) * i
          );
        } else {
          var a = i / this.getLength();
          P.isZero(a) && this.getAngle(), this._set(
            this.x * a,
            this.y * a
          );
        }
      },
      getAngle: function() {
        return this.getAngleInRadians.apply(this, arguments) * 180 / Math.PI;
      },
      setAngle: function(i) {
        this.setAngleInRadians.call(this, i * Math.PI / 180);
      },
      getAngleInDegrees: "#getAngle",
      setAngleInDegrees: "#setAngle",
      getAngleInRadians: function() {
        if (arguments.length) {
          var i = M.read(arguments), r = this.getLength() * i.getLength();
          if (P.isZero(r))
            return NaN;
          var a = this.dot(i) / r;
          return Math.acos(a < -1 ? -1 : a > 1 ? 1 : a);
        } else
          return this.isZero() ? this._angle || 0 : this._angle = Math.atan2(this.y, this.x);
      },
      setAngleInRadians: function(i) {
        if (this._angle = i, !this.isZero()) {
          var r = this.getLength();
          this._set(
            Math.cos(i) * r,
            Math.sin(i) * r
          );
        }
      },
      getQuadrant: function() {
        return this.x >= 0 ? this.y >= 0 ? 1 : 4 : this.y >= 0 ? 2 : 3;
      }
    }, {
      beans: !1,
      getDirectedAngle: function() {
        var i = M.read(arguments);
        return Math.atan2(this.cross(i), this.dot(i)) * 180 / Math.PI;
      },
      getDistance: function() {
        var i = arguments, r = M.read(i), a = r.x - this.x, l = r.y - this.y, u = a * a + l * l, d = o.read(i);
        return d ? u : Math.sqrt(u);
      },
      normalize: function(i) {
        i === t && (i = 1);
        var r = this.getLength(), a = r !== 0 ? i / r : 0, l = new M(this.x * a, this.y * a);
        return a >= 0 && (l._angle = this._angle), l;
      },
      rotate: function(i, r) {
        if (i === 0)
          return this.clone();
        i = i * Math.PI / 180;
        var a = r ? this.subtract(r) : this, l = Math.sin(i), u = Math.cos(i);
        return a = new M(
          a.x * u - a.y * l,
          a.x * l + a.y * u
        ), r ? a.add(r) : a;
      },
      transform: function(i) {
        return i ? i._transformPoint(this) : this;
      },
      add: function() {
        var i = M.read(arguments);
        return new M(this.x + i.x, this.y + i.y);
      },
      subtract: function() {
        var i = M.read(arguments);
        return new M(this.x - i.x, this.y - i.y);
      },
      multiply: function() {
        var i = M.read(arguments);
        return new M(this.x * i.x, this.y * i.y);
      },
      divide: function() {
        var i = M.read(arguments);
        return new M(this.x / i.x, this.y / i.y);
      },
      modulo: function() {
        var i = M.read(arguments);
        return new M(this.x % i.x, this.y % i.y);
      },
      negate: function() {
        return new M(-this.x, -this.y);
      },
      isInside: function() {
        return D.read(arguments).contains(this);
      },
      isClose: function() {
        var i = arguments, r = M.read(i), a = o.read(i);
        return this.getDistance(r) <= a;
      },
      isCollinear: function() {
        var i = M.read(arguments);
        return M.isCollinear(this.x, this.y, i.x, i.y);
      },
      isColinear: "#isCollinear",
      isOrthogonal: function() {
        var i = M.read(arguments);
        return M.isOrthogonal(this.x, this.y, i.x, i.y);
      },
      isZero: function() {
        var i = P.isZero;
        return i(this.x) && i(this.y);
      },
      isNaN: function() {
        return isNaN(this.x) || isNaN(this.y);
      },
      isInQuadrant: function(i) {
        return this.x * (i > 1 && i < 4 ? -1 : 1) >= 0 && this.y * (i > 2 ? -1 : 1) >= 0;
      },
      dot: function() {
        var i = M.read(arguments);
        return this.x * i.x + this.y * i.y;
      },
      cross: function() {
        var i = M.read(arguments);
        return this.x * i.y - this.y * i.x;
      },
      project: function() {
        var i = M.read(arguments), r = i.isZero() ? 0 : this.dot(i) / i.dot(i);
        return new M(
          i.x * r,
          i.y * r
        );
      },
      statics: {
        min: function() {
          var i = arguments, r = M.read(i), a = M.read(i);
          return new M(
            Math.min(r.x, a.x),
            Math.min(r.y, a.y)
          );
        },
        max: function() {
          var i = arguments, r = M.read(i), a = M.read(i);
          return new M(
            Math.max(r.x, a.x),
            Math.max(r.y, a.y)
          );
        },
        random: function() {
          return new M(Math.random(), Math.random());
        },
        isCollinear: function(i, r, a, l) {
          return Math.abs(i * l - r * a) <= Math.sqrt((i * i + r * r) * (a * a + l * l)) * 1e-8;
        },
        isOrthogonal: function(i, r, a, l) {
          return Math.abs(i * a + r * l) <= Math.sqrt((i * i + r * r) * (a * a + l * l)) * 1e-8;
        }
      }
    }, o.each(["round", "ceil", "floor", "abs"], function(i) {
      var r = Math[i];
      this[i] = function() {
        return new M(r(this.x), r(this.y));
      };
    }, {})), Z = M.extend({
      initialize: function(r, a, l, u) {
        this._x = r, this._y = a, this._owner = l, this._setter = u;
      },
      _set: function(i, r, a) {
        return this._x = i, this._y = r, a || this._owner[this._setter](this), this;
      },
      getX: function() {
        return this._x;
      },
      setX: function(i) {
        this._x = i, this._owner[this._setter](this);
      },
      getY: function() {
        return this._y;
      },
      setY: function(i) {
        this._y = i, this._owner[this._setter](this);
      },
      isSelected: function() {
        return !!(this._owner._selection & this._getSelection());
      },
      setSelected: function(i) {
        this._owner._changeSelection(this._getSelection(), i);
      },
      _getSelection: function() {
        return this._setter === "setPosition" ? 4 : 0;
      }
    }), F = o.extend({
      _class: "Size",
      _readIndex: !0,
      initialize: function(r, a) {
        var l = typeof r, u = this.__read, d = 0;
        if (l === "number") {
          var v = typeof a == "number";
          this._set(r, v ? a : r), u && (d = v ? 2 : 1);
        } else if (l === "undefined" || r === null)
          this._set(0, 0), u && (d = r === null ? 1 : 0);
        else {
          var p = l === "string" ? r.split(/[\s,]+/) || [] : r;
          d = 1, Array.isArray(p) ? this._set(+p[0], +(p.length > 1 ? p[1] : p[0])) : "width" in p ? this._set(p.width || 0, p.height || 0) : "x" in p ? this._set(p.x || 0, p.y || 0) : (this._set(0, 0), d = 0);
        }
        return u && (this.__read = d), this;
      },
      set: "#initialize",
      _set: function(i, r) {
        return this.width = i, this.height = r, this;
      },
      equals: function(i) {
        return i === this || i && (this.width === i.width && this.height === i.height || Array.isArray(i) && this.width === i[0] && this.height === i[1]) || !1;
      },
      clone: function() {
        return new F(this.width, this.height);
      },
      toString: function() {
        var i = B.instance;
        return "{ width: " + i.number(this.width) + ", height: " + i.number(this.height) + " }";
      },
      _serialize: function(i) {
        var r = i.formatter;
        return [
          r.number(this.width),
          r.number(this.height)
        ];
      },
      add: function() {
        var i = F.read(arguments);
        return new F(this.width + i.width, this.height + i.height);
      },
      subtract: function() {
        var i = F.read(arguments);
        return new F(this.width - i.width, this.height - i.height);
      },
      multiply: function() {
        var i = F.read(arguments);
        return new F(this.width * i.width, this.height * i.height);
      },
      divide: function() {
        var i = F.read(arguments);
        return new F(this.width / i.width, this.height / i.height);
      },
      modulo: function() {
        var i = F.read(arguments);
        return new F(this.width % i.width, this.height % i.height);
      },
      negate: function() {
        return new F(-this.width, -this.height);
      },
      isZero: function() {
        var i = P.isZero;
        return i(this.width) && i(this.height);
      },
      isNaN: function() {
        return isNaN(this.width) || isNaN(this.height);
      },
      statics: {
        min: function(i, r) {
          return new F(
            Math.min(i.width, r.width),
            Math.min(i.height, r.height)
          );
        },
        max: function(i, r) {
          return new F(
            Math.max(i.width, r.width),
            Math.max(i.height, r.height)
          );
        },
        random: function() {
          return new F(Math.random(), Math.random());
        }
      }
    }, o.each(["round", "ceil", "floor", "abs"], function(i) {
      var r = Math[i];
      this[i] = function() {
        return new F(r(this.width), r(this.height));
      };
    }, {})), Q = F.extend({
      initialize: function(r, a, l, u) {
        this._width = r, this._height = a, this._owner = l, this._setter = u;
      },
      _set: function(i, r, a) {
        return this._width = i, this._height = r, a || this._owner[this._setter](this), this;
      },
      getWidth: function() {
        return this._width;
      },
      setWidth: function(i) {
        this._width = i, this._owner[this._setter](this);
      },
      getHeight: function() {
        return this._height;
      },
      setHeight: function(i) {
        this._height = i, this._owner[this._setter](this);
      }
    }), D = o.extend({
      _class: "Rectangle",
      _readIndex: !0,
      beans: !0,
      initialize: function(r, a, l, u) {
        var d = arguments, v = typeof r, p;
        if (v === "number" ? (this._set(r, a, l, u), p = 4) : v === "undefined" || r === null ? (this._set(0, 0, 0, 0), p = r === null ? 1 : 0) : d.length === 1 && (Array.isArray(r) ? (this._set.apply(this, r), p = 1) : r.x !== t || r.width !== t ? (this._set(
          r.x || 0,
          r.y || 0,
          r.width || 0,
          r.height || 0
        ), p = 1) : r.from === t && r.to === t && (this._set(0, 0, 0, 0), o.readSupported(d, this) && (p = 1))), p === t) {
          var y = M.readNamed(d, "from"), S = o.peek(d), L = y.x, E = y.y, A, T;
          if (S && S.x !== t || o.hasNamed(d, "to")) {
            var G = M.readNamed(d, "to");
            A = G.x - L, T = G.y - E, A < 0 && (L = G.x, A = -A), T < 0 && (E = G.y, T = -T);
          } else {
            var R = F.read(d);
            A = R.width, T = R.height;
          }
          this._set(L, E, A, T), p = d.__index;
        }
        var Y = d.__filtered;
        return Y && (this.__filtered = Y), this.__read && (this.__read = p), this;
      },
      set: "#initialize",
      _set: function(i, r, a, l) {
        return this.x = i, this.y = r, this.width = a, this.height = l, this;
      },
      clone: function() {
        return new D(this.x, this.y, this.width, this.height);
      },
      equals: function(i) {
        var r = o.isPlainValue(i) ? D.read(arguments) : i;
        return r === this || r && this.x === r.x && this.y === r.y && this.width === r.width && this.height === r.height || !1;
      },
      toString: function() {
        var i = B.instance;
        return "{ x: " + i.number(this.x) + ", y: " + i.number(this.y) + ", width: " + i.number(this.width) + ", height: " + i.number(this.height) + " }";
      },
      _serialize: function(i) {
        var r = i.formatter;
        return [
          r.number(this.x),
          r.number(this.y),
          r.number(this.width),
          r.number(this.height)
        ];
      },
      getPoint: function(i) {
        var r = i ? M : Z;
        return new r(this.x, this.y, this, "setPoint");
      },
      setPoint: function() {
        var i = M.read(arguments);
        this.x = i.x, this.y = i.y;
      },
      getSize: function(i) {
        var r = i ? F : Q;
        return new r(this.width, this.height, this, "setSize");
      },
      _fw: 1,
      _fh: 1,
      setSize: function() {
        var i = F.read(arguments), r = this._sx, a = this._sy, l = i.width, u = i.height;
        r && (this.x += (this.width - l) * r), a && (this.y += (this.height - u) * a), this.width = l, this.height = u, this._fw = this._fh = 1;
      },
      getLeft: function() {
        return this.x;
      },
      setLeft: function(i) {
        if (!this._fw) {
          var r = i - this.x;
          this.width -= this._sx === 0.5 ? r * 2 : r;
        }
        this.x = i, this._sx = this._fw = 0;
      },
      getTop: function() {
        return this.y;
      },
      setTop: function(i) {
        if (!this._fh) {
          var r = i - this.y;
          this.height -= this._sy === 0.5 ? r * 2 : r;
        }
        this.y = i, this._sy = this._fh = 0;
      },
      getRight: function() {
        return this.x + this.width;
      },
      setRight: function(i) {
        if (!this._fw) {
          var r = i - this.x;
          this.width = this._sx === 0.5 ? r * 2 : r;
        }
        this.x = i - this.width, this._sx = 1, this._fw = 0;
      },
      getBottom: function() {
        return this.y + this.height;
      },
      setBottom: function(i) {
        if (!this._fh) {
          var r = i - this.y;
          this.height = this._sy === 0.5 ? r * 2 : r;
        }
        this.y = i - this.height, this._sy = 1, this._fh = 0;
      },
      getCenterX: function() {
        return this.x + this.width / 2;
      },
      setCenterX: function(i) {
        this._fw || this._sx === 0.5 ? this.x = i - this.width / 2 : (this._sx && (this.x += (i - this.x) * 2 * this._sx), this.width = (i - this.x) * 2), this._sx = 0.5, this._fw = 0;
      },
      getCenterY: function() {
        return this.y + this.height / 2;
      },
      setCenterY: function(i) {
        this._fh || this._sy === 0.5 ? this.y = i - this.height / 2 : (this._sy && (this.y += (i - this.y) * 2 * this._sy), this.height = (i - this.y) * 2), this._sy = 0.5, this._fh = 0;
      },
      getCenter: function(i) {
        var r = i ? M : Z;
        return new r(this.getCenterX(), this.getCenterY(), this, "setCenter");
      },
      setCenter: function() {
        var i = M.read(arguments);
        return this.setCenterX(i.x), this.setCenterY(i.y), this;
      },
      getArea: function() {
        return this.width * this.height;
      },
      isEmpty: function() {
        return this.width === 0 || this.height === 0;
      },
      contains: function(i) {
        return i && i.width !== t || (Array.isArray(i) ? i : arguments).length === 4 ? this._containsRectangle(D.read(arguments)) : this._containsPoint(M.read(arguments));
      },
      _containsPoint: function(i) {
        var r = i.x, a = i.y;
        return r >= this.x && a >= this.y && r <= this.x + this.width && a <= this.y + this.height;
      },
      _containsRectangle: function(i) {
        var r = i.x, a = i.y;
        return r >= this.x && a >= this.y && r + i.width <= this.x + this.width && a + i.height <= this.y + this.height;
      },
      intersects: function() {
        var i = D.read(arguments), r = o.read(arguments) || 0;
        return i.x + i.width > this.x - r && i.y + i.height > this.y - r && i.x < this.x + this.width + r && i.y < this.y + this.height + r;
      },
      intersect: function() {
        var i = D.read(arguments), r = Math.max(this.x, i.x), a = Math.max(this.y, i.y), l = Math.min(this.x + this.width, i.x + i.width), u = Math.min(this.y + this.height, i.y + i.height);
        return new D(r, a, l - r, u - a);
      },
      unite: function() {
        var i = D.read(arguments), r = Math.min(this.x, i.x), a = Math.min(this.y, i.y), l = Math.max(this.x + this.width, i.x + i.width), u = Math.max(this.y + this.height, i.y + i.height);
        return new D(r, a, l - r, u - a);
      },
      include: function() {
        var i = M.read(arguments), r = Math.min(this.x, i.x), a = Math.min(this.y, i.y), l = Math.max(this.x + this.width, i.x), u = Math.max(this.y + this.height, i.y);
        return new D(r, a, l - r, u - a);
      },
      expand: function() {
        var i = F.read(arguments), r = i.width, a = i.height;
        return new D(
          this.x - r / 2,
          this.y - a / 2,
          this.width + r,
          this.height + a
        );
      },
      scale: function(i, r) {
        return this.expand(
          this.width * i - this.width,
          this.height * (r === t ? i : r) - this.height
        );
      }
    }, o.each(
      [
        ["Top", "Left"],
        ["Top", "Right"],
        ["Bottom", "Left"],
        ["Bottom", "Right"],
        ["Left", "Center"],
        ["Top", "Center"],
        ["Right", "Center"],
        ["Bottom", "Center"]
      ],
      function(i, r) {
        var a = i.join(""), l = /^[RL]/.test(a);
        r >= 4 && (i[1] += l ? "Y" : "X");
        var u = i[l ? 0 : 1], d = i[l ? 1 : 0], v = "get" + u, p = "get" + d, y = "set" + u, S = "set" + d, L = "get" + a, E = "set" + a;
        this[L] = function(A) {
          var T = A ? M : Z;
          return new T(this[v](), this[p](), this, E);
        }, this[E] = function() {
          var A = M.read(arguments);
          this[y](A.x), this[S](A.y);
        };
      },
      {
        beans: !0
      }
    )), te = D.extend(
      {
        initialize: function(r, a, l, u, d, v) {
          this._set(r, a, l, u, !0), this._owner = d, this._setter = v;
        },
        _set: function(i, r, a, l, u) {
          return this._x = i, this._y = r, this._width = a, this._height = l, u || this._owner[this._setter](this), this;
        }
      },
      new function() {
        var i = D.prototype;
        return o.each(
          ["x", "y", "width", "height"],
          function(r) {
            var a = o.capitalize(r), l = "_" + r;
            this["get" + a] = function() {
              return this[l];
            }, this["set" + a] = function(u) {
              this[l] = u, this._dontNotify || this._owner[this._setter](this);
            };
          },
          o.each(
            [
              "Point",
              "Size",
              "Center",
              "Left",
              "Top",
              "Right",
              "Bottom",
              "CenterX",
              "CenterY",
              "TopLeft",
              "TopRight",
              "BottomLeft",
              "BottomRight",
              "LeftCenter",
              "TopCenter",
              "RightCenter",
              "BottomCenter"
            ],
            function(r) {
              var a = "set" + r;
              this[a] = function() {
                this._dontNotify = !0, i[a].apply(this, arguments), this._dontNotify = !1, this._owner[this._setter](this);
              };
            },
            {
              isSelected: function() {
                return !!(this._owner._selection & 2);
              },
              setSelected: function(r) {
                var a = this._owner;
                a._changeSelection && a._changeSelection(2, r);
              }
            }
          )
        );
      }()
    ), ee = o.extend({
      _class: "Matrix",
      initialize: function i(r, a) {
        var l = arguments, u = l.length, d = !0;
        if (u >= 6 ? this._set.apply(this, l) : u === 1 || u === 2 ? r instanceof i ? this._set(
          r._a,
          r._b,
          r._c,
          r._d,
          r._tx,
          r._ty,
          a
        ) : Array.isArray(r) ? this._set.apply(
          this,
          a ? r.concat([a]) : r
        ) : d = !1 : u ? d = !1 : this.reset(), !d)
          throw new Error("Unsupported matrix parameters");
        return this;
      },
      set: "#initialize",
      _set: function(i, r, a, l, u, d, v) {
        return this._a = i, this._b = r, this._c = a, this._d = l, this._tx = u, this._ty = d, v || this._changed(), this;
      },
      _serialize: function(i, r) {
        return o.serialize(this.getValues(), i, !0, r);
      },
      _changed: function() {
        var i = this._owner;
        i && (i._applyMatrix ? i.transform(null, !0) : i._changed(25));
      },
      clone: function() {
        return new ee(
          this._a,
          this._b,
          this._c,
          this._d,
          this._tx,
          this._ty
        );
      },
      equals: function(i) {
        return i === this || i && this._a === i._a && this._b === i._b && this._c === i._c && this._d === i._d && this._tx === i._tx && this._ty === i._ty;
      },
      toString: function() {
        var i = B.instance;
        return "[[" + [
          i.number(this._a),
          i.number(this._c),
          i.number(this._tx)
        ].join(", ") + "], [" + [
          i.number(this._b),
          i.number(this._d),
          i.number(this._ty)
        ].join(", ") + "]]";
      },
      reset: function(i) {
        return this._a = this._d = 1, this._b = this._c = this._tx = this._ty = 0, i || this._changed(), this;
      },
      apply: function(i, r) {
        var a = this._owner;
        return a ? (a.transform(null, o.pick(i, !0), r), this.isIdentity()) : !1;
      },
      translate: function() {
        var i = M.read(arguments), r = i.x, a = i.y;
        return this._tx += r * this._a + a * this._c, this._ty += r * this._b + a * this._d, this._changed(), this;
      },
      scale: function() {
        var i = arguments, r = M.read(i), a = M.read(i, 0, { readNull: !0 });
        return a && this.translate(a), this._a *= r.x, this._b *= r.x, this._c *= r.y, this._d *= r.y, a && this.translate(a.negate()), this._changed(), this;
      },
      rotate: function(i) {
        i *= Math.PI / 180;
        var r = M.read(arguments, 1), a = r.x, l = r.y, u = Math.cos(i), d = Math.sin(i), v = a - a * u + l * d, p = l - a * d - l * u, y = this._a, S = this._b, L = this._c, E = this._d;
        return this._a = u * y + d * L, this._b = u * S + d * E, this._c = -d * y + u * L, this._d = -d * S + u * E, this._tx += v * y + p * L, this._ty += v * S + p * E, this._changed(), this;
      },
      shear: function() {
        var i = arguments, r = M.read(i), a = M.read(i, 0, { readNull: !0 });
        a && this.translate(a);
        var l = this._a, u = this._b;
        return this._a += r.y * this._c, this._b += r.y * this._d, this._c += r.x * l, this._d += r.x * u, a && this.translate(a.negate()), this._changed(), this;
      },
      skew: function() {
        var i = arguments, r = M.read(i), a = M.read(i, 0, { readNull: !0 }), l = Math.PI / 180, u = new M(
          Math.tan(r.x * l),
          Math.tan(r.y * l)
        );
        return this.shear(u, a);
      },
      append: function(i, r) {
        if (i) {
          var a = this._a, l = this._b, u = this._c, d = this._d, v = i._a, p = i._c, y = i._b, S = i._d, L = i._tx, E = i._ty;
          this._a = v * a + y * u, this._c = p * a + S * u, this._b = v * l + y * d, this._d = p * l + S * d, this._tx += L * a + E * u, this._ty += L * l + E * d, r || this._changed();
        }
        return this;
      },
      prepend: function(i, r) {
        if (i) {
          var a = this._a, l = this._b, u = this._c, d = this._d, v = this._tx, p = this._ty, y = i._a, S = i._c, L = i._b, E = i._d, A = i._tx, T = i._ty;
          this._a = y * a + S * l, this._c = y * u + S * d, this._b = L * a + E * l, this._d = L * u + E * d, this._tx = y * v + S * p + A, this._ty = L * v + E * p + T, r || this._changed();
        }
        return this;
      },
      appended: function(i) {
        return this.clone().append(i);
      },
      prepended: function(i) {
        return this.clone().prepend(i);
      },
      invert: function() {
        var i = this._a, r = this._b, a = this._c, l = this._d, u = this._tx, d = this._ty, v = i * l - r * a, p = null;
        return v && !isNaN(v) && isFinite(u) && isFinite(d) && (this._a = l / v, this._b = -r / v, this._c = -a / v, this._d = i / v, this._tx = (a * d - l * u) / v, this._ty = (r * u - i * d) / v, p = this), p;
      },
      inverted: function() {
        return this.clone().invert();
      },
      concatenate: "#append",
      preConcatenate: "#prepend",
      chain: "#appended",
      _shiftless: function() {
        return new ee(this._a, this._b, this._c, this._d, 0, 0);
      },
      _orNullIfIdentity: function() {
        return this.isIdentity() ? null : this;
      },
      isIdentity: function() {
        return this._a === 1 && this._b === 0 && this._c === 0 && this._d === 1 && this._tx === 0 && this._ty === 0;
      },
      isInvertible: function() {
        var i = this._a * this._d - this._c * this._b;
        return i && !isNaN(i) && isFinite(this._tx) && isFinite(this._ty);
      },
      isSingular: function() {
        return !this.isInvertible();
      },
      transform: function(i, r, a) {
        return arguments.length < 3 ? this._transformPoint(M.read(arguments)) : this._transformCoordinates(i, r, a);
      },
      _transformPoint: function(i, r, a) {
        var l = i.x, u = i.y;
        return r || (r = new M()), r._set(
          l * this._a + u * this._c + this._tx,
          l * this._b + u * this._d + this._ty,
          a
        );
      },
      _transformCoordinates: function(i, r, a) {
        for (var l = 0, u = 2 * a; l < u; l += 2) {
          var d = i[l], v = i[l + 1];
          r[l] = d * this._a + v * this._c + this._tx, r[l + 1] = d * this._b + v * this._d + this._ty;
        }
        return r;
      },
      _transformCorners: function(i) {
        var r = i.x, a = i.y, l = r + i.width, u = a + i.height, d = [r, a, l, a, l, u, r, u];
        return this._transformCoordinates(d, d, 4);
      },
      _transformBounds: function(i, r, a) {
        for (var l = this._transformCorners(i), u = l.slice(0, 2), d = u.slice(), v = 2; v < 8; v++) {
          var p = l[v], y = v & 1;
          p < u[y] ? u[y] = p : p > d[y] && (d[y] = p);
        }
        return r || (r = new D()), r._set(
          u[0],
          u[1],
          d[0] - u[0],
          d[1] - u[1],
          a
        );
      },
      inverseTransform: function() {
        return this._inverseTransform(M.read(arguments));
      },
      _inverseTransform: function(i, r, a) {
        var l = this._a, u = this._b, d = this._c, v = this._d, p = this._tx, y = this._ty, S = l * v - u * d, L = null;
        if (S && !isNaN(S) && isFinite(p) && isFinite(y)) {
          var E = i.x - this._tx, A = i.y - this._ty;
          r || (r = new M()), L = r._set(
            (E * v - A * d) / S,
            (A * l - E * u) / S,
            a
          );
        }
        return L;
      },
      decompose: function() {
        var i = this._a, r = this._b, a = this._c, l = this._d, u = i * l - r * a, d = Math.sqrt, v = Math.atan2, p = 180 / Math.PI, y, S, L;
        if (i !== 0 || r !== 0) {
          var E = d(i * i + r * r);
          y = Math.acos(i / E) * (r > 0 ? 1 : -1), S = [E, u / E], L = [v(i * a + r * l, E * E), 0];
        } else if (a !== 0 || l !== 0) {
          var A = d(a * a + l * l);
          y = Math.asin(a / A) * (l > 0 ? 1 : -1), S = [u / A, A], L = [0, v(i * a + r * l, A * A)];
        } else
          y = 0, L = S = [0, 0];
        return {
          translation: this.getTranslation(),
          rotation: y * p,
          scaling: new M(S),
          skewing: new M(L[0] * p, L[1] * p)
        };
      },
      getValues: function() {
        return [this._a, this._b, this._c, this._d, this._tx, this._ty];
      },
      getTranslation: function() {
        return new M(this._tx, this._ty);
      },
      getScaling: function() {
        return this.decompose().scaling;
      },
      getRotation: function() {
        return this.decompose().rotation;
      },
      applyToContext: function(i) {
        this.isIdentity() || i.transform(
          this._a,
          this._b,
          this._c,
          this._d,
          this._tx,
          this._ty
        );
      }
    }, o.each(["a", "b", "c", "d", "tx", "ty"], function(i) {
      var r = o.capitalize(i), a = "_" + i;
      this["get" + r] = function() {
        return this[a];
      }, this["set" + r] = function(l) {
        this[a] = l, this._changed();
      };
    }, {})), le = o.extend({
      _class: "Line",
      initialize: function(r, a, l, u, d) {
        var v = !1;
        arguments.length >= 4 ? (this._px = r, this._py = a, this._vx = l, this._vy = u, v = d) : (this._px = r.x, this._py = r.y, this._vx = a.x, this._vy = a.y, v = l), v || (this._vx -= this._px, this._vy -= this._py);
      },
      getPoint: function() {
        return new M(this._px, this._py);
      },
      getVector: function() {
        return new M(this._vx, this._vy);
      },
      getLength: function() {
        return this.getVector().getLength();
      },
      intersect: function(i, r) {
        return le.intersect(
          this._px,
          this._py,
          this._vx,
          this._vy,
          i._px,
          i._py,
          i._vx,
          i._vy,
          !0,
          r
        );
      },
      getSide: function(i, r) {
        return le.getSide(
          this._px,
          this._py,
          this._vx,
          this._vy,
          i.x,
          i.y,
          !0,
          r
        );
      },
      getDistance: function(i) {
        return Math.abs(this.getSignedDistance(i));
      },
      getSignedDistance: function(i) {
        return le.getSignedDistance(
          this._px,
          this._py,
          this._vx,
          this._vy,
          i.x,
          i.y,
          !0
        );
      },
      isCollinear: function(i) {
        return M.isCollinear(this._vx, this._vy, i._vx, i._vy);
      },
      isOrthogonal: function(i) {
        return M.isOrthogonal(this._vx, this._vy, i._vx, i._vy);
      },
      statics: {
        intersect: function(i, r, a, l, u, d, v, p, y, S) {
          y || (a -= i, l -= r, v -= u, p -= d);
          var L = a * p - l * v;
          if (!P.isMachineZero(L)) {
            var E = i - u, A = r - d, T = (v * A - p * E) / L, G = (a * A - l * E) / L, R = 1e-12, Y = -R, k = 1 + R;
            if (S || Y < T && T < k && Y < G && G < k)
              return S || (T = T <= 0 ? 0 : T >= 1 ? 1 : T), new M(
                i + T * a,
                r + T * l
              );
          }
        },
        getSide: function(i, r, a, l, u, d, v, p) {
          v || (a -= i, l -= r);
          var y = u - i, S = d - r, L = y * l - S * a;
          return !p && P.isMachineZero(L) && (L = (y * a + y * a) / (a * a + l * l), L >= 0 && L <= 1 && (L = 0)), L < 0 ? -1 : L > 0 ? 1 : 0;
        },
        getSignedDistance: function(i, r, a, l, u, d, v) {
          return v || (a -= i, l -= r), a === 0 ? l > 0 ? u - i : i - u : l === 0 ? a < 0 ? d - r : r - d : ((u - i) * l - (d - r) * a) / (l > a ? l * Math.sqrt(1 + a * a / (l * l)) : a * Math.sqrt(1 + l * l / (a * a)));
        },
        getDistance: function(i, r, a, l, u, d, v) {
          return Math.abs(
            le.getSignedDistance(i, r, a, l, u, d, v)
          );
        }
      }
    }), fe = _.extend({
      _class: "Project",
      _list: "projects",
      _reference: "project",
      _compactSerialize: !0,
      initialize: function(r) {
        _.call(this, !0), this._children = [], this._namedChildren = {}, this._activeLayer = null, this._currentStyle = new _i(null, null, this), this._view = ei.create(
          this,
          r || mt.getCanvas(1, 1)
        ), this._selectionItems = {}, this._selectionCount = 0, this._updateVersion = 0;
      },
      _serialize: function(i, r) {
        return o.serialize(this._children, i, !0, r);
      },
      _changed: function(i, r) {
        if (i & 1) {
          var a = this._view;
          a && (a._needsUpdate = !0, !a._requested && a._autoUpdate && a.requestUpdate());
        }
        var l = this._changes;
        if (l && r) {
          var u = this._changesById, d = r._id, v = u[d];
          v ? v.flags |= i : l.push(u[d] = { item: r, flags: i });
        }
      },
      clear: function() {
        for (var i = this._children, r = i.length - 1; r >= 0; r--)
          i[r].remove();
      },
      isEmpty: function() {
        return !this._children.length;
      },
      remove: function i() {
        return i.base.call(this) ? (this._view && this._view.remove(), !0) : !1;
      },
      getView: function() {
        return this._view;
      },
      getCurrentStyle: function() {
        return this._currentStyle;
      },
      setCurrentStyle: function(i) {
        this._currentStyle.set(i);
      },
      getIndex: function() {
        return this._index;
      },
      getOptions: function() {
        return this._scope.settings;
      },
      getLayers: function() {
        return this._children;
      },
      getActiveLayer: function() {
        return this._activeLayer || new je({ project: this, insert: !0 });
      },
      getSymbolDefinitions: function() {
        var i = [], r = {};
        return this.getItems({
          class: pt,
          match: function(a) {
            var l = a._definition, u = l._id;
            return r[u] || (r[u] = !0, i.push(l)), !1;
          }
        }), i;
      },
      getSymbols: "getSymbolDefinitions",
      getSelectedItems: function() {
        var i = this._selectionItems, r = [];
        for (var a in i) {
          var l = i[a], u = l._selection;
          u & 1 && l.isInserted() ? r.push(l) : u || this._updateSelection(l);
        }
        return r;
      },
      _updateSelection: function(i) {
        var r = i._id, a = this._selectionItems;
        i._selection ? a[r] !== i && (this._selectionCount++, a[r] = i) : a[r] === i && (this._selectionCount--, delete a[r]);
      },
      selectAll: function() {
        for (var i = this._children, r = 0, a = i.length; r < a; r++)
          i[r].setFullySelected(!0);
      },
      deselectAll: function() {
        var i = this._selectionItems;
        for (var r in i)
          i[r].setFullySelected(!1);
      },
      addLayer: function(i) {
        return this.insertLayer(t, i);
      },
      insertLayer: function(i, r) {
        if (r instanceof je) {
          r._remove(!1, !0), o.splice(this._children, [r], i, 0), r._setProject(this, !0);
          var a = r._name;
          a && r.setName(a), this._changes && r._changed(5), this._activeLayer || (this._activeLayer = r);
        } else
          r = null;
        return r;
      },
      _insertItem: function(i, r, a) {
        return r = this.insertLayer(i, r) || (this._activeLayer || this._insertItem(
          t,
          new je(X.NO_INSERT),
          !0
        )).insertChild(i, r), a && r.activate && r.activate(), r;
      },
      getItems: function(i) {
        return X._getItems(this, i);
      },
      getItem: function(i) {
        return X._getItems(this, i, null, null, !0)[0] || null;
      },
      importJSON: function(i) {
        this.activate();
        var r = this._activeLayer;
        return o.importJSON(i, r && r.isEmpty() && r);
      },
      removeOn: function(i) {
        var r = this._removeSets;
        if (r) {
          i === "mouseup" && (r.mousedrag = null);
          var a = r[i];
          if (a) {
            for (var l in a) {
              var u = a[l];
              for (var d in r) {
                var v = r[d];
                v && v != a && delete v[u._id];
              }
              u.remove();
            }
            r[i] = null;
          }
        }
      },
      draw: function(i, r, a) {
        this._updateVersion++, i.save(), r.applyToContext(i);
        for (var l = this._children, u = new o({
          offset: new M(0, 0),
          pixelRatio: a,
          viewMatrix: r.isIdentity() ? null : r,
          matrices: [new ee()],
          updateMatrix: !0
        }), d = 0, v = l.length; d < v; d++)
          l[d].draw(i, u);
        if (i.restore(), this._selectionCount > 0) {
          i.save(), i.strokeWidth = 1;
          var p = this._selectionItems, y = this._scope.settings.handleSize, S = this._updateVersion;
          for (var L in p)
            p[L]._drawSelection(i, r, y, p, S);
          i.restore();
        }
      }
    }), X = o.extend(
      h,
      {
        statics: {
          extend: function i(r) {
            return r._serializeFields && (r._serializeFields = o.set(
              {},
              this.prototype._serializeFields,
              r._serializeFields
            )), i.base.apply(this, arguments);
          },
          INSERT: { insert: !0 },
          NO_INSERT: { insert: !1 }
        },
        _class: "Item",
        _name: null,
        _applyMatrix: !0,
        _canApplyMatrix: !0,
        _canScaleStroke: !1,
        _pivot: null,
        _visible: !0,
        _blendMode: "normal",
        _opacity: 1,
        _locked: !1,
        _guide: !1,
        _clipMask: !1,
        _selection: 0,
        _selectBounds: !0,
        _selectChildren: !1,
        _serializeFields: {
          name: null,
          applyMatrix: null,
          matrix: new ee(),
          pivot: null,
          visible: !0,
          blendMode: "normal",
          opacity: 1,
          locked: !1,
          guide: !1,
          clipMask: !1,
          selected: !1,
          data: {}
        },
        _prioritize: ["applyMatrix"]
      },
      new function() {
        var i = [
          "onMouseDown",
          "onMouseUp",
          "onMouseDrag",
          "onClick",
          "onDoubleClick",
          "onMouseMove",
          "onMouseEnter",
          "onMouseLeave"
        ];
        return o.each(
          i,
          function(r) {
            this._events[r] = {
              install: function(a) {
                this.getView()._countItemEvent(a, 1);
              },
              uninstall: function(a) {
                this.getView()._countItemEvent(a, -1);
              }
            };
          },
          {
            _events: {
              onFrame: {
                install: function() {
                  this.getView()._animateItem(this, !0);
                },
                uninstall: function() {
                  this.getView()._animateItem(this, !1);
                }
              },
              onLoad: {},
              onError: {}
            },
            statics: {
              _itemHandlers: i
            }
          }
        );
      }(),
      {
        initialize: function() {
        },
        _initialize: function(i, r) {
          var a = i && o.isPlainObject(i), l = a && i.internal === !0, u = this._matrix = new ee(), d = a && i.project || He.project, v = He.settings;
          return this._id = l ? null : U.get(), this._parent = this._index = null, this._applyMatrix = this._canApplyMatrix && v.applyMatrix, r && u.translate(r), u._owner = this, this._style = new _i(d._currentStyle, this, d), l || a && i.insert == !1 || !v.insertItems && !(a && i.insert == !0) ? this._setProject(d) : (a && i.parent || d)._insertItem(t, this, !0), a && i !== X.NO_INSERT && i !== X.INSERT && this.set(i, {
            internal: !0,
            insert: !0,
            project: !0,
            parent: !0
          }), a;
        },
        _serialize: function(i, r) {
          var a = {}, l = this;
          function u(d) {
            for (var v in d) {
              var p = l[v];
              o.equals(p, v === "leading" ? d.fontSize * 1.2 : d[v]) || (a[v] = o.serialize(
                p,
                i,
                v !== "data",
                r
              ));
            }
          }
          return u(this._serializeFields), this instanceof W || u(this._style._defaults), [this._class, a];
        },
        _changed: function(i) {
          var r = this._symbol, a = this._parent || r, l = this._project;
          i & 8 && (this._bounds = this._position = this._decomposed = t), i & 16 && (this._globalMatrix = t), a && i & 72 && X._clearBoundsCache(a), i & 2 && X._clearBoundsCache(this), l && l._changed(i, this), r && r._changed(i);
        },
        getId: function() {
          return this._id;
        },
        getName: function() {
          return this._name;
        },
        setName: function(i) {
          if (this._name && this._removeNamed(), i === +i + "")
            throw new Error(
              "Names consisting only of numbers are not supported."
            );
          var r = this._getOwner();
          if (i && r) {
            var a = r._children, l = r._namedChildren;
            (l[i] = l[i] || []).push(this), i in a || (a[i] = this);
          }
          this._name = i || t, this._changed(256);
        },
        getStyle: function() {
          return this._style;
        },
        setStyle: function(i) {
          this.getStyle().set(i);
        }
      },
      o.each(
        ["locked", "visible", "blendMode", "opacity", "guide"],
        function(i) {
          var r = o.capitalize(i), a = "_" + i, l = {
            locked: 256,
            visible: 265
          };
          this["get" + r] = function() {
            return this[a];
          }, this["set" + r] = function(u) {
            u != this[a] && (this[a] = u, this._changed(l[i] || 257));
          };
        },
        {}
      ),
      {
        beans: !0,
        getSelection: function() {
          return this._selection;
        },
        setSelection: function(i) {
          if (i !== this._selection) {
            this._selection = i;
            var r = this._project;
            r && (r._updateSelection(this), this._changed(257));
          }
        },
        _changeSelection: function(i, r) {
          var a = this._selection;
          this.setSelection(r ? a | i : a & ~i);
        },
        isSelected: function() {
          if (this._selectChildren) {
            for (var i = this._children, r = 0, a = i.length; r < a; r++)
              if (i[r].isSelected())
                return !0;
          }
          return !!(this._selection & 1);
        },
        setSelected: function(i) {
          if (this._selectChildren)
            for (var r = this._children, a = 0, l = r.length; a < l; a++)
              r[a].setSelected(i);
          this._changeSelection(1, i);
        },
        isFullySelected: function() {
          var i = this._children, r = !!(this._selection & 1);
          if (i && r) {
            for (var a = 0, l = i.length; a < l; a++)
              if (!i[a].isFullySelected())
                return !1;
            return !0;
          }
          return r;
        },
        setFullySelected: function(i) {
          var r = this._children;
          if (r)
            for (var a = 0, l = r.length; a < l; a++)
              r[a].setFullySelected(i);
          this._changeSelection(1, i);
        },
        isClipMask: function() {
          return this._clipMask;
        },
        setClipMask: function(i) {
          this._clipMask != (i = !!i) && (this._clipMask = i, i && (this.setFillColor(null), this.setStrokeColor(null)), this._changed(257), this._parent && this._parent._changed(2048));
        },
        getData: function() {
          return this._data || (this._data = {}), this._data;
        },
        setData: function(i) {
          this._data = i;
        },
        getPosition: function(i) {
          var r = i ? M : Z, a = this._position || (this._position = this._getPositionFromBounds());
          return new r(a.x, a.y, this, "setPosition");
        },
        setPosition: function() {
          this.translate(M.read(arguments).subtract(this.getPosition(!0)));
        },
        _getPositionFromBounds: function(i) {
          return this._pivot ? this._matrix._transformPoint(this._pivot) : (i || this.getBounds()).getCenter(!0);
        },
        getPivot: function() {
          var i = this._pivot;
          return i ? new Z(i.x, i.y, this, "setPivot") : null;
        },
        setPivot: function() {
          this._pivot = M.read(arguments, 0, { clone: !0, readNull: !0 }), this._position = t;
        }
      },
      o.each(
        {
          getStrokeBounds: { stroke: !0 },
          getHandleBounds: { handle: !0 },
          getInternalBounds: { internal: !0 }
        },
        function(i, r) {
          this[r] = function(a) {
            return this.getBounds(a, i);
          };
        },
        {
          beans: !0,
          getBounds: function(i, r) {
            var a = r || i instanceof ee, l = o.set(
              {},
              a ? r : i,
              this._boundsOptions
            );
            (!l.stroke || this.getStrokeScaling()) && (l.cacheItem = this);
            var u = this._getCachedBounds(a && i, l).rect;
            return arguments.length ? u : new te(
              u.x,
              u.y,
              u.width,
              u.height,
              this,
              "setBounds"
            );
          },
          setBounds: function() {
            var i = D.read(arguments), r = this.getBounds(), a = this._matrix, l = new ee(), u = i.getCenter();
            l.translate(u), (i.width != r.width || i.height != r.height) && (a.isInvertible() || (a.set(a._backup || new ee().translate(a.getTranslation())), r = this.getBounds()), l.scale(
              r.width !== 0 ? i.width / r.width : 0,
              r.height !== 0 ? i.height / r.height : 0
            )), u = r.getCenter(), l.translate(-u.x, -u.y), this.transform(l);
          },
          _getBounds: function(i, r) {
            var a = this._children;
            return !a || !a.length ? new D() : (X._updateBoundsCache(this, r.cacheItem), X._getBounds(a, i, r));
          },
          _getBoundsCacheKey: function(i, r) {
            return [
              i.stroke ? 1 : 0,
              i.handle ? 1 : 0,
              r ? 1 : 0
            ].join("");
          },
          _getCachedBounds: function(i, r, a) {
            i = i && i._orNullIfIdentity();
            var l = r.internal && !a, u = r.cacheItem, d = l ? null : this._matrix._orNullIfIdentity(), v = u && (!i || i.equals(d)) && this._getBoundsCacheKey(r, l), p = this._bounds;
            if (X._updateBoundsCache(this._parent || this._symbol, u), v && p && v in p) {
              var y = p[v];
              return {
                rect: y.rect.clone(),
                nonscaling: y.nonscaling
              };
            }
            var S = this._getBounds(i || d, r), L = S.rect || S, E = this._style, A = S.nonscaling || E.hasStroke() && !E.getStrokeScaling();
            if (v) {
              p || (this._bounds = p = {});
              var y = p[v] = {
                rect: L.clone(),
                nonscaling: A,
                internal: l
              };
            }
            return {
              rect: L,
              nonscaling: A
            };
          },
          _getStrokeMatrix: function(i, r) {
            var a = this.getStrokeScaling() ? null : r && r.internal ? this : this._parent || this._symbol && this._symbol._item, l = a ? a.getViewMatrix().invert() : i;
            return l && l._shiftless();
          },
          statics: {
            _updateBoundsCache: function(i, r) {
              if (i && r) {
                var a = r._id, l = i._boundsCache = i._boundsCache || {
                  ids: {},
                  list: []
                };
                l.ids[a] || (l.list.push(r), l.ids[a] = r);
              }
            },
            _clearBoundsCache: function(i) {
              var r = i._boundsCache;
              if (r) {
                i._bounds = i._position = i._boundsCache = t;
                for (var a = 0, l = r.list, u = l.length; a < u; a++) {
                  var d = l[a];
                  d !== i && (d._bounds = d._position = t, d._boundsCache && X._clearBoundsCache(d));
                }
              }
            },
            _getBounds: function(i, r, a) {
              var l = 1 / 0, u = -l, d = l, v = u, p = !1;
              a = a || {};
              for (var y = 0, S = i.length; y < S; y++) {
                var L = i[y];
                if (L._visible && !L.isEmpty(!0)) {
                  var E = L._getCachedBounds(
                    r && r.appended(L._matrix),
                    a,
                    !0
                  ), A = E.rect;
                  l = Math.min(A.x, l), d = Math.min(A.y, d), u = Math.max(A.x + A.width, u), v = Math.max(A.y + A.height, v), E.nonscaling && (p = !0);
                }
              }
              return {
                rect: isFinite(l) ? new D(l, d, u - l, v - d) : new D(),
                nonscaling: p
              };
            }
          }
        }
      ),
      {
        beans: !0,
        _decompose: function() {
          return this._applyMatrix ? null : this._decomposed || (this._decomposed = this._matrix.decompose());
        },
        getRotation: function() {
          var i = this._decompose();
          return i ? i.rotation : 0;
        },
        setRotation: function(i) {
          var r = this.getRotation();
          if (r != null && i != null) {
            var a = this._decomposed;
            this.rotate(i - r), a && (a.rotation = i, this._decomposed = a);
          }
        },
        getScaling: function() {
          var i = this._decompose(), r = i && i.scaling;
          return new Z(r ? r.x : 1, r ? r.y : 1, this, "setScaling");
        },
        setScaling: function() {
          var i = this.getScaling(), r = M.read(arguments, 0, { clone: !0, readNull: !0 });
          if (i && r && !i.equals(r)) {
            var a = this.getRotation(), l = this._decomposed, u = new ee(), d = P.isZero;
            if (d(i.x) || d(i.y))
              u.translate(l.translation), a && u.rotate(a), u.scale(r.x, r.y), this._matrix.set(u);
            else {
              var v = this.getPosition(!0);
              u.translate(v), a && u.rotate(a), u.scale(r.x / i.x, r.y / i.y), a && u.rotate(-a), u.translate(v.negate()), this.transform(u);
            }
            l && (l.scaling = r, this._decomposed = l);
          }
        },
        getMatrix: function() {
          return this._matrix;
        },
        setMatrix: function() {
          var i = this._matrix;
          i.set.apply(i, arguments);
        },
        getGlobalMatrix: function(i) {
          var r = this._globalMatrix;
          if (r)
            for (var a = this._parent, l = []; a; ) {
              if (!a._globalMatrix) {
                r = null;
                for (var u = 0, d = l.length; u < d; u++)
                  l[u]._globalMatrix = null;
                break;
              }
              l.push(a), a = a._parent;
            }
          if (!r) {
            r = this._globalMatrix = this._matrix.clone();
            var a = this._parent;
            a && r.prepend(a.getGlobalMatrix(!0));
          }
          return i ? r : r.clone();
        },
        getViewMatrix: function() {
          return this.getGlobalMatrix().prepend(this.getView()._matrix);
        },
        getApplyMatrix: function() {
          return this._applyMatrix;
        },
        setApplyMatrix: function(i) {
          (this._applyMatrix = this._canApplyMatrix && !!i) && this.transform(null, !0);
        },
        getTransformContent: "#getApplyMatrix",
        setTransformContent: "#setApplyMatrix"
      },
      {
        getProject: function() {
          return this._project;
        },
        _setProject: function(i, r) {
          if (this._project !== i) {
            this._project && this._installEvents(!1), this._project = i;
            for (var a = this._children, l = 0, u = a && a.length; l < u; l++)
              a[l]._setProject(i);
            r = !0;
          }
          r && this._installEvents(!0);
        },
        getView: function() {
          return this._project._view;
        },
        _installEvents: function i(r) {
          i.base.call(this, r);
          for (var a = this._children, l = 0, u = a && a.length; l < u; l++)
            a[l]._installEvents(r);
        },
        getLayer: function() {
          for (var i = this; i = i._parent; )
            if (i instanceof je)
              return i;
          return null;
        },
        getParent: function() {
          return this._parent;
        },
        setParent: function(i) {
          return i.addChild(this);
        },
        _getOwner: "#getParent",
        getChildren: function() {
          return this._children;
        },
        setChildren: function(i) {
          this.removeChildren(), this.addChildren(i);
        },
        getFirstChild: function() {
          return this._children && this._children[0] || null;
        },
        getLastChild: function() {
          return this._children && this._children[this._children.length - 1] || null;
        },
        getNextSibling: function() {
          var i = this._getOwner();
          return i && i._children[this._index + 1] || null;
        },
        getPreviousSibling: function() {
          var i = this._getOwner();
          return i && i._children[this._index - 1] || null;
        },
        getIndex: function() {
          return this._index;
        },
        setIndex: function(i) {
          var r = this._parent, a = r && r._children;
          a && r.insertChildren(
            i in a ? i : t,
            [this]
          );
        },
        equals: function(i) {
          return i === this || i && this._class === i._class && this._style.equals(i._style) && this._matrix.equals(i._matrix) && this._locked === i._locked && this._visible === i._visible && this._blendMode === i._blendMode && this._opacity === i._opacity && this._clipMask === i._clipMask && this._guide === i._guide && this._equals(i) || !1;
        },
        _equals: function(i) {
          return o.equals(this._children, i._children);
        },
        clone: function(i) {
          var r = new this.constructor(X.NO_INSERT), a = this._children, l = o.pick(
            i ? i.insert : t,
            i === t || i === !0
          ), u = o.pick(i ? i.deep : t, !0);
          a && r.copyAttributes(this), (!a || u) && r.copyContent(this), a || r.copyAttributes(this), l && r.insertAbove(this);
          var d = this._name, v = this._parent;
          if (d && v) {
            for (var a = v._children, p = d, y = 1; a[d]; )
              d = p + " " + y++;
            d !== p && r.setName(d);
          }
          return r;
        },
        copyContent: function(i) {
          for (var r = i._children, a = 0, l = r && r.length; a < l; a++)
            this.addChild(r[a].clone(!1), !0);
        },
        copyAttributes: function(i, r) {
          this.setStyle(i._style);
          for (var a = [
            "_locked",
            "_visible",
            "_blendMode",
            "_opacity",
            "_clipMask",
            "_guide"
          ], l = 0, u = a.length; l < u; l++) {
            var d = a[l];
            i.hasOwnProperty(d) && (this[d] = i[d]);
          }
          r || this._matrix.set(i._matrix, !0), this.setApplyMatrix(i._applyMatrix), this.setPivot(i._pivot), this.setSelection(i._selection);
          var v = i._data, p = i._name;
          this._data = v ? o.clone(v) : null, p && this.setName(p);
        },
        rasterize: function(i, r) {
          var a, l, u;
          o.isPlainObject(i) ? (a = i.resolution, l = i.insert, u = i.raster) : (a = i, l = r), u || (u = new Ye(X.NO_INSERT));
          var d = this.getStrokeBounds(), v = (a || this.getView().getResolution()) / 72, p = d.getTopLeft().floor(), y = d.getBottomRight().ceil(), S = new F(y.subtract(p)), L = S.multiply(v);
          if (u.setSize(L, !0), !L.isZero()) {
            var E = u.getContext(!0), A = new ee().scale(v).translate(p.negate());
            E.save(), A.applyToContext(E), this.draw(E, new o({ matrices: [A] })), E.restore();
          }
          return u._matrix.set(
            new ee().translate(p.add(S.divide(2))).scale(1 / v)
          ), (l === t || l) && u.insertAbove(this), u;
        },
        contains: function() {
          var i = this._matrix;
          return i.isInvertible() && !!this._contains(i._inverseTransform(M.read(arguments)));
        },
        _contains: function(i) {
          var r = this._children;
          if (r) {
            for (var a = r.length - 1; a >= 0; a--)
              if (r[a].contains(i))
                return !0;
            return !1;
          }
          return i.isInside(this.getInternalBounds());
        },
        isInside: function() {
          return D.read(arguments).contains(this.getBounds());
        },
        _asPathItem: function() {
          return new We.Rectangle({
            rectangle: this.getInternalBounds(),
            matrix: this._matrix,
            insert: !1
          });
        },
        intersects: function(i, r) {
          return i instanceof X ? this._asPathItem().getIntersections(
            i._asPathItem(),
            null,
            r,
            !0
          ).length > 0 : !1;
        }
      },
      new function() {
        function i() {
          var l = arguments;
          return this._hitTest(
            M.read(l),
            $e.getOptions(l)
          );
        }
        function r() {
          var l = arguments, u = M.read(l), d = $e.getOptions(l), v = [];
          return this._hitTest(u, new o({ all: v }, d)), v;
        }
        function a(l, u, d, v) {
          var p = this._children;
          if (p)
            for (var y = p.length - 1; y >= 0; y--) {
              var S = p[y], L = S !== v && S._hitTest(
                l,
                u,
                d
              );
              if (L && !u.all)
                return L;
            }
          return null;
        }
        return fe.inject({
          hitTest: i,
          hitTestAll: r,
          _hitTest: a
        }), {
          hitTest: i,
          hitTestAll: r,
          _hitTestChildren: a
        };
      }(),
      {
        _hitTest: function(i, r, a) {
          if (this._locked || !this._visible || this._guide && !r.guides || this.isEmpty())
            return null;
          var l = this._matrix, u = a ? a.appended(l) : this.getGlobalMatrix().prepend(this.getView()._matrix), d = Math.max(r.tolerance, 1e-12), v = r._tolerancePadding = new F(
            We._getStrokePadding(
              d,
              l._shiftless().invert()
            )
          );
          if (i = l._inverseTransform(i), !i || !this._children && !this.getBounds({ internal: !0, stroke: !0, handle: !0 }).expand(v.multiply(2))._containsPoint(i))
            return null;
          var p = !(r.guides && !this._guide || r.selected && !this.isSelected() || r.type && r.type !== o.hyphenate(this._class) || r.class && !(this instanceof r.class)), y = r.match, S = this, L, E;
          function A(C) {
            return C && y && !y(C) && (C = null), C && r.all && r.all.push(C), C;
          }
          function T(C, I) {
            var j = I ? L["get" + I]() : S.getPosition();
            if (i.subtract(j).divide(v).length <= 1)
              return new $e(C, S, {
                name: I ? o.hyphenate(I) : C,
                point: j
              });
          }
          var G = r.position, R = r.center, Y = r.bounds;
          if (p && this._parent && (G || R || Y)) {
            if ((R || Y) && (L = this.getInternalBounds()), E = G && T("position") || R && T("center", "Center"), !E && Y)
              for (var k = [
                "TopLeft",
                "TopRight",
                "BottomLeft",
                "BottomRight",
                "LeftCenter",
                "TopCenter",
                "RightCenter",
                "BottomCenter"
              ], z = 0; z < 8 && !E; z++)
                E = T("bounds", k[z]);
            E = A(E);
          }
          return E || (E = this._hitTestChildren(i, r, u) || p && A(this._hitTestSelf(
            i,
            r,
            u,
            this.getStrokeScaling() ? null : u._shiftless().invert()
          )) || null), E && E.point && (E.point = l.transform(E.point)), E;
        },
        _hitTestSelf: function(i, r) {
          if (r.fill && this.hasFill() && this._contains(i))
            return new $e("fill", this);
        },
        matches: function(i, r) {
          function a(v, p) {
            for (var y in v)
              if (v.hasOwnProperty(y)) {
                var S = v[y], L = p[y];
                if (o.isPlainObject(S) && o.isPlainObject(L)) {
                  if (!a(S, L))
                    return !1;
                } else if (!o.equals(S, L))
                  return !1;
              }
            return !0;
          }
          var l = typeof i;
          if (l === "object") {
            for (var u in i)
              if (i.hasOwnProperty(u) && !this.matches(u, i[u]))
                return !1;
            return !0;
          } else {
            if (l === "function")
              return i(this);
            if (i === "match")
              return r(this);
            var d = /^(empty|editable)$/.test(i) ? this["is" + o.capitalize(i)]() : i === "type" ? o.hyphenate(this._class) : this[i];
            if (i === "class") {
              if (typeof r == "function")
                return this instanceof r;
              d = this._class;
            }
            if (typeof r == "function")
              return !!r(d);
            if (r) {
              if (r.test)
                return r.test(d);
              if (o.isPlainObject(r))
                return a(r, d);
            }
            return o.equals(d, r);
          }
        },
        getItems: function(i) {
          return X._getItems(this, i, this._matrix);
        },
        getItem: function(i) {
          return X._getItems(this, i, this._matrix, null, !0)[0] || null;
        },
        statics: {
          _getItems: function i(r, a, l, u, d) {
            if (!u) {
              var v = typeof a == "object" && a, p = v && v.overlapping, y = v && v.inside, S = p || y, A = S && D.read([S]);
              u = {
                items: [],
                recursive: v && v.recursive !== !1,
                inside: !!y,
                overlapping: !!p,
                rect: A,
                path: p && new We.Rectangle({
                  rectangle: A,
                  insert: !1
                })
              }, v && (a = o.filter({}, a, {
                recursive: !0,
                inside: !0,
                overlapping: !0
              }));
            }
            var L = r._children, E = u.items, A = u.rect;
            l = A && (l || new ee());
            for (var T = 0, G = L && L.length; T < G; T++) {
              var R = L[T], Y = l && l.appended(R._matrix), k = !0;
              if (A) {
                var S = R.getBounds(Y);
                if (!A.intersects(S))
                  continue;
                A.contains(S) || u.overlapping && (S.contains(A) || u.path.intersects(R, Y)) || (k = !1);
              }
              if (k && R.matches(a) && (E.push(R), d) || (u.recursive !== !1 && i(R, a, Y, u, d), d && E.length > 0))
                break;
            }
            return E;
          }
        }
      },
      {
        importJSON: function(i) {
          var r = o.importJSON(i, this);
          return r !== this ? this.addChild(r) : r;
        },
        addChild: function(i) {
          return this.insertChild(t, i);
        },
        insertChild: function(i, r) {
          var a = r ? this.insertChildren(i, [r]) : null;
          return a && a[0];
        },
        addChildren: function(i) {
          return this.insertChildren(this._children.length, i);
        },
        insertChildren: function(i, r) {
          var a = this._children;
          if (a && r && r.length > 0) {
            r = o.slice(r);
            for (var l = {}, u = r.length - 1; u >= 0; u--) {
              var d = r[u], v = d && d._id;
              !d || l[v] ? r.splice(u, 1) : (d._remove(!1, !0), l[v] = !0);
            }
            o.splice(a, r, i, 0);
            for (var p = this._project, y = p._changes, u = 0, S = r.length; u < S; u++) {
              var d = r[u], L = d._name;
              d._parent = this, d._setProject(p, !0), L && d.setName(L), y && d._changed(5);
            }
            this._changed(11);
          } else
            r = null;
          return r;
        },
        _insertItem: "#insertChild",
        _insertAt: function(i, r) {
          var a = i && i._getOwner(), l = i !== this && a ? this : null;
          return l && (l._remove(!1, !0), a._insertItem(i._index + r, l)), l;
        },
        insertAbove: function(i) {
          return this._insertAt(i, 1);
        },
        insertBelow: function(i) {
          return this._insertAt(i, 0);
        },
        sendToBack: function() {
          var i = this._getOwner();
          return i ? i._insertItem(0, this) : null;
        },
        bringToFront: function() {
          var i = this._getOwner();
          return i ? i._insertItem(t, this) : null;
        },
        appendTop: "#addChild",
        appendBottom: function(i) {
          return this.insertChild(0, i);
        },
        moveAbove: "#insertAbove",
        moveBelow: "#insertBelow",
        addTo: function(i) {
          return i._insertItem(t, this);
        },
        copyTo: function(i) {
          return this.clone(!1).addTo(i);
        },
        reduce: function(i) {
          var r = this._children;
          if (r && r.length === 1) {
            var a = r[0].reduce(i);
            return this._parent ? (a.insertAbove(this), this.remove()) : a.remove(), a;
          }
          return this;
        },
        _removeNamed: function() {
          var i = this._getOwner();
          if (i) {
            var r = i._children, a = i._namedChildren, l = this._name, u = a[l], d = u ? u.indexOf(this) : -1;
            d !== -1 && (r[l] == this && delete r[l], u.splice(d, 1), u.length ? r[l] = u[0] : delete a[l]);
          }
        },
        _remove: function(i, r) {
          var a = this._getOwner(), l = this._project, u = this._index;
          return this._style && this._style._dispose(), a ? (this._name && this._removeNamed(), u != null && (l._activeLayer === this && (l._activeLayer = this.getNextSibling() || this.getPreviousSibling()), o.splice(a._children, null, u, 1)), this._installEvents(!1), i && l._changes && this._changed(5), r && a._changed(11, this), this._parent = null, !0) : !1;
        },
        remove: function() {
          return this._remove(!0, !0);
        },
        replaceWith: function(i) {
          var r = i && i.insertBelow(this);
          return r && this.remove(), r;
        },
        removeChildren: function(i, r) {
          if (!this._children)
            return null;
          i = i || 0, r = o.pick(r, this._children.length);
          for (var a = o.splice(this._children, null, i, r - i), l = a.length - 1; l >= 0; l--)
            a[l]._remove(!0, !1);
          return a.length > 0 && this._changed(11), a;
        },
        clear: "#removeChildren",
        reverseChildren: function() {
          if (this._children) {
            this._children.reverse();
            for (var i = 0, r = this._children.length; i < r; i++)
              this._children[i]._index = i;
            this._changed(11);
          }
        },
        isEmpty: function(i) {
          var r = this._children, a = r ? r.length : 0;
          if (i) {
            for (var l = 0; l < a; l++)
              if (!r[l].isEmpty(i))
                return !1;
            return !0;
          }
          return !a;
        },
        isEditable: function() {
          for (var i = this; i; ) {
            if (!i._visible || i._locked)
              return !1;
            i = i._parent;
          }
          return !0;
        },
        hasFill: function() {
          return this.getStyle().hasFill();
        },
        hasStroke: function() {
          return this.getStyle().hasStroke();
        },
        hasShadow: function() {
          return this.getStyle().hasShadow();
        },
        _getOrder: function(i) {
          function r(v) {
            var p = [];
            do
              p.unshift(v);
            while (v = v._parent);
            return p;
          }
          for (var a = r(this), l = r(i), u = 0, d = Math.min(a.length, l.length); u < d; u++)
            if (a[u] != l[u])
              return a[u]._index < l[u]._index ? 1 : -1;
          return 0;
        },
        hasChildren: function() {
          return this._children && this._children.length > 0;
        },
        isInserted: function() {
          return this._parent ? this._parent.isInserted() : !1;
        },
        isAbove: function(i) {
          return this._getOrder(i) === -1;
        },
        isBelow: function(i) {
          return this._getOrder(i) === 1;
        },
        isParent: function(i) {
          return this._parent === i;
        },
        isChild: function(i) {
          return i && i._parent === this;
        },
        isDescendant: function(i) {
          for (var r = this; r = r._parent; )
            if (r === i)
              return !0;
          return !1;
        },
        isAncestor: function(i) {
          return i ? i.isDescendant(this) : !1;
        },
        isSibling: function(i) {
          return this._parent === i._parent;
        },
        isGroupedWith: function(i) {
          for (var r = this._parent; r; ) {
            if (r._parent && /^(Group|Layer|CompoundPath)$/.test(r._class) && i.isDescendant(r))
              return !0;
            r = r._parent;
          }
          return !1;
        }
      },
      o.each(["rotate", "scale", "shear", "skew"], function(i) {
        var r = i === "rotate";
        this[i] = function() {
          var a = arguments, l = (r ? o : M).read(a), u = M.read(a, 0, { readNull: !0 });
          return this.transform(new ee()[i](
            l,
            u || this.getPosition(!0)
          ));
        };
      }, {
        translate: function() {
          var i = new ee();
          return this.transform(i.translate.apply(i, arguments));
        },
        transform: function(i, r, a) {
          var l = this._matrix, u = i && !i.isIdentity(), d = a && this._canApplyMatrix || this._applyMatrix && (u || !l.isIdentity() || r && this._children);
          if (!u && !d)
            return this;
          if (u) {
            !i.isInvertible() && l.isInvertible() && (l._backup = l.getValues()), l.prepend(i, !0);
            var v = this._style, p = v.getFillColor(!0), y = v.getStrokeColor(!0);
            p && p.transform(i), y && y.transform(i);
          }
          if (d && (d = this._transformContent(
            l,
            r,
            a
          ))) {
            var S = this._pivot;
            S && l._transformPoint(S, S, !0), l.reset(!0), a && this._canApplyMatrix && (this._applyMatrix = !0);
          }
          var L = this._bounds, E = this._position;
          (u || d) && this._changed(25);
          var A = u && L && i.decompose();
          if (A && A.skewing.isZero() && A.rotation % 90 === 0) {
            for (var T in L) {
              var G = L[T];
              if (G.nonscaling)
                delete L[T];
              else if (d || !G.internal) {
                var R = G.rect;
                i._transformBounds(R, R);
              }
            }
            this._bounds = L;
            var Y = L[this._getBoundsCacheKey(
              this._boundsOptions || {}
            )];
            Y && (this._position = this._getPositionFromBounds(Y.rect));
          } else
            u && E && this._pivot && (this._position = i._transformPoint(E, E));
          return this;
        },
        _transformContent: function(i, r, a) {
          var l = this._children;
          if (l) {
            for (var u = 0, d = l.length; u < d; u++)
              l[u].transform(i, r, a);
            return !0;
          }
        },
        globalToLocal: function() {
          return this.getGlobalMatrix(!0)._inverseTransform(
            M.read(arguments)
          );
        },
        localToGlobal: function() {
          return this.getGlobalMatrix(!0)._transformPoint(
            M.read(arguments)
          );
        },
        parentToLocal: function() {
          return this._matrix._inverseTransform(M.read(arguments));
        },
        localToParent: function() {
          return this._matrix._transformPoint(M.read(arguments));
        },
        fitBounds: function(i, r) {
          i = D.read(arguments);
          var a = this.getBounds(), l = a.height / a.width, u = i.height / i.width, d = (r ? l > u : l < u) ? i.width / a.width : i.height / a.height, v = new D(
            new M(),
            new F(a.width * d, a.height * d)
          );
          v.setCenter(i.getCenter()), this.setBounds(v);
        }
      }),
      {
        _setStyles: function(i, r, a) {
          var l = this._style, u = this._matrix;
          if (l.hasFill() && (i.fillStyle = l.getFillColor().toCanvasStyle(i, u)), l.hasStroke()) {
            i.strokeStyle = l.getStrokeColor().toCanvasStyle(i, u), i.lineWidth = l.getStrokeWidth();
            var d = l.getStrokeJoin(), v = l.getStrokeCap(), p = l.getMiterLimit();
            if (d && (i.lineJoin = d), v && (i.lineCap = v), p && (i.miterLimit = p), He.support.nativeDash) {
              var y = l.getDashArray(), S = l.getDashOffset();
              y && y.length && ("setLineDash" in i ? (i.setLineDash(y), i.lineDashOffset = S) : (i.mozDash = y, i.mozDashOffset = S));
            }
          }
          if (l.hasShadow()) {
            var L = r.pixelRatio || 1, E = a._shiftless().prepend(
              new ee().scale(L, L)
            ), A = E.transform(new M(l.getShadowBlur(), 0)), T = E.transform(this.getShadowOffset());
            i.shadowColor = l.getShadowColor().toCanvasStyle(i), i.shadowBlur = A.getLength(), i.shadowOffsetX = T.x, i.shadowOffsetY = T.y;
          }
        },
        draw: function(i, r, a) {
          if (this._updateVersion = this._project._updateVersion, !(!this._visible || this._opacity === 0)) {
            var l = r.matrices, u = r.viewMatrix, d = this._matrix, v = l[l.length - 1].appended(d);
            if (v.isInvertible()) {
              u = u ? u.appended(v) : v, l.push(v), r.updateMatrix && (this._globalMatrix = v);
              var p = this._blendMode, y = P.clamp(this._opacity, 0, 1), S = p === "normal", L = Qe.nativeModes[p], E = S && y === 1 || r.dontStart || r.clip || (L || S && y < 1) && this._canComposite(), A = r.pixelRatio || 1, T, G, R;
              if (!E) {
                var Y = this.getStrokeBounds(u);
                if (!Y.width || !Y.height) {
                  l.pop();
                  return;
                }
                R = r.offset, G = r.offset = Y.getTopLeft().floor(), T = i, i = mt.getContext(Y.getSize().ceil().add(1).multiply(A)), A !== 1 && i.scale(A, A);
              }
              i.save();
              var k = a ? a.appended(d) : this._canScaleStroke && !this.getStrokeScaling(!0) && u, z = !E && r.clipItem, C = !k || z;
              if (E ? (i.globalAlpha = y, L && (i.globalCompositeOperation = p)) : C && i.translate(-G.x, -G.y), C && (E ? d : u).applyToContext(i), z && r.clipItem.draw(i, r.extend({ clip: !0 })), k) {
                i.setTransform(A, 0, 0, A, 0, 0);
                var I = r.offset;
                I && i.translate(-I.x, -I.y);
              }
              this._draw(i, r, u, k), i.restore(), l.pop(), r.clip && !r.dontFinish && i.clip(this.getFillRule()), E || (Qe.process(
                p,
                i,
                T,
                y,
                G.subtract(R).multiply(A)
              ), mt.release(i), r.offset = R);
            }
          }
        },
        _isUpdated: function(i) {
          var r = this._parent;
          if (r instanceof It)
            return r._isUpdated(i);
          var a = this._updateVersion === i;
          return !a && r && r._visible && r._isUpdated(i) && (this._updateVersion = i, a = !0), a;
        },
        _drawSelection: function(i, r, a, l, u) {
          var d = this._selection, v = d & 1, p = d & 2 || v && this._selectBounds, y = d & 4;
          if (this._drawSelected || (v = !1), (v || p || y) && this._isUpdated(u)) {
            var S, L = this.getSelectedColor(!0) || (S = this.getLayer()) && S.getSelectedColor(!0), E = r.appended(this.getGlobalMatrix(!0)), A = a / 2;
            if (i.strokeStyle = i.fillStyle = L ? L.toCanvasStyle(i) : "#009dec", v && this._drawSelected(i, E, l), y) {
              var T = this.getPosition(!0), G = this._parent, R = G ? G.localToGlobal(T) : T, Y = R.x, k = R.y;
              i.beginPath(), i.arc(Y, k, A, 0, Math.PI * 2, !0), i.stroke();
              for (var z = [[0, -1], [1, 0], [0, 1], [-1, 0]], C = A, I = a + 1, j = 0; j < 4; j++) {
                var q = z[j], H = q[0], ie = q[1];
                i.moveTo(Y + H * C, k + ie * C), i.lineTo(Y + H * I, k + ie * I), i.stroke();
              }
            }
            if (p) {
              var ae = E._transformCorners(this.getInternalBounds());
              i.beginPath();
              for (var j = 0; j < 8; j++)
                i[j ? "lineTo" : "moveTo"](ae[j], ae[++j]);
              i.closePath(), i.stroke();
              for (var j = 0; j < 8; j++)
                i.fillRect(
                  ae[j] - A,
                  ae[++j] - A,
                  a,
                  a
                );
            }
          }
        },
        _canComposite: function() {
          return !1;
        }
      },
      o.each(["down", "drag", "up", "move"], function(i) {
        this["removeOn" + o.capitalize(i)] = function() {
          var r = {};
          return r[i] = !0, this.removeOn(r);
        };
      }, {
        removeOn: function(i) {
          for (var r in i)
            if (i[r]) {
              var a = "mouse" + r, l = this._project, u = l._removeSets = l._removeSets || {};
              u[a] = u[a] || {}, u[a][this._id] = this;
            }
          return this;
        }
      }),
      {
        tween: function(i, r, a) {
          a || (a = r, r = i, i = null, a || (a = r, r = null));
          var l = a && a.easing, u = a && a.start, d = a != null && (typeof a == "number" ? a : a.duration), v = new et(this, i, r, d, l, u);
          function p(y) {
            v._handleFrame(y.time * 1e3), v.running || this.off("frame", p);
          }
          return d && this.on("frame", p), v;
        },
        tweenTo: function(i, r) {
          return this.tween(null, i, r);
        },
        tweenFrom: function(i, r) {
          return this.tween(i, null, r);
        }
      }
    ), W = X.extend({
      _class: "Group",
      _selectBounds: !1,
      _selectChildren: !0,
      _serializeFields: {
        children: []
      },
      initialize: function(r) {
        this._children = [], this._namedChildren = {}, this._initialize(r) || this.addChildren(Array.isArray(r) ? r : arguments);
      },
      _changed: function i(r) {
        i.base.call(this, r), r & 2050 && (this._clipItem = t);
      },
      _getClipItem: function() {
        var i = this._clipItem;
        if (i === t) {
          i = null;
          for (var r = this._children, a = 0, l = r.length; a < l; a++)
            if (r[a]._clipMask) {
              i = r[a];
              break;
            }
          this._clipItem = i;
        }
        return i;
      },
      isClipped: function() {
        return !!this._getClipItem();
      },
      setClipped: function(i) {
        var r = this.getFirstChild();
        r && r.setClipMask(i);
      },
      _getBounds: function i(r, a) {
        var l = this._getClipItem();
        return l ? l._getCachedBounds(
          l._matrix.prepended(r),
          o.set({}, a, { stroke: !1 })
        ) : i.base.call(this, r, a);
      },
      _hitTestChildren: function i(r, a, l) {
        var u = this._getClipItem();
        return (!u || u.contains(r)) && i.base.call(
          this,
          r,
          a,
          l,
          u
        );
      },
      _draw: function(i, r) {
        var a = r.clip, l = !a && this._getClipItem();
        r = r.extend({ clipItem: l, clip: !1 }), a ? (i.beginPath(), r.dontStart = r.dontFinish = !0) : l && l.draw(i, r.extend({ clip: !0 }));
        for (var u = this._children, d = 0, v = u.length; d < v; d++) {
          var p = u[d];
          p !== l && p.draw(i, r);
        }
      }
    }), je = W.extend({
      _class: "Layer",
      initialize: function() {
        W.apply(this, arguments);
      },
      _getOwner: function() {
        return this._parent || this._index != null && this._project;
      },
      isInserted: function i() {
        return this._parent ? i.base.call(this) : this._index != null;
      },
      activate: function() {
        this._project._activeLayer = this;
      },
      _hitTestSelf: function() {
      }
    }), ke = X.extend(
      {
        _class: "Shape",
        _applyMatrix: !1,
        _canApplyMatrix: !1,
        _canScaleStroke: !0,
        _serializeFields: {
          type: null,
          size: null,
          radius: null
        },
        initialize: function(r, a) {
          this._initialize(r, a);
        },
        _equals: function(i) {
          return this._type === i._type && this._size.equals(i._size) && o.equals(this._radius, i._radius);
        },
        copyContent: function(i) {
          this.setType(i._type), this.setSize(i._size), this.setRadius(i._radius);
        },
        getType: function() {
          return this._type;
        },
        setType: function(i) {
          this._type = i;
        },
        getShape: "#getType",
        setShape: "#setType",
        getSize: function() {
          var i = this._size;
          return new Q(i.width, i.height, this, "setSize");
        },
        setSize: function() {
          var i = F.read(arguments);
          if (!this._size)
            this._size = i.clone();
          else if (!this._size.equals(i)) {
            var r = this._type, a = i.width, l = i.height;
            r === "rectangle" ? this._radius.set(F.min(this._radius, i.divide(2).abs())) : r === "circle" ? (a = l = (a + l) / 2, this._radius = a / 2) : r === "ellipse" && this._radius._set(a / 2, l / 2), this._size._set(a, l), this._changed(9);
          }
        },
        getRadius: function() {
          var i = this._radius;
          return this._type === "circle" ? i : new Q(i.width, i.height, this, "setRadius");
        },
        setRadius: function(i) {
          var r = this._type;
          if (r === "circle") {
            if (i === this._radius)
              return;
            var a = i * 2;
            this._radius = i, this._size._set(a, a);
          } else if (i = F.read(arguments), !this._radius)
            this._radius = i.clone();
          else {
            if (this._radius.equals(i))
              return;
            if (this._radius.set(i), r === "rectangle") {
              var a = F.max(this._size, i.multiply(2));
              this._size.set(a);
            } else
              r === "ellipse" && this._size._set(i.width * 2, i.height * 2);
          }
          this._changed(9);
        },
        isEmpty: function() {
          return !1;
        },
        toPath: function(i) {
          var r = new We[o.capitalize(this._type)]({
            center: new M(),
            size: this._size,
            radius: this._radius,
            insert: !1
          });
          return r.copyAttributes(this), He.settings.applyMatrix && r.setApplyMatrix(!0), (i === t || i) && r.insertAbove(this), r;
        },
        toShape: "#clone",
        _asPathItem: function() {
          return this.toPath(!1);
        },
        _draw: function(i, r, a, l) {
          var u = this._style, d = u.hasFill(), v = u.hasStroke(), p = r.dontFinish || r.clip, y = !l;
          if (d || v || p) {
            var S = this._type, L = this._radius, E = S === "circle";
            if (r.dontStart || i.beginPath(), y && E)
              i.arc(0, 0, L, 0, Math.PI * 2, !0);
            else {
              var A = E ? L : L.width, T = E ? L : L.height, G = this._size, R = G.width, Y = G.height;
              if (y && S === "rectangle" && A === 0 && T === 0)
                i.rect(-R / 2, -Y / 2, R, Y);
              else {
                var k = R / 2, z = Y / 2, C = 1 - 0.5522847498307936, I = A * C, j = T * C, q = [
                  -k,
                  -z + T,
                  -k,
                  -z + j,
                  -k + I,
                  -z,
                  -k + A,
                  -z,
                  k - A,
                  -z,
                  k - I,
                  -z,
                  k,
                  -z + j,
                  k,
                  -z + T,
                  k,
                  z - T,
                  k,
                  z - j,
                  k - I,
                  z,
                  k - A,
                  z,
                  -k + A,
                  z,
                  -k + I,
                  z,
                  -k,
                  z - j,
                  -k,
                  z - T
                ];
                l && l.transform(q, q, 32), i.moveTo(q[0], q[1]), i.bezierCurveTo(q[2], q[3], q[4], q[5], q[6], q[7]), k !== A && i.lineTo(q[8], q[9]), i.bezierCurveTo(q[10], q[11], q[12], q[13], q[14], q[15]), z !== T && i.lineTo(q[16], q[17]), i.bezierCurveTo(q[18], q[19], q[20], q[21], q[22], q[23]), k !== A && i.lineTo(q[24], q[25]), i.bezierCurveTo(q[26], q[27], q[28], q[29], q[30], q[31]);
              }
            }
            i.closePath();
          }
          !p && (d || v) && (this._setStyles(i, r, a), d && (i.fill(u.getFillRule()), i.shadowColor = "rgba(0,0,0,0)"), v && i.stroke());
        },
        _canComposite: function() {
          return !(this.hasFill() && this.hasStroke());
        },
        _getBounds: function(i, r) {
          var a = new D(this._size).setCenter(0, 0), l = this._style, u = r.stroke && l.hasStroke() && l.getStrokeWidth();
          return i && (a = i._transformBounds(a)), u ? a.expand(We._getStrokePadding(
            u,
            this._getStrokeMatrix(i, r)
          )) : a;
        }
      },
      new function() {
        function i(a, l, u) {
          var d = a._radius;
          if (!d.isZero())
            for (var v = a._size.divide(2), p = 1; p <= 4; p++) {
              var y = new M(p > 1 && p < 4 ? -1 : 1, p > 2 ? -1 : 1), S = y.multiply(v), L = S.subtract(y.multiply(d)), E = new D(
                u ? S.add(y.multiply(u)) : S,
                L
              );
              if (E.contains(l))
                return { point: L, quadrant: p };
            }
        }
        function r(a, l, u, d) {
          var v = a.divide(l);
          return (!d || v.isInQuadrant(d)) && v.subtract(v.normalize()).multiply(l).divide(u).length <= 1;
        }
        return {
          _contains: function a(l) {
            if (this._type === "rectangle") {
              var u = i(this, l);
              return u ? l.subtract(u.point).divide(this._radius).getLength() <= 1 : a.base.call(this, l);
            } else
              return l.divide(this.size).getLength() <= 0.5;
          },
          _hitTestSelf: function a(l, u, d, v) {
            var p = !1, y = this._style, S = u.stroke && y.hasStroke(), L = u.fill && y.hasFill();
            if (S || L) {
              var E = this._type, A = this._radius, T = S ? y.getStrokeWidth() / 2 : 0, G = u._tolerancePadding.add(
                We._getStrokePadding(
                  T,
                  !y.getStrokeScaling() && v
                )
              );
              if (E === "rectangle") {
                var R = G.multiply(2), Y = i(this, l, R);
                if (Y)
                  p = r(
                    l.subtract(Y.point),
                    A,
                    G,
                    Y.quadrant
                  );
                else {
                  var k = new D(this._size).setCenter(0, 0), z = k.expand(R), C = k.expand(R.negate());
                  p = z._containsPoint(l) && !C._containsPoint(l);
                }
              } else
                p = r(l, A, G);
            }
            return p ? new $e(S ? "stroke" : "fill", this) : a.base.apply(this, arguments);
          }
        };
      }(),
      {
        statics: new function() {
          function i(r, a, l, u, d) {
            var v = o.create(ke.prototype);
            return v._type = r, v._size = l, v._radius = u, v._initialize(o.getNamed(d), a), v;
          }
          return {
            Circle: function() {
              var r = arguments, a = M.readNamed(r, "center"), l = o.readNamed(r, "radius");
              return i(
                "circle",
                a,
                new F(l * 2),
                l,
                r
              );
            },
            Rectangle: function() {
              var r = arguments, a = D.readNamed(r, "rectangle"), l = F.min(
                F.readNamed(r, "radius"),
                a.getSize(!0).divide(2)
              );
              return i(
                "rectangle",
                a.getCenter(!0),
                a.getSize(!0),
                l,
                r
              );
            },
            Ellipse: function() {
              var r = arguments, a = ke._readEllipse(r), l = a.radius;
              return i(
                "ellipse",
                a.center,
                l.multiply(2),
                l,
                r
              );
            },
            _readEllipse: function(r) {
              var a, l;
              if (o.hasNamed(r, "radius"))
                a = M.readNamed(r, "center"), l = F.readNamed(r, "radius");
              else {
                var u = D.readNamed(r, "rectangle");
                a = u.getCenter(!0), l = u.getSize(!0).divide(2);
              }
              return { center: a, radius: l };
            }
          };
        }()
      }
    ), Ye = X.extend({
      _class: "Raster",
      _applyMatrix: !1,
      _canApplyMatrix: !1,
      _boundsOptions: { stroke: !1, handle: !1 },
      _serializeFields: {
        crossOrigin: null,
        source: null
      },
      _prioritize: ["crossOrigin"],
      _smoothing: "low",
      beans: !0,
      initialize: function(r, a) {
        if (!this._initialize(
          r,
          a !== t && M.read(arguments)
        )) {
          var l, u = typeof r, d = u === "string" ? s.getElementById(r) : u === "object" ? r : null;
          if (d && d !== X.NO_INSERT) {
            if (d.getContext || d.naturalHeight != null)
              l = d;
            else if (d) {
              var v = F.read(arguments);
              v.isZero() || (l = mt.getCanvas(v));
            }
          }
          l ? this.setImage(l) : this.setSource(r);
        }
        this._size || (this._size = new F(), this._loaded = !1);
      },
      _equals: function(i) {
        return this.getSource() === i.getSource();
      },
      copyContent: function(i) {
        var r = i._image, a = i._canvas;
        if (r)
          this._setImage(r);
        else if (a) {
          var l = mt.getCanvas(i._size);
          l.getContext("2d").drawImage(a, 0, 0), this._setImage(l);
        }
        this._crossOrigin = i._crossOrigin;
      },
      getSize: function() {
        var i = this._size;
        return new Q(
          i ? i.width : 0,
          i ? i.height : 0,
          this,
          "setSize"
        );
      },
      setSize: function(i, r) {
        var a = F.read(arguments);
        if (a.equals(this._size))
          r && this.clear();
        else if (a.width > 0 && a.height > 0) {
          var l = !r && this.getElement();
          this._setImage(mt.getCanvas(a)), l && this.getContext(!0).drawImage(
            l,
            0,
            0,
            a.width,
            a.height
          );
        } else
          this._canvas && mt.release(this._canvas), this._size = a.clone();
      },
      getWidth: function() {
        return this._size ? this._size.width : 0;
      },
      setWidth: function(i) {
        this.setSize(i, this.getHeight());
      },
      getHeight: function() {
        return this._size ? this._size.height : 0;
      },
      setHeight: function(i) {
        this.setSize(this.getWidth(), i);
      },
      getLoaded: function() {
        return this._loaded;
      },
      isEmpty: function() {
        var i = this._size;
        return !i || i.width === 0 && i.height === 0;
      },
      getResolution: function() {
        var i = this._matrix, r = new M(0, 0).transform(i), a = new M(1, 0).transform(i).subtract(r), l = new M(0, 1).transform(i).subtract(r);
        return new F(
          72 / a.getLength(),
          72 / l.getLength()
        );
      },
      getPpi: "#getResolution",
      getImage: function() {
        return this._image;
      },
      setImage: function(i) {
        var r = this;
        function a(l) {
          var u = r.getView(), d = l && l.type || "load";
          u && r.responds(d) && (He = u._scope, r.emit(d, new Fi(l)));
        }
        this._setImage(i), this._loaded ? setTimeout(a, 0) : i && $t.add(i, {
          load: function(l) {
            r._setImage(i), a(l);
          },
          error: a
        });
      },
      _setImage: function(i) {
        this._canvas && mt.release(this._canvas), i && i.getContext ? (this._image = null, this._canvas = i, this._loaded = !0) : (this._image = i, this._canvas = null, this._loaded = !!(i && i.src && i.complete)), this._size = new F(
          i ? i.naturalWidth || i.width : 0,
          i ? i.naturalHeight || i.height : 0
        ), this._context = null, this._changed(1033);
      },
      getCanvas: function() {
        if (!this._canvas) {
          var i = mt.getContext(this._size);
          try {
            this._image && i.drawImage(this._image, 0, 0), this._canvas = i.canvas;
          } catch {
            mt.release(i);
          }
        }
        return this._canvas;
      },
      setCanvas: "#setImage",
      getContext: function(i) {
        return this._context || (this._context = this.getCanvas().getContext("2d")), i && (this._image = null, this._changed(1025)), this._context;
      },
      setContext: function(i) {
        this._context = i;
      },
      getSource: function() {
        var i = this._image;
        return i && i.src || this.toDataURL();
      },
      setSource: function(i) {
        var r = new e.Image(), a = this._crossOrigin;
        a && (r.crossOrigin = a), i && (r.src = i), this.setImage(r);
      },
      getCrossOrigin: function() {
        var i = this._image;
        return i && i.crossOrigin || this._crossOrigin || "";
      },
      setCrossOrigin: function(i) {
        this._crossOrigin = i;
        var r = this._image;
        r && (r.crossOrigin = i);
      },
      getSmoothing: function() {
        return this._smoothing;
      },
      setSmoothing: function(i) {
        this._smoothing = typeof i == "string" ? i : i ? "low" : "off", this._changed(257);
      },
      getElement: function() {
        return this._canvas || this._loaded && this._image;
      }
    }, {
      beans: !1,
      getSubCanvas: function() {
        var i = D.read(arguments), r = mt.getContext(i.getSize());
        return r.drawImage(
          this.getCanvas(),
          i.x,
          i.y,
          i.width,
          i.height,
          0,
          0,
          i.width,
          i.height
        ), r.canvas;
      },
      getSubRaster: function() {
        var i = D.read(arguments), r = new Ye(X.NO_INSERT);
        return r._setImage(this.getSubCanvas(i)), r.translate(i.getCenter().subtract(this.getSize().divide(2))), r._matrix.prepend(this._matrix), r.insertAbove(this), r;
      },
      toDataURL: function() {
        var i = this._image, r = i && i.src;
        if (/^data:/.test(r))
          return r;
        var a = this.getCanvas();
        return a ? a.toDataURL.apply(a, arguments) : null;
      },
      drawImage: function(i) {
        var r = M.read(arguments, 1);
        this.getContext(!0).drawImage(i, r.x, r.y);
      },
      getAverageColor: function(i) {
        var r, a;
        if (i ? i instanceof Yt ? (a = i, r = i.getBounds()) : typeof i == "object" && ("width" in i ? r = new D(i) : "x" in i && (r = new D(i.x - 0.5, i.y - 0.5, 1, 1))) : r = this.getBounds(), !r)
          return null;
        var l = 32, u = Math.min(r.width, l), d = Math.min(r.height, l), v = Ye._sampleContext;
        v ? v.clearRect(0, 0, l + 1, l + 1) : v = Ye._sampleContext = mt.getContext(
          new F(l)
        ), v.save();
        var p = new ee().scale(u / r.width, d / r.height).translate(-r.x, -r.y);
        p.applyToContext(v), a && a.draw(v, new o({ clip: !0, matrices: [p] })), this._matrix.applyToContext(v);
        var y = this.getElement(), S = this._size;
        y && v.drawImage(y, -S.width / 2, -S.height / 2), v.restore();
        for (var L = v.getImageData(
          0.5,
          0.5,
          Math.ceil(u),
          Math.ceil(d)
        ).data, E = [0, 0, 0], A = 0, T = 0, G = L.length; T < G; T += 4) {
          var R = L[T + 3];
          A += R, R /= 255, E[0] += L[T] * R, E[1] += L[T + 1] * R, E[2] += L[T + 2] * R;
        }
        for (var T = 0; T < 3; T++)
          E[T] /= A;
        return A ? Lt.read(E) : null;
      },
      getPixel: function() {
        var i = M.read(arguments), r = this.getContext().getImageData(i.x, i.y, 1, 1).data;
        return new Lt(
          "rgb",
          [r[0] / 255, r[1] / 255, r[2] / 255],
          r[3] / 255
        );
      },
      setPixel: function() {
        var i = arguments, r = M.read(i), a = Lt.read(i), l = a._convert("rgb"), u = a._alpha, d = this.getContext(!0), v = d.createImageData(1, 1), p = v.data;
        p[0] = l[0] * 255, p[1] = l[1] * 255, p[2] = l[2] * 255, p[3] = u != null ? u * 255 : 255, d.putImageData(v, r.x, r.y);
      },
      clear: function() {
        var i = this._size;
        this.getContext(!0).clearRect(0, 0, i.width + 1, i.height + 1);
      },
      createImageData: function() {
        var i = F.read(arguments);
        return this.getContext().createImageData(i.width, i.height);
      },
      getImageData: function() {
        var i = D.read(arguments);
        return i.isEmpty() && (i = new D(this._size)), this.getContext().getImageData(
          i.x,
          i.y,
          i.width,
          i.height
        );
      },
      putImageData: function(i) {
        var r = M.read(arguments, 1);
        this.getContext(!0).putImageData(i, r.x, r.y);
      },
      setImageData: function(i) {
        this.setSize(i), this.getContext(!0).putImageData(i, 0, 0);
      },
      _getBounds: function(i, r) {
        var a = new D(this._size).setCenter(0, 0);
        return i ? i._transformBounds(a) : a;
      },
      _hitTestSelf: function(i) {
        if (this._contains(i)) {
          var r = this;
          return new $e("pixel", r, {
            offset: i.add(r._size.divide(2)).round(),
            color: {
              get: function() {
                return r.getPixel(this.offset);
              }
            }
          });
        }
      },
      _draw: function(i, r, a) {
        var l = this.getElement();
        if (l && l.width > 0 && l.height > 0) {
          i.globalAlpha = P.clamp(this._opacity, 0, 1), this._setStyles(i, r, a);
          var u = this._smoothing, d = u === "off";
          Wt.setPrefixed(
            i,
            d ? "imageSmoothingEnabled" : "imageSmoothingQuality",
            d ? !1 : u
          ), i.drawImage(
            l,
            -this._size.width / 2,
            -this._size.height / 2
          );
        }
      },
      _canComposite: function() {
        return !0;
      }
    }), pt = X.extend({
      _class: "SymbolItem",
      _applyMatrix: !1,
      _canApplyMatrix: !1,
      _boundsOptions: { stroke: !0 },
      _serializeFields: {
        symbol: null
      },
      initialize: function(r, a) {
        this._initialize(
          r,
          a !== t && M.read(arguments, 1)
        ) || this.setDefinition(r instanceof Le ? r : new Le(r));
      },
      _equals: function(i) {
        return this._definition === i._definition;
      },
      copyContent: function(i) {
        this.setDefinition(i._definition);
      },
      getDefinition: function() {
        return this._definition;
      },
      setDefinition: function(i) {
        this._definition = i, this._changed(9);
      },
      getSymbol: "#getDefinition",
      setSymbol: "#setDefinition",
      isEmpty: function() {
        return this._definition._item.isEmpty();
      },
      _getBounds: function(i, r) {
        var a = this._definition._item;
        return a._getCachedBounds(a._matrix.prepended(i), r);
      },
      _hitTestSelf: function(i, r, a) {
        var l = r.extend({ all: !1 }), u = this._definition._item._hitTest(i, l, a);
        return u && (u.item = this), u;
      },
      _draw: function(i, r) {
        this._definition._item.draw(i, r);
      }
    }), Le = o.extend({
      _class: "SymbolDefinition",
      initialize: function(r, a) {
        this._id = U.get(), this.project = He.project, r && this.setItem(r, a);
      },
      _serialize: function(i, r) {
        return r.add(this, function() {
          return o.serialize(
            [this._class, this._item],
            i,
            !1,
            r
          );
        });
      },
      _changed: function(i) {
        i & 8 && X._clearBoundsCache(this), i & 1 && this.project._changed(i);
      },
      getItem: function() {
        return this._item;
      },
      setItem: function(i, r) {
        i._symbol && (i = i.clone()), this._item && (this._item._symbol = null), this._item = i, i.remove(), i.setSelected(!1), r || i.setPosition(new M()), i._symbol = this, this._changed(9);
      },
      getDefinition: "#getItem",
      setDefinition: "#setItem",
      place: function(i) {
        return new pt(this, i);
      },
      clone: function() {
        return new Le(this._item.clone(!1));
      },
      equals: function(i) {
        return i === this || i && this._item.equals(i._item) || !1;
      }
    }), $e = o.extend({
      _class: "HitResult",
      initialize: function(r, a, l) {
        this.type = r, this.item = a, l && this.inject(l);
      },
      statics: {
        getOptions: function(i) {
          var r = i && o.read(i);
          return new o({
            type: null,
            tolerance: He.settings.hitTolerance,
            fill: !r,
            stroke: !r,
            segments: !r,
            handles: !1,
            ends: !1,
            position: !1,
            center: !1,
            bounds: !1,
            guides: !1,
            selected: !1
          }, r);
        }
      }
    }), ce = o.extend({
      _class: "Segment",
      beans: !0,
      _selection: 0,
      initialize: function(r, a, l, u, d, v) {
        var p = arguments.length, y, S, L, E;
        p > 0 && (r == null || typeof r == "object" ? p === 1 && r && "point" in r ? (y = r.point, S = r.handleIn, L = r.handleOut, E = r.selection) : (y = r, S = a, L = l, E = u) : (y = [r, a], S = l !== t ? [l, u] : null, L = d !== t ? [d, v] : null)), new ht(y, this, "_point"), new ht(S, this, "_handleIn"), new ht(L, this, "_handleOut"), E && this.setSelection(E);
      },
      _serialize: function(i, r) {
        var a = this._point, l = this._selection, u = l || this.hasHandles() ? [a, this._handleIn, this._handleOut] : a;
        return l && u.push(l), o.serialize(u, i, !0, r);
      },
      _changed: function(i) {
        var r = this._path;
        if (r) {
          var a = r._curves, l = this._index, u;
          a && ((!i || i === this._point || i === this._handleIn) && (u = l > 0 ? a[l - 1] : r._closed ? a[a.length - 1] : null) && u._changed(), (!i || i === this._point || i === this._handleOut) && (u = a[l]) && u._changed()), r._changed(41);
        }
      },
      getPoint: function() {
        return this._point;
      },
      setPoint: function() {
        this._point.set(M.read(arguments));
      },
      getHandleIn: function() {
        return this._handleIn;
      },
      setHandleIn: function() {
        this._handleIn.set(M.read(arguments));
      },
      getHandleOut: function() {
        return this._handleOut;
      },
      setHandleOut: function() {
        this._handleOut.set(M.read(arguments));
      },
      hasHandles: function() {
        return !this._handleIn.isZero() || !this._handleOut.isZero();
      },
      isSmooth: function() {
        var i = this._handleIn, r = this._handleOut;
        return !i.isZero() && !r.isZero() && i.isCollinear(r);
      },
      clearHandles: function() {
        this._handleIn._set(0, 0), this._handleOut._set(0, 0);
      },
      getSelection: function() {
        return this._selection;
      },
      setSelection: function(i) {
        var r = this._selection, a = this._path;
        this._selection = i = i || 0, a && i !== r && (a._updateSelection(this, r, i), a._changed(257));
      },
      _changeSelection: function(i, r) {
        var a = this._selection;
        this.setSelection(r ? a | i : a & ~i);
      },
      isSelected: function() {
        return !!(this._selection & 7);
      },
      setSelected: function(i) {
        this._changeSelection(7, i);
      },
      getIndex: function() {
        return this._index !== t ? this._index : null;
      },
      getPath: function() {
        return this._path || null;
      },
      getCurve: function() {
        var i = this._path, r = this._index;
        return i ? (r > 0 && !i._closed && r === i._segments.length - 1 && r--, i.getCurves()[r] || null) : null;
      },
      getLocation: function() {
        var i = this.getCurve();
        return i ? new ft(i, this === i._segment1 ? 0 : 1) : null;
      },
      getNext: function() {
        var i = this._path && this._path._segments;
        return i && (i[this._index + 1] || this._path._closed && i[0]) || null;
      },
      smooth: function(i, r, a) {
        var l = i || {}, u = l.type, d = l.factor, v = this.getPrevious(), p = this.getNext(), y = (v || this)._point, S = this._point, L = (p || this)._point, E = y.getDistance(S), A = S.getDistance(L);
        if (!u || u === "catmull-rom") {
          var T = d === t ? 0.5 : d, G = Math.pow(E, T), R = G * G, Y = Math.pow(A, T), k = Y * Y;
          if (!r && v) {
            var z = 2 * k + 3 * Y * G + R, C = 3 * Y * (Y + G);
            this.setHandleIn(C !== 0 ? new M(
              (k * y._x + z * S._x - R * L._x) / C - S._x,
              (k * y._y + z * S._y - R * L._y) / C - S._y
            ) : new M());
          }
          if (!a && p) {
            var z = 2 * R + 3 * G * Y + k, C = 3 * G * (G + Y);
            this.setHandleOut(C !== 0 ? new M(
              (R * L._x + z * S._x - k * y._x) / C - S._x,
              (R * L._y + z * S._y - k * y._y) / C - S._y
            ) : new M());
          }
        } else if (u === "geometric") {
          if (v && p) {
            var I = y.subtract(L), j = d === t ? 0.4 : d, q = j * E / (E + A);
            r || this.setHandleIn(I.multiply(q)), a || this.setHandleOut(I.multiply(q - j));
          }
        } else
          throw new Error("Smoothing method '" + u + "' not supported.");
      },
      getPrevious: function() {
        var i = this._path && this._path._segments;
        return i && (i[this._index - 1] || this._path._closed && i[i.length - 1]) || null;
      },
      isFirst: function() {
        return !this._index;
      },
      isLast: function() {
        var i = this._path;
        return i && this._index === i._segments.length - 1 || !1;
      },
      reverse: function() {
        var i = this._handleIn, r = this._handleOut, a = i.clone();
        i.set(r), r.set(a);
      },
      reversed: function() {
        return new ce(this._point, this._handleOut, this._handleIn);
      },
      remove: function() {
        return this._path ? !!this._path.removeSegment(this._index) : !1;
      },
      clone: function() {
        return new ce(this._point, this._handleIn, this._handleOut);
      },
      equals: function(i) {
        return i === this || i && this._class === i._class && this._point.equals(i._point) && this._handleIn.equals(i._handleIn) && this._handleOut.equals(i._handleOut) || !1;
      },
      toString: function() {
        var i = ["point: " + this._point];
        return this._handleIn.isZero() || i.push("handleIn: " + this._handleIn), this._handleOut.isZero() || i.push("handleOut: " + this._handleOut), "{ " + i.join(", ") + " }";
      },
      transform: function(i) {
        this._transformCoordinates(i, new Array(6), !0), this._changed();
      },
      interpolate: function(i, r, a) {
        var l = 1 - a, u = a, d = i._point, v = r._point, p = i._handleIn, y = r._handleIn, S = r._handleOut, L = i._handleOut;
        this._point._set(
          l * d._x + u * v._x,
          l * d._y + u * v._y,
          !0
        ), this._handleIn._set(
          l * p._x + u * y._x,
          l * p._y + u * y._y,
          !0
        ), this._handleOut._set(
          l * L._x + u * S._x,
          l * L._y + u * S._y,
          !0
        ), this._changed();
      },
      _transformCoordinates: function(i, r, a) {
        var l = this._point, u = !a || !this._handleIn.isZero() ? this._handleIn : null, d = !a || !this._handleOut.isZero() ? this._handleOut : null, v = l._x, p = l._y, y = 2;
        return r[0] = v, r[1] = p, u && (r[y++] = u._x + v, r[y++] = u._y + p), d && (r[y++] = d._x + v, r[y++] = d._y + p), i && (i._transformCoordinates(r, r, y / 2), v = r[0], p = r[1], a ? (l._x = v, l._y = p, y = 2, u && (u._x = r[y++] - v, u._y = r[y++] - p), d && (d._x = r[y++] - v, d._y = r[y++] - p)) : (u || (r[y++] = v, r[y++] = p), d || (r[y++] = v, r[y++] = p))), r;
      }
    }), ht = M.extend({
      initialize: function(r, a, l) {
        var u, d, v;
        if (!r)
          u = d = 0;
        else if ((u = r[0]) !== t)
          d = r[1];
        else {
          var p = r;
          (u = p.x) === t && (p = M.read(arguments), u = p.x), d = p.y, v = p.selected;
        }
        this._x = u, this._y = d, this._owner = a, a[l] = this, v && this.setSelected(!0);
      },
      _set: function(i, r) {
        return this._x = i, this._y = r, this._owner._changed(this), this;
      },
      getX: function() {
        return this._x;
      },
      setX: function(i) {
        this._x = i, this._owner._changed(this);
      },
      getY: function() {
        return this._y;
      },
      setY: function(i) {
        this._y = i, this._owner._changed(this);
      },
      isZero: function() {
        var i = P.isZero;
        return i(this._x) && i(this._y);
      },
      isSelected: function() {
        return !!(this._owner._selection & this._getSelection());
      },
      setSelected: function(i) {
        this._owner._changeSelection(this._getSelection(), i);
      },
      _getSelection: function() {
        var i = this._owner;
        return this === i._point ? 1 : this === i._handleIn ? 2 : this === i._handleOut ? 4 : 0;
      }
    }), De = o.extend(
      {
        _class: "Curve",
        beans: !0,
        initialize: function(r, a, l, u, d, v, p, y) {
          var S = arguments.length, L, E, A, T, G, R;
          S === 3 ? (this._path = r, L = a, E = l) : S ? S === 1 ? "segment1" in r ? (L = new ce(r.segment1), E = new ce(r.segment2)) : "point1" in r ? (A = r.point1, G = r.handle1, R = r.handle2, T = r.point2) : Array.isArray(r) && (A = [r[0], r[1]], T = [r[6], r[7]], G = [r[2] - r[0], r[3] - r[1]], R = [r[4] - r[6], r[5] - r[7]]) : S === 2 ? (L = new ce(r), E = new ce(a)) : S === 4 ? (A = r, G = a, R = l, T = u) : S === 8 && (A = [r, a], T = [p, y], G = [l - r, u - a], R = [d - p, v - y]) : (L = new ce(), E = new ce()), this._segment1 = L || new ce(A, null, G), this._segment2 = E || new ce(T, R, null);
        },
        _serialize: function(i, r) {
          return o.serialize(
            this.hasHandles() ? [
              this.getPoint1(),
              this.getHandle1(),
              this.getHandle2(),
              this.getPoint2()
            ] : [this.getPoint1(), this.getPoint2()],
            i,
            !0,
            r
          );
        },
        _changed: function() {
          this._length = this._bounds = t;
        },
        clone: function() {
          return new De(this._segment1, this._segment2);
        },
        toString: function() {
          var i = ["point1: " + this._segment1._point];
          return this._segment1._handleOut.isZero() || i.push("handle1: " + this._segment1._handleOut), this._segment2._handleIn.isZero() || i.push("handle2: " + this._segment2._handleIn), i.push("point2: " + this._segment2._point), "{ " + i.join(", ") + " }";
        },
        classify: function() {
          return De.classify(this.getValues());
        },
        remove: function() {
          var i = !1;
          if (this._path) {
            var r = this._segment2, a = r._handleOut;
            i = r.remove(), i && this._segment1._handleOut.set(a);
          }
          return i;
        },
        getPoint1: function() {
          return this._segment1._point;
        },
        setPoint1: function() {
          this._segment1._point.set(M.read(arguments));
        },
        getPoint2: function() {
          return this._segment2._point;
        },
        setPoint2: function() {
          this._segment2._point.set(M.read(arguments));
        },
        getHandle1: function() {
          return this._segment1._handleOut;
        },
        setHandle1: function() {
          this._segment1._handleOut.set(M.read(arguments));
        },
        getHandle2: function() {
          return this._segment2._handleIn;
        },
        setHandle2: function() {
          this._segment2._handleIn.set(M.read(arguments));
        },
        getSegment1: function() {
          return this._segment1;
        },
        getSegment2: function() {
          return this._segment2;
        },
        getPath: function() {
          return this._path;
        },
        getIndex: function() {
          return this._segment1._index;
        },
        getNext: function() {
          var i = this._path && this._path._curves;
          return i && (i[this._segment1._index + 1] || this._path._closed && i[0]) || null;
        },
        getPrevious: function() {
          var i = this._path && this._path._curves;
          return i && (i[this._segment1._index - 1] || this._path._closed && i[i.length - 1]) || null;
        },
        isFirst: function() {
          return !this._segment1._index;
        },
        isLast: function() {
          var i = this._path;
          return i && this._segment1._index === i._curves.length - 1 || !1;
        },
        isSelected: function() {
          return this.getPoint1().isSelected() && this.getHandle1().isSelected() && this.getHandle2().isSelected() && this.getPoint2().isSelected();
        },
        setSelected: function(i) {
          this.getPoint1().setSelected(i), this.getHandle1().setSelected(i), this.getHandle2().setSelected(i), this.getPoint2().setSelected(i);
        },
        getValues: function(i) {
          return De.getValues(this._segment1, this._segment2, i);
        },
        getPoints: function() {
          for (var i = this.getValues(), r = [], a = 0; a < 8; a += 2)
            r.push(new M(i[a], i[a + 1]));
          return r;
        }
      },
      {
        getLength: function() {
          return this._length == null && (this._length = De.getLength(this.getValues(), 0, 1)), this._length;
        },
        getArea: function() {
          return De.getArea(this.getValues());
        },
        getLine: function() {
          return new le(this._segment1._point, this._segment2._point);
        },
        getPart: function(i, r) {
          return new De(De.getPart(this.getValues(), i, r));
        },
        getPartLength: function(i, r) {
          return De.getLength(this.getValues(), i, r);
        },
        divideAt: function(i) {
          return this.divideAtTime(i && i.curve === this ? i.time : this.getTimeAt(i));
        },
        divideAtTime: function(i, r) {
          var a = 1e-8, l = 1 - a, u = null;
          if (i >= a && i <= l) {
            var d = De.subdivide(this.getValues(), i), v = d[0], p = d[1], y = r || this.hasHandles(), S = this._segment1, L = this._segment2, E = this._path;
            y && (S._handleOut._set(v[2] - v[0], v[3] - v[1]), L._handleIn._set(p[4] - p[6], p[5] - p[7]));
            var A = v[6], T = v[7], G = new ce(
              new M(A, T),
              y && new M(v[4] - A, v[5] - T),
              y && new M(p[2] - A, p[3] - T)
            );
            E ? (E.insert(S._index + 1, G), u = this.getNext()) : (this._segment2 = G, this._changed(), u = new De(G, L));
          }
          return u;
        },
        splitAt: function(i) {
          var r = this._path;
          return r ? r.splitAt(i) : null;
        },
        splitAtTime: function(i) {
          return this.splitAt(this.getLocationAtTime(i));
        },
        divide: function(i, r) {
          return this.divideAtTime(i === t ? 0.5 : r ? i : this.getTimeAt(i));
        },
        split: function(i, r) {
          return this.splitAtTime(i === t ? 0.5 : r ? i : this.getTimeAt(i));
        },
        reversed: function() {
          return new De(this._segment2.reversed(), this._segment1.reversed());
        },
        clearHandles: function() {
          this._segment1._handleOut._set(0, 0), this._segment2._handleIn._set(0, 0);
        },
        statics: {
          getValues: function(i, r, a, l) {
            var u = i._point, d = i._handleOut, v = r._handleIn, p = r._point, y = u.x, S = u.y, L = p.x, E = p.y, A = l ? [y, S, y, S, L, E, L, E] : [
              y,
              S,
              y + d._x,
              S + d._y,
              L + v._x,
              E + v._y,
              L,
              E
            ];
            return a && a._transformCoordinates(A, A, 4), A;
          },
          subdivide: function(i, r) {
            var a = i[0], l = i[1], u = i[2], d = i[3], v = i[4], p = i[5], y = i[6], S = i[7];
            r === t && (r = 0.5);
            var L = 1 - r, E = L * a + r * u, A = L * l + r * d, T = L * u + r * v, G = L * d + r * p, R = L * v + r * y, Y = L * p + r * S, k = L * E + r * T, z = L * A + r * G, C = L * T + r * R, I = L * G + r * Y, j = L * k + r * C, q = L * z + r * I;
            return [
              [a, l, E, A, k, z, j, q],
              [j, q, C, I, R, Y, y, S]
            ];
          },
          getMonoCurves: function(i, r) {
            var a = [], l = r ? 0 : 1, u = i[l + 0], d = i[l + 2], v = i[l + 4], p = i[l + 6];
            if (u >= d == d >= v && d >= v == v >= p || De.isStraight(i))
              a.push(i);
            else {
              var y = 3 * (d - v) - u + p, S = 2 * (u + v) - 4 * d, L = d - u, E = 1e-8, A = 1 - E, T = [], G = P.solveQuadratic(y, S, L, T, E, A);
              if (!G)
                a.push(i);
              else {
                T.sort();
                var R = T[0], Y = De.subdivide(i, R);
                a.push(Y[0]), G > 1 && (R = (T[1] - R) / (1 - R), Y = De.subdivide(Y[1], R), a.push(Y[0])), a.push(Y[1]);
              }
            }
            return a;
          },
          solveCubic: function(i, r, a, l, u, d) {
            var v = i[r], p = i[r + 2], y = i[r + 4], S = i[r + 6], L = 0;
            if (!(v < a && S < a && p < a && y < a || v > a && S > a && p > a && y > a)) {
              var E = 3 * (p - v), A = 3 * (y - p) - E, T = S - v - E - A;
              L = P.solveCubic(T, A, E, v - a, l, u, d);
            }
            return L;
          },
          getTimeOf: function(i, r) {
            var a = new M(i[0], i[1]), l = new M(i[6], i[7]), u = 1e-12, d = 1e-7, v = r.isClose(a, u) ? 0 : r.isClose(l, u) ? 1 : null;
            if (v === null)
              for (var p = [r.x, r.y], y = [], S = 0; S < 2; S++)
                for (var L = De.solveCubic(i, S, p[S], y, 0, 1), E = 0; E < L; E++) {
                  var A = y[E];
                  if (r.isClose(De.getPoint(i, A), d))
                    return A;
                }
            return r.isClose(a, d) ? 0 : r.isClose(l, d) ? 1 : null;
          },
          getNearestTime: function(i, r) {
            if (De.isStraight(i)) {
              var a = i[0], l = i[1], u = i[6], d = i[7], v = u - a, p = d - l, y = v * v + p * p;
              if (y === 0)
                return 0;
              var S = ((r.x - a) * v + (r.y - l) * p) / y;
              return S < 1e-12 ? 0 : S > 0.999999999999 ? 1 : De.getTimeOf(
                i,
                new M(a + S * v, l + S * p)
              );
            }
            var L = 100, E = 1 / 0, A = 0;
            function T(Y) {
              if (Y >= 0 && Y <= 1) {
                var k = r.getDistance(De.getPoint(i, Y), !0);
                if (k < E)
                  return E = k, A = Y, !0;
              }
            }
            for (var G = 0; G <= L; G++)
              T(G / L);
            for (var R = 1 / (L * 2); R > 1e-8; )
              !T(A - R) && !T(A + R) && (R /= 2);
            return A;
          },
          getPart: function(i, r, a) {
            var l = r > a;
            if (l) {
              var u = r;
              r = a, a = u;
            }
            return r > 0 && (i = De.subdivide(i, r)[1]), a < 1 && (i = De.subdivide(i, (a - r) / (1 - r))[0]), l ? [i[6], i[7], i[4], i[5], i[2], i[3], i[0], i[1]] : i;
          },
          isFlatEnough: function(i, r) {
            var a = i[0], l = i[1], u = i[2], d = i[3], v = i[4], p = i[5], y = i[6], S = i[7], L = 3 * u - 2 * a - y, E = 3 * d - 2 * l - S, A = 3 * v - 2 * y - a, T = 3 * p - 2 * S - l;
            return Math.max(L * L, A * A) + Math.max(E * E, T * T) <= 16 * r * r;
          },
          getArea: function(i) {
            var r = i[0], a = i[1], l = i[2], u = i[3], d = i[4], v = i[5], p = i[6], y = i[7];
            return 3 * ((y - a) * (l + d) - (p - r) * (u + v) + u * (r - d) - l * (a - v) + y * (d + r / 3) - p * (v + a / 3)) / 20;
          },
          getBounds: function(i) {
            for (var r = i.slice(0, 2), a = r.slice(), l = [0, 0], u = 0; u < 2; u++)
              De._addBounds(
                i[u],
                i[u + 2],
                i[u + 4],
                i[u + 6],
                u,
                0,
                r,
                a,
                l
              );
            return new D(r[0], r[1], a[0] - r[0], a[1] - r[1]);
          },
          _addBounds: function(i, r, a, l, u, d, v, p, y) {
            function S(j, q) {
              var H = j - q, ie = j + q;
              H < v[u] && (v[u] = H), ie > p[u] && (p[u] = ie);
            }
            d /= 2;
            var L = v[u] + d, E = p[u] - d;
            if (i < L || r < L || a < L || l < L || i > E || r > E || a > E || l > E)
              if (r < i != r < l && a < i != a < l)
                S(i, 0), S(l, 0);
              else {
                var A = 3 * (r - a) - i + l, T = 2 * (i + a) - 4 * r, G = r - i, R = P.solveQuadratic(A, T, G, y), Y = 1e-8, k = 1 - Y;
                S(l, 0);
                for (var z = 0; z < R; z++) {
                  var C = y[z], I = 1 - C;
                  Y <= C && C <= k && S(
                    I * I * I * i + 3 * I * I * C * r + 3 * I * C * C * a + C * C * C * l,
                    d
                  );
                }
              }
          }
        }
      },
      o.each(
        ["getBounds", "getStrokeBounds", "getHandleBounds"],
        function(i) {
          this[i] = function() {
            this._bounds || (this._bounds = {});
            var r = this._bounds[i];
            return r || (r = this._bounds[i] = We[i](
              [this._segment1, this._segment2],
              !1,
              this._path
            )), r.clone();
          };
        },
        {}
      ),
      o.each({
        isStraight: function(i, r, a, l) {
          if (r.isZero() && a.isZero())
            return !0;
          var u = l.subtract(i);
          if (u.isZero())
            return !1;
          if (u.isCollinear(r) && u.isCollinear(a)) {
            var d = new le(i, l), v = 1e-7;
            if (d.getDistance(i.add(r)) < v && d.getDistance(l.add(a)) < v) {
              var p = u.dot(u), y = u.dot(r) / p, S = u.dot(a) / p;
              return y >= 0 && y <= 1 && S <= 0 && S >= -1;
            }
          }
          return !1;
        },
        isLinear: function(i, r, a, l) {
          var u = l.subtract(i).divide(3);
          return r.equals(u) && a.negate().equals(u);
        }
      }, function(i, r) {
        this[r] = function(a) {
          var l = this._segment1, u = this._segment2;
          return i(
            l._point,
            l._handleOut,
            u._handleIn,
            u._point,
            a
          );
        }, this.statics[r] = function(a, l) {
          var u = a[0], d = a[1], v = a[6], p = a[7];
          return i(
            new M(u, d),
            new M(a[2] - u, a[3] - d),
            new M(a[4] - v, a[5] - p),
            new M(v, p),
            l
          );
        };
      }, {
        statics: {},
        hasHandles: function() {
          return !this._segment1._handleOut.isZero() || !this._segment2._handleIn.isZero();
        },
        hasLength: function(i) {
          return (!this.getPoint1().equals(this.getPoint2()) || this.hasHandles()) && this.getLength() > (i || 0);
        },
        isCollinear: function(i) {
          return i && this.isStraight() && i.isStraight() && this.getLine().isCollinear(i.getLine());
        },
        isHorizontal: function() {
          return this.isStraight() && Math.abs(this.getTangentAtTime(0.5).y) < 1e-8;
        },
        isVertical: function() {
          return this.isStraight() && Math.abs(this.getTangentAtTime(0.5).x) < 1e-8;
        }
      }),
      {
        beans: !1,
        getLocationAt: function(i, r) {
          return this.getLocationAtTime(
            r ? i : this.getTimeAt(i)
          );
        },
        getLocationAtTime: function(i) {
          return i != null && i >= 0 && i <= 1 ? new ft(this, i) : null;
        },
        getTimeAt: function(i, r) {
          return De.getTimeAt(this.getValues(), i, r);
        },
        getParameterAt: "#getTimeAt",
        getTimesWithTangent: function() {
          var i = M.read(arguments);
          return i.isZero() ? [] : De.getTimesWithTangent(this.getValues(), i);
        },
        getOffsetAtTime: function(i) {
          return this.getPartLength(0, i);
        },
        getLocationOf: function() {
          return this.getLocationAtTime(this.getTimeOf(M.read(arguments)));
        },
        getOffsetOf: function() {
          var i = this.getLocationOf.apply(this, arguments);
          return i ? i.getOffset() : null;
        },
        getTimeOf: function() {
          return De.getTimeOf(this.getValues(), M.read(arguments));
        },
        getParameterOf: "#getTimeOf",
        getNearestLocation: function() {
          var i = M.read(arguments), r = this.getValues(), a = De.getNearestTime(r, i), l = De.getPoint(r, a);
          return new ft(this, a, l, null, i.getDistance(l));
        },
        getNearestPoint: function() {
          var i = this.getNearestLocation.apply(this, arguments);
          return i && i.getPoint();
        }
      },
      new function() {
        var i = [
          "getPoint",
          "getTangent",
          "getNormal",
          "getWeightedTangent",
          "getWeightedNormal",
          "getCurvature"
        ];
        return o.each(
          i,
          function(r) {
            this[r + "At"] = function(a, l) {
              var u = this.getValues();
              return De[r](u, l ? a : De.getTimeAt(u, a));
            }, this[r + "AtTime"] = function(a) {
              return De[r](this.getValues(), a);
            };
          },
          {
            statics: {
              _evaluateMethods: i
            }
          }
        );
      }(),
      new function() {
        function i(l) {
          var u = l[0], d = l[1], v = l[2], p = l[3], y = l[4], S = l[5], L = l[6], E = l[7], A = 9 * (v - y) + 3 * (L - u), T = 6 * (u + y) - 12 * v, G = 3 * (v - u), R = 9 * (p - S) + 3 * (E - d), Y = 6 * (d + S) - 12 * p, k = 3 * (p - d);
          return function(z) {
            var C = (A * z + T) * z + G, I = (R * z + Y) * z + k;
            return Math.sqrt(C * C + I * I);
          };
        }
        function r(l, u) {
          return Math.max(2, Math.min(16, Math.ceil(Math.abs(u - l) * 32)));
        }
        function a(l, u, d, v) {
          if (u == null || u < 0 || u > 1)
            return null;
          var p = l[0], y = l[1], S = l[2], L = l[3], E = l[4], A = l[5], T = l[6], G = l[7], R = P.isZero;
          R(S - p) && R(L - y) && (S = p, L = y), R(E - T) && R(A - G) && (E = T, A = G);
          var Y = 3 * (S - p), k = 3 * (E - S) - Y, z = T - p - Y - k, C = 3 * (L - y), I = 3 * (A - L) - C, j = G - y - C - I, q, H;
          if (d === 0)
            q = u === 0 ? p : u === 1 ? T : ((z * u + k) * u + Y) * u + p, H = u === 0 ? y : u === 1 ? G : ((j * u + I) * u + C) * u + y;
          else {
            var ie = 1e-8, ae = 1 - ie;
            if (u < ie ? (q = Y, H = C) : u > ae ? (q = 3 * (T - E), H = 3 * (G - A)) : (q = (3 * z * u + 2 * k) * u + Y, H = (3 * j * u + 2 * I) * u + C), v) {
              q === 0 && H === 0 && (u < ie || u > ae) && (q = E - S, H = A - L);
              var he = Math.sqrt(q * q + H * H);
              he && (q /= he, H /= he);
            }
            if (d === 3) {
              var E = 6 * z * u + 2 * k, A = 6 * j * u + 2 * I, pe = Math.pow(q * q + H * H, 3 / 2);
              q = pe !== 0 ? (q * A - H * E) / pe : 0, H = 0;
            }
          }
          return d === 2 ? new M(H, -q) : new M(q, H);
        }
        return { statics: {
          classify: function(l) {
            var u = l[0], d = l[1], v = l[2], p = l[3], y = l[4], S = l[5], L = l[6], E = l[7], A = u * (E - S) + d * (y - L) + L * S - E * y, T = v * (d - E) + p * (L - u) + u * E - d * L, G = y * (p - d) + S * (u - v) + v * d - p * u, R = 3 * G, Y = R - T, k = Y - T + A, z = Math.sqrt(k * k + Y * Y + R * R), C = z !== 0 ? 1 / z : 0, I = P.isZero, j = "serpentine";
            k *= C, Y *= C, R *= C;
            function q(he, pe, se) {
              var de = pe !== t, ve = de && pe > 0 && pe < 1, we = de && se > 0 && se < 1;
              return de && (!(ve || we) || he === "loop" && !(ve && we)) && (he = "arch", ve = we = !1), {
                type: he,
                roots: ve || we ? ve && we ? pe < se ? [pe, se] : [se, pe] : [ve ? pe : se] : null
              };
            }
            if (I(k))
              return I(Y) ? q(I(R) ? "line" : "quadratic") : q(j, R / (3 * Y));
            var H = 3 * Y * Y - 4 * k * R;
            if (I(H))
              return q("cusp", Y / (2 * k));
            var ie = H > 0 ? Math.sqrt(H / 3) : Math.sqrt(-H), ae = 2 * k;
            return q(
              H > 0 ? j : "loop",
              (Y + ie) / ae,
              (Y - ie) / ae
            );
          },
          getLength: function(l, u, d, v) {
            if (u === t && (u = 0), d === t && (d = 1), De.isStraight(l)) {
              var p = l;
              d < 1 && (p = De.subdivide(p, d)[0], u /= d), u > 0 && (p = De.subdivide(p, u)[1]);
              var y = p[6] - p[0], S = p[7] - p[1];
              return Math.sqrt(y * y + S * S);
            }
            return P.integrate(
              v || i(l),
              u,
              d,
              r(u, d)
            );
          },
          getTimeAt: function(l, u, d) {
            if (d === t && (d = u < 0 ? 1 : 0), u === 0)
              return d;
            var v = Math.abs, p = 1e-12, y = u > 0, S = y ? d : 0, L = y ? 1 : d, E = i(l), A = De.getLength(l, S, L, E), T = v(u) - A;
            if (v(T) < p)
              return y ? L : S;
            if (T > p)
              return null;
            var G = u / A, R = 0;
            function Y(k) {
              return R += P.integrate(
                E,
                d,
                k,
                r(d, k)
              ), d = k, R - u;
            }
            return P.findRoot(
              Y,
              E,
              d + G,
              S,
              L,
              32,
              1e-12
            );
          },
          getPoint: function(l, u) {
            return a(l, u, 0, !1);
          },
          getTangent: function(l, u) {
            return a(l, u, 1, !0);
          },
          getWeightedTangent: function(l, u) {
            return a(l, u, 1, !1);
          },
          getNormal: function(l, u) {
            return a(l, u, 2, !0);
          },
          getWeightedNormal: function(l, u) {
            return a(l, u, 2, !1);
          },
          getCurvature: function(l, u) {
            return a(l, u, 3, !1).x;
          },
          getPeaks: function(l) {
            var u = l[0], d = l[1], v = l[2], p = l[3], y = l[4], S = l[5], L = l[6], E = l[7], A = -u + 3 * v - 3 * y + L, T = 3 * u - 6 * v + 3 * y, G = -3 * u + 3 * v, R = -d + 3 * p - 3 * S + E, Y = 3 * d - 6 * p + 3 * S, k = -3 * d + 3 * p, z = 1e-8, C = 1 - z, I = [];
            return P.solveCubic(
              9 * (A * A + R * R),
              9 * (A * T + Y * R),
              2 * (T * T + Y * Y) + 3 * (G * A + k * R),
              G * T + Y * k,
              I,
              z,
              C
            ), I.sort();
          }
        } };
      }(),
      new function() {
        function i(T, G, R, Y, k, z, C) {
          var I = !C && R.getPrevious() === k, j = !C && R !== k && R.getNext() === k, q = 1e-8, H = 1 - q;
          if (Y !== null && Y >= (I ? q : 0) && Y <= (j ? H : 1) && z !== null && z >= (j ? q : 0) && z <= (I ? H : 1)) {
            var ie = new ft(R, Y, null, C), ae = new ft(k, z, null, C);
            ie._intersection = ae, ae._intersection = ie, (!G || G(ie)) && ft.insert(T, ie, !0);
          }
        }
        function r(T, G, R, Y, k, z, C, I, j, q, H, ie, ae) {
          if (++j >= 4096 || ++I >= 40)
            return j;
          var he = 1e-9, pe = G[0], se = G[1], de = G[6], ve = G[7], we = le.getSignedDistance, Se = we(pe, se, de, ve, G[2], G[3]), Ae = we(pe, se, de, ve, G[4], G[5]), Ge = Se * Ae > 0 ? 3 / 4 : 4 / 9, Je = Ge * Math.min(0, Se, Ae), it = Ge * Math.max(0, Se, Ae), gt = we(pe, se, de, ve, T[0], T[1]), Ne = we(pe, se, de, ve, T[2], T[3]), Fe = we(pe, se, de, ve, T[4], T[5]), st = we(pe, se, de, ve, T[6], T[7]), _t = a(gt, Ne, Fe, st), vt = _t[0], Rt = _t[1], Et, Ht;
          if (Se === 0 && Ae === 0 && gt === 0 && Ne === 0 && Fe === 0 && st === 0 || (Et = l(vt, Rt, Je, it)) == null || (Ht = l(
            vt.reverse(),
            Rt.reverse(),
            Je,
            it
          )) == null)
            return j;
          var jt = q + (H - q) * Et, Vt = q + (H - q) * Ht;
          if (Math.max(ae - ie, Vt - jt) < he) {
            var Mi = (jt + Vt) / 2, Li = (ie + ae) / 2;
            i(
              k,
              z,
              C ? Y : R,
              C ? Li : Mi,
              C ? R : Y,
              C ? Mi : Li
            );
          } else {
            T = De.getPart(T, Et, Ht);
            var Ai = ae - ie;
            if (Ht - Et > 0.8)
              if (Vt - jt > Ai) {
                var vi = De.subdivide(T, 0.5), Mi = (jt + Vt) / 2;
                j = r(
                  G,
                  vi[0],
                  Y,
                  R,
                  k,
                  z,
                  !C,
                  I,
                  j,
                  ie,
                  ae,
                  jt,
                  Mi
                ), j = r(
                  G,
                  vi[1],
                  Y,
                  R,
                  k,
                  z,
                  !C,
                  I,
                  j,
                  ie,
                  ae,
                  Mi,
                  Vt
                );
              } else {
                var vi = De.subdivide(G, 0.5), Li = (ie + ae) / 2;
                j = r(
                  vi[0],
                  T,
                  Y,
                  R,
                  k,
                  z,
                  !C,
                  I,
                  j,
                  ie,
                  Li,
                  jt,
                  Vt
                ), j = r(
                  vi[1],
                  T,
                  Y,
                  R,
                  k,
                  z,
                  !C,
                  I,
                  j,
                  Li,
                  ae,
                  jt,
                  Vt
                );
              }
            else
              Ai === 0 || Ai >= he ? j = r(
                G,
                T,
                Y,
                R,
                k,
                z,
                !C,
                I,
                j,
                ie,
                ae,
                jt,
                Vt
              ) : j = r(
                T,
                G,
                R,
                Y,
                k,
                z,
                C,
                I,
                j,
                jt,
                Vt,
                ie,
                ae
              );
          }
          return j;
        }
        function a(T, G, R, Y) {
          var k = [0, T], z = [1 / 3, G], C = [2 / 3, R], I = [1, Y], j = G - (2 * T + Y) / 3, q = R - (T + 2 * Y) / 3, H;
          if (j * q < 0)
            H = [[k, z, I], [k, C, I]];
          else {
            var ie = j / q;
            H = [
              ie >= 2 ? [k, z, I] : ie <= 0.5 ? [k, C, I] : [k, z, C, I],
              [k, I]
            ];
          }
          return (j || q) < 0 ? H.reverse() : H;
        }
        function l(T, G, R, Y) {
          return T[0][1] < R ? u(T, !0, R) : G[0][1] > Y ? u(G, !1, Y) : T[0][0];
        }
        function u(T, G, R) {
          for (var Y = T[0][0], k = T[0][1], z = 1, C = T.length; z < C; z++) {
            var I = T[z][0], j = T[z][1];
            if (G ? j >= R : j <= R)
              return j === R ? I : Y + (R - k) * (I - Y) / (j - k);
            Y = I, k = j;
          }
          return null;
        }
        function d(T, G, R, Y, k) {
          var z = P.isZero;
          if (z(Y) && z(k)) {
            var C = De.getTimeOf(T, new M(G, R));
            return C === null ? [] : [C];
          }
          for (var I = Math.atan2(-k, Y), j = Math.sin(I), q = Math.cos(I), H = [], ie = [], ae = 0; ae < 8; ae += 2) {
            var he = T[ae] - G, pe = T[ae + 1] - R;
            H.push(
              he * q - pe * j,
              he * j + pe * q
            );
          }
          return De.solveCubic(H, 1, 0, ie, 0, 1), ie;
        }
        function v(T, G, R, Y, k, z, C) {
          for (var I = G[0], j = G[1], q = G[6], H = G[7], ie = d(T, I, j, q - I, H - j), ae = 0, he = ie.length; ae < he; ae++) {
            var pe = ie[ae], se = De.getPoint(T, pe), de = De.getTimeOf(G, se);
            de !== null && i(
              k,
              z,
              C ? Y : R,
              C ? de : pe,
              C ? R : Y,
              C ? pe : de
            );
          }
        }
        function p(T, G, R, Y, k, z) {
          var C = le.intersect(
            T[0],
            T[1],
            T[6],
            T[7],
            G[0],
            G[1],
            G[6],
            G[7]
          );
          C && i(
            k,
            z,
            R,
            De.getTimeOf(T, C),
            Y,
            De.getTimeOf(G, C)
          );
        }
        function y(T, G, R, Y, k, z) {
          var C = 1e-12, I = Math.min, j = Math.max;
          if (j(T[0], T[2], T[4], T[6]) + C > I(G[0], G[2], G[4], G[6]) && I(T[0], T[2], T[4], T[6]) - C < j(G[0], G[2], G[4], G[6]) && j(T[1], T[3], T[5], T[7]) + C > I(G[1], G[3], G[5], G[7]) && I(T[1], T[3], T[5], T[7]) - C < j(G[1], G[3], G[5], G[7])) {
            var q = E(T, G);
            if (q)
              for (var H = 0; H < 2; H++) {
                var ie = q[H];
                i(
                  k,
                  z,
                  R,
                  ie[0],
                  Y,
                  ie[1],
                  !0
                );
              }
            else {
              var ae = De.isStraight(T), he = De.isStraight(G), pe = ae && he, se = ae && !he, de = k.length;
              if ((pe ? p : ae || he ? v : r)(
                se ? G : T,
                se ? T : G,
                se ? Y : R,
                se ? R : Y,
                k,
                z,
                se,
                0,
                0,
                0,
                1,
                0,
                1
              ), !pe || k.length === de)
                for (var H = 0; H < 4; H++) {
                  var ve = H >> 1, we = H & 1, Se = ve * 6, Ae = we * 6, Ge = new M(T[Se], T[Se + 1]), Je = new M(G[Ae], G[Ae + 1]);
                  Ge.isClose(Je, C) && i(
                    k,
                    z,
                    R,
                    ve,
                    Y,
                    we
                  );
                }
            }
          }
          return k;
        }
        function S(T, G, R, Y) {
          var k = De.classify(T);
          if (k.type === "loop") {
            var z = k.roots;
            i(
              R,
              Y,
              G,
              z[0],
              G,
              z[1]
            );
          }
          return R;
        }
        function L(T, G, R, Y, k, z) {
          var C = 1e-7, I = !G;
          I && (G = T);
          for (var j = T.length, q = G.length, H = new Array(j), ie = I ? H : new Array(q), ae = [], he = 0; he < j; he++)
            H[he] = T[he].getValues(Y);
          if (!I)
            for (var he = 0; he < q; he++)
              ie[he] = G[he].getValues(k);
          for (var pe = x.findCurveBoundsCollisions(
            H,
            ie,
            C
          ), se = 0; se < j; se++) {
            var de = T[se], ve = H[se];
            I && S(ve, de, ae, R);
            var we = pe[se];
            if (we)
              for (var Se = 0; Se < we.length; Se++) {
                if (z && ae.length)
                  return ae;
                var Ae = we[Se];
                if (!I || Ae > se) {
                  var Ge = G[Ae], Je = ie[Ae];
                  y(
                    ve,
                    Je,
                    de,
                    Ge,
                    ae,
                    R
                  );
                }
              }
          }
          return ae;
        }
        function E(T, G) {
          function R(st) {
            var _t = st[6] - st[0], vt = st[7] - st[1];
            return _t * _t + vt * vt;
          }
          var Y = Math.abs, k = le.getDistance, z = 1e-8, C = 1e-7, I = De.isStraight(T), j = De.isStraight(G), q = I && j, H = R(T) < R(G), ie = H ? G : T, ae = H ? T : G, he = ie[0], pe = ie[1], se = ie[6] - he, de = ie[7] - pe;
          if (k(he, pe, se, de, ae[0], ae[1], !0) < C && k(he, pe, se, de, ae[6], ae[7], !0) < C)
            !q && k(he, pe, se, de, ie[2], ie[3], !0) < C && k(he, pe, se, de, ie[4], ie[5], !0) < C && k(he, pe, se, de, ae[2], ae[3], !0) < C && k(he, pe, se, de, ae[4], ae[5], !0) < C && (I = j = q = !0);
          else if (q)
            return null;
          if (I ^ j)
            return null;
          for (var ve = [T, G], we = [], Se = 0; Se < 4 && we.length < 2; Se++) {
            var Ae = Se & 1, Ge = Ae ^ 1, Je = Se >> 1, it = De.getTimeOf(ve[Ae], new M(
              ve[Ge][Je ? 6 : 0],
              ve[Ge][Je ? 7 : 1]
            ));
            if (it != null) {
              var gt = Ae ? [Je, it] : [it, Je];
              (!we.length || Y(gt[0] - we[0][0]) > z && Y(gt[1] - we[0][1]) > z) && we.push(gt);
            }
            if (Se > 2 && !we.length)
              break;
          }
          if (we.length !== 2)
            we = null;
          else if (!q) {
            var Ne = De.getPart(T, we[0][0], we[1][0]), Fe = De.getPart(G, we[0][1], we[1][1]);
            (Y(Fe[2] - Ne[2]) > C || Y(Fe[3] - Ne[3]) > C || Y(Fe[4] - Ne[4]) > C || Y(Fe[5] - Ne[5]) > C) && (we = null);
          }
          return we;
        }
        function A(T, G) {
          var R = T[0], Y = T[1], k = T[2], z = T[3], C = T[4], I = T[5], j = T[6], q = T[7], H = G.normalize(), ie = H.x, ae = H.y, he = 3 * j - 9 * C + 9 * k - 3 * R, pe = 3 * q - 9 * I + 9 * z - 3 * Y, se = 6 * C - 12 * k + 6 * R, de = 6 * I - 12 * z + 6 * Y, ve = 3 * k - 3 * R, we = 3 * z - 3 * Y, Se = 2 * he * ae - 2 * pe * ie, Ae = [];
          if (Math.abs(Se) < P.CURVETIME_EPSILON) {
            var Ge = he * we - pe * ve, Se = he * de - pe * se;
            if (Se != 0) {
              var Je = -Ge / Se;
              Je >= 0 && Je <= 1 && Ae.push(Je);
            }
          } else {
            var it = (se * se - 4 * he * ve) * ae * ae + (-2 * se * de + 4 * pe * ve + 4 * he * we) * ie * ae + (de * de - 4 * pe * we) * ie * ie, gt = se * ae - de * ie;
            if (it >= 0 && Se != 0) {
              var Ne = Math.sqrt(it), Fe = -(gt + Ne) / Se, st = (-gt + Ne) / Se;
              Fe >= 0 && Fe <= 1 && Ae.push(Fe), st >= 0 && st <= 1 && Ae.push(st);
            }
          }
          return Ae;
        }
        return {
          getIntersections: function(T) {
            var G = this.getValues(), R = T && T !== this && T.getValues();
            return R ? y(G, R, this, T, []) : S(G, this, []);
          },
          statics: {
            getOverlaps: E,
            getIntersections: L,
            getCurveLineIntersections: d,
            getTimesWithTangent: A
          }
        };
      }()
    ), ft = o.extend(
      {
        _class: "CurveLocation",
        initialize: function(r, a, l, u, d) {
          if (a >= 0.99999999) {
            var v = r.getNext();
            v && (a = 0, r = v);
          }
          this._setCurve(r), this._time = a, this._point = l || r.getPointAtTime(a), this._overlap = u, this._distance = d, this._intersection = this._next = this._previous = null;
        },
        _setPath: function(i) {
          this._path = i, this._version = i ? i._version : 0;
        },
        _setCurve: function(i) {
          this._setPath(i._path), this._curve = i, this._segment = null, this._segment1 = i._segment1, this._segment2 = i._segment2;
        },
        _setSegment: function(i) {
          var r = i.getCurve();
          r ? this._setCurve(r) : (this._setPath(i._path), this._segment1 = i, this._segment2 = null), this._segment = i, this._time = i === this._segment1 ? 0 : 1, this._point = i._point.clone();
        },
        getSegment: function() {
          var i = this._segment;
          if (!i) {
            var r = this.getCurve(), a = this.getTime();
            a === 0 ? i = r._segment1 : a === 1 ? i = r._segment2 : a != null && (i = r.getPartLength(0, a) < r.getPartLength(a, 1) ? r._segment1 : r._segment2), this._segment = i;
          }
          return i;
        },
        getCurve: function() {
          var i = this._path, r = this;
          i && i._version !== this._version && (this._time = this._offset = this._curveOffset = this._curve = null);
          function a(l) {
            var u = l && l.getCurve();
            if (u && (r._time = u.getTimeOf(r._point)) != null)
              return r._setCurve(u), u;
          }
          return this._curve || a(this._segment) || a(this._segment1) || a(this._segment2.getPrevious());
        },
        getPath: function() {
          var i = this.getCurve();
          return i && i._path;
        },
        getIndex: function() {
          var i = this.getCurve();
          return i && i.getIndex();
        },
        getTime: function() {
          var i = this.getCurve(), r = this._time;
          return i && r == null ? this._time = i.getTimeOf(this._point) : r;
        },
        getParameter: "#getTime",
        getPoint: function() {
          return this._point;
        },
        getOffset: function() {
          var i = this._offset;
          if (i == null) {
            i = 0;
            var r = this.getPath(), a = this.getIndex();
            if (r && a != null)
              for (var l = r.getCurves(), u = 0; u < a; u++)
                i += l[u].getLength();
            this._offset = i += this.getCurveOffset();
          }
          return i;
        },
        getCurveOffset: function() {
          var i = this._curveOffset;
          if (i == null) {
            var r = this.getCurve(), a = this.getTime();
            this._curveOffset = i = a != null && r && r.getPartLength(0, a);
          }
          return i;
        },
        getIntersection: function() {
          return this._intersection;
        },
        getDistance: function() {
          return this._distance;
        },
        divide: function() {
          var i = this.getCurve(), r = i && i.divideAtTime(this.getTime());
          return r && this._setSegment(r._segment1), r;
        },
        split: function() {
          var i = this.getCurve(), r = i._path, a = i && i.splitAtTime(this.getTime());
          return a && this._setSegment(r.getLastSegment()), a;
        },
        equals: function(i, r) {
          var a = this === i;
          if (!a && i instanceof ft) {
            var l = this.getCurve(), u = i.getCurve(), d = l._path, v = u._path;
            if (d === v) {
              var p = Math.abs, y = 1e-7, S = p(this.getOffset() - i.getOffset()), L = !r && this._intersection, E = !r && i._intersection;
              a = (S < y || d && p(d.getLength() - S) < y) && (!L && !E || L && E && L.equals(E, !0));
            }
          }
          return a;
        },
        toString: function() {
          var i = [], r = this.getPoint(), a = B.instance;
          r && i.push("point: " + r);
          var l = this.getIndex();
          l != null && i.push("index: " + l);
          var u = this.getTime();
          return u != null && i.push("time: " + a.number(u)), this._distance != null && i.push("distance: " + a.number(this._distance)), "{ " + i.join(", ") + " }";
        },
        isTouching: function() {
          var i = this._intersection;
          if (i && this.getTangent().isCollinear(i.getTangent())) {
            var r = this.getCurve(), a = i.getCurve();
            return !(r.isStraight() && a.isStraight() && r.getLine().intersect(a.getLine()));
          }
          return !1;
        },
        isCrossing: function() {
          var i = this._intersection;
          if (!i)
            return !1;
          var r = this.getTime(), a = i.getTime(), l = 1e-8, u = 1 - l, d = r >= l && r <= u, v = a >= l && a <= u;
          if (d && v)
            return !this.isTouching();
          var p = this.getCurve(), y = p && r < l ? p.getPrevious() : p, S = i.getCurve(), L = S && a < l ? S.getPrevious() : S;
          if (r > u && (p = p.getNext()), a > u && (S = S.getNext()), !y || !p || !L || !S)
            return !1;
          var E = [];
          function A(ie, ae) {
            var he = ie.getValues(), pe = De.classify(he).roots || De.getPeaks(he), se = pe.length, de = De.getLength(
              he,
              ae && se ? pe[se - 1] : 0,
              !ae && se ? pe[0] : 1
            );
            E.push(se ? de : de / 32);
          }
          function T(ie, ae, he) {
            return ae < he ? ie > ae && ie < he : ie > ae || ie < he;
          }
          d || (A(y, !0), A(p, !1)), v || (A(L, !0), A(S, !1));
          var G = this.getPoint(), R = Math.min.apply(Math, E), Y = d ? p.getTangentAtTime(r) : p.getPointAt(R).subtract(G), k = d ? Y.negate() : y.getPointAt(-R).subtract(G), z = v ? S.getTangentAtTime(a) : S.getPointAt(R).subtract(G), C = v ? z.negate() : L.getPointAt(-R).subtract(G), I = k.getAngle(), j = Y.getAngle(), q = C.getAngle(), H = z.getAngle();
          return !!(d ? T(I, q, H) ^ T(j, q, H) && T(I, H, q) ^ T(j, H, q) : T(q, I, j) ^ T(H, I, j) && T(q, j, I) ^ T(H, j, I));
        },
        hasOverlap: function() {
          return !!this._overlap;
        }
      },
      o.each(De._evaluateMethods, function(i) {
        var r = i + "At";
        this[i] = function() {
          var a = this.getCurve(), l = this.getTime();
          return l != null && a && a[r](l, !0);
        };
      }, {
        preserve: !0
      }),
      new function() {
        function i(r, a, l) {
          var u = r.length, d = 0, v = u - 1;
          function p(G, R) {
            for (var Y = G + R; Y >= -1 && Y <= u; Y += R) {
              var k = r[(Y % u + u) % u];
              if (!a.getPoint().isClose(
                k.getPoint(),
                1e-7
              ))
                break;
              if (a.equals(k))
                return k;
            }
            return null;
          }
          for (; d <= v; ) {
            var y = d + v >>> 1, S = r[y], L;
            if (l && (L = a.equals(S) ? S : p(y, -1) || p(y, 1)))
              return a._overlap && (L._overlap = L._intersection._overlap = !0), L;
            var E = a.getPath(), A = S.getPath(), T = E !== A ? E._id - A._id : a.getIndex() + a.getTime() - (S.getIndex() + S.getTime());
            T < 0 ? v = y - 1 : d = y + 1;
          }
          return r.splice(d, 0, a), a;
        }
        return { statics: {
          insert: i,
          expand: function(r) {
            for (var a = r.slice(), l = r.length - 1; l >= 0; l--)
              i(a, r[l]._intersection, !1);
            return a;
          }
        } };
      }()
    ), Yt = X.extend({
      _class: "PathItem",
      _selectBounds: !1,
      _canScaleStroke: !0,
      beans: !0,
      initialize: function() {
      },
      statics: {
        create: function(i) {
          var r, a, l;
          if (o.isPlainObject(i) ? (a = i.segments, r = i.pathData) : Array.isArray(i) ? a = i : typeof i == "string" && (r = i), a) {
            var u = a[0];
            l = u && Array.isArray(u[0]);
          } else
            r && (l = (r.match(/m/gi) || []).length > 1 || /z\s*\S+/i.test(r));
          var d = l ? It : We;
          return new d(i);
        }
      },
      _asPathItem: function() {
        return this;
      },
      isClockwise: function() {
        return this.getArea() >= 0;
      },
      setClockwise: function(i) {
        this.isClockwise() != (i = !!i) && this.reverse();
      },
      setPathData: function(i) {
        var r = i && i.match(/[mlhvcsqtaz][^mlhvcsqtaz]*/ig), a, l = !1, u, d, v = new M(), p = new M();
        function y(C, I) {
          var j = +a[C];
          return l && (j += v[I]), j;
        }
        function S(C) {
          return new M(
            y(C, "x"),
            y(C + 1, "y")
          );
        }
        this.clear();
        for (var L = 0, E = r && r.length; L < E; L++) {
          var A = r[L], T = A[0], G = T.toLowerCase();
          a = A.match(/[+-]?(?:\d*\.\d+|\d+\.?)(?:[eE][+-]?\d+)?/g);
          var R = a && a.length;
          switch (l = T === G, u === "z" && !/[mz]/.test(G) && this.moveTo(v), G) {
            case "m":
            case "l":
              for (var Y = G === "m", k = 0; k < R; k += 2)
                this[Y ? "moveTo" : "lineTo"](v = S(k)), Y && (p = v, Y = !1);
              d = v;
              break;
            case "h":
            case "v":
              var z = G === "h" ? "x" : "y";
              v = v.clone();
              for (var k = 0; k < R; k++)
                v[z] = y(k, z), this.lineTo(v);
              d = v;
              break;
            case "c":
              for (var k = 0; k < R; k += 6)
                this.cubicCurveTo(
                  S(k),
                  d = S(k + 2),
                  v = S(k + 4)
                );
              break;
            case "s":
              for (var k = 0; k < R; k += 4)
                this.cubicCurveTo(
                  /[cs]/.test(u) ? v.multiply(2).subtract(d) : v,
                  d = S(k),
                  v = S(k + 2)
                ), u = G;
              break;
            case "q":
              for (var k = 0; k < R; k += 4)
                this.quadraticCurveTo(
                  d = S(k),
                  v = S(k + 2)
                );
              break;
            case "t":
              for (var k = 0; k < R; k += 2)
                this.quadraticCurveTo(
                  d = /[qt]/.test(u) ? v.multiply(2).subtract(d) : v,
                  v = S(k)
                ), u = G;
              break;
            case "a":
              for (var k = 0; k < R; k += 7)
                this.arcTo(
                  v = S(k + 5),
                  new F(+a[k], +a[k + 1]),
                  +a[k + 2],
                  +a[k + 4],
                  +a[k + 3]
                );
              break;
            case "z":
              this.closePath(1e-12), v = p;
              break;
          }
          u = G;
        }
      },
      _canComposite: function() {
        return !(this.hasFill() && this.hasStroke());
      },
      _contains: function(i) {
        var r = i.isInside(
          this.getBounds({ internal: !0, handle: !0 })
        ) ? this._getWinding(i) : {};
        return r.onPath || !!(this.getFillRule() === "evenodd" ? r.windingL & 1 || r.windingR & 1 : r.winding);
      },
      getIntersections: function(i, r, a, l) {
        var u = this === i || !i, d = this._matrix._orNullIfIdentity(), v = u ? d : (a || i._matrix)._orNullIfIdentity();
        return u || this.getBounds(d).intersects(
          i.getBounds(v),
          1e-12
        ) ? De.getIntersections(
          this.getCurves(),
          !u && i.getCurves(),
          r,
          d,
          v,
          l
        ) : [];
      },
      getCrossings: function(i) {
        return this.getIntersections(i, function(r) {
          return r.isCrossing();
        });
      },
      getNearestLocation: function() {
        for (var i = M.read(arguments), r = this.getCurves(), a = 1 / 0, l = null, u = 0, d = r.length; u < d; u++) {
          var v = r[u].getNearestLocation(i);
          v._distance < a && (a = v._distance, l = v);
        }
        return l;
      },
      getNearestPoint: function() {
        var i = this.getNearestLocation.apply(this, arguments);
        return i && i.getPoint();
      },
      interpolate: function(i, r, a) {
        var l = !this._children, u = l ? "_segments" : "_children", d = i[u], v = r[u], p = this[u];
        if (!d || !v || d.length !== v.length)
          throw new Error("Invalid operands in interpolate() call: " + i + ", " + r);
        var y = p.length, S = v.length;
        if (y < S)
          for (var L = l ? ce : We, E = y; E < S; E++)
            this.add(new L());
        else
          y > S && this[l ? "removeSegments" : "removeChildren"](S, y);
        for (var E = 0; E < S; E++)
          p[E].interpolate(d[E], v[E], a);
        l && (this.setClosed(i._closed), this._changed(9));
      },
      compare: function(i) {
        var r = !1;
        if (i) {
          var a = this._children || [this], l = i._children ? i._children.slice() : [i], u = a.length, d = l.length, v = [], p = 0;
          r = !0;
          for (var y = x.findItemBoundsCollisions(a, l, P.GEOMETRIC_EPSILON), S = u - 1; S >= 0 && r; S--) {
            var L = a[S];
            r = !1;
            var E = y[S];
            if (E)
              for (var A = E.length - 1; A >= 0 && !r; A--)
                L.compare(l[E[A]]) && (v[E[A]] || (v[E[A]] = !0, p++), r = !0);
          }
          r = r && p === d;
        }
        return r;
      }
    }), We = Yt.extend(
      {
        _class: "Path",
        _serializeFields: {
          segments: [],
          closed: !1
        },
        initialize: function(r) {
          this._closed = !1, this._segments = [], this._version = 0;
          var a = arguments, l = Array.isArray(r) ? typeof r[0] == "object" ? r : a : r && r.size === t && (r.x !== t || r.point !== t) ? a : null;
          l && l.length > 0 ? this.setSegments(l) : (this._curves = t, this._segmentSelection = 0, !l && typeof r == "string" && (this.setPathData(r), r = null)), this._initialize(!l && r);
        },
        _equals: function(i) {
          return this._closed === i._closed && o.equals(this._segments, i._segments);
        },
        copyContent: function(i) {
          this.setSegments(i._segments), this._closed = i._closed;
        },
        _changed: function i(r) {
          if (i.base.call(this, r), r & 8) {
            if (this._length = this._area = t, r & 32)
              this._version++;
            else if (this._curves)
              for (var a = 0, l = this._curves.length; a < l; a++)
                this._curves[a]._changed();
          } else
            r & 64 && (this._bounds = t);
        },
        getStyle: function() {
          var i = this._parent;
          return (i instanceof It ? i : this)._style;
        },
        getSegments: function() {
          return this._segments;
        },
        setSegments: function(i) {
          var r = this.isFullySelected(), a = i && i.length;
          if (this._segments.length = 0, this._segmentSelection = 0, this._curves = t, a) {
            var l = i[a - 1];
            typeof l == "boolean" && (this.setClosed(l), a--), this._add(ce.readList(i, 0, {}, a));
          }
          r && this.setFullySelected(!0);
        },
        getFirstSegment: function() {
          return this._segments[0];
        },
        getLastSegment: function() {
          return this._segments[this._segments.length - 1];
        },
        getCurves: function() {
          var i = this._curves, r = this._segments;
          if (!i) {
            var a = this._countCurves();
            i = this._curves = new Array(a);
            for (var l = 0; l < a; l++)
              i[l] = new De(
                this,
                r[l],
                r[l + 1] || r[0]
              );
          }
          return i;
        },
        getFirstCurve: function() {
          return this.getCurves()[0];
        },
        getLastCurve: function() {
          var i = this.getCurves();
          return i[i.length - 1];
        },
        isClosed: function() {
          return this._closed;
        },
        setClosed: function(i) {
          if (this._closed != (i = !!i)) {
            if (this._closed = i, this._curves) {
              var r = this._curves.length = this._countCurves();
              i && (this._curves[r - 1] = new De(
                this,
                this._segments[r - 1],
                this._segments[0]
              ));
            }
            this._changed(41);
          }
        }
      },
      {
        beans: !0,
        getPathData: function(i, r) {
          var a = this._segments, l = a.length, u = new B(r), d = new Array(6), v = !0, p, y, S, L, E, A, T, G, R = [];
          function Y(z, C) {
            if (z._transformCoordinates(i, d), p = d[0], y = d[1], v)
              R.push("M" + u.pair(p, y)), v = !1;
            else if (E = d[2], A = d[3], E === p && A === y && T === S && G === L) {
              if (!C) {
                var I = p - S, j = y - L;
                R.push(
                  I === 0 ? "v" + u.number(j) : j === 0 ? "h" + u.number(I) : "l" + u.pair(I, j)
                );
              }
            } else
              R.push("c" + u.pair(T - S, G - L) + " " + u.pair(E - S, A - L) + " " + u.pair(p - S, y - L));
            S = p, L = y, T = d[4], G = d[5];
          }
          if (!l)
            return "";
          for (var k = 0; k < l; k++)
            Y(a[k]);
          return this._closed && l > 0 && (Y(a[0], !0), R.push("z")), R.join("");
        },
        isEmpty: function() {
          return !this._segments.length;
        },
        _transformContent: function(i) {
          for (var r = this._segments, a = new Array(6), l = 0, u = r.length; l < u; l++)
            r[l]._transformCoordinates(i, a, !0);
          return !0;
        },
        _add: function(i, v) {
          for (var a = this._segments, l = this._curves, u = i.length, d = v == null, v = d ? a.length : v, p = 0; p < u; p++) {
            var y = i[p];
            y._path && (y = i[p] = y.clone()), y._path = this, y._index = v + p, y._selection && this._updateSelection(y, 0, y._selection);
          }
          if (d)
            o.push(a, i);
          else {
            a.splice.apply(a, [v, 0].concat(i));
            for (var p = v + u, S = a.length; p < S; p++)
              a[p]._index = p;
          }
          if (l) {
            var L = this._countCurves(), E = v > 0 && v + u - 1 === L ? v - 1 : v, A = E, T = Math.min(E + u, L);
            i._curves && (l.splice.apply(l, [E, 0].concat(i._curves)), A += i._curves.length);
            for (var p = A; p < T; p++)
              l.splice(p, 0, new De(this, null, null));
            this._adjustCurves(E, T);
          }
          return this._changed(41), i;
        },
        _adjustCurves: function(i, r) {
          for (var a = this._segments, l = this._curves, u, d = i; d < r; d++)
            u = l[d], u._path = this, u._segment1 = a[d], u._segment2 = a[d + 1] || a[0], u._changed();
          (u = l[this._closed && !i ? a.length - 1 : i - 1]) && (u._segment2 = a[i] || a[0], u._changed()), (u = l[r]) && (u._segment1 = a[r], u._changed());
        },
        _countCurves: function() {
          var i = this._segments.length;
          return !this._closed && i > 0 ? i - 1 : i;
        },
        add: function(i) {
          var r = arguments;
          return r.length > 1 && typeof i != "number" ? this._add(ce.readList(r)) : this._add([ce.read(r)])[0];
        },
        insert: function(i, r) {
          var a = arguments;
          return a.length > 2 && typeof r != "number" ? this._add(ce.readList(a, 1), i) : this._add([ce.read(a, 1)], i)[0];
        },
        addSegment: function() {
          return this._add([ce.read(arguments)])[0];
        },
        insertSegment: function(i) {
          return this._add([ce.read(arguments, 1)], i)[0];
        },
        addSegments: function(i) {
          return this._add(ce.readList(i));
        },
        insertSegments: function(i, r) {
          return this._add(ce.readList(r), i);
        },
        removeSegment: function(i) {
          return this.removeSegments(i, i + 1)[0] || null;
        },
        removeSegments: function(i, r, a) {
          i = i || 0, r = o.pick(r, this._segments.length);
          var l = this._segments, u = this._curves, d = l.length, v = l.splice(i, r - i), p = v.length;
          if (!p)
            return v;
          for (var y = 0; y < p; y++) {
            var S = v[y];
            S._selection && this._updateSelection(S, S._selection, 0), S._index = S._path = null;
          }
          for (var y = i, L = l.length; y < L; y++)
            l[y]._index = y;
          if (u) {
            for (var E = i > 0 && r === d + (this._closed ? 1 : 0) ? i - 1 : i, u = u.splice(E, p), y = u.length - 1; y >= 0; y--)
              u[y]._path = null;
            a && (v._curves = u.slice(1)), this._adjustCurves(E, E);
          }
          return this._changed(41), v;
        },
        clear: "#removeSegments",
        hasHandles: function() {
          for (var i = this._segments, r = 0, a = i.length; r < a; r++)
            if (i[r].hasHandles())
              return !0;
          return !1;
        },
        clearHandles: function() {
          for (var i = this._segments, r = 0, a = i.length; r < a; r++)
            i[r].clearHandles();
        },
        getLength: function() {
          if (this._length == null) {
            for (var i = this.getCurves(), r = 0, a = 0, l = i.length; a < l; a++)
              r += i[a].getLength();
            this._length = r;
          }
          return this._length;
        },
        getArea: function() {
          var i = this._area;
          if (i == null) {
            var r = this._segments, a = this._closed;
            i = 0;
            for (var l = 0, u = r.length; l < u; l++) {
              var d = l + 1 === u;
              i += De.getArea(De.getValues(
                r[l],
                r[d ? 0 : l + 1],
                null,
                d && !a
              ));
            }
            this._area = i;
          }
          return i;
        },
        isFullySelected: function() {
          var i = this._segments.length;
          return this.isSelected() && i > 0 && this._segmentSelection === i * 7;
        },
        setFullySelected: function(i) {
          i && this._selectSegments(!0), this.setSelected(i);
        },
        setSelection: function i(r) {
          r & 1 || this._selectSegments(!1), i.base.call(this, r);
        },
        _selectSegments: function(i) {
          var r = this._segments, a = r.length, l = i ? 7 : 0;
          this._segmentSelection = l * a;
          for (var u = 0; u < a; u++)
            r[u]._selection = l;
        },
        _updateSelection: function(i, r, a) {
          i._selection = a;
          var l = this._segmentSelection += a - r;
          l > 0 && this.setSelected(!0);
        },
        divideAt: function(i) {
          var r = this.getLocationAt(i), a;
          return r && (a = r.getCurve().divideAt(r.getCurveOffset())) ? a._segment1 : null;
        },
        splitAt: function(i) {
          var r = this.getLocationAt(i), a = r && r.index, l = r && r.time, u = 1e-8, d = 1 - u;
          l > d && (a++, l = 0);
          var v = this.getCurves();
          if (a >= 0 && a < v.length) {
            l >= u && v[a++].divideAtTime(l);
            var p = this.removeSegments(a, this._segments.length, !0), y;
            return this._closed ? (this.setClosed(!1), y = this) : (y = new We(X.NO_INSERT), y.insertAbove(this), y.copyAttributes(this)), y._add(p, 0), this.addSegment(p[0]), y;
          }
          return null;
        },
        split: function(i, r) {
          var a, l = r === t ? i : (a = this.getCurves()[i]) && a.getLocationAtTime(r);
          return l != null ? this.splitAt(l) : null;
        },
        join: function(i, r) {
          var a = r || 0;
          if (i && i !== this) {
            var l = i._segments, u = this.getLastSegment(), d = i.getLastSegment();
            if (!d)
              return this;
            u && u._point.isClose(d._point, a) && i.reverse();
            var v = i.getFirstSegment();
            if (u && u._point.isClose(v._point, a))
              u.setHandleOut(v._handleOut), this._add(l.slice(1));
            else {
              var p = this.getFirstSegment();
              p && p._point.isClose(v._point, a) && i.reverse(), d = i.getLastSegment(), p && p._point.isClose(d._point, a) ? (p.setHandleIn(d._handleIn), this._add(l.slice(0, l.length - 1), 0)) : this._add(l.slice());
            }
            i._closed && this._add([l[0]]), i.remove();
          }
          var y = this.getFirstSegment(), S = this.getLastSegment();
          return y !== S && y._point.isClose(S._point, a) && (y.setHandleIn(S._handleIn), S.remove(), this.setClosed(!0)), this;
        },
        reduce: function(i) {
          for (var r = this.getCurves(), a = i && i.simplify, l = a ? 1e-7 : 0, u = r.length - 1; u >= 0; u--) {
            var d = r[u];
            !d.hasHandles() && (!d.hasLength(l) || a && d.isCollinear(d.getNext())) && d.remove();
          }
          return this;
        },
        reverse: function() {
          this._segments.reverse();
          for (var i = 0, r = this._segments.length; i < r; i++) {
            var a = this._segments[i], l = a._handleIn;
            a._handleIn = a._handleOut, a._handleOut = l, a._index = i;
          }
          this._curves = null, this._changed(9);
        },
        flatten: function(i) {
          for (var r = new rt(this, i || 0.25, 256, !0), a = r.parts, l = a.length, u = [], d = 0; d < l; d++)
            u.push(new ce(a[d].curve.slice(0, 2)));
          !this._closed && l > 0 && u.push(new ce(a[l - 1].curve.slice(6))), this.setSegments(u);
        },
        simplify: function(i) {
          var r = new tt(this).fit(i || 2.5);
          return r && this.setSegments(r), !!r;
        },
        smooth: function(i) {
          var r = this, a = i || {}, l = a.type || "asymmetric", u = this._segments, d = u.length, v = this._closed;
          function p(vt, Rt) {
            var Et = vt && vt.index;
            if (Et != null) {
              var Ht = vt.path;
              if (Ht && Ht !== r)
                throw new Error(vt._class + " " + Et + " of " + Ht + " is not part of " + r);
              Rt && vt instanceof De && Et++;
            } else
              Et = typeof vt == "number" ? vt : Rt;
            return Math.min(Et < 0 && v ? Et % d : Et < 0 ? Et + d : Et, d - 1);
          }
          var y = v && a.from === t && a.to === t, S = p(a.from, 0), L = p(a.to, d - 1);
          if (S > L)
            if (v)
              S -= d;
            else {
              var E = S;
              S = L, L = E;
            }
          if (/^(?:asymmetric|continuous)$/.test(l)) {
            var A = l === "asymmetric", T = Math.min, G = L - S + 1, R = G - 1, Y = y ? T(G, 4) : 1, k = Y, z = Y, C = [];
            if (v || (k = T(1, S), z = T(1, d - L - 1)), R += k + z, R <= 1)
              return;
            for (var I = 0, j = S - k; I <= R; I++, j++)
              C[I] = u[(j < 0 ? j + d : j) % d]._point;
            for (var q = C[0]._x + 2 * C[1]._x, H = C[0]._y + 2 * C[1]._y, ie = 2, ae = R - 1, he = [q], pe = [H], se = [ie], de = [], ve = [], I = 1; I < R; I++) {
              var we = I < ae, Se = we || A ? 1 : 2, Ae = we ? 4 : A ? 2 : 7, Ge = we ? 4 : A ? 3 : 8, Je = we ? 2 : A ? 0 : 1, it = Se / ie;
              ie = se[I] = Ae - it, q = he[I] = Ge * C[I]._x + Je * C[I + 1]._x - it * q, H = pe[I] = Ge * C[I]._y + Je * C[I + 1]._y - it * H;
            }
            de[ae] = he[ae] / se[ae], ve[ae] = pe[ae] / se[ae];
            for (var I = R - 2; I >= 0; I--)
              de[I] = (he[I] - de[I + 1]) / se[I], ve[I] = (pe[I] - ve[I + 1]) / se[I];
            de[R] = (3 * C[R]._x - de[ae]) / 2, ve[R] = (3 * C[R]._y - ve[ae]) / 2;
            for (var I = k, gt = R - z, j = S; I <= gt; I++, j++) {
              var Ne = u[j < 0 ? j + d : j], Fe = Ne._point, st = de[I] - Fe._x, _t = ve[I] - Fe._y;
              (y || I < gt) && Ne.setHandleOut(st, _t), (y || I > k) && Ne.setHandleIn(-st, -_t);
            }
          } else
            for (var I = S; I <= L; I++)
              u[I < 0 ? I + d : I].smooth(
                a,
                !y && I === S,
                !y && I === L
              );
        },
        toShape: function(i) {
          if (!this._closed)
            return null;
          var r = this._segments, a, l, u, d;
          function v(A, T) {
            var G = r[A], R = G.getNext(), Y = r[T], k = Y.getNext();
            return G._handleOut.isZero() && R._handleIn.isZero() && Y._handleOut.isZero() && k._handleIn.isZero() && R._point.subtract(G._point).isCollinear(
              k._point.subtract(Y._point)
            );
          }
          function p(A) {
            var T = r[A], G = T.getPrevious(), R = T.getNext();
            return G._handleOut.isZero() && T._handleIn.isZero() && T._handleOut.isZero() && R._handleIn.isZero() && T._point.subtract(G._point).isOrthogonal(
              R._point.subtract(T._point)
            );
          }
          function y(A) {
            var T = r[A], G = T.getNext(), R = T._handleOut, Y = G._handleIn, k = 0.5522847498307936;
            if (R.isOrthogonal(Y)) {
              var z = T._point, C = G._point, I = new le(z, R, !0).intersect(
                new le(C, Y, !0),
                !0
              );
              return I && P.isZero(R.getLength() / I.subtract(z).getLength() - k) && P.isZero(Y.getLength() / I.subtract(C).getLength() - k);
            }
            return !1;
          }
          function S(A, T) {
            return r[A]._point.getDistance(r[T]._point);
          }
          if (!this.hasHandles() && r.length === 4 && v(0, 2) && v(1, 3) && p(1) ? (a = ke.Rectangle, l = new F(S(0, 3), S(0, 1)), d = r[1]._point.add(r[2]._point).divide(2)) : r.length === 8 && y(0) && y(2) && y(4) && y(6) && v(1, 5) && v(3, 7) ? (a = ke.Rectangle, l = new F(S(1, 6), S(0, 3)), u = l.subtract(new F(
            S(0, 7),
            S(1, 2)
          )).divide(2), d = r[3]._point.add(r[4]._point).divide(2)) : r.length === 4 && y(0) && y(1) && y(2) && y(3) && (P.isZero(S(0, 2) - S(1, 3)) ? (a = ke.Circle, u = S(0, 2) / 2) : (a = ke.Ellipse, u = new F(S(2, 0) / 2, S(3, 1) / 2)), d = r[1]._point), a) {
            var L = this.getPosition(!0), E = new a({
              center: L,
              size: l,
              radius: u,
              insert: !1
            });
            return E.copyAttributes(this, !0), E._matrix.prepend(this._matrix), E.rotate(d.subtract(L).getAngle() + 90), (i === t || i) && E.insertAbove(this), E;
          }
          return null;
        },
        toPath: "#clone",
        compare: function i(r) {
          if (!r || r instanceof It)
            return i.base.call(this, r);
          var a = this.getCurves(), l = r.getCurves(), u = a.length, d = l.length;
          if (!u || !d)
            return u == d;
          for (var v = a[0].getValues(), p = [], y = 0, S, L = 0, E, A = 0; A < d; A++) {
            var Y = l[A].getValues();
            p.push(Y);
            var T = De.getOverlaps(v, Y);
            if (T) {
              S = !A && T[0][0] > 0 ? d - 1 : A, E = T[0][1];
              break;
            }
          }
          for (var G = Math.abs, R = 1e-8, Y = p[S], k; v && Y; ) {
            var T = De.getOverlaps(v, Y);
            if (T) {
              var z = T[0][0];
              if (G(z - L) < R) {
                L = T[1][0], L === 1 && (v = ++y < u ? a[y].getValues() : null, L = 0);
                var C = T[0][1];
                if (G(C - E) < R) {
                  if (k || (k = [S, C]), E = T[1][1], E === 1 && (++S >= d && (S = 0), Y = p[S] || l[S].getValues(), E = 0), !v)
                    return k[0] === S && k[1] === E;
                  continue;
                }
              }
            }
            break;
          }
          return !1;
        },
        _hitTestSelf: function(i, r, a, l) {
          var u = this, d = this.getStyle(), v = this._segments, p = v.length, y = this._closed, S = r._tolerancePadding, L = S, E, A, T, G, R, Y, k = r.stroke && d.hasStroke(), z = r.fill && d.hasFill(), C = r.curves, I = k ? d.getStrokeWidth() / 2 : z && r.tolerance > 0 || C ? 0 : null;
          I !== null && (I > 0 ? (E = d.getStrokeJoin(), A = d.getStrokeCap(), T = d.getMiterLimit(), L = L.add(
            We._getStrokePadding(I, l)
          )) : E = A = "round");
          function j(de, ve) {
            return i.subtract(de).divide(ve).length <= 1;
          }
          function q(de, ve, we) {
            if (!r.selected || ve.isSelected()) {
              var Se = de._point;
              if (ve !== Se && (ve = ve.add(Se)), j(ve, L))
                return new $e(we, u, {
                  segment: de,
                  point: ve
                });
            }
          }
          function H(de, ve) {
            return (ve || r.segments) && q(de, de._point, "segment") || !ve && r.handles && (q(de, de._handleIn, "handle-in") || q(de, de._handleOut, "handle-out"));
          }
          function ie(de) {
            G.add(de);
          }
          function ae(de) {
            var ve = y || de._index > 0 && de._index < p - 1;
            if ((ve ? E : A) === "round")
              return j(de._point, L);
            if (G = new We({ internal: !0, closed: !0 }), ve ? de.isSmooth() || We._addBevelJoin(
              de,
              E,
              I,
              T,
              null,
              l,
              ie,
              !0
            ) : A === "square" && We._addSquareCap(
              de,
              A,
              I,
              null,
              l,
              ie,
              !0
            ), !G.isEmpty()) {
              var we;
              return G.contains(i) || (we = G.getNearestLocation(i)) && j(we.getPoint(), S);
            }
          }
          if (r.ends && !r.segments && !y) {
            if (Y = H(v[0], !0) || H(v[p - 1], !0))
              return Y;
          } else if (r.segments || r.handles) {
            for (var he = 0; he < p; he++)
              if (Y = H(v[he]))
                return Y;
          }
          if (I !== null) {
            if (R = this.getNearestLocation(i), R) {
              var pe = R.getTime();
              pe === 0 || pe === 1 && p > 1 ? ae(R.getSegment()) || (R = null) : j(R.getPoint(), L) || (R = null);
            }
            if (!R && E === "miter" && p > 1)
              for (var he = 0; he < p; he++) {
                var se = v[he];
                if (i.getDistance(se._point) <= T * I && ae(se)) {
                  R = se.getLocation();
                  break;
                }
              }
          }
          return !R && z && this._contains(i) || R && !k && !C ? new $e("fill", this) : R ? new $e(k ? "stroke" : "curve", this, {
            location: R,
            point: R.getPoint()
          }) : null;
        }
      },
      o.each(
        De._evaluateMethods,
        function(i) {
          this[i + "At"] = function(r) {
            var a = this.getLocationAt(r);
            return a && a[i]();
          };
        },
        {
          beans: !1,
          getLocationOf: function() {
            for (var i = M.read(arguments), r = this.getCurves(), a = 0, l = r.length; a < l; a++) {
              var u = r[a].getLocationOf(i);
              if (u)
                return u;
            }
            return null;
          },
          getOffsetOf: function() {
            var i = this.getLocationOf.apply(this, arguments);
            return i ? i.getOffset() : null;
          },
          getLocationAt: function(i) {
            if (typeof i == "number") {
              for (var r = this.getCurves(), a = 0, l = 0, u = r.length; l < u; l++) {
                var d = a, v = r[l];
                if (a += v.getLength(), a > i)
                  return v.getLocationAt(i - d);
              }
              if (r.length > 0 && i <= this.getLength())
                return new ft(r[r.length - 1], 1);
            } else if (i && i.getPath && i.getPath() === this)
              return i;
            return null;
          },
          getOffsetsWithTangent: function() {
            var i = M.read(arguments);
            if (i.isZero())
              return [];
            for (var r = [], a = 0, l = this.getCurves(), u = 0, d = l.length; u < d; u++) {
              for (var v = l[u], p = v.getTimesWithTangent(i), y = 0, S = p.length; y < S; y++) {
                var L = a + v.getOffsetAtTime(p[y]);
                r.indexOf(L) < 0 && r.push(L);
              }
              a += v.length;
            }
            return r;
          }
        }
      ),
      new function() {
        function i(a, l, u, d) {
          if (d <= 0)
            return;
          var v = d / 2, p = d - 2, y = v - 1, S = new Array(6), L, E;
          function A(z) {
            var C = S[z], I = S[z + 1];
            (L != C || E != I) && (a.beginPath(), a.moveTo(L, E), a.lineTo(C, I), a.stroke(), a.beginPath(), a.arc(C, I, v, 0, Math.PI * 2, !0), a.fill());
          }
          for (var T = 0, G = l.length; T < G; T++) {
            var R = l[T], Y = R._selection;
            if (R._transformCoordinates(u, S), L = S[0], E = S[1], Y & 2 && A(2), Y & 4 && A(4), a.fillRect(L - v, E - v, d, d), p > 0 && !(Y & 1)) {
              var k = a.fillStyle;
              a.fillStyle = "#ffffff", a.fillRect(L - y, E - y, p, p), a.fillStyle = k;
            }
          }
        }
        function r(a, l, u) {
          var d = l._segments, v = d.length, p = new Array(6), y = !0, S, L, E, A, T, G, R, Y;
          function k(C) {
            if (u)
              C._transformCoordinates(u, p), S = p[0], L = p[1];
            else {
              var I = C._point;
              S = I._x, L = I._y;
            }
            if (y)
              a.moveTo(S, L), y = !1;
            else {
              if (u)
                T = p[2], G = p[3];
              else {
                var j = C._handleIn;
                T = S + j._x, G = L + j._y;
              }
              T === S && G === L && R === E && Y === A ? a.lineTo(S, L) : a.bezierCurveTo(R, Y, T, G, S, L);
            }
            if (E = S, A = L, u)
              R = p[4], Y = p[5];
            else {
              var j = C._handleOut;
              R = E + j._x, Y = A + j._y;
            }
          }
          for (var z = 0; z < v; z++)
            k(d[z]);
          l._closed && v > 0 && k(d[0]);
        }
        return {
          _draw: function(a, l, u, d) {
            var v = l.dontStart, p = l.dontFinish || l.clip, y = this.getStyle(), S = y.hasFill(), L = y.hasStroke(), E = y.getDashArray(), A = !He.support.nativeDash && L && E && E.length;
            v || a.beginPath(), (S || L && !A || p) && (r(a, this, d), this._closed && a.closePath());
            function T(C) {
              return E[(C % A + A) % A];
            }
            if (!p && (S || L) && (this._setStyles(a, l, u), S && (a.fill(y.getFillRule()), a.shadowColor = "rgba(0,0,0,0)"), L)) {
              if (A) {
                v || a.beginPath();
                for (var G = new rt(
                  this,
                  0.25,
                  32,
                  !1,
                  d
                ), R = G.length, Y = -y.getDashOffset(), k, z = 0; Y > 0; )
                  Y -= T(z--) + T(z--);
                for (; Y < R; )
                  k = Y + T(z++), (Y > 0 || k > 0) && G.drawPart(
                    a,
                    Math.max(Y, 0),
                    Math.max(k, 0)
                  ), Y = k + T(z++);
              }
              a.stroke();
            }
          },
          _drawSelected: function(a, l) {
            a.beginPath(), r(a, this, l), a.stroke(), i(a, this._segments, l, He.settings.handleSize);
          }
        };
      }(),
      new function() {
        function i(r) {
          var a = r._segments;
          if (!a.length)
            throw new Error("Use a moveTo() command first");
          return a[a.length - 1];
        }
        return {
          moveTo: function() {
            var r = this._segments;
            r.length === 1 && this.removeSegment(0), r.length || this._add([new ce(M.read(arguments))]);
          },
          moveBy: function() {
            throw new Error("moveBy() is unsupported on Path items.");
          },
          lineTo: function() {
            this._add([new ce(M.read(arguments))]);
          },
          cubicCurveTo: function() {
            var r = arguments, a = M.read(r), l = M.read(r), u = M.read(r), d = i(this);
            d.setHandleOut(a.subtract(d._point)), this._add([new ce(u, l.subtract(u))]);
          },
          quadraticCurveTo: function() {
            var r = arguments, a = M.read(r), l = M.read(r), u = i(this)._point;
            this.cubicCurveTo(
              a.add(u.subtract(a).multiply(1 / 3)),
              a.add(l.subtract(a).multiply(1 / 3)),
              l
            );
          },
          curveTo: function() {
            var r = arguments, a = M.read(r), l = M.read(r), u = o.pick(o.read(r), 0.5), d = 1 - u, v = i(this)._point, p = a.subtract(v.multiply(d * d)).subtract(l.multiply(u * u)).divide(2 * u * d);
            if (p.isNaN())
              throw new Error(
                "Cannot put a curve through points with parameter = " + u
              );
            this.quadraticCurveTo(p, l);
          },
          arcTo: function() {
            var r = arguments, a = Math.abs, l = Math.sqrt, u = i(this), d = u._point, v = M.read(r), p, y = o.peek(r), S = o.pick(y, !0), L, E, A, T;
            if (typeof S == "boolean")
              var G = d.add(v).divide(2), p = G.add(G.subtract(d).rotate(
                S ? -90 : 90
              ));
            else if (o.remain(r) <= 2)
              p = v, v = M.read(r);
            else if (!d.equals(v)) {
              var R = F.read(r), Y = P.isZero;
              if (Y(R.width) || Y(R.height))
                return this.lineTo(v);
              var k = o.read(r), S = !!o.read(r), z = !!o.read(r), G = d.add(v).divide(2), C = d.subtract(G).rotate(-k), I = C.x, j = C.y, q = a(R.width), H = a(R.height), ie = q * q, ae = H * H, he = I * I, pe = j * j, se = l(he / ie + pe / ae);
              if (se > 1 && (q *= se, H *= se, ie = q * q, ae = H * H), se = (ie * ae - ie * pe - ae * he) / (ie * pe + ae * he), a(se) < 1e-12 && (se = 0), se < 0)
                throw new Error(
                  "Cannot create an arc with the given arguments"
                );
              L = new M(q * j / H, -H * I / q).multiply((z === S ? -1 : 1) * l(se)).rotate(k).add(G), T = new ee().translate(L).rotate(k).scale(q, H), A = T._inverseTransform(d), E = A.getDirectedAngle(T._inverseTransform(v)), !S && E > 0 ? E -= 360 : S && E < 0 && (E += 360);
            }
            if (p) {
              var de = new le(
                d.add(p).divide(2),
                p.subtract(d).rotate(90),
                !0
              ), ve = new le(
                p.add(v).divide(2),
                v.subtract(p).rotate(90),
                !0
              ), we = new le(d, v), Se = we.getSide(p);
              if (L = de.intersect(ve, !0), !L) {
                if (!Se)
                  return this.lineTo(v);
                throw new Error(
                  "Cannot create an arc with the given arguments"
                );
              }
              A = d.subtract(L), E = A.getDirectedAngle(v.subtract(L));
              var Ae = we.getSide(L, !0);
              Ae === 0 ? E = Se * a(E) : Se === Ae && (E += E < 0 ? 360 : -360);
            }
            if (E) {
              for (var Ge = 1e-5, Je = a(E), it = Je >= 360 ? 4 : Math.ceil((Je - Ge) / 90), gt = E / it, Ne = gt * Math.PI / 360, Fe = 4 / 3 * Math.sin(Ne) / (1 + Math.cos(Ne)), st = [], _t = 0; _t <= it; _t++) {
                var C = v, vt = null;
                if (_t < it && (vt = A.rotate(90).multiply(Fe), T ? (C = T._transformPoint(A), vt = T._transformPoint(A.add(vt)).subtract(C)) : C = L.add(A)), !_t)
                  u.setHandleOut(vt);
                else {
                  var Rt = A.rotate(-90).multiply(Fe);
                  T && (Rt = T._transformPoint(A.add(Rt)).subtract(C)), st.push(new ce(C, Rt, vt));
                }
                A = A.rotate(gt);
              }
              this._add(st);
            }
          },
          lineBy: function() {
            var r = M.read(arguments), a = i(this)._point;
            this.lineTo(a.add(r));
          },
          curveBy: function() {
            var r = arguments, a = M.read(r), l = M.read(r), u = o.read(r), d = i(this)._point;
            this.curveTo(d.add(a), d.add(l), u);
          },
          cubicCurveBy: function() {
            var r = arguments, a = M.read(r), l = M.read(r), u = M.read(r), d = i(this)._point;
            this.cubicCurveTo(
              d.add(a),
              d.add(l),
              d.add(u)
            );
          },
          quadraticCurveBy: function() {
            var r = arguments, a = M.read(r), l = M.read(r), u = i(this)._point;
            this.quadraticCurveTo(u.add(a), u.add(l));
          },
          arcBy: function() {
            var r = arguments, a = i(this)._point, l = a.add(M.read(r)), u = o.pick(o.peek(r), !0);
            typeof u == "boolean" ? this.arcTo(l, u) : this.arcTo(l, a.add(M.read(r)));
          },
          closePath: function(r) {
            this.setClosed(!0), this.join(this, r);
          }
        };
      }(),
      {
        _getBounds: function(i, r) {
          var a = r.handle ? "getHandleBounds" : r.stroke ? "getStrokeBounds" : "getBounds";
          return We[a](this._segments, this._closed, this, i, r);
        },
        statics: {
          getBounds: function(i, r, a, l, u, d) {
            var v = i[0];
            if (!v)
              return new D();
            var p = new Array(6), y = v._transformCoordinates(l, new Array(6)), S = y.slice(0, 2), L = S.slice(), E = new Array(2);
            function A(R) {
              R._transformCoordinates(l, p);
              for (var Y = 0; Y < 2; Y++)
                De._addBounds(
                  y[Y],
                  y[Y + 4],
                  p[Y + 2],
                  p[Y],
                  Y,
                  d ? d[Y] : 0,
                  S,
                  L,
                  E
                );
              var k = y;
              y = p, p = k;
            }
            for (var T = 1, G = i.length; T < G; T++)
              A(i[T]);
            return r && A(v), new D(S[0], S[1], L[0] - S[0], L[1] - S[1]);
          },
          getStrokeBounds: function(i, r, a, l, u) {
            var d = a.getStyle(), v = d.hasStroke(), p = d.getStrokeWidth(), y = v && a._getStrokeMatrix(l, u), S = v && We._getStrokePadding(
              p,
              y
            ), L = We.getBounds(
              i,
              r,
              a,
              l,
              u,
              S
            );
            if (!v)
              return L;
            var E = p / 2, A = d.getStrokeJoin(), T = d.getStrokeCap(), G = d.getMiterLimit(), R = new D(new F(S));
            function Y(q) {
              L = L.include(q);
            }
            function k(q) {
              L = L.unite(
                R.setCenter(q._point.transform(l))
              );
            }
            function z(q, H) {
              H === "round" || q.isSmooth() ? k(q) : We._addBevelJoin(
                q,
                H,
                E,
                G,
                l,
                y,
                Y
              );
            }
            function C(q, H) {
              H === "round" ? k(q) : We._addSquareCap(
                q,
                H,
                E,
                l,
                y,
                Y
              );
            }
            var I = i.length - (r ? 0 : 1);
            if (I > 0) {
              for (var j = 1; j < I; j++)
                z(i[j], A);
              r ? z(i[0], A) : (C(i[0], T), C(i[i.length - 1], T));
            }
            return L;
          },
          _getStrokePadding: function(i, r) {
            if (!r)
              return [i, i];
            var a = new M(i, 0).transform(r), l = new M(0, i).transform(r), u = a.getAngleInRadians(), d = a.getLength(), v = l.getLength(), p = Math.sin(u), y = Math.cos(u), S = Math.tan(u), L = Math.atan2(v * S, d), E = Math.atan2(v, S * d);
            return [
              Math.abs(d * Math.cos(L) * y + v * Math.sin(L) * p),
              Math.abs(v * Math.sin(E) * y + d * Math.cos(E) * p)
            ];
          },
          _addBevelJoin: function(i, r, a, l, u, d, v, p) {
            var y = i.getCurve(), S = y.getPrevious(), L = y.getPoint1().transform(u), E = S.getNormalAtTime(1).multiply(a).transform(d), A = y.getNormalAtTime(0).multiply(a).transform(d), T = E.getDirectedAngle(A);
            if ((T < 0 || T >= 180) && (E = E.negate(), A = A.negate()), p && v(L), v(L.add(E)), r === "miter") {
              var G = new le(
                L.add(E),
                new M(-E.y, E.x),
                !0
              ).intersect(new le(
                L.add(A),
                new M(-A.y, A.x),
                !0
              ), !0);
              G && L.getDistance(G) <= l * a && v(G);
            }
            v(L.add(A));
          },
          _addSquareCap: function(i, r, a, l, u, d, v) {
            var p = i._point.transform(l), y = i.getLocation(), S = y.getNormal().multiply(y.getTime() === 0 ? a : -a).transform(u);
            r === "square" && (v && (d(p.subtract(S)), d(p.add(S))), p = p.add(S.rotate(-90))), d(p.add(S)), d(p.subtract(S));
          },
          getHandleBounds: function(i, r, a, l, u) {
            var d = a.getStyle(), v = u.stroke && d.hasStroke(), p, y;
            if (v) {
              var S = a._getStrokeMatrix(l, u), L = d.getStrokeWidth() / 2, E = L;
              d.getStrokeJoin() === "miter" && (E = L * d.getMiterLimit()), d.getStrokeCap() === "square" && (E = Math.max(E, L * Math.SQRT2)), p = We._getStrokePadding(L, S), y = We._getStrokePadding(E, S);
            }
            for (var A = new Array(6), T = 1 / 0, G = -T, R = T, Y = G, k = 0, z = i.length; k < z; k++) {
              var C = i[k];
              C._transformCoordinates(l, A);
              for (var I = 0; I < 6; I += 2) {
                var j = I ? p : y, q = j ? j[0] : 0, H = j ? j[1] : 0, ie = A[I], ae = A[I + 1], he = ie - q, pe = ie + q, se = ae - H, de = ae + H;
                he < T && (T = he), pe > G && (G = pe), se < R && (R = se), de > Y && (Y = de);
              }
            }
            return new D(T, R, G - T, Y - R);
          }
        }
      }
    );
    We.inject({ statics: new function() {
      var i = 0.5522847498307936, r = [
        new ce([-1, 0], [0, i], [0, -i]),
        new ce([0, -1], [-i, 0], [i, 0]),
        new ce([1, 0], [0, -i], [0, i]),
        new ce([0, 1], [i, 0], [-i, 0])
      ];
      function a(u, d, v) {
        var p = o.getNamed(v), y = new We(p && (p.insert == !0 ? X.INSERT : p.insert == !1 ? X.NO_INSERT : null));
        return y._add(u), y._closed = d, y.set(p, X.INSERT);
      }
      function l(u, d, v) {
        for (var p = new Array(4), y = 0; y < 4; y++) {
          var S = r[y];
          p[y] = new ce(
            S._point.multiply(d).add(u),
            S._handleIn.multiply(d),
            S._handleOut.multiply(d)
          );
        }
        return a(p, !0, v);
      }
      return {
        Line: function() {
          var u = arguments;
          return a([
            new ce(M.readNamed(u, "from")),
            new ce(M.readNamed(u, "to"))
          ], !1, u);
        },
        Circle: function() {
          var u = arguments, d = M.readNamed(u, "center"), v = o.readNamed(u, "radius");
          return l(d, new F(v), u);
        },
        Rectangle: function() {
          var u = arguments, d = D.readNamed(u, "rectangle"), v = F.readNamed(
            u,
            "radius",
            0,
            { readNull: !0 }
          ), p = d.getBottomLeft(!0), y = d.getTopLeft(!0), S = d.getTopRight(!0), L = d.getBottomRight(!0), E;
          if (!v || v.isZero())
            E = [
              new ce(p),
              new ce(y),
              new ce(S),
              new ce(L)
            ];
          else {
            v = F.min(v, d.getSize(!0).divide(2));
            var A = v.width, T = v.height, G = A * i, R = T * i;
            E = [
              new ce(p.add(A, 0), null, [-G, 0]),
              new ce(p.subtract(0, T), [0, R]),
              new ce(y.add(0, T), null, [0, -R]),
              new ce(y.add(A, 0), [-G, 0], null),
              new ce(S.subtract(A, 0), null, [G, 0]),
              new ce(S.add(0, T), [0, -R], null),
              new ce(L.subtract(0, T), null, [0, R]),
              new ce(L.subtract(A, 0), [G, 0])
            ];
          }
          return a(E, !0, u);
        },
        RoundRectangle: "#Rectangle",
        Ellipse: function() {
          var u = arguments, d = ke._readEllipse(u);
          return l(d.center, d.radius, u);
        },
        Oval: "#Ellipse",
        Arc: function() {
          var u = arguments, d = M.readNamed(u, "from"), v = M.readNamed(u, "through"), p = M.readNamed(u, "to"), y = o.getNamed(u), S = new We(y && y.insert == !1 && X.NO_INSERT);
          return S.moveTo(d), S.arcTo(v, p), S.set(y);
        },
        RegularPolygon: function() {
          for (var u = arguments, d = M.readNamed(u, "center"), v = o.readNamed(u, "sides"), p = o.readNamed(u, "radius"), y = 360 / v, S = v % 3 === 0, L = new M(0, S ? -p : p), E = S ? -1 : 0.5, A = new Array(v), T = 0; T < v; T++)
            A[T] = new ce(d.add(
              L.rotate((T + E) * y)
            ));
          return a(A, !0, u);
        },
        Star: function() {
          for (var u = arguments, d = M.readNamed(u, "center"), v = o.readNamed(u, "points") * 2, p = o.readNamed(u, "radius1"), y = o.readNamed(u, "radius2"), S = 360 / v, L = new M(0, -1), E = new Array(v), A = 0; A < v; A++)
            E[A] = new ce(d.add(L.rotate(S * A).multiply(A % 2 ? y : p)));
          return a(E, !0, u);
        }
      };
    }() });
    var It = Yt.extend(
      {
        _class: "CompoundPath",
        _serializeFields: {
          children: []
        },
        beans: !0,
        initialize: function(r) {
          this._children = [], this._namedChildren = {}, this._initialize(r) || (typeof r == "string" ? this.setPathData(r) : this.addChildren(Array.isArray(r) ? r : arguments));
        },
        insertChildren: function i(r, a) {
          var l = a, u = l[0];
          u && typeof u[0] == "number" && (l = [l]);
          for (var d = a.length - 1; d >= 0; d--) {
            var v = l[d];
            l === a && !(v instanceof We) && (l = o.slice(l)), Array.isArray(v) ? l[d] = new We({ segments: v, insert: !1 }) : v instanceof It && (l.splice.apply(l, [d, 1].concat(v.removeChildren())), v.remove());
          }
          return i.base.call(this, r, l);
        },
        reduce: function i(r) {
          for (var a = this._children, l = a.length - 1; l >= 0; l--) {
            var u = a[l].reduce(r);
            u.isEmpty() && u.remove();
          }
          if (!a.length) {
            var u = new We(X.NO_INSERT);
            return u.copyAttributes(this), u.insertAbove(this), this.remove(), u;
          }
          return i.base.call(this);
        },
        isClosed: function() {
          for (var i = this._children, r = 0, a = i.length; r < a; r++)
            if (!i[r]._closed)
              return !1;
          return !0;
        },
        setClosed: function(i) {
          for (var r = this._children, a = 0, l = r.length; a < l; a++)
            r[a].setClosed(i);
        },
        getFirstSegment: function() {
          var i = this.getFirstChild();
          return i && i.getFirstSegment();
        },
        getLastSegment: function() {
          var i = this.getLastChild();
          return i && i.getLastSegment();
        },
        getCurves: function() {
          for (var i = this._children, r = [], a = 0, l = i.length; a < l; a++)
            o.push(r, i[a].getCurves());
          return r;
        },
        getFirstCurve: function() {
          var i = this.getFirstChild();
          return i && i.getFirstCurve();
        },
        getLastCurve: function() {
          var i = this.getLastChild();
          return i && i.getLastCurve();
        },
        getArea: function() {
          for (var i = this._children, r = 0, a = 0, l = i.length; a < l; a++)
            r += i[a].getArea();
          return r;
        },
        getLength: function() {
          for (var i = this._children, r = 0, a = 0, l = i.length; a < l; a++)
            r += i[a].getLength();
          return r;
        },
        getPathData: function(i, r) {
          for (var a = this._children, l = [], u = 0, d = a.length; u < d; u++) {
            var v = a[u], p = v._matrix;
            l.push(v.getPathData(i && !p.isIdentity() ? i.appended(p) : i, r));
          }
          return l.join("");
        },
        _hitTestChildren: function i(r, a, l) {
          return i.base.call(
            this,
            r,
            a.class === We || a.type === "path" ? a : o.set({}, a, { fill: !1 }),
            l
          );
        },
        _draw: function(i, r, a, l) {
          var u = this._children;
          if (u.length) {
            r = r.extend({ dontStart: !0, dontFinish: !0 }), i.beginPath();
            for (var d = 0, v = u.length; d < v; d++)
              u[d].draw(i, r, l);
            if (!r.clip) {
              this._setStyles(i, r, a);
              var p = this._style;
              p.hasFill() && (i.fill(p.getFillRule()), i.shadowColor = "rgba(0,0,0,0)"), p.hasStroke() && i.stroke();
            }
          }
        },
        _drawSelected: function(i, r, a) {
          for (var l = this._children, u = 0, d = l.length; u < d; u++) {
            var v = l[u], p = v._matrix;
            a[v._id] || v._drawSelected(i, p.isIdentity() ? r : r.appended(p));
          }
        }
      },
      new function() {
        function i(r, a) {
          var l = r._children;
          if (a && !l.length)
            throw new Error("Use a moveTo() command first");
          return l[l.length - 1];
        }
        return o.each(
          [
            "lineTo",
            "cubicCurveTo",
            "quadraticCurveTo",
            "curveTo",
            "arcTo",
            "lineBy",
            "cubicCurveBy",
            "quadraticCurveBy",
            "curveBy",
            "arcBy"
          ],
          function(r) {
            this[r] = function() {
              var a = i(this, !0);
              a[r].apply(a, arguments);
            };
          },
          {
            moveTo: function() {
              var r = i(this), a = r && r.isEmpty() ? r : new We(X.NO_INSERT);
              a !== r && this.addChild(a), a.moveTo.apply(a, arguments);
            },
            moveBy: function() {
              var r = i(this, !0), a = r && r.getLastSegment(), l = M.read(arguments);
              this.moveTo(a ? l.add(a._point) : l);
            },
            closePath: function(r) {
              i(this, !0).closePath(r);
            }
          }
        );
      }(),
      o.each(["reverse", "flatten", "simplify", "smooth"], function(i) {
        this[i] = function(r) {
          for (var a = this._children, l, u = 0, d = a.length; u < d; u++)
            l = a[u][i](r) || l;
          return l;
        };
      }, {})
    );
    Yt.inject(new function() {
      var i = Math.min, r = Math.max, a = Math.abs, l = {
        unite: { 1: !0, 2: !0 },
        intersect: { 2: !0 },
        subtract: { 1: !0 },
        exclude: { 1: !0, "-1": !0 }
      };
      function u(k) {
        return k._children || [k];
      }
      function d(k, z) {
        var C = k.clone(!1).reduce({ simplify: !0 }).transform(null, !0, !0);
        if (z) {
          for (var I = u(C), j = 0, q = I.length; j < q; j++) {
            var k = I[j];
            !k._closed && !k.isEmpty() && (k.closePath(1e-12), k.getFirstSegment().setHandleIn(0, 0), k.getLastSegment().setHandleOut(0, 0));
          }
          C = C.resolveCrossings().reorient(C.getFillRule() === "nonzero", !0);
        }
        return C;
      }
      function v(k, z, C, I, j) {
        var q = new It(X.NO_INSERT);
        return q.addChildren(k, !0), q = q.reduce({ simplify: z }), j && j.insert == !1 || q.insertAbove(I && C.isSibling(I) && C.getIndex() < I.getIndex() ? I : C), q.copyAttributes(C, !0), q;
      }
      function p(k) {
        return k.hasOverlap() || k.isCrossing();
      }
      function y(k, z, C, I) {
        if (I && (I.trace == !1 || I.stroke) && /^(subtract|intersect)$/.test(C))
          return S(k, z, C);
        var j = d(k, !0), q = z && k !== z && d(z, !0), H = l[C];
        H[C] = !0, q && (H.subtract || H.exclude) ^ (q.isClockwise() ^ j.isClockwise()) && q.reverse();
        var ie = T(ft.expand(
          j.getIntersections(q, p)
        )), ae = u(j), he = q && u(q), pe = [], se = [], de;
        function ve(vt) {
          for (var Rt = 0, Et = vt.length; Rt < Et; Rt++) {
            var Ht = vt[Rt];
            o.push(pe, Ht._segments), o.push(se, Ht.getCurves()), Ht._overlapsOnly = !0;
          }
        }
        function we(vt) {
          for (var Rt = [], Et = 0, Ht = vt && vt.length; Et < Ht; Et++)
            Rt.push(se[vt[Et]]);
          return Rt;
        }
        if (ie.length) {
          ve(ae), he && ve(he);
          for (var Se = new Array(se.length), Ae = 0, Ge = se.length; Ae < Ge; Ae++)
            Se[Ae] = se[Ae].getValues();
          for (var Je = x.findCurveBoundsCollisions(
            Se,
            Se,
            0,
            !0
          ), it = {}, Ae = 0; Ae < se.length; Ae++) {
            var gt = se[Ae], Ne = gt._path._id, Fe = it[Ne] = it[Ne] || {};
            Fe[gt.getIndex()] = {
              hor: we(Je[Ae].hor),
              ver: we(Je[Ae].ver)
            };
          }
          for (var Ae = 0, Ge = ie.length; Ae < Ge; Ae++)
            R(
              ie[Ae]._segment,
              j,
              q,
              it,
              H
            );
          for (var Ae = 0, Ge = pe.length; Ae < Ge; Ae++) {
            var st = pe[Ae], _t = st._intersection;
            st._winding || R(
              st,
              j,
              q,
              it,
              H
            ), _t && _t._overlap || (st._path._overlapsOnly = !1);
          }
          de = Y(pe, H);
        } else
          de = A(
            he ? ae.concat(he) : ae.slice(),
            function(vt) {
              return !!H[vt];
            }
          );
        return v(de, !0, k, z, I);
      }
      function S(k, z, C) {
        var I = d(k), j = d(z), q = I.getIntersections(j, p), H = C === "subtract", ie = C === "divide", ae = {}, he = [];
        function pe(ve) {
          if (!ae[ve._id] && (ie || j.contains(ve.getPointAt(ve.getLength() / 2)) ^ H))
            return he.unshift(ve), ae[ve._id] = !0;
        }
        for (var se = q.length - 1; se >= 0; se--) {
          var de = q[se].split();
          de && (pe(de) && de.getFirstSegment().setHandleIn(0, 0), I.getLastSegment().setHandleOut(0, 0));
        }
        return pe(I), v(he, !1, k, z);
      }
      function L(k, z) {
        for (var C = k; C; ) {
          if (C === z)
            return;
          C = C._previous;
        }
        for (; k._next && k._next !== z; )
          k = k._next;
        if (!k._next) {
          for (; z._previous; )
            z = z._previous;
          k._next = z, z._previous = k;
        }
      }
      function E(k) {
        for (var z = k.length - 1; z >= 0; z--)
          k[z].clearHandles();
      }
      function A(k, z, C) {
        var I = k && k.length;
        if (I) {
          var j = o.each(k, function(Je, it) {
            this[Je._id] = {
              container: null,
              winding: Je.isClockwise() ? 1 : -1,
              index: it
            };
          }, {}), q = k.slice().sort(function(Je, it) {
            return a(it.getArea()) - a(Je.getArea());
          }), H = q[0], ie = x.findItemBoundsCollisions(
            q,
            null,
            P.GEOMETRIC_EPSILON
          );
          C == null && (C = H.isClockwise());
          for (var ae = 0; ae < I; ae++) {
            var he = q[ae], pe = j[he._id], se = 0, de = ie[ae];
            if (de) {
              for (var ve = null, we = de.length - 1; we >= 0; we--)
                if (de[we] < ae) {
                  ve = ve || he.getInteriorPoint();
                  var Se = q[de[we]];
                  if (Se.contains(ve)) {
                    var Ae = j[Se._id];
                    se = Ae.winding, pe.winding += se, pe.container = Ae.exclude ? Ae.container : Se;
                    break;
                  }
                }
            }
            if (z(pe.winding) === z(se))
              pe.exclude = !0, k[pe.index] = null;
            else {
              var Ge = pe.container;
              he.setClockwise(
                Ge ? !Ge.isClockwise() : C
              );
            }
          }
        }
        return k;
      }
      function T(k, z, C) {
        var I = z && [], j = 1e-8, q = 1 - j, H = !1, ie = C || [], ae = C && {}, he, pe, se;
        function de(Rt) {
          return Rt._path._id + "." + Rt._segment1._index;
        }
        for (var ve = (C && C.length) - 1; ve >= 0; ve--) {
          var we = C[ve];
          we._path && (ae[de(we)] = !0);
        }
        for (var ve = k.length - 1; ve >= 0; ve--) {
          var Se = k[ve], Ae = Se._time, Ge = Ae, Je = z && !z(Se), we = Se._curve, it;
          if (we && (we !== pe ? (H = !we.hasHandles() || ae && ae[de(we)], he = [], se = null, pe = we) : se >= j && (Ae /= se)), Je) {
            he && he.push(Se);
            continue;
          } else
            z && I.unshift(Se);
          if (se = Ge, Ae < j)
            it = we._segment1;
          else if (Ae > q)
            it = we._segment2;
          else {
            var gt = we.divideAtTime(Ae, !0);
            H && ie.push(we, gt), it = gt._segment1;
            for (var Ne = he.length - 1; Ne >= 0; Ne--) {
              var Fe = he[Ne];
              Fe._time = (Fe._time - Ae) / (1 - Ae);
            }
          }
          Se._setSegment(it);
          var st = it._intersection, _t = Se._intersection;
          if (st) {
            L(st, _t);
            for (var vt = st; vt; )
              L(vt._intersection, st), vt = vt._next;
          } else
            it._intersection = _t;
        }
        return C || E(ie), I || k;
      }
      function G(k, z, C, I, j) {
        var q = Array.isArray(z) ? z : z[C ? "hor" : "ver"], H = C ? 1 : 0, ie = H ^ 1, ae = [k.x, k.y], he = ae[H], pe = ae[ie], se = 1e-9, de = 1e-6, ve = he - se, we = he + se, Se = 0, Ae = 0, Ge = 0, Je = 0, it = !1, gt = !1, Ne = 1, Fe = [], st, _t;
        function vt(ri) {
          var Nt = ri[ie + 0], Di = ri[ie + 6];
          if (!(pe < i(Nt, Di) || pe > r(Nt, Di))) {
            var li = ri[H + 0], nn = ri[H + 2], Vi = ri[H + 4], Wi = ri[H + 6];
            if (Nt === Di) {
              (li < we && Wi > ve || Wi < we && li > ve) && (it = !0);
              return;
            }
            var Ji = pe === Nt ? 0 : pe === Di || ve > r(li, nn, Vi, Wi) || we < i(li, nn, Vi, Wi) ? 1 : De.solveCubic(ri, ie, pe, Fe, 0, 1) > 0 ? Fe[0] : 1, Hi = Ji === 0 ? li : Ji === 1 ? Wi : De.getPoint(ri, Ji)[C ? "y" : "x"], $i = Nt > Di ? 1 : -1, _n = st[ie] > st[ie + 6] ? 1 : -1, Xi = st[H + 6];
            return pe !== Nt ? (Hi < ve ? Ge += $i : Hi > we ? Je += $i : it = !0, Hi > he - de && Hi < he + de && (Ne /= 2)) : ($i !== _n ? li < ve ? Ge += $i : li > we && (Je += $i) : li != Xi && (Xi < we && Hi > we ? (Je += $i, it = !0) : Xi > ve && Hi < ve && (Ge += $i, it = !0)), Ne /= 4), st = ri, !j && Hi > ve && Hi < we && De.getTangent(ri, Ji)[C ? "x" : "y"] === 0 && G(k, z, !C, I, !0);
          }
        }
        function Rt(ri) {
          var Nt = ri[ie + 0], Di = ri[ie + 2], li = ri[ie + 4], nn = ri[ie + 6];
          if (pe <= r(Nt, Di, li, nn) && pe >= i(Nt, Di, li, nn)) {
            for (var Vi = ri[H + 0], Wi = ri[H + 2], Ji = ri[H + 4], Hi = ri[H + 6], $i = ve > r(Vi, Wi, Ji, Hi) || we < i(Vi, Wi, Ji, Hi) ? [ri] : De.getMonoCurves(ri, C), _n, Xi = 0, cn = $i.length; Xi < cn; Xi++)
              if (_n = vt($i[Xi]))
                return _n;
          }
        }
        for (var Et = 0, Ht = q.length; Et < Ht; Et++) {
          var jt = q[Et], Vt = jt._path, Mi = jt.getValues(), Li;
          if ((!Et || q[Et - 1]._path !== Vt) && (st = null, Vt._closed || (_t = De.getValues(
            Vt.getLastCurve().getSegment2(),
            jt.getSegment1(),
            null,
            !I
          ), _t[ie] !== _t[ie + 6] && (st = _t)), !st)) {
            st = Mi;
            for (var Ai = Vt.getLastCurve(); Ai && Ai !== jt; ) {
              var vi = Ai.getValues();
              if (vi[ie] !== vi[ie + 6]) {
                st = vi;
                break;
              }
              Ai = Ai.getPrevious();
            }
          }
          if (Li = Rt(Mi))
            return Li;
          if (Et + 1 === Ht || q[Et + 1]._path !== Vt) {
            if (_t && (Li = Rt(_t)))
              return Li;
            it && !Ge && !Je && (Ge = Je = Vt.isClockwise(I) ^ C ? 1 : -1), Se += Ge, Ae += Je, Ge = Je = 0, it && (gt = !0, it = !1), _t = null;
          }
        }
        return Se = a(Se), Ae = a(Ae), {
          winding: r(Se, Ae),
          windingL: Se,
          windingR: Ae,
          quality: Ne,
          onPath: gt
        };
      }
      function R(k, z, C, I, j) {
        var q = [], H = k, ie = 0, se;
        do {
          var ae = k.getCurve();
          if (ae) {
            var he = ae.getLength();
            q.push({ segment: k, curve: ae, length: he }), ie += he;
          }
          k = k.getNext();
        } while (k && !k._intersection && k !== H);
        for (var pe = [0.5, 0.25, 0.75], se = { winding: 0, quality: -1 }, de = 1e-3, ve = 1 - de, we = 0; we < pe.length && se.quality < 0.5; we++)
          for (var he = ie * pe[we], Se = 0, Ae = q.length; Se < Ae; Se++) {
            var Ge = q[Se], Je = Ge.length;
            if (he <= Je) {
              var ae = Ge.curve, it = ae._path, gt = it._parent, Ne = gt instanceof It ? gt : it, Fe = P.clamp(ae.getTimeAt(he), de, ve), st = ae.getPointAtTime(Fe), _t = a(ae.getTangentAtTime(Fe).y) < Math.SQRT1_2, vt = null;
              if (j.subtract && C) {
                var Rt = Ne === z ? C : z, Et = Rt._getWinding(st, _t, !0);
                if (Ne === z && Et.winding || Ne === C && !Et.winding) {
                  if (Et.quality < 1)
                    continue;
                  vt = { winding: 0, quality: 1 };
                }
              }
              vt = vt || G(
                st,
                I[it._id][ae.getIndex()],
                _t,
                !0
              ), vt.quality > se.quality && (se = vt);
              break;
            }
            he -= Je;
          }
        for (var Se = q.length - 1; Se >= 0; Se--)
          q[Se].segment._winding = se;
      }
      function Y(k, z) {
        var C = [], I;
        function j(Ht) {
          var jt;
          return !!(Ht && !Ht._visited && (!z || z[(jt = Ht._winding || {}).winding] && !(z.unite && jt.winding === 2 && jt.windingL && jt.windingR)));
        }
        function q(Ht) {
          if (Ht) {
            for (var jt = 0, Vt = I.length; jt < Vt; jt++)
              if (Ht === I[jt])
                return !0;
          }
          return !1;
        }
        function H(Ht) {
          for (var jt = Ht._segments, Vt = 0, Mi = jt.length; Vt < Mi; Vt++)
            jt[Vt]._visited = !0;
        }
        function ie(Ht, jt) {
          var Vt = Ht._intersection, Mi = Vt, Li = [];
          jt && (I = [Ht]);
          function Ai(vi, ri) {
            for (; vi && vi !== ri; ) {
              var Nt = vi._segment, Di = Nt && Nt._path;
              if (Di) {
                var li = Nt.getNext() || Di.getFirstSegment(), nn = li._intersection;
                Nt !== Ht && (q(Nt) || q(li) || li && j(Nt) && (j(li) || nn && j(nn._segment))) && Li.push(Nt), jt && I.push(Nt);
              }
              vi = vi._next;
            }
          }
          if (Vt) {
            for (Ai(Vt); Vt && Vt._previous; )
              Vt = Vt._previous;
            Ai(Vt, Mi);
          }
          return Li;
        }
        k.sort(function(Ht, jt) {
          var Vt = Ht._intersection, Mi = jt._intersection, Li = !!(Vt && Vt._overlap), Ai = !!(Mi && Mi._overlap), vi = Ht._path, ri = jt._path;
          return Li ^ Ai ? Li ? 1 : -1 : !Vt ^ !Mi ? Vt ? 1 : -1 : vi !== ri ? vi._id - ri._id : Ht._index - jt._index;
        });
        for (var ae = 0, he = k.length; ae < he; ae++) {
          var pe = k[ae], se = j(pe), de = null, ve = !1, we = !0, Se = [], Ae, Ge, Je;
          if (se && pe._path._overlapsOnly) {
            var it = pe._path, gt = pe._intersection._segment._path;
            it.compare(gt) && (it.getArea() && C.push(it.clone(!1)), H(it), H(gt), se = !1);
          }
          for (; se; ) {
            var Ne = !de, Fe = ie(pe, Ne), st = Fe.shift(), ve = !Ne && (q(pe) || q(st)), _t = !ve && st;
            if (Ne && (de = new We(X.NO_INSERT), Ae = null), ve) {
              (pe.isFirst() || pe.isLast()) && (we = pe._path._closed), pe._visited = !0;
              break;
            }
            if (_t && Ae && (Se.push(Ae), Ae = null), Ae || (_t && Fe.push(pe), Ae = {
              start: de._segments.length,
              crossings: Fe,
              visited: Ge = [],
              handleIn: Je
            }), _t && (pe = st), !j(pe)) {
              de.removeSegments(Ae.start);
              for (var vt = 0, Rt = Ge.length; vt < Rt; vt++)
                Ge[vt]._visited = !1;
              Ge.length = 0;
              do
                pe = Ae && Ae.crossings.shift(), (!pe || !pe._path) && (pe = null, Ae = Se.pop(), Ae && (Ge = Ae.visited, Je = Ae.handleIn));
              while (Ae && !j(pe));
              if (!pe)
                break;
            }
            var Et = pe.getNext();
            de.add(new ce(
              pe._point,
              Je,
              Et && pe._handleOut
            )), pe._visited = !0, Ge.push(pe), pe = Et || pe._path.getFirstSegment(), Je = Et && Et._handleIn;
          }
          ve && (we && (de.getFirstSegment().setHandleIn(Je), de.setClosed(we)), de.getArea() !== 0 && C.push(de));
        }
        return C;
      }
      return {
        _getWinding: function(k, z, C) {
          return G(k, this.getCurves(), z, C);
        },
        unite: function(k, z) {
          return y(this, k, "unite", z);
        },
        intersect: function(k, z) {
          return y(this, k, "intersect", z);
        },
        subtract: function(k, z) {
          return y(this, k, "subtract", z);
        },
        exclude: function(k, z) {
          return y(this, k, "exclude", z);
        },
        divide: function(k, z) {
          return z && (z.trace == !1 || z.stroke) ? S(this, k, "divide") : v([
            this.subtract(k, z),
            this.intersect(k, z)
          ], !0, this, k, z);
        },
        resolveCrossings: function() {
          var k = this._children, z = k || [this];
          function C(Ae, Ge) {
            var Je = Ae && Ae._intersection;
            return Je && Je._overlap && Je._path === Ge;
          }
          var I = !1, j = !1, q = this.getIntersections(null, function(Ae) {
            return Ae.hasOverlap() && (I = !0) || Ae.isCrossing() && (j = !0);
          }), H = I && j && [];
          if (q = ft.expand(q), I)
            for (var ie = T(q, function(Ae) {
              return Ae.hasOverlap();
            }, H), ae = ie.length - 1; ae >= 0; ae--) {
              var he = ie[ae], pe = he._path, se = he._segment, de = se.getPrevious(), ve = se.getNext();
              C(de, pe) && C(ve, pe) && (se.remove(), de._handleOut._set(0, 0), ve._handleIn._set(0, 0), de !== se && !de.getCurve().hasLength() && (ve._handleIn.set(de._handleIn), de.remove()));
            }
          j && (T(q, I && function(Ae) {
            var Ge = Ae.getCurve(), Je = Ae.getSegment(), it = Ae._intersection, gt = it._curve, Ne = it._segment;
            if (Ge && gt && Ge._path && gt._path)
              return !0;
            Je && (Je._intersection = null), Ne && (Ne._intersection = null);
          }, H), H && E(H), z = Y(o.each(z, function(Ae) {
            o.push(this, Ae._segments);
          }, [])));
          var we = z.length, Se;
          return we > 1 && k ? (z !== k && this.setChildren(z), Se = this) : we === 1 && !k && (z[0] !== this && this.setSegments(z[0].removeSegments()), Se = this), Se || (Se = new It(X.NO_INSERT), Se.addChildren(z), Se = Se.reduce(), Se.copyAttributes(this), this.replaceWith(Se)), Se;
        },
        reorient: function(k, z) {
          var C = this._children;
          return C && C.length ? this.setChildren(A(
            this.removeChildren(),
            function(I) {
              return !!(k ? I : I & 1);
            },
            z
          )) : z !== t && this.setClockwise(z), this;
        },
        getInteriorPoint: function() {
          var k = this.getBounds(), z = k.getCenter(!0);
          if (!this.contains(z)) {
            for (var C = this.getCurves(), I = z.y, j = [], q = [], H = 0, ie = C.length; H < ie; H++) {
              var ae = C[H].getValues(), he = ae[1], pe = ae[3], se = ae[5], de = ae[7];
              if (I >= i(he, pe, se, de) && I <= r(he, pe, se, de))
                for (var ve = De.getMonoCurves(ae), we = 0, Se = ve.length; we < Se; we++) {
                  var Ae = ve[we], Ge = Ae[1], Je = Ae[7];
                  if (Ge !== Je && (I >= Ge && I <= Je || I >= Je && I <= Ge)) {
                    var it = I === Ge ? Ae[0] : I === Je ? Ae[6] : De.solveCubic(Ae, 1, I, q, 0, 1) === 1 ? De.getPoint(Ae, q[0]).x : (Ae[0] + Ae[6]) / 2;
                    j.push(it);
                  }
                }
            }
            j.length > 1 && (j.sort(function(gt, Ne) {
              return gt - Ne;
            }), z.x = (j[0] + j[1]) / 2);
          }
          return z;
        }
      };
    }());
    var rt = o.extend(
      {
        _class: "PathFlattener",
        initialize: function(i, r, a, l, u) {
          var d = [], v = [], p = 0, y = 1 / (a || 32), S = i._segments, L = S[0], E;
          function A(Y, k) {
            var z = De.getValues(Y, k, u);
            d.push(z), T(z, Y._index, 0, 1);
          }
          function T(Y, k, z, C) {
            if (C - z > y && !(l && De.isStraight(Y)) && !De.isFlatEnough(Y, r || 0.25)) {
              var I = De.subdivide(Y, 0.5), j = (z + C) / 2;
              T(I[0], k, z, j), T(I[1], k, j, C);
            } else {
              var q = Y[6] - Y[0], H = Y[7] - Y[1], ie = Math.sqrt(q * q + H * H);
              ie > 0 && (p += ie, v.push({
                offset: p,
                curve: Y,
                index: k,
                time: C
              }));
            }
          }
          for (var G = 1, R = S.length; G < R; G++)
            E = S[G], A(L, E), L = E;
          i._closed && A(E || L, S[0]), this.curves = d, this.parts = v, this.length = p, this.index = 0;
        },
        _get: function(i) {
          for (var r = this.parts, a = r.length, l, u = this.index; l = u, !(!u || r[--u].offset < i); )
            ;
          for (; l < a; l++) {
            var d = r[l];
            if (d.offset >= i) {
              this.index = l;
              var v = r[l - 1], p = v && v.index === d.index ? v.time : 0, y = v ? v.offset : 0;
              return {
                index: d.index,
                time: p + (d.time - p) * (i - y) / (d.offset - y)
              };
            }
          }
          return {
            index: r[a - 1].index,
            time: 1
          };
        },
        drawPart: function(i, r, a) {
          for (var l = this._get(r), u = this._get(a), d = l.index, v = u.index; d <= v; d++) {
            var p = De.getPart(
              this.curves[d],
              d === l.index ? l.time : 0,
              d === u.index ? u.time : 1
            );
            d === l.index && i.moveTo(p[0], p[1]), i.bezierCurveTo.apply(i, p.slice(2));
          }
        }
      },
      o.each(
        De._evaluateMethods,
        function(i) {
          this[i + "At"] = function(r) {
            var a = this._get(r);
            return De[i](this.curves[a.index], a.time);
          };
        },
        {}
      )
    ), tt = o.extend({
      initialize: function(i) {
        for (var r = this.points = [], a = i._segments, l = i._closed, u = 0, d, v = a.length; u < v; u++) {
          var p = a[u].point;
          (!d || !d.equals(p)) && r.push(d = p.clone());
        }
        l && (r.unshift(r[r.length - 1]), r.push(r[1])), this.closed = l;
      },
      fit: function(i) {
        var r = this.points, a = r.length, l = null;
        return a > 0 && (l = [new ce(r[0])], a > 1 && (this.fitCubic(
          l,
          i,
          0,
          a - 1,
          r[1].subtract(r[0]),
          r[a - 2].subtract(r[a - 1])
        ), this.closed && (l.shift(), l.pop()))), l;
      },
      fitCubic: function(i, r, a, l, u, d) {
        var v = this.points;
        if (l - a === 1) {
          var p = v[a], y = v[l], S = p.getDistance(y) / 3;
          this.addCurve(i, [
            p,
            p.add(u.normalize(S)),
            y.add(d.normalize(S)),
            y
          ]);
          return;
        }
        for (var L = this.chordLengthParameterize(a, l), E = Math.max(r, r * r), A, T = !0, G = 0; G <= 4; G++) {
          var R = this.generateBezier(a, l, L, u, d), Y = this.findMaxError(a, l, R, L);
          if (Y.error < r && T) {
            this.addCurve(i, R);
            return;
          }
          if (A = Y.index, Y.error >= E)
            break;
          T = this.reparameterize(a, l, L, R), E = Y.error;
        }
        var k = v[A - 1].subtract(v[A + 1]);
        this.fitCubic(i, r, a, A, u, k), this.fitCubic(i, r, A, l, k.negate(), d);
      },
      addCurve: function(i, r) {
        var a = i[i.length - 1];
        a.setHandleOut(r[1].subtract(r[0])), i.push(new ce(r[3], r[2].subtract(r[3])));
      },
      generateBezier: function(i, r, a, l, u) {
        for (var d = 1e-12, v = Math.abs, p = this.points, y = p[i], S = p[r], L = [[0, 0], [0, 0]], E = [0, 0], A = 0, T = r - i + 1; A < T; A++) {
          var G = a[A], R = 1 - G, Y = 3 * G * R, k = R * R * R, z = Y * R, C = Y * G, I = G * G * G, j = l.normalize(z), q = u.normalize(C), H = p[i + A].subtract(y.multiply(k + z)).subtract(S.multiply(C + I));
          L[0][0] += j.dot(j), L[0][1] += j.dot(q), L[1][0] = L[0][1], L[1][1] += q.dot(q), E[0] += j.dot(H), E[1] += q.dot(H);
        }
        var ie = L[0][0] * L[1][1] - L[1][0] * L[0][1], ae, he;
        if (v(ie) > d) {
          var pe = L[0][0] * E[1] - L[1][0] * E[0], se = E[0] * L[1][1] - E[1] * L[0][1];
          ae = se / ie, he = pe / ie;
        } else {
          var de = L[0][0] + L[0][1], ve = L[1][0] + L[1][1];
          ae = he = v(de) > d ? E[0] / de : v(ve) > d ? E[1] / ve : 0;
        }
        var we = S.getDistance(y), Se = d * we, Ae, Ge;
        if (ae < Se || he < Se)
          ae = he = we / 3;
        else {
          var Je = S.subtract(y);
          Ae = l.normalize(ae), Ge = u.normalize(he), Ae.dot(Je) - Ge.dot(Je) > we * we && (ae = he = we / 3, Ae = Ge = null);
        }
        return [
          y,
          y.add(Ae || l.normalize(ae)),
          S.add(Ge || u.normalize(he)),
          S
        ];
      },
      reparameterize: function(i, r, a, l) {
        for (var u = i; u <= r; u++)
          a[u - i] = this.findRoot(l, this.points[u], a[u - i]);
        for (var u = 1, d = a.length; u < d; u++)
          if (a[u] <= a[u - 1])
            return !1;
        return !0;
      },
      findRoot: function(i, r, a) {
        for (var l = [], u = [], d = 0; d <= 2; d++)
          l[d] = i[d + 1].subtract(i[d]).multiply(3);
        for (var d = 0; d <= 1; d++)
          u[d] = l[d + 1].subtract(l[d]).multiply(2);
        var v = this.evaluate(3, i, a), p = this.evaluate(2, l, a), y = this.evaluate(1, u, a), S = v.subtract(r), L = p.dot(p) + S.dot(y);
        return P.isMachineZero(L) ? a : a - S.dot(p) / L;
      },
      evaluate: function(i, r, a) {
        for (var l = r.slice(), u = 1; u <= i; u++)
          for (var d = 0; d <= i - u; d++)
            l[d] = l[d].multiply(1 - a).add(l[d + 1].multiply(a));
        return l[0];
      },
      chordLengthParameterize: function(i, r) {
        for (var a = [0], l = i + 1; l <= r; l++)
          a[l - i] = a[l - i - 1] + this.points[l].getDistance(this.points[l - 1]);
        for (var l = 1, u = r - i; l <= u; l++)
          a[l] /= a[u];
        return a;
      },
      findMaxError: function(i, r, a, l) {
        for (var u = Math.floor((r - i + 1) / 2), d = 0, v = i + 1; v < r; v++) {
          var p = this.evaluate(3, a, l[v - i]), y = p.subtract(this.points[v]), S = y.x * y.x + y.y * y.y;
          S >= d && (d = S, u = v);
        }
        return {
          error: d,
          index: u
        };
      }
    }), Kt = X.extend({
      _class: "TextItem",
      _applyMatrix: !1,
      _canApplyMatrix: !1,
      _serializeFields: {
        content: null
      },
      _boundsOptions: { stroke: !1, handle: !1 },
      initialize: function(r) {
        this._content = "", this._lines = [];
        var a = r && o.isPlainObject(r) && r.x === t && r.y === t;
        this._initialize(a && r, !a && M.read(arguments));
      },
      _equals: function(i) {
        return this._content === i._content;
      },
      copyContent: function(i) {
        this.setContent(i._content);
      },
      getContent: function() {
        return this._content;
      },
      setContent: function(i) {
        this._content = "" + i, this._lines = this._content.split(/\r\n|\n|\r/mg), this._changed(521);
      },
      isEmpty: function() {
        return !this._content;
      },
      getCharacterStyle: "#getStyle",
      setCharacterStyle: "#setStyle",
      getParagraphStyle: "#getStyle",
      setParagraphStyle: "#setStyle"
    }), qt = Kt.extend({
      _class: "PointText",
      initialize: function() {
        Kt.apply(this, arguments);
      },
      getPoint: function() {
        var i = this._matrix.getTranslation();
        return new Z(i.x, i.y, this, "setPoint");
      },
      setPoint: function() {
        var i = M.read(arguments);
        this.translate(i.subtract(this._matrix.getTranslation()));
      },
      _draw: function(i, r, a) {
        if (this._content) {
          this._setStyles(i, r, a);
          var l = this._lines, u = this._style, d = u.hasFill(), v = u.hasStroke(), p = u.getLeading(), y = i.shadowColor;
          i.font = u.getFontStyle(), i.textAlign = u.getJustification();
          for (var S = 0, L = l.length; S < L; S++) {
            i.shadowColor = y;
            var E = l[S];
            d && (i.fillText(E, 0, 0), i.shadowColor = "rgba(0,0,0,0)"), v && i.strokeText(E, 0, 0), i.translate(0, p);
          }
        }
      },
      _getBounds: function(i, r) {
        var a = this._style, l = this._lines, u = l.length, d = a.getJustification(), v = a.getLeading(), p = this.getView().getTextWidth(a.getFontStyle(), l), y = 0;
        d !== "left" && (y -= p / (d === "center" ? 2 : 1));
        var S = new D(
          y,
          u ? -0.75 * v : 0,
          p,
          u * v
        );
        return i ? i._transformBounds(S, S) : S;
      }
    }), Lt = o.extend(
      new function() {
        var i = {
          gray: ["gray"],
          rgb: ["red", "green", "blue"],
          hsb: ["hue", "saturation", "brightness"],
          hsl: ["hue", "saturation", "lightness"],
          gradient: ["gradient", "origin", "destination", "highlight"]
        }, r = {}, a = {
          transparent: [0, 0, 0, 0]
        }, l;
        function u(p) {
          var y = p.match(
            /^#([\da-f]{2})([\da-f]{2})([\da-f]{2})([\da-f]{2})?$/i
          ) || p.match(
            /^#([\da-f])([\da-f])([\da-f])([\da-f])?$/i
          ), S = "rgb", L;
          if (y) {
            var E = y[4] ? 4 : 3;
            L = new Array(E);
            for (var A = 0; A < E; A++) {
              var T = y[A + 1];
              L[A] = parseInt(T.length == 1 ? T + T : T, 16) / 255;
            }
          } else if (y = p.match(/^(rgb|hsl)a?\((.*)\)$/)) {
            S = y[1], L = y[2].trim().split(/[,\s]+/g);
            for (var G = S === "hsl", A = 0, R = Math.min(L.length, 4); A < R; A++) {
              var Y = L[A], T = parseFloat(Y);
              if (G)
                if (A === 0) {
                  var k = Y.match(/([a-z]*)$/)[1];
                  T *= {
                    turn: 360,
                    rad: 180 / Math.PI,
                    grad: 0.9
                  }[k] || 1;
                } else
                  A < 3 && (T /= 100);
              else
                A < 3 && (T /= /%$/.test(Y) ? 100 : 255);
              L[A] = T;
            }
          } else {
            var z = a[p];
            if (!z)
              if (n) {
                l || (l = mt.getContext(1, 1, {
                  willReadFrequently: !0
                }), l.globalCompositeOperation = "copy"), l.fillStyle = "rgba(0,0,0,0)", l.fillStyle = p, l.fillRect(0, 0, 1, 1);
                var C = l.getImageData(0, 0, 1, 1).data;
                z = a[p] = [
                  C[0] / 255,
                  C[1] / 255,
                  C[2] / 255
                ];
              } else
                z = [0, 0, 0];
            L = z.slice();
          }
          return [S, L];
        }
        var d = [
          [0, 3, 1],
          [2, 0, 1],
          [1, 0, 3],
          [1, 2, 0],
          [3, 1, 0],
          [0, 1, 2]
        ], v = {
          "rgb-hsb": function(p, y, S) {
            var L = Math.max(p, y, S), E = Math.min(p, y, S), A = L - E, T = A === 0 ? 0 : (L == p ? (y - S) / A + (y < S ? 6 : 0) : L == y ? (S - p) / A + 2 : (p - y) / A + 4) * 60;
            return [T, L === 0 ? 0 : A / L, L];
          },
          "hsb-rgb": function(p, y, S) {
            p = (p / 60 % 6 + 6) % 6;
            var E = Math.floor(p), L = p - E, E = d[E], A = [
              S,
              S * (1 - y),
              S * (1 - y * L),
              S * (1 - y * (1 - L))
            ];
            return [A[E[0]], A[E[1]], A[E[2]]];
          },
          "rgb-hsl": function(p, y, S) {
            var L = Math.max(p, y, S), E = Math.min(p, y, S), A = L - E, T = A === 0, G = T ? 0 : (L == p ? (y - S) / A + (y < S ? 6 : 0) : L == y ? (S - p) / A + 2 : (p - y) / A + 4) * 60, R = (L + E) / 2, Y = T ? 0 : R < 0.5 ? A / (L + E) : A / (2 - L - E);
            return [G, Y, R];
          },
          "hsl-rgb": function(p, y, S) {
            if (p = (p / 360 % 1 + 1) % 1, y === 0)
              return [S, S, S];
            for (var L = [p + 1 / 3, p, p - 1 / 3], E = S < 0.5 ? S * (1 + y) : S + y - S * y, A = 2 * S - E, T = [], G = 0; G < 3; G++) {
              var R = L[G];
              R < 0 && (R += 1), R > 1 && (R -= 1), T[G] = 6 * R < 1 ? A + (E - A) * 6 * R : 2 * R < 1 ? E : 3 * R < 2 ? A + (E - A) * (2 / 3 - R) * 6 : A;
            }
            return T;
          },
          "rgb-gray": function(p, y, S) {
            return [p * 0.2989 + y * 0.587 + S * 0.114];
          },
          "gray-rgb": function(p) {
            return [p, p, p];
          },
          "gray-hsb": function(p) {
            return [0, 0, p];
          },
          "gray-hsl": function(p) {
            return [0, 0, p];
          },
          "gradient-rgb": function() {
            return [];
          },
          "rgb-gradient": function() {
            return [];
          }
        };
        return o.each(i, function(p, y) {
          r[y] = [], o.each(p, function(S, L) {
            var E = o.capitalize(S), A = /^(hue|saturation)$/.test(S), T = r[y][L] = y === "gradient" ? S === "gradient" ? function(G) {
              var R = this._components[0];
              return G = Ci.read(
                Array.isArray(G) ? G : arguments,
                0,
                { readNull: !0 }
              ), R !== G && (R && R._removeOwner(this), G && G._addOwner(this)), G;
            } : function() {
              return M.read(arguments, 0, {
                readNull: S === "highlight",
                clone: !0
              });
            } : function(G) {
              return G == null || isNaN(G) ? 0 : +G;
            };
            this["get" + E] = function() {
              return this._type === y || A && /^hs[bl]$/.test(this._type) ? this._components[L] : this._convert(y)[L];
            }, this["set" + E] = function(G) {
              this._type !== y && !(A && /^hs[bl]$/.test(this._type)) && (this._components = this._convert(y), this._properties = i[y], this._type = y), this._components[L] = T.call(this, G), this._changed();
            };
          }, this);
        }, {
          _class: "Color",
          _readIndex: !0,
          initialize: function p(y) {
            var S = arguments, L = this.__read, E = 0, A, T, G, R;
            Array.isArray(y) && (S = y, y = S[0]);
            var Y = y != null && typeof y;
            if (Y === "string" && y in i && (A = y, y = S[1], Array.isArray(y) ? (T = y, G = S[2]) : (L && (E = 1), S = o.slice(S, 1), Y = typeof y)), !T) {
              if (R = Y === "number" ? S : Y === "object" && y.length != null ? y : null, R) {
                A || (A = R.length >= 3 ? "rgb" : "gray");
                var k = i[A].length;
                G = R[k], L && (E += R === arguments ? k + (G != null ? 1 : 0) : 1), R.length > k && (R = o.slice(R, 0, k));
              } else if (Y === "string") {
                var z = u(y);
                A = z[0], T = z[1], T.length === 4 && (G = T[3], T.length--);
              } else if (Y === "object")
                if (y.constructor === p) {
                  if (A = y._type, T = y._components.slice(), G = y._alpha, A === "gradient")
                    for (var C = 1, I = T.length; C < I; C++) {
                      var j = T[C];
                      j && (T[C] = j.clone());
                    }
                } else if (y.constructor === Ci)
                  A = "gradient", R = S;
                else {
                  A = "hue" in y ? "lightness" in y ? "hsl" : "hsb" : "gradient" in y || "stops" in y || "radial" in y ? "gradient" : "gray" in y ? "gray" : "rgb";
                  var q = i[A], H = r[A];
                  this._components = T = [];
                  for (var C = 0, I = q.length; C < I; C++) {
                    var ie = y[q[C]];
                    ie == null && !C && A === "gradient" && "stops" in y && (ie = {
                      stops: y.stops,
                      radial: y.radial
                    }), ie = H[C].call(this, ie), ie != null && (T[C] = ie);
                  }
                  G = y.alpha;
                }
              L && A && (E = 1);
            }
            if (this._type = A || "rgb", !T) {
              this._components = T = [];
              for (var H = r[this._type], C = 0, I = H.length; C < I; C++) {
                var ie = H[C].call(this, R && R[C]);
                ie != null && (T[C] = ie);
              }
            }
            return this._components = T, this._properties = i[this._type], this._alpha = G, L && (this.__read = E), this;
          },
          set: "#initialize",
          _serialize: function(p, y) {
            var S = this.getComponents();
            return o.serialize(
              /^(gray|rgb)$/.test(this._type) ? S : [this._type].concat(S),
              p,
              !0,
              y
            );
          },
          _changed: function() {
            this._canvasStyle = null, this._owner && (this._setter ? this._owner[this._setter](this) : this._owner._changed(129));
          },
          _convert: function(p) {
            var y;
            return this._type === p ? this._components.slice() : (y = v[this._type + "-" + p]) ? y.apply(this, this._components) : v["rgb-" + p].apply(
              this,
              v[this._type + "-rgb"].apply(
                this,
                this._components
              )
            );
          },
          convert: function(p) {
            return new Lt(p, this._convert(p), this._alpha);
          },
          getType: function() {
            return this._type;
          },
          setType: function(p) {
            this._components = this._convert(p), this._properties = i[p], this._type = p;
          },
          getComponents: function() {
            var p = this._components.slice();
            return this._alpha != null && p.push(this._alpha), p;
          },
          getAlpha: function() {
            return this._alpha != null ? this._alpha : 1;
          },
          setAlpha: function(p) {
            this._alpha = p == null ? null : Math.min(Math.max(p, 0), 1), this._changed();
          },
          hasAlpha: function() {
            return this._alpha != null;
          },
          equals: function(p) {
            var y = o.isPlainValue(p, !0) ? Lt.read(arguments) : p;
            return y === this || y && this._class === y._class && this._type === y._type && this.getAlpha() === y.getAlpha() && o.equals(this._components, y._components) || !1;
          },
          toString: function() {
            for (var p = this._properties, y = [], S = this._type === "gradient", L = B.instance, E = 0, A = p.length; E < A; E++) {
              var T = this._components[E];
              T != null && y.push(p[E] + ": " + (S ? T : L.number(T)));
            }
            return this._alpha != null && y.push("alpha: " + L.number(this._alpha)), "{ " + y.join(", ") + " }";
          },
          toCSS: function(p) {
            var y = this._convert("rgb"), S = p || this._alpha == null ? 1 : this._alpha;
            function L(E) {
              return Math.round((E < 0 ? 0 : E > 1 ? 1 : E) * 255);
            }
            return y = [
              L(y[0]),
              L(y[1]),
              L(y[2])
            ], S < 1 && y.push(S < 0 ? 0 : S), p ? "#" + ((1 << 24) + (y[0] << 16) + (y[1] << 8) + y[2]).toString(16).slice(1) : (y.length == 4 ? "rgba(" : "rgb(") + y.join(",") + ")";
          },
          toCanvasStyle: function(p, y) {
            if (this._canvasStyle)
              return this._canvasStyle;
            if (this._type !== "gradient")
              return this._canvasStyle = this.toCSS();
            var S = this._components, L = S[0], E = L._stops, A = S[1], T = S[2], G = S[3], R = y && y.inverted(), Y;
            if (R && (A = R._transformPoint(A), T = R._transformPoint(T), G && (G = R._transformPoint(G))), L._radial) {
              var k = T.getDistance(A);
              if (G) {
                var z = G.subtract(A);
                z.getLength() > k && (G = A.add(z.normalize(k - 0.1)));
              }
              var C = G || A;
              Y = p.createRadialGradient(
                C.x,
                C.y,
                0,
                A.x,
                A.y,
                k
              );
            } else
              Y = p.createLinearGradient(
                A.x,
                A.y,
                T.x,
                T.y
              );
            for (var I = 0, j = E.length; I < j; I++) {
              var q = E[I], H = q._offset;
              Y.addColorStop(
                H ?? I / (j - 1),
                q._color.toCanvasStyle()
              );
            }
            return this._canvasStyle = Y;
          },
          transform: function(p) {
            if (this._type === "gradient") {
              for (var y = this._components, S = 1, L = y.length; S < L; S++) {
                var E = y[S];
                p._transformPoint(E, E, !0);
              }
              this._changed();
            }
          },
          statics: {
            _types: i,
            random: function() {
              var p = Math.random;
              return new Lt(p(), p(), p());
            },
            _setOwner: function(p, y, S) {
              return p && (p._owner && y && p._owner !== y && (p = p.clone()), !p._owner ^ !y && (p._owner = y || null, p._setter = S || null)), p;
            }
          }
        });
      }(),
      new function() {
        var i = {
          add: function(r, a) {
            return r + a;
          },
          subtract: function(r, a) {
            return r - a;
          },
          multiply: function(r, a) {
            return r * a;
          },
          divide: function(r, a) {
            return r / a;
          }
        };
        return o.each(i, function(r, a) {
          this[a] = function(l) {
            l = Lt.read(arguments);
            for (var u = this._type, d = this._components, v = l._convert(u), p = 0, y = d.length; p < y; p++)
              v[p] = r(d[p], v[p]);
            return new Lt(
              u,
              v,
              this._alpha != null ? r(this._alpha, l.getAlpha()) : null
            );
          };
        }, {});
      }()
    ), Ci = o.extend({
      _class: "Gradient",
      initialize: function(r, a) {
        this._id = U.get(), r && o.isPlainObject(r) && (this.set(r), r = a = null), this._stops == null && this.setStops(r || ["white", "black"]), this._radial == null && this.setRadial(typeof a == "string" && a === "radial" || a || !1);
      },
      _serialize: function(i, r) {
        return r.add(this, function() {
          return o.serialize(
            [this._stops, this._radial],
            i,
            !0,
            r
          );
        });
      },
      _changed: function() {
        for (var i = 0, r = this._owners && this._owners.length; i < r; i++)
          this._owners[i]._changed();
      },
      _addOwner: function(i) {
        this._owners || (this._owners = []), this._owners.push(i);
      },
      _removeOwner: function(i) {
        var r = this._owners ? this._owners.indexOf(i) : -1;
        r != -1 && (this._owners.splice(r, 1), this._owners.length || (this._owners = t));
      },
      clone: function() {
        for (var i = [], r = 0, a = this._stops.length; r < a; r++)
          i[r] = this._stops[r].clone();
        return new Ci(i, this._radial);
      },
      getStops: function() {
        return this._stops;
      },
      setStops: function(i) {
        if (i.length < 2)
          throw new Error(
            "Gradient stop list needs to contain at least two stops."
          );
        var r = this._stops;
        if (r)
          for (var a = 0, l = r.length; a < l; a++)
            r[a]._owner = t;
        r = this._stops = ji.readList(i, 0, { clone: !0 });
        for (var a = 0, l = r.length; a < l; a++)
          r[a]._owner = this;
        this._changed();
      },
      getRadial: function() {
        return this._radial;
      },
      setRadial: function(i) {
        this._radial = i, this._changed();
      },
      equals: function(i) {
        if (i === this)
          return !0;
        if (i && this._class === i._class) {
          var r = this._stops, a = i._stops, l = r.length;
          if (l === a.length) {
            for (var u = 0; u < l; u++)
              if (!r[u].equals(a[u]))
                return !1;
            return !0;
          }
        }
        return !1;
      }
    }), ji = o.extend({
      _class: "GradientStop",
      initialize: function(r, a) {
        var l = r, u = a;
        typeof r == "object" && a === t && (Array.isArray(r) && typeof r[0] != "number" ? (l = r[0], u = r[1]) : ("color" in r || "offset" in r || "rampPoint" in r) && (l = r.color, u = r.offset || r.rampPoint || 0)), this.setColor(l), this.setOffset(u);
      },
      clone: function() {
        return new ji(this._color.clone(), this._offset);
      },
      _serialize: function(i, r) {
        var a = this._color, l = this._offset;
        return o.serialize(
          l == null ? [a] : [a, l],
          i,
          !0,
          r
        );
      },
      _changed: function() {
        this._owner && this._owner._changed(129);
      },
      getOffset: function() {
        return this._offset;
      },
      setOffset: function(i) {
        this._offset = i, this._changed();
      },
      getRampPoint: "#getOffset",
      setRampPoint: "#setOffset",
      getColor: function() {
        return this._color;
      },
      setColor: function() {
        Lt._setOwner(this._color, null), this._color = Lt._setOwner(
          Lt.read(arguments, 0),
          this,
          "setColor"
        ), this._changed();
      },
      equals: function(i) {
        return i === this || i && this._class === i._class && this._color.equals(i._color) && this._offset == i._offset || !1;
      }
    }), _i = o.extend(new function() {
      var i = {
        fillColor: null,
        fillRule: "nonzero",
        strokeColor: null,
        strokeWidth: 1,
        strokeCap: "butt",
        strokeJoin: "miter",
        strokeScaling: !0,
        miterLimit: 10,
        dashOffset: 0,
        dashArray: [],
        shadowColor: null,
        shadowBlur: 0,
        shadowOffset: new M(),
        selectedColor: null
      }, r = o.set({}, i, {
        fontFamily: "sans-serif",
        fontWeight: "normal",
        fontSize: 12,
        leading: null,
        justification: "left"
      }), a = o.set({}, r, {
        fillColor: new Lt()
      }), l = {
        strokeWidth: 193,
        strokeCap: 193,
        strokeJoin: 193,
        strokeScaling: 201,
        miterLimit: 193,
        fontFamily: 9,
        fontWeight: 9,
        fontSize: 9,
        font: 9,
        leading: 9,
        justification: 9
      }, u = {
        beans: !0
      }, d = {
        _class: "Style",
        beans: !0,
        initialize: function(p, y, S) {
          this._values = {}, this._owner = y, this._project = y && y._project || S || He.project, this._defaults = !y || y instanceof W ? r : y instanceof Kt ? a : i, p && this.set(p);
        }
      };
      return o.each(r, function(v, p) {
        var y = /Color$/.test(p), S = p === "shadowOffset", L = o.capitalize(p), E = l[p], A = "set" + L, T = "get" + L;
        d[A] = function(G) {
          var R = this._owner, Y = R && R._children, k = Y && Y.length > 0 && !(R instanceof It);
          if (k)
            for (var z = 0, C = Y.length; z < C; z++)
              Y[z]._style[A](G);
          if ((p === "selectedColor" || !k) && p in this._defaults) {
            var I = this._values[p];
            I !== G && (y && (I && (Lt._setOwner(I, null), I._canvasStyle = null), G && G.constructor === Lt && (G = Lt._setOwner(
              G,
              R,
              k && A
            ))), this._values[p] = G, R && R._changed(E || 129));
          }
        }, d[T] = function(G) {
          var R = this._owner, Y = R && R._children, k = Y && Y.length > 0 && !(R instanceof It), z;
          if (k && !G)
            for (var C = 0, I = Y.length; C < I; C++) {
              var j = Y[C]._style[T]();
              if (!C)
                z = j;
              else if (!o.equals(z, j))
                return t;
            }
          else if (p in this._defaults) {
            var z = this._values[p];
            if (z === t)
              z = this._defaults[p], z && z.clone && (z = z.clone());
            else {
              var q = y ? Lt : S ? M : null;
              q && !(z && z.constructor === q) && (this._values[p] = z = q.read(
                [z],
                0,
                { readNull: !0, clone: !0 }
              ));
            }
          }
          return z && y && (z = Lt._setOwner(z, R, k && A)), z;
        }, u[T] = function(G) {
          return this._style[T](G);
        }, u[A] = function(G) {
          this._style[A](G);
        };
      }), o.each({
        Font: "FontFamily",
        WindingRule: "FillRule"
      }, function(v, p) {
        var y = "get" + p, S = "set" + p;
        d[y] = u[y] = "#get" + v, d[S] = u[S] = "#set" + v;
      }), X.inject(u), d;
    }(), {
      set: function(i) {
        var r = i instanceof _i, a = r ? i._values : i;
        if (a) {
          for (var l in a)
            if (l in this._defaults) {
              var u = a[l];
              this[l] = u && r && u.clone ? u.clone() : u;
            }
        }
      },
      equals: function(i) {
        function r(a, l, u) {
          var d = a._values, v = l._values, p = l._defaults;
          for (var y in d) {
            var S = d[y], L = v[y];
            if (!(u && y in v) && !o.equals(
              S,
              L === t ? p[y] : L
            ))
              return !1;
          }
          return !0;
        }
        return i === this || i && this._class === i._class && r(this, i) && r(i, this, !0) || !1;
      },
      _dispose: function() {
        var i;
        i = this.getFillColor(), i && (i._canvasStyle = null), i = this.getStrokeColor(), i && (i._canvasStyle = null), i = this.getShadowColor(), i && (i._canvasStyle = null);
      },
      hasFill: function() {
        var i = this.getFillColor();
        return !!i && i.alpha > 0;
      },
      hasStroke: function() {
        var i = this.getStrokeColor();
        return !!i && i.alpha > 0 && this.getStrokeWidth() > 0;
      },
      hasShadow: function() {
        var i = this.getShadowColor();
        return !!i && i.alpha > 0 && (this.getShadowBlur() > 0 || !this.getShadowOffset().isZero());
      },
      getView: function() {
        return this._project._view;
      },
      getFontStyle: function() {
        var i = this.getFontSize();
        return this.getFontWeight() + " " + i + (/[a-z]/i.test(i + "") ? " " : "px ") + this.getFontFamily();
      },
      getFont: "#getFontFamily",
      setFont: "#setFontFamily",
      getLeading: function i() {
        var r = i.base.call(this), a = this.getFontSize();
        return /pt|em|%|px/.test(a) && (a = this.getView().getPixelSize(a)), r ?? a * 1.2;
      }
    }), Wt = new function() {
      function i(r, a, l, u) {
        for (var d = ["", "webkit", "moz", "Moz", "ms", "o"], v = a[0].toUpperCase() + a.substring(1), p = 0; p < 6; p++) {
          var y = d[p], S = y ? y + v : a;
          if (S in r) {
            if (l)
              r[S] = u;
            else
              return r[S];
            break;
          }
        }
      }
      return {
        getStyles: function(r) {
          var a = r && r.nodeType !== 9 ? r.ownerDocument : r, l = a && a.defaultView;
          return l && l.getComputedStyle(r, "");
        },
        getBounds: function(r, a) {
          var l = r.ownerDocument, u = l.body, d = l.documentElement, v;
          try {
            v = r.getBoundingClientRect();
          } catch {
            v = { left: 0, top: 0, width: 0, height: 0 };
          }
          var p = v.left - (d.clientLeft || u.clientLeft || 0), y = v.top - (d.clientTop || u.clientTop || 0);
          if (!a) {
            var S = l.defaultView;
            p += S.pageXOffset || d.scrollLeft || u.scrollLeft, y += S.pageYOffset || d.scrollTop || u.scrollTop;
          }
          return new D(p, y, v.width, v.height);
        },
        getViewportBounds: function(r) {
          var a = r.ownerDocument, l = a.defaultView, u = a.documentElement;
          return new D(
            0,
            0,
            l.innerWidth || u.clientWidth,
            l.innerHeight || u.clientHeight
          );
        },
        getOffset: function(r, a) {
          return Wt.getBounds(r, a).getPoint();
        },
        getSize: function(r) {
          return Wt.getBounds(r, !0).getSize();
        },
        isInvisible: function(r) {
          return Wt.getSize(r).equals(new F(0, 0));
        },
        isInView: function(r) {
          return !Wt.isInvisible(r) && Wt.getViewportBounds(r).intersects(
            Wt.getBounds(r, !0)
          );
        },
        isInserted: function(r) {
          return s.body.contains(r);
        },
        getPrefixed: function(r, a) {
          return r && i(r, a);
        },
        setPrefixed: function(r, a, l) {
          if (typeof a == "object")
            for (var u in a)
              i(r, u, !0, a[u]);
          else
            i(r, a, !0, l);
        }
      };
    }(), $t = {
      add: function(i, r) {
        if (i)
          for (var a in r)
            for (var l = r[a], u = a.split(/[\s,]+/g), d = 0, v = u.length; d < v; d++) {
              var p = u[d], y = i === s && (p === "touchstart" || p === "touchmove") ? { passive: !1 } : !1;
              i.addEventListener(p, l, y);
            }
      },
      remove: function(i, r) {
        if (i)
          for (var a in r)
            for (var l = r[a], u = a.split(/[\s,]+/g), d = 0, v = u.length; d < v; d++)
              i.removeEventListener(u[d], l, !1);
      },
      getPoint: function(i) {
        var r = i.targetTouches ? i.targetTouches.length ? i.targetTouches[0] : i.changedTouches[0] : i;
        return new M(
          r.pageX || r.clientX + s.documentElement.scrollLeft,
          r.pageY || r.clientY + s.documentElement.scrollTop
        );
      },
      getTarget: function(i) {
        return i.target || i.srcElement;
      },
      getRelatedTarget: function(i) {
        return i.relatedTarget || i.toElement;
      },
      getOffset: function(i, r) {
        return $t.getPoint(i).subtract(Wt.getOffset(
          r || $t.getTarget(i)
        ));
      }
    };
    $t.requestAnimationFrame = new function() {
      var i = Wt.getPrefixed(n, "requestAnimationFrame"), r = !1, a = [], l;
      function u() {
        var d = a;
        a = [];
        for (var v = 0, p = d.length; v < p; v++)
          d[v]();
        r = i && a.length, r && i(u);
      }
      return function(d) {
        a.push(d), i ? r || (i(u), r = !0) : l || (l = setInterval(u, 1e3 / 60));
      };
    }();
    var ei = o.extend(
      h,
      {
        _class: "View",
        initialize: function i(r, a) {
          function l(E) {
            return a[E] || parseInt(a.getAttribute(E), 10);
          }
          function u() {
            var E = Wt.getSize(a);
            return E.isNaN() || E.isZero() ? new F(l("width"), l("height")) : E;
          }
          var d;
          if (n && a) {
            this._id = a.getAttribute("id"), this._id == null && a.setAttribute("id", this._id = "paper-view-" + i._id++), $t.add(a, this._viewEvents);
            var v = "none";
            if (Wt.setPrefixed(a.style, {
              userDrag: v,
              userSelect: v,
              touchCallout: v,
              contentZooming: v,
              tapHighlightColor: "rgba(0,0,0,0)"
            }), c.hasAttribute(a, "resize")) {
              var p = this;
              $t.add(n, this._windowEvents = {
                resize: function() {
                  p.setViewSize(u());
                }
              });
            }
            if (d = u(), c.hasAttribute(a, "stats") && typeof Stats < "u") {
              this._stats = new Stats();
              var y = this._stats.domElement, S = y.style, L = Wt.getOffset(a);
              S.position = "absolute", S.left = L.x + "px", S.top = L.y + "px", s.body.appendChild(y);
            }
          } else
            d = new F(a), a = null;
          this._project = r, this._scope = r._scope, this._element = a, this._pixelRatio || (this._pixelRatio = n && n.devicePixelRatio || 1), this._setElementSize(d.width, d.height), this._viewSize = d, i._views.push(this), i._viewsById[this._id] = this, (this._matrix = new ee())._owner = this, i._focused || (i._focused = this), this._frameItems = {}, this._frameItemCount = 0, this._itemEvents = { native: {}, virtual: {} }, this._autoUpdate = !He.agent.node, this._needsUpdate = !1;
        },
        remove: function() {
          if (!this._project)
            return !1;
          ei._focused === this && (ei._focused = null), ei._views.splice(ei._views.indexOf(this), 1), delete ei._viewsById[this._id];
          var i = this._project;
          return i._view === this && (i._view = null), $t.remove(this._element, this._viewEvents), $t.remove(n, this._windowEvents), this._element = this._project = null, this.off("frame"), this._animate = !1, this._frameItems = {}, !0;
        },
        _events: o.each(
          X._itemHandlers.concat(["onResize", "onKeyDown", "onKeyUp"]),
          function(i) {
            this[i] = {};
          },
          {
            onFrame: {
              install: function() {
                this.play();
              },
              uninstall: function() {
                this.pause();
              }
            }
          }
        ),
        _animate: !1,
        _time: 0,
        _count: 0,
        getAutoUpdate: function() {
          return this._autoUpdate;
        },
        setAutoUpdate: function(i) {
          this._autoUpdate = i, i && this.requestUpdate();
        },
        update: function() {
        },
        draw: function() {
          this.update();
        },
        requestUpdate: function() {
          if (!this._requested) {
            var i = this;
            $t.requestAnimationFrame(function() {
              if (i._requested = !1, i._animate) {
                i.requestUpdate();
                var r = i._element;
                (!Wt.getPrefixed(s, "hidden") || c.getAttribute(r, "keepalive") === "true") && Wt.isInView(r) && i._handleFrame();
              }
              i._autoUpdate && i.update();
            }), this._requested = !0;
          }
        },
        play: function() {
          this._animate = !0, this.requestUpdate();
        },
        pause: function() {
          this._animate = !1;
        },
        _handleFrame: function() {
          He = this._scope;
          var i = Date.now() / 1e3, r = this._last ? i - this._last : 0;
          this._last = i, this.emit("frame", new o({
            delta: r,
            time: this._time += r,
            count: this._count++
          })), this._stats && this._stats.update();
        },
        _animateItem: function(i, r) {
          var a = this._frameItems;
          r ? (a[i._id] = {
            item: i,
            time: 0,
            count: 0
          }, ++this._frameItemCount === 1 && this.on("frame", this._handleFrameItems)) : (delete a[i._id], --this._frameItemCount === 0 && this.off("frame", this._handleFrameItems));
        },
        _handleFrameItems: function(i) {
          for (var r in this._frameItems) {
            var a = this._frameItems[r];
            a.item.emit("frame", new o(i, {
              time: a.time += i.delta,
              count: a.count++
            }));
          }
        },
        _changed: function() {
          this._project._changed(4097), this._bounds = this._decomposed = t;
        },
        getElement: function() {
          return this._element;
        },
        getPixelRatio: function() {
          return this._pixelRatio;
        },
        getResolution: function() {
          return this._pixelRatio * 72;
        },
        getViewSize: function() {
          var i = this._viewSize;
          return new Q(i.width, i.height, this, "setViewSize");
        },
        setViewSize: function() {
          var i = F.read(arguments), r = i.subtract(this._viewSize);
          r.isZero() || (this._setElementSize(i.width, i.height), this._viewSize.set(i), this._changed(), this.emit("resize", { size: i, delta: r }), this._autoUpdate && this.update());
        },
        _setElementSize: function(i, r) {
          var a = this._element;
          a && (a.width !== i && (a.width = i), a.height !== r && (a.height = r));
        },
        getBounds: function() {
          return this._bounds || (this._bounds = this._matrix.inverted()._transformBounds(
            new D(new M(), this._viewSize)
          )), this._bounds;
        },
        getSize: function() {
          return this.getBounds().getSize();
        },
        isVisible: function() {
          return Wt.isInView(this._element);
        },
        isInserted: function() {
          return Wt.isInserted(this._element);
        },
        getPixelSize: function(i) {
          var r = this._element, a;
          if (r) {
            var l = r.parentNode, u = s.createElement("div");
            u.style.fontSize = i, l.appendChild(u), a = parseFloat(Wt.getStyles(u).fontSize), l.removeChild(u);
          } else
            a = parseFloat(a);
          return a;
        },
        getTextWidth: function(i, r) {
          return 0;
        }
      },
      o.each(["rotate", "scale", "shear", "skew"], function(i) {
        var r = i === "rotate";
        this[i] = function() {
          var a = arguments, l = (r ? o : M).read(a), u = M.read(a, 0, { readNull: !0 });
          return this.transform(new ee()[i](
            l,
            u || this.getCenter(!0)
          ));
        };
      }, {
        _decompose: function() {
          return this._decomposed || (this._decomposed = this._matrix.decompose());
        },
        translate: function() {
          var i = new ee();
          return this.transform(i.translate.apply(i, arguments));
        },
        getCenter: function() {
          return this.getBounds().getCenter();
        },
        setCenter: function() {
          var i = M.read(arguments);
          this.translate(this.getCenter().subtract(i));
        },
        getZoom: function() {
          var i = this._decompose().scaling;
          return (i.x + i.y) / 2;
        },
        setZoom: function(i) {
          this.transform(new ee().scale(
            i / this.getZoom(),
            this.getCenter()
          ));
        },
        getRotation: function() {
          return this._decompose().rotation;
        },
        setRotation: function(i) {
          var r = this.getRotation();
          r != null && i != null && this.rotate(i - r);
        },
        getScaling: function() {
          var i = this._decompose().scaling;
          return new Z(i.x, i.y, this, "setScaling");
        },
        setScaling: function() {
          var i = this.getScaling(), r = M.read(arguments, 0, { clone: !0, readNull: !0 });
          i && r && this.scale(r.x / i.x, r.y / i.y);
        },
        getMatrix: function() {
          return this._matrix;
        },
        setMatrix: function() {
          var i = this._matrix;
          i.set.apply(i, arguments);
        },
        transform: function(i) {
          this._matrix.append(i);
        },
        scrollBy: function() {
          this.translate(M.read(arguments).negate());
        }
      }),
      {
        projectToView: function() {
          return this._matrix._transformPoint(M.read(arguments));
        },
        viewToProject: function() {
          return this._matrix._inverseTransform(M.read(arguments));
        },
        getEventPoint: function(i) {
          return this.viewToProject($t.getOffset(i, this._element));
        }
      },
      {
        statics: {
          _views: [],
          _viewsById: {},
          _id: 0,
          create: function(i, r) {
            s && typeof r == "string" && (r = s.getElementById(r));
            var a = n ? tn : ei;
            return new a(i, r);
          }
        }
      },
      new function() {
        if (!n)
          return;
        var i, r, a = !1, l = !1;
        function u(se) {
          var de = $t.getTarget(se);
          return de.getAttribute && ei._viewsById[de.getAttribute("id")];
        }
        function d() {
          var se = ei._focused;
          if (!se || !se.isVisible()) {
            for (var de = 0, ve = ei._views.length; de < ve; de++)
              if ((se = ei._views[de]).isVisible()) {
                ei._focused = r = se;
                break;
              }
          }
        }
        function v(se, de, ve) {
          se._handleMouseEvent("mousemove", de, ve);
        }
        var p = n.navigator, y, S, L;
        p.pointerEnabled || p.msPointerEnabled ? (y = "pointerdown MSPointerDown", S = "pointermove MSPointerMove", L = "pointerup pointercancel MSPointerUp MSPointerCancel") : (y = "touchstart", S = "touchmove", L = "touchend touchcancel", "ontouchstart" in n && p.userAgent.match(
          /mobile|tablet|ip(ad|hone|od)|android|silk/i
        ) || (y += " mousedown", S += " mousemove", L += " mouseup"));
        var E = {}, A = {
          mouseout: function(se) {
            var de = ei._focused, ve = $t.getRelatedTarget(se);
            if (de && (!ve || ve.nodeName === "HTML")) {
              var we = $t.getOffset(se, de._element), Se = we.x, Ae = Math.abs, Ge = Ae(Se), Je = 1 << 25, it = Ge - Je;
              we.x = Ae(it) < Ge ? it * (Se < 0 ? -1 : 1) : Se, v(de, se, de.viewToProject(we));
            }
          },
          scroll: d
        };
        E[y] = function(se) {
          var de = ei._focused = u(se);
          a || (a = !0, de._handleMouseEvent("mousedown", se));
        }, A[S] = function(se) {
          var de = ei._focused;
          if (!l) {
            var ve = u(se);
            ve ? de !== ve && (de && v(de, se), i || (i = de), de = ei._focused = r = ve) : r && r === de && (i && !i.isInserted() && (i = null), de = ei._focused = i, i = null, d());
          }
          de && v(de, se);
        }, A[y] = function() {
          l = !0;
        }, A[L] = function(se) {
          var de = ei._focused;
          de && a && de._handleMouseEvent("mouseup", se), l = a = !1;
        }, $t.add(s, A), $t.add(n, {
          load: d
        });
        var T = !1, G = !1, R = {
          doubleclick: "click",
          mousedrag: "mousemove"
        }, Y = !1, k, z, C, I, j, q, H, ie;
        function ae(se, de, ve, we, Se, Ae, Ge) {
          var Je = !1, it;
          function gt(Ne, Fe) {
            if (Ne.responds(Fe)) {
              if (it || (it = new yt(
                Fe,
                we,
                Se,
                de || Ne,
                Ae ? Se.subtract(Ae) : null
              )), Ne.emit(Fe, it) && (T = !0, it.prevented && (G = !0), it.stopped))
                return Je = !0;
            } else {
              var st = R[Fe];
              if (st)
                return gt(Ne, st);
            }
          }
          for (; se && se !== Ge && !gt(se, ve); )
            se = se._parent;
          return Je;
        }
        function he(se, de, ve, we, Se, Ae) {
          return se._project.removeOn(ve), G = T = !1, j && ae(
            j,
            null,
            ve,
            we,
            Se,
            Ae
          ) || de && de !== j && !de.isDescendant(j) && ae(de, null, ve === "mousedrag" ? "mousemove" : ve, we, Se, Ae, j) || ae(
            se,
            j || de || se,
            ve,
            we,
            Se,
            Ae
          );
        }
        var pe = {
          mousedown: {
            mousedown: 1,
            mousedrag: 1,
            click: 1,
            doubleclick: 1
          },
          mouseup: {
            mouseup: 1,
            mousedrag: 1,
            click: 1,
            doubleclick: 1
          },
          mousemove: {
            mousedrag: 1,
            mousemove: 1,
            mouseenter: 1,
            mouseleave: 1
          }
        };
        return {
          _viewEvents: E,
          _handleMouseEvent: function(se, de, ve) {
            var we = this._itemEvents, Se = we.native[se], Ae = se === "mousemove", Ge = this._scope.tool, Je = this;
            function it(Rt) {
              return we.virtual[Rt] || Je.responds(Rt) || Ge && Ge.responds(Rt);
            }
            Ae && a && it("mousedrag") && (se = "mousedrag"), ve || (ve = this.getEventPoint(de));
            var gt = this.getBounds().contains(ve), Ne = Se && gt && Je._project.hitTest(ve, {
              tolerance: 0,
              fill: !0,
              stroke: !0
            }), Fe = Ne && Ne.item || null, st = !1, _t = {};
            if (_t[se.substr(5)] = !0, Se && Fe !== I && (I && ae(I, null, "mouseleave", de, ve), Fe && ae(Fe, null, "mouseenter", de, ve), I = Fe), Y ^ gt && (ae(
              this,
              null,
              gt ? "mouseenter" : "mouseleave",
              de,
              ve
            ), st = !0), (gt || _t.drag) && !ve.equals(z) && (he(
              this,
              Fe,
              Ae ? se : "mousemove",
              de,
              ve,
              z
            ), st = !0), Y = gt, _t.down && gt || _t.up && k) {
              if (he(this, Fe, se, de, ve, k), _t.down) {
                if (ie = Fe === q && Date.now() - H < 300, C = q = Fe, !G && Fe) {
                  for (var vt = Fe; vt && !vt.responds("mousedrag"); )
                    vt = vt._parent;
                  vt && (j = Fe);
                }
                k = ve;
              } else
                _t.up && (!G && Fe === C && (H = Date.now(), he(this, Fe, ie ? "doubleclick" : "click", de, ve, k), ie = !1), C = j = null);
              Y = !1, st = !0;
            }
            z = ve, st && Ge && (T = Ge._handleMouseEvent(se, de, ve, _t) || T), de.cancelable !== !1 && (T && !_t.move || _t.down && it("mouseup")) && de.preventDefault();
          },
          _handleKeyEvent: function(se, de, ve, we) {
            var Se = this._scope, Ae = Se.tool, Ge;
            function Je(it) {
              it.responds(se) && (He = Se, it.emit(se, Ge = Ge || new _e(se, de, ve, we)));
            }
            this.isVisible() && (Je(this), Ae && Ae.responds(se) && Je(Ae));
          },
          _countItemEvent: function(se, de) {
            var ve = this._itemEvents, we = ve.native, Se = ve.virtual;
            for (var Ae in pe)
              we[Ae] = (we[Ae] || 0) + (pe[Ae][se] || 0) * de;
            Se[se] = (Se[se] || 0) + de;
          },
          statics: {
            updateFocus: d,
            _resetState: function() {
              a = l = T = Y = !1, i = r = k = z = C = I = j = q = H = ie = null;
            }
          }
        };
      }()
    ), tn = ei.extend({
      _class: "CanvasView",
      initialize: function(r, a) {
        if (!(a instanceof n.HTMLCanvasElement)) {
          var l = F.read(arguments, 1);
          if (l.isZero())
            throw new Error(
              "Cannot create CanvasView with the provided argument: " + o.slice(arguments, 1)
            );
          a = mt.getCanvas(l);
        }
        var u = this._context = a.getContext("2d");
        if (u.save(), this._pixelRatio = 1, !/^off|false$/.test(c.getAttribute(a, "hidpi"))) {
          var d = n.devicePixelRatio || 1, v = Wt.getPrefixed(
            u,
            "backingStorePixelRatio"
          ) || 1;
          this._pixelRatio = d / v;
        }
        ei.call(this, r, a), this._needsUpdate = !0;
      },
      remove: function i() {
        return this._context.restore(), i.base.call(this);
      },
      _setElementSize: function i(r, a) {
        var l = this._pixelRatio;
        if (i.base.call(this, r * l, a * l), l !== 1) {
          var u = this._element, d = this._context;
          if (!c.hasAttribute(u, "resize")) {
            var v = u.style;
            v.width = r + "px", v.height = a + "px";
          }
          d.restore(), d.save(), d.scale(l, l);
        }
      },
      getContext: function() {
        return this._context;
      },
      getPixelSize: function i(r) {
        var a = He.agent, l;
        if (a && a.firefox)
          l = i.base.call(this, r);
        else {
          var u = this._context, d = u.font;
          u.font = r + " serif", l = parseFloat(u.font), u.font = d;
        }
        return l;
      },
      getTextWidth: function(i, r) {
        var a = this._context, l = a.font, u = 0;
        a.font = i;
        for (var d = 0, v = r.length; d < v; d++)
          u = Math.max(u, a.measureText(r[d]).width);
        return a.font = l, u;
      },
      update: function() {
        if (!this._needsUpdate)
          return !1;
        var i = this._project, r = this._context, a = this._viewSize;
        return r.clearRect(0, 0, a.width + 1, a.height + 1), i && i.draw(r, this._matrix, this._pixelRatio), this._needsUpdate = !1, !0;
      }
    }), Fi = o.extend({
      _class: "Event",
      initialize: function(r) {
        this.event = r, this.type = r && r.type;
      },
      prevented: !1,
      stopped: !1,
      preventDefault: function() {
        this.prevented = !0, this.event.preventDefault();
      },
      stopPropagation: function() {
        this.stopped = !0, this.event.stopPropagation();
      },
      stop: function() {
        this.stopPropagation(), this.preventDefault();
      },
      getTimeStamp: function() {
        return this.event.timeStamp;
      },
      getModifiers: function() {
        return Ct.modifiers;
      }
    }), _e = Fi.extend({
      _class: "KeyEvent",
      initialize: function(r, a, l, u) {
        this.type = r, this.event = a, this.key = l, this.character = u;
      },
      toString: function() {
        return "{ type: '" + this.type + "', key: '" + this.key + "', character: '" + this.character + "', modifiers: " + this.getModifiers() + " }";
      }
    }), Ct = new function() {
      var i = {
        "	": "tab",
        " ": "space",
        "\b": "backspace",
        "": "delete",
        Spacebar: "space",
        Del: "delete",
        Win: "meta",
        Esc: "escape"
      }, r = {
        tab: "	",
        space: " ",
        enter: "\r"
      }, a = {}, l = {}, u, d, v = new o({
        shift: !1,
        control: !1,
        alt: !1,
        meta: !1,
        capsLock: !1,
        space: !1
      }).inject({
        option: {
          get: function() {
            return this.alt;
          }
        },
        command: {
          get: function() {
            var S = He && He.agent;
            return S && S.mac ? this.meta : this.control;
          }
        }
      });
      function p(S) {
        var L = S.key || S.keyIdentifier;
        return L = /^U\+/.test(L) ? String.fromCharCode(parseInt(L.substr(2), 16)) : /^Arrow[A-Z]/.test(L) ? L.substr(5) : L === "Unidentified" || L === t ? String.fromCharCode(S.keyCode) : L, i[L] || (L.length > 1 ? o.hyphenate(L) : L.toLowerCase());
      }
      function y(S, L, E, A) {
        var T = ei._focused, G;
        if (a[L] = S, S ? l[L] = E : delete l[L], L.length > 1 && (G = o.camelize(L)) in v) {
          v[G] = S;
          var R = He && He.agent;
          if (G === "meta" && R && R.mac)
            if (S)
              u = {};
            else {
              for (var Y in u)
                Y in l && y(!1, Y, u[Y], A);
              u = null;
            }
        } else
          S && u && (u[L] = E);
        T && T._handleKeyEvent(
          S ? "keydown" : "keyup",
          A,
          L,
          E
        );
      }
      return $t.add(s, {
        keydown: function(S) {
          var L = p(S), E = He && He.agent;
          L.length > 1 || E && E.chrome && (S.altKey || E.mac && S.metaKey || !E.mac && S.ctrlKey) ? y(
            !0,
            L,
            r[L] || (L.length > 1 ? "" : L),
            S
          ) : d = L;
        },
        keypress: function(S) {
          if (d) {
            var L = p(S), E = S.charCode, A = E >= 32 ? String.fromCharCode(E) : L.length > 1 ? "" : L;
            L !== d && (L = A.toLowerCase()), y(!0, L, A, S), d = null;
          }
        },
        keyup: function(S) {
          var L = p(S);
          L in l && y(!1, L, l[L], S);
        }
      }), $t.add(n, {
        blur: function(S) {
          for (var L in l)
            y(!1, L, l[L], S);
        }
      }), {
        modifiers: v,
        isDown: function(S) {
          return !!a[S];
        }
      };
    }(), yt = Fi.extend({
      _class: "MouseEvent",
      initialize: function(r, a, l, u, d) {
        this.type = r, this.event = a, this.point = l, this.target = u, this.delta = d;
      },
      toString: function() {
        return "{ type: '" + this.type + "', point: " + this.point + ", target: " + this.target + (this.delta ? ", delta: " + this.delta : "") + ", modifiers: " + this.getModifiers() + " }";
      }
    }), Re = Fi.extend({
      _class: "ToolEvent",
      _item: null,
      initialize: function(r, a, l) {
        this.tool = r, this.type = a, this.event = l;
      },
      _choosePoint: function(i, r) {
        return i || (r ? r.clone() : null);
      },
      getPoint: function() {
        return this._choosePoint(this._point, this.tool._point);
      },
      setPoint: function(i) {
        this._point = i;
      },
      getLastPoint: function() {
        return this._choosePoint(this._lastPoint, this.tool._lastPoint);
      },
      setLastPoint: function(i) {
        this._lastPoint = i;
      },
      getDownPoint: function() {
        return this._choosePoint(this._downPoint, this.tool._downPoint);
      },
      setDownPoint: function(i) {
        this._downPoint = i;
      },
      getMiddlePoint: function() {
        return !this._middlePoint && this.tool._lastPoint ? this.tool._point.add(this.tool._lastPoint).divide(2) : this._middlePoint;
      },
      setMiddlePoint: function(i) {
        this._middlePoint = i;
      },
      getDelta: function() {
        return !this._delta && this.tool._lastPoint ? this.tool._point.subtract(this.tool._lastPoint) : this._delta;
      },
      setDelta: function(i) {
        this._delta = i;
      },
      getCount: function() {
        return this.tool[/^mouse(down|up)$/.test(this.type) ? "_downCount" : "_moveCount"];
      },
      setCount: function(i) {
        this.tool[/^mouse(down|up)$/.test(this.type) ? "downCount" : "count"] = i;
      },
      getItem: function() {
        if (!this._item) {
          var i = this.tool._scope.project.hitTest(this.getPoint());
          if (i) {
            for (var r = i.item, a = r._parent; /^(Group|CompoundPath)$/.test(a._class); )
              r = a, a = a._parent;
            this._item = r;
          }
        }
        return this._item;
      },
      setItem: function(i) {
        this._item = i;
      },
      toString: function() {
        return "{ type: " + this.type + ", point: " + this.getPoint() + ", count: " + this.getCount() + ", modifiers: " + this.getModifiers() + " }";
      }
    }), Ee = _.extend({
      _class: "Tool",
      _list: "tools",
      _reference: "tool",
      _events: [
        "onMouseDown",
        "onMouseUp",
        "onMouseDrag",
        "onMouseMove",
        "onActivate",
        "onDeactivate",
        "onEditOptions",
        "onKeyDown",
        "onKeyUp"
      ],
      initialize: function(r) {
        _.call(this), this._moveCount = -1, this._downCount = -1, this.set(r);
      },
      getMinDistance: function() {
        return this._minDistance;
      },
      setMinDistance: function(i) {
        this._minDistance = i, i != null && this._maxDistance != null && i > this._maxDistance && (this._maxDistance = i);
      },
      getMaxDistance: function() {
        return this._maxDistance;
      },
      setMaxDistance: function(i) {
        this._maxDistance = i, this._minDistance != null && i != null && i < this._minDistance && (this._minDistance = i);
      },
      getFixedDistance: function() {
        return this._minDistance == this._maxDistance ? this._minDistance : null;
      },
      setFixedDistance: function(i) {
        this._minDistance = this._maxDistance = i;
      },
      _handleMouseEvent: function(i, r, a, l) {
        He = this._scope, l.drag && !this.responds(i) && (i = "mousemove");
        var u = l.move || l.drag, d = this.responds(i), v = !1, p = this;
        function y(L, E) {
          var A = a, T = u ? p._point : p._downPoint || A;
          if (u) {
            if (p._moveCount >= 0 && A.equals(T))
              return !1;
            if (T && (L != null || E != null)) {
              var G = A.subtract(T), R = G.getLength();
              if (R < (L || 0))
                return !1;
              E && (A = T.add(G.normalize(
                Math.min(R, E)
              )));
            }
            p._moveCount++;
          }
          return p._point = A, p._lastPoint = T || A, l.down && (p._moveCount = -1, p._downPoint = A, p._downCount++), !0;
        }
        function S() {
          d && (v = p.emit(i, new Re(p, i, r)) || v);
        }
        if (l.down)
          y(), S();
        else if (l.up)
          y(null, this._maxDistance), S();
        else if (d)
          for (; y(this._minDistance, this._maxDistance); )
            S();
        return v;
      }
    }), et = o.extend(h, {
      _class: "Tween",
      statics: {
        easings: new o({
          linear: function(i) {
            return i;
          },
          easeInQuad: function(i) {
            return i * i;
          },
          easeOutQuad: function(i) {
            return i * (2 - i);
          },
          easeInOutQuad: function(i) {
            return i < 0.5 ? 2 * i * i : -1 + 2 * (2 - i) * i;
          },
          easeInCubic: function(i) {
            return i * i * i;
          },
          easeOutCubic: function(i) {
            return --i * i * i + 1;
          },
          easeInOutCubic: function(i) {
            return i < 0.5 ? 4 * i * i * i : (i - 1) * (2 * i - 2) * (2 * i - 2) + 1;
          },
          easeInQuart: function(i) {
            return i * i * i * i;
          },
          easeOutQuart: function(i) {
            return 1 - --i * i * i * i;
          },
          easeInOutQuart: function(i) {
            return i < 0.5 ? 8 * i * i * i * i : 1 - 8 * --i * i * i * i;
          },
          easeInQuint: function(i) {
            return i * i * i * i * i;
          },
          easeOutQuint: function(i) {
            return 1 + --i * i * i * i * i;
          },
          easeInOutQuint: function(i) {
            return i < 0.5 ? 16 * i * i * i * i * i : 1 + 16 * --i * i * i * i * i;
          }
        })
      },
      initialize: function i(r, a, l, u, d, v) {
        this.object = r;
        var p = typeof d, y = p === "function";
        this.type = y ? p : p === "string" ? d : "linear", this.easing = y ? d : i.easings[this.type], this.duration = u, this.running = !1, this._then = null, this._startTime = null;
        var S = a || l;
        this._keys = S ? Object.keys(S) : [], this._parsedKeys = this._parseKeys(this._keys), this._from = S && this._getState(a), this._to = S && this._getState(l), v !== !1 && this.start();
      },
      then: function(i) {
        return this._then = i, this;
      },
      start: function() {
        return this._startTime = null, this.running = !0, this;
      },
      stop: function() {
        return this.running = !1, this;
      },
      update: function(i) {
        if (this.running) {
          i >= 1 && (i = 1, this.running = !1);
          for (var r = this.easing(i), a = this._keys, l = function(L) {
            return typeof L == "function" ? L(r, i) : L;
          }, u = 0, d = a && a.length; u < d; u++) {
            var v = a[u], p = l(this._from[v]), y = l(this._to[v]), S = p && y && p.__add && y.__add ? y.__subtract(p).__multiply(r).__add(p) : (y - p) * r + p;
            this._setProperty(this._parsedKeys[v], S);
          }
          this.responds("update") && this.emit("update", new o({
            progress: i,
            factor: r
          })), !this.running && this._then && this._then(this.object);
        }
        return this;
      },
      _events: {
        onUpdate: {}
      },
      _handleFrame: function(i) {
        var r = this._startTime, a = r ? (i - r) / this.duration : 0;
        r || (this._startTime = i), this.update(a);
      },
      _getState: function(i) {
        for (var r = this._keys, a = {}, l = 0, u = r.length; l < u; l++) {
          var d = r[l], v = this._parsedKeys[d], p = this._getProperty(v), y;
          if (i) {
            var S = this._resolveValue(p, i[d]);
            this._setProperty(v, S), y = this._getProperty(v), y = y && y.clone ? y.clone() : y, this._setProperty(v, p);
          } else
            y = p && p.clone ? p.clone() : p;
          a[d] = y;
        }
        return a;
      },
      _resolveValue: function(i, r) {
        if (r) {
          if (Array.isArray(r) && r.length === 2) {
            var a = r[0];
            return a && a.match && a.match(/^[+\-\*\/]=/) ? this._calculate(i, a[0], r[1]) : r;
          } else if (typeof r == "string") {
            var l = r.match(/^[+\-*/]=(.*)/);
            if (l) {
              var u = JSON.parse(l[1].replace(
                /(['"])?([a-zA-Z0-9_]+)(['"])?:/g,
                '"$2": '
              ));
              return this._calculate(i, r[0], u);
            }
          }
        }
        return r;
      },
      _calculate: function(i, r, a) {
        return He.PaperScript.calculateBinary(i, r, a);
      },
      _parseKeys: function(i) {
        for (var r = {}, a = 0, l = i.length; a < l; a++) {
          var u = i[a], d = u.replace(/\.([^.]*)/g, "/$1").replace(/\[['"]?([^'"\]]*)['"]?\]/g, "/$1");
          r[u] = d.split("/");
        }
        return r;
      },
      _getProperty: function(i, r) {
        for (var a = this.object, l = 0, u = i.length - (r || 0); l < u && a; l++)
          a = a[i[l]];
        return a;
      },
      _setProperty: function(i, r) {
        var a = this._getProperty(i, 1);
        a && (a[i[i.length - 1]] = r);
      }
    }), kt = {
      request: function(i) {
        var r = new e.XMLHttpRequest();
        return r.open(
          (i.method || "get").toUpperCase(),
          i.url,
          o.pick(i.async, !0)
        ), i.mimeType && r.overrideMimeType(i.mimeType), r.onload = function() {
          var a = r.status;
          a === 0 || a === 200 ? i.onLoad && i.onLoad.call(r, r.responseText) : r.onerror();
        }, r.onerror = function() {
          var a = r.status, l = 'Could not load "' + i.url + '" (Status: ' + a + ")";
          if (i.onError)
            i.onError(l, a);
          else
            throw new Error(l);
        }, r.send(null);
      }
    }, mt = o.exports.CanvasProvider = {
      canvases: [],
      getCanvas: function(i, r, a) {
        if (!n)
          return null;
        var l, u = !0;
        typeof i == "object" && (r = i.height, i = i.width), this.canvases.length ? l = this.canvases.pop() : (l = s.createElement("canvas"), u = !1);
        var d = l.getContext("2d", a || {});
        if (!d)
          throw new Error("Canvas " + l + " is unable to provide a 2D context.");
        return l.width === i && l.height === r ? u && d.clearRect(0, 0, i + 1, r + 1) : (l.width = i, l.height = r), d.save(), l;
      },
      getContext: function(i, r, a) {
        var l = this.getCanvas(i, r, a);
        return l ? l.getContext("2d", a || {}) : null;
      },
      release: function(i) {
        var r = i && i.canvas ? i.canvas : i;
        r && r.getContext && (r.getContext("2d").restore(), this.canvases.push(r));
      }
    }, Qe = new function() {
      var i = Math.min, r = Math.max, a = Math.abs, l, u, d, v, p, y, S, L, E, A, T;
      function G(j, q, H) {
        return 0.2989 * j + 0.587 * q + 0.114 * H;
      }
      function R(j, q, H, he) {
        var ae = he - G(j, q, H);
        E = j + ae, A = q + ae, T = H + ae;
        var he = G(E, A, T), pe = i(E, A, T), se = r(E, A, T);
        if (pe < 0) {
          var de = he - pe;
          E = he + (E - he) * he / de, A = he + (A - he) * he / de, T = he + (T - he) * he / de;
        }
        if (se > 255) {
          var ve = 255 - he, we = se - he;
          E = he + (E - he) * ve / we, A = he + (A - he) * ve / we, T = he + (T - he) * ve / we;
        }
      }
      function Y(j, q, H) {
        return r(j, q, H) - i(j, q, H);
      }
      function k(j, q, H, ie) {
        var ae = [j, q, H], he = r(j, q, H), pe = i(j, q, H), se;
        pe = pe === j ? 0 : pe === q ? 1 : 2, he = he === j ? 0 : he === q ? 1 : 2, se = i(pe, he) === 0 ? r(pe, he) === 1 ? 2 : 1 : 0, ae[he] > ae[pe] ? (ae[se] = (ae[se] - ae[pe]) * ie / (ae[he] - ae[pe]), ae[he] = ie) : ae[se] = ae[he] = 0, ae[pe] = 0, E = ae[0], A = ae[1], T = ae[2];
      }
      var z = {
        multiply: function() {
          E = p * l / 255, A = y * u / 255, T = S * d / 255;
        },
        screen: function() {
          E = p + l - p * l / 255, A = y + u - y * u / 255, T = S + d - S * d / 255;
        },
        overlay: function() {
          E = p < 128 ? 2 * p * l / 255 : 255 - 2 * (255 - p) * (255 - l) / 255, A = y < 128 ? 2 * y * u / 255 : 255 - 2 * (255 - y) * (255 - u) / 255, T = S < 128 ? 2 * S * d / 255 : 255 - 2 * (255 - S) * (255 - d) / 255;
        },
        "soft-light": function() {
          var j = l * p / 255;
          E = j + p * (255 - (255 - p) * (255 - l) / 255 - j) / 255, j = u * y / 255, A = j + y * (255 - (255 - y) * (255 - u) / 255 - j) / 255, j = d * S / 255, T = j + S * (255 - (255 - S) * (255 - d) / 255 - j) / 255;
        },
        "hard-light": function() {
          E = l < 128 ? 2 * l * p / 255 : 255 - 2 * (255 - l) * (255 - p) / 255, A = u < 128 ? 2 * u * y / 255 : 255 - 2 * (255 - u) * (255 - y) / 255, T = d < 128 ? 2 * d * S / 255 : 255 - 2 * (255 - d) * (255 - S) / 255;
        },
        "color-dodge": function() {
          E = p === 0 ? 0 : l === 255 ? 255 : i(255, 255 * p / (255 - l)), A = y === 0 ? 0 : u === 255 ? 255 : i(255, 255 * y / (255 - u)), T = S === 0 ? 0 : d === 255 ? 255 : i(255, 255 * S / (255 - d));
        },
        "color-burn": function() {
          E = p === 255 ? 255 : l === 0 ? 0 : r(0, 255 - (255 - p) * 255 / l), A = y === 255 ? 255 : u === 0 ? 0 : r(0, 255 - (255 - y) * 255 / u), T = S === 255 ? 255 : d === 0 ? 0 : r(0, 255 - (255 - S) * 255 / d);
        },
        darken: function() {
          E = p < l ? p : l, A = y < u ? y : u, T = S < d ? S : d;
        },
        lighten: function() {
          E = p > l ? p : l, A = y > u ? y : u, T = S > d ? S : d;
        },
        difference: function() {
          E = p - l, E < 0 && (E = -E), A = y - u, A < 0 && (A = -A), T = S - d, T < 0 && (T = -T);
        },
        exclusion: function() {
          E = p + l * (255 - p - p) / 255, A = y + u * (255 - y - y) / 255, T = S + d * (255 - S - S) / 255;
        },
        hue: function() {
          k(l, u, d, Y(p, y, S)), R(E, A, T, G(p, y, S));
        },
        saturation: function() {
          k(p, y, S, Y(l, u, d)), R(E, A, T, G(p, y, S));
        },
        luminosity: function() {
          R(p, y, S, G(l, u, d));
        },
        color: function() {
          R(l, u, d, G(p, y, S));
        },
        add: function() {
          E = i(p + l, 255), A = i(y + u, 255), T = i(S + d, 255);
        },
        subtract: function() {
          E = r(p - l, 0), A = r(y - u, 0), T = r(S - d, 0);
        },
        average: function() {
          E = (p + l) / 2, A = (y + u) / 2, T = (S + d) / 2;
        },
        negation: function() {
          E = 255 - a(255 - l - p), A = 255 - a(255 - u - y), T = 255 - a(255 - d - S);
        }
      }, C = this.nativeModes = o.each([
        "source-over",
        "source-in",
        "source-out",
        "source-atop",
        "destination-over",
        "destination-in",
        "destination-out",
        "destination-atop",
        "lighter",
        "darker",
        "copy",
        "xor"
      ], function(j) {
        this[j] = !0;
      }, {}), I = mt.getContext(1, 1, { willReadFrequently: !0 });
      I && (o.each(z, function(j, q) {
        var H = q === "darken", ie = !1;
        I.save();
        try {
          I.fillStyle = H ? "#300" : "#a00", I.fillRect(0, 0, 1, 1), I.globalCompositeOperation = q, I.globalCompositeOperation === q && (I.fillStyle = H ? "#a00" : "#300", I.fillRect(0, 0, 1, 1), ie = I.getImageData(0, 0, 1, 1).data[0] !== H ? 170 : 51);
        } catch {
        }
        I.restore(), C[q] = ie;
      }), mt.release(I)), this.process = function(j, q, H, ie, ae) {
        var he = q.canvas, pe = j === "normal";
        if (pe || C[j])
          H.save(), H.setTransform(1, 0, 0, 1, 0, 0), H.globalAlpha = ie, pe || (H.globalCompositeOperation = j), H.drawImage(he, ae.x, ae.y), H.restore();
        else {
          var se = z[j];
          if (!se)
            return;
          for (var de = H.getImageData(
            ae.x,
            ae.y,
            he.width,
            he.height
          ), ve = de.data, we = q.getImageData(
            0,
            0,
            he.width,
            he.height
          ).data, Se = 0, Ae = ve.length; Se < Ae; Se += 4) {
            l = we[Se], p = ve[Se], u = we[Se + 1], y = ve[Se + 1], d = we[Se + 2], S = ve[Se + 2], v = we[Se + 3], L = ve[Se + 3], se();
            var Ge = v * ie / 255, Je = 1 - Ge;
            ve[Se] = Ge * E + Je * p, ve[Se + 1] = Ge * A + Je * y, ve[Se + 2] = Ge * T + Je * S, ve[Se + 3] = v * ie + Je * L;
          }
          H.putImageData(de, ae.x, ae.y);
        }
      };
    }(), bt = new function() {
      var i = "http://www.w3.org/2000/svg", r = "http://www.w3.org/2000/xmlns", a = "http://www.w3.org/1999/xlink", l = {
        href: a,
        xlink: r,
        xmlns: r + "/",
        "xmlns:xlink": r + "/"
      };
      function u(p, y, S) {
        return v(s.createElementNS(i, p), y, S);
      }
      function d(p, y) {
        var S = l[y], L = S ? p.getAttributeNS(S, y) : p.getAttribute(y);
        return L === "null" ? null : L;
      }
      function v(p, y, S) {
        for (var L in y) {
          var E = y[L], A = l[L];
          typeof E == "number" && S && (E = S.number(E)), A ? p.setAttributeNS(A, L, E) : p.setAttribute(L, E);
        }
        return p;
      }
      return {
        svg: i,
        xmlns: r,
        xlink: a,
        create: u,
        get: d,
        set: v
      };
    }(), Gt = o.each({
      fillColor: ["fill", "color"],
      fillRule: ["fill-rule", "string"],
      strokeColor: ["stroke", "color"],
      strokeWidth: ["stroke-width", "number"],
      strokeCap: ["stroke-linecap", "string"],
      strokeJoin: ["stroke-linejoin", "string"],
      strokeScaling: ["vector-effect", "lookup", {
        true: "none",
        false: "non-scaling-stroke"
      }, function(i, r) {
        return !r && (i instanceof Yt || i instanceof ke || i instanceof Kt);
      }],
      miterLimit: ["stroke-miterlimit", "number"],
      dashArray: ["stroke-dasharray", "array"],
      dashOffset: ["stroke-dashoffset", "number"],
      fontFamily: ["font-family", "string"],
      fontWeight: ["font-weight", "string"],
      fontSize: ["font-size", "number"],
      justification: ["text-anchor", "lookup", {
        left: "start",
        center: "middle",
        right: "end"
      }],
      opacity: ["opacity", "number"],
      blendMode: ["mix-blend-mode", "style"]
    }, function(i, r) {
      var a = o.capitalize(r), l = i[2];
      this[r] = {
        type: i[1],
        property: r,
        attribute: i[0],
        toSVG: l,
        fromSVG: l && o.each(l, function(u, d) {
          this[u] = d;
        }, {}),
        exportFilter: i[3],
        get: "get" + a,
        set: "set" + a
      };
    }, {});
    new function() {
      var i;
      function r(z, C, I) {
        var j = new o(), q = z.getTranslation();
        if (C) {
          var H;
          z.isInvertible() ? (z = z._shiftless(), H = z._inverseTransform(q), q = null) : H = new M(), j[I ? "cx" : "x"] = H.x, j[I ? "cy" : "y"] = H.y;
        }
        if (!z.isIdentity()) {
          var ie = z.decompose();
          if (ie) {
            var ae = [], he = ie.rotation, pe = ie.scaling, se = ie.skewing;
            q && !q.isZero() && ae.push("translate(" + i.point(q) + ")"), he && ae.push("rotate(" + i.number(he) + ")"), (!P.isZero(pe.x - 1) || !P.isZero(pe.y - 1)) && ae.push("scale(" + i.point(pe) + ")"), se.x && ae.push("skewX(" + i.number(se.x) + ")"), se.y && ae.push("skewY(" + i.number(se.y) + ")"), j.transform = ae.join(" ");
          } else
            j.transform = "matrix(" + z.getValues().join(",") + ")";
        }
        return j;
      }
      function a(z, C) {
        for (var I = r(z._matrix), j = z._children, q = bt.create("g", I, i), H = 0, ie = j.length; H < ie; H++) {
          var ae = j[H], he = Y(ae, C);
          if (he)
            if (ae.isClipMask()) {
              var pe = bt.create("clipPath");
              pe.appendChild(he), G(ae, pe, "clip"), bt.set(q, {
                "clip-path": "url(#" + pe.id + ")"
              });
            } else
              q.appendChild(he);
        }
        return q;
      }
      function l(z, C) {
        var I = r(z._matrix, !0), j = z.getSize(), q = z.getImage();
        return I.x -= j.width / 2, I.y -= j.height / 2, I.width = j.width, I.height = j.height, I.href = C.embedImages == !1 && q && q.src || z.toDataURL(), bt.create("image", I, i);
      }
      function u(z, C) {
        var I = C.matchShapes;
        if (I) {
          var j = z.toShape(!1);
          if (j)
            return d(j);
        }
        var q = z._segments, H = q.length, ie, ae = r(z._matrix);
        if (I && H >= 2 && !z.hasHandles())
          if (H > 2) {
            ie = z._closed ? "polygon" : "polyline";
            for (var he = [], pe = 0; pe < H; pe++)
              he.push(i.point(q[pe]._point));
            ae.points = he.join(" ");
          } else {
            ie = "line";
            var se = q[0]._point, de = q[1]._point;
            ae.set({
              x1: se.x,
              y1: se.y,
              x2: de.x,
              y2: de.y
            });
          }
        else
          ie = "path", ae.d = z.getPathData(null, C.precision);
        return bt.create(ie, ae, i);
      }
      function d(z) {
        var C = z._type, I = z._radius, j = r(z._matrix, !0, C !== "rectangle");
        if (C === "rectangle") {
          C = "rect";
          var q = z._size, H = q.width, ie = q.height;
          j.x -= H / 2, j.y -= ie / 2, j.width = H, j.height = ie, I.isZero() && (I = null);
        }
        return I && (C === "circle" ? j.r = I : (j.rx = I.width, j.ry = I.height)), bt.create(C, j, i);
      }
      function v(z, C) {
        var I = r(z._matrix), j = z.getPathData(null, C.precision);
        return j && (I.d = j), bt.create("path", I, i);
      }
      function p(z, C) {
        var I = r(z._matrix, !0), j = z._definition, q = T(j, "symbol"), H = j._item, ie = H.getStrokeBounds();
        return q || (q = bt.create("symbol", {
          viewBox: i.rectangle(ie)
        }), q.appendChild(Y(H, C)), G(j, q, "symbol")), I.href = "#" + q.id, I.x += ie.x, I.y += ie.y, I.width = ie.width, I.height = ie.height, I.overflow = "visible", bt.create("use", I, i);
      }
      function y(z) {
        var C = T(z, "color");
        if (!C) {
          var I = z.getGradient(), j = I._radial, q = z.getOrigin(), H = z.getDestination(), ie;
          if (j) {
            ie = {
              cx: q.x,
              cy: q.y,
              r: q.getDistance(H)
            };
            var ae = z.getHighlight();
            ae && (ie.fx = ae.x, ie.fy = ae.y);
          } else
            ie = {
              x1: q.x,
              y1: q.y,
              x2: H.x,
              y2: H.y
            };
          ie.gradientUnits = "userSpaceOnUse", C = bt.create((j ? "radial" : "linear") + "Gradient", ie, i);
          for (var he = I._stops, pe = 0, se = he.length; pe < se; pe++) {
            var de = he[pe], ve = de._color, we = ve.getAlpha(), Se = de._offset;
            ie = {
              offset: Se ?? pe / (se - 1)
            }, ve && (ie["stop-color"] = ve.toCSS(!0)), we < 1 && (ie["stop-opacity"] = we), C.appendChild(
              bt.create("stop", ie, i)
            );
          }
          G(z, C, "color");
        }
        return "url(#" + C.id + ")";
      }
      function S(z) {
        var C = bt.create(
          "text",
          r(z._matrix, !0),
          i
        );
        return C.textContent = z._content, C;
      }
      var L = {
        Group: a,
        Layer: a,
        Raster: l,
        Path: u,
        Shape: d,
        CompoundPath: v,
        SymbolItem: p,
        PointText: S
      };
      function E(z, C, I, j) {
        var q = {}, H = !j && z.getParent(), ie = [];
        return z._name != null && (q.id = z._name), o.each(Gt, function(ae) {
          var he = ae.get, pe = ae.type, se = z[he]();
          if (ae.exportFilter ? ae.exportFilter(z, se) : I.reduceAttributes == !1 || !H || !o.equals(H[he](), se)) {
            if (pe === "color" && se != null) {
              var de = se.getAlpha();
              de < 1 && (q[ae.attribute + "-opacity"] = de);
            }
            pe === "style" ? ie.push(ae.attribute + ": " + se) : q[ae.attribute] = se == null ? "none" : pe === "color" ? se.gradient ? y(se) : se.toCSS(!0) : pe === "array" ? se.join(",") : pe === "lookup" ? ae.toSVG[se] : se;
          }
        }), ie.length && (q.style = ie.join(";")), q.opacity === 1 && delete q.opacity, z._visible || (q.visibility = "hidden"), bt.set(C, q, i);
      }
      var A;
      function T(z, C) {
        return A || (A = { ids: {}, svgs: {} }), z && A.svgs[C + "-" + (z._id || z.__id || (z.__id = U.get("svg")))];
      }
      function G(z, C, I) {
        A || T();
        var j = A.ids[I] = (A.ids[I] || 0) + 1;
        C.id = I + "-" + j, A.svgs[I + "-" + (z._id || z.__id)] = C;
      }
      function R(z, C) {
        var I = z, j = null;
        if (A) {
          I = z.nodeName.toLowerCase() === "svg" && z;
          for (var q in A.svgs)
            j || (I || (I = bt.create("svg"), I.appendChild(z)), j = I.insertBefore(
              bt.create("defs"),
              I.firstChild
            )), j.appendChild(A.svgs[q]);
          A = null;
        }
        return C.asString ? new e.XMLSerializer().serializeToString(I) : I;
      }
      function Y(z, C, I) {
        var j = L[z._class], q = j && j(z, C);
        if (q) {
          var H = C.onExport;
          H && (q = H(z, q, C) || q);
          var ie = JSON.stringify(z._data);
          ie && ie !== "{}" && ie !== "null" && q.setAttribute("data-paper-data", ie);
        }
        return q && E(z, q, C, I);
      }
      function k(z) {
        return z || (z = {}), i = new B(z.precision), z;
      }
      X.inject({
        exportSVG: function(z) {
          return z = k(z), R(Y(this, z, !0), z);
        }
      }), fe.inject({
        exportSVG: function(z) {
          z = k(z);
          var C = this._children, I = this.getView(), j = o.pick(z.bounds, "view"), q = z.matrix || j === "view" && I._matrix, H = q && ee.read([q]), ie = j === "view" ? new D([0, 0], I.getViewSize()) : j === "content" ? X._getBounds(C, H, { stroke: !0 }).rect : D.read([j], 0, { readNull: !0 }), ae = {
            version: "1.1",
            xmlns: bt.svg,
            "xmlns:xlink": bt.xlink
          };
          ie && (ae.width = ie.width, ae.height = ie.height, (ie.x || ie.x === 0 || ie.y || ie.y === 0) && (ae.viewBox = i.rectangle(ie)));
          var he = bt.create("svg", ae, i), pe = he;
          H && !H.isIdentity() && (pe = he.appendChild(bt.create(
            "g",
            r(H),
            i
          )));
          for (var se = 0, de = C.length; se < de; se++)
            pe.appendChild(Y(C[se], z, !0));
          return R(he, z);
        }
      });
    }(), new function() {
      var i = {}, r;
      function a(C, I, j, q, H, ie) {
        var ae = bt.get(C, I) || ie, he = ae == null ? q ? null : j ? "" : 0 : j ? ae : parseFloat(ae);
        return /%\s*$/.test(ae) ? he / 100 * (H ? 1 : r[/x|^width/.test(I) ? "width" : "height"]) : he;
      }
      function l(C, I, j, q, H, ie, ae) {
        return I = a(C, I || "x", !1, q, H, ie), j = a(C, j || "y", !1, q, H, ae), q && (I == null || j == null) ? null : new M(I, j);
      }
      function u(C, I, j, q, H) {
        return I = a(C, I || "width", !1, q, H), j = a(C, j || "height", !1, q, H), q && (I == null || j == null) ? null : new F(I, j);
      }
      function d(C, I, j) {
        return C === "none" ? null : I === "number" ? parseFloat(C) : I === "array" ? C ? C.split(/[\s,]+/g).map(parseFloat) : [] : I === "color" ? Y(C) || C : I === "lookup" ? j[C] : C;
      }
      function v(C, I, j, q) {
        var H = C.childNodes, ie = I === "clippath", ae = I === "defs", he = new W(), pe = he._project, se = pe._currentStyle, de = [];
        if (!ie && !ae && (he = R(he, C, q), pe._currentStyle = he._style.clone()), q)
          for (var ve = C.querySelectorAll("defs"), we = 0, Se = ve.length; we < Se; we++)
            k(ve[we], j, !1);
        for (var we = 0, Se = H.length; we < Se; we++) {
          var Ae = H[we], Ge;
          Ae.nodeType === 1 && !/^defs$/i.test(Ae.nodeName) && (Ge = k(Ae, j, !1)) && !(Ge instanceof Le) && de.push(Ge);
        }
        return he.addChildren(de), ie && (he = R(he.reduce(), C, q)), pe._currentStyle = se, (ie || ae) && (he.remove(), he = null), he;
      }
      function p(C, I) {
        for (var j = C.getAttribute("points").match(
          /[+-]?(?:\d*\.\d+|\d+\.?)(?:[eE][+-]?\d+)?/g
        ), q = [], H = 0, ie = j.length; H < ie; H += 2)
          q.push(new M(
            parseFloat(j[H]),
            parseFloat(j[H + 1])
          ));
        var ae = new We(q);
        return I === "polygon" && ae.closePath(), ae;
      }
      function y(C) {
        return Yt.create(C.getAttribute("d"));
      }
      function S(C, I) {
        var j = (a(C, "href", !0) || "").substring(1), q = I === "radialgradient", H;
        if (j)
          H = i[j].getGradient(), H._radial ^ q && (H = H.clone(), H._radial = q);
        else {
          for (var ie = C.childNodes, ae = [], he = 0, pe = ie.length; he < pe; he++) {
            var se = ie[he];
            se.nodeType === 1 && ae.push(R(new ji(), se));
          }
          H = new Ci(ae, q);
        }
        var de, ve, we, Se = a(C, "gradientUnits", !0) !== "userSpaceOnUse";
        q ? (de = l(
          C,
          "cx",
          "cy",
          !1,
          Se,
          "50%",
          "50%"
        ), ve = de.add(
          a(C, "r", !1, !1, Se, "50%"),
          0
        ), we = l(C, "fx", "fy", !0, Se)) : (de = l(
          C,
          "x1",
          "y1",
          !1,
          Se,
          "0%",
          "0%"
        ), ve = l(
          C,
          "x2",
          "y2",
          !1,
          Se,
          "100%",
          "0%"
        ));
        var Ae = R(
          new Lt(H, de, ve, we),
          C
        );
        return Ae._scaleToBounds = Se, null;
      }
      var L = {
        "#document": function(C, I, j, q) {
          for (var H = C.childNodes, ie = 0, ae = H.length; ie < ae; ie++) {
            var he = H[ie];
            if (he.nodeType === 1)
              return k(he, j, q);
          }
        },
        g: v,
        svg: v,
        clippath: v,
        polygon: p,
        polyline: p,
        path: y,
        lineargradient: S,
        radialgradient: S,
        image: function(C) {
          var I = new Ye(a(C, "href", !0));
          return I.on("load", function() {
            var j = u(C);
            this.setSize(j);
            var q = l(C).add(j.divide(2));
            this._matrix.append(new ee().translate(q));
          }), I;
        },
        symbol: function(C, I, j, q) {
          return new Le(
            v(C, I, j, q),
            !0
          );
        },
        defs: v,
        use: function(C) {
          var I = (a(C, "href", !0) || "").substring(1), j = i[I], q = l(C);
          return j ? j instanceof Le ? j.place(q) : j.clone().translate(q) : null;
        },
        circle: function(C) {
          return new ke.Circle(
            l(C, "cx", "cy"),
            a(C, "r")
          );
        },
        ellipse: function(C) {
          return new ke.Ellipse({
            center: l(C, "cx", "cy"),
            radius: u(C, "rx", "ry")
          });
        },
        rect: function(C) {
          return new ke.Rectangle(new D(
            l(C),
            u(C)
          ), u(C, "rx", "ry"));
        },
        line: function(C) {
          return new We.Line(
            l(C, "x1", "y1"),
            l(C, "x2", "y2")
          );
        },
        text: function(C) {
          var I = new qt(l(C).add(
            l(C, "dx", "dy")
          ));
          return I.setContent(C.textContent.trim() || ""), I;
        },
        switch: v
      };
      function E(C, I, j, q) {
        if (C.transform) {
          for (var H = (q.getAttribute(j) || "").split(/\)\s*/g), ie = new ee(), ae = 0, he = H.length; ae < he; ae++) {
            var pe = H[ae];
            if (!pe)
              break;
            for (var se = pe.split(/\(\s*/), de = se[0].trim(), ve = se[1].split(/[\s,]+/g), we = 0, Se = ve.length; we < Se; we++)
              ve[we] = parseFloat(ve[we]);
            switch (de) {
              case "matrix":
                ie.append(
                  new ee(ve[0], ve[1], ve[2], ve[3], ve[4], ve[5])
                );
                break;
              case "rotate":
                ie.rotate(ve[0], ve[1] || 0, ve[2] || 0);
                break;
              case "translate":
                ie.translate(ve[0], ve[1] || 0);
                break;
              case "scale":
                ie.scale(ve);
                break;
              case "skewX":
                ie.skew(ve[0], 0);
                break;
              case "skewY":
                ie.skew(0, ve[0]);
                break;
            }
          }
          C.transform(ie);
        }
      }
      function A(C, I, j) {
        var q = j === "fill-opacity" ? "getFillColor" : "getStrokeColor", H = C[q] && C[q]();
        H && H.setAlpha(parseFloat(I));
      }
      var T = o.set(o.each(Gt, function(C) {
        this[C.attribute] = function(I, j) {
          if (I[C.set] && (I[C.set](d(j, C.type, C.fromSVG)), C.type === "color")) {
            var q = I[C.get]();
            if (q && q._scaleToBounds) {
              var H = I.getBounds();
              q.transform(new ee().translate(H.getPoint()).scale(H.getSize()));
            }
          }
        };
      }, {}), {
        id: function(C, I) {
          i[I] = C, C.setName && C.setName(I);
        },
        "clip-path": function(C, I) {
          var j = Y(I);
          if (j)
            if (j = j.clone(), j.setClipMask(!0), C instanceof W)
              C.insertChild(0, j);
            else
              return new W(j, C);
        },
        gradientTransform: E,
        transform: E,
        "fill-opacity": A,
        "stroke-opacity": A,
        visibility: function(C, I) {
          C.setVisible && C.setVisible(I === "visible");
        },
        display: function(C, I) {
          C.setVisible && C.setVisible(I !== null);
        },
        "stop-color": function(C, I) {
          C.setColor && C.setColor(I);
        },
        "stop-opacity": function(C, I) {
          C._color && C._color.setAlpha(parseFloat(I));
        },
        offset: function(C, I) {
          if (C.setOffset) {
            var j = I.match(/(.*)%$/);
            C.setOffset(j ? j[1] / 100 : parseFloat(I));
          }
        },
        viewBox: function(C, I, j, q, H) {
          var ie = new D(d(I, "array")), ae = u(q, null, null, !0), he, pe;
          if (C instanceof W) {
            var se = ae ? ae.divide(ie.getSize()) : 1, pe = new ee().scale(se).translate(ie.getPoint().negate());
            he = C;
          } else
            C instanceof Le && (ae && ie.setSize(ae), he = C._item);
          if (he) {
            if (G(q, "overflow", H) !== "visible") {
              var de = new ke.Rectangle(ie);
              de.setClipMask(!0), he.addChild(de);
            }
            pe && he.transform(pe);
          }
        }
      });
      function G(C, I, j) {
        var q = C.attributes[I], H = q && q.value;
        if (!H && C.style) {
          var ie = o.camelize(I);
          H = C.style[ie], !H && j.node[ie] !== j.parent[ie] && (H = j.node[ie]);
        }
        return H ? H === "none" ? null : H : t;
      }
      function R(C, I, j) {
        var q = I.parentNode, H = {
          node: Wt.getStyles(I) || {},
          parent: !j && !/^defs$/i.test(q.tagName) && Wt.getStyles(q) || {}
        };
        return o.each(T, function(ie, ae) {
          var he = G(I, ae, H);
          C = he !== t && ie(C, he, ae, I, H) || C;
        }), C;
      }
      function Y(C) {
        var I = C && C.match(/\((?:["'#]*)([^"')]+)/), j = I && I[1], q = j && i[n ? j.replace(n.location.href.split("#")[0] + "#", "") : j];
        return q && q._scaleToBounds && (q = q.clone(), q._scaleToBounds = !0), q;
      }
      function k(C, I, j) {
        var q = C.nodeName.toLowerCase(), H = q !== "#document", ie = s.body, ae, he, pe;
        j && H && (r = He.getView().getSize(), r = u(C, null, null, !0) || r, ae = bt.create("svg", {
          style: "stroke-width: 1px; stroke-miterlimit: 10"
        }), he = C.parentNode, pe = C.nextSibling, ae.appendChild(C), ie.appendChild(ae));
        var se = He.settings, de = se.applyMatrix, ve = se.insertItems;
        se.applyMatrix = !1, se.insertItems = !1;
        var we = L[q], Se = we && we(C, q, I, j) || null;
        if (se.insertItems = ve, se.applyMatrix = de, Se) {
          H && !(Se instanceof W) && (Se = R(Se, C, j));
          var Ae = I.onImport, Ge = H && C.getAttribute("data-paper-data");
          Ae && (Se = Ae(C, Se, I) || Se), I.expandShapes && Se instanceof ke && (Se.remove(), Se = Se.toPath()), Ge && (Se._data = JSON.parse(Ge));
        }
        return ae && (ie.removeChild(ae), he && (pe ? he.insertBefore(C, pe) : he.appendChild(C))), j && (i = {}, Se && o.pick(I.applyMatrix, de) && Se.matrix.apply(!0, !0)), Se;
      }
      function z(C, I, j) {
        if (!C)
          return null;
        I = typeof I == "function" ? { onLoad: I } : I || {};
        var q = He, H = null;
        function ie(se) {
          try {
            var de = typeof se == "object" ? se : new e.DOMParser().parseFromString(
              se.trim(),
              "image/svg+xml"
            );
            if (!de.nodeName)
              throw de = null, new Error("Unsupported SVG source: " + C);
            He = q, H = k(de, I, !0), (!I || I.insert !== !1) && j._insertItem(t, H);
            var ve = I.onLoad;
            ve && ve(H, se);
          } catch (we) {
            ae(we);
          }
        }
        function ae(se, de) {
          var ve = I.onError;
          if (ve)
            ve(se, de);
          else
            throw new Error(se);
        }
        if (typeof C == "string" && !/^[\s\S]*</.test(C)) {
          var he = s.getElementById(C);
          he ? ie(he) : kt.request({
            url: C,
            async: !0,
            onLoad: ie,
            onError: ae
          });
        } else if (typeof File < "u" && C instanceof File) {
          var pe = new FileReader();
          return pe.onload = function() {
            ie(pe.result);
          }, pe.onerror = function() {
            ae(pe.error);
          }, pe.readAsText(C);
        } else
          ie(C);
        return H;
      }
      X.inject({
        importSVG: function(C, I) {
          return z(C, I, this);
        }
      }), fe.inject({
        importSVG: function(C, I) {
          return this.activate(), z(C, I, this);
        }
      });
    }(), o.exports.PaperScript = (function() {
      var i = this, r = i.acorn;
      if (!r && typeof Xa < "u")
        try {
          r = Ww();
        } catch {
        }
      if (!r) {
        var a, l;
        r = a = l = {}, function(R, Y) {
          if (typeof a == "object" && typeof l == "object")
            return Y(a);
          if (typeof t == "function" && t.amd)
            return t(["exports"], Y);
          Y(R.acorn || (R.acorn = {}));
        }(this, function(R) {
          R.version = "0.5.0";
          var Y, k, z, C;
          R.parse = function(K, oe) {
            return k = String(K), z = k.length, j(oe), me(), Js(Y.program);
          };
          var I = R.defaultOptions = {
            ecmaVersion: 5,
            strictSemicolons: !1,
            allowTrailingCommas: !0,
            forbidReserved: !1,
            allowReturnOutsideFunction: !1,
            locations: !1,
            onComment: null,
            ranges: !1,
            program: null,
            sourceFile: null,
            directSourceFile: null
          };
          function j(K) {
            Y = K || {};
            for (var oe in I)
              Object.prototype.hasOwnProperty.call(Y, oe) || (Y[oe] = I[oe]);
            C = Y.sourceFile || null;
          }
          var q = R.getLineInfo = function(K, oe) {
            for (var Me = 1, Be = 0; ; ) {
              O.lastIndex = Be;
              var ot = O.exec(K);
              if (ot && ot.index < oe)
                ++Me, Be = ot.index + ot[0].length;
              else
                break;
            }
            return { line: Me, column: oe - Be };
          };
          R.tokenize = function(K, oe) {
            k = String(K), z = k.length, j(oe), me();
            var Me = {};
            function Be(ot) {
              return Ge = ae, an(ot), Me.start = ie, Me.end = ae, Me.startLoc = he, Me.endLoc = pe, Me.type = se, Me.value = de, Me;
            }
            return Be.jumpTo = function(ot, ut) {
              if (H = ot, Y.locations) {
                we = 1, Se = O.lastIndex = 0;
                for (var St; (St = O.exec(k)) && St.index < ot; )
                  ++we, Se = St.index + St[0].length;
              }
              ve = ut, Ze();
            }, Be;
          };
          var H, ie, ae, he, pe, se, de, ve, we, Se, Ae, Ge, Je, it, gt, Ne;
          function Fe(K, oe) {
            var Me = q(k, K);
            oe += " (" + Me.line + ":" + Me.column + ")";
            var Be = new SyntaxError(oe);
            throw Be.pos = K, Be.loc = Me, Be.raisedAt = H, Be;
          }
          var st = [], _t = { type: "num" }, vt = { type: "regexp" }, Rt = { type: "string" }, Et = { type: "name" }, Ht = { type: "eof" }, jt = { keyword: "break" }, Vt = { keyword: "case", beforeExpr: !0 }, Mi = { keyword: "catch" }, Li = { keyword: "continue" }, Ai = { keyword: "debugger" }, vi = { keyword: "default" }, ri = { keyword: "do", isLoop: !0 }, Nt = { keyword: "else", beforeExpr: !0 }, Di = { keyword: "finally" }, li = { keyword: "for", isLoop: !0 }, nn = { keyword: "function" }, Vi = { keyword: "if" }, Wi = { keyword: "return", beforeExpr: !0 }, Ji = { keyword: "switch" }, Hi = { keyword: "throw", beforeExpr: !0 }, $i = { keyword: "try" }, _n = { keyword: "var" }, Xi = { keyword: "while", isLoop: !0 }, cn = { keyword: "with" }, Cn = { keyword: "new", beforeExpr: !0 }, Zr = { keyword: "this" }, Pr = { keyword: "null", atomValue: null }, An = { keyword: "true", atomValue: !0 }, qr = { keyword: "false", atomValue: !1 }, Vn = { keyword: "in", binop: 7, beforeExpr: !0 }, dr = {
            break: jt,
            case: Vt,
            catch: Mi,
            continue: Li,
            debugger: Ai,
            default: vi,
            do: ri,
            else: Nt,
            finally: Di,
            for: li,
            function: nn,
            if: Vi,
            return: Wi,
            switch: Ji,
            throw: Hi,
            try: $i,
            var: _n,
            while: Xi,
            with: cn,
            null: Pr,
            true: An,
            false: qr,
            new: Cn,
            in: Vn,
            instanceof: { keyword: "instanceof", binop: 7, beforeExpr: !0 },
            this: Zr,
            typeof: { keyword: "typeof", prefix: !0, beforeExpr: !0 },
            void: { keyword: "void", prefix: !0, beforeExpr: !0 },
            delete: { keyword: "delete", prefix: !0, beforeExpr: !0 }
          }, Hn = { type: "[", beforeExpr: !0 }, fn = { type: "]" }, dn = { type: "{", beforeExpr: !0 }, bn = { type: "}" }, sn = { type: "(", beforeExpr: !0 }, ni = { type: ")" }, gn = { type: ",", beforeExpr: !0 }, rn = { type: ";", beforeExpr: !0 }, Pn = { type: ":", beforeExpr: !0 }, gr = { type: "." }, Or = { type: "?", beforeExpr: !0 }, xr = { binop: 10, beforeExpr: !0 }, wr = { isAssign: !0, beforeExpr: !0 }, g = { isAssign: !0, beforeExpr: !0 }, V = { postfix: !0, prefix: !0, isUpdate: !0 }, ue = { prefix: !0, beforeExpr: !0 }, ye = { binop: 1, beforeExpr: !0 }, Ie = { binop: 2, beforeExpr: !0 }, nt = { binop: 3, beforeExpr: !0 }, dt = { binop: 4, beforeExpr: !0 }, zt = { binop: 5, beforeExpr: !0 }, Xt = { binop: 6, beforeExpr: !0 }, hi = { binop: 7, beforeExpr: !0 }, ii = { binop: 8, beforeExpr: !0 }, oi = { binop: 9, prefix: !0, beforeExpr: !0 }, vn = { binop: 10, beforeExpr: !0 };
          R.tokTypes = {
            bracketL: Hn,
            bracketR: fn,
            braceL: dn,
            braceR: bn,
            parenL: sn,
            parenR: ni,
            comma: gn,
            semi: rn,
            colon: Pn,
            dot: gr,
            question: Or,
            slash: xr,
            eq: wr,
            name: Et,
            eof: Ht,
            num: _t,
            regexp: vt,
            string: Rt
          };
          for (var rr in dr)
            R.tokTypes["_" + rr] = dr[rr];
          function Tn(K) {
            K = K.split(" ");
            var oe = "", Me = [];
            e:
              for (var Be = 0; Be < K.length; ++Be) {
                for (var ot = 0; ot < Me.length; ++ot)
                  if (Me[ot][0].length == K[Be].length) {
                    Me[ot].push(K[Be]);
                    continue e;
                  }
                Me.push([K[Be]]);
              }
            function ut(Zt) {
              if (Zt.length == 1)
                return oe += "return str === " + JSON.stringify(Zt[0]) + ";";
              oe += "switch(str){";
              for (var yi = 0; yi < Zt.length; ++yi)
                oe += "case " + JSON.stringify(Zt[yi]) + ":";
              oe += "return true}return false;";
            }
            if (Me.length > 3) {
              Me.sort(function(Zt, yi) {
                return yi.length - Zt.length;
              }), oe += "switch(str.length){";
              for (var Be = 0; Be < Me.length; ++Be) {
                var St = Me[Be];
                oe += "case " + St[0].length + ":", ut(St);
              }
              oe += "}";
            } else
              ut(K);
            return new Function("str", oe);
          }
          var Sr = Tn("abstract boolean byte char class double enum export extends final float goto implements import int interface long native package private protected public short static super synchronized throws transient volatile"), Mr = Tn("class enum extends super const export import"), sr = Tn("implements interface let package private protected public static yield"), Cr = Tn("eval arguments"), os = Tn("break case catch continue debugger default do else finally for function if return switch throw try var while with null true false instanceof typeof void delete new in this"), Sn = /[\u1680\u180e\u2000-\u200a\u202f\u205f\u3000\ufeff]/, Nr = "ªµºÀ-ÖØ-öø-ˁˆ-ˑˠ-ˤˬˮͰ-ʹͶͷͺ-ͽΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԧԱ-Ֆՙա-ևא-תװ-ײؠ-يٮٯٱ-ۓەۥۦۮۯۺ-ۼۿܐܒ-ܯݍ-ޥޱߊ-ߪߴߵߺࠀ-ࠕࠚࠤࠨࡀ-ࡘࢠࢢ-ࢬऄ-हऽॐक़-ॡॱ-ॷॹ-ॿঅ-ঌএঐও-নপ-রলশ-হঽৎড়ঢ়য়-ৡৰৱਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਖ਼-ੜਫ਼ੲ-ੴઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽૐૠૡଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽଡ଼ଢ଼ୟ-ୡୱஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹௐఅ-ఌఎ-ఐఒ-నప-ళవ-హఽౘౙౠౡಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽೞೠೡೱೲഅ-ഌഎ-ഐഒ-ഺഽൎൠൡൺ-ൿඅ-ඖක-නඳ-රලව-ෆก-ะาำเ-ๆກຂຄງຈຊຍດ-ທນ-ຟມ-ຣລວສຫອ-ະາຳຽເ-ໄໆໜ-ໟༀཀ-ཇཉ-ཬྈ-ྌက-ဪဿၐ-ၕၚ-ၝၡၥၦၮ-ၰၵ-ႁႎႠ-ჅჇჍა-ჺჼ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᎠ-Ᏼᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛮ-ᛰᜀ-ᜌᜎ-ᜑᜠ-ᜱᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳៗៜᠠ-ᡷᢀ-ᢨᢪᢰ-ᣵᤀ-ᤜᥐ-ᥭᥰ-ᥴᦀ-ᦫᧁ-ᧇᨀ-ᨖᨠ-ᩔᪧᬅ-ᬳᭅ-ᭋᮃ-ᮠᮮᮯᮺ-ᯥᰀ-ᰣᱍ-ᱏᱚ-ᱽᳩ-ᳬᳮ-ᳱᳵᳶᴀ-ᶿḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼⁱⁿₐ-ₜℂℇℊ-ℓℕℙ-ℝℤΩℨK-ℭℯ-ℹℼ-ℿⅅ-ⅉⅎⅠ-ↈⰀ-Ⱞⰰ-ⱞⱠ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞⸯ々-〇〡-〩〱-〵〸-〼ぁ-ゖゝ-ゟァ-ヺー-ヿㄅ-ㄭㄱ-ㆎㆠ-ㆺㇰ-ㇿ㐀-䶵一-鿌ꀀ-ꒌꓐ-ꓽꔀ-ꘌꘐ-ꘟꘪꘫꙀ-ꙮꙿ-ꚗꚠ-ꛯꜗ-ꜟꜢ-ꞈꞋ-ꞎꞐ-ꞓꞠ-Ɦꟸ-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢꡀ-ꡳꢂ-ꢳꣲ-ꣷꣻꤊ-ꤥꤰ-ꥆꥠ-ꥼꦄ-ꦲꧏꨀ-ꨨꩀ-ꩂꩄ-ꩋꩠ-ꩶꩺꪀ-ꪯꪱꪵꪶꪹ-ꪽꫀꫂꫛ-ꫝꫠ-ꫪꫲ-ꫴꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꯀ-ꯢ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎ﬀ-ﬆﬓ-ﬗיִײַ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼＡ-Ｚａ-ｚｦ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ", Rr = "̀-ͯ҃-֑҇-ׇֽֿׁׂׅׄؐ-ؚؠ-ىٲ-ۓۧ-ۨۻ-ۼܰ-݊ࠀ-ࠔࠛ-ࠣࠥ-ࠧࠩ-࠭ࡀ-ࡗࣤ-ࣾऀ-ःऺ-़ा-ॏ॑-ॗॢ-ॣ०-९ঁ-ঃ়া-ৄেৈৗয়-ৠਁ-ਃ਼ਾ-ੂੇੈੋ-੍ੑ੦-ੱੵઁ-ઃ઼ા-ૅે-ૉો-્ૢ-ૣ૦-૯ଁ-ଃ଼ା-ୄେୈୋ-୍ୖୗୟ-ୠ୦-୯ஂா-ூெ-ைொ-்ௗ௦-௯ఁ-ఃె-ైొ-్ౕౖౢ-ౣ౦-౯ಂಃ಼ಾ-ೄೆ-ೈೊ-್ೕೖೢ-ೣ೦-೯ംഃെ-ൈൗൢ-ൣ൦-൯ංඃ්ා-ුූෘ-ෟෲෳิ-ฺเ-ๅ๐-๙ິ-ູ່-ໍ໐-໙༘༙༠-༩༹༵༷ཁ-ཇཱ-྄྆-྇ྍ-ྗྙ-ྼ࿆က-ဩ၀-၉ၧ-ၭၱ-ၴႂ-ႍႏ-ႝ፝-፟ᜎ-ᜐᜠ-ᜰᝀ-ᝐᝲᝳក-ឲ៝០-៩᠋-᠍᠐-᠙ᤠ-ᤫᤰ-᤻ᥑ-ᥭᦰ-ᧀᧈ-ᧉ᧐-᧙ᨀ-ᨕᨠ-ᩓ᩠-᩿᩼-᪉᪐-᪙ᭆ-ᭋ᭐-᭙᭫-᭳᮰-᮹᯦-᯳ᰀ-ᰢ᱀-᱉ᱛ-ᱽ᳐-᳒ᴀ-ᶾḁ-ἕ‌‍‿⁀⁔⃐-⃥⃜⃡-⃰ⶁ-ⶖⷠ-ⷿ〡-〨゙゚Ꙁ-ꙭꙴ-꙽ꚟ꛰-꛱ꟸ-ꠀ꠆ꠋꠣ-ꠧꢀ-ꢁꢴ-꣄꣐-꣙ꣳ-ꣷ꤀-꤉ꤦ-꤭ꤰ-ꥅꦀ-ꦃ꦳-꧀ꨀ-ꨧꩀ-ꩁꩌ-ꩍ꩐-꩙ꩻꫠ-ꫩꫲ-ꫳꯀ-ꯡ꯬꯭꯰-꯹ﬠ-ﬨ︀-️︠-︦︳︴﹍-﹏０-９＿", vs = new RegExp("[" + Nr + "]"), Ts = new RegExp("[" + Nr + Rr + "]"), w = /[\n\r\u2028\u2029]/, O = /\r\n|[\n\r\u2028\u2029]/g, J = R.isIdentifierStart = function(K) {
            return K < 65 ? K === 36 : K < 91 ? !0 : K < 97 ? K === 95 : K < 123 ? !0 : K >= 170 && vs.test(String.fromCharCode(K));
          }, re = R.isIdentifierChar = function(K) {
            return K < 48 ? K === 36 : K < 58 ? !0 : K < 65 ? !1 : K < 91 ? !0 : K < 97 ? K === 95 : K < 123 ? !0 : K >= 170 && Ts.test(String.fromCharCode(K));
          };
          function ge() {
            this.line = we, this.column = H - Se;
          }
          function me() {
            we = 1, H = Se = 0, ve = !0, Ze();
          }
          function xe(K, oe) {
            ae = H, Y.locations && (pe = new ge()), se = K, Ze(), de = oe, ve = K.beforeExpr;
          }
          function Ue() {
            var K = Y.onComment && Y.locations && new ge(), oe = H, Me = k.indexOf("*/", H += 2);
            if (Me === -1 && Fe(H - 2, "Unterminated comment"), H = Me + 2, Y.locations) {
              O.lastIndex = oe;
              for (var Be; (Be = O.exec(k)) && Be.index < H; )
                ++we, Se = Be.index + Be[0].length;
            }
            Y.onComment && Y.onComment(
              !0,
              k.slice(oe + 2, Me),
              oe,
              H,
              K,
              Y.locations && new ge()
            );
          }
          function ze() {
            for (var K = H, oe = Y.onComment && Y.locations && new ge(), Me = k.charCodeAt(H += 2); H < z && Me !== 10 && Me !== 13 && Me !== 8232 && Me !== 8233; )
              ++H, Me = k.charCodeAt(H);
            Y.onComment && Y.onComment(
              !1,
              k.slice(K + 2, H),
              K,
              H,
              oe,
              Y.locations && new ge()
            );
          }
          function Ze() {
            for (; H < z; ) {
              var K = k.charCodeAt(H);
              if (K === 32)
                ++H;
              else if (K === 13) {
                ++H;
                var oe = k.charCodeAt(H);
                oe === 10 && ++H, Y.locations && (++we, Se = H);
              } else if (K === 10 || K === 8232 || K === 8233)
                ++H, Y.locations && (++we, Se = H);
              else if (K > 8 && K < 14)
                ++H;
              else if (K === 47) {
                var oe = k.charCodeAt(H + 1);
                if (oe === 42)
                  Ue();
                else if (oe === 47)
                  ze();
                else
                  break;
              } else if (K === 160)
                ++H;
              else if (K >= 5760 && Sn.test(String.fromCharCode(K)))
                ++H;
              else
                break;
            }
          }
          function At() {
            var K = k.charCodeAt(H + 1);
            return K >= 48 && K <= 57 ? Qi(!0) : (++H, xe(gr));
          }
          function Bt() {
            var K = k.charCodeAt(H + 1);
            return ve ? (++H, ki()) : K === 61 ? xi(g, 2) : xi(xr, 1);
          }
          function lt() {
            var K = k.charCodeAt(H + 1);
            return K === 61 ? xi(g, 2) : xi(vn, 1);
          }
          function Ft(K) {
            var oe = k.charCodeAt(H + 1);
            return oe === K ? xi(K === 124 ? ye : Ie, 2) : oe === 61 ? xi(g, 2) : xi(K === 124 ? nt : zt, 1);
          }
          function fi() {
            var K = k.charCodeAt(H + 1);
            return K === 61 ? xi(g, 2) : xi(dt, 1);
          }
          function si(K) {
            var oe = k.charCodeAt(H + 1);
            return oe === K ? oe == 45 && k.charCodeAt(H + 2) == 62 && w.test(k.slice(Ge, H)) ? (H += 3, ze(), Ze(), an()) : xi(V, 2) : oe === 61 ? xi(g, 2) : xi(oi, 1);
          }
          function di(K) {
            var oe = k.charCodeAt(H + 1), Me = 1;
            return oe === K ? (Me = K === 62 && k.charCodeAt(H + 2) === 62 ? 3 : 2, k.charCodeAt(H + Me) === 61 ? xi(g, Me + 1) : xi(ii, Me)) : oe == 33 && K == 60 && k.charCodeAt(H + 2) == 45 && k.charCodeAt(H + 3) == 45 ? (H += 4, ze(), Ze(), an()) : (oe === 61 && (Me = k.charCodeAt(H + 2) === 61 ? 3 : 2), xi(hi, Me));
          }
          function xn(K) {
            var oe = k.charCodeAt(H + 1);
            return oe === 61 ? xi(Xt, k.charCodeAt(H + 2) === 61 ? 3 : 2) : xi(K === 61 ? wr : ue, 1);
          }
          function wn(K) {
            switch (K) {
              case 46:
                return At();
              case 40:
                return ++H, xe(sn);
              case 41:
                return ++H, xe(ni);
              case 59:
                return ++H, xe(rn);
              case 44:
                return ++H, xe(gn);
              case 91:
                return ++H, xe(Hn);
              case 93:
                return ++H, xe(fn);
              case 123:
                return ++H, xe(dn);
              case 125:
                return ++H, xe(bn);
              case 58:
                return ++H, xe(Pn);
              case 63:
                return ++H, xe(Or);
              case 48:
                var oe = k.charCodeAt(H + 1);
                if (oe === 120 || oe === 88)
                  return Ni();
              case 49:
              case 50:
              case 51:
              case 52:
              case 53:
              case 54:
              case 55:
              case 56:
              case 57:
                return Qi(!1);
              case 34:
              case 39:
                return ar(K);
              case 47:
                return Bt();
              case 37:
              case 42:
                return lt();
              case 124:
              case 38:
                return Ft(K);
              case 94:
                return fi();
              case 43:
              case 45:
                return si(K);
              case 60:
              case 62:
                return di(K);
              case 61:
              case 33:
                return xn(K);
              case 126:
                return xi(ue, 1);
            }
            return !1;
          }
          function an(K) {
            if (K ? H = ie + 1 : ie = H, Y.locations && (he = new ge()), K)
              return ki();
            if (H >= z)
              return xe(Ht);
            var oe = k.charCodeAt(H);
            if (J(oe) || oe === 92)
              return Yn();
            var Me = wn(oe);
            if (Me === !1) {
              var Be = String.fromCharCode(oe);
              if (Be === "\\" || vs.test(Be))
                return Yn();
              Fe(H, "Unexpected character '" + Be + "'");
            }
            return Me;
          }
          function xi(K, oe) {
            var Me = k.slice(H, H + oe);
            H += oe, xe(K, Me);
          }
          function ki() {
            for (var ot = "", K, oe, Me = H; ; ) {
              H >= z && Fe(Me, "Unterminated regular expression");
              var Be = k.charAt(H);
              if (w.test(Be) && Fe(Me, "Unterminated regular expression"), K)
                K = !1;
              else {
                if (Be === "[")
                  oe = !0;
                else if (Be === "]" && oe)
                  oe = !1;
                else if (Be === "/" && !oe)
                  break;
                K = Be === "\\";
              }
              ++H;
            }
            var ot = k.slice(Me, H);
            ++H;
            var ut = Ar();
            ut && !/^[gmsiy]*$/.test(ut) && Fe(Me, "Invalid regexp flag");
            try {
              var St = new RegExp(ot, ut);
            } catch (Zt) {
              Zt instanceof SyntaxError && Fe(Me, Zt.message), Fe(Zt);
            }
            return xe(vt, St);
          }
          function Dn(K, oe) {
            for (var Me = H, Be = 0, ot = 0, ut = oe ?? 1 / 0; ot < ut; ++ot) {
              var St = k.charCodeAt(H), Zt;
              if (St >= 97 ? Zt = St - 97 + 10 : St >= 65 ? Zt = St - 65 + 10 : St >= 48 && St <= 57 ? Zt = St - 48 : Zt = 1 / 0, Zt >= K)
                break;
              ++H, Be = Be * K + Zt;
            }
            return H === Me || oe != null && H - Me !== oe ? null : Be;
          }
          function Ni() {
            H += 2;
            var K = Dn(16);
            return K == null && Fe(ie + 2, "Expected hexadecimal number"), J(k.charCodeAt(H)) && Fe(H, "Identifier directly after number"), xe(_t, K);
          }
          function Qi(K) {
            var oe = H, Me = !1, Be = k.charCodeAt(H) === 48;
            !K && Dn(10) === null && Fe(oe, "Invalid number"), k.charCodeAt(H) === 46 && (++H, Dn(10), Me = !0);
            var ot = k.charCodeAt(H);
            (ot === 69 || ot === 101) && (ot = k.charCodeAt(++H), (ot === 43 || ot === 45) && ++H, Dn(10) === null && Fe(oe, "Invalid number"), Me = !0), J(k.charCodeAt(H)) && Fe(H, "Identifier directly after number");
            var ut = k.slice(oe, H), St;
            return Me ? St = parseFloat(ut) : !Be || ut.length === 1 ? St = parseInt(ut, 10) : /[89]/.test(ut) || Ne ? Fe(oe, "Invalid number") : St = parseInt(ut, 8), xe(_t, St);
          }
          function ar(K) {
            H++;
            for (var oe = ""; ; ) {
              H >= z && Fe(ie, "Unterminated string constant");
              var Me = k.charCodeAt(H);
              if (Me === K)
                return ++H, xe(Rt, oe);
              if (Me === 92) {
                Me = k.charCodeAt(++H);
                var Be = /^[0-7]+/.exec(k.slice(H, H + 3));
                for (Be && (Be = Be[0]); Be && parseInt(Be, 8) > 255; )
                  Be = Be.slice(0, -1);
                if (Be === "0" && (Be = null), ++H, Be)
                  Ne && Fe(H - 2, "Octal literal in strict mode"), oe += String.fromCharCode(parseInt(Be, 8)), H += Be.length - 1;
                else
                  switch (Me) {
                    case 110:
                      oe += `
`;
                      break;
                    case 114:
                      oe += "\r";
                      break;
                    case 120:
                      oe += String.fromCharCode(pr(2));
                      break;
                    case 117:
                      oe += String.fromCharCode(pr(4));
                      break;
                    case 85:
                      oe += String.fromCharCode(pr(8));
                      break;
                    case 116:
                      oe += "	";
                      break;
                    case 98:
                      oe += "\b";
                      break;
                    case 118:
                      oe += "\v";
                      break;
                    case 102:
                      oe += "\f";
                      break;
                    case 48:
                      oe += "\0";
                      break;
                    case 13:
                      k.charCodeAt(H) === 10 && ++H;
                    case 10:
                      Y.locations && (Se = H, ++we);
                      break;
                    default:
                      oe += String.fromCharCode(Me);
                      break;
                  }
              } else
                (Me === 13 || Me === 10 || Me === 8232 || Me === 8233) && Fe(ie, "Unterminated string constant"), oe += String.fromCharCode(Me), ++H;
            }
          }
          function pr(K) {
            var oe = Dn(16, K);
            return oe === null && Fe(ie, "Bad character escape sequence"), oe;
          }
          var pn;
          function Ar() {
            pn = !1;
            for (var K, oe = !0, Me = H; ; ) {
              var Be = k.charCodeAt(H);
              if (re(Be))
                pn && (K += k.charAt(H)), ++H;
              else if (Be === 92) {
                pn || (K = k.slice(Me, H)), pn = !0, k.charCodeAt(++H) != 117 && Fe(H, "Expecting Unicode escape sequence \\uXXXX"), ++H;
                var ot = pr(4), ut = String.fromCharCode(ot);
                ut || Fe(H - 1, "Invalid Unicode escape"), (oe ? J(ot) : re(ot)) || Fe(H - 4, "Invalid Unicode escape"), K += ut;
              } else
                break;
              oe = !1;
            }
            return pn ? K : k.slice(Me, H);
          }
          function Yn() {
            var K = Ar(), oe = Et;
            return !pn && os(K) && (oe = dr[K]), xe(oe, K);
          }
          function Qt() {
            Ae = ie, Ge = ae, Je = pe, an();
          }
          function qn(K) {
            if (Ne = K, H = ie, Y.locations)
              for (; H < Se; )
                Se = k.lastIndexOf(`
`, Se - 2) + 1, --we;
            Ze(), an();
          }
          function Gn() {
            this.type = null, this.start = ie, this.end = null;
          }
          function Dr() {
            this.start = he, this.end = null, C !== null && (this.source = C);
          }
          function Si() {
            var K = new Gn();
            return Y.locations && (K.loc = new Dr()), Y.directSourceFile && (K.sourceFile = Y.directSourceFile), Y.ranges && (K.range = [ie, 0]), K;
          }
          function hn(K) {
            var oe = new Gn();
            return oe.start = K.start, Y.locations && (oe.loc = new Dr(), oe.loc.start = K.loc.start), Y.ranges && (oe.range = [K.range[0], 0]), oe;
          }
          function Jt(K, oe) {
            return K.type = oe, K.end = Ge, Y.locations && (K.loc.end = Je), Y.ranges && (K.range[1] = Ge), K;
          }
          function Ln(K) {
            return Y.ecmaVersion >= 5 && K.type === "ExpressionStatement" && K.expression.type === "Literal" && K.expression.value === "use strict";
          }
          function gi(K) {
            if (se === K)
              return Qt(), !0;
          }
          function Bi() {
            return !Y.strictSemicolons && (se === Ht || se === bn || w.test(k.slice(Ge, ie)));
          }
          function Bn() {
            !gi(rn) && !Bi() && un();
          }
          function ui(K) {
            se === K ? Qt() : un();
          }
          function un() {
            Fe(ie, "Unexpected token");
          }
          function zr(K) {
            K.type !== "Identifier" && K.type !== "MemberExpression" && Fe(K.start, "Assigning to rvalue"), Ne && K.type === "Identifier" && Cr(K.name) && Fe(K.start, "Assigning to " + K.name + " in strict mode");
          }
          function Js(K) {
            Ae = Ge = H, Y.locations && (Je = new ge()), it = Ne = null, gt = [], an();
            var oe = K || Si(), Me = !0;
            for (K || (oe.body = []); se !== Ht; ) {
              var Be = Ki();
              oe.body.push(Be), Me && Ln(Be) && qn(!0), Me = !1;
            }
            return Jt(oe, "Program");
          }
          var $r = { kind: "loop" }, Fr = { kind: "switch" };
          function Ki() {
            (se === xr || se === g && de == "/=") && an(!0);
            var K = se, oe = Si();
            switch (K) {
              case jt:
              case Li:
                Qt();
                var Me = K === jt;
                gi(rn) || Bi() ? oe.label = null : se !== Et ? un() : (oe.label = qe(), Bn());
                for (var Be = 0; Be < gt.length; ++Be) {
                  var ot = gt[Be];
                  if ((oe.label == null || ot.name === oe.label.name) && (ot.kind != null && (Me || ot.kind === "loop") || oe.label && Me))
                    break;
                }
                return Be === gt.length && Fe(oe.start, "Unsyntactic " + K.keyword), Jt(oe, Me ? "BreakStatement" : "ContinueStatement");
              case Ai:
                return Qt(), Bn(), Jt(oe, "DebuggerStatement");
              case ri:
                return Qt(), gt.push($r), oe.body = Ki(), gt.pop(), ui(Xi), oe.test = On(), Bn(), Jt(oe, "DoWhileStatement");
              case li:
                if (Qt(), gt.push($r), ui(sn), se === rn)
                  return tr(oe, null);
                if (se === _n) {
                  var ut = Si();
                  return Qt(), $n(ut, !0), Jt(ut, "VariableDeclaration"), ut.declarations.length === 1 && gi(Vn) ? Ur(oe, ut) : tr(oe, ut);
                }
                var ut = Pi(!1, !0);
                return gi(Vn) ? (zr(ut), Ur(oe, ut)) : tr(oe, ut);
              case nn:
                return Qt(), Tt(oe, !0);
              case Vi:
                return Qt(), oe.test = On(), oe.consequent = Ki(), oe.alternate = gi(Nt) ? Ki() : null, Jt(oe, "IfStatement");
              case Wi:
                return !it && !Y.allowReturnOutsideFunction && Fe(ie, "'return' outside of function"), Qt(), gi(rn) || Bi() ? oe.argument = null : (oe.argument = Pi(), Bn()), Jt(oe, "ReturnStatement");
              case Ji:
                Qt(), oe.discriminant = On(), oe.cases = [], ui(dn), gt.push(Fr);
                for (var St, Zt; se != bn; )
                  if (se === Vt || se === vi) {
                    var yi = se === Vt;
                    St && Jt(St, "SwitchCase"), oe.cases.push(St = Si()), St.consequent = [], Qt(), yi ? St.test = Pi() : (Zt && Fe(Ae, "Multiple default clauses"), Zt = !0, St.test = null), ui(Pn);
                  } else
                    St || un(), St.consequent.push(Ki());
                return St && Jt(St, "SwitchCase"), Qt(), gt.pop(), Jt(oe, "SwitchStatement");
              case Hi:
                return Qt(), w.test(k.slice(Ge, ie)) && Fe(Ge, "Illegal newline after throw"), oe.argument = Pi(), Bn(), Jt(oe, "ThrowStatement");
              case $i:
                if (Qt(), oe.block = or(), oe.handler = null, se === Mi) {
                  var Yi = Si();
                  Qt(), ui(sn), Yi.param = qe(), Ne && Cr(Yi.param.name) && Fe(Yi.param.start, "Binding " + Yi.param.name + " in strict mode"), ui(ni), Yi.guard = null, Yi.body = or(), oe.handler = Jt(Yi, "CatchClause");
                }
                return oe.guardedHandlers = st, oe.finalizer = gi(Di) ? or() : null, !oe.handler && !oe.finalizer && Fe(oe.start, "Missing catch or finally clause"), Jt(oe, "TryStatement");
              case _n:
                return Qt(), $n(oe), Bn(), Jt(oe, "VariableDeclaration");
              case Xi:
                return Qt(), oe.test = On(), gt.push($r), oe.body = Ki(), gt.pop(), Jt(oe, "WhileStatement");
              case cn:
                return Ne && Fe(ie, "'with' in strict mode"), Qt(), oe.object = On(), oe.body = Ki(), Jt(oe, "WithStatement");
              case dn:
                return or();
              case rn:
                return Qt(), Jt(oe, "EmptyStatement");
              default:
                var Nn = de, mn = Pi();
                if (K === Et && mn.type === "Identifier" && gi(Pn)) {
                  for (var Be = 0; Be < gt.length; ++Be)
                    gt[Be].name === Nn && Fe(mn.start, "Label '" + Nn + "' is already declared");
                  var mr = se.isLoop ? "loop" : se === Ji ? "switch" : null;
                  return gt.push({ name: Nn, kind: mr }), oe.body = Ki(), gt.pop(), oe.label = mn, Jt(oe, "LabeledStatement");
                } else
                  return oe.expression = mn, Bn(), Jt(oe, "ExpressionStatement");
            }
          }
          function On() {
            ui(sn);
            var K = Pi();
            return ui(ni), K;
          }
          function or(K) {
            var oe = Si(), Me = !0, Be = !1, ot;
            for (oe.body = [], ui(dn); !gi(bn); ) {
              var ut = Ki();
              oe.body.push(ut), Me && K && Ln(ut) && (ot = Be, qn(Be = !0)), Me = !1;
            }
            return Be && !ot && qn(!1), Jt(oe, "BlockStatement");
          }
          function tr(K, oe) {
            return K.init = oe, ui(rn), K.test = se === rn ? null : Pi(), ui(rn), K.update = se === ni ? null : Pi(), ui(ni), K.body = Ki(), gt.pop(), Jt(K, "ForStatement");
          }
          function Ur(K, oe) {
            return K.left = oe, K.right = Pi(), ui(ni), K.body = Ki(), gt.pop(), Jt(K, "ForInStatement");
          }
          function $n(K, oe) {
            for (K.declarations = [], K.kind = "var"; ; ) {
              var Me = Si();
              if (Me.id = qe(), Ne && Cr(Me.id.name) && Fe(Me.id.start, "Binding " + Me.id.name + " in strict mode"), Me.init = gi(wr) ? Pi(!0, oe) : null, K.declarations.push(Jt(Me, "VariableDeclarator")), !gi(gn))
                break;
            }
            return K;
          }
          function Pi(K, oe) {
            var Me = ls(oe);
            if (!K && se === gn) {
              var Be = hn(Me);
              for (Be.expressions = [Me]; gi(gn); )
                Be.expressions.push(ls(oe));
              return Jt(Be, "SequenceExpression");
            }
            return Me;
          }
          function ls(K) {
            var oe = ys(K);
            if (se.isAssign) {
              var Me = hn(oe);
              return Me.operator = de, Me.left = oe, Qt(), Me.right = ls(K), zr(oe), Jt(Me, "AssignmentExpression");
            }
            return oe;
          }
          function ys(K) {
            var oe = Ls(K);
            if (gi(Or)) {
              var Me = hn(oe);
              return Me.test = oe, Me.consequent = Pi(!0), ui(Pn), Me.alternate = Pi(!0, K), Jt(Me, "ConditionalExpression");
            }
            return oe;
          }
          function Ls(K) {
            return Jn(zn(), -1, K);
          }
          function Jn(K, oe, Me) {
            var Be = se.binop;
            if (Be != null && (!Me || se !== Vn) && Be > oe) {
              var ot = hn(K);
              ot.left = K, ot.operator = de;
              var ut = se;
              Qt(), ot.right = Jn(zn(), Be, Me);
              var St = Jt(ot, ut === ye || ut === Ie ? "LogicalExpression" : "BinaryExpression");
              return Jn(St, oe, Me);
            }
            return K;
          }
          function zn() {
            if (se.prefix) {
              var K = Si(), oe = se.isUpdate;
              return K.operator = de, K.prefix = !0, ve = !0, Qt(), K.argument = zn(), oe ? zr(K.argument) : Ne && K.operator === "delete" && K.argument.type === "Identifier" && Fe(K.start, "Deleting local variable in strict mode"), Jt(K, oe ? "UpdateExpression" : "UnaryExpression");
            }
            for (var Me = bs(); se.postfix && !Bi(); ) {
              var K = hn(Me);
              K.operator = de, K.prefix = !1, K.argument = Me, zr(Me), Qt(), Me = Jt(K, "UpdateExpression");
            }
            return Me;
          }
          function bs() {
            return lr(Pe());
          }
          function lr(K, oe) {
            if (gi(gr)) {
              var Me = hn(K);
              return Me.object = K, Me.property = qe(!0), Me.computed = !1, lr(Jt(Me, "MemberExpression"), oe);
            } else if (gi(Hn)) {
              var Me = hn(K);
              return Me.object = K, Me.property = Pi(), Me.computed = !0, ui(fn), lr(Jt(Me, "MemberExpression"), oe);
            } else if (!oe && gi(sn)) {
              var Me = hn(K);
              return Me.callee = K, Me.arguments = Oe(ni, !1), lr(Jt(Me, "CallExpression"), oe);
            } else
              return K;
          }
          function Pe() {
            switch (se) {
              case Zr:
                var Be = Si();
                return Qt(), Jt(Be, "ThisExpression");
              case Et:
                return qe();
              case _t:
              case Rt:
              case vt:
                var Be = Si();
                return Be.value = de, Be.raw = k.slice(ie, ae), Qt(), Jt(Be, "Literal");
              case Pr:
              case An:
              case qr:
                var Be = Si();
                return Be.value = se.atomValue, Be.raw = se.keyword, Qt(), Jt(Be, "Literal");
              case sn:
                var K = he, oe = ie;
                Qt();
                var Me = Pi();
                return Me.start = oe, Me.end = ae, Y.locations && (Me.loc.start = K, Me.loc.end = pe), Y.ranges && (Me.range = [oe, ae]), ui(ni), Me;
              case Hn:
                var Be = Si();
                return Qt(), Be.elements = Oe(fn, !0, !0), Jt(Be, "ArrayExpression");
              case dn:
                return ct();
              case nn:
                var Be = Si();
                return Qt(), Tt(Be, !1);
              case Cn:
                return Ke();
              default:
                un();
            }
          }
          function Ke() {
            var K = Si();
            return Qt(), K.callee = lr(Pe(), !0), gi(sn) ? K.arguments = Oe(ni, !1) : K.arguments = st, Jt(K, "NewExpression");
          }
          function ct() {
            var K = Si(), oe = !0, Me = !1;
            for (K.properties = [], Qt(); !gi(bn); ) {
              if (oe)
                oe = !1;
              else if (ui(gn), Y.allowTrailingCommas && gi(bn))
                break;
              var Be = { key: xt() }, ot = !1, ut;
              if (gi(Pn) ? (Be.value = Pi(!0), ut = Be.kind = "init") : Y.ecmaVersion >= 5 && Be.key.type === "Identifier" && (Be.key.name === "get" || Be.key.name === "set") ? (ot = Me = !0, ut = Be.kind = Be.key.name, Be.key = xt(), se !== sn && un(), Be.value = Tt(Si(), !1)) : un(), Be.key.type === "Identifier" && (Ne || Me))
                for (var St = 0; St < K.properties.length; ++St) {
                  var Zt = K.properties[St];
                  if (Zt.key.name === Be.key.name) {
                    var yi = ut == Zt.kind || ot && Zt.kind === "init" || ut === "init" && (Zt.kind === "get" || Zt.kind === "set");
                    yi && !Ne && ut === "init" && Zt.kind === "init" && (yi = !1), yi && Fe(Be.key.start, "Redefinition of property");
                  }
                }
              K.properties.push(Be);
            }
            return Jt(K, "ObjectExpression");
          }
          function xt() {
            return se === _t || se === Rt ? Pe() : qe(!0);
          }
          function Tt(K, oe) {
            se === Et ? K.id = qe() : oe ? un() : K.id = null, K.params = [];
            var Me = !0;
            for (ui(sn); !gi(ni); )
              Me ? Me = !1 : ui(gn), K.params.push(qe());
            var Be = it, ot = gt;
            if (it = !0, gt = [], K.body = or(!0), it = Be, gt = ot, Ne || K.body.body.length && Ln(K.body.body[0]))
              for (var ut = K.id ? -1 : 0; ut < K.params.length; ++ut) {
                var St = ut < 0 ? K.id : K.params[ut];
                if ((sr(St.name) || Cr(St.name)) && Fe(St.start, "Defining '" + St.name + "' in strict mode"), ut >= 0)
                  for (var Zt = 0; Zt < ut; ++Zt)
                    St.name === K.params[Zt].name && Fe(St.start, "Argument name clash in strict mode");
              }
            return Jt(K, oe ? "FunctionDeclaration" : "FunctionExpression");
          }
          function Oe(K, oe, Me) {
            for (var Be = [], ot = !0; !gi(K); ) {
              if (ot)
                ot = !1;
              else if (ui(gn), oe && Y.allowTrailingCommas && gi(K))
                break;
              Me && se === gn ? Be.push(null) : Be.push(Pi(!0));
            }
            return Be;
          }
          function qe(K) {
            var oe = Si();
            return K && Y.forbidReserved == "everywhere" && (K = !1), se === Et ? (!K && (Y.forbidReserved && (Y.ecmaVersion === 3 ? Sr : Mr)(de) || Ne && sr(de)) && k.slice(ie, ae).indexOf("\\") == -1 && Fe(ie, "The keyword '" + de + "' is reserved"), oe.name = de) : K && se.keyword ? oe.name = se.keyword : un(), ve = !1, Qt(), Jt(oe, "Identifier");
          }
        }), r.version || (r = null);
      }
      function u(R, Y) {
        return (i.acorn || r).parse(R, Y);
      }
      var d = {
        "+": "__add",
        "-": "__subtract",
        "*": "__multiply",
        "/": "__divide",
        "%": "__modulo",
        "==": "__equals",
        "!=": "__equals"
      }, v = {
        "-": "__negate",
        "+": "__self"
      }, p = o.each(
        ["add", "subtract", "multiply", "divide", "modulo", "equals", "negate"],
        function(R) {
          this["__" + R] = "#" + R;
        },
        {
          __self: function() {
            return this;
          }
        }
      );
      M.inject(p), F.inject(p), Lt.inject(p);
      function y(R, Y, k) {
        var z = d[Y];
        if (R && R[z]) {
          var C = R[z](k);
          return Y === "!=" ? !C : C;
        }
        switch (Y) {
          case "+":
            return R + k;
          case "-":
            return R - k;
          case "*":
            return R * k;
          case "/":
            return R / k;
          case "%":
            return R % k;
          case "==":
            return R == k;
          case "!=":
            return R != k;
        }
      }
      function S(R, Y) {
        var k = v[R];
        if (Y && Y[k])
          return Y[k]();
        switch (R) {
          case "+":
            return +Y;
          case "-":
            return -Y;
        }
      }
      function L(R, Y) {
        if (!R)
          return "";
        Y = Y || {};
        var k = [];
        function z(Ne) {
          for (var Fe = 0, st = k.length; Fe < st; Fe++) {
            var _t = k[Fe];
            if (_t[0] >= Ne)
              break;
            Ne += _t[1];
          }
          return Ne;
        }
        function C(Ne) {
          return R.substring(
            z(Ne.range[0]),
            z(Ne.range[1])
          );
        }
        function I(Ne, Fe) {
          return R.substring(
            z(Ne.range[1]),
            z(Fe.range[0])
          );
        }
        function j(Ne, Fe) {
          for (var st = z(Ne.range[0]), _t = z(Ne.range[1]), vt = 0, Rt = k.length - 1; Rt >= 0; Rt--)
            if (st > k[Rt][0]) {
              vt = Rt + 1;
              break;
            }
          k.splice(vt, 0, [st, Fe.length - _t + st]), R = R.substring(0, st) + Fe + R.substring(_t);
        }
        function q(Ne, Fe) {
          switch (Ne.type) {
            case "UnaryExpression":
              if (Ne.operator in v && Ne.argument.type !== "Literal") {
                var st = C(Ne.argument);
                j(Ne, '$__("' + Ne.operator + '", ' + st + ")");
              }
              break;
            case "BinaryExpression":
              if (Ne.operator in d && Ne.left.type !== "Literal") {
                var _t = C(Ne.left), vt = C(Ne.right), Rt = I(Ne.left, Ne.right), Et = Ne.operator;
                j(Ne, "__$__(" + _t + "," + Rt.replace(
                  new RegExp("\\" + Et),
                  '"' + Et + '"'
                ) + ", " + vt + ")");
              }
              break;
            case "UpdateExpression":
            case "AssignmentExpression":
              var Ht = Fe && Fe.type;
              if (!(Ht === "ForStatement" || Ht === "BinaryExpression" && /^[=!<>]/.test(Fe.operator) || Ht === "MemberExpression" && Fe.computed)) {
                if (Ne.type === "UpdateExpression") {
                  var st = C(Ne.argument), jt = "__$__(" + st + ', "' + Ne.operator[0] + '", 1)', Vt = st + " = " + jt;
                  Ne.prefix ? Vt = "(" + Vt + ")" : (Ht === "AssignmentExpression" || Ht === "VariableDeclarator" || Ht === "BinaryExpression") && (C(Fe.left || Fe.id) === st && (Vt = jt), Vt = st + "; " + Vt), j(Ne, Vt);
                } else if (/^.=$/.test(Ne.operator) && Ne.left.type !== "Literal") {
                  var _t = C(Ne.left), vt = C(Ne.right), jt = _t + " = __$__(" + _t + ', "' + Ne.operator[0] + '", ' + vt + ")";
                  j(Ne, /^\(.*\)$/.test(C(Ne)) ? "(" + jt + ")" : jt);
                }
              }
              break;
          }
        }
        function H(Ne) {
          switch (Ne.type) {
            case "ExportDefaultDeclaration":
              j({
                range: [Ne.start, Ne.declaration.start]
              }, "module.exports = ");
              break;
            case "ExportNamedDeclaration":
              var Fe = Ne.declaration, st = Ne.specifiers;
              if (Fe) {
                var _t = Fe.declarations;
                _t && (_t.forEach(function(Rt) {
                  j(Rt, "module.exports." + C(Rt));
                }), j({
                  range: [
                    Ne.start,
                    Fe.start + Fe.kind.length
                  ]
                }, ""));
              } else if (st) {
                var vt = st.map(function(Rt) {
                  var Et = C(Rt);
                  return "module.exports." + Et + " = " + Et + "; ";
                }).join("");
                vt && j(Ne, vt);
              }
              break;
          }
        }
        function ie(Ne, Fe, st) {
          if (Ne) {
            for (var _t in Ne)
              if (_t !== "range" && _t !== "loc") {
                var vt = Ne[_t];
                if (Array.isArray(vt))
                  for (var Rt = 0, Et = vt.length; Rt < Et; Rt++)
                    ie(vt[Rt], Ne, st);
                else
                  vt && typeof vt == "object" && ie(vt, Ne, st);
              }
            st.operatorOverloading !== !1 && q(Ne, Fe), st.moduleExports !== !1 && H(Ne);
          }
        }
        function ae(Ne) {
          var Fe = "", st = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
          for (Ne = (Math.abs(Ne) << 1) + (Ne < 0 ? 1 : 0); Ne || !Fe; ) {
            var _t = Ne & 31;
            Ne >>= 5, Ne && (_t |= 32), Fe += st[_t];
          }
          return Fe;
        }
        var he = Y.url || "", pe = Y.sourceMaps, se = Y.paperFeatures || {}, de = Y.source || R, ve = Y.offset || 0, we = He.agent, Se = we.versionNumber, Ae = !1, Ge = /\r\n|\n|\r/mg, Je;
        if (pe && (we.chrome && Se >= 30 || we.webkit && Se >= 537.76 || we.firefox && Se >= 23 || we.node)) {
          if (we.node)
            ve -= 2;
          else if (n && he && !n.location.href.indexOf(he)) {
            var it = s.getElementsByTagName("html")[0].innerHTML;
            ve = it.substr(0, it.indexOf(R) + 1).match(
              Ge
            ).length + 1;
          }
          Ae = ve > 0 && !(we.chrome && Se >= 36 || we.safari && Se >= 600 || we.firefox && Se >= 40 || we.node);
          var gt = ["AA" + ae(Ae ? 0 : ve) + "A"];
          gt.length = (R.match(Ge) || []).length + 1 + (Ae ? ve : 0), Je = {
            version: 3,
            file: he,
            names: [],
            mappings: gt.join(";AACA"),
            sourceRoot: "",
            sources: [he],
            sourcesContent: [de]
          };
        }
        return (se.operatorOverloading !== !1 || se.moduleExports !== !1) && ie(u(R, {
          ranges: !0,
          preserveParens: !0,
          sourceType: "module"
        }), null, se), Je && (Ae && (R = new Array(ve + 1).join(`
`) + R), /^(inline|both)$/.test(pe) && (R += `
//# sourceMappingURL=data:application/json;base64,` + e.btoa(unescape(encodeURIComponent(
          JSON.stringify(Je)
        )))), R += `
//# sourceURL=` + (he || "paperscript")), {
          url: he,
          source: de,
          code: R,
          map: Je
        };
      }
      function E(R, Y, k) {
        He = Y;
        var z = Y.getView(), C = /\btool\.\w+|\s+on(?:Key|Mouse)(?:Up|Down|Move|Drag)\b/.test(R) && !/\bnew\s+Tool\b/.test(R) ? new Ee() : null, I = C ? C._events : [], j = ["onFrame", "onResize"].concat(I), q = [], H = [], ie, ae = typeof R == "object" ? R : L(R, k);
        R = ae.code;
        function he(Se, Ae) {
          for (var Ge in Se)
            (Ae || !/^_/.test(Ge)) && new RegExp("([\\b\\s\\W]|^)" + Ge.replace(/\$/g, "\\$") + "\\b").test(R) && (q.push(Ge), H.push(Se[Ge]));
        }
        he(
          { __$__: y, $__: S, paper: Y, tool: C },
          !0
        ), he(Y), R = "var module = { exports: {} }; " + R;
        var ve = o.each(j, function(Se) {
          new RegExp("\\s+" + Se + "\\b").test(R) && (q.push(Se), this.push("module.exports." + Se + " = " + Se + ";"));
        }, []).join(`
`);
        ve && (R += `
` + ve), R += `
return module.exports;`;
        var pe = He.agent;
        if (s && (pe.chrome || pe.firefox && pe.versionNumber < 40)) {
          var se = s.createElement("script"), de = s.head || s.getElementsByTagName("head")[0];
          pe.firefox && (R = `
` + R), se.appendChild(s.createTextNode(
            "document.__paperscript__ = function(" + q + ") {" + R + `
}`
          )), de.appendChild(se), ie = s.__paperscript__, delete s.__paperscript__, de.removeChild(se);
        } else
          ie = Function(q, R);
        var ve = ie && ie.apply(Y, H), we = ve || {};
        return o.each(I, function(Se) {
          var Ae = we[Se];
          Ae && (C[Se] = Ae);
        }), z && (we.onResize && z.setOnResize(we.onResize), z.emit("resize", {
          size: z.size,
          delta: new M()
        }), we.onFrame && z.setOnFrame(we.onFrame), z.requestUpdate()), ve;
      }
      function A(R) {
        if (/^text\/(?:x-|)paperscript$/.test(R.type) && c.getAttribute(R, "ignore") !== "true") {
          var Y = c.getAttribute(R, "canvas"), k = s.getElementById(Y), z = R.src || R.getAttribute("data-src"), C = c.hasAttribute(R, "async"), I = "data-paper-scope";
          if (!k)
            throw new Error('Unable to find canvas with id "' + Y + '"');
          var j = c.get(k.getAttribute(I)) || new c().setup(k);
          return k.setAttribute(I, j._id), z ? kt.request({
            url: z,
            async: C,
            mimeType: "text/plain",
            onLoad: function(q) {
              E(q, j, z);
            }
          }) : E(R.innerHTML, j, R.baseURI), R.setAttribute("data-paper-ignore", "true"), j;
        }
      }
      function T() {
        o.each(
          s && s.getElementsByTagName("script"),
          A
        );
      }
      function G(R) {
        return R ? A(R) : T();
      }
      return n && (s.readyState === "complete" ? setTimeout(T) : $t.add(n, { load: T })), {
        compile: L,
        execute: E,
        load: G,
        parse: u,
        calculateBinary: y,
        calculateUnary: S
      };
    }).call(this);
    var He = new (c.inject(o.exports, {
      Base: o,
      Numerical: P,
      Key: Ct,
      DomEvent: $t,
      DomElement: Wt,
      document: s,
      window: n,
      Symbol: Le,
      PlacedSymbol: pt
    }))();
    return He.agent.node && Xf(He), typeof t == "function" && t.amd ? t("paper", He) : b && (b.exports = He), He;
  }).call(ss, typeof self == "object" ? self : null);
})(fg);
var Zw = fg.exports;
const qw = /* @__PURE__ */ uu(Zw);
function $w(b) {
  if (b && !(typeof window > "u")) {
    var e = document.createElement("style");
    return e.setAttribute("type", "text/css"), e.innerHTML = b, document.head.appendChild(e), b;
  }
}
function Ta(b, e) {
  var t = b.__state.conversionName.toString(), n = Math.round(b.r), s = Math.round(b.g), o = Math.round(b.b), h = b.a, c = Math.round(b.h), _ = b.s.toFixed(1), x = b.v.toFixed(1);
  if (e || t === "THREE_CHAR_HEX" || t === "SIX_CHAR_HEX") {
    for (var B = b.hex.toString(16); B.length < 6; )
      B = "0" + B;
    return "#" + B;
  } else {
    if (t === "CSS_RGB")
      return "rgb(" + n + "," + s + "," + o + ")";
    if (t === "CSS_RGBA")
      return "rgba(" + n + "," + s + "," + o + "," + h + ")";
    if (t === "HEX")
      return "0x" + b.hex.toString(16);
    if (t === "RGB_ARRAY")
      return "[" + n + "," + s + "," + o + "]";
    if (t === "RGBA_ARRAY")
      return "[" + n + "," + s + "," + o + "," + h + "]";
    if (t === "RGB_OBJ")
      return "{r:" + n + ",g:" + s + ",b:" + o + "}";
    if (t === "RGBA_OBJ")
      return "{r:" + n + ",g:" + s + ",b:" + o + ",a:" + h + "}";
    if (t === "HSV_OBJ")
      return "{h:" + c + ",s:" + _ + ",v:" + x + "}";
    if (t === "HSVA_OBJ")
      return "{h:" + c + ",s:" + _ + ",v:" + x + ",a:" + h + "}";
  }
  return "unknown format";
}
var Jf = Array.prototype.forEach, Za = Array.prototype.slice, Dt = {
  BREAK: {},
  extend: function(e) {
    return this.each(Za.call(arguments, 1), function(t) {
      var n = this.isObject(t) ? Object.keys(t) : [];
      n.forEach((function(s) {
        this.isUndefined(t[s]) || (e[s] = t[s]);
      }).bind(this));
    }, this), e;
  },
  defaults: function(e) {
    return this.each(Za.call(arguments, 1), function(t) {
      var n = this.isObject(t) ? Object.keys(t) : [];
      n.forEach((function(s) {
        this.isUndefined(e[s]) && (e[s] = t[s]);
      }).bind(this));
    }, this), e;
  },
  compose: function() {
    var e = Za.call(arguments);
    return function() {
      for (var t = Za.call(arguments), n = e.length - 1; n >= 0; n--)
        t = [e[n].apply(this, t)];
      return t[0];
    };
  },
  each: function(e, t, n) {
    if (e) {
      if (Jf && e.forEach && e.forEach === Jf)
        e.forEach(t, n);
      else if (e.length === e.length + 0) {
        var s = void 0, o = void 0;
        for (s = 0, o = e.length; s < o; s++)
          if (s in e && t.call(n, e[s], s) === this.BREAK)
            return;
      } else
        for (var h in e)
          if (t.call(n, e[h], h) === this.BREAK)
            return;
    }
  },
  defer: function(e) {
    setTimeout(e, 0);
  },
  debounce: function(e, t, n) {
    var s = void 0;
    return function() {
      var o = this, h = arguments;
      function c() {
        s = null, n || e.apply(o, h);
      }
      var _ = n || !s;
      clearTimeout(s), s = setTimeout(c, t), _ && e.apply(o, h);
    };
  },
  toArray: function(e) {
    return e.toArray ? e.toArray() : Za.call(e);
  },
  isUndefined: function(e) {
    return e === void 0;
  },
  isNull: function(e) {
    return e === null;
  },
  isNaN: function(b) {
    function e(t) {
      return b.apply(this, arguments);
    }
    return e.toString = function() {
      return b.toString();
    }, e;
  }(function(b) {
    return isNaN(b);
  }),
  isArray: Array.isArray || function(b) {
    return b.constructor === Array;
  },
  isObject: function(e) {
    return e === Object(e);
  },
  isNumber: function(e) {
    return e === e + 0;
  },
  isString: function(e) {
    return e === e + "";
  },
  isBoolean: function(e) {
    return e === !1 || e === !0;
  },
  isFunction: function(e) {
    return e instanceof Function;
  }
}, Xw = [
  {
    litmus: Dt.isString,
    conversions: {
      THREE_CHAR_HEX: {
        read: function(e) {
          var t = e.match(/^#([A-F0-9])([A-F0-9])([A-F0-9])$/i);
          return t === null ? !1 : {
            space: "HEX",
            hex: parseInt("0x" + t[1].toString() + t[1].toString() + t[2].toString() + t[2].toString() + t[3].toString() + t[3].toString(), 0)
          };
        },
        write: Ta
      },
      SIX_CHAR_HEX: {
        read: function(e) {
          var t = e.match(/^#([A-F0-9]{6})$/i);
          return t === null ? !1 : {
            space: "HEX",
            hex: parseInt("0x" + t[1].toString(), 0)
          };
        },
        write: Ta
      },
      CSS_RGB: {
        read: function(e) {
          var t = e.match(/^rgb\(\s*(\S+)\s*,\s*(\S+)\s*,\s*(\S+)\s*\)/);
          return t === null ? !1 : {
            space: "RGB",
            r: parseFloat(t[1]),
            g: parseFloat(t[2]),
            b: parseFloat(t[3])
          };
        },
        write: Ta
      },
      CSS_RGBA: {
        read: function(e) {
          var t = e.match(/^rgba\(\s*(\S+)\s*,\s*(\S+)\s*,\s*(\S+)\s*,\s*(\S+)\s*\)/);
          return t === null ? !1 : {
            space: "RGB",
            r: parseFloat(t[1]),
            g: parseFloat(t[2]),
            b: parseFloat(t[3]),
            a: parseFloat(t[4])
          };
        },
        write: Ta
      }
    }
  },
  {
    litmus: Dt.isNumber,
    conversions: {
      HEX: {
        read: function(e) {
          return {
            space: "HEX",
            hex: e,
            conversionName: "HEX"
          };
        },
        write: function(e) {
          return e.hex;
        }
      }
    }
  },
  {
    litmus: Dt.isArray,
    conversions: {
      RGB_ARRAY: {
        read: function(e) {
          return e.length !== 3 ? !1 : {
            space: "RGB",
            r: e[0],
            g: e[1],
            b: e[2]
          };
        },
        write: function(e) {
          return [e.r, e.g, e.b];
        }
      },
      RGBA_ARRAY: {
        read: function(e) {
          return e.length !== 4 ? !1 : {
            space: "RGB",
            r: e[0],
            g: e[1],
            b: e[2],
            a: e[3]
          };
        },
        write: function(e) {
          return [e.r, e.g, e.b, e.a];
        }
      }
    }
  },
  {
    litmus: Dt.isObject,
    conversions: {
      RGBA_OBJ: {
        read: function(e) {
          return Dt.isNumber(e.r) && Dt.isNumber(e.g) && Dt.isNumber(e.b) && Dt.isNumber(e.a) ? {
            space: "RGB",
            r: e.r,
            g: e.g,
            b: e.b,
            a: e.a
          } : !1;
        },
        write: function(e) {
          return {
            r: e.r,
            g: e.g,
            b: e.b,
            a: e.a
          };
        }
      },
      RGB_OBJ: {
        read: function(e) {
          return Dt.isNumber(e.r) && Dt.isNumber(e.g) && Dt.isNumber(e.b) ? {
            space: "RGB",
            r: e.r,
            g: e.g,
            b: e.b
          } : !1;
        },
        write: function(e) {
          return {
            r: e.r,
            g: e.g,
            b: e.b
          };
        }
      },
      HSVA_OBJ: {
        read: function(e) {
          return Dt.isNumber(e.h) && Dt.isNumber(e.s) && Dt.isNumber(e.v) && Dt.isNumber(e.a) ? {
            space: "HSV",
            h: e.h,
            s: e.s,
            v: e.v,
            a: e.a
          } : !1;
        },
        write: function(e) {
          return {
            h: e.h,
            s: e.s,
            v: e.v,
            a: e.a
          };
        }
      },
      HSV_OBJ: {
        read: function(e) {
          return Dt.isNumber(e.h) && Dt.isNumber(e.s) && Dt.isNumber(e.v) ? {
            space: "HSV",
            h: e.h,
            s: e.s,
            v: e.v
          } : !1;
        },
        write: function(e) {
          return {
            h: e.h,
            s: e.s,
            v: e.v
          };
        }
      }
    }
  }
], qa = void 0, nl = void 0, $h = function() {
  nl = !1;
  var e = arguments.length > 1 ? Dt.toArray(arguments) : arguments[0];
  return Dt.each(Xw, function(t) {
    if (t.litmus(e))
      return Dt.each(t.conversions, function(n, s) {
        if (qa = n.read(e), nl === !1 && qa !== !1)
          return nl = qa, qa.conversionName = s, qa.conversion = n, Dt.BREAK;
      }), Dt.BREAK;
  }), nl;
}, Qf = void 0, wl = {
  hsv_to_rgb: function(e, t, n) {
    var s = Math.floor(e / 60) % 6, o = e / 60 - Math.floor(e / 60), h = n * (1 - t), c = n * (1 - o * t), _ = n * (1 - (1 - o) * t), x = [[n, _, h], [c, n, h], [h, n, _], [h, c, n], [_, h, n], [n, h, c]][s];
    return {
      r: x[0] * 255,
      g: x[1] * 255,
      b: x[2] * 255
    };
  },
  rgb_to_hsv: function(e, t, n) {
    var s = Math.min(e, t, n), o = Math.max(e, t, n), h = o - s, c = void 0, _ = void 0;
    if (o !== 0)
      _ = h / o;
    else
      return {
        h: NaN,
        s: 0,
        v: 0
      };
    return e === o ? c = (t - n) / h : t === o ? c = 2 + (n - e) / h : c = 4 + (e - t) / h, c /= 6, c < 0 && (c += 1), {
      h: c * 360,
      s: _,
      v: o / 255
    };
  },
  rgb_to_hex: function(e, t, n) {
    var s = this.hex_with_component(0, 2, e);
    return s = this.hex_with_component(s, 1, t), s = this.hex_with_component(s, 0, n), s;
  },
  component_from_hex: function(e, t) {
    return e >> t * 8 & 255;
  },
  hex_with_component: function(e, t, n) {
    return n << (Qf = t * 8) | e & ~(255 << Qf);
  }
}, Kw = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(b) {
  return typeof b;
} : function(b) {
  return b && typeof Symbol == "function" && b.constructor === Symbol && b !== Symbol.prototype ? "symbol" : typeof b;
}, ms = function(b, e) {
  if (!(b instanceof e))
    throw new TypeError("Cannot call a class as a function");
}, _s = function() {
  function b(e, t) {
    for (var n = 0; n < t.length; n++) {
      var s = t[n];
      s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(e, s.key, s);
    }
  }
  return function(e, t, n) {
    return t && b(e.prototype, t), n && b(e, n), e;
  };
}(), qs = function b(e, t, n) {
  e === null && (e = Function.prototype);
  var s = Object.getOwnPropertyDescriptor(e, t);
  if (s === void 0) {
    var o = Object.getPrototypeOf(e);
    return o === null ? void 0 : b(o, t, n);
  } else {
    if ("value" in s)
      return s.value;
    var h = s.get;
    return h === void 0 ? void 0 : h.call(n);
  }
}, Xs = function(b, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  b.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: b,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(b, e) : b.__proto__ = e);
}, Ks = function(b, e) {
  if (!b)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : b;
}, er = function() {
  function b() {
    if (ms(this, b), this.__state = $h.apply(this, arguments), this.__state === !1)
      throw new Error("Failed to interpret color arguments");
    this.__state.a = this.__state.a || 1;
  }
  return _s(b, [{
    key: "toString",
    value: function() {
      return Ta(this);
    }
  }, {
    key: "toHexString",
    value: function() {
      return Ta(this, !0);
    }
  }, {
    key: "toOriginal",
    value: function() {
      return this.__state.conversion.write(this);
    }
  }]), b;
}();
function wu(b, e, t) {
  Object.defineProperty(b, e, {
    get: function() {
      return this.__state.space === "RGB" ? this.__state[e] : (er.recalculateRGB(this, e, t), this.__state[e]);
    },
    set: function(s) {
      this.__state.space !== "RGB" && (er.recalculateRGB(this, e, t), this.__state.space = "RGB"), this.__state[e] = s;
    }
  });
}
function Su(b, e) {
  Object.defineProperty(b, e, {
    get: function() {
      return this.__state.space === "HSV" ? this.__state[e] : (er.recalculateHSV(this), this.__state[e]);
    },
    set: function(n) {
      this.__state.space !== "HSV" && (er.recalculateHSV(this), this.__state.space = "HSV"), this.__state[e] = n;
    }
  });
}
er.recalculateRGB = function(b, e, t) {
  if (b.__state.space === "HEX")
    b.__state[e] = wl.component_from_hex(b.__state.hex, t);
  else if (b.__state.space === "HSV")
    Dt.extend(b.__state, wl.hsv_to_rgb(b.__state.h, b.__state.s, b.__state.v));
  else
    throw new Error("Corrupted color state");
};
er.recalculateHSV = function(b) {
  var e = wl.rgb_to_hsv(b.r, b.g, b.b);
  Dt.extend(b.__state, {
    s: e.s,
    v: e.v
  }), Dt.isNaN(e.h) ? Dt.isUndefined(b.__state.h) && (b.__state.h = 0) : b.__state.h = e.h;
};
er.COMPONENTS = ["r", "g", "b", "h", "s", "v", "hex", "a"];
wu(er.prototype, "r", 2);
wu(er.prototype, "g", 1);
wu(er.prototype, "b", 0);
Su(er.prototype, "h");
Su(er.prototype, "s");
Su(er.prototype, "v");
Object.defineProperty(er.prototype, "a", {
  get: function() {
    return this.__state.a;
  },
  set: function(e) {
    this.__state.a = e;
  }
});
Object.defineProperty(er.prototype, "hex", {
  get: function() {
    return this.__state.space !== "HEX" && (this.__state.hex = wl.rgb_to_hex(this.r, this.g, this.b), this.__state.space = "HEX"), this.__state.hex;
  },
  set: function(e) {
    this.__state.space = "HEX", this.__state.hex = e;
  }
});
var da = function() {
  function b(e, t) {
    ms(this, b), this.initialValue = e[t], this.domElement = document.createElement("div"), this.object = e, this.property = t, this.__onChange = void 0, this.__onFinishChange = void 0;
  }
  return _s(b, [{
    key: "onChange",
    value: function(t) {
      return this.__onChange = t, this;
    }
  }, {
    key: "onFinishChange",
    value: function(t) {
      return this.__onFinishChange = t, this;
    }
  }, {
    key: "setValue",
    value: function(t) {
      return this.object[this.property] = t, this.__onChange && this.__onChange.call(this, t), this.updateDisplay(), this;
    }
  }, {
    key: "getValue",
    value: function() {
      return this.object[this.property];
    }
  }, {
    key: "updateDisplay",
    value: function() {
      return this;
    }
  }, {
    key: "isModified",
    value: function() {
      return this.initialValue !== this.getValue();
    }
  }]), b;
}(), Jw = {
  HTMLEvents: ["change"],
  MouseEvents: ["click", "mousemove", "mousedown", "mouseup", "mouseover"],
  KeyboardEvents: ["keydown"]
}, dg = {};
Dt.each(Jw, function(b, e) {
  Dt.each(b, function(t) {
    dg[t] = e;
  });
});
var Qw = /(\d+(\.\d+)?)px/;
function Cs(b) {
  if (b === "0" || Dt.isUndefined(b))
    return 0;
  var e = b.match(Qw);
  return Dt.isNull(e) ? 0 : parseFloat(e[1]);
}
var Mt = {
  makeSelectable: function(e, t) {
    e === void 0 || e.style === void 0 || (e.onselectstart = t ? function() {
      return !1;
    } : function() {
    }, e.style.MozUserSelect = t ? "auto" : "none", e.style.KhtmlUserSelect = t ? "auto" : "none", e.unselectable = t ? "on" : "off");
  },
  makeFullscreen: function(e, t, n) {
    var s = n, o = t;
    Dt.isUndefined(o) && (o = !0), Dt.isUndefined(s) && (s = !0), e.style.position = "absolute", o && (e.style.left = 0, e.style.right = 0), s && (e.style.top = 0, e.style.bottom = 0);
  },
  fakeEvent: function(e, t, n, s) {
    var o = n || {}, h = dg[t];
    if (!h)
      throw new Error("Event type " + t + " not supported.");
    var c = document.createEvent(h);
    switch (h) {
      case "MouseEvents": {
        var _ = o.x || o.clientX || 0, x = o.y || o.clientY || 0;
        c.initMouseEvent(
          t,
          o.bubbles || !1,
          o.cancelable || !0,
          window,
          o.clickCount || 1,
          0,
          0,
          _,
          x,
          !1,
          !1,
          !1,
          !1,
          0,
          null
        );
        break;
      }
      case "KeyboardEvents": {
        var B = c.initKeyboardEvent || c.initKeyEvent;
        Dt.defaults(o, {
          cancelable: !0,
          ctrlKey: !1,
          altKey: !1,
          shiftKey: !1,
          metaKey: !1,
          keyCode: void 0,
          charCode: void 0
        }), B(t, o.bubbles || !1, o.cancelable, window, o.ctrlKey, o.altKey, o.shiftKey, o.metaKey, o.keyCode, o.charCode);
        break;
      }
      default: {
        c.initEvent(t, o.bubbles || !1, o.cancelable || !0);
        break;
      }
    }
    Dt.defaults(c, s), e.dispatchEvent(c);
  },
  bind: function(e, t, n, s) {
    var o = s || !1;
    return e.addEventListener ? e.addEventListener(t, n, o) : e.attachEvent && e.attachEvent("on" + t, n), Mt;
  },
  unbind: function(e, t, n, s) {
    var o = s || !1;
    return e.removeEventListener ? e.removeEventListener(t, n, o) : e.detachEvent && e.detachEvent("on" + t, n), Mt;
  },
  addClass: function(e, t) {
    if (e.className === void 0)
      e.className = t;
    else if (e.className !== t) {
      var n = e.className.split(/ +/);
      n.indexOf(t) === -1 && (n.push(t), e.className = n.join(" ").replace(/^\s+/, "").replace(/\s+$/, ""));
    }
    return Mt;
  },
  removeClass: function(e, t) {
    if (t)
      if (e.className === t)
        e.removeAttribute("class");
      else {
        var n = e.className.split(/ +/), s = n.indexOf(t);
        s !== -1 && (n.splice(s, 1), e.className = n.join(" "));
      }
    else
      e.className = void 0;
    return Mt;
  },
  hasClass: function(e, t) {
    return new RegExp("(?:^|\\s+)" + t + "(?:\\s+|$)").test(e.className) || !1;
  },
  getWidth: function(e) {
    var t = getComputedStyle(e);
    return Cs(t["border-left-width"]) + Cs(t["border-right-width"]) + Cs(t["padding-left"]) + Cs(t["padding-right"]) + Cs(t.width);
  },
  getHeight: function(e) {
    var t = getComputedStyle(e);
    return Cs(t["border-top-width"]) + Cs(t["border-bottom-width"]) + Cs(t["padding-top"]) + Cs(t["padding-bottom"]) + Cs(t.height);
  },
  getOffset: function(e) {
    var t = e, n = { left: 0, top: 0 };
    if (t.offsetParent)
      do
        n.left += t.offsetLeft, n.top += t.offsetTop, t = t.offsetParent;
      while (t);
    return n;
  },
  isActive: function(e) {
    return e === document.activeElement && (e.type || e.href);
  }
}, gg = function(b) {
  Xs(e, b);
  function e(t, n) {
    ms(this, e);
    var s = Ks(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, n)), o = s;
    s.__prev = s.getValue(), s.__checkbox = document.createElement("input"), s.__checkbox.setAttribute("type", "checkbox");
    function h() {
      o.setValue(!o.__prev);
    }
    return Mt.bind(s.__checkbox, "change", h, !1), s.domElement.appendChild(s.__checkbox), s.updateDisplay(), s;
  }
  return _s(e, [{
    key: "setValue",
    value: function(n) {
      var s = qs(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "setValue", this).call(this, n);
      return this.__onFinishChange && this.__onFinishChange.call(this, this.getValue()), this.__prev = this.getValue(), s;
    }
  }, {
    key: "updateDisplay",
    value: function() {
      return this.getValue() === !0 ? (this.__checkbox.setAttribute("checked", "checked"), this.__checkbox.checked = !0, this.__prev = !0) : (this.__checkbox.checked = !1, this.__prev = !1), qs(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "updateDisplay", this).call(this);
    }
  }]), e;
}(da), e1 = function(b) {
  Xs(e, b);
  function e(t, n, s) {
    ms(this, e);
    var o = Ks(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, n)), h = s, c = o;
    if (o.__select = document.createElement("select"), Dt.isArray(h)) {
      var _ = {};
      Dt.each(h, function(x) {
        _[x] = x;
      }), h = _;
    }
    return Dt.each(h, function(x, B) {
      var P = document.createElement("option");
      P.innerHTML = B, P.setAttribute("value", x), c.__select.appendChild(P);
    }), o.updateDisplay(), Mt.bind(o.__select, "change", function() {
      var x = this.options[this.selectedIndex].value;
      c.setValue(x);
    }), o.domElement.appendChild(o.__select), o;
  }
  return _s(e, [{
    key: "setValue",
    value: function(n) {
      var s = qs(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "setValue", this).call(this, n);
      return this.__onFinishChange && this.__onFinishChange.call(this, this.getValue()), s;
    }
  }, {
    key: "updateDisplay",
    value: function() {
      return Mt.isActive(this.__select) ? this : (this.__select.value = this.getValue(), qs(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "updateDisplay", this).call(this));
    }
  }]), e;
}(da), t1 = function(b) {
  Xs(e, b);
  function e(t, n) {
    ms(this, e);
    var s = Ks(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, n)), o = s;
    function h() {
      o.setValue(o.__input.value);
    }
    function c() {
      o.__onFinishChange && o.__onFinishChange.call(o, o.getValue());
    }
    return s.__input = document.createElement("input"), s.__input.setAttribute("type", "text"), Mt.bind(s.__input, "keyup", h), Mt.bind(s.__input, "change", h), Mt.bind(s.__input, "blur", c), Mt.bind(s.__input, "keydown", function(_) {
      _.keyCode === 13 && this.blur();
    }), s.updateDisplay(), s.domElement.appendChild(s.__input), s;
  }
  return _s(e, [{
    key: "updateDisplay",
    value: function() {
      return Mt.isActive(this.__input) || (this.__input.value = this.getValue()), qs(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "updateDisplay", this).call(this);
    }
  }]), e;
}(da);
function ed(b) {
  var e = b.toString();
  return e.indexOf(".") > -1 ? e.length - e.indexOf(".") - 1 : 0;
}
var pg = function(b) {
  Xs(e, b);
  function e(t, n, s) {
    ms(this, e);
    var o = Ks(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, n)), h = s || {};
    return o.__min = h.min, o.__max = h.max, o.__step = h.step, Dt.isUndefined(o.__step) ? o.initialValue === 0 ? o.__impliedStep = 1 : o.__impliedStep = Math.pow(10, Math.floor(Math.log(Math.abs(o.initialValue)) / Math.LN10)) / 10 : o.__impliedStep = o.__step, o.__precision = ed(o.__impliedStep), o;
  }
  return _s(e, [{
    key: "setValue",
    value: function(n) {
      var s = n;
      return this.__min !== void 0 && s < this.__min ? s = this.__min : this.__max !== void 0 && s > this.__max && (s = this.__max), this.__step !== void 0 && s % this.__step !== 0 && (s = Math.round(s / this.__step) * this.__step), qs(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "setValue", this).call(this, s);
    }
  }, {
    key: "min",
    value: function(n) {
      return this.__min = n, this;
    }
  }, {
    key: "max",
    value: function(n) {
      return this.__max = n, this;
    }
  }, {
    key: "step",
    value: function(n) {
      return this.__step = n, this.__impliedStep = n, this.__precision = ed(n), this;
    }
  }]), e;
}(da);
function i1(b, e) {
  var t = Math.pow(10, e);
  return Math.round(b * t) / t;
}
var Sl = function(b) {
  Xs(e, b);
  function e(t, n, s) {
    ms(this, e);
    var o = Ks(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, n, s));
    o.__truncationSuspended = !1;
    var h = o, c = void 0;
    function _() {
      var Z = parseFloat(h.__input.value);
      Dt.isNaN(Z) || h.setValue(Z);
    }
    function x() {
      h.__onFinishChange && h.__onFinishChange.call(h, h.getValue());
    }
    function B() {
      x();
    }
    function P(Z) {
      var F = c - Z.clientY;
      h.setValue(h.getValue() + F * h.__impliedStep), c = Z.clientY;
    }
    function U() {
      Mt.unbind(window, "mousemove", P), Mt.unbind(window, "mouseup", U), x();
    }
    function M(Z) {
      Mt.bind(window, "mousemove", P), Mt.bind(window, "mouseup", U), c = Z.clientY;
    }
    return o.__input = document.createElement("input"), o.__input.setAttribute("type", "text"), Mt.bind(o.__input, "change", _), Mt.bind(o.__input, "blur", B), Mt.bind(o.__input, "mousedown", M), Mt.bind(o.__input, "keydown", function(Z) {
      Z.keyCode === 13 && (h.__truncationSuspended = !0, this.blur(), h.__truncationSuspended = !1, x());
    }), o.updateDisplay(), o.domElement.appendChild(o.__input), o;
  }
  return _s(e, [{
    key: "updateDisplay",
    value: function() {
      return this.__input.value = this.__truncationSuspended ? this.getValue() : i1(this.getValue(), this.__precision), qs(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "updateDisplay", this).call(this);
    }
  }]), e;
}(pg);
function td(b, e, t, n, s) {
  return n + (s - n) * ((b - e) / (t - e));
}
var Xh = function(b) {
  Xs(e, b);
  function e(t, n, s, o, h) {
    ms(this, e);
    var c = Ks(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, n, { min: s, max: o, step: h })), _ = c;
    c.__background = document.createElement("div"), c.__foreground = document.createElement("div"), Mt.bind(c.__background, "mousedown", x), Mt.bind(c.__background, "touchstart", U), Mt.addClass(c.__background, "slider"), Mt.addClass(c.__foreground, "slider-fg");
    function x(F) {
      document.activeElement.blur(), Mt.bind(window, "mousemove", B), Mt.bind(window, "mouseup", P), B(F);
    }
    function B(F) {
      F.preventDefault();
      var Q = _.__background.getBoundingClientRect();
      return _.setValue(td(F.clientX, Q.left, Q.right, _.__min, _.__max)), !1;
    }
    function P() {
      Mt.unbind(window, "mousemove", B), Mt.unbind(window, "mouseup", P), _.__onFinishChange && _.__onFinishChange.call(_, _.getValue());
    }
    function U(F) {
      F.touches.length === 1 && (Mt.bind(window, "touchmove", M), Mt.bind(window, "touchend", Z), M(F));
    }
    function M(F) {
      var Q = F.touches[0].clientX, D = _.__background.getBoundingClientRect();
      _.setValue(td(Q, D.left, D.right, _.__min, _.__max));
    }
    function Z() {
      Mt.unbind(window, "touchmove", M), Mt.unbind(window, "touchend", Z), _.__onFinishChange && _.__onFinishChange.call(_, _.getValue());
    }
    return c.updateDisplay(), c.__background.appendChild(c.__foreground), c.domElement.appendChild(c.__background), c;
  }
  return _s(e, [{
    key: "updateDisplay",
    value: function() {
      var n = (this.getValue() - this.__min) / (this.__max - this.__min);
      return this.__foreground.style.width = n * 100 + "%", qs(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "updateDisplay", this).call(this);
    }
  }]), e;
}(pg), mg = function(b) {
  Xs(e, b);
  function e(t, n, s) {
    ms(this, e);
    var o = Ks(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, n)), h = o;
    return o.__button = document.createElement("div"), o.__button.innerHTML = s === void 0 ? "Fire" : s, Mt.bind(o.__button, "click", function(c) {
      return c.preventDefault(), h.fire(), !1;
    }), Mt.addClass(o.__button, "button"), o.domElement.appendChild(o.__button), o;
  }
  return _s(e, [{
    key: "fire",
    value: function() {
      this.__onChange && this.__onChange.call(this), this.getValue().call(this.object), this.__onFinishChange && this.__onFinishChange.call(this, this.getValue());
    }
  }]), e;
}(da), Kh = function(b) {
  Xs(e, b);
  function e(t, n) {
    ms(this, e);
    var s = Ks(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, n));
    s.__color = new er(s.getValue()), s.__temp = new er(0);
    var o = s;
    s.domElement = document.createElement("div"), Mt.makeSelectable(s.domElement, !1), s.__selector = document.createElement("div"), s.__selector.className = "selector", s.__saturation_field = document.createElement("div"), s.__saturation_field.className = "saturation-field", s.__field_knob = document.createElement("div"), s.__field_knob.className = "field-knob", s.__field_knob_border = "2px solid ", s.__hue_knob = document.createElement("div"), s.__hue_knob.className = "hue-knob", s.__hue_field = document.createElement("div"), s.__hue_field.className = "hue-field", s.__input = document.createElement("input"), s.__input.type = "text", s.__input_textShadow = "0 1px 1px ", Mt.bind(s.__input, "keydown", function(F) {
      F.keyCode === 13 && P.call(this);
    }), Mt.bind(s.__input, "blur", P), Mt.bind(s.__selector, "mousedown", function() {
      Mt.addClass(this, "drag").bind(window, "mouseup", function() {
        Mt.removeClass(o.__selector, "drag");
      });
    }), Mt.bind(s.__selector, "touchstart", function() {
      Mt.addClass(this, "drag").bind(window, "touchend", function() {
        Mt.removeClass(o.__selector, "drag");
      });
    });
    var h = document.createElement("div");
    Dt.extend(s.__selector.style, {
      width: "122px",
      height: "102px",
      padding: "3px",
      backgroundColor: "#222",
      boxShadow: "0px 1px 3px rgba(0,0,0,0.3)"
    }), Dt.extend(s.__field_knob.style, {
      position: "absolute",
      width: "12px",
      height: "12px",
      border: s.__field_knob_border + (s.__color.v < 0.5 ? "#fff" : "#000"),
      boxShadow: "0px 1px 3px rgba(0,0,0,0.5)",
      borderRadius: "12px",
      zIndex: 1
    }), Dt.extend(s.__hue_knob.style, {
      position: "absolute",
      width: "15px",
      height: "2px",
      borderRight: "4px solid #fff",
      zIndex: 1
    }), Dt.extend(s.__saturation_field.style, {
      width: "100px",
      height: "100px",
      border: "1px solid #555",
      marginRight: "3px",
      display: "inline-block",
      cursor: "pointer"
    }), Dt.extend(h.style, {
      width: "100%",
      height: "100%",
      background: "none"
    }), id(h, "top", "rgba(0,0,0,0)", "#000"), Dt.extend(s.__hue_field.style, {
      width: "15px",
      height: "100px",
      border: "1px solid #555",
      cursor: "ns-resize",
      position: "absolute",
      top: "3px",
      right: "3px"
    }), r1(s.__hue_field), Dt.extend(s.__input.style, {
      outline: "none",
      textAlign: "center",
      color: "#fff",
      border: 0,
      fontWeight: "bold",
      textShadow: s.__input_textShadow + "rgba(0,0,0,0.7)"
    }), Mt.bind(s.__saturation_field, "mousedown", c), Mt.bind(s.__saturation_field, "touchstart", c), Mt.bind(s.__field_knob, "mousedown", c), Mt.bind(s.__field_knob, "touchstart", c), Mt.bind(s.__hue_field, "mousedown", _), Mt.bind(s.__hue_field, "touchstart", _);
    function c(F) {
      M(F), Mt.bind(window, "mousemove", M), Mt.bind(window, "touchmove", M), Mt.bind(window, "mouseup", x), Mt.bind(window, "touchend", x);
    }
    function _(F) {
      Z(F), Mt.bind(window, "mousemove", Z), Mt.bind(window, "touchmove", Z), Mt.bind(window, "mouseup", B), Mt.bind(window, "touchend", B);
    }
    function x() {
      Mt.unbind(window, "mousemove", M), Mt.unbind(window, "touchmove", M), Mt.unbind(window, "mouseup", x), Mt.unbind(window, "touchend", x), U();
    }
    function B() {
      Mt.unbind(window, "mousemove", Z), Mt.unbind(window, "touchmove", Z), Mt.unbind(window, "mouseup", B), Mt.unbind(window, "touchend", B), U();
    }
    function P() {
      var F = $h(this.value);
      F !== !1 ? (o.__color.__state = F, o.setValue(o.__color.toOriginal())) : this.value = o.__color.toString();
    }
    function U() {
      o.__onFinishChange && o.__onFinishChange.call(o, o.__color.toOriginal());
    }
    s.__saturation_field.appendChild(h), s.__selector.appendChild(s.__field_knob), s.__selector.appendChild(s.__saturation_field), s.__selector.appendChild(s.__hue_field), s.__hue_field.appendChild(s.__hue_knob), s.domElement.appendChild(s.__input), s.domElement.appendChild(s.__selector), s.updateDisplay();
    function M(F) {
      F.type.indexOf("touch") === -1 && F.preventDefault();
      var Q = o.__saturation_field.getBoundingClientRect(), D = F.touches && F.touches[0] || F, te = D.clientX, ee = D.clientY, le = (te - Q.left) / (Q.right - Q.left), fe = 1 - (ee - Q.top) / (Q.bottom - Q.top);
      return fe > 1 ? fe = 1 : fe < 0 && (fe = 0), le > 1 ? le = 1 : le < 0 && (le = 0), o.__color.v = fe, o.__color.s = le, o.setValue(o.__color.toOriginal()), !1;
    }
    function Z(F) {
      F.type.indexOf("touch") === -1 && F.preventDefault();
      var Q = o.__hue_field.getBoundingClientRect(), D = F.touches && F.touches[0] || F, te = D.clientY, ee = 1 - (te - Q.top) / (Q.bottom - Q.top);
      return ee > 1 ? ee = 1 : ee < 0 && (ee = 0), o.__color.h = ee * 360, o.setValue(o.__color.toOriginal()), !1;
    }
    return s;
  }
  return _s(e, [{
    key: "updateDisplay",
    value: function() {
      var n = $h(this.getValue());
      if (n !== !1) {
        var s = !1;
        Dt.each(er.COMPONENTS, function(c) {
          if (!Dt.isUndefined(n[c]) && !Dt.isUndefined(this.__color.__state[c]) && n[c] !== this.__color.__state[c])
            return s = !0, {};
        }, this), s && Dt.extend(this.__color.__state, n);
      }
      Dt.extend(this.__temp.__state, this.__color.__state), this.__temp.a = 1;
      var o = this.__color.v < 0.5 || this.__color.s > 0.5 ? 255 : 0, h = 255 - o;
      Dt.extend(this.__field_knob.style, {
        marginLeft: 100 * this.__color.s - 7 + "px",
        marginTop: 100 * (1 - this.__color.v) - 7 + "px",
        backgroundColor: this.__temp.toHexString(),
        border: this.__field_knob_border + "rgb(" + o + "," + o + "," + o + ")"
      }), this.__hue_knob.style.marginTop = (1 - this.__color.h / 360) * 100 + "px", this.__temp.s = 1, this.__temp.v = 1, id(this.__saturation_field, "left", "#fff", this.__temp.toHexString()), this.__input.value = this.__color.toString(), Dt.extend(this.__input.style, {
        backgroundColor: this.__color.toHexString(),
        color: "rgb(" + o + "," + o + "," + o + ")",
        textShadow: this.__input_textShadow + "rgba(" + h + "," + h + "," + h + ",.7)"
      });
    }
  }]), e;
}(da), n1 = ["-moz-", "-o-", "-webkit-", "-ms-", ""];
function id(b, e, t, n) {
  b.style.background = "", Dt.each(n1, function(s) {
    b.style.cssText += "background: " + s + "linear-gradient(" + e + ", " + t + " 0%, " + n + " 100%); ";
  });
}
function r1(b) {
  b.style.background = "", b.style.cssText += "background: -moz-linear-gradient(top,  #ff0000 0%, #ff00ff 17%, #0000ff 34%, #00ffff 50%, #00ff00 67%, #ffff00 84%, #ff0000 100%);", b.style.cssText += "background: -webkit-linear-gradient(top,  #ff0000 0%,#ff00ff 17%,#0000ff 34%,#00ffff 50%,#00ff00 67%,#ffff00 84%,#ff0000 100%);", b.style.cssText += "background: -o-linear-gradient(top,  #ff0000 0%,#ff00ff 17%,#0000ff 34%,#00ffff 50%,#00ff00 67%,#ffff00 84%,#ff0000 100%);", b.style.cssText += "background: -ms-linear-gradient(top,  #ff0000 0%,#ff00ff 17%,#0000ff 34%,#00ffff 50%,#00ff00 67%,#ffff00 84%,#ff0000 100%);", b.style.cssText += "background: linear-gradient(top,  #ff0000 0%,#ff00ff 17%,#0000ff 34%,#00ffff 50%,#00ff00 67%,#ffff00 84%,#ff0000 100%);";
}
var s1 = {
  load: function(e, t) {
    var n = t || document, s = n.createElement("link");
    s.type = "text/css", s.rel = "stylesheet", s.href = e, n.getElementsByTagName("head")[0].appendChild(s);
  },
  inject: function(e, t) {
    var n = t || document, s = document.createElement("style");
    s.type = "text/css", s.innerHTML = e;
    var o = n.getElementsByTagName("head")[0];
    try {
      o.appendChild(s);
    } catch {
    }
  }
}, a1 = `<div id="dg-save" class="dg dialogue">

  Here's the new load parameter for your <code>GUI</code>'s constructor:

  <textarea id="dg-new-constructor"></textarea>

  <div id="dg-save-locally">

    <input id="dg-local-storage" type="checkbox"/> Automatically save
    values to <code>localStorage</code> on exit.

    <div id="dg-local-explain">The values saved to <code>localStorage</code> will
      override those passed to <code>dat.GUI</code>'s constructor. This makes it
      easier to work incrementally, but <code>localStorage</code> is fragile,
      and your friends may not see the same values you do.

    </div>

  </div>

</div>`, o1 = function(e, t) {
  var n = e[t];
  return Dt.isArray(arguments[2]) || Dt.isObject(arguments[2]) ? new e1(e, t, arguments[2]) : Dt.isNumber(n) ? Dt.isNumber(arguments[2]) && Dt.isNumber(arguments[3]) ? Dt.isNumber(arguments[4]) ? new Xh(e, t, arguments[2], arguments[3], arguments[4]) : new Xh(e, t, arguments[2], arguments[3]) : Dt.isNumber(arguments[4]) ? new Sl(e, t, { min: arguments[2], max: arguments[3], step: arguments[4] }) : new Sl(e, t, { min: arguments[2], max: arguments[3] }) : Dt.isString(n) ? new t1(e, t) : Dt.isFunction(n) ? new mg(e, t, "") : Dt.isBoolean(n) ? new gg(e, t) : null;
};
function l1(b) {
  setTimeout(b, 1e3 / 60);
}
var h1 = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || l1, u1 = function() {
  function b() {
    ms(this, b), this.backgroundElement = document.createElement("div"), Dt.extend(this.backgroundElement.style, {
      backgroundColor: "rgba(0,0,0,0.8)",
      top: 0,
      left: 0,
      display: "none",
      zIndex: "1000",
      opacity: 0,
      WebkitTransition: "opacity 0.2s linear",
      transition: "opacity 0.2s linear"
    }), Mt.makeFullscreen(this.backgroundElement), this.backgroundElement.style.position = "fixed", this.domElement = document.createElement("div"), Dt.extend(this.domElement.style, {
      position: "fixed",
      display: "none",
      zIndex: "1001",
      opacity: 0,
      WebkitTransition: "-webkit-transform 0.2s ease-out, opacity 0.2s linear",
      transition: "transform 0.2s ease-out, opacity 0.2s linear"
    }), document.body.appendChild(this.backgroundElement), document.body.appendChild(this.domElement);
    var e = this;
    Mt.bind(this.backgroundElement, "click", function() {
      e.hide();
    });
  }
  return _s(b, [{
    key: "show",
    value: function() {
      var t = this;
      this.backgroundElement.style.display = "block", this.domElement.style.display = "block", this.domElement.style.opacity = 0, this.domElement.style.webkitTransform = "scale(1.1)", this.layout(), Dt.defer(function() {
        t.backgroundElement.style.opacity = 1, t.domElement.style.opacity = 1, t.domElement.style.webkitTransform = "scale(1)";
      });
    }
  }, {
    key: "hide",
    value: function() {
      var t = this, n = function s() {
        t.domElement.style.display = "none", t.backgroundElement.style.display = "none", Mt.unbind(t.domElement, "webkitTransitionEnd", s), Mt.unbind(t.domElement, "transitionend", s), Mt.unbind(t.domElement, "oTransitionEnd", s);
      };
      Mt.bind(this.domElement, "webkitTransitionEnd", n), Mt.bind(this.domElement, "transitionend", n), Mt.bind(this.domElement, "oTransitionEnd", n), this.backgroundElement.style.opacity = 0, this.domElement.style.opacity = 0, this.domElement.style.webkitTransform = "scale(1.1)";
    }
  }, {
    key: "layout",
    value: function() {
      this.domElement.style.left = window.innerWidth / 2 - Mt.getWidth(this.domElement) / 2 + "px", this.domElement.style.top = window.innerHeight / 2 - Mt.getHeight(this.domElement) / 2 + "px";
    }
  }]), b;
}(), c1 = $w(`.dg ul{list-style:none;margin:0;padding:0;width:100%;clear:both}.dg.ac{position:fixed;top:0;left:0;right:0;height:0;z-index:0}.dg:not(.ac) .main{overflow:hidden}.dg.main{-webkit-transition:opacity .1s linear;-o-transition:opacity .1s linear;-moz-transition:opacity .1s linear;transition:opacity .1s linear}.dg.main.taller-than-window{overflow-y:auto}.dg.main.taller-than-window .close-button{opacity:1;margin-top:-1px;border-top:1px solid #2c2c2c}.dg.main ul.closed .close-button{opacity:1 !important}.dg.main:hover .close-button,.dg.main .close-button.drag{opacity:1}.dg.main .close-button{-webkit-transition:opacity .1s linear;-o-transition:opacity .1s linear;-moz-transition:opacity .1s linear;transition:opacity .1s linear;border:0;line-height:19px;height:20px;cursor:pointer;text-align:center;background-color:#000}.dg.main .close-button.close-top{position:relative}.dg.main .close-button.close-bottom{position:absolute}.dg.main .close-button:hover{background-color:#111}.dg.a{float:right;margin-right:15px;overflow-y:visible}.dg.a.has-save>ul.close-top{margin-top:0}.dg.a.has-save>ul.close-bottom{margin-top:27px}.dg.a.has-save>ul.closed{margin-top:0}.dg.a .save-row{top:0;z-index:1002}.dg.a .save-row.close-top{position:relative}.dg.a .save-row.close-bottom{position:fixed}.dg li{-webkit-transition:height .1s ease-out;-o-transition:height .1s ease-out;-moz-transition:height .1s ease-out;transition:height .1s ease-out;-webkit-transition:overflow .1s linear;-o-transition:overflow .1s linear;-moz-transition:overflow .1s linear;transition:overflow .1s linear}.dg li:not(.folder){cursor:auto;height:27px;line-height:27px;padding:0 4px 0 5px}.dg li.folder{padding:0;border-left:4px solid rgba(0,0,0,0)}.dg li.title{cursor:pointer;margin-left:-4px}.dg .closed li:not(.title),.dg .closed ul li,.dg .closed ul li>*{height:0;overflow:hidden;border:0}.dg .cr{clear:both;padding-left:3px;height:27px;overflow:hidden}.dg .property-name{cursor:default;float:left;clear:left;width:40%;overflow:hidden;text-overflow:ellipsis}.dg .cr.function .property-name{width:100%}.dg .c{float:left;width:60%;position:relative}.dg .c input[type=text]{border:0;margin-top:4px;padding:3px;width:100%;float:right}.dg .has-slider input[type=text]{width:30%;margin-left:0}.dg .slider{float:left;width:66%;margin-left:-5px;margin-right:0;height:19px;margin-top:4px}.dg .slider-fg{height:100%}.dg .c input[type=checkbox]{margin-top:7px}.dg .c select{margin-top:5px}.dg .cr.function,.dg .cr.function .property-name,.dg .cr.function *,.dg .cr.boolean,.dg .cr.boolean *{cursor:pointer}.dg .cr.color{overflow:visible}.dg .selector{display:none;position:absolute;margin-left:-9px;margin-top:23px;z-index:10}.dg .c:hover .selector,.dg .selector.drag{display:block}.dg li.save-row{padding:0}.dg li.save-row .button{display:inline-block;padding:0px 6px}.dg.dialogue{background-color:#222;width:460px;padding:15px;font-size:13px;line-height:15px}#dg-new-constructor{padding:10px;color:#222;font-family:Monaco, monospace;font-size:10px;border:0;resize:none;box-shadow:inset 1px 1px 1px #888;word-wrap:break-word;margin:12px 0;display:block;width:440px;overflow-y:scroll;height:100px;position:relative}#dg-local-explain{display:none;font-size:11px;line-height:17px;border-radius:3px;background-color:#333;padding:8px;margin-top:10px}#dg-local-explain code{font-size:10px}#dat-gui-save-locally{display:none}.dg{color:#eee;font:11px 'Lucida Grande', sans-serif;text-shadow:0 -1px 0 #111}.dg.main::-webkit-scrollbar{width:5px;background:#1a1a1a}.dg.main::-webkit-scrollbar-corner{height:0;display:none}.dg.main::-webkit-scrollbar-thumb{border-radius:5px;background:#676767}.dg li:not(.folder){background:#1a1a1a;border-bottom:1px solid #2c2c2c}.dg li.save-row{line-height:25px;background:#dad5cb;border:0}.dg li.save-row select{margin-left:5px;width:108px}.dg li.save-row .button{margin-left:5px;margin-top:1px;border-radius:2px;font-size:9px;line-height:7px;padding:4px 4px 5px 4px;background:#c5bdad;color:#fff;text-shadow:0 1px 0 #b0a58f;box-shadow:0 -1px 0 #b0a58f;cursor:pointer}.dg li.save-row .button.gears{background:#c5bdad url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAANCAYAAAB/9ZQ7AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAQJJREFUeNpiYKAU/P//PwGIC/ApCABiBSAW+I8AClAcgKxQ4T9hoMAEUrxx2QSGN6+egDX+/vWT4e7N82AMYoPAx/evwWoYoSYbACX2s7KxCxzcsezDh3evFoDEBYTEEqycggWAzA9AuUSQQgeYPa9fPv6/YWm/Acx5IPb7ty/fw+QZblw67vDs8R0YHyQhgObx+yAJkBqmG5dPPDh1aPOGR/eugW0G4vlIoTIfyFcA+QekhhHJhPdQxbiAIguMBTQZrPD7108M6roWYDFQiIAAv6Aow/1bFwXgis+f2LUAynwoIaNcz8XNx3Dl7MEJUDGQpx9gtQ8YCueB+D26OECAAQDadt7e46D42QAAAABJRU5ErkJggg==) 2px 1px no-repeat;height:7px;width:8px}.dg li.save-row .button:hover{background-color:#bab19e;box-shadow:0 -1px 0 #b0a58f}.dg li.folder{border-bottom:0}.dg li.title{padding-left:16px;background:#000 url(data:image/gif;base64,R0lGODlhBQAFAJEAAP////Pz8////////yH5BAEAAAIALAAAAAAFAAUAAAIIlI+hKgFxoCgAOw==) 6px 10px no-repeat;cursor:pointer;border-bottom:1px solid rgba(255,255,255,0.2)}.dg .closed li.title{background-image:url(data:image/gif;base64,R0lGODlhBQAFAJEAAP////Pz8////////yH5BAEAAAIALAAAAAAFAAUAAAIIlGIWqMCbWAEAOw==)}.dg .cr.boolean{border-left:3px solid #806787}.dg .cr.color{border-left:3px solid}.dg .cr.function{border-left:3px solid #e61d5f}.dg .cr.number{border-left:3px solid #2FA1D6}.dg .cr.number input[type=text]{color:#2FA1D6}.dg .cr.string{border-left:3px solid #1ed36f}.dg .cr.string input[type=text]{color:#1ed36f}.dg .cr.function:hover,.dg .cr.boolean:hover{background:#111}.dg .c input[type=text]{background:#303030;outline:none}.dg .c input[type=text]:hover{background:#3c3c3c}.dg .c input[type=text]:focus{background:#494949;color:#fff}.dg .c .slider{background:#303030;cursor:ew-resize}.dg .c .slider-fg{background:#2FA1D6;max-width:100%}.dg .c .slider:hover{background:#3c3c3c}.dg .c .slider:hover .slider-fg{background:#44abda}
`);
s1.inject(c1);
var nd = "dg", rd = 72, sd = 20, uo = "Default", Ka = function() {
  try {
    return !!window.localStorage;
  } catch {
    return !1;
  }
}(), io = void 0, ad = !0, Ca = void 0, Rh = !1, _g = [], yn = function b(e) {
  var t = this, n = e || {};
  this.domElement = document.createElement("div"), this.__ul = document.createElement("ul"), this.domElement.appendChild(this.__ul), Mt.addClass(this.domElement, nd), this.__folders = {}, this.__controllers = [], this.__rememberedObjects = [], this.__rememberedObjectIndecesToControllers = [], this.__listening = [], n = Dt.defaults(n, {
    closeOnTop: !1,
    autoPlace: !0,
    width: b.DEFAULT_WIDTH
  }), n = Dt.defaults(n, {
    resizable: n.autoPlace,
    hideable: n.autoPlace
  }), Dt.isUndefined(n.load) ? n.load = { preset: uo } : n.preset && (n.load.preset = n.preset), Dt.isUndefined(n.parent) && n.hideable && _g.push(this), n.resizable = Dt.isUndefined(n.parent) && n.resizable, n.autoPlace && Dt.isUndefined(n.scrollable) && (n.scrollable = !0);
  var s = Ka && localStorage.getItem(Aa(this, "isLocal")) === "true", o = void 0, h = void 0;
  if (Object.defineProperties(
    this,
    {
      parent: {
        get: function() {
          return n.parent;
        }
      },
      scrollable: {
        get: function() {
          return n.scrollable;
        }
      },
      autoPlace: {
        get: function() {
          return n.autoPlace;
        }
      },
      closeOnTop: {
        get: function() {
          return n.closeOnTop;
        }
      },
      preset: {
        get: function() {
          return t.parent ? t.getRoot().preset : n.load.preset;
        },
        set: function(U) {
          t.parent ? t.getRoot().preset = U : n.load.preset = U, p1(this), t.revert();
        }
      },
      width: {
        get: function() {
          return n.width;
        },
        set: function(U) {
          n.width = U, eu(t, U);
        }
      },
      name: {
        get: function() {
          return n.name;
        },
        set: function(U) {
          n.name = U, h && (h.innerHTML = n.name);
        }
      },
      closed: {
        get: function() {
          return n.closed;
        },
        set: function(U) {
          n.closed = U, n.closed ? Mt.addClass(t.__ul, b.CLASS_CLOSED) : Mt.removeClass(t.__ul, b.CLASS_CLOSED), this.onResize(), t.__closeButton && (t.__closeButton.innerHTML = U ? b.TEXT_OPEN : b.TEXT_CLOSED);
        }
      },
      load: {
        get: function() {
          return n.load;
        }
      },
      useLocalStorage: {
        get: function() {
          return s;
        },
        set: function(U) {
          Ka && (s = U, U ? Mt.bind(window, "unload", o) : Mt.unbind(window, "unload", o), localStorage.setItem(Aa(t, "isLocal"), U));
        }
      }
    }
  ), Dt.isUndefined(n.parent)) {
    if (this.closed = n.closed || !1, Mt.addClass(this.domElement, b.CLASS_MAIN), Mt.makeSelectable(this.domElement, !1), Ka && s) {
      t.useLocalStorage = !0;
      var c = localStorage.getItem(Aa(this, "gui"));
      c && (n.load = JSON.parse(c));
    }
    this.__closeButton = document.createElement("div"), this.__closeButton.innerHTML = b.TEXT_CLOSED, Mt.addClass(this.__closeButton, b.CLASS_CLOSE_BUTTON), n.closeOnTop ? (Mt.addClass(this.__closeButton, b.CLASS_CLOSE_TOP), this.domElement.insertBefore(this.__closeButton, this.domElement.childNodes[0])) : (Mt.addClass(this.__closeButton, b.CLASS_CLOSE_BOTTOM), this.domElement.appendChild(this.__closeButton)), Mt.bind(this.__closeButton, "click", function() {
      t.closed = !t.closed;
    });
  } else {
    n.closed === void 0 && (n.closed = !0);
    var _ = document.createTextNode(n.name);
    Mt.addClass(_, "controller-name"), h = Mu(t, _);
    var x = function(U) {
      return U.preventDefault(), t.closed = !t.closed, !1;
    };
    Mt.addClass(this.__ul, b.CLASS_CLOSED), Mt.addClass(h, "title"), Mt.bind(h, "click", x), n.closed || (this.closed = !1);
  }
  n.autoPlace && (Dt.isUndefined(n.parent) && (ad && (Ca = document.createElement("div"), Mt.addClass(Ca, nd), Mt.addClass(Ca, b.CLASS_AUTO_PLACE_CONTAINER), document.body.appendChild(Ca), ad = !1), Ca.appendChild(this.domElement), Mt.addClass(this.domElement, b.CLASS_AUTO_PLACE)), this.parent || eu(t, n.width)), this.__resizeHandler = function() {
    t.onResizeDebounced();
  }, Mt.bind(window, "resize", this.__resizeHandler), Mt.bind(this.__ul, "webkitTransitionEnd", this.__resizeHandler), Mt.bind(this.__ul, "transitionend", this.__resizeHandler), Mt.bind(this.__ul, "oTransitionEnd", this.__resizeHandler), this.onResize(), n.resizable && g1(this), o = function() {
    Ka && localStorage.getItem(Aa(t, "isLocal")) === "true" && localStorage.setItem(Aa(t, "gui"), JSON.stringify(t.getSaveObject()));
  }, this.saveToLocalStorageIfPossible = o;
  function B() {
    var P = t.getRoot();
    P.width += 1, Dt.defer(function() {
      P.width -= 1;
    });
  }
  n.parent || B();
};
yn.toggleHide = function() {
  Rh = !Rh, Dt.each(_g, function(b) {
    b.domElement.style.display = Rh ? "none" : "";
  });
};
yn.CLASS_AUTO_PLACE = "a";
yn.CLASS_AUTO_PLACE_CONTAINER = "ac";
yn.CLASS_MAIN = "main";
yn.CLASS_CONTROLLER_ROW = "cr";
yn.CLASS_TOO_TALL = "taller-than-window";
yn.CLASS_CLOSED = "closed";
yn.CLASS_CLOSE_BUTTON = "close-button";
yn.CLASS_CLOSE_TOP = "close-top";
yn.CLASS_CLOSE_BOTTOM = "close-bottom";
yn.CLASS_DRAG = "drag";
yn.DEFAULT_WIDTH = 245;
yn.TEXT_CLOSED = "Close Controls";
yn.TEXT_OPEN = "Open Controls";
yn._keydownHandler = function(b) {
  document.activeElement.type !== "text" && (b.which === rd || b.keyCode === rd) && yn.toggleHide();
};
Mt.bind(window, "keydown", yn._keydownHandler, !1);
Dt.extend(
  yn.prototype,
  {
    add: function(e, t) {
      return no(this, e, t, {
        factoryArgs: Array.prototype.slice.call(arguments, 2)
      });
    },
    addColor: function(e, t) {
      return no(this, e, t, {
        color: !0
      });
    },
    remove: function(e) {
      this.__ul.removeChild(e.__li), this.__controllers.splice(this.__controllers.indexOf(e), 1);
      var t = this;
      Dt.defer(function() {
        t.onResize();
      });
    },
    destroy: function() {
      if (this.parent)
        throw new Error("Only the root GUI should be removed with .destroy(). For subfolders, use gui.removeFolder(folder) instead.");
      this.autoPlace && Ca.removeChild(this.domElement);
      var e = this;
      Dt.each(this.__folders, function(t) {
        e.removeFolder(t);
      }), Mt.unbind(window, "keydown", yn._keydownHandler, !1), od(this);
    },
    addFolder: function(e) {
      if (this.__folders[e] !== void 0)
        throw new Error('You already have a folder in this GUI by the name "' + e + '"');
      var t = { name: e, parent: this };
      t.autoPlace = this.autoPlace, this.load && this.load.folders && this.load.folders[e] && (t.closed = this.load.folders[e].closed, t.load = this.load.folders[e]);
      var n = new yn(t);
      this.__folders[e] = n;
      var s = Mu(this, n.domElement);
      return Mt.addClass(s, "folder"), n;
    },
    removeFolder: function(e) {
      this.__ul.removeChild(e.domElement.parentElement), delete this.__folders[e.name], this.load && this.load.folders && this.load.folders[e.name] && delete this.load.folders[e.name], od(e);
      var t = this;
      Dt.each(e.__folders, function(n) {
        e.removeFolder(n);
      }), Dt.defer(function() {
        t.onResize();
      });
    },
    open: function() {
      this.closed = !1;
    },
    close: function() {
      this.closed = !0;
    },
    hide: function() {
      this.domElement.style.display = "none";
    },
    show: function() {
      this.domElement.style.display = "";
    },
    onResize: function() {
      var e = this.getRoot();
      if (e.scrollable) {
        var t = Mt.getOffset(e.__ul).top, n = 0;
        Dt.each(e.__ul.childNodes, function(s) {
          e.autoPlace && s === e.__save_row || (n += Mt.getHeight(s));
        }), window.innerHeight - t - sd < n ? (Mt.addClass(e.domElement, yn.CLASS_TOO_TALL), e.__ul.style.height = window.innerHeight - t - sd + "px") : (Mt.removeClass(e.domElement, yn.CLASS_TOO_TALL), e.__ul.style.height = "auto");
      }
      e.__resize_handle && Dt.defer(function() {
        e.__resize_handle.style.height = e.__ul.offsetHeight + "px";
      }), e.__closeButton && (e.__closeButton.style.width = e.width + "px");
    },
    onResizeDebounced: Dt.debounce(function() {
      this.onResize();
    }, 50),
    remember: function() {
      if (Dt.isUndefined(io) && (io = new u1(), io.domElement.innerHTML = a1), this.parent)
        throw new Error("You can only call remember on a top level GUI.");
      var e = this;
      Dt.each(Array.prototype.slice.call(arguments), function(t) {
        e.__rememberedObjects.length === 0 && d1(e), e.__rememberedObjects.indexOf(t) === -1 && e.__rememberedObjects.push(t);
      }), this.autoPlace && eu(this, this.width);
    },
    getRoot: function() {
      for (var e = this; e.parent; )
        e = e.parent;
      return e;
    },
    getSaveObject: function() {
      var e = this.load;
      return e.closed = this.closed, this.__rememberedObjects.length > 0 && (e.preset = this.preset, e.remembered || (e.remembered = {}), e.remembered[this.preset] = rl(this)), e.folders = {}, Dt.each(this.__folders, function(t, n) {
        e.folders[n] = t.getSaveObject();
      }), e;
    },
    save: function() {
      this.load.remembered || (this.load.remembered = {}), this.load.remembered[this.preset] = rl(this), Jh(this, !1), this.saveToLocalStorageIfPossible();
    },
    saveAs: function(e) {
      this.load.remembered || (this.load.remembered = {}, this.load.remembered[uo] = rl(this, !0)), this.load.remembered[e] = rl(this), this.preset = e, Qh(this, e, !0), this.saveToLocalStorageIfPossible();
    },
    revert: function(e) {
      Dt.each(this.__controllers, function(t) {
        this.getRoot().load.remembered ? vg(e || this.getRoot(), t) : t.setValue(t.initialValue), t.__onFinishChange && t.__onFinishChange.call(t, t.getValue());
      }, this), Dt.each(this.__folders, function(t) {
        t.revert(t);
      }), e || Jh(this.getRoot(), !1);
    },
    listen: function(e) {
      var t = this.__listening.length === 0;
      this.__listening.push(e), t && yg(this.__listening);
    },
    updateDisplay: function() {
      Dt.each(this.__controllers, function(e) {
        e.updateDisplay();
      }), Dt.each(this.__folders, function(e) {
        e.updateDisplay();
      });
    }
  }
);
function Mu(b, e, t) {
  var n = document.createElement("li");
  return e && n.appendChild(e), t ? b.__ul.insertBefore(n, t) : b.__ul.appendChild(n), b.onResize(), n;
}
function od(b) {
  Mt.unbind(window, "resize", b.__resizeHandler), b.saveToLocalStorageIfPossible && Mt.unbind(window, "unload", b.saveToLocalStorageIfPossible);
}
function Jh(b, e) {
  var t = b.__preset_select[b.__preset_select.selectedIndex];
  e ? t.innerHTML = t.value + "*" : t.innerHTML = t.value;
}
function f1(b, e, t) {
  if (t.__li = e, t.__gui = b, Dt.extend(t, {
    options: function(h) {
      if (arguments.length > 1) {
        var c = t.__li.nextElementSibling;
        return t.remove(), no(b, t.object, t.property, {
          before: c,
          factoryArgs: [Dt.toArray(arguments)]
        });
      }
      if (Dt.isArray(h) || Dt.isObject(h)) {
        var _ = t.__li.nextElementSibling;
        return t.remove(), no(b, t.object, t.property, {
          before: _,
          factoryArgs: [h]
        });
      }
    },
    name: function(h) {
      return t.__li.firstElementChild.firstElementChild.innerHTML = h, t;
    },
    listen: function() {
      return t.__gui.listen(t), t;
    },
    remove: function() {
      return t.__gui.remove(t), t;
    }
  }), t instanceof Xh) {
    var n = new Sl(t.object, t.property, { min: t.__min, max: t.__max, step: t.__step });
    Dt.each(["updateDisplay", "onChange", "onFinishChange", "step", "min", "max"], function(o) {
      var h = t[o], c = n[o];
      t[o] = n[o] = function() {
        var _ = Array.prototype.slice.call(arguments);
        return c.apply(n, _), h.apply(t, _);
      };
    }), Mt.addClass(e, "has-slider"), t.domElement.insertBefore(n.domElement, t.domElement.firstElementChild);
  } else if (t instanceof Sl) {
    var s = function(h) {
      if (Dt.isNumber(t.__min) && Dt.isNumber(t.__max)) {
        var c = t.__li.firstElementChild.firstElementChild.innerHTML, _ = t.__gui.__listening.indexOf(t) > -1;
        t.remove();
        var x = no(b, t.object, t.property, {
          before: t.__li.nextElementSibling,
          factoryArgs: [t.__min, t.__max, t.__step]
        });
        return x.name(c), _ && x.listen(), x;
      }
      return h;
    };
    t.min = Dt.compose(s, t.min), t.max = Dt.compose(s, t.max);
  } else
    t instanceof gg ? (Mt.bind(e, "click", function() {
      Mt.fakeEvent(t.__checkbox, "click");
    }), Mt.bind(t.__checkbox, "click", function(o) {
      o.stopPropagation();
    })) : t instanceof mg ? (Mt.bind(e, "click", function() {
      Mt.fakeEvent(t.__button, "click");
    }), Mt.bind(e, "mouseover", function() {
      Mt.addClass(t.__button, "hover");
    }), Mt.bind(e, "mouseout", function() {
      Mt.removeClass(t.__button, "hover");
    })) : t instanceof Kh && (Mt.addClass(e, "color"), t.updateDisplay = Dt.compose(function(o) {
      return e.style.borderLeftColor = t.__color.toString(), o;
    }, t.updateDisplay), t.updateDisplay());
  t.setValue = Dt.compose(function(o) {
    return b.getRoot().__preset_select && t.isModified() && Jh(b.getRoot(), !0), o;
  }, t.setValue);
}
function vg(b, e) {
  var t = b.getRoot(), n = t.__rememberedObjects.indexOf(e.object);
  if (n !== -1) {
    var s = t.__rememberedObjectIndecesToControllers[n];
    if (s === void 0 && (s = {}, t.__rememberedObjectIndecesToControllers[n] = s), s[e.property] = e, t.load && t.load.remembered) {
      var o = t.load.remembered, h = void 0;
      if (o[b.preset])
        h = o[b.preset];
      else if (o[uo])
        h = o[uo];
      else
        return;
      if (h[n] && h[n][e.property] !== void 0) {
        var c = h[n][e.property];
        e.initialValue = c, e.setValue(c);
      }
    }
  }
}
function no(b, e, t, n) {
  if (e[t] === void 0)
    throw new Error('Object "' + e + '" has no property "' + t + '"');
  var s = void 0;
  if (n.color)
    s = new Kh(e, t);
  else {
    var o = [e, t].concat(n.factoryArgs);
    s = o1.apply(b, o);
  }
  n.before instanceof da && (n.before = n.before.__li), vg(b, s), Mt.addClass(s.domElement, "c");
  var h = document.createElement("span");
  Mt.addClass(h, "property-name"), h.innerHTML = s.property;
  var c = document.createElement("div");
  c.appendChild(h), c.appendChild(s.domElement);
  var _ = Mu(b, c, n.before);
  return Mt.addClass(_, yn.CLASS_CONTROLLER_ROW), s instanceof Kh ? Mt.addClass(_, "color") : Mt.addClass(_, Kw(s.getValue())), f1(b, _, s), b.__controllers.push(s), s;
}
function Aa(b, e) {
  return document.location.href + "." + e;
}
function Qh(b, e, t) {
  var n = document.createElement("option");
  n.innerHTML = e, n.value = e, b.__preset_select.appendChild(n), t && (b.__preset_select.selectedIndex = b.__preset_select.length - 1);
}
function ld(b, e) {
  e.style.display = b.useLocalStorage ? "block" : "none";
}
function d1(b) {
  var e = b.__save_row = document.createElement("li");
  Mt.addClass(b.domElement, "has-save"), b.__ul.insertBefore(e, b.__ul.firstChild), Mt.addClass(e, "save-row");
  var t = document.createElement("span");
  t.innerHTML = "&nbsp;", Mt.addClass(t, "button gears");
  var n = document.createElement("span");
  n.innerHTML = "Save", Mt.addClass(n, "button"), Mt.addClass(n, "save");
  var s = document.createElement("span");
  s.innerHTML = "New", Mt.addClass(s, "button"), Mt.addClass(s, "save-as");
  var o = document.createElement("span");
  o.innerHTML = "Revert", Mt.addClass(o, "button"), Mt.addClass(o, "revert");
  var h = b.__preset_select = document.createElement("select");
  if (b.load && b.load.remembered ? Dt.each(b.load.remembered, function(P, U) {
    Qh(b, U, U === b.preset);
  }) : Qh(b, uo, !1), Mt.bind(h, "change", function() {
    for (var P = 0; P < b.__preset_select.length; P++)
      b.__preset_select[P].innerHTML = b.__preset_select[P].value;
    b.preset = this.value;
  }), e.appendChild(h), e.appendChild(t), e.appendChild(n), e.appendChild(s), e.appendChild(o), Ka) {
    var c = document.getElementById("dg-local-explain"), _ = document.getElementById("dg-local-storage"), x = document.getElementById("dg-save-locally");
    x.style.display = "block", localStorage.getItem(Aa(b, "isLocal")) === "true" && _.setAttribute("checked", "checked"), ld(b, c), Mt.bind(_, "change", function() {
      b.useLocalStorage = !b.useLocalStorage, ld(b, c);
    });
  }
  var B = document.getElementById("dg-new-constructor");
  Mt.bind(B, "keydown", function(P) {
    P.metaKey && (P.which === 67 || P.keyCode === 67) && io.hide();
  }), Mt.bind(t, "click", function() {
    B.innerHTML = JSON.stringify(b.getSaveObject(), void 0, 2), io.show(), B.focus(), B.select();
  }), Mt.bind(n, "click", function() {
    b.save();
  }), Mt.bind(s, "click", function() {
    var P = prompt("Enter a new preset name.");
    P && b.saveAs(P);
  }), Mt.bind(o, "click", function() {
    b.revert();
  });
}
function g1(b) {
  var e = void 0;
  b.__resize_handle = document.createElement("div"), Dt.extend(b.__resize_handle.style, {
    width: "6px",
    marginLeft: "-3px",
    height: "200px",
    cursor: "ew-resize",
    position: "absolute"
  });
  function t(o) {
    return o.preventDefault(), b.width += e - o.clientX, b.onResize(), e = o.clientX, !1;
  }
  function n() {
    Mt.removeClass(b.__closeButton, yn.CLASS_DRAG), Mt.unbind(window, "mousemove", t), Mt.unbind(window, "mouseup", n);
  }
  function s(o) {
    return o.preventDefault(), e = o.clientX, Mt.addClass(b.__closeButton, yn.CLASS_DRAG), Mt.bind(window, "mousemove", t), Mt.bind(window, "mouseup", n), !1;
  }
  Mt.bind(b.__resize_handle, "mousedown", s), Mt.bind(b.__closeButton, "mousedown", s), b.domElement.insertBefore(b.__resize_handle, b.domElement.firstElementChild);
}
function eu(b, e) {
  b.domElement.style.width = e + "px", b.__save_row && b.autoPlace && (b.__save_row.style.width = e + "px"), b.__closeButton && (b.__closeButton.style.width = e + "px");
}
function rl(b, e) {
  var t = {};
  return Dt.each(b.__rememberedObjects, function(n, s) {
    var o = {}, h = b.__rememberedObjectIndecesToControllers[s];
    Dt.each(h, function(c, _) {
      o[_] = e ? c.initialValue : c.getValue();
    }), t[s] = o;
  }), t;
}
function p1(b) {
  for (var e = 0; e < b.__preset_select.length; e++)
    b.__preset_select[e].value === b.preset && (b.__preset_select.selectedIndex = e);
}
function yg(b) {
  b.length !== 0 && h1.call(window, function() {
    yg(b);
  }), Dt.each(b, function(e) {
    e.updateDisplay();
  });
}
var m1 = yn;
let Dh = null;
class _1 {
  constructor(e) {
    if (this.debug = null, this.config = null, this.updateConfig = (t) => {
      this.config = t;
    }, Dh)
      return Dh;
    Dh = this, this.config = e, this.init();
  }
  init() {
    if (this.debug)
      return;
    const e = new m1({ width: 300 });
    let t;
    window.parent !== window ? (t = this.getExportIntegration(), e.add(t, "export").name("Save")) : (t = this.getExportStandalone(), e.add(t, "export").name("Export")), this.debug = e, this.debug.domElement.style.display = "none", new URLSearchParams(window.location.search).get("config") === "true" && (this.debug.open(), this.debug.domElement.style.display = "block");
  }
  getExportIntegration() {
    return {
      export: () => {
        const t = "babylon-customization.json", n = this.exportConfigCustmizations(this.config);
        window.parent.postMessage(
          {
            type: "exportConfig",
            data: {
              filename: t,
              config: n
            }
          },
          "*"
        );
      }
    };
  }
  getExportStandalone() {
    return {
      export: () => {
        const t = "babylon-customization.json", n = JSON.stringify(this.exportConfigCustmizations(this.config));
        let s = document.createElement("a");
        s.setAttribute("href", "data:text/plain;charset=utf-8," + encodeURIComponent(n)), s.setAttribute("download", t), s.style.display = "none", document.body.appendChild(s), s.click(), document.body.removeChild(s);
      }
    };
  }
  updateDisplay(e) {
    if (e) {
      for (var t in e.__controllers)
        e.__controllers[t].updateDisplay();
      for (var n in e.__folders)
        this.updateDisplay(e.__folders[n]);
    }
  }
  exportConfigCustmizations(e) {
    if (!(!e || !this.debug))
      return e;
  }
  exportCustomProperties(e) {
    return Object.entries(e.__folders).map(([t, n]) => ({
      [t]: this.exportCustomPropertiesProps(n)
    })).reduce((t, n) => ({ ...n, ...t }), {});
  }
  exportCustomPropertiesProps(e) {
    const t = e.__controllers.reduce(
      (s, o) => ({
        ...s,
        [o.property]: o.getValue()
      }),
      {}
    ), n = Object.entries(e.__folders).map(([s, o]) => ({
      [s]: this.exportCustomPropertiesProps(o)
    })).reduce((s, o) => ({ ...o, ...s }), {});
    return {
      ...t,
      ...n
    };
  }
}
class v1 {
  constructor(e, t, n) {
    this.gui = null, this.config = null, this.sceneHelper = null, this.shadowMinZController = null, this.shadowMaxZController = null;
    const s = new _1(e);
    s.init(), this.gui = s, this.onUpdate = t, this.config = e, this.sceneHelper = n;
  }
  /**
   * The function "setupGui" configures the general, environment, lights, and camera settings based on
   * the provided configuration object, and calls the onUpdate function with the updated configuration.
   * @param {SceneConfig} config - The `config` parameter is an object that contains the initial configuration
   * for the GUI. It may include properties such as general settings, environment settings, lights
   * settings, and camera settings.
   * @param onUpdate - The `onUpdate` parameter is a callback function that will be called whenever
   * there is an update to the configuration. It takes a new configuration object as a parameter
   * (`newConfig: SceneConfig`).
   */
  setupGui(e) {
    if (!this.config)
      return;
    const t = (n) => {
      var s;
      this.onUpdate(n), (s = this.gui) == null || s.updateConfig(n);
    };
    this.configureGeneral(this.config, t), this.configureEnvironment(this.config, t), this.configureLights(this.config, t), this.configureCamera(this.config, t, e), this.configureShadows(this.config, t), this.configureAr(this.config, t), this.configureModel(this.config, t), this.configureAnimations(this.config, t, e);
  }
  configureModel(e, t) {
    var s, o;
    if (!e.model)
      return;
    const n = (o = (s = this.gui) == null ? void 0 : s.debug) == null ? void 0 : o.addFolder("Model");
    e.model.config || (e.model.config = { doubleSided: !0 }), n == null || n.add(e.model.config, "doubleSided").name("Double Sided").onFinishChange(() => {
      t(e);
    });
  }
  configureShadows(e, t) {
    var o, h, c, _, x, B;
    if (!e.environment || !e.environment.shadows)
      return;
    const n = (h = (o = this.gui) == null ? void 0 : o.debug) == null ? void 0 : h.addFolder("Shadows");
    n == null || n.add(e.environment.shadows, "enableShadows").name("Enable Shadows").onChange(() => {
      t(e);
    }), n == null || n.addColor(e.environment.shadows, "shadowHexColor").name("Hex Color").onChange(() => {
      t(e);
    }), n == null || n.add(e.environment.shadows, "shadowDarkness", 0, 1, 0.1).name("Transparency").onChange(() => {
      t(e);
    }), n == null || n.add(e.environment.shadows, "groundSizeMultiplierWidth", 0, 5, 0.1).name("Ground Width").onChange(() => {
      t(e);
    }), n == null || n.add(e.environment.shadows, "groundSizeMultiplierLength", 0, 5, 0.1).name("Ground Length").onChange(() => {
      t(e);
    }), n == null || n.add(e.environment.shadows, "shadowMapSize", 0, 128, 4).name("Map Size").onChange(() => {
      t(e);
    });
    const s = {
      enableShadowMinZ: !!((_ = (c = e == null ? void 0 : e.environment) == null ? void 0 : c.shadows) != null && _.shadowMinZ),
      enableShadowMaxZ: !!((B = (x = e == null ? void 0 : e.environment) == null ? void 0 : x.shadows) != null && B.shadowMaxZ)
    };
    n == null || n.add(s, "enableShadowMinZ").name("Enable starting shadow clipping").onChange(() => {
      s.enableShadowMinZ ? e.environment.shadows.shadowMinZ = 0 : (e.environment.shadows.shadowMinZ = null, t(e)), this.buildShadowZConfig(e, n, t);
    }), n == null || n.add(s, "enableShadowMaxZ").name("Enable ending shadow clipping").onChange(() => {
      s.enableShadowMaxZ ? e.environment.shadows.shadowMaxZ = 0 : (e.environment.shadows.shadowMaxZ = null, t(e)), this.buildShadowZConfig(e, n, t);
    }), n && this.buildShadowZConfig(e, n, t);
  }
  buildShadowZConfig(e, t, n) {
    var s, o, h, c, _, x, B, P, U, M;
    ((o = (s = e == null ? void 0 : e.environment) == null ? void 0 : s.shadows) == null ? void 0 : o.shadowMinZ) !== void 0 && ((c = (h = e == null ? void 0 : e.environment) == null ? void 0 : h.shadows) == null ? void 0 : c.shadowMinZ) !== null ? this.shadowMinZController || (this.shadowMinZController = t == null ? void 0 : t.add((_ = e == null ? void 0 : e.environment) == null ? void 0 : _.shadows, "shadowMinZ", -50, 0, 1).name("Clipping Start").onChange(() => {
      n(e);
    })) : this.shadowMinZController && (t == null || t.remove(this.shadowMinZController), this.shadowMinZController = null), ((B = (x = e == null ? void 0 : e.environment) == null ? void 0 : x.shadows) == null ? void 0 : B.shadowMaxZ) !== void 0 && ((U = (P = e == null ? void 0 : e.environment) == null ? void 0 : P.shadows) == null ? void 0 : U.shadowMaxZ) !== null ? this.shadowMaxZController || (this.shadowMaxZController = t == null ? void 0 : t.add((M = e == null ? void 0 : e.environment) == null ? void 0 : M.shadows, "shadowMaxZ", 0, 50, 1).name("Clipping End").onChange(() => {
      n(e);
    })) : this.shadowMaxZController && (t == null || t.remove(this.shadowMaxZController), this.shadowMaxZController = null);
  }
  configureGeneral(e, t) {
    var s, o;
    if (!e.general)
      return;
    const n = (o = (s = this.gui) == null ? void 0 : s.debug) == null ? void 0 : o.addFolder("General");
    n == null || n.addColor(e.general, "backgroundColor").name("Background Color").onChange(() => {
      t(e);
    }), n == null || n.add(e.general, "removeDefaultBackground").name("Remove Background").onChange(() => {
      t(e);
    }), e.camera && (n == null || n.add(e.camera, "toneMappingEnabled").name("Tone Mapping Enabled").onFinishChange(() => {
      t(e);
    }), n == null || n.add(e.camera, "toneMappingType", {
      Standard: 0,
      AcesToneMapping: 1
    }).name("Tone Mapping Type").onFinishChange(() => {
      var h;
      (h = e == null ? void 0 : e.camera) != null && h.toneMappingType && (e.camera.toneMappingType = Number(e.camera.toneMappingType)), t(e);
    }), this.configureAntialias(n, e, t));
  }
  configureAntialias(e, t, n) {
    if (!e || !t.general)
      return;
    const s = e == null ? void 0 : e.addFolder("Antialias"), o = s == null ? void 0 : s.addFolder("Desktop"), h = s == null ? void 0 : s.addFolder("Mobile"), c = {
      desktop: null,
      mobile: null
    };
    t.general.antialias ? t.general.antialias && t.general.antialias.desktop && !t.general.antialias.mobile && (t.general.antialias.mobile = {
      enabled: t.general.antialias.desktop.enabled,
      inRotationEnabled: t.general.antialias.desktop.inRotationEnabled
    }) : t.general.antialias = {
      desktop: {
        enabled: !0,
        inRotationEnabled: !1
      },
      mobile: {
        enabled: !0,
        inRotationEnabled: !1
      }
    };
    function _(U, M, Z = !0) {
      var te, ee, le;
      const F = (ee = (te = t.general) == null ? void 0 : te.antialias) == null ? void 0 : ee[U];
      if (!F)
        return;
      const { enabled: Q, inRotationEnabled: D } = F;
      if (F.inRotationEnabled = Q ? D : !1, M) {
        const fe = (le = M.domElement.parentElement) == null ? void 0 : le.parentElement;
        fe && (fe.style.display = Q ? "" : "none");
      }
      Z && n(t);
    }
    function x(U, M) {
      var Q, D;
      const Z = (D = (Q = t.general) == null ? void 0 : Q.antialias) == null ? void 0 : D[M];
      if (!Z)
        return null;
      U == null || U.add(Z, "enabled").name("Enabled").onChange(() => {
        _(M, c[M] ?? void 0);
      });
      const F = U == null ? void 0 : U.add(Z, "inRotationEnabled").name("In Rotation Enabled").listen().onChange(() => n(t));
      return c[M] = F, F;
    }
    const B = x(o, "desktop"), P = x(h, "mobile");
    _("desktop", B ?? void 0, !1), _("mobile", P ?? void 0, !1);
  }
  configureAr(e, t) {
    var B, P, U, M, Z;
    if (!e.general || !e.general.meshSize)
      return;
    const n = (P = (B = this.gui) == null ? void 0 : B.debug) == null ? void 0 : P.addFolder("Augmented Reality");
    n == null || n.add(e.general, "arEnabled").name("Enabled").onChange(() => {
      t(e);
    }), n == null || n.add({ enabled: e.general.arAnchor === "wall" }, "enabled").name("Enable wall placement").onChange((F) => {
      e.general && (e.general.arAnchor = F ? "wall" : null), t(e);
    }), n == null || n.add({ enabled: e.general.arScale ?? !1 }, "enabled").name("Resizable in AR").onChange((F) => {
      e.general && (e.general.arScale = F), t(e);
    }), n == null || n.add({ enabled: e.general.arOnTheFly }, "enabled").name("Faster AR Conversion").onChange((F) => {
      e.general && (e.general.arOnTheFly = F), t(e);
    });
    const s = n == null ? void 0 : n.addFolder("Measure Scene Ar"), o = {
      options: {
        width: ((U = e.general.meshSize) == null ? void 0 : U.width) ?? !1,
        height: ((M = e.general.meshSize) == null ? void 0 : M.height) ?? !1,
        depth: ((Z = e.general.meshSize) == null ? void 0 : Z.depth) ?? !1
      }
    };
    let c = (() => {
      const { width: F, height: Q, depth: D } = o.options;
      return F ? "width" : Q ? "height" : D ? "depth" : null;
    })();
    const _ = (F) => {
      if (F === "none" || !F)
        return 0;
      if (e.general && e.general.meshSize)
        return e.general.meshSize[F];
    };
    s == null || s.add(o, "options", {
      None: "none",
      Width: "width",
      Height: "height",
      Depth: "depth"
    }).name("Know Dimension").setValue(c).onFinishChange((F) => {
      c = F, F === "none" && e.general && e.general.meshSize && (e.general.meshSize = {
        width: null,
        height: null,
        depth: null
      }, t(e)), x == null || x.setValue(_(c));
    });
    const x = s == null ? void 0 : s.add({ size: 0 }, "size", -500, 500, 1).name("Measure (cm)").setValue(_(c)).onFinishChange((F) => {
      e.general && e.general.meshSize && (Object.keys(e.general.meshSize).forEach((Q) => {
        e.general && e.general.meshSize && (e.general.meshSize[Q] = Q !== c ? null : F);
      }), t(e));
    });
  }
  configureEnvironment(e, t) {
    var s, o;
    if (!e.general || !e.general.environmentOptions)
      return;
    const n = (o = (s = this.gui) == null ? void 0 : s.debug) == null ? void 0 : o.addFolder("Environment");
    n == null || n.add(e.general, "exposure", 0, 5, 0.1).name("Exposure").onChange(() => {
      t(e);
    }), n == null || n.add(e.general, "contrast", 0, 5, 0.1).name("Contrast").onChange(() => {
      t(e);
    }).isModified, n == null || n.add(e.general.environmentOptions, "rotationY", 0, 10, 1e-3).name("Rotation Y").onChange(() => {
      t(e);
    }), n == null || n.add(e.general.environmentOptions, "intensity", 0, 20, 0.1).name("Intensity").onChange(() => {
      t(e);
    }), n == null || n.add(e.general.environmentOptions, "pbrIntensity", 0, 20, 0.1).name("PBR Intensity").onChange(() => {
      t(e);
    });
  }
  configureCamera(e, t, n) {
    var B, P;
    const s = n == null ? void 0 : n.cameras.find((U) => U instanceof BABYLON.ArcRotateCamera);
    if (!e.camera || !e.camera.position || !s)
      return;
    const o = (P = (B = this.gui) == null ? void 0 : B.debug) == null ? void 0 : P.addFolder("Camera");
    o == null || o.add(e.camera, "autoRotate").name("Auto Rotate").onChange(() => {
      t(e);
    }), e.camera.zoom === void 0 && (e.camera.zoom = 0), o == null || o.add(e.camera, "zoom", -50, 10, 0.1).name("Initial Zoom").onChange(() => {
      t(e);
    }), o == null || o.add(e.camera.position, "fov", 0, 1.6, 1e-3).name("Fov").onChange((U) => {
      s.fov = U, n == null || n.render();
    });
    const h = o == null ? void 0 : o.addFolder("Rotation");
    h == null || h.add(e.camera.position, "alpha", -10, 10, 0.01).name("X").onChange((U) => {
      s.alpha = U, n == null || n.render();
    }), h == null || h.add(e.camera.position, "beta", -3, 3, 0.01).name("Y").onChange((U) => {
      s.beta = U, n == null || n.render();
    });
    const c = o == null ? void 0 : o.addFolder("Zoom Settings");
    e.camera.useMinZoomPerc = e.camera.useMinZoomPerc === null ? !1 : e.camera.useMinZoomPerc, e.camera.useMaxZoomPerc = e.camera.useMaxZoomPerc === null ? !1 : e.camera.useMaxZoomPerc, c == null || c.add(e.camera, "useMinZoomPerc", 0, 1, 0.01).name("Enable Max Zoom").onChange(() => {
      t(e);
    });
    const _ = c == null ? void 0 : c.add(e.camera, "minZoomPerc", 0, 10, 0.01).name("Max Zoom");
    _ == null || _.onChange((U) => {
      var Z;
      const M = (Z = e.camera) == null ? void 0 : Z.maxZoomPerc;
      M && U > M && _.setValue(M), t(e);
    }), c == null || c.add(e.camera, "useMaxZoomPerc", 0, 1, 0.01).name("Enable Min Zoom").onChange(() => {
      t(e);
    });
    const x = c == null ? void 0 : c.add(e.camera, "maxZoomPerc", 0, 10, 0.01).name("Min Zoom");
    x == null || x.onChange((U) => {
      var Z;
      const M = (Z = e.camera) == null ? void 0 : Z.minZoomPerc;
      U === 0 ? x.setValue(0.01) : M && U < M && x.setValue(M), t(e);
    });
  }
  configureLights(e, t) {
    var s, o;
    if (!e.lights)
      return;
    const n = (o = (s = this.gui) == null ? void 0 : s.debug) == null ? void 0 : o.addFolder("Lights");
    this.configureLight(
      n,
      "Directional Light Back",
      e.lights.directionalLightBack,
      e,
      t
    ), this.configureLight(
      n,
      "Directional Light Left",
      e.lights.directionalLightLeft,
      e,
      t
    ), this.configureLight(n, "Point Light Back", e.lights.pointLightBack, e, t), this.configureLight(n, "Point Light Front", e.lights.pointLightFront, e, t), this.configureLight(n, "Hemisphere Light", e.lights.hemisphereLight, e, t);
  }
  configureLight(e, t, n, s, o) {
    const h = e == null ? void 0 : e.addFolder(t), c = h == null ? void 0 : h.addFolder("position"), _ = h == null ? void 0 : h.addFolder("general");
    c == null || c.add(n.position, "x", -100, 100, 0.1).name("Position X").onChange(() => {
      o(s);
    }), c == null || c.add(n.position, "y", -100, 100, 0.1).name("Position Y").onChange(() => {
      o(s);
    }), c == null || c.add(n.position, "z", -100, 100, 0.1).name("Position Z").onChange(() => {
      o(s);
    }), _ == null || _.add(n.general, "intensity", 0, 50, 0.1).name("Intensity").onChange(() => {
      o(s);
    }), _ == null || _.add(n.general, "visible").name("Visible").onChange(() => {
      o(s);
    });
  }
  configureAnimations(e, t, n) {
    var h, c;
    const s = (n == null ? void 0 : n.animationGroups) && n.animationGroups.length > 0;
    if (!e.animations || !s)
      return;
    const o = (c = (h = this.gui) == null ? void 0 : h.debug) == null ? void 0 : c.addFolder("animations");
    o == null || o.add(e.animations, "runAtStart").name("Run At Start").onChange(() => t(e)), o == null || o.add(e.animations, "loop").name("Loop").onChange(() => t(e)), o == null || o.add(e.animations, "speed", 0.1, 5, 0.1).name("Speed").onChange(() => t(e));
  }
}
var y1 = /* @__PURE__ */ ((b) => (b.CameraMovement = "camera-movement", b.ScriptExecution = "script-execution", b.DesignChanged = "design-changed", b))(y1 || {});
class Cu {
  constructor(e) {
    this._zkScene = null, this._zkModel = null, this._canvasID = "zakeke-canvas-viewer3D-" + Zakeke.makeID(5), this._canvas = null, this._domElement = null, this._lastWidth = Number.MIN_VALUE, this._lastHeight = Number.MIN_VALUE, this._resizeObserver = null, this._engine = null, this._scene = null, this._bindedResize = null, this._sceneHelper = null, this._environmentManager = null, this._glowManager = null, this._sceneActionsExecutor = null, this._renderingNeeded = !1, this._renderingPaused = !1, this._autoRender = !1, this._antiAliasConfig = {
      enabled: !0,
      inRotationEnabled: !1
    }, this._postProcesses = [], this._camera = null, this._hemiLight = null, this._pointLight = null, this._highlightColor = "#00ff00", this._highlightSize = 2, this._highlightLayer = null, this._highlightBlurHorizontalSize = 1, this._highlightBlurVerticalSize = 1, this._highlightAnimationID = null, this._highlightCurrentMeshes = [], this._highlightNextMeshes = [], this._deviceType = MPlaza.DeviceType.All, this._destroyed = !1, this._sceneDesignManager = null, this._meshLocationsManager = null, this._renderDesignQueue = Promise.resolve(), this._groupPickedListeners = [], this._focusAttributesListeners = [], this._designNotifyMessageListeners = [], this._designRemoveMessageListeners = [], this._designEventMessages = [], this._onDelayLoadingStart = null, this._onDelayLoadingProgress = null, this._onDelayLoadingSuccess = null, this._onDelayLoadingError = null, this._infoPointPickedListeners = [], this._infoPointContentShownListeners = [], this._infoPointContentHiddenListeners = [], this._beginAssetsLoadingListeners = [], this._endAssetsLoadingListeners = [], this._nextSceneMeshesLoadedListeners = [], this._nextSceneTexturesLoadedListeners = [], this._beginSceneLoadingListeners = [], this._endSceneLoadingListeners = [], this._scriptExecutionListeners = [], this._arFileUrls = {}, this._designTextureResolution = 1024, this._configPreview = !1, this._defaultBackgroundColor = null, this._grids = [], this._dracoCompression = null, this._infoPointsManager = null, this._infoPointsManagerStyle = null, this._canShowInfoPoints = !0, this._canShowInfoPointsContent = !0, this._broadcastChannel = null, this._isHologramSource = !1, this._isHologram = !1, this._lastResizableMeshID = "", this._brandLogoButton = null, this._advancedTexture = null, this._createGui = null, this._performanceInfo = null, this._currentRotation = 0, this._isRotating = !1, this._isViewer = !1, this._isSelectionMode = !0, this._mouseWheelInput = null, this._modelParentNode = null, this.setCameraLocked = (t) => {
      this._zkScene && this._sceneHelper && this._scene && (this._sceneHelper.setupCamera(), this._camera = this._scene.activeCamera, this._camera && (t ? (this._sceneHelper.setCameraLimitLowerRadius(!0), this._sceneHelper.setMinZoomPerc(1), this._sceneHelper.setMaxZoomPerc(1)) : (this._sceneHelper.setCameraLimitLowerRadius(!1), this._sceneHelper.setMinZoomPerc(1), this._sceneHelper.setMaxZoomPerc(1.5))));
    }, e != null && (typeof e == "boolean" ? this._configPreview = e : (this._configPreview = e.configPreview, e.defaultBackgroundColor && (this._defaultBackgroundColor = BABYLON.Color4.FromHexString(e.defaultBackgroundColor)), this._isViewer = (e == null ? void 0 : e.isViewer) ?? !1)), this._elementSelector = new Zd();
  }
  get zkScene() {
    return this._zkScene;
  }
  get zkModel() {
    return this._zkModel;
  }
  get canvas() {
    return this._canvas;
  }
  get engine() {
    return this._engine;
  }
  get scene() {
    return this._scene;
  }
  get autoRender() {
    return this._autoRender;
  }
  set autoRender(e) {
    this._autoRender = e;
  }
  get antiAliasConfig() {
    return this._antiAliasConfig;
  }
  set antiAliasConfig(e) {
    this._antiAliasConfig = e;
  }
  get isLowEndDevice() {
    return this._performanceInfo && this._performanceInfo.isLowEndDevice;
  }
  get isHologramSource() {
    return this.isHologramSource;
  }
  get createGui() {
    return this._createGui;
  }
  set createGui(e) {
    this._createGui = e;
  }
  set isHologramSource(e) {
    this._isHologramSource = e, e && (this._isHologram = !1, this.detachBroadcastChannelEventHandlers());
  }
  get isHologram() {
    return this._isHologram;
  }
  set isHologram(e) {
    this._isHologram = e, e ? (this._isHologramSource = !1, this.attachBroadcastChannelEventHandlers()) : this.detachBroadcastChannelEventHandlers(), this.refreshEnvironment();
  }
  get isSelectionMode() {
    return this._isSelectionMode;
  }
  set isSelectionMode(e) {
    this._isSelectionMode = e;
  }
  setupAntiAliasing() {
    if (this._zkScene) {
      let e = this.getAntiAliasingConfig();
      this._antiAliasConfig = e, e.enabled === !0 ? this.enableAntialiasing() : e.enabled === !1 && this.disableAntialiasing();
    }
  }
  getAntiAliasingConfig() {
    var t, n, s, o, h;
    if (!this._zkScene)
      return this._antiAliasConfig;
    const e = (o = (s = (n = (t = this._zkScene).get) == null ? void 0 : n.call(t, "config")) == null ? void 0 : s.toJSON) == null ? void 0 : o.call(s);
    return (h = e == null ? void 0 : e.general) != null && h.antialias ? gw() ? e.general.antialias.mobile ?? this._antiAliasConfig : e.general.antialias.desktop ?? this._antiAliasConfig : this._antiAliasConfig;
  }
  enableAntialiasing() {
    this._scene && this._antiAliasConfig.enabled && (this.createAntialiasPostProcesses(), this._scene.postProcessesEnabled = !0);
  }
  disableAntialiasing(e = !1) {
    this._scene && (this._scene.postProcessesEnabled = !1), e && this.disposePostProcesses();
  }
  // Per coerenza con tutto il resto inserisco questi metodi set & get,
  // andrebbero usate solo le proprietà, ma questo anche in SceneEditor
  getARScale() {
    let e = !0;
    if (this._zkScene) {
      let t = this._zkScene.getARScale();
      return t ?? e;
    }
    return e;
  }
  setARScale(e) {
    this._zkScene && this._zkScene.setARScale(e);
  }
  getUseMaterialOffloading() {
    let e = !1;
    if (this.zkScene) {
      let t = this.zkScene.getUseMaterialOffloading();
      return t ?? e;
    }
    return e;
  }
  setUseMaterialOffloading(e) {
    this._zkScene && this._zkScene.setUseMaterialOffloading(e);
  }
  getPrefetchMeshes() {
    if (this.zkScene) {
      const t = this.zkScene.getPrefetchMeshes();
      return t ?? !0;
    }
    return !0;
  }
  setPrefetchMeshes(e) {
    this._zkScene && this._zkScene.setPrefetchMeshes(e);
  }
  getPrefetchMaterials() {
    if (this.zkScene) {
      const t = this.zkScene.getPrefetchMaterials();
      return t ?? !0;
    }
    return !0;
  }
  setPrefetchMaterials(e) {
    this._zkScene && this._zkScene.setPrefetchMaterials(e);
  }
  getShowHideInfoPoints() {
    return this.canShowInfoPoints;
  }
  setShowHideInfoPoints(e) {
    this.canShowInfoPoints = e;
  }
  get camera() {
    return this._camera;
  }
  get deviceType() {
    return this._deviceType;
  }
  set deviceType(e) {
    this._deviceType = e;
  }
  getDeviceType() {
    return this.deviceType;
  }
  get highlightColor() {
    return this._highlightColor;
  }
  set highlightColor(e) {
    this._highlightColor = e;
  }
  get highlightSize() {
    return this._highlightSize;
  }
  set highlightSize(e) {
    this._highlightSize = e;
  }
  get destroyed() {
    return this._destroyed;
  }
  /**
   * Recupera il token di autorizzazione disponibile
   * @returns Il token se disponibile, altrimenti null
   */
  getAvailableAuthToken() {
    return this._authorizationToken && typeof this._authorizationToken == "string" ? this._authorizationToken : window.token && typeof window.token == "string" && window.token.trim() !== "" ? window.token : null;
  }
  get onDelayLoadingStart() {
    return this._onDelayLoadingStart;
  }
  set onDelayLoadingStart(e) {
    this._onDelayLoadingStart = e;
  }
  get onDelayLoadingProgress() {
    return this._onDelayLoadingProgress;
  }
  set onDelayLoadingProgress(e) {
    this._onDelayLoadingProgress = e;
  }
  get onDelayLoadingSuccess() {
    return this._onDelayLoadingSuccess;
  }
  set onDelayLoadingSuccess(e) {
    this._onDelayLoadingSuccess = e;
  }
  get onDelayLoadingError() {
    return this._onDelayLoadingError;
  }
  set onDelayLoadingError(e) {
    this._onDelayLoadingError = e;
  }
  get dracoCompression() {
    return this._dracoCompression || (this._dracoCompression = Iw.Default), this._dracoCompression;
  }
  get infoPointsShown() {
    return this._infoPointsManager ? this._infoPointsManager.infoPointsShown : !1;
  }
  get infoPointsManagerStyle() {
    return this._infoPointsManagerStyle;
  }
  set infoPointsManagerStyle(e) {
    this._infoPointsManagerStyle = e, this.updateInfoPointsManagerStyle();
  }
  get canShowInfoPoints() {
    return this._canShowInfoPoints;
  }
  set canShowInfoPoints(e) {
    this._canShowInfoPoints = e, this.refreshInfoPoints();
  }
  get canShowInfoPointsContent() {
    return this._canShowInfoPointsContent;
  }
  set canShowInfoPointsContent(e) {
    this._canShowInfoPointsContent = e, this._infoPointsManager && (this._infoPointsManager.canShowInfoPointsContent = e);
  }
  static async createSceneViewerAsync(e) {
    const t = new Cu(e);
    return await t.initAsync(), t;
  }
  dispose() {
    this.closeBroadcastChannel(), this.removeCanvas(), this.removeDomElement(), this.deleteScene(), this.deleteEngine();
  }
  async initAsync() {
    this._bindedResize = this.resize.bind(this), Zakeke.Tools.Init(), BABYLON.Geometry.onDelayLoadingStart = (e) => {
      this._onDelayLoadingStart && this._onDelayLoadingStart(e);
    }, BABYLON.Geometry.onDelayLoadingProgress = (e) => {
      this._onDelayLoadingProgress && this._onDelayLoadingProgress(e);
    }, BABYLON.Geometry.onDelayLoadingSuccess = (e) => {
      this._onDelayLoadingSuccess && this._onDelayLoadingSuccess(e);
    }, BABYLON.Geometry.onDelayLoadingError = (e) => {
      this._onDelayLoadingError && this._onDelayLoadingError(e);
    }, BABYLON.Geometry.dracoDecodingFunction = (e, t, n) => {
      this.dracoDecodingFunction(e, t, n);
    }, this.createCanvas(), this.createDOMElement(), await this.init3DEngineAsync();
  }
  async init3DEngineAsync() {
    this.createEngine(), await this.createEmptySceneAsync(), this._destroyed = !1;
  }
  createCanvas() {
    return this._canvas = document.createElement("canvas"), this._canvas.setAttribute("id", this._canvasID), this._canvas.setAttribute("touch-action", "none"), this._canvas.addEventListener("dblclick", (e) => this.setRenderingNeeded()), this._canvas;
  }
  removeCanvas() {
    this._canvas && (this._canvas.remove(), this._canvas = null);
  }
  deleteEngine() {
    this._engine && (this._engine.dispose(), this._engine = null), this._destroyed = !0, $(window).off("resize", this._bindedResize), this._resizeObserver && (this._resizeObserver.disconnect(), this._resizeObserver = null);
  }
  deleteScene() {
    this.deleteComponents(), this._scene && (this._scene.dispose(), this._scene = null);
  }
  deleteComponents() {
    this.resetPerformanceInfo(), this.emptyArFileCache(), this.disposeInfoPointsManager(), this._meshLocationsManager && (this._meshLocationsManager.dispose(), this._meshLocationsManager = null), this._sceneDesignManager && (this._sceneDesignManager.dispose(), this._sceneDesignManager = null), this._sceneHelper && (this._sceneHelper.dispose(), this._sceneHelper = null), this._environmentManager && (this._environmentManager.dispose(), this._environmentManager = null), this._glowManager && (this._glowManager.dispose(), this._glowManager = null), this._sceneActionsExecutor && (this._sceneActionsExecutor.dispose(), this._sceneActionsExecutor = null), this.disposePostProcesses();
  }
  disposeInfoPointsManager() {
    this._infoPointsManager && (this._infoPointsManager.dispose(), this._infoPointsManager = null);
  }
  disposePostProcesses() {
    for (; this._postProcesses.length > 0; ) {
      var e = this._postProcesses.pop();
      e && e.dispose();
    }
  }
  emptyArFileCache() {
    this._arFileUrls = {};
  }
  async resetSceneAsync() {
    await this.init3DEngineAsync();
  }
  /**
   * In some case, we need to replace the model with a new one for example when reverting some changes in the preview 3D.
   * Backbone don't allow to replace all the model, so we need to replace the model with a old clone.
   * @param zkModel The new model to replace the old one.
   */
  replaceModel(e) {
    this._zkModel = e, this.render();
  }
  setZkScene(e) {
    this._zkScene = e;
  }
  closeBroadcastChannel() {
    this._broadcastChannel && (this._broadcastChannel.close(), this._broadcastChannel = null);
  }
  openBroadcastChannel() {
    if (!this._broadcastChannel && window.BroadcastChannel)
      try {
        this._broadcastChannel = new BroadcastChannel("zakeke-broadcast-channel");
      } catch (e) {
        console.error("Failed opening broadcast channel"), console.error(e);
      }
  }
  getOrCreateBroadcastChannel() {
    return this.openBroadcastChannel(), this._broadcastChannel;
  }
  createEngine() {
    this.deleteScene(), this.deleteEngine(), this._engine = new BABYLON.Engine(this._canvas, !0, { stencil: !0, preserveDrawingBuffer: !0 }), this._engine.enableOfflineSupport = !1, this._engine.disableUniformBuffers = !0, Logger.info("WebGL version: " + this._engine.webGLVersion), $(window).resize(this._bindedResize), $(window).on("orientationchange", () => {
      setTimeout(() => this._bindedResize(), 100);
    });
  }
  createBrandLogoButton() {
    var e = BABYLON.GUI.Button.CreateImageOnlyButton(
      "zakeke-logo",
      "https://zakeke.blob.core.windows.net/files/images/logo_hq.png"
    );
    return e.image.stretch = BABYLON.GUI.Image.STRETCH_UNIFORM, e.width = "120px", e.height = "70px", e.color = "transparent", e.hoverCursor = "pointer", e.horizontalAlignment = BABYLON.GUI.Control.HORIZONTAL_ALIGNMENT_LEFT, e.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_TOP, e.left = "40px", e.top = "15px", e.onPointerClickObservable.add(function() {
      window.open("https://www.zakeke.com/");
    }), this._brandLogoButton = e, this._advancedTexture = BABYLON.GUI.AdvancedDynamicTexture.CreateFullscreenUI("UI", !0, this._scene), this._advancedTexture.updateSamplingMode(BABYLON.Texture.NEAREST_NEAREST), this._advancedTexture.renderScale = 2, this._advancedTexture.addControl(this._brandLogoButton), this._brandLogoButton;
  }
  async createEmptySceneAsync() {
    this.deleteScene(), this._engine && (this._scene = new BABYLON.Scene(this._engine), this._defaultBackgroundColor && this._scene.clearColor.copyFrom(this._defaultBackgroundColor), await this.setupSceneAsync());
  }
  refreshLights() {
    var n, s, o, h, c, _;
    if (!this._zkScene)
      return;
    ((s = (n = this._zkScene) == null ? void 0 : n.getGeneralConfig()) == null ? void 0 : s.get("preventDefaultLights")) !== !0 && ((o = this._sceneHelper) == null || o.setupLights());
    const t = (c = (h = this._zkScene) == null ? void 0 : h.getSceneConfig()) == null ? void 0 : c.get("lights");
    t != null && t.attributes && ((_ = this._sceneHelper) == null || _.setUpCustomLights(t.attributes));
  }
  async setupSceneAsync(e = !0) {
    var t, n, s, o, h, c, _, x, B, P, U, M, Z, F, Q;
    if (this._zkScene && this._zkScene.get("config") && ((n = (t = this._zkScene.get("config")) == null ? void 0 : t.get("general")) != null && n.get("meshSize"))) {
      const D = (o = (s = this._zkScene.get("config")) == null ? void 0 : s.get("general")) == null ? void 0 : o.get("meshSize"), te = (h = this._scene) == null ? void 0 : h.meshes.find((ee) => !ee.parent);
      te && D && (D.width || D.height || D.depth) && (te.metadata ? te.metadata.sizecm = D : te.metadata = { sizecm: D });
    }
    if (this.refreshModel(), this._engine && this._scene) {
      this._sceneHelper = new mi(this._scene);
      const D = this.getAvailableAuthToken();
      D && this._sceneHelper.setAuthorizationToken(D);
      const te = this._zkScene ? this._zkScene.getCameraPositionScale() : void 0, ee = this._zkScene ? this._zkScene.getCameraPositionFOV() : void 0, le = this._zkScene ? this._zkScene.getCameraLimitLowerRadius() : void 0, fe = this._zkScene ? this._zkScene.getCameraZoomEnabled() : void 0, X = this._zkScene ? this._zkScene.getCameraUseMinZoomPerc() : !1, W = this._zkScene ? this._zkScene.getCameraMinZoomPerc() : 1, je = this._zkScene ? this._zkScene.getCameraUseMaxZoomPerc() : !1, ke = this._zkScene ? this._zkScene.getCameraMaxZoomPerc() : 1.5, Ye = this._zkScene ? this._zkScene.getCameraLowerAlphaLimit() : null, pt = this._zkScene ? this._zkScene.getCameraUpperAlphaLimit() : null, Le = this._zkScene ? this._zkScene.getCameraLowerBetaLimit() : null, $e = this._zkScene ? this._zkScene.getCameraUpperBetaLimit() : null, ce = this._zkScene ? (c = this._zkScene.getCameraConfig()) == null ? void 0 : c.get("zoom") : null;
      if (te != null && te != null && this._sceneHelper.setCameraPositionScale(te, !1), ee != null && ee != null && this._sceneHelper.setCameraPositionFOV(ee), le != null && le != null && this._sceneHelper.setCameraLimitLowerRadius(le, !1), fe != null && fe != null && this._sceneHelper.setZoomEnabled(fe), this._sceneHelper.setCameraZoom(ce), this._sceneHelper.setupCamera(), this._camera = this._scene.activeCamera, this._mouseWheelInput = ((_ = this._camera) == null ? void 0 : _.inputs.attached.mousewheel) ?? null, this._camera && (X ? this._sceneHelper.setMinZoomPerc(W) : this._sceneHelper.setMinZoomPerc(null), je ? this._sceneHelper.setMaxZoomPerc(ke) : this._sceneHelper.setMaxZoomPerc(null), this._sceneHelper.setCameraAlphaLimits(Ye, pt), this._sceneHelper.setCameraBetaLimits(Le, $e)), this._camera && e && (this._camera.onViewMatrixChangedObservable.add(() => {
        this.notifyCameraMovement();
      }), this._camera.onRestoreStateObservable.add(() => {
        this.setupShaderMaterialsCameraPosition(), this.setRenderingNeeded();
      }), this.refreshCameraPosition()), (x = this._sceneHelper) == null || x.setupAnimations(this._zkScene), this._modelParentNode || (this._modelParentNode = new BABYLON.TransformNode("modelParent")), (B = this._sceneHelper) == null || B.setupShadows(this._zkScene), this.refreshLights(), this.createHighlightLayer(), await this.refreshEnvironment(), await this.fixEnvironmentTexture(), this.setupGlowManager(), this._zkScene && (this._meshLocationsManager = new lw(), this._meshLocationsManager.setModelAndScene(this._zkScene, this._scene), this._meshLocationsManager.addMeshAnimationCompletedListener(() => this.setRenderingNeeded())), await this.setupSceneActionsExecutorAsync(), this.setRenderingOnDelayLoaded(), this.setupAntiAliasing(), this._scene.onPointerDown = (ht, De) => this.onPointerDown(ht, De), this._scene.registerBeforeRender(() => {
        this.onBeforeRender();
      }), this.refreshInfoPoints(), this.refreshModel(), (Z = (M = (U = (P = this._zkScene) == null ? void 0 : P.get("config")) == null ? void 0 : U.get("general")) == null ? void 0 : M.get("environmentOptions")) != null && Z.get("pbrIntensity") && this.updatePBRMaterialsIntensity(), this._zkScene) {
        const ht = (Q = (F = this._zkScene) == null ? void 0 : F.getGeneralConfig()) == null ? void 0 : Q.get("removeDefaultBackground");
        this._sceneHelper.removeDefaultBackground(ht), this._sceneHelper.setUpSceneToneMapping(this._zkScene);
      }
      this._engine.stopRenderLoop(), this.render(), this._engine.runRenderLoop(() => {
        this.checkRendering();
      });
    }
  }
  onBeforeRender() {
    if (this._scene && this._sceneHelper) {
      if (this._camera) {
        const e = this._sceneHelper.getDefaultPointLight();
        e && (e.position = this._camera.position);
      }
      this._scene.meshes.forEach((e) => {
        e.mustDepthSortFacets && e.isFacetDataEnabled && e.updateFacetData();
      });
    }
  }
  render() {
    this._scene && !this._scene.isDisposed && !this._renderingPaused && this._scene.render();
  }
  // Disabilito il post-processing quando la camera è in movimento
  checkRendering() {
    this._scene && (this._autoRender || this._renderingNeeded || this._scene._activeAnimatables.length !== 0 || this._sceneHelper && this._sceneHelper.userIsMoving() ? (this.checkPerformance(), (this.isLowEndDevice || this._autoRender && !this._camera.autoRotationBehavior || // fix: in autorotate the antialiasing will be disabled without autoRotationBehavior check
    this._scene._activeAnimatables.length !== 0 || this._sceneHelper && this._sceneHelper.userIsMoving()) && !this._antiAliasConfig.inRotationEnabled ? this.disableAntialiasing() : this.enableAntialiasing(), this.render(), this._renderingNeeded && (this._renderingNeeded = !1)) : !this._scene.postProcessesEnabled && !this._antiAliasConfig.inRotationEnabled && (this.enableAntialiasing(), this.render()), this._infoPointsManager && this._infoPointsManager.updateInfoPointsVisibility() && this.render());
  }
  resetPerformanceInfo() {
    this._performanceInfo = null;
  }
  checkPerformance() {
    if (this._performanceInfo || (this._performanceInfo = { totalFPS: 0, countFPS: 0, isLowEndDevice: !1, chekDone: !1 }), this._engine && !this._performanceInfo.chekDone) {
      this._performanceInfo.totalFPS += this._engine.getFps(), this._performanceInfo.countFPS++;
      const e = this._performanceInfo.totalFPS / this._performanceInfo.countFPS;
      this._performanceInfo.countFPS > 30 && (this._performanceInfo.isLowEndDevice = e <= 30, this._performanceInfo.chekDone = !0);
    }
  }
  createAntialiasPostProcesses() {
    if (this._camera && this._postProcesses.length === 0) {
      var e = /firefox/i.test(navigator.userAgent);
      e || this._postProcesses.push(
        new BABYLON.PassPostProcess("scale_pass", 4, this._camera, BABYLON.Texture.BILINEAR_SAMPLINGMODE)
      ), this._postProcesses.push(
        new BABYLON.PassPostProcess("scale_pass", 2, this._camera, BABYLON.Texture.BILINEAR_SAMPLINGMODE)
      ), this._postProcesses.push(
        new BABYLON.PassPostProcess("scale_pass", 1, this._camera, BABYLON.Texture.BILINEAR_SAMPLINGMODE)
      );
    }
  }
  getDAMMainMesh() {
    var e, t;
    return (t = (e = this._sceneHelper) == null ? void 0 : e.getVTOMeshes().userMeshes.filter((n) => !n.parent)) == null ? void 0 : t[0];
  }
  setRenderingNeeded() {
    this._renderingNeeded = !0;
  }
  setLongRenderingNeeded() {
    this.setRenderingNeeded();
    for (let e = 50; e <= 1e3; e += 200)
      setTimeout(() => this.setRenderingNeeded(), e);
  }
  refreshRendering() {
    this.setLongRenderingNeeded();
  }
  pauseRendering() {
    this._renderingPaused = !0;
  }
  resumeRendering() {
    this._renderingPaused = !1, this.setRenderingNeeded();
  }
  setLoadingScreen(e) {
    this._engine && (this._engine.loadingScreen = e);
  }
  setRenderingOnDelayLoaded() {
    if (this._scene) {
      var e = this;
      this._scene.getGeometries().forEach(function(t) {
        var n = t.onGeometryUpdated;
        t.onGeometryUpdated = function(s, o) {
          e.setLongRenderingNeeded(), n && n.apply(this, [s, o]);
        };
      });
    }
  }
  createHighlightLayer() {
    this._scene && (this._highlightLayer = new BABYLON.HighlightLayer("hl1", this._scene), this.updateHighlightLayerExcludedDesignMeshes(), this.setupHighlightLayerIntensity());
  }
  setupHighlightLayerIntensity() {
    this._highlightLayer && (this._highlightLayer.blurHorizontalSize = this._highlightSize, this._highlightLayer.blurVerticalSize = this._highlightSize, this._highlightBlurHorizontalSize = this._highlightSize, this._highlightBlurVerticalSize = this._highlightSize);
  }
  updateHighlightLayerExcludedDesignMeshes() {
    this.scene && this._sceneHelper && this._highlightLayer && (this._highlightLayer.removeAllMeshes(), this.scene.meshes.filter(this._sceneHelper.isCanvasMesh).forEach((e) => this._highlightLayer.addExcludedMesh(e)));
  }
  createDOMElement() {
    this._canvas && (this._domElement = document.createElement("div"), this._domElement.setAttribute("id", "zakeke-canvas-viewer3D-div-" + Zakeke.makeID(5)), this._domElement.appendChild(this._canvas), this._domElement.style.position = "absolute", this._domElement.style.width = "100%", this._domElement.style.height = "100%", this._domElement.style.left = "0", this._domElement.style.top = "0");
  }
  removeDomElement() {
    this._domElement && (this.detach(), this._domElement.remove(), this._domElement = null);
  }
  appendTo(e) {
    this._domElement && (e.firstChild ? e.insertBefore(this._domElement, e.firstChild) : e.appendChild(this._domElement), e.appendChild(this._domElement), this.resize(), this.resize(), this.setupResizeObserver(e));
  }
  setupResizeObserver(e) {
    this._resizeObserver && this._resizeObserver.disconnect(), this._resizeObserver = new ResizeObserver(() => {
      requestAnimationFrame(() => {
        this.resize();
      });
    }), this._resizeObserver.observe(e);
  }
  detach() {
    this._resizeObserver && (this._resizeObserver.disconnect(), this._resizeObserver = null), this._domElement && this._domElement.parentNode && this._domElement.parentNode.removeChild(this._domElement);
  }
  updateView(e = !0, t = !1) {
    this.resize(t), e && this._scene && this.adjustCamera(!1);
  }
  resize(e = !1) {
    if (this._canvas) {
      this.disableAntialiasing(!0);
      var t = this._canvas.parentNode;
      if (!(!t || !(t instanceof HTMLElement))) {
        var n = t.offsetWidth, s = t.offsetHeight, o = this._canvas.width !== this._canvas.clientWidth || this._canvas.height !== this._canvas.clientHeight;
        (n != this._lastWidth || s != this._lastHeight || e || o) && (this._canvas.style.width = "100%", this._canvas.style.height = "100%", this._engine && (this._engine.resize(), this.setRenderingNeeded())), this._lastWidth = n, this._lastHeight = s, this.enableAntialiasing();
      }
    }
  }
  switchFullScreen(e) {
    this._sceneHelper && this._sceneHelper.switchFullScreen(e);
  }
  setupGlowManager() {
    this._glowManager && (this._glowManager.dispose(), this._glowManager = null), this._zkScene && this._scene && (this._glowManager = new hw(this._zkScene, this._scene), this._glowManager.update(), this.setRenderingNeeded());
  }
  async setupSceneActionsExecutorAsync() {
    this._zkScene && this._scene && (this._sceneActionsExecutor = new ow(this._zkScene, this._scene), this._sceneActionsExecutor.deviceType = this.deviceType, this._sceneActionsExecutor.useMaterialOffloading = !this._configPreview && this.getUseMaterialOffloading(), this._sceneActionsExecutor.prefetchMeshes = this.getPrefetchMeshes(), this._sceneActionsExecutor.prefetchMaterials = this.getPrefetchMaterials(), this._sceneActionsExecutor.addMeshDesignRefreshRequiredListeners(async (e) => {
      await this.refreshMeshesDesignAsync(e.meshes, e.effect);
    }), this._sceneActionsExecutor.addBeginAssetsLoadingListener(() => this.fireBeginAssetsLoadingEvent()), this._sceneActionsExecutor.addEndAssetsLoadingListener(() => this.fireEndAssetsLoadingEvent()));
  }
  restoreCameraState() {
    this._sceneHelper && (this._sceneHelper.restoreCameraState(), this._sceneHelper.setupShaderMaterialsCameraPosition(), this.setRenderingNeeded());
  }
  async fixEnvironmentTexture() {
    if (this._scene && this._scene.environmentTexture && this._scene.environmentTexture.url && typeof this._scene.environmentTexture.url == "string") {
      const e = this._scene.environmentTexture.url, t = (e.match(/http/g) || []).length;
      let n = e;
      if (t > 1) {
        let c = e.lastIndexOf("http");
        c >= 0 && (n = e.substring(c));
      } else if (t == 0 && this._zkScene && this._zkScene.get("rootUrl")) {
        let c = this._zkScene.get("rootUrl");
        if (c) {
          const _ = c.endsWith("/") ? "" : "/";
          n = c + _ + e;
        }
      } else if (t === 0)
        return;
      let s, o, h;
      this._scene && this._scene.metadata && (this._scene.metadata.environmentTextureRotationY !== void 0 && typeof this._scene.metadata.environmentTextureRotationY == "number" && (s = this._scene.metadata.environmentTextureRotationY), this._scene.metadata.environmentTextureExtensions && (o = this._scene.metadata.environmentTextureExtensions), this._scene.metadata.environmentTextureFiles && (h = this._scene.metadata.environmentTextureFiles)), await this.setSceneEnvironmentTexture(n, s, o, h);
    } else
      await this.checkSceneEmptyEnvironmentTexture();
  }
  async checkSceneEmptyEnvironmentTexture() {
    this._scene && this._sceneHelper && this._sceneHelper.containsPBRMaterials() && !this._scene.environmentTexture && await this.setDefaultSceneEnvironmentTexture();
  }
  async setDefaultSceneEnvironmentTexture() {
    const e = ci.Environment.EnvironmentTextureCDNUrl;
    await this.setSceneEnvironmentTexture(e);
  }
  async setSceneEnvironmentTexture(e, t, n, s, o) {
    return new Promise((h) => {
      if (this._scene && this._sceneHelper) {
        this._scene.environmentTexture && this._sceneHelper.isTextureWithUrl(this._scene.environmentTexture) && this._scene.environmentTexture.url && this._scene.environmentTexture.url != e && (this._scene.environmentTexture.dispose(), this._scene.environmentTexture = null);
        const c = () => {
          this.setLongRenderingNeeded();
        };
        this._scene.metadata || (this._scene.metadata = {}), delete this._scene.metadata.environmentTextureType, delete this._scene.metadata.environmentTextureSize, delete this._scene.metadata.environmentTextureExtensions, delete this._scene.metadata.environmentTextureFiles;
        let _ = null;
        e.endsWith(".dds") ? _ = BABYLON.CubeTexture.CreateFromPrefilteredData(e, this._scene) : e.endsWith(".hdr") ? (_ = new BABYLON.HDRCubeTexture(
          e,
          this._scene,
          128,
          (o == null ? void 0 : o.get("mipMaps")) || void 0,
          (o == null ? void 0 : o.get("generateHarmonics")) || void 0,
          (o == null ? void 0 : o.get("gammaSpace")) || void 0,
          (o == null ? void 0 : o.get("prefilterOnLoad")) || void 0,
          c
        ), this._scene.metadata.environmentTextureType = "BABYLON.HDRCubeTexture", this._scene.metadata.environmentTextureSize = 128) : e.endsWith(".env") ? _ = new BABYLON.CubeTexture(
          e,
          this._scene,
          null,
          !1,
          null,
          c,
          null,
          void 0,
          !0,
          void 0,
          !0
        ) : e.endsWith(".basis") ? _ = BABYLON.CubeTexture.CreateFromPrefilteredData(e, this._scene) : n && n.length === 6 && s && s.length === 6 && (_ = new BABYLON.CubeTexture(
          e,
          this._scene,
          n,
          !1,
          s,
          c
        ), this._scene.metadata.environmentTextureExtensions = n, this._scene.metadata.environmentTextureFiles = s), _ && mi.whenTextureIsReadyAsync(_).then(() => {
          var x, B, P, U, M, Z, F, Q;
          if (_ && this._scene) {
            const D = (U = (P = (B = (x = this._zkScene) == null ? void 0 : x.get("config")) == null ? void 0 : B.get("general")) == null ? void 0 : P.get("environmentOptions")) == null ? void 0 : U.get("intensity"), te = (Q = (F = (Z = (M = this._zkScene) == null ? void 0 : M.get("config")) == null ? void 0 : Z.get("general")) == null ? void 0 : F.get("environmentOptions")) == null ? void 0 : Q.get("rotationY");
            D && (_.level = D), te ? _.rotationY = te : this._scene.metadata && this._scene.metadata.environmentTextureRotationY != null && delete this._scene.metadata.environmentTextureRotationY, this._scene.environmentTexture = _, console.log("Environment texture loaded: " + e), this.setRenderingNeeded(), h();
          }
        });
      } else
        h();
    });
  }
  async loadSceneFromModelAsync(e, t, n) {
    if (e && e instanceof MPlaza.Model && (this._zkModel = e), t && t instanceof Zakeke.Scene) {
      this._zkScene = t, this.checkSceneShaderMaterials(t);
      const s = t.get("rootUrl"), o = t.get("sceneFileName");
      s && o && await this.loadSceneFromRemoteFilesAsync(s, o, n);
    }
  }
  async loadSceneFromModelDataAsync(e, t, n, s) {
    if (e && e instanceof MPlaza.Model && (this._zkModel = e), t && t instanceof Zakeke.Scene) {
      this._zkScene = t, this.checkSceneShaderMaterials(t);
      var o = "data:" + n;
      const h = t.get("rootUrl");
      h && await this.loadSceneFromRemoteFilesAsync(h, o, s);
    }
  }
  preSceneFileLoading() {
  }
  postSceneFileLoading() {
  }
  // Carica la scena Babylon JS tramite rootUrl e sceneFilename
  // La scena verrà caricata direttamente da Babylon JS. Le texture verranno lette risolvendo
  // il path in base a rootUrl e al nome della texture
  // textureUrl = rootUrl + texture.name
  async loadSceneFromRemoteFilesAsync(e, t, n) {
    if (!this._engine)
      throw new Error("Unable to load scene when the 3D engine is null");
    try {
      this.fireBeginSceneLoadingEvent(), this.preSceneFileLoading(), this.pauseRendering(), this._engine.sceneFileRootUrl = e;
      let s = await BABYLON.SceneLoader.LoadAsync(e, t, this._engine, n);
      if (this._destroyed) {
        Logger.info("Loading scene engine destroyed"), s.dispose();
        return;
      }
      if (await new Promise((x) => s.executeWhenReady(() => x())), this._destroyed)
        throw Logger.info("Loading scene engine destroyed"), s.dispose(), new Error("Engine destroyed while loading scene");
      const o = mi.visibleMeshesRequireDelayedLoading(s);
      o && this.fireBeginAssetsLoadingEvent();
      let h = 0;
      const c = s.meshes.filter((x) => x.isVisible);
      for (let x = 0; x < c.length; x++)
        await this.fireNextSceneMeshesLoadedEvent(x + 1, c.length), await new Promise((B) => {
          setTimeout(() => {
            B();
          }, 10);
        });
      await mi.whenAllVisibleMeshesAreReadyAsync(c), o && this.fireEndAssetsLoadingEvent(), this.deleteScene(), this._scene = s, this._defaultBackgroundColor ? this._scene.clearColor.copyFrom(this._defaultBackgroundColor) : this._scene.clearColor = new BABYLON.Color4(0, 0, 0, 0);
      let _ = [];
      for (let x = 0; x < this._scene.textures.length; x++) {
        const B = this._scene.textures[x];
        _.push(B.name), B instanceof BABYLON.Texture && B.onLoadObservable && B.onLoadObservable.add((P) => {
          this.setLongRenderingNeeded();
        });
      }
      if (this._scene && this._scene.metadata && !this._scene.metadata.delayedMaterials)
        for (let x = 0; x < this._scene.textures.length; x++)
          await this.fireNextSceneTextureLoadedEvent(x + 1, this._scene.textures.length), await new Promise((B) => {
            setTimeout(() => {
              B();
            }, 10);
          });
      if (await this.setupSceneAsync(), this._sceneHelper) {
        if (this._configPreview && this._scene.metadata && this._scene.metadata.delayedMaterials) {
          this._scene.useDelayedTextureLoading = !0;
          try {
            console.log("Trying loading delayed materials using Zip file"), await this._sceneHelper.loadAllDelayedMaterialFromZip(
              e,
              this.zkScene.get("version"),
              this.fireNextSceneTextureLoadedEvent.bind(this)
            ), console.log("Delayed materials loaded using zip file");
          } catch (x) {
            console.warn(
              "Delayed materials not loaded using zip file error:",
              x,
              ", trying to load delayed materials the stanrdad way"
            ), await this._sceneHelper.cleanupAllTemporaryMaterialsAsync(), await this._sceneHelper.loadAllDelayedMaterialsAsync(
              e,
              this.fireNextSceneTextureLoadedEvent.bind(this)
            );
          }
        }
        this._configPreview && this._scene.metadata && this._scene.metadata.offloadedMaterials && this._sceneHelper.loadAllOffloadedMaterials(e), this._configPreview && this._scene.metadata && this._scene.metadata.originalMeshMaterials && this._sceneHelper.unsetAllDummyMaterials(), this._sceneHelper.setupShaderMaterialsCameraPosition();
        try {
          await this.reloadAllLoadingErrorTexturesAsync();
        } catch (x) {
          console.error(x);
        }
      }
      if (this._environmentManager) {
        const x = this._environmentManager.getSkyboxTexture();
        x && await mi.whenTextureIsReadyAsync(x);
      }
    } finally {
      this.resumeRendering(), this.postSceneFileLoading(), this.fireEndSceneLoadingEvent();
    }
  }
  getSkyboxTexture() {
    var e;
    return (e = this._environmentManager) == null ? void 0 : e.getSkyboxTexture();
  }
  // Carica la scena Babylon JS tramite rootUrl e sceneFilename
  // La scena verrà caricata direttamente da Babylon JS. Le texture verranno lette risolvendo
  // il path in base a rootUrl e al nome della texture
  // textureUrl = rootUrl + texture.name
  async loadSceneFromRemoteFilesAsync_OLD(e, t, n) {
    return new Promise(async (s, o) => {
      this._engine || o(), this.preSceneFileLoading(), this._engine.sceneFileRootUrl = e;
      let h = await BABYLON.SceneLoader.LoadAsync(e, t, this._engine, n);
      if (this._destroyed) {
        Logger.info("Loading scene engine destroyed"), h.dispose();
        return;
      }
      h.executeWhenReady(async () => {
        this._destroyed && (Logger.info("Loading scene engine destroyed"), h.dispose(), o());
        const c = h.meshes.filter((x) => x.isVisible), _ = mi.visibleMeshesRequireDelayedLoading(h);
        _ && this.fireBeginAssetsLoadingEvent(), await mi.whenAllVisibleMeshesAreReadyAsync(c), _ && this.fireEndAssetsLoadingEvent(), this.deleteScene(), this._scene = h;
        for (let x = 0; x < this._scene.textures.length; x++) {
          const B = this._scene.textures[x];
          B instanceof BABYLON.Texture && B.onLoadObservable && B.onLoadObservable.add((P) => {
            this.setLongRenderingNeeded();
          });
        }
        await this.setupSceneAsync(), this._sceneHelper && (this._configPreview && this._scene.metadata && this._scene.metadata.delayedMaterials && await this._sceneHelper.loadAllDelayedMaterialsAsync(e), this._configPreview && this._scene.metadata && this._scene.metadata.offloadedMaterials && this._sceneHelper.loadAllOffloadedMaterials(e), this._configPreview && this._scene.metadata && this._scene.metadata.originalMeshMaterials && this._sceneHelper.unsetAllDummyMaterials(), this._sceneHelper.setupShaderMaterialsCameraPosition()), this.postSceneFileLoading(), s();
      });
    });
  }
  checkSceneShaderMaterials(e) {
    if (e instanceof Zakeke.Scene && e.get("shaderMaterials"))
      for (let t = 0; t < e.get("shaderMaterials").length; t++) {
        const n = e.get("shaderMaterials").at(t), s = n.get("name"), o = n.get("vertex"), h = n.get("fragment");
        if (s && o && h) {
          const c = { name: s, vertex: o, fragment: h };
          this.setupShadersStore(c);
        }
      }
  }
  checkShaderMaterial(e) {
    if (e && e instanceof Zakeke.Material && e.get("shaders")) {
      const n = e.get("shaders").get("name"), s = e.get("shaders").get("vertex"), o = e.get("shaders").get("fragment");
      if (n && s && o) {
        const h = { name: n, vertex: s, fragment: o };
        this.setupShadersStore(h);
      }
    }
  }
  setupShadersStore(e) {
    if (e && e.hasOwnProperty("name") && e.hasOwnProperty("vertex") && e.hasOwnProperty("fragment")) {
      var t = e.name + "VertexShader", n = e.name + "FragmentShader";
      BABYLON.Effect.ShadersStore[t] = e.vertex, BABYLON.Effect.ShadersStore[n] = e.fragment;
    }
  }
  isRealMesh(e) {
    return this._sceneHelper ? this._sceneHelper.isRealMesh(e) : !1;
  }
  countSceneMeshes() {
    return this._sceneHelper ? this._sceneHelper.countSceneMeshes() : 0;
  }
  getVisibleMeshes() {
    return this._sceneHelper ? this._sceneHelper.getVisibleMeshes() : [];
  }
  getSceneBoundingInfo() {
    return this._sceneHelper ? this._sceneHelper.getSceneBoundingInfo() : null;
  }
  selectMesh(e) {
    this.selectUnselectMesh(e, !0);
  }
  unselectMesh(e) {
    this.selectUnselectMesh(e, !1);
  }
  unselectAllMeshes() {
    this._scene && (this._scene.meshes.forEach((e) => this.unselectSingleMesh(e)), this.fireFocusAttributesEvent({ groups: [] }));
  }
  selectUnselectMesh(e, t) {
    if (this._scene && (this._scene.meshes.forEach((s) => this.unselectSingleMesh(s)), t)) {
      let s = (h) => {
        this.selectSingleMesh(h);
        const c = h.getChildMeshes();
        c && c.forEach((_) => s(_));
      };
      const o = this._scene.getMeshByID(e);
      if (o) {
        s(o);
        const h = this.getGroupForMesh(o);
        h && (this.highlightGroupForMesh(o), this.fireGroupPickedEvent({ groupID: h.get("groupID") }));
        var n = this.getVisibleHiddenAttributesForMesh(o);
        this.fireFocusAttributesEvent({ groups: n }), n.length > 0 && this.highlightMeshes([o]);
      }
    }
  }
  selectSingleMesh(e) {
    this.setRenderingNeeded(), e.selected = !0;
  }
  unselectSingleMesh(e) {
    this.setRenderingNeeded(), e.selected = !1;
  }
  selectMeshesWithMaterial(e) {
    this.selectUnselectMeshesWithMaterial(e, !0);
  }
  unselectMeshesWithMaterial(e) {
    this.selectUnselectMeshesWithMaterial(e, !1);
  }
  selectUnselectMeshesWithMaterial(e, t) {
    if (this._scene && (this._scene.meshes.forEach((n) => this.unselectSingleMesh(n)), t)) {
      let n = (s) => {
        s.material && s.material.id === e && this.selectSingleMesh(s);
        const o = s.getChildMeshes();
        o && o.forEach((h) => {
          n(h);
        });
      };
      this._scene.meshes.forEach((s) => {
        n(s);
      });
    }
  }
  onPointerDown(e, t) {
    t.hit && t.pickedMesh ? this.selectMesh(t.pickedMesh.id) : this.unselectAllMeshes();
  }
  getSelectedRootMesh() {
    if (this._scene)
      for (let e = 0; e < this._scene.meshes.length; e++) {
        const t = this._scene.meshes[e];
        if (t.selected) {
          const n = t.parent;
          if (!n || !n.selected)
            return t;
        }
      }
    return null;
  }
  getMeshByID(e) {
    return this._scene ? this._scene.getMeshByID(e) : null;
  }
  getMeshByName(e) {
    return this._scene ? this._scene.getMeshByName(e) : null;
  }
  getMaterialByID(e) {
    return this._scene ? this._scene.getMaterialByID(e) : null;
  }
  setCameraLocation(e, t = !1, n = !0) {
    if (this._zkScene && this._sceneHelper) {
      const s = this._zkScene.getCameraLocation(e);
      if (s) {
        const o = new BABYLON.Vector3(
          s.get("px"),
          s.get("py"),
          s.get("pz")
        ), h = new BABYLON.Vector3(
          s.get("tx"),
          s.get("ty"),
          s.get("tz")
        );
        if (n) {
          if (!t)
            this._sceneHelper.animateCamera(h, o, 0.5);
          else if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
            const c = this._sceneHelper.computeCameraAngleOfView(h, o);
            this._sceneHelper.animateCameraToFinalParamters(
              c.alpha,
              c.beta,
              this._camera.radius,
              this._camera.target,
              0.5
            );
          }
        } else if (!t)
          this._sceneHelper.moveCamera(h, o);
        else if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
          const c = this._sceneHelper.computeCameraAngleOfView(h, o);
          this._sceneHelper.moveCameraToFinalParameters(
            c.alpha,
            c.beta,
            this._camera.radius,
            this._camera.target
          );
        }
      }
    }
    this.setRenderingNeeded();
  }
  updateCameraLocation(e) {
    if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      const t = this._camera.position, n = this._camera.target;
      e.set("px", t.x), e.set("py", t.y), e.set("pz", t.z), e.set("tx", n.x), e.set("ty", n.y), e.set("tz", n.z);
    }
  }
  adjustCamera(e) {
    this._sceneHelper && (e != null && e != null && typeof e == "boolean" ? this._sceneHelper.adjustCamera(void 0, void 0, void 0, e) : this._sceneHelper.adjustCamera(), this.setupShaderMaterialsCameraPosition(), this.setRenderingNeeded());
  }
  zoomIn() {
    this._sceneHelper && this._sceneHelper.zoomIn();
  }
  zoomOut() {
    this._sceneHelper && this._sceneHelper.zoomOut();
  }
  zoom(e) {
    this._sceneHelper && this._sceneHelper.zoom(e);
  }
  rotateCameraLeft(e, t) {
    this._sceneHelper && this._sceneHelper.rotateCameraLeft(e, t);
  }
  rotateCameraRight(e, t) {
    this._sceneHelper && this._sceneHelper.rotateCameraRight(e, t);
  }
  rotateCameraUp(e, t) {
    this._sceneHelper && this._sceneHelper.rotateCameraUp(e, t);
  }
  rotateCameraDown(e, t) {
    this._sceneHelper && this._sceneHelper.rotateCameraDown(e, t);
  }
  setCameraPivot(e) {
    if (this._scene && this._sceneHelper) {
      const t = e ? this._scene.getMeshByID(e) : null;
      this._sceneHelper.setCameraPivot(t);
    }
  }
  setCameraZoomEnabled(e) {
    this._scene && this._sceneHelper && (this._sceneHelper.setZoomEnabled(e), this.setRenderingNeeded());
  }
  async executeScriptAsync(e) {
    this._sceneActionsExecutor && (await this._sceneActionsExecutor.executeScriptAsync(e), this.notifyScriptExecution(e), this.setupShaderMaterialsCameraPosition(), this.refreshInfoPoints(), this.setLongRenderingNeeded());
  }
  async executeActionsAsync(e, t, n) {
    this._sceneActionsExecutor && (await this._sceneActionsExecutor.executeActionsAsync(e, t, n), this.notifyActionExecution(e, t, n), this.setupShaderMaterialsCameraPosition(), this.refreshInfoPoints(), this.setLongRenderingNeeded());
  }
  async prefetchMeshesForUnselectedOptionsAsync(e) {
    this._sceneActionsExecutor && await this._sceneActionsExecutor.prefetchMeshesForUnselectedOptionsAsync(e);
  }
  async prefetchDataForUnselectedOptionsAsync(e) {
    this._sceneActionsExecutor && await this._sceneActionsExecutor.prefetchDataForUnselectedOptionsAsync(e);
  }
  async updatePBRMaterialsIntensity() {
    var s, o, h, c, _;
    const e = (s = this._scene) == null ? void 0 : s.materials, t = (h = (o = this._zkScene) == null ? void 0 : o.get("config")) == null ? void 0 : h.toJSON();
    if (!t || !e)
      return;
    const n = (_ = (c = t == null ? void 0 : t.general) == null ? void 0 : c.environmentOptions) == null ? void 0 : _.pbrIntensity;
    n && (e == null || e.forEach((x) => {
      x instanceof BABYLON.PBRMaterial && (x.environmentIntensity = n);
    }));
  }
  async refreshModel() {
    var n, s, o, h, c, _, x, B;
    const e = (n = this._scene) == null ? void 0 : n.meshes, t = (o = (s = this._zkScene) == null ? void 0 : s.get("config")) == null ? void 0 : o.toJSON();
    if (!(!t || !e) && ((x = this._sceneHelper) == null || x.transformEntireScene(
      (h = t.model) == null ? void 0 : h.position,
      (c = t.model) == null ? void 0 : c.rotation,
      (_ = t.model) == null ? void 0 : _.scale,
      this._modelParentNode
    ), (B = t.model) != null && B.config)) {
      const P = t.model.config.doubleSided;
      P !== void 0 && (e == null || e.forEach((U) => {
        U.material instanceof BABYLON.PBRMaterial && U.material && !(U instanceof BABYLON.GroundMesh) && (U.material.backFaceCulling = !P);
      }));
    }
  }
  async refreshEnvironment() {
    if (this._zkScene && this._scene) {
      const e = this._zkScene.getOrCreateGeneralConfig().get("environmentTexture"), t = this._zkScene.getOrCreateGeneralConfig().get("environmentOptions");
      e && t && !this._scene.textures.some((n) => n.url === e) && await this.setSceneEnvironmentTexture(e, void 0, void 0, void 0, t), (!this._environmentManager || this._environmentManager.zkScene != this._zkScene || this._environmentManager.scene != this._scene || this._environmentManager.isHologram != this._isHologram) && (this._environmentManager = new ng(this._zkScene, this._scene, this._isHologram)), this._environmentManager.update(), this.setLongRenderingNeeded(), this._camera && this._camera instanceof BABYLON.ArcRotateCamera && (this._autoRender = this._camera.useAutoRotationBehavior), this.setRenderingNeeded();
    }
  }
  highlightMeshes(e) {
    if (!e || Object.prototype.toString.call(e) !== "[object Array]" || this._highlightSize == 0)
      return;
    const t = this._highlightBlurHorizontalSize, n = this._highlightBlurVerticalSize, s = (c) => {
      c.isVisible && this._highlightLayer && this._highlightLayer.addMesh(c, BABYLON.Color3.FromHexString(this._highlightColor)), c.getChildMeshes().forEach((x) => {
        x instanceof BABYLON.Mesh && s(x);
      });
    }, o = (c) => {
      this._highlightLayer && this._highlightLayer.removeMesh(c), c.getChildMeshes().forEach((x) => {
        x instanceof BABYLON.Mesh && o(x);
      });
    }, h = () => {
      if (this._highlightAnimationID && (clearInterval(this._highlightAnimationID), this._highlightAnimationID = null), this._highlightCurrentMeshes && this._highlightCurrentMeshes.forEach((c) => {
        c instanceof BABYLON.Mesh && o(c);
      }), this._highlightLayer && (this._highlightLayer.blurHorizontalSize = t, this._highlightLayer.blurVerticalSize = n), this._highlightNextMeshes) {
        const c = this._highlightNextMeshes;
        this._highlightNextMeshes = [], this.highlightMeshes(c);
      }
    };
    if (this._highlightAnimationID) {
      this._highlightNextMeshes = e, h();
      return;
    }
    if (this._highlightLayer || this.createHighlightLayer(), this._highlightLayer) {
      this._highlightCurrentMeshes = e, e.forEach((U) => {
        U instanceof BABYLON.Mesh && s(U);
      });
      const c = 800, _ = 20, x = _ / c;
      let B = t, P = n;
      this._highlightAnimationID = window.setInterval(() => {
        this._highlightLayer && (B -= t * x, P -= n * x, B = Math.max(0, B), P = Math.max(0, P), B >= 0 && (this._highlightLayer.blurHorizontalSize = B), P >= 0 && (this._highlightLayer.blurVerticalSize = P), (B == 0 || P == 0) && h(), this.setRenderingNeeded());
      }, _), this.setRenderingNeeded();
    }
  }
  highlightGroupForMesh(e) {
    const t = this.getGroupForMesh(e);
    this.highlightGroup(t);
  }
  highlightGroupByID(e) {
    if (this._zkModel) {
      const t = this._zkModel.get("attributeGroups").findWhere({ groupID: e });
      t ? this.highlightGroup(t) : this.highlightGroup(null);
    }
  }
  highlightGroup(e) {
    if (this._zkScene && this._scene && e) {
      const n = e.get("meshSelector");
      if (n) {
        var t = this._elementSelector.getMeshElements(
          this._zkScene,
          this._scene,
          null,
          n,
          MPlaza.SceneElementType.Mesh
        );
        this.highlightMeshes(t);
      }
    }
  }
  getGroupForMesh(e) {
    if (this._zkModel && this._zkScene && this._scene && e && this._sceneHelper) {
      const t = this._zkModel.get("attributeGroups");
      for (let n = 0; n < t.length; n++) {
        const s = t.at(n), o = s.get("meshSelector");
        if (o) {
          const h = this._elementSelector.getMeshElements(
            this._zkScene,
            this._scene,
            null,
            o,
            MPlaza.SceneElementType.Mesh
          );
          for (let c = 0; c < h.length; c++) {
            let _ = h[c];
            if (e.id == _.id || this._sceneHelper.meshHasParent(e.id, _.id))
              return s;
          }
        }
      }
    }
    return null;
  }
  highlightAttributeByID(e) {
    if (this._zkModel) {
      const t = this._zkModel.get("attributes").findWhere({ attributeID: e });
      t ? this.highlightAttribute(t) : this.highlightAttribute(null);
    }
  }
  highlightAttribute(e) {
    if (this._zkScene && this._scene && e) {
      const n = e.get("meshSelector");
      if (n) {
        var t = this._elementSelector.getMeshElements(
          this._zkScene,
          this._scene,
          null,
          n,
          MPlaza.SceneElementType.Mesh
        );
        this.highlightMeshes(t);
      }
    }
  }
  getVisibleHiddenAttributesForMesh(e) {
    const t = [], n = (o) => {
      let h = t.find((c) => c.groupId == o);
      return h || (h = { groupId: o, visibleAttributes: [], hiddenAttributes: [] }, t.push(h)), h;
    };
    if (this._zkModel && this._zkScene && this._scene && e) {
      const o = this._zkModel.get("attributes");
      for (let h = 0; h < o.length; h++) {
        const c = o.at(h), _ = c.get("attributeID"), x = c.get("meshSelector");
        if (x) {
          const B = n(c.get("groupID"));
          var s = this._elementSelector.getMeshElements(
            this._zkScene,
            this._scene,
            null,
            x,
            MPlaza.SceneElementType.Mesh
          );
          s.find((U) => this._sceneHelper ? e.id == U.id || this._sceneHelper.meshHasParent(e.id, U.id) : !1) ? B.visibleAttributes.push(_) : B.hiddenAttributes.push(_);
        }
      }
    }
    return t.filter((o) => o.visibleAttributes.length > 0);
  }
  // -------------------------------------------------------------
  // Events
  // -------------------------------------------------------------
  fireGroupPickedEvent(e) {
    for (let t = 0; t < this._groupPickedListeners.length; t++)
      this._groupPickedListeners[t](e);
  }
  addGroupPickedListener(e) {
    this._groupPickedListeners.push(e);
  }
  fireFocusAttributesEvent(e) {
    for (let t = 0; t < this._focusAttributesListeners.length; t++)
      this._focusAttributesListeners[t](e);
  }
  addFocusAttributesListener(e) {
    this._focusAttributesListeners.push(e);
  }
  addNotifyMessageListener(e) {
    this._designNotifyMessageListeners.push(e), this._sceneDesignManager && this._sceneDesignManager.addNotifyMessageListener(e);
  }
  addRemoveMessageListener(e) {
    this._designRemoveMessageListeners.push(e), this._sceneDesignManager && this._sceneDesignManager.addRemoveMessageListener(e);
  }
  addScriptExecutionListener(e) {
    this._scriptExecutionListeners.push(e);
  }
  removeScriptExecutionListener(e) {
    const t = this._scriptExecutionListeners.indexOf(e);
    t !== -1 && this._scriptExecutionListeners.splice(t, 1);
  }
  setEventMessages(e) {
    this._designEventMessages = e, this._sceneDesignManager && this._sceneDesignManager.setEventMessages(e);
  }
  addInfoPointPickedListener(e) {
    this._infoPointPickedListeners.push(e), this._infoPointsManager && this._infoPointsManager.addInfoPointPickedListener(e);
  }
  addInfoPointContentShownListener(e) {
    this._infoPointContentShownListeners.push(e), this._infoPointsManager && this._infoPointsManager.addInfoPointContentShownListener(e);
  }
  addInfoPointContentHiddenListener(e) {
    this._infoPointContentHiddenListeners.push(e), this._infoPointsManager && this._infoPointsManager.addInfoPointContentHiddenListener(e);
  }
  // begin assets loading
  addBeginAssetsLoadingListener(e) {
    this._beginAssetsLoadingListeners.push(e);
  }
  fireBeginAssetsLoadingEvent() {
    Logger.info("Begin Assets Loading");
    for (let e = 0; e < this._beginAssetsLoadingListeners.length; ++e)
      this._beginAssetsLoadingListeners[e]();
  }
  addEndAssetsLoadingListener(e) {
    this._endAssetsLoadingListeners.push(e);
  }
  fireEndAssetsLoadingEvent() {
    Logger.info("End Assets Loading");
    for (let e = 0; e < this._endAssetsLoadingListeners.length; ++e)
      this._endAssetsLoadingListeners[e]();
  }
  addNextSceneMeshesLoadedListeners(e) {
    this._nextSceneMeshesLoadedListeners.push(e);
  }
  async fireNextSceneMeshesLoadedEvent(e, t) {
    let n = [];
    for (let s = 0; s < this._nextSceneMeshesLoadedListeners.length; ++s)
      n.push(this._nextSceneMeshesLoadedListeners[s](e, t));
    await Promise.all(n);
  }
  addNextSceneTextureLoadedListeners(e) {
    this._nextSceneTexturesLoadedListeners.push(e);
  }
  async fireNextSceneTextureLoadedEvent(e, t) {
    let n = [];
    for (let s = 0; s < this._nextSceneTexturesLoadedListeners.length; ++s)
      n.push(this._nextSceneTexturesLoadedListeners[s](e, t));
    await Promise.all(n);
  }
  addBeginSceneLoadingListener(e) {
    this._beginAssetsLoadingListeners.push(e);
  }
  fireBeginSceneLoadingEvent() {
    Logger.info("Begin Scene Loading");
    for (let e = 0; e < this._beginAssetsLoadingListeners.length; ++e)
      this._beginAssetsLoadingListeners[e]();
  }
  addEndSceneLoadingListener(e) {
    this._endAssetsLoadingListeners.push(e);
  }
  fireEndSceneLoadingEvent() {
    Logger.info("End Scene Loading");
    for (let e = 0; e < this._endAssetsLoadingListeners.length; ++e)
      this._endAssetsLoadingListeners[e]();
  }
  // --------------------------------------------------------------
  async getSceneScreenshotAsync(e, t) {
    return this._sceneHelper ? (this.setRenderingNeeded(), await this._sceneHelper.takeScreenshotAsync(e, t)) : null;
  }
  async getSceneContentScreenshotAsync(e, t, n = 0, s, o, h, c, _) {
    if (!this._sceneHelper || !this.scene || !this.zkModel || !this.zkScene)
      return null;
    this.preSceneContentScreenshot(), this._environmentManager && (this._environmentManager.dispose(), this._environmentManager = null), this.setRenderingNeeded();
    let x = "";
    const B = c ? typeof c == "string" ? BABYLON.Color4.FromHexString(c) : c : void 0;
    if (o)
      x = await this._sceneHelper.takeContentScreenshotAsync(e, t, B);
    else {
      const U = this._canvas;
      if (U) {
        const M = U.width, Z = U.height;
        U.width = e, U.height = t;
        const F = this.scene.activeCamera.position.clone(), Q = this.scene.activeCamera.target.clone(), D = h ? {
          position: new BABYLON.Vector3(h.get("px"), h.get("py"), h.get("pz")),
          target: new BABYLON.Vector3(h.get("tx"), h.get("ty"), h.get("tz"))
        } : {
          position: this._scene.activeCamera.position,
          target: this._scene.activeCamera.target
        };
        this._scene.activeCamera.position = D.position, this._scene.activeCamera.target = D.target, this._scene.render(), x = await this._sceneHelper.takeContentScreenshotAsync(e, t, B), this._scene.activeCamera.position = F, this._scene.activeCamera.target = Q, U.width = M, U.height = Z;
      }
    }
    console.log("senza Utils");
    let P;
    if (_ != null ? P = await bw(x, _) : P = await Wh(x), P || (console.error("Failed trimming image.", x), P = x), P = await Sw(P, e, t, n), !P)
      throw new Error("Failed resizing image.");
    return this.refreshEnvironment(), this.postSceneContentScreenshot(), P;
  }
  preSceneContentScreenshot() {
  }
  postSceneContentScreenshot() {
  }
  preSceneMaterialScreenshot() {
    this._environmentManager && (this._environmentManager.dispose(), this._environmentManager = null);
  }
  postSceneMaterialScreenshot() {
    this.refreshEnvironment();
  }
  async getMaterialScreenshotAsync(e, t, n) {
    if (!this._scene || !this._sceneHelper)
      return null;
    this.preSceneMaterialScreenshot();
    let s = null;
    const o = await this.getSceneRootUrl();
    if (o) {
      const h = await lo.getPreviewsAsync(
        this._scene,
        o,
        [e],
        {
          width: t,
          height: n,
          crop: !0
        },
        !1
      ), c = Object.keys(h.previewFiles);
      c.length == 1 && (s = h.previewFiles[c[0]]);
    } else {
      const h = await this._sceneHelper.takeMaterialScreenshotAsync(e, t, n), c = await Wh(h);
      c && (s = c);
    }
    return this.postSceneMaterialScreenshot(), s;
  }
  // Used to avoid multiple listeners when using react redraw
  clearListeners() {
    this._groupPickedListeners = [], this._focusAttributesListeners = [], this._scriptExecutionListeners = [];
  }
  // Il parametro showDesign è stato aggiunto per impedire la visualizzazione dei design sugli oggetti.
  // Un utilizzo di questo parametro viene fatto quando si vogliono ottenere le informazioni sugli item
  // del design senza volerli visualizzare perché ad esempio potrebbero essere elementi di testo con
  // dei font ancora non caricati. In tal caso andrebbero prima caricati i font e poi visualizzato il design
  async renderDesignAsync(e, t = !0) {
    const n = this._renderDesignQueue;
    return this._renderDesignQueue = n.catch(() => {
    }).then(() => this._renderDesignInternalAsync(e, t)), this._renderDesignQueue;
  }
  async _renderDesignInternalAsync(e, t) {
    if (this._scene && this._zkScene && this._zkModel && e) {
      if (this._sceneDesignManager && this._sceneDesignManager.isForModels(this._scene, this._zkModel, e))
        this._sceneDesignManager.showDesign = t, this._sceneDesignManager.rotation = this._currentRotation, await this._sceneDesignManager.refreshAsync();
      else {
        this.emptyArFileCache(), this._sceneDesignManager && (this._sceneDesignManager.dispose(), this._sceneDesignManager = null), this._sceneDesignManager = new Bw(
          this._scene,
          this._zkScene,
          this._zkModel,
          e,
          t
        ), this._sceneDesignManager.addRenderingNeededListener(() => {
          this.setLongRenderingNeeded(), this.notifyDesignChanged(e);
        }), this._sceneDesignManager.setCustomizerGrids(this._grids), this._sceneDesignManager.setEventMessages(this._designEventMessages);
        for (const n of this._designNotifyMessageListeners)
          this._sceneDesignManager.addNotifyMessageListener(n);
        for (const n of this._designRemoveMessageListeners)
          this._sceneDesignManager.addRemoveMessageListener(n);
        await this._sceneDesignManager.refreshAsync();
      }
      this.updateHighlightLayerExcludedDesignMeshes(), this.setLongRenderingNeeded();
    }
  }
  resetDesign() {
    this._scene && this._zkScene && this._zkModel && (this._sceneDesignManager && (this._sceneDesignManager.dispose(), this._sceneDesignManager = null), this.updateHighlightLayerExcludedDesignMeshes(), this.setLongRenderingNeeded());
  }
  clearMeshDesignManagers() {
    this._sceneDesignManager && this._sceneDesignManager.clearMeshDesignManagers();
  }
  async refreshMeshesDesignAsync(e, t) {
    e && Object.prototype.toString.call(e) === "[object Array]" && e.forEach(async (n) => await this.refreshMeshDesignAsync(n.id, void 0, t || void 0));
  }
  async refreshMeshDesignAsync(e, t = 0, n) {
    var s;
    (s = this._sceneDesignManager) == null || s.refreshMeshDesignAsync(e, t, n);
  }
  setCustomizerGrids(e) {
    var t;
    this._grids = e, (t = this._sceneDesignManager) == null || t.setCustomizerGrids(e);
  }
  removeDesignItem(e, t) {
    var n;
    t == null || t.deselectAll(), t == null || t.removeItemByGuid(e), t == null || t.updateSelectionState(), (n = this._sceneDesignManager) == null || n.removeItem(e);
  }
  addDesignItemText(e, t, n) {
    var s;
    return n ? n.addTextElement(null, e, !1) : (s = this._sceneDesignManager) == null ? void 0 : s.addItemText(e, t);
  }
  async addDesignItemImage(e, t, n) {
    var o;
    return n ? await n.insertImageById(e) : await ((o = this._sceneDesignManager) == null ? void 0 : o.addItemImage(e, t));
  }
  getDesignItemsInfo(e) {
    var t;
    return ((t = this._sceneDesignManager) == null ? void 0 : t.getItemsInfo(e)) || [];
  }
  setDesignItemText(e, t, n) {
    var s;
    (s = this._sceneDesignManager) == null || s.setItemText(e, t), n == null || n.modifyTextElementContentByGuid(e, t);
  }
  async refreshDesignTextureForItem(e) {
    var t;
    await ((t = this._sceneDesignManager) == null ? void 0 : t.refreshTextureForItem(e));
  }
  /**
   * Get font weights from font variations - same logic as MeshDesignManager
   */
  getFontWeights(e) {
    let t = e.faces.map((U) => U.variation), n = t.filter((U) => U.startsWith("i")).map((U) => parseInt(U.charAt(U.length - 1)) * 100), s = t.filter((U) => U.startsWith("n")).map((U) => parseInt(U.charAt(U.length - 1)) * 100), o = s.filter((U) => U <= 500).sort((U, M) => M - U)[0], h = n.filter((U) => U <= 500).sort((U, M) => M - U)[0], c = s.filter((U) => U == 700), _ = (c.length ? c : s.filter((U) => U > 500)).sort((U, M) => U - M)[0], x = n.filter((U) => U == _);
    x = x.length ? x : n.filter((U) => U == 700);
    let B = (x.length ? x : n.filter((U) => U > 500)).sort((U, M) => U - M)[0];
    const P = [];
    return o && P.push({ style: "normal", weight: o }), _ && P.push({ style: "normal", weight: _ }), h && P.push({ style: "italic", weight: h }), B && P.push({ style: "italic", weight: B }), P;
  }
  setDesignItemBold(e, t, n, s) {
    var o;
    (o = this._sceneDesignManager) == null || o.setItemBold(e, t, n);
  }
  setDesignItemItalic(e, t, n, s) {
    var o;
    (o = this._sceneDesignManager) == null || o.setItemItalic(e, t, n);
  }
  setDesignItemColor(e, t, n) {
    var s;
    (s = this._sceneDesignManager) == null || s.setItemColor(e, t), n == null || n.modifyTextElementFillColorByGuid(e, t);
  }
  setDesignItemFontFamily(e, t, n) {
    var s;
    (s = this._sceneDesignManager) == null || s.setItemFontFamily(e, t), n == null || n.modifyTextElementFontFamilyByGuid(e, t);
  }
  setDesignItemFontWeight(e, t, n, s) {
    let o = s == null ? void 0 : s.findItemByGuid(e);
    if (!o || !s || !n)
      return;
    let c = s.getTextItemInfo(o).fontWeight.split(" "), _ = c.includes("italic"), x = !1;
    for (let U of c) {
      let M = parseInt(U);
      if (!isNaN(M)) {
        x = M > 500;
        break;
      }
    }
    const B = this.getFontWeights(n);
    let P;
    if (_) {
      const U = B.filter((M) => M.style === "italic");
      if (U.length === 0) {
        _ = !1;
        const M = B.filter((Z) => Z.style === "normal");
        if (x) {
          const Z = M.filter((F) => F.weight > 500).sort((F, Q) => F.weight - Q.weight)[0];
          P = Z == null ? void 0 : Z.weight;
        } else {
          const Z = M.filter((F) => F.weight <= 500).sort((F, Q) => Q.weight - F.weight)[0];
          P = Z == null ? void 0 : Z.weight;
        }
      } else if (x) {
        const M = U.filter((Z) => Z.weight > 500).sort((Z, F) => Z.weight - F.weight)[0];
        P = M == null ? void 0 : M.weight;
      } else {
        const M = U.filter((Z) => Z.weight <= 500).sort((Z, F) => F.weight - Z.weight)[0];
        P = M == null ? void 0 : M.weight;
      }
    } else {
      const U = B.filter((M) => M.style === "normal");
      if (x) {
        const M = U.filter((Z) => Z.weight > 500).sort((Z, F) => Z.weight - F.weight)[0];
        P = M == null ? void 0 : M.weight;
      } else {
        const M = U.filter((Z) => Z.weight <= 500).sort((Z, F) => F.weight - Z.weight)[0];
        P = M == null ? void 0 : M.weight;
      }
    }
    if (P !== void 0) {
      let U = _ ? `italic ${P}` : P.toString();
      s.modifyTextElementFontWeight(o, U);
    }
  }
  async setDesignItemImage(e, t, n) {
    var s;
    await ((s = this._sceneDesignManager) == null ? void 0 : s.setItemImage(e, t)), n == null || n.replaceImageByGuid(e, t);
  }
  setItemTextOnPath(e, t, n, s) {
    var h;
    (h = this._sceneDesignManager) == null || h.setItemTextOnPath(e, t, n);
    let o = s == null ? void 0 : s.findItemByGuid(e);
    n ? s == null || s.convertToTextOnPath(o) : s == null || s.convertToTextArea(o);
  }
  removeDesignItemImage(e, t) {
    var n;
    t == null || t.deselectAll(), t == null || t.removeImageByGuid(e), t == null || t.updateSelectionState(), (n = this._sceneDesignManager) == null || n.removeItemImage(e);
  }
  async setDesignItemSize(e, t, n, s) {
    var o;
    s && await s.setItemSize(e, t, n), await ((o = this._sceneDesignManager) == null ? void 0 : o.setItemSize(e, t, n));
  }
  setDesignItemConstraints(e, t, n) {
    var s;
    (n == null ? void 0 : n.setItemConstraints(e, t)) ?? ((s = this._sceneDesignManager) == null || s.setItemConstraints(e, t));
  }
  setDesignPrintingMethod(e, t, n) {
    var s;
    (n == null ? void 0 : n.setDesignPrintingMethod(e, t)) ?? ((s = this._sceneDesignManager) == null || s.setDesignPrintingMethod(e, t));
  }
  setDesignVisibility(e, t) {
    var n;
    (n = this._sceneDesignManager) == null || n.setDesignVisibility(e, t);
  }
  setupShaderMaterialsCameraPosition() {
    if (this._scene)
      for (let e = 0; e < this._scene.materials.length; e++) {
        const t = this._scene.materials[e];
        this.setupShaderMaterialCameraPosition(t);
      }
  }
  setupShaderMaterialCameraPosition(e) {
    this._scene && this._scene.activeCamera && e && e instanceof BABYLON.ShaderMaterial && e.setVector3("cameraPosition", this._scene.activeCamera.position);
  }
  setMeshLocation(e) {
    this._meshLocationsManager && this._meshLocationsManager.setMeshLocationByID(e);
  }
  async explodeMeshes() {
    this._meshLocationsManager && await this._meshLocationsManager.explodeMeshes();
  }
  async collapseMeshes() {
    this._meshLocationsManager && await this._meshLocationsManager.collapseMeshes();
  }
  dracoDecodingFunction(e, t, n) {
    this.decodeDracoFile(e, t, n);
  }
  decodeDracoFile(e, t, n) {
    var s = (/* @__PURE__ */ new Date()).getTime(), o = new Uint8Array(t), h = msgpack.decode(o);
    this.dracoCompression.decodeMeshAsync(h.data, h.attributes).then(function(c) {
      let _ = {};
      c && (c.indices && (_.indices = c.indices), c.positions && (_.positions = c.positions), c.normals && (_.normals = c.normals), c.tangents && (_.tangents = c.tangents), c.uvs && (_.uvs = c.uvs), c.uvs2 && (_.uv2s = c.uvs2), c.uvs3 && (_.uv3s = c.uvs3), c.uvs4 && (_.uv4s = c.uvs4), c.uvs5 && (_.uv5s = c.uvs5), c.uvs6 && (_.uv6s = c.uvs6));
      var x = /* @__PURE__ */ new Date(), B = x.getTime(), P = B - s, U = x.getHours() + ":" + x.getMinutes() + ":" + x.getSeconds() + "." + x.getMilliseconds();
      console.log(
        "Draco Decoding [" + U + "] - " + e + "	" + t.byteLength + "	" + P + " ms"
      ), n && n(_);
    });
  }
  exportSceneToBabylon() {
    return !this._zkScene || !this._sceneHelper ? null : this._sceneHelper.exportSceneToBabylon();
  }
  exportVisibleMeshesToBabylon() {
    return !this._zkScene || !this._sceneHelper ? null : this._sceneHelper.exportVisibleMeshesToBabylon();
  }
  async exportMeshesForTyOnToBabylon() {
    return !this._zkScene || !this._sceneHelper ? null : await this._sceneHelper.exportMeshesForTyOnToBabylon();
  }
  async exportMeshToBabylon(e) {
    if (!this._scene || !this._zkScene || !this._sceneHelper)
      return null;
    const t = this._scene.getMeshById(e);
    return t ? await this._sceneHelper.exportMeshToBabylon(t) : null;
  }
  async downloadMeshToBabylon(e) {
    if (!this._scene || !this._zkScene || !this._sceneHelper)
      return;
    const t = this._scene.getMeshById(e);
    t && await this._sceneHelper.downloadMeshBabylonAsync(t);
  }
  async saveSceneOnDatabaseAsync(e) {
    const t = this.exportSceneToBabylon();
    if (t) {
      const n = new $f();
      await n.openAsync(), await n.saveFileAsync(e, t);
    }
  }
  async saveVisibleMeshesOnDatabaseAsync(e) {
    const t = await this.exportMeshesForTyOnToBabylon();
    if (t) {
      const n = new $f();
      await n.openAsync(), await n.saveFileAsync(e, t);
    }
  }
  async saveGlbOnDatabaseAsync(e) {
    let t = null, n = "";
    if (t = await this.exportSceneToLocalGLBAsync(), t) {
      const s = await t.arrayBuffer(), o = Math.random().toString(36).substring(7), h = new FormData();
      h.append("blob", new Blob([s]), `model_${o}.glb`);
      try {
        const c = await fetch(Zakeke.config.baseApiUrl + "tryonassetupload/asset-upload", {
          method: "POST",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + window.token
          },
          body: h
        });
        if (c.status === 200)
          return n = await c.text(), n = n.replace(/^"|"$/g, "").substring(n.indexOf("fileUrl=") + 8 - 1), console.log("solo parametro restituito da asset-upload", n), n;
        console.error("Error uploading model", c);
      } catch (c) {
        console.error("Error uploading model", c);
      }
    }
    return n;
  }
  getArFileUrlCacheKey(e, t, n = "usdz") {
    let s = "scene_" + e;
    if (t && (s += "_code_" + t), this._sceneDesignManager) {
      var o = this._sceneDesignManager.getDesignItemsJson();
      if (o) {
        var h = CryptoJS.SHA1(o).toString();
        s += "_design_" + this._sceneDesignManager.getDesignID() + "_" + h;
      }
    }
    return s += "_" + n, s;
  }
  getCachedArFileUrl(e, t, n = "usdz") {
    var s = this.getArFileUrlCacheKey(e, t, n);
    return this._arFileUrls.hasOwnProperty(s) ? this._arFileUrls[s] : null;
  }
  cacheArFileUrl(e, t, n, s) {
    if (s) {
      var o = this.getArFileUrlCacheKey(e, t || void 0, n);
      this._arFileUrls[o] = s;
    }
  }
  async exportMeshToGLBBlob(e) {
    var o, h, c, _;
    if (!this._scene || !this._zkScene || !this._sceneHelper)
      return null;
    let t = null;
    const n = this._zkScene.get("rootUrl");
    n && (t = n), await ((o = this._sceneDesignManager) == null ? void 0 : o.changeToRasterizedTextures()), (h = this._sceneDesignManager) == null || h.expandCanvasMeshes(0.05);
    let s = await this._sceneHelper.exportMeshToGLBBlob(t, e);
    return console.log("dopo l'export faccio rientrare l'expand", s), (c = this._sceneDesignManager) == null || c.expandCanvasMeshes(-0.05), await ((_ = this._sceneDesignManager) == null ? void 0 : _.changeToDynamicTextures()), s;
  }
  async exportSceneToUsdzAsync(e, t, n) {
    var B, P, U, M;
    if (!this._zkScene || !this._sceneHelper)
      return null;
    const s = "usdz";
    let o = null;
    if (e && (!this._sceneDesignManager || n) && (o = this.getCachedArFileUrl(e, t, s)), o)
      return o;
    let h = null, c = null;
    const _ = this._zkScene.get("name");
    _ && (h = _);
    const x = this._zkScene.get("rootUrl");
    return x && (c = x), await ((B = this._sceneDesignManager) == null ? void 0 : B.changeToRasterizedTextures()), this._sceneDesignManager && this._sceneDesignManager.expandCanvasMeshes(), o = await this._sceneHelper.exportSceneToUsdzAsync(
      h,
      c,
      this._sceneDesignManager && !n ? void 0 : e,
      this._sceneDesignManager && !n ? void 0 : t,
      ((P = this.zkScene) == null ? void 0 : P.getARMeshSize()) ?? null,
      this.getDAMMainMesh() ?? null,
      (U = this._zkScene) == null ? void 0 : U.getARScale()
    ), this._sceneDesignManager && this._sceneDesignManager.contractCanvasMeshes(), await ((M = this._sceneDesignManager) == null ? void 0 : M.changeToDynamicTextures()), o && e && !this._sceneDesignManager && this.cacheArFileUrl(e, t || null, s, o), o;
  }
  async exportMeshToUsdzAsync(e) {
    var n, s, o;
    const t = this.getMeshByID(e);
    if (t && this._zkScene && this._sceneHelper) {
      let h = null;
      const c = this._zkScene.get("rootUrl");
      c && (h = c), await ((n = this._sceneDesignManager) == null ? void 0 : n.changeToRasterizedTextures());
      const _ = await this._sceneHelper.exportMeshToUsdzAsync(
        h,
        t,
        ((s = this.zkScene) == null ? void 0 : s.getARMeshSize()) ?? null,
        this.getDAMMainMesh() ?? null,
        this.getARScale()
      );
      return await ((o = this._sceneDesignManager) == null ? void 0 : o.changeToDynamicTextures()), Logger.info("USDZ: " + _), _;
    }
    return null;
  }
  async exportSceneToRemoteGlTFAsync(e, t, n) {
    var _, x, B, P;
    if (!this._sceneHelper)
      return null;
    const s = "glTF";
    let o = null;
    if (e && (!this._sceneDesignManager || n) && (o = this.getCachedArFileUrl(e, t, s)), o)
      return o;
    let h = null, c = null;
    if (this._zkScene) {
      const U = this._zkScene.get("name");
      U && (h = U);
      const M = this._zkScene.get("rootUrl");
      M && (c = M);
    }
    return await ((_ = this._sceneDesignManager) == null ? void 0 : _.changeToRasterizedTextures()), this._sceneDesignManager && this._sceneDesignManager.expandCanvasMeshes(), o = await this._sceneHelper.exportSceneToRemoteGlTFAsync(
      h,
      c,
      this._sceneDesignManager && !n ? void 0 : e,
      this._sceneDesignManager && !n ? void 0 : t,
      ((x = this.zkScene) == null ? void 0 : x.getARMeshSize()) ?? null,
      this.getDAMMainMesh() ?? null,
      (B = this._zkScene) == null ? void 0 : B.getARScale()
    ), this._sceneDesignManager && this._sceneDesignManager.contractCanvasMeshes(), await ((P = this._sceneDesignManager) == null ? void 0 : P.changeToDynamicTextures()), o && e && !this._sceneDesignManager && this.cacheArFileUrl(e, t || null, s, o), Logger.info("GlTF: " + o), o;
  }
  async exportMeshToRemoteGlTFAsync(e) {
    var n, s, o;
    const t = this.getMeshByID(e);
    if (t && this._zkScene && this._sceneHelper) {
      let h = null;
      const c = this._zkScene.get("rootUrl");
      c && (h = c), await ((n = this._sceneDesignManager) == null ? void 0 : n.changeToRasterizedTextures());
      const _ = await this._sceneHelper.exportMeshToRemoteGlTFAsync(
        h,
        t,
        ((s = this.zkScene) == null ? void 0 : s.getARMeshSize()) ?? null,
        this.getDAMMainMesh() ?? null,
        this.getARScale()
      );
      return Logger.info("GlTF: " + _), await ((o = this._sceneDesignManager) == null ? void 0 : o.changeToDynamicTextures()), _;
    }
    return null;
  }
  async exportSceneToRemoteGLBAsync(e, t, n) {
    var _, x, B, P;
    if (!this._sceneHelper)
      return null;
    const s = "glb";
    let o = null;
    if (e && (!this._sceneDesignManager || n) && (o = this.getCachedArFileUrl(e, t, s)), o)
      return o;
    let h = null, c = null;
    if (this._zkScene) {
      const U = this._zkScene.get("name");
      U && (h = U);
      const M = this._zkScene.get("rootUrl");
      M && (c = M);
    }
    return await ((_ = this._sceneDesignManager) == null ? void 0 : _.changeToRasterizedTextures()), this._sceneDesignManager && this._sceneDesignManager.expandCanvasMeshes(), o = await this._sceneHelper.exportSceneToRemoteGLBAsync(
      h,
      c,
      this._sceneDesignManager && !n ? void 0 : e,
      this._sceneDesignManager && !n ? void 0 : t,
      ((x = this.zkScene) == null ? void 0 : x.getARMeshSize()) ?? null,
      this.getDAMMainMesh() ?? null,
      (B = this._zkScene) == null ? void 0 : B.getARScale()
    ), this._sceneDesignManager && this._sceneDesignManager.contractCanvasMeshes(), await ((P = this._sceneDesignManager) == null ? void 0 : P.changeToDynamicTextures()), o && e && !this._sceneDesignManager && this.cacheArFileUrl(e, t || null, s, o), Logger.info("GLB: " + o), o;
  }
  async exportMeshToRemoteGLBAsync(e) {
    var n, s, o;
    const t = this.getMeshByID(e);
    if (t && this._zkScene && this._sceneHelper) {
      let h = null;
      const c = this._zkScene.get("rootUrl");
      c && (h = c), await ((n = this._sceneDesignManager) == null ? void 0 : n.changeToRasterizedTextures());
      const _ = await this._sceneHelper.exportMeshToRemoteGLBAsync(
        h,
        t,
        ((s = this.zkScene) == null ? void 0 : s.getARMeshSize()) ?? null,
        this.getDAMMainMesh() ?? null,
        this.getARScale()
      );
      return Logger.info("GlTF: " + _), await ((o = this._sceneDesignManager) == null ? void 0 : o.changeToDynamicTextures()), _;
    }
    return null;
  }
  // Esporta la scena nei formati glb e usdz utili per visualizzarli con model-viewer
  // il formato png viene richiesto per ottenere un poster del modello da visualizzare inizialmente
  async exportSceneToARAsync(e, t) {
    var h, c;
    let n = [];
    if (!this._sceneHelper)
      return n;
    let s = null, o = null;
    if (this._zkScene) {
      const _ = this._zkScene.get("name");
      _ && (s = _);
      const x = this._zkScene.get("rootUrl");
      x && (o = x);
    }
    return await ((h = this._sceneDesignManager) == null ? void 0 : h.changeToRasterizedTextures()), this._sceneDesignManager && this._sceneDesignManager.expandCanvasMeshes(), n = await this._sceneHelper.exportSceneToARMultiformatAsync(
      s,
      o,
      ["usdz", "glb"],
      e,
      t
    ), this._sceneDesignManager && this._sceneDesignManager.contractCanvasMeshes(), await ((c = this._sceneDesignManager) == null ? void 0 : c.changeToDynamicTextures()), n;
  }
  // Esporta la mesh nei formati glb e usdz utili per visualizzarli con model-viewer
  // il formato png viene richiesto per ottenere un poster del modello da visualizzare inizialmente
  async exportMeshToARAsync(e) {
    var s, o, h;
    let t = [];
    const n = this.getMeshByID(e);
    if (n && this._zkScene && this._sceneHelper) {
      let c = null;
      const _ = this._zkScene.get("rootUrl");
      _ && (c = _), await ((s = this._sceneDesignManager) == null ? void 0 : s.changeToRasterizedTextures()), t = await this._sceneHelper.exportMeshToARMultiformatAsync(
        c,
        n,
        ["usdz", "glb"],
        ((o = this.zkScene) == null ? void 0 : o.getARMeshSize()) ?? null,
        this.getDAMMainMesh() ?? null,
        this.getARScale()
      ), await ((h = this._sceneDesignManager) == null ? void 0 : h.changeToDynamicTextures());
    }
    return t;
  }
  isAREnabled() {
    if (!this._zkScene)
      return !1;
    let e = this._zkScene.getAREnabled();
    return e != null && e && this._sceneHelper != null && // this._sceneHelper.getMeshesForAR().length > 0 &&
    this._sceneHelper.checkMaterialsForAR();
  }
  async exportSceneToLocalGLBAsync() {
    var t, n;
    await ((t = this._sceneDesignManager) == null ? void 0 : t.changeToRasterizedTextures()), this._sceneDesignManager && this._sceneDesignManager.expandCanvasMeshes();
    let e = null;
    return this._sceneHelper && (e = await this._sceneHelper.exportSceneToLocalGLBBlobAsync()), this._sceneDesignManager && this._sceneDesignManager.contractCanvasMeshes(), await ((n = this._sceneDesignManager) == null ? void 0 : n.changeToDynamicTextures()), e;
  }
  async downloadSceneLocalGLBAsync() {
    this._sceneDesignManager && this._sceneDesignManager.expandCanvasMeshes(), this._sceneHelper && await this._sceneHelper.downloadSceneLocalGLBAsync(), this._sceneDesignManager && this._sceneDesignManager.contractCanvasMeshes();
  }
  async exportSceneToLocalUSDZAsync() {
    var t, n;
    await ((t = this._sceneDesignManager) == null ? void 0 : t.changeToRasterizedTextures()), this._sceneDesignManager && this._sceneDesignManager.expandCanvasMeshes();
    let e = null;
    return this._sceneHelper && (e = await this._sceneHelper.exportSceneToLocalUSDZUrlAsync()), this._sceneDesignManager && this._sceneDesignManager.contractCanvasMeshes(), await ((n = this._sceneDesignManager) == null ? void 0 : n.changeToDynamicTextures()), e;
  }
  async downloadSceneLocalUSDZAsync() {
    this._sceneDesignManager && this._sceneDesignManager.expandCanvasMeshes(), this._sceneHelper && await this._sceneHelper.downloadSceneLocalUSDZAsync(), this._sceneDesignManager && this._sceneDesignManager.contractCanvasMeshes();
  }
  getSceneRootUrl() {
    return new Promise((e, t) => {
      let n = null;
      this._zkScene ? (n = this._zkScene.get("rootUrl") || null, n ? e(n) : jQuery.ajax({
        url: this._zkScene.getSceneRootUrlApiUrl(),
        type: "GET",
        success: function(s) {
          n = s, e(n);
        },
        error: function(s, o, h) {
          t(h);
        }
      })) : e(n);
    });
  }
  isTryOnMeshVisibleEnabledToShow() {
    const e = this.getVisibleMeshes();
    for (const t of e) {
      const n = t.getChildren();
      if (n.length > 0 && n.find(
        (o) => this._sceneHelper.isTryOnEnabledForMesh(o)
      ) && this._sceneHelper.isTryOnEnabledForMesh(t))
        return !0;
    }
    return !1;
  }
  getTryOnMeshVisible() {
    const e = this.getVisibleMeshes();
    for (let t of e) {
      const n = t.getChildren();
      if (n.length > 0 && !t.parent && n.find(
        (o) => {
          var h;
          return (h = this._sceneHelper) == null ? void 0 : h.isTryOnEnabledForMesh(o);
        }
      ))
        return t;
    }
    return null;
  }
  getFrameDAMSettings() {
    if (this._zkScene) {
      const e = this._zkScene.getFrameDAMSettings() ?? null;
      if (e)
        return JSON.parse(e);
    }
    return null;
  }
  getMeshFineTuningData(e) {
    const t = typeof e == "string" ? this.getMeshByID(e) : e;
    return t && t.metadata && t.metadata.tryOnFineTuningSettings ? t.metadata.tryOnFineTuningSettings : null;
  }
  getDAMFineTuningData() {
    var e, t;
    return (e = this.zkScene) != null && e.getFrameDAMSettings() && ((t = this.getFrameDAMSettings()) == null ? void 0 : t.finetuning) || null;
  }
  getTryOnFineTuningMeshVisible() {
    var t;
    const e = this.getVisibleMeshes();
    for (const n of e) {
      const s = n.getChildren();
      if (s.length > 0 && s.find(
        (h) => {
          var c;
          return (c = this._sceneHelper) == null ? void 0 : c.isTryOnEnabledForMesh(h);
        }
      ) && (t = n == null ? void 0 : n.metadata) != null && t.tryOnFineTuningSettings)
        return n;
    }
    return null;
  }
  refreshInfoPoints() {
    if (!(this._zkScene && this._zkScene.getInfoPointsEnabled() && this.canShowInfoPoints)) {
      this.disposeInfoPointsManager(), this.setLongRenderingNeeded();
      return;
    }
    const t = this.getInfoPointsManagerStyle();
    let n = null;
    this._infoPointsManager || this._scene && this._zkScene && (this._infoPointsManager = new Rw(this._zkScene, this._scene, t), this._infoPointPickedListeners && this._infoPointPickedListeners.length > 0 && this._infoPointsManager.addInfoPointPickedListenerRange(this._infoPointPickedListeners), this._infoPointContentShownListeners && this._infoPointContentShownListeners.length > 0 && this._infoPointsManager.addInfoPointContentShownListenerRange(this._infoPointContentShownListeners), this._infoPointContentHiddenListeners && this._infoPointContentHiddenListeners.length > 0 && this._infoPointsManager.addInfoPointContentHiddenListenerRange(
      this._infoPointContentHiddenListeners
    ), this._infoPointsManager.onBeforeShowImages = () => {
      n === null && (n = this.antiAliasConfig.enabled), this.antiAliasConfig.enabled = !1, this.disableAntialiasing();
    }, this._infoPointsManager.onAfterShowImages = () => {
      this.antiAliasConfig.enabled = n, n = null, this.enableAntialiasing(), this.setLongRenderingNeeded();
    }, this._infoPointsManager.addRenderingNeededListener(() => this.setRenderingNeeded())), this._infoPointsManager && (this.updateInfoPointsManagerStyle(), this._infoPointsManager.canShowInfoPointsContent = this.canShowInfoPointsContent, this._infoPointsManager.refresh()), this.setLongRenderingNeeded();
  }
  getInfoPointsManagerStyle() {
    const e = this._infoPointsManagerStyle ? this._infoPointsManagerStyle : {};
    if (this._zkScene) {
      const t = this._zkScene.getInfoPointsStyleConfig();
      t && (e.infoPointsStyle || (e.infoPointsStyle = {}), t.get("borderColor") && (e.infoPointsStyle.borderColor = t.get("borderColor")), t.get("innerPointColor") && (e.infoPointsStyle.innerPointColor = t.get("innerPointColor")), t.get("color") && (e.infoPointsStyle.color = t.get("color")), t.get("highlightColor") && (e.infoPointsStyle.highlightColor = t.get("highlightColor")));
    }
    return e;
  }
  updateInfoPointsManagerStyle() {
    if (this._infoPointsManager) {
      const e = this.getInfoPointsManagerStyle();
      this._infoPointsManager.applyStyle(e);
    }
  }
  showInfoPoints() {
    this._infoPointsManager && (this._infoPointsManager.showInfoPoints(), this.render(), this.setRenderingNeeded());
  }
  hideInfoPoints() {
    this._infoPointsManager && (this._infoPointsManager.hideInfoPoints(), this.render(), this.setRenderingNeeded());
  }
  // try to reload all textures with loading errors
  async reloadAllLoadingErrorTexturesAsync() {
    if (this._zkScene && this._sceneHelper) {
      const e = this._zkScene.get("rootUrl");
      e && await this._sceneHelper.reloadAllLoadingErrorTexturesAsync(e);
    }
  }
  // try to reload the material textures with loading errors
  async reloadMaterialLoadingErrorTexturesAsync(e) {
    if (this._zkScene && this._sceneHelper) {
      const t = this._zkScene.get("rootUrl");
      t && await this._sceneHelper.reloadMaterialLoadingErrorTexturesAsync(t, e);
    }
  }
  // try to reload the texture having loading errors
  async reloadLoadingErrorTextureAsync(e) {
    if (this._zkScene && this._sceneHelper) {
      const t = this._zkScene.get("rootUrl");
      t && await this._sceneHelper.reloadLoadingErrorTextureAsync(t, e);
    }
  }
  // were there any loading errors for the texture?
  isTextureLoadingError(e) {
    return this._sceneHelper ? this._sceneHelper.isTextureLoadingError(e) : !1;
  }
  // the material has some texture with loading errors
  materialHasLoadingErrorTextues(e) {
    return this._sceneHelper ? this._sceneHelper.materialHasLoadingErrorTextues(e) : !1;
  }
  // Check if any texture in the scene has loading errors
  hasAnyTextureLoadingErrors() {
    return !this._scene || !this._sceneHelper ? !1 : this._scene.textures.some((e) => this._sceneHelper.isTextureLoadingError(e));
  }
  // Get all textures with loading errors
  getTexturesWithLoadingErrors() {
    return !this._scene || !this._sceneHelper ? [] : this._scene.textures.filter((e) => this._sceneHelper.isTextureLoadingError(e));
  }
  // Get all materials that have at least one texture with loading errors
  getMaterialsWithLoadingErrors() {
    return this._sceneHelper ? this._sceneHelper.getAllMaterials().filter((e) => this._sceneHelper.materialHasLoadingErrorTextues(e)) : [];
  }
  notifyCameraMovement() {
    if (this._isHologramSource && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      let e = this.getOrCreateBroadcastChannel();
      if (!e)
        return;
      e.postMessage({
        type: "camera-movement",
        target: { x: this._camera.target.x, y: this._camera.target.y, z: this._camera.target.z },
        alpha: this._camera.alpha,
        beta: this._camera.beta,
        radius: this._camera.radius
      });
    }
  }
  notifyScriptExecution(e) {
    if (this._isHologramSource) {
      const t = e.map((s) => ({
        attributeID: s.attributeID,
        selectedValue: s.selectedValue,
        actions: s.actions.map((o) => ({
          attributeGuid: o.get("actionGuid"),
          name: o.get("name"),
          actionTypeID: o.get("actionTypeID"),
          sceneElementTypeID: o.get("sceneElementTypeID"),
          selector: o.get("selector"),
          propertyName: o.get("propertyName"),
          value: o.get("value"),
          execOrder: o.get("execOrder"),
          deviceTypes: o.get("deviceTypes")
        }))
      }));
      let n = this.getOrCreateBroadcastChannel();
      if (!n)
        return;
      n.postMessage({
        type: "script-execution",
        script: t
      });
    }
    for (const t of this._scriptExecutionListeners)
      t(e);
  }
  notifyDesignChanged(e) {
    if (this._isHologramSource) {
      let t = this.getOrCreateBroadcastChannel();
      if (!t)
        return;
      t.postMessage({
        type: "design-changed",
        design: e.toJSON()
      });
    }
  }
  notifyActionExecution(e, t, n) {
    this.notifyScriptExecution([
      {
        attributeID: e,
        selectedValue: t,
        actions: n
      }
    ]);
  }
  attachBroadcastChannelEventHandlers() {
    if (this._isHologram && !this._isHologramSource) {
      var e = this.getOrCreateBroadcastChannel();
      if (!e)
        return;
      e.onmessage = (t) => this.onBroadcastMessageReceived(t);
    }
  }
  detachBroadcastChannelEventHandlers() {
    this._broadcastChannel && (this._broadcastChannel.onmessage = null);
  }
  onBroadcastMessageReceived(e) {
    this._isHologram && e && e.data && e.data.type && (e.data.type === "camera-movement" ? this.processCameraMovementEvent(e) : e.data.type === "script-execution" ? this.processScriptExecution(e) : e.data.type === "design-changed" && this.processDesignChanged(e));
  }
  processCameraMovementEvent(e) {
    this._camera && this._camera instanceof BABYLON.ArcRotateCamera && e && e.data && (this._camera.target = new BABYLON.Vector3(e.data.target.x, e.data.target.y, e.data.target.z), this._camera.alpha = e.data.alpha, this._camera.beta = e.data.beta, this._camera.radius = e.data.radius, this.setRenderingNeeded());
  }
  processScriptExecution(e) {
    if (e && e.data && e.data.script && Object.prototype.toString.call(e.data.script) === "[object Array]") {
      var t = e.data.script.map(
        (n) => ({
          attributeID: n.attributeID,
          selectedValue: n.selectedValue,
          actions: n.actions.map((s) => new MPlaza.AttributeSceneAction(s))
        })
      );
      this.executeScriptAsync(t);
    }
  }
  processDesignChanged(e) {
    if (e && e.data && e.data.design) {
      let t = new MPlaza.Design(e.data.design);
      this.renderDesignAsync(t);
    }
  }
  loadSceneConfig(e) {
    const t = new Zakeke.SceneConfig(e);
    if (this._zkScene && !this._zkScene.get("config"))
      this._zkScene.set("config", t);
    else {
      const n = new Zakeke.Scene();
      n.set("config", t), this._zkScene = n;
    }
    this.checkSceneShaderMaterials(this._zkScene);
  }
  updateFromConfig(e, t) {
    var n, s;
    if (this._zkScene) {
      let o = (s = (n = this._zkScene) == null ? void 0 : n.get("config")) == null ? void 0 : s.toJSON();
      const h = Yw.merge(o, e), c = new Zakeke.SceneConfig(h);
      if (this._zkScene.set("config", c), (t == null ? void 0 : t.preventRefresh) === !0)
        return;
      this.setupSceneAsync((t == null ? void 0 : t.updateCamera) === !0);
    }
  }
  /**
   * Set up new camera position if parameter is present in config
   */
  refreshCameraPosition() {
    var n, s, o;
    const e = (s = (n = this._zkScene) == null ? void 0 : n.get("config")) == null ? void 0 : s.toJSON(), t = e == null ? void 0 : e.camera;
    t && (t != null && t.position) && ((o = this._sceneHelper) == null || o.setUpCameraByOptions(t.position));
  }
  setupDebugGUI() {
    var n;
    const e = (n = this._zkScene) == null ? void 0 : n.get("config"), t = (s) => {
      this.updateFromConfig(s, { updateCamera: !1 });
    };
    this._createGui = new v1(
      e.toJSON(),
      (s) => t(s),
      this._sceneHelper
    ), this._createGui.setupGui(this._scene);
  }
  async setUpEmptyScene(e) {
    this._scene && (e && this.loadSceneConfig(e), await this.setupSceneAsync(), this.setRenderingNeeded());
  }
  /**
   * Loads a babylon scene from a remote URL.
   * @param rootUrl The root URL of the scene.
   * @param sceneFileName The name of the scene file.
   * @param sceneConfig Optional scene configuration.
   */
  async loadFromSceneUrl(e, t, n) {
    await this.loadSceneFromRemoteFilesAsync(e, t), n && this.loadSceneConfig(n), await this.setupSceneAsync(), this.setRenderingNeeded();
  }
  stopAllAnimations() {
    this._scene && this._sceneHelper && this._sceneHelper.stopAllAnimations();
  }
  hasAnimations() {
    return this._scene && this._sceneHelper ? this._sceneHelper.hasAnimations() : !1;
  }
  playAnimations() {
    this._scene && this._sceneHelper && this._sceneHelper.playAnimations();
  }
  // al momento Marco FF ha detto che non serve esposto
  // public setupAnimations () {
  // 	if (this._scene && this._sceneHelper) {
  // 		this._sceneHelper.setupAnimations(this._zkScene);
  // 	}
  // }
  /**
   * Loads a scene from a GLB file URL.
   * @param url The URL of the GLB file.
   * @param sceneConfig Optional scene configuration.
   */
  async loadFromGlbUrl(e, t) {
    var s, o, h;
    const n = ((s = t == null ? void 0 : t.camera) == null ? void 0 : s.animateIntro) !== void 0 ? (o = t == null ? void 0 : t.camera) == null ? void 0 : o.animateIntro : !0;
    await ((h = this._sceneHelper) == null ? void 0 : h.importMeshesFromUrlAsync(e, null, void 0, n, ".glb", this._isViewer)), t && this.loadSceneConfig(t), await this.setupSceneAsync(), this.updateView(!1, !0);
  }
  /**
   * Loads a scene from a file.
   * @param file The file to load the scene from.
   */
  async loadFromFile(e, t) {
    var n, s;
    ((n = t == null ? void 0 : t.camera) == null ? void 0 : n.animateIntro) !== void 0 && ((s = t == null ? void 0 : t.camera) == null || s.animateIntro);
    try {
      await BABYLON.SceneLoader.AppendAsync(e.name, e, this._scene);
    } catch (o) {
      console.log("dropObjectIntoScene: ", o);
    }
    t && this.loadSceneConfig(t), await this.setupSceneAsync(), this.updateView(!0, !0), this.setRenderingNeeded();
  }
  async showResizableCanvasModel(e) {
    if (this._scene && this._zkScene && this._zkModel && this._sceneHelper) {
      const t = await this._sceneHelper.showResizableCanvas(
        e.width,
        e.height,
        e.depth,
        e.borderRadius,
        e.type,
        e.borderColor,
        e.columns,
        e.rows,
        e.ppcm,
        e.backgroundColor,
        e.backgroundUrl,
        e.shape
      );
      if (!t)
        return { meshes: [], matrixJson: "" };
      const n = new qw.PaperScope();
      n.setup(new n.Size(1, 1));
      const s = new n.Matrix(), o = tg.DEFAULT_SIZE;
      s.translate(o / 2, o / 2), s.scale(o / e.width, o / e.height);
      const h = JSON.stringify(s.values);
      return { meshes: t, matrixJson: h };
    }
    return { meshes: [], matrixJson: "" };
  }
  async showResizableCanvasPerCurrentSide(e) {
    console.log("showResizableCanvasPerCurrentSide", e);
    const t = `resizable-canvas-${e.width}-${e.height}-${e.colorId}-${e.currentSideId}-${e.columns}-${e.rows}-${e.type}-${e.borderColor}`;
    if (this._lastResizableMeshID === t)
      return;
    this._lastResizableMeshID = t;
    const n = await this.showResizableCanvasModel(e);
    if (n.meshes.length === 0)
      return;
    const s = this._zkModel.get("scenes").at(0).get("meshSides");
    s.filter((_) => _.get("isResizable")).forEach((_) => s.remove(_));
    const h = e.type === "mirrored" ? ["front", "borders"] : ["front"];
    let c = 0;
    for (const _ of n.meshes)
      if (_ && h.includes(_.name)) {
        _.id = t.replace("sideIdPlaceholder", e.currentSideId.toString()) + c++;
        const x = new MPlaza.ModelSceneMeshSide({
          sideID: e.currentSideId,
          meshID: _.id,
          uvChannel: 0,
          percWidth: 1,
          percHeight: 1,
          subMeshID: 0,
          matrix: n.matrixJson,
          isResizable: !0
        });
        s.push(x);
      }
    console.log({ meshSides: s }), setTimeout(() => this.adjustCamera(!1), 100);
  }
  async showResizableCanvasPerVariant(e) {
    if (console.log("showResizableCanvasPerVariant", e), !this.zkModel)
      return;
    const t = `resizable-canvas-${e.width}-${e.height}-${e.colorId}-sideIdPlaceholder-${e.columns}-${e.rows}-${e.type}-${e.borderColor}`;
    if (this._lastResizableMeshID === t)
      return;
    this._lastResizableMeshID = t;
    const n = await this.showResizableCanvasModel(e);
    if (n.meshes.length === 0)
      return;
    let s = 0;
    const o = e.sidesIds.length > 1;
    let h = ["front", "back", "borders"];
    e.type === "none" || e.type === "colored" ? o ? h = ["front", "back"] : h = ["front"] : e.type === "mirrored" && (o ? h = ["front", "back", "borders"] : h = ["front", "borders"]);
    const c = this._zkModel.get("scenes").at(0).get("meshSides");
    c.filter((x) => x.get("isResizable")).forEach((x) => c.remove(x));
    for (const x of n.meshes)
      if (x && h.includes(x.name)) {
        const B = !o || x.name === "front" ? e.sidesIds[0] : e.sidesIds[1];
        x.id = t.replace("sideIdPlaceholder", B.toString()) + s++;
        const P = new MPlaza.ModelSceneMeshSide({
          sideID: B,
          meshID: x.id,
          uvChannel: 0,
          percWidth: 1,
          percHeight: 1,
          subMeshID: 0,
          matrix: n.matrixJson,
          isResizable: !0
        });
        c.push(P);
      }
    setTimeout(() => this.adjustCamera(!1), 100);
  }
  clearResizableProduct() {
    var e;
    (e = this._sceneHelper) == null || e.clearResizableMeshes();
  }
  setMouseWheelInputEnabled(e) {
    this._camera && this._mouseWheelInput && (e ? this._camera.inputs.add(this._mouseWheelInput) : this._camera.inputs.remove(this._mouseWheelInput));
  }
  setCameraPinchingZoom(e) {
    if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      const t = this._camera.inputs.attached.pointers;
      t.pinchZoom = e, t.multiTouchPanAndZoom = e;
    }
  }
  switchMode(e) {
    var t;
    e === "upload" && (this._lastResizableMeshID = ""), (t = this._sceneHelper) == null || t.switchMode(e), setTimeout(() => this.adjustCamera(!1), 100);
  }
  async setCanvasRotation(e, t) {
    var _;
    if (e = e % 360, this._isRotating || !this._zkModel || !this._sceneHelper || !this._sceneDesignManager || this._currentRotation === e)
      return;
    const n = this._zkModel.get("scenes").at(0).get("meshSides");
    if (n.length === 0)
      return;
    const o = n.at(0).get("meshID"), h = this.getMeshByID(o);
    if (!h)
      return;
    const c = h.getFacetNormal(0);
    this._isRotating = !0, await ((_ = this._sceneHelper) == null ? void 0 : _.rotate(this._currentRotation - e, c, t)), this._currentRotation = e, this._isRotating = !1, this._sceneDesignManager.rotation = this._currentRotation, await this._sceneDesignManager.refreshAsync(), this.setRenderingNeeded();
  }
  getFitToScreenMargin() {
    return this._zkScene ? this._zkScene.getFitToScreenMargin() : 1;
  }
  setFitToScreenMargin(e) {
    this._zkScene && this._zkScene.setFitToScreenMargin(e);
  }
  moveDesignItemUp(e, t) {
    var n;
    console.log("sceneViewer moveDesignItemUp", e), t ? t.moveItemUp(e) : (n = this._sceneDesignManager) == null || n.moveItemUp(e);
  }
  moveDesignItemDown(e, t) {
    var n;
    console.log("sceneViewer moveDesignItemDown", e), t ? t.moveItemDown(e) : (n = this._sceneDesignManager) == null || n.moveItemDown(e);
  }
}
class b1 {
  constructor(e) {
    this.materials = [], this.guid = Zakeke.generateUUID(), this.groupName = e;
  }
}
var x1 = /* @__PURE__ */ ((b) => (b[b.uploading = 0] = "uploading", b[b.progress = 1] = "progress", b[b.checking = 2] = "checking", b[b.success = 3] = "success", b[b.completed_success = 4] = "completed_success", b[b.completed_error = 5] = "completed_error", b))(x1 || {});
const bg = class fl extends Cu {
  constructor(e) {
    super({ configPreview: !0 }), this._dracoEnabled = !0, this._dracoEncodingSpeed = 5, this._dracoDecodingSpeed = 5, this._envMode = Er.Editor, this._selectOnPick = !0, this._showBoundingBox = !1, this._editorBackgroundColor = "#444444", this._showGround = !0, this._ground = null, this._showLights = !1, this._lightsLayer = null, this._showAxes = !1, this._axesLayer = null, this._showFineTuning = !1, this._fineTuningModelLoaded = !1, this._showHighlight = !0, this._highlightOver = !0, this._highlightOverColor = "#0082ff", this._editingMode = $a.None, this._manipulatedNode = null, this._oldManipulatedNode = null, this._EditControl = org.ssatguru.babylonjs.component.EditControl, this._editControl = null, this._editControlVisible = !1, this._shiftPressed = !1, this._ctrlPressed = !1, this._realMeshVisibility = {}, this._sceneSourceTasks = [], this._isLoadingSourceFiles = !1, this._authorizationToken = "", this._incrementalWorkersScriptsUrls = [], this._preUpdateListeners = [], this._postUpdateListeners = [], this._meshSelectedListeners = [], this._selectionChangedListeners = [], this._lightSelectedListeners = [], this._sceneCreatedListeners = [], this._cameraLocationCreatedListeners = [], this._sceneSourceTaskSuccessListeners = [], this._sceneSourceTaskErrorListeners = [], this._sceneSourceTasksCheckListeners = [], this._meshesUpdateListeners = [], this._materialsUpdateListeners = [], this._lightsUpdateListeners = [], this._cameraLocationsUpdateListeners = [], this._meshLocationCreatedListeners = [], this._meshLocationsUpdateListeners = [], this._arTaskSuccessListeners = [], this._arTaskErrorListeners = [], this._arTasksCheckListeners = [], this._tryOnFineTuningSettingListeners = [], this._tryOnFineTuningCloseListeners = [], this._pickedProvider = hg.NotSelected, this._providerData = { mesh: new Blob() }, this._sessionTryOnEnabled = !1, this._tryOnInfoLoading = !0, this._initialMeshMaterials = {}, this._initialSubMeshMaterials = {}, this._lastMeshMaterials = {}, this._lastSubMeshMaterials = {}, this._meshOver = null, this._incrementalFilesMaker = null, this._sceneToBlobs = null, this._showMeasurements = !1, this._modelMeasurements = BABYLON.Vector3.Zero(), e && (this._incrementalWorkersScriptsUrls = e.incrementalWorkersScriptsUrls, this._authorizationToken = e.authorizationToken, e.showGround != null && e.showGround != null && (this._showGround = e.showGround), e.editorBackgroundColor !== void 0 && e.editorBackgroundColor !== null && (this._editorBackgroundColor = e.editorBackgroundColor), e.showHighlight !== void 0 && e.showHighlight !== null && (this._showHighlight = e.showHighlight), e.highlightColor !== void 0 && e.highlightColor !== null && (this._highlightColor = e.highlightColor), e.highlightOver !== void 0 && e.highlightOver != null && (this._highlightOver = e.highlightOver), e.highlightOverColor !== void 0 && e.highlightOverColor != null && (this._highlightOverColor = e.highlightOverColor));
  }
  // Real mesh visibility
  get realMeshVisibility() {
    return this._realMeshVisibility;
  }
  // Environemnt manager
  get environmentManager() {
    return this._environmentManager;
  }
  // EnvMode
  get envMode() {
    return this._envMode;
  }
  // Source tasks
  get sceneSourceTasks() {
    return this._sceneSourceTasks;
  }
  set envMode(e) {
    this._envMode != e && (this._envMode = e, this.refreshEnvironment());
  }
  // SelectOnPick
  get selectOnPick() {
    return this._selectOnPick;
  }
  set seletOnPick(e) {
    this._selectOnPick != e && (this._selectOnPick = e);
  }
  // ShowBoundingBox
  get showBoundingBox() {
    return this._showBoundingBox;
  }
  set showBoundingBox(e) {
    this._showBoundingBox != e && (this._showBoundingBox = e, this.updateBoundingBox(), this.setRenderingNeeded());
  }
  // EditorBackgroundColor
  get editorBackgroundColor() {
    return this._editorBackgroundColor;
  }
  set editorBackgroundColor(e) {
    this._editorBackgroundColor != e && this.setEditorBackgroundColor(e);
  }
  // ShowGround
  get showGround() {
    return this._showGround;
  }
  set showGround(e) {
    this._showGround != e && (this._showGround = e, this.refreshGround());
  }
  // ShowLights
  get showLights() {
    return this._showLights;
  }
  set showLights(e) {
    this._showLights != e && (this._showLights = e, this._lightsLayer && this._lightsLayer.refresh(), this.setRenderingNeeded());
  }
  // ShowAxes
  get showAxes() {
    return this._showAxes;
  }
  set showAxes(e) {
    this._showAxes != e && (this._showAxes = e, this._axesLayer && this._axesLayer.refresh(), this.setRenderingNeeded());
  }
  get showFineTuning() {
    return this._showFineTuning;
  }
  set showFineTuning(e) {
    this._showFineTuning = e, this._fineTuningModelLoaded = !1;
  }
  set fineTuningModelLoaded(e) {
    this._fineTuningModelLoaded = e;
  }
  get fineTuningModelLoaded() {
    return this._fineTuningModelLoaded;
  }
  get sessionTryOnEnabled() {
    return this._sessionTryOnEnabled;
  }
  set sessionTryOnEnabled(e) {
    this._sessionTryOnEnabled = e;
  }
  get tryOnInfoLoading() {
    return this._tryOnInfoLoading;
  }
  set tryOnInfoLoading(e) {
    this._tryOnInfoLoading = e;
  }
  // ShowHighlight
  get showHighlight() {
    return this._showHighlight;
  }
  set showHighlight(e) {
    this._showHighlight != e && (this._showHighlight = e);
  }
  // HighlightOver
  get highlightOver() {
    return this._highlightOver;
  }
  set highlightOver(e) {
    this._highlightOver != e && (this._highlightOver = e);
  }
  // HighlightOverColor
  get highlightOverColor() {
    return this._highlightOverColor;
  }
  set highlightOverColor(e) {
    this._highlightOverColor != e && (this._highlightOverColor = e);
  }
  // EditingMode
  get editingMode() {
    return this._editingMode;
  }
  set editingMode(e) {
    this._editingMode != e && this.setEditingMode(e);
  }
  // EditingControlVisible
  get editControlVisible() {
    return this._editControlVisible;
  }
  set editControlVisible(e) {
    this._editControlVisible != e && this.showHideEditControl(e);
  }
  get selectedProvider() {
    return this._pickedProvider;
  }
  get selectedProviderFineTuningData() {
    return this._providerData;
  }
  get modelMeasurements() {
    return this._modelMeasurements;
  }
  set modelMeasurements(e) {
    this._modelMeasurements = e;
  }
  get showMeasurements() {
    return this._showMeasurements;
  }
  fireHideMeasurementsEvent() {
    this._showMeasurements = !1;
  }
  fireShowMeasurementsEvent() {
    this._showMeasurements = !0;
  }
  static async createSceneEditorAsync(e) {
    const t = new fl(e);
    return await t.initAsync(), t.checkSceneSourceTasks(), t;
  }
  createCanvas() {
    const e = super.createCanvas();
    return e.addEventListener(
      "keydown",
      (t) => {
        this._shiftPressed = t.key == "Shift", this._ctrlPressed = t.key == "Control";
      },
      !1
    ), e.addEventListener(
      "keyup",
      (t) => {
        this._shiftPressed = t.key != "Shift", this._ctrlPressed = t.key != "Control";
      },
      !1
    ), e.addEventListener("dblclick", (t) => {
      this.setRenderingNeeded();
    }), e;
  }
  deleteComponents() {
    super.deleteComponents(), this._editControl && (this._editControl.detach(), this._editControl = null), this._lightsLayer && (this._lightsLayer.dispose(), this._lightsLayer = null), this._axesLayer && (this._axesLayer.dispose(), this._axesLayer = null);
  }
  dispose() {
    super.dispose(), this._incrementalFilesMaker && (this._incrementalFilesMaker.dispose(), delete this._incrementalFilesMaker), this._sceneToBlobs && (this._sceneToBlobs.dispose(), delete this._sceneToBlobs);
  }
  createEngine() {
    super.createEngine(), BABYLON.SceneLoader.ForceFullSceneLoadingForIncremental = !0;
  }
  async createEmptySceneAsync() {
    await super.createEmptySceneAsync(), this._engine && this.fireSceneCreatedEvent();
  }
  async setupSceneAsync() {
    var e;
    await super.setupSceneAsync(), this._engine && this._scene && (this._scene.setRenderingAutoClearDepthStencil(1, !0, !0, !1), this._scene.setRenderingAutoClearDepthStencil(2, !0, !0, !1), this._lightsLayer = new Uw(this), this._lightsLayer.addLightSelectedListener((t) => {
      this.lightsLayer_onLightSelected(t);
    }), (e = this._sceneHelper) == null || e.cleanUnusedMaterialsMappings(this._zkScene), this.addMaterialsUpdateListener(() => {
      var t;
      return (t = this._sceneHelper) == null ? void 0 : t.cleanUnusedMaterialsMappings(this._zkScene);
    }), this.setupAxes(), this._zkModel && this._meshLocationsManager && (this._meshLocationsManager.addBeforeSaveMeshLocationListener(() => this.onBeforeSaveMeshLocation()), this._meshLocationsManager.addAfterSaveMeshLocationListener(() => this.onAfterSaveMeshLocation())), this._scene.onPointerMove = (t, n) => this.onPointerMove(t, n));
  }
  render() {
    this.firePreUpdateEvent(), super.render(), this._lightsLayer && this._lightsLayer.render(), this._axesLayer && this._axesLayer.render(), this.firePostUpdateEvent();
  }
  deleteHighlightLayer() {
    this._highlightLayer && (this._highlightLayer.dispose(), this._highlightLayer = null), this.setRenderingNeeded();
  }
  setupHighlightLayerIntensity() {
    this._highlightLayer && (this._highlightLayer.blurHorizontalSize = this._highlightBlurHorizontalSize, this._highlightLayer.blurVerticalSize = this._highlightBlurVerticalSize);
  }
  setupAxes() {
    this._axesLayer = new Fw(this);
  }
  getMatchSameNameTextures() {
    if (this._zkScene) {
      let e = this._zkScene.getMatchSameNameTextures();
      return e ?? !1;
    }
    return !1;
  }
  setMatchSameNameTextures(e) {
    this._zkScene && this._zkScene.setMatchSameNameTextures(e);
  }
  getAREnabled() {
    let e = !1;
    if (this._zkScene) {
      let t = this._zkScene.getAREnabled();
      return t ?? e;
    }
    return e;
  }
  setAREnabled(e) {
    this._zkScene && this._zkScene.setAREnabled(e);
  }
  getAROnTheFly() {
    let e = !1;
    if (this._zkScene) {
      let t = this._zkScene.getAROnTheFly();
      return t ?? e;
    }
    return e;
  }
  setAROnTheFly(e) {
    this._zkScene && this._zkScene.setAROnTheFly(e);
  }
  setARAnchor(e) {
    this._zkScene && this._zkScene.setARAnchor(e);
  }
  getTryOnEnabled() {
    let e = !1;
    if (this._zkScene) {
      let t = this._zkScene.getTryOnEnabled();
      return t ?? e;
    }
    return e;
  }
  setTryOnEnabled(e) {
    this._zkScene && this._zkScene.setTryOnEnabled(e);
  }
  setTryOnSelectedType(e) {
    if (this._zkScene) {
      const t = this.getTryOnDefaultTypeSettings(), n = this._zkScene.getTryOnSettings() || t;
      n.type = e, this.setTryOnTypeSettings(n);
    }
  }
  setFrameDAMSettings(e) {
    this._zkScene && this._zkScene.setFrameDAMSettings(typeof e == "string" ? e : JSON.stringify(e));
  }
  getForceDracoCompression() {
    let e = !1;
    if (this._zkScene) {
      let t = this._zkScene.getForceDracoCompression();
      return t ?? e;
    }
    return e;
  }
  setForceDracoCompression(e) {
    this._zkScene && this._zkScene.setForceDracoCompression(e);
  }
  getWebPEnabled() {
    return this._zkScene ? this._zkScene.getWebPEnabled() : !1;
  }
  setWebPEnabled(e) {
    this._zkScene && this._zkScene.setWebPEnabled(e);
  }
  getWebPType() {
    return this._zkScene ? this._zkScene.getWebPType() : "Lossless";
  }
  setWebPType(e) {
    this._zkScene && this._zkScene.setWebPType(e);
  }
  getWebPQuality() {
    return this._zkScene ? this._zkScene.getWebPQuality() : 80;
  }
  setWebPQuality(e) {
    this._zkScene && this._zkScene.setWebPQuality(e);
  }
  setProvider(e) {
    this._pickedProvider = e;
  }
  setProviderFineTuningData(e) {
    this._providerData = {
      mesh: e.mesh ? e.mesh : this._providerData.mesh,
      settings: e.settings ? e.settings : this._providerData.settings
    };
  }
  resetProviderFineTuningData() {
    var e;
    (e = this._scene) == null || e.meshes.forEach((t) => {
      t.metadata && t.metadata.tryOnFineTuningSettings && (t.metadata.tryOnFineTuningSettings = null);
    }), this._providerData = {};
  }
  setMeshFineTuningData(e, t) {
    const n = typeof e == "string" ? this.getMeshByID(e) : e;
    n && (n.metadata || (n.metadata = {}), n.metadata.tryOnFineTuningSettings = t);
  }
  setDAMFineTuningData(e) {
    const t = {
      finetuning: e
    };
    this.setFrameDAMSettings(t);
  }
  getTryOnSelectedType() {
    if (this._zkScene) {
      let e = this._zkScene.getTryOnSettings();
      if (e && e.type)
        return e.type;
    }
    return null;
  }
  getTryOnSettings() {
    const e = this.getTryOnDefaultTypeSettings();
    if (this._zkScene) {
      let t = this._zkScene.getTryOnSettings();
      if (t)
        return t;
    }
    return e;
  }
  getTryOnSetting(e) {
    if (this._zkScene) {
      let t = this._zkScene.getTryOnSettings();
      if (t && e in t.typeSettings && t.typeSettings[e] && typeof t.typeSettings[e] == "boolean")
        return t.typeSettings[e];
    }
    return !1;
  }
  setTryOnSetting(e, t) {
    let n = this.getTryOnDefaultTypeSettings();
    if (this._zkScene) {
      let s = this._zkScene.getTryOnSettings();
      if (!s) {
        switch (e) {
          case Ds.GlassPupillaryDistanceTool:
          case Ds.VirtualTryOn:
          case Ds.MandatoryPupillaryDistance:
            n.typeSettings[e] = t;
            break;
          case Ds.StyleButton:
            n.styleButton = t;
        }
        this.setTryOnTypeSettings(n);
        return;
      }
      switch (e) {
        case Ds.GlassPupillaryDistanceTool:
          s.typeSettings.pd = t;
          break;
        case Ds.VirtualTryOn:
          s.typeSettings.try_on = t;
          break;
        case Ds.MandatoryPupillaryDistance:
          s.typeSettings.mandatoryPD = t;
          break;
        case Ds.StyleButton:
          s.styleButton = t;
          break;
      }
      s.typeSettings.pd && s.typeSettings.try_on || (s.styleButton = "single"), this._zkScene.setTryOnSettings(s);
    }
  }
  setTryOnTypeSettings(e) {
    this._zkScene && this._zkScene.setTryOnSettings(e);
  }
  getTryOnDefaultTypeSettings() {
    return {
      type: lg.NotSelected,
      styleButton: "single",
      buttonCustomizations: [
        {
          image: "base",
          textLabel: "Virtual Try-on",
          textColor: null,
          backgroundColor: null,
          borderColor: null,
          borderWidth: 0,
          borderRadius: 0
        }
      ],
      typeSettings: {
        try_on: !0,
        pd: !1,
        active: this.getTryOnEnabled() ?? !1
      }
    };
  }
  setTryOnDefaultTypeSettings() {
    let e = this.getTryOnDefaultTypeSettings();
    this.setTryOnTypeSettings(e);
  }
  getUseDelayedMaterialLoading() {
    let e = !1;
    if (this.zkScene) {
      let t = this.zkScene.getUseDelayedMaterialLoading();
      return t ?? e;
    }
    return e;
  }
  setUseDelayedMaterialLoading(e) {
    this._zkScene && this._zkScene.setUseDelayedMaterialLoading(e);
  }
  getUseDelayedTextureLoading() {
    if (this._zkScene) {
      let t = this._zkScene.getUseDelayedTextureLoading();
      return t ?? !1;
    }
    return !1;
  }
  setUseDelayedTextureLoading(e) {
    this._zkScene && this._zkScene.setUseDelayedTextureLoading(e);
  }
  getGlowEnabled() {
    return this._glowManager ? this._glowManager.enabled : !1;
  }
  setGlowEnabled(e) {
    this._glowManager && (this._glowManager.enabled = e, this.setRenderingNeeded());
  }
  getGlowIntensity() {
    return this._glowManager ? this._glowManager.intensity : 1;
  }
  setGlowIntensity(e) {
    this._glowManager && (this._glowManager.intensity = e, this.setRenderingNeeded());
  }
  getGlowBlurSize() {
    return this._glowManager ? this._glowManager.blurSize : 16;
  }
  setGlowBlurSize(e) {
    this._glowManager && (this._glowManager.blurSize = e, this.setRenderingNeeded());
  }
  getInfoPointsEnabled() {
    let e = !1;
    if (this._zkScene) {
      let t = this._zkScene.getInfoPointsEnabled();
      return t ?? e;
    }
    return e;
  }
  setInfoPointsEnabled(e) {
    this._zkScene && this._zkScene.setInfoPointsEnabled(e), this.refreshInfoPoints();
  }
  getInfoPointsBorderColor() {
    const e = "";
    if (this._zkScene) {
      const t = this._zkScene.getInfoPointsBorderColor();
      return t ?? e;
    }
    return e;
  }
  setInfoPointsBorderColor(e) {
    this._zkScene && (this._zkScene.setInfoPointsBorderColor(e), this.refreshInfoPoints());
  }
  getInfoPointsInnerPointColor() {
    const e = "";
    if (this._zkScene) {
      const t = this._zkScene.getInfoPointsInnerPointColor();
      return t ?? e;
    }
    return e;
  }
  setInfoPointsInnerPointColor(e) {
    this._zkScene && (this._zkScene.setInfoPointsInnerPointColor(e), this.refreshInfoPoints());
  }
  getInfoPointsColor() {
    const e = "";
    if (this._zkScene) {
      const t = this._zkScene.getInfoPointsColor();
      return t ?? e;
    }
    return e;
  }
  setInfoPointsColor(e) {
    this._zkScene && (this._zkScene.setInfoPointsColor(e), this.refreshInfoPoints());
  }
  getInfoPointsHighlightColor() {
    const e = "";
    if (this._zkScene) {
      const t = this._zkScene.getInfoPointsHighlightColor();
      return t ?? e;
    }
    return e;
  }
  setInfoPointsHighlightColor(e) {
    this._zkScene && (this._zkScene.setInfoPointsHighlightColor(e), this.refreshInfoPoints());
  }
  enableGlowForMesh(e) {
    this._glowManager && this._glowManager.enableGlowForMesh(e);
  }
  disableGlowForMesh(e) {
    this._glowManager && (this._glowManager.disableGlowForMesh(e), this.setRenderingNeeded());
  }
  enableARForMesh(e) {
    e && (e.metadata || (e.metadata = {}), e.metadata.AR = !0);
  }
  disableARForMesh(e) {
    e && (e.metadata || (e.metadata = {}), e.metadata.AR = !1);
  }
  disableTryOnForMesh(e) {
    e && (e.metadata || (e.metadata = {}), e.metadata.TryOn = !1, e.getChildMeshes().forEach((t) => this.disableTryOnForMesh(t)));
  }
  enableTryOnForMesh(e) {
    e && (e.metadata || (e.metadata = {}), e.metadata.TryOn = !0, e.getChildMeshes().forEach((t) => this.enableTryOnForMesh(t)));
  }
  enableInfoPointsForMesh(e) {
    e && (e.metadata || (e.metadata = {}), e.metadata.showInfoPoints = !0, this.refreshInfoPoints());
  }
  disableInfoPointsForMesh(e) {
    e && e.metadata && e.metadata.showInfoPoints !== void 0 && e.metadata.showInfoPoints !== null && (delete e.metadata.showInfoPoints, this.refreshInfoPoints());
  }
  enableForcedInfoPointsVisibilityOnMesh(e) {
    e && (e.metadata || (e.metadata = {}), e.metadata.forceShowInfoPoints = !0, this.refreshInfoPoints());
  }
  disableForcedInfoPointsVisibilityOnMesh(e) {
    e && e.metadata && e.metadata.forceShowInfoPoints !== void 0 && e.metadata.forceShowInfoPoints !== null && (delete e.metadata.forceShowInfoPoints, this.refreshInfoPoints());
  }
  setEditorBackgroundColor(e) {
    this._editorBackgroundColor = e, this.refreshEnvironment();
  }
  setViewerBackgroundAlpha(e) {
    this._zkScene && (this._zkScene.getOrCreateGeneralConfig().set("backgroundAlpha", e), this.refreshEnvironment());
  }
  setViewerBackgroundColor(e) {
    this._zkScene && (this._zkScene.getOrCreateGeneralConfig().set("backgroundColor", e), this.refreshEnvironment());
  }
  setViewerEnvironmentSizeAuto(e) {
    this._zkScene && (this._zkScene.getOrCreateEnvironmentConfig().set("sizeAuto", e), this.refreshEnvironment());
  }
  setViewerEnvironmentMainColor(e) {
    this._zkScene && (this._zkScene.getOrCreateEnvironmentConfig().set("mainColor", e), this.refreshEnvironment());
  }
  setViewerSkyboxCreateSkybox(e) {
    this._zkScene && (this._zkScene.getOrCreateSkyboxConfig().set("createSkybox", e), this.refreshEnvironment());
  }
  setViewerSkyboxSize(e) {
    this._zkScene && (this._zkScene.getOrCreateSkyboxConfig().set("size", e), this.refreshEnvironment());
  }
  setViewerSkyboxBlur(e) {
    if (this._zkScene) {
      let t = e >= 0 ? e : 0;
      this._zkScene.getOrCreateSkyboxConfig().set("blur", t), this.refreshEnvironment();
    }
  }
  setViewerSkyboxTexture(e, t, n) {
    if (this._zkScene && e != null && typeof e == "string") {
      const s = this._zkScene.getOrCreateSkyboxConfig();
      s.set("texture", e), s.set("extensions", t), s.set("files", n), this.refreshEnvironment();
    }
  }
  removeViewerSkyboxTexture() {
    if (this._zkScene) {
      const e = this._zkScene.getSkyboxConfig();
      e && e.get("texture") != null && (e.unset("texture"), this.refreshEnvironment());
    }
  }
  setViewerSkyboxColor(e) {
    this._zkScene && e != null && typeof e == "string" && (this._zkScene.getOrCreateSkyboxConfig().set("color", e), this.refreshEnvironment());
  }
  setViewerGroundCreateGround(e) {
    this._zkScene && e != null && typeof e == "boolean" && (this._zkScene.getOrCreateGroundConfig().set("createGround", e), this.refreshEnvironment());
  }
  setViewerGroundSize(e) {
    this._zkScene && (this._zkScene.getOrCreateGroundConfig().set("size", e), this.refreshEnvironment());
  }
  setViewerGroundTexture(e) {
    this._zkScene && e != null && typeof e == "string" && (this._zkScene.getOrCreateGroundConfig().set("texture", e), this.refreshEnvironment());
  }
  removeViewerGroundTexture() {
    if (this._zkScene) {
      const e = this._zkScene.getGroundConfig();
      e && e.get("texture") != null && (e.unset("texture"), this.refreshEnvironment());
    }
  }
  setViewerGroundColor(e) {
    this._zkScene && e != null && typeof e == "string" && (this._zkScene.getOrCreateGroundConfig().set("color", e), this.refreshEnvironment());
  }
  setViewerGroundOpacity(e) {
    this._zkScene && e != null && typeof e == "number" && (this._zkScene.getOrCreateGroundConfig().set("opacity", e), this.refreshEnvironment());
  }
  setViewerGroundEnableShadow(e) {
    this._zkScene && e != null && typeof e == "boolean" && (this._zkScene.getOrCreateGroundConfig().set("enableShadow", e), this.refreshEnvironment());
  }
  setViewerGroundShadowLevel(e) {
    this._zkScene && e != null && typeof e == "number" && (this._zkScene.getOrCreateGroundConfig().set("shadowLevel", e), this.refreshEnvironment());
  }
  setViewerGroundEnableMirror(e) {
    this._zkScene && e != null && typeof e == "boolean" && (this._zkScene.getOrCreateGroundConfig().set("enableMirror", e), this.refreshEnvironment());
  }
  setViewerGroundMirrorBlur(e) {
    this._zkScene && e != null && typeof e == "number" && (this._zkScene.getOrCreateGroundConfig().set("mirrorBlurKernel", e), this.refreshEnvironment());
  }
  setViewerCameraAutoRotate(e) {
    this._zkScene && e != null && typeof e == "boolean" && (this._zkScene.getOrCreateCameraConfig().set("autoRotate", e), this.autoRender = e, this.refreshEnvironment());
  }
  setViewerCameraContrast(e) {
    this._zkScene && e != null && typeof e == "number" && (this._zkScene.getOrCreateCameraConfig().set("contrast", e), this.refreshEnvironment());
  }
  setViewerCameraExposure(e) {
    this._zkScene && e != null && typeof e == "number" && (this._zkScene.getOrCreateCameraConfig().set("exposure", e), this.refreshEnvironment());
  }
  setViewerCameraUpperAlphaLimit(e) {
    var t;
    if (this._zkScene && e != null && typeof e == "number") {
      const s = this._zkScene.getOrCreateCameraConfig().get("lowerAlphaLimit");
      this._zkScene.setCameraUpperAlphaLimit(Math.max(e, s ?? e)), (t = this._sceneHelper) == null || t.setCameraUpperAlphaLimit(Math.max(e, s ?? e)), this.setRenderingNeeded();
    }
  }
  setViewerCameraLowerAlphaLimit(e) {
    var t;
    if (this._zkScene && e != null && typeof e == "number") {
      const s = this._zkScene.getOrCreateCameraConfig().get("upperAlphaLimit");
      this._zkScene.setCameraLowerAlphaLimit(Math.min(e, s ?? e)), (t = this._sceneHelper) == null || t.setCameraLowerAlphaLimit(Math.min(e, s ?? e)), this.setRenderingNeeded();
    }
  }
  setViewerCameraLowerBetaLimit(e) {
    var t;
    if (this._zkScene && e != null && typeof e == "number") {
      const s = this._zkScene.getOrCreateCameraConfig().get("upperBetaLimit");
      this._zkScene.setCameraLowerBetaLimit(Math.min(e, s ?? e)), (t = this._sceneHelper) == null || t.setCameraLowerBetaLimit(Math.min(e, s ?? e)), this.setRenderingNeeded();
    }
  }
  setViewerCameraUpperBetaLimit(e) {
    var t;
    if (this._zkScene && e != null && typeof e == "number") {
      const s = this._zkScene.getOrCreateCameraConfig().get("lowerBetaLimit");
      this._zkScene.setCameraUpperBetaLimit(Math.max(e, s ?? e)), (t = this._sceneHelper) == null || t.setCameraUpperBetaLimit(Math.max(e, s ?? e)), this.setRenderingNeeded();
    }
  }
  setViewerCameraToneMappingEnabled(e) {
    this._zkScene && e != null && typeof e == "boolean" && (this._zkScene.getOrCreateCameraConfig().set("toneMappingEnabled", e), this.refreshEnvironment());
  }
  serializeFromVector(e) {
    return e ? { x: e.x, y: e.y, z: e.z } : null;
  }
  setModelTransformsFromDAMMesh() {
    var s, o, h;
    const t = (((s = this._scene) == null ? void 0 : s.meshes) || []).find(
      (c) => !c.parent && c.name && !c.name.startsWith("__") && c.getChildMeshes().length > 0
    ), n = t || this.getDAMMainMesh();
    if (n) {
      const c = n.position, _ = n.rotation, x = n.scaling;
      console.log("Reading transforms from:", {
        source: t ? "parent node" : "child mesh",
        nodeName: n.name,
        originalScale: { x: x.x, y: x.y, z: x.z }
      });
      const B = new BABYLON.Vector3(Math.abs(x.x), Math.abs(x.y), Math.abs(x.z));
      console.log("Normalized scale:", { x: B.x, y: B.y, z: B.z });
      const P = (o = this._zkScene) == null ? void 0 : o.getOrCreateModelConfig();
      P.set("position", this.serializeFromVector(c)), P.set("rotation", this.serializeFromVector(_)), P.set("scale", this.serializeFromVector(B));
      const U = this.getFrameDAMSettings();
      U && ((h = this._zkScene) == null || h.setFrameDAMSettings(JSON.stringify(U)));
    } else
      console.warn("No transform source found for DAM model");
  }
  resetEditorEnvironment() {
    this.resetEditorBackground(), this.resetEditorCamera(), this.setRenderingNeeded();
  }
  resetEditorBackground() {
    this._scene && (this._scene.clearColor = BABYLON.Color3.FromHexString(this._editorBackgroundColor).toColor4(), this.refreshGround(), this.setRenderingNeeded());
  }
  resetEditorCamera() {
    if (this._scene) {
      const e = this._scene.activeCamera;
      e instanceof BABYLON.ArcRotateCamera && (e.useAutoRotationBehavior = !1), this._autoRender = !1, this.setRenderingNeeded();
    }
  }
  preSceneContentScreenshot() {
    this.resetEditorEnvironment(), this.removeGround();
  }
  postSceneContentScreenshot() {
  }
  preSceneMaterialScreenshot() {
    super.preSceneMaterialScreenshot(), this.adjustSceneForSerialization();
  }
  postSceneMaterialScreenshot() {
    super.postSceneMaterialScreenshot();
  }
  sceneReadyForSave() {
    if (this._scene) {
      for (let e = 0; e < this._scene.meshes.length; e++)
        if (!this._scene.meshes[e].isReady())
          return !1;
    }
    return !0;
  }
  isCurrentCameraPivot(e) {
    if (this._sceneHelper) {
      const t = this._sceneHelper.getCameraPivot();
      return t && t.id === e;
    }
    return !1;
  }
  getCurrentCameraPivotID() {
    if (this._scene && this._sceneHelper) {
      const e = this._sceneHelper.getCameraPivot();
      if (e) {
        const t = this._scene.getMeshByID(e.id);
        if (t)
          return t.id;
      }
    }
    return null;
  }
  // Riscritta quella di SceneViewer perché viene salvata l'informazione
  // sul nuovo pivot, non solo modifcato il punto di vista
  setCameraPivot(e) {
    if (this._scene && this._sceneHelper) {
      for (let n = 0; n < this._scene.meshes.length; n++) {
        var t = this._scene.meshes[n];
        t.metadata && t.metadata.isCameraPivot != null && delete t.metadata.isCameraPivot;
      }
      if (e) {
        const n = this._scene.getMeshByID(e);
        n && (n.metadata = n.metadata || {}, n.metadata.isCameraPivot = !0), this._sceneHelper.setCameraPivot(n || null);
      } else
        this._sceneHelper.setCameraPivot(null);
    }
  }
  // --------------------------------------------------------
  // Funzioni per il salvataggio della scena
  // --------------------------------------------------------
  async getBlobFromEmbeddedTextureAsync(e) {
    let t = null;
    if (e.url) {
      const h = e.url;
      var n = h.substring(0, 5) === "data:", s = h.substring(0, 5) === "blob:", o = n && h.indexOf(";base64,") !== -1;
      if (n && e._buffer && (e._buffer instanceof ArrayBuffer || e._buffer instanceof Uint8Array || e._buffer instanceof Blob))
        e._buffer instanceof Blob ? t = e._buffer : e._buffer instanceof Uint8Array ? t = new Blob([e._buffer], { type: e.mimeType }) : e._buffer instanceof ArrayBuffer && (t = new Blob([new Uint8Array(e._buffer)], { type: e.mimeType }));
      else if (s)
        await new Promise((c) => {
          var _ = new XMLHttpRequest();
          _.open("GET", h, !0), _.responseType = "blob", _.onload = function(x) {
            this.status == 200 && c(this.response);
          }, _.send();
        });
      else if (o) {
        const c = new Uint8Array(BABYLON.Tools.DecodeBase64(h));
        t = new Blob([c], { type: e.mimeType });
      }
    }
    return t;
  }
  async uploadEmbeddedTexturesAsync(e) {
    const t = [];
    if (this._zkScene && this._scene && this._sceneHelper) {
      this._scene, this._zkScene;
      const n = this._sceneHelper;
      this.getAllMaterials().forEach((o) => {
        o.getActiveTextures().filter((c) => c instanceof BABYLON.Texture).forEach((c) => {
          if (c.url) {
            var _ = c.url.substring(0, 5) === "data:", x = c.url.substring(0, 5) === "blob:", B = _ && c.url.indexOf(";base64,") !== -1;
            if (_ || x || B) {
              const P = n.getMaterialTextureType(o, c);
              P && t.push({
                texture: c,
                material: o,
                type: P
              });
            }
          }
        });
      });
    }
    for (let n = 0; n < t.length; n++) {
      const s = t[n], o = s.texture, h = await this.getBlobFromEmbeddedTextureAsync(o);
      if (h) {
        let c = ".png";
        o.mimeType === "image/jpeg" && (c = ".jpg");
        const x = `${s.type.replace(" ", "_")}${c}`;
        let B = new File([h], x);
        const P = await this.uploadTextureFileAsync(B, s.material);
        if (P) {
          const U = P.get("url");
          U && await new Promise((M, Z) => {
            o.updateURL(
              U,
              void 0,
              () => M(),
              void 0,
              () => Z()
            );
          });
        }
        e && e(n / t.length * 100, "textures");
      }
    }
  }
  useIncrementalLoading() {
    if (this._sceneHelper) {
      const e = this._sceneHelper.getTotalVertices(), t = this._sceneHelper.getTotalIndices();
      if (e + t >= 1e3)
        return !0;
    }
    return !1;
  }
  // Prepara il modello backbone zkScene per il salvataggio. Nel dettaglio:
  // 1. Esegue lo screenshot della scena e imposta i byte nel modello zkScene
  // 2. Recupera il JSON della scena da Babylon JS.
  // 3. Esegue l'upload del file in modo che possa essere salvato nel percorso previsto per la scena corrente.
  // 4. Aggiorna il modello impostando i dati relativi al file "uploadato" (essenzialmente il fileObject)
  updateSceneModel(e, t, n, s) {
    if (this._zkScene && this._scene) {
      this._scene;
      const o = this._zkScene;
      this.resetRealVisibility();
      const h = this.infoPointsShown;
      h && this.hideInfoPoints(), this.uploadEmbeddedTexturesAsync((c, _) => {
        n && n(c, _);
      }).then(() => {
        this.getSceneScreenshotAsync(500, 450).then((c) => {
          h && this.showInfoPoints(), o.set("imageData", c), o.set("version", o.get("version") + 1);
          var _ = this.useIncrementalLoading();
          _ ? this.uploadSceneIncrementalFiles(
            (x) => {
              this.onUploadScenFileSuccess(x), e && e();
            },
            (x) => {
              t && t(x);
            },
            (x) => {
              n && n(x);
            },
            s
          ) : this.uploadSceneFile(
            (x) => {
              this.onUploadScenFileSuccess(x), e && e();
            },
            (x) => {
              t && t(x);
            },
            (x, B) => {
              n && n(x, B);
            }
          );
        });
      }).catch((c) => {
        t && t(c);
      });
    }
  }
  // Aggiorna il modello con i dati sul file di scena salvato
  onUploadScenFileSuccess(e) {
    this._zkScene && e && (e.hasOwnProperty("fileObjectID") || e.hasOwnProperty("fileLength")) && e.hasOwnProperty("rootUrl") && e.hasOwnProperty("sceneFileName") && (e.hasOwnProperty("manifestFileObjectID") || e.hasOwnProperty("manifestFileLength")) && (e.hasOwnProperty("incrementalsFileObjectID") || e.hasOwnProperty("incrementalsFileLength")) ? (this._zkScene.set("fileObjectID", e.fileObjectID), this._zkScene.set("fileLength", e.fileLength), this._zkScene.set("url", e.url), this._zkScene.set("rootUrl", e.rootUrl), this._zkScene.set("sceneFileName", e.sceneFileName), this._zkScene.set("manifestFileObjectID", e.manifestFileObjectID), this._zkScene.set("manifestFileLength", e.manifestFileLength), this._zkScene.set("manifestFileUrl", e.manifestFileUrl), this._zkScene.set("incrementalsFileObjectID", e.incrementalsFileObjectID), this._zkScene.set("incrementalsFileLength", e.incrementalsFileLength), this._zkScene.set("incrementalsFileUrl", e.incrementalsFileUrl)) : Logger.info("le informazioni sul file di scena salvato sono vuote o incorrette");
  }
  uploadSceneFile(e, t, n) {
    if (!this._scene || !this._zkScene) {
      t && t("No scene to upload");
      return;
    }
    this._scene;
    const s = this._zkScene, o = s.get("version"), h = this.getSceneJson();
    this.getSceneFileBlobsAsync(h, o, (c) => {
      n && n(c, "optimize");
    }).then((c) => {
      const _ = new FormData();
      for (let x = 0; x < c.length; x++) {
        const B = c[x];
        _.append("file_" + x, B.blob, B.name);
      }
      fetch(s.getSceneIncrementalFileUploadUrl(), {
        method: "POST",
        body: _,
        headers: {
          Authorization: "Bearer " + this._authorizationToken
        }
      }).then((x) => {
        if (!x.ok)
          throw new Error("HTTP error " + x.status);
        return x.json();
      }).then((x) => {
        e && e(x);
      }).catch((x) => {
        t && t(x.message);
      });
    });
  }
  async getSceneFileBlobsAsync(e, t, n) {
    let s = [];
    return this._sceneToBlobs || (this._sceneToBlobs = new Nw(this._incrementalWorkersScriptsUrls)), this._sceneToBlobs && (await this._sceneToBlobs.whenReadyAsync(), s = await this._sceneToBlobs.getSceneBlobsAsync(e, t, n)), s;
  }
  // Serializza in JSON la scena Babylon JS
  getSceneJson() {
    var t;
    let e = "";
    if (this._scene && this._sceneHelper) {
      const n = this._envMode;
      this.setEnvironmentMode(Er.Editor), this.disableAntialiasing(!0);
      const s = this.resetCameraRotationLimits();
      this.deleteHighlightLayer();
      const o = this._manipulatedNode;
      this.setManipulatedNode(null), this.getUseMaterialOffloading() && !this.getUseDelayedMaterialLoading() && this._sceneHelper.offloadAllUnusedMaterials(), this._sceneHelper.setDummyMaterialToInvisibleMeshes(), this.adjustSceneForSerialization();
      const h = BABYLON.SceneSerializer.Serialize(this._scene);
      if (h.postProcesses = [], e = JSON.stringify(h), this.getUseMaterialOffloading() && !this.getUseDelayedMaterialLoading()) {
        const c = (t = this._zkScene) == null ? void 0 : t.get("rootUrl");
        c && this._sceneHelper.loadAllOffloadedMaterials(c);
      }
      this._sceneHelper.unsetAllDummyMaterials(), n != Er.Editor && this.setEnvironmentMode(n), this.enableAntialiasing(), this.createHighlightLayer(), this.setManipulatedNode(o), this.setCameraRotationLimits(s);
    }
    return e;
  }
  resetCameraRotationLimits() {
    const e = {
      lowerAlphaLimit: null,
      upperAlphaLimit: null,
      lowerBetaLimit: null,
      upperBetaLimit: null
    };
    return this._camera && this._camera instanceof BABYLON.ArcRotateCamera && (e.lowerAlphaLimit = this._camera.lowerAlphaLimit, e.upperAlphaLimit = this._camera.upperAlphaLimit, e.lowerBetaLimit = this._camera.lowerBetaLimit, e.upperBetaLimit = this._camera.upperBetaLimit, this._camera.lowerAlphaLimit = null, this._camera.upperAlphaLimit = null, this._camera.lowerBetaLimit = 0.01, this._camera.upperBetaLimit = Math.PI - 0.01), e;
  }
  setCameraRotationLimits(e) {
    e = e || {
      lowerAlphaLimit: null,
      upperAlphaLimit: null,
      lowerBetaLimit: 0.01,
      upperBetaLimit: Math.PI - 0.01
    }, this._camera && this._camera instanceof BABYLON.ArcRotateCamera && (this._camera.lowerAlphaLimit = e.lowerAlphaLimit, this._camera.upperAlphaLimit = e.upperAlphaLimit, this._camera.lowerBetaLimit = e.lowerBetaLimit || 0.01, this._camera.upperBetaLimit = e.upperBetaLimit || Math.PI - 0.01);
  }
  // Metodo fondamentale per modificare gli url delle texture ed eliminare le
  // le texture non più utilizzate. In fase di caricamento della scena, Babylon JS
  // risolve il nome delle texture in base al path della scena. Quindi gli url delle
  // texture vanno, se necessario, trasformanti in path relativi.
  adjustSceneForSerialization() {
    if (this._scene && this._sceneHelper && this._zkScene) {
      const e = this._sceneHelper;
      this.removeDisabledFresnelParameters();
      let t = !1;
      this._zkScene.getUseDelayedTextureLoading() != null && (t = this._zkScene.getUseDelayedTextureLoading()), this._scene.useDelayedTextureLoading = t;
      const n = this.getMatchSameNameTextures(), s = this._zkScene.getSourcesIDs();
      this._zkScene.getLibraryMaterialIDs();
      const o = {}, h = [], c = [], _ = [], x = e.getTextureUrl(this._scene.environmentTexture), B = x !== null && x.endsWith(ci.Environment.EnvironmentTextureName);
      if (this._zkScene.set("useDefaultEnvironmentTexture", B), this._scene.environmentTexture && (this._scene.environmentTexture instanceof BABYLON.CubeTexture || this._scene.environmentTexture instanceof BABYLON.HDRCubeTexture)) {
        const D = this._scene.environmentTexture.rotationY;
        this._scene.metadata || (this._scene.metadata = {}), this._scene.metadata.environmentTextureRotationY = D;
      }
      this._scene.textures.forEach((D) => {
        var ee, le;
        if (!e.isTextureWithUrl(D))
          return;
        let te = D.url;
        if (D.getInternalTexture) {
          const fe = D.getInternalTexture();
          fe && fe.url && (te = fe.url);
        }
        if (te) {
          let fe = te;
          if (fe === ci.Environment.EnvironmentTextureCDNUrl) {
            D.url = "textures/" + Zakeke.getEmptyUUID().replace(/-/g, "") + "/" + ci.Environment.EnvironmentTextureName, D.name = D.url;
            return;
          }
          if (fe == ci.Environment.SkyboxTextureCDNUrl || fe == ci.Environment.GroundTextureCDNUrl)
            return;
          let X = !1;
          fe.startsWith("blob:") && D.metadata && D.metadata.fileUrl && (fe = D.metadata.fileUrl);
          for (let ke = 0; ke < s.length; ke++) {
            let Ye = s[ke].replace(/-/g, ""), pt = fe.indexOf(Ye);
            if (pt != -1) {
              X = !0, D.name = fe.substring(pt), D.url = D.name, Logger.info("texture url: " + D.url);
              break;
            }
          }
          let W = !1;
          const je = this._zkScene.get("rootUrl") || "";
          if (D.materialMapping) {
            W = !0;
            const ke = ((le = (ee = D.name) == null ? void 0 : ee.split("/")) == null ? void 0 : le.pop()) || D.name, Ye = D.materialMapping, pt = Ye.libraryMaterialID.replace(/-/g, ""), Le = Ye.sceneMaterialID.replace(/-/g, "");
            D.url = `textures/${Le}/${ke}`, D.name = D.url;
            const $e = `textures/${pt}/${ke}`;
            if (oa(h, $e) || h.push($e), D.metadata && D.metadata.mobileUrl) {
              const ht = D.metadata.mobileUrl.split("/").pop();
              D.metadata.mobileUrl = `${je}textures/${Le}/${ht}`;
              const De = `textures/${pt}/${ht}`;
              oa(h, De) || h.push(De);
            }
          }
          if (!X && !W) {
            const ke = this.extractTextureNameAndUrl(fe, n, o);
            if (ke.url && ke.name && (D.url = ke.url, D.name = ke.name, oa(h, D.url) || h.push(D.url)), D.metadata && D.metadata.mobileUrl && D.materialMapping) {
              const Ye = this.extractTextureNameAndUrl(
                D.metadata.mobileUrl,
                n,
                o
              );
              Ye.url && Ye.name && (D.metadata.mobileUrl = Ye.url, oa(h, D.metadata.mobileUrl) || h.push(D.metadata.mobileUrl), oa(_, D.metadata.mobileUrl) || _.push(D.metadata.mobileUrl), oa(c, D.url) || c.push(D.url));
            }
          }
        }
      });
      const P = ["px", "py", "pz", "nx", "ny", "nz"], U = (D) => {
        let te = D.lastIndexOf("."), ee = D;
        if (te !== -1) {
          let le = D.substring(0, te);
          for (let fe = 0; fe < P.length; fe++) {
            const X = P[fe];
            if (te = le.lastIndexOf("_" + X), te != -1) {
              ee = le.substring(0, te);
              break;
            }
          }
        }
        return ee;
      }, M = (D) => {
        const te = U(D);
        for (let ee = 0; ee < h.length; ee++) {
          const le = h[ee];
          if (te.endsWith(le))
            return !0;
        }
        return !1;
      }, Z = (D) => {
        const te = U(D);
        for (let ee = 0; ee < c.length; ee++) {
          const le = c[ee];
          if (te.endsWith(le))
            return !0;
        }
        return !1;
      }, F = (D) => {
        const te = U(D);
        for (let ee = 0; ee < _.length; ee++) {
          const le = _[ee];
          if (te.endsWith(le))
            return !0;
        }
        return !1;
      }, Q = [];
      for (let D = 0; D < this._zkScene.get("textures").length; D++) {
        const te = this._zkScene.get("textures").at(D), ee = te.get("url");
        ee && M(ee) ? Z(ee) ? te.set("usage", Zakeke.TextureUsage.Desktop) : F(ee) ? te.set("usage", Zakeke.TextureUsage.Mobile) : te.set("usage", Zakeke.TextureUsage.Any) : Q.push(te);
      }
      Q.length > 0 && this._zkScene.get("textures").remove(Q), this._zkScene.set("usedTextureUrls", h);
    }
  }
  // Metodo da usare per le texture caricate dall'utente, per trasformre il percorso assoluto
  // del tipo ..../textures/{ materialID }/{filename.xxx} nel percorso relativo textures/{materialID}/{filename.xxx}
  // Utilizza ed aggiorna eventualmente un dictionary per riutilizzare lo stesso percorso a parità di nome
  extractTextureNameAndUrl(e, t, n) {
    const s = { name: "", url: "" };
    let o = e.lastIndexOf("/");
    if (o !== -1) {
      const h = e.substring(o + 1);
      if (n.hasOwnProperty(h))
        s.url = n[h], s.name = s.url;
      else if (o = e.lastIndexOf("/", o - 1), o !== -1 && (o = e.lastIndexOf("/", o - 1), o !== -1)) {
        const c = e.substring(o + 1);
        s.url = c, s.name = c, t && (n[h] = c);
      }
    }
    return s;
  }
  removeDisabledFresnelParameters() {
    const e = function(t) {
      return t && t.isEnabled != null && !t.isEnabled && t.leftColor != null && t.leftColor != null && t.leftColor instanceof BABYLON.Color3 && t.leftColor.equals(BABYLON.Color3.White()) && t.rightColor != null && t.rightColor != null && t.rightColor instanceof BABYLON.Color3 && t.rightColor.equals(BABYLON.Color3.Black()) && t.bias != null && t.bias == 0 && t.power != null && t.power == 1;
    };
    this._scene && this._scene.materials.forEach(function(t) {
      t instanceof BABYLON.StandardMaterial ? (t.diffuseFresnelParameters && e(t.diffuseFresnelParameters) && (t.diffuseFresnelParameters = new BABYLON.FresnelParameters(), t.diffuseFresnelParameters.isEnabled = !1), t.emissiveFresnelParameters && e(t.emissiveFresnelParameters) && (t.emissiveFresnelParameters = new BABYLON.FresnelParameters(), t.emissiveFresnelParameters.isEnabled = !1), t.opacityFresnelParameters && e(t.opacityFresnelParameters) && (t.opacityFresnelParameters = new BABYLON.FresnelParameters(), t.opacityFresnelParameters.isEnabled = !1), t.reflectionFresnelParameters && e(t.reflectionFresnelParameters) && (t.reflectionFresnelParameters = new BABYLON.FresnelParameters(), t.reflectionFresnelParameters.isEnabled = !1), t.refractionFresnelParameters && e(t.refractionFresnelParameters) && (t.refractionFresnelParameters = new BABYLON.FresnelParameters(), t.refractionFresnelParameters.isEnabled = !1)) : t instanceof BABYLON.PBRMaterial || t instanceof Zakeke.PBRMaterial && t.opacityFresnelParameters && e(t.opacityFresnelParameters) && (t.opacityFresnelParameters = void 0);
    });
  }
  // Versione che utilizza un webworker (incapsulato in IncrementalFiles) per produrre i file incrementali (ed eventualmente
  // codificarli con Draco). In futuro si potrebbe convertire in async.
  uploadSceneIncrementalFiles(e, t, n, s) {
    if (!this._scene || !this._zkScene || !this._sceneHelper) {
      t && t("No scene to upload");
      return;
    }
    const o = this._zkScene, h = this._sceneHelper;
    let c = o.get("version"), _ = this.envMode;
    this.setEnvironmentMode(Er.Editor), this.disableAntialiasing(!0);
    let x = this.resetCameraRotationLimits();
    this.deleteHighlightLayer(), this.adjustSceneForSerialization(), h.setDummyMaterialToInvisibleMeshes();
    let B = this.getUseDelayedMaterialLoading(), P = this.getUseMaterialOffloading(), U = {}, M = {};
    B ? this.getAllMaterials().forEach((D) => {
      const te = this.getMeshesUsingMaterial(D.id);
      D.id !== "default material" && te.length === 0 && (U[D.id] = {
        name: D.name,
        file: "material_" + c + "_" + D.id.replace(/[^a-z0-9]/gi, "_").toLowerCase() + ".json"
      });
    }) : P && this.getAllMaterials().forEach((D) => {
      const te = this.getMeshesUsingMaterial(D.id);
      D.id !== "default material" && te.length === 0 && (M[D.id] = h.getOffloadedMaterialInfo(D));
    }), this._scene.metadata || (this._scene.metadata = {}), this._scene.metadata.offloadedMaterials = M, this._scene.metadata.delayedMaterials = U;
    let Z = BABYLON.SceneSerializer.Serialize(this._scene);
    if (Z.postProcesses = [], Z.metadata && Z.metadata.originalMeshMaterials) {
      const Q = JSON.parse(JSON.stringify(Z.metadata.originalMeshMaterials));
      h.unsetAllDummyMaterials(), Z.metadata.originalMeshMaterials = Q;
    }
    const F = {
      useDraco: this._dracoEnabled,
      forceDraco: o.getForceDracoCompression() ?? !1,
      dracoEncodingSpeed: this._dracoEncodingSpeed,
      dracoDecodingSpeed: this._dracoDecodingSpeed,
      excludedMeshes: [],
      delayMatarialLoading: Object.keys(U),
      offloadedMaterialIDs: Object.keys(M)
    };
    console.log(F), this.getSceneIncrementalFilesAsync(c, Z, F, n).then(
      (Q) => {
        let D = new FormData();
        for (let ee = 0; ee < Q.length; ee++) {
          const le = Q[ee];
          let fe = le.name, X = le.data, W = !1;
          !le.dracoEncoded && le.data.length > 180 && le.data.length < 45e4 && (Logger.info("Uncompressed file length: " + le.data.length), X = LZString.compressToUint8Array(le.data), Logger.info("Compressed file length: " + X.length), fe = "compressed_" + le.name, W = !0);
          let je;
          if (!le.dracoEncoded && !W)
            je = new Blob([X], { type: "text/plain" });
          else {
            var te = X.buffer;
            je = new Blob([te]);
          }
          D.append("file_" + ee, je, fe);
        }
        fetch(o.getSceneIncrementalFileUploadUrl(), {
          method: "POST",
          headers: {
            Authorization: "Bearer " + this._authorizationToken
          },
          body: D
        }).then((ee) => {
          if (!ee.ok)
            throw new Error("HTTP error " + ee.status);
          return ee.json();
        }).then((ee) => {
          e && e(ee);
        }).catch(function(ee) {
          t && t(ee.message);
        }), _ != Er.Editor && this.setEnvironmentMode(_), this.enableAntialiasing(), this.createHighlightLayer(), this.setCameraRotationLimits(x);
      }
    );
  }
  // Utilizza il web worker MakeIncrementalFiles per ottenere i file incrementali (eventualmente codificati con Draco)
  async getSceneIncrementalFilesAsync(e, t, n, s) {
    let o = [];
    return this._incrementalFilesMaker || (this._incrementalFilesMaker = new fw(this._incrementalWorkersScriptsUrls)), this._incrementalFilesMaker && (await this._incrementalFilesMaker.whenReadyAsync(), o = await this._incrementalFilesMaker.getIncrementalFilesAsync(t, e, n)), o;
  }
  // Fine funzioni salvataggio scena
  // --------------------------------------------------------
  async setNewSceneModelAsync(e, t) {
    this._zkModel = e, this._zkScene = t, await this.init3DEngineAsync(), this.fireMeshesUpdateEvent(), this.fireMaterialsUpdateEvent(), this.fireLightsUpdateEvent(), this.fireCameraLocationsUpdateEvent();
  }
  getSceneConfig() {
    var e;
    return ((e = this._zkScene) == null ? void 0 : e.getSceneConfig()) ?? null;
  }
  preSceneFileLoading() {
    this.resetRealVisibility();
  }
  postSceneFileLoading() {
    this.fireSceneCreatedEvent(), this.fireMeshesUpdateEvent(), this.fireMaterialsUpdateEvent(), this.fireLightsUpdateEvent(), this.fireCameraLocationsUpdateEvent();
  }
  // ==============================================================================
  // Importazione Assets
  // ==============================================================================
  // I file "uploadati" dall'utente non vengono caricati immediatamente nella scena
  // ma viene creato un task di elaborazione lato server il cui stato verrà controllato tramite polling.
  // Per ogni task server di caricamento verrà creato un oggetto task lato client che è utile
  // per il recupero tramite polling delle informazioni.
  // I task lato client avranno uno degli stati:
  //   uploading         - Task avviato per l'uploading dei file
  //   progress          - Task in elaborazione
  //   checking          - Chimata Ajax di controllo stato in corso
  //   success           - Task server completato con successo, si possono importare i relativi file nella scena Babylon JS corrente
  //   completed_success - Task eseguito correttamente e file importati nella scena Babylon JS
  //   completed_error   - Task in errore, può essere eliminato dalla lista dei task da controllare
  loadSceneSourceFiles(e, t, n, s) {
    if (this._zkScene) {
      const x = this._zkScene, B = new FormData();
      if (t)
        B.append("url", t);
      else if (e) {
        for (let D = 0; D < e.length; D++)
          B.append("file-" + D, e[D]);
        var o = this._zkScene.getTexturesConfig();
        if (o) {
          var h = new Zakeke.SceneSourceTaskOptions();
          h.set("textures", o);
          var c = JSON.stringify(h), _ = new Blob([c], {
            type: "application/json"
          });
          B.append("task-options", _, "task-options.json");
        }
      }
      const P = {
        downloadProgress: 0,
        uploadProgress: 0,
        status: 0,
        message: "",
        sceneSourceInfo: {},
        taskID: void 0,
        sourceID: void 0,
        meshes: []
      };
      this._sceneSourceTasks.push(P);
      const U = x.getSourceTasksUrl(), M = new Request(U, {
        method: "POST",
        headers: {
          Authorization: "Bearer " + this._authorizationToken
        },
        body: B
      }), Z = (D) => {
        const te = D.loaded / D.total;
        P.uploadProgress = te * 100, this.fireSceneSourceTaskCheckEvent();
      }, F = (D) => {
        const te = D.loaded / D.total;
        P.downloadProgress = te * 100, this.fireSceneSourceTaskCheckEvent();
      }, Q = new XMLHttpRequest();
      Q.upload.addEventListener("progress", Z), Q.addEventListener("progress", F), M.signal.addEventListener("fetch", () => Q.send()), fetch(M).then((D) => D.json()).then((D) => {
        D && D.hasOwnProperty("taskID") && D.hasOwnProperty("sourceID") ? (P.taskID = D.taskID, P.sourceID = D.sourceID, P.status = 1, this.fireSceneSourceTaskCheckEvent()) : Logger.info("task creation process did not go well"), n && n(P);
      }).catch((D) => {
        this._sceneSourceTasks = this._sceneSourceTasks.filter((te) => {
        }), this.fireSceneSourceTaskCheckEvent(), s && s(D);
      }), this.fireSceneSourceTaskCheckEvent();
    }
  }
  // Il metodo viene richiamato ogni secondo per il controllo dei task di caricamento file
  // eventualmente presenti in coda
  checkSceneSourceTasks() {
    if (this._scene && this._zkScene && this._sceneSourceTasks && this._sceneSourceTasks.length > 0) {
      const t = this._zkScene;
      for (let n = 0; n < this._sceneSourceTasks.length; n++) {
        let s = this._sceneSourceTasks[n];
        if (s.status == 5 || s.status == 4) {
          this._sceneSourceTasks.splice(n--, 1), this.fireSceneSourceTaskCheckEvent();
          continue;
        }
        if (!(s.status == 2 || s.status == 0)) {
          if (s.status == 1) {
            s.status = 2;
            const o = (h) => {
              h.status = 5, this.fireSceneSourceTaskErrorEvent(h.taskID), this.fireSceneSourceTaskCheckEvent();
            };
            var e = async (h) => {
              try {
                const c = await fetch(t.getSourceTaskResultUrl(h.taskID), {
                  method: "GET",
                  cache: "no-cache",
                  headers: {
                    Authorization: "Bearer " + this._authorizationToken
                  }
                });
                if (c.ok) {
                  const _ = await c.json();
                  if (_ && _.hasOwnProperty("taskID") && _.hasOwnProperty("state") && _.hasOwnProperty("message") && _.hasOwnProperty("sourceFile"))
                    if (_.state == 2) {
                      h.sceneSourceInfo = {
                        sourceID: _.sourceFile.sourceID,
                        fileObjectID: _.sourceFile.fileObjectID,
                        fileLength: _.sourceFile.fileLength,
                        url: _.sourceFile.url,
                        rootUrl: _.sourceFile.rootUrl,
                        sceneFileName: _.sourceFile.sceneFileName,
                        textureFiles: []
                      };
                      for (let x = 0; x < _.sourceFile.textureFiles.length; x++)
                        h.sceneSourceInfo.textureFiles.push({
                          textureID: _.sourceFile.textureFiles[x].textureID,
                          fileObjectID: _.sourceFile.textureFiles[x].fileObjectID,
                          fileLength: _.sourceFile.textureFiles[x].fileLength,
                          url: _.sourceFile.textureFiles[x].url
                        });
                      h.status = 3;
                    } else
                      _.state == 3 ? o(h) : h.status = 1;
                  else
                    o(h);
                } else
                  o(h);
              } catch {
                o(h);
              }
            };
            e(s);
          }
          s.status == 3 && (this._isLoadingSourceFiles || (this._isLoadingSourceFiles = !0, s.sceneSourceInfo.rootUrl && s.sceneSourceInfo.sceneFileName ? (this.updateSceneModelFromSourceTask(s), this.loadMeshesFromRemoteFiles(
            s.sceneSourceInfo.rootUrl,
            s.sceneSourceInfo.sceneFileName,
            (o) => {
              o && Object.prototype.toString.call(o) === "[object Array]" && o.forEach((h) => {
                h.isPickable = !0;
              }), this._isLoadingSourceFiles = !1, this.fireSceneSourceTaskSuccessEvent(o), this.fireMeshesUpdateEvent(), this.fireMaterialsUpdateEvent(), this.fireLightsUpdateEvent(), s.meshes = o, s.status = 4;
            },
            (o) => {
              Logger.info("Errore nel caricamento delle mesh: " + o), this._isLoadingSourceFiles = !1, this.fireSceneSourceTaskErrorEvent(s.taskID), s.status = 5;
            }
          )) : (Logger.info("Risultato del task di caricamento non valido"), this._isLoadingSourceFiles = !1, this.fireSceneSourceTaskErrorEvent(s.taskID), s.status = 5), this.fireSceneSourceTaskCheckEvent()));
        }
      }
    }
    setTimeout(() => this.checkSceneSourceTasks(), 500);
  }
  updateSceneModelFromSourceTask(e) {
    if (this._zkScene) {
      const t = new Zakeke.SceneSource();
      t.set("sourceID", e.sceneSourceInfo.sourceID), t.set("fileObjectID", e.sceneSourceInfo.fileObjectID), t.set("fileLength", e.sceneSourceInfo.fileLength), t.set("url", e.sceneSourceInfo.url), t.set("rootUrl", e.sceneSourceInfo.rootUrl), t.set("sceneFileName", e.sceneSourceInfo.sceneFileName);
      for (let n = 0; n < e.sceneSourceInfo.textureFiles.length; n++) {
        const s = e.sceneSourceInfo.textureFiles[n];
        if (s.textureID && (s.fileObjectID || s.fileLength) && s.url) {
          const o = new Zakeke.SceneSourceTexture();
          o.set("textureID", s.textureID), o.set("fileObjectID", s.fileObjectID), o.set("fileLength", s.fileLength), o.set("url", s.url), t.get("textures").push(o);
        }
      }
      this._zkScene.get("sources").push(t);
    }
  }
  // Carica i file provenienti da una sorgente nella scena Babylon JS corrente
  // Ad ogni mesh e ad ogni materiale viene assegnato un identificativo univoco (GUID).
  // Inoltre tutte le mesh vengono inserite in un nuovo gruppo il cui nome deriva da quello
  // del file di scena
  loadMeshesFromRemoteFiles(e, t, n, s) {
    if (!this._scene || !this._sceneHelper) {
      s && s("No scene to fill with imported meshes");
      return;
    }
    this._scene;
    const o = this._sceneHelper;
    let h = e + t;
    o.importMeshesFromUrlAsync(h, null, void 0).then(async (c) => (Logger.info("Uploading embedded textures..."), await this.uploadEmbeddedTexturesAsync(), c)).then((c) => (Logger.info("File imported successfully."), this.checkSceneEmptyEnvironmentTexture(), this.refreshEnvironment(), c)).then((c) => {
      Logger.info("Operation completed successfully."), n == null || n(c);
    }).catch((c) => {
      Logger.info("Error loading file"), s && s(c);
    }), Logger.info("loading finished");
  }
  // Carica i file provenienti da una sorgente nella scena Babylon JS corrente
  // Ad ogni mesh e ad ogni materiale viene assegnato un identificativo univoco (GUID).
  // Inoltre tutte le mesh vengono inserite in un nuovo gruppo il cui nome deriva da quello
  // del file di scena
  loadMeshesFromRemoteFiles_OLD(e, t, n, s) {
    if (!this._scene || !this._sceneHelper) {
      s && s("No scene to fill with imported meshes");
      return;
    }
    const o = this._scene, h = this._sceneHelper;
    let c = t, _ = t.lastIndexOf(".");
    _ !== -1 && (c = t.substr(0, _));
    const x = this._scene.materials.map((M) => M.id);
    let B;
    BABYLON.GLTFFileLoader.IncrementalLoading = !1, BABYLON.SceneLoader.OnPluginActivatedObservable.add((M) => {
      B = M.name;
    });
    const P = new BABYLON.AssetsManager(this._scene), U = P.addMeshTask("mesh-task", "", e, t);
    U.onSuccess = (M) => {
      Logger.info("task completed successfully");
      const Z = M.loadedMeshes, F = new BABYLON.Mesh(c, o);
      F.id = Zakeke.generateUUID(), F.metadata = {
        isRealMesh: !0,
        isGroup: !0
      }, Z.forEach((Q) => {
        Q.parent || (Q.parent = F), Q.material || (Q.material = new BABYLON.StandardMaterial(Q.name + "Mat", o)), Q.id = Zakeke.generateUUID();
      }), o.materials.forEach((Q) => {
        oa(x, Q.id) || (Q.id = Zakeke.generateUUID());
      }), this.checkSceneEmptyEnvironmentTexture(), this.refreshEnvironment(), h.adjustCamera(B, !1, !1), h.setupShaderMaterialsCameraPosition(), n && n(Z);
    }, U.onError = (M, Z, F) => {
      Logger.info("task completed with errors"), s && s(Z);
    }, P.onFinish = function() {
      Logger.info("loading finished");
    }, P.load();
  }
  // Fine importazione Assets
  // ==============================================================================
  isRealMesh(e) {
    return this._sceneHelper ? this._sceneHelper.isRealMesh(e) : !1;
  }
  onMeshChanged(e) {
    this.updateBoundingBox(), this.setRenderingNeeded();
  }
  onSubMeshChanged(e) {
    this.updateBoundingBox(), this.setRenderingNeeded();
  }
  onMaterialChanged(e) {
    this.setRenderingNeeded();
  }
  onLightChanged(e) {
    this.setRenderingNeeded();
  }
  getSceneMeshesByName(e) {
    return this._sceneHelper ? this._sceneHelper.getSceneMeshesByName(e) : [];
  }
  getSceneMeshes() {
    return this._sceneHelper ? this._sceneHelper.getSceneMeshes() : [];
  }
  getMeshesUsingMaterial(e) {
    return this._sceneHelper ? this._sceneHelper.getMeshesUsingMaterial(e) : [];
  }
  getMeshesMaterials(e) {
    return this._sceneHelper ? this._sceneHelper.getMeshesMaterials(e) : [];
  }
  getMeshMaterials(e) {
    return this._sceneHelper ? this._sceneHelper.getMeshMaterials(e) : [];
  }
  getAllMaterials() {
    return this._sceneHelper ? this._sceneHelper.getAllMaterials() : [];
  }
  // restituisce un array di gruppi di materiali
  // ogni gruppo è del tipo MaterialGroup, con proprietà
  // "group"(nome del gruppo)
  // "materials"(elenco materiali)
  getGroupedMaterials() {
    const e = [], t = {}, n = this.getAllMaterials();
    for (let s = 0; s < n.length; s++) {
      let o = n[s];
      if (o.id == "groundMaterial")
        continue;
      const h = this.getMaterialGroup(o.id);
      let c = null;
      t.hasOwnProperty(h) ? c = t[h] : (c = new b1(h), e.push(c), t[h] = c), c && c.materials.push(o);
    }
    return e.sort(function(s, o) {
      var h = s.groupName.toLowerCase(), c = o.groupName.toLowerCase();
      return h < c ? -1 : h > c ? 1 : 0;
    });
  }
  // Assegna il gruppo ad un array di materiali
  setMaterialsGroup(e, t, n = !0) {
    for (let s = 0; s < e.length; s++) {
      const o = e[s];
      this.setMaterialGroup(o, t, n);
    }
  }
  // Assegna il gruppo ad un singolo materiale
  setMaterialGroup(e, t, n = !0) {
    !this._scene || !this._scene.getMaterialByID(e) || (this._scene.metadata || (this._scene.metadata = {}), this._scene.metadata.groups || (this._scene.metadata.groups = {}), this._scene.metadata.groups[e] = t, n && this.fireMaterialsUpdateEvent());
  }
  // Restituisce il gruppo di un materiale
  getMaterialGroup(e) {
    return this._scene && this._scene.metadata && this._scene.metadata.groups && this._scene.metadata.groups.hasOwnProperty(e) ? this._scene.metadata.groups[e] : fl.EmptyGroupName;
  }
  // Elimina il gruppo di un materiale
  removeMaterialGroup(e) {
    this._scene && this._scene.metadata && this._scene.metadata.groups && this._scene.metadata.groups.hasOwnProperty(e) && (delete this._scene.metadata.groups[e], this.fireMaterialsUpdateEvent());
  }
  getMaterialsByGroup(e) {
    const t = [], n = e || fl.EmptyGroupName;
    return this._scene && this._sceneHelper && this._sceneHelper.getAllMaterials().forEach((s) => {
      this.getMaterialGroup(s.id) === n && t.push(s);
    }), t;
  }
  getGroupCenter(e) {
    return this._sceneHelper ? this._sceneHelper.getMeshHierarchyCenter(e) : null;
  }
  getGroupBoundingInfo(e) {
    let t = e.getHierarchyBoundingVectors(!0);
    return new BABYLON.BoundingInfo(t.min, t.max);
  }
  showHideBoundingBox(e) {
    this._showBoundingBox = e, this.updateBoundingBox(), this.setRenderingNeeded();
  }
  updateBoundingBox() {
    this.deleteBoundingBox(), this.showBoundingBox && this.createSceneBoundingBox(!0);
  }
  deleteBoundingBox() {
    let e = this.getSceneBoundingBox();
    e && e.dispose();
  }
  setCameraPositionScale(e) {
    this._zkScene && this._sceneHelper && (this._zkScene.setCameraPositionScale(e), this._sceneHelper.setCameraPositionScale(e, !0), this.setRenderingNeeded());
  }
  setCameraPositionFOV(e) {
    this._zkScene && this._sceneHelper && (this._zkScene.setCameraPositionFOV(e), this._sceneHelper.setCameraPositionFOV(e), this.setRenderingNeeded());
  }
  setCameraLimitLowerRadius(e) {
    this._zkScene && this._sceneHelper && (this._zkScene.setCameraLimitLowerRadius(e), this._sceneHelper.setCameraLimitLowerRadius(e, !0), this.setRenderingNeeded());
  }
  setCameraZoomEnabled(e) {
    this._zkScene && this._sceneHelper && (this._zkScene.setCameraZoomEnabled(e), this._sceneHelper.setZoomEnabled(e), this.setRenderingNeeded());
  }
  setCameraUseMinZoomPercentage(e) {
    this._zkScene && this._sceneHelper && (this._zkScene.setCameraUseMinZoomPerc(e), this._sceneHelper.setMinZoomPerc(e ? this._zkScene.getCameraMinZoomPerc() : void 0), this.setRenderingNeeded());
  }
  setCameraMinZoomPercentage(e) {
    if (this._zkScene && this._sceneHelper) {
      this._zkScene.setCameraMinZoomPerc(e);
      var t = this._zkScene.getCameraUseMinZoomPerc();
      this._sceneHelper.setMinZoomPerc(t ? e : void 0), this.setRenderingNeeded();
    }
  }
  setCameraUseMaxZoomPercentage(e) {
    this._zkScene && this._sceneHelper && (this._zkScene.setCameraUseMaxZoomPerc(e), this._sceneHelper.setMaxZoomPerc(e ? this._zkScene.getCameraMaxZoomPerc() : void 0), this.setRenderingNeeded());
  }
  setCameraMaxZoomPercentage(e) {
    if (this._zkScene && this._sceneHelper) {
      this._zkScene.setCameraMaxZoomPerc(e);
      const t = this._zkScene.getCameraUseMaxZoomPerc();
      this._sceneHelper.setMaxZoomPerc(t ? e : void 0), this.setRenderingNeeded();
    }
  }
  lockCameraAlphaAngle() {
    if (this._zkScene && this._sceneHelper && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      const e = this._camera.alpha ?? 0;
      this._zkScene.setCameraLowerAlphaLimit(e), this._zkScene.setCameraUpperAlphaLimit(e), this._sceneHelper.setCameraAlphaLimits(e, e), this.setRenderingNeeded();
    }
  }
  unlockCameraAlphaAngle() {
    this._zkScene && this._sceneHelper && (this._zkScene.setCameraLowerAlphaLimit(null), this._zkScene.setCameraUpperAlphaLimit(null), this._sceneHelper.setCameraAlphaLimits(null, null), this.setRenderingNeeded());
  }
  lockCameraBetaAngle() {
    if (this._zkScene && this._sceneHelper && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      var e = this._camera.beta ?? -1.57;
      this._zkScene.setCameraLowerBetaLimit(e), this._zkScene.setCameraUpperBetaLimit(e), this._sceneHelper.setCameraBetaLimits(e, e), this.setRenderingNeeded();
    }
  }
  unlockCameraBetaAngle() {
    this._zkScene && this._sceneHelper && (this._zkScene.setCameraLowerBetaLimit(null), this._zkScene.setCameraUpperBetaLimit(null), this._sceneHelper.setCameraBetaLimits(null, null), this.setRenderingNeeded());
  }
  setCameraLowerAlphaLimit() {
    if (this._zkScene && this._sceneHelper && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      const e = this._camera.alpha;
      this._zkScene.setCameraLowerAlphaLimit(e), this._sceneHelper.setCameraLowerAlphaLimit(e), this.setRenderingNeeded();
    }
  }
  unsetCameraLowerAlphaLimit() {
    this._zkScene && this._sceneHelper && (this._zkScene.setCameraLowerAlphaLimit(null), this._sceneHelper.setCameraLowerAlphaLimit(null), this.setRenderingNeeded());
  }
  setCameraUpperAlphaLimit() {
    if (this._zkScene && this._sceneHelper && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      var e = this._camera.alpha;
      this._zkScene.setCameraUpperAlphaLimit(e), this._sceneHelper.setCameraUpperAlphaLimit(e), this.setRenderingNeeded();
    }
  }
  unsetCameraUpperAlphaLimit() {
    this._zkScene && this._sceneHelper && (this._zkScene.setCameraUpperAlphaLimit(null), this._sceneHelper.setCameraUpperAlphaLimit(null), this.setRenderingNeeded());
  }
  setCameraLowerBetaLimit() {
    if (this._zkScene && this._sceneHelper && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      const e = this._camera.beta;
      this._zkScene.setCameraLowerBetaLimit(e), this._sceneHelper.setCameraLowerBetaLimit(e), this.setRenderingNeeded();
    }
  }
  unsetCameraLowerBetaLimit() {
    this._zkScene && this._zkScene && this._sceneHelper && (this._zkScene.setCameraLowerBetaLimit(null), this._sceneHelper.setCameraLowerBetaLimit(null), this.setRenderingNeeded());
  }
  setCameraUpperBetaLimit() {
    if (this._zkScene && this._sceneHelper && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      const e = this._camera.beta;
      this._zkScene.setCameraUpperBetaLimit(e), this._sceneHelper.setCameraUpperBetaLimit(e), this.setRenderingNeeded();
    }
  }
  unsetCameraUpperBetaLimit() {
    this._zkScene && this._sceneHelper && (this._zkScene.setCameraUpperBetaLimit(null), this._sceneHelper.setCameraUpperBetaLimit(null), this.setRenderingNeeded());
  }
  // Mesh selection overrides (the selection logic si a little bit different
  // respect the parent SceneViewer one)
  selectMesh(e) {
    this.selectUnselectMesh(e, !0);
  }
  unselectMesh(e) {
    this.selectUnselectMesh(e, !1);
  }
  unselectAllMeshes() {
    this._scene && this._scene.meshes.forEach((e) => this.unselectSingleMesh(e));
  }
  selectUnselectMesh(e, t) {
    if (this._scene) {
      if (this.deleteBoundingBox(), this.unselectAllMeshes(), t) {
        const n = (o) => {
          this.selectSingleMesh(o), o.getChildMeshes().forEach((h) => n(h));
        };
        let s = this._scene.getMeshByID(e);
        this._isSelectionMode || (s = this.getDAMMainMesh() ?? s), s && n(s), this.setManipulatedNode(s);
      } else
        this.setManipulatedNode(null);
      this.fireSelectionChangedEvent();
    }
  }
  selectSingleMesh(e) {
    e.selected = !0, this.highlightMesh(e, !0), this.setRenderingNeeded();
  }
  unselectSingleMesh(e) {
    e.selected = !1, this.highlightMesh(e, !1), this.setRenderingNeeded();
  }
  isMeshSelected(e) {
    return e && e.selected != null && e.selected;
  }
  // Show-hide mesh methods
  showMesh(e) {
    this.resetRealVisibility(), this.showHideMesh(e, !0, !0);
  }
  hideMesh(e) {
    this.resetRealVisibility(), this.showHideMesh(e, !1, !0);
  }
  showHideMesh(e, t, n = !0) {
    var s;
    if (this._scene && this._sceneHelper && this._camera) {
      this._scene;
      const o = this._sceneHelper, h = this._camera, c = (B, P) => {
        B.isVisible = P, Logger.info(B.name), B.getChildMeshes().forEach((U) => c(U, P));
      }, _ = (B, P) => {
        c(B, P), !(o && h && B.metadata && B.metadata.isGroup && B.getChildMeshes().length === 0) && P && !h.isCompletelyInFrustum(B) && (o.adjustCamera(void 0, !1, !1), o.setupShaderMaterialsCameraPosition()), n && this.fireMeshesUpdateEvent(), this.setRenderingNeeded();
      }, x = this._scene.getMeshByID(e);
      if (x) {
        const B = (s = this._zkScene) == null ? void 0 : s.get("rootUrl");
        B ? o.unsetMeshDummyMaterialAsync(x, B, !0).then(() => _(x, t)) : _(x, t);
      }
      this.refreshInfoPoints();
    }
  }
  // Permette di mostrare esclusivamente la mesh selezionata (e i suoi figli)
  // Lo stato precedente delle mesh viene memorizzato in modo da poter essere
  // ripristinato con la funzione resetRealVisibility
  setTemporaryExclusivelyVisible(e) {
    this._scene && (this.resetRealVisibility(), this._realMeshVisibility = {}, this._scene.meshes.forEach((t) => {
      this._realMeshVisibility[t.id] = t.isVisible, this.isRealMesh(t) && (t.isVisible = !1);
    }), this.showHideMesh(e, !0, !1));
  }
  // Reimposto lo stato di visibilità come era precedentemente alla chiamata
  // a setTempraryExclusiveVisible
  resetRealVisibility() {
    this._scene && this._sceneHelper && this._realMeshVisibility && (this._sceneHelper.getSceneMeshes().forEach((t) => {
      this._realMeshVisibility.hasOwnProperty(t.id) && (t.isVisible = this._realMeshVisibility[t.id]);
    }), this.setRenderingNeeded());
  }
  // Funzione per modificare il colore di un materiale in modo progressivo (tramite animazione)
  changeMaterialColor(e, t, n) {
    this._sceneHelper && this._sceneHelper.changeMaterialColor(e, t, n);
  }
  renameMesh(e, t) {
    if (this._scene) {
      const n = this._scene.getMeshByID(e);
      n && (n.name = t, this.fireMeshesUpdateEvent());
    }
  }
  //#region Events
  // PreUpdateEvent
  firePreUpdateEvent() {
    this._preUpdateListeners.forEach((e) => e());
  }
  addPreUpdateListener(e) {
    this._preUpdateListeners.push(e);
  }
  removePreUpdateListener(e) {
    for (let t = 0; t < this._preUpdateListeners.length; t++)
      if (this._preUpdateListeners[t] == e) {
        this._preUpdateListeners.splice(t--, 1);
        break;
      }
  }
  // PostUpdateEvent
  firePostUpdateEvent() {
    this._postUpdateListeners.forEach((e) => e());
  }
  addPostUpdateListener(e) {
    this._postUpdateListeners.push(e);
  }
  removePostUpdateListener(e) {
    for (let t = 0; t < this._postUpdateListeners.length; t++)
      if (this._postUpdateListeners[t] == e) {
        this._postUpdateListeners.splice(t--, 1);
        break;
      }
  }
  // MeshSelected
  fireMeshSelectedEvent(e) {
    this._meshSelectedListeners.forEach((t) => t(e));
  }
  addMeshSelectedListener(e) {
    this._meshSelectedListeners.push(e);
  }
  removeMeshSelectedListener(e) {
    const t = this._meshSelectedListeners.indexOf(e);
    t != -1 && this._meshSelectedListeners.splice(t, 1);
  }
  // SelectionChanged
  fireSelectionChangedEvent() {
    this._selectionChangedListeners.forEach((e) => e());
  }
  addSelectionChangedListener(e) {
    this._selectionChangedListeners.push(e);
  }
  removeSelectionChangedListener(e) {
    const t = this._selectionChangedListeners.indexOf(e);
    t != -1 && this._selectionChangedListeners.splice(t, 1);
  }
  // LightsSelected
  fireLightSelectedEvent(e) {
    this._lightSelectedListeners.forEach((t) => t(e));
  }
  addLightSelectedListener(e) {
    this._lightSelectedListeners.push(e);
  }
  // SceneCreated
  fireSceneCreatedEvent() {
    this._sceneCreatedListeners.forEach((e) => e());
  }
  addSceneCreatedListener(e) {
    this._sceneCreatedListeners.push(e);
  }
  // CameraLocationCreated
  fireCameraLocationCreatedEvent(e) {
    this._cameraLocationCreatedListeners.forEach((t) => t(e));
  }
  addCameraLocationCreatedListener(e) {
    this._cameraLocationCreatedListeners.push(e);
  }
  // CameraLocationsUpdate
  fireCameraLocationsUpdateEvent(e) {
    if (!e && this._scene && (e = this.getAllCameraLocations()), !e)
      throw "Failed firing positions update event: lights are null and no scene present";
    this._cameraLocationsUpdateListeners.forEach((t) => t(e));
  }
  addCameraLocationsUpdateListener(e) {
    this._cameraLocationsUpdateListeners.push(e);
  }
  removeCameraLocationsUpdateListener(e) {
    const t = this._cameraLocationsUpdateListeners.indexOf(e);
    t != -1 && this._cameraLocationsUpdateListeners.splice(t, 1);
  }
  // SceneSourceTaskSuccess
  fireSceneSourceTaskSuccessEvent(e) {
    this._sceneSourceTaskSuccessListeners.forEach((t) => t(e));
  }
  addSceneSourceTaskSuccessListener(e) {
    this._sceneSourceTaskSuccessListeners.push(e);
  }
  // SceneSourceTaskError
  fireSceneSourceTaskErrorEvent(e) {
    this._sceneSourceTaskErrorListeners.forEach((t) => t(e));
  }
  addSceneSourceTaskErrorListener(e) {
    this._sceneSourceTaskErrorListeners.push(e);
  }
  removeSceneSourceTaskErrorListener(e) {
    const t = this._sceneSourceTaskErrorListeners.indexOf(e);
    t != -1 && this._sceneSourceTaskErrorListeners.splice(t, 1);
  }
  // SceneSourceTaskCheck
  fireSceneSourceTaskCheckEvent() {
    this._sceneSourceTasksCheckListeners.forEach((e) => e());
  }
  addSceneSourceTaskCheckListener(e) {
    this._sceneSourceTasksCheckListeners.push(e);
  }
  removeSceneSourceTaskCheckListener(e) {
    const t = this._sceneSourceTasksCheckListeners.indexOf(e);
    t != -1 && this._sceneSourceTasksCheckListeners.splice(t, 1);
  }
  // MeshesUpdate
  fireMeshesUpdateEvent(e) {
    if (!e && this._scene && (e = this.getSceneMeshes()), !e)
      throw "Failed firing mesh update event: meshes are null and no scene present";
    this._meshesUpdateListeners.forEach((t) => t(e));
  }
  addMeshesUpdateListener(e) {
    this._meshesUpdateListeners.push(e);
  }
  removeMeshesUpdateListener(e) {
    const t = this._meshesUpdateListeners.indexOf(e);
    t != -1 && this._meshesUpdateListeners.splice(t, 1);
  }
  // MaterialsUpdate
  fireMaterialsUpdateEvent(e) {
    if (!e && this._scene && (e = this.getGroupedMaterials()), !e)
      throw "Failed firing materials update event: materials are null and no scene present";
    this._materialsUpdateListeners.forEach((t) => t(e));
  }
  addMaterialsUpdateListener(e) {
    this._materialsUpdateListeners.push(e);
  }
  removeMaterialsUpdateListener(e) {
    const t = this._materialsUpdateListeners.indexOf(e);
    t != -1 && this._materialsUpdateListeners.splice(t, 1);
  }
  // LightsUpdate
  fireLightsUpdateEvent(e) {
    if (!e && this._scene && (e = this.getAllLights()), !e)
      throw "Failed firing lights update event: lights are null and no scene present";
    this._lightsUpdateListeners.forEach((t) => t(e));
  }
  addLightsUpdateListener(e) {
    this._lightsUpdateListeners.push(e);
  }
  removeLightsUpdateListener(e) {
    const t = this._lightsUpdateListeners.indexOf(e);
    t != -1 && this._lightsUpdateListeners.splice(t, 1);
  }
  // MeshLocationCreated
  fireMeshLocationCreatedEvent(e) {
    this._meshLocationCreatedListeners.forEach((t) => t(e));
  }
  addMeshLocationCreatedListener(e) {
    this._meshLocationCreatedListeners.push(e);
  }
  // MeshLocationsUpdate
  fireMeshLocationsUpdateEvent(e) {
    if (!e && this._scene && (e = this.getAllMeshLocations()), e)
      this._meshLocationsUpdateListeners.forEach((t) => t(e));
    else
      throw "Failed firing mesh positions update event: positions are null and no scene present";
  }
  addMeshLocatonsUpdateListener(e) {
    this._meshLocationsUpdateListeners.push(e);
  }
  // ArTaskSuccess
  fireArTaskSuccessEvent() {
    this._arTaskSuccessListeners.forEach((e) => e());
  }
  addArTaskSuccessListener(e) {
    this._arTaskSuccessListeners.push(e);
  }
  // ArTaskError
  fireArTaskErrorEvent() {
    this._arTaskErrorListeners.forEach((e) => e());
  }
  addArTaskErrorListener(e) {
    this._arTaskErrorListeners.push(e);
  }
  // ArTaskCheck
  fireArTaskCheckEvent() {
    this._arTasksCheckListeners.forEach((e) => e());
  }
  addArTaskCheckListener(e) {
    this._arTasksCheckListeners.push(e);
  }
  fireFineTuningSettingEvent(e) {
    this._tryOnFineTuningSettingListeners.forEach((t) => t(e));
  }
  addFineTuningSettingListener(e) {
    return this._tryOnFineTuningSettingListeners.push(e), this._tryOnFineTuningSettingListeners.length - 1;
  }
  removeFineTuningSettingListener(e) {
    this._tryOnFineTuningSettingListeners.splice(e, 1);
  }
  removeAllFineTuningSettingListeners() {
    this._tryOnFineTuningSettingListeners = [];
  }
  fireFineTuningCloseEvent() {
    this._tryOnFineTuningCloseListeners.forEach((e) => e());
  }
  addFineTuningCloseListener(e) {
    this._tryOnFineTuningCloseListeners.push(e);
  }
  // Clear
  clearListeners() {
    this._meshSelectedListeners = [], this._selectionChangedListeners = [], this._lightSelectedListeners = [], this._sceneCreatedListeners = [], this._cameraLocationCreatedListeners = [], this._sceneSourceTaskSuccessListeners = [], this._sceneSourceTaskErrorListeners = [], this._sceneSourceTasksCheckListeners = [], this._meshesUpdateListeners = [], this._materialsUpdateListeners = [], this._lightsUpdateListeners = [], this._cameraLocationsUpdateListeners = [], this._meshLocationCreatedListeners = [], this._meshLocationsUpdateListeners = [], this._arTaskSuccessListeners = [], this._arTaskErrorListeners = [], this._arTasksCheckListeners = [], this._tryOnFineTuningSettingListeners = [], this._tryOnFineTuningCloseListeners = [];
  }
  //#endregion
  //#region Interazione utente (Pointer Down/Move)
  onPointerDown(e, t) {
    if (!(!this._scene || !this._sceneHelper || this._envMode != Er.Editor) && this._selectOnPick && t && t.hit && t.pickedMesh && t.pickedMesh !== this._ground) {
      this.selectMesh(t.pickedMesh.id);
      const n = this.convertSceneToScreenPoint(this._scene.pointerX, this._scene.pointerY);
      if (n) {
        const s = {
          name: t.pickedMesh.name,
          id: t.pickedMesh.id,
          scenePointerX: this._scene.pointerX,
          scenePointerY: this._scene.pointerY,
          screenPointerX: n.X,
          screenPointerY: n.Y
        };
        this.fireMeshSelectedEvent(s);
      }
    }
  }
  onPointerMove(e, t) {
    if (!this._scene || !this._sceneHelper || this._envMode != Er.Editor)
      return;
    if (this.highlightMeshOver(!1), !this._highlightOver) {
      this._meshOver = null;
      return;
    }
    const n = this._scene.pick(this._scene.pointerX, this._scene.pointerY);
    n && n.hit && n.pickedMesh && this._sceneHelper.isRealMesh(n.pickedMesh) && (this._meshOver = n.pickedMesh, this.highlightMeshOver(!0));
  }
  //#endregion
  //#region Element Selection
  getSubMesh(e, t) {
    return this._sceneHelper ? this._sceneHelper.getSubMesh(e, t) : null;
  }
  getLightByID(e) {
    return this._scene ? this._scene.getLightByID(e) : null;
  }
  //#endregion
  //#region Apply material
  applyMaterialByName(e, t) {
    this._sceneHelper && this._sceneHelper.applyMaterialByName(e, t);
  }
  applyMaterial(e, t) {
    this._sceneHelper && (this._sceneHelper.applyMaterial(e, t), this.setLongRenderingNeeded());
  }
  applyMaterialToSubMeshByName(e, t, n) {
    this._sceneHelper && this._sceneHelper.applyMaterialToSubMeshByName(e, t, n);
  }
  applyMaterialToSubMesh(e, t, n) {
    this._sceneHelper && this._sceneHelper.applyMaterialToSubMesh(e, t, n);
  }
  resetMeshMaterial(e, t) {
    t ? this._initialMeshMaterials : this._lastMeshMaterials;
  }
  resetSubMeshMaterial(e, t, n) {
    const s = n ? this._initialSubMeshMaterials : this._lastSubMeshMaterials;
    if (e && t && e.material instanceof BABYLON.MultiMaterial) {
      const o = t.materialIndex;
      if (o >= 0 && o < e.material.subMaterials.length) {
        const h = `${e.id}_${o}`;
        if (s.hasOwnProperty(h)) {
          const c = s[h], _ = this.getMaterialByID(c);
          _ && (e.material.subMaterials[o] = _);
        }
      }
    }
    this.setRenderingNeeded();
  }
  //#endregion
  getExtension(e) {
    var t = e.lastIndexOf(".");
    if (t !== -1) {
      var n = e.substring(t).toLowerCase();
      return n;
    }
  }
  //#region Caricamento texture da file esterni
  loadMobileTextureFilesAsync(e, t, n, s) {
    return new Promise((o, h) => {
      this.loadMobileTextureFiles(
        e,
        t,
        n,
        s,
        () => o(),
        (c) => h()
      );
    });
  }
  loadMobileTextureFiles(e, t, n, s, o, h) {
    const c = e.length === 6 || this.getExtension(e[0].name) === ".dds" || this.getExtension(e[0].name) === ".hdr" || this.getExtension(e[0].name) === ".env" || this.getExtension(e[0].name) === ".basis";
    this.uploadTextureFiles(
      e,
      t,
      n,
      (_) => {
        _.length > 0 && (c ? this.setMobileCubeTextureImages(_, t, n) : this.setMobileTextureImage(_[0], t, n, s)), o && o();
      },
      h,
      !1
    );
  }
  loadTextureFilesAsync(e, t, n, s) {
    return new Promise((o, h) => {
      this.loadTextureFiles(
        e,
        t,
        n,
        s,
        () => o(),
        (c) => h(c)
      );
    });
  }
  // Per il caso di texture di ambiente si suppone che material sia null e che type sia
  // uno di "environment", "skybox", "ground"
  loadTextureFiles(e, t, n, s, o, h) {
    const c = e.length === 6 || this.getExtension(e[0].name) === ".dds" || this.getExtension(e[0].name) === ".hdr" || this.getExtension(e[0].name) === ".env" || this.getExtension(e[0].name) === ".basis";
    this.uploadTextureFiles(
      e,
      t,
      n,
      async (_) => {
        var x, B, P;
        if (_.length > 0) {
          if (c)
            await this.setCubeTextureImages(_, t, n);
          else {
            await this.setTextureImage(_[0], t, n, s);
            const M = ((Z) => {
              const F = {
                clearCoat_textureRoughness: "textureRoughness",
                clearCoat_bump: "bumpTexture",
                clearCoat_tint: "tintTexture",
                clearCoat_texture: "texture",
                sheen_texture: "texture",
                sheen_textureRoughness: "textureRoughness",
                anisotropy_texture: "texture",
                subSurface_thickness: "thicknessTexture",
                subSurface_refractionIntensity: "refractionIntensityTexture",
                subSurface_translucencyIntensity: "translucencyIntensityTexture"
              };
              return F[Z] ? F[Z] : Z.toLowerCase().includes("texture") ? "texture" : Z.split("_")[1] + "Texture";
            })(n);
            (!n.includes("sheen") && !n.includes("clearCoat") && !n.includes("subSurface") && !n.includes("anisotropy") && (!t[n + "Texture"].metadata || !t[n + "Texture"].metadata.mobileUrl) || !((x = t[n.split("_")[0]][M]) != null && x.metadata) || !((P = (B = t[n.split("_")[0]][M]) == null ? void 0 : B.metadata) != null && P.mobileUrl)) && await new Promise(async (Z) => {
              this.uploadTextureFiles(
                e,
                t,
                n,
                async (F) => {
                  this.setMobileTextureImage(F[0], t, n, s), Z();
                },
                h,
                !0
              );
            });
          }
          o && o();
        }
      },
      h,
      !1
    );
  }
  getRecursiveBoundingBox(e) {
    this.calculateRecursiveBoundingBox(e);
    const t = e.getBoundingInfo().boundingBox.scale(2);
    return e.setBoundingInfo(new BABYLON.BoundingInfo(BABYLON.Vector3.Zero(), BABYLON.Vector3.Zero())), new BABYLON.BoundingBox(t.minimum, t.maximum);
  }
  calculateRecursiveBoundingBox(e) {
    const t = (s) => {
      s.refreshBoundingInfo();
      for (const o of s.getChildMeshes(!0))
        t(o);
    };
    t(e);
    const n = e.getHierarchyBoundingVectors(!0);
    e.setBoundingInfo(new BABYLON.BoundingInfo(n.min, n.max));
  }
  calculateBoundingBox(e) {
    let { min: t, max: n } = e[0].getHierarchyBoundingVectors(!1);
    for (let s = 1; s < e.length; s++) {
      const o = e[s].getHierarchyBoundingVectors(!1);
      t = BABYLON.Vector3.Minimize(t, o.min), n = BABYLON.Vector3.Maximize(n, o.max);
    }
    return new BABYLON.BoundingBox(t, n).extendSizeWorld.length();
  }
  // VERIFICA SE CI SONO MESH CHE SUPERANO I BOUNDS DELLE MESH DI RIFERIMENTO
  // Ritorna 1 se la mesh supera il volume di tutte le altre mesh
  // Ritorna -1 se la mesh è superata da almeno una delle altre mesh
  // Ritorna 0 se la mesh non supera il volume di nessuna delle altre mesh o se il volume è simile
  //maxThreshold percentuale di sensibilità del controllo
  //minThreshold aumentondolo aumenta la sensibilità del controllo
  checkMeshHiddenByMeshes(e, t, n, s) {
    const o = this.calculateBoundingBox(t), h = this.calculateBoundingBox(e);
    return h - h * n > o ? 1 : h + h * s < o ? -1 : 0;
  }
  uploadTextureFileAsync(e, t) {
    return new Promise((n, s) => {
      if (!this._scene || !this._zkScene || !e) {
        n(null);
        return;
      }
      const o = t ? t.id : Zakeke.getEmptyUUID(), h = (x) => {
        if (this._zkScene && x && x.textureID && x.materialID && (x.fileObjectID || x.fileLength) && x.url) {
          const B = new Zakeke.SceneTexture();
          return B.set("textureID", x.textureID), B.set("materialID", x.materialID), B.set("fileObjectID", x.fileObjectID), B.set("fileLength", x.fileLength), B.set("url", x.url), this._zkScene.get("textures").push(B), B;
        }
        return null;
      }, c = new FormData();
      c.append("file", e);
      const _ = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${this._authorizationToken}`
        },
        body: c
      };
      fetch(this.getTexturesUploadUrl(o), _).then((x) => {
        if (x.ok)
          return x.json();
        throw new Error("An error occurred");
      }).then((x) => {
        if (Array.isArray(x)) {
          const B = h(x[0]);
          B ? n(B) : s("Invalid image");
        } else
          s("Invalid image");
      }).catch((x) => {
        s("An error occurred: " + x.message);
      });
    });
  }
  async uploadTextureFiles(e, t, n, s, o, h) {
    if (!this._scene || !this._zkScene || !e || e.length == 0)
      return;
    const c = t ? t.id : Zakeke.getEmptyUUID(), _ = (ee) => {
      if (this._zkScene && ee && ee.textureID && ee.materialID && (ee.fileObjectID || ee.fileLength) && ee.url) {
        const le = new Zakeke.SceneTexture();
        return le.set("textureID", ee.textureID), le.set("materialID", ee.materialID), le.set("fileObjectID", ee.fileObjectID), le.set("fileLength", ee.fileLength), le.set("url", ee.url), this._zkScene.get("textures").push(le), le;
      }
      return null;
    }, x = (ee) => {
      const le = ee.lastIndexOf(".");
      return le !== -1 ? ee.substring(le) : null;
    }, B = (ee, le) => {
      const fe = ee.lastIndexOf(".");
      return fe !== -1 ? ee.substring(0, fe).endsWith("_" + le) : !1;
    }, P = x(e[0].name), U = this.canLoadCubemap(t, n) && (e.length == 6 || P === ".dds" || P === ".hdr" || P === ".env" || P === ".basis"), M = [];
    if (U && e.length == 6) {
      const ee = ["px", "py", "pz", "nx", "ny", "nz"];
      for (let le = 0; le < e.length; le++) {
        const fe = e[le];
        let X = -1;
        for (let W = 0; W < ee.length; W++)
          if (B(fe.name, ee[W])) {
            M.push(fe), X = W;
            break;
          }
        X !== -1 && ee.splice(X, 1);
      }
      if (ee.length != 0) {
        const le = "Immagini per la cube map non valide";
        o && o(le), Logger.info(le);
        return;
      }
    } else
      M.push(e[0]);
    const Z = new FormData();
    for (let ee = 0; ee < M.length; ee++)
      Z.append("file-" + ee, M[ee]);
    var F = this._zkScene.getTexturesConfig();
    if (F) {
      var Q = JSON.stringify(F), D = new Blob([Q], {
        type: "application/json"
      });
      Z.append("options", D, "options.json");
    }
    Z.forEach((ee) => console.log("File: ", ee));
    const te = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${this._authorizationToken}`
        // 'Content-Type': 'multipart/form-data',
      },
      body: Z
    };
    fetch(this.getTexturesUploadUrl(c) + "?resize=" + h, te).then((ee) => {
      if (!ee.ok)
        throw new Error("An error occurred: " + ee.status);
      return ee.json();
    }).then((ee) => {
      const le = [];
      if (Object.prototype.toString.call(ee) === "[object Array]")
        for (let fe = 0; fe < ee.length; fe++) {
          const X = _(ee[fe]);
          if (!X) {
            const W = "Immagini non valide";
            if (o) {
              o(W);
              return;
            }
          }
          X && le.push(X);
        }
      s && s(le);
    }).catch((ee) => {
      const le = "An error occurred: " + ee.message;
      o && o(le);
    });
  }
  getTexturesUploadUrl(e) {
    return this._zkScene ? this._zkScene.getTexturesUrl(e) : "";
  }
  removeAllMaterialPhotos(e) {
    if (this._zkScene) {
      const t = [];
      for (let n = 0; n < this._zkScene.get("materialPhotos").length; n++)
        this._zkScene.get("materialPhotos").at(n).get("materialID") === e.id && t.push(this._zkScene.get("materialPhotos").at(n));
      t.length > 0 && this._zkScene.get("materialPhotos").remove(t);
    }
  }
  removeMaterialPhotoAtIndex(e, t) {
    if (this._zkScene) {
      const n = [];
      for (let s = 0; s < this._zkScene.get("materialPhotos").length; s++)
        this._zkScene.get("materialPhotos").at(s).get("materialID") === e.id && n.push(this._zkScene.get("materialPhotos").at(s));
      if (n.length > 0) {
        const s = n[t];
        this._zkScene.get("materialPhotos").remove(s);
      }
    }
  }
  loadMaterialPhotoFiles(e, t, n, s) {
    this.uploadMaterialPhotoFiles(
      e,
      t,
      (o) => {
        this.refreshInfoPoints(), n && n();
      },
      s
    );
  }
  uploadMaterialPhotoFiles(e, t, n, s) {
    if (!this._scene || !this._zkScene || !e || e.length === 0)
      return;
    const o = t.id, h = (x) => {
      if (this._zkScene && x && x.photoID && x.materialID && (x.fileObjectID || x.fileLength) && x.url) {
        const B = new Zakeke.SceneMaterialPhoto();
        return B.set("photoID", x.photoID), B.set("materialID", x.materialID), B.set("fileObjectID", x.fileObjectID), B.set("fileLength", x.fileLength), B.set("url", x.url), this._zkScene.get("materialPhotos").push(B), B;
      }
      return null;
    }, c = (x) => {
      const B = x.lastIndexOf(".");
      return B !== -1 ? x.substring(B) : null;
    }, _ = new FormData();
    for (let x = 0; x < e.length; x++) {
      const B = c(e[x].name);
      (B === ".png" || B === ".jpg") && _.append("file-" + x, e[x]);
    }
    jQuery.ajax({
      url: this.getMaterialPhotosUploadUrl(o),
      data: _,
      cache: !1,
      contentType: !1,
      processData: !1,
      type: "POST",
      success: (x) => {
        const B = [];
        if (Object.prototype.toString.call(x) === "[object Array]")
          for (let P = 0; P < x.length; P++) {
            const U = h(x[P]);
            if (!U) {
              const M = "Immagini non valide";
              if (s) {
                s(M);
                return;
              }
            }
            U && B.push(U);
          }
        n && n(B);
      },
      error: (x, B, P) => {
        const U = "An error occurred: " + B + " Error: " + P;
        s && s(U);
      }
    });
  }
  getMaterialPhotosUploadUrl(e) {
    return this._zkScene ? this._zkScene.getMaterialPhotosUrl(e) : "";
  }
  // Verifica se il material può caricare una cubemap per il tipo di proprietà specificato (type)
  canLoadCubemap(e, t) {
    return e ? e instanceof BABYLON.StandardMaterial && (t == "reflection" || t == "refraction") ? !0 : e instanceof BABYLON.PBRMetallicRoughnessMaterial || e instanceof BABYLON.PBRSpecularGlossinessMaterial ? t === "environment" : e instanceof BABYLON.PBRMaterial || e instanceof Zakeke.PBRMaterial ? t === "reflection" : e instanceof BABYLON.ShaderMaterial : t == "environment" || t == "skybox";
  }
  // Aggiorna la configurazione di ambiente impostando l'url di una texture caricata
  async setEnvironmentTexture(e, t, n, s) {
    t === "environment" ? await this.setSceneEnvironmentTexture(e, void 0, n, s) : t === "skybox" ? this.setViewerSkyboxTexture(e, n, s) : t === "ground" && this.setViewerGroundTexture(e);
  }
  removeSceneEnvironmentTexture() {
    this._scene && this._scene.environmentTexture && (this._scene.environmentTexture.dispose(), this._scene.environmentTexture = null, this._scene.metadata && this._scene.metadata.environmentTextureRotationY != null && delete this._scene.metadata.environmentTextureRotationY), this.setRenderingNeeded();
  }
  setSceneEnvironmentTextureRotationY(e) {
    this._scene && this._scene.environmentTexture && (this._scene.environmentTexture instanceof BABYLON.CubeTexture || this._scene.environmentTexture instanceof BABYLON.HDRCubeTexture) && (this._scene.environmentTexture.rotationY = e * Math.PI / 180, this.setLongRenderingNeeded());
  }
  // Crea e imposta la singola texture sul materiale per il tipo di proprietà specificato
  async setTextureImage(e, t, n, s) {
    return new Promise(async (o) => {
      if (this._scene && e && e instanceof Zakeke.SceneTexture) {
        const h = e.get("url");
        if (h)
          if (!t)
            await this.setEnvironmentTexture(h, n, void 0, void 0), o();
          else {
            const c = this.getMaterialTexture(t, n);
            let _ = !0;
            c && c instanceof BABYLON.Texture && (_ = c.invertY);
            const x = new BABYLON.Texture(
              h,
              this._scene,
              s,
              _,
              void 0,
              () => this.setRenderingNeeded()
            );
            c && c instanceof BABYLON.Texture && (x.uScale = c.uScale, x.vScale = c.vScale, x.uOffset = c.uOffset, x.vOffset = c.vOffset, x.uAng = c.uAng, x.vAng = c.vAng, x.level = c.level, x.coordinatesIndex = c.coordinatesIndex, x.coordinatesMode = c.coordinatesMode, x.hasAlpha = c.hasAlpha, x.wrapU = c.wrapU, x.wrapV = c.wrapV, x.gammaSpace = c.gammaSpace), mi.whenTextureIsReadyAsync(x).then(() => {
              this.applyTexture(x, t, n), c && !this.isTextureUsed(c) && c.dispose(), this.setRenderingNeeded(), o();
            });
          }
      }
    });
  }
  // Crea la cubemap e la imposta sul materiale e tipo di poprietà specificato
  async setCubeTextureImages(e, t, n) {
    return new Promise(async (s) => {
      (!this._scene || Object.prototype.toString.call(e) != "[object Array]") && s();
      for (let _ = 0; _ < e.length; _++) {
        const x = e[_];
        (!x || !(x instanceof Zakeke.SceneTexture)) && s();
      }
      const o = () => this.setLongRenderingNeeded();
      let h = null;
      const c = this.getCubeTextureInfo(e);
      if (c.url && this._scene)
        if (e.length === 1) {
          const _ = c.url;
          _ && (t ? _.endsWith(".dds") ? h = BABYLON.CubeTexture.CreateFromPrefilteredData(_, this._scene) : _.endsWith(".hdr") ? h = new BABYLON.HDRCubeTexture(
            _,
            this._scene,
            128,
            void 0,
            void 0,
            void 0,
            void 0,
            o
          ) : _.endsWith(".env") ? h = new BABYLON.CubeTexture(
            _,
            this._scene,
            null,
            !1,
            null,
            o,
            null,
            void 0,
            !0,
            void 0,
            !0
          ) : _.endsWith(".basis") && (h = BABYLON.CubeTexture.CreateFromPrefilteredData(_, this._scene)) : (await this.setEnvironmentTexture(_, n, void 0, void 0), this.setLongRenderingNeeded()));
        } else
          e.length === 6 && c.files.length === 6 && c.extensions.length === 6 && (t ? h = new BABYLON.CubeTexture(
            c.url,
            this._scene,
            c.extensions,
            !1,
            c.files,
            o
          ) : await this.setEnvironmentTexture(
            c.url,
            n,
            c.extensions,
            c.files
          ));
      h ? mi.whenTextureIsReadyAsync(h).then(() => {
        if (t) {
          const _ = this.getMaterialTexture(t, n);
          this.applyTexture(h, t, n), _ && !this.isTextureUsed(_) && _.dispose(), this.setRenderingNeeded();
        }
        s();
      }) : s();
    });
  }
  setMobileTextureImage(e, t, n, s) {
    if (this._scene && this._sceneHelper) {
      const o = e.get("url");
      if (o) {
        let h = null;
        t ? h = this.getMaterialTexture(t, n) : h = this._scene.environmentTexture, h !== null && this._sceneHelper.isTextureWithUrl(h) && (h.metadata || (h.metadata = {}), h.metadata.mobileUrl = o);
      }
    }
  }
  setMobileCubeTextureImages(e, t, n) {
    if (!this._scene || Object.prototype.toString.call(e) != "[object Array]")
      return;
    for (let o = 0; o < e.length; o++) {
      const h = e[o];
      if (!h || !(h instanceof Zakeke.SceneTexture))
        return;
    }
    const s = this.getCubeTextureInfo(e);
    if (s.url) {
      let o = null;
      t ? o = this.getMaterialTexture(t, n) : o = this._scene.environmentTexture, o && o instanceof BABYLON.CubeTexture && (o.metadata || (o.metadata = {}), o.metadata.mobileUrl = s.url, s.files.length === 6 && (o.metadata.mobileFiles = s.files, o.metadata.mobileExtensions = s.extensions));
    }
  }
  // Costruisce l'url della cubemap da utilizzare per la costruzione della texture di Babylon JS
  // Nel caso di cubemap con 6 immagini (_px _nx...), restituisce l'url senza il suffisso
  getCubeTextureInfo(e) {
    const t = {
      url: null,
      files: [],
      extensions: []
    };
    if (e.length === 1)
      t.url = e[0].get("url") || null;
    else if (e.length === 6) {
      const n = ["px", "py", "pz", "nx", "ny", "nz"];
      let s = null;
      const o = [], h = [], c = (B, P) => {
        const U = B.lastIndexOf(".");
        return U !== -1 ? B.substring(0, U).endsWith("_" + P) : !1;
      }, _ = (B, P) => {
        const U = B.lastIndexOf(".");
        if (U !== -1) {
          const M = B.substring(0, U);
          if (M.endsWith("_" + P))
            return M.substring(0, M.length - ("_" + P).length);
        }
        return null;
      }, x = (B, P) => {
        const U = B.lastIndexOf("_" + P);
        return U !== -1 ? B.substr(U) : null;
      };
      for (let B = 0; B < n.length; B++) {
        const P = n[B];
        for (let U = 0; U < e.length; U++) {
          const M = e[U].get("url");
          if (M && c(M, P)) {
            o.push(M);
            const Z = x(M, P);
            Z && h.push(Z), s || (s = _(M, P));
            break;
          }
        }
      }
      t.url = s, t.files = o, t.extensions = h;
    }
    return t;
  }
  isTextureUsed(e) {
    if (this._scene && e)
      for (let t = 0; t < this._scene.materials.length; t++) {
        const s = this._scene.materials[t].getActiveTextures();
        for (let o = 0; o < s.length; o++)
          if (s[o].uid === e.uid)
            return !0;
      }
    return !1;
  }
  async changeTextureInvertYAsync(e, t, n) {
    if (this._scene && this._sceneHelper) {
      var s = this._sceneHelper.getMaterialTexture(e, t);
      if (s && s instanceof BABYLON.Texture && s.invertY != n) {
        let h = s.url;
        if (h) {
          let c = h;
          if (!/^(?:\/|[a-z]+:\/\/)/.test(h)) {
            var o = await this.getSceneRootUrl();
            o && (c = o + h);
          }
          const x = new BABYLON.Texture(
            c,
            this._scene,
            void 0,
            n,
            void 0,
            () => this.setRenderingNeeded()
          );
          s && s instanceof BABYLON.Texture && (x.uScale = s.uScale, x.vScale = s.vScale, x.uOffset = s.uOffset, x.vOffset = s.vOffset, x.uAng = s.uAng, x.vAng = s.vAng, x.level = s.level, x.coordinatesIndex = s.coordinatesIndex, x.coordinatesMode = s.coordinatesMode, x.hasAlpha = s.hasAlpha, x.wrapU = s.wrapU, x.wrapV = s.wrapV, x.gammaSpace = s.gammaSpace), await mi.whenTextureIsReadyAsync(x), this.applyTexture(x, e, t), s && !this.isTextureUsed(s) && s.dispose(), this.setRenderingNeeded();
        }
      }
    }
  }
  applyTextureByName(e, t, n) {
    if (this._scene) {
      const s = this._scene.textures.find((o) => o.name === e);
      s && this.applyTexture(s, t, n);
    }
  }
  applyTexture(e, t, n) {
    if (e && n == "lightmap" && (e.coordinatesIndex = 1, (t instanceof BABYLON.StandardMaterial || t instanceof BABYLON.PBRMaterial || t instanceof BABYLON.PBRBaseSimpleMaterial) && (t.useLightmapAsShadowmap = !0)), t instanceof BABYLON.StandardMaterial)
      switch (n) {
        case "diffuse":
          t.diffuseTexture = e;
          break;
        case "emissive":
          t.emissiveTexture = e;
          break;
        case "ambient":
          t.ambientTexture = e;
          break;
        case "lightmap":
          t.lightmapTexture = e;
          break;
        case "opacity":
          t.opacityTexture = e;
          break;
        case "specular":
          t.specularTexture = e;
          break;
        case "reflection":
          t.reflectionTexture = e;
          break;
        case "refraction":
          t.refractionTexture = e;
          break;
        case "bump":
          t.bumpTexture = e;
          break;
      }
    else if (t instanceof BABYLON.PBRMetallicRoughnessMaterial)
      switch (n) {
        case "environment":
        case "normal":
        case "emissive":
        case "occlusion":
        case "base":
        case "metallicRoughness":
          t[`${n}Texture`] = e;
          break;
      }
    else if (t instanceof BABYLON.PBRSpecularGlossinessMaterial)
      switch (n) {
        case "environment":
        case "normal":
        case "emissive":
        case "occlusion":
        case "diffuse":
        case "specularGlossiness":
          t[`${n}Texture`] = e;
          break;
      }
    else if (t instanceof BABYLON.PBRMaterial)
      switch (n) {
        case "cameraColorGrading":
          t.cameraColorGradingTexture = e;
          break;
        case "albedo":
        case "ambient":
        case "opacity":
        case "reflection":
        case "emissive":
        case "reflectivity":
        case "metallic":
        case "microSurface":
        case "bump":
        case "lightmap":
          t[`${n}Texture`] = e;
          break;
        case "refraction":
          t.refractionTexture = e;
          break;
        case "environmentBRDF":
          t.environmentBRDFTexture = e;
          break;
        case "clearCoat_texture":
          t.clearCoat.texture = e;
          break;
        case "clearCoat_bump":
          t.clearCoat.bumpTexture = e;
          break;
        case "clearCoat_tint":
          t.clearCoat.tintTexture = e;
          break;
        case "clearCoat_textureRoughness":
          t.clearCoat.textureRoughness = e;
          break;
        case "anisotropy_texture":
          t.anisotropy.texture = e;
          break;
        case "sheen_texture":
          t.sheen.texture = e;
          break;
        case "sheen_textureRoughness":
          t.sheen.textureRoughness = e;
          break;
        case "subSurface_thickness":
          t.subSurface.thicknessTexture = e;
          break;
        case "subSurface_translucencyIntensity":
          t.subSurface.translucencyIntensityTexture = e;
          break;
        case "subSurface_refractionIntensity":
          t.subSurface.refractionIntensityTexture = e;
          break;
      }
    else if (t instanceof BABYLON.ShaderMaterial)
      e && e instanceof BABYLON.Texture ? t.setTexture(n, e) : t.removeTexture(n);
    else if (t instanceof Zakeke.PBRMaterial)
      switch (n) {
        case "albedo":
          t.albedoTexture = e;
          break;
        case "bump":
          t.bumpTexture = e;
          break;
        case "reflection":
          t.reflectionTexture = e;
          break;
        case "matCapReflection":
          t.matCapReflectionTexture = e;
          break;
        case "reflectivity":
          t.reflectivityTexture = e;
          break;
        case "microsurface":
          t.microsurfaceTexture = e;
          break;
        case "ambient":
          t.ambientTexture = e;
          break;
        case "ao":
          t.aoTexture = e;
          break;
        case "opacity":
          t.opacityTexture = e;
          break;
      }
    this.setLongRenderingNeeded();
  }
  getMaterialTexture(e, t) {
    if (e instanceof BABYLON.StandardMaterial)
      switch (t) {
        case "diffuse":
          return e.diffuseTexture;
        case "emissive":
          return e.emissiveTexture;
        case "ambient":
          return e.ambientTexture;
        case "lightmap":
          return e.lightmapTexture;
        case "opacity":
          return e.opacityTexture;
        case "specular":
          return e.specularTexture;
        case "reflection":
          return e.reflectionTexture;
        case "refraction":
          return e.refractionTexture;
        case "bump":
          return e.bumpTexture;
      }
    else if (e instanceof BABYLON.PBRMetallicRoughnessMaterial)
      switch (t) {
        case "environment":
          return e.environmentTexture;
        case "normal":
          return e.normalTexture;
        case "emissive":
          return e.emissiveTexture;
        case "occlusion":
          return e.occlusionTexture;
        case "base":
          return e.baseTexture;
        case "metallicRoughness":
          return e.metallicRoughnessTexture;
      }
    else if (e instanceof BABYLON.PBRSpecularGlossinessMaterial)
      switch (t) {
        case "environment":
          return e.environmentTexture;
        case "normal":
          return e.normalTexture;
        case "emissive":
          return e.emissiveTexture;
        case "occlusion":
          return e.occlusionTexture;
        case "diffuse":
          return e.diffuseTexture;
        case "specularGlossiness":
          return e.specularGlossinessTexture;
      }
    else if (e instanceof BABYLON.PBRMaterial)
      switch (t) {
        case "cameraColorGrading":
          return e.cameraColorGradingTexture;
        case "albedo":
          return e.albedoTexture;
        case "ambient":
          return e.ambientTexture;
        case "opacity":
          return e.opacityTexture;
        case "reflection":
          return e.reflectionTexture;
        case "emissive":
          return e.emissiveTexture;
        case "reflectivity":
          return e.reflectivityTexture;
        case "metallic":
          return e.metallicTexture;
        case "microSurface":
          return e.microSurfaceTexture;
        case "bump":
          return e.bumpTexture;
        case "lightmap":
          return e.lightmapTexture;
        case "refraction":
          return e.refractionTexture;
        case "clearCoat":
          return e.clearCoat.texture;
        case "clearCoat_bump":
          return e.clearCoat.bumpTexture;
        case "clearCoat_tint":
          return e.clearCoat.tintTexture;
        case "clearCoat_textureRoughness":
          return e.clearCoat.textureRoughness;
        case "clearCoat_texture":
          return e.clearCoat.texture;
        case "anisotropy_texture":
          return e.anisotropy.texture;
        case "sheen_texture":
          return e.sheen.texture;
        case "sheen_textureRoughness":
          return e.sheen.textureRoughness;
        case "subSurface_thickness":
          return e.subSurface.thicknessTexture;
        case "subSurface_refractionIntensity":
          return e.subSurface.refractionIntensityTexture;
        case "subSurface_translucencyIntensity":
          return e.subSurface.translucencyIntensityTexture;
      }
    else if (e instanceof Zakeke.PBRMaterial)
      switch (t) {
        case "albedo":
          return e.albedoTexture;
        case "bump":
          return e.bumpTexture;
        case "reflection":
          return e.reflectionTexture;
        case "matCapReflection":
          return e.matCapReflectionTexture;
        case "reflectivity":
          return e.reflectivityTexture;
        case "microsurface":
          return e.microsurfaceTexture;
        case "ambient":
          return e.ambientTexture;
        case "ao":
          return e.aoTexture;
        case "opacity":
          return e.opacityTexture;
      }
    return null;
  }
  removeMaterialTexture(e, t) {
    this.applyTexture(null, e, t);
  }
  removeMaterialMobileTexture(e, t) {
    const n = this.getMaterialTexture(e, t);
    n && n.metadata && n.metadata.mobileUrl && (delete n.metadata.mobileUrl, n.metadata.hasOwnProperty("mobileFiles") && delete n.metadata.mobileFiles, n.metadata.hasOwnProperty("mobileExtensions") && delete n.metadata.mobileExtensions, Object.keys(n.metadata).length === 0 && n.metadata.constructor === Object && delete n.metadata);
  }
  //#endregion
  //#region Operazioni sugli elementi della scena
  /**
   * Create a group of meshes
   * @param parentId Id of the parent node of the group
   * @param name Name of the group
   * @param children Array of meshes to be included in the group
   */
  createGroup(e, t, n) {
    if (this._scene) {
      const s = new BABYLON.Mesh(t, this._scene);
      if (s.id = Zakeke.generateUUID(), s.metadata = {
        isRealMesh: !0,
        isGroup: !0
      }, e) {
        const o = this._scene.getMeshByID(e);
        o && (s.parent = o);
      }
      return n && n.forEach((o) => o.parent = s), this.fireMeshesUpdateEvent(), s;
    }
    return null;
  }
  deleteMesh(e, t) {
    const n = { meshIDs: [], materialIDs: [] };
    if (this._scene && this._sceneHelper && this._zkScene) {
      const s = this._scene, o = this._sceneHelper, h = this._zkScene, c = s.getMeshByID(e);
      if (c) {
        const _ = (B) => {
          const P = this.getMeshMaterials(B);
          for (let U = 0; U < P.length; U++) {
            const M = P[U];
            if (!M)
              continue;
            const Z = this.getMeshesUsingMaterial(M.id);
            Z.length === 1 && Z.every((F) => o.meshHasParent(F.id, c.id)) && (n.materialIDs.push(P[U].id), P[U].dispose());
          }
          B.getChildMeshes().forEach((U) => _(U));
        };
        t && (_(c), this.fireMaterialsUpdateEvent());
        const x = o.getCameraPivot();
        x && x === c && this.setCameraPivot(null), this.isMeshSelected(c) && this.unselectMesh(c.id), c.dispose(), n.meshIDs.push(e);
      }
      this.fireMeshesUpdateEvent(), this.setRenderingNeeded(), n.materialIDs.forEach((_) => {
        const x = h.getLibraryShaderMaterialIDForSceneMaterial(_);
        x && h.unregisterShaderMaterial(x);
      });
    }
    return n;
  }
  // Cancella tutte le mesh
  deleteAllMeshes() {
    if (this._scene && this._sceneHelper) {
      for (let e = 0; e < this._scene.meshes.length; e++) {
        const t = this._scene.meshes[e];
        this._sceneHelper.isRealMesh(t) && (this._scene.meshes.splice(e--, 1), t.dispose());
      }
      this.setCameraPivot(null), this.setRenderingNeeded();
    }
  }
  deleteDuplicatedMeshesWithDifferentParent(e, t) {
    const n = { meshIDs: [], materialIDs: [] };
    if (this._scene && this._sceneHelper && this._zkScene) {
      const s = this._scene, o = this._sceneHelper, h = this._zkScene, c = (x) => {
        const B = this.getSceneMeshesByName(x.name);
        let P = !1;
        for (let M = 0; M < B.length; M++) {
          var U = B[M];
          if (U.id != x.id && !o.meshHasParent(U.id, e)) {
            if (t) {
              const Z = this.getMeshMaterials(U);
              for (let F = 0; F < Z.length; F++)
                this.getMeshesUsingMaterial(Z[F].id).length == 1 && (n.materialIDs.push(Z[F].id), Z[F].dispose());
            }
            n.meshIDs.push(U.id), U.dispose(), B.splice(M--, 1), P = !0;
            break;
          }
        }
        P || x.getChildMeshes().forEach((M) => c(M));
      }, _ = s.getMeshByID(e);
      _ && _.getChildMeshes().forEach((x) => c(x)), this.setRenderingNeeded(), n.materialIDs.forEach((x) => {
        const B = h.getLibraryShaderMaterialIDForSceneMaterial(x);
        B && h.unregisterShaderMaterial(B);
      });
    }
    return n;
  }
  // Cancella tutte le mesh figlie di quella in input
  // che hanno lo stesso nome di altre mesh con id diverso
  // Questa funzione può essere utile per elminiare oggetti duplicati importati
  // con file diversi
  deleteDuplicatedChildMeshes(e, t) {
    const n = { meshIDs: [], materialIDs: [] };
    if (this._scene && this._sceneHelper && this._zkScene) {
      const s = this._scene, o = this._sceneHelper, h = this._zkScene, c = (x) => {
        const B = this.getSceneMeshesByName(x.name);
        let P = !1;
        for (let U = 0; U < B.length; U++) {
          const M = B[U];
          if (M.id != x.id && !o.meshHasParent(M.id, e)) {
            if (t) {
              const Z = this.getMeshMaterials(x);
              for (let F = 0; F < Z.length; F++)
                this.getMeshesUsingMaterial(Z[F].id).length == 1 && (n.materialIDs.push(Z[F].id), Z[F].dispose());
            }
            n.meshIDs.push(x.id), x.dispose(), P = !0;
            break;
          }
        }
        if (!P) {
          const U = x.getChildMeshes();
          for (let M = 0; M < U.length; M++)
            c(U[M]);
        }
      }, _ = s.getMeshByID(e);
      _ && _.getChildMeshes().forEach((x) => c(x)), this.setRenderingNeeded(), n.materialIDs.forEach((x) => {
        const B = h.getLibraryShaderMaterialIDForSceneMaterial(x);
        B && h.unregisterShaderMaterial(B);
      });
    }
    return n;
  }
  deleteMaterial(e) {
    if (this._scene && this._sceneHelper) {
      const t = this._scene.getMaterialByID(e);
      t && (this.deleteMaterialInternal(t), this.fireMaterialsUpdateEvent(), this.setRenderingNeeded());
    }
  }
  deleteMaterialInternal(e) {
    if (this._scene && this._sceneHelper && e) {
      const t = e.id;
      if (this._zkScene) {
        const s = this._zkScene.getLibraryShaderMaterialIDForSceneMaterial(e.id);
        s && this._zkScene.unregisterShaderMaterial(s);
      }
      const n = this._sceneHelper.getTexturesExclusivelyForMaterial(e);
      e.dispose();
      for (let s = 0; s < n.length; s++)
        n[s].dispose();
      this._sceneHelper.removeSceneMaterialMetadata(t);
    }
  }
  deleteAllMaterials() {
    if (this._scene) {
      for (; this._scene.materials.length > 0; ) {
        const e = this._scene.materials.pop();
        e && this.deleteMaterialInternal(e);
      }
      this.fireMaterialsUpdateEvent(), this.setRenderingNeeded(), this.fireMaterialsUpdateEvent();
    }
  }
  renameMaterial(e, t) {
    if (this._scene) {
      const n = this._scene.getMaterialByID(e);
      n && (n.name = t), this.fireMaterialsUpdateEvent();
    }
  }
  cloneMesh(e) {
    let t = null;
    return this._scene && this._sceneHelper && (t = this._sceneHelper.cloneMesh(e, !1, !1), this.setRenderingNeeded(), this.fireMeshesUpdateEvent()), t;
  }
  // Same as clone but with duplicated geometry data too
  duplicateMesh(e, t = !1) {
    let n = null;
    return this._scene && this._sceneHelper && (n = this._sceneHelper.cloneMesh(e, !0, t), this.setRenderingNeeded(), this.fireMeshesUpdateEvent()), n;
  }
  cloneMaterial(e, t, n) {
    let s = null;
    if (this._scene && this._sceneHelper) {
      const h = this._scene.getMaterialById(e);
      if (h) {
        const c = n || h.name + " - clone";
        if (s = h.clone(c), s) {
          const _ = t || Zakeke.generateUUID();
          s.id = _;
          const x = this._sceneHelper.getTexturesForMaterial(h), B = this._sceneHelper.getTexturesForMaterial(s);
          for (let P = 0; P < B.length; P++) {
            const U = B[P], M = x[P];
            M && M.metadata && (U.metadata = JSON.parse(JSON.stringify(M.metadata)));
          }
          if (this._zkScene) {
            const P = this._zkScene.getMappingForSceneMaterial(h.id);
            if (P) {
              var o = P.get("libraryMaterialID");
              this._zkScene.mapLibraryMaterial(o, s.id);
              const U = this._sceneHelper.getTexturesForMaterial(h), M = this._sceneHelper.getTexturesForMaterial(s);
              for (let Z = 0; Z < M.length; Z++) {
                const F = M[Z], Q = U[Z];
                F.materialMapping = Q.materialMapping;
              }
            }
          }
        }
      }
      this.setRenderingNeeded(), this.fireMaterialsUpdateEvent();
    }
    return s;
  }
  createMaterial(e, t, n) {
    let s = null;
    if (this._scene) {
      const o = e || "new material", h = t || "Standard";
      h === "Standard" ? s = new BABYLON.StandardMaterial(o, this._scene) : h === "PBRMetallicRoughness" ? (s = new BABYLON.PBRMetallicRoughnessMaterial(o, this._scene), s.subSurface.indexOfRefraction = 1, s._imageProcessingConfiguration.contrast = 1) : h === "PBRSpecularGlossiness" ? s = new BABYLON.PBRSpecularGlossinessMaterial(o, this._scene) : h === "PBR" ? (s = new BABYLON.PBRMaterial(o, this._scene), s.enableSpecularAntiAliasing = !0, s.metallic = 0.9, s.roughness = 0.3, s.indexOfRefraction = 1.5) : h === "NewPBR" && (s = new Zakeke.PBRMaterial(o, this._scene)), s && (s.id = Zakeke.generateUUID(), n && (s.metadata || (s.metadata = {}), s.metadata.group = n)), this.checkSceneEmptyEnvironmentTexture(), this.setRenderingNeeded(), this.fireMaterialsUpdateEvent();
    }
    return s;
  }
  changeMeshParent(e, t) {
    if (this._scene) {
      const n = this._scene.getMeshById(e);
      if (n && (!n.parent || n.parent.id != t)) {
        const s = this._scene.getMeshById(t);
        n.setParent(s), this.setRenderingNeeded(), this.fireMeshesUpdateEvent();
      }
    }
  }
  removeMeshParent(e) {
    if (this._scene) {
      const t = this._scene.getMeshByID(e);
      t && (t.parent = null, this.fireMeshesUpdateEvent());
    }
  }
  setManipulatedNode(e) {
    e !== this._manipulatedNode && (this._manipulatedNode = e, this.showHideEditControl(this._editControlVisible), this.setRenderingNeeded());
  }
  importLibraryMaterial(e) {
    if (this._scene && this._sceneHelper && this._zkScene && e && e instanceof Zakeke.Material) {
      e.get("shaders") && this.checkShaderMaterial(e);
      const n = e.get("JSON") || e.get("json"), s = e.get("rootUrl");
      if (n && s) {
        const o = JSON.parse(n), h = BABYLON.Material.Parse(o, this._scene, s);
        if (h) {
          if (h.id = Zakeke.generateUUID(), this._zkScene.mapLibraryMaterial(e.getMaterialID(), h.id), e.get("shaders")) {
            const x = e.get("shaders"), B = x.get("name"), P = x.get("vertex"), U = x.get("fragment");
            B && P && U && this._zkScene.registerShaderMaterial(
              e.getMaterialID(),
              B,
              P,
              U
            ), this.setupShaderMaterialCameraPosition(h);
          }
          e.get("sourceTextureImages").forEach(async (x) => {
            var P, U;
            if ((P = this._zkScene) != null && P.get("textures").find((M) => M.get("url") === x.get("url")))
              return;
            let B = new Zakeke.SceneTexture();
            B.set("textureID", Zakeke.generateUUID()), B.set("materialID", h.id), B.set("fileObjectID", x.get("fileObjectID")), B.set("fileLength", (x == null ? void 0 : x.get("fileLength")) || -1), B.set("url", x.get("url")), (U = this.zkScene) == null || U.get("textures").push(B);
          });
          const _ = this._sceneHelper.getTexturesForMaterial(h);
          for (let x = 0; x < _.length; x++) {
            var t = _[x];
            t.materialMapping = {
              libraryMaterialRootUrl: s,
              libraryMaterialID: e.getMaterialID(),
              sceneMaterialID: h.id
            }, t.url && !t.url.startsWith("http") && (t.name = t.url, t.url = s + t.url), t.metadata && t.metadata.mobileUrl && !t.metadata.mobileUrl.startsWith("http") && (t.metadata.mobileUrl = s + t.metadata.mobileUrl);
          }
        }
      }
      this.fireMaterialsUpdateEvent(), this.setRenderingNeeded();
    }
  }
  //#endregion
  //#region Recupero Texture
  // I metodi per il recupero delle texture sono stati spostati in SceneHelper
  // Li lascio qui solo momentaneamente
  getTexturesForMaterial(e) {
    return this._sceneHelper ? this._sceneHelper.getTexturesForMaterial(e) : [];
  }
  getStandardMaterialTextures(e) {
    return this._sceneHelper ? this._sceneHelper.getStandardMaterialTextures(e) : [];
  }
  getPBRBaseSimpleMaterialTextures(e) {
    return this._sceneHelper ? this._sceneHelper.getPBRBaseSimpleMaterialTextures(e) : [];
  }
  getPBRMaterialTextures(e) {
    return this._sceneHelper ? this._sceneHelper.getPBRMaterialTextures(e) : [];
  }
  getNewPBRMaterialTextures(e) {
    return this._sceneHelper ? this._sceneHelper.getNewPBRMaterialTextures(e) : [];
  }
  getPBRMetallicRoughnessMaterialTextures(e) {
    return this._sceneHelper ? this._sceneHelper.getPBRMetallicRoughnessMaterialTextures(e) : [];
  }
  getPBRSpecularGlossinessMaterialTextures(e) {
    return this._sceneHelper ? this._sceneHelper.getPBRSpecularGlossinessMaterialTextures(e) : [];
  }
  //#endregion
  //#region Camera Location
  removeCameraLocation(e) {
    var t;
    (t = this._zkScene) == null || t.get("cameraLocations").remove(e), this.fireCameraLocationsUpdateEvent();
  }
  saveCameraLocation(e) {
    if (this._zkScene && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      const t = this._camera.position, n = this._camera.target, s = new Zakeke.SceneCameraLocation();
      s.set("name", e), s.set("px", t.x), s.set("py", t.y), s.set("pz", t.z), s.set("tx", n.x), s.set("ty", n.y), s.set("tz", n.z), this._zkScene.get("cameraLocations").push(s), this.fireCameraLocationCreatedEvent(s), this.fireCameraLocationsUpdateEvent();
    }
  }
  clearCameraLocations() {
    if (this._zkScene) {
      const e = this._zkScene.get("cameraLocations");
      for (; e.length > 0; )
        e.remove(e.at(0));
      this.fireCameraLocationsUpdateEvent();
    }
  }
  //public setCameraLocation(locationID: string) {
  //    if (this._sceneHelper && this._zkScene) {
  //        const zkCameraLocation = this._zkScene.getCameraLocation(locationID);
  //        if (zkCameraLocation) {
  //            const position = new BABYLON.Vector3(zkCameraLocation.get("px"), zkCameraLocation.get("py"), zkCameraLocation.get("pz"));
  //            const target = new BABYLON.Vector3(zkCameraLocation.get("tx"), zkCameraLocation.get("ty"), zkCameraLocation.get("tz"));
  //            this._sceneHelper.animateCamera(target, position, 0.5);
  //        }
  //    }
  //    this.setRenderingNeeded();
  //}
  getAllCameraLocations() {
    const e = [];
    if (this._zkScene)
      for (let t = 0; t < this._zkScene.get("cameraLocations").length; t++)
        e.push(this._zkScene.get("cameraLocations").at(t));
    return e;
  }
  //#endregion
  //#region Collapse / Explode (Mesh Locations)
  saveMeshLocation(e) {
    this._meshLocationsManager && this._meshLocationsManager.saveMeshLocation(e);
  }
  saveExplodedMeshLocation() {
    this._meshLocationsManager && this._meshLocationsManager.saveExplodedMeshLocation();
  }
  saveCollapsedMeshLocation() {
    this._meshLocationsManager && this._meshLocationsManager.saveCollapsedMeshLocation();
  }
  onBeforeSaveMeshLocation() {
    this._oldManipulatedNode = this._manipulatedNode, this.setManipulatedNode(null);
  }
  onAfterSaveMeshLocation() {
    this.fireMeshLocationsUpdateEvent(), this.setManipulatedNode(this._oldManipulatedNode);
  }
  clearMeshLocations() {
    this._meshLocationsManager && this._meshLocationsManager.clearMeshLocations();
  }
  getAllMeshLocations() {
    const e = [];
    if (this._zkScene)
      for (let t = 0; t < this._zkScene.get("meshLocations").length; t++)
        e.push(this._zkScene.get("meshLocations").at(t));
    return e;
  }
  //#endregion
  //#region Material Library
  // Nota Bene
  // E' un po' incasinato, c'è da mettere ordine, primo abbozzo di implementazione.
  // Il problema principale è la gestione delle texture
  // che possono provenire da fonti diverse (sorgenti, librerie e caricate singolarmente dall'utente).
  // In breve: innanzitutto scatta una screenshot del materiale. per fare questo nasconde tutte le mesh,
  // crea una sfera temporanea e una camera temporanea prende la screenshot e poi rattiva le mesh così
  // come erano inialmente. Poi, clona il materiale iniziale (babylon) e lo associa ad un nuovo materiale lato server (zkMaterial).
  // Recupera le texture (babylon) associate al materiale di scena.
  // Per copiare le immagini lato server, recupera i fileObjectID per ognuna delle texture.
  // (Per una texture babylon possono esserci più file fileObjectID associati. Ad esempio, per una cubemap, ci saranno 6 fileObjectID associati.)
  // Per ogni fileObjectID, memorizza su skMaterial anche la provenienza, in modo che lato server il path possa essere costruito correttamente.
  // Salva il nuovo zkMaterial (lato server avverrà la copia dei file di immagini texture).
  // Alla fine elimina il nuovo materiale creato come clone.
  makeLibraryMaterial(e, t) {
    return new Promise((n, s) => {
      this.getMaterialScreenShotForLibrary(e, (o) => {
        o ? this.createLibraryMaterial(e, t, o, n) : s("No data generated for screenshot");
      });
    });
  }
  getMaterialScreenShotForLibrary(e, t) {
    if (this._scene && this._sceneHelper) {
      this.resetEditorEnvironment(), this.removeGround(), this._environmentManager && (this._environmentManager.dispose(), this._environmentManager = null);
      const n = 500, s = 500;
      this._sceneHelper.takeMaterialScreenshotAsync(e, n, s).then((o) => {
        vw(o, n, s, (h) => {
          this.refreshEnvironment(), t && t(h);
        });
      });
    } else
      t && t(null);
  }
  createLibraryMaterial(e, t, n, s) {
    let o = null;
    const h = () => {
      o && this.deleteMaterial(o.id), s && s();
    };
    if (!this._scene || !this._sceneHelper || !this._zkScene) {
      h();
      return;
    }
    const c = this._scene, _ = this._sceneHelper, x = this._zkScene;
    if (!c.getMaterialById(e)) {
      h();
      return;
    }
    const P = new Zakeke.Material();
    P.set("name", t), P.set("imageData", n);
    let U = e, M = U.replace(/-/g, "");
    const Z = P.getMaterialID(), F = Z.replace(/-/g, "");
    if (o = this.cloneMaterial(e, Z, t), !o) {
      h();
      return;
    }
    const Q = x.getSourcesIDs(), D = _.getTexturesForMaterial(o), te = [];
    for (let je = 0; je < D.length; je++) {
      const ke = D[je];
      if (ke.materialMapping) {
        const Ye = ke.materialMapping.libraryMaterialID;
        Ye && te.push(Ye);
      }
    }
    let ee = new Zakeke.Materials();
    const le = ["px", "py", "pz", "nx", "ny", "nz"], fe = function(je) {
      const ke = je.lastIndexOf(".");
      if (ke !== -1) {
        const Ye = je.substring(0, ke);
        if (le.some((pt) => Ye.endsWith("_" + pt)))
          return Ye.substring(0, Ye.length - 3);
      }
      return je;
    }, X = (je, ke) => fe(je).endsWith(ke), W = async () => {
      var ke;
      for (let Ye = 0; Ye < D.length; Ye++) {
        const pt = D[Ye];
        if (pt && _.isTextureWithUrl(pt) && pt.url) {
          let Le = null, $e = null;
          for (let We = 0; We < Q.length; We++) {
            const It = Q[We].replace(/-/g, "");
            if (pt.url.indexOf(It) != -1) {
              Le = Q[We], $e = It;
              break;
            }
          }
          const ce = [];
          for (let We = 0; We < x.get("textures").length; We++) {
            const It = x.get("textures").at(We);
            It.get("url") && X(It.get("url"), pt.url) && ce.push({
              fileObjectID: It.get("fileObjectID"),
              url: It.get("url"),
              fileLength: It.get("fileLength")
            });
          }
          const ht = (pt.url.startsWith("http") ? pt.url : x.get("rootUrl") + pt.url) || "";
          ht && ce.filter((We) => We.url === ht).length === 0 && ce.push({
            url: ht,
            fileLength: ((ke = pt == null ? void 0 : pt._texture) == null ? void 0 : ke._size) || -1
          });
          for (let We = 0; We < ce.length; We++) {
            const It = new Zakeke.MaterialSourceTextureImage();
            It.set("fileObjectID", ce[We].fileObjectID), It.set("url", ce[We].url || ""), It.set("fileLength", ce[We].fileLength || -1), Le ? (It.set("sceneID", x.getSceneID()), It.set("sourceID", Le)) : (It.set("sceneID", x.getSceneID()), It.set("materialID", U)), P.get("sourceTextureImages").push(It);
          }
          if (pt.metadata && pt.metadata.mobileUrl) {
            const We = pt.metadata.mobileUrl, It = new Zakeke.MaterialSourceTextureImage(), rt = We.startsWith("http") ? We : (P.get("rootUrl") || x.get("rootUrl")) + We;
            if (It.set("url", rt), It.set("sceneID", x.getSceneID()), It.set("materialID", U), P.get("sourceTextureImages").push(It), console.log("#2 scene texture", pt), pt.metadata && pt.metadata.mobileUrl) {
              const tt = pt.metadata.mobileUrl;
              pt.metadata.mobileUrl = "textures/" + F + "/" + tt.substring(tt.lastIndexOf("/") + 1);
            }
          }
          let De = "", ft = "", Yt = pt.name;
          if (Le && $e) {
            const We = pt.url.indexOf($e);
            We != -1 && (Yt = pt.url.substring(We)), De = $e, ft = "textures/" + F, pt.name = Yt.replace(new RegExp(De, "g"), ft);
          } else {
            var je = pt.url.lastIndexOf("/");
            je !== -1 && (je = pt.url.lastIndexOf("/", je - 1), je !== -1 && (je = pt.url.lastIndexOf("/", je - 1), je != -1 && (Yt = pt.url.substring(je + 1)))), De = M, ft = F, pt.name = Yt.replace(
              new RegExp("textures/([A-Za-z0-9]*)/(.*)", "g"),
              "textures/" + ft + "/$2"
            );
          }
          pt.url = pt.name;
        }
      }
      if (o) {
        const Ye = o.serialize(), pt = JSON.stringify(Ye);
        P.set("JSON", pt), P.save(null, {
          success: function(Le, $e, ce) {
            h();
          },
          error: function(Le, $e, ce) {
            h();
          }
        });
      } else
        h();
    };
    if (te.length > 0) {
      const je = { ids: te.join(",") };
      try {
        ee.fetch({
          success: (ke, Ye, pt) => {
            ee = ke, W();
          },
          error: (ke, Ye, pt) => {
            Logger.info("Errore nel salvataggio del materiale di libreria"), h();
          },
          data: je
        });
      } catch {
      }
    } else
      W();
  }
  //#endregion
  //#region Lights
  lightsLayer_onLightSelected(e) {
    this.fireLightSelectedEvent(e);
  }
  isDefaultLight(e) {
    return this._sceneHelper ? this._sceneHelper.isDefaultLight(e) : !1;
  }
  createLight(e, t) {
    let n = null;
    if (this._scene) {
      const s = e || "new light", o = t || "Point", h = BABYLON.Vector3.Zero(), c = BABYLON.Vector3.Zero(), _ = 25 * Math.PI / 180, x = 2;
      o == "Point" ? n = new BABYLON.PointLight(s, h, this._scene) : o == "Directional" ? n = new BABYLON.DirectionalLight(s, c, this._scene) : o == "Spot" ? n = new BABYLON.SpotLight(s, h, c, _, x, this._scene) : o == "Hemispheric" && (n = new BABYLON.HemisphericLight(s, c, this._scene)), n && (n.id = Zakeke.generateUUID()), this._lightsLayer && this._lightsLayer.refresh(), this.setRenderingNeeded(), this.fireLightsUpdateEvent();
    }
    return n;
  }
  cloneLight(e, t, n) {
    let s = null;
    if (this._scene) {
      const o = this._scene.getLightByID(e);
      if (o) {
        const h = n || o.name + " - clone";
        if (s = o.clone(h), s) {
          s.name = h;
          const c = t || Zakeke.generateUUID();
          s.id = c, this._lightsLayer && this._lightsLayer.refresh();
        }
      }
      this.setRenderingNeeded(), this.fireLightsUpdateEvent();
    }
    return s;
  }
  renameLight(e, t) {
    if (this._scene) {
      const n = this._scene.getLightByID(e);
      n && (n.name = t, this._lightsLayer && this._lightsLayer.refresh()), this.fireLightsUpdateEvent();
    }
  }
  deleteLight(e) {
    if (this._scene) {
      const t = this._scene.getLightByID(e);
      t && (t.dispose(), this._scene.meshes.forEach((n) => n._markSubMeshesAsLightDirty()), this._lightsLayer && this._lightsLayer.refresh()), this.setRenderingNeeded(), this.fireLightsUpdateEvent();
    }
  }
  getAllLights() {
    return this._scene ? this._scene.lights : [];
  }
  canShowLights() {
    return this._showLights && this._envMode == Er.Editor;
  }
  showHideLights(e) {
    this._showLights = e, this._lightsLayer && this._lightsLayer.refresh(), this.setRenderingNeeded();
  }
  //#endregion
  //#region Ground
  canShowGround() {
    return this._showGround && this._envMode == Er.Editor;
  }
  removeGround() {
    this._ground && (this._ground.dispose(), this._ground = null), this.setRenderingNeeded();
  }
  refreshGround() {
    if (!this._scene)
      return;
    if (this.removeGround(), !this.canShowGround()) {
      this.setRenderingNeeded();
      return;
    }
    const e = this._scene.clearColor, t = e.toHexString(), n = mw(t) ? 0.8 : -0.5, s = BABYLON.Color3.FromHexString(_w(t, n));
    let o = 1e3, h = 1;
    if (this.countSceneMeshes() > 0) {
      const _ = this._scene.getWorldExtends((P) => this.isRealMesh(P)), B = _.max.subtract(_.min).length() * 1.5;
      isFinite(B) && (o = B * 20, h = o / 100);
    }
    this._ground = BABYLON.Mesh.CreateGround("ground", o, o, 10, this._scene), this._ground.doNotSerialize = !0, this._ground.isVisible = this.showGround, this._ground.isPickable = !1, this._ground.metadata = {
      isRealMesh: !1,
      isGround: !0
    };
    const c = new BABYLON.GridMaterial("groundMaterial", this._scene);
    c.doNotSerialize = !0, c.backFaceCulling = !1, c.mainColor = new BABYLON.Color3(e.r, e.g, e.b), c.opacity = 1, c.gridRatio = h, c.lineColor = s, c.metadata = { isRealMaterial: !1 }, this._ground.material = c, this.setRenderingNeeded();
  }
  showHideGround(e) {
    this.showGround = e, this.refreshGround();
  }
  //#endregion
  //#region Axes
  canShowAxes() {
    return this._showAxes && this._envMode == Er.Editor;
  }
  showHideAxes(e) {
    this._showAxes = e, this._axesLayer && this._axesLayer.refresh(), this.setRenderingNeeded();
  }
  //#endregion
  //#region Highlights
  showHideHighlight(e) {
    this._showHighlight = e;
    const t = this.getSelectedRootMesh();
    this.highlightMesh(t, e), this.setRenderingNeeded();
  }
  setHighlightOver(e) {
    this._highlightOver = e;
  }
  highlightMesh(e, t) {
    if (!this._showHighlight || this._envMode != Er.Editor) {
      this.deleteHighlightLayer();
      return;
    }
    e && e instanceof BABYLON.Mesh && (t ? (this._highlightLayer || this.createHighlightLayer(), this._highlightLayer && this._highlightLayer.addMesh(e, BABYLON.Color3.FromHexString(this._highlightColor))) : this._highlightLayer && this._highlightLayer.removeMesh(e)), this.setLongRenderingNeeded();
  }
  highlightMeshOver(e) {
    if (!this._showHighlight || this._envMode != Er.Editor) {
      this.deleteHighlightLayer();
      return;
    }
    this._meshOver && this._meshOver instanceof BABYLON.Mesh && !this.isMeshSelected(this._meshOver) && (e && this._highlightOver ? (this._highlightLayer || this.createHighlightLayer(), this._highlightLayer && !this._highlightLayer.hasMesh(this._meshOver) && this._highlightLayer.addMesh(this._meshOver, BABYLON.Color3.FromHexString(this.highlightOverColor))) : this._highlightLayer && this._highlightLayer.removeMesh(this._meshOver)), this.setLongRenderingNeeded();
  }
  //#endregion
  //#region Edit control (Gizmo)
  showHideEditControl(e) {
    this._scene && this._camera && this._canvas && (this._editControlVisible = e, this._editControl && (!e || this._manipulatedNode == null) && (this._editControl.detach(), this._editControl = null), e && this._manipulatedNode && (this._editControl ? this._editControl.switchTo(this._manipulatedNode) : (this._editControl = new this._EditControl(
      this._manipulatedNode,
      this._camera,
      this._canvas,
      0.75,
      !0
    ), this._editControl.setRotSnapValue(3.14 / 18), this._editControl.setTransSnapValue(0.5), this._editControl.setScaleSnapValue(0.25), this._editControl.addActionEndListener((t) => {
      this.fireMeshesUpdateEvent();
    })), this.setEditingMode(this._editingMode)), this.setRenderingNeeded());
  }
  setEditingMode(e) {
    this._editingMode = e, this._editControl && (e === $a.Translate ? this._editControl.enableTranslation() : e === $a.Rotate ? this._editControl.enableRotation() : e === $a.Scaling && this._editControl.enableScaling()), this.setRenderingNeeded();
  }
  undoEditing() {
    this._editControl && this._editControl.undo();
  }
  redoEditing() {
    this._editControl && this._editControl.redo();
  }
  //#endregion
  //#region Environment
  setEnvironmentMode(e) {
    e != this._envMode && (this._envMode = e, this.refreshEnvironment());
  }
  async refreshEnvironment() {
    this._scene && (this.setRenderingNeeded(), this._envMode == Er.Editor ? (this.disableAntialiasing(), this.resetEditorEnvironment(), this._environmentManager && (this._environmentManager.dispose(), this._environmentManager = null)) : (this.deleteHighlightLayer(), this.refreshGround(), this._zkScene && ((!this._environmentManager || this._environmentManager.scene != this._scene || this._environmentManager.zkScene != this._zkScene) && (this._environmentManager = new ng(this._zkScene, this._scene)), this._environmentManager.update(), this.setLongRenderingNeeded())), this.refreshGround(), this._lightsLayer && this._lightsLayer.refresh(), this._axesLayer && this._axesLayer.refresh(), this._camera && this._camera instanceof BABYLON.ArcRotateCamera && (this.autoRender = this._camera.useAutoRotationBehavior), this.setRenderingNeeded());
  }
  //#endregion
  //#region Zoom & Move camera
  zoomOnMesh(e) {
    this._sceneHelper && this._sceneHelper.zoomOnMesh(e);
  }
  // Sperimentale (è difficile capire come muovere la camera per inquadrare un oggetto)
  moveCameraToMeshPosition(e) {
    if (this._scene && this._sceneHelper && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      const n = this._sceneHelper.getMeshHierarchyCenter(e), s = this._camera.target, o = this._camera.radius, h = n.subtract(s), c = h.length();
      if (isFinite(c)) {
        let _ = h.normalize(), x = s.add(_.scale(o));
        const B = new BABYLON.Ray(x, _.scale(-1), o), P = this._scene.pickWithRay(B, (U) => U === e);
        if (P && P.hit) {
          const U = new BABYLON.Vector3(), M = new BABYLON.Quaternion(), Z = new BABYLON.Vector3();
          e.getWorldMatrix().decompose(U, M, Z), 0.1 / U.length() * 100, P.pickedPoint;
          var t = P.getNormal();
          t && (_ = t.normalize(), x = s.add(_.scale(o)));
        }
        this._sceneHelper.animateCamera(s, x, 1);
      }
      this.setRenderingNeeded();
    }
  }
  //#endregion
  //#region Scene & Mesh Export: USDZ, glTF, Obj, AR
  exportMeshToOBJ(e) {
    if (!this._scene)
      return;
    const t = this._scene.getMeshByID(e);
    if (!t || !(t instanceof BABYLON.Mesh))
      return;
    const n = BABYLON.OBJExport.OBJ([t]);
    this.saveTextAsFile(n, t.name + ".obj");
  }
  exportMeshGeometryToJson(e) {
    if (!this._scene)
      return;
    const t = this._scene.getMeshByID(e);
    if (!t || !(t instanceof BABYLON.Mesh))
      return;
    const n = {
      positions: t.getVerticesData(BABYLON.VertexBuffer.PositionKind),
      normals: t.getVerticesData(BABYLON.VertexBuffer.NormalKind),
      colors: t.getVerticesData(BABYLON.VertexBuffer.ColorKind),
      uvs: t.getVerticesData(BABYLON.VertexBuffer.UVKind),
      uvs2: t.getVerticesData(BABYLON.VertexBuffer.UV2Kind),
      indices: t.getIndices()
    }, s = JSON.stringify(n, null, 0);
    this.saveTextAsFile(s, t.name + ".json");
  }
  enableDisableARForMesh(e, t) {
    const n = this.getMeshByID(e);
    n && (n.metadata || (n.metadata = {}), n.metadata.AR = t);
  }
  isAREnabledForMesh(e) {
    const t = this.getMeshByID(e);
    return t && t.metadata ? t.metadata.AR !== void 0 ? t.metadata.AR : !0 : !1;
  }
  enableDisableTryOnForMesh(e, t) {
    const n = this.getMeshByID(e);
    n && (n.metadata || (n.metadata = {}), n.metadata.AR = t);
  }
  isTryOnEnabledForMesh(e) {
    const t = this.getMeshByID(e);
    return t && t.metadata ? t.metadata.TryOn !== void 0 ? t.metadata.TryOn : !0 : !1;
  }
  //#endregion
  //#region Utilities
  splitSubMeshes(e) {
    if (this._scene && this._sceneHelper) {
      const t = this._scene.getMeshByID(e);
      t && this._sceneHelper.createMeshesFromSubMeshes(t);
    }
  }
  flipMeshFaces(e) {
    const t = this.getMeshByID(e);
    if (!t)
      return;
    const n = (s) => {
      s instanceof BABYLON.Mesh && s.flipFaces(!0), s.getChildMeshes().forEach((o) => n(o));
    };
    n(t);
  }
  convertSceneToScreenPoint(e, t) {
    if (this._canvas) {
      let n = 0, s = 0, o = this._canvas;
      do
        n += o.offsetLeft, s += o.offsetTop, o = o.offsetParent;
      while (o);
      return { X: e + n, Y: t + s };
    }
    return null;
  }
  saveTextAsFile(e, t) {
    const n = e, s = new Blob([n], { type: "text/plain" }), o = window.URL.createObjectURL(s), h = t;
    this.downloadFile(h, o);
  }
  saveBytesAsFile(e, t) {
    const n = new Blob([e]), s = window.URL.createObjectURL(n);
    this.downloadFile(t, s);
  }
  saveBlobAsFile(e, t, n) {
    let s = null;
    n ? s = window.URL.createObjectURL(new Blob([e], { type: n })) : s = window.URL.createObjectURL(new Blob([e])), this.downloadFile(t, s);
  }
  downloadFile(e, t) {
    var n = document.createElement("a");
    n.download = e, n.innerHTML = "Download File", n.href = t, n.onclick = (s) => {
      document.body.removeChild(n);
    }, n.style.display = "none", document.body.appendChild(n), n.click();
  }
  //#endregion
  //#region Draco
  // Test Draco encoding
  exportDracoEncodedToFile(e) {
    if (!this._scene)
      return;
    const t = this._scene.getMeshByID(e);
    if (!t)
      return;
    const n = this.getDracoEncodedGeometry(t);
    n && this.saveBytesAsFile(n, t.name + "_draco.dat");
  }
  // Funzione utile per testare la codifica Draco delle geometrie
  // La codifica reale delle mesh avviene durante il salvataggio e se ne
  // occupa la classe MakeIncremental, utilizzata in un worker thread
  getDracoEncodedGeometry(e) {
    let t = null;
    if (this._scene && e && e instanceof BABYLON.Mesh) {
      const s = e.getVerticesData(BABYLON.VertexBuffer.PositionKind), o = e.getVerticesData(BABYLON.VertexBuffer.NormalKind), h = e.getVerticesData(BABYLON.VertexBuffer.ColorKind), c = e.getVerticesData(BABYLON.VertexBuffer.UVKind), _ = e.getVerticesData(BABYLON.VertexBuffer.UV2Kind), x = e.getIndices(), B = {};
      x && (B.indices = new Uint32Array(x)), s && (B.positions = new Float32Array(s)), o && (B.normals = new Float32Array(o)), c && (B.uvs = new Float32Array(c)), _ && (B.uvs2 = new Float32Array(_)), h && (B.colors = new Uint32Array(h));
      const P = DracoEncoderModule(), U = new P.Encoder(), M = new P.MeshBuilder(), Z = new P.Mesh(), F = B.indices.length / 3, Q = B.positions.length / 3;
      M.AddFacesToMesh(Z, F, B.indices), M.AddFloatAttributeToMesh(Z, P.POSITION, Q, 3, B.positions), B.normals && M.AddFloatAttributeToMesh(Z, P.NORMAL, Q, 3, B.normals), B.colors && M.AddFloatAttributeToMesh(Z, P.COLOR, Q, 4, B.colors), B.uvs && M.AddFloatAttributeToMesh(Z, P.TEX_COORD, Q, 2, B.uvs), B.uvs2 && M.AddFloatAttributeToMesh(Z, P.TEX_COORD, Q, 2, B.uvs2), U.SetSpeedOptions(5, 5), U.SetAttributeQuantization(P.POSITION, 14), U.SetAttributeQuantization(P.TEX_COORD, 12), U.SetAttributeQuantization(P.NORMAL, 10), U.SetAttributeQuantization(P.COLOR, 10), U.SetAttributeQuantization(P.GENERIC, 8), U.SetEncodingMethod(P.MESH_EDGEBREAKER_ENCODING);
      const D = new P.DracoInt8Array(), te = U.EncodeMeshToDracoBuffer(Z, D);
      t = new ArrayBuffer(te);
      var n = new Int8Array(t);
      for (let ee = 0; ee < te; ++ee)
        n[ee] = D.GetValue(ee);
      P.destroy(Z), P.destroy(D), P.destroy(U), P.destroy(M);
    }
    return t;
  }
  // Decodifica dei dati Draco ereditata da SceneViewer
  //#endregion
  //#region Mesh Creation
  // Crea una mesh (cubo) custom specificandone la geometria
  // utile per comprendere il modo in cui Babylon JS organizza i dati delle geomtrie
  createCustomMesh() {
    let e = null;
    if (this._scene) {
      e = new BABYLON.Mesh("custom", this._scene);
      var t = [-5, 2, -3, -7, -2, -3, -3, -2, -3, 5, 2, 3, 7, -2, 3, 3, -2, 3], n = [0, 1, 2, 3, 4, 5], s = [1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 0, 1, 0, 0, 0, 1, 1, 0, 0, 1, 0, 1], o = [0, 1, 0, 0, 1, 0], h = [];
      BABYLON.VertexData.ComputeNormals(t, n, h);
      const c = new BABYLON.VertexData();
      c.positions = t, c.indices = n, c.colors = s, c.normals = h, c.uvs = o, c.applyToMesh(e);
    }
    return e;
  }
  createBox(e, t) {
    let n = null, s = null;
    return this._scene && this._sceneHelper && (e && (s = this._scene.getMeshByID(e)), n = this._sceneHelper.createBox(s, t), this.setLongRenderingNeeded()), n;
  }
  getSceneBoundingBox() {
    let e = null;
    if (this._scene)
      for (let t = 0; t < this._scene.meshes.length; t++) {
        const n = this._scene.meshes[t];
        if (n && n.metadata && n.metadata.sceneBoundingBox) {
          e = n;
          break;
        }
      }
    return e;
  }
  getOrCreateSceneBoundingBox(e = !0) {
    let t = this.getSceneBoundingBox();
    return t || (t = this.createBoundingBox(null, "SceneBoundingBox", e), t && (t.metadata || (t.metadata = {}), t.metadata.boundingBox = !0, t.metadata.sceneBoundingBox = !0)), t;
  }
  createSceneBoundingBox(e = !0) {
    let t = this.getSceneBoundingBox();
    return t ? t.isVisible = e : (t = this.createBoundingBox(null, "SceneBoundingBox", e), t && (t.metadata || (t.metadata = {}), t.metadata.boundingBox = !0, t.metadata.sceneBoundingBox = !0)), t;
  }
  createBoundingBox(e, t, n = !0) {
    let s = null;
    if (e && (s = this.getMeshByID(e)), this._sceneHelper) {
      var o = this._sceneHelper.createBoundingBox(s, t);
      return o && (o.isVisible = n), this.setLongRenderingNeeded(), o;
    }
    return null;
  }
  createSphere(e, t) {
    let n = null, s = null;
    return this._scene && e && (s = this._scene.getMeshById(e)), this._sceneHelper && (n = this._sceneHelper.createSphere(s, t), this.setLongRenderingNeeded()), n;
  }
  createPlane(e, t) {
    let n = null, s = null;
    return this._scene && e && (s = this._scene.getMeshById(e)), this._sceneHelper && (n = this._sceneHelper.createPlane(s, t), this.setLongRenderingNeeded()), n;
  }
  createDisc(e, t) {
    let n = null, s = null;
    return this._scene && e && (s = this._scene.getMeshById(e)), this._sceneHelper && (n = this._sceneHelper.createDisc(s, t), this.setLongRenderingNeeded()), n;
  }
  createCylinder(e, t) {
    let n = null, s = null;
    return this._scene && e && (s = this._scene.getMeshById(e)), this._sceneHelper && (n = this._sceneHelper.createCylinder(s, t), this.setLongRenderingNeeded()), n;
  }
  createTorus(e, t) {
    let n = null, s = null;
    return this._scene && e && (s = this._scene.getMeshById(e)), this._sceneHelper && (n = this._sceneHelper.createTorus(s, t), this.setLongRenderingNeeded()), n;
  }
  createKnot(e, t) {
    let n = null, s = null;
    return this._scene && e && (s = this._scene.getMeshById(e)), this._sceneHelper && (n = this._sceneHelper.createKnot(s, t), this.setLongRenderingNeeded()), n;
  }
  createRibbon(e, t) {
    let n = null, s = null;
    return this._scene && e && (s = this._scene.getMeshById(e)), this._sceneHelper && (n = this._sceneHelper.createRibbon(s, t), this.setLongRenderingNeeded()), n;
  }
  async createRoundedCubeAsync(e, t) {
    let n = [], s = null;
    return this._scene && e && (s = this._scene.getMeshById(e)), this._sceneHelper && (n = await this._sceneHelper.createRoundedCubeAsync(s, t), this.setLongRenderingNeeded()), n;
  }
  async createRoundedCylinderAsync(e, t) {
    let n = [], s = null;
    return this._scene && e && (s = this._scene.getMeshById(e)), this._sceneHelper && (n = await this._sceneHelper.createRoundedCylinderAsync(s, t), this.setLongRenderingNeeded()), n;
  }
  async createMatBallAsync(e, t) {
    let n = [], s = null;
    return this._scene && e && (s = this._scene.getMeshById(e)), this._sceneHelper && (n = await this._sceneHelper.createMatBallAsync(s, t), this.setLongRenderingNeeded()), n;
  }
  async createMaleHeadAsync(e, t) {
    let n = [], s = null;
    return this._scene && e && (s = this._scene.getMeshById(e)), this._sceneHelper && (n = await this._sceneHelper.createMaleHeadAsync(s, t), this.setLongRenderingNeeded()), n;
  }
  async createFemaleHeadAsync(e, t) {
    let n = [], s = null;
    return this._scene && e && (s = this._scene.getMeshById(e)), this._sceneHelper && (n = await this._sceneHelper.createFemaleHeadAsync(s, t), this.setLongRenderingNeeded()), n;
  }
  async createPokemonBallAsync(e, t) {
    let n = [], s = null;
    return this._scene && e && (s = this._scene.getMeshById(e)), this._sceneHelper && (n = await this._sceneHelper.createPokemonBallAsync(s, t), this.setLongRenderingNeeded()), n;
  }
  async createShaderBallAsync(e, t) {
    let n = [], s = null;
    return this._scene && e && (s = this._scene.getMeshById(e)), this._sceneHelper && (n = await this._sceneHelper.createShaderBallAsync(s, t), this.setLongRenderingNeeded()), n;
  }
  async createBootsAsync(e, t) {
    let n = [], s = null;
    return this._scene && e && (s = this._scene.getMeshById(e)), this._sceneHelper && (n = await this._sceneHelper.createBootsAsync(s, t), this.setLongRenderingNeeded()), n;
  }
  async createSuzanneAsync(e, t) {
    let n = [], s = null;
    return this._scene && e && (s = this._scene.getMeshById(e)), this._sceneHelper && (n = await this._sceneHelper.createSuzanneAsync(s, t), this.setLongRenderingNeeded()), n;
  }
  async createStepPyramidAsync(e, t) {
    let n = [], s = null;
    return this._scene && e && (s = this._scene.getMeshById(e)), this._sceneHelper && (n = await this._sceneHelper.createStepPyramidAsync(s, t), this.setLongRenderingNeeded()), n;
  }
  async createTeapotAsync(e, t) {
    let n = [], s = null;
    return this._scene && e && (s = this._scene.getMeshById(e)), this._sceneHelper && (n = await this._sceneHelper.createTeapotAsync(s, t), this.setLongRenderingNeeded()), n;
  }
  async createAlloyWheelAsync(e, t) {
    let n = [], s = null;
    return this._scene && e && (s = this._scene.getMeshById(e)), this._sceneHelper && (n = await this._sceneHelper.createAlloyWheelAsync(s, t), this.setLongRenderingNeeded()), n;
  }
  async createTryonReferenceGlassesFrameAsync(e, t) {
    let n = [], s = null;
    return this._scene && e && (s = this._scene.getMeshById(e)), this._sceneHelper && (n = await this._sceneHelper.createTryonReferenceGlassesFrameAsync(s, t), this.setLongRenderingNeeded()), n;
  }
  removeAllVTOReferenceMeshes() {
    if (!this.scene)
      return [];
    const e = [], t = [...this.scene.meshes];
    for (const n of t)
      n.name && n.name.toLowerCase().includes("vto_reference") ? n.dispose(!1, !0) : e.push(n);
    return e;
  }
  hideAllVTOFiles(e) {
    for (const t of e)
      t.name && t.name.toLowerCase().includes("vto_reference") && (t.metadata || (t.metadata = {}), t.metadata.TryOn = !1);
  }
  async createTryOnReferenceModelsAsync(e, t, n) {
    let s = null, o = [];
    return this._scene && e && (s = this._scene.getMeshById(e)), this._sceneHelper && (o = await this._sceneHelper.createTryOnReferenceModelsAsync(s, t, n), this.fireMeshesUpdateEvent(), this.setRenderingNeeded(), this.hideAllVTOFiles(o)), o;
  }
  setTryOnReferenceVisible(e) {
    this._sceneHelper && (this._sceneHelper.setTryOnReferenceVisible(e), this.setRenderingNeeded());
  }
  isTryOnReferenceVisible() {
    return this._sceneHelper ? this._sceneHelper.isTryOnReferenceVisible() : !1;
  }
  scaleSceneToTryonReferenceModels(e) {
    var t;
    this._sceneHelper && (this._sceneHelper.scaleSceneToTryonReferenceModels(e), (t = this._sceneHelper) == null || t.setupShadows(this._zkScene), this.setRenderingNeeded());
  }
  getSceneScalingPercentageForVTO() {
    return this._sceneHelper ? this._sceneHelper.getSceneScalingPercentageForVTO() : 100;
  }
  setSceneScalePercentageForVTO(e) {
    var t;
    this._sceneHelper && (this._sceneHelper.setSceneScalePercentageForVTO(e), (t = this._sceneHelper) == null || t.setupShadows(this._zkScene), this.setRenderingNeeded());
  }
  getScenePositionPercentageForVTO() {
    return this._sceneHelper ? this._sceneHelper.getScenePositionPercentageForVTO() : { x: 0, y: 0, z: 0 };
  }
  setScenePositionPercentageForVTO(e, t, n) {
    var s;
    this._sceneHelper && (this._sceneHelper.setScenePositionPercentageForVTO(e, t, n), (s = this._sceneHelper) == null || s.setupShadows(this._zkScene), this.setRenderingNeeded());
  }
  getSceneRotationForVTO() {
    return this._sceneHelper ? this._sceneHelper.getSceneRotationForVTO() : { x: 0, y: 0, z: 0 };
  }
  setSceneRotationForVTO(e, t, n) {
    var s;
    this._sceneHelper && (this._sceneHelper.setSceneRotationForVTO(e, t, n), (s = this._sceneHelper) == null || s.setupShadows(this._zkScene), this.setRenderingNeeded());
  }
  setVTOReferenceVisible(e) {
    this._sceneHelper && (this._sceneHelper.setVTOReferenceVisible(e), this.setRenderingNeeded());
  }
  setShadowsVisibility(e) {
    var t;
    this._sceneHelper && (this._sceneHelper.setShadowsVisibility(e), (t = this._sceneHelper) == null || t.setupShadows(this._zkScene), this.setRenderingNeeded());
  }
  async importMeshesFromUrlAsync(e, t) {
    let n = [], s = null;
    return this._scene && e && (s = this._scene.getMeshById(e)), this._sceneHelper && (n = await this._sceneHelper.importMeshesFromUrlAsync(t, s), this.checkSceneEmptyEnvironmentTexture(), this.setLongRenderingNeeded()), n;
  }
  //#endregion
  //#region 2D Design Rendering
  async connectMeshToModelSideAsync(e, t, n) {
    this._sceneDesignManager && this._sceneDesignManager.connectMeshToModelSideAsync(e, t, n);
  }
  clearMeshDesignManagers() {
    this._sceneDesignManager && this._sceneDesignManager.clearMeshDesignManagers();
  }
  getMeshDesignMananger(e, t) {
    var n;
    return this._sceneDesignManager && this.scene ? (n = this._sceneDesignManager) == null ? void 0 : n.getMeshDesignMananger(e, t) : null;
  }
  // -------------------------------------------------------------
  // Design view transformation
  // -------------------------------------------------------------
  translateDesignView(e, t, n, s) {
    this._sceneDesignManager && this._sceneDesignManager.translateDesignView(e, t, n, s);
  }
  rotateDesignView(e, t, n, s, o) {
    this._sceneDesignManager && this._sceneDesignManager.rotateDesignView(e, t, n, s, o);
  }
  scaleDesignView(e, t, n, s, o, h) {
    this._sceneDesignManager && this._sceneDesignManager.scaleDesignView(e, t, n, s, o, h);
  }
  async setDesignViewTextureUVChannelAsync(e, t, n) {
    this._sceneDesignManager && await this._sceneDesignManager.setDesignViewTextureUVChannelAsync(e, t, n);
  }
  async setDesignViewFormFactorAsync(e, t, n, s) {
    this._sceneDesignManager && await this._sceneDesignManager.setDesignViewFormFactorAsync(e, t, n, s);
  }
  //#endregion
  //#region Mesh measuring
  getCurrentARMeshUsedForMeasure() {
    var t;
    return (t = this.scene) == null ? void 0 : t.meshes.find((n) => n.metadata && n.metadata.sizecm);
  }
  getCurrentARSizeCm() {
    var t;
    const e = this.getCurrentARMeshUsedForMeasure();
    return (t = e == null ? void 0 : e.metadata) == null ? void 0 : t.sizecm;
  }
  setSceneSizeCm(e, t) {
    const n = this.getOrCreateSceneBoundingBox(!1);
    n && this.setMeshSizeCm(n.id, e, t);
  }
  getSceneWidthCm() {
    const e = this.getSceneBoundingBox();
    return e && e.metadata && e.metadata.sizecm && e.metadata.sizecm.width ? e.metadata.sizecm.width : null;
  }
  getSceneHeightCm() {
    const e = this.getSceneBoundingBox();
    return e && e.metadata && e.metadata.sizecm && e.metadata.sizecm.height ? e.metadata.sizecm.height : null;
  }
  getSceneDepthCm() {
    const e = this.getSceneBoundingBox();
    return e && e.metadata && e.metadata.sizecm && e.metadata.sizecm.depth ? e.metadata.sizecm.depth : null;
  }
  setMeshSizeCm(e, t, n) {
    const s = this.getMeshByID(e);
    if (s) {
      let o = null;
      t && typeof t == "number" && !isNaN(t) && (n === "width" ? o = { width: t } : n === "height" ? o = { height: t } : n === "depth" && (o = { depth: t })), s.metadata || (s.metadata = {}), s.metadata.sizecm = o;
    }
  }
  getMeshWidthCm(e) {
    const t = this.getMeshByID(e);
    return t && t.metadata && t.metadata.sizecm && t.metadata.sizecm.width ? t.metadata.sizecm.width : null;
  }
  getMeshHeightCm(e) {
    const t = this.getMeshByID(e);
    return t && t.metadata && t.metadata.sizecm && t.metadata.sizecm.height ? t.metadata.sizecm.height : null;
  }
  getMeshDepthCm(e) {
    const t = this.getMeshByID(e);
    return t && t.metadata && t.metadata.sizecm && t.metadata.sizecm.depth ? t.metadata.sizecm.depth : null;
  }
  //#endregion
  //#region Material Previews
  async getMaterialsPreviewsAsync(e, t, n, s, o = !0) {
    const h = [];
    if (this._scene && this._sceneHelper && this._zkScene) {
      const _ = await this.getSceneRootUrl();
      if (_) {
        const x = await lo.getPreviewsAsync(
          this._scene,
          _,
          e,
          { width: t, height: n },
          !0
        );
        for (var c in x.previewFiles)
          h.push(x.previewFiles[c]);
      }
    }
    return h;
  }
  async getAllMaterialsPreviewsAsync(e, t, n, s = !0) {
    const o = [];
    if (this._scene && this._sceneHelper && this._zkScene) {
      const c = this._sceneHelper.getAllMaterials().map((_) => _.id);
      return this.getMaterialsPreviewsAsync(c, e, t, n, s);
    }
    return o;
  }
  async downloadMaterialsPreviewsAsync(e, t, n, s) {
    if (this._scene && this._sceneHelper && this._zkScene) {
      const o = await this.getSceneRootUrl();
      o && await lo.downloadPreviewsAsync(this._scene, o, e, {
        width: t,
        height: n,
        crop: s
      });
    }
  }
  async downloadAllMaterialsPreviewsAsync(e, t, n) {
    if (this._scene && this._sceneHelper && this._zkScene) {
      const o = this._sceneHelper.getAllMaterials().map((h) => h.id);
      await this.downloadMaterialsPreviewsAsync(o, e, t, n);
    }
  }
  //#endregion
  createEnvelopeMesh(e) {
    if (this._scene && this._sceneHelper) {
      const t = this._scene.getMeshByID(e);
      if (t && t instanceof BABYLON.Mesh)
        return this._sceneHelper.createEnvelopeMesh(t);
    }
    return null;
  }
  expandMesh(e, t) {
    if (this._scene && this._sceneHelper) {
      const n = this._scene.getMeshByID(e);
      n && n instanceof BABYLON.Mesh && this._sceneHelper.expandMesh(n, t);
    }
  }
  enableDisableMeshFacetData(e, t) {
    if (this._scene && this._sceneHelper) {
      const n = this._scene.getMeshByID(e);
      n && (t ? n.updateFacetData() : n.disableFacetData());
    }
  }
  enableDisableDepthSortFacets(e, t) {
    if (this._scene && this._sceneHelper) {
      const n = this._scene.getMeshByID(e);
      n && (n.mustDepthSortFacets = t);
    }
  }
};
bg.EmptyGroupName = "_dummy_";
let w1 = bg;
var S1 = /* @__PURE__ */ ((b) => (b[b.Box = 0] = "Box", b[b.RoundedBox = 1] = "RoundedBox", b[b.Sphere = 2] = "Sphere", b[b.Plane = 3] = "Plane", b[b.Cylinder = 4] = "Cylinder", b[b.RoundedCylinder = 5] = "RoundedCylinder", b[b.Torus = 6] = "Torus", b[b.Knot = 7] = "Knot", b[b.Ribbon = 8] = "Ribbon", b[b.Custom = 9] = "Custom", b))(S1 || {});
class xg extends w1 {
  constructor(e) {
    super(e), this._zkMaterial = null, this._material = null, this._meshType = 0, this._mesh = null, this._materialCreatedListeners = [], this._filesInput = null;
  }
  get zkMaterial() {
    return this._zkMaterial;
  }
  get material() {
    return this._material;
  }
  static async createMaterialEditorAsync(e) {
    e || (e = {
      authorizationToken: "",
      showGround: !1,
      editorBackgroundColor: "#33334c",
      showHighlight: !1,
      incrementalWorkersScriptsUrls: []
    });
    const t = new xg(e);
    return await t.initAsync(), t;
  }
  deleteComponents() {
    super.deleteComponents(), this.deleteEditorMaterial(), this.deleteEditorMesh();
  }
  deleteEditorMaterial() {
    this._material && (this._material.dispose(), this._material = null, this.fireMaterialCreatedEvent());
  }
  deleteEditorMesh() {
    this._mesh && (this._mesh.dispose(), this._mesh = null), this._scene && this._sceneHelper && this._sceneHelper.getSceneMeshes().forEach((t) => t.dispose());
  }
  dispose() {
    super.dispose();
  }
  async createEmptySceneAsync() {
    await super.createEmptySceneAsync(), this.createEditorMaterial(void 0, "Standard"), await this.createEditorMeshAsync();
  }
  createEditorMaterial(e, t, n) {
    let s = null;
    return t != "ShaderMaterial" ? s = super.createMaterial(e, t, n) : (s = this.createShaderMaterial(), s && (s.id = Zakeke.generateUUID(), this.checkSceneEmptyEnvironmentTexture())), this._material = s, this.setRenderingNeeded(), this.fireMaterialCreatedEvent(), s;
  }
  applyEditorMaterial() {
    this._material && this._mesh && this.applyMaterial(this._material, this._mesh);
  }
  async replaceSceneAsync(e) {
    var t = null, n = null;
    this._material && this._zkMaterial && (t = this._material.serialize(), n = this._zkMaterial.get("rootUrl")), this.deleteScene(), this._scene = e, await this.setupSceneAsync(), t && n ? (this._material = BABYLON.Material.Parse(t, this._scene, n), this.fireMaterialCreatedEvent()) : this.createEditorMaterial(void 0, "Standard"), this.applyEditorMaterial(), this.adjustCamera(!1);
  }
  createShaderMaterial() {
    let e = null;
    if (this._scene && this._zkMaterial && this._zkMaterial.get("shaders")) {
      const n = this._zkMaterial.get("name") || "ShaderMaterial - " + Zakeke.makeID(5);
      var t = {
        vertex: this._zkMaterial.get("shaders").get("name"),
        fragment: this._zkMaterial.get("shaders").get("name")
      };
      const s = {
        attributes: this._zkMaterial.getShaderAttributeOptions(Zakeke.ShaderOptionType.Attribute),
        uniforms: this._zkMaterial.getShaderAttributeOptions(Zakeke.ShaderOptionType.Uniform),
        samplers: this._zkMaterial.getShaderAttributeOptions(Zakeke.ShaderOptionType.Sampler)
      };
      e = new BABYLON.ShaderMaterial(n, this._scene, t, s), this.setupShaderMaterialCameraPosition(e);
    }
    return e;
  }
  createEditorMaterialFromJson(e, t) {
    if (this._scene) {
      var n = JSON.parse(e);
      this._material = BABYLON.Material.Parse(n, this._scene, t), this._material && this.setupShaderMaterialCameraPosition(this._material), this.checkSceneEmptyEnvironmentTexture(), this.fireMaterialCreatedEvent();
    }
  }
  async createEditorMeshAsync() {
    switch (this.deleteEditorMesh(), this._meshType) {
      case 0:
        this._mesh = this.createBox(null, "box");
        break;
      case 1:
        {
          const e = await this.createRoundedCubeAsync(null, "rounded box");
          e.length == 1 ? this._mesh = e[0] : this._mesh = this.createGroup(null, "rounded box group", e);
        }
        break;
      case 2:
        this._mesh = this.createSphere(null, "sphere");
        break;
      case 3:
        this._mesh = this.createPlane(null, "plane");
        break;
      case 4:
        this._mesh = this.createCylinder(null, "cylinder");
        break;
      case 5:
        {
          const e = await this.createRoundedCylinderAsync(null, "rounded cylinder");
          e.length == 1 ? this._mesh = e[0] : (this._mesh = this.createGroup(null, "rounded cylinder group"), e.forEach((t) => t.parent = this._mesh));
        }
        break;
      case 6:
        this._mesh = this.createTorus(null, "torus");
        break;
      case 7:
        this._mesh = this.createKnot(null, "knot");
        break;
      case 8:
        this._mesh = this.createRibbon(null, "ribbon");
        break;
    }
    this.applyEditorMaterial(), this.adjustCamera(!1);
  }
  async setEditorMeshType(e) {
    this._meshType = e, await this.createEditorMeshAsync();
  }
  async updateMaterialModelAsync() {
    if (this._zkMaterial && this._material && this._sceneHelper) {
      const t = await this._sceneHelper.takeMaterialScreenshotAsync(this._material.id, 500, 450);
      this._zkMaterial.set("imageData", t);
      const n = this._zkMaterial.get("name");
      n && n != this._material.name && (this._material.name = n);
      var e = this.getEditorMaterialJson();
      e && this._zkMaterial.set("JSON", e);
    }
  }
  getEditorMaterialJson() {
    if (this._scene && this._sceneHelper && this._material) {
      const n = this._sceneHelper;
      this._scene.textures.forEach((s) => {
        if (n.isTextureWithUrl(s) && s.url) {
          var o = s.url.lastIndexOf("/");
          if (o !== -1 && (o = s.url.lastIndexOf("/", o - 1), o !== -1 && (o = s.url.lastIndexOf("/", o - 1), o != -1))) {
            var h = s.url.substring(o + 1);
            s.name = h, s.url = s.name;
          }
        }
      });
      var e = this._material.serialize(), t = JSON.stringify(e);
      return t;
    }
    return null;
  }
  setMaterialModel(e, t) {
    if (this._zkMaterial = e, this.deleteEditorMaterial(), this._zkMaterial && this._zkMaterial instanceof Zakeke.Material) {
      const o = this._zkMaterial.get("shaders");
      if (o) {
        const h = o.get("name"), c = o.get("vertex"), _ = o.get("fragment");
        h && c && _ && this.setupShadersStore({ name: h, vertex: c, fragment: _ });
      }
      var n = this._zkMaterial.get("JSON"), s = this._zkMaterial.get("rootUrl");
      n && s ? this.createEditorMaterialFromJson(n, s) : this.createEditorMaterial(this._zkMaterial.get("name") || void 0, t), this._material && (this._material.id = this._zkMaterial.getMaterialID());
    } else
      this.createEditorMaterial(void 0, t);
    this.applyEditorMaterial(), this.adjustCamera(!1), this.setupShaderMaterialsCameraPosition();
  }
  getTexturesUploadUrl(e) {
    return this._zkMaterial ? this._zkMaterial.getTexturesUrl() : "";
  }
  loadEditorMaterialTextureFiles__(e, t, n, s) {
    this.loadTextureFiles(e, this._material, t, !1, n, s);
  }
  loadEditorMaterialTextureFiles(e, t, n, s) {
    if (!this._material)
      return;
    const o = (M) => {
      let Z = M.lastIndexOf(".");
      if (Z !== -1)
        return M.substring(Z);
    }, h = (M, Z) => {
      const F = M.lastIndexOf(".");
      return F !== -1 ? M.substring(0, F).endsWith("_" + Z) : !1;
    };
    if (!(!e || e.length == 0)) {
      var c = this.canLoadCubemap(this._material, t) && (e.length == 6 || o(e[0].name) == ".dds" || o(e[0].name) == ".hdr"), _ = [];
      if (c && e.length == 6) {
        var x = ["px", "py", "pz", "nx", "ny", "nz"];
        for (let M = 0; M < e.length; M++) {
          const Z = e[M];
          let F = -1;
          for (var B = 0; B < x.length; B++)
            if (h(Z.name, x[B])) {
              _.push(Z), F = B;
              break;
            }
          F !== -1 && x.splice(F, 1);
        }
        if (x.length != 0) {
          var P = "Immagini per la cube map non valide";
          s && s(P), Logger.info(P);
          return;
        }
      } else
        _.push(e[0]);
      var U = new FormData();
      for (let M = 0; M < _.length; M++)
        U.append("file-" + M, _[M]);
      jQuery.ajax({
        url: this.getTexturesUploadUrl(this._material.id),
        data: U,
        cache: !1,
        contentType: !1,
        processData: !1,
        type: "POST",
        success: (M) => {
          Object.prototype.toString.call(M) === "[object Array]" && (c ? this.setEditorMaterialCubeTextureImages(M, t) : this.setEditorMaterialTextureImage(M[0], t)), n && n();
        },
        error: (M, Z, F) => {
          var Q = "An error occurred: " + Z + "nError: " + F;
          s && s(Q);
        }
      });
    }
  }
  setEditorMaterialTextureImage(e, t) {
    if (this._scene && this._zkMaterial && this._material && e && e.imageUrl && e.fileObjectID) {
      const n = new Zakeke.MaterialTextureImage();
      n.set("textureImageID", Zakeke.generateUUID()), n.set("fileObjectID", e.fileObjectID), n.set("imageUrl", e.imageUrl), this._zkMaterial.get("textureImages").push(n);
      const s = e.imageUrl, o = new BABYLON.Texture(s, this._scene), h = this.getMaterialTexture(this._material, t);
      h && h instanceof BABYLON.Texture && (o.uScale = h.uScale, o.vScale = h.vScale, o.uOffset = h.uOffset, o.vOffset = h.vOffset, o.uAng = h.uAng, o.vAng = h.vAng, o.level = h.level, o.coordinatesIndex = h.coordinatesIndex, o.coordinatesMode = h.coordinatesMode, o.hasAlpha = h.hasAlpha, o.wrapU = h.wrapU, o.wrapV = h.wrapV), this.applyTexture(o, this._material, t), h && !this.isTextureUsed(h) && h.dispose();
    }
  }
  setEditorMaterialCubeTextureImages(e, t) {
    if (!this._scene || !this._zkMaterial || !this._material || Object.prototype.toString.call(e) != "[object Array]")
      return;
    let n = null;
    const s = () => this.setRenderingNeeded();
    if (e.length == 1) {
      let _ = e[0];
      if (_.imageUrl && _.fileObjectID) {
        _.imageUrl.endsWith(".dds") ? n = BABYLON.CubeTexture.CreateFromPrefilteredData(_.imageUrl, this._scene) : _.imageUrl.endsWith(".hdr") && (n = new BABYLON.HDRCubeTexture(
          _.imageUrl,
          this._scene,
          512,
          void 0,
          void 0,
          void 0,
          void 0,
          s
        ));
        var o = new Zakeke.MaterialTextureImage();
        o.set("textureImageID", Zakeke.generateUUID()), o.set("fileObjectID", _.fileObjectID), o.set("imageUrl", _.imageUrl), this._zkMaterial.get("textureImages").push(o);
      }
    } else if (e.length == 6) {
      const _ = ["px", "py", "pz", "nx", "ny", "nz"];
      let x = "";
      const B = [], P = [], U = (F, Q) => {
        var D = F.lastIndexOf(".");
        if (D !== -1) {
          var te = F.substring(0, D);
          return te.endsWith("_" + Q);
        }
        return !1;
      }, M = (F, Q) => {
        const D = F.lastIndexOf(".");
        if (D !== -1) {
          var te = F.substring(0, D);
          if (te.endsWith("_" + Q))
            return te.substring(0, te.length - ("_" + Q).length);
        }
        return null;
      }, Z = (F, Q) => {
        const D = F.lastIndexOf("_" + Q);
        return D !== -1 ? F.substr(D) : null;
      };
      for (let F = 0; F < _.length; F++) {
        var h = _[F];
        for (let Q = 0; Q < e.length; Q++) {
          const te = e[Q].imageUrl;
          if (te && U(te, h)) {
            B.push(te), P.push(Z(te, h) ?? ""), x || (x = M(te, h) ?? "");
            break;
          }
        }
      }
      for (let F = 0; F < e.length; F++) {
        const Q = e[F];
        if (Q.imageUrl && Q.fileObjectID != null) {
          const D = Q.imageUrl, te = Q.fileObjectID, ee = new Zakeke.MaterialTextureImage();
          ee.set("textureImageID", Zakeke.generateUUID()), ee.set("fileObjectID", te), ee.set("imageUrl", D), this._zkMaterial.get("textureImages").push(ee);
        }
      }
      n = new BABYLON.CubeTexture(x, this._scene, P, !1, B);
    }
    if (n) {
      var c = this.getMaterialTexture(this._material, t);
      this.applyTexture(n, this._material, t), c && !this.isTextureUsed(c) && c.dispose();
    }
  }
  // -------------------------------------------------------------
  // Events
  // -------------------------------------------------------------
  fireMaterialCreatedEvent() {
    for (let e = 0; e < this._materialCreatedListeners.length; ++e)
      this._materialCreatedListeners[e]();
  }
  addMaterialCreatedListener(e) {
    this._materialCreatedListeners.push(e);
  }
  //#region Load Custom Mesh
  loadFiles(e, t, n) {
    if (!this._engine || !this._scene || !this._sceneHelper)
      return;
    const s = this._engine, o = this._scene, h = this._sceneHelper;
    this._filesInput || (this._filesInput = new BABYLON.FilesInput(
      s,
      o,
      async (c, _) => {
        await this.replaceSceneAsync(_);
        const x = h.getSceneMeshes();
        this._meshType = 9, this._mesh = this.createGroup(null, "group", x), this.applyEditorMaterial(), t && t();
      },
      null,
      //(progress: BABYLON.SceneLoaderProgressEvent) => { }, // progressCallback
      null,
      //() => { },  // additionalRenderLoopLogicCallback
      null,
      //(remaining: number) => { }, // textureLoadingCallback
      null,
      //(files?: File[]) => { },  // startingProcessingFilesCallback
      null,
      //(sceneFile: File) => { }, // onReloadCallback
      (c, _, x) => {
        n && n(x);
      }
    )), this._filesInput && this._filesInput.loadFiles(e);
  }
  //#endregion
}
const M1 = "https://3dviewer-img.futurefashionsolution.com/_common/envMap/default.env", H1 = {
  general: {
    backgroundAlpha: 1,
    backgroundColor: "#ffffff",
    screenshotBackgroundColor: null,
    removeDefaultBackground: !0,
    environmentTexture: M1,
    matchSameNameTextures: null,
    antialiasEnabled: null,
    tryOnEnabled: null,
    tryOnSettings: null,
    arEnabled: !0,
    arOnTheFly: !1,
    arAnchor: null,
    arScale: null,
    meshSize: {
      height: null,
      width: null,
      depth: null
    },
    antialias: {
      desktop: {
        enabled: !0,
        inRotationEnabled: !0
      }
    },
    frameDAMSettings: null,
    useDelayedTextureLoading: null,
    useDelayedMaterialLoading: null,
    useMaterialOffloading: null,
    prefetchMeshes: null,
    prefetchMaterials: null,
    exposure: 1,
    contrast: 1,
    preventDefaultLights: !0,
    forceDracoCompression: null,
    fitToScreenMargin: 1,
    environmentOptions: {
      mipMaps: !1,
      generateHarmonics: !1,
      gammaSpace: !0,
      prefilterOnLoad: !0,
      rotationY: 1.57,
      intensity: 1,
      // environment intensity
      pbrIntensity: 1
      // pbr intensity
    }
  },
  environment: {
    sizeAuto: null,
    mainColor: "#CB0E00",
    backgroundColor: "#5CA0B5",
    skybox: {
      createSkybox: !1,
      size: null,
      texture: null,
      extensions: null,
      files: null,
      color: null,
      blur: 0
    },
    ground: {
      createGround: !1,
      size: null,
      texture: null,
      color: null,
      opacity: null,
      enableShadow: !1,
      shadowLevel: null,
      enableMirror: !0,
      mirrorBlurKernel: null
    },
    shadows: {
      enableShadows: !1,
      groundSizeMultiplierWidth: 1.2,
      groundSizeMultiplierLength: 1.5,
      shadowMapSize: 51,
      shadowHexColor: "#454545",
      contactHardeningUVRatio: 0.4,
      useContactHardeningShadow: !0,
      useBlurCloseExponentialShadowMap: !1,
      usePercentageCloserFiltering: !1,
      useKernelBlur: !0,
      usePoissonSampling: !1,
      blurBoxOffset: 10,
      blurScale: 4,
      blurKernel: 10,
      depthScale: 1,
      shadowDarkness: 0.3
    }
  },
  camera: {
    autoRotate: !1,
    rotationSpeed: 0.2,
    changeRotationDirection: !1,
    contrast: 1.6,
    exposure: 0.8,
    toneMappingEnabled: !0,
    toneMappingType: 0,
    setInitialZoomToBoundingBox: !0,
    initialZoomToBBInertiaDamping: 0.9,
    initialZoomToBBModelSizeRadius: 0.7,
    initialZoomToBBScrollZoomEnabled: !0,
    initialZoomToBBScrollLowerLimit: 2,
    initialZoomToBBScrollUpperLimit: 2,
    positionScale: null,
    limitLowerRadius: !0,
    zoomEnabled: null,
    useMinZoomPerc: !0,
    minZoomPerc: 0.5,
    useMaxZoomPerc: !0,
    maxZoomPerc: 1.5,
    lowerAlphaLimit: null,
    upperAlphaLimit: null,
    fixedAlphaAngle: null,
    fixedBetaAngle: null,
    useLowerAlphaLimit: null,
    lowerBetaLimit: 0,
    upperBetaLimit: 3,
    useLowerBetaLimit: null,
    useUpperAlphaLimit: null,
    useUpperBetaLimit: null,
    zoom: 0,
    position: {
      alpha: 1.57,
      beta: 1.55,
      fov: 0.4
    },
    animateIntro: !1
  },
  model: {
    rotation: {
      x: 0,
      y: 0,
      z: 0
    },
    position: {
      x: 0,
      y: 0,
      z: 0
    },
    scale: {
      x: 1,
      y: 1,
      z: 1
    },
    config: {
      doubleSided: !1
    }
  },
  glow: null,
  infoPoints: null,
  uiConfig: {
    urlARIcon: "",
    urlLoader: ""
  },
  lights: {
    directionalLightBack: {
      position: {
        x: -1,
        y: 0,
        z: -1
      },
      general: {
        intensity: 3,
        visible: !0
      }
    },
    directionalLightLeft: {
      position: {
        x: 0,
        y: 0,
        z: 1
      },
      general: {
        intensity: 1.2,
        visible: !0
      }
    },
    pointLightBack: {
      position: {
        x: 1,
        y: 0.5,
        z: 0.5
      },
      general: {
        intensity: 2,
        visible: !1
      }
    },
    pointLightFront: {
      position: {
        x: -1,
        y: 0.5,
        z: -0.5
      },
      general: {
        intensity: 2,
        visible: !1
      }
    },
    hemisphereLight: {
      position: {
        x: 0,
        y: 30.76964,
        z: 0
      },
      general: {
        intensity: 0.5,
        visible: !1
      }
    }
  },
  textures: null,
  animations: {
    runAtStart: !0,
    loop: !0,
    speed: 1
  }
};
export {
  Pl as AndroidAR,
  Fw as AxesLayer,
  Wd as BlendProceduralTexture,
  so as BlurXProceduralTexture,
  ao as BlurYProceduralTexture,
  y1 as BroadcastChannelEventType,
  zw as DAMViewerAnalyticsEventType,
  $f as Database,
  ci as DefaultAssetUrls,
  Iw as DracoCompression,
  $a as EditingMode,
  S1 as EditorMeshType,
  Zd as ElementSelector,
  ng as EnvironmentManager,
  Er as EnvironmentMode,
  Vw as EventState,
  oo as ForegroundBackgroundProceduralTexture,
  hw as GlowManager,
  Zf as IS_ANDROID,
  qf as IS_IOS,
  fw as IncrementalFiles,
  Rw as InfoPointsManager,
  Tw as InnerShadow,
  Uw as LightsLayer,
  xg as MaterialEditor,
  b1 as MaterialGroup,
  Mw as MaterialPreviewData,
  lo as MaterialsPreview,
  tg as MeshDesignManager,
  zx as MeshExpander,
  lw as MeshLocationsManager,
  pu as MoveProceduralTexture,
  ug as MultiObserver,
  to as MultiplyProceduralTexture,
  Yd as NormalMapProceduralTexture,
  cg as Observable,
  Hw as Observer,
  ew as OpacityProceduralTexture,
  Lw as OuterShadow,
  ul as OverlayProceduralTexture,
  V1 as Preview3DConfigurationManager,
  Aw as ProceduralNormalMap,
  ow as SceneActionsExecutor,
  Bw as SceneDesignManager,
  w1 as SceneEditor,
  mi as SceneHelper,
  Nw as SceneToBlobs,
  Cu as SceneViewer,
  x1 as SourceTaskStatus,
  Ms as StringTools,
  Dw as TryOnFineTuningMazingEnvironment,
  hg as TryOnProvider,
  Ds as TryOnSettingsType,
  lg as TryOnType,
  Fx as UsdzHelper,
  xu as WorkerPool,
  Ay as ZakekeEnvironment,
  oa as arrayContains,
  _w as changeColorLuminosity,
  N1 as chunkString,
  vw as cropImageTransparency,
  P1 as cropImageTransparencyAsync,
  bw as cropToContentAsync,
  Qd as dataURItoBlob,
  Oh as debounce,
  H1 as defaultSceneConfig,
  F1 as flipImage,
  D1 as getAbsoluteUrl,
  pw as getColorBrightness,
  O1 as getColorImage,
  E1 as getContrastYIQ,
  I1 as getContrastYIQHex,
  U1 as getNavigatorQueryParams,
  z1 as getRandomString,
  R1 as getStringHashCode,
  k1 as getViewport,
  L1 as isAndroid,
  mw as isColorDark,
  T1 as isIPhoneX,
  gw as isMobile,
  tl as isPBRMaterial,
  B1 as isiOS,
  Jd as removeBlanks,
  Sw as resizeImageFromDataUri,
  yw as trimCanvas,
  Wh as trimImageAsync
};
